/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		5: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + ".chunk." + {"0":"8557e","1":"29d25","2":"4a62d","3":"35e8d","4":"bb386"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://storage.googleapis.com/humanitix-ticketing/build/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+00f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("J6GP");
exports.encode = exports.stringify = __webpack_require__("bvhO");

/***/ }),

/***/ "+E8Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = deprecation;
// provide method to give a stack track for warnings
// useful for tracking-down where deprecated methods/properties/classes
// are being used within the code

// A map of warning messages already fired
var warnings = {};

// provide method to give a stack track for warnings
// useful for tracking-down where deprecated methods/properties/classes
// are being used within the code
function warn(msg) {
    // Ignore duplicat
    if (warnings[msg]) {
        return;
    }

    /* eslint-disable no-console */
    var stack = new Error().stack;

    // Handle IE < 10 and Safari < 6
    if (typeof stack === 'undefined') {
        console.warn('Deprecation Warning: ', msg);
    } else {
        // chop off the stack trace which includes pixi.js internal calls
        stack = stack.split('\n').splice(3).join('\n');

        if (console.groupCollapsed) {
            console.groupCollapsed('%cDeprecation Warning: %c%s', 'color:#614108;background:#fffbe6', 'font-weight:normal;color:#614108;background:#fffbe6', msg);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn('Deprecation Warning: ', msg);
            console.warn(stack);
        }
    }
    /* eslint-enable no-console */

    warnings[msg] = true;
}

function deprecation(core) {
    var mesh = core.mesh,
        particles = core.particles,
        extras = core.extras,
        filters = core.filters,
        prepare = core.prepare,
        loaders = core.loaders,
        interaction = core.interaction;

    Object.defineProperties(core, {

        /**
         * @class
         * @private
         * @name SpriteBatch
         * @memberof PIXI
         * @see PIXI.ParticleContainer
         * @throws {ReferenceError} SpriteBatch does not exist any more, please use the new ParticleContainer instead.
         * @deprecated since version 3.0.0
         */
        SpriteBatch: {
            get: function get() {
                throw new ReferenceError('SpriteBatch does not exist any more, ' + 'please use the new ParticleContainer instead.');
            }
        },

        /**
         * @class
         * @private
         * @name AssetLoader
         * @memberof PIXI
         * @see PIXI.loaders.Loader
         * @throws {ReferenceError} The loader system was overhauled in PixiJS v3,
         * please see the new PIXI.loaders.Loader class.
         * @deprecated since version 3.0.0
         */
        AssetLoader: {
            get: function get() {
                throw new ReferenceError('The loader system was overhauled in PixiJS v3, ' + 'please see the new PIXI.loaders.Loader class.');
            }
        },

        /**
         * @class
         * @private
         * @name Stage
         * @memberof PIXI
         * @see PIXI.Container
         * @deprecated since version 3.0.0
         */
        Stage: {
            get: function get() {
                warn('You do not need to use a PIXI Stage any more, you can simply render any container.');

                return core.Container;
            }
        },

        /**
         * @class
         * @private
         * @name DisplayObjectContainer
         * @memberof PIXI
         * @see PIXI.Container
         * @deprecated since version 3.0.0
         */
        DisplayObjectContainer: {
            get: function get() {
                warn('DisplayObjectContainer has been shortened to Container, please use Container from now on.');

                return core.Container;
            }
        },

        /**
         * @class
         * @private
         * @name Strip
         * @memberof PIXI
         * @see PIXI.mesh.Mesh
         * @deprecated since version 3.0.0
         */
        Strip: {
            get: function get() {
                warn('The Strip class has been renamed to Mesh and moved to mesh.Mesh, please use mesh.Mesh from now on.');

                return mesh.Mesh;
            }
        },

        /**
         * @class
         * @private
         * @name Rope
         * @memberof PIXI
         * @see PIXI.mesh.Rope
         * @deprecated since version 3.0.0
         */
        Rope: {
            get: function get() {
                warn('The Rope class has been moved to mesh.Rope, please use mesh.Rope from now on.');

                return mesh.Rope;
            }
        },

        /**
         * @class
         * @private
         * @name ParticleContainer
         * @memberof PIXI
         * @see PIXI.particles.ParticleContainer
         * @deprecated since version 4.0.0
         */
        ParticleContainer: {
            get: function get() {
                warn('The ParticleContainer class has been moved to particles.ParticleContainer, ' + 'please use particles.ParticleContainer from now on.');

                return particles.ParticleContainer;
            }
        },

        /**
         * @class
         * @private
         * @name MovieClip
         * @memberof PIXI
         * @see PIXI.extras.MovieClip
         * @deprecated since version 3.0.0
         */
        MovieClip: {
            get: function get() {
                warn('The MovieClip class has been moved to extras.AnimatedSprite, please use extras.AnimatedSprite.');

                return extras.AnimatedSprite;
            }
        },

        /**
         * @class
         * @private
         * @name TilingSprite
         * @memberof PIXI
         * @see PIXI.extras.TilingSprite
         * @deprecated since version 3.0.0
         */
        TilingSprite: {
            get: function get() {
                warn('The TilingSprite class has been moved to extras.TilingSprite, ' + 'please use extras.TilingSprite from now on.');

                return extras.TilingSprite;
            }
        },

        /**
         * @class
         * @private
         * @name BitmapText
         * @memberof PIXI
         * @see PIXI.extras.BitmapText
         * @deprecated since version 3.0.0
         */
        BitmapText: {
            get: function get() {
                warn('The BitmapText class has been moved to extras.BitmapText, ' + 'please use extras.BitmapText from now on.');

                return extras.BitmapText;
            }
        },

        /**
         * @class
         * @private
         * @name blendModes
         * @memberof PIXI
         * @see PIXI.BLEND_MODES
         * @deprecated since version 3.0.0
         */
        blendModes: {
            get: function get() {
                warn('The blendModes has been moved to BLEND_MODES, please use BLEND_MODES from now on.');

                return core.BLEND_MODES;
            }
        },

        /**
         * @class
         * @private
         * @name scaleModes
         * @memberof PIXI
         * @see PIXI.SCALE_MODES
         * @deprecated since version 3.0.0
         */
        scaleModes: {
            get: function get() {
                warn('The scaleModes has been moved to SCALE_MODES, please use SCALE_MODES from now on.');

                return core.SCALE_MODES;
            }
        },

        /**
         * @class
         * @private
         * @name BaseTextureCache
         * @memberof PIXI
         * @see PIXI.utils.BaseTextureCache
         * @deprecated since version 3.0.0
         */
        BaseTextureCache: {
            get: function get() {
                warn('The BaseTextureCache class has been moved to utils.BaseTextureCache, ' + 'please use utils.BaseTextureCache from now on.');

                return core.utils.BaseTextureCache;
            }
        },

        /**
         * @class
         * @private
         * @name TextureCache
         * @memberof PIXI
         * @see PIXI.utils.TextureCache
         * @deprecated since version 3.0.0
         */
        TextureCache: {
            get: function get() {
                warn('The TextureCache class has been moved to utils.TextureCache, ' + 'please use utils.TextureCache from now on.');

                return core.utils.TextureCache;
            }
        },

        /**
         * @namespace
         * @private
         * @name math
         * @memberof PIXI
         * @see PIXI
         * @deprecated since version 3.0.6
         */
        math: {
            get: function get() {
                warn('The math namespace is deprecated, please access members already accessible on PIXI.');

                return core;
            }
        },

        /**
         * @class
         * @private
         * @name PIXI.AbstractFilter
         * @see PIXI.Filter
         * @deprecated since version 3.0.6
         */
        AbstractFilter: {
            get: function get() {
                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');

                return core.Filter;
            }
        },

        /**
         * @class
         * @private
         * @name PIXI.TransformManual
         * @see PIXI.TransformBase
         * @deprecated since version 4.0.0
         */
        TransformManual: {
            get: function get() {
                warn('TransformManual has been renamed to TransformBase, please update your pixi-spine');

                return core.TransformBase;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.TARGET_FPMS
         * @see PIXI.settings.TARGET_FPMS
         * @deprecated since version 4.2.0
         */
        TARGET_FPMS: {
            get: function get() {
                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');

                return core.settings.TARGET_FPMS;
            },
            set: function set(value) {
                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');

                core.settings.TARGET_FPMS = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.FILTER_RESOLUTION
         * @see PIXI.settings.FILTER_RESOLUTION
         * @deprecated since version 4.2.0
         */
        FILTER_RESOLUTION: {
            get: function get() {
                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');

                return core.settings.FILTER_RESOLUTION;
            },
            set: function set(value) {
                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');

                core.settings.FILTER_RESOLUTION = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.RESOLUTION
         * @see PIXI.settings.RESOLUTION
         * @deprecated since version 4.2.0
         */
        RESOLUTION: {
            get: function get() {
                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');

                return core.settings.RESOLUTION;
            },
            set: function set(value) {
                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');

                core.settings.RESOLUTION = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.MIPMAP_TEXTURES
         * @see PIXI.settings.MIPMAP_TEXTURES
         * @deprecated since version 4.2.0
         */
        MIPMAP_TEXTURES: {
            get: function get() {
                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');

                return core.settings.MIPMAP_TEXTURES;
            },
            set: function set(value) {
                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');

                core.settings.MIPMAP_TEXTURES = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.SPRITE_BATCH_SIZE
         * @see PIXI.settings.SPRITE_BATCH_SIZE
         * @deprecated since version 4.2.0
         */
        SPRITE_BATCH_SIZE: {
            get: function get() {
                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');

                return core.settings.SPRITE_BATCH_SIZE;
            },
            set: function set(value) {
                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');

                core.settings.SPRITE_BATCH_SIZE = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.SPRITE_MAX_TEXTURES
         * @see PIXI.settings.SPRITE_MAX_TEXTURES
         * @deprecated since version 4.2.0
         */
        SPRITE_MAX_TEXTURES: {
            get: function get() {
                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');

                return core.settings.SPRITE_MAX_TEXTURES;
            },
            set: function set(value) {
                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');

                core.settings.SPRITE_MAX_TEXTURES = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.RETINA_PREFIX
         * @see PIXI.settings.RETINA_PREFIX
         * @deprecated since version 4.2.0
         */
        RETINA_PREFIX: {
            get: function get() {
                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');

                return core.settings.RETINA_PREFIX;
            },
            set: function set(value) {
                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');

                core.settings.RETINA_PREFIX = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.DEFAULT_RENDER_OPTIONS
         * @see PIXI.settings.RENDER_OPTIONS
         * @deprecated since version 4.2.0
         */
        DEFAULT_RENDER_OPTIONS: {
            get: function get() {
                warn('PIXI.DEFAULT_RENDER_OPTIONS has been deprecated, please use PIXI.settings.DEFAULT_RENDER_OPTIONS');

                return core.settings.RENDER_OPTIONS;
            }
        }
    });

    // Move the default properties to settings
    var defaults = [{ parent: 'TRANSFORM_MODE', target: 'TRANSFORM_MODE' }, { parent: 'GC_MODES', target: 'GC_MODE' }, { parent: 'WRAP_MODES', target: 'WRAP_MODE' }, { parent: 'SCALE_MODES', target: 'SCALE_MODE' }, { parent: 'PRECISION', target: 'PRECISION_FRAGMENT' }];

    var _loop = function _loop(i) {
        var deprecation = defaults[i];

        Object.defineProperty(core[deprecation.parent], 'DEFAULT', {
            get: function get() {
                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, ' + ('please use PIXI.settings.' + deprecation.target));

                return core.settings[deprecation.target];
            },
            set: function set(value) {
                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, ' + ('please use PIXI.settings.' + deprecation.target));

                core.settings[deprecation.target] = value;
            }
        });
    };

    for (var i = 0; i < defaults.length; i++) {
        _loop(i);
    }

    Object.defineProperties(core.settings, {

        /**
         * @static
         * @name PRECISION
         * @memberof PIXI.settings
         * @see PIXI.PRECISION
         * @deprecated since version 4.4.0
         */
        PRECISION: {
            get: function get() {
                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');

                return core.settings.PRECISION_FRAGMENT;
            },
            set: function set(value) {
                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');

                core.settings.PRECISION_FRAGMENT = value;
            }
        }
    });

    if (extras.AnimatedSprite) {
        Object.defineProperties(extras, {

            /**
             * @class
             * @name MovieClip
             * @memberof PIXI.extras
             * @see PIXI.extras.AnimatedSprite
             * @deprecated since version 4.2.0
             */
            MovieClip: {
                get: function get() {
                    warn('The MovieClip class has been renamed to AnimatedSprite, please use AnimatedSprite from now on.');

                    return extras.AnimatedSprite;
                }
            }
        });
    }

    if (extras) {
        Object.defineProperties(extras, {
            /**
             * @class
             * @name TextureTransform
             * @memberof PIXI.extras
             * @see PIXI.TextureMatrix
             * @deprecated since version 4.6.0
             */
            TextureTransform: {
                get: function get() {
                    warn('The TextureTransform class has been renamed to TextureMatrix, ' + 'please use PIXI.TextureMatrix from now on.');

                    return core.TextureMatrix;
                }
            }
        });
    }

    core.DisplayObject.prototype.generateTexture = function generateTexture(renderer, scaleMode, resolution) {
        warn('generateTexture has moved to the renderer, please use renderer.generateTexture(displayObject)');

        return renderer.generateTexture(this, scaleMode, resolution);
    };

    core.Graphics.prototype.generateTexture = function generateTexture(scaleMode, resolution) {
        warn('graphics generate texture has moved to the renderer. ' + 'Or to render a graphics to a texture using canvas please use generateCanvasTexture');

        return this.generateCanvasTexture(scaleMode, resolution);
    };

    /**
     * @method
     * @name PIXI.GroupD8.isSwapWidthHeight
     * @see PIXI.GroupD8.isVertical
     * @param {number} rotation - The number to check.
     * @returns {boolean} Whether or not the direction is vertical
     * @deprecated since version 4.6.0
     */
    core.GroupD8.isSwapWidthHeight = function isSwapWidthHeight(rotation) {
        warn('GroupD8.isSwapWidthHeight was renamed to GroupD8.isVertical');

        return core.GroupD8.isVertical(rotation);
    };

    core.RenderTexture.prototype.render = function render(displayObject, matrix, clear, updateTransform) {
        this.legacyRenderer.render(displayObject, this, clear, matrix, !updateTransform);
        warn('RenderTexture.render is now deprecated, please use renderer.render(displayObject, renderTexture)');
    };

    core.RenderTexture.prototype.getImage = function getImage(target) {
        warn('RenderTexture.getImage is now deprecated, please use renderer.extract.image(target)');

        return this.legacyRenderer.extract.image(target);
    };

    core.RenderTexture.prototype.getBase64 = function getBase64(target) {
        warn('RenderTexture.getBase64 is now deprecated, please use renderer.extract.base64(target)');

        return this.legacyRenderer.extract.base64(target);
    };

    core.RenderTexture.prototype.getCanvas = function getCanvas(target) {
        warn('RenderTexture.getCanvas is now deprecated, please use renderer.extract.canvas(target)');

        return this.legacyRenderer.extract.canvas(target);
    };

    core.RenderTexture.prototype.getPixels = function getPixels(target) {
        warn('RenderTexture.getPixels is now deprecated, please use renderer.extract.pixels(target)');

        return this.legacyRenderer.pixels(target);
    };

    /**
     * @method
     * @private
     * @name PIXI.Sprite#setTexture
     * @see PIXI.Sprite#texture
     * @deprecated since version 3.0.0
     * @param {PIXI.Texture} texture - The texture to set to.
     */
    core.Sprite.prototype.setTexture = function setTexture(texture) {
        this.texture = texture;
        warn('setTexture is now deprecated, please use the texture property, e.g : sprite.texture = texture;');
    };

    if (extras.BitmapText) {
        /**
         * @method
         * @name PIXI.extras.BitmapText#setText
         * @see PIXI.extras.BitmapText#text
         * @deprecated since version 3.0.0
         * @param {string} text - The text to set to.
         */
        extras.BitmapText.prototype.setText = function setText(text) {
            this.text = text;
            warn('setText is now deprecated, please use the text property, e.g : myBitmapText.text = \'my text\';');
        };
    }

    /**
     * @method
     * @name PIXI.Text#setText
     * @see PIXI.Text#text
     * @deprecated since version 3.0.0
     * @param {string} text - The text to set to.
     */
    core.Text.prototype.setText = function setText(text) {
        this.text = text;
        warn('setText is now deprecated, please use the text property, e.g : myText.text = \'my text\';');
    };

    /**
     * Calculates the ascent, descent and fontSize of a given fontStyle
     *
     * @name PIXI.Text.calculateFontProperties
     * @see PIXI.TextMetrics.measureFont
     * @deprecated since version 4.5.0
     * @param {string} font - String representing the style of the font
     * @return {Object} Font properties object
     */
    core.Text.calculateFontProperties = function calculateFontProperties(font) {
        warn('Text.calculateFontProperties is now deprecated, please use the TextMetrics.measureFont');

        return core.TextMetrics.measureFont(font);
    };

    Object.defineProperties(core.Text, {
        fontPropertiesCache: {
            get: function get() {
                warn('Text.fontPropertiesCache is deprecated');

                return core.TextMetrics._fonts;
            }
        },
        fontPropertiesCanvas: {
            get: function get() {
                warn('Text.fontPropertiesCanvas is deprecated');

                return core.TextMetrics._canvas;
            }
        },
        fontPropertiesContext: {
            get: function get() {
                warn('Text.fontPropertiesContext is deprecated');

                return core.TextMetrics._context;
            }
        }
    });

    /**
     * @method
     * @name PIXI.Text#setStyle
     * @see PIXI.Text#style
     * @deprecated since version 3.0.0
     * @param {*} style - The style to set to.
     */
    core.Text.prototype.setStyle = function setStyle(style) {
        this.style = style;
        warn('setStyle is now deprecated, please use the style property, e.g : myText.style = style;');
    };

    /**
     * @method
     * @name PIXI.Text#determineFontProperties
     * @see PIXI.Text#measureFontProperties
     * @deprecated since version 4.2.0
     * @private
     * @param {string} fontStyle - String representing the style of the font
     * @return {Object} Font properties object
     */
    core.Text.prototype.determineFontProperties = function determineFontProperties(fontStyle) {
        warn('determineFontProperties is now deprecated, please use TextMetrics.measureFont method');

        return core.TextMetrics.measureFont(fontStyle);
    };

    /**
     * @method
     * @name PIXI.Text.getFontStyle
     * @see PIXI.TextMetrics.getFontStyle
     * @deprecated since version 4.5.0
     * @param {PIXI.TextStyle} style - The style to use.
     * @return {string} Font string
     */
    core.Text.getFontStyle = function getFontStyle(style) {
        warn('getFontStyle is now deprecated, please use TextStyle.toFontString() instead');

        style = style || {};

        if (!(style instanceof core.TextStyle)) {
            style = new core.TextStyle(style);
        }

        return style.toFontString();
    };

    Object.defineProperties(core.TextStyle.prototype, {
        /**
         * Set all properties of a font as a single string
         *
         * @name PIXI.TextStyle#font
         * @deprecated since version 4.0.0
         */
        font: {
            get: function get() {
                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\', \'fontSize\', \'fontStyle\', \'fontVariant\' and \'fontWeight\' properties from now on');

                var fontSizeString = typeof this._fontSize === 'number' ? this._fontSize + 'px' : this._fontSize;

                return this._fontStyle + ' ' + this._fontVariant + ' ' + this._fontWeight + ' ' + fontSizeString + ' ' + this._fontFamily;
            },
            set: function set(font) {
                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\',\'fontSize\',fontStyle\',\'fontVariant\' and \'fontWeight\' properties from now on');

                // can work out fontStyle from search of whole string
                if (font.indexOf('italic') > 1) {
                    this._fontStyle = 'italic';
                } else if (font.indexOf('oblique') > -1) {
                    this._fontStyle = 'oblique';
                } else {
                    this._fontStyle = 'normal';
                }

                // can work out fontVariant from search of whole string
                if (font.indexOf('small-caps') > -1) {
                    this._fontVariant = 'small-caps';
                } else {
                    this._fontVariant = 'normal';
                }

                // fontWeight and fontFamily are tricker to find, but it's easier to find the fontSize due to it's units
                var splits = font.split(' ');
                var fontSizeIndex = -1;

                this._fontSize = 26;
                for (var i = 0; i < splits.length; ++i) {
                    if (splits[i].match(/(px|pt|em|%)/)) {
                        fontSizeIndex = i;
                        this._fontSize = splits[i];
                        break;
                    }
                }

                // we can now search for fontWeight as we know it must occur before the fontSize
                this._fontWeight = 'normal';
                for (var _i = 0; _i < fontSizeIndex; ++_i) {
                    if (splits[_i].match(/(bold|bolder|lighter|100|200|300|400|500|600|700|800|900)/)) {
                        this._fontWeight = splits[_i];
                        break;
                    }
                }

                // and finally join everything together after the fontSize in case the font family has multiple words
                if (fontSizeIndex > -1 && fontSizeIndex < splits.length - 1) {
                    this._fontFamily = '';
                    for (var _i2 = fontSizeIndex + 1; _i2 < splits.length; ++_i2) {
                        this._fontFamily += splits[_i2] + ' ';
                    }

                    this._fontFamily = this._fontFamily.slice(0, -1);
                } else {
                    this._fontFamily = 'Arial';
                }

                this.styleID++;
            }
        }
    });

    /**
     * @method
     * @name PIXI.Texture#setFrame
     * @see PIXI.Texture#setFrame
     * @deprecated since version 3.0.0
     * @param {PIXI.Rectangle} frame - The frame to set.
     */
    core.Texture.prototype.setFrame = function setFrame(frame) {
        this.frame = frame;
        warn('setFrame is now deprecated, please use the frame property, e.g: myTexture.frame = frame;');
    };

    /**
     * @static
     * @function
     * @name PIXI.Texture.addTextureToCache
     * @see PIXI.Texture.addToCache
     * @deprecated since 4.5.0
     * @param {PIXI.Texture} texture - The Texture to add to the cache.
     * @param {string} id - The id that the texture will be stored against.
     */
    core.Texture.addTextureToCache = function addTextureToCache(texture, id) {
        core.Texture.addToCache(texture, id);
        warn('Texture.addTextureToCache is deprecated, please use Texture.addToCache from now on.');
    };

    /**
     * @static
     * @function
     * @name PIXI.Texture.removeTextureFromCache
     * @see PIXI.Texture.removeFromCache
     * @deprecated since 4.5.0
     * @param {string} id - The id of the texture to be removed
     * @return {PIXI.Texture|null} The texture that was removed
     */
    core.Texture.removeTextureFromCache = function removeTextureFromCache(id) {
        warn('Texture.removeTextureFromCache is deprecated, please use Texture.removeFromCache from now on. ' + 'Be aware that Texture.removeFromCache does not automatically its BaseTexture from the BaseTextureCache. ' + 'For that, use BaseTexture.removeFromCache');

        core.BaseTexture.removeFromCache(id);

        return core.Texture.removeFromCache(id);
    };

    Object.defineProperties(filters, {

        /**
         * @class
         * @private
         * @name PIXI.filters.AbstractFilter
         * @see PIXI.AbstractFilter
         * @deprecated since version 3.0.6
         */
        AbstractFilter: {
            get: function get() {
                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');

                return core.AbstractFilter;
            }
        },

        /**
         * @class
         * @private
         * @name PIXI.filters.SpriteMaskFilter
         * @see PIXI.SpriteMaskFilter
         * @deprecated since version 3.0.6
         */
        SpriteMaskFilter: {
            get: function get() {
                warn('filters.SpriteMaskFilter is an undocumented alias, please use SpriteMaskFilter from now on.');

                return core.SpriteMaskFilter;
            }
        },

        /**
         * @class
         * @private
         * @name PIXI.filters.VoidFilter
         * @see PIXI.filters.AlphaFilter
         * @deprecated since version 4.5.7
         */
        VoidFilter: {
            get: function get() {
                warn('VoidFilter has been renamed to AlphaFilter, please use PIXI.filters.AlphaFilter');

                return filters.AlphaFilter;
            }
        }
    });

    /**
     * @method
     * @name PIXI.utils.uuid
     * @see PIXI.utils.uid
     * @deprecated since version 3.0.6
     * @return {number} The uid
     */
    core.utils.uuid = function () {
        warn('utils.uuid() is deprecated, please use utils.uid() from now on.');

        return core.utils.uid();
    };

    /**
     * @method
     * @name PIXI.utils.canUseNewCanvasBlendModes
     * @see PIXI.CanvasTinter
     * @deprecated
     * @return {boolean} Can use blend modes.
     */
    core.utils.canUseNewCanvasBlendModes = function () {
        warn('utils.canUseNewCanvasBlendModes() is deprecated, please use CanvasTinter.canUseMultiply from now on');

        return core.CanvasTinter.canUseMultiply;
    };

    var saidHello = true;

    /**
     * @name PIXI.utils._saidHello
     * @type {boolean}
     * @see PIXI.utils.skipHello
     * @deprecated since 4.1.0
     */
    Object.defineProperty(core.utils, '_saidHello', {
        set: function set(bool) {
            if (bool) {
                warn('PIXI.utils._saidHello is deprecated, please use PIXI.utils.skipHello()');
                this.skipHello();
            }
            saidHello = bool;
        },
        get: function get() {
            return saidHello;
        }
    });

    if (prepare.BasePrepare) {
        /**
         * @method
         * @name PIXI.prepare.BasePrepare#register
         * @see PIXI.prepare.BasePrepare#registerFindHook
         * @deprecated since version 4.4.2
         * @param {Function} [addHook] - Function call that takes two parameters: `item:*, queue:Array`
         *        function must return `true` if it was able to add item to the queue.
         * @param {Function} [uploadHook] - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
         *        function must return `true` if it was able to handle upload of item.
         * @return {PIXI.BasePrepare} Instance of plugin for chaining.
         */
        prepare.BasePrepare.prototype.register = function register(addHook, uploadHook) {
            warn('renderer.plugins.prepare.register is now deprecated, ' + 'please use renderer.plugins.prepare.registerFindHook & renderer.plugins.prepare.registerUploadHook');

            if (addHook) {
                this.registerFindHook(addHook);
            }

            if (uploadHook) {
                this.registerUploadHook(uploadHook);
            }

            return this;
        };
    }

    if (prepare.canvas) {
        /**
         * The number of graphics or textures to upload to the GPU.
         *
         * @name PIXI.prepare.canvas.UPLOADS_PER_FRAME
         * @static
         * @type {number}
         * @see PIXI.prepare.BasePrepare.limiter
         * @deprecated since 4.2.0
         */
        Object.defineProperty(prepare.canvas, 'UPLOADS_PER_FRAME', {
            set: function set() {
                warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
                // because we don't have a reference to the renderer, we can't actually set
                // the uploads per frame, so we'll have to stick with the warning.
            },
            get: function get() {
                warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');

                return NaN;
            }
        });
    }

    if (prepare.webgl) {
        /**
         * The number of graphics or textures to upload to the GPU.
         *
         * @name PIXI.prepare.webgl.UPLOADS_PER_FRAME
         * @static
         * @type {number}
         * @see PIXI.prepare.BasePrepare.limiter
         * @deprecated since 4.2.0
         */
        Object.defineProperty(prepare.webgl, 'UPLOADS_PER_FRAME', {
            set: function set() {
                warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
                // because we don't have a reference to the renderer, we can't actually set
                // the uploads per frame, so we'll have to stick with the warning.
            },
            get: function get() {
                warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');

                return NaN;
            }
        });
    }

    if (loaders.Loader) {
        var Resource = loaders.Resource;
        var Loader = loaders.Loader;

        Object.defineProperties(Resource.prototype, {
            isJson: {
                get: function get() {
                    warn('The isJson property is deprecated, please use `resource.type === Resource.TYPE.JSON`.');

                    return this.type === Resource.TYPE.JSON;
                }
            },
            isXml: {
                get: function get() {
                    warn('The isXml property is deprecated, please use `resource.type === Resource.TYPE.XML`.');

                    return this.type === Resource.TYPE.XML;
                }
            },
            isImage: {
                get: function get() {
                    warn('The isImage property is deprecated, please use `resource.type === Resource.TYPE.IMAGE`.');

                    return this.type === Resource.TYPE.IMAGE;
                }
            },
            isAudio: {
                get: function get() {
                    warn('The isAudio property is deprecated, please use `resource.type === Resource.TYPE.AUDIO`.');

                    return this.type === Resource.TYPE.AUDIO;
                }
            },
            isVideo: {
                get: function get() {
                    warn('The isVideo property is deprecated, please use `resource.type === Resource.TYPE.VIDEO`.');

                    return this.type === Resource.TYPE.VIDEO;
                }
            }
        });

        Object.defineProperties(Loader.prototype, {
            before: {
                get: function get() {
                    warn('The before() method is deprecated, please use pre().');

                    return this.pre;
                }
            },
            after: {
                get: function get() {
                    warn('The after() method is deprecated, please use use().');

                    return this.use;
                }
            }
        });
    }

    if (interaction.interactiveTarget) {
        /**
         * @name PIXI.interaction.interactiveTarget#defaultCursor
         * @static
         * @type {number}
         * @see PIXI.interaction.interactiveTarget#cursor
         * @deprecated since 4.3.0
         */
        Object.defineProperty(interaction.interactiveTarget, 'defaultCursor', {
            set: function set(value) {
                warn('Property defaultCursor has been replaced with \'cursor\'. ');
                this.cursor = value;
            },
            get: function get() {
                warn('Property defaultCursor has been replaced with \'cursor\'. ');

                return this.cursor;
            }
        });
    }

    if (interaction.InteractionManager) {
        /**
         * @name PIXI.interaction.InteractionManager#defaultCursorStyle
         * @static
         * @type {string}
         * @see PIXI.interaction.InteractionManager#cursorStyles
         * @deprecated since 4.3.0
         */
        Object.defineProperty(interaction.InteractionManager, 'defaultCursorStyle', {
            set: function set(value) {
                warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');
                this.cursorStyles.default = value;
            },
            get: function get() {
                warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');

                return this.cursorStyles.default;
            }
        });

        /**
         * @name PIXI.interaction.InteractionManager#currentCursorStyle
         * @static
         * @type {string}
         * @see PIXI.interaction.InteractionManager#cursorStyles
         * @deprecated since 4.3.0
         */
        Object.defineProperty(interaction.InteractionManager, 'currentCursorStyle', {
            set: function set(value) {
                warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');
                this.currentCursorMode = value;
            },
            get: function get() {
                warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');

                return this.currentCursorMode;
            }
        });
    }
}
//# sourceMappingURL=deprecation.js.map

/***/ }),

/***/ "+QT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var TwoCols = function TwoCols(_ref) {
  var children = _ref.children,
      leftStyle = _ref.leftStyle;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    { "class": "columns two-cols", style: { height: "100%" } },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      { style: leftStyle, "class": "column left-col" },
      children[0]
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "aside",
      { "class": "column right-col" },
      children[1]
    )
  );
};
/* harmony default export */ __webpack_exports__["a"] = (TwoCols);

/***/ }),

/***/ "+UA8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pixiGlCore = __webpack_require__("PJsv");

var _const = __webpack_require__("YEQi");

var _RenderTarget = __webpack_require__("Xw9x");

var _RenderTarget2 = _interopRequireDefault(_RenderTarget);

var _utils = __webpack_require__("dDI1");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * Helper class to create a webGL Texture
 *
 * @class
 * @memberof PIXI
 */
var TextureManager = function () {
    /**
     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
     */
    function TextureManager(renderer) {
        _classCallCheck(this, TextureManager);

        /**
         * A reference to the current renderer
         *
         * @member {PIXI.WebGLRenderer}
         */
        this.renderer = renderer;

        /**
         * The current WebGL rendering context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = renderer.gl;

        /**
         * Track textures in the renderer so we can no longer listen to them on destruction.
         *
         * @member {Array<*>}
         * @private
         */
        this._managedTextures = [];
    }

    /**
     * Binds a texture.
     *
     */

    TextureManager.prototype.bindTexture = function bindTexture() {}
    // empty


    /**
     * Gets a texture.
     *
     */
    ;

    TextureManager.prototype.getTexture = function getTexture() {}
    // empty


    /**
     * Updates and/or Creates a WebGL texture for the renderer's context.
     *
     * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to update
     * @param {number} location - the location the texture will be bound to.
     * @return {GLTexture} The gl texture.
     */
    ;

    TextureManager.prototype.updateTexture = function updateTexture(texture, location) {
        // assume it good!
        // texture = texture.baseTexture || texture;

        var gl = this.gl;

        var isRenderTexture = !!texture._glRenderTargets;

        if (!texture.hasLoaded) {
            return null;
        }

        var boundTextures = this.renderer.boundTextures;

        // if the location is undefined then this may have been called by n event.
        // this being the case the texture may already be bound to a slot. As a texture can only be bound once
        // we need to find its current location if it exists.
        if (location === undefined) {
            location = 0;

            // TODO maybe we can use texture bound ids later on...
            // check if texture is already bound..
            for (var i = 0; i < boundTextures.length; ++i) {
                if (boundTextures[i] === texture) {
                    location = i;
                    break;
                }
            }
        }

        boundTextures[location] = texture;

        gl.activeTexture(gl.TEXTURE0 + location);

        var glTexture = texture._glTextures[this.renderer.CONTEXT_UID];

        if (!glTexture) {
            if (isRenderTexture) {
                var renderTarget = new _RenderTarget2.default(this.gl, texture.width, texture.height, texture.scaleMode, texture.resolution);

                renderTarget.resize(texture.width, texture.height);
                texture._glRenderTargets[this.renderer.CONTEXT_UID] = renderTarget;
                glTexture = renderTarget.texture;

                // framebuffer constructor disactivates current framebuffer
                if (!this.renderer._activeRenderTarget.root) {
                    this.renderer._activeRenderTarget.frameBuffer.bind();
                }
            } else {
                glTexture = new _pixiGlCore.GLTexture(this.gl, null, null, null, null);
                glTexture.bind(location);
                glTexture.premultiplyAlpha = true;
                glTexture.upload(texture.source);
            }

            texture._glTextures[this.renderer.CONTEXT_UID] = glTexture;

            texture.on('update', this.updateTexture, this);
            texture.on('dispose', this.destroyTexture, this);

            this._managedTextures.push(texture);

            if (texture.isPowerOfTwo) {
                if (texture.mipmap) {
                    glTexture.enableMipmap();
                }

                if (texture.wrapMode === _const.WRAP_MODES.CLAMP) {
                    glTexture.enableWrapClamp();
                } else if (texture.wrapMode === _const.WRAP_MODES.REPEAT) {
                    glTexture.enableWrapRepeat();
                } else {
                    glTexture.enableWrapMirrorRepeat();
                }
            } else {
                glTexture.enableWrapClamp();
            }

            if (texture.scaleMode === _const.SCALE_MODES.NEAREST) {
                glTexture.enableNearestScaling();
            } else {
                glTexture.enableLinearScaling();
            }
        }
        // the texture already exists so we only need to update it..
        else if (isRenderTexture) {
                texture._glRenderTargets[this.renderer.CONTEXT_UID].resize(texture.width, texture.height);
            } else {
                glTexture.upload(texture.source);
            }

        return glTexture;
    };

    /**
     * Deletes the texture from WebGL
     *
     * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to destroy
     * @param {boolean} [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
     */

    TextureManager.prototype.destroyTexture = function destroyTexture(texture, skipRemove) {
        texture = texture.baseTexture || texture;

        if (!texture.hasLoaded) {
            return;
        }

        var renderer = this.renderer;
        var uid = renderer.CONTEXT_UID;
        var glTextures = texture._glTextures;
        var glRenderTargets = texture._glRenderTargets;

        if (glTextures[uid]) {
            renderer.unbindTexture(texture);

            glTextures[uid].destroy();
            texture.off('update', this.updateTexture, this);
            texture.off('dispose', this.destroyTexture, this);

            delete glTextures[uid];

            if (!skipRemove) {
                var i = this._managedTextures.indexOf(texture);

                if (i !== -1) {
                    (0, _utils.removeItems)(this._managedTextures, i, 1);
                }
            }
        }

        if (glRenderTargets && glRenderTargets[uid]) {
            if (renderer._activeRenderTarget === glRenderTargets[uid]) {
                renderer.bindRenderTarget(renderer.rootRenderTarget);
            }

            glRenderTargets[uid].destroy();
            delete glRenderTargets[uid];
        }
    };

    /**
     * Deletes all the textures from WebGL
     */

    TextureManager.prototype.removeAll = function removeAll() {
        // empty all the old gl textures as they are useless now
        for (var i = 0; i < this._managedTextures.length; ++i) {
            var texture = this._managedTextures[i];

            if (texture._glTextures[this.renderer.CONTEXT_UID]) {
                delete texture._glTextures[this.renderer.CONTEXT_UID];
            }
        }
    };

    /**
     * Destroys this manager and removes all its textures
     */

    TextureManager.prototype.destroy = function destroy() {
        // destroy managed textures
        for (var i = 0; i < this._managedTextures.length; ++i) {
            var texture = this._managedTextures[i];

            this.destroyTexture(texture, true);

            texture.off('update', this.updateTexture, this);
            texture.off('dispose', this.destroyTexture, this);
        }

        this._managedTextures = null;
    };

    return TextureManager;
}();

exports.default = TextureManager;
//# sourceMappingURL=TextureManager.js.map

/***/ }),

/***/ "+ghv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _CanvasTinter = __webpack_require__("xwA8");

var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var tempPoint = new core.Point();

/**
 * A tiling sprite is a fast way of rendering a tiling image
 *
 * @class
 * @extends PIXI.Sprite
 * @memberof PIXI.extras
 */

var TilingSprite = function (_core$Sprite) {
    _inherits(TilingSprite, _core$Sprite);

    /**
     * @param {PIXI.Texture} texture - the texture of the tiling sprite
     * @param {number} [width=100] - the width of the tiling sprite
     * @param {number} [height=100] - the height of the tiling sprite
     */
    function TilingSprite(texture) {
        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

        _classCallCheck(this, TilingSprite);

        /**
         * Tile transform
         *
         * @member {PIXI.TransformStatic}
         */
        var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, texture));

        _this.tileTransform = new core.TransformStatic();

        // /// private

        /**
         * The with of the tiling sprite
         *
         * @member {number}
         * @private
         */
        _this._width = width;

        /**
         * The height of the tiling sprite
         *
         * @member {number}
         * @private
         */
        _this._height = height;

        /**
         * Canvas pattern
         *
         * @type {CanvasPattern}
         * @private
         */
        _this._canvasPattern = null;

        /**
         * transform that is applied to UV to get the texture coords
         *
         * @member {PIXI.TextureMatrix}
         */
        _this.uvTransform = texture.transform || new core.TextureMatrix(texture);

        /**
         * Plugin that is responsible for rendering this element.
         * Allows to customize the rendering process without overriding '_renderWebGL' method.
         *
         * @member {string}
         * @default 'tilingSprite'
         */
        _this.pluginName = 'tilingSprite';

        /**
         * Whether or not anchor affects uvs
         *
         * @member {boolean}
         * @default false
         */
        _this.uvRespectAnchor = false;
        return _this;
    }
    /**
     * Changes frame clamping in corresponding textureTransform, shortcut
     * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
     *
     * @default 0.5
     * @member {number}
     */

    /**
     * @private
     */
    TilingSprite.prototype._onTextureUpdate = function _onTextureUpdate() {
        if (this.uvTransform) {
            this.uvTransform.texture = this._texture;
        }
        this.cachedTint = 0xFFFFFF;
    };

    /**
     * Renders the object using the WebGL renderer
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */

    TilingSprite.prototype._renderWebGL = function _renderWebGL(renderer) {
        // tweak our texture temporarily..
        var texture = this._texture;

        if (!texture || !texture.valid) {
            return;
        }

        this.tileTransform.updateLocalTransform();
        this.uvTransform.update();

        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - a reference to the canvas renderer
     */

    TilingSprite.prototype._renderCanvas = function _renderCanvas(renderer) {
        var texture = this._texture;

        if (!texture.baseTexture.hasLoaded) {
            return;
        }

        var context = renderer.context;
        var transform = this.worldTransform;
        var resolution = renderer.resolution;
        var isTextureRotated = texture.rotate === 2;
        var baseTexture = texture.baseTexture;
        var baseTextureResolution = baseTexture.resolution;
        var modX = this.tilePosition.x / this.tileScale.x % texture.orig.width * baseTextureResolution;
        var modY = this.tilePosition.y / this.tileScale.y % texture.orig.height * baseTextureResolution;

        // create a nice shiny pattern!
        if (this._textureID !== this._texture._updateID || this.cachedTint !== this.tint) {
            this._textureID = this._texture._updateID;
            // cut an object from a spritesheet..
            var tempCanvas = new core.CanvasRenderTarget(texture.orig.width, texture.orig.height, baseTextureResolution);

            // Tint the tiling sprite
            if (this.tint !== 0xFFFFFF) {
                this.tintedTexture = _CanvasTinter2.default.getTintedTexture(this, this.tint);
                tempCanvas.context.drawImage(this.tintedTexture, 0, 0);
            } else {
                var sx = texture._frame.x * baseTextureResolution;
                var sy = texture._frame.y * baseTextureResolution;
                var sWidth = texture._frame.width * baseTextureResolution;
                var sHeight = texture._frame.height * baseTextureResolution;
                var dWidth = (texture.trim ? texture.trim.width : texture.orig.width) * baseTextureResolution;
                var dHeight = (texture.trim ? texture.trim.height : texture.orig.height) * baseTextureResolution;
                var dx = (texture.trim ? texture.trim.x : 0) * baseTextureResolution;
                var dy = (texture.trim ? texture.trim.y : 0) * baseTextureResolution;

                if (isTextureRotated) {
                    // Apply rotation and transform
                    tempCanvas.context.rotate(-Math.PI / 2);
                    tempCanvas.context.translate(-dHeight, 0);
                    tempCanvas.context.drawImage(baseTexture.source, sx, sy, sWidth, sHeight, -dy, dx, dHeight, dWidth);
                } else {
                    tempCanvas.context.drawImage(baseTexture.source, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
                }
            }

            this.cachedTint = this.tint;
            this._canvasPattern = tempCanvas.context.createPattern(tempCanvas.canvas, 'repeat');
        }

        // set context state..
        context.globalAlpha = this.worldAlpha;
        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);

        renderer.setBlendMode(this.blendMode);

        // fill the pattern!
        context.fillStyle = this._canvasPattern;

        // TODO - this should be rolled into the setTransform above..
        context.scale(this.tileScale.x / baseTextureResolution, this.tileScale.y / baseTextureResolution);

        var anchorX = this.anchor.x * -this._width * baseTextureResolution;
        var anchorY = this.anchor.y * -this._height * baseTextureResolution;

        if (this.uvRespectAnchor) {
            context.translate(modX, modY);

            context.fillRect(-modX + anchorX, -modY + anchorY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
        } else {
            context.translate(modX + anchorX, modY + anchorY);

            context.fillRect(-modX, -modY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
        }
    };

    /**
     * Updates the bounds of the tiling sprite.
     *
     * @private
     */

    TilingSprite.prototype._calculateBounds = function _calculateBounds() {
        var minX = this._width * -this._anchor._x;
        var minY = this._height * -this._anchor._y;
        var maxX = this._width * (1 - this._anchor._x);
        var maxY = this._height * (1 - this._anchor._y);

        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    };

    /**
     * Gets the local bounds of the sprite object.
     *
     * @param {PIXI.Rectangle} rect - The output rectangle.
     * @return {PIXI.Rectangle} The bounds.
     */

    TilingSprite.prototype.getLocalBounds = function getLocalBounds(rect) {
        // we can do a fast local bounds if the sprite has no children!
        if (this.children.length === 0) {
            this._bounds.minX = this._width * -this._anchor._x;
            this._bounds.minY = this._height * -this._anchor._y;
            this._bounds.maxX = this._width * (1 - this._anchor._x);
            this._bounds.maxY = this._height * (1 - this._anchor._y);

            if (!rect) {
                if (!this._localBoundsRect) {
                    this._localBoundsRect = new core.Rectangle();
                }

                rect = this._localBoundsRect;
            }

            return this._bounds.getRectangle(rect);
        }

        return _core$Sprite.prototype.getLocalBounds.call(this, rect);
    };

    /**
     * Checks if a point is inside this tiling sprite.
     *
     * @param {PIXI.Point} point - the point to check
     * @return {boolean} Whether or not the sprite contains the point.
     */

    TilingSprite.prototype.containsPoint = function containsPoint(point) {
        this.worldTransform.applyInverse(point, tempPoint);

        var width = this._width;
        var height = this._height;
        var x1 = -width * this.anchor._x;

        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
            var y1 = -height * this.anchor._y;

            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
                return true;
            }
        }

        return false;
    };

    /**
     * Destroys this sprite and optionally its texture and children
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
     */

    TilingSprite.prototype.destroy = function destroy(options) {
        _core$Sprite.prototype.destroy.call(this, options);

        this.tileTransform = null;
        this.uvTransform = null;
    };

    /**
     * Helper function that creates a new tiling sprite based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @static
     * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
     * @param {number} width - the width of the tiling sprite
     * @param {number} height - the height of the tiling sprite
     * @return {PIXI.Texture} The newly created texture
     */

    TilingSprite.from = function from(source, width, height) {
        return new TilingSprite(core.Texture.from(source), width, height);
    };

    /**
     * Helper function that creates a tiling sprite that will use a texture from the TextureCache based on the frameId
     * The frame ids are created when a Texture packer file has been loaded
     *
     * @static
     * @param {string} frameId - The frame Id of the texture in the cache
     * @param {number} width - the width of the tiling sprite
     * @param {number} height - the height of the tiling sprite
     * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the frameId
     */

    TilingSprite.fromFrame = function fromFrame(frameId, width, height) {
        var texture = core.utils.TextureCache[frameId];

        if (!texture) {
            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache ' + this);
        }

        return new TilingSprite(texture, width, height);
    };

    /**
     * Helper function that creates a sprite that will contain a texture based on an image url
     * If the image is not in the texture cache it will be loaded
     *
     * @static
     * @param {string} imageId - The image url of the texture
     * @param {number} width - the width of the tiling sprite
     * @param {number} height - the height of the tiling sprite
     * @param {boolean} [crossorigin] - if you want to specify the cross-origin parameter
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
     *  see {@link PIXI.SCALE_MODES} for possible values
     * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the image id
     */

    TilingSprite.fromImage = function fromImage(imageId, width, height, crossorigin, scaleMode) {
        return new TilingSprite(core.Texture.fromImage(imageId, crossorigin, scaleMode), width, height);
    };

    /**
     * The width of the sprite, setting this will actually modify the scale to achieve the value set
     *
     * @member {number}
     */

    _createClass(TilingSprite, [{
        key: 'clampMargin',
        get: function get() {
            return this.uvTransform.clampMargin;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uvTransform.clampMargin = value;
            this.uvTransform.update(true);
        }

        /**
         * The scaling of the image that is being tiled
         *
         * @member {PIXI.ObservablePoint}
         */

    }, {
        key: 'tileScale',
        get: function get() {
            return this.tileTransform.scale;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.tileTransform.scale.copy(value);
        }

        /**
         * The offset of the image that is being tiled
         *
         * @member {PIXI.ObservablePoint}
         */

    }, {
        key: 'tilePosition',
        get: function get() {
            return this.tileTransform.position;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.tileTransform.position.copy(value);
        }
    }, {
        key: 'width',
        get: function get() {
            return this._width;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._width = value;
        }

        /**
         * The height of the TilingSprite, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            return this._height;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._height = value;
        }
    }]);

    return TilingSprite;
}(core.Sprite);

exports.default = TilingSprite;
//# sourceMappingURL=TilingSprite.js.map

/***/ }),

/***/ "//1e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _BlurXFilter = __webpack_require__("Zx84");

var _BlurXFilter2 = _interopRequireDefault(_BlurXFilter);

var _BlurYFilter = __webpack_require__("KYHG");

var _BlurYFilter2 = _interopRequireDefault(_BlurYFilter);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The BlurFilter applies a Gaussian blur to an object.
 * The strength of the blur can be set for x- and y-axis separately.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var BlurFilter = function (_core$Filter) {
    _inherits(BlurFilter, _core$Filter);

    /**
     * @param {number} strength - The strength of the blur filter.
     * @param {number} quality - The quality of the blur filter.
     * @param {number} resolution - The resolution of the blur filter.
     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
     */
    function BlurFilter(strength, quality, resolution, kernelSize) {
        _classCallCheck(this, BlurFilter);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this));

        _this.blurXFilter = new _BlurXFilter2.default(strength, quality, resolution, kernelSize);
        _this.blurYFilter = new _BlurYFilter2.default(strength, quality, resolution, kernelSize);

        _this.padding = 0;
        _this.resolution = resolution || core.settings.RESOLUTION;
        _this.quality = quality || 4;
        _this.blur = strength || 8;
        return _this;
    }

    /**
     * Applies the filter.
     *
     * @param {PIXI.FilterManager} filterManager - The manager.
     * @param {PIXI.RenderTarget} input - The input target.
     * @param {PIXI.RenderTarget} output - The output target.
     */

    BlurFilter.prototype.apply = function apply(filterManager, input, output) {
        var renderTarget = filterManager.getRenderTarget(true);

        this.blurXFilter.apply(filterManager, input, renderTarget, true);
        this.blurYFilter.apply(filterManager, renderTarget, output, false);

        filterManager.returnRenderTarget(renderTarget);
    };

    /**
     * Sets the strength of both the blurX and blurY properties simultaneously
     *
     * @member {number}
     * @default 2
     */

    _createClass(BlurFilter, [{
        key: 'blur',
        get: function get() {
            return this.blurXFilter.blur;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.blurXFilter.blur = this.blurYFilter.blur = value;
            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
        }

        /**
         * Sets the number of passes for blur. More passes means higher quaility bluring.
         *
         * @member {number}
         * @default 1
         */

    }, {
        key: 'quality',
        get: function get() {
            return this.blurXFilter.quality;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.blurXFilter.quality = this.blurYFilter.quality = value;
        }

        /**
         * Sets the strength of the blurX property
         *
         * @member {number}
         * @default 2
         */

    }, {
        key: 'blurX',
        get: function get() {
            return this.blurXFilter.blur;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.blurXFilter.blur = value;
            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
        }

        /**
         * Sets the strength of the blurY property
         *
         * @member {number}
         * @default 2
         */

    }, {
        key: 'blurY',
        get: function get() {
            return this.blurYFilter.blur;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.blurYFilter.blur = value;
            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
        }

        /**
         * Sets the blendmode of the filter
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL
         */

    }, {
        key: 'blendMode',
        get: function get() {
            return this.blurYFilter._blendMode;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.blurYFilter._blendMode = value;
        }
    }]);

    return BlurFilter;
}(core.Filter);

exports.default = BlurFilter;
//# sourceMappingURL=BlurFilter.js.map

/***/ }),

/***/ "//Eg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var InteractionManager_1 = __webpack_require__("dUAP");
var THRESHOLD = 20;

var SelectionListener = function () {
    function SelectionListener(element, item, cb) {
        _classCallCheck(this, SelectionListener);

        this.cb = cb;
        this.tid;
        this.item = item;
        this.onUp = this.onUp.bind(this);
        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.interactionManager = InteractionManager_1.default.createInteractionManager();
        this.createDragAndDropFor(element);
    }

    SelectionListener.prototype.createDragAndDropFor = function createDragAndDropFor(target) {
        target.interactive = true;
        this.moved = false;
        this.mouseDown = false;
        target.on("mousedown", this.onDown);
        target.on("mousemove", this.onMove);
        target.on("mouseup", this.onUp);
        target.on("tap", this.onUp);
    };

    SelectionListener.prototype.onDown = function onDown(e) {
        SelectionListener.clickWasOnElement = true;
        if (this.interactionManager.isSelected(this.item)) {
            this.cb();
        } else {
            this.mouseDown = true;
            clearTimeout(this.tid);
            this.tid = setTimeout(this.cb, 200);
        }
    };

    SelectionListener.prototype.onUp = function onUp(e) {
        this.mouseDown = false;
        clearTimeout(this.tid);
        if (!this.moved && !SelectionListener.isShiftSelect) {
            this.cb();
        }
        this.moved = false;
    };

    SelectionListener.prototype.onMove = function onMove(e) {
        if (this.mouseDown) {
            if (e.data.originalEvent.movementX > THRESHOLD || e.data.originalEvent.movementY > THRESHOLD) {
                this.moved = true;
                clearTimeout(this.tid);
            }
        }
    };

    return SelectionListener;
}();

SelectionListener.clickWasOnElement = false;
SelectionListener.isShiftSelect = false;
exports.default = SelectionListener;
//# sourceMappingURL=SelectionListener.js.map

/***/ }),

/***/ "/Fvp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var strictUriEncode = __webpack_require__("gIXU");
var decodeComponent = __webpack_require__("pWxZ");

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [encode(key, options), '[', index, ']'].join('') : [encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('');
			};
		case 'bracket':
			return function (key, value) {
				return value === null ? [encode(key, options), '[]'].join('') : [encode(key, options), '[]=', encode(value, options)].join('');
			};
		default:
			return function (key, value) {
				return value === null ? encode(key, options) : [encode(key, options), '=', encode(value, options)].join('');
			};
	}
}

function parserForArrayFormat(options) {
	var result = void 0;

	switch (options.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};
		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(input) {
	var queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return input.slice(queryStart + 1);
}

function parse(input, options) {
	options = _extends({ decode: true, arrayFormat: 'none' }, options);

	var formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	var ret = Object.create(null);

	if (typeof input !== 'string') {
		return ret;
	}

	input = input.trim().replace(/^[?#&]/, '');

	if (!input) {
		return ret;
	}

	for (var _iterator = input.split('&'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var param = _ref;

		var _param$replace$split = param.replace(/\+/g, ' ').split('='),
		    key = _param$replace$split[0],
		    value = _param$replace$split[1];

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters


		value = value === undefined ? null : decode(value, options);

		formatter(decode(key, options), value, ret);
	}

	return Object.keys(ret).sort().reduce(function (result, key) {
		var value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, options) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	options = _extends(defaults, options);

	if (options.sort === false) {
		options.sort = function () {};
	}

	var formatter = encoderForArrayFormat(options);

	return obj ? Object.keys(obj).sort(options.sort).map(function (key) {
		var value = obj[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			var result = [];

			for (var _iterator2 = value.slice(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
				var _ref2;

				if (_isArray2) {
					if (_i2 >= _iterator2.length) break;
					_ref2 = _iterator2[_i2++];
				} else {
					_i2 = _iterator2.next();
					if (_i2.done) break;
					_ref2 = _i2.value;
				}

				var value2 = _ref2;

				if (value2 === undefined) {
					continue;
				}

				result.push(formatter(key, value2, result.length));
			}

			return result.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (input, options) {
	return {
		url: input.split('?')[0] || '',
		query: parse(extract(input), options)
	};
};

/***/ }),

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "/j6N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _InteractionData = __webpack_require__("VcKu");

Object.defineProperty(exports, 'InteractionData', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InteractionData).default;
  }
});

var _InteractionManager = __webpack_require__("IdKE");

Object.defineProperty(exports, 'InteractionManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InteractionManager).default;
  }
});

var _interactiveTarget = __webpack_require__("ya0i");

Object.defineProperty(exports, 'interactiveTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_interactiveTarget).default;
  }
});

var _InteractionTrackingData = __webpack_require__("aVqp");

Object.defineProperty(exports, 'InteractionTrackingData', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InteractionTrackingData).default;
  }
});

var _InteractionEvent = __webpack_require__("mpmK");

Object.defineProperty(exports, 'InteractionEvent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InteractionEvent).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "/lqD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// References:
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// https://gist.github.com/1579671
// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
// https://gist.github.com/timhall/4078614
// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame

// Expected to be used with Browserfiy
// Browserify automatically detects the use of `global` and passes the
// correct reference of `global`, `self`, and finally `window`

var ONE_FRAME_TIME = 16;

// Date.now
if (!(Date.now && Date.prototype.getTime)) {
    Date.now = function now() {
        return new Date().getTime();
    };
}

// performance.now
if (!(global.performance && global.performance.now)) {
    var startTime = Date.now();

    if (!global.performance) {
        global.performance = {};
    }

    global.performance.now = function () {
        return Date.now() - startTime;
    };
}

// requestAnimationFrame
var lastTime = Date.now();
var vendors = ['ms', 'moz', 'webkit', 'o'];

for (var x = 0; x < vendors.length && !global.requestAnimationFrame; ++x) {
    var p = vendors[x];

    global.requestAnimationFrame = global[p + 'RequestAnimationFrame'];
    global.cancelAnimationFrame = global[p + 'CancelAnimationFrame'] || global[p + 'CancelRequestAnimationFrame'];
}

if (!global.requestAnimationFrame) {
    global.requestAnimationFrame = function (callback) {
        if (typeof callback !== 'function') {
            throw new TypeError(callback + 'is not a function');
        }

        var currentTime = Date.now();
        var delay = ONE_FRAME_TIME + lastTime - currentTime;

        if (delay < 0) {
            delay = 0;
        }

        lastTime = currentTime;

        return setTimeout(function () {
            lastTime = Date.now();
            callback(performance.now());
        }, delay);
    };
}

if (!global.cancelAnimationFrame) {
    global.cancelAnimationFrame = function (id) {
        return clearTimeout(id);
    };
}
//# sourceMappingURL=requestAnimationFrame.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "/uM6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var fragShader = "\nvarying vec2 vTextureCoord;\nvarying float vidx;\nuniform vec3 u_color;\nuniform sampler2D uSampler;\nuniform float u_alpha;\nuniform float u_fontSize;\nuniform float u_weight;\n\nvoid main(void)\n{\n\n    int i = int(floor(vidx));\n    float smoothing = 1. / u_fontSize * 6.;\n    float debug = 0.0;\n\n    vec2 textureCoord = vTextureCoord * 2.;\n    float dist = texture2D(uSampler, vTextureCoord).r;\n\n    if (debug > 0.0) {\n        gl_FragColor = vec4(dist, dist, dist, 1);\n    } else {\n        float alpha = smoothstep(u_weight - smoothing, u_weight + smoothing, dist);\n\n        vec3 color = u_color * alpha;\n\n        gl_FragColor = vec4(color, alpha) * u_alpha;\n    }\n}\n";
exports.default = fragShader;
//# sourceMappingURL=sdfFrag.js.map

/***/ }),

/***/ "/w7L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),

/***/ "01sX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function parseURI(str, opts) {
  opts = opts || {};

  var o = {
    key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
    q: {
      name: 'queryKey',
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
    },
    parser: {
      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
    }
  };

  var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str);
  var uri = {};
  var i = 14;

  while (i--) {
    uri[o.key[i]] = m[i] || '';
  }uri[o.q.name] = {};
  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
    if ($1) uri[o.q.name][$1] = $2;
  });

  return uri;
};

/***/ }),

/***/ "03y+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./config.js
var config = __webpack_require__("aSYM");

// CONCATENATED MODULE: ./services/tracking/FacebookPixelService.js
// https://developers.facebook.com/docs/facebook-pixel/implementation/pixel-for-official-events#object-properties

var errorTracking = __webpack_require__("QyN2");

var FacebookPixelService = {
  track: function track(type, fbEventName, fbEventData, event) {
    fbEventData.content_ids = event && event.dates ? event.dates.map(function (d) {
      return d._id;
    }) : [];
    fbEventData.eventref = window.fb_oea ? "fb_oea" : "";
    if (window.fbq) {
      fbq(type, fbEventName, fbEventData);
    }
  },
  ticketsViewed: function ticketsViewed(event) {
    this.track("trackCustom", "ViewContent", {}, event);
  },
  ticketsAdded: function ticketsAdded(event, order) {
    try {
      if (event && order) {
        this.track("trackCustom", "TicketsAdded", {
          currency: Object(config["a" /* default */])("CURRENCY"),
          totalTickets: order.tickets.length
        }, event);
      }
    } catch (e) {
      errorTracking.track(e);
    }
  },
  enteredDetails: function enteredDetails(event, order) {
    try {
      if (event && order) {
        this.track("trackCustom", "EnteredDetails", {
          value: order.totals.total,
          currency: Object(config["a" /* default */])("CURRENCY"),
          totalTickets: order.tickets.length
        }, event);
      }
    } catch (e) {
      errorTracking.track(e);
    }
  },
  checkout: function checkout(event, order) {
    if (event && order) {
      this.track("track", "InitiateCheckout", {
        value: order.totals.total,
        currency: Object(config["a" /* default */])("CURRENCY"),
        totalTickets: order.tickets.length
      }, event);
    }
  },
  complete: function complete(event, order) {
    try {
      if (event && order) {
        this.track("track", "Purchase", {
          value: order.totals.total,
          currency: Object(config["a" /* default */])("CURRENCY"),
          totalTickets: order.tickets.length,
          num_items: order.tickets.length
        }, event);
      }
    } catch (e) {
      errorTracking.track(e);
    }
  }
};
/* harmony default export */ var tracking_FacebookPixelService = (FacebookPixelService);
// EXTERNAL MODULE: ./services/tracking/GoogleTagManagerService.js
var GoogleTagManagerService = __webpack_require__("Ys9y");

// CONCATENATED MODULE: ./services/tracking/TrackingService.js



var TrackingService = {
  ticketsViewed: function ticketsViewed(event) {
    tracking_FacebookPixelService.ticketsViewed(event);
  },
  ticketsAdded: function ticketsAdded(event, order) {
    tracking_FacebookPixelService.ticketsAdded(event, order);
    GoogleTagManagerService["a" /* default */].ticketsAdded(event, order);
  },
  enteredDetails: function enteredDetails(event, order) {
    tracking_FacebookPixelService.enteredDetails(event, order);
    GoogleTagManagerService["a" /* default */].enteredDetails(event, order);
    tracking_FacebookPixelService.checkout(event, order);
  },
  complete: function complete(event, order) {
    tracking_FacebookPixelService.complete(event, order);
    GoogleTagManagerService["a" /* default */].complete(event, order);
  }
};
/* harmony default export */ var tracking_TrackingService = __webpack_exports__["a"] = (TrackingService);

/***/ }),

/***/ "08UO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
    return function textureParser(resource, next) {
        // create a new texture if the data is an Image object
        if (resource.data && resource.type === _resourceLoader.Resource.TYPE.IMAGE) {
            resource.texture = _Texture2.default.fromLoader(resource.data, resource.url, resource.name);
        }
        next();
    };
};

var _resourceLoader = __webpack_require__("6Jqp");

var _Texture = __webpack_require__("xUki");

var _Texture2 = _interopRequireDefault(_Texture);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
//# sourceMappingURL=textureParser.js.map

/***/ }),

/***/ "0KR6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var Required = function Required(_ref) {
  var required = _ref.required;

  return required ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "span",
    { "aria-hidden": "true", style: { color: "#c0212c" } },
    "*"
  ) : "";
};
/* harmony default export */ __webpack_exports__["a"] = (Required);

/***/ }),

/***/ "0U4Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a1935f207416c7ed14d9b54e1af40c7e.svg";

/***/ }),

/***/ "106G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _path = __webpack_require__("UUq2");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 *
 * Basic FXAA implementation based on the code on geeks3d.com with the
 * modification that the texture2DLod stuff was removed since it's
 * unsupported by WebGL.
 *
 * @see https://github.com/mitsuhiko/webgl-meincraft
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 *
 */
var FXAAFilter = function (_core$Filter) {
  _inherits(FXAAFilter, _core$Filter);

  /**
   *
   */
  function FXAAFilter() {
    _classCallCheck(this, FXAAFilter);

    // TODO - needs work
    return _possibleConstructorReturn(this, _core$Filter.call(this,
    // vertex shader
    '\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nuniform vec4 filterArea;\n\nvarying vec2 vTextureCoord;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= filterArea.xy;\n    coord += filterArea.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= filterArea.zw;\n    coord /= filterArea.xy;\n\n    return coord;\n}\n\nvoid texcoords(vec2 fragCoord, vec2 resolution,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    vec2 inverseVP = 1.0 / resolution.xy;\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n   vTextureCoord = aTextureCoord;\n\n   vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n   texcoords(fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}',
    // fragment shader
    'varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform vec4 filterArea;\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it\'s\n unsupported by WebGL.\n \n --\n \n From:\n https://github.com/mitsuhiko/webgl-meincraft\n \n Copyright (c) 2011 by Armin Ronacher.\n \n Some rights reserved.\n \n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n \n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n \n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n \n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n \n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 resolution,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    mediump vec2 inverseVP = vec2(1.0 / resolution.x, 1.0 / resolution.y);\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n    \n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n    \n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n    \n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n    \n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n    \n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n      vec4 color;\n\n    color = fxaa(uSampler, fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n'));
  }

  return FXAAFilter;
}(core.Filter);

exports.default = FXAAFilter;
//# sourceMappingURL=FXAAFilter.js.map

/***/ }),

/***/ "1BGf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fdb70df9a57b8107c3ace7ef92ced178.svg";

/***/ }),

/***/ "1ZIP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Mesh = __webpack_require__("esRn");

Object.defineProperty(exports, 'Mesh', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Mesh).default;
  }
});

var _MeshRenderer = __webpack_require__("IWZv");

Object.defineProperty(exports, 'MeshRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MeshRenderer).default;
  }
});

var _CanvasMeshRenderer = __webpack_require__("bPb9");

Object.defineProperty(exports, 'CanvasMeshRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasMeshRenderer).default;
  }
});

var _Plane = __webpack_require__("sY57");

Object.defineProperty(exports, 'Plane', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Plane).default;
  }
});

var _NineSlicePlane = __webpack_require__("VYYc");

Object.defineProperty(exports, 'NineSlicePlane', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NineSlicePlane).default;
  }
});

var _Rope = __webpack_require__("XEQk");

Object.defineProperty(exports, 'Rope', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rope).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "1eZj":
/***/ (function(module, exports) {

module.exports.pages = function pages(glyphs) {
    var pages = new Float32Array(glyphs.length * 4 * 1);
    var i = 0;
    glyphs.forEach(function (glyph) {
        var id = glyph.data.page || 0;
        pages[i++] = id;
        pages[i++] = id;
        pages[i++] = id;
        pages[i++] = id;
    });
    return pages;
};
module.exports.uvs = function uvs(glyphs, texWidth, texHeight, flipY) {
    var uvs = new Float32Array(glyphs.length * 4 * 2);
    var i = 0;
    glyphs.forEach(function (glyph) {
        var bitmap = glyph.data;
        var bw = bitmap.x + bitmap.width;
        var bh = bitmap.y + bitmap.height;
        var u0 = bitmap.x / texWidth;
        var v1 = bitmap.y / texHeight;
        var u1 = bw / texWidth;
        var v0 = bh / texHeight;
        if (flipY) {
            v1 = (texHeight - bitmap.y) / texHeight;
            v0 = (texHeight - bh) / texHeight;
        }
        uvs[i++] = u0;
        uvs[i++] = v1;
        uvs[i++] = u0;
        uvs[i++] = v0;
        uvs[i++] = u1;
        uvs[i++] = v0;
        uvs[i++] = u1;
        uvs[i++] = v1;
    });
    return uvs;
};
module.exports.positions = function positions(glyphs) {
    var positions = new Float32Array(glyphs.length * 4 * 2);
    var i = 0;
    glyphs.forEach(function (glyph) {
        var bitmap = glyph.data;
        var x = glyph.position[0] + bitmap.xoffset;
        var y = glyph.position[1] + bitmap.yoffset;
        var w = bitmap.width;
        var h = bitmap.height;
        positions[i++] = x;
        positions[i++] = y;
        positions[i++] = x;
        positions[i++] = y + h;
        positions[i++] = x + w;
        positions[i++] = y + h;
        positions[i++] = x + w;
        positions[i++] = y;
    });
    return positions;
};
//# sourceMappingURL=vertices.js.map

/***/ }),

/***/ "2M8e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;

var _DateUtils = __webpack_require__("s8Q5");

var _LocaleUtils = __webpack_require__("Awug");

var _classNames = __webpack_require__("ESgF");

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, _DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
//# sourceMappingURL=Helpers.js.map

/***/ }),

/***/ "2OHv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  utils.forEach(['url', 'method', 'params', 'data'], function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(['headers', 'auth', 'proxy'], function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath'], function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};

/***/ }),

/***/ "2PS8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scrollToId; });
/* unused harmony export scrollToIdX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scrollToTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollToNextX; });
/* unused harmony export scrollTo */
/* unused harmony export scrollToX */
var scrollToId = function scrollToId(id) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;

  try {
    var element = document.getElementById(id);
    if (element) {
      scrollTo(findPos(element) + offset, duration, window);
    } else {
      console.error("no element");
    }
  } catch (e) {
    console.error("scrollToId", e);
  }
};

var scrollToIdX = function scrollToIdX(id) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  setTimeout(function () {
    try {
      var element = document.getElementById(id);
      if (element) {
        var scrollEl = findAncestor(element, "scrollEl");
        scrollToX(findPosLeft(element) + offset, 200, scrollEl);
      }
    } catch (e) {}
  }, 100);
};

function findPos(obj) {
  var top = 0;
  if (obj.offsetParent) {
    do {
      top += obj.offsetTop;
    } while (obj = obj.offsetParent);
    return top;
  }
}

function findPosLeft(obj) {
  var left = 0;
  if (obj.offsetParent) {
    do {
      left += obj.offsetLeft;
    } while (obj = obj.offsetParent);
    return [left];
  }
}

function findAncestor(el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls)) {}
  return el;
}

var scrollToTicket = function scrollToTicket(ticketIndex) {
  try {
    var parentElement = document.getElementById("ticket-picker");
    var elementX = (window.innerWidth - 48) * ticketIndex;
    scrollToX(elementX, 200, parentElement);
  } catch (err) {}
};

var scrollToNextX = function scrollToNextX(ticketIndex, elementId) {
  try {
    var parentElement = document.getElementById(elementId);
    var elementX = window.innerWidth * ticketIndex;
    scrollToX(elementX, 200, parentElement);
  } catch (err) {}
};

var scrollTo = function scrollTo(elementY, duration, scrollEl) {
  var startingY = scrollEl.scrollTop;
  var diff = elementY - startingY;
  var start;

  if (!window.requestAnimationFrame) {
    scrollEl.scrollTo(elementY, 0);
    return;
  }
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    var time = timestamp - start;
    var percent = duration === 0 ? 100 : Math.min(time / duration, 1);
    scrollEl.scrollTo(startingY + diff * percent, 0);
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
};

var scrollToX = function scrollToX(elementX, duration, scrollEl) {
  var startingX = scrollEl.scrollLeft;
  var diff = elementX - startingX;
  var start;

  if (!window.requestAnimationFrame) {
    scrollEl.scrollTo(elementX, 0);
    return;
  }
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    var time = timestamp - start;
    var percent = duration === 0 ? 100 : Math.min(time / duration, 1);
    scrollEl.scrollTo(startingX + diff * percent, 0);
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
};

/***/ }),

/***/ "2dnb":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var equal = __webpack_require__("msqx");
var HEADER = new Buffer([66, 77, 70, 3]);

module.exports = function (buf) {
  if (typeof buf === 'string') return buf.substring(0, 3) === 'BMF';
  return buf.length > 4 && equal(buf.slice(0, 4), HEADER);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("dskh").Buffer))

/***/ }),

/***/ "2gTp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ "2kJT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Default property values of accessible objects
 * used by {@link PIXI.accessibility.AccessibilityManager}.
 *
 * @function accessibleTarget
 * @memberof PIXI.accessibility
 * @example
 *      function MyObject() {}
 *
 *      Object.assign(
 *          MyObject.prototype,
 *          PIXI.accessibility.accessibleTarget
 *      );
 */
exports.default = {
  /**
   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
   *   shadow div with attributes set
   *
   * @member {boolean}
   */
  accessible: false,

  /**
   * Sets the title attribute of the shadow div
   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
   *
   * @member {string}
   */
  accessibleTitle: null,

  /**
   * Sets the aria-label attribute of the shadow div
   *
   * @member {string}
   */
  accessibleHint: null,

  /**
   * @todo Needs docs.
   */
  tabIndex: 0,

  /**
   * @todo Needs docs.
   */
  _accessibleActive: false,

  /**
   * @todo Needs docs.
   */
  _accessibleDiv: false
};
//# sourceMappingURL=accessibleTarget.js.map

/***/ }),

/***/ "39pn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getMaxKernelSize;
function getMaxKernelSize(gl) {
    var maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    var kernelSize = 15;

    while (kernelSize > maxVaryings) {
        kernelSize -= 2;
    }

    return kernelSize;
}
//# sourceMappingURL=getMaxBlurKernelSize.js.map

/***/ }),

/***/ "3I3T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "93b00da40e6662288c2395970159337a.svg";

/***/ }),

/***/ "3MQf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pixiGlCore = __webpack_require__("PJsv");

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * An object containing WebGL specific properties to be used by the WebGL renderer
 *
 * @class
 * @private
 * @memberof PIXI
 */
var WebGLGraphicsData = function () {
  /**
   * @param {WebGLRenderingContext} gl - The current WebGL drawing context
   * @param {PIXI.Shader} shader - The shader
   * @param {object} attribsState - The state for the VAO
   */
  function WebGLGraphicsData(gl, shader, attribsState) {
    _classCallCheck(this, WebGLGraphicsData);

    /**
     * The current WebGL drawing context
     *
     * @member {WebGLRenderingContext}
     */
    this.gl = gl;

    // TODO does this need to be split before uploading??
    /**
     * An array of color components (r,g,b)
     * @member {number[]}
     */
    this.color = [0, 0, 0]; // color split!

    /**
     * An array of points to draw
     * @member {PIXI.Point[]}
     */
    this.points = [];

    /**
     * The indices of the vertices
     * @member {number[]}
     */
    this.indices = [];
    /**
     * The main buffer
     * @member {WebGLBuffer}
     */
    this.buffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl);

    /**
     * The index buffer
     * @member {WebGLBuffer}
     */
    this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl);

    /**
     * Whether this graphics is dirty or not
     * @member {boolean}
     */
    this.dirty = true;

    /**
     * Whether this graphics is nativeLines or not
     * @member {boolean}
     */
    this.nativeLines = false;

    this.glPoints = null;
    this.glIndices = null;

    /**
     *
     * @member {PIXI.Shader}
     */
    this.shader = shader;

    this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, attribsState).addIndex(this.indexBuffer).addAttribute(this.buffer, shader.attributes.aVertexPosition, gl.FLOAT, false, 4 * 6, 0).addAttribute(this.buffer, shader.attributes.aColor, gl.FLOAT, false, 4 * 6, 2 * 4);
  }

  /**
   * Resets the vertices and the indices
   */

  WebGLGraphicsData.prototype.reset = function reset() {
    this.points.length = 0;
    this.indices.length = 0;
  };

  /**
   * Binds the buffers and uploads the data
   */

  WebGLGraphicsData.prototype.upload = function upload() {
    this.glPoints = new Float32Array(this.points);
    this.buffer.upload(this.glPoints);

    this.glIndices = new Uint16Array(this.indices);
    this.indexBuffer.upload(this.glIndices);

    this.dirty = false;
  };

  /**
   * Empties all the data
   */

  WebGLGraphicsData.prototype.destroy = function destroy() {
    this.color = null;
    this.points = null;
    this.indices = null;

    this.vao.destroy();
    this.buffer.destroy();
    this.indexBuffer.destroy();

    this.gl = null;

    this.buffer = null;
    this.indexBuffer = null;

    this.glPoints = null;
    this.glIndices = null;
  };

  return WebGLGraphicsData;
}();

exports.default = WebGLGraphicsData;
//# sourceMappingURL=WebGLGraphicsData.js.map

/***/ }),

/***/ "3bIi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("YdsM");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),

/***/ "3hrJ":
/***/ (function(module, exports) {



var mapType = function mapType(gl, type) {
    if (!GL_TABLE) {
        var typeNames = Object.keys(GL_TO_GLSL_TYPES);

        GL_TABLE = {};

        for (var i = 0; i < typeNames.length; ++i) {
            var tn = typeNames[i];
            GL_TABLE[gl[tn]] = GL_TO_GLSL_TYPES[tn];
        }
    }

    return GL_TABLE[type];
};

var GL_TABLE = null;

var GL_TO_GLSL_TYPES = {
    'FLOAT': 'float',
    'FLOAT_VEC2': 'vec2',
    'FLOAT_VEC3': 'vec3',
    'FLOAT_VEC4': 'vec4',

    'INT': 'int',
    'INT_VEC2': 'ivec2',
    'INT_VEC3': 'ivec3',
    'INT_VEC4': 'ivec4',

    'BOOL': 'bool',
    'BOOL_VEC2': 'bvec2',
    'BOOL_VEC3': 'bvec3',
    'BOOL_VEC4': 'bvec4',

    'FLOAT_MAT2': 'mat2',
    'FLOAT_MAT3': 'mat3',
    'FLOAT_MAT4': 'mat4',

    'SAMPLER_2D': 'sampler2D'
};

module.exports = mapType;

/***/ }),

/***/ "3ilc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * Internal class for handling the priority sorting of ticker handlers.
 *
 * @private
 * @class
 * @memberof PIXI.ticker
 */
var TickerListener = function () {
    /**
     * Constructor
     *
     * @param {Function} fn - The listener function to be added for one update
     * @param {Function} [context=null] - The listener context
     * @param {number} [priority=0] - The priority for emitting
     * @param {boolean} [once=false] - If the handler should fire once
     */
    function TickerListener(fn) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        _classCallCheck(this, TickerListener);

        /**
         * The handler function to execute.
         * @member {Function}
         */
        this.fn = fn;

        /**
         * The calling to execute.
         * @member {Function}
         */
        this.context = context;

        /**
         * The current priority.
         * @member {number}
         */
        this.priority = priority;

        /**
         * If this should only execute once.
         * @member {boolean}
         */
        this.once = once;

        /**
         * The next item in chain.
         * @member {TickerListener}
         */
        this.next = null;

        /**
         * The previous item in chain.
         * @member {TickerListener}
         */
        this.previous = null;

        /**
         * `true` if this listener has been destroyed already.
         * @member {boolean}
         * @private
         */
        this._destroyed = false;
    }

    /**
     * Simple compare function to figure out if a function and context match.
     *
     * @param {Function} fn - The listener function to be added for one update
     * @param {Function} context - The listener context
     * @return {boolean} `true` if the listener match the arguments
     */

    TickerListener.prototype.match = function match(fn, context) {
        context = context || null;

        return this.fn === fn && this.context === context;
    };

    /**
     * Emit by calling the current function.
     * @param {number} deltaTime - time since the last emit.
     * @return {TickerListener} Next ticker
     */

    TickerListener.prototype.emit = function emit(deltaTime) {
        if (this.fn) {
            if (this.context) {
                this.fn.call(this.context, deltaTime);
            } else {
                this.fn(deltaTime);
            }
        }

        var redirect = this.next;

        if (this.once) {
            this.destroy(true);
        }

        // Soft-destroying should remove
        // the next reference
        if (this._destroyed) {
            this.next = null;
        }

        return redirect;
    };

    /**
     * Connect to the list.
     * @param {TickerListener} previous - Input node, previous listener
     */

    TickerListener.prototype.connect = function connect(previous) {
        this.previous = previous;
        if (previous.next) {
            previous.next.previous = this;
        }
        this.next = previous.next;
        previous.next = this;
    };

    /**
     * Destroy and don't use after this.
     * @param {boolean} [hard = false] `true` to remove the `next` reference, this
     *        is considered a hard destroy. Soft destroy maintains the next reference.
     * @return {TickerListener} The listener to redirect while emitting or removing.
     */

    TickerListener.prototype.destroy = function destroy() {
        var hard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        this._destroyed = true;
        this.fn = null;
        this.context = null;

        // Disconnect, hook up next and previous
        if (this.previous) {
            this.previous.next = this.next;
        }

        if (this.next) {
            this.next.previous = this.previous;
        }

        // Redirect to the next item
        var redirect = this.next;

        // Remove references
        this.next = hard ? null : redirect;
        this.previous = null;

        return redirect;
    };

    return TickerListener;
}();

exports.default = TickerListener;
//# sourceMappingURL=TickerListener.js.map

/***/ }),

/***/ "3rZB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _CanvasRenderer = __webpack_require__("GzOR");

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _const = __webpack_require__("YEQi");

var _math = __webpack_require__("e3iB");

var _CanvasTinter = __webpack_require__("xwA8");

var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var canvasRenderWorldTransform = new _math.Matrix();

/**
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
 * share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's CanvasSpriteRenderer:
 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/CanvasSpriteRenderer.java
 */

/**
 * Renderer dedicated to drawing and batching sprites.
 *
 * @class
 * @private
 * @memberof PIXI
 */

var CanvasSpriteRenderer = function () {
    /**
     * @param {PIXI.WebGLRenderer} renderer -The renderer sprite this batch works for.
     */
    function CanvasSpriteRenderer(renderer) {
        _classCallCheck(this, CanvasSpriteRenderer);

        this.renderer = renderer;
    }

    /**
     * Renders the sprite object.
     *
     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
     */

    CanvasSpriteRenderer.prototype.render = function render(sprite) {
        var texture = sprite._texture;
        var renderer = this.renderer;

        var width = texture._frame.width;
        var height = texture._frame.height;

        var wt = sprite.transform.worldTransform;
        var dx = 0;
        var dy = 0;

        if (texture.orig.width <= 0 || texture.orig.height <= 0 || !texture.baseTexture.source) {
            return;
        }

        renderer.setBlendMode(sprite.blendMode);

        //  Ignore null sources
        if (texture.valid) {
            renderer.context.globalAlpha = sprite.worldAlpha;

            // If smoothingEnabled is supported and we need to change the smoothing property for sprite texture
            var smoothingEnabled = texture.baseTexture.scaleMode === _const.SCALE_MODES.LINEAR;

            if (renderer.smoothProperty && renderer.context[renderer.smoothProperty] !== smoothingEnabled) {
                renderer.context[renderer.smoothProperty] = smoothingEnabled;
            }

            if (texture.trim) {
                dx = texture.trim.width / 2 + texture.trim.x - sprite.anchor.x * texture.orig.width;
                dy = texture.trim.height / 2 + texture.trim.y - sprite.anchor.y * texture.orig.height;
            } else {
                dx = (0.5 - sprite.anchor.x) * texture.orig.width;
                dy = (0.5 - sprite.anchor.y) * texture.orig.height;
            }

            if (texture.rotate) {
                wt.copy(canvasRenderWorldTransform);
                wt = canvasRenderWorldTransform;
                _math.GroupD8.matrixAppendRotationInv(wt, texture.rotate, dx, dy);
                // the anchor has already been applied above, so lets set it to zero
                dx = 0;
                dy = 0;
            }

            dx -= width / 2;
            dy -= height / 2;

            // Allow for pixel rounding
            if (renderer.roundPixels) {
                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution | 0, wt.ty * renderer.resolution | 0);

                dx = dx | 0;
                dy = dy | 0;
            } else {
                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution, wt.ty * renderer.resolution);
            }

            var resolution = texture.baseTexture.resolution;

            if (sprite.tint !== 0xFFFFFF) {
                if (sprite.cachedTint !== sprite.tint || sprite.tintedTexture.tintId !== sprite._texture._updateID) {
                    sprite.cachedTint = sprite.tint;

                    // TODO clean up caching - how to clean up the caches?
                    sprite.tintedTexture = _CanvasTinter2.default.getTintedTexture(sprite, sprite.tint);
                }

                renderer.context.drawImage(sprite.tintedTexture, 0, 0, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
            } else {
                renderer.context.drawImage(texture.baseTexture.source, texture._frame.x * resolution, texture._frame.y * resolution, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
            }
        }
    };

    /**
     * destroy the sprite object.
     *
     */

    CanvasSpriteRenderer.prototype.destroy = function destroy() {
        this.renderer = null;
    };

    return CanvasSpriteRenderer;
}();

exports.default = CanvasSpriteRenderer;

_CanvasRenderer2.default.registerPlugin('sprite', CanvasSpriteRenderer);
//# sourceMappingURL=CanvasSpriteRenderer.js.map

/***/ }),

/***/ "3yKM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var vertShader = function vertShader(MAX) {
    return "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute float a_idoff;\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix[" + MAX + "];\nuniform float u_fontInfoSize;\n\nvarying vec2 vTextureCoord;\nvarying float vidx;\n\nvoid main(void)\n{\n    int idx = int(floor(a_idoff));\n    float zero = 0.0;\n    float one = 1.0;\n    vTextureCoord = aTextureCoord;\n    vidx = a_idoff;\n    gl_Position = vec4((projectionMatrix * translationMatrix[idx] * vec3(aVertexPosition * u_fontInfoSize, 1.0)).xy, 0.0, 1.0);\n}\n\n";
};
exports.default = vertShader;
//# sourceMappingURL=sdfVert.js.map

/***/ }),

/***/ "4EC6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * CountLimiter limits the number of items handled by a {@link PIXI.prepare.BasePrepare} to a specified
 * number of items per frame.
 *
 * @class
 * @memberof PIXI
 */
var CountLimiter = function () {
  /**
   * @param {number} maxItemsPerFrame - The maximum number of items that can be prepared each frame.
   */
  function CountLimiter(maxItemsPerFrame) {
    _classCallCheck(this, CountLimiter);

    /**
     * The maximum number of items that can be prepared each frame.
     * @private
     */
    this.maxItemsPerFrame = maxItemsPerFrame;
    /**
     * The number of items that can be prepared in the current frame.
     * @type {number}
     * @private
     */
    this.itemsLeft = 0;
  }

  /**
   * Resets any counting properties to start fresh on a new frame.
   */

  CountLimiter.prototype.beginFrame = function beginFrame() {
    this.itemsLeft = this.maxItemsPerFrame;
  };

  /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @return {boolean} If the item is allowed to be uploaded.
   */

  CountLimiter.prototype.allowedToUpload = function allowedToUpload() {
    return this.itemsLeft-- > 0;
  };

  return CountLimiter;
}();

exports.default = CountLimiter;
//# sourceMappingURL=CountLimiter.js.map

/***/ }),

/***/ "4ORL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PIXI = __webpack_require__("ix37");

var utils = __webpack_require__("GZIj");
var Plugin = __webpack_require__("sh3Y");

module.exports = function (_Plugin) {
    _inherits(Drag, _Plugin);

    /**
     * enable one-finger touch to drag
     * @private
     * @param {Viewport} parent
     * @param {object} [options]
     * @param {string} [options.direction=all] direction to drag (all, x, or y)
     * @param {boolean} [options.wheel=true] use wheel to scroll in y direction (unless wheel plugin is active)
     * @param {number} [options.wheelScroll=1] number of pixels to scroll with each wheel spin
     * @param {boolean} [options.reverse] reverse the direction of the wheel scroll
     * @param {boolean|string} [options.clampWheel] (true, x, or y) clamp wheel (to avoid weird bounce with mouse wheel)
     * @param {string} [options.underflow=center] (top/bottom/center and left/right/center, or center) where to place world if too small for screen
     * @param {number} [options.factor=1] factor to multiply drag to increase the speed of movement
     * @param {string} [options.mouseButtons=all] changes which mouse buttons trigger drag, use: 'all', 'left', right' 'middle', or some combination, like, 'middle-right'
     */
    function Drag(parent, options) {
        _classCallCheck(this, Drag);

        options = options || {};

        var _this = _possibleConstructorReturn(this, (Drag.__proto__ || Object.getPrototypeOf(Drag)).call(this, parent));

        _this.moved = false;
        _this.wheelActive = utils.defaults(options.wheel, true);
        _this.wheelScroll = options.wheelScroll || 1;
        _this.reverse = options.reverse ? 1 : -1;
        _this.clampWheel = options.clampWheel;
        _this.factor = options.factor || 1;
        _this.xDirection = !options.direction || options.direction === 'all' || options.direction === 'x';
        _this.yDirection = !options.direction || options.direction === 'all' || options.direction === 'y';
        _this.parseUnderflow(options.underflow || 'center');
        _this.mouseButtons(options.mouseButtons);
        return _this;
    }

    _createClass(Drag, [{
        key: 'mouseButtons',
        value: function mouseButtons(buttons) {
            if (!buttons || buttons === 'all') {
                this.mouse = [1, 1, 1];
            } else {
                this.mouse = [buttons.indexOf('left') === -1 ? false : true, buttons.indexOf('middle') === -1 ? false : true, buttons.indexOf('right') === -1 ? false : true];
            }
        }
    }, {
        key: 'parseUnderflow',
        value: function parseUnderflow(clamp) {
            clamp = clamp.toLowerCase();
            if (clamp === 'center') {
                this.underflowX = 0;
                this.underflowY = 0;
            } else {
                this.underflowX = clamp.indexOf('left') !== -1 ? -1 : clamp.indexOf('right') !== -1 ? 1 : 0;
                this.underflowY = clamp.indexOf('top') !== -1 ? -1 : clamp.indexOf('bottom') !== -1 ? 1 : 0;
            }
        }
    }, {
        key: 'checkButtons',
        value: function checkButtons(e) {
            var isMouse = e.data.pointerType === 'mouse';
            var count = this.parent.countDownPointers();
            if (this.parent.parent) {
                if (count === 1 || count > 1 && !this.parent.plugins['pinch']) {
                    if (!isMouse || this.mouse[e.data.button]) {
                        return true;
                    }
                }
            }
            return false;
        }
    }, {
        key: 'down',
        value: function down(e) {
            if (this.paused) {
                return;
            }
            if (this.checkButtons(e)) {
                var parent = this.parent.parent.toLocal(e.data.global);
                this.last = { x: e.data.global.x, y: e.data.global.y, parent: parent };
                this.current = e.data.pointerId;
                return true;
            } else {
                this.last = null;
            }
        }
    }, {
        key: 'move',
        value: function move(e) {
            if (this.paused) {
                return;
            }
            if (this.last && this.current === e.data.pointerId) {
                var x = e.data.global.x;
                var y = e.data.global.y;
                var count = this.parent.countDownPointers();
                if (count === 1 || count > 1 && !this.parent.plugins['pinch']) {
                    var distX = x - this.last.x;
                    var distY = y - this.last.y;
                    if (this.moved || this.xDirection && this.parent.checkThreshold(distX) || this.yDirection && this.parent.checkThreshold(distY)) {
                        var newParent = this.parent.parent.toLocal(e.data.global);
                        if (this.xDirection) {
                            this.parent.x += (newParent.x - this.last.parent.x) * this.factor;
                        }
                        if (this.yDirection) {
                            this.parent.y += (newParent.y - this.last.parent.y) * this.factor;
                        }
                        this.last = { x: x, y: y, parent: newParent };
                        if (!this.moved) {
                            this.parent.emit('drag-start', { screen: new PIXI.Point(this.last.x, this.last.y), world: this.parent.toWorld(this.last), viewport: this.parent });
                        }
                        this.moved = true;
                        this.parent.emit('moved', { viewport: this.parent, type: 'drag' });
                        return true;
                    }
                } else {
                    this.moved = false;
                }
            }
        }
    }, {
        key: 'up',
        value: function up() {
            var touches = this.parent.getTouchPointers();
            if (touches.length === 1) {
                var pointer = touches[0];
                if (pointer.last) {
                    var parent = this.parent.parent.toLocal(pointer.last);
                    this.last = { x: pointer.last.x, y: pointer.last.y, parent: parent };
                    this.current = pointer.last.data.pointerId;
                }
                this.moved = false;
                return true;
            } else if (this.last) {
                if (this.moved) {
                    this.parent.emit('drag-end', { screen: new PIXI.Point(this.last.x, this.last.y), world: this.parent.toWorld(this.last), viewport: this.parent });
                    this.last = this.moved = false;
                    return true;
                }
            }
        }
    }, {
        key: 'wheel',
        value: function wheel(e) {
            if (this.paused) {
                return;
            }

            if (this.wheelActive) {
                var wheel = this.parent.plugins['wheel'];
                if (!wheel) {
                    if (this.xDirection) {
                        this.parent.x += e.deltaX * this.wheelScroll * this.reverse;
                    }
                    if (this.yDirection) {
                        this.parent.y += e.deltaY * this.wheelScroll * this.reverse;
                    }
                    if (this.clampWheel) {
                        this.clamp();
                    }
                    this.parent.emit('wheel-scroll', this.parent);
                    this.parent.emit('moved', this.parent);
                    if (!this.parent.passiveWheel) {
                        e.preventDefault();
                    }
                    return true;
                }
            }
        }
    }, {
        key: 'resume',
        value: function resume() {
            this.last = null;
            this.paused = false;
        }
    }, {
        key: 'clamp',
        value: function clamp() {
            var decelerate = this.parent.plugins['decelerate'] || {};
            if (this.clampWheel !== 'y') {
                if (this.parent.screenWorldWidth < this.parent.screenWidth) {
                    switch (this.underflowX) {
                        case -1:
                            this.parent.x = 0;
                            break;
                        case 1:
                            this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth;
                            break;
                        default:
                            this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
                    }
                } else {
                    if (this.parent.left < 0) {
                        this.parent.x = 0;
                        decelerate.x = 0;
                    } else if (this.parent.right > this.parent.worldWidth) {
                        this.parent.x = -this.parent.worldWidth * this.parent.scale.x + this.parent.screenWidth;
                        decelerate.x = 0;
                    }
                }
            }
            if (this.clampWheel !== 'x') {
                if (this.parent.screenWorldHeight < this.parent.screenHeight) {
                    switch (this.underflowY) {
                        case -1:
                            this.parent.y = 0;
                            break;
                        case 1:
                            this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight;
                            break;
                        default:
                            this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
                    }
                } else {
                    if (this.parent.top < 0) {
                        this.parent.y = 0;
                        decelerate.y = 0;
                    }
                    if (this.parent.bottom > this.parent.worldHeight) {
                        this.parent.y = -this.parent.worldHeight * this.parent.scale.y + this.parent.screenHeight;
                        decelerate.y = 0;
                    }
                }
            }
        }
    }, {
        key: 'active',
        get: function get() {
            return this.moved;
        }
    }]);

    return Drag;
}(Plugin);

/***/ }),

/***/ "4Q11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("dZBD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("/Fvp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("aSYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Format__ = __webpack_require__("84la");





var EventsService = {
  get: function get(slug, token, orderId, eventDateId) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])("API_URL") + "event/" + slug, {
        params: {
          token: token,
          orderId: orderId,
          eventDateId: eventDateId
        }
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getEventPublic: function getEventPublic(eventId, orderId, token) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])("API_URL") + "public/edit-order/event/" + orderId + "/" + eventId + "/" + token)).then(function ($await_1) {
        try {
          response = $await_1;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  getAdditionalQuestionsPreview: function getAdditionalQuestionsPreview(slug) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])("API_URL") + "public/additional-questions-preview/" + slug).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getAllByUser: function getAllByUser(userId, organiserId) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])("API_URL") + "event/user-events/" + userId + "/" + organiserId).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getTickets: function getTickets(eventId, eventDateId, accessCode) {
    var isBrowser = typeof window !== "undefined";
    var offerId = void 0;
    if (isBrowser) {
      var parsed = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(window.location.search);
      // get the offer id for waitlist clients
      offerId = parsed.offerid;
    }
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])("API_URL") + "event/tickets/", {
        params: {
          eventId: eventId,
          eventDateId: eventDateId,
          accessCode: accessCode,
          offerId: offerId
        }
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  checkAccessCode: function checkAccessCode(eventId, accessCode) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])("API_URL") + "access-codes/check", {
        params: {
          eventId: eventId,
          accessCode: accessCode
        }
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getDates: function getDates(eventId, month, year) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])("API_URL") + "event/dates/" + eventId, {
        params: {
          month: month,
          year: year
        }
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getNearestDate: function getNearestDate(eventId) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])("API_URL") + "event/dates/nearest/" + eventId, {
        params: {
          date: new Date()
        }
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getDate: function getDate(eventSlug, eventDateId) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])("API_URL") + "event/dates/" + eventSlug + "/" + eventDateId).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getCalendarDescription: function getCalendarDescription(event) {
    var description = [event.name];
    if (event && event.accessibility) {
      // info
      var infoItems = ["contactName", "contactNumber", "travelInstructions", "entryInstructions", "afterEntryInstructions", "hazards", "toiletLocation", "disabledParking"];
      var accessibilityPoints = infoItems.reduce(function (points, key) {
        if (event.accessibility[key]) {
          points.push(Object(__WEBPACK_IMPORTED_MODULE_3__utils_Format__["reverseCamelize"])(key) + ": " + event.accessibility[key]);
        }
        return points;
      }, []);
      // features
      if (event.accessibility.features) {
        var features = event.accessibility.features;
        var featuresKeys = Object.keys(features);
        var accessibilityFeatures = [];
        for (var _iterator = featuresKeys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var key = _ref;

          if (features[key]) {
            accessibilityFeatures.push(" - " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_Format__["reverseCamelize"])(key));
          }
        }
        if (accessibilityFeatures.length) {
          accessibilityPoints.push("\nAccessibility Features");
          accessibilityPoints = accessibilityPoints.concat(accessibilityFeatures);
        }
      }
      if (accessibilityPoints.length) {
        description.push("\nAccessibility");
        description = description.concat(accessibilityPoints);
      }
    }
    return description.join("\n");
  }
};

/* harmony default export */ __webpack_exports__["a"] = (EventsService);

/***/ }),

/***/ "4e4/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);

var ActionBar = function ActionBar(_ref) {
  var children = _ref.children;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    { "class": "action-bar", style: { padding: "15px 14px" } },
    children
  );
};
/* harmony default export */ __webpack_exports__["a"] = (ActionBar);

/***/ }),

/***/ "4eqS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = maxRecommendedTextures;

var _ismobilejs = __webpack_require__("nSZq");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function maxRecommendedTextures(max) {
    if (_ismobilejs2.default.tablet || _ismobilejs2.default.phone) {
        // check if the res is iphone 6 or higher..
        return 4;
    }

    // desktop should be ok
    return max;
}
//# sourceMappingURL=maxRecommendedTextures.js.map

/***/ }),

/***/ "4h5L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var uuid = __webpack_require__("qQO4");

var MapObject = function () {
    function MapObject(_id, actions) {
        _classCallCheck(this, MapObject);

        this.selected = false;
        this._id = _id || uuid();
        this.actions = actions;
        this.selected = false;
    }

    MapObject.prototype.onChange = function onChange() {
        if (this._onChange) {
            this._onChange();
        }
    };

    MapObject.prototype.setOnChange = function setOnChange(cb) {
        this._onChange = cb;
    };

    _createClass(MapObject, [{
        key: "isSelected",
        get: function get() {
            return this.selected;
        }
    }]);

    return MapObject;
}();

exports.default = MapObject;
//# sourceMappingURL=SeatingObject.js.map

/***/ }),

/***/ "50FS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__("dZBD");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./config.js
var config = __webpack_require__("aSYM");

// CONCATENATED MODULE: ./services/ContactService.js



var ContactService = {
  sendMessage: function sendMessage(eventId, values) {
    return new Promise(function (resolve, reject) {
      axios_default.a.post(Object(config["a" /* default */])('API_URL') + 'emails/send-message', {
        eventId: eventId,
        values: values
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};

/* harmony default export */ var services_ContactService = (ContactService);
// CONCATENATED MODULE: ./state/actions/contactActions.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONTACT_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTACT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONTACT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTACT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return contactActions_reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return contactActions_sendMessage; });


var CONTACT_RESET = "CONTACT_RESET";
var CONTACT_REQUEST = "CONTACT_REQUEST";
var CONTACT_SUCCESS = "CONTACT_SUCCESS";
var CONTACT_ERROR = "CONTACT_ERROR";

var contactActions_reset = function reset() {
  return function (dispatch) {
    dispatch({ type: CONTACT_RESET });
  };
};

var contactActions_sendMessage = function sendMessage(eventId, values) {
  return function (dispatch) {
    dispatch({ type: CONTACT_REQUEST });
    services_ContactService.sendMessage(eventId, values).then(function (event) {
      dispatch({ type: CONTACT_SUCCESS });
    }).catch(function (err) {
      dispatch({ type: CONTACT_ERROR, error: err });
    });
  };
};

/***/ }),

/***/ "58Ti":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("B6/o");

module.exports = Function.prototype.bind || implementation;

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "5Nhd":
/***/ (function(module, exports, __webpack_require__) {

var wordWrap = __webpack_require__("L9l0");
var xtend = __webpack_require__("K5Tb");
var number = __webpack_require__("EMul");

var X_HEIGHTS = ['x', 'e', 'a', 'o', 'n', 's', 'r', 'c', 'u', 'm', 'v', 'w', 'z'];
var M_WIDTHS = ['m', 'w'];
var CAP_HEIGHTS = ['H', 'I', 'N', 'E', 'F', 'K', 'L', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

var TAB_ID = '\t'.charCodeAt(0);
var SPACE_ID = ' '.charCodeAt(0);
var ALIGN_LEFT = 0,
    ALIGN_CENTER = 1,
    ALIGN_RIGHT = 2;

module.exports = function createLayout(opt) {
  return new TextLayout(opt);
};

function TextLayout(opt) {
  this.glyphs = [];
  this._measure = this.computeMetrics.bind(this);
  this.update(opt);
}

TextLayout.prototype.update = function (opt) {
  opt = xtend({
    measure: this._measure
  }, opt);
  this._opt = opt;
  this._opt.tabSize = number(this._opt.tabSize, 4);

  if (!opt.font) throw new Error('must provide a valid bitmap font');

  var glyphs = this.glyphs;
  var text = opt.text || '';
  var font = opt.font;
  this._setupSpaceGlyphs(font);

  var lines = wordWrap.lines(text, opt);
  var minWidth = opt.width || 0;

  //clear glyphs
  glyphs.length = 0;

  //get max line width
  var maxLineWidth = lines.reduce(function (prev, line) {
    return Math.max(prev, line.width, minWidth);
  }, 0);

  //the pen position
  var x = 0;
  var y = 0;
  var lineHeight = number(opt.lineHeight, font.common.lineHeight);
  var baseline = font.common.base;
  var descender = lineHeight - baseline;
  var letterSpacing = opt.letterSpacing || 0;
  var height = lineHeight * lines.length - descender;
  var align = getAlignType(this._opt.align);

  //draw text along baseline
  y -= height;

  //the metrics for this text layout
  this._width = maxLineWidth;
  this._height = height;
  this._descender = lineHeight - baseline;
  this._baseline = baseline;
  this._xHeight = getXHeight(font);
  this._capHeight = getCapHeight(font);
  this._lineHeight = lineHeight;
  this._ascender = lineHeight - descender - this._xHeight;

  //layout each glyph
  var self = this;
  lines.forEach(function (line, lineIndex) {
    var start = line.start;
    var end = line.end;
    var lineWidth = line.width;
    var lastGlyph;

    //for each glyph in that line...
    for (var i = start; i < end; i++) {
      var id = text.charCodeAt(i);
      var glyph = self.getGlyph(font, id);
      if (glyph) {
        if (lastGlyph) x += getKerning(font, lastGlyph.id, glyph.id);

        var tx = x;
        if (align === ALIGN_CENTER) tx += (maxLineWidth - lineWidth) / 2;else if (align === ALIGN_RIGHT) tx += maxLineWidth - lineWidth;

        glyphs.push({
          position: [tx, y],
          data: glyph,
          index: i,
          line: lineIndex
        });

        //move pen forward
        x += glyph.xadvance + letterSpacing;
        lastGlyph = glyph;
      }
    }

    //next line down
    y += lineHeight;
    x = 0;
  });
  this._linesTotal = lines.length;
};

TextLayout.prototype._setupSpaceGlyphs = function (font) {
  //These are fallbacks, when the font doesn't include
  //' ' or '\t' glyphs
  this._fallbackSpaceGlyph = null;
  this._fallbackTabGlyph = null;

  if (!font.chars || font.chars.length === 0) return;

  //try to get space glyph
  //then fall back to the 'm' or 'w' glyphs
  //then fall back to the first glyph available
  var space = getGlyphById(font, SPACE_ID) || getMGlyph(font) || font.chars[0];

  //and create a fallback for tab
  var tabWidth = this._opt.tabSize * space.xadvance;
  this._fallbackSpaceGlyph = space;
  this._fallbackTabGlyph = xtend(space, {
    x: 0, y: 0, xadvance: tabWidth, id: TAB_ID,
    xoffset: 0, yoffset: 0, width: 0, height: 0
  });
};

TextLayout.prototype.getGlyph = function (font, id) {
  var glyph = getGlyphById(font, id);
  if (glyph) return glyph;else if (id === TAB_ID) return this._fallbackTabGlyph;else if (id === SPACE_ID) return this._fallbackSpaceGlyph;
  return null;
};

TextLayout.prototype.computeMetrics = function (text, start, end, width) {
  var letterSpacing = this._opt.letterSpacing || 0;
  var font = this._opt.font;
  var curPen = 0;
  var curWidth = 0;
  var count = 0;
  var glyph;
  var lastGlyph;

  if (!font.chars || font.chars.length === 0) {
    return {
      start: start,
      end: start,
      width: 0
    };
  }

  end = Math.min(text.length, end);
  for (var i = start; i < end; i++) {
    var id = text.charCodeAt(i);
    var glyph = this.getGlyph(font, id);

    if (glyph) {
      //move pen forward
      var xoff = glyph.xoffset;
      var kern = lastGlyph ? getKerning(font, lastGlyph.id, glyph.id) : 0;
      curPen += kern;

      var nextPen = curPen + glyph.xadvance + letterSpacing;
      var nextWidth = curPen + glyph.width;

      //we've hit our limit; we can't move onto the next glyph
      if (nextWidth >= width || nextPen >= width) break;

      //otherwise continue along our line
      curPen = nextPen;
      curWidth = nextWidth;
      lastGlyph = glyph;
    }
    count++;
  }

  //make sure rightmost edge lines up with rendered glyphs
  if (lastGlyph) curWidth += lastGlyph.xoffset;

  return {
    start: start,
    end: start + count,
    width: curWidth
  };
}

//getters for the private vars
;['width', 'height', 'descender', 'ascender', 'xHeight', 'baseline', 'capHeight', 'lineHeight'].forEach(addGetter);

function addGetter(name) {
  Object.defineProperty(TextLayout.prototype, name, {
    get: wrapper(name),
    configurable: true
  });
}

//create lookups for private vars
function wrapper(name) {
  return new Function(['return function ' + name + '() {', '  return this._' + name, '}'].join('\n'))();
}

function getGlyphById(font, id) {
  if (!font.chars || font.chars.length === 0) return null;

  var glyphIdx = findChar(font.chars, id);
  if (glyphIdx >= 0) return font.chars[glyphIdx];
  return null;
}

function getXHeight(font) {
  for (var i = 0; i < X_HEIGHTS.length; i++) {
    var id = X_HEIGHTS[i].charCodeAt(0);
    var idx = findChar(font.chars, id);
    if (idx >= 0) return font.chars[idx].height;
  }
  return 0;
}

function getMGlyph(font) {
  for (var i = 0; i < M_WIDTHS.length; i++) {
    var id = M_WIDTHS[i].charCodeAt(0);
    var idx = findChar(font.chars, id);
    if (idx >= 0) return font.chars[idx];
  }
  return 0;
}

function getCapHeight(font) {
  for (var i = 0; i < CAP_HEIGHTS.length; i++) {
    var id = CAP_HEIGHTS[i].charCodeAt(0);
    var idx = findChar(font.chars, id);
    if (idx >= 0) return font.chars[idx].height;
  }
  return 0;
}

function getKerning(font, left, right) {
  if (!font.kernings || font.kernings.length === 0) return 0;

  var table = font.kernings;
  for (var i = 0; i < table.length; i++) {
    var kern = table[i];
    if (kern.first === left && kern.second === right) return kern.amount;
  }
  return 0;
}

function getAlignType(align) {
  if (align === 'center') return ALIGN_CENTER;else if (align === 'right') return ALIGN_RIGHT;
  return ALIGN_LEFT;
}

function findChar(array, value, start) {
  start = start || 0;
  for (var i = start; i < array.length; i++) {
    if (array[i].id === value) {
      return i;
    }
  }
  return -1;
}

/***/ }),

/***/ "5TyI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cae6c220d9f94c174a58bdb7ef335ca7.png";

/***/ }),

/***/ "5Wbt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.encodeBinary = encodeBinary;
var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

/**
 * Encodes binary into base64.
 *
 * @param {string} input The input data to encode.
 * @returns {string} The encoded base64 string
 */
function encodeBinary(input) {
    var output = '';
    var inx = 0;

    while (inx < input.length) {
        // Fill byte buffer array
        var bytebuffer = [0, 0, 0];
        var encodedCharIndexes = [0, 0, 0, 0];

        for (var jnx = 0; jnx < bytebuffer.length; ++jnx) {
            if (inx < input.length) {
                // throw away high-order byte, as documented at:
                // https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
                bytebuffer[jnx] = input.charCodeAt(inx++) & 0xff;
            } else {
                bytebuffer[jnx] = 0;
            }
        }

        // Get each encoded character, 6 bits at a time
        // index 1: first 6 bits
        encodedCharIndexes[0] = bytebuffer[0] >> 2;

        // index 2: second 6 bits (2 least significant bits from input byte 1 + 4 most significant bits from byte 2)
        encodedCharIndexes[1] = (bytebuffer[0] & 0x3) << 4 | bytebuffer[1] >> 4;

        // index 3: third 6 bits (4 least significant bits from input byte 2 + 2 most significant bits from byte 3)
        encodedCharIndexes[2] = (bytebuffer[1] & 0x0f) << 2 | bytebuffer[2] >> 6;

        // index 3: forth 6 bits (6 least significant bits from input byte 3)
        encodedCharIndexes[3] = bytebuffer[2] & 0x3f;

        // Determine whether padding happened, and adjust accordingly
        var paddingBytes = inx - (input.length - 1);

        switch (paddingBytes) {
            case 2:
                // Set last 2 characters to padding char
                encodedCharIndexes[3] = 64;
                encodedCharIndexes[2] = 64;
                break;

            case 1:
                // Set last character to padding char
                encodedCharIndexes[3] = 64;
                break;

            default:
                break; // No padding - proceed
        }

        // Now we will grab each appropriate character out of our keystring
        // based on our index array and append it to the output string
        for (var _jnx = 0; _jnx < encodedCharIndexes.length; ++_jnx) {
            output += _keyStr.charAt(encodedCharIndexes[_jnx]);
        }
    }

    return output;
}

// Backwards compat
if (true) {
    module.exports.default = encodeBinary; // eslint-disable-line no-undef
}
//# sourceMappingURL=b64.js.map

/***/ }),

/***/ "5XUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Required__ = __webpack_require__("0KR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Description__ = __webpack_require__("CuFb");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var InputField = function InputField(_ref) {
  var input = _ref.input,
      label = _ref.label,
      description = _ref.description,
      inputType = _ref.inputType,
      required = _ref.required,
      placeholder = _ref.placeholder,
      type = _ref.type,
      disabled = _ref.disabled,
      style = _ref.style,
      inputStyle = _ref.inputStyle,
      autocomplete = _ref.autocomplete,
      _ref$autofocus = _ref.autofocus,
      autofocus = _ref$autofocus === undefined ? false : _ref$autofocus,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning;

  inputType = inputType ? inputType : type;
  var invalidObj = {};
  if (required) {
    invalidObj = {
      "aria-invalid": error && touched ? "true" : "false"
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    {
      "class": touched && error ? "form-group has-error" : "form-group",
      style: style
    },
    label ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "label",
      { "for": input.name, "class": "form-label" },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__Required__["a" /* default */], { required: required }),
      label
    ) : "",
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__Description__["a" /* default */], { description: description }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("input", _extends({
      "class": "form-input",
      id: input.name,
      disabled: disabled
    }, input, {
      type: inputType,
      placeholder: placeholder,
      autocomplete: autocomplete,
      style: inputStyle
    }, invalidObj, {
      "aria-required": required ? "true" : "false",
      autofocus: autofocus,
      "aria-describedby": input.name + "Error"
    })),
    touched && error && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "p",
      { "class": "form-input-hint", id: input.name + "Error" },
      error
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (InputField);

/***/ }),

/***/ "5YsI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function isString(arg) {
    return typeof arg === 'string';
  },
  isObject: function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  },
  isNull: function isNull(arg) {
    return arg === null;
  },
  isNullOrUndefined: function isNullOrUndefined(arg) {
    return arg == null;
  }
};

/***/ }),

/***/ "5ZOS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    compileProgram: __webpack_require__("x48B"),
    defaultValue: __webpack_require__("7Hmw"),
    extractAttributes: __webpack_require__("LN7j"),
    extractUniforms: __webpack_require__("sq5Z"),
    generateUniformAccessObject: __webpack_require__("lval"),
    setPrecision: __webpack_require__("F9WP"),
    mapSize: __webpack_require__("KK7d"),
    mapType: __webpack_require__("3hrJ")
};

/***/ }),

/***/ "5cLE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("Ywoo");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LocaleUtils = __webpack_require__("Awug");

var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);

var _keys = __webpack_require__("SdFt");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption(props) {
    _classCallCheck(this, Caption);

    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === _keys.ENTER) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement('div', { className: classNames.caption, role: 'heading' }, _react2.default.createElement('div', { onClick: onClick, onKeyUp: this.handleKeyUp }, months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)));
    }
  }]);

  return Caption;
}(_react.Component);

Caption.defaultProps = {
  localeUtils: _LocaleUtils2.default
};
exports.default = Caption;
Caption.propTypes =  false ? {
  date: _propTypes2.default.instanceOf(Date),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired
  }).isRequired
} : {};
//# sourceMappingURL=Caption.js.map

/***/ }),

/***/ "5i8b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Seat_1 = __webpack_require__("ETAJ");
var Selector_1 = __webpack_require__("8Y7Z");
var InteractionManager_1 = __webpack_require__("dUAP");
var SelectionListener_1 = __webpack_require__("//Eg");
var Utils_1 = __webpack_require__("o6Mn");
var MoveableObject_1 = __webpack_require__("eqVo");
var bound_1 = __webpack_require__("USDo");
var Text_js_1 = __webpack_require__("h2Qz");
var Config_1 = __webpack_require__("gH/r");
var ActionTracker_1 = __webpack_require__("h0Oq");

var Table = function (_MoveableObject_1$def) {
    _inherits(Table, _MoveableObject_1$def);

    function Table(_ref, actions) {
        var _id = _ref._id,
            type = _ref.type,
            pos = _ref.pos,
            seats = _ref.seats,
            tableId = _ref.tableId,
            sectionId = _ref.sectionId,
            ticketIds = _ref.ticketIds,
            label = _ref.label,
            name = _ref.name,
            seatLabelPattern = _ref.seatLabelPattern,
            seatlabelStartAt = _ref.seatlabelStartAt,
            tablePrefix = _ref.tablePrefix,
            seatPrefix = _ref.seatPrefix,
            reserved = _ref.reserved,
            locked = _ref.locked,
            bookByTable = _ref.bookByTable,
            rotation = _ref.rotation,
            pivot = _ref.pivot;

        _classCallCheck(this, Table);

        var _this = _possibleConstructorReturn(this, _MoveableObject_1$def.call(this, _id, actions));

        var onSeatClicked = actions.onSeatClicked,
            onTableClicked = actions.onTableClicked,
            onTableUnclicked = actions.onTableUnclicked,
            onTableMoved = actions.onTableMoved,
            onElementClicked = actions.onElementClicked;

        _this.type = type;
        _this.rotation = rotation || 0;
        _this.basicType = "table";
        _this.onTableClicked = onTableClicked;
        _this.onElementClicked = onElementClicked;
        _this.onTableUnclicked = onTableUnclicked;
        _this.onTableMoved = onTableMoved;
        _this.tableId = tableId;
        _this.sectionId = sectionId;
        _this.tablePrefix = tablePrefix || "Table";
        _this.seatPrefix = seatPrefix;
        _this.seatlabelStartAt = seatlabelStartAt || 1;
        _this.label = label || _this.tableId + 1;
        _this.bookByTable = bookByTable || false;
        _this.seatLabelPattern = seatLabelPattern || Table.labelPatterns.COUNT;
        _this.name = name || _this.tablePrefix + " " + _this.label;
        _this.ticketIds = ticketIds || [];
        _this.seatData = seats;
        _this.onSeatClicked = function (seatId) {
            onSeatClicked(seatId, _this.tableId);
        };
        _this.tableTexture = PIXI.loader.resources[Utils_1.circleTableNotSelectedTexture].texture;
        _this.tableTexture.baseTexture.mipmap = true;
        _this.drag = false;
        _this.reserved = reserved;
        _this.locked = locked;
        _this.selected = false;
        _this.pos = pos;
        _this.pivot = pivot || { x: 0, y: 0 };
        _this.interactionManager = InteractionManager_1.default.createInteractionManager();
        _this.move = _this.move.bind(_this);
        return _this;
    }

    Table.prototype.draw = function draw() {
        this.setScales(this.seatData);
        this.tableInit(this.pos);
        this.seats = this.seatsInit(this.seatData, this.actions);
        this.seatContainer = this.getSeatContainer(this.pos);
        this.tableContainerInit(this.pos);
        this.selectionListener = new SelectionListener_1.default(this.moveableContainer, this, this.onClick);
    };

    Table.prototype.onRename = function onRename(cb) {
        this.renameCb = cb;
    };

    Table.prototype.setBookByTable = function setBookByTable(bookByTable) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setBookByTable", this.setBookByTable, [this.bookByTable]);
        this.bookByTable = bookByTable;
        this.ticketIds = [];
        if (this.packageTicketChangeCb) {
            this.packageTicketChangeCb();
        }
        this.onChange();
        return undoValue;
    };

    Table.prototype.setLocked = function setLocked(locked) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setLocked", this.setLocked, [this.locked]);
        this.locked = locked;
        this.seats.forEach(function (seat) {
            return seat.setLocked(locked);
        });
        this.onChange();
        return undoValue;
    };

    Table.prototype.setSeatLabelPattern = function setSeatLabelPattern(value) {
        var _this2 = this;

        var undoValue = ActionTracker_1.default.constructUndoValue("setSeatLabelPattern", this.setSeatLabelPattern, [this.seatLabelPattern]);
        this.seatLabelPattern = value;
        this.seats.forEach(function (seat) {
            return seat.setLabelPattern(_this2.seatLabelPattern);
        });
        return undoValue;
    };

    Table.prototype.setSeatLabelPrefix = function setSeatLabelPrefix(value) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setSeatLabelPrefix", this.setSeatLabelPrefix, [this.seatPrefix]);
        this.seatPrefix = value;
        return undoValue;
    };

    Table.prototype.setTableLabelPrefix = function setTableLabelPrefix(value) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setTableLabelPrefix", this.setTableLabelPrefix, [this.tablePrefix]);
        this.tablePrefix = value;
        this.name = this.tablePrefix + " " + this.label;
        this.rename();
        return undoValue;
    };

    Table.prototype.setLabel = function setLabel(value) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setLabel", this.setLabel, [this.label]);
        this.label = value;
        this.name = this.tablePrefix + " " + this.label;
        this.rename();
        this.onChange();
        return undoValue;
    };

    Table.prototype.setSectionId = function setSectionId(newSectionId) {
        var _this3 = this;

        this.sectionId = newSectionId;
        this.tables.forEach(function (table) {
            return table.setSectionId(_this3.sectionId);
        });
    };

    Table.prototype.rename = function rename() {
        if (this.renameCb) {
            this.renameCb();
        }
        this.text.text = this.name;
    };

    Table.prototype.setSeatLabelStartAt = function setSeatLabelStartAt(value) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setSeatLabelStartAt", this.setSeatLabelStartAt, [this.seatlabelStartAt]);
        this.seatlabelStartAt = value;
        this.seats.forEach(function (seat) {
            return seat.setSeatLabelStartAt(value);
        });
        return undoValue;
    };

    Table.prototype.toJSON = function toJSON() {
        return {
            _id: this._id,
            type: this.type,
            seats: this.seats.map(function (seat) {
                return seat.toJSON();
            }),
            pos: {
                x: this.moveableContainer.position.x,
                y: this.moveableContainer.position.y
            },
            globalPos: {
                x: this.moveableContainer.getGlobalPosition().x,
                y: this.moveableContainer.getGlobalPosition().y
            },
            tableId: this.tableId,
            label: this.label,
            name: this.name,
            sectionId: this.sectionId,
            ticketIds: this.ticketIds,
            locked: this.locked,
            bookByTable: this.bookByTable,
            rotation: this.moveableContainer.rotation,
            pivot: { x: this.moveableContainer.pivot.x, y: this.moveableContainer.pivot.y }
        };
    };

    Table.prototype.setContainerOffset = function setContainerOffset(x, y) {
        this.contXOffset = x;
        this.contYOffset = y;
    };

    Table.prototype.getBounds = function getBounds() {
        var width = (this.seatCircleRadius + Utils_1.seatWidth / 2) * 2;
        var height = (this.seatCircleRadius + Utils_1.seatHeight / 2) * 2;
        var x = this.moveableContainer.position.x + this.table.position.x - width / 2 - this.moveableContainer.pivot.x;
        var y = this.moveableContainer.position.y + this.table.position.y - height / 2 - this.moveableContainer.pivot.y;
        return {
            top: y,
            bottom: y + height,
            left: x,
            right: x + width
        };
    };

    Table.prototype.getTableCapacity = function getTableCapacity() {
        return this.seats.filter(function (seat) {
            return !seat.disabled;
        }).length;
    };

    Table.prototype.getSelectionBoxBounds = function getSelectionBoxBounds() {
        var offset = this.actions.getOffset();
        var width = (this.seatCircleRadius + Utils_1.seatWidth / 2) * 2;
        var height = (this.seatCircleRadius + Utils_1.seatWidth / 2) * 2;
        var x = this.moveableContainer.position.x + this.table.position.x - width / 2 + offset.x - this.moveableContainer.pivot.x;
        var y = this.moveableContainer.position.y + this.table.position.y - height / 2 + offset.y - this.moveableContainer.pivot.y;
        return { x: x, y: y, width: width, height: height };
    };

    Table.prototype.onSelect = function onSelect() {
        this.selected = true;
        this.seats.forEach(function (seat) {
            return seat.onTableSelected();
        });
        this.updateTexture();
    };

    Table.prototype.onDeselect = function onDeselect() {
        this.selected = false;
        this.seats.forEach(function (seat) {
            return seat.onTableDeselected();
        });
        this.updateTexture();
    };

    Table.prototype.updateTexture = function updateTexture() {
        var currentTexture = this.selected ? Utils_1.circleTableSelectedTexture : Utils_1.circleTableNotSelectedTexture;
        this.tableTexture = PIXI.loader.resources[currentTexture].texture;
        this.tableTexture.baseTexture.mipmap = true;
        this.table.texture = this.tableTexture;
    };

    Table.prototype.drawSelectionBox = function drawSelectionBox() {
        var _getSelectionBoxBound = this.getSelectionBoxBounds(),
            x = _getSelectionBoxBound.x,
            y = _getSelectionBoxBound.y,
            width = _getSelectionBoxBound.width,
            height = _getSelectionBoxBound.height;

        Selector_1.drawSelectionBox(x, y, width, height);
    };

    Table.prototype.setTableLabel = function setTableLabel() {
        this.text = Text_js_1.TextWrapper.createText(this.name, Config_1.default.fontStyle);
    };

    Table.prototype.getSeatPos = function getSeatPos(i, seatCount) {
        var posX = Math.ceil(this.seatCircleRadius * Math.cos(i * (2 * Math.PI) / seatCount));
        var posY = Math.ceil(this.seatCircleRadius * Math.sin(i * (2 * Math.PI) / seatCount));
        return { x: posX, y: posY };
    };

    Table.prototype.seatsInit = function seatsInit(seats, actions) {
        var _this4 = this;

        var seatCount = seats.length;
        return seats.map(function (seat, i) {
            var constructionValue = _extends({ pos: _this4.getSeatPos(i, seatCount), seatlabelStartAt: _this4.seatlabelStartAt }, seat);
            actions.onSeatClicked = _this4.onSeatClicked;
            return new Seat_1.default(constructionValue, actions);
        });
    };

    Table.prototype.tableInit = function tableInit(pos) {
        this.table = new PIXI.Sprite(this.tableTexture);
        this.table.anchor = new PIXI.ObservablePoint(function () {}, undefined, 0.5, 0.5);
        this.table.scale = new PIXI.Point(this.scale, this.scale);
        this.setTableLabel();
    };

    Table.prototype.setScales = function setScales(seats) {
        this.scale = seats.length > 8 ? seats.length / 8 * 0.2 : 0.2;
        this.seatCircleRadius = this.tableTexture.orig.width * this.scale / 2 + Utils_1.seatWidth / 2 + 5;
    };

    Table.prototype.tableContainerInit = function tableContainerInit(_ref2) {
        var x = _ref2.x,
            y = _ref2.y;

        this.containerScale = new PIXI.Point(1, 1);
        this.moveableContainer = new PIXI.Container();
        this.moveableContainer.parentGroup = Config_1.default.spriteGroup;
        this.moveableContainer.position = new PIXI.Point(x, y);
        this.moveableContainer.pivot.x = this.pivot.x;
        this.moveableContainer.pivot.y = this.pivot.y;
        this.moveableContainer.rotation = this.rotation;
        this.moveableContainer.interactive = true;
        this.moveableContainer.buttonMode = true;
        this.moveableContainer.addChild(this.table);
        this.moveableContainer.addChild(this.text);
        this.moveableContainer.addChild(this.seatContainer);
        this.moveableContainer.scale = this.containerScale;
    };

    Table.prototype.getReleventControlData = function getReleventControlData() {
        return { id: this.tableId, type: this.type, sectionId: this.sectionId, seatNum: this.seats.length };
    };

    Table.prototype.assignTicketType = function assignTicketType(ticketId) {
        this.seats.map(function (seat) {
            return seat.assignTicketType(ticketId);
        });
        this.ticketIds.push(ticketId);
        this.onChange();
        return ActionTracker_1.default.constructUndoValue("assignTicketType", this.removeTicketType, [ticketId]);
    };

    Table.prototype.removeTicketType = function removeTicketType(ticketId) {
        this.seats.map(function (seat) {
            return seat.removeTicketType(ticketId);
        });
        var index = this.ticketIds.indexOf(ticketId);
        if (index > -1) {
            this.ticketIds.splice(index, 1);
            this.onChange();
            return ActionTracker_1.default.constructUndoValue("removeTicketType", this.assignTicketType, [ticketId]);
        }
    };

    Table.prototype.countTicketMappings = function countTicketMappings() {
        var ticketMapping = this.seats.map(function (seat) {
            return seat.countTicketMappings();
        }).reduce(function (current, ticketMappings) {
            return current.concat(ticketMappings);
        }, []);
        return ticketMapping.reduce(function (total, ticketMapping) {
            if (!total[ticketMapping]) {
                total[ticketMapping] = 1;
            } else {
                total[ticketMapping] = total[ticketMapping] + 1;
            }
            return total;
        }, {});
    };

    Table.prototype.onClick = function onClick() {
        if (this.seats.filter(function (seat) {
            return seat.isSelected;
        }).length === 0) {
            this.interactionManager.itemSelected(this);
        }
    };

    Table.prototype.onPackageTicketChange = function onPackageTicketChange(cb) {
        this.packageTicketChangeCb = cb;
    };

    Table.prototype.getPoints = function getPoints() {
        var width = (this.seatCircleRadius + Utils_1.seatWidth / 2) * 2;
        var height = (this.seatCircleRadius + Utils_1.seatHeight / 2) * 2;
        var x = this.moveableContainer.position.x + this.table.position.x - width / 2;
        var y = this.moveableContainer.position.y + this.table.position.y - height / 2;
        return this.pointsBetween(x, y, width, height);
    };

    Table.prototype.pointsBetween = function pointsBetween(x, y, width, height) {
        var points = [];
        var amountBetween = 10;
        for (var i = 0; i <= amountBetween; i++) {
            points.push([x + width * i / amountBetween, y]);
        }
        for (var i = 0; i <= amountBetween; i++) {
            points.push([x + width, y + height * i / amountBetween]);
        }
        for (var i = 0; i <= amountBetween; i++) {
            points.push([x + width - i * width / amountBetween, y + height]);
        }
        for (var i = 0; i <= amountBetween; i++) {
            points.push([x, y + height - height * i / amountBetween]);
        }
        return points;
    };

    Table.prototype.getSeatContainer = function getSeatContainer(_ref3) {
        var x = _ref3.x,
            y = _ref3.y;

        var seatContainer = new PIXI.Container();
        this.seats.forEach(function (seat) {
            return seatContainer.addChild(seat.getSeat());
        });
        return seatContainer;
    };

    Table.prototype.getTableContainer = function getTableContainer() {
        return this.moveableContainer;
    };

    Table.prototype.addSeats = function addSeats(seatData, amount) {
        var _this5 = this;

        seatData.pos = { x: -100, y: -100 };
        for (var i = 0; i < amount; i++) {
            seatData.seatId = this.seats.length;
            seatData.seatlabelStartAt = this.seatlabelStartAt;
            this.seats.push(new Seat_1.default(seatData, this.actions));
        }
        this.setScales(this.seats);
        this.interactionManager.drawBounds(this);
        this.table.scale = new PIXI.Point(this.scale, this.scale);
        var seatCount = this.seats.length;
        this.seats.forEach(function (seat, i) {
            seat.setPos(_this5.getSeatPos(i, seatCount));
        });
        for (var i = seatCount - amount; i < seatCount; i++) {
            this.seatContainer.addChild(this.seats[i].getSeat());
        }
        this.onChange();
    };

    Table.prototype.boundBy = function boundBy(p3, p4) {
        var width = (this.seatCircleRadius + Utils_1.seatWidth / 2) * 2;
        var height = (this.seatCircleRadius + Utils_1.seatHeight / 2) * 2;
        var x = this.moveableContainer.position.x + this.table.position.x - width / 2 + this.contXOffset;
        var y = this.moveableContainer.position.y + this.table.position.y - height / 2 + this.contYOffset;
        var p1 = { x: x, y: y };
        var p2 = { x: x + width, y: y + height };
        if (!(p2.y < p3.y || p1.y > p4.y || p2.x < p3.x || p1.x > p4.x)) {
            this.selected = true;
        } else {
            this.selected = false;
        }
        return this;
    };

    Table.prototype.getSeatsBoundBy = function getSeatsBoundBy(p3, p4) {
        var width = (this.seatCircleRadius + Utils_1.seatWidth / 2) * 2;
        var height = (this.seatCircleRadius + Utils_1.seatHeight / 2) * 2;
        var x = this.moveableContainer.position.x + this.table.position.x - width / 2 + this.contXOffset;
        var y = this.moveableContainer.position.y + this.table.position.y - height / 2 + this.contYOffset;
        var p1 = { x: x, y: y };
        var p2 = { x: p1.x + Utils_1.seatWidth, y: p1.y + Utils_1.seatHeight };
        return this.seats.map(function (seat) {
            return seat.boundBy(p1, p2, p3, p4);
        }).filter(function (seat) {
            return seat;
        });
    };

    Table.prototype.setId = function setId(tableId) {
        this.tableId = tableId;
    };

    Table.prototype.getTableId = function getTableId() {
        return this.tableId;
    };

    Table.prototype.removeSeats = function removeSeats(amount) {
        var _this6 = this;

        for (var i = 0; i < amount; i++) {
            this.seats.splice(-1, 1);
            this.seatContainer.removeChildAt(this.seatContainer.children.length - 1);
        }
        this.setScales(this.seats);
        this.interactionManager.drawBounds(this);
        this.table.scale = new PIXI.Point(this.scale, this.scale);
        var seatCount = this.seats.length;
        this.seats.forEach(function (seat, i) {
            seat.setPos(_this6.getSeatPos(i, seatCount));
        });
        this.onChange();
    };

    Table.prototype.getPos = function getPos() {
        return this.moveableContainer.position;
    };

    Table.prototype.disableNextClick = function disableNextClick() {
        this.seats.forEach(function (seat) {
            return seat.disableNextClick();
        });
    };

    Table.prototype.enableNextClick = function enableNextClick() {
        this.seats.forEach(function (seat) {
            return seat.enableNextClick();
        });
    };

    Table.prototype.isThisTable = function isThisTable(_id) {
        return this._id === _id;
    };

    Table.prototype.getId = function getId() {
        return this._id;
    };

    Table.prototype.toggleTicketTypeColors = function toggleTicketTypeColors(enable) {
        this.seats.forEach(function (seat) {
            return seat.toggleTicketTypeColors(enable);
        });
    };

    return Table;
}(MoveableObject_1.default);

Table.tableTypes = {
    ROUND: "round",
    RECT: "rect"
};
Table.labelPatterns = {
    COUNT: "count",
    ALPHABET: "alphabet"
};
__decorate([bound_1.default], Table.prototype, "onRename", null);
__decorate([bound_1.default], Table.prototype, "setBookByTable", null);
__decorate([bound_1.default], Table.prototype, "setLocked", null);
__decorate([bound_1.default], Table.prototype, "setSeatLabelPattern", null);
__decorate([bound_1.default], Table.prototype, "setSeatLabelPrefix", null);
__decorate([bound_1.default], Table.prototype, "setTableLabelPrefix", null);
__decorate([bound_1.default], Table.prototype, "setLabel", null);
__decorate([bound_1.default], Table.prototype, "setSectionId", null);
__decorate([bound_1.default], Table.prototype, "rename", null);
__decorate([bound_1.default], Table.prototype, "setSeatLabelStartAt", null);
__decorate([bound_1.default], Table.prototype, "setContainerOffset", null);
__decorate([bound_1.default], Table.prototype, "getBounds", null);
__decorate([bound_1.default], Table.prototype, "getTableCapacity", null);
__decorate([bound_1.default], Table.prototype, "onSelect", null);
__decorate([bound_1.default], Table.prototype, "onDeselect", null);
__decorate([bound_1.default], Table.prototype, "seatsInit", null);
__decorate([bound_1.default], Table.prototype, "tableInit", null);
__decorate([bound_1.default], Table.prototype, "setScales", null);
__decorate([bound_1.default], Table.prototype, "getReleventControlData", null);
__decorate([bound_1.default], Table.prototype, "assignTicketType", null);
__decorate([bound_1.default], Table.prototype, "removeTicketType", null);
__decorate([bound_1.default], Table.prototype, "countTicketMappings", null);
__decorate([bound_1.default], Table.prototype, "onClick", null);
__decorate([bound_1.default], Table.prototype, "onPackageTicketChange", null);
__decorate([bound_1.default], Table.prototype, "getSeatContainer", null);
__decorate([bound_1.default], Table.prototype, "getTableContainer", null);
__decorate([bound_1.default], Table.prototype, "boundBy", null);
__decorate([bound_1.default], Table.prototype, "setId", null);
__decorate([bound_1.default], Table.prototype, "getTableId", null);
__decorate([bound_1.default], Table.prototype, "disableNextClick", null);
__decorate([bound_1.default], Table.prototype, "enableNextClick", null);
__decorate([bound_1.default], Table.prototype, "isThisTable", null);
__decorate([bound_1.default], Table.prototype, "getId", null);
__decorate([bound_1.default], Table.prototype, "toggleTicketTypeColors", null);
exports.default = Table;
//# sourceMappingURL=Table.js.map

/***/ }),

/***/ "5jj8":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function (main) {
  'use strict';

  /**
   * Parse or format dates
   * @class fecha
   */

  var fecha = {};
  var token = /d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
  var twoDigits = /\d\d?/;
  var threeDigits = /\d{3}/;
  var fourDigits = /\d{4}/;
  var word = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
  var literal = /\[([^]*?)\]/gm;
  var noop = function noop() {};

  function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
      newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
  }

  function monthUpdate(arrName) {
    return function (d, v, i18n) {
      var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
      if (~index) {
        d.month = index;
      }
    };
  }

  function pad(val, len) {
    val = String(val);
    len = len || 2;
    while (val.length < len) {
      val = '0' + val;
    }
    return val;
  }

  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var monthNamesShort = shorten(monthNames, 3);
  var dayNamesShort = shorten(dayNames, 3);
  fecha.i18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ['am', 'pm'],
    DoFn: function DoFn(D) {
      return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
    }
  };

  var formatFlags = {
    D: function D(dateObj) {
      return dateObj.getDate();
    },
    DD: function DD(dateObj) {
      return pad(dateObj.getDate());
    },
    Do: function Do(dateObj, i18n) {
      return i18n.DoFn(dateObj.getDate());
    },
    d: function d(dateObj) {
      return dateObj.getDay();
    },
    dd: function dd(dateObj) {
      return pad(dateObj.getDay());
    },
    ddd: function ddd(dateObj, i18n) {
      return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function dddd(dateObj, i18n) {
      return i18n.dayNames[dateObj.getDay()];
    },
    M: function M(dateObj) {
      return dateObj.getMonth() + 1;
    },
    MM: function MM(dateObj) {
      return pad(dateObj.getMonth() + 1);
    },
    MMM: function MMM(dateObj, i18n) {
      return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function MMMM(dateObj, i18n) {
      return i18n.monthNames[dateObj.getMonth()];
    },
    YY: function YY(dateObj) {
      return String(dateObj.getFullYear()).substr(2);
    },
    YYYY: function YYYY(dateObj) {
      return pad(dateObj.getFullYear(), 4);
    },
    h: function h(dateObj) {
      return dateObj.getHours() % 12 || 12;
    },
    hh: function hh(dateObj) {
      return pad(dateObj.getHours() % 12 || 12);
    },
    H: function H(dateObj) {
      return dateObj.getHours();
    },
    HH: function HH(dateObj) {
      return pad(dateObj.getHours());
    },
    m: function m(dateObj) {
      return dateObj.getMinutes();
    },
    mm: function mm(dateObj) {
      return pad(dateObj.getMinutes());
    },
    s: function s(dateObj) {
      return dateObj.getSeconds();
    },
    ss: function ss(dateObj) {
      return pad(dateObj.getSeconds());
    },
    S: function S(dateObj) {
      return Math.round(dateObj.getMilliseconds() / 100);
    },
    SS: function SS(dateObj) {
      return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function SSS(dateObj) {
      return pad(dateObj.getMilliseconds(), 3);
    },
    a: function a(dateObj, i18n) {
      return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function A(dateObj, i18n) {
      return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
    },
    ZZ: function ZZ(dateObj) {
      var o = dateObj.getTimezoneOffset();
      return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
    }
  };

  var parseFlags = {
    D: [twoDigits, function (d, v) {
      d.day = v;
    }],
    Do: [new RegExp(twoDigits.source + word.source), function (d, v) {
      d.day = parseInt(v, 10);
    }],
    M: [twoDigits, function (d, v) {
      d.month = v - 1;
    }],
    YY: [twoDigits, function (d, v) {
      var da = new Date(),
          cent = +('' + da.getFullYear()).substr(0, 2);
      d.year = '' + (v > 68 ? cent - 1 : cent) + v;
    }],
    h: [twoDigits, function (d, v) {
      d.hour = v;
    }],
    m: [twoDigits, function (d, v) {
      d.minute = v;
    }],
    s: [twoDigits, function (d, v) {
      d.second = v;
    }],
    YYYY: [fourDigits, function (d, v) {
      d.year = v;
    }],
    S: [/\d/, function (d, v) {
      d.millisecond = v * 100;
    }],
    SS: [/\d{2}/, function (d, v) {
      d.millisecond = v * 10;
    }],
    SSS: [threeDigits, function (d, v) {
      d.millisecond = v;
    }],
    d: [twoDigits, noop],
    ddd: [word, noop],
    MMM: [word, monthUpdate('monthNamesShort')],
    MMMM: [word, monthUpdate('monthNames')],
    a: [word, function (d, v, i18n) {
      var val = v.toLowerCase();
      if (val === i18n.amPm[0]) {
        d.isPm = false;
      } else if (val === i18n.amPm[1]) {
        d.isPm = true;
      }
    }],
    ZZ: [/([\+\-]\d\d:?\d\d|Z)/, function (d, v) {
      if (v === 'Z') v = '+00:00';
      var parts = (v + '').match(/([\+\-]|\d\d)/gi),
          minutes;

      if (parts) {
        minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
      }
    }]
  };
  parseFlags.dd = parseFlags.d;
  parseFlags.dddd = parseFlags.ddd;
  parseFlags.DD = parseFlags.D;
  parseFlags.mm = parseFlags.m;
  parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
  parseFlags.MM = parseFlags.M;
  parseFlags.ss = parseFlags.s;
  parseFlags.A = parseFlags.a;

  // Some common format strings
  fecha.masks = {
    default: 'ddd MMM DD YYYY HH:mm:ss',
    shortDate: 'M/D/YY',
    mediumDate: 'MMM D, YYYY',
    longDate: 'MMMM D, YYYY',
    fullDate: 'dddd, MMMM D, YYYY',
    shortTime: 'HH:mm',
    mediumTime: 'HH:mm:ss',
    longTime: 'HH:mm:ss.SSS'
  };

  /***
   * Format a date
   * @method format
   * @param {Date|number} dateObj
   * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
   */
  fecha.format = function (dateObj, mask, i18nSettings) {
    var i18n = i18nSettings || fecha.i18n;

    if (typeof dateObj === 'number') {
      dateObj = new Date(dateObj);
    }

    if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
      throw new Error('Invalid Date in fecha.format');
    }

    mask = fecha.masks[mask] || mask || fecha.masks['default'];

    var literals = [];

    // Make literals inactive by replacing them with ??
    mask = mask.replace(literal, function ($0, $1) {
      literals.push($1);
      return '??';
    });
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
      return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/\?\?/g, function () {
      return literals.shift();
    });
  };

  /**
   * Parse a date string into an object, changes - into /
   * @method parse
   * @param {string} dateStr Date string
   * @param {string} format Date parse format
   * @returns {Date|boolean}
   */
  fecha.parse = function (dateStr, format, i18nSettings) {
    var i18n = i18nSettings || fecha.i18n;

    if (typeof format !== 'string') {
      throw new Error('Invalid format in fecha.parse');
    }

    format = fecha.masks[format] || format;

    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
      return false;
    }

    var isValid = true;
    var dateInfo = {};
    format.replace(token, function ($0) {
      if (parseFlags[$0]) {
        var info = parseFlags[$0];
        var index = dateStr.search(info[0]);
        if (!~index) {
          isValid = false;
        } else {
          dateStr.replace(info[0], function (result) {
            info[1](dateInfo, result, i18n);
            dateStr = dateStr.substr(index + result.length);
            return result;
          });
        }
      }

      return parseFlags[$0] ? '' : $0.slice(1, $0.length - 1);
    });

    if (!isValid) {
      return false;
    }

    var today = new Date();
    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
      dateInfo.hour = +dateInfo.hour + 12;
    } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
      dateInfo.hour = 0;
    }

    var date;
    if (dateInfo.timezoneOffset != null) {
      dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
      date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
    } else {
      date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
    }
    return date;
  };

  /* istanbul ignore next */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = fecha;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return fecha;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    main.fecha = fecha;
  }
})(this);

/***/ }),

/***/ "5ocZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bb7aca9fd156c4388c4ac6f494db503c.svg";

/***/ }),

/***/ "5t/1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var SelectableObject = function () {
    function SelectableObject(_id, pos, reserved, held, locked, ticketIds, bookByTable) {
        _classCallCheck(this, SelectableObject);

        this.selected = false;
        this._id = _id;
        this.pos = pos;
        this.reserved = reserved;
        this.held = held;
        this.locked = locked;
        this.ticketIds = ticketIds;
        this.bookByTable = bookByTable;
    }

    _createClass(SelectableObject, [{
        key: "id",
        get: function get() {
            return this._id;
        }
    }]);

    return SelectableObject;
}();

exports.default = SelectableObject;
//# sourceMappingURL=SelectableObject.js.map

/***/ }),

/***/ "5u59":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Ticker = exports.shared = undefined;

var _Ticker = __webpack_require__("nuOJ");

var _Ticker2 = _interopRequireDefault(_Ticker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The shared ticker instance used by {@link PIXI.extras.AnimatedSprite}.
 * and by {@link PIXI.interaction.InteractionManager}.
 * The property {@link PIXI.ticker.Ticker#autoStart} is set to `true`
 * for this instance. Please follow the examples for usage, including
 * how to opt-out of auto-starting the shared ticker.
 *
 * @example
 * let ticker = PIXI.ticker.shared;
 * // Set this to prevent starting this ticker when listeners are added.
 * // By default this is true only for the PIXI.ticker.shared instance.
 * ticker.autoStart = false;
 * // FYI, call this to ensure the ticker is stopped. It should be stopped
 * // if you have not attempted to render anything yet.
 * ticker.stop();
 * // Call this when you are ready for a running shared ticker.
 * ticker.start();
 *
 * @example
 * // You may use the shared ticker to render...
 * let renderer = PIXI.autoDetectRenderer(800, 600);
 * let stage = new PIXI.Container();
 * let interactionManager = PIXI.interaction.InteractionManager(renderer);
 * document.body.appendChild(renderer.view);
 * ticker.add(function (time) {
 *     renderer.render(stage);
 * });
 *
 * @example
 * // Or you can just update it manually.
 * ticker.autoStart = false;
 * ticker.stop();
 * function animate(time) {
 *     ticker.update(time);
 *     renderer.render(stage);
 *     requestAnimationFrame(animate);
 * }
 * animate(performance.now());
 *
 * @type {PIXI.ticker.Ticker}
 * @memberof PIXI.ticker
 */
var shared = new _Ticker2.default();

shared.autoStart = true;
shared.destroy = function () {
  // protect destroying shared ticker
  // this is used by other internal systems
  // like AnimatedSprite and InteractionManager
};

/**
 * This namespace contains an API for interacting with PIXI's internal global update loop.
 *
 * This ticker is used for rendering, {@link PIXI.extras.AnimatedSprite AnimatedSprite},
 * {@link PIXI.interaction.InteractionManager InteractionManager} and many other time-based PIXI systems.
 * @example
 * const ticker = new PIXI.ticker.Ticker();
 * ticker.stop();
 * ticker.add((deltaTime) => {
 *   // do something every frame
 * });
 * ticker.start();
 * @namespace PIXI.ticker
 */
exports.shared = shared;
exports.Ticker = _Ticker2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "5xRX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eb69debd5434a3f8260d59484e015d07.svg";

/***/ }),

/***/ "64fV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _Texture = __webpack_require__("xUki");

var _Texture2 = _interopRequireDefault(_Texture);

var _BaseTexture = __webpack_require__("ce6K");

var _BaseTexture2 = _interopRequireDefault(_BaseTexture);

var _utils = __webpack_require__("dDI1");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DisplayObject = core.DisplayObject;
var _tempMatrix = new core.Matrix();

DisplayObject.prototype._cacheAsBitmap = false;
DisplayObject.prototype._cacheData = false;

// figured theres no point adding ALL the extra variables to prototype.
// this model can hold the information needed. This can also be generated on demand as
// most objects are not cached as bitmaps.
/**
 * @class
 * @ignore
 */

var CacheData =
/**
 *
 */
function CacheData() {
    _classCallCheck(this, CacheData);

    this.textureCacheId = null;

    this.originalRenderWebGL = null;
    this.originalRenderCanvas = null;
    this.originalCalculateBounds = null;
    this.originalGetLocalBounds = null;

    this.originalUpdateTransform = null;
    this.originalHitTest = null;
    this.originalDestroy = null;
    this.originalMask = null;
    this.originalFilterArea = null;
    this.sprite = null;
};

Object.defineProperties(DisplayObject.prototype, {
    /**
     * Set this to true if you want this display object to be cached as a bitmap.
     * This basically takes a snap shot of the display object as it is at that moment. It can
     * provide a performance benefit for complex static displayObjects.
     * To remove simply set this property to 'false'
     *
     * IMPORTANT GOTCHA - make sure that all your textures are preloaded BEFORE setting this property to true
     * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
     *
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     */
    cacheAsBitmap: {
        get: function get() {
            return this._cacheAsBitmap;
        },
        set: function set(value) {
            if (this._cacheAsBitmap === value) {
                return;
            }

            this._cacheAsBitmap = value;

            var data = void 0;

            if (value) {
                if (!this._cacheData) {
                    this._cacheData = new CacheData();
                }

                data = this._cacheData;

                data.originalRenderWebGL = this.renderWebGL;
                data.originalRenderCanvas = this.renderCanvas;

                data.originalUpdateTransform = this.updateTransform;
                data.originalCalculateBounds = this.calculateBounds;
                data.originalGetLocalBounds = this.getLocalBounds;

                data.originalDestroy = this.destroy;

                data.originalContainsPoint = this.containsPoint;

                data.originalMask = this._mask;
                data.originalFilterArea = this.filterArea;

                this.renderWebGL = this._renderCachedWebGL;
                this.renderCanvas = this._renderCachedCanvas;

                this.destroy = this._cacheAsBitmapDestroy;
            } else {
                data = this._cacheData;

                if (data.sprite) {
                    this._destroyCachedDisplayObject();
                }

                this.renderWebGL = data.originalRenderWebGL;
                this.renderCanvas = data.originalRenderCanvas;
                this.calculateBounds = data.originalCalculateBounds;
                this.getLocalBounds = data.originalGetLocalBounds;

                this.destroy = data.originalDestroy;

                this.updateTransform = data.originalUpdateTransform;
                this.containsPoint = data.originalContainsPoint;

                this._mask = data.originalMask;
                this.filterArea = data.originalFilterArea;
            }
        }
    }
});

/**
 * Renders a cached version of the sprite with WebGL
 *
 * @private
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
 */
DisplayObject.prototype._renderCachedWebGL = function _renderCachedWebGL(renderer) {
    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
        return;
    }

    this._initCachedDisplayObject(renderer);

    this._cacheData.sprite.transform._worldID = this.transform._worldID;
    this._cacheData.sprite.worldAlpha = this.worldAlpha;
    this._cacheData.sprite._renderWebGL(renderer);
};

/**
 * Prepares the WebGL renderer to cache the sprite
 *
 * @private
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
 */
DisplayObject.prototype._initCachedDisplayObject = function _initCachedDisplayObject(renderer) {
    if (this._cacheData && this._cacheData.sprite) {
        return;
    }

    // make sure alpha is set to 1 otherwise it will get rendered as invisible!
    var cacheAlpha = this.alpha;

    this.alpha = 1;

    // first we flush anything left in the renderer (otherwise it would get rendered to the cached texture)
    renderer.currentRenderer.flush();
    // this.filters= [];

    // next we find the dimensions of the untransformed object
    // this function also calls updatetransform on all its children as part of the measuring.
    // This means we don't need to update the transform again in this function
    // TODO pass an object to clone too? saves having to create a new one each time!
    var bounds = this.getLocalBounds().clone();

    // add some padding!
    if (this._filters && this._filters.length) {
        var padding = this._filters[0].padding;

        bounds.pad(padding);
    }

    bounds.ceil(core.settings.RESOLUTION);

    // for now we cache the current renderTarget that the webGL renderer is currently using.
    // this could be more elegent..
    var cachedRenderTarget = renderer._activeRenderTarget;
    // We also store the filter stack - I will definitely look to change how this works a little later down the line.
    var stack = renderer.filterManager.filterStack;

    // this renderTexture will be used to store the cached DisplayObject

    var renderTexture = core.RenderTexture.create(bounds.width, bounds.height);

    var textureCacheId = 'cacheAsBitmap_' + (0, _utils.uid)();

    this._cacheData.textureCacheId = textureCacheId;

    _BaseTexture2.default.addToCache(renderTexture.baseTexture, textureCacheId);
    _Texture2.default.addToCache(renderTexture, textureCacheId);

    // need to set //
    var m = _tempMatrix;

    m.tx = -bounds.x;
    m.ty = -bounds.y;

    // reset
    this.transform.worldTransform.identity();

    // set all properties to there original so we can render to a texture
    this.renderWebGL = this._cacheData.originalRenderWebGL;

    renderer.render(this, renderTexture, true, m, true);
    // now restore the state be setting the new properties

    renderer.bindRenderTarget(cachedRenderTarget);

    renderer.filterManager.filterStack = stack;

    this.renderWebGL = this._renderCachedWebGL;
    // the rest is the same as for Canvas
    this.updateTransform = this.displayObjectUpdateTransform;
    this.calculateBounds = this._calculateCachedBounds;
    this.getLocalBounds = this._getCachedLocalBounds;

    this._mask = null;
    this.filterArea = null;

    // create our cached sprite
    var cachedSprite = new core.Sprite(renderTexture);

    cachedSprite.transform.worldTransform = this.transform.worldTransform;
    cachedSprite.anchor.x = -(bounds.x / bounds.width);
    cachedSprite.anchor.y = -(bounds.y / bounds.height);
    cachedSprite.alpha = cacheAlpha;
    cachedSprite._bounds = this._bounds;

    this._cacheData.sprite = cachedSprite;

    this.transform._parentID = -1;
    // restore the transform of the cached sprite to avoid the nasty flicker..
    if (!this.parent) {
        this.parent = renderer._tempDisplayObjectParent;
        this.updateTransform();
        this.parent = null;
    } else {
        this.updateTransform();
    }

    // map the hit test..
    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};

/**
 * Renders a cached version of the sprite with canvas
 *
 * @private
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
 */
DisplayObject.prototype._renderCachedCanvas = function _renderCachedCanvas(renderer) {
    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
        return;
    }

    this._initCachedDisplayObjectCanvas(renderer);

    this._cacheData.sprite.worldAlpha = this.worldAlpha;
    this._cacheData.sprite._renderCanvas(renderer);
};

// TODO this can be the same as the webGL verison.. will need to do a little tweaking first though..
/**
 * Prepares the Canvas renderer to cache the sprite
 *
 * @private
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
 */
DisplayObject.prototype._initCachedDisplayObjectCanvas = function _initCachedDisplayObjectCanvas(renderer) {
    if (this._cacheData && this._cacheData.sprite) {
        return;
    }

    // get bounds actually transforms the object for us already!
    var bounds = this.getLocalBounds();

    var cacheAlpha = this.alpha;

    this.alpha = 1;

    var cachedRenderTarget = renderer.context;

    bounds.ceil(core.settings.RESOLUTION);

    var renderTexture = core.RenderTexture.create(bounds.width, bounds.height);

    var textureCacheId = 'cacheAsBitmap_' + (0, _utils.uid)();

    this._cacheData.textureCacheId = textureCacheId;

    _BaseTexture2.default.addToCache(renderTexture.baseTexture, textureCacheId);
    _Texture2.default.addToCache(renderTexture, textureCacheId);

    // need to set //
    var m = _tempMatrix;

    this.transform.localTransform.copy(m);
    m.invert();

    m.tx -= bounds.x;
    m.ty -= bounds.y;

    // m.append(this.transform.worldTransform.)
    // set all properties to there original so we can render to a texture
    this.renderCanvas = this._cacheData.originalRenderCanvas;

    // renderTexture.render(this, m, true);
    renderer.render(this, renderTexture, true, m, false);

    // now restore the state be setting the new properties
    renderer.context = cachedRenderTarget;

    this.renderCanvas = this._renderCachedCanvas;
    // the rest is the same as for WebGL
    this.updateTransform = this.displayObjectUpdateTransform;
    this.calculateBounds = this._calculateCachedBounds;
    this.getLocalBounds = this._getCachedLocalBounds;

    this._mask = null;
    this.filterArea = null;

    // create our cached sprite
    var cachedSprite = new core.Sprite(renderTexture);

    cachedSprite.transform.worldTransform = this.transform.worldTransform;
    cachedSprite.anchor.x = -(bounds.x / bounds.width);
    cachedSprite.anchor.y = -(bounds.y / bounds.height);
    cachedSprite.alpha = cacheAlpha;
    cachedSprite._bounds = this._bounds;

    this._cacheData.sprite = cachedSprite;

    this.transform._parentID = -1;
    // restore the transform of the cached sprite to avoid the nasty flicker..
    if (!this.parent) {
        this.parent = renderer._tempDisplayObjectParent;
        this.updateTransform();
        this.parent = null;
    } else {
        this.updateTransform();
    }

    // map the hit test..
    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};

/**
 * Calculates the bounds of the cached sprite
 *
 * @private
 */
DisplayObject.prototype._calculateCachedBounds = function _calculateCachedBounds() {
    this._bounds.clear();
    this._cacheData.sprite.transform._worldID = this.transform._worldID;
    this._cacheData.sprite._calculateBounds();
    this._lastBoundsID = this._boundsID;
};

/**
 * Gets the bounds of the cached sprite.
 *
 * @private
 * @return {Rectangle} The local bounds.
 */
DisplayObject.prototype._getCachedLocalBounds = function _getCachedLocalBounds() {
    return this._cacheData.sprite.getLocalBounds();
};

/**
 * Destroys the cached sprite.
 *
 * @private
 */
DisplayObject.prototype._destroyCachedDisplayObject = function _destroyCachedDisplayObject() {
    this._cacheData.sprite._texture.destroy(true);
    this._cacheData.sprite = null;

    _BaseTexture2.default.removeFromCache(this._cacheData.textureCacheId);
    _Texture2.default.removeFromCache(this._cacheData.textureCacheId);

    this._cacheData.textureCacheId = null;
};

/**
 * Destroys the cached object.
 *
 * @private
 * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
 *  have been set to that value.
 *  Used when destroying containers, see the Container.destroy method.
 */
DisplayObject.prototype._cacheAsBitmapDestroy = function _cacheAsBitmapDestroy(options) {
    this.cacheAsBitmap = false;
    this.destroy(options);
};
//# sourceMappingURL=cacheAsBitmap.js.map

/***/ }),

/***/ "6Jqp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// import Loader from './Loader';
// import Resource from './Resource';
// import * as async from './async';
// import * as b64 from './b64';

/* eslint-disable no-undef */

var Loader = __webpack_require__("KNjQ").Loader;
var Resource = __webpack_require__("F/bs").Resource;
var async = __webpack_require__("bC3n");
var b64 = __webpack_require__("5Wbt");

/**
 *
 * @static
 * @memberof Loader
 * @member {Class<Resource>}
 */
Loader.Resource = Resource;

/**
 *
 * @static
 * @memberof Loader
 * @member {Class<async>}
 */
Loader.async = async;

/**
 *
 * @static
 * @memberof Loader
 * @member {Class<encodeBinary>}
 */
Loader.encodeBinary = b64;

/**
 *
 * @deprecated
 * @see Loader.encodeBinary
 *
 * @static
 * @memberof Loader
 * @member {Class<encodeBinary>}
 */
Loader.base64 = b64;

// export manually, and also as default
module.exports = Loader;

// default & named export
module.exports.Loader = Loader;
module.exports.default = Loader;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "6S93":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2f79219fb19edd31931504e867bf87c7.svg";

/***/ }),

/***/ "6bgb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var WarningMessage = function WarningMessage(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? "Warring" : _ref$title,
      _ref$message = _ref.message,
      message = _ref$message === undefined ? "" : _ref$message;

  var style = {
    padding: '20px',
    textAlign: 'center'
  };
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    { style: style },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "h3",
      null,
      title
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "p",
      null,
      message
    )
  );
};
/* harmony default export */ __webpack_exports__["a"] = (WarningMessage);

/***/ }),

/***/ "6dLN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2975223c3b784378ceeb015fa772637e.svg";

/***/ }),

/***/ "6orE":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("qrAv");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "6pik":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "10b81e7ca379a686a9ccecdf731b03ca.svg";

/***/ }),

/***/ "6xpY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4c5c41732f44f235b1235300ee5a8cc2.svg";

/***/ }),

/***/ "7/2Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),

/***/ "7BI5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLPrepare = __webpack_require__("laVK");

Object.defineProperty(exports, 'webgl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WebGLPrepare).default;
  }
});

var _CanvasPrepare = __webpack_require__("lVSe");

Object.defineProperty(exports, 'canvas', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasPrepare).default;
  }
});

var _BasePrepare = __webpack_require__("NEc+");

Object.defineProperty(exports, 'BasePrepare', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BasePrepare).default;
  }
});

var _CountLimiter = __webpack_require__("4EC6");

Object.defineProperty(exports, 'CountLimiter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CountLimiter).default;
  }
});

var _TimeLimiter = __webpack_require__("p35m");

Object.defineProperty(exports, 'TimeLimiter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TimeLimiter).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "7F5b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

/**
 * Returns the global position of the displayObject. Does not depend on object scale, rotation and pivot.
 *
 * @method getGlobalPosition
 * @memberof PIXI.DisplayObject#
 * @param {Point} point - the point to write the global value to. If null a new point will be returned
 * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
 *  being updated. This means the calculation returned MAY be out of date BUT will give you a
 *  nice performance boost
 * @return {Point} The updated point
 */
core.DisplayObject.prototype.getGlobalPosition = function getGlobalPosition() {
    var point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new core.Point();
    var skipUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (this.parent) {
        this.parent.toGlobal(this.position, point, skipUpdate);
    } else {
        point.x = this.position.x;
        point.y = this.position.y;
    }

    return point;
};
//# sourceMappingURL=getGlobalPosition.js.map

/***/ }),

/***/ "7Hmw":
/***/ (function(module, exports) {

/**
 * @class
 * @memberof PIXI.glCore.shader
 * @param type {String} Type of value
 * @param size {Number}
 */
var defaultValue = function defaultValue(type, size) {
    switch (type) {
        case 'float':
            return 0;

        case 'vec2':
            return new Float32Array(2 * size);

        case 'vec3':
            return new Float32Array(3 * size);

        case 'vec4':
            return new Float32Array(4 * size);

        case 'int':
        case 'sampler2D':
            return 0;

        case 'ivec2':
            return new Int32Array(2 * size);

        case 'ivec3':
            return new Int32Array(3 * size);

        case 'ivec4':
            return new Int32Array(4 * size);

        case 'bool':
            return false;

        case 'bvec2':

            return booleanArray(2 * size);

        case 'bvec3':
            return booleanArray(3 * size);

        case 'bvec4':
            return booleanArray(4 * size);

        case 'mat2':
            return new Float32Array([1, 0, 0, 1]);

        case 'mat3':
            return new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);

        case 'mat4':
            return new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
    }
};

var booleanArray = function booleanArray(size) {
    var array = new Array(size);

    for (var i = 0; i < array.length; i++) {
        array[i] = false;
    }

    return array;
};

module.exports = defaultValue;

/***/ }),

/***/ "84la":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currency", function() { return currency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseQueryString", function() { return parseQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reverseCamelize", function() { return reverseCamelize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkPad", function() { return checkPad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertValueToArray", function() { return convertValueToArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hexToRgba", function() { return hexToRgba; });
var currency = function currency(number, options) {
  var str = "$" + number.toFixed(2);
  if (options.prefix) {
    str = options.prefix + " " + str;
  }
  return str;
};

var parseQueryString = function parseQueryString(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    // If first entry with this name
    if (typeof query_string[pair[0]] === "undefined") {
      query_string[pair[0]] = decodeURIComponent(pair[1]);
      // If second entry with this name
    } else if (typeof query_string[pair[0]] === "string") {
      var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
      query_string[pair[0]] = arr;
      // If third or later entry with this name
    } else {
      query_string[pair[0]].push(decodeURIComponent(pair[1]));
    }
  }
  return query_string;
};

var reverseCamelize = function reverseCamelize(string) {
  var text = string;
  var result = text.replace(/([A-Z])/g, " $1");
  var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
};

var checkPad = function checkPad(number) {
  if (isNaN(number)) {
    return number;
  }
  var numberStr = number.toFixed(2);
  numberStr = numberStr.replace(".00", "");
  return numberStr;
};

// convert value to array based on delimiter
var convertValueToArray = function convertValueToArray(value, delimiter) {
  var values = value && String(value).indexOf(delimiter) !== -1 ? value.split(delimiter) : [value];
  return values;
};
// convert css hex to rgba
var hexToRgba = function hexToRgba(hex, opacity) {
  var isAString = typeof hex === "string" || hex instanceof String;
  if (!isAString) {
    return hex;
  }
  var opacity = opacity || 100;
  var hex = hex.replace("#", "");
  if (hex.length === 6) {
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
  } else {
    var rd = hex.substring(0, 1) + hex.substring(0, 1);
    var gd = hex.substring(1, 2) + hex.substring(1, 2);
    var bd = hex.substring(2, 3) + hex.substring(2, 3);
    var r = parseInt(rd, 16);
    var g = parseInt(gd, 16);
    var b = parseInt(bd, 16);
  }
  return "rgba(" + r + ", " + g + ", " + b + ", " + opacity / 100 + ")";
};

/***/ }),

/***/ "87nI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__("kfMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion__ = __webpack_require__("mibh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_preact_router_match__);





var linkcss = Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])({
  border: "none",
  padding: 9,
  fontSize: 16,
  color: "#5a626c",
  fontWeight: 600,
  borderRadius: 4,
  backgroundColor: "#fafafa",
  marginBottom: 8,
  width: "100%",
  textAlign: "left",
  display: "block",
  "&:hover": {
    boxShadow: "0 1px 4px 0 rgba(9, 30, 66, 0.13)",
    color: "#323232",
    textDecoration: "none"
  }
});

var wrapper = Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])({
  maxHeight: 300,
  overflowY: "scroll",
  "@media(max-width: 600px)": {
    maxWidth: "calc(100vw - 80px)"
  }
});

var DateModal = function DateModal(_ref) {
  var open = _ref.open,
      closeHandler = _ref.closeHandler,
      title = _ref.title,
      dates = _ref.dates,
      eventSlug = _ref.eventSlug;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__Modal__["a" /* default */], {
    showModal: open,
    closeHandler: closeHandler,
    title: title,
    maxWidth: 600,
    contents: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      { className: wrapper },
      dates.map(function (date) {
        if (date.valid) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_3_preact_router_match__["Link"],
            {
              href: "/" + eventSlug + "/tickets?dateId=" + date._id,
              className: linkcss
            },
            date.display.combined
          );
        }
      })
    )
  });
};

/* harmony default export */ __webpack_exports__["a"] = (DateModal);

/***/ }),

/***/ "8ODW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _BaseTexture2 = __webpack_require__("ce6K");

var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A BaseRenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
 *
 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a BaseRenderTexture should be preloaded
 * otherwise black rectangles will be drawn instead.
 *
 * A BaseRenderTexture takes a snapshot of any Display Object given to its render method. The position
 * and rotation of the given Display Objects is ignored. For example:
 *
 * ```js
 * let renderer = PIXI.autoDetectRenderer(1024, 1024);
 * let baseRenderTexture = new PIXI.BaseRenderTexture(800, 600);
 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
 * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
 *
 * sprite.position.x = 800/2;
 * sprite.position.y = 600/2;
 * sprite.anchor.x = 0.5;
 * sprite.anchor.y = 0.5;
 *
 * renderer.render(sprite, renderTexture);
 * ```
 *
 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
 * you can clear the transform
 *
 * ```js
 *
 * sprite.setTransform()
 *
 * let baseRenderTexture = new PIXI.BaseRenderTexture(100, 100);
 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
 *
 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
 * ```
 *
 * @class
 * @extends PIXI.BaseTexture
 * @memberof PIXI
 */
var BaseRenderTexture = function (_BaseTexture) {
  _inherits(BaseRenderTexture, _BaseTexture);

  /**
   * @param {number} [width=100] - The width of the base render texture
   * @param {number} [height=100] - The height of the base render texture
   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
   * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
   */
  function BaseRenderTexture() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    var scaleMode = arguments[2];
    var resolution = arguments[3];

    _classCallCheck(this, BaseRenderTexture);

    var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, null, scaleMode));

    _this.resolution = resolution || _settings2.default.RESOLUTION;

    _this.width = Math.ceil(width);
    _this.height = Math.ceil(height);

    _this.realWidth = _this.width * _this.resolution;
    _this.realHeight = _this.height * _this.resolution;

    _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
    _this.hasLoaded = true;

    /**
     * A map of renderer IDs to webgl renderTargets
     *
     * @private
     * @member {object<number, WebGLTexture>}
     */
    _this._glRenderTargets = {};

    /**
     * A reference to the canvas render target (we only need one as this can be shared across renderers)
     *
     * @private
     * @member {object<number, WebGLTexture>}
     */
    _this._canvasRenderTarget = null;

    /**
     * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
     *
     * @member {boolean}
     */
    _this.valid = false;
    return _this;
  }

  /**
   * Resizes the BaseRenderTexture.
   *
   * @param {number} width - The width to resize to.
   * @param {number} height - The height to resize to.
   */

  BaseRenderTexture.prototype.resize = function resize(width, height) {
    width = Math.ceil(width);
    height = Math.ceil(height);

    if (width === this.width && height === this.height) {
      return;
    }

    this.valid = width > 0 && height > 0;

    this.width = width;
    this.height = height;

    this.realWidth = this.width * this.resolution;
    this.realHeight = this.height * this.resolution;

    if (!this.valid) {
      return;
    }

    this.emit('update', this);
  };

  /**
   * Destroys this texture
   *
   */

  BaseRenderTexture.prototype.destroy = function destroy() {
    _BaseTexture.prototype.destroy.call(this, true);
    this.renderer = null;
  };

  return BaseRenderTexture;
}(_BaseTexture3.default);

exports.default = BaseRenderTexture;
//# sourceMappingURL=BaseRenderTexture.js.map

/***/ }),

/***/ "8SKy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Rectangle = __webpack_require__("MxpT");

var _Rectangle2 = _interopRequireDefault(_Rectangle);

var _const = __webpack_require__("YEQi");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * The Circle object can be used to specify a hit area for displayObjects
 *
 * @class
 * @memberof PIXI
 */
var Circle = function () {
  /**
   * @param {number} [x=0] - The X coordinate of the center of this circle
   * @param {number} [y=0] - The Y coordinate of the center of this circle
   * @param {number} [radius=0] - The radius of the circle
   */
  function Circle() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, Circle);

    /**
     * @member {number}
     * @default 0
     */
    this.x = x;

    /**
     * @member {number}
     * @default 0
     */
    this.y = y;

    /**
     * @member {number}
     * @default 0
     */
    this.radius = radius;

    /**
     * The type of the object, mainly used to avoid `instanceof` checks
     *
     * @member {number}
     * @readOnly
     * @default PIXI.SHAPES.CIRC
     * @see PIXI.SHAPES
     */
    this.type = _const.SHAPES.CIRC;
  }

  /**
   * Creates a clone of this Circle instance
   *
   * @return {PIXI.Circle} a copy of the Circle
   */

  Circle.prototype.clone = function clone() {
    return new Circle(this.x, this.y, this.radius);
  };

  /**
   * Checks whether the x and y coordinates given are contained within this circle
   *
   * @param {number} x - The X coordinate of the point to test
   * @param {number} y - The Y coordinate of the point to test
   * @return {boolean} Whether the x/y coordinates are within this Circle
   */

  Circle.prototype.contains = function contains(x, y) {
    if (this.radius <= 0) {
      return false;
    }

    var r2 = this.radius * this.radius;
    var dx = this.x - x;
    var dy = this.y - y;

    dx *= dx;
    dy *= dy;

    return dx + dy <= r2;
  };

  /**
  * Returns the framing rectangle of the circle as a Rectangle object
  *
  * @return {PIXI.Rectangle} the framing rectangle
  */

  Circle.prototype.getBounds = function getBounds() {
    return new _Rectangle2.default(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
  };

  return Circle;
}();

exports.default = Circle;
//# sourceMappingURL=Circle.js.map

/***/ }),

/***/ "8Y7Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var InteractionManager_1 = __webpack_require__("dUAP");
var SelectionListener_1 = __webpack_require__("//Eg");
var Config_1 = __webpack_require__("gH/r");
var Utils_1 = __webpack_require__("o6Mn");
var ActionTracker_1 = __webpack_require__("h0Oq");
var bound_1 = __webpack_require__("USDo");
var _Config_1$default$sty = Config_1.default.style,
    primaryColor = _Config_1$default$sty.primaryColor,
    backgroundConstructionColor = _Config_1$default$sty.backgroundConstructionColor;

var graphics = new PIXI.Graphics();
var container = new PIXI.Container();
var leftOptionsContainer = new PIXI.Container();
var rightOptionsContainer = new PIXI.Container();
container.parentGroup = Config_1.default.graphicsGroup;
leftOptionsContainer.parentGroup = Config_1.default.graphicsGroup;
rightOptionsContainer.parentGroup = Config_1.default.graphicsGroup;
graphics.parentGroup = Config_1.default.graphicsGroup;
var intManager = void 0;
var currentPointBoxes = [];
var res = void 0;
function init() {
    var reservation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    graphics = new PIXI.Graphics();
    container = new PIXI.Container();
    leftOptionsContainer = new PIXI.Container();
    rightOptionsContainer = new PIXI.Container();
    container.parentGroup = Config_1.default.graphicsGroup;
    leftOptionsContainer.parentGroup = Config_1.default.graphicsGroup;
    rightOptionsContainer.parentGroup = Config_1.default.graphicsGroup;
    graphics.parentGroup = Config_1.default.graphicsGroup;
    currentPointBoxes = [];
    container.addChild(graphics);
    res = reservation;
}
exports.init = init;
function initialiseInteractionManager() {
    intManager = InteractionManager_1.default.createInteractionManager();
    if (!res) {
        initialiseOptions();
    }
}
exports.initialiseInteractionManager = initialiseInteractionManager;
function initialiseOptions() {
    var leftOptionsBounds = {
        x: -34,
        y: -2,
        width: 58,
        height: 25
    };
    var rightOptionsBounds = {
        x: -2,
        y: -2,
        width: 25,
        height: 25
    };
    var background = new PIXI.Graphics();
    background.beginFill(backgroundConstructionColor, 1.0);
    background.drawRect(leftOptionsBounds.x, leftOptionsBounds.y, leftOptionsBounds.width, leftOptionsBounds.height);
    background.endFill();
    var leftOutline = new PIXI.Graphics();
    leftOutline.lineStyle(2, primaryColor, 1.0);
    leftOutline.drawRoundedRect(leftOptionsBounds.x - 1, leftOptionsBounds.y - 1, leftOptionsBounds.width + 1, leftOptionsBounds.height + 1, 1);
    var rightBackground = new PIXI.Graphics();
    rightBackground.beginFill(backgroundConstructionColor, 1.0);
    rightBackground.drawRect(rightOptionsBounds.x, rightOptionsBounds.y, rightOptionsBounds.width, rightOptionsBounds.height);
    rightBackground.endFill();
    var rightOutline = new PIXI.Graphics();
    rightOutline.lineStyle(2, primaryColor, 1.0);
    rightOutline.drawRoundedRect(rightOptionsBounds.x - 1, rightOptionsBounds.y - 1, rightOptionsBounds.width + 1, rightOptionsBounds.height + 1, 1);
    var deleteImage = PIXI.loader.resources[Utils_1.deleteElementName].texture;
    deleteImage.baseTexture.mipmap = true;
    var deleteSprite = new PIXI.Sprite(deleteImage);
    deleteSprite.width = 20;
    deleteSprite.height = 20;
    deleteSprite.interactive = true;
    deleteSprite.buttonMode = true;
    deleteSprite.on("click", function () {
        clear();
        intManager.deleteSelected();
    });
    var dupeImage = PIXI.loader.resources[Utils_1.duplicateElementName].texture;
    dupeImage.baseTexture.mipmap = true;
    var dupeSprite = new PIXI.Sprite(dupeImage);
    dupeSprite.width = 20;
    dupeSprite.height = 20;
    dupeSprite.position = new PIXI.Point(-30, 0);
    dupeSprite.interactive = true;
    dupeSprite.buttonMode = true;
    dupeSprite.on("click", intManager.dupeSelected);
    var rotImage = PIXI.loader.resources[Utils_1.rotateElementName].texture;
    rotImage.baseTexture.mipmap = true;
    var rotSprite = new PIXI.Sprite(rotImage);
    rotSprite.width = 20;
    rotSprite.height = 20;
    rotSprite.interactive = true;
    rotSprite.buttonMode = true;
    rotInteraction(rotSprite);
    rightOptionsContainer.addChild(rightBackground);
    rightOptionsContainer.addChild(rotSprite);
    rightOptionsContainer.addChild(rightOutline);
    rightOptionsContainer.visible = false;
    leftOptionsContainer.addChild(background);
    leftOptionsContainer.addChild(dupeSprite);
    leftOptionsContainer.addChild(deleteSprite);
    leftOptionsContainer.addChild(leftOutline);
    leftOptionsContainer.visible = false;
    container.addChild(leftOptionsContainer);
    container.addChild(rightOptionsContainer);
}
function rotInteraction(rotSprite) {
    rotSprite.on("mousedown", function (e) {
        intManager.rotStart();
    });
}
function getGraphics() {
    return container;
}
exports.getGraphics = getGraphics;
function drawPolySelectionBox(points) {
    clear();
    polySelectionBox(points);
    leftOptionsContainer.visible = false;
    rightOptionsContainer.visible = false;
}
exports.drawPolySelectionBox = drawPolySelectionBox;
function drawEditablePolyBox(points, onVertexMoved, onVertexAdded, onVertexRemoved) {
    clear();
    testPolySelectionBox(points, onVertexAdded);
    pointBoxes(points, onVertexMoved, onVertexRemoved);
    leftOptionsContainer.visible = false;
    rightOptionsContainer.visible = false;
}
exports.drawEditablePolyBox = drawEditablePolyBox;
function drawScalableBox(x, y, width, height, xScaleCb, yScaleCb, xyScaleCb) {
    clear();
    var points = getPoints(x, y, width, height, xScaleCb, yScaleCb, xyScaleCb);
    selectionBox(x, y, width, height);
    options(x, y, width);
    points.forEach(function (pointBox) {
        return container.addChild(pointBox.getGraphics());
    });
}
exports.drawScalableBox = drawScalableBox;
function drawSelectionBox(x, y, width, height) {
    var showOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var showRotation = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    clear();
    if (showOptions) {
        options(x, y, width);
    }
}
exports.drawSelectionBox = drawSelectionBox;
function drawSelectionBoxTest(left, right, width, height, pivot, rotation) {
    var showOptions = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    var showRotation = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    clear();
    optionsWithRot(left, right, width, height, pivot, rotation);
}
exports.drawSelectionBoxTest = drawSelectionBoxTest;
function getPoints(x, y, width, height, xScaleCb, yScaleCb, xyScaleCb) {
    var xMid = x + width / 2;
    var yMid = y + height / 2;
    var bottom = y + height;
    var right = x + width;
    return [new PointBox(0, x, y, xyScaleCb), new PointBox(1, xMid, y, yScaleCb), new PointBox(2, right, y, xyScaleCb), new PointBox(3, right, yMid, xScaleCb), new PointBox(4, right, bottom, xyScaleCb), new PointBox(5, xMid, bottom, yScaleCb), new PointBox(6, x, bottom, xyScaleCb), new PointBox(7, x, yMid, xScaleCb)];
}
function options(x, y, width) {
    leftOptionsContainer.visible = true;
    leftOptionsContainer.position = new PIXI.Point(x - 27, y - 27);
}
function optionsWithRot(left, right, width, height, pivot, rotation) {
    leftOptionsContainer.visible = true;
    leftOptionsContainer.position = new PIXI.Point(left.x, left.y);
    rightOptionsContainer.visible = true;
    leftOptionsContainer.rotation = rotation;
    rightOptionsContainer.position = new PIXI.Point(right.x, right.y);
    rightOptionsContainer.rotation = rotation;
}
function polySelectionBox(points) {
    graphics.lineStyle(3, primaryColor, 1.0);
    graphics.drawPolygon(points);
}
function testPolySelectionBox(points, onVertexAdded) {
    var polyLines = points.map(function (point, i) {
        var point2 = void 0;
        var id2 = void 0;
        if (i === points.length - 1) {
            point2 = points[0];
            id2 = 0;
        } else {
            point2 = points[i + 1];
            id2 = i + 1;
        }
        return new PolyLine(point, point2, i, id2, onVertexAdded);
    });
    polyLines.forEach(function (polyLine) {
        return container.addChild(polyLine.getGraphics());
    });
}
function pointBoxes(points, onVertexMoved, onVertexRemoved) {
    currentPointBoxes = points.map(function (point, i) {
        return new PointBox(i, point.x, point.y, onVertexMoved, onVertexRemoved);
    });
    currentPointBoxes.forEach(function (pointBox) {
        return container.addChild(pointBox.getGraphics());
    });
}
function selectionBox(x, y, width, height) {
    graphics.lineStyle(2, primaryColor, 1.0);
    graphics.drawRoundedRect(x, y, width, height, 1);
}
function selectionCircle(x, y, radius) {
    graphics.lineStyle(2, primaryColor, 1.0);
    graphics.drawCircle(x, y, radius);
}
function selectMultipleTables(tables) {
    clear();
    var leftMost = void 0,
        topMost = void 0,
        wide = void 0;
    tables.forEach(function (table) {
        var _table$getSelectionBo = table.getSelectionBoxBounds(),
            x = _table$getSelectionBo.x,
            y = _table$getSelectionBo.y,
            width = _table$getSelectionBo.width,
            height = _table$getSelectionBo.height;

        if (!leftMost || leftMost > x) {
            leftMost = x;
            wide = width;
        }
        if (!topMost || topMost > y) {
            topMost = y;
        }
    });
    options(leftMost, topMost, wide);
}
exports.selectMultipleTables = selectMultipleTables;
function selectMultipleSeats(seats) {
    clear();
    seats.forEach(function (seat) {
        var _seat$getSelectionBou = seat.getSelectionBounds(),
            x = _seat$getSelectionBou.x,
            y = _seat$getSelectionBou.y,
            radius = _seat$getSelectionBou.radius;

        selectionCircle(x, y, radius);
    });
}
exports.selectMultipleSeats = selectMultipleSeats;
function clear() {
    leftOptionsContainer.visible = false;
    rightOptionsContainer.visible = false;
    if (container.children.length > 3) {
        container.removeChildren(3);
    }
    graphics.clear();
}
exports.clear = clear;
function drawDragSelection(startPos, endPos) {
    var polygonVerticies = [{ x: startPos.x, y: startPos.y }, { x: endPos.x, y: startPos.y }, { x: endPos.x, y: endPos.y }, { x: startPos.x, y: endPos.y }];
    graphics.clear();
    leftOptionsContainer.visible = false;
    graphics.lineStyle(3, primaryColor, 0.7);
    graphics.drawDashedPolygon(polygonVerticies, 0, 0, 0, 10, 5, 260 / 750);
}
exports.drawDragSelection = drawDragSelection;

var PolyLine = function () {
    function PolyLine(p1, p2, id1, id2, onVertexAdded) {
        _classCallCheck(this, PolyLine);

        this.p1 = p1;
        this.p2 = p2;
        this.id1 = id1;
        this.id2 = id2;
        this.onVertexAdded = onVertexAdded;
        this.clickedBefore = false;
        this.graphics = new PIXI.Graphics();
        this.drawLine();
        this.selectionListener = new SelectionListener_1.default(this.graphics, this, function () {});
        this.listenForDoubleClick();
    }

    PolyLine.prototype.drawSelectionBox = function drawSelectionBox() {};

    PolyLine.prototype.onElementClicked = function onElementClicked() {};

    PolyLine.prototype.onSelect = function onSelect() {};

    PolyLine.prototype.onDeselect = function onDeselect() {};

    PolyLine.prototype.drawLine = function drawLine() {
        this.graphics.lineStyle(0.0, primaryColor, 1.0);
        var xDiff = this.p1.x - this.p2.x;
        var yDiff = this.p1.y - this.p2.y;
        var pw = Math.abs(xDiff);
        var ph = Math.abs(yDiff);
        var width = 2.0;
        var theta = Math.atan(ph / pw);
        var ninety = Math.PI / 2;
        var perc = theta / ninety;
        var xInc = width * perc;
        var yInc = width - xInc;
        if (xDiff >= 0 && yDiff >= 0 || xDiff < 0 && yDiff < 0) {
            this.points = [new PIXI.Point(this.p1.x - xInc, this.p1.y + yInc), new PIXI.Point(this.p1.x + xInc, this.p1.y - yInc), new PIXI.Point(this.p2.x + xInc, this.p2.y - yInc), new PIXI.Point(this.p2.x - xInc, this.p2.y + yInc)];
        } else {
            this.points = [new PIXI.Point(this.p1.x + xInc, this.p1.y + yInc), new PIXI.Point(this.p1.x - xInc, this.p1.y - yInc), new PIXI.Point(this.p2.x - xInc, this.p2.y - yInc), new PIXI.Point(this.p2.x + xInc, this.p2.y + yInc)];
        }
        var polygon = new PIXI.Polygon(this.points);
        this.graphics.beginFill(primaryColor);
        this.graphics.drawPolygon(polygon);
        this.graphics.hitArea = polygon;
    };

    PolyLine.prototype.getGraphics = function getGraphics() {
        return this.graphics;
    };

    PolyLine.prototype.countDown = function countDown() {
        var _this = this;

        setInterval(function () {
            _this.clickedBefore = false;
        }, 500);
    };

    PolyLine.prototype.listenForDoubleClick = function listenForDoubleClick() {
        var _this2 = this;

        this.graphics.interactive = true;
        this.graphics.on("click", function (e) {
            if (_this2.clickedBefore) {
                _this2.onVertexAdded(_this2.id1, _this2.id2, e);
            } else {
                _this2.clickedBefore = true;
                _this2.countDown();
            }
        });
    };

    return PolyLine;
}();

var PointBox = function () {
    function PointBox(id, x, y, onVertexMoved, onVertexRemoved) {
        _classCallCheck(this, PointBox);

        this.basicType = "pointBox";
        this.id = id;
        this.x = x;
        this.y = y;
        this.clickedBefore = false;
        this.onVertexMoved = onVertexMoved;
        this.onVertexRemoved = onVertexRemoved;
        if (!this.onVertexRemoved) {
            this.onVertexRemoved = function () {};
        }
        this.graphics = new PIXI.Graphics();
        this.selectionListener = new SelectionListener_1.default(this.graphics, this, function () {});
        this.drawPoint();
        this.interactionManager = InteractionManager_1.default.createInteractionManager();
        this.createDragAndDropFor(this.graphics);
        this.listenForDoubleClick();
    }

    PointBox.prototype.listenForDoubleClick = function listenForDoubleClick() {
        var _this3 = this;

        this.graphics.interactive = true;
        this.graphics.on("click", function () {
            if (_this3.clickedBefore) {
                _this3.onVertexRemoved(_this3.id);
            } else {
                _this3.clickedBefore = true;
                _this3.countDown();
            }
        });
    };

    PointBox.prototype.countDown = function countDown() {
        var _this4 = this;

        setInterval(function () {
            _this4.clickedBefore = false;
        }, 500);
    };

    PointBox.prototype.drawPoint = function drawPoint() {
        this.graphics.beginFill(primaryColor);
        this.graphics.drawRoundedRect(this.x - 5, this.y - 5, 10, 10, 1);
    };

    PointBox.prototype.getGraphics = function getGraphics() {
        return this.graphics;
    };

    PointBox.prototype.drawSelectionBox = function drawSelectionBox() {};

    PointBox.prototype.onElementClicked = function onElementClicked() {};

    PointBox.prototype.onSelect = function onSelect() {};

    PointBox.prototype.onDeselect = function onDeselect() {};

    PointBox.prototype.move = function move(e) {
        this.hasMoved = true;
        this.trackMovement(e);
        var undoValue = ActionTracker_1.default.constructUndoValue("movePointBox", this.move, [this.getInverseMovementFromEvent(e)]);
        this.onVertexMoved(this.id, e);
        return undoValue;
    };

    PointBox.prototype.createDragAndDropFor = function createDragAndDropFor(target) {
        var _this5 = this;

        target.interactive = true;
        target.on("mousedown", function (e) {
            _this5.xMovement = 0;
            _this5.yMovement = 0;
            _this5.hasMoved = false;
            _this5.interactionManager.itemSelected(_this5);
            var interactionMember = Config_1.default.app.renderer.plugins.interaction;
            interactionMember.once('mouseup', function () {
                if (_this5.hasMoved) {
                    _this5.undoId = ActionTracker_1.default.generateActionId();
                    ActionTracker_1.default.addUndoAction("movePointBox", _this5.undoId, [_this5.move], [[_this5.getInverseMovementValues()]]);
                }
                _this5.xMovement = 0;
                _this5.yMovement = 0;
            });
        });
    };

    PointBox.prototype.getInverseMovementFromEvent = function getInverseMovementFromEvent(e) {
        var _e$data$originalEvent = e.data.originalEvent,
            movementX = _e$data$originalEvent.movementX,
            movementY = _e$data$originalEvent.movementY;

        return {
            data: { originalEvent: { movementY: -movementY, movementX: -movementX } }
        };
    };

    PointBox.prototype.getInverseMovementValues = function getInverseMovementValues() {
        return {
            data: { originalEvent: { movementY: -this.yMovement, movementX: -this.xMovement } }
        };
    };

    PointBox.prototype.trackMovement = function trackMovement(e) {
        var _e$data$originalEvent2 = e.data.originalEvent,
            movementX = _e$data$originalEvent2.movementX,
            movementY = _e$data$originalEvent2.movementY;

        this.xMovement += movementX;
        this.yMovement += movementY;
    };

    return PointBox;
}();

__decorate([bound_1.default], PointBox.prototype, "move", null);
__decorate([bound_1.default], PointBox.prototype, "createDragAndDropFor", null);
__decorate([bound_1.default], PointBox.prototype, "getInverseMovementFromEvent", null);
__decorate([bound_1.default], PointBox.prototype, "getInverseMovementValues", null);
__decorate([bound_1.default], PointBox.prototype, "trackMovement", null);
//# sourceMappingURL=Selector.js.map

/***/ }),

/***/ "8fQc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ParticleContainer = __webpack_require__("Q1sA");

Object.defineProperty(exports, 'ParticleContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ParticleContainer).default;
  }
});

var _ParticleRenderer = __webpack_require__("gx9Q");

Object.defineProperty(exports, 'ParticleRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ParticleRenderer).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "8pGs":
/***/ (function(module, exports, __webpack_require__) {

/*
  Used as main file in package.json
*/

/* eslint-disable no-var */
/* eslint-env node */

var DayPicker = __webpack_require__("ReEC");
var DateUtils = __webpack_require__("s8Q5");
var LocaleUtils = __webpack_require__("Awug");
var ModifiersUtils = __webpack_require__("ogP8");
var Weekday = __webpack_require__("FQbN");
var Navbar = __webpack_require__("Yp9R");
var PropTypes = __webpack_require__("nxZI");

module.exports = DayPicker;
module.exports.DateUtils = DateUtils;
module.exports.LocaleUtils = LocaleUtils;
module.exports.ModifiersUtils = ModifiersUtils;
module.exports.WeekdayPropTypes = Weekday.propTypes;
module.exports.NavbarPropTypes = Navbar.propTypes;
module.exports.PropTypes = PropTypes;

/***/ }),

/***/ "8vce":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Table_1 = __webpack_require__("OCym");
var Rows_1 = __webpack_require__("mmMt");
var StaticContainer_1 = __webpack_require__("dUhe");
var bound_1 = __webpack_require__("USDo");

var Section = function (_StaticContainer_1$de) {
    _inherits(Section, _StaticContainer_1$de);

    function Section(_ref) {
        var _id = _ref._id,
            pos = _ref.pos,
            name = _ref.name,
            sectionId = _ref.sectionId,
            tables = _ref.tables,
            ticketIds = _ref.ticketIds;

        _classCallCheck(this, Section);

        var _this = _possibleConstructorReturn(this, _StaticContainer_1$de.call(this, _id, {}));

        _this.focused = false;
        _this.name = name;
        _this.sectionId = sectionId;
        _this.basicType = "section";
        _this.ticketIds = ticketIds;
        _this.sectionContainer = new PIXI.Container();
        _this.sectionContainer.position = pos;
        _this.tables = tables.map(function (table, i) {
            table.tableId = i;
            table.sectionId = _this._id;
            table.sectionName = _this.name;
            var newTable = _this.determineTable(table);
            newTable.draw();
            return newTable;
        });
        _this.tables.forEach(function (table) {
            return _this.sectionContainer.addChild(table.getTableContainer());
        });
        _this.tables.forEach(function (table) {
            return table.setContainerOffset(_this.sectionContainer.position.x, _this.sectionContainer.position.y);
        });
        _this.bounds = _this.sectionContainer.getBounds();
        return _this;
    }

    Section.prototype.determineTable = function determineTable(table) {
        switch (table.type) {
            case "circle":
                return new Table_1.default(table, {}, false);
            case "row":
                return new Rows_1.default(table, {}, false);
        }
    };

    Section.prototype.showTextSeat = function showTextSeat(show) {
        this.tables.forEach(function (table) {
            return table.showTextSeat(show);
        });
    };

    Section.prototype.getSectionContainer = function getSectionContainer() {
        return this.sectionContainer;
    };

    Section.prototype.getBounds = function getBounds() {
        return this.bounds;
    };

    return Section;
}(StaticContainer_1.default);

__decorate([bound_1.default], Section.prototype, "determineTable", null);
__decorate([bound_1.default], Section.prototype, "showTextSeat", null);
__decorate([bound_1.default], Section.prototype, "getSectionContainer", null);
__decorate([bound_1.default], Section.prototype, "getBounds", null);
exports.default = Section;
//# sourceMappingURL=Section.js.map

/***/ }),

/***/ "9TS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_freeGlobal.js
var _freeGlobal = __webpack_require__("i/J7");

// CONCATENATED MODULE: ../node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ var _root = (root);
// CONCATENATED MODULE: ../node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root.Symbol;

/* harmony default export */ var _Symbol = (Symbol);
// CONCATENATED MODULE: ../node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);
// CONCATENATED MODULE: ../node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);
// CONCATENATED MODULE: ../node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return _baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value) ? _getRawTag(value) : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);
// CONCATENATED MODULE: ../node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);
// CONCATENATED MODULE: ../node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);
// CONCATENATED MODULE: ../node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);
// CONCATENATED MODULE: ../node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = __webpack_exports__["a"] = (isPlainObject);

/***/ }),

/***/ "9V2T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__("RKsu");

var _utils = __webpack_require__("H4Cu");

var _withTouchListeners = __webpack_require__("KPDt");

var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);

var _StyleSheet = __webpack_require__("dG+0");

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ScrollLock = function (_PureComponent) {
  _inherits(ScrollLock, _PureComponent);

  function ScrollLock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.getStyles = function () {
      var accountForScrollbars = _this.props.accountForScrollbars;

      var height = (0, _utils.getDocumentHeight)();
      var paddingRight = accountForScrollbars ? (0, _utils.getPadding)() : null;
      var styles = 'body {\n      box-sizing: border-box !important;\n      overflow: hidden !important;\n      position: relative !important;\n      ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n      ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n    }';

      return styles;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_exenv.canUseDOM) return;
      this.initialHeight = window.innerHeight;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var offset = window.innerHeight - this.initialHeight;

      // adjust scroll if the window has been resized since the lock was engaged
      // e.g. mobile safari dynamic chrome heights
      if (offset) {
        window.scrollTo(0, window.pageYOffset + offset);
      }

      // reset the initial height in case this scroll lock is used again
      this.initialHeight = window.innerHeight;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_StyleSheet2.default, { styles: this.getStyles() });
    }
  }]);

  return ScrollLock;
}(_react.PureComponent);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};
exports.default = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),

/***/ "A1Ay":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Table_1 = __webpack_require__("Fu79");
var Rows_1 = __webpack_require__("MZrl");
var StaticContainer_1 = __webpack_require__("dUhe");
var bound_1 = __webpack_require__("USDo");
var hull = __webpack_require__("rWY2");
var events = {
    onSeatClicked: function onSeatClicked() {
        return console.log("onSeatClicked not implemented");
    },
    onTableClicked: function onTableClicked() {
        return console.log("onTableClicked not implemented");
    }
};

var Section = function (_StaticContainer_1$de) {
    _inherits(Section, _StaticContainer_1$de);

    function Section(_ref, disableInteraction) {
        var _id = _ref._id,
            pos = _ref.pos,
            name = _ref.name,
            sectionId = _ref.sectionId,
            tables = _ref.tables,
            ticketIds = _ref.ticketIds;

        _classCallCheck(this, Section);

        var _this = _possibleConstructorReturn(this, _StaticContainer_1$de.call(this, _id, {}));

        _this.focused = false;
        _this.name = name;
        _this.sectionId = sectionId;
        _this.basicType = "section";
        _this.ticketIds = ticketIds;
        _this.sectionContainer = new PIXI.Container();
        _this.sectionContainer.position = pos;
        _this.tables = tables.map(function (table, i) {
            table.tableId = i;
            table.sectionId = _this._id;
            table.sectionName = _this.name;
            var newTable = _this.determineTable(table, _this.actions, disableInteraction);
            newTable.draw();
            return newTable;
        });
        _this.tables.forEach(function (table) {
            return _this.sectionContainer.addChild(table.getTableContainer());
        });
        _this.tables.forEach(function (table) {
            return table.setContainerOffset(_this.sectionContainer.position.x, _this.sectionContainer.position.y);
        });
        _this.bounds = _this.sectionContainer.getBounds();
        return _this;
    }

    Section.prototype.determineTable = function determineTable(table, actions, disableInteraction) {
        switch (table.type) {
            case "circle":
                return new Table_1.default(table, actions, disableInteraction);
            case "row":
                return new Rows_1.default(table, actions, disableInteraction);
        }
    };

    Section.prototype.addTicketDataTo = function addTicketDataTo(seatingData, ticketData) {
        var table = this.tables.find(function (table) {
            return table.id === seatingData.tableId;
        });
        if (table) {
            table.addTicketDataTo(seatingData, ticketData);
        }
    };

    Section.prototype.showTextSeat = function showTextSeat(show) {
        this.tables.forEach(function (table) {
            return table.showTextSeat(show);
        });
    };

    Section.prototype.removeTicketDataFrom = function removeTicketDataFrom(seatingData) {
        var table = this.tables.find(function (table) {
            return table.id === seatingData.tableId;
        });
        if (table) {
            table.removeTicketDataFrom(seatingData);
        }
    };

    Section.prototype.unClickSeat = function unClickSeat(seatingData) {
        var table = this.tables.find(function (table) {
            return table.id === seatingData.tableId;
        });
        if (table) {
            table.unClickSeat(seatingData);
        }
    };

    Section.prototype.seatSelected = function seatSelected(seatCurrentlySelected) {
        this.tables.forEach(function (table) {
            table.seatSelected(seatCurrentlySelected);
        });
    };

    Section.prototype.enableClick = function enableClick(enable) {
        this.tables.forEach(function (table) {
            table.enableClick(enable);
        });
    };

    Section.prototype.getNames = function getNames(seatData) {
        var table = this.tables.find(function (table) {
            return table.id === seatData.tableId;
        });
        if (table) {
            return table.getNames(seatData);
        }
    };

    Section.prototype.highlight = function highlight(_highlight, seatData) {
        var table = this.tables.find(function (table) {
            return table.id === seatData.tableId;
        });
        if (table) {
            table.highlight(_highlight, seatData);
        }
    };

    Section.prototype.changeSeat = function changeSeat(seatData) {
        var table = this.tables.find(function (table) {
            return table.id === seatData.tableId;
        });
        if (table) {
            return table.changeSeat(seatData);
        }
    };

    Section.prototype.deselectSeat = function deselectSeat() {
        this.tables.forEach(function (table) {
            table.deselectSeat();
        });
    };

    Section.prototype.unAssignSeat = function unAssignSeat(seatingData) {
        var table = this.tables.find(function (table) {
            return table.id === seatingData.tableId;
        });
        if (table) {
            table.unAssignSeat(seatingData);
        }
    };

    Section.prototype.getTable = function getTable(tableId) {
        return this.tables[tableId];
    };

    Section.prototype.getSectionContainer = function getSectionContainer() {
        return this.sectionContainer;
    };

    Section.prototype.getBounds = function getBounds() {
        return this.bounds;
    };

    Section.prototype.getDimensions = function getDimensions() {
        var dim = this.tables[0].getDimensions();
        var top = dim.top;
        var bottom = dim.bottom;
        var left = dim.left;
        var right = dim.right;
        this.tables.forEach(function (table) {
            var dimension = table.getDimensions();
            if (dimension.left < left) {
                left = dimension.left;
            }
            if (dimension.right > right) {
                right = dimension.right;
            }
            if (dimension.top < top) {
                top = dimension.top;
            }
            if (dimension.bottom > bottom) {
                bottom = dimension.bottom;
            }
        });
        return {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
    };

    Section.prototype.applicableTicketType = function applicableTicketType(ticketTypeId) {
        var applicable = this.ticketIds.includes(ticketTypeId);
        return {
            _id: this._id,
            applicable: applicable
        };
    };

    Section.prototype.setActions = function setActions(actions) {
        this.actions = actions;
        this.tables.forEach(function (table) {
            return table.setActions(actions);
        });
    };

    return Section;
}(StaticContainer_1.default);

__decorate([bound_1.default], Section.prototype, "determineTable", null);
__decorate([bound_1.default], Section.prototype, "addTicketDataTo", null);
__decorate([bound_1.default], Section.prototype, "showTextSeat", null);
__decorate([bound_1.default], Section.prototype, "removeTicketDataFrom", null);
__decorate([bound_1.default], Section.prototype, "unClickSeat", null);
__decorate([bound_1.default], Section.prototype, "seatSelected", null);
__decorate([bound_1.default], Section.prototype, "enableClick", null);
__decorate([bound_1.default], Section.prototype, "getNames", null);
__decorate([bound_1.default], Section.prototype, "highlight", null);
__decorate([bound_1.default], Section.prototype, "changeSeat", null);
__decorate([bound_1.default], Section.prototype, "deselectSeat", null);
__decorate([bound_1.default], Section.prototype, "unAssignSeat", null);
__decorate([bound_1.default], Section.prototype, "getTable", null);
__decorate([bound_1.default], Section.prototype, "getSectionContainer", null);
__decorate([bound_1.default], Section.prototype, "getBounds", null);
__decorate([bound_1.default], Section.prototype, "getDimensions", null);
__decorate([bound_1.default], Section.prototype, "applicableTicketType", null);
__decorate([bound_1.default], Section.prototype, "setActions", null);
exports.default = Section;
//# sourceMappingURL=Section.js.map

/***/ }),

/***/ "A2is":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};

/***/ }),

/***/ "A5+a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = __webpack_require__("sh3Y");

module.exports = function (_Plugin) {
    _inherits(Decelerate, _Plugin);

    /**
     * @private
     * @param {Viewport} parent
     * @param {object} [options]
     * @param {number} [options.friction=0.95] percent to decelerate after movement
     * @param {number} [options.bounce=0.8] percent to decelerate when past boundaries (only applicable when viewport.bounce() is active)
     * @param {number} [options.minSpeed=0.01] minimum velocity before stopping/reversing acceleration
     */
    function Decelerate(parent, options) {
        _classCallCheck(this, Decelerate);

        var _this = _possibleConstructorReturn(this, (Decelerate.__proto__ || Object.getPrototypeOf(Decelerate)).call(this, parent));

        options = options || {};
        _this.friction = options.friction || 0.95;
        _this.bounce = options.bounce || 0.5;
        _this.minSpeed = typeof options.minSpeed !== 'undefined' ? options.minSpeed : 0.01;
        _this.saved = [];
        _this.reset();
        _this.parent.on('moved', function (data) {
            return _this.moved(data);
        });
        return _this;
    }

    _createClass(Decelerate, [{
        key: 'down',
        value: function down() {
            this.saved = [];
            this.x = this.y = false;
        }
    }, {
        key: 'isActive',
        value: function isActive() {
            return this.x || this.y;
        }
    }, {
        key: 'move',
        value: function move() {
            if (this.paused) {
                return;
            }

            var count = this.parent.countDownPointers();
            if (count === 1 || count > 1 && !this.parent.plugins['pinch']) {
                this.saved.push({ x: this.parent.x, y: this.parent.y, time: performance.now() });
                if (this.saved.length > 60) {
                    this.saved.splice(0, 30);
                }
            }
        }
    }, {
        key: 'moved',
        value: function moved(data) {
            if (this.saved.length) {
                var last = this.saved[this.saved.length - 1];
                if (data.type === 'clamp-x') {
                    if (last.x === data.original.x) {
                        last.x = this.parent.x;
                    }
                } else if (data.type === 'clamp-y') {
                    if (last.y === data.original.y) {
                        last.y = this.parent.y;
                    }
                }
            }
        }
    }, {
        key: 'up',
        value: function up() {
            if (this.parent.countDownPointers() === 0 && this.saved.length) {
                var now = performance.now();
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.saved[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var save = _step.value;

                        if (save.time >= now - 100) {
                            var time = now - save.time;
                            this.x = (this.parent.x - save.x) / time;
                            this.y = (this.parent.y - save.y) / time;
                            this.percentChangeX = this.percentChangeY = this.friction;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }

        /**
         * manually activate plugin
         * @param {object} options
         * @param {number} [options.x]
         * @param {number} [options.y]
         */

    }, {
        key: 'activate',
        value: function activate(options) {
            options = options || {};
            if (typeof options.x !== 'undefined') {
                this.x = options.x;
                this.percentChangeX = this.friction;
            }
            if (typeof options.y !== 'undefined') {
                this.y = options.y;
                this.percentChangeY = this.friction;
            }
        }
    }, {
        key: 'update',
        value: function update(elapsed) {
            if (this.paused) {
                return;
            }

            var moved = void 0;
            if (this.x) {
                this.parent.x += this.x * elapsed;
                this.x *= this.percentChangeX;
                if (Math.abs(this.x) < this.minSpeed) {
                    this.x = 0;
                }
                moved = true;
            }
            if (this.y) {
                this.parent.y += this.y * elapsed;
                this.y *= this.percentChangeY;
                if (Math.abs(this.y) < this.minSpeed) {
                    this.y = 0;
                }
                moved = true;
            }
            if (moved) {
                this.parent.emit('moved', { viewport: this.parent, type: 'decelerate' });
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.x = this.y = null;
        }
    }]);

    return Decelerate;
}(Plugin);

/***/ }),

/***/ "AHbX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = bezierCurveTo;
/**
 * Calculate the points for a bezier curve and then draws it.
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @param {number} fromX - Starting point x
 * @param {number} fromY - Starting point y
 * @param {number} cpX - Control point x
 * @param {number} cpY - Control point y
 * @param {number} cpX2 - Second Control point x
 * @param {number} cpY2 - Second Control point y
 * @param {number} toX - Destination point x
 * @param {number} toY - Destination point y
 * @param {number} n - Number of segments approximating the bezier curve
 * @param {number[]} [path=[]] - Path array to push points into
 * @return {number[]} Array of points of the curve
 */
function bezierCurveTo(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, n) {
    var path = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : [];

    var dt = 0;
    var dt2 = 0;
    var dt3 = 0;
    var t2 = 0;
    var t3 = 0;

    path.push(fromX, fromY);

    for (var i = 1, j = 0; i <= n; ++i) {
        j = i / n;

        dt = 1 - j;
        dt2 = dt * dt;
        dt3 = dt2 * dt;

        t2 = j * j;
        t3 = t2 * j;

        path.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
    }

    return path;
}
//# sourceMappingURL=bezierCurveTo.js.map

/***/ }),

/***/ "AQv1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = __webpack_require__("sh3Y");

module.exports = function (_Plugin) {
    _inherits(Wheel, _Plugin);

    /**
     * @private
     * @param {Viewport} parent
     * @param {object} [options]
     * @param {number} [options.percent=0.1] percent to scroll with each spin
     * @param {number} [options.smooth] smooth the zooming by providing the number of frames to zoom between wheel spins
     * @param {boolean} [options.interrupt=true] stop smoothing with any user input on the viewport
     * @param {boolean} [options.reverse] reverse the direction of the scroll
     * @param {PIXI.Point} [options.center] place this point at center during zoom instead of current mouse position
     *
     * @event wheel({wheel: {dx, dy, dz}, event, viewport})
     */
    function Wheel(parent, options) {
        _classCallCheck(this, Wheel);

        var _this = _possibleConstructorReturn(this, (Wheel.__proto__ || Object.getPrototypeOf(Wheel)).call(this, parent));

        options = options || {};
        _this.percent = options.percent || 0.1;
        _this.center = options.center;
        _this.reverse = options.reverse;
        _this.smooth = options.smooth;
        _this.interrupt = typeof options.interrupt === 'undefined' ? true : options.interrupt;
        return _this;
    }

    _createClass(Wheel, [{
        key: 'down',
        value: function down() {
            if (this.interrupt) {
                this.smoothing = null;
            }
        }
    }, {
        key: 'update',
        value: function update() {
            if (this.smoothing) {
                var point = this.smoothingCenter;
                var change = this.smoothing;
                var oldPoint = void 0;
                if (!this.center) {
                    oldPoint = this.parent.toLocal(point);
                }
                this.parent.scale.x += change.x;
                this.parent.scale.y += change.y;
                this.parent.emit('zoomed', { viewport: this.parent, type: 'wheel' });
                var clamp = this.parent.plugins['clamp-zoom'];
                if (clamp) {
                    clamp.clamp();
                }
                if (this.center) {
                    this.parent.moveCenter(this.center);
                } else {
                    var newPoint = this.parent.toGlobal(oldPoint);
                    this.parent.x += point.x - newPoint.x;
                    this.parent.y += point.y - newPoint.y;
                }
                this.smoothingCount++;
                if (this.smoothingCount >= this.smooth) {
                    this.smoothing = null;
                }
            }
        }
    }, {
        key: 'wheel',
        value: function wheel(e) {
            if (this.paused) {
                return;
            }

            var point = this.parent.getPointerPosition(e);
            var sign = this.reverse ? -1 : 1;
            var step = sign * -e.deltaY * (e.deltaMode ? 120 : 1) / 500;
            var change = Math.pow(2, (1 + this.percent) * step);
            if (this.smooth) {
                var original = {
                    x: this.smoothing ? this.smoothing.x * (this.smooth - this.smoothingCount) : 0,
                    y: this.smoothing ? this.smoothing.y * (this.smooth - this.smoothingCount) : 0
                };
                this.smoothing = {
                    x: ((this.parent.scale.x + original.x) * change - this.parent.scale.x) / this.smooth,
                    y: ((this.parent.scale.y + original.y) * change - this.parent.scale.y) / this.smooth
                };
                this.smoothingCount = 0;
                this.smoothingCenter = point;
            } else {
                var oldPoint = void 0;
                if (!this.center) {
                    oldPoint = this.parent.toLocal(point);
                }
                this.parent.scale.x *= change;
                this.parent.scale.y *= change;
                this.parent.emit('zoomed', { viewport: this.parent, type: 'wheel' });
                var clamp = this.parent.plugins['clamp-zoom'];
                if (clamp) {
                    clamp.clamp();
                }
                if (this.center) {
                    this.parent.moveCenter(this.center);
                } else {
                    var newPoint = this.parent.toGlobal(oldPoint);
                    this.parent.x += point.x - newPoint.x;
                    this.parent.y += point.y - newPoint.y;
                }
            }
            this.parent.emit('moved', { viewport: this.parent, type: 'wheel' });
            this.parent.emit('wheel', { wheel: { dx: e.deltaX, dy: e.deltaY, dz: e.deltaZ }, event: e, viewport: this.parent });
            if (!this.parent.passiveWheel) {
                e.preventDefault();
            }
        }
    }]);

    return Wheel;
}(Plugin);

/***/ }),

/***/ "AVkB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _extractUniformsFromSrc = __webpack_require__("s0lT");

var _extractUniformsFromSrc2 = _interopRequireDefault(_extractUniformsFromSrc);

var _utils = __webpack_require__("dDI1");

var _const = __webpack_require__("YEQi");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SOURCE_KEY_MAP = {};

// let math = require('../../../math');
/**
 * @class
 * @memberof PIXI
 * @extends PIXI.Shader
 */

var Filter = function () {
  /**
   * @param {string} [vertexSrc] - The source of the vertex shader.
   * @param {string} [fragmentSrc] - The source of the fragment shader.
   * @param {object} [uniformData] - Custom uniforms to use to augment the built-in ones.
   */
  function Filter(vertexSrc, fragmentSrc, uniformData) {
    _classCallCheck(this, Filter);

    /**
     * The vertex shader.
     *
     * @member {string}
     */
    this.vertexSrc = vertexSrc || Filter.defaultVertexSrc;

    /**
     * The fragment shader.
     *
     * @member {string}
     */
    this.fragmentSrc = fragmentSrc || Filter.defaultFragmentSrc;

    this._blendMode = _const.BLEND_MODES.NORMAL;

    this.uniformData = uniformData || (0, _extractUniformsFromSrc2.default)(this.vertexSrc, this.fragmentSrc, 'projectionMatrix|uSampler');

    /**
     * An object containing the current values of custom uniforms.
     * @example <caption>Updating the value of a custom uniform</caption>
     * filter.uniforms.time = performance.now();
     *
     * @member {object}
     */
    this.uniforms = {};

    for (var i in this.uniformData) {
      this.uniforms[i] = this.uniformData[i].value;
      if (this.uniformData[i].type) {
        this.uniformData[i].type = this.uniformData[i].type.toLowerCase();
      }
    }

    // this is where we store shader references..
    // TODO we could cache this!
    this.glShaders = {};

    // used for caching.. sure there is a better way!
    if (!SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc]) {
      SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc] = (0, _utils.uid)();
    }

    this.glShaderKey = SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc];

    /**
     * The padding of the filter. Some filters require extra space to breath such as a blur.
     * Increasing this will add extra width and height to the bounds of the object that the
     * filter is applied to.
     *
     * @member {number}
     */
    this.padding = 4;

    /**
     * The resolution of the filter. Setting this to be lower will lower the quality but
     * increase the performance of the filter.
     *
     * @member {number}
     */
    this.resolution = _settings2.default.FILTER_RESOLUTION;

    /**
     * If enabled is true the filter is applied, if false it will not.
     *
     * @member {boolean}
     */
    this.enabled = true;

    /**
     * If enabled, PixiJS will fit the filter area into boundaries for better performance.
     * Switch it off if it does not work for specific shader.
     *
     * @member {boolean}
     */
    this.autoFit = true;
  }

  /**
   * Applies the filter
   *
   * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
   * @param {PIXI.RenderTarget} input - The input render target.
   * @param {PIXI.RenderTarget} output - The target to output to.
   * @param {boolean} clear - Should the output be cleared before rendering to it
   * @param {object} [currentState] - It's current state of filter.
   *        There are some useful properties in the currentState :
   *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
   */

  Filter.prototype.apply = function apply(filterManager, input, output, clear, currentState) // eslint-disable-line no-unused-vars
  {
    // --- //
    //  this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(tempMatrix, window.panda );

    // do as you please!

    filterManager.applyFilter(this, input, output, clear);

    // or just do a regular render..
  };

  /**
   * Sets the blendmode of the filter
   *
   * @member {number}
   * @default PIXI.BLEND_MODES.NORMAL
   */

  _createClass(Filter, [{
    key: 'blendMode',
    get: function get() {
      return this._blendMode;
    },
    set: function set(value) // eslint-disable-line require-jsdoc
    {
      this._blendMode = value;
    }

    /**
     * The default vertex shader source
     *
     * @static
     * @constant
     */

  }], [{
    key: 'defaultVertexSrc',
    get: function get() {
      return ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform mat3 projectionMatrix;', 'uniform mat3 filterMatrix;', 'varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;', '   vTextureCoord = aTextureCoord ;', '}'].join('\n');
    }

    /**
     * The default fragment shader source
     *
     * @static
     * @constant
     */

  }, {
    key: 'defaultFragmentSrc',
    get: function get() {
      return ['varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'uniform sampler2D uSampler;', 'uniform sampler2D filterSampler;', 'void main(void){', '   vec4 masky = texture2D(filterSampler, vFilterCoord);', '   vec4 sample = texture2D(uSampler, vTextureCoord);', '   vec4 color;', '   if(mod(vFilterCoord.x, 1.0) > 0.5)', '   {', '     color = vec4(1.0, 0.0, 0.0, 1.0);', '   }', '   else', '   {', '     color = vec4(0.0, 1.0, 0.0, 1.0);', '   }',
      // '   gl_FragColor = vec4(mod(vFilterCoord.x, 1.5), vFilterCoord.y,0.0,1.0);',
      '   gl_FragColor = mix(sample, masky, 0.5);', '   gl_FragColor *= sample.a;', '}'].join('\n');
    }
  }]);

  return Filter;
}();

exports.default = Filter;
//# sourceMappingURL=Filter.js.map

/***/ }),

/***/ "AsaK":
/***/ (function(module, exports) {

// square distance from a point to a segment
function getSqSegDist(p, p1, p2) {
    var x = p1[0],
        y = p1[1],
        dx = p2[0] - x,
        dy = p2[1] - y;

    if (dx !== 0 || dy !== 0) {

        var t = ((p[0] - x) * dx + (p[1] - y) * dy) / (dx * dx + dy * dy);

        if (t > 1) {
            x = p2[0];
            y = p2[1];
        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }

    dx = p[0] - x;
    dy = p[1] - y;

    return dx * dx + dy * dy;
}

function simplifyDPStep(points, first, last, sqTolerance, simplified) {
    var maxSqDist = sqTolerance,
        index;

    for (var i = first + 1; i < last; i++) {
        var sqDist = getSqSegDist(points[i], points[first], points[last]);

        if (sqDist > maxSqDist) {
            index = i;
            maxSqDist = sqDist;
        }
    }

    if (maxSqDist > sqTolerance) {
        if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
        simplified.push(points[index]);
        if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
    }
}

// simplification using Ramer-Douglas-Peucker algorithm
module.exports = function simplifyDouglasPeucker(points, tolerance) {
    if (points.length <= 1) return points;
    tolerance = typeof tolerance === 'number' ? tolerance : 1;
    var sqTolerance = tolerance * tolerance;

    var last = points.length - 1;

    var simplified = [points[0]];
    simplifyDPStep(points, 0, last, sqTolerance, simplified);
    simplified.push(points[last]);

    return simplified;
};

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "Awug":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};
//# sourceMappingURL=LocaleUtils.js.map

/***/ }),

/***/ "B6/o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(that, args.concat(slice.call(arguments)));
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

/***/ }),

/***/ "B7+M":
/***/ (function(module, exports) {

var HEADER = [66, 77, 70];

module.exports = function readBMFontBinary(buf) {
  if (buf.length < 6) throw new Error('invalid buffer length for BMFont');

  var header = HEADER.every(function (byte, i) {
    return buf.readUInt8(i) === byte;
  });

  if (!header) throw new Error('BMFont missing BMF byte header');

  var i = 3;
  var vers = buf.readUInt8(i++);
  if (vers > 3) throw new Error('Only supports BMFont Binary v3 (BMFont App v1.10)');

  var target = { kernings: [], chars: [] };
  for (var b = 0; b < 5; b++) {
    i += readBlock(target, buf, i);
  }return target;
};

function readBlock(target, buf, i) {
  if (i > buf.length - 1) return 0;

  var blockID = buf.readUInt8(i++);
  var blockSize = buf.readInt32LE(i);
  i += 4;

  switch (blockID) {
    case 1:
      target.info = readInfo(buf, i);
      break;
    case 2:
      target.common = readCommon(buf, i);
      break;
    case 3:
      target.pages = readPages(buf, i, blockSize);
      break;
    case 4:
      target.chars = readChars(buf, i, blockSize);
      break;
    case 5:
      target.kernings = readKernings(buf, i, blockSize);
      break;
  }
  return 5 + blockSize;
}

function readInfo(buf, i) {
  var info = {};
  info.size = buf.readInt16LE(i);

  var bitField = buf.readUInt8(i + 2);
  info.smooth = bitField >> 7 & 1;
  info.unicode = bitField >> 6 & 1;
  info.italic = bitField >> 5 & 1;
  info.bold = bitField >> 4 & 1;

  //fixedHeight is only mentioned in binary spec 
  if (bitField >> 3 & 1) info.fixedHeight = 1;

  info.charset = buf.readUInt8(i + 3) || '';
  info.stretchH = buf.readUInt16LE(i + 4);
  info.aa = buf.readUInt8(i + 6);
  info.padding = [buf.readInt8(i + 7), buf.readInt8(i + 8), buf.readInt8(i + 9), buf.readInt8(i + 10)];
  info.spacing = [buf.readInt8(i + 11), buf.readInt8(i + 12)];
  info.outline = buf.readUInt8(i + 13);
  info.face = readStringNT(buf, i + 14);
  return info;
}

function readCommon(buf, i) {
  var common = {};
  common.lineHeight = buf.readUInt16LE(i);
  common.base = buf.readUInt16LE(i + 2);
  common.scaleW = buf.readUInt16LE(i + 4);
  common.scaleH = buf.readUInt16LE(i + 6);
  common.pages = buf.readUInt16LE(i + 8);
  var bitField = buf.readUInt8(i + 10);
  common.packed = 0;
  common.alphaChnl = buf.readUInt8(i + 11);
  common.redChnl = buf.readUInt8(i + 12);
  common.greenChnl = buf.readUInt8(i + 13);
  common.blueChnl = buf.readUInt8(i + 14);
  return common;
}

function readPages(buf, i, size) {
  var pages = [];
  var text = readNameNT(buf, i);
  var len = text.length + 1;
  var count = size / len;
  for (var c = 0; c < count; c++) {
    pages[c] = buf.slice(i, i + text.length).toString('utf8');
    i += len;
  }
  return pages;
}

function readChars(buf, i, blockSize) {
  var chars = [];

  var count = blockSize / 20;
  for (var c = 0; c < count; c++) {
    var char = {};
    var off = c * 20;
    char.id = buf.readUInt32LE(i + 0 + off);
    char.x = buf.readUInt16LE(i + 4 + off);
    char.y = buf.readUInt16LE(i + 6 + off);
    char.width = buf.readUInt16LE(i + 8 + off);
    char.height = buf.readUInt16LE(i + 10 + off);
    char.xoffset = buf.readInt16LE(i + 12 + off);
    char.yoffset = buf.readInt16LE(i + 14 + off);
    char.xadvance = buf.readInt16LE(i + 16 + off);
    char.page = buf.readUInt8(i + 18 + off);
    char.chnl = buf.readUInt8(i + 19 + off);
    chars[c] = char;
  }
  return chars;
}

function readKernings(buf, i, blockSize) {
  var kernings = [];
  var count = blockSize / 10;
  for (var c = 0; c < count; c++) {
    var kern = {};
    var off = c * 10;
    kern.first = buf.readUInt32LE(i + 0 + off);
    kern.second = buf.readUInt32LE(i + 4 + off);
    kern.amount = buf.readInt16LE(i + 8 + off);
    kernings[c] = kern;
  }
  return kernings;
}

function readNameNT(buf, offset) {
  var pos = offset;
  for (; pos < buf.length; pos++) {
    if (buf[pos] === 0x00) break;
  }
  return buf.slice(offset, pos);
}

function readStringNT(buf, offset) {
  return readNameNT(buf, offset).toString('utf8');
}

/***/ }),

/***/ "BGVx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = buildRoundedRectangle;

var _earcut = __webpack_require__("vwhv");

var _earcut2 = _interopRequireDefault(_earcut);

var _buildLine = __webpack_require__("MEjA");

var _buildLine2 = _interopRequireDefault(_buildLine);

var _utils = __webpack_require__("dDI1");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Builds a rounded rectangle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
 */
function buildRoundedRectangle(graphicsData, webGLData, webGLDataNativeLines) {
    var rrectData = graphicsData.shape;
    var x = rrectData.x;
    var y = rrectData.y;
    var width = rrectData.width;
    var height = rrectData.height;

    var radius = rrectData.radius;

    var recPoints = [];

    recPoints.push(x + radius, y);
    quadraticBezierCurve(x + width - radius, y, x + width, y, x + width, y + radius, recPoints);
    quadraticBezierCurve(x + width, y + height - radius, x + width, y + height, x + width - radius, y + height, recPoints);
    quadraticBezierCurve(x + radius, y + height, x, y + height, x, y + height - radius, recPoints);
    quadraticBezierCurve(x, y + radius, x, y, x + radius + 0.0000000001, y, recPoints);

    // this tiny number deals with the issue that occurs when points overlap and earcut fails to triangulate the item.
    // TODO - fix this properly, this is not very elegant.. but it works for now.

    if (graphicsData.fill) {
        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
        var alpha = graphicsData.fillAlpha;

        var r = color[0] * alpha;
        var g = color[1] * alpha;
        var b = color[2] * alpha;

        var verts = webGLData.points;
        var indices = webGLData.indices;

        var vecPos = verts.length / 6;

        var triangles = (0, _earcut2.default)(recPoints, null, 2);

        for (var i = 0, j = triangles.length; i < j; i += 3) {
            indices.push(triangles[i] + vecPos);
            indices.push(triangles[i] + vecPos);
            indices.push(triangles[i + 1] + vecPos);
            indices.push(triangles[i + 2] + vecPos);
            indices.push(triangles[i + 2] + vecPos);
        }

        for (var _i = 0, _j = recPoints.length; _i < _j; _i++) {
            verts.push(recPoints[_i], recPoints[++_i], r, g, b, alpha);
        }
    }

    if (graphicsData.lineWidth) {
        var tempPoints = graphicsData.points;

        graphicsData.points = recPoints;

        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);

        graphicsData.points = tempPoints;
    }
}

/**
 * Calculate a single point for a quadratic bezier curve.
 * Utility function used by quadraticBezierCurve.
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} n1 - first number
 * @param {number} n2 - second number
 * @param {number} perc - percentage
 * @return {number} the result
 *
 */
function getPt(n1, n2, perc) {
    var diff = n2 - n1;

    return n1 + diff * perc;
}

/**
 * Calculate the points for a quadratic bezier curve. (helper function..)
 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} fromX - Origin point x
 * @param {number} fromY - Origin point x
 * @param {number} cpX - Control point x
 * @param {number} cpY - Control point y
 * @param {number} toX - Destination point x
 * @param {number} toY - Destination point y
 * @param {number[]} [out=[]] - The output array to add points into. If not passed, a new array is created.
 * @return {number[]} an array of points
 */
function quadraticBezierCurve(fromX, fromY, cpX, cpY, toX, toY) {
    var out = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];

    var n = 20;
    var points = out;

    var xa = 0;
    var ya = 0;
    var xb = 0;
    var yb = 0;
    var x = 0;
    var y = 0;

    for (var i = 0, j = 0; i <= n; ++i) {
        j = i / n;

        // The Green Line
        xa = getPt(fromX, cpX, j);
        ya = getPt(fromY, cpY, j);
        xb = getPt(cpX, toX, j);
        yb = getPt(cpY, toY, j);

        // The Black Dot
        x = getPt(xa, xb, j);
        y = getPt(ya, yb, j);

        points.push(x, y);
    }

    return points;
}
//# sourceMappingURL=buildRoundedRectangle.js.map

/***/ }),

/***/ "BJd1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "27b8a7251f674a93adf2d4b01d9a95d1.svg";

/***/ }),

/***/ "BPe0":
/***/ (function(module, exports) {

Array.prototype.find = Array.prototype.find || function (callback) {
  if (this === null) {
    throw new TypeError("Array.prototype.find called on null or undefined");
  } else if (typeof callback !== "function") {
    throw new TypeError("callback must be a function");
  }
  var list = Object(this);
  // Makes sures is always has an positive integer as length.
  var length = list.length >>> 0;
  var thisArg = arguments[1];
  for (var i = 0; i < length; i++) {
    var element = list[i];
    if (callback.call(thisArg, element, i, list)) {
      return element;
    }
  }
};

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, "includes", {
    enumerable: false,
    value: function value(obj) {
      var newArr = this.filter(function (el) {
        return el == obj;
      });
      return newArr.length > 0;
    }
  });
}

if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    "use strict";

    if (typeof start !== "number") {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

/***/ }),

/***/ "BQ2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actionTypes_namespaceObject = {};
__webpack_require__.d(actionTypes_namespaceObject, "prefix", function() { return prefix; });
__webpack_require__.d(actionTypes_namespaceObject, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
__webpack_require__.d(actionTypes_namespaceObject, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
__webpack_require__.d(actionTypes_namespaceObject, "ARRAY_POP", function() { return ARRAY_POP; });
__webpack_require__.d(actionTypes_namespaceObject, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
__webpack_require__.d(actionTypes_namespaceObject, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
__webpack_require__.d(actionTypes_namespaceObject, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
__webpack_require__.d(actionTypes_namespaceObject, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
__webpack_require__.d(actionTypes_namespaceObject, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
__webpack_require__.d(actionTypes_namespaceObject, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
__webpack_require__.d(actionTypes_namespaceObject, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
__webpack_require__.d(actionTypes_namespaceObject, "AUTOFILL", function() { return AUTOFILL; });
__webpack_require__.d(actionTypes_namespaceObject, "BLUR", function() { return BLUR; });
__webpack_require__.d(actionTypes_namespaceObject, "CHANGE", function() { return CHANGE; });
__webpack_require__.d(actionTypes_namespaceObject, "CLEAR_FIELDS", function() { return CLEAR_FIELDS; });
__webpack_require__.d(actionTypes_namespaceObject, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
__webpack_require__.d(actionTypes_namespaceObject, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
__webpack_require__.d(actionTypes_namespaceObject, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
__webpack_require__.d(actionTypes_namespaceObject, "DESTROY", function() { return DESTROY; });
__webpack_require__.d(actionTypes_namespaceObject, "FOCUS", function() { return FOCUS; });
__webpack_require__.d(actionTypes_namespaceObject, "INITIALIZE", function() { return INITIALIZE; });
__webpack_require__.d(actionTypes_namespaceObject, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
__webpack_require__.d(actionTypes_namespaceObject, "RESET", function() { return RESET; });
__webpack_require__.d(actionTypes_namespaceObject, "RESET_SECTION", function() { return RESET_SECTION; });
__webpack_require__.d(actionTypes_namespaceObject, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
__webpack_require__.d(actionTypes_namespaceObject, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
__webpack_require__.d(actionTypes_namespaceObject, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
__webpack_require__.d(actionTypes_namespaceObject, "START_SUBMIT", function() { return START_SUBMIT; });
__webpack_require__.d(actionTypes_namespaceObject, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
__webpack_require__.d(actionTypes_namespaceObject, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
__webpack_require__.d(actionTypes_namespaceObject, "SUBMIT", function() { return SUBMIT; });
__webpack_require__.d(actionTypes_namespaceObject, "TOUCH", function() { return TOUCH; });
__webpack_require__.d(actionTypes_namespaceObject, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
__webpack_require__.d(actionTypes_namespaceObject, "UNTOUCH", function() { return UNTOUCH; });
__webpack_require__.d(actionTypes_namespaceObject, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
__webpack_require__.d(actionTypes_namespaceObject, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });

// CONCATENATED MODULE: ../node_modules/redux-form/es/actionTypes.js
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_FIELDS = prefix + 'CLEAR_FIELDS';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var RESET_SECTION = prefix + 'RESET_SECTION';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';
// CONCATENATED MODULE: ../node_modules/redux-form/es/actions.js
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



var actions_arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: ARRAY_INSERT,
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var actions_arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: ARRAY_MOVE,
    meta: { form: form, field: field, from: from, to: to }
  };
};

var actions_arrayPop = function arrayPop(form, field) {
  return {
    type: ARRAY_POP,
    meta: { form: form, field: field }
  };
};

var actions_arrayPush = function arrayPush(form, field, value) {
  return {
    type: ARRAY_PUSH,
    meta: { form: form, field: field },
    payload: value
  };
};

var actions_arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: ARRAY_REMOVE,
    meta: { form: form, field: field, index: index }
  };
};

var actions_arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: ARRAY_REMOVE_ALL,
    meta: { form: form, field: field }
  };
};

var actions_arrayShift = function arrayShift(form, field) {
  return {
    type: ARRAY_SHIFT,
    meta: { form: form, field: field }
  };
};

var actions_arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: ARRAY_SPLICE,
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var actions_arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: ARRAY_SWAP, meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var actions_arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: ARRAY_UNSHIFT,
    meta: { form: form, field: field },
    payload: value
  };
};

var actions_autofill = function autofill(form, field, value) {
  return {
    type: AUTOFILL,
    meta: { form: form, field: field },
    payload: value
  };
};

var actions_blur = function blur(form, field, value, touch) {
  return {
    type: BLUR,
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var actions_change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: CHANGE,
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var actions_clearSubmit = function clearSubmit(form) {
  return {
    type: CLEAR_SUBMIT,
    meta: { form: form }
  };
};

var actions_clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: CLEAR_SUBMIT_ERRORS,
    meta: { form: form }
  };
};

var actions_clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: CLEAR_ASYNC_ERROR,
    meta: { form: form, field: field }
  };
};

var actions_clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }

  return {
    type: CLEAR_FIELDS,
    meta: { form: form, keepTouched: keepTouched, persistentSubmitErrors: persistentSubmitErrors, fields: fields }
  };
};

var actions_destroy = function destroy() {
  for (var _len2 = arguments.length, form = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form[_key2] = arguments[_key2];
  }

  return {
    type: DESTROY,
    meta: { form: form }
  };
};

var actions_focus = function focus(form, field) {
  return {
    type: FOCUS,
    meta: { form: form, field: field }
  };
};

var actions_initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: INITIALIZE,
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var actions_registerField = function registerField(form, name, type) {
  return {
    type: REGISTER_FIELD,
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var actions_reset = function reset(form) {
  return {
    type: RESET,
    meta: { form: form }
  };
};

var actions_resetSection = function resetSection(form) {
  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }

  return {
    type: RESET_SECTION,
    meta: { form: form, sections: sections }
  };
};

var actions_startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: START_ASYNC_VALIDATION,
    meta: { form: form, field: field }
  };
};

var actions_startSubmit = function startSubmit(form) {
  return {
    type: START_SUBMIT,
    meta: { form: form }
  };
};

var actions_stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: STOP_ASYNC_VALIDATION,
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var actions_stopSubmit = function stopSubmit(form, errors) {
  return {
    type: STOP_SUBMIT,
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var actions_submit = function submit(form) {
  return {
    type: SUBMIT,
    meta: { form: form }
  };
};

var actions_setSubmitFailed = function setSubmitFailed(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: SET_SUBMIT_FAILED,
    meta: { form: form, fields: fields },
    error: true
  };
};

var actions_setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: SET_SUBMIT_SUCCEEDED,
    meta: { form: form, fields: fields },
    error: false
  };
};

var actions_touch = function touch(form) {
  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }

  return {
    type: TOUCH,
    meta: { form: form, fields: fields }
  };
};

var actions_unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: UNREGISTER_FIELD,
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var actions_untouch = function untouch(form) {
  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }

  return {
    type: UNTOUCH,
    meta: { form: form, fields: fields }
  };
};

var actions_updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: UPDATE_SYNC_ERRORS,
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var actions_updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: UPDATE_SYNC_WARNINGS,
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: actions_arrayInsert,
  arrayMove: actions_arrayMove,
  arrayPop: actions_arrayPop,
  arrayPush: actions_arrayPush,
  arrayRemove: actions_arrayRemove,
  arrayRemoveAll: actions_arrayRemoveAll,
  arrayShift: actions_arrayShift,
  arraySplice: actions_arraySplice,
  arraySwap: actions_arraySwap,
  arrayUnshift: actions_arrayUnshift,
  autofill: actions_autofill,
  blur: actions_blur,
  change: actions_change,
  clearFields: actions_clearFields,
  clearSubmit: actions_clearSubmit,
  clearSubmitErrors: actions_clearSubmitErrors,
  clearAsyncError: actions_clearAsyncError,
  destroy: actions_destroy,
  focus: actions_focus,
  initialize: actions_initialize,
  registerField: actions_registerField,
  reset: actions_reset,
  resetSection: actions_resetSection,
  startAsyncValidation: actions_startAsyncValidation,
  startSubmit: actions_startSubmit,
  stopAsyncValidation: actions_stopAsyncValidation,
  stopSubmit: actions_stopSubmit,
  submit: actions_submit,
  setSubmitFailed: actions_setSubmitFailed,
  setSubmitSucceeded: actions_setSubmitSucceeded,
  touch: actions_touch,
  unregisterField: actions_unregisterField,
  untouch: actions_untouch,
  updateSyncErrors: actions_updateSyncErrors,
  updateSyncWarnings: actions_updateSyncWarnings
};

/* harmony default export */ var es_actions = (actions);
// CONCATENATED MODULE: ../node_modules/redux-form/es/defaultShouldAsyncValidate.js


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
    case 'change':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};

/* harmony default export */ var es_defaultShouldAsyncValidate = (defaultShouldAsyncValidate);
// CONCATENATED MODULE: ../node_modules/redux-form/es/defaultShouldValidate.js


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};

/* harmony default export */ var es_defaultShouldValidate = (defaultShouldValidate);
// CONCATENATED MODULE: ../node_modules/redux-form/es/defaultShouldError.js


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};

/* harmony default export */ var es_defaultShouldError = (defaultShouldError);
// CONCATENATED MODULE: ../node_modules/redux-form/es/defaultShouldWarn.js


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};

/* harmony default export */ var es_defaultShouldWarn = (defaultShouldWarn);
// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/redux-form/node_modules/prop-types/index.js
var prop_types = __webpack_require__("iuFh");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/redux-form/es/Form.js
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}




var Form_Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return preact_compat_es["default"].createElement('form', this.props);
    }
  }]);

  return Form;
}(preact_compat_es["Component"]);

Form_Form.contextTypes = {
  _reduxForm: prop_types_default.a.object
};

/* harmony default export */ var es_Form = (Form_Form);
// CONCATENATED MODULE: ../node_modules/redux-form/es/util/prefixName.js


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};

/* harmony default export */ var prefixName = (formatName);
// CONCATENATED MODULE: ../node_modules/redux-form/es/FormSection.js
var FormSection__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var FormSection__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function FormSection__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function FormSection__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function FormSection__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}





var FormSection_FormSection = function (_Component) {
  FormSection__inherits(FormSection, _Component);

  function FormSection(props, context) {
    FormSection__classCallCheck(this, FormSection);

    var _this = FormSection__possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  FormSection__createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: FormSection__extends({}, context._reduxForm, {
          sectionPrefix: prefixName(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (preact_compat_es["default"].isValidElement(children)) {
        return children;
      }

      return Object(preact_compat_es["createElement"])(component, FormSection__extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(preact_compat_es["Component"]);

FormSection_FormSection.propTypes = {
  name: prop_types_default.a.string.isRequired,
  component: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string])
};

FormSection_FormSection.defaultProps = {
  component: 'div'
};

FormSection_FormSection.childContextTypes = {
  _reduxForm: prop_types_default.a.object.isRequired
};

FormSection_FormSection.contextTypes = {
  _reduxForm: prop_types_default.a.object
};

/* harmony default export */ var es_FormSection = (FormSection_FormSection);
// CONCATENATED MODULE: ../node_modules/es6-error/es6/index.js
function es6__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function es6__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function es6__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  es6__inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    es6__classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = es6__possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return es6__possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ var es6 = (ExtendableError);
// CONCATENATED MODULE: ../node_modules/redux-form/es/SubmissionError.js
function SubmissionError__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function SubmissionError__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function SubmissionError__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}



var SubmissionError = function (_ExtendableError) {
  SubmissionError__inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    SubmissionError__classCallCheck(this, SubmissionError);

    var _this = SubmissionError__possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(es6);

/* harmony default export */ var es_SubmissionError = (SubmissionError);
// CONCATENATED MODULE: ../node_modules/redux-form/es/propTypes.js


var any = prop_types_default.a.any,
    bool = prop_types_default.a.bool,
    propTypes_func = prop_types_default.a.func,
    shape = prop_types_default.a.shape,
    propTypes_string = prop_types_default.a.string,
    oneOfType = prop_types_default.a.oneOfType,
    propTypes_object = prop_types_default.a.object,
    number = prop_types_default.a.number;

var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, propTypes_string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: propTypes_string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: propTypes_object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: propTypes_func.isRequired, // function to insert a value into an array field
    move: propTypes_func.isRequired, // function to move a value within an array field
    pop: propTypes_func.isRequired, // function to pop a value off of an array field
    push: propTypes_func.isRequired, // function to push a value onto an array field
    remove: propTypes_func.isRequired, // function to remove a value from an array field
    removeAll: propTypes_func.isRequired, // function to remove all the values from an array field
    shift: propTypes_func.isRequired, // function to shift a value out of an array field
    splice: propTypes_func.isRequired, // function to splice a value into an array field
    swap: propTypes_func.isRequired, // function to swap values in an array field
    unshift: propTypes_func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: propTypes_func.isRequired, // function to trigger async validation
  autofill: propTypes_func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: propTypes_func.isRequired, // action to mark a field as blurred
  change: propTypes_func.isRequired, // action to change the value of a field
  clearAsyncError: propTypes_func.isRequired, // action to clear the async error of a field
  clearFields: propTypes_func.isRequired, // action to clean fields values for all fields
  clearSubmitErrors: propTypes_func.isRequired, // action to remove submitErrors and error
  destroy: propTypes_func.isRequired, // action to destroy the form's data in Redux
  dispatch: propTypes_func.isRequired, // the Redux dispatch action
  handleSubmit: propTypes_func.isRequired, // function to submit the form
  initialize: propTypes_func.isRequired, // action to initialize form data
  reset: propTypes_func.isRequired, // action to reset the form data to previously initialized values
  resetSection: propTypes_func.isRequired, // action to reset the form sections data to previously initialized values
  touch: propTypes_func.isRequired, // action to mark fields as touched
  submit: propTypes_func.isRequired, // action to trigger a submission of the specified form
  untouch: propTypes_func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: propTypes_func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: propTypes_string.isRequired,
  onBlur: propTypes_func.isRequired,
  onChange: propTypes_func.isRequired,
  onDragStart: propTypes_func.isRequired,
  onDrop: propTypes_func.isRequired,
  onFocus: propTypes_func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: propTypes_func.isRequired,
  error: any,
  form: propTypes_string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: propTypes_string
};

var fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: propTypes_string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: propTypes_string
};

var fieldArrayFieldsPropTypes = {
  name: propTypes_string.isRequired,
  forEach: propTypes_func.isRequired,
  get: propTypes_func.isRequired,
  getAll: propTypes_func.isRequired,
  insert: propTypes_func.isRequired,
  length: number.isRequired,
  map: propTypes_func.isRequired,
  move: propTypes_func.isRequired,
  pop: propTypes_func.isRequired,
  push: propTypes_func.isRequired,
  reduce: propTypes_func.isRequired,
  remove: propTypes_func.isRequired,
  removeAll: propTypes_func.isRequired,
  shift: propTypes_func.isRequired,
  swap: propTypes_func.isRequired,
  unshift: propTypes_func.isRequired
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

var fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

/* harmony default export */ var propTypes = (formPropTypes);
// EXTERNAL MODULE: ../node_modules/redux-form/node_modules/invariant/browser.js
var browser = __webpack_require__("tkK7");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__("jYI/");

// CONCATENATED MODULE: ../node_modules/redux-form/es/createFieldProps.js
var createFieldProps__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function createFieldProps__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return createFieldProps__extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return createFieldProps__extends({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return createFieldProps__extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return createFieldProps__extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS,
      deepEqual = _ref2.deepEqual;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = createFieldProps__objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: createFieldProps__extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: createFieldProps__extends({}, custom, props)
  };
};

/* harmony default export */ var es_createFieldProps = (createFieldProps);
// CONCATENATED MODULE: ../node_modules/redux-form/es/events/isEvent.js
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ var events_isEvent = (isEvent);
// CONCATENATED MODULE: ../node_modules/redux-form/es/events/getValue.js


var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue_getValue = function getValue(event, isReactNative) {
  if (events_isEvent(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ var events_getValue = (getValue_getValue);
// CONCATENATED MODULE: ../node_modules/redux-form/es/isReactNative.js
var isReactNative_isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ var es_isReactNative = (isReactNative_isReactNative);
// CONCATENATED MODULE: ../node_modules/redux-form/es/events/onChangeValue.js



var onChangeValue_onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = events_getValue(event, es_isReactNative);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ var events_onChangeValue = (onChangeValue_onChangeValue);
// CONCATENATED MODULE: ../node_modules/redux-form/es/util/eventConsts.js
var dataKey = 'text';
// CONCATENATED MODULE: ../node_modules/redux-form/es/structure/plain/splice.js
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var splice_splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ var plain_splice = (splice_splice);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ var _arrayMap = (arrayMap);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_copyArray.js
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ var _copyArray = (copyArray);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ var lodash_es_isArray = (isArray);
// EXTERNAL MODULE: ../node_modules/redux-form/node_modules/lodash-es/_root.js
var _root = __webpack_require__("MC1R");

// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var _Symbol_Symbol = _root["a" /* default */].Symbol;

/* harmony default export */ var _Symbol = (_Symbol_Symbol);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return _baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value) ? _getRawTag(value) : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isSymbol.js



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || lodash_es_isObjectLike(value) && _baseGetTag(value) == symbolTag;
}

/* harmony default export */ var lodash_es_isSymbol = (isSymbol);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isFunction.js



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!lodash_es_isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ var lodash_es_isFunction = (isFunction);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var coreJsData = _root["a" /* default */]['__core-js_shared__'];

/* harmony default export */ var _coreJsData = (coreJsData);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/* harmony default export */ var _isMasked = (isMasked);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_toSource.js
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ var _toSource = (toSource);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var _baseIsNative_funcProto = Function.prototype,
    _baseIsNative_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var _baseIsNative_funcToString = _baseIsNative_funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = _baseIsNative_objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + _baseIsNative_funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!lodash_es_isObject(value) || _isMasked(value)) {
    return false;
  }
  var pattern = lodash_es_isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

/* harmony default export */ var _baseIsNative = (baseIsNative);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function _getValue_getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getValue = (_getValue_getValue);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* harmony default export */ var _getNative = (getNative);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/* harmony default export */ var lodash_es_eq = (eq);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var _listCacheDelete_splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    _listCacheDelete_splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = (ListCache);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var Map = _getNative(_root["a" /* default */], 'Map');

/* harmony default export */ var _Map = (Map);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/* harmony default export */ var _isKeyable = (isKeyable);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = (MapCache);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/memoize.js


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

/* harmony default export */ var lodash_es_memoize = (memoize);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_toKey.js


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || lodash_es_isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/* harmony default export */ var _toKey = (toKey);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var _baseToString_INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (lodash_es_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (lodash_es_isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -_baseToString_INFINITY ? '-0' : result;
}

/* harmony default export */ var _baseToString = (baseToString);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* harmony default export */ var lodash_es_toString = (toString_toString);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/toPath.js








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (lodash_es_isArray(value)) {
    return _arrayMap(value, _toKey);
  }
  return lodash_es_isSymbol(value) ? [value] : _copyArray(_stringToPath(lodash_es_toString(value)));
}

/* harmony default export */ var lodash_es_toPath = (toPath);
// CONCATENATED MODULE: ../node_modules/redux-form/es/structure/plain/getIn.js


var getIn_getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = lodash_es_toPath(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ var plain_getIn = (getIn_getIn);
// CONCATENATED MODULE: ../node_modules/redux-form/es/structure/plain/setIn.js


var setIn__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return setIn__extends({}, state, _defineProperty({}, first, next));
};

var setIn_setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, lodash_es_toPath(field), 0);
};

/* harmony default export */ var plain_setIn = (setIn_setIn);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache();
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = (Stack);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_setCacheAdd.js
/** Used to stand-in for `undefined` hash values. */
var _setCacheAdd_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, _setCacheAdd_HASH_UNDEFINED);
  return this;
}

/* harmony default export */ var _setCacheAdd = (setCacheAdd);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_setCacheHas.js
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ var _setCacheHas = (setCacheHas);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_SetCache.js




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

/* harmony default export */ var _SetCache = (SetCache);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_arraySome.js
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ var _arraySome = (arraySome);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_cacheHas.js
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ var _cacheHas = (cacheHas);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_equalArrays.js




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new _SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function (othValue, othIndex) {
        if (!_cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalArrays = (equalArrays);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_Uint8Array.js


/** Built-in value references. */
var Uint8Array = _root["a" /* default */].Uint8Array;

/* harmony default export */ var _Uint8Array = (Uint8Array);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_mapToArray.js
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ var _mapToArray = (mapToArray);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_setToArray.js
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ var _setToArray = (setToArray);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_equalByTag.js







/** Used to compose bitmasks for value comparisons. */
var _equalByTag_COMPARE_PARTIAL_FLAG = 1,
    _equalByTag_COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    _equalByTag_symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var _equalByTag_symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = _equalByTag_symbolProto ? _equalByTag_symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return lodash_es_eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = _mapToArray;

    case setTag:
      var isPartial = bitmask & _equalByTag_COMPARE_PARTIAL_FLAG;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= _equalByTag_COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case _equalByTag_symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ var _equalByTag = (equalByTag);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_arrayPush.js
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function _arrayPush_arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ var _arrayPush = (_arrayPush_arrayPush);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseGetAllKeys.js



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return lodash_es_isArray(object) ? result : _arrayPush(result, symbolsFunc(object));
}

/* harmony default export */ var _baseGetAllKeys = (baseGetAllKeys);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_arrayFilter.js
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ var _arrayFilter = (arrayFilter);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/stubArray.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ var lodash_es_stubArray = (stubArray);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_getSymbols.js



/** Used for built-in method references. */
var _getSymbols_objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = _getSymbols_objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? lodash_es_stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ var _getSymbols = (getSymbols);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseTimes.js
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ var _baseTimes = (baseTimes);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == argsTag;
}

/* harmony default export */ var _baseIsArguments = (baseIsArguments);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var isArguments_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = isArguments_objectProto.hasOwnProperty;

/** Built-in value references. */
var isArguments_propertyIsEnumerable = isArguments_objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (value) {
  return lodash_es_isObjectLike(value) && isArguments_hasOwnProperty.call(value, 'callee') && !isArguments_propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ var lodash_es_isArguments = (isArguments);
// EXTERNAL MODULE: ../node_modules/redux-form/node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__("to8j");

// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_isIndex.js
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/* harmony default export */ var _isIndex = (isIndex);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isLength.js
/** Used as references for various `Number` constants. */
var isLength_MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= isLength_MAX_SAFE_INTEGER;
}

/* harmony default export */ var lodash_es_isLength = (isLength);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var _baseIsTypedArray_argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    _baseIsTypedArray_boolTag = '[object Boolean]',
    _baseIsTypedArray_dateTag = '[object Date]',
    _baseIsTypedArray_errorTag = '[object Error]',
    _baseIsTypedArray_funcTag = '[object Function]',
    _baseIsTypedArray_mapTag = '[object Map]',
    _baseIsTypedArray_numberTag = '[object Number]',
    objectTag = '[object Object]',
    _baseIsTypedArray_regexpTag = '[object RegExp]',
    _baseIsTypedArray_setTag = '[object Set]',
    _baseIsTypedArray_stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var _baseIsTypedArray_arrayBufferTag = '[object ArrayBuffer]',
    _baseIsTypedArray_dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[_baseIsTypedArray_argsTag] = typedArrayTags[arrayTag] = typedArrayTags[_baseIsTypedArray_arrayBufferTag] = typedArrayTags[_baseIsTypedArray_boolTag] = typedArrayTags[_baseIsTypedArray_dataViewTag] = typedArrayTags[_baseIsTypedArray_dateTag] = typedArrayTags[_baseIsTypedArray_errorTag] = typedArrayTags[_baseIsTypedArray_funcTag] = typedArrayTags[_baseIsTypedArray_mapTag] = typedArrayTags[_baseIsTypedArray_numberTag] = typedArrayTags[objectTag] = typedArrayTags[_baseIsTypedArray_regexpTag] = typedArrayTags[_baseIsTypedArray_setTag] = typedArrayTags[_baseIsTypedArray_stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return lodash_es_isObjectLike(value) && lodash_es_isLength(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

/* harmony default export */ var _baseIsTypedArray = (baseIsTypedArray);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseUnary.js
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/* harmony default export */ var _baseUnary = (baseUnary);
// EXTERNAL MODULE: ../node_modules/redux-form/node_modules/lodash-es/_nodeUtil.js
var _nodeUtil = __webpack_require__("iEgh");

// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

/* harmony default export */ var lodash_es_isTypedArray = (isTypedArray);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_arrayLikeKeys.js







/** Used for built-in method references. */
var _arrayLikeKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _arrayLikeKeys_hasOwnProperty = _arrayLikeKeys_objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = lodash_es_isArray(value),
      isArg = !isArr && lodash_es_isArguments(value),
      isBuff = !isArr && !isArg && Object(isBuffer["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && lodash_es_isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || _arrayLikeKeys_hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    _isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _arrayLikeKeys = (arrayLikeKeys);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var _isPrototype_objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || _isPrototype_objectProto;

  return value === proto;
}

/* harmony default export */ var _isPrototype = (isPrototype);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _nativeKeys = (nativeKeys);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var _baseKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = _baseKeys_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeys = (baseKeys);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isArrayLike.js



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && lodash_es_isLength(value.length) && !lodash_es_isFunction(value);
}

/* harmony default export */ var lodash_es_isArrayLike = (isArrayLike);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/keys.js




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys_keys(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

/* harmony default export */ var lodash_es_keys = (keys_keys);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_getAllKeys.js




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, lodash_es_keys, _getSymbols);
}

/* harmony default export */ var _getAllKeys = (getAllKeys);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_equalObjects.js


/** Used to compose bitmasks for value comparisons. */
var _equalObjects_COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var _equalObjects_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _equalObjects_hasOwnProperty = _equalObjects_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & _equalObjects_COMPARE_PARTIAL_FLAG,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : _equalObjects_hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalObjects = (equalObjects);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root["a" /* default */], 'DataView');

/* harmony default export */ var _DataView = (DataView);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var _Promise_Promise = _getNative(_root["a" /* default */], 'Promise');

/* harmony default export */ var _Promise = (_Promise_Promise);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var Set = _getNative(_root["a" /* default */], 'Set');

/* harmony default export */ var _Set = (Set);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_WeakMap.js



/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root["a" /* default */], 'WeakMap');

/* harmony default export */ var _WeakMap = (WeakMap);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var _getTag_mapTag = '[object Map]',
    _getTag_objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    _getTag_setTag = '[object Set]',
    _getTag_weakMapTag = '[object WeakMap]';

var _getTag_dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var _getTag_getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (_DataView && _getTag_getTag(new _DataView(new ArrayBuffer(1))) != _getTag_dataViewTag || _Map && _getTag_getTag(new _Map()) != _getTag_mapTag || _Promise && _getTag_getTag(_Promise.resolve()) != promiseTag || _Set && _getTag_getTag(new _Set()) != _getTag_setTag || _WeakMap && _getTag_getTag(new _WeakMap()) != _getTag_weakMapTag) {
    _getTag_getTag = function getTag(value) {
        var result = _baseGetTag(value),
            Ctor = result == _getTag_objectTag ? value.constructor : undefined,
            ctorString = Ctor ? _toSource(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return _getTag_dataViewTag;
                case mapCtorString:
                    return _getTag_mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return _getTag_setTag;
                case weakMapCtorString:
                    return _getTag_weakMapTag;
            }
        }
        return result;
    };
}

/* harmony default export */ var _getTag = (_getTag_getTag);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseIsEqualDeep.js









/** Used to compose bitmasks for value comparisons. */
var _baseIsEqualDeep_COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var _baseIsEqualDeep_argsTag = '[object Arguments]',
    _baseIsEqualDeep_arrayTag = '[object Array]',
    _baseIsEqualDeep_objectTag = '[object Object]';

/** Used for built-in method references. */
var _baseIsEqualDeep_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseIsEqualDeep_hasOwnProperty = _baseIsEqualDeep_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = lodash_es_isArray(object),
      othIsArr = lodash_es_isArray(other),
      objTag = objIsArr ? _baseIsEqualDeep_arrayTag : _getTag(object),
      othTag = othIsArr ? _baseIsEqualDeep_arrayTag : _getTag(other);

  objTag = objTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : objTag;
  othTag = othTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : othTag;

  var objIsObj = objTag == _baseIsEqualDeep_objectTag,
      othIsObj = othTag == _baseIsEqualDeep_objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(isBuffer["a" /* default */])(object)) {
    if (!Object(isBuffer["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack());
    return objIsArr || lodash_es_isTypedArray(object) ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack) : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & _baseIsEqualDeep_COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && _baseIsEqualDeep_hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && _baseIsEqualDeep_hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack());
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ var _baseIsEqualDeep = (baseIsEqualDeep);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseIsEqual.js



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !lodash_es_isObjectLike(value) && !lodash_es_isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ var _baseIsEqual = (baseIsEqual);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isEqualWith.js


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? _baseIsEqual(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ var lodash_es_isEqualWith = (isEqualWith);
// CONCATENATED MODULE: ../node_modules/redux-form/es/structure/plain/deepEqual.js



var deepEqual_customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === undefined || obj === '';
    var otherIsEmpty = other === null || other === undefined || other === '';
    return objIsEmpty === otherIsEmpty;
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (preact_compat_es["default"].isValidElement(obj) || preact_compat_es["default"].isValidElement(other)) return false;
};

var deepEqual_deepEqual = function deepEqual(a, b) {
  return lodash_es_isEqualWith(a, b, deepEqual_customizer);
};

/* harmony default export */ var plain_deepEqual = (deepEqual_deepEqual);
// CONCATENATED MODULE: ../node_modules/redux-form/es/structure/plain/deleteIn.js


var deleteIn__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function deleteIn__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function deleteIn__toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(deleteIn__toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(deleteIn__toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(deleteIn__toConsumableArray(rest)));
      return state[first] === _result ? state : deleteIn__extends({}, state, deleteIn__defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(deleteIn__toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = deleteIn__extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn_deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(deleteIn__toConsumableArray(lodash_es_toPath(field))));
};

/* harmony default export */ var plain_deleteIn = (deleteIn_deleteIn);
// CONCATENATED MODULE: ../node_modules/redux-form/es/structure/plain/keys.js


function plain_keys_keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}

/* harmony default export */ var plain_keys = (plain_keys_keys);
// CONCATENATED MODULE: ../node_modules/redux-form/es/structure/plain/index.js







var plain_structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: plain_getIn,
  setIn: plain_setIn,
  deepEqual: plain_deepEqual,
  deleteIn: plain_deleteIn,
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: plain_keys,
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: plain_splice,
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ var plain = (plain_structure);
// CONCATENATED MODULE: ../node_modules/redux-form/es/ConnectedField.js
var ConnectedField__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var ConnectedField__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function ConnectedField__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function ConnectedField__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function ConnectedField__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function ConnectedField__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}










var propsToNotUpdateFor = ['_reduxForm'];

var ConnectedField_isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var ConnectedField_isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (ConnectedField_isObject(event) && ConnectedField_isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (ConnectedField_isObject(event) && ConnectedField_isObject(event.dataTransfer) && ConnectedField_isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (ConnectedField_isObject(event) && ConnectedField_isObject(event.dataTransfer) && ConnectedField_isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var ConnectedField_createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = plain.getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    ConnectedField__inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      ConnectedField__classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = ConnectedField__possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = events_onChangeValue(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!es_isReactNative) {
            onChange(ConnectedField__extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onChange(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));

          // call post-change callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'change');
          }
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;

        var defaultPrevented = false;
        if (onFocus) {
          if (!es_isReactNative) {
            onFocus(ConnectedField__extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            onFocus(event, name);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = events_onChangeValue(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          if (!es_isReactNative) {
            onBlur(ConnectedField__extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onBlur(event, newValue, previousValue, name);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'blur');
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            name = _this$props4.name,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, dataKey, value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event, name);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, dataKey);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(ConnectedField__extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), ConnectedField__possibleConstructorReturn(_this, _ret);
    }

    ConnectedField__createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            rest = ConnectedField__objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop']);

        var _createFieldProps = es_createFieldProps(structure, name, ConnectedField__extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = ConnectedField__objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(preact_compat_es["createElement"])(component, ConnectedField__extends({}, input, custom));
        } else {
          return Object(preact_compat_es["createElement"])(component, ConnectedField__extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(preact_compat_es["Component"]);

  ConnectedField.propTypes = {
    component: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string]).isRequired,
    props: prop_types_default.a.object
  };

  var connector = Object(es["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ var es_ConnectedField = (ConnectedField_createConnectedField);
// CONCATENATED MODULE: ../node_modules/redux-form/es/util/shallowCompare.js


var shallowCompare_customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare_shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  var propsEqual = lodash_es_isEqualWith(instance.props, nextProps, shallowCompare_customizer);
  var stateEqual = lodash_es_isEqualWith(instance.state, nextState, shallowCompare_customizer);

  return !propsEqual || !stateEqual;
};

/* harmony default export */ var util_shallowCompare = (shallowCompare_shallowCompare);
// CONCATENATED MODULE: ../node_modules/redux-form/es/createField.js
var createField__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var createField__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function createField__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function createField__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function createField__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}









var createField_createField = function createField(structure) {
  var ConnectedField = es_ConnectedField(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    createField__inherits(Field, _Component);

    function Field(props, context) {
      createField__classCallCheck(this, Field);

      var _this = createField__possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    createField__createClass(Field, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return util_shallowCompare(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = prefixName(this.context, this.props.name);
        var newName = prefixName(nextContext, nextProps.name);

        if (oldName !== newName ||
        // use deepEqual here because they could be a function or an array of functions
        !plain.deepEqual(this.props.validate, nextProps.validate) || !plain.deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        browser_default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(preact_compat_es["createElement"])(ConnectedField, createField__extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return prefixName(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(preact_compat_es["Component"]);

  Field.propTypes = {
    name: prop_types_default.a.string.isRequired,
    component: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string]).isRequired,
    format: prop_types_default.a.func,
    normalize: prop_types_default.a.func,
    onBlur: prop_types_default.a.func,
    onChange: prop_types_default.a.func,
    onFocus: prop_types_default.a.func,
    onDragStart: prop_types_default.a.func,
    onDrop: prop_types_default.a.func,
    parse: prop_types_default.a.func,
    props: prop_types_default.a.object,
    validate: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.arrayOf(prop_types_default.a.func)]),
    warn: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.arrayOf(prop_types_default.a.func)]),
    withRef: prop_types_default.a.bool
  };
  Field.contextTypes = {
    _reduxForm: prop_types_default.a.object
  };

  return Field;
};

/* harmony default export */ var es_createField = (createField_createField);
// CONCATENATED MODULE: ../node_modules/redux-form/es/Field.js



/* harmony default export */ var es_Field = (es_createField(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/ConnectedFields.js
var ConnectedFields__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var ConnectedFields__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function ConnectedFields__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function ConnectedFields__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function ConnectedFields__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function ConnectedFields__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}








var ConnectedFields_propsToNotUpdateFor = ['_reduxForm'];

var ConnectedFields_createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return plain.getIn(syncErrors, name + '._error') || plain.getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_Component) {
    ConnectedFields__inherits(ConnectedFields, _Component);

    function ConnectedFields(props) {
      ConnectedFields__classCallCheck(this, ConnectedFields);

      var _this = ConnectedFields__possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = events_onChangeValue(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));

        // call post-change callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'change');
        }
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = events_onChangeValue(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'blur');
        }
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    ConnectedFields__createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~ConnectedFields_propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return plain.setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.refs.renderedComponent;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = ConnectedFields__objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = es_createFieldProps(structure, name, ConnectedFields__extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = ConnectedFields__objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return plain.setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = ConnectedFields__objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = 'renderedComponent';
        }

        return Object(preact_compat_es["createElement"])(component, ConnectedFields__extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(preact_compat_es["Component"]);

  ConnectedFields.propTypes = {
    component: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string]).isRequired,
    _fields: prop_types_default.a.object.isRequired,
    props: prop_types_default.a.object
  };

  var connector = Object(es["b" /* connect */])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ var es_ConnectedFields = (ConnectedFields_createConnectedFields);
// CONCATENATED MODULE: ../node_modules/redux-form/es/createFields.js
var createFields__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var createFields__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function createFields__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function createFields__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function createFields__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}









var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields_createFields = function createFields(structure) {
  var ConnectedFields = es_ConnectedFields(structure);

  var Fields = function (_Component) {
    createFields__inherits(Fields, _Component);

    function Fields(props, context) {
      createFields__classCallCheck(this, Fields);

      var _this = createFields__possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    createFields__createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return util_shallowCompare(this, nextProps);
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var error = validateNameProp(this.props.names);
        if (error) {
          throw error;
        }
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!plain.deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(prefixName(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(prefixName(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(prefixName(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        browser_default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(preact_compat_es["createElement"])(ConnectedFields, createFields__extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return prefixName(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return prefixName(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(preact_compat_es["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string]).isRequired,
    format: prop_types_default.a.func,
    parse: prop_types_default.a.func,
    props: prop_types_default.a.object,
    withRef: prop_types_default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: prop_types_default.a.object
  };

  return Fields;
};

/* harmony default export */ var es_createFields = (createFields_createFields);
// CONCATENATED MODULE: ../node_modules/redux-form/es/Fields.js



/* harmony default export */ var es_Fields = (es_createFields(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_defineProperty.js


var defineProperty = function () {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

/* harmony default export */ var lodash_es__defineProperty = (defineProperty);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && lodash_es__defineProperty) {
    lodash_es__defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ var _baseAssignValue = (baseAssignValue);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_createBaseFor.js
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ var _createBaseFor = (createBaseFor);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseFor.js


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

/* harmony default export */ var _baseFor = (baseFor);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseForOwn.js



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, lodash_es_keys);
}

/* harmony default export */ var _baseForOwn = (baseForOwn);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseIsMatch.js



/** Used to compose bitmasks for value comparisons. */
var _baseIsMatch_COMPARE_PARTIAL_FLAG = 1,
    _baseIsMatch_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? _baseIsEqual(srcValue, objValue, _baseIsMatch_COMPARE_PARTIAL_FLAG | _baseIsMatch_COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ var _baseIsMatch = (baseIsMatch);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_isStrictComparable.js


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !lodash_es_isObject(value);
}

/* harmony default export */ var _isStrictComparable = (isStrictComparable);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_getMatchData.js



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = lodash_es_keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

/* harmony default export */ var _getMatchData = (getMatchData);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_matchesStrictComparable.js
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

/* harmony default export */ var _matchesStrictComparable = (matchesStrictComparable);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseMatches.js




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

/* harmony default export */ var _baseMatches = (baseMatches);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_isKey.js



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (lodash_es_isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || lodash_es_isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/* harmony default export */ var _isKey = (isKey);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_castPath.js





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (lodash_es_isArray(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(lodash_es_toString(value));
}

/* harmony default export */ var _castPath = (castPath);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseGet.js



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/* harmony default export */ var _baseGet = (baseGet);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/get.js


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get_get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ var lodash_es_get = (get_get);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseHasIn.js
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ var _baseHasIn = (baseHasIn);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_hasPath.js







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && lodash_es_isLength(length) && _isIndex(key, length) && (lodash_es_isArray(object) || lodash_es_isArguments(object));
}

/* harmony default export */ var _hasPath = (hasPath);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/hasIn.js



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

/* harmony default export */ var lodash_es_hasIn = (hasIn);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseMatchesProperty.js








/** Used to compose bitmasks for value comparisons. */
var _baseMatchesProperty_COMPARE_PARTIAL_FLAG = 1,
    _baseMatchesProperty_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function (object) {
    var objValue = lodash_es_get(object, path);
    return objValue === undefined && objValue === srcValue ? lodash_es_hasIn(object, path) : _baseIsEqual(srcValue, objValue, _baseMatchesProperty_COMPARE_PARTIAL_FLAG | _baseMatchesProperty_COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ var _baseMatchesProperty = (baseMatchesProperty);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/identity.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ var lodash_es_identity = (identity);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseProperty.js
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ var _baseProperty = (baseProperty);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_basePropertyDeep.js


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return _baseGet(object, path);
  };
}

/* harmony default export */ var _basePropertyDeep = (basePropertyDeep);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/property.js





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

/* harmony default export */ var lodash_es_property = (property);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseIteratee.js






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return lodash_es_identity;
  }
  if (typeof value == 'object') {
    return lodash_es_isArray(value) ? _baseMatchesProperty(value[0], value[1]) : _baseMatches(value);
  }
  return lodash_es_property(value);
}

/* harmony default export */ var _baseIteratee = (baseIteratee);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/mapValues.js




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee, 3);

  _baseForOwn(object, function (value, key, object) {
    _baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ var lodash_es_mapValues = (mapValues);
// EXTERNAL MODULE: ../node_modules/redux/es/index.js + 6 modules
var redux_es = __webpack_require__("fpuT");

// CONCATENATED MODULE: ../node_modules/redux-form/es/createFieldArrayProps.js
var createFieldArrayProps__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function createFieldArrayProps__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = createFieldArrayProps__objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = createFieldArrayProps__extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};

/* harmony default export */ var es_createFieldArrayProps = (createFieldArrayProps);
// CONCATENATED MODULE: ../node_modules/redux-form/es/ConnectedFieldArray.js


var ConnectedFieldArray__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function ConnectedFieldArray__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function ConnectedFieldArray__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function ConnectedFieldArray__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function ConnectedFieldArray__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}









var ConnectedFieldArray_propsToNotUpdateFor = ['_reduxForm', 'value'];

var ConnectedFieldArray_createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return plain.getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_Component) {
    ConnectedFieldArray__inherits(ConnectedFieldArray, _Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      ConnectedFieldArray__classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = ConnectedFieldArray__possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), ConnectedFieldArray__possibleConstructorReturn(_this, _ret);
    }

    ConnectedFieldArray__createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function (val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
            return val !== thisValue[index];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~ConnectedFieldArray_propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = ConnectedFieldArray__objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = es_createFieldArrayProps(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return Object(preact_compat_es["createElement"])(component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(preact_compat_es["Component"]);

  ConnectedFieldArray.propTypes = {
    component: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string]).isRequired,
    props: prop_types_default.a.object,
    rerenderOnEveryChange: prop_types_default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: prop_types_default.a.object
  };

  var connector = Object(es["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return lodash_es_mapValues({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(redux_es["b" /* bindActionCreators */])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ var es_ConnectedFieldArray = (ConnectedFieldArray_createConnectedFieldArray);
// CONCATENATED MODULE: ../node_modules/redux-form/es/createFieldArray.js
var createFieldArray__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var createFieldArray__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function createFieldArray__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function createFieldArray__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function createFieldArray__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function createFieldArray__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}







var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return createFieldArray__defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray_createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = es_ConnectedFieldArray(structure);

  var FieldArray = function (_Component) {
    createFieldArray__inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      createFieldArray__classCallCheck(this, FieldArray);

      var _this = createFieldArray__possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    createFieldArray__createClass(FieldArray, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = prefixName(this.context, this.props.name);
        var newName = prefixName(nextContext, nextProps.name);

        if (oldName !== newName) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        browser_default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(preact_compat_es["createElement"])(ConnectedFieldArray, createFieldArray__extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return prefixName(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : undefined;
      }
    }]);

    return FieldArray;
  }(preact_compat_es["Component"]);

  FieldArray.propTypes = {
    name: prop_types_default.a.string.isRequired,
    component: prop_types_default.a.func.isRequired,
    props: prop_types_default.a.object,
    validate: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.arrayOf(prop_types_default.a.func)]),
    warn: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.arrayOf(prop_types_default.a.func)]),
    withRef: prop_types_default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: prop_types_default.a.object
  };

  return FieldArray;
};

/* harmony default export */ var es_createFieldArray = (createFieldArray_createFieldArray);
// CONCATENATED MODULE: ../node_modules/redux-form/es/FieldArray.js



/* harmony default export */ var es_FieldArray = (es_createFieldArray(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/createFormValueSelector.js



var createFormValueSelector_createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    browser_default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      browser_default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : plain.setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ var es_createFormValueSelector = (createFormValueSelector_createFormValueSelector);
// CONCATENATED MODULE: ../node_modules/redux-form/es/formValueSelector.js



/* harmony default export */ var formValueSelector = (es_createFormValueSelector(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isEqual.js


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return _baseIsEqual(value, other);
}

/* harmony default export */ var lodash_es_isEqual = (isEqual);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isEmpty.js









/** `Object#toString` result references. */
var isEmpty_mapTag = '[object Map]',
    isEmpty_setTag = '[object Set]';

/** Used for built-in method references. */
var isEmpty_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isEmpty_hasOwnProperty = isEmpty_objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (lodash_es_isArrayLike(value) && (lodash_es_isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || Object(isBuffer["a" /* default */])(value) || lodash_es_isTypedArray(value) || lodash_es_isArguments(value))) {
    return !value.length;
  }
  var tag = _getTag(value);
  if (tag == isEmpty_mapTag || tag == isEmpty_setTag) {
    return !value.size;
  }
  if (_isPrototype(value)) {
    return !_baseKeys(value).length;
  }
  for (var key in value) {
    if (isEmpty_hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ var lodash_es_isEmpty = (isEmpty);
// CONCATENATED MODULE: ../node_modules/redux-form/es/createFormValues.js




var createFormValues__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var createFormValues__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function createFormValues__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function createFormValues__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function createFormValues__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function createFormValues__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function createFormValues__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}






var createFormValues_createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        createFormValues__inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          createFormValues__classCallCheck(this, FormValues);

          var _this = createFormValues__possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          _this.updateComponent(props);
          return _this;
        }

        createFormValues__createClass(FormValues, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            if (typeof firstArg === 'function') {
              this.updateComponent(props);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var Component = this.Component;

            return preact_compat_es["default"].createElement(Component
            // so that the connected component updates props when sectionPrefix has changed
            , createFormValues__extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }, {
          key: 'updateComponent',
          value: function updateComponent(props) {
            var valuesMap = void 0;
            var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
            if (typeof resolvedFirstArg === 'string') {
              valuesMap = rest.reduce(function (result, k) {
                result[k] = k;
                return result;
              }, createFormValues__defineProperty({}, resolvedFirstArg, resolvedFirstArg));
            } else {
              valuesMap = resolvedFirstArg;
            }
            if (lodash_es_isEmpty(valuesMap)) {
              // maybe that empty valuesMap is ok if firstArg is a function?
              // if this is the case, we probably should set this.Component = Component
              throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
            }
            if (lodash_es_isEqual(valuesMap, this._valuesMap)) {
              // no change in valuesMap
              return;
            }
            this._valuesMap = valuesMap;
            this.setComponent();
          }
        }, {
          key: 'setComponent',
          value: function setComponent() {
            var _this2 = this;

            var formValuesSelector = function formValuesSelector(_, _ref2) {
              var sectionPrefix = _ref2.sectionPrefix;

              // Yes, we're only using connect() for listening to updates.
              // The second argument needs to be there so that connect calls
              // the selector when props change
              var getValues = _this2.context._reduxForm.getValues;

              var values = getValues();
              return lodash_es_mapValues(_this2._valuesMap, function (path) {
                return getIn(values, prefixName(_this2.context, path));
              });
            };
            this.Component = Object(es["b" /* connect */])(formValuesSelector, function () {
              return {};
            } // ignore dispatch
            )(function (_ref3) {
              var sectionPrefix = _ref3.sectionPrefix,
                  otherProps = createFormValues__objectWithoutProperties(_ref3, ['sectionPrefix']);

              return preact_compat_es["default"].createElement(Component, otherProps);
            });
          }
        }]);

        return FormValues;
      }(preact_compat_es["default"].Component);

      FormValues.contextTypes = {
        _reduxForm: prop_types_default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ var createFormValues = (createFormValues_createValues);
// CONCATENATED MODULE: ../node_modules/redux-form/es/formValues.js



/* harmony default export */ var formValues = (createFormValues(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/getFormError.js
var createGetFormError = function createGetFormError(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.error');
    };
  };
};

/* harmony default export */ var getFormError = (createGetFormError);
// CONCATENATED MODULE: ../node_modules/redux-form/es/getFormError.js



/* harmony default export */ var es_getFormError = (getFormError(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/getFormNames.js
function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;

  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
}

/* harmony default export */ var getFormNames = (createGetFormNames);
// CONCATENATED MODULE: ../node_modules/redux-form/es/getFormNames.js



/* harmony default export */ var es_getFormNames = (getFormNames(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/getFormValues.js
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ var getFormValues = (createGetFormValues);
// CONCATENATED MODULE: ../node_modules/redux-form/es/getFormValues.js



/* harmony default export */ var es_getFormValues = (getFormValues(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/getFormInitialValues.js
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ var getFormInitialValues = (createGetFormInitialValues);
// CONCATENATED MODULE: ../node_modules/redux-form/es/getFormInitialValues.js



/* harmony default export */ var es_getFormInitialValues = (getFormInitialValues(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/getFormSyncErrors.js
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors') || empty;
    };
  };
};

/* harmony default export */ var getFormSyncErrors = (createGetFormSyncErrors);
// CONCATENATED MODULE: ../node_modules/redux-form/es/getFormSyncErrors.js



/* harmony default export */ var es_getFormSyncErrors = (getFormSyncErrors(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/getFormMeta.js
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
    };
  };
};

/* harmony default export */ var getFormMeta = (createGetFormMeta);
// CONCATENATED MODULE: ../node_modules/redux-form/es/getFormMeta.js



/* harmony default export */ var es_getFormMeta = (getFormMeta(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/getFormAsyncErrors.js
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ var getFormAsyncErrors = (createGetFormAsyncErrors);
// CONCATENATED MODULE: ../node_modules/redux-form/es/getFormAsyncErrors.js



/* harmony default export */ var es_getFormAsyncErrors = (getFormAsyncErrors(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/getFormSyncWarnings.js
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings') || empty;
    };
  };
};

/* harmony default export */ var getFormSyncWarnings = (createGetFormSyncWarnings);
// CONCATENATED MODULE: ../node_modules/redux-form/es/getFormSyncWarnings.js



/* harmony default export */ var es_getFormSyncWarnings = (getFormSyncWarnings(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/getFormSubmitErrors.js
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
    };
  };
};

/* harmony default export */ var getFormSubmitErrors = (createGetFormSubmitErrors);
// CONCATENATED MODULE: ../node_modules/redux-form/es/getFormSubmitErrors.js



/* harmony default export */ var es_getFormSubmitErrors = (getFormSubmitErrors(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/isPristine.js
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ var selectors_isPristine = (createIsPristine);
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/isDirty.js


var isDirty_createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = selectors_isPristine(structure)(form, getFormState);
    return function (state) {
      return !isPristine(state);
    };
  };
};

/* harmony default export */ var isDirty = (isDirty_createIsDirty);
// CONCATENATED MODULE: ../node_modules/redux-form/es/isDirty.js



/* harmony default export */ var es_isDirty = (isDirty(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/hasError.js


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};

var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ var es_hasError = (createHasError);
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/isValid.js


var isValid_createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = es_hasError(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ var selectors_isValid = (isValid_createIsValid);
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/isInvalid.js


var isInvalid_createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = selectors_isValid(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ var isInvalid = (isInvalid_createIsInvalid);
// CONCATENATED MODULE: ../node_modules/redux-form/es/isInvalid.js



/* harmony default export */ var es_isInvalid = (isInvalid(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/isPristine.js



/* harmony default export */ var es_isPristine = (selectors_isPristine(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/isValid.js



/* harmony default export */ var es_isValid = (selectors_isValid(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/isSubmitting.js
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ var isSubmitting = (createIsSubmitting);
// CONCATENATED MODULE: ../node_modules/redux-form/es/isSubmitting.js



/* harmony default export */ var es_isSubmitting = (isSubmitting(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/hasSubmitSucceeded.js
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ var hasSubmitSucceeded = (createHasSubmitSucceeded);
// CONCATENATED MODULE: ../node_modules/redux-form/es/hasSubmitSucceeded.js



/* harmony default export */ var es_hasSubmitSucceeded = (hasSubmitSucceeded(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/selectors/hasSubmitFailed.js
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ var hasSubmitFailed = (createHasSubmitFailed);
// CONCATENATED MODULE: ../node_modules/redux-form/es/hasSubmitFailed.js



/* harmony default export */ var es_hasSubmitFailed = (hasSubmitFailed(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_assignMergeValue.js



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if (value !== undefined && !lodash_es_eq(object[key], value) || value === undefined && !(key in object)) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignMergeValue = (assignMergeValue);
// EXTERNAL MODULE: ../node_modules/redux-form/node_modules/lodash-es/_cloneBuffer.js
var _cloneBuffer = __webpack_require__("NMNZ");

// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_cloneArrayBuffer.js


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

/* harmony default export */ var _cloneArrayBuffer = (cloneArrayBuffer);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_cloneTypedArray.js


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ var _cloneTypedArray = (cloneTypedArray);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseCreate.js


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!lodash_es_isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

/* harmony default export */ var _baseCreate = (baseCreate);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_initCloneObject.js




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !_isPrototype(object) ? _baseCreate(_getPrototype(object)) : {};
}

/* harmony default export */ var _initCloneObject = (initCloneObject);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isArrayLikeObject.js



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return lodash_es_isObjectLike(value) && lodash_es_isArrayLike(value);
}

/* harmony default export */ var lodash_es_isArrayLikeObject = (isArrayLikeObject);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var isPlainObject_objectTag = '[object Object]';

/** Used for built-in method references. */
var isPlainObject_funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var isPlainObject_funcToString = isPlainObject_funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = isPlainObject_funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != isPlainObject_objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && isPlainObject_funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_safeGet.js
/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ var _safeGet = (safeGet);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) || value === undefined && !(key in object)) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignValue = (assignValue);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_copyObject.js



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ var _copyObject = (copyObject);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_nativeKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _nativeKeysIn = (nativeKeysIn);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseKeysIn.js




/** Used for built-in method references. */
var _baseKeysIn_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeysIn_hasOwnProperty = _baseKeysIn_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!lodash_es_isObject(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !_baseKeysIn_hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeysIn = (baseKeysIn);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/keysIn.js




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

/* harmony default export */ var lodash_es_keysIn = (keysIn);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/toPlainObject.js



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, lodash_es_keysIn(value));
}

/* harmony default export */ var lodash_es_toPlainObject = (toPlainObject);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseMergeDeep.js
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = lodash_es_isArray(srcValue),
        isBuff = !isArr && Object(isBuffer["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && lodash_es_isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (lodash_es_isArray(objValue)) {
        newValue = objValue;
      } else if (lodash_es_isArrayLikeObject(objValue)) {
        newValue = _copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = Object(_cloneBuffer["a" /* default */])(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (lodash_es_isPlainObject(srcValue) || lodash_es_isArguments(srcValue)) {
      newValue = objValue;
      if (lodash_es_isArguments(objValue)) {
        newValue = lodash_es_toPlainObject(objValue);
      } else if (!lodash_es_isObject(objValue) || lodash_es_isFunction(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

/* harmony default export */ var _baseMergeDeep = (baseMergeDeep);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseMerge.js








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function (srcValue, key) {
    if (lodash_es_isObject(srcValue)) {
      stack || (stack = new _Stack());
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(_safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, lodash_es_keysIn);
}

/* harmony default export */ var _baseMerge = (baseMerge);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_apply.js
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ var _apply = (apply);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_overRest.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

/* harmony default export */ var _overRest = (overRest);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/constant.js
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

/* harmony default export */ var lodash_es_constant = (constant);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !lodash_es__defineProperty ? lodash_es_identity : function (func, string) {
  return lodash_es__defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': lodash_es_constant(string),
    'writable': true
  });
};

/* harmony default export */ var _baseSetToString = (baseSetToString);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_shortOut.js
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ var _shortOut = (shortOut);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

/* harmony default export */ var _setToString = (setToString);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_baseRest.js




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, lodash_es_identity), func + '');
}

/* harmony default export */ var _baseRest = (baseRest);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_isIterateeCall.js





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!lodash_es_isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? lodash_es_isArrayLike(object) && _isIndex(index, object.length) : type == 'string' && index in object) {
    return lodash_es_eq(object[index], value);
  }
  return false;
}

/* harmony default export */ var _isIterateeCall = (isIterateeCall);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/_createAssigner.js



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ var _createAssigner = (createAssigner);
// CONCATENATED MODULE: ../node_modules/redux-form/node_modules/lodash-es/merge.js



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function (object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

/* harmony default export */ var lodash_es_merge = (merge);
// EXTERNAL MODULE: ../node_modules/redux-form/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__("ND05");
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// EXTERNAL MODULE: ../node_modules/is-promise/index.js
var is_promise = __webpack_require__("ZcPk");
var is_promise_default = /*#__PURE__*/__webpack_require__.n(is_promise);

// CONCATENATED MODULE: ../node_modules/redux-form/es/asyncValidation.js


var asyncValidation_asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!is_promise_default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (errors && Object.keys(errors).length) {
        stop(errors);
        return errors;
      } else if (rejected) {
        stop();
        throw new Error('Asynchronous validation promise was rejected without errors.');
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ var es_asyncValidation = (asyncValidation_asyncValidation);
// CONCATENATED MODULE: ../node_modules/redux-form/es/events/silenceEvent.js


var silenceEvent_silenceEvent = function silenceEvent(event) {
  var is = events_isEvent(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ var events_silenceEvent = (silenceEvent_silenceEvent);
// CONCATENATED MODULE: ../node_modules/redux-form/es/events/silenceEvents.js


var silenceEvents_silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return events_silenceEvent(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ var events_silenceEvents = (silenceEvents_silenceEvents);
// CONCATENATED MODULE: ../node_modules/redux-form/es/generateValidator.js


var generateValidator_toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = generateValidator_toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};

var generateValidator_generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = plain.setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ var es_generateValidator = (generateValidator_generateValidator);
// CONCATENATED MODULE: ../node_modules/redux-form/es/handleSubmit.js
var handleSubmit__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function handleSubmit__toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}




var handleSubmit_handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;

  touch.apply(undefined, handleSubmit__toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof es_SubmissionError ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, handleSubmit__toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (is_promise_default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof es_SubmissionError ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, handleSubmit__toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, handleSubmit__toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, handleSubmit__toConsumableArray(fields));
    var errors = handleSubmit__extends({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};

/* harmony default export */ var es_handleSubmit = (handleSubmit_handleSubmit);
// CONCATENATED MODULE: ../node_modules/redux-form/es/util/getDisplayName.js


var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};

/* harmony default export */ var util_getDisplayName = (getDisplayName);
// EXTERNAL MODULE: ../node_modules/redux-form/es/util/isHotReloading.js
var isHotReloading = __webpack_require__("lLGk");

// CONCATENATED MODULE: ../node_modules/redux-form/es/createReduxForm.js



var createReduxForm__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var createReduxForm__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var createReduxForm__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function createReduxForm__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function createReduxForm__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function createReduxForm__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function createReduxForm__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function createReduxForm__toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function createReduxForm__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
























var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && createReduxForm__typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var createReduxForm_arrayInsert = es_actions.arrayInsert,
    createReduxForm_arrayMove = es_actions.arrayMove,
    createReduxForm_arrayPop = es_actions.arrayPop,
    createReduxForm_arrayPush = es_actions.arrayPush,
    createReduxForm_arrayRemove = es_actions.arrayRemove,
    createReduxForm_arrayRemoveAll = es_actions.arrayRemoveAll,
    createReduxForm_arrayShift = es_actions.arrayShift,
    createReduxForm_arraySplice = es_actions.arraySplice,
    createReduxForm_arraySwap = es_actions.arraySwap,
    createReduxForm_arrayUnshift = es_actions.arrayUnshift,
    createReduxForm_blur = es_actions.blur,
    createReduxForm_change = es_actions.change,
    createReduxForm_focus = es_actions.focus,
    formActions = createReduxForm__objectWithoutProperties(es_actions, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: createReduxForm_arrayInsert,
  arrayMove: createReduxForm_arrayMove,
  arrayPop: createReduxForm_arrayPop,
  arrayPush: createReduxForm_arrayPush,
  arrayRemove: createReduxForm_arrayRemove,
  arrayRemoveAll: createReduxForm_arrayRemoveAll,
  arrayShift: createReduxForm_arrayShift,
  arraySplice: createReduxForm_arraySplice,
  arraySwap: createReduxForm_arraySwap,
  arrayUnshift: createReduxForm_arrayUnshift
};

var createReduxForm_propsToNotUpdateFor = [].concat(createReduxForm__toConsumableArray(Object.keys(es_actions)), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm_createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = selectors_isValid(structure);
  return function (initialConfig) {
    var config = createReduxForm__extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: es_defaultShouldAsyncValidate,
      shouldValidate: es_defaultShouldValidate,
      shouldError: es_defaultShouldError,
      shouldWarn: es_defaultShouldWarn,
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        createReduxForm__inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          createReduxForm__classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = createReduxForm__possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;

            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  _unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                }
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? es_generateValidator(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? es_generateValidator(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value, trigger) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncChangeFields = _this$props2.asyncChangeFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;

            var submitting = !name;

            var fieldNeedsValidation = function fieldNeedsValidation() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);

              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };

            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : trigger,
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return es_asyncValidation(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            throw error;
          }, _this.listenToSubmit = function (promise) {
            if (!is_promise_default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;

            if (!submitOrEvent || events_silenceEvent(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(es_handleSubmit(checkSubmit(onSubmit), createReduxForm__extends({}, _this.props, Object(redux_es["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return events_silenceEvents(function () {
                return !_this.submitPromise && _this.listenToSubmit(es_handleSubmit(checkSubmit(submitOrEvent), createReduxForm__extends({}, _this.props, Object(redux_es["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _temp), createReduxForm__possibleConstructorReturn(_this, _ret);
        }

        createReduxForm__createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: createReduxForm__extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: nextProps.updateUnregisteredFields
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                updateUnregisteredFields: this.props.updateUnregisteredFields
              });
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!plain.deepEqual(lastSyncErrors, nextSyncErrors) || !plain.deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'shouldErrorFunction',
          value: function shouldErrorFunction() {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                shouldError = _props3.shouldError;

            var shouldValidateOverridden = shouldValidate !== es_defaultShouldValidate;
            var shouldErrorOverridden = shouldError !== es_defaultShouldError;

            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props4 = this.props,
                validate = _props4.validate,
                values = _props4.values;

            var shouldError = this.shouldErrorFunction();
            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              };

              if (shouldError(validateParams)) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = lodash_es_merge(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = createReduxForm__objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            } else {
              this.lastFieldValidatorKeys = [];
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props5 = this.props,
                warning = _props5.warning,
                syncWarnings = _props5.syncWarnings,
                updateSyncWarnings = _props5.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!plain.deepEqual(lastSyncWarnings, nextSyncWarnings) || !plain.deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'shouldWarnFunction',
          value: function shouldWarnFunction() {
            var _props6 = this.props,
                shouldValidate = _props6.shouldValidate,
                shouldWarn = _props6.shouldWarn;

            var shouldValidateOverridden = shouldValidate !== es_defaultShouldValidate;
            var shouldWarnOverridden = shouldWarn !== es_defaultShouldWarn;

            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props7 = this.props,
                warn = _props7.warn,
                values = _props7.values;

            var shouldWarn = this.shouldWarnFunction();
            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              };

              if (shouldWarn(validateParams)) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = lodash_es_merge(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = createReduxForm__objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!Object(isHotReloading["a" /* default */])()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            browser_default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
            // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608

            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~createReduxForm_propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!Object(isHotReloading["a" /* default */])()) {
              this.initIfNeeded(this.props);
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            browser_default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props8 = this.props,
                destroyOnUnmount = _props8.destroyOnUnmount,
                destroy = _props8.destroy;

            if (destroyOnUnmount && !Object(isHotReloading["a" /* default */])()) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props9 = this.props,
                anyTouched = _props9.anyTouched,
                array = _props9.array,
                arrayInsert = _props9.arrayInsert,
                arrayMove = _props9.arrayMove,
                arrayPop = _props9.arrayPop,
                arrayPush = _props9.arrayPush,
                arrayRemove = _props9.arrayRemove,
                arrayRemoveAll = _props9.arrayRemoveAll,
                arrayShift = _props9.arrayShift,
                arraySplice = _props9.arraySplice,
                arraySwap = _props9.arraySwap,
                arrayUnshift = _props9.arrayUnshift,
                asyncErrors = _props9.asyncErrors,
                asyncValidate = _props9.asyncValidate,
                asyncValidating = _props9.asyncValidating,
                blur = _props9.blur,
                change = _props9.change,
                clearSubmit = _props9.clearSubmit,
                destroy = _props9.destroy,
                destroyOnUnmount = _props9.destroyOnUnmount,
                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
                dirty = _props9.dirty,
                dispatch = _props9.dispatch,
                enableReinitialize = _props9.enableReinitialize,
                error = _props9.error,
                focus = _props9.focus,
                form = _props9.form,
                getFormState = _props9.getFormState,
                initialize = _props9.initialize,
                initialized = _props9.initialized,
                initialValues = _props9.initialValues,
                invalid = _props9.invalid,
                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
                updateUnregisteredFields = _props9.updateUnregisteredFields,
                pristine = _props9.pristine,
                propNamespace = _props9.propNamespace,
                registeredFields = _props9.registeredFields,
                registerField = _props9.registerField,
                reset = _props9.reset,
                resetSection = _props9.resetSection,
                setSubmitFailed = _props9.setSubmitFailed,
                setSubmitSucceeded = _props9.setSubmitSucceeded,
                shouldAsyncValidate = _props9.shouldAsyncValidate,
                shouldValidate = _props9.shouldValidate,
                shouldError = _props9.shouldError,
                shouldWarn = _props9.shouldWarn,
                startAsyncValidation = _props9.startAsyncValidation,
                startSubmit = _props9.startSubmit,
                stopAsyncValidation = _props9.stopAsyncValidation,
                stopSubmit = _props9.stopSubmit,
                submitting = _props9.submitting,
                submitFailed = _props9.submitFailed,
                submitSucceeded = _props9.submitSucceeded,
                touch = _props9.touch,
                touchOnBlur = _props9.touchOnBlur,
                touchOnChange = _props9.touchOnChange,
                persistentSubmitErrors = _props9.persistentSubmitErrors,
                syncErrors = _props9.syncErrors,
                syncWarnings = _props9.syncWarnings,
                unregisterField = _props9.unregisterField,
                untouch = _props9.untouch,
                updateSyncErrors = _props9.updateSyncErrors,
                updateSyncWarnings = _props9.updateSyncWarnings,
                valid = _props9.valid,
                validExceptSubmit = _props9.validExceptSubmit,
                values = _props9.values,
                warning = _props9.warning,
                rest = createReduxForm__objectWithoutProperties(_props9, ['anyTouched', 'array', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'updateUnregisteredFields', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'resetSection', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */

            var reduxFormProps = createReduxForm__extends({
              array: array,
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(redux_es["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              resetSection: resetSection,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = createReduxForm__extends({}, propNamespace ? createReduxForm__defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              propsToPass.ref = 'wrapped';
            }
            return Object(preact_compat_es["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(preact_compat_es["Component"]);

      Form.displayName = 'Form(' + util_getDisplayName(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: prop_types_default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: prop_types_default.a.bool,
        forceUnregisterOnUnmount: prop_types_default.a.bool,
        form: prop_types_default.a.string.isRequired,
        initialValues: prop_types_default.a.oneOfType([prop_types_default.a.array, prop_types_default.a.object]),
        getFormState: prop_types_default.a.func,
        onSubmitFail: prop_types_default.a.func,
        onSubmitSuccess: prop_types_default.a.func,
        propNamespace: prop_types_default.a.string,
        validate: prop_types_default.a.func,
        warn: prop_types_default.a.func,
        touchOnBlur: prop_types_default.a.bool,
        touchOnChange: prop_types_default.a.bool,
        triggerSubmit: prop_types_default.a.bool,
        persistentSubmitErrors: prop_types_default.a.bool,
        registeredFields: prop_types_default.a.any
      };

      var connector = Object(es["b" /* connect */])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || {};
        var syncWarnings = getIn(formState, 'syncWarnings') || {};
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = lodash_es_mapValues(formActions, bindForm);
        var boundArrayACs = lodash_es_mapValues(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return createReduxForm_blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return createReduxForm_change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(createReduxForm_focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(redux_es["b" /* bindActionCreators */])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(redux_es["b" /* bindActionCreators */])(boundArrayACs.arrayInsert, dispatch),
          move: Object(redux_es["b" /* bindActionCreators */])(boundArrayACs.arrayMove, dispatch),
          pop: Object(redux_es["b" /* bindActionCreators */])(boundArrayACs.arrayPop, dispatch),
          push: Object(redux_es["b" /* bindActionCreators */])(boundArrayACs.arrayPush, dispatch),
          remove: Object(redux_es["b" /* bindActionCreators */])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(redux_es["b" /* bindActionCreators */])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(redux_es["b" /* bindActionCreators */])(boundArrayACs.arrayShift, dispatch),
          splice: Object(redux_es["b" /* bindActionCreators */])(boundArrayACs.arraySplice, dispatch),
          swap: Object(redux_es["b" /* bindActionCreators */])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(redux_es["b" /* bindActionCreators */])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = createReduxForm__extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = hoist_non_react_statics_cjs_default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api

      var ReduxForm = function (_Component2) {
        createReduxForm__inherits(ReduxForm, _Component2);

        function ReduxForm() {
          createReduxForm__classCallCheck(this, ReduxForm);

          return createReduxForm__possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        createReduxForm__createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this5 = this;

            var _props10 = this.props,
                initialValues = _props10.initialValues,
                rest = createReduxForm__objectWithoutProperties(_props10, ['initialValues']);

            return Object(preact_compat_es["createElement"])(ConnectedForm, createReduxForm__extends({}, rest, {
              ref: function ref(_ref3) {
                return _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.ref && this.ref.getWrappedInstance().refs.wrapped;
          }
        }]);

        return ReduxForm;
      }(preact_compat_es["Component"]);

      return hoist_non_react_statics_cjs_default()(ReduxForm, WrappedComponent);
    };
  };
};

/* harmony default export */ var es_createReduxForm = (createReduxForm_createReduxForm);
// CONCATENATED MODULE: ../node_modules/redux-form/es/reduxForm.js



/* harmony default export */ var reduxForm = (es_createReduxForm(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/deleteInWithCleanUp.js


function createDeleteInWithCleanUp(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn,
      deleteIn = _ref.deleteIn,
      setIn = _ref.setIn;

  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
    if (path[path.length - 1] === ']') {
      // array path
      var pathTokens = lodash_es_toPath(path);
      pathTokens.pop();
      var parent = getIn(state, pathTokens.join('.'));
      return parent ? setIn(state, path) : state;
    }

    var result = state;
    if (getIn(state, path) !== undefined) {
      result = deleteIn(state, path);
    }

    var dotIndex = path.lastIndexOf('.');
    if (dotIndex > 0) {
      var parentPath = path.substring(0, dotIndex);
      if (parentPath[parentPath.length - 1] !== ']') {
        var _parent = getIn(result, parentPath);
        if (deepEqual(_parent, empty)) {
          return deleteInWithCleanUp(result, parentPath);
        }
      }
    }
    return result;
  };

  return deleteInWithCleanUp;
}

/* harmony default export */ var es_deleteInWithCleanUp = (createDeleteInWithCleanUp);
// CONCATENATED MODULE: ../node_modules/redux-form/es/createReducer.js
function createReducer__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function createReducer__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}





var createReducer_isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > prefix.length && action.type.substring(0, prefix.length) === prefix;
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = es_deleteInWithCleanUp(structure);
  var plainDeleteInWithCleanUp = es_deleteInWithCleanUp(plain);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = plain.getIn(slice, field);
    return existing || force ? setIn(state, key, plain.setIn(slice, field, plain.splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, createReducer__defineProperty(_behaviors, ARRAY_INSERT, function (state, _ref) {
    var _ref$meta = _ref.meta,
        field = _ref$meta.field,
        index = _ref$meta.index,
        payload = _ref.payload;

    return arraySplice(state, field, index, 0, payload);
  }), createReducer__defineProperty(_behaviors, ARRAY_MOVE, function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        from = _ref2$meta.from,
        to = _ref2$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), createReducer__defineProperty(_behaviors, ARRAY_POP, function (state, _ref3) {
    var field = _ref3.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), createReducer__defineProperty(_behaviors, ARRAY_PUSH, function (state, _ref4) {
    var field = _ref4.meta.field,
        payload = _ref4.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), createReducer__defineProperty(_behaviors, ARRAY_REMOVE, function (state, _ref5) {
    var _ref5$meta = _ref5.meta,
        field = _ref5$meta.field,
        index = _ref5$meta.index;

    return arraySplice(state, field, index, 1);
  }), createReducer__defineProperty(_behaviors, ARRAY_REMOVE_ALL, function (state, _ref6) {
    var field = _ref6.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), createReducer__defineProperty(_behaviors, ARRAY_SHIFT, function (state, _ref7) {
    var field = _ref7.meta.field;

    return arraySplice(state, field, 0, 1);
  }), createReducer__defineProperty(_behaviors, ARRAY_SPLICE, function (state, _ref8) {
    var _ref8$meta = _ref8.meta,
        field = _ref8$meta.field,
        index = _ref8$meta.index,
        removeNum = _ref8$meta.removeNum,
        payload = _ref8.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), createReducer__defineProperty(_behaviors, ARRAY_SWAP, function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        indexA = _ref9$meta.indexA,
        indexB = _ref9$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), createReducer__defineProperty(_behaviors, ARRAY_UNSHIFT, function (state, _ref10) {
    var field = _ref10.meta.field,
        payload = _ref10.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), createReducer__defineProperty(_behaviors, AUTOFILL, function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), createReducer__defineProperty(_behaviors, BLUR, function (state, _ref12) {
    var _ref12$meta = _ref12.meta,
        field = _ref12$meta.field,
        touch = _ref12$meta.touch,
        payload = _ref12.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), createReducer__defineProperty(_behaviors, CHANGE, function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), createReducer__defineProperty(_behaviors, CLEAR_SUBMIT, function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), createReducer__defineProperty(_behaviors, CLEAR_SUBMIT_ERRORS, function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), createReducer__defineProperty(_behaviors, CLEAR_ASYNC_ERROR, function (state, _ref14) {
    var field = _ref14.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), createReducer__defineProperty(_behaviors, CLEAR_FIELDS, function (state, _ref15) {
    var _ref15$meta = _ref15.meta,
        keepTouched = _ref15$meta.keepTouched,
        persistentSubmitErrors = _ref15$meta.persistentSubmitErrors,
        fields = _ref15$meta.fields;

    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, 'values.' + field);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, 'submitErrors.' + field);
      }
      result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
      if (!keepTouched) {
        result = deleteIn(result, 'fields.' + field + '.touched');
      }
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), createReducer__defineProperty(_behaviors, FOCUS, function (state, _ref16) {
    var field = _ref16.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), createReducer__defineProperty(_behaviors, INITIALIZE, function (state, _ref17) {
    var payload = _ref17.payload,
        _ref17$meta = _ref17.meta,
        keepDirty = _ref17$meta.keepDirty,
        keepSubmitSucceeded = _ref17$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref17$meta.updateUnregisteredFields,
        keepValues = _ref17$meta.keepValues;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');

    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);

        newValues = setIn(newValues, name, previousValue);
      });

      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);

        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), createReducer__defineProperty(_behaviors, REGISTER_FIELD, function (state, _ref18) {
    var _ref18$payload = _ref18.payload,
        name = _ref18$payload.name,
        type = _ref18$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), createReducer__defineProperty(_behaviors, RESET, function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), createReducer__defineProperty(_behaviors, RESET_SECTION, function (state, _ref19) {
    var sections = _ref19.meta.sections;

    var result = state;

    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, 'asyncErrors.' + section);
      result = deleteInWithCleanUp(result, 'submitErrors.' + section);
      result = deleteInWithCleanUp(result, 'fields.' + section);

      var values = getIn(state, 'initial.' + section);
      result = values ? setIn(result, 'values.' + section, values) : deleteInWithCleanUp(result, 'values.' + section);
    });

    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');

    return result;
  }), createReducer__defineProperty(_behaviors, SUBMIT, function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), createReducer__defineProperty(_behaviors, START_ASYNC_VALIDATION, function (state, _ref20) {
    var field = _ref20.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), createReducer__defineProperty(_behaviors, START_SUBMIT, function (state) {
    return setIn(state, 'submitting', true);
  }), createReducer__defineProperty(_behaviors, STOP_ASYNC_VALIDATION, function (state, _ref21) {
    var payload = _ref21.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = createReducer__objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }
    return result;
  }), createReducer__defineProperty(_behaviors, STOP_SUBMIT, function (state, _ref22) {
    var payload = _ref22.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = createReducer__objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), createReducer__defineProperty(_behaviors, SET_SUBMIT_FAILED, function (state, _ref23) {
    var fields = _ref23.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), createReducer__defineProperty(_behaviors, SET_SUBMIT_SUCCEEDED, function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), createReducer__defineProperty(_behaviors, TOUCH, function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), createReducer__defineProperty(_behaviors, UNREGISTER_FIELD, function (state, _ref25) {
    var _ref25$payload = _ref25.payload,
        name = _ref25$payload.name,
        destroyOnUnmount = _ref25$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (plain.deepEqual(syncErrors, plain.empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (plain.deepEqual(syncWarnings, plain.empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), createReducer__defineProperty(_behaviors, UNTOUCH, function (state, _ref26) {
    var fields = _ref26.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), createReducer__defineProperty(_behaviors, UPDATE_SYNC_ERRORS, function (state, _ref27) {
    var _ref27$payload = _ref27.payload,
        syncErrors = _ref27$payload.syncErrors,
        error = _ref27$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), createReducer__defineProperty(_behaviors, UPDATE_SYNC_WARNINGS, function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncWarnings = _ref28$payload.syncWarnings,
        warning = _ref28$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !createReducer_isReduxFormAction(action)) {
        return state;
      }
      if (action.type === DESTROY && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function (reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer
        var form = action && action.meta && action.meta.form;

        if (form) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ var es_createReducer = (createReducer);
// CONCATENATED MODULE: ../node_modules/redux-form/es/reducer.js



/* harmony default export */ var es_reducer = (es_createReducer(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/createValues.js
var createValues__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function createValues__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}



var createValues_createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = createValues__extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(es["b" /* connect */])(function (state) {
      return createValues__defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ var es_createValues = (createValues_createValues);
// CONCATENATED MODULE: ../node_modules/redux-form/es/values.js



/* harmony default export */ var es_values = (es_createValues(plain));
// CONCATENATED MODULE: ../node_modules/redux-form/es/index.js
/* unused harmony export actionTypes */
/* unused harmony export arrayInsert */
/* unused harmony export arrayMove */
/* unused harmony export arrayPop */
/* unused harmony export arrayPush */
/* unused harmony export arrayRemove */
/* unused harmony export arrayRemoveAll */
/* unused harmony export arrayShift */
/* unused harmony export arraySplice */
/* unused harmony export arraySwap */
/* unused harmony export arrayUnshift */
/* unused harmony export autofill */
/* unused harmony export blur */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return es_change; });
/* unused harmony export clearAsyncError */
/* unused harmony export clearFields */
/* unused harmony export clearSubmitErrors */
/* unused harmony export destroy */
/* unused harmony export focus */
/* unused harmony export initialize */
/* unused harmony export registerField */
/* unused harmony export reset */
/* unused harmony export resetSection */
/* unused harmony export setSubmitFailed */
/* unused harmony export setSubmitSucceeded */
/* unused harmony export startAsyncValidation */
/* unused harmony export startSubmit */
/* unused harmony export stopAsyncValidation */
/* unused harmony export stopSubmit */
/* unused harmony export submit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return es_touch; });
/* unused harmony export unregisterField */
/* unused harmony export untouch */
/* unused harmony export updateSyncWarnings */
/* unused concated harmony import defaultShouldAsyncValidate */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_defaultShouldAsyncValidate; });
/* unused concated harmony import defaultShouldValidate */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_defaultShouldValidate; });
/* unused concated harmony import defaultShouldError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_defaultShouldError; });
/* unused concated harmony import defaultShouldWarn */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_defaultShouldWarn; });
/* unused concated harmony import Form */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_Form; });
/* unused concated harmony import FormSection */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_FormSection; });
/* unused concated harmony import SubmissionError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_SubmissionError; });
/* unused concated harmony import propTypes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return propTypes; });
/* unused concated harmony import fieldInputPropTypes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fieldInputPropTypes; });
/* unused concated harmony import fieldMetaPropTypes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fieldMetaPropTypes; });
/* unused concated harmony import fieldPropTypes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fieldPropTypes; });
/* unused concated harmony import fieldArrayFieldsPropTypes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fieldArrayFieldsPropTypes; });
/* unused concated harmony import fieldArrayMetaPropTypes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fieldArrayMetaPropTypes; });
/* unused concated harmony import fieldArrayPropTypes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fieldArrayPropTypes; });
/* unused concated harmony import formPropTypes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formPropTypes; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return es_Field; });
/* unused concated harmony import Fields */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_Fields; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return es_FieldArray; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return formValueSelector; });
/* unused concated harmony import formValues */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formValues; });
/* unused concated harmony import getFormError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_getFormError; });
/* unused concated harmony import getFormNames */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_getFormNames; });
/* unused concated harmony import getFormValues */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_getFormValues; });
/* unused concated harmony import getFormInitialValues */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_getFormInitialValues; });
/* unused concated harmony import getFormSyncErrors */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_getFormSyncErrors; });
/* unused concated harmony import getFormMeta */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_getFormMeta; });
/* unused concated harmony import getFormAsyncErrors */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_getFormAsyncErrors; });
/* unused concated harmony import getFormSyncWarnings */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_getFormSyncWarnings; });
/* unused concated harmony import getFormSubmitErrors */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_getFormSubmitErrors; });
/* unused concated harmony import isDirty */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_isDirty; });
/* unused concated harmony import isInvalid */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_isInvalid; });
/* unused concated harmony import isPristine */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_isPristine; });
/* unused concated harmony import isValid */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_isValid; });
/* unused concated harmony import isSubmitting */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_isSubmitting; });
/* unused concated harmony import hasSubmitSucceeded */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_hasSubmitSucceeded; });
/* unused concated harmony import hasSubmitFailed */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_hasSubmitFailed; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return reduxForm; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return es_reducer; });
/* unused concated harmony import values */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_values; });









// alias for propTypes

























var actionTypes = actionTypes_namespaceObject;
var es_arrayInsert = es_actions.arrayInsert;
var es_arrayMove = es_actions.arrayMove;
var es_arrayPop = es_actions.arrayPop;
var es_arrayPush = es_actions.arrayPush;
var es_arrayRemove = es_actions.arrayRemove;
var es_arrayRemoveAll = es_actions.arrayRemoveAll;
var es_arrayShift = es_actions.arrayShift;
var es_arraySplice = es_actions.arraySplice;
var es_arraySwap = es_actions.arraySwap;
var es_arrayUnshift = es_actions.arrayUnshift;
var es_autofill = es_actions.autofill;
var es_blur = es_actions.blur;
var es_change = es_actions.change;
var es_clearAsyncError = es_actions.clearAsyncError;
var es_clearFields = es_actions.clearFields;
var es_clearSubmitErrors = es_actions.clearSubmitErrors;
var es_destroy = es_actions.destroy;
var es_focus = es_actions.focus;
var es_initialize = es_actions.initialize;
var es_registerField = es_actions.registerField;
var es_reset = es_actions.reset;
var es_resetSection = es_actions.resetSection;
var es_setSubmitFailed = es_actions.setSubmitFailed;
var es_setSubmitSucceeded = es_actions.setSubmitSucceeded;
var es_startAsyncValidation = es_actions.startAsyncValidation;
var es_startSubmit = es_actions.startSubmit;
var es_stopAsyncValidation = es_actions.stopAsyncValidation;
var es_stopSubmit = es_actions.stopSubmit;
var es_submit = es_actions.submit;
var es_touch = es_actions.touch;
var es_unregisterField = es_actions.unregisterField;
var es_untouch = es_actions.untouch;
var es_updateSyncWarnings = es_actions.updateSyncWarnings;

/***/ }),

/***/ "BXyq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var normalizeHeaderName = __webpack_require__("M8l6");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  // Only Node.JS has a process variable that is of [[Class]] process
  if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("KRuG");
  } else if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("KRuG");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/***/ }),

/***/ "BmeC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b7b15692ac40fd729adeed910ccc89b0.svg";

/***/ }),

/***/ "C1th":
/***/ (function(module, exports) {

var STREET_NUMBER = ["street_number", "premise"];
var STREET = ["route", "sublocality"];
var STREET2 = ["sublocality_level_1"];
var STREET3 = ["sublocality_level_2", "sublocality_level_3", "sublocality_level_4", "sublocality_level_5"];
var SUBURB = "locality";
var CITY = "administrative_area_level_2";
var STATE = "administrative_area_level_1";
var COUNTRY = "country";
var POSTCODE = "postal_code";
var UNKNOWN = "";

var getSuburb = function getSuburb(addressComponents) {
  var result = UNKNOWN;
  if (addressComponents && addressComponents.length) {
    result = addressComponents.find(function (address) {
      return address.types.find(function (type) {
        return type === SUBURB;
      });
    });
    result = result && result.short_name ? result.short_name : result;
  }
  return result;
};

var getCity = function getCity(addressComponents) {
  var result = UNKNOWN;
  if (addressComponents && addressComponents.length) {
    result = addressComponents.find(function (address) {
      return address.types.find(function (type) {
        return type === CITY;
      });
    });
    result = result && result.short_name ? result.short_name : result;
  }
  return result;
};

var getState = function getState(addressComponents) {
  var result = UNKNOWN;
  if (addressComponents && addressComponents.length) {
    result = addressComponents.find(function (address) {
      return address.types.find(function (type) {
        return type === STATE;
      });
    });
    result = result && result.short_name ? result.short_name : result;
  }
  return result;
};

var getCountry = function getCountry(addressComponents) {
  var result = UNKNOWN;
  if (addressComponents && addressComponents.length) {
    result = addressComponents.find(function (address) {
      return address.types.find(function (type) {
        return type === COUNTRY;
      });
    });
    result = result && result.short_name ? result.short_name : result;
  }
  return result;
};

var getPostalCode = function getPostalCode(addressComponents) {
  var result = UNKNOWN;
  if (addressComponents && addressComponents.length) {
    result = addressComponents.find(function (address) {
      return address.types.find(function (type) {
        return type === POSTCODE;
      });
    });
    result = result && result.short_name ? result.short_name : result;
  }
  return result;
};

module.exports = { getSuburb: getSuburb, getCity: getCity, getState: getState, getCountry: getCountry, getPostalCode: getPostalCode };

/***/ }),

/***/ "CLzQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f195a867bddfaf902336603f4e522232.svg";

/***/ }),

/***/ "ClQe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * @class
 * @memberof PIXI
 */
var WebGLManager = function () {
  /**
   * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
   */
  function WebGLManager(renderer) {
    _classCallCheck(this, WebGLManager);

    /**
     * The renderer this manager works for.
     *
     * @member {PIXI.WebGLRenderer}
     */
    this.renderer = renderer;

    this.renderer.on('context', this.onContextChange, this);
  }

  /**
   * Generic method called when there is a WebGL context change.
   *
   */

  WebGLManager.prototype.onContextChange = function onContextChange() {}
  // do some codes init!


  /**
   * Generic destroy methods to be overridden by the subclass
   *
   */
  ;

  WebGLManager.prototype.destroy = function destroy() {
    this.renderer.off('context', this.onContextChange, this);

    this.renderer = null;
  };

  return WebGLManager;
}();

exports.default = WebGLManager;
//# sourceMappingURL=WebGLManager.js.map

/***/ }),

/***/ "CuFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var Description = function Description(_ref) {
  var description = _ref.description;

  return description ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "p",
    { style: { fontSize: 14, color: "#5a626c", marginBottom: 8 } },
    description
  ) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (Description);

/***/ }),

/***/ "D4Hc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c6583ecabf79d03926b33f5a4134a481.svg";

/***/ }),

/***/ "DI0o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createIndicesForQuads;
/**
 * Generic Mask Stack data structure
 *
 * @memberof PIXI
 * @function createIndicesForQuads
 * @private
 * @param {number} size - Number of quads
 * @return {Uint16Array} indices
 */
function createIndicesForQuads(size) {
    // the total number of indices in our array, there are 6 points per quad.

    var totalIndices = size * 6;

    var indices = new Uint16Array(totalIndices);

    // fill the indices with the quads to draw
    for (var i = 0, j = 0; i < totalIndices; i += 6, j += 4) {
        indices[i + 0] = j + 0;
        indices[i + 1] = j + 1;
        indices[i + 2] = j + 2;
        indices[i + 3] = j + 0;
        indices[i + 4] = j + 2;
        indices[i + 5] = j + 3;
    }

    return indices;
}
//# sourceMappingURL=createIndicesForQuads.js.map

/***/ }),

/***/ "DMyS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b2e1b728d2cb08e2e354a1788bf2bf67.svg";

/***/ }),

/***/ "DpAE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("Ywoo");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateUtils = __webpack_require__("s8Q5");

var _Helpers = __webpack_require__("2M8e");

var _classNames = __webpack_require__("ESgF");

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;

      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = _extends({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement('div', {
        className: className,
        tabIndex: tabIndex,
        style: style,
        role: 'gridcell',
        'aria-label': ariaLabel,
        'aria-disabled': ariaDisabled,
        'aria-selected': ariaSelected,
        onClick: handleEvent(onClick, day, modifiers),
        onKeyDown: handleEvent(onKeyDown, day, modifiers),
        onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
        onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
        onMouseUp: handleEvent(onMouseUp, day, modifiers),
        onMouseDown: handleEvent(onMouseDown, day, modifiers),
        onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
        onTouchStart: handleEvent(onTouchStart, day, modifiers),
        onFocus: handleEvent(onFocus, day, modifiers)
      }, children);
    }
  }]);

  return Day;
}(_react.Component);

Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;
Day.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    day: _propTypes2.default.string.isRequired
  }).isRequired,

  day: _propTypes2.default.instanceOf(Date).isRequired,
  children: _propTypes2.default.node.isRequired,

  ariaDisabled: _propTypes2.default.bool,
  ariaLabel: _propTypes2.default.string,
  ariaSelected: _propTypes2.default.bool,
  empty: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
} : {};
//# sourceMappingURL=Day.js.map

/***/ }),

/***/ "DqsF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.autoDetectRenderer = autoDetectRenderer;

var _utils = __webpack_require__("dDI1");

var utils = _interopRequireWildcard(_utils);

var _CanvasRenderer = __webpack_require__("GzOR");

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _WebGLRenderer = __webpack_require__("i77b");

var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

// eslint-disable-next-line valid-jsdoc
/**
 * This helper function will automatically detect which renderer you should be using.
 * WebGL is the preferred renderer as it is a lot faster. If webGL is not supported by
 * the browser then this function will return a canvas renderer
 *
 * @memberof PIXI
 * @function autoDetectRenderer
 * @param {object} [options] - The optional renderer parameters
 * @param {number} [options.width=800] - the width of the renderers view
 * @param {number} [options.height=600] - the height of the renderers view
 * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
 * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
 * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
 * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
 *  need to call toDataUrl on the webgl context
 * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
 *  (shown if not transparent).
 * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
 *   not before the new render pass.
 * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
 * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present
 * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
 *  stopping pixel interpolation.
 * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
 *  FXAA is faster, but may not always look as great **webgl only**
 * @param {boolean} [options.legacy=false] - `true` to ensure compatibility with older / less advanced devices.
 *  If you experience unexplained flickering try setting this to true. **webgl only**
 * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
 *  for devices with dual graphics card **webgl only**
 * @return {PIXI.WebGLRenderer|PIXI.CanvasRenderer} Returns WebGL renderer if available, otherwise CanvasRenderer
 */
function autoDetectRenderer(options, arg1, arg2, arg3) {
    // Backward-compatible support for noWebGL option
    var forceCanvas = options && options.forceCanvas;

    if (arg3 !== undefined) {
        forceCanvas = arg3;
    }

    if (!forceCanvas && utils.isWebGLSupported()) {
        return new _WebGLRenderer2.default(options, arg1, arg2);
    }

    return new _CanvasRenderer2.default(options, arg1, arg2);
}
//# sourceMappingURL=autoDetectRenderer.js.map

/***/ }),

/***/ "E70C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_SUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_SUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SUMMARY_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadSummary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_OrderService__ = __webpack_require__("l/4+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers__ = __webpack_require__("6orE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_normaliseMerchandiseData__ = __webpack_require__("awkt");




var GET_SUMMARY_REQUEST = "GET_SUMMARY_REQUEST";
var GET_SUMMARY_SUCCESS = "GET_SUMMARY_SUCCESS";
var GET_SUMMARY_ERROR = "GET_SUMMARY_ERROR";

var loadSummary = function loadSummary(id, requestedTickets, clientDonation, order, merch, giftCard) {
  var isEventId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;

  var normalisedMerchData = void 0;
  if (merch) {
    normalisedMerchData = Object(__WEBPACK_IMPORTED_MODULE_3__utils_normaliseMerchandiseData__["a" /* default */])(merch);
  }
  return function (dispatch) {
    dispatch({ type: GET_SUMMARY_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].summary(id, requestedTickets, clientDonation, order, normalisedMerchData, giftCard, isEventId).then(function (result) {
      dispatch({
        type: GET_SUMMARY_SUCCESS,
        summary: result,
        tickets: result.tickets
      });
    }).catch(function (err) {
      dispatch({ type: GET_SUMMARY_ERROR, error: "Summary failed to load" });
    });
  };
};

/***/ }),

/***/ "EA1K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Config_1 = __webpack_require__("gH/r");
var Section_1 = __webpack_require__("ZfHd");
var Selector_1 = __webpack_require__("8Y7Z");
var KeyboardManager_1 = __webpack_require__("wqtJ");
var InteractionManager_1 = __webpack_require__("dUAP");
var SelectionListener_1 = __webpack_require__("//Eg");
var GeneralObject_1 = __webpack_require__("Gv70");
var bound_1 = __webpack_require__("USDo");
var ActionTracker_1 = __webpack_require__("h0Oq");

var SeatingConstruction = function () {
    function SeatingConstruction(_ref, actions) {
        var _this = this;

        var sections = _ref.sections,
            _ref$objects = _ref.objects,
            objects = _ref$objects === undefined ? [] : _ref$objects;

        _classCallCheck(this, SeatingConstruction);

        this.actions = actions;
        this.mouseX = 0;
        this.mouseY = 0;
        this.interactionManager = InteractionManager_1.default.createInteractionManager();
        this.sections = sections.map(function (section) {
            if (section.tables && section.tables.length > 0) {
                return section;
            }
        }).filter(function (section) {
            return section;
        }).map(function (section, i) {
            section.sectionId = i;
            section.showSection = sections.length > 1;
            return new Section_1.default(section, _this.actions);
        });
        this.ticketMappingCount = this.sections.map(function (section) {
            return section.countTicketMappings();
        }).reduce(function (total, ticketMapping) {
            for (var key in ticketMapping) {
                if (total[key]) {
                    total[key] = total[key] + ticketMapping[key];
                } else {
                    total[key] = ticketMapping[key];
                }
            }
            return total;
        }, {});
        this.capacity = this.sections.map(function (section) {
            return section.getSectionCapacity();
        }).reduce(function (total, current) {
            return total + current;
        }, 0);
        this.objects = objects.map(function (object, i) {
            object.objectId = i;
            return new GeneralObject_1.default(object, _this.actions, false);
        });
        this.seatingConstructionContainer = new PIXI.Container();
        this.sectionContainer = new PIXI.Container();
        this.sections.forEach(function (section) {
            return _this.sectionContainer.addChild(section.getSectionContainer());
        });
        this.objectContainer = new PIXI.Container();
        this.objects.forEach(function (object) {
            return _this.objectContainer.addChild(object.getContainer());
        });
        this.seatingConstructionContainer.addChild(this.sectionContainer);
        this.seatingConstructionContainer.addChild(this.objectContainer);
        this.keyboardManager = new KeyboardManager_1.default();
        Config_1.default.viewport.on("clicked", function (screen, world) {
            if (SelectionListener_1.default.clickWasOnElement) {
                SelectionListener_1.default.clickWasOnElement = false;
            } else {
                _this.unselect();
            }
        });
    }

    SeatingConstruction.createSeatingConstructionView = function createSeatingConstructionView(seatingMapData, actions) {
        if (!SeatingConstruction.initialised) {
            SeatingConstruction.instance;
            SeatingConstruction.initialised = true;
            SeatingConstruction.instance = new SeatingConstruction(seatingMapData, actions);
        }
        return SeatingConstruction.instance;
    };

    SeatingConstruction.getInstance = function getInstance() {
        return SeatingConstruction.instance;
    };

    SeatingConstruction.prototype.changeTicketMappingCount = function changeTicketMappingCount(ticketId, amount) {
        this.ticketMappingCount[ticketId] = this.ticketMappingCount[ticketId] + amount;
    };

    SeatingConstruction.prototype.showSections = function showSections() {
        return SeatingConstruction.instance.sections.length > 1;
    };

    SeatingConstruction.prototype.listenForSectionAdded = function listenForSectionAdded(sectionAddedCB) {
        this.sectionAddedCB = sectionAddedCB;
    };

    SeatingConstruction.prototype.getDimensions = function getDimensions() {
        var dim = this.sections[0].getBounds();
        var top = dim.top;
        var bottom = dim.bottom;
        var left = dim.left;
        var right = dim.right;
        var objectDim = this.objects.map(function (object) {
            return object.getCorner();
        });
        var sectionDim = this.sections.map(function (section) {
            return section.getBounds();
        });
        objectDim.concat(sectionDim).forEach(function (dimension) {
            if (dimension.left < left) {
                left = dimension.left;
            }
            if (dimension.right > right) {
                right = dimension.right;
            }
            if (dimension.top < top) {
                top = dimension.top;
            }
            if (dimension.bottom > bottom) {
                bottom = dimension.bottom;
            }
        });
        return {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
    };

    SeatingConstruction.prototype.hide = function hide() {
        this.seatingConstructionContainer.visible = false;
    };

    SeatingConstruction.prototype.show = function show() {
        this.seatingConstructionContainer.visible = true;
    };

    SeatingConstruction.prototype.getContainer = function getContainer() {
        return this.seatingConstructionContainer;
    };

    SeatingConstruction.prototype.getSections = function getSections() {
        return this.sections;
    };

    SeatingConstruction.prototype.getObjects = function getObjects() {
        return this.objects.map(function (object) {
            return object.toJSON();
        });
    };

    SeatingConstruction.prototype.toJSON = function toJSON() {
        return {
            sections: this.sections.map(function (section) {
                return section.toJSON();
            }),
            objects: this.objects.map(function (object) {
                return object.toJSON();
            })
        };
    };

    SeatingConstruction.prototype.setConcave = function setConcave(sectionId, concavitivity) {
        this.sections[sectionId].setConcavitivity(concavitivity);
    };

    SeatingConstruction.prototype.listenForMouseMove = function listenForMouseMove() {
        var _this2 = this;

        this.pixiInt.on("mousemove", function (event) {
            var _event$data$global = event.data.global,
                x = _event$data$global.x,
                y = _event$data$global.y;

            _this2.mouseX = x;
            _this2.mouseY = y;
        });
    };

    SeatingConstruction.prototype.listenForShiftDrag = function listenForShiftDrag(canvasBounding) {
        var _this3 = this;

        this.pixiInt = Config_1.default.app.renderer.plugins.interaction;
        var top = canvasBounding.top,
            left = canvasBounding.left;

        this.pixiInt.on("mousedown", function () {
            if (_this3.keyboardManager.shiftPressed) {
                SelectionListener_1.default.isShiftSelect = true;
                var boxEnd = false;
                var mouse = _this3.pixiInt.mouse.global;
                var _Config_1$default$vie = Config_1.default.viewport.transform,
                    position = _Config_1$default$vie.position,
                    scale = _Config_1$default$vie.scale;

                var start = { x: (mouse.x - left - position._x) / scale._x, y: (mouse.y - top - position._y) / scale._y };
                var end = { x: 0, y: 0 };
                var mouseMove = function mouseMove() {
                    end.x = (mouse.x - left - position._x) / scale._x;
                    end.y = (mouse.y - top - position._y) / scale._y;
                    Selector_1.drawDragSelection(start, end);
                };
                _this3.pixiInt.on("mousemove", mouseMove);
                _this3.keyboardManager.onShiftReleased(function () {
                    if (!boxEnd) {
                        boxEnd = true;
                        _this3.pixiInt.removeListener("mousemove", mouseMove);
                        _this3.getTablesSelected(start, end);
                    }
                });
                _this3.pixiInt.once("mouseup", function () {
                    if (!boxEnd) {
                        boxEnd = true;
                        SelectionListener_1.default.isShiftSelect = false;
                        _this3.pixiInt.removeListener("mousemove", mouseMove);
                        _this3.getTablesSelected(start, end);
                    }
                });
            }
        });
    };

    SeatingConstruction.prototype.getTablesSelected = function getTablesSelected(firstPos, lastPos) {
        var p1 = firstPos;
        var p2 = lastPos;
        if (p1.x > p2.x && p1.y > p2.y) {
            p2 = firstPos;
            p1 = lastPos;
        } else if (p1.x < p2.x && p1.y > p2.y) {
            var yTemp = p1.y;
            p1.y = p2.y;
            p2.y = yTemp;
        } else if (p1.x > p2.x && p1.y < p2.y) {
            var xTemp = p1.x;
            p1.x = p2.x;
            p2.x = xTemp;
        }
        this.selectedTables = this.sections.map(function (section) {
            return section.findTablesBoundBy(p1, p2);
        }).reduce(function (data, current) {
            return data.concat(current);
        }, []);
        var subsetCurrentlySelected = this.interactionManager.allSelectedTablesCurrentlySelected(this.selectedTables);
        if (subsetCurrentlySelected) {
            var selectedSeats = this.selectedTables.map(function (table) {
                return table.getSeatsBoundBy(p1, p2);
            }).reduce(function (data, current) {
                return data.concat(current);
            }, []);
            if (selectedSeats.length > 0) {
                this.interactionManager.selectGroupSeats(selectedSeats);
            }
        } else {
            Selector_1.selectMultipleTables(this.selectedTables);
            this.interactionManager.selectGroup(this.selectedTables);
        }
    };

    SeatingConstruction.prototype.addSeats = function addSeats(sectionId, tableId, amount) {
        var seatData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { disabled: false, reserved: false, locked: false };

        this.sections[sectionId].addSeats(tableId, seatData, amount);
        this.adjustCapacity(amount);
        this.onChange();
        return ActionTracker_1.default.constructUndoValue("addSeats", this.removeSeats, [sectionId, tableId, amount]);
    };

    SeatingConstruction.prototype.removeSeats = function removeSeats(sectionId, tableId, amount) {
        this.sections[sectionId].removeSeats(tableId, amount);
        this.adjustCapacity(0 - amount);
        this.onChange();
        return ActionTracker_1.default.constructUndoValue("removeSeats", this.addSeats, [sectionId, tableId, amount]);
    };

    SeatingConstruction.prototype.unselect = function unselect() {
        Selector_1.clear();
        var currentlySelectedItems = this.interactionManager.unselect();
        this.interactionManager.clearGroup();
        this.actions.clearElements();
        currentlySelectedItems.forEach(function (item) {
            if (item.disableNextClick) {
                item.disableNextClick();
            }
        });
    };

    SeatingConstruction.prototype.addTable = function addTable(tableData) {
        var pos = this.getScopedPosition(tableData);
        tableData.globalPos = this.removeCanvasOffset(tableData);
        var sectionId = this.containedWithinASection(pos);
        if (sectionId !== null) {
            this.addTableToSection(sectionId, tableData);
        } else {
            this.addSection();
            this.addTableToSection(this.sections.length - 1, tableData);
        }
        this.adjustCapacity(tableData.seats ? tableData.seats.length : 0);
    };

    SeatingConstruction.prototype.addMapObject = function addMapObject(objectData) {
        var pos = objectData.pos;
        var _Config_1$default$vie2 = Config_1.default.viewport.transform,
            position = _Config_1$default$vie2.position,
            scale = _Config_1$default$vie2.scale;

        pos.x = (pos.x - position.x) / scale.x;
        pos.y = (pos.y - position.y) / scale.y;
    };

    SeatingConstruction.prototype.containedWithinASection = function containedWithinASection(pos) {
        var pos2 = { x: pos.x + 1, y: pos.y + 1 };
        var containedSections = this.sections.map(function (s) {
            return s.positionContainedWithinSection(pos, pos2);
        }).filter(function (s) {
            return s !== null;
        });
        if (containedSections.length > 0) {
            return containedSections[0];
        } else {
            return null;
        }
    };

    SeatingConstruction.prototype.addTableToSection = function addTableToSection(sectionId, tableData) {
        this.sections[sectionId].addTable(tableData, false);
    };

    SeatingConstruction.prototype.addObject = function addObject(objectData) {
        var pos = this.getScopedPosition(objectData);
        objectData.pos = pos;
        objectData.objectId = this.objects.length;
        var mapObject = new GeneralObject_1.default(objectData, this.actions, false);
        this.objects.push(mapObject);
        this.objectContainer.addChild(mapObject.getContainer());
    };

    SeatingConstruction.prototype.moveTables = function moveTables(tables, sectionId) {
        var _this4 = this;

        var oldSectionId = tables[0].sectionId;
        var removedSections = [];
        var removedTables = [];
        var newTables = tables.filter(function (table) {
            return table.sectionId !== sectionId;
        }).map(function (table) {
            var tableData = _this4.sections[table.sectionId].getTable(table.tableId).toJSON();
            removedTables.push(_this4.sections[table.sectionId].removeTable(table.tableId));
            if (_this4.sections[table.sectionId].tables.length === 0) {
                if (sectionId > table.sectionId) {
                    sectionId = sectionId - 1;
                }
                removedSections.push(_this4.removeSection(table.sectionId));
            }
            return _this4.sections[sectionId].addTable(tableData, false);
        });
        if (newTables.length > 0) {
            if (newTables.length > 1) {
                this.interactionManager.selectGroup(newTables);
            } else {
                this.interactionManager.itemSelected(newTables[0]);
            }
            this.interactionManager.removeSelected();
        }
        return ActionTracker_1.default.constructUndoValue("moveToNewSection", this.undoMove, [removedSections, removedTables, newTables]);
    };

    SeatingConstruction.prototype.moveToNewSection = function moveToNewSection(tables) {
        var updateOtherSections = this.sections.length < 2;
        var oldSectionId = tables[0].sectionId;
        var sectionId = this.createSection();
        var undoAction = this.moveTables(tables, sectionId);
        if (updateOtherSections) {
            this.sections.forEach(function (section) {
                return section.setSectionVisible(true);
            });
        }
        return undoAction;
    };

    SeatingConstruction.prototype.undoMove = function undoMove(removedSections, removedTables, newTables) {
        var _this5 = this;

        var newRemovedSections = [];
        var newRemovedTables = newTables.map(function (newTable) {
            var removedTable = _this5.sections[newTable.sectionId].removeTable(newTable.tableId);
            if (_this5.sections[newTable.sectionId].tables.length === 0) {
                newRemovedSections.push(_this5.removeSection(newTable.sectionId));
            }
            return removedTable;
        });
        if (removedSections.length > 0) {
            removedSections.forEach(function (section) {
                _this5.sections.splice(section.index, 0, section.section);
                _this5.sectionContainer.addChildAt(section.section.getSectionContainer(), section.index);
            });
            this.sections.forEach(function (section, i) {
                return section.setSectionId(i);
            });
        }
        removedTables.forEach(function (table) {
            _this5.sections[table.sectionId].addTableReference(table);
        });
        return ActionTracker_1.default.constructUndoValue("moveToNewSection", this.undoMove, [newRemovedSections, newRemovedTables, removedTables]);
    };

    SeatingConstruction.prototype.createSection = function createSection() {
        var sectionId = this.sections.length;
        var sectionData = {
            sectionId: sectionId,
            tables: [],
            showSection: true
        };
        if (this.sections.length < 2 && this.sectionAddedCB) {
            this.sectionAddedCB();
        }
        var newSection = new Section_1.default(sectionData, this.actions);
        this.sections.push(newSection);
        this.sectionContainer.addChild(newSection.getSectionContainer());
        return sectionId;
    };

    SeatingConstruction.prototype.removeSection = function removeSection(sectionId) {
        var index = sectionId;
        var section = this.sections.splice(sectionId, 1);
        this.sectionContainer.removeChildAt(sectionId);
        this.sections.forEach(function (section, i) {
            return section.setSectionId(i);
        });
        return { index: index, section: section[0] };
    };

    SeatingConstruction.prototype.removeTables = function removeTables(elements) {
        var _this6 = this;

        var amountOfSeatsRemoved = 0;
        elements.forEach(function (element) {
            if (element.basicType === "object") {
                _this6.objectContainer.removeChildAt(element.objectId);
                _this6.objects.splice(element.objectId, 1);
                _this6.objects.forEach(function (object, i) {
                    return object.setObjectId(i);
                });
            } else {
                amountOfSeatsRemoved += _this6.sections[element.sectionId].removeTable(element.tableId).getTableCapacity();
            }
        });
        this.adjustCapacity(0 - amountOfSeatsRemoved);
    };

    SeatingConstruction.prototype.duplicateTables = function duplicateTables(tables) {
        var _this7 = this;

        var sectionId = void 0;
        var duplicatedTables = tables.map(function (table) {
            sectionId = table.sectionId;
            return _this7.sections[table.sectionId].duplicateTable(table.tableId);
        });
        if (sectionId) {
            this.sections[sectionId].updateBounds();
        }
        this.interactionManager.selectGroup(duplicatedTables);
        this.interactionManager.drawBounds(duplicatedTables[0]);
    };

    SeatingConstruction.prototype.duplicateObjects = function duplicateObjects(objects) {
        var _this8 = this;

        var newObjects = objects.map(function (object) {
            var newObj = object.toJSON();
            newObj._id = undefined;
            newObj.pos.x = newObj.pos.x + 20;
            newObj.pos.y = newObj.pos.y + 20;
            newObj.objectId = _this8.objects.length;
            var mapObject = new GeneralObject_1.default(newObj, _this8.actions, false);
            _this8.objects.push(mapObject);
            _this8.objectContainer.addChild(mapObject.getContainer());
            return mapObject;
        });
        this.interactionManager.selectGroup(newObjects);
        this.interactionManager.drawBounds(newObjects[0]);
    };

    SeatingConstruction.prototype.addSection = function addSection() {
        var sectionData = {
            sectionName: "",
            sectionId: this.sections.length,
            pos: {
                x: 0,
                y: 0
            },
            bounds: {
                width: 200,
                height: 200
            },
            tables: [],
            showSection: this.sections.length > 0
        };
        var newSection = new Section_1.default(sectionData, this.actions);
        this.sections.push(newSection);
        this.sectionContainer.addChild(newSection.getSectionContainer());
    };

    SeatingConstruction.prototype.getScopedPosition = function getScopedPosition(_ref2) {
        var pos = _ref2.pos;

        var newPos = new PIXI.Point();
        var _Config_1$default$vie3 = Config_1.default.viewport.transform,
            position = _Config_1$default$vie3.position,
            scale = _Config_1$default$vie3.scale;
        var _Config_1$default$can = Config_1.default.canvasBounding,
            top = _Config_1$default$can.top,
            left = _Config_1$default$can.left;

        newPos.x = (pos.x - position.x - left * 2) / scale.x;
        newPos.y = (pos.y - position.y - top * 2) / scale.y;
        return newPos;
    };

    SeatingConstruction.prototype.adjustCapacity = function adjustCapacity(num) {
        this.capacity += num;
        if (this.onCapacityChange) {
            this.onCapacityChange(this.capacity);
        }
    };

    SeatingConstruction.prototype.listenOnCapacityChange = function listenOnCapacityChange(cb) {
        this.onCapacityChange = cb;
    };

    SeatingConstruction.prototype.removeCanvasOffset = function removeCanvasOffset(_ref3) {
        var pos = _ref3.pos;

        var newPos = new PIXI.Point();
        var _Config_1$default$can2 = Config_1.default.canvasBounding,
            top = _Config_1$default$can2.top,
            left = _Config_1$default$can2.left;

        newPos.x = pos.x - left;
        newPos.y = pos.y - top;
        return newPos;
    };

    SeatingConstruction.prototype.hideSection = function hideSection(hide) {
        this.sections.forEach(function (section) {
            return section.hideSection(hide);
        });
    };

    SeatingConstruction.prototype.toggleTicketTypeColors = function toggleTicketTypeColors(enable) {
        this.sections.forEach(function (section) {
            return section.toggleTicketTypeColors(enable);
        });
    };

    SeatingConstruction.prototype.onChange = function onChange() {
        if (this._onChange) {
            this._onChange();
        }
    };

    SeatingConstruction.prototype.setOnChange = function setOnChange(cb) {
        this._onChange = cb;
    };

    return SeatingConstruction;
}();

SeatingConstruction.initialised = false;
__decorate([bound_1.default], SeatingConstruction.prototype, "changeTicketMappingCount", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "showSections", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "listenForSectionAdded", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "getDimensions", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "hide", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "show", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "getContainer", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "getSections", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "getObjects", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "toJSON", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "setConcave", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "listenForMouseMove", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "listenForShiftDrag", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "getTablesSelected", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "addSeats", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "removeSeats", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "unselect", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "addTable", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "addMapObject", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "containedWithinASection", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "addTableToSection", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "addObject", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "moveTables", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "moveToNewSection", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "undoMove", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "createSection", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "removeSection", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "removeTables", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "duplicateTables", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "duplicateObjects", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "addSection", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "getScopedPosition", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "adjustCapacity", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "listenOnCapacityChange", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "removeCanvasOffset", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "hideSection", null);
__decorate([bound_1.default], SeatingConstruction.prototype, "toggleTicketTypeColors", null);
exports.default = SeatingConstruction;
//# sourceMappingURL=SeatingConstruction.js.map

/***/ }),

/***/ "ECnJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Section_1 = __webpack_require__("A1Ay");
var Config_1 = __webpack_require__("gH/r");
var GeneralObject_1 = __webpack_require__("Gv70");
var bound_1 = __webpack_require__("USDo");

var SeatingManagement = function () {
    function SeatingManagement(_ref, disableInteraction) {
        var _this = this;

        var sections = _ref.sections,
            _ref$objects = _ref.objects,
            objects = _ref$objects === undefined ? [] : _ref$objects;

        _classCallCheck(this, SeatingManagement);

        this.ticketMapping = {};
        this.sections = sections.map(function (section, i) {
            section.sectionId = i;
            return new Section_1.default(section, disableInteraction);
        });
        this.objects = objects.map(function (object, i) {
            object.objectId = i;
            return new GeneralObject_1.default(object, {}, true);
        });
        this.seatingManagementContainer = new PIXI.Container();
        this.sectionContainer = new PIXI.Container();
        this.sections.forEach(function (section) {
            return _this.sectionContainer.addChild(section.getSectionContainer());
        });
        this.sectionContainer.removeChildAt(this.sections.length - 1);
        this.sectionContainer.addChild(this.sections[this.sections.length - 1].getSectionContainer());
        this.objectContainer = new PIXI.Container();
        this.objects.forEach(function (object) {
            return _this.objectContainer.addChild(object.getContainer());
        });
        this.seatingManagementContainer.addChild(this.sectionContainer);
        this.seatingManagementContainer.addChild(this.objectContainer);
        this.listenOnzoom();
    }

    SeatingManagement.createSeatingManagementView = function createSeatingManagementView(seatingMapData) {
        var disableInteraction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        SeatingManagement.instance = new SeatingManagement(seatingMapData, disableInteraction);
        return SeatingManagement.instance;
    };

    SeatingManagement.getInstance = function getInstance() {
        return SeatingManagement.instance;
    };

    SeatingManagement.prototype.listenOnzoom = function listenOnzoom() {
        var _this2 = this;

        var scale = Config_1.default.viewport.scale;

        var isShowingSeat = void 0,
            isShowingTable = void 0;
        if (scale._x >= 0.80) {
            isShowingSeat = true;
            this.sections.forEach(function (section) {
                return section.showTextSeat(true);
            });
        } else {
            isShowingSeat = false;
            this.sections.forEach(function (section) {
                return section.showTextSeat(false);
            });
        }
        Config_1.default.viewport.on("zoomed", function (_ref2) {
            var viewport = _ref2.viewport;
            var scale = viewport.scale;

            if (scale._x >= 0.80 && !isShowingSeat) {
                _this2.sections.forEach(function (section) {
                    return section.showTextSeat(true);
                });
                isShowingSeat = true;
            } else if (scale._x < 0.80 && isShowingSeat) {
                _this2.sections.forEach(function (section) {
                    return section.showTextSeat(false);
                });
                isShowingSeat = false;
            }
        });
    };

    SeatingManagement.prototype.seatSelected = function seatSelected(seatCurrentlySelected) {
        this.sections.forEach(function (section) {
            section.seatSelected(seatCurrentlySelected);
        });
    };

    SeatingManagement.prototype.enableClick = function enableClick(enable) {
        this.sections.forEach(function (section) {
            section.enableClick(enable);
        });
    };

    SeatingManagement.prototype.getNames = function getNames(seatData) {
        var section = this.sections.find(function (section) {
            return section.id === seatData.sectionId;
        });
        if (section) {
            return section.getNames(seatData);
        }
    };

    SeatingManagement.prototype.highlight = function highlight(_highlight, seatData) {
        var section = this.sections.find(function (section) {
            return section.id === seatData.sectionId;
        });
        if (section) {
            section.highlight(_highlight, seatData);
        }
    };

    SeatingManagement.prototype.changeSeat = function changeSeat(seatData) {
        var section = this.sections.find(function (section) {
            return section.id === seatData.sectionId;
        });
        if (section) {
            return section.changeSeat(seatData);
        }
    };

    SeatingManagement.prototype.deselectSeat = function deselectSeat() {
        this.sections.forEach(function (section) {
            section.deselectSeat();
        });
    };

    SeatingManagement.prototype.unAssignSeat = function unAssignSeat(seatingData) {
        var section = this.sections.find(function (section) {
            return section.id === seatingData.sectionId;
        });
        if (section) {
            section.unAssignSeat(seatingData);
        }
    };

    SeatingManagement.prototype.completeMove = function completeMove(from, to, ticketData) {
        this.removeTicketDataFrom(from);
        this.addTicketDataTo(to, ticketData);
    };

    SeatingManagement.prototype.completeSwap = function completeSwap(to, ticketData) {
        this.addTicketDataTo(to, ticketData);
    };

    SeatingManagement.prototype.completeAssign = function completeAssign(to, ticketData) {
        this.addTicketDataTo(to, ticketData);
    };

    SeatingManagement.prototype.addTicketDataTo = function addTicketDataTo(seatingData, ticketData) {
        var section = this.sections.find(function (section) {
            return section.id === seatingData.sectionId;
        });
        if (section) {
            section.addTicketDataTo(seatingData, ticketData);
        }
    };

    SeatingManagement.prototype.removeTicketDataFrom = function removeTicketDataFrom(seatingData) {
        var section = this.sections.find(function (section) {
            return section.id === seatingData.sectionId;
        });
        if (section) {
            section.removeTicketDataFrom(seatingData);
        }
    };

    SeatingManagement.prototype.unClickSeat = function unClickSeat(seatingData) {
        var section = this.sections.find(function (section) {
            return section.id === seatingData.sectionId;
        });
        if (section) {
            section.unClickSeat(seatingData);
        }
    };

    SeatingManagement.prototype.getTicketMapping = function getTicketMapping() {
        return this.ticketMapping;
    };

    SeatingManagement.prototype.getDimensions = function getDimensions() {
        var dim = this.sections[0].getBounds();
        var top = dim.top;
        var bottom = dim.bottom;
        var left = dim.left;
        var right = dim.right;
        var objectDim = this.objects.map(function (object) {
            return object.getCorner();
        });
        var sectionDim = this.sections.map(function (section) {
            return section.getBounds();
        });
        objectDim.concat(sectionDim).forEach(function (dimension) {
            if (dimension.left < left) {
                left = dimension.left;
            }
            if (dimension.right > right) {
                right = dimension.right;
            }
            if (dimension.top < top) {
                top = dimension.top;
            }
            if (dimension.bottom > bottom) {
                bottom = dimension.bottom;
            }
        });
        return {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
    };

    SeatingManagement.prototype.getContainer = function getContainer() {
        return this.seatingManagementContainer;
    };

    SeatingManagement.prototype.hide = function hide() {
        this.seatingManagementContainer.visible = false;
    };

    SeatingManagement.prototype.show = function show() {
        this.seatingManagementContainer.visible = true;
    };

    SeatingManagement.prototype.setActions = function setActions(actions) {
        this.actions = actions;
        this.sections.forEach(function (section) {
            return section.setActions(actions);
        });
    };

    return SeatingManagement;
}();

SeatingManagement.initialised = false;
__decorate([bound_1.default], SeatingManagement.prototype, "listenOnzoom", null);
__decorate([bound_1.default], SeatingManagement.prototype, "seatSelected", null);
__decorate([bound_1.default], SeatingManagement.prototype, "enableClick", null);
__decorate([bound_1.default], SeatingManagement.prototype, "getNames", null);
__decorate([bound_1.default], SeatingManagement.prototype, "highlight", null);
__decorate([bound_1.default], SeatingManagement.prototype, "changeSeat", null);
__decorate([bound_1.default], SeatingManagement.prototype, "deselectSeat", null);
__decorate([bound_1.default], SeatingManagement.prototype, "unAssignSeat", null);
__decorate([bound_1.default], SeatingManagement.prototype, "completeMove", null);
__decorate([bound_1.default], SeatingManagement.prototype, "completeSwap", null);
__decorate([bound_1.default], SeatingManagement.prototype, "completeAssign", null);
__decorate([bound_1.default], SeatingManagement.prototype, "addTicketDataTo", null);
__decorate([bound_1.default], SeatingManagement.prototype, "removeTicketDataFrom", null);
__decorate([bound_1.default], SeatingManagement.prototype, "unClickSeat", null);
__decorate([bound_1.default], SeatingManagement.prototype, "getTicketMapping", null);
__decorate([bound_1.default], SeatingManagement.prototype, "getDimensions", null);
__decorate([bound_1.default], SeatingManagement.prototype, "getContainer", null);
__decorate([bound_1.default], SeatingManagement.prototype, "hide", null);
__decorate([bound_1.default], SeatingManagement.prototype, "show", null);
__decorate([bound_1.default], SeatingManagement.prototype, "setActions", null);
exports.default = SeatingManagement;
//# sourceMappingURL=SeatingManagement.js.map

/***/ }),

/***/ "ED/T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),

/***/ "EMul":
/***/ (function(module, exports) {

module.exports = function numtype(num, def) {
	return typeof num === 'number' ? num : typeof def === 'number' ? def : 0;
};

/***/ }),

/***/ "ESZJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
    return function spritesheetParser(resource, next) {
        var imageResourceName = resource.name + '_image';

        // skip if no data, its not json, it isn't spritesheet data, or the image resource already exists
        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.JSON || !resource.data.frames || this.resources[imageResourceName]) {
            next();

            return;
        }

        var loadOptions = {
            crossOrigin: resource.crossOrigin,
            metadata: resource.metadata.imageMetadata,
            parentResource: resource
        };

        var resourcePath = getResourcePath(resource, this.baseUrl);

        // load the image for this sheet
        this.add(imageResourceName, resourcePath, loadOptions, function onImageLoad(res) {
            if (res.error) {
                next(res.error);

                return;
            }

            var spritesheet = new _core.Spritesheet(res.texture.baseTexture, resource.data, resource.url);

            spritesheet.parse(function () {
                resource.spritesheet = spritesheet;
                resource.textures = spritesheet.textures;
                next();
            });
        });
    };
};

exports.getResourcePath = getResourcePath;

var _resourceLoader = __webpack_require__("6Jqp");

var _url = __webpack_require__("Mej7");

var _url2 = _interopRequireDefault(_url);

var _core = __webpack_require__("RjZD");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function getResourcePath(resource, baseUrl) {
    // Prepend url path unless the resource image is a data url
    if (resource.isDataUrl) {
        return resource.data.meta.image;
    }

    return _url2.default.resolve(resource.url.replace(baseUrl, ''), resource.data.meta.image);
}
//# sourceMappingURL=spritesheetParser.js.map

/***/ }),

/***/ "ESgF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};
//# sourceMappingURL=classNames.js.map

/***/ }),

/***/ "ETAJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Text_js_1 = __webpack_require__("h2Qz");
var InteractionManager_1 = __webpack_require__("dUAP");
var Config_1 = __webpack_require__("gH/r");
var Utils_1 = __webpack_require__("o6Mn");
var SeatingObject_1 = __webpack_require__("4h5L");
var bound_1 = __webpack_require__("USDo");
var ActionTracker_js_1 = __webpack_require__("h0Oq");

var Seat = function (_SeatingObject_1$defa) {
    _inherits(Seat, _SeatingObject_1$defa);

    function Seat(_ref, actions) {
        var _id = _ref._id,
            pos = _ref.pos,
            disabled = _ref.disabled,
            disableInteraction = _ref.disableInteraction,
            reserved = _ref.reserved,
            seatId = _ref.seatId,
            held = _ref.held,
            locked = _ref.locked,
            ticketIds = _ref.ticketIds,
            seatLabelPattern = _ref.seatLabelPattern,
            seatlabelStartAt = _ref.seatlabelStartAt,
            labelOverride = _ref.labelOverride,
            tableSelected = _ref.tableSelected,
            textOverride = _ref.textOverride;

        _classCallCheck(this, Seat);

        var _this = _possibleConstructorReturn(this, _SeatingObject_1$defa.call(this, _id, actions));

        var onSeatClicked = actions.onSeatClicked,
            onElementClicked = actions.onElementClicked;

        _this.disabled = disabled;
        _this.textOverride = textOverride;
        _this.disableInteraction = disableInteraction;
        _this.onSeatClicked = onSeatClicked;
        _this.labelOverride = labelOverride;
        _this.onElementClicked = onElementClicked;
        _this.reserved = reserved;
        _this.seatId = seatId;
        _this.ticketIds = ticketIds || [];
        _this.held = held;
        _this.locked = locked;
        _this.basicType = "seat";
        _this.seatLabelPattern = seatLabelPattern;
        _this.seatContainer = new PIXI.Container();
        _this.seatContainer.parentGroup = Config_1.default.spriteGroup;
        _this.seatlabelStartAt = seatlabelStartAt !== undefined ? seatlabelStartAt : 1;
        _this.seatTexture = PIXI.loader.resources[Utils_1.seatNotSelectedtexture].texture;
        _this.seatTexture.baseTexture.mipmap = true;
        _this.seatWidthScale = Utils_1.seatWidth / _this.seatTexture.orig.width;
        _this.seatHeightScale = Utils_1.seatHeight / _this.seatTexture.orig.height;
        _this.interactionManager = InteractionManager_1.default.createInteractionManager();
        _this.seat = new PIXI.Sprite(_this.seatTexture);
        _this.createClickFor(_this.seat);
        _this.seat.anchor = new PIXI.ObservablePoint(function () {}, undefined, 0.5, 0.5);
        _this.setLabel();
        _this.seat.scale = new PIXI.Point(_this.seatWidthScale, _this.seatHeightScale);
        _this.tableSelected = tableSelected;
        _this.selected = false;
        _this.seatContainer.addChild(_this.seat);
        _this.seatContainer.addChild(_this.text);
        _this.ticketTypeSprite = new PIXI.Sprite();
        _this.ticketTypeSprite.anchor = new PIXI.ObservablePoint(function () {}, undefined, 0.5, 0.5);
        _this.ticketTypeSprite.visible = false;
        _this.seatContainer.addChild(_this.ticketTypeSprite);
        _this.updateTicketTypeGraphics();
        _this.seatContainer.position = pos;
        _this.setInteraction();
        _this.setTexture();
        return _this;
    }

    Seat.prototype.setState = function setState(_ref2) {
        var pos = _ref2.pos,
            disabled = _ref2.disabled,
            disableInteraction = _ref2.disableInteraction,
            reserved = _ref2.reserved,
            seatId = _ref2.seatId,
            held = _ref2.held,
            locked = _ref2.locked,
            ticketIds = _ref2.ticketIds,
            seatLabelPattern = _ref2.seatLabelPattern,
            seatlabelStartAt = _ref2.seatlabelStartAt,
            labelOverride = _ref2.labelOverride,
            tableSelected = _ref2.tableSelected;

        this.disabled = disabled;
        this.disableInteraction = disableInteraction;
        this.labelOverride = labelOverride;
        this.reserved = reserved;
        this.seatId = seatId;
        this.ticketIds = ticketIds || [];
        this.held = held;
        this.locked = locked;
        this.seatLabelPattern = seatLabelPattern;
        this.seatlabelStartAt = seatlabelStartAt !== undefined ? seatlabelStartAt : 1;
        this.seatContainer.position = pos;
        this.setText();
        this.tableSelected = tableSelected;
        this.toggleText();
        this.setInteraction();
        this.setTexture();
    };

    Seat.prototype.setInteraction = function setInteraction() {
        var _this2 = this;

        this.seatContainer.interactive = true;
        this.seatContainer.on("click", function () {
            if (!_this2.disableInteraction) {
                if (_this2.tableSelected) {
                    if (_this2.ignoreNextClick) {
                        _this2.ignoreNextClick = false;
                    } else {
                        if (!_this2.selected) {
                            _this2.selected = true;
                            _this2.interactionManager.seatSelected(_this2);
                        } else {
                            _this2.selected = false;
                            _this2.interactionManager.seatDeselected(_this2);
                        }
                    }
                }
            }
        });
        this.seat.on("mouseover", function () {
            if (_this2.disabled && !_this2.disableInteraction) {
                _this2.seat.alpha = 0.5;
            }
        });
        this.seat.on("mouseout", function () {
            if (_this2.disabled && !_this2.disableInteraction) {
                _this2.seat.alpha = 0;
            }
        });
    };

    Seat.prototype.disableNextClick = function disableNextClick() {
        this.ignoreNextClick = true;
    };

    Seat.prototype.enableNextClick = function enableNextClick() {
        this.ignoreNextClick = false;
    };

    Seat.prototype.deSelect = function deSelect() {
        this.selected = false;
    };

    Seat.prototype.select = function select() {
        this.selected = true;
    };

    Seat.prototype.setLocked = function setLocked(locked) {
        var undoValue = ActionTracker_js_1.default.constructUndoValue("setLocked", this.setLocked, [this.locked]);
        this.locked = locked;
        this.onChange();
        return undoValue;
    };

    Seat.prototype.boundBy = function boundBy(p1, p2, p3, p4) {
        if (!(p2.y < p3.y || p1.y > p4.y || p2.x < p3.x || p1.x > p4.x)) {
            this.selected = true;
            this.ignoreNextClick = false;
            return this;
        }
    };

    Seat.prototype.getSelectionBounds = function getSelectionBounds() {
        var _Config_1$default$vie = Config_1.default.viewport.transform,
            position = _Config_1$default$vie.position,
            scale = _Config_1$default$vie.scale;

        var canvasBounding = Config_1.default.canvasBounding;

        var _seatContainer$getGlo = this.seatContainer.getGlobalPosition(),
            x = _seatContainer$getGlo.x,
            y = _seatContainer$getGlo.y;

        x = (x - canvasBounding.left - position.x) / scale.x;
        y = (y - canvasBounding.top - position.y) / scale.y;
        return { x: x, y: y, radius: Utils_1.seatWidth / 2 };
    };

    Seat.prototype.setSeatLabelStartAt = function setSeatLabelStartAt(seatlabelStartAt) {
        this.seatlabelStartAt = seatlabelStartAt;
        this.setText();
    };

    Seat.prototype.getSeatLabelStartAt = function getSeatLabelStartAt() {
        return this.seatlabelStartAt;
    };

    Seat.prototype.setLabelPattern = function setLabelPattern(seatLabelPattern) {
        this.seatLabelPattern = seatLabelPattern;
        this.setText();
    };

    Seat.prototype.setText = function setText() {
        if (this.textOverride) {
            this.text.text = this.textOverride;
        } else {
            if (this.labelOverride !== undefined) {
                this.text.text = String(this.labelOverride + this.seatlabelStartAt);
            } else {
                if (this.seatLabelPattern === "alphabet") {
                    this.text.text = String.fromCharCode(65 + this.seatId + this.seatlabelStartAt);
                } else {
                    this.text.text = String(this.seatId + this.seatlabelStartAt);
                }
            }
        }
    };

    Seat.prototype.onTableSelected = function onTableSelected() {
        this.tableSelected = true;
        this.setTexture();
    };

    Seat.prototype.onTableDeselected = function onTableDeselected() {
        this.tableSelected = false;
        this.setTexture();
    };

    Seat.prototype.setTexture = function setTexture() {
        if (!this.disabled) {
            var textureName = this.tableSelected ? Utils_1.seatSelectedtexture : Utils_1.seatNotSelectedtexture;
            this.seatTexture = PIXI.loader.resources[textureName].texture;
            this.seatTexture.baseTexture.mipmap = true;
            this.seat.texture = this.seatTexture;
            this.seat.visible = true;
            this.seat.alpha = 1;
        } else {
            this.seat.alpha = 0;
        }
    };

    Seat.prototype.disable = function disable(disableSeat) {
        var invokeCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var disableInteraction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var undoValue = ActionTracker_js_1.default.constructUndoValue("disable", this.disable, [this.disabled]);
        this.disabled = disableSeat;
        this.disableInteraction = disableInteraction;
        this.seatContainer.interactive = this.disableInteraction;
        if (disableInteraction) {
            this.seatContainer.cursor = "default";
        } else {
            this.seatContainer.cursor = "pointer";
        }
        if (this.disabled && invokeCallback && this.onDisabled) {
            this.onDisabled();
        }
        this.setTexture();
        this.toggleText();
        this.onChange();
        return undoValue;
    };

    Seat.prototype.isDisabled = function isDisabled() {
        return this.disabled;
    };

    Seat.prototype.toggleText = function toggleText() {
        this.text.visible = !this.disabled;
    };

    Seat.prototype.toJSON = function toJSON() {
        var isRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var rowLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

        return {
            _id: this._id,
            label: this.text.text,
            pos: { x: this.seatContainer.position.x, y: this.seatContainer.position.y },
            disabled: this.disabled,
            disableInteraction: this.disableInteraction,
            reserved: this.reserved,
            seatId: this.seatId,
            held: this.held,
            locked: this.locked,
            ticketIds: this.ticketIds,
            textOverride: this.textOverride,
            seatLabelPattern: this.seatLabelPattern,
            seatLabelStartAt: this.seatlabelStartAt,
            name: isRow ? "Row " + rowLabel + " Seat " + this.text.text : "Seat " + this.text.text
        };
    };

    Seat.prototype.assignTicketType = function assignTicketType(ticketId) {
        var index = this.ticketIds.indexOf(ticketId);
        if (index === -1) {
            this.ticketIds.push(ticketId);
            this.updateTicketTypeGraphics();
            this.onChange();
            return ActionTracker_js_1.default.constructUndoValue("assignTicketType", this.removeTicketType, [ticketId]);
        }
    };

    Seat.prototype.removeTicketType = function removeTicketType(ticketId) {
        var index = this.ticketIds.indexOf(ticketId);
        if (index > -1) {
            this.ticketIds.splice(index, 1);
            this.updateTicketTypeGraphics();
            this.onChange();
            return ActionTracker_js_1.default.constructUndoValue("removeTicketType", this.assignTicketType, [ticketId]);
        }
    };

    Seat.prototype.updateTicketTypeGraphics = function updateTicketTypeGraphics() {
        var key = this.createKey();
        var alreadyExists = Config_1.default.ticketMappingRepo.has(key);
        if (!alreadyExists) {
            this.createTexture(key);
        }
        this.ticketTypeSprite.texture = Config_1.default.ticketMappingRepo.get(key);
    };

    Seat.prototype.createKey = function createKey() {
        return this.ticketIds.reduce(function (str, ticketId) {
            return "" + str + ticketId;
        }, "");
    };

    Seat.prototype.createTexture = function createTexture(key) {
        this.ticketTypeGraphics = new PIXI.Graphics();
        this.ticketTypeGraphics.visible = true;
        this.ticketTypeGraphics.clear();
        this.ticketTypeGraphics.drawTicketTypeColor(Config_1.default.getSpecificTicketTypeColors(this.ticketIds), Utils_1.seatWidth / 2 - 1);
        var rt = Config_1.default.app.renderer.generateTexture(this.ticketTypeGraphics);
        Config_1.default.ticketMappingRepo.set(key, rt);
    };

    Seat.prototype.countTicketMappings = function countTicketMappings() {
        return this.ticketIds;
    };

    Seat.prototype.createClickFor = function createClickFor(target) {
        var _this3 = this;

        target.interactive = true;
        target.on("mousedown", function (e) {
            _this3.onSeatClicked(_this3.seatId);
        });
    };

    Seat.prototype.setLabel = function setLabel() {
        var label = void 0;
        if (this.textOverride) {
            label = this.textOverride;
        } else {
            if (this.labelOverride !== undefined) {
                label = String(this.labelOverride + this.seatlabelStartAt);
            } else {
                if (this.seatLabelPattern === "alphabet") {
                    label = String.fromCharCode(65 + this.seatId + this.seatlabelStartAt);
                } else {
                    label = String(this.seatId + this.seatlabelStartAt);
                }
            }
        }
        this.text = Text_js_1.TextWrapper.createText(label, Config_1.default.fontStyle);
        this.text.resolution = 2;
        this.text.anchor = new PIXI.ObservablePoint(function () {}, undefined, 0.5, 0.5);
        this.toggleText();
    };

    Seat.prototype.setPos = function setPos(pos) {
        this.seatContainer.position = pos;
    };

    Seat.prototype.getSeat = function getSeat() {
        return this.seatContainer;
    };

    Seat.prototype.setLabelOverride = function setLabelOverride(i) {
        this.labelOverride = i;
        this.setText();
    };

    Seat.prototype.setSeatId = function setSeatId(seatId) {
        this.seatId = seatId;
    };

    Seat.prototype.setOnDisable = function setOnDisable(cb) {
        this.onDisabled = cb;
    };

    Seat.prototype.getPosition = function getPosition() {
        return this.seatContainer.position;
    };

    Seat.prototype.overrideText = function overrideText(textOverride) {
        var oldTextOverride = this.textOverride;
        this.textOverride = textOverride;
        this.setText();
        return ActionTracker_js_1.default.constructUndoValue("overrideText", this.overrideText, [oldTextOverride]);
    };

    Seat.prototype.toggleTicketTypeColors = function toggleTicketTypeColors(enable) {
        if (!this.disabled) {
            this.ticketTypeSprite.visible = enable;
        }
    };

    return Seat;
}(SeatingObject_1.default);

__decorate([bound_1.default], Seat.prototype, "setInteraction", null);
__decorate([bound_1.default], Seat.prototype, "disableNextClick", null);
__decorate([bound_1.default], Seat.prototype, "enableNextClick", null);
__decorate([bound_1.default], Seat.prototype, "deSelect", null);
__decorate([bound_1.default], Seat.prototype, "select", null);
__decorate([bound_1.default], Seat.prototype, "setLocked", null);
__decorate([bound_1.default], Seat.prototype, "boundBy", null);
__decorate([bound_1.default], Seat.prototype, "getSelectionBounds", null);
__decorate([bound_1.default], Seat.prototype, "setSeatLabelStartAt", null);
__decorate([bound_1.default], Seat.prototype, "getSeatLabelStartAt", null);
__decorate([bound_1.default], Seat.prototype, "setLabelPattern", null);
__decorate([bound_1.default], Seat.prototype, "setText", null);
__decorate([bound_1.default], Seat.prototype, "onTableSelected", null);
__decorate([bound_1.default], Seat.prototype, "onTableDeselected", null);
__decorate([bound_1.default], Seat.prototype, "setTexture", null);
__decorate([bound_1.default], Seat.prototype, "disable", null);
__decorate([bound_1.default], Seat.prototype, "isDisabled", null);
__decorate([bound_1.default], Seat.prototype, "toggleText", null);
__decorate([bound_1.default], Seat.prototype, "toJSON", null);
__decorate([bound_1.default], Seat.prototype, "assignTicketType", null);
__decorate([bound_1.default], Seat.prototype, "removeTicketType", null);
__decorate([bound_1.default], Seat.prototype, "updateTicketTypeGraphics", null);
__decorate([bound_1.default], Seat.prototype, "createTexture", null);
__decorate([bound_1.default], Seat.prototype, "countTicketMappings", null);
__decorate([bound_1.default], Seat.prototype, "createClickFor", null);
__decorate([bound_1.default], Seat.prototype, "setLabel", null);
__decorate([bound_1.default], Seat.prototype, "setPos", null);
__decorate([bound_1.default], Seat.prototype, "getSeat", null);
__decorate([bound_1.default], Seat.prototype, "setLabelOverride", null);
__decorate([bound_1.default], Seat.prototype, "setOnDisable", null);
__decorate([bound_1.default], Seat.prototype, "getPosition", null);
__decorate([bound_1.default], Seat.prototype, "overrideText", null);
__decorate([bound_1.default], Seat.prototype, "toggleTicketTypeColors", null);
exports.default = Seat;
//# sourceMappingURL=Seat.js.map

/***/ }),

/***/ "EYtC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = buildPoly;

var _buildLine = __webpack_require__("MEjA");

var _buildLine2 = _interopRequireDefault(_buildLine);

var _utils = __webpack_require__("dDI1");

var _earcut = __webpack_require__("vwhv");

var _earcut2 = _interopRequireDefault(_earcut);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Builds a polygon to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
 */
function buildPoly(graphicsData, webGLData, webGLDataNativeLines) {
    graphicsData.points = graphicsData.shape.points.slice();

    var points = graphicsData.points;

    if (graphicsData.fill && points.length >= 6) {
        var holeArray = [];
        // Process holes..
        var holes = graphicsData.holes;

        for (var i = 0; i < holes.length; i++) {
            var hole = holes[i];

            holeArray.push(points.length / 2);

            points = points.concat(hole.points);
        }

        // get first and last point.. figure out the middle!
        var verts = webGLData.points;
        var indices = webGLData.indices;

        var length = points.length / 2;

        // sort color
        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
        var alpha = graphicsData.fillAlpha;
        var r = color[0] * alpha;
        var g = color[1] * alpha;
        var b = color[2] * alpha;

        var triangles = (0, _earcut2.default)(points, holeArray, 2);

        if (!triangles) {
            return;
        }

        var vertPos = verts.length / 6;

        for (var _i = 0; _i < triangles.length; _i += 3) {
            indices.push(triangles[_i] + vertPos);
            indices.push(triangles[_i] + vertPos);
            indices.push(triangles[_i + 1] + vertPos);
            indices.push(triangles[_i + 2] + vertPos);
            indices.push(triangles[_i + 2] + vertPos);
        }

        for (var _i2 = 0; _i2 < length; _i2++) {
            verts.push(points[_i2 * 2], points[_i2 * 2 + 1], r, g, b, alpha);
        }
    }

    if (graphicsData.lineWidth > 0) {
        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
    }
}
//# sourceMappingURL=buildPoly.js.map

/***/ }),

/***/ "Eh8S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;
exports.parse = parse;

exports.default = function () {
    return function bitmapFontParser(resource, next) {
        // skip if no data or not xml data
        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.XML) {
            next();

            return;
        }

        // skip if not bitmap font data, using some silly duck-typing
        if (resource.data.getElementsByTagName('page').length === 0 || resource.data.getElementsByTagName('info').length === 0 || resource.data.getElementsByTagName('info')[0].getAttribute('face') === null) {
            next();

            return;
        }

        var xmlUrl = !resource.isDataUrl ? path.dirname(resource.url) : '';

        if (resource.isDataUrl) {
            if (xmlUrl === '.') {
                xmlUrl = '';
            }

            if (this.baseUrl && xmlUrl) {
                // if baseurl has a trailing slash then add one to xmlUrl so the replace works below
                if (this.baseUrl.charAt(this.baseUrl.length - 1) === '/') {
                    xmlUrl += '/';
                }
            }
        }

        // remove baseUrl from xmlUrl
        xmlUrl = xmlUrl.replace(this.baseUrl, '');

        // if there is an xmlUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
        if (xmlUrl && xmlUrl.charAt(xmlUrl.length - 1) !== '/') {
            xmlUrl += '/';
        }

        var pages = resource.data.getElementsByTagName('page');
        var textures = {};

        // Handle completed, when the number of textures
        // load is the same number as references in the fnt file
        var completed = function completed(page) {
            textures[page.metadata.pageFile] = page.texture;

            if (Object.keys(textures).length === pages.length) {
                parse(resource, textures);
                next();
            }
        };

        for (var i = 0; i < pages.length; ++i) {
            var pageFile = pages[i].getAttribute('file');
            var url = xmlUrl + pageFile;
            var exists = false;

            // incase the image is loaded outside
            // using the same loader, resource will be available
            for (var name in this.resources) {
                var bitmapResource = this.resources[name];

                if (bitmapResource.url === url) {
                    bitmapResource.metadata.pageFile = pageFile;
                    if (bitmapResource.texture) {
                        completed(bitmapResource);
                    } else {
                        bitmapResource.onAfterMiddleware.add(completed);
                    }
                    exists = true;
                    break;
                }
            }

            // texture is not loaded, we'll attempt to add
            // it to the load and add the texture to the list
            if (!exists) {
                // Standard loading options for images
                var options = {
                    crossOrigin: resource.crossOrigin,
                    loadType: _resourceLoader.Resource.LOAD_TYPE.IMAGE,
                    metadata: _extends({ pageFile: pageFile }, resource.metadata.imageMetadata),
                    parentResource: resource
                };

                this.add(url, options, completed);
            }
        }
    };
};

var _path = __webpack_require__("UUq2");

var path = _interopRequireWildcard(_path);

var _resourceLoader = __webpack_require__("6Jqp");

var _extras = __webpack_require__("KRVa");

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

/**
 * Register a BitmapText font from loader resource.
 *
 * @function parseBitmapFontData
 * @memberof PIXI.loaders
 * @param {PIXI.loaders.Resource} resource - Loader resource.
 * @param {PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
 */
function parse(resource, textures) {
    resource.bitmapFont = _extras.BitmapText.registerFont(resource.data, textures);
}
//# sourceMappingURL=bitmapFontParser.js.map

/***/ }),

/***/ "Et5b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = __webpack_require__("sh3Y");
var utils = __webpack_require__("GZIj");

module.exports = function (_Plugin) {
    _inherits(clamp, _Plugin);

    /**
     * @private
     * @param {object} options
     * @param {(number|boolean)} [options.left] clamp left; true=0
     * @param {(number|boolean)} [options.right] clamp right; true=viewport.worldWidth
     * @param {(number|boolean)} [options.top] clamp top; true=0
     * @param {(number|boolean)} [options.bottom] clamp bottom; true=viewport.worldHeight
     * @param {string} [options.direction] (all, x, or y) using clamps of [0, viewport.worldWidth/viewport.worldHeight]; replaces left/right/top/bottom if set
     * @param {string} [options.underflow=center] (none OR (top/bottom/center and left/right/center) OR center) where to place world if too small for screen (e.g., top-right, center, none, bottomleft)
     */
    function clamp(parent, options) {
        _classCallCheck(this, clamp);

        options = options || {};

        var _this = _possibleConstructorReturn(this, (clamp.__proto__ || Object.getPrototypeOf(clamp)).call(this, parent));

        if (typeof options.direction === 'undefined') {
            _this.left = utils.defaults(options.left, null);
            _this.right = utils.defaults(options.right, null);
            _this.top = utils.defaults(options.top, null);
            _this.bottom = utils.defaults(options.bottom, null);
        } else {
            _this.left = options.direction === 'x' || options.direction === 'all' ? true : null;
            _this.right = options.direction === 'x' || options.direction === 'all' ? true : null;
            _this.top = options.direction === 'y' || options.direction === 'all' ? true : null;
            _this.bottom = options.direction === 'y' || options.direction === 'all' ? true : null;
        }
        _this.parseUnderflow(options.underflow || 'center');
        _this.move();
        return _this;
    }

    _createClass(clamp, [{
        key: 'parseUnderflow',
        value: function parseUnderflow(clamp) {
            clamp = clamp.toLowerCase();
            if (clamp === 'none') {
                this.noUnderflow = true;
            } else if (clamp === 'center') {
                this.underflowX = this.underflowY = 0;
                this.noUnderflow = false;
            } else {
                this.underflowX = clamp.indexOf('left') !== -1 ? -1 : clamp.indexOf('right') !== -1 ? 1 : 0;
                this.underflowY = clamp.indexOf('top') !== -1 ? -1 : clamp.indexOf('bottom') !== -1 ? 1 : 0;
                this.noUnderflow = false;
            }
        }
    }, {
        key: 'move',
        value: function move() {
            this.update();
        }
    }, {
        key: 'update',
        value: function update() {
            if (this.paused) {
                return;
            }
            var original = { x: this.parent.x, y: this.parent.y };
            var decelerate = this.parent.plugins['decelerate'] || {};
            if (this.left !== null || this.right !== null) {
                var moved = void 0;
                if (this.parent.screenWorldWidth < this.parent.screenWidth) {
                    if (!this.noUnderflow) {
                        switch (this.underflowX) {
                            case -1:
                                if (this.parent.x !== 0) {
                                    this.parent.x = 0;
                                    moved = true;
                                }
                                break;
                            case 1:
                                if (this.parent.x !== this.parent.screenWidth - this.parent.screenWorldWidth) {
                                    this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth;
                                    moved = true;
                                }
                                break;
                            default:
                                if (this.parent.x !== (this.parent.screenWidth - this.parent.screenWorldWidth) / 2) {
                                    this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
                                    moved = true;
                                }
                        }
                    }
                } else {
                    if (this.left !== null) {
                        if (this.parent.left < (this.left === true ? 0 : this.left)) {
                            this.parent.x = -(this.left === true ? 0 : this.left) * this.parent.scale.x;
                            decelerate.x = 0;
                            moved = true;
                        }
                    }
                    if (this.right !== null) {
                        if (this.parent.right > (this.right === true ? this.parent.worldWidth : this.right)) {
                            this.parent.x = -(this.right === true ? this.parent.worldWidth : this.right) * this.parent.scale.x + this.parent.screenWidth;
                            decelerate.x = 0;
                            moved = true;
                        }
                    }
                }
                if (moved) {
                    this.parent.emit('moved', { viewport: this.parent, original: original, type: 'clamp-x' });
                }
            }
            if (this.top !== null || this.bottom !== null) {
                var _moved = void 0;
                if (this.parent.screenWorldHeight < this.parent.screenHeight) {
                    if (!this.noUnderflow) {
                        switch (this.underflowY) {
                            case -1:
                                if (this.parent.y !== 0) {
                                    this.parent.y = 0;
                                    _moved = true;
                                }
                                break;
                            case 1:
                                if (this.parent.y !== this.parent.screenHeight - this.parent.screenWorldHeight) {
                                    this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight;
                                    _moved = true;
                                }
                                break;
                            default:
                                if (this.parent.y !== (this.parent.screenHeight - this.parent.screenWorldHeight) / 2) {
                                    this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
                                    _moved = true;
                                }
                        }
                    }
                } else {
                    if (this.top !== null) {
                        if (this.parent.top < (this.top === true ? 0 : this.top)) {
                            this.parent.y = -(this.top === true ? 0 : this.top) * this.parent.scale.y;
                            decelerate.y = 0;
                            _moved = true;
                        }
                    }
                    if (this.bottom !== null) {
                        if (this.parent.bottom > (this.bottom === true ? this.parent.worldHeight : this.bottom)) {
                            this.parent.y = -(this.bottom === true ? this.parent.worldHeight : this.bottom) * this.parent.scale.y + this.parent.screenHeight;
                            decelerate.y = 0;
                            _moved = true;
                        }
                    }
                }
                if (_moved) {
                    this.parent.emit('moved', { viewport: this.parent, original: original, type: 'clamp-y' });
                }
            }
        }
    }]);

    return clamp;
}(Plugin);

/***/ }),

/***/ "EtHY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Section_1 = __webpack_require__("8vce");
var Config_1 = __webpack_require__("gH/r");
var GeneralObject_1 = __webpack_require__("Gv70");
var bound_1 = __webpack_require__("USDo");

var SeatingMapping = function () {
    function SeatingMapping(_ref) {
        var _this = this;

        var sections = _ref.sections,
            _ref$objects = _ref.objects,
            objects = _ref$objects === undefined ? [] : _ref$objects;

        _classCallCheck(this, SeatingMapping);

        this.ticketMapping = {};
        this.sections = sections.map(function (section, i) {
            section.sectionId = i;
            return new Section_1.default(section);
        });
        this.objects = objects.map(function (object, i) {
            object.objectId = i;
            return new GeneralObject_1.default(object, {}, true);
        });
        this.seatingMappingContainer = new PIXI.Container();
        this.sectionContainer = new PIXI.Container();
        this.sections.forEach(function (section) {
            return _this.sectionContainer.addChild(section.getSectionContainer());
        });
        this.sectionContainer.removeChildAt(this.sections.length - 1);
        this.sectionContainer.addChild(this.sections[this.sections.length - 1].getSectionContainer());
        this.objectContainer = new PIXI.Container();
        this.objects.forEach(function (object) {
            return _this.objectContainer.addChild(object.getContainer());
        });
        this.seatingMappingContainer.addChild(this.sectionContainer);
        this.seatingMappingContainer.addChild(this.objectContainer);
        this.listenOnzoom();
    }

    SeatingMapping.createSeatingMappingView = function createSeatingMappingView(seatingMapData) {
        SeatingMapping.instance = new SeatingMapping(seatingMapData);
        return SeatingMapping.instance;
    };

    SeatingMapping.getInstance = function getInstance() {
        return SeatingMapping.instance;
    };

    SeatingMapping.prototype.getContainer = function getContainer() {
        return this.seatingMappingContainer;
    };

    SeatingMapping.prototype.listenOnzoom = function listenOnzoom() {
        var _this2 = this;

        var scale = Config_1.default.viewport.scale;

        var isShowingSeat = void 0,
            isShowingTable = void 0;
        if (scale._x >= 0.80) {
            isShowingSeat = true;
            this.sections.forEach(function (section) {
                return section.showTextSeat(true);
            });
        } else {
            isShowingSeat = false;
            this.sections.forEach(function (section) {
                return section.showTextSeat(false);
            });
        }
        Config_1.default.viewport.on("zoomed", function (_ref2) {
            var viewport = _ref2.viewport;
            var scale = viewport.scale;

            if (scale._x >= 0.80 && !isShowingSeat) {
                _this2.sections.forEach(function (section) {
                    return section.showTextSeat(true);
                });
                isShowingSeat = true;
            } else if (scale._x < 0.80 && isShowingSeat) {
                _this2.sections.forEach(function (section) {
                    return section.showTextSeat(false);
                });
                isShowingSeat = false;
            }
        });
    };

    SeatingMapping.prototype.getDimensions = function getDimensions() {
        var dim = this.sections[0].getBounds();
        var top = dim.top;
        var bottom = dim.bottom;
        var left = dim.left;
        var right = dim.right;
        var objectDim = this.objects.map(function (object) {
            return object.getCorner();
        });
        var sectionDim = this.sections.map(function (section) {
            return section.getBounds();
        });
        objectDim.concat(sectionDim).forEach(function (dimension) {
            if (dimension.left < left) {
                left = dimension.left;
            }
            if (dimension.right > right) {
                right = dimension.right;
            }
            if (dimension.top < top) {
                top = dimension.top;
            }
            if (dimension.bottom > bottom) {
                bottom = dimension.bottom;
            }
        });
        return {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
    };

    return SeatingMapping;
}();

SeatingMapping.initialised = false;
__decorate([bound_1.default], SeatingMapping.prototype, "getContainer", null);
__decorate([bound_1.default], SeatingMapping.prototype, "listenOnzoom", null);
__decorate([bound_1.default], SeatingMapping.prototype, "getDimensions", null);
exports.default = SeatingMapping;
//# sourceMappingURL=SeatingMapping.js.map

/***/ }),

/***/ "F/bs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Resource = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _parseUri = __webpack_require__("01sX");

var _parseUri2 = _interopRequireDefault(_parseUri);

var _miniSignals = __webpack_require__("vKdq");

var _miniSignals2 = _interopRequireDefault(_miniSignals);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

// tests if CORS is supported in XHR, if not we need to use XDR
var useXdr = !!(window.XDomainRequest && !('withCredentials' in new XMLHttpRequest()));
var tempAnchor = null;

// some status constants
var STATUS_NONE = 0;
var STATUS_OK = 200;
var STATUS_EMPTY = 204;
var STATUS_IE_BUG_EMPTY = 1223;
var STATUS_TYPE_OK = 2;

// noop
function _noop() {} /* empty */

/**
 * Manages the state and loading of a resource and all child resources.
 *
 * @class
 */

var Resource = exports.Resource = function () {
    /**
     * Sets the load type to be used for a specific extension.
     *
     * @static
     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
     * @param {Resource.LOAD_TYPE} loadType - The load type to set it to.
     */
    Resource.setExtensionLoadType = function setExtensionLoadType(extname, loadType) {
        setExtMap(Resource._loadTypeMap, extname, loadType);
    };

    /**
     * Sets the load type to be used for a specific extension.
     *
     * @static
     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
     * @param {Resource.XHR_RESPONSE_TYPE} xhrType - The xhr type to set it to.
     */

    Resource.setExtensionXhrType = function setExtensionXhrType(extname, xhrType) {
        setExtMap(Resource._xhrTypeMap, extname, xhrType);
    };

    /**
     * @param {string} name - The name of the resource to load.
     * @param {string|string[]} url - The url for this resource, for audio/video loads you can pass
     *      an array of sources.
     * @param {object} [options] - The options for the load.
     * @param {string|boolean} [options.crossOrigin] - Is this request cross-origin? Default is to
     *      determine automatically.
     * @param {number} [options.timeout=0] - A timeout in milliseconds for the load. If the load takes
     *      longer than this time it is cancelled and the load is considered a failure. If this value is
     *      set to `0` then there is no explicit timeout.
     * @param {Resource.LOAD_TYPE} [options.loadType=Resource.LOAD_TYPE.XHR] - How should this resource
     *      be loaded?
     * @param {Resource.XHR_RESPONSE_TYPE} [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
     *      should the data being loaded be interpreted when using XHR?
     * @param {Resource.IMetadata} [options.metadata] - Extra configuration for middleware and the Resource object.
     */

    function Resource(name, url, options) {
        _classCallCheck(this, Resource);

        if (typeof name !== 'string' || typeof url !== 'string') {
            throw new Error('Both name and url are required for constructing a resource.');
        }

        options = options || {};

        /**
         * The state flags of this resource.
         *
         * @private
         * @member {number}
         */
        this._flags = 0;

        // set data url flag, needs to be set early for some _determineX checks to work.
        this._setFlag(Resource.STATUS_FLAGS.DATA_URL, url.indexOf('data:') === 0);

        /**
         * The name of this resource.
         *
         * @readonly
         * @member {string}
         */
        this.name = name;

        /**
         * The url used to load this resource.
         *
         * @readonly
         * @member {string}
         */
        this.url = url;

        /**
         * The extension used to load this resource.
         *
         * @readonly
         * @member {string}
         */
        this.extension = this._getExtension();

        /**
         * The data that was loaded by the resource.
         *
         * @member {any}
         */
        this.data = null;

        /**
         * Is this request cross-origin? If unset, determined automatically.
         *
         * @member {string}
         */
        this.crossOrigin = options.crossOrigin === true ? 'anonymous' : options.crossOrigin;

        /**
         * A timeout in milliseconds for the load. If the load takes longer than this time
         * it is cancelled and the load is considered a failure. If this value is set to `0`
         * then there is no explicit timeout.
         *
         * @member {number}
         */
        this.timeout = options.timeout || 0;

        /**
         * The method of loading to use for this resource.
         *
         * @member {Resource.LOAD_TYPE}
         */
        this.loadType = options.loadType || this._determineLoadType();

        /**
         * The type used to load the resource via XHR. If unset, determined automatically.
         *
         * @member {string}
         */
        this.xhrType = options.xhrType;

        /**
         * Extra info for middleware, and controlling specifics about how the resource loads.
         *
         * Note that if you pass in a `loadElement`, the Resource class takes ownership of it.
         * Meaning it will modify it as it sees fit.
         *
         * @member {Resource.IMetadata}
         */
        this.metadata = options.metadata || {};

        /**
         * The error that occurred while loading (if any).
         *
         * @readonly
         * @member {Error}
         */
        this.error = null;

        /**
         * The XHR object that was used to load this resource. This is only set
         * when `loadType` is `Resource.LOAD_TYPE.XHR`.
         *
         * @readonly
         * @member {XMLHttpRequest}
         */
        this.xhr = null;

        /**
         * The child resources this resource owns.
         *
         * @readonly
         * @member {Resource[]}
         */
        this.children = [];

        /**
         * The resource type.
         *
         * @readonly
         * @member {Resource.TYPE}
         */
        this.type = Resource.TYPE.UNKNOWN;

        /**
         * The progress chunk owned by this resource.
         *
         * @readonly
         * @member {number}
         */
        this.progressChunk = 0;

        /**
         * The `dequeue` method that will be used a storage place for the async queue dequeue method
         * used privately by the loader.
         *
         * @private
         * @member {function}
         */
        this._dequeue = _noop;

        /**
         * Used a storage place for the on load binding used privately by the loader.
         *
         * @private
         * @member {function}
         */
        this._onLoadBinding = null;

        /**
         * The timer for element loads to check if they timeout.
         *
         * @private
         * @member {number}
         */
        this._elementTimer = 0;

        /**
         * The `complete` function bound to this resource's context.
         *
         * @private
         * @member {function}
         */
        this._boundComplete = this.complete.bind(this);

        /**
         * The `_onError` function bound to this resource's context.
         *
         * @private
         * @member {function}
         */
        this._boundOnError = this._onError.bind(this);

        /**
         * The `_onProgress` function bound to this resource's context.
         *
         * @private
         * @member {function}
         */
        this._boundOnProgress = this._onProgress.bind(this);

        /**
         * The `_onTimeout` function bound to this resource's context.
         *
         * @private
         * @member {function}
         */
        this._boundOnTimeout = this._onTimeout.bind(this);

        // xhr callbacks
        this._boundXhrOnError = this._xhrOnError.bind(this);
        this._boundXhrOnTimeout = this._xhrOnTimeout.bind(this);
        this._boundXhrOnAbort = this._xhrOnAbort.bind(this);
        this._boundXhrOnLoad = this._xhrOnLoad.bind(this);

        /**
         * Dispatched when the resource beings to load.
         *
         * The callback looks like {@link Resource.OnStartSignal}.
         *
         * @member {Signal<Resource.OnStartSignal>}
         */
        this.onStart = new _miniSignals2.default();

        /**
         * Dispatched each time progress of this resource load updates.
         * Not all resources types and loader systems can support this event
         * so sometimes it may not be available. If the resource
         * is being loaded on a modern browser, using XHR, and the remote server
         * properly sets Content-Length headers, then this will be available.
         *
         * The callback looks like {@link Resource.OnProgressSignal}.
         *
         * @member {Signal<Resource.OnProgressSignal>}
         */
        this.onProgress = new _miniSignals2.default();

        /**
         * Dispatched once this resource has loaded, if there was an error it will
         * be in the `error` property.
         *
         * The callback looks like {@link Resource.OnCompleteSignal}.
         *
         * @member {Signal<Resource.OnCompleteSignal>}
         */
        this.onComplete = new _miniSignals2.default();

        /**
         * Dispatched after this resource has had all the *after* middleware run on it.
         *
         * The callback looks like {@link Resource.OnCompleteSignal}.
         *
         * @member {Signal<Resource.OnCompleteSignal>}
         */
        this.onAfterMiddleware = new _miniSignals2.default();
    }

    /**
     * When the resource starts to load.
     *
     * @memberof Resource
     * @callback OnStartSignal
     * @param {Resource} resource - The resource that the event happened on.
     */

    /**
     * When the resource reports loading progress.
     *
     * @memberof Resource
     * @callback OnProgressSignal
     * @param {Resource} resource - The resource that the event happened on.
     * @param {number} percentage - The progress of the load in the range [0, 1].
     */

    /**
     * When the resource finishes loading.
     *
     * @memberof Resource
     * @callback OnCompleteSignal
     * @param {Resource} resource - The resource that the event happened on.
     */

    /**
     * @memberof Resource
     * @typedef {object} IMetadata
     * @property {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [loadElement=null] - The
     *      element to use for loading, instead of creating one.
     * @property {boolean} [skipSource=false] - Skips adding source(s) to the load element. This
     *      is useful if you want to pass in a `loadElement` that you already added load sources to.
     * @property {string|string[]} [mimeType] - The mime type to use for the source element
     *      of a video/audio elment. If the urls are an array, you can pass this as an array as well
     *      where each index is the mime type to use for the corresponding url index.
     */

    /**
     * Stores whether or not this url is a data url.
     *
     * @readonly
     * @member {boolean}
     */

    /**
     * Marks the resource as complete.
     *
     */
    Resource.prototype.complete = function complete() {
        this._clearEvents();
        this._finish();
    };

    /**
     * Aborts the loading of this resource, with an optional message.
     *
     * @param {string} message - The message to use for the error
     */

    Resource.prototype.abort = function abort(message) {
        // abort can be called multiple times, ignore subsequent calls.
        if (this.error) {
            return;
        }

        // store error
        this.error = new Error(message);

        // clear events before calling aborts
        this._clearEvents();

        // abort the actual loading
        if (this.xhr) {
            this.xhr.abort();
        } else if (this.xdr) {
            this.xdr.abort();
        } else if (this.data) {
            // single source
            if (this.data.src) {
                this.data.src = Resource.EMPTY_GIF;
            }
            // multi-source
            else {
                    while (this.data.firstChild) {
                        this.data.removeChild(this.data.firstChild);
                    }
                }
        }

        // done now.
        this._finish();
    };

    /**
     * Kicks off loading of this resource. This method is asynchronous.
     *
     * @param {Resource.OnCompleteSignal} [cb] - Optional callback to call once the resource is loaded.
     */

    Resource.prototype.load = function load(cb) {
        var _this = this;

        if (this.isLoading) {
            return;
        }

        if (this.isComplete) {
            if (cb) {
                setTimeout(function () {
                    return cb(_this);
                }, 1);
            }

            return;
        } else if (cb) {
            this.onComplete.once(cb);
        }

        this._setFlag(Resource.STATUS_FLAGS.LOADING, true);

        this.onStart.dispatch(this);

        // if unset, determine the value
        if (this.crossOrigin === false || typeof this.crossOrigin !== 'string') {
            this.crossOrigin = this._determineCrossOrigin(this.url);
        }

        switch (this.loadType) {
            case Resource.LOAD_TYPE.IMAGE:
                this.type = Resource.TYPE.IMAGE;
                this._loadElement('image');
                break;

            case Resource.LOAD_TYPE.AUDIO:
                this.type = Resource.TYPE.AUDIO;
                this._loadSourceElement('audio');
                break;

            case Resource.LOAD_TYPE.VIDEO:
                this.type = Resource.TYPE.VIDEO;
                this._loadSourceElement('video');
                break;

            case Resource.LOAD_TYPE.XHR:
            /* falls through */
            default:
                if (useXdr && this.crossOrigin) {
                    this._loadXdr();
                } else {
                    this._loadXhr();
                }
                break;
        }
    };

    /**
     * Checks if the flag is set.
     *
     * @private
     * @param {number} flag - The flag to check.
     * @return {boolean} True if the flag is set.
     */

    Resource.prototype._hasFlag = function _hasFlag(flag) {
        return (this._flags & flag) !== 0;
    };

    /**
     * (Un)Sets the flag.
     *
     * @private
     * @param {number} flag - The flag to (un)set.
     * @param {boolean} value - Whether to set or (un)set the flag.
     */

    Resource.prototype._setFlag = function _setFlag(flag, value) {
        this._flags = value ? this._flags | flag : this._flags & ~flag;
    };

    /**
     * Clears all the events from the underlying loading source.
     *
     * @private
     */

    Resource.prototype._clearEvents = function _clearEvents() {
        clearTimeout(this._elementTimer);

        if (this.data && this.data.removeEventListener) {
            this.data.removeEventListener('error', this._boundOnError, false);
            this.data.removeEventListener('load', this._boundComplete, false);
            this.data.removeEventListener('progress', this._boundOnProgress, false);
            this.data.removeEventListener('canplaythrough', this._boundComplete, false);
        }

        if (this.xhr) {
            if (this.xhr.removeEventListener) {
                this.xhr.removeEventListener('error', this._boundXhrOnError, false);
                this.xhr.removeEventListener('timeout', this._boundXhrOnTimeout, false);
                this.xhr.removeEventListener('abort', this._boundXhrOnAbort, false);
                this.xhr.removeEventListener('progress', this._boundOnProgress, false);
                this.xhr.removeEventListener('load', this._boundXhrOnLoad, false);
            } else {
                this.xhr.onerror = null;
                this.xhr.ontimeout = null;
                this.xhr.onprogress = null;
                this.xhr.onload = null;
            }
        }
    };

    /**
     * Finalizes the load.
     *
     * @private
     */

    Resource.prototype._finish = function _finish() {
        if (this.isComplete) {
            throw new Error('Complete called again for an already completed resource.');
        }

        this._setFlag(Resource.STATUS_FLAGS.COMPLETE, true);
        this._setFlag(Resource.STATUS_FLAGS.LOADING, false);

        this.onComplete.dispatch(this);
    };

    /**
     * Loads this resources using an element that has a single source,
     * like an HTMLImageElement.
     *
     * @private
     * @param {string} type - The type of element to use.
     */

    Resource.prototype._loadElement = function _loadElement(type) {
        if (this.metadata.loadElement) {
            this.data = this.metadata.loadElement;
        } else if (type === 'image' && typeof window.Image !== 'undefined') {
            this.data = new Image();
        } else {
            this.data = document.createElement(type);
        }

        if (this.crossOrigin) {
            this.data.crossOrigin = this.crossOrigin;
        }

        if (!this.metadata.skipSource) {
            this.data.src = this.url;
        }

        this.data.addEventListener('error', this._boundOnError, false);
        this.data.addEventListener('load', this._boundComplete, false);
        this.data.addEventListener('progress', this._boundOnProgress, false);

        if (this.timeout) {
            this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
        }
    };

    /**
     * Loads this resources using an element that has multiple sources,
     * like an HTMLAudioElement or HTMLVideoElement.
     *
     * @private
     * @param {string} type - The type of element to use.
     */

    Resource.prototype._loadSourceElement = function _loadSourceElement(type) {
        if (this.metadata.loadElement) {
            this.data = this.metadata.loadElement;
        } else if (type === 'audio' && typeof window.Audio !== 'undefined') {
            this.data = new Audio();
        } else {
            this.data = document.createElement(type);
        }

        if (this.data === null) {
            this.abort('Unsupported element: ' + type);

            return;
        }

        if (this.crossOrigin) {
            this.data.crossOrigin = this.crossOrigin;
        }

        if (!this.metadata.skipSource) {
            // support for CocoonJS Canvas+ runtime, lacks document.createElement('source')
            if (navigator.isCocoonJS) {
                this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
            } else if (Array.isArray(this.url)) {
                var mimeTypes = this.metadata.mimeType;

                for (var i = 0; i < this.url.length; ++i) {
                    this.data.appendChild(this._createSource(type, this.url[i], Array.isArray(mimeTypes) ? mimeTypes[i] : mimeTypes));
                }
            } else {
                var _mimeTypes = this.metadata.mimeType;

                this.data.appendChild(this._createSource(type, this.url, Array.isArray(_mimeTypes) ? _mimeTypes[0] : _mimeTypes));
            }
        }

        this.data.addEventListener('error', this._boundOnError, false);
        this.data.addEventListener('load', this._boundComplete, false);
        this.data.addEventListener('progress', this._boundOnProgress, false);
        this.data.addEventListener('canplaythrough', this._boundComplete, false);

        this.data.load();

        if (this.timeout) {
            this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
        }
    };

    /**
     * Loads this resources using an XMLHttpRequest.
     *
     * @private
     */

    Resource.prototype._loadXhr = function _loadXhr() {
        // if unset, determine the value
        if (typeof this.xhrType !== 'string') {
            this.xhrType = this._determineXhrType();
        }

        var xhr = this.xhr = new XMLHttpRequest();

        // set the request type and url
        xhr.open('GET', this.url, true);

        xhr.timeout = this.timeout;

        // load json as text and parse it ourselves. We do this because some browsers
        // *cough* safari *cough* can't deal with it.
        if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON || this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
            xhr.responseType = Resource.XHR_RESPONSE_TYPE.TEXT;
        } else {
            xhr.responseType = this.xhrType;
        }

        xhr.addEventListener('error', this._boundXhrOnError, false);
        xhr.addEventListener('timeout', this._boundXhrOnTimeout, false);
        xhr.addEventListener('abort', this._boundXhrOnAbort, false);
        xhr.addEventListener('progress', this._boundOnProgress, false);
        xhr.addEventListener('load', this._boundXhrOnLoad, false);

        xhr.send();
    };

    /**
     * Loads this resources using an XDomainRequest. This is here because we need to support IE9 (gross).
     *
     * @private
     */

    Resource.prototype._loadXdr = function _loadXdr() {
        // if unset, determine the value
        if (typeof this.xhrType !== 'string') {
            this.xhrType = this._determineXhrType();
        }

        var xdr = this.xhr = new XDomainRequest(); // eslint-disable-line no-undef

        // XDomainRequest has a few quirks. Occasionally it will abort requests
        // A way to avoid this is to make sure ALL callbacks are set even if not used
        // More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9
        xdr.timeout = this.timeout || 5000; // XDR needs a timeout value or it breaks in IE9

        xdr.onerror = this._boundXhrOnError;
        xdr.ontimeout = this._boundXhrOnTimeout;
        xdr.onprogress = this._boundOnProgress;
        xdr.onload = this._boundXhrOnLoad;

        xdr.open('GET', this.url, true);

        // Note: The xdr.send() call is wrapped in a timeout to prevent an
        // issue with the interface where some requests are lost if multiple
        // XDomainRequests are being sent at the same time.
        // Some info here: https://github.com/photonstorm/phaser/issues/1248
        setTimeout(function () {
            return xdr.send();
        }, 1);
    };

    /**
     * Creates a source used in loading via an element.
     *
     * @private
     * @param {string} type - The element type (video or audio).
     * @param {string} url - The source URL to load from.
     * @param {string} [mime] - The mime type of the video
     * @return {HTMLSourceElement} The source element.
     */

    Resource.prototype._createSource = function _createSource(type, url, mime) {
        if (!mime) {
            mime = type + '/' + this._getExtension(url);
        }

        var source = document.createElement('source');

        source.src = url;
        source.type = mime;

        return source;
    };

    /**
     * Called if a load errors out.
     *
     * @param {Event} event - The error event from the element that emits it.
     * @private
     */

    Resource.prototype._onError = function _onError(event) {
        this.abort('Failed to load element using: ' + event.target.nodeName);
    };

    /**
     * Called if a load progress event fires for an element or xhr/xdr.
     *
     * @private
     * @param {XMLHttpRequestProgressEvent|Event} event - Progress event.
     */

    Resource.prototype._onProgress = function _onProgress(event) {
        if (event && event.lengthComputable) {
            this.onProgress.dispatch(this, event.loaded / event.total);
        }
    };

    /**
     * Called if a timeout event fires for an element.
     *
     * @private
     */

    Resource.prototype._onTimeout = function _onTimeout() {
        this.abort('Load timed out.');
    };

    /**
     * Called if an error event fires for xhr/xdr.
     *
     * @private
     */

    Resource.prototype._xhrOnError = function _xhrOnError() {
        var xhr = this.xhr;

        this.abort(reqType(xhr) + ' Request failed. Status: ' + xhr.status + ', text: "' + xhr.statusText + '"');
    };

    /**
     * Called if an error event fires for xhr/xdr.
     *
     * @private
     */

    Resource.prototype._xhrOnTimeout = function _xhrOnTimeout() {
        var xhr = this.xhr;

        this.abort(reqType(xhr) + ' Request timed out.');
    };

    /**
     * Called if an abort event fires for xhr/xdr.
     *
     * @private
     */

    Resource.prototype._xhrOnAbort = function _xhrOnAbort() {
        var xhr = this.xhr;

        this.abort(reqType(xhr) + ' Request was aborted by the user.');
    };

    /**
     * Called when data successfully loads from an xhr/xdr request.
     *
     * @private
     * @param {XMLHttpRequestLoadEvent|Event} event - Load event
     */

    Resource.prototype._xhrOnLoad = function _xhrOnLoad() {
        var xhr = this.xhr;
        var text = '';
        var status = typeof xhr.status === 'undefined' ? STATUS_OK : xhr.status; // XDR has no `.status`, assume 200.

        // responseText is accessible only if responseType is '' or 'text' and on older browsers
        if (xhr.responseType === '' || xhr.responseType === 'text' || typeof xhr.responseType === 'undefined') {
            text = xhr.responseText;
        }

        // status can be 0 when using the `file://` protocol so we also check if a response is set.
        // If it has a response, we assume 200; otherwise a 0 status code with no contents is an aborted request.
        if (status === STATUS_NONE && (text.length > 0 || xhr.responseType === Resource.XHR_RESPONSE_TYPE.BUFFER)) {
            status = STATUS_OK;
        }
        // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
        else if (status === STATUS_IE_BUG_EMPTY) {
                status = STATUS_EMPTY;
            }

        var statusType = status / 100 | 0;

        if (statusType === STATUS_TYPE_OK) {
            // if text, just return it
            if (this.xhrType === Resource.XHR_RESPONSE_TYPE.TEXT) {
                this.data = text;
                this.type = Resource.TYPE.TEXT;
            }
            // if json, parse into json object
            else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON) {
                    try {
                        this.data = JSON.parse(text);
                        this.type = Resource.TYPE.JSON;
                    } catch (e) {
                        this.abort('Error trying to parse loaded json: ' + e);

                        return;
                    }
                }
                // if xml, parse into an xml document or div element
                else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
                        try {
                            if (window.DOMParser) {
                                var domparser = new DOMParser();

                                this.data = domparser.parseFromString(text, 'text/xml');
                            } else {
                                var div = document.createElement('div');

                                div.innerHTML = text;

                                this.data = div;
                            }

                            this.type = Resource.TYPE.XML;
                        } catch (e) {
                            this.abort('Error trying to parse loaded xml: ' + e);

                            return;
                        }
                    }
                    // other types just return the response
                    else {
                            this.data = xhr.response || text;
                        }
        } else {
            this.abort('[' + xhr.status + '] ' + xhr.statusText + ': ' + xhr.responseURL);

            return;
        }

        this.complete();
    };

    /**
     * Sets the `crossOrigin` property for this resource based on if the url
     * for this resource is cross-origin. If crossOrigin was manually set, this
     * function does nothing.
     *
     * @private
     * @param {string} url - The url to test.
     * @param {object} [loc=window.location] - The location object to test against.
     * @return {string} The crossOrigin value to use (or empty string for none).
     */

    Resource.prototype._determineCrossOrigin = function _determineCrossOrigin(url, loc) {
        // data: and javascript: urls are considered same-origin
        if (url.indexOf('data:') === 0) {
            return '';
        }

        // A sandboxed iframe without the 'allow-same-origin' attribute will have a special
        // origin designed not to match window.location.origin, and will always require
        // crossOrigin requests regardless of whether the location matches.
        if (window.origin !== window.location.origin) {
            return 'anonymous';
        }

        // default is window.location
        loc = loc || window.location;

        if (!tempAnchor) {
            tempAnchor = document.createElement('a');
        }

        // let the browser determine the full href for the url of this resource and then
        // parse with the node url lib, we can't use the properties of the anchor element
        // because they don't work in IE9 :(
        tempAnchor.href = url;
        url = (0, _parseUri2.default)(tempAnchor.href, { strictMode: true });

        var samePort = !url.port && loc.port === '' || url.port === loc.port;
        var protocol = url.protocol ? url.protocol + ':' : '';

        // if cross origin
        if (url.host !== loc.hostname || !samePort || protocol !== loc.protocol) {
            return 'anonymous';
        }

        return '';
    };

    /**
     * Determines the responseType of an XHR request based on the extension of the
     * resource being loaded.
     *
     * @private
     * @return {Resource.XHR_RESPONSE_TYPE} The responseType to use.
     */

    Resource.prototype._determineXhrType = function _determineXhrType() {
        return Resource._xhrTypeMap[this.extension] || Resource.XHR_RESPONSE_TYPE.TEXT;
    };

    /**
     * Determines the loadType of a resource based on the extension of the
     * resource being loaded.
     *
     * @private
     * @return {Resource.LOAD_TYPE} The loadType to use.
     */

    Resource.prototype._determineLoadType = function _determineLoadType() {
        return Resource._loadTypeMap[this.extension] || Resource.LOAD_TYPE.XHR;
    };

    /**
     * Extracts the extension (sans '.') of the file being loaded by the resource.
     *
     * @private
     * @return {string} The extension.
     */

    Resource.prototype._getExtension = function _getExtension() {
        var url = this.url;
        var ext = '';

        if (this.isDataUrl) {
            var slashIndex = url.indexOf('/');

            ext = url.substring(slashIndex + 1, url.indexOf(';', slashIndex));
        } else {
            var queryStart = url.indexOf('?');
            var hashStart = url.indexOf('#');
            var index = Math.min(queryStart > -1 ? queryStart : url.length, hashStart > -1 ? hashStart : url.length);

            url = url.substring(0, index);
            ext = url.substring(url.lastIndexOf('.') + 1);
        }

        return ext.toLowerCase();
    };

    /**
     * Determines the mime type of an XHR request based on the responseType of
     * resource being loaded.
     *
     * @private
     * @param {Resource.XHR_RESPONSE_TYPE} type - The type to get a mime type for.
     * @return {string} The mime type to use.
     */

    Resource.prototype._getMimeFromXhrType = function _getMimeFromXhrType(type) {
        switch (type) {
            case Resource.XHR_RESPONSE_TYPE.BUFFER:
                return 'application/octet-binary';

            case Resource.XHR_RESPONSE_TYPE.BLOB:
                return 'application/blob';

            case Resource.XHR_RESPONSE_TYPE.DOCUMENT:
                return 'application/xml';

            case Resource.XHR_RESPONSE_TYPE.JSON:
                return 'application/json';

            case Resource.XHR_RESPONSE_TYPE.DEFAULT:
            case Resource.XHR_RESPONSE_TYPE.TEXT:
            /* falls through */
            default:
                return 'text/plain';
        }
    };

    _createClass(Resource, [{
        key: 'isDataUrl',
        get: function get() {
            return this._hasFlag(Resource.STATUS_FLAGS.DATA_URL);
        }

        /**
         * Describes if this resource has finished loading. Is true when the resource has completely
         * loaded.
         *
         * @readonly
         * @member {boolean}
         */

    }, {
        key: 'isComplete',
        get: function get() {
            return this._hasFlag(Resource.STATUS_FLAGS.COMPLETE);
        }

        /**
         * Describes if this resource is currently loading. Is true when the resource starts loading,
         * and is false again when complete.
         *
         * @readonly
         * @member {boolean}
         */

    }, {
        key: 'isLoading',
        get: function get() {
            return this._hasFlag(Resource.STATUS_FLAGS.LOADING);
        }
    }]);

    return Resource;
}();

/**
 * The types of resources a resource could represent.
 *
 * @static
 * @readonly
 * @enum {number}
 */

Resource.STATUS_FLAGS = {
    NONE: 0,
    DATA_URL: 1 << 0,
    COMPLETE: 1 << 1,
    LOADING: 1 << 2
};

/**
 * The types of resources a resource could represent.
 *
 * @static
 * @readonly
 * @enum {number}
 */
Resource.TYPE = {
    UNKNOWN: 0,
    JSON: 1,
    XML: 2,
    IMAGE: 3,
    AUDIO: 4,
    VIDEO: 5,
    TEXT: 6
};

/**
 * The types of loading a resource can use.
 *
 * @static
 * @readonly
 * @enum {number}
 */
Resource.LOAD_TYPE = {
    /** Uses XMLHttpRequest to load the resource. */
    XHR: 1,
    /** Uses an `Image` object to load the resource. */
    IMAGE: 2,
    /** Uses an `Audio` object to load the resource. */
    AUDIO: 3,
    /** Uses a `Video` object to load the resource. */
    VIDEO: 4
};

/**
 * The XHR ready states, used internally.
 *
 * @static
 * @readonly
 * @enum {string}
 */
Resource.XHR_RESPONSE_TYPE = {
    /** string */
    DEFAULT: 'text',
    /** ArrayBuffer */
    BUFFER: 'arraybuffer',
    /** Blob */
    BLOB: 'blob',
    /** Document */
    DOCUMENT: 'document',
    /** Object */
    JSON: 'json',
    /** String */
    TEXT: 'text'
};

Resource._loadTypeMap = {
    // images
    gif: Resource.LOAD_TYPE.IMAGE,
    png: Resource.LOAD_TYPE.IMAGE,
    bmp: Resource.LOAD_TYPE.IMAGE,
    jpg: Resource.LOAD_TYPE.IMAGE,
    jpeg: Resource.LOAD_TYPE.IMAGE,
    tif: Resource.LOAD_TYPE.IMAGE,
    tiff: Resource.LOAD_TYPE.IMAGE,
    webp: Resource.LOAD_TYPE.IMAGE,
    tga: Resource.LOAD_TYPE.IMAGE,
    svg: Resource.LOAD_TYPE.IMAGE,
    'svg+xml': Resource.LOAD_TYPE.IMAGE, // for SVG data urls

    // audio
    mp3: Resource.LOAD_TYPE.AUDIO,
    ogg: Resource.LOAD_TYPE.AUDIO,
    wav: Resource.LOAD_TYPE.AUDIO,

    // videos
    mp4: Resource.LOAD_TYPE.VIDEO,
    webm: Resource.LOAD_TYPE.VIDEO
};

Resource._xhrTypeMap = {
    // xml
    xhtml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    html: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    htm: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    xml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    tmx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    svg: Resource.XHR_RESPONSE_TYPE.DOCUMENT,

    // This was added to handle Tiled Tileset XML, but .tsx is also a TypeScript React Component.
    // Since it is way less likely for people to be loading TypeScript files instead of Tiled files,
    // this should probably be fine.
    tsx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,

    // images
    gif: Resource.XHR_RESPONSE_TYPE.BLOB,
    png: Resource.XHR_RESPONSE_TYPE.BLOB,
    bmp: Resource.XHR_RESPONSE_TYPE.BLOB,
    jpg: Resource.XHR_RESPONSE_TYPE.BLOB,
    jpeg: Resource.XHR_RESPONSE_TYPE.BLOB,
    tif: Resource.XHR_RESPONSE_TYPE.BLOB,
    tiff: Resource.XHR_RESPONSE_TYPE.BLOB,
    webp: Resource.XHR_RESPONSE_TYPE.BLOB,
    tga: Resource.XHR_RESPONSE_TYPE.BLOB,

    // json
    json: Resource.XHR_RESPONSE_TYPE.JSON,

    // text
    text: Resource.XHR_RESPONSE_TYPE.TEXT,
    txt: Resource.XHR_RESPONSE_TYPE.TEXT,

    // fonts
    ttf: Resource.XHR_RESPONSE_TYPE.BUFFER,
    otf: Resource.XHR_RESPONSE_TYPE.BUFFER
};

// We can't set the `src` attribute to empty string, so on abort we set it to this 1px transparent gif
Resource.EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

/**
 * Quick helper to set a value on one of the extension maps. Ensures there is no
 * dot at the start of the extension.
 *
 * @ignore
 * @param {object} map - The map to set on.
 * @param {string} extname - The extension (or key) to set.
 * @param {number} val - The value to set.
 */
function setExtMap(map, extname, val) {
    if (extname && extname.indexOf('.') === 0) {
        extname = extname.substring(1);
    }

    if (!extname) {
        return;
    }

    map[extname] = val;
}

/**
 * Quick helper to get string xhr type.
 *
 * @ignore
 * @param {XMLHttpRequest|XDomainRequest} xhr - The request to check.
 * @return {string} The type.
 */
function reqType(xhr) {
    return xhr.toString().replace('object ', '');
}

// Backwards compat
if (true) {
    module.exports.default = Resource; // eslint-disable-line no-undef
}
//# sourceMappingURL=Resource.js.map

/***/ }),

/***/ "F5z4":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__("KM04")) : typeof define === 'function' && define.amd ? define(['preact'], factory) : global['preact-async-route'] = factory(global.preact);
})(this, function (preact) {
	'use strict';

	var _extends = Object.assign || function (target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					target[key] = source[key];
				}
			}
		}return target;
	};

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var AsyncRoute = function (_Component) {
		_inherits(AsyncRoute, _Component);

		function AsyncRoute() {
			_classCallCheck(this, AsyncRoute);

			var _this = _possibleConstructorReturn(this, _Component.call(this));

			_this.state = {
				componentData: null
			};
			return _this;
		}

		AsyncRoute.prototype.loadComponent = function loadComponent() {
			var _this2 = this;

			if (this.props.component) {
				return this.setState({
					componentData: this.props.component
				});
			}
			var componentData = this.props.getComponent(this.props.url, function (_ref) {
				var component = _ref.component;

				// Named param for making callback future proof
				if (component) {
					_this2.setState({
						componentData: component
					});
				}
			}, _extends({}, this.props, this.props.matches));

			// In case returned value was a promise
			if (componentData && componentData.then) {
				// IIFE to check if a later ending promise was creating a race condition
				// Check test case for more info
				(function (url) {
					componentData.then(function (component) {
						if (url !== _this2.props.url) {
							_this2.setState({ componentData: null }, function () {
								_this2.loadComponent();
							});
							return;
						}
						_this2.setState({
							componentData: component
						});
					});
				})(this.props.url);
			}
		};

		AsyncRoute.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
			var _this3 = this;

			if (this.props.path && this.props.path !== nextProps.path) {
				this.setState({
					componentData: null
				}, function () {
					_this3.loadComponent();
				});
			}
		};

		AsyncRoute.prototype.componentWillMount = function componentWillMount() {
			this.loadComponent();
		};

		AsyncRoute.prototype.render = function render() {
			if (this.state.componentData) {
				return preact.h(this.state.componentData, this.props);
			} else if (this.props.loading) {
				var loadingComponent = this.props.loading();
				return loadingComponent;
			}
			return null;
		};

		return AsyncRoute;
	}(preact.Component);

	return AsyncRoute;
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "F9WP":
/***/ (function(module, exports) {

/**
 * Sets the float precision on the shader. If the precision is already present this function will do nothing
 * @param {string} src       the shader source
 * @param {string} precision The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
 *
 * @return {string} modified shader source
 */
var setPrecision = function setPrecision(src, precision) {
    if (src.substring(0, 9) !== 'precision') {
        return 'precision ' + precision + ' float;\n' + src;
    }

    return src;
};

module.exports = setPrecision;

/***/ }),

/***/ "FIMm":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function (root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module && !module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
		root = freeGlobal;
	}

	/**
  * The `punycode` object.
  * @name punycode
  * @type Object
  */
	var punycode,


	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647,
	    // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	    tMin = 1,
	    tMax = 26,
	    skew = 38,
	    damp = 700,
	    initialBias = 72,
	    initialN = 128,
	    // 0x80
	delimiter = '-',
	    // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	    regexNonASCII = /[^\x20-\x7E]/,
	    // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
	    // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},


	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	    floor = Math.floor,
	    stringFromCharCode = String.fromCharCode,


	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
  * A generic error utility function.
  * @private
  * @param {String} type The error type.
  * @returns {Error} Throws a `RangeError` with the applicable error message.
  */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
  * A generic `Array#map` utility function.
  * @private
  * @param {Array} array The array to iterate over.
  * @param {Function} callback The function that gets called for every array
  * item.
  * @returns {Array} A new array of values returned by the callback function.
  */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
  * A simple `Array#map`-like wrapper to work with domain name strings or email
  * addresses.
  * @private
  * @param {String} domain The domain name or email address.
  * @param {Function} callback The function that gets called for every
  * character.
  * @returns {Array} A new string of characters returned by the callback
  * function.
  */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
  * Creates an array containing the numeric code points of each Unicode
  * character in the string. While JavaScript uses UCS-2 internally,
  * this function will convert a pair of surrogate halves (each of which
  * UCS-2 exposes as separate characters) into a single code point,
  * matching UTF-16.
  * @see `punycode.ucs2.encode`
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode.ucs2
  * @name decode
  * @param {String} string The Unicode input string (UCS-2).
  * @returns {Array} The new array of code points.
  */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) {
					// low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
  * Creates a string based on an array of numeric code points.
  * @see `punycode.ucs2.decode`
  * @memberOf punycode.ucs2
  * @name encode
  * @param {Array} codePoints The array of numeric code points.
  * @returns {String} The new Unicode string (UCS-2).
  */
	function ucs2encode(array) {
		return map(array, function (value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
  * Converts a basic code point into a digit/integer.
  * @see `digitToBasic()`
  * @private
  * @param {Number} codePoint The basic numeric code point value.
  * @returns {Number} The numeric value of a basic code point (for use in
  * representing integers) in the range `0` to `base - 1`, or `base` if
  * the code point does not represent a value.
  */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
  * Converts a digit/integer into a basic code point.
  * @see `basicToDigit()`
  * @private
  * @param {Number} digit The numeric value of a basic code point.
  * @returns {Number} The basic code point whose value (when used for
  * representing integers) is `digit`, which needs to be in the range
  * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
  * used; else, the lowercase form is used. The behavior is undefined
  * if `flag` is non-zero and `digit` has no uppercase form.
  */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
  * Bias adaptation function as per section 3.4 of RFC 3492.
  * https://tools.ietf.org/html/rfc3492#section-3.4
  * @private
  */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
  * Converts a Punycode string of ASCII-only symbols to a string of Unicode
  * symbols.
  * @memberOf punycode
  * @param {String} input The Punycode string of ASCII-only symbols.
  * @returns {String} The resulting string of Unicode symbols.
  */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,

		/** Cached calculation results */
		baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base;; /* no condition */k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;
			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);
		}

		return ucs2encode(output);
	}

	/**
  * Converts a string of Unicode symbols (e.g. a domain name label) to a
  * Punycode string of ASCII-only symbols.
  * @memberOf punycode
  * @param {String} input The string of Unicode symbols.
  * @returns {String} The resulting Punycode string of ASCII-only symbols.
  */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],

		/** `inputLength` will hold the number of code points in `input`. */
		inputLength,

		/** Cached calculation results */
		handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base;; /* no condition */k += base) {
						t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;
		}
		return output.join('');
	}

	/**
  * Converts a Punycode string representing a domain name or an email address
  * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
  * it doesn't matter if you call it on a string that has already been
  * converted to Unicode.
  * @memberOf punycode
  * @param {String} input The Punycoded domain name or email address to
  * convert to Unicode.
  * @returns {String} The Unicode representation of the given Punycode
  * string.
  */
	function toUnicode(input) {
		return mapDomain(input, function (string) {
			return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
		});
	}

	/**
  * Converts a Unicode string representing a domain name or an email address to
  * Punycode. Only the non-ASCII parts of the domain name will be converted,
  * i.e. it doesn't matter if you call it with a domain that's already in
  * ASCII.
  * @memberOf punycode
  * @param {String} input The domain name or email address to convert, as a
  * Unicode string.
  * @returns {String} The Punycode representation of the given domain name or
  * email address.
  */
	function toASCII(input) {
		return mapDomain(input, function (string) {
			return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
		'version': '1.4.1',
		/**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}
})(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("l262")(module), __webpack_require__("h6ac")))

/***/ }),

/***/ "FQbN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("Ywoo");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement('div', { className: className, role: 'columnheader' }, _react2.default.createElement('abbr', { title: title }, content));
    }
  }]);

  return Weekday;
}(_react.Component);

exports.default = Weekday;
Weekday.propTypes =  false ? {
  weekday: _propTypes2.default.number,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,

  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
} : {};
//# sourceMappingURL=Weekday.js.map

/***/ }),

/***/ "FRMY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2868f1349014531ca7cbed01a42420a4.svg";

/***/ }),

/***/ "FULv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5fd34436cffb5b85fff31c4e892df121.svg";

/***/ }),

/***/ "FXvN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__("b4C7");

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;

/***/ }),

/***/ "FYdd":
/***/ (function(module, exports) {

module.exports = function parseBMFontAscii(data) {
  if (!data) throw new Error('no data provided');
  data = data.toString().trim();

  var output = {
    pages: [],
    chars: [],
    kernings: []
  };

  var lines = data.split(/\r\n?|\n/g);

  if (lines.length === 0) throw new Error('no data in BMFont file');

  for (var i = 0; i < lines.length; i++) {
    var lineData = splitLine(lines[i], i);
    if (!lineData) //skip empty lines
      continue;

    if (lineData.key === 'page') {
      if (typeof lineData.data.id !== 'number') throw new Error('malformed file at line ' + i + ' -- needs page id=N');
      if (typeof lineData.data.file !== 'string') throw new Error('malformed file at line ' + i + ' -- needs page file="path"');
      output.pages[lineData.data.id] = lineData.data.file;
    } else if (lineData.key === 'chars' || lineData.key === 'kernings') {
      //... do nothing for these two ...
    } else if (lineData.key === 'char') {
      output.chars.push(lineData.data);
    } else if (lineData.key === 'kerning') {
      output.kernings.push(lineData.data);
    } else {
      output[lineData.key] = lineData.data;
    }
  }

  return output;
};

function splitLine(line, idx) {
  line = line.replace(/\t+/g, ' ').trim();
  if (!line) return null;

  var space = line.indexOf(' ');
  if (space === -1) throw new Error("no named row at line " + idx);

  var key = line.substring(0, space);

  line = line.substring(space + 1);
  //clear "letter" field as it is non-standard and
  //requires additional complexity to parse " / = symbols
  line = line.replace(/letter=[\'\"]\S+[\'\"]/gi, '');
  line = line.split("=");
  line = line.map(function (str) {
    return str.trim().match(/(".*?"|[^"\s]+)+(?=\s*|\s*$)/g);
  });

  var data = [];
  for (var i = 0; i < line.length; i++) {
    var dt = line[i];
    if (i === 0) {
      data.push({
        key: dt[0],
        data: ""
      });
    } else if (i === line.length - 1) {
      data[data.length - 1].data = parseData(dt[0]);
    } else {
      data[data.length - 1].data = parseData(dt[0]);
      data.push({
        key: dt[1],
        data: ""
      });
    }
  }

  var out = {
    key: key,
    data: {}
  };

  data.forEach(function (v) {
    out.data[v.key] = v.data;
  });

  return out;
}

function parseData(data) {
  if (!data || data.length === 0) return "";

  if (data.indexOf('"') === 0 || data.indexOf("'") === 0) return data.substring(1, data.length - 1);
  if (data.indexOf(',') !== -1) return parseIntList(data);
  return parseInt(data, 10);
}

function parseIntList(data) {
  return data.split(',').map(function (val) {
    return parseInt(val, 10);
  });
}

/***/ }),

/***/ "FcPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var Content = function Content(_ref) {
    var children = _ref.children,
        style = _ref.style;


    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'article',
        { style: style },
        children
    );
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),

/***/ "Ffi5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "31557c5eb8bac0dbf9067b2ed6ae9f7f.png";

/***/ }),

/***/ "FtW/":
/***/ (function(module, exports) {

// var GL_MAP = {};

/**
 * @param gl {WebGLRenderingContext} The current WebGL context
 * @param attribs {*}
 * @param state {*}
 */
var setVertexAttribArrays = function setVertexAttribArrays(gl, attribs, state) {
    var i;
    if (state) {
        var tempAttribState = state.tempAttribState,
            attribState = state.attribState;

        for (i = 0; i < tempAttribState.length; i++) {
            tempAttribState[i] = false;
        }

        // set the new attribs
        for (i = 0; i < attribs.length; i++) {
            tempAttribState[attribs[i].attribute.location] = true;
        }

        for (i = 0; i < attribState.length; i++) {
            if (attribState[i] !== tempAttribState[i]) {
                attribState[i] = tempAttribState[i];

                if (state.attribState[i]) {
                    gl.enableVertexAttribArray(i);
                } else {
                    gl.disableVertexAttribArray(i);
                }
            }
        }
    } else {
        for (i = 0; i < attribs.length; i++) {
            var attrib = attribs[i];
            gl.enableVertexAttribArray(attrib.attribute.location);
        }
    }
};

module.exports = setVertexAttribArrays;

/***/ }),

/***/ "Fu79":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Table_1 = __webpack_require__("QfCP");
var Seat_1 = __webpack_require__("S77k");

var Table = function (_Table_1$default) {
    _inherits(Table, _Table_1$default);

    function Table() {
        _classCallCheck(this, Table);

        return _possibleConstructorReturn(this, _Table_1$default.apply(this, arguments));
    }

    Table.prototype.draw = function draw() {
        this.setScales(this.seatData);
        this.tableInit(this.pos);
        this.seats = this.seatsInit(this.seatData, this.actions);
        this.seatContainer = this.getSeatContainer(this.pos);
        this.tableContainerInit(this.pos);
    };

    Table.prototype.seatsInit = function seatsInit(seats, disableInteraction) {
        var _this2 = this;

        var seatCount = seats.length;
        return seats.map(function (seat, i) {
            var constructionValue = _extends({ pos: _this2.getSeatPos(i, seatCount), seatlabelStartAt: _this2.seatlabelStartAt, bookByTable: _this2.bookByTable, tableId: _this2._id, sectionId: _this2.sectionId, sectionName: _this2.sectionName, tableName: _this2.name }, seat);
            return new Seat_1.default(constructionValue, _this2.actions, disableInteraction);
        });
    };

    return Table;
}(Table_1.default);

exports.default = Table;
//# sourceMappingURL=Table.js.map

/***/ }),

/***/ "FydA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _const = __webpack_require__("YEQi");

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * A set of functions used to handle masking.
 *
 * @class
 * @memberof PIXI
 */
var CanvasMaskManager = function () {
    /**
     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
     */
    function CanvasMaskManager(renderer) {
        _classCallCheck(this, CanvasMaskManager);

        this.renderer = renderer;
    }

    /**
     * This method adds it to the current stack of masks.
     *
     * @param {object} maskData - the maskData that will be pushed
     */

    CanvasMaskManager.prototype.pushMask = function pushMask(maskData) {
        var renderer = this.renderer;

        renderer.context.save();

        var cacheAlpha = maskData.alpha;
        var transform = maskData.transform.worldTransform;
        var resolution = renderer.resolution;

        renderer.context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);

        // TODO suport sprite alpha masks??
        // lots of effort required. If demand is great enough..
        if (!maskData._texture) {
            this.renderGraphicsShape(maskData);
            renderer.context.clip();
        }

        maskData.worldAlpha = cacheAlpha;
    };

    /**
     * Renders a PIXI.Graphics shape.
     *
     * @param {PIXI.Graphics} graphics - The object to render.
     */

    CanvasMaskManager.prototype.renderGraphicsShape = function renderGraphicsShape(graphics) {
        var context = this.renderer.context;
        var len = graphics.graphicsData.length;

        if (len === 0) {
            return;
        }

        context.beginPath();

        for (var i = 0; i < len; i++) {
            var data = graphics.graphicsData[i];
            var shape = data.shape;

            if (data.type === _const.SHAPES.POLY) {
                var points = shape.points;
                var holes = data.holes;
                var outerArea = void 0;
                var innerArea = void 0;

                context.moveTo(points[0], points[1]);

                for (var j = 2; j < points.length; j += 2) {
                    context.lineTo(points[j], points[j + 1]);
                }

                // if the first and last point are the same close the path - much neater :)
                if (points[0] === points[points.length - 2] && points[1] === points[points.length - 1]) {
                    context.closePath();
                }

                if (holes.length > 0) {
                    outerArea = 0;
                    for (var _j = 0; _j < points.length; _j += 2) {
                        outerArea += points[_j] * points[_j + 3] - points[_j + 1] * points[_j + 2];
                    }

                    for (var k = 0; k < holes.length; k++) {
                        points = holes[k].points;

                        innerArea = 0;
                        for (var _j2 = 0; _j2 < points.length; _j2 += 2) {
                            innerArea += points[_j2] * points[_j2 + 3] - points[_j2 + 1] * points[_j2 + 2];
                        }

                        context.moveTo(points[0], points[1]);

                        if (innerArea * outerArea < 0) {
                            for (var _j3 = 2; _j3 < points.length; _j3 += 2) {
                                context.lineTo(points[_j3], points[_j3 + 1]);
                            }
                        } else {
                            for (var _j4 = points.length - 2; _j4 >= 2; _j4 -= 2) {
                                context.lineTo(points[_j4], points[_j4 + 1]);
                            }
                        }
                    }
                }
            } else if (data.type === _const.SHAPES.RECT) {
                context.rect(shape.x, shape.y, shape.width, shape.height);
                context.closePath();
            } else if (data.type === _const.SHAPES.CIRC) {
                // TODO - need to be Undefined!
                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
                context.closePath();
            } else if (data.type === _const.SHAPES.ELIP) {
                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas

                var w = shape.width * 2;
                var h = shape.height * 2;

                var x = shape.x - w / 2;
                var y = shape.y - h / 2;

                var kappa = 0.5522848;
                var ox = w / 2 * kappa; // control point offset horizontal
                var oy = h / 2 * kappa; // control point offset vertical
                var xe = x + w; // x-end
                var ye = y + h; // y-end
                var xm = x + w / 2; // x-middle
                var ym = y + h / 2; // y-middle

                context.moveTo(x, ym);
                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
                context.closePath();
            } else if (data.type === _const.SHAPES.RREC) {
                var rx = shape.x;
                var ry = shape.y;
                var width = shape.width;
                var height = shape.height;
                var radius = shape.radius;

                var maxRadius = Math.min(width, height) / 2 | 0;

                radius = radius > maxRadius ? maxRadius : radius;

                context.moveTo(rx, ry + radius);
                context.lineTo(rx, ry + height - radius);
                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
                context.lineTo(rx + width - radius, ry + height);
                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
                context.lineTo(rx + width, ry + radius);
                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
                context.lineTo(rx + radius, ry);
                context.quadraticCurveTo(rx, ry, rx, ry + radius);
                context.closePath();
            }
        }
    };

    /**
     * Restores the current drawing context to the state it was before the mask was applied.
     *
     * @param {PIXI.CanvasRenderer} renderer - The renderer context to use.
     */

    CanvasMaskManager.prototype.popMask = function popMask(renderer) {
        renderer.context.restore();
        renderer.invalidateBlendMode();
    };

    /**
     * Destroys this canvas mask manager.
     *
     */

    CanvasMaskManager.prototype.destroy = function destroy() {
        /* empty */
    };

    return CanvasMaskManager;
}();

exports.default = CanvasMaskManager;
//# sourceMappingURL=CanvasMaskManager.js.map

/***/ }),

/***/ "GNKS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("WAcE");

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "GZIj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Penner = __webpack_require__("nx9B");

function exists(a) {
    return a !== undefined && a !== null;
}

function defaults(a, defaults) {
    return a !== undefined && a !== null ? a : defaults;
}

/**
 * @param {(function|string)} [ease]
 * @param {string} defaults for pennr equation
 * @private
 * @returns {function} correct penner equation
 */
function ease(ease, defaults) {
    if (!exists(ease)) {
        return Penner[defaults];
    } else if (typeof ease === 'function') {
        return ease;
    } else if (typeof ease === 'string') {
        return Penner[ease];
    }
}

module.exports = {
    exists: exists,
    defaults: defaults,
    ease: ease
};

/***/ }),

/***/ "Ga9O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = generateVertBlurSource;
var vertTemplate = ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform float strength;', 'uniform mat3 projectionMatrix;', 'varying vec2 vBlurTexCoords[%size%];', 'void main(void)', '{', 'gl_Position = vec4((projectionMatrix * vec3((aVertexPosition), 1.0)).xy, 0.0, 1.0);', '%blur%', '}'].join('\n');

function generateVertBlurSource(kernelSize, x) {
    var halfLength = Math.ceil(kernelSize / 2);

    var vertSource = vertTemplate;

    var blurLoop = '';
    var template = void 0;
    // let value;

    if (x) {
        template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(%sampleIndex% * strength, 0.0);';
    } else {
        template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(0.0, %sampleIndex% * strength);';
    }

    for (var i = 0; i < kernelSize; i++) {
        var blur = template.replace('%index%', i);

        // value = i;

        // if(i >= halfLength)
        // {
        //     value = kernelSize - i - 1;
        // }

        blur = blur.replace('%sampleIndex%', i - (halfLength - 1) + '.0');

        blurLoop += blur;
        blurLoop += '\n';
    }

    vertSource = vertSource.replace('%blur%', blurLoop);
    vertSource = vertSource.replace('%size%', kernelSize);

    return vertSource;
}
//# sourceMappingURL=generateBlurVertSource.js.map

/***/ }),

/***/ "GkT9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _path = __webpack_require__("UUq2");

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Simplest filter - applies alpha
 *
 * Use this instead of Container's alpha property to avoid visual layering of individual elements.
 * AlphaFilter applies alpha evenly across the entire display object and any opaque elements it contains.
 * If elements are not opaque, they will blend with each other anyway.
 *
 * Very handy if you want to use common features of all filters:
 *
 * 1. Assign a blendMode to this filter, blend all elements inside display object with background.
 *
 * 2. To use clipping in display coordinates, assign a filterArea to the same container that has this filter.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var AlphaFilter = function (_core$Filter) {
    _inherits(AlphaFilter, _core$Filter);

    /**
     * @param {number} [alpha=1] Amount of alpha from 0 to 1, where 0 is transparent
     */
    function AlphaFilter() {
        var alpha = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.0;

        _classCallCheck(this, AlphaFilter);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
        // fragment shader
        'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float uAlpha;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;\n}\n'));

        _this.alpha = alpha;
        _this.glShaderKey = 'alpha';
        return _this;
    }

    /**
     * Coefficient for alpha multiplication
     *
     * @member {number}
     * @default 1
     */

    _createClass(AlphaFilter, [{
        key: 'alpha',
        get: function get() {
            return this.uniforms.uAlpha;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.uAlpha = value;
        }
    }]);

    return AlphaFilter;
}(core.Filter);

exports.default = AlphaFilter;
//# sourceMappingURL=AlphaFilter.js.map

/***/ }),

/***/ "GkaI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = checkMaxIfStatmentsInShader;

var _pixiGlCore = __webpack_require__("PJsv");

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var fragTemplate = ['precision mediump float;', 'void main(void){', 'float test = 0.1;', '%forloop%', 'gl_FragColor = vec4(0.0);', '}'].join('\n');

function checkMaxIfStatmentsInShader(maxIfs, gl) {
    var createTempContext = !gl;

    // @if DEBUG
    if (maxIfs === 0) {
        throw new Error('Invalid value of `0` passed to `checkMaxIfStatementsInShader`');
    }
    // @endif

    if (createTempContext) {
        var tinyCanvas = document.createElement('canvas');

        tinyCanvas.width = 1;
        tinyCanvas.height = 1;

        gl = _pixiGlCore2.default.createContext(tinyCanvas);
    }

    var shader = gl.createShader(gl.FRAGMENT_SHADER);

    while (true) // eslint-disable-line no-constant-condition
    {
        var fragmentSrc = fragTemplate.replace(/%forloop%/gi, generateIfTestSrc(maxIfs));

        gl.shaderSource(shader, fragmentSrc);
        gl.compileShader(shader);

        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            maxIfs = maxIfs / 2 | 0;
        } else {
            // valid!
            break;
        }
    }

    if (createTempContext) {
        // get rid of context
        if (gl.getExtension('WEBGL_lose_context')) {
            gl.getExtension('WEBGL_lose_context').loseContext();
        }
    }

    return maxIfs;
}

function generateIfTestSrc(maxIfs) {
    var src = '';

    for (var i = 0; i < maxIfs; ++i) {
        if (i > 0) {
            src += '\nelse ';
        }

        if (i < maxIfs - 1) {
            src += 'if(test == ' + i + '.0){}';
        }
    }

    return src;
}
//# sourceMappingURL=checkMaxIfStatmentsInShader.js.map

/***/ }),

/***/ "Gv70":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var MapObject_1 = __webpack_require__("KM7c");

var GeneralObject = function (_MapObject_1$default) {
  _inherits(GeneralObject, _MapObject_1$default);

  function GeneralObject() {
    _classCallCheck(this, GeneralObject);

    return _possibleConstructorReturn(this, _MapObject_1$default.apply(this, arguments));
  }

  return GeneralObject;
}(MapObject_1.default);

exports.default = GeneralObject;
//# sourceMappingURL=GeneralObject.js.map

/***/ }),

/***/ "GzOR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _SystemRenderer2 = __webpack_require__("Hz2Z");

var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);

var _CanvasMaskManager = __webpack_require__("FydA");

var _CanvasMaskManager2 = _interopRequireDefault(_CanvasMaskManager);

var _CanvasRenderTarget = __webpack_require__("khQn");

var _CanvasRenderTarget2 = _interopRequireDefault(_CanvasRenderTarget);

var _mapCanvasBlendModesToPixi = __webpack_require__("pZ9z");

var _mapCanvasBlendModesToPixi2 = _interopRequireDefault(_mapCanvasBlendModesToPixi);

var _utils = __webpack_require__("dDI1");

var _const = __webpack_require__("YEQi");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The CanvasRenderer draws the scene and all its content onto a 2d canvas. This renderer should
 * be used for browsers that do not support WebGL. Don't forget to add the CanvasRenderer.view to
 * your DOM or you will not see anything :)
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.SystemRenderer
 */
var CanvasRenderer = function (_SystemRenderer) {
    _inherits(CanvasRenderer, _SystemRenderer);

    // eslint-disable-next-line valid-jsdoc
    /**
     * @param {object} [options] - The optional renderer parameters
     * @param {number} [options.width=800] - the width of the screen
     * @param {number} [options.height=600] - the height of the screen
     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
     * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
     *  resolution of the renderer retina would be 2.
     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
     *  enable this if you need to call toDataUrl on the webgl context.
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
     *      not before the new render pass.
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
     *  stopping pixel interpolation.
     */
    function CanvasRenderer(options, arg2, arg3) {
        _classCallCheck(this, CanvasRenderer);

        var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'Canvas', options, arg2, arg3));

        _this.type = _const.RENDERER_TYPE.CANVAS;

        /**
         * The root canvas 2d context that everything is drawn with.
         *
         * @member {CanvasRenderingContext2D}
         */
        _this.rootContext = _this.view.getContext('2d', { alpha: _this.transparent });

        /**
         * The currently active canvas 2d context (could change with renderTextures)
         *
         * @member {CanvasRenderingContext2D}
         */
        _this.context = _this.rootContext;

        /**
         * Boolean flag controlling canvas refresh.
         *
         * @member {boolean}
         */
        _this.refresh = true;

        /**
         * Instance of a CanvasMaskManager, handles masking when using the canvas renderer.
         *
         * @member {PIXI.CanvasMaskManager}
         */
        _this.maskManager = new _CanvasMaskManager2.default(_this);

        /**
         * The canvas property used to set the canvas smoothing property.
         *
         * @member {string}
         */
        _this.smoothProperty = 'imageSmoothingEnabled';

        if (!_this.rootContext.imageSmoothingEnabled) {
            if (_this.rootContext.webkitImageSmoothingEnabled) {
                _this.smoothProperty = 'webkitImageSmoothingEnabled';
            } else if (_this.rootContext.mozImageSmoothingEnabled) {
                _this.smoothProperty = 'mozImageSmoothingEnabled';
            } else if (_this.rootContext.oImageSmoothingEnabled) {
                _this.smoothProperty = 'oImageSmoothingEnabled';
            } else if (_this.rootContext.msImageSmoothingEnabled) {
                _this.smoothProperty = 'msImageSmoothingEnabled';
            }
        }

        _this.initPlugins();

        _this.blendModes = (0, _mapCanvasBlendModesToPixi2.default)();
        _this._activeBlendMode = null;

        _this.renderingToScreen = false;

        _this.resize(_this.options.width, _this.options.height);

        /**
         * Fired after rendering finishes.
         *
         * @event PIXI.CanvasRenderer#postrender
         */

        /**
         * Fired before rendering starts.
         *
         * @event PIXI.CanvasRenderer#prerender
         */
        return _this;
    }

    /**
     * Renders the object to this canvas view
     *
     * @param {PIXI.DisplayObject} displayObject - The object to be rendered
     * @param {PIXI.RenderTexture} [renderTexture] - A render texture to be rendered to.
     *  If unset, it will render to the root context.
     * @param {boolean} [clear=false] - Whether to clear the canvas before drawing
     * @param {PIXI.Matrix} [transform] - A transformation to be applied
     * @param {boolean} [skipUpdateTransform=false] - Whether to skip the update transform
     */

    CanvasRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
        if (!this.view) {
            return;
        }

        // can be handy to know!
        this.renderingToScreen = !renderTexture;

        this.emit('prerender');

        var rootResolution = this.resolution;

        if (renderTexture) {
            renderTexture = renderTexture.baseTexture || renderTexture;

            if (!renderTexture._canvasRenderTarget) {
                renderTexture._canvasRenderTarget = new _CanvasRenderTarget2.default(renderTexture.width, renderTexture.height, renderTexture.resolution);
                renderTexture.source = renderTexture._canvasRenderTarget.canvas;
                renderTexture.valid = true;
            }

            this.context = renderTexture._canvasRenderTarget.context;
            this.resolution = renderTexture._canvasRenderTarget.resolution;
        } else {
            this.context = this.rootContext;
        }

        var context = this.context;

        if (!renderTexture) {
            this._lastObjectRendered = displayObject;
        }

        if (!skipUpdateTransform) {
            // update the scene graph
            var cacheParent = displayObject.parent;
            var tempWt = this._tempDisplayObjectParent.transform.worldTransform;

            if (transform) {
                transform.copy(tempWt);

                // lets not forget to flag the parent transform as dirty...
                this._tempDisplayObjectParent.transform._worldID = -1;
            } else {
                tempWt.identity();
            }

            displayObject.parent = this._tempDisplayObjectParent;

            displayObject.updateTransform();
            displayObject.parent = cacheParent;
            // displayObject.hitArea = //TODO add a temp hit area
        }

        context.save();
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.globalAlpha = 1;
        this._activeBlendMode = _const.BLEND_MODES.NORMAL;
        context.globalCompositeOperation = this.blendModes[_const.BLEND_MODES.NORMAL];

        if (navigator.isCocoonJS && this.view.screencanvas) {
            context.fillStyle = 'black';
            context.clear();
        }

        if (clear !== undefined ? clear : this.clearBeforeRender) {
            if (this.renderingToScreen) {
                if (this.transparent) {
                    context.clearRect(0, 0, this.width, this.height);
                } else {
                    context.fillStyle = this._backgroundColorString;
                    context.fillRect(0, 0, this.width, this.height);
                }
            } // else {
            // TODO: implement background for CanvasRenderTarget or RenderTexture?
            // }
        }

        // TODO RENDER TARGET STUFF HERE..
        var tempContext = this.context;

        this.context = context;
        displayObject.renderCanvas(this);
        this.context = tempContext;

        context.restore();

        this.resolution = rootResolution;

        this.emit('postrender');
    };

    /**
     * Clear the canvas of renderer.
     *
     * @param {string} [clearColor] - Clear the canvas with this color, except the canvas is transparent.
     */

    CanvasRenderer.prototype.clear = function clear(clearColor) {
        var context = this.context;

        clearColor = clearColor || this._backgroundColorString;

        if (!this.transparent && clearColor) {
            context.fillStyle = clearColor;
            context.fillRect(0, 0, this.width, this.height);
        } else {
            context.clearRect(0, 0, this.width, this.height);
        }
    };

    /**
     * Sets the blend mode of the renderer.
     *
     * @param {number} blendMode - See {@link PIXI.BLEND_MODES} for valid values.
     */

    CanvasRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
        if (this._activeBlendMode === blendMode) {
            return;
        }

        this._activeBlendMode = blendMode;
        this.context.globalCompositeOperation = this.blendModes[blendMode];
    };

    /**
     * Removes everything from the renderer and optionally removes the Canvas DOM element.
     *
     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
     */

    CanvasRenderer.prototype.destroy = function destroy(removeView) {
        this.destroyPlugins();

        // call the base destroy
        _SystemRenderer.prototype.destroy.call(this, removeView);

        this.context = null;

        this.refresh = true;

        this.maskManager.destroy();
        this.maskManager = null;

        this.smoothProperty = null;
    };

    /**
     * Resizes the canvas view to the specified width and height.
     *
     * @extends PIXI.SystemRenderer#resize
     *
     * @param {number} screenWidth - the new width of the screen
     * @param {number} screenHeight - the new height of the screen
     */

    CanvasRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
        _SystemRenderer.prototype.resize.call(this, screenWidth, screenHeight);

        // reset the scale mode.. oddly this seems to be reset when the canvas is resized.
        // surely a browser bug?? Let PixiJS fix that for you..
        if (this.smoothProperty) {
            this.rootContext[this.smoothProperty] = _settings2.default.SCALE_MODE === _const.SCALE_MODES.LINEAR;
        }
    };

    /**
     * Checks if blend mode has changed.
     */

    CanvasRenderer.prototype.invalidateBlendMode = function invalidateBlendMode() {
        this._activeBlendMode = this.blendModes.indexOf(this.context.globalCompositeOperation);
    };

    return CanvasRenderer;
}(_SystemRenderer3.default);

/**
 * Collection of installed plugins. These are included by default in PIXI, but can be excluded
 * by creating a custom build. Consult the README for more information about creating custom
 * builds and excluding plugins.
 * @name PIXI.CanvasRenderer#plugins
 * @type {object}
 * @readonly
 * @property {PIXI.accessibility.AccessibilityManager} accessibility Support tabbing interactive elements.
 * @property {PIXI.extract.CanvasExtract} extract Extract image data from renderer.
 * @property {PIXI.interaction.InteractionManager} interaction Handles mouse, touch and pointer events.
 * @property {PIXI.prepare.CanvasPrepare} prepare Pre-render display objects.
 */

/**
 * Adds a plugin to the renderer.
 *
 * @method PIXI.CanvasRenderer#registerPlugin
 * @param {string} pluginName - The name of the plugin.
 * @param {Function} ctor - The constructor function or class for the plugin.
 */

exports.default = CanvasRenderer;
_utils.pluginTarget.mixin(CanvasRenderer);
//# sourceMappingURL=CanvasRenderer.js.map

/***/ }),

/***/ "H4Cu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventTouchMove = preventTouchMove;
exports.allowTouchMove = allowTouchMove;
exports.preventInertiaScroll = preventInertiaScroll;
exports.isTouchDevice = isTouchDevice;
exports.getPadding = getPadding;
exports.camelToKebab = camelToKebab;
exports.getWindowHeight = getWindowHeight;
exports.getDocumentHeight = getDocumentHeight;
exports.parse = parse;
exports.makeStyleTag = makeStyleTag;
exports.injectStyles = injectStyles;
exports.insertStyleTag = insertStyleTag;
function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  if (typeof window === 'undefined' || !window) return false;
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function getPadding() {
  if (typeof window === 'undefined' || !window || !document) return 0;

  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
  var clientWidth = document.body ? document.body.clientWidth : 0;
  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

  return adjustedPadding;
}

function camelToKebab(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

function getWindowHeight() {
  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  if (typeof window !== 'undefined' && window && window.innerHeight) {
    return window.innerHeight * multiplier;
  }
}

function getDocumentHeight() {
  if (typeof window !== 'undefined' && document && document.body) {
    return document.body.clientHeight;
  }
}

function parse(val) {
  return isNaN(val) ? val : val + 'px';
}

// ==============================
// Style Sheets
// ==============================

function makeStyleTag(id) {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-react-scrolllock', '');

  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName('head')[0];
  head.appendChild(tag);
}

/***/ }),

/***/ "H6Qo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),

/***/ "HWKW":
/***/ (function(module, exports) {

//Some versions of GlyphDesigner have a typo
//that causes some bugs with parsing. 
//Need to confirm with recent version of the software
//to see whether this is still an issue or not.
var GLYPH_DESIGNER_ERROR = 'chasrset';

module.exports = function parseAttributes(obj) {
  if (GLYPH_DESIGNER_ERROR in obj) {
    obj['charset'] = obj[GLYPH_DESIGNER_ERROR];
    delete obj[GLYPH_DESIGNER_ERROR];
  }

  for (var k in obj) {
    if (k === 'face' || k === 'charset') continue;else if (k === 'padding' || k === 'spacing') obj[k] = parseIntList(obj[k]);else obj[k] = parseInt(obj[k], 10);
  }
  return obj;
};

function parseIntList(data) {
  return data.split(',').map(function (val) {
    return parseInt(val, 10);
  });
}

/***/ }),

/***/ "Hstv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_EVENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_USER_EVENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_USER_EVENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_USER_EVENTS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_EVENT_DATES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_EVENT_DATES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_EVENT_DATES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_DATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_DATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_DATE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_NEAREST_EVENT_DATES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_NEAREST_EVENT_DATES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_NEAREST_EVENT_DATES_ERROR; });
/* unused harmony export SET_WIDGET */
/* unused harmony export GET_ADDITIONAL_QUESTION_WITH_QUANTITY_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getEventPublic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getUserEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getNextAvailableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getAdditionalQuestionsPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return clearEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventsService__ = __webpack_require__("4Q11");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ticketsActions__ = __webpack_require__("tyHu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orderActions__ = __webpack_require__("J21P");


var GET_EVENT_REQUEST = "GET_EVENT_REQUEST";
var GET_EVENT_SUCCESS = "GET_EVENT_SUCCESS";
var GET_EVENT_ERROR = "GET_EVENT_ERROR";

var GET_USER_EVENTS_REQUEST = "GET_USER_EVENTS_REQUEST";
var GET_USER_EVENTS_SUCCESS = "GET_USER_EVENTS_SUCCESS";
var GET_USER_EVENTS_ERROR = "GET_USER_EVENTS_ERROR";

var GET_EVENT_DATES_REQUEST = "GET_EVENT_DATES_REQUEST";
var GET_EVENT_DATES_SUCCESS = "GET_EVENT_DATES_SUCCESS";
var GET_EVENT_DATES_ERROR = "GET_EVENT_DATES_ERROR";

var GET_DATE_REQUEST = "GET_DATE_REQUEST";
var GET_DATE_SUCCESS = "GET_DATE_SUCCESS";
var GET_DATE_ERROR = "GET_DATE_ERROR";

var GET_NEAREST_EVENT_DATES_REQUEST = "GET_NEAREST_EVENT_DATES_REQUEST";
var GET_NEAREST_EVENT_DATES_SUCCESS = "GET_NEAREST_EVENT_DATES_SUCCESS";
var GET_NEAREST_EVENT_DATES_ERROR = "GET_NEAREST_EVENT_DATES_ERROR";

var SET_WIDGET = "SET_WIDGET";

var GET_ADDITIONAL_QUESTION_WITH_QUANTITY_SUCCESS = "GET_ADDITIONAL_QUESTION_WITH_QUANTITY_SUCCESS";

var CLEAR_EVENT = "CLEAR_EVENT";





var getEvent = function getEvent(slug, token, getTickets, orderId) {
  var getMerch = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var eventDateId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

  return function (dispatch, getState) {
    dispatch({ type: GET_EVENT_REQUEST, slug: slug });
    __WEBPACK_IMPORTED_MODULE_0__services_EventsService__["a" /* default */].get(slug, token, orderId, eventDateId).then(function (event) {
      dispatch({ type: GET_EVENT_SUCCESS, event: event });
      if (getTickets) {
        var state = getState();
        Object(__WEBPACK_IMPORTED_MODULE_1__ticketsActions__["s" /* loadTickets */])(state.event.id, state.ticketSelection.selectedDateId)(dispatch);
      }
      if (orderId) {
        Object(__WEBPACK_IMPORTED_MODULE_2__orderActions__["Q" /* getOrder */])(orderId, getMerch)(dispatch);
      }
    }).catch(function (err) {
      dispatch({ type: GET_EVENT_ERROR, error: err });
    });
  };
};

var getEventPublic = function getEventPublic(eventId, orderId, token) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var event;
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (err) {
        try {
          dispatch({ type: GET_EVENT_ERROR, error: err });
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: GET_EVENT_REQUEST });
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__services_EventsService__["a" /* default */].getEventPublic(eventId, orderId, token)).then(function ($await_2) {
          try {
            event = $await_2;
            dispatch({ type: GET_EVENT_SUCCESS, event: event });
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (err) {
        $Try_1_Catch(err)
      }
    });
  };
};
// slug can be either userId or organiserId
var getUserEvents = function getUserEvents(userId, organiserId) {
  return function (dispatch) {
    dispatch({ type: GET_USER_EVENTS_REQUEST, userId: userId, organiserId: organiserId });
    __WEBPACK_IMPORTED_MODULE_0__services_EventsService__["a" /* default */].getAllByUser(userId, organiserId).then(function (events) {
      dispatch({ type: GET_USER_EVENTS_SUCCESS, events: events });
    }).catch(function (err) {
      dispatch({ type: GET_USER_EVENTS_ERROR, error: err });
    });
  };
};

var getDates = function getDates(eventId, month, year, date) {
  return function (dispatch) {
    dispatch({ type: GET_EVENT_DATES_REQUEST, month: date });
    __WEBPACK_IMPORTED_MODULE_0__services_EventsService__["a" /* default */].getDates(eventId, month, year).then(function (dates) {
      dispatch({ type: GET_EVENT_DATES_SUCCESS, dates: dates });
    }).catch(function (err) {
      dispatch({ type: GET_EVENT_DATES_ERROR, error: err });
    });
  };
};

var getDate = function getDate(eventSlug, eventDateId) {
  return function (dispatch) {
    dispatch({ type: GET_DATE_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_EventsService__["a" /* default */].getDate(eventSlug, eventDateId).then(function (date) {
      dispatch({ type: GET_DATE_SUCCESS, date: date });
    }).catch(function (err) {
      dispatch({ type: GET_DATE_ERROR, error: err });
    });
  };
};

var getNextAvailableDates = function getNextAvailableDates(eventId) {
  return function (dispatch) {
    dispatch({ type: GET_NEAREST_EVENT_DATES_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_EventsService__["a" /* default */].getNearestDate(eventId).then(function (data) {
      dispatch({
        type: GET_NEAREST_EVENT_DATES_SUCCESS,
        month: new Date(data.month),
        dates: data.dates
      });
    }).catch(function (err) {
      dispatch({ type: GET_NEAREST_EVENT_DATES_ERROR, error: err });
    });
  };
};

var getAdditionalQuestionsPreview = function getAdditionalQuestionsPreview(eventSlug) {
  return function (dispatch) {
    dispatch({ type: GET_EVENT_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_EventsService__["a" /* default */].getAdditionalQuestionsPreview(eventSlug).then(function (event) {
      dispatch({
        type: GET_EVENT_SUCCESS,
        event: event
      });
    }).catch(function (err) {
      dispatch({ type: GET_EVENT_ERROR, error: err });
    });
  };
};

var clearEvent = function clearEvent() {
  return function (dispatch) {
    dispatch({ type: CLEAR_EVENT });
  };
};

/***/ }),

/***/ "HtZT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4b9a70e43206a4cc8a5ad328e2d3428f.svg";

/***/ }),

/***/ "Hz2Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _utils = __webpack_require__("dDI1");

var _math = __webpack_require__("e3iB");

var _const = __webpack_require__("YEQi");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

var _Container = __webpack_require__("OzBO");

var _Container2 = _interopRequireDefault(_Container);

var _RenderTexture = __webpack_require__("Jb0W");

var _RenderTexture2 = _interopRequireDefault(_RenderTexture);

var _eventemitter = __webpack_require__("wCSE");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var tempMatrix = new _math.Matrix();

/**
 * The SystemRenderer is the base for a PixiJS Renderer. It is extended by the {@link PIXI.CanvasRenderer}
 * and {@link PIXI.WebGLRenderer} which can be used for rendering a PixiJS scene.
 *
 * @abstract
 * @class
 * @extends EventEmitter
 * @memberof PIXI
 */

var SystemRenderer = function (_EventEmitter) {
  _inherits(SystemRenderer, _EventEmitter);

  // eslint-disable-next-line valid-jsdoc
  /**
   * @param {string} system - The name of the system this renderer is for.
   * @param {object} [options] - The optional renderer parameters
   * @param {number} [options.width=800] - the width of the screen
   * @param {number} [options.height=600] - the height of the screen
   * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
   * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
   * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
   * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
   * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
   *  resolution of the renderer retina would be 2.
   * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
   *  enable this if you need to call toDataUrl on the webgl context.
   * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
   *      not before the new render pass.
   * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
   *  (shown if not transparent).
   * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
   *  stopping pixel interpolation.
   */
  function SystemRenderer(system, options, arg2, arg3) {
    _classCallCheck(this, SystemRenderer);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    (0, _utils.sayHello)(system);

    // Support for constructor(system, screenWidth, screenHeight, options)
    if (typeof options === 'number') {
      options = _extends({
        width: options,
        height: arg2 || _settings2.default.RENDER_OPTIONS.height
      }, arg3);
    }

    // Add the default render options
    options = _extends({}, _settings2.default.RENDER_OPTIONS, options);

    /**
     * The supplied constructor options.
     *
     * @member {Object}
     * @readOnly
     */
    _this.options = options;

    /**
     * The type of the renderer.
     *
     * @member {number}
     * @default PIXI.RENDERER_TYPE.UNKNOWN
     * @see PIXI.RENDERER_TYPE
     */
    _this.type = _const.RENDERER_TYPE.UNKNOWN;

    /**
     * Measurements of the screen. (0, 0, screenWidth, screenHeight)
     *
     * Its safe to use as filterArea or hitArea for whole stage
     *
     * @member {PIXI.Rectangle}
     */
    _this.screen = new _math.Rectangle(0, 0, options.width, options.height);

    /**
     * The canvas element that everything is drawn to
     *
     * @member {HTMLCanvasElement}
     */
    _this.view = options.view || document.createElement('canvas');

    /**
     * The resolution / device pixel ratio of the renderer
     *
     * @member {number}
     * @default 1
     */
    _this.resolution = options.resolution || _settings2.default.RESOLUTION;

    /**
     * Whether the render view is transparent
     *
     * @member {boolean}
     */
    _this.transparent = options.transparent;

    /**
     * Whether css dimensions of canvas view should be resized to screen dimensions automatically
     *
     * @member {boolean}
     */
    _this.autoResize = options.autoResize || false;

    /**
     * Tracks the blend modes useful for this renderer.
     *
     * @member {object<string, mixed>}
     */
    _this.blendModes = null;

    /**
     * The value of the preserveDrawingBuffer flag affects whether or not the contents of
     * the stencil buffer is retained after rendering.
     *
     * @member {boolean}
     */
    _this.preserveDrawingBuffer = options.preserveDrawingBuffer;

    /**
     * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
     * If the scene is NOT transparent PixiJS will use a canvas sized fillRect operation every
     * frame to set the canvas background color. If the scene is transparent PixiJS will use clearRect
     * to clear the canvas every frame. Disable this by setting this to false. For example if
     * your game has a canvas filling background image you often don't need this set.
     *
     * @member {boolean}
     * @default
     */
    _this.clearBeforeRender = options.clearBeforeRender;

    /**
     * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
     * Handy for crisp pixel art and speed on legacy devices.
     *
     * @member {boolean}
     */
    _this.roundPixels = options.roundPixels;

    /**
     * The background color as a number.
     *
     * @member {number}
     * @private
     */
    _this._backgroundColor = 0x000000;

    /**
     * The background color as an [R, G, B] array.
     *
     * @member {number[]}
     * @private
     */
    _this._backgroundColorRgba = [0, 0, 0, 0];

    /**
     * The background color as a string.
     *
     * @member {string}
     * @private
     */
    _this._backgroundColorString = '#000000';

    _this.backgroundColor = options.backgroundColor || _this._backgroundColor; // run bg color setter

    /**
     * This temporary display object used as the parent of the currently being rendered item
     *
     * @member {PIXI.DisplayObject}
     * @private
     */
    _this._tempDisplayObjectParent = new _Container2.default();

    /**
     * The last root object that the renderer tried to render.
     *
     * @member {PIXI.DisplayObject}
     * @private
     */
    _this._lastObjectRendered = _this._tempDisplayObjectParent;
    return _this;
  }

  /**
   * Same as view.width, actual number of pixels in the canvas by horizontal
   *
   * @member {number}
   * @readonly
   * @default 800
   */

  /**
   * Resizes the screen and canvas to the specified width and height
   * Canvas dimensions are multiplied by resolution
   *
   * @param {number} screenWidth - the new width of the screen
   * @param {number} screenHeight - the new height of the screen
   */
  SystemRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
    this.screen.width = screenWidth;
    this.screen.height = screenHeight;

    this.view.width = screenWidth * this.resolution;
    this.view.height = screenHeight * this.resolution;

    if (this.autoResize) {
      this.view.style.width = screenWidth + 'px';
      this.view.style.height = screenHeight + 'px';
    }
  };

  /**
   * Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   *
   * @param {PIXI.DisplayObject} displayObject - The displayObject the object will be generated from
   * @param {number} scaleMode - Should be one of the scaleMode consts
   * @param {number} resolution - The resolution / device pixel ratio of the texture being generated
   * @param {PIXI.Rectangle} [region] - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @return {PIXI.Texture} a texture of the graphics object
   */

  SystemRenderer.prototype.generateTexture = function generateTexture(displayObject, scaleMode, resolution, region) {
    region = region || displayObject.getLocalBounds();

    var renderTexture = _RenderTexture2.default.create(region.width | 0, region.height | 0, scaleMode, resolution);

    tempMatrix.tx = -region.x;
    tempMatrix.ty = -region.y;

    this.render(displayObject, renderTexture, false, tempMatrix, !!displayObject.parent);

    return renderTexture;
  };

  /**
   * Removes everything from the renderer and optionally removes the Canvas DOM element.
   *
   * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
   */

  SystemRenderer.prototype.destroy = function destroy(removeView) {
    if (removeView && this.view.parentNode) {
      this.view.parentNode.removeChild(this.view);
    }

    this.type = _const.RENDERER_TYPE.UNKNOWN;

    this.view = null;

    this.screen = null;

    this.resolution = 0;

    this.transparent = false;

    this.autoResize = false;

    this.blendModes = null;

    this.options = null;

    this.preserveDrawingBuffer = false;
    this.clearBeforeRender = false;

    this.roundPixels = false;

    this._backgroundColor = 0;
    this._backgroundColorRgba = null;
    this._backgroundColorString = null;

    this._tempDisplayObjectParent = null;
    this._lastObjectRendered = null;
  };

  /**
   * The background color to fill if not transparent
   *
   * @member {number}
   */

  _createClass(SystemRenderer, [{
    key: 'width',
    get: function get() {
      return this.view.width;
    }

    /**
     * Same as view.height, actual number of pixels in the canvas by vertical
     *
     * @member {number}
     * @readonly
     * @default 600
     */

  }, {
    key: 'height',
    get: function get() {
      return this.view.height;
    }
  }, {
    key: 'backgroundColor',
    get: function get() {
      return this._backgroundColor;
    },
    set: function set(value) // eslint-disable-line require-jsdoc
    {
      this._backgroundColor = value;
      this._backgroundColorString = (0, _utils.hex2string)(value);
      (0, _utils.hex2rgb)(value, this._backgroundColorRgba);
    }
  }]);

  return SystemRenderer;
}(_eventemitter2.default);

exports.default = SystemRenderer;
//# sourceMappingURL=SystemRenderer.js.map

/***/ }),

/***/ "IPtN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollLock = __webpack_require__("9V2T");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollLock).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),

/***/ "IWZv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _pixiGlCore = __webpack_require__("PJsv");

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

var _Mesh = __webpack_require__("esRn");

var _Mesh2 = _interopRequireDefault(_Mesh);

var _path = __webpack_require__("UUq2");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var matrixIdentity = core.Matrix.IDENTITY;

/**
 * WebGL renderer plugin for tiling sprites
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.ObjectRenderer
 */

var MeshRenderer = function (_core$ObjectRenderer) {
    _inherits(MeshRenderer, _core$ObjectRenderer);

    /**
     * constructor for renderer
     *
     * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
     */
    function MeshRenderer(renderer) {
        _classCallCheck(this, MeshRenderer);

        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));

        _this.shader = null;
        return _this;
    }

    /**
     * Sets up the renderer context and necessary buffers.
     *
     * @private
     */

    MeshRenderer.prototype.onContextChange = function onContextChange() {
        var gl = this.renderer.gl;

        this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\nuniform vec4 uColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;\n}\n');
    };

    /**
     * renders mesh
     *
     * @param {PIXI.mesh.Mesh} mesh mesh instance
     */

    MeshRenderer.prototype.render = function render(mesh) {
        var renderer = this.renderer;
        var gl = renderer.gl;
        var texture = mesh._texture;

        if (!texture.valid) {
            return;
        }

        var glData = mesh._glDatas[renderer.CONTEXT_UID];

        if (!glData) {
            renderer.bindVao(null);

            glData = {
                shader: this.shader,
                vertexBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.vertices, gl.STREAM_DRAW),
                uvBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.uvs, gl.STREAM_DRAW),
                indexBuffer: _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, mesh.indices, gl.STATIC_DRAW),
                // build the vao object that will render..
                vao: null,
                dirty: mesh.dirty,
                indexDirty: mesh.indexDirty,
                vertexDirty: mesh.vertexDirty
            };

            // build the vao object that will render..
            glData.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(glData.indexBuffer).addAttribute(glData.vertexBuffer, glData.shader.attributes.aVertexPosition, gl.FLOAT, false, 2 * 4, 0).addAttribute(glData.uvBuffer, glData.shader.attributes.aTextureCoord, gl.FLOAT, false, 2 * 4, 0);

            mesh._glDatas[renderer.CONTEXT_UID] = glData;
        }

        renderer.bindVao(glData.vao);

        if (mesh.dirty !== glData.dirty) {
            glData.dirty = mesh.dirty;
            glData.uvBuffer.upload(mesh.uvs);
        }

        if (mesh.indexDirty !== glData.indexDirty) {
            glData.indexDirty = mesh.indexDirty;
            glData.indexBuffer.upload(mesh.indices);
        }

        if (mesh.vertexDirty !== glData.vertexDirty) {
            glData.vertexDirty = mesh.vertexDirty;
            glData.vertexBuffer.upload(mesh.vertices);
        }

        renderer.bindShader(glData.shader);

        glData.shader.uniforms.uSampler = renderer.bindTexture(texture);

        renderer.state.setBlendMode(core.utils.correctBlendMode(mesh.blendMode, texture.baseTexture.premultipliedAlpha));

        if (glData.shader.uniforms.uTransform) {
            if (mesh.uploadUvTransform) {
                glData.shader.uniforms.uTransform = mesh._uvTransform.mapCoord.toArray(true);
            } else {
                glData.shader.uniforms.uTransform = matrixIdentity.toArray(true);
            }
        }
        glData.shader.uniforms.translationMatrix = mesh.worldTransform.toArray(true);

        glData.shader.uniforms.uColor = core.utils.premultiplyRgba(mesh.tintRgb, mesh.worldAlpha, glData.shader.uniforms.uColor, texture.baseTexture.premultipliedAlpha);

        var drawMode = mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH ? gl.TRIANGLE_STRIP : gl.TRIANGLES;

        glData.vao.draw(drawMode, mesh.indices.length, 0);
    };

    return MeshRenderer;
}(core.ObjectRenderer);

exports.default = MeshRenderer;

core.WebGLRenderer.registerPlugin('mesh', MeshRenderer);
//# sourceMappingURL=MeshRenderer.js.map

/***/ }),

/***/ "IdKE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _InteractionData = __webpack_require__("VcKu");

var _InteractionData2 = _interopRequireDefault(_InteractionData);

var _InteractionEvent = __webpack_require__("mpmK");

var _InteractionEvent2 = _interopRequireDefault(_InteractionEvent);

var _InteractionTrackingData = __webpack_require__("aVqp");

var _InteractionTrackingData2 = _interopRequireDefault(_InteractionTrackingData);

var _eventemitter = __webpack_require__("wCSE");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _interactiveTarget = __webpack_require__("ya0i");

var _interactiveTarget2 = _interopRequireDefault(_interactiveTarget);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// Mix interactiveTarget into core.DisplayObject.prototype, after deprecation has been handled
core.utils.mixins.delayMixin(core.DisplayObject.prototype, _interactiveTarget2.default);

var MOUSE_POINTER_ID = 1;

// helpers for hitTest() - only used inside hitTest()
var hitTestEvent = {
    target: null,
    data: {
        global: null
    }
};

/**
 * The interaction manager deals with mouse, touch and pointer events. Any DisplayObject can be interactive
 * if its interactive parameter is set to true
 * This manager also supports multitouch.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.interaction
 *
 * @class
 * @extends EventEmitter
 * @memberof PIXI.interaction
 */

var InteractionManager = function (_EventEmitter) {
    _inherits(InteractionManager, _EventEmitter);

    /**
     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
     * @param {object} [options] - The options for the manager.
     * @param {boolean} [options.autoPreventDefault=true] - Should the manager automatically prevent default browser actions.
     * @param {number} [options.interactionFrequency=10] - Frequency increases the interaction events will be checked.
     */
    function InteractionManager(renderer, options) {
        _classCallCheck(this, InteractionManager);

        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        options = options || {};

        /**
         * The renderer this interaction manager works for.
         *
         * @member {PIXI.SystemRenderer}
         */
        _this.renderer = renderer;

        /**
         * Should default browser actions automatically be prevented.
         * Does not apply to pointer events for backwards compatibility
         * preventDefault on pointer events stops mouse events from firing
         * Thus, for every pointer event, there will always be either a mouse of touch event alongside it.
         *
         * @member {boolean}
         * @default true
         */
        _this.autoPreventDefault = options.autoPreventDefault !== undefined ? options.autoPreventDefault : true;

        /**
         * Frequency in milliseconds that the mousemove, moveover & mouseout interaction events will be checked.
         *
         * @member {number}
         * @default 10
         */
        _this.interactionFrequency = options.interactionFrequency || 10;

        /**
         * The mouse data
         *
         * @member {PIXI.interaction.InteractionData}
         */
        _this.mouse = new _InteractionData2.default();
        _this.mouse.identifier = MOUSE_POINTER_ID;

        // setting the mouse to start off far off screen will mean that mouse over does
        //  not get called before we even move the mouse.
        _this.mouse.global.set(-999999);

        /**
         * Actively tracked InteractionData
         *
         * @private
         * @member {Object.<number,PIXI.interation.InteractionData>}
         */
        _this.activeInteractionData = {};
        _this.activeInteractionData[MOUSE_POINTER_ID] = _this.mouse;

        /**
         * Pool of unused InteractionData
         *
         * @private
         * @member {PIXI.interation.InteractionData[]}
         */
        _this.interactionDataPool = [];

        /**
         * An event data object to handle all the event tracking/dispatching
         *
         * @member {object}
         */
        _this.eventData = new _InteractionEvent2.default();

        /**
         * The DOM element to bind to.
         *
         * @private
         * @member {HTMLElement}
         */
        _this.interactionDOMElement = null;

        /**
         * This property determines if mousemove and touchmove events are fired only when the cursor
         * is over the object.
         * Setting to true will make things work more in line with how the DOM verison works.
         * Setting to false can make things easier for things like dragging
         * It is currently set to false as this is how PixiJS used to work. This will be set to true in
         * future versions of pixi.
         *
         * @member {boolean}
         * @default false
         */
        _this.moveWhenInside = false;

        /**
         * Have events been attached to the dom element?
         *
         * @private
         * @member {boolean}
         */
        _this.eventsAdded = false;

        /**
         * Is the mouse hovering over the renderer?
         *
         * @private
         * @member {boolean}
         */
        _this.mouseOverRenderer = false;

        /**
         * Does the device support touch events
         * https://www.w3.org/TR/touch-events/
         *
         * @readonly
         * @member {boolean}
         */
        _this.supportsTouchEvents = 'ontouchstart' in window;

        /**
         * Does the device support pointer events
         * https://www.w3.org/Submission/pointer-events/
         *
         * @readonly
         * @member {boolean}
         */
        _this.supportsPointerEvents = !!window.PointerEvent;

        // this will make it so that you don't have to call bind all the time

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerUp = _this.onPointerUp.bind(_this);
        _this.processPointerUp = _this.processPointerUp.bind(_this);

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerCancel = _this.onPointerCancel.bind(_this);
        _this.processPointerCancel = _this.processPointerCancel.bind(_this);

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerDown = _this.onPointerDown.bind(_this);
        _this.processPointerDown = _this.processPointerDown.bind(_this);

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerMove = _this.onPointerMove.bind(_this);
        _this.processPointerMove = _this.processPointerMove.bind(_this);

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerOut = _this.onPointerOut.bind(_this);
        _this.processPointerOverOut = _this.processPointerOverOut.bind(_this);

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerOver = _this.onPointerOver.bind(_this);

        /**
         * Dictionary of how different cursor modes are handled. Strings are handled as CSS cursor
         * values, objects are handled as dictionaries of CSS values for interactionDOMElement,
         * and functions are called instead of changing the CSS.
         * Default CSS cursor values are provided for 'default' and 'pointer' modes.
         * @member {Object.<string, (string|Function|Object.<string, string>)>}
         */
        _this.cursorStyles = {
            default: 'inherit',
            pointer: 'pointer'
        };

        /**
         * The mode of the cursor that is being used.
         * The value of this is a key from the cursorStyles dictionary.
         *
         * @member {string}
         */
        _this.currentCursorMode = null;

        /**
         * Internal cached let.
         *
         * @private
         * @member {string}
         */
        _this.cursor = null;

        /**
         * Internal cached let.
         *
         * @private
         * @member {PIXI.Point}
         */
        _this._tempPoint = new core.Point();

        /**
         * The current resolution / device pixel ratio.
         *
         * @member {number}
         * @default 1
         */
        _this.resolution = 1;

        _this.setTargetElement(_this.renderer.view, _this.renderer.resolution);

        /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display
         * object.
         *
         * @event PIXI.interaction.InteractionManager#mousedown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * on the display object.
         *
         * @event PIXI.interaction.InteractionManager#rightdown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is released over the display
         * object.
         *
         * @event PIXI.interaction.InteractionManager#mouseup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * over the display object.
         *
         * @event PIXI.interaction.InteractionManager#rightup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
         * the display object.
         *
         * @event PIXI.interaction.InteractionManager#click
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * and released on the display object.
         *
         * @event PIXI.interaction.InteractionManager#rightclick
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is released outside the
         * display object that initially registered a
         * [mousedown]{@link PIXI.interaction.InteractionManager#event:mousedown}.
         *
         * @event PIXI.interaction.InteractionManager#mouseupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * outside the display object that initially registered a
         * [rightdown]{@link PIXI.interaction.InteractionManager#event:rightdown}.
         *
         * @event PIXI.interaction.InteractionManager#rightupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved while over the display object
         *
         * @event PIXI.interaction.InteractionManager#mousemove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved onto the display object
         *
         * @event PIXI.interaction.InteractionManager#mouseover
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved off the display object
         *
         * @event PIXI.interaction.InteractionManager#mouseout
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is pressed on the display object.
         *
         * @event PIXI.interaction.InteractionManager#pointerdown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is released over the display object.
         * Not always fired when some buttons are held down while others are released. In those cases,
         * use [mousedown]{@link PIXI.interaction.InteractionManager#event:mousedown} and
         * [mouseup]{@link PIXI.interaction.InteractionManager#event:mouseup} instead.
         *
         * @event PIXI.interaction.InteractionManager#pointerup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when the operating system cancels a pointer event
         *
         * @event PIXI.interaction.InteractionManager#pointercancel
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is pressed and released on the display object.
         *
         * @event PIXI.interaction.InteractionManager#pointertap
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is released outside the display object that initially
         * registered a [pointerdown]{@link PIXI.interaction.InteractionManager#event:pointerdown}.
         *
         * @event PIXI.interaction.InteractionManager#pointerupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved while over the display object
         *
         * @event PIXI.interaction.InteractionManager#pointermove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved onto the display object
         *
         * @event PIXI.interaction.InteractionManager#pointerover
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved off the display object
         *
         * @event PIXI.interaction.InteractionManager#pointerout
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is placed on the display object.
         *
         * @event PIXI.interaction.InteractionManager#touchstart
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is removed from the display object.
         *
         * @event PIXI.interaction.InteractionManager#touchend
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when the operating system cancels a touch
         *
         * @event PIXI.interaction.InteractionManager#touchcancel
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is placed and removed from the display object.
         *
         * @event PIXI.interaction.InteractionManager#tap
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is removed outside of the display object that initially
         * registered a [touchstart]{@link PIXI.interaction.InteractionManager#event:touchstart}.
         *
         * @event PIXI.interaction.InteractionManager#touchendoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is moved along the display object.
         *
         * @event PIXI.interaction.InteractionManager#touchmove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display.
         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mousedown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#rightdown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is released over the display
         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mouseup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * over the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#rightup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
         * the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#click
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * and released on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#rightclick
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is released outside the
         * display object that initially registered a
         * [mousedown]{@link PIXI.DisplayObject#event:mousedown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mouseupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * outside the display object that initially registered a
         * [rightdown]{@link PIXI.DisplayObject#event:rightdown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#rightupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved while over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mousemove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved onto the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mouseover
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved off the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mouseout
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is pressed on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointerdown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is released over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointerup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when the operating system cancels a pointer event.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointercancel
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is pressed and released on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointertap
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is released outside the display object that initially
         * registered a [pointerdown]{@link PIXI.DisplayObject#event:pointerdown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointerupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved while over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointermove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved onto the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointerover
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved off the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointerout
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is placed on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#touchstart
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is removed from the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#touchend
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when the operating system cancels a touch.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#touchcancel
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is placed and removed from the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#tap
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is removed outside of the display object that initially
         * registered a [touchstart]{@link PIXI.DisplayObject#event:touchstart}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#touchendoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is moved along the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#touchmove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */
        return _this;
    }

    /**
     * Hit tests a point against the display tree, returning the first interactive object that is hit.
     *
     * @param {PIXI.Point} globalPoint - A point to hit test with, in global space.
     * @param {PIXI.Container} [root] - The root display object to start from. If omitted, defaults
     * to the last rendered root of the associated renderer.
     * @return {PIXI.DisplayObject} The hit display object, if any.
     */

    InteractionManager.prototype.hitTest = function hitTest(globalPoint, root) {
        // clear the target for our hit test
        hitTestEvent.target = null;
        // assign the global point
        hitTestEvent.data.global = globalPoint;
        // ensure safety of the root
        if (!root) {
            root = this.renderer._lastObjectRendered;
        }
        // run the hit test
        this.processInteractive(hitTestEvent, root, null, true);
        // return our found object - it'll be null if we didn't hit anything

        return hitTestEvent.target;
    };

    /**
     * Sets the DOM element which will receive mouse/touch events. This is useful for when you have
     * other DOM elements on top of the renderers Canvas element. With this you'll be bale to deletegate
     * another DOM element to receive those events.
     *
     * @param {HTMLCanvasElement} element - the DOM element which will receive mouse and touch events.
     * @param {number} [resolution=1] - The resolution / device pixel ratio of the new element (relative to the canvas).
     */

    InteractionManager.prototype.setTargetElement = function setTargetElement(element) {
        var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        this.removeEvents();

        this.interactionDOMElement = element;

        this.resolution = resolution;

        this.addEvents();
    };

    /**
     * Registers all the DOM events
     *
     * @private
     */

    InteractionManager.prototype.addEvents = function addEvents() {
        if (!this.interactionDOMElement) {
            return;
        }

        core.ticker.shared.add(this.update, this, core.UPDATE_PRIORITY.INTERACTION);

        if (window.navigator.msPointerEnabled) {
            this.interactionDOMElement.style['-ms-content-zooming'] = 'none';
            this.interactionDOMElement.style['-ms-touch-action'] = 'none';
        } else if (this.supportsPointerEvents) {
            this.interactionDOMElement.style['touch-action'] = 'none';
        }

        /**
         * These events are added first, so that if pointer events are normalised, they are fired
         * in the same order as non-normalised events. ie. pointer event 1st, mouse / touch 2nd
         */
        if (this.supportsPointerEvents) {
            window.document.addEventListener('pointermove', this.onPointerMove, true);
            this.interactionDOMElement.addEventListener('pointerdown', this.onPointerDown, true);
            // pointerout is fired in addition to pointerup (for touch events) and pointercancel
            // we already handle those, so for the purposes of what we do in onPointerOut, we only
            // care about the pointerleave event
            this.interactionDOMElement.addEventListener('pointerleave', this.onPointerOut, true);
            this.interactionDOMElement.addEventListener('pointerover', this.onPointerOver, true);
            window.addEventListener('pointercancel', this.onPointerCancel, true);
            window.addEventListener('pointerup', this.onPointerUp, true);
        } else {
            window.document.addEventListener('mousemove', this.onPointerMove, true);
            this.interactionDOMElement.addEventListener('mousedown', this.onPointerDown, true);
            this.interactionDOMElement.addEventListener('mouseout', this.onPointerOut, true);
            this.interactionDOMElement.addEventListener('mouseover', this.onPointerOver, true);
            window.addEventListener('mouseup', this.onPointerUp, true);
        }

        // always look directly for touch events so that we can provide original data
        // In a future version we should change this to being just a fallback and rely solely on
        // PointerEvents whenever available
        if (this.supportsTouchEvents) {
            this.interactionDOMElement.addEventListener('touchstart', this.onPointerDown, true);
            this.interactionDOMElement.addEventListener('touchcancel', this.onPointerCancel, true);
            this.interactionDOMElement.addEventListener('touchend', this.onPointerUp, true);
            this.interactionDOMElement.addEventListener('touchmove', this.onPointerMove, true);
        }

        this.eventsAdded = true;
    };

    /**
     * Removes all the DOM events that were previously registered
     *
     * @private
     */

    InteractionManager.prototype.removeEvents = function removeEvents() {
        if (!this.interactionDOMElement) {
            return;
        }

        core.ticker.shared.remove(this.update, this);

        if (window.navigator.msPointerEnabled) {
            this.interactionDOMElement.style['-ms-content-zooming'] = '';
            this.interactionDOMElement.style['-ms-touch-action'] = '';
        } else if (this.supportsPointerEvents) {
            this.interactionDOMElement.style['touch-action'] = '';
        }

        if (this.supportsPointerEvents) {
            window.document.removeEventListener('pointermove', this.onPointerMove, true);
            this.interactionDOMElement.removeEventListener('pointerdown', this.onPointerDown, true);
            this.interactionDOMElement.removeEventListener('pointerleave', this.onPointerOut, true);
            this.interactionDOMElement.removeEventListener('pointerover', this.onPointerOver, true);
            window.removeEventListener('pointercancel', this.onPointerCancel, true);
            window.removeEventListener('pointerup', this.onPointerUp, true);
        } else {
            window.document.removeEventListener('mousemove', this.onPointerMove, true);
            this.interactionDOMElement.removeEventListener('mousedown', this.onPointerDown, true);
            this.interactionDOMElement.removeEventListener('mouseout', this.onPointerOut, true);
            this.interactionDOMElement.removeEventListener('mouseover', this.onPointerOver, true);
            window.removeEventListener('mouseup', this.onPointerUp, true);
        }

        if (this.supportsTouchEvents) {
            this.interactionDOMElement.removeEventListener('touchstart', this.onPointerDown, true);
            this.interactionDOMElement.removeEventListener('touchcancel', this.onPointerCancel, true);
            this.interactionDOMElement.removeEventListener('touchend', this.onPointerUp, true);
            this.interactionDOMElement.removeEventListener('touchmove', this.onPointerMove, true);
        }

        this.interactionDOMElement = null;

        this.eventsAdded = false;
    };

    /**
     * Updates the state of interactive objects.
     * Invoked by a throttled ticker update from {@link PIXI.ticker.shared}.
     *
     * @param {number} deltaTime - time delta since last tick
     */

    InteractionManager.prototype.update = function update(deltaTime) {
        this._deltaTime += deltaTime;

        if (this._deltaTime < this.interactionFrequency) {
            return;
        }

        this._deltaTime = 0;

        if (!this.interactionDOMElement) {
            return;
        }

        // if the user move the mouse this check has already been done using the mouse move!
        if (this.didMove) {
            this.didMove = false;

            return;
        }

        this.cursor = null;

        // Resets the flag as set by a stopPropagation call. This flag is usually reset by a user interaction of any kind,
        // but there was a scenario of a display object moving under a static mouse cursor.
        // In this case, mouseover and mouseevents would not pass the flag test in dispatchEvent function
        for (var k in this.activeInteractionData) {
            // eslint-disable-next-line no-prototype-builtins
            if (this.activeInteractionData.hasOwnProperty(k)) {
                var interactionData = this.activeInteractionData[k];

                if (interactionData.originalEvent && interactionData.pointerType !== 'touch') {
                    var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, interactionData.originalEvent, interactionData);

                    this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, true);
                }
            }
        }

        this.setCursorMode(this.cursor);

        // TODO
    };

    /**
     * Sets the current cursor mode, handling any callbacks or CSS style changes.
     *
     * @param {string} mode - cursor mode, a key from the cursorStyles dictionary
     */

    InteractionManager.prototype.setCursorMode = function setCursorMode(mode) {
        mode = mode || 'default';
        // if the mode didn't actually change, bail early
        if (this.currentCursorMode === mode) {
            return;
        }
        this.currentCursorMode = mode;
        var style = this.cursorStyles[mode];

        // only do things if there is a cursor style for it
        if (style) {
            switch (typeof style === 'undefined' ? 'undefined' : _typeof(style)) {
                case 'string':
                    // string styles are handled as cursor CSS
                    this.interactionDOMElement.style.cursor = style;
                    break;
                case 'function':
                    // functions are just called, and passed the cursor mode
                    style(mode);
                    break;
                case 'object':
                    // if it is an object, assume that it is a dictionary of CSS styles,
                    // apply it to the interactionDOMElement
                    _extends(this.interactionDOMElement.style, style);
                    break;
            }
        } else if (typeof mode === 'string' && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode)) {
            // if it mode is a string (not a Symbol) and cursorStyles doesn't have any entry
            // for the mode, then assume that the dev wants it to be CSS for the cursor.
            this.interactionDOMElement.style.cursor = mode;
        }
    };

    /**
     * Dispatches an event on the display object that was interacted with
     *
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the display object in question
     * @param {string} eventString - the name of the event (e.g, mousedown)
     * @param {object} eventData - the event data object
     * @private
     */

    InteractionManager.prototype.dispatchEvent = function dispatchEvent(displayObject, eventString, eventData) {
        if (!eventData.stopped) {
            eventData.currentTarget = displayObject;
            eventData.type = eventString;

            displayObject.emit(eventString, eventData);

            if (displayObject[eventString]) {
                displayObject[eventString](eventData);
            }
        }
    };

    /**
     * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
     * resulting value is stored in the point. This takes into account the fact that the DOM
     * element could be scaled and positioned anywhere on the screen.
     *
     * @param  {PIXI.Point} point - the point that the result will be stored in
     * @param  {number} x - the x coord of the position to map
     * @param  {number} y - the y coord of the position to map
     */

    InteractionManager.prototype.mapPositionToPoint = function mapPositionToPoint(point, x, y) {
        var rect = void 0;

        // IE 11 fix
        if (!this.interactionDOMElement.parentElement) {
            rect = { x: 0, y: 0, width: 0, height: 0 };
        } else {
            rect = this.interactionDOMElement.getBoundingClientRect();
        }

        var resolutionMultiplier = navigator.isCocoonJS ? this.resolution : 1.0 / this.resolution;

        point.x = (x - rect.left) * (this.interactionDOMElement.width / rect.width) * resolutionMultiplier;
        point.y = (y - rect.top) * (this.interactionDOMElement.height / rect.height) * resolutionMultiplier;
    };

    /**
     * This function is provides a neat way of crawling through the scene graph and running a
     * specified function on all interactive objects it finds. It will also take care of hit
     * testing the interactive objects and passes the hit across in the function.
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - event containing the point that
     *  is tested for collision
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the displayObject
     *  that will be hit test (recursively crawls its children)
     * @param {Function} [func] - the function that will be called on each interactive object. The
     *  interactionEvent, displayObject and hit will be passed to the function
     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
     * @param {boolean} [interactive] - Whether the displayObject is interactive
     * @return {boolean} returns true if the displayObject hit the point
     */

    InteractionManager.prototype.processInteractive = function processInteractive(interactionEvent, displayObject, func, hitTest, interactive) {
        if (!displayObject || !displayObject.visible) {
            return false;
        }

        var point = interactionEvent.data.global;

        // Took a little while to rework this function correctly! But now it is done and nice and optimised. ^_^
        //
        // This function will now loop through all objects and then only hit test the objects it HAS
        // to, not all of them. MUCH faster..
        // An object will be hit test if the following is true:
        //
        // 1: It is interactive.
        // 2: It belongs to a parent that is interactive AND one of the parents children have not already been hit.
        //
        // As another little optimisation once an interactive object has been hit we can carry on
        // through the scenegraph, but we know that there will be no more hits! So we can avoid extra hit tests
        // A final optimisation is that an object is not hit test directly if a child has already been hit.

        interactive = displayObject.interactive || interactive;

        var hit = false;
        var interactiveParent = interactive;

        // Flag here can set to false if the event is outside the parents hitArea or mask
        var hitTestChildren = true;

        // If there is a hitArea, no need to test against anything else if the pointer is not within the hitArea
        // There is also no longer a need to hitTest children.
        if (displayObject.hitArea) {
            if (hitTest) {
                displayObject.worldTransform.applyInverse(point, this._tempPoint);
                if (!displayObject.hitArea.contains(this._tempPoint.x, this._tempPoint.y)) {
                    hitTest = false;
                    hitTestChildren = false;
                } else {
                    hit = true;
                }
            }
            interactiveParent = false;
        }
        // If there is a mask, no need to test against anything else if the pointer is not within the mask
        else if (displayObject._mask) {
                if (hitTest) {
                    if (!displayObject._mask.containsPoint(point)) {
                        hitTest = false;
                        hitTestChildren = false;
                    }
                }
            }

        // ** FREE TIP **! If an object is not interactive or has no buttons in it
        // (such as a game scene!) set interactiveChildren to false for that displayObject.
        // This will allow PixiJS to completely ignore and bypass checking the displayObjects children.
        if (hitTestChildren && displayObject.interactiveChildren && displayObject.children) {
            var children = displayObject.children;

            for (var i = children.length - 1; i >= 0; i--) {
                var child = children[i];

                // time to get recursive.. if this function will return if something is hit..
                var childHit = this.processInteractive(interactionEvent, child, func, hitTest, interactiveParent);

                if (childHit) {
                    // its a good idea to check if a child has lost its parent.
                    // this means it has been removed whilst looping so its best
                    if (!child.parent) {
                        continue;
                    }

                    // we no longer need to hit test any more objects in this container as we we
                    // now know the parent has been hit
                    interactiveParent = false;

                    // If the child is interactive , that means that the object hit was actually
                    // interactive and not just the child of an interactive object.
                    // This means we no longer need to hit test anything else. We still need to run
                    // through all objects, but we don't need to perform any hit tests.

                    if (childHit) {
                        if (interactionEvent.target) {
                            hitTest = false;
                        }
                        hit = true;
                    }
                }
            }
        }

        // no point running this if the item is not interactive or does not have an interactive parent.
        if (interactive) {
            // if we are hit testing (as in we have no hit any objects yet)
            // We also don't need to worry about hit testing if once of the displayObjects children
            // has already been hit - but only if it was interactive, otherwise we need to keep
            // looking for an interactive child, just in case we hit one
            if (hitTest && !interactionEvent.target) {
                // already tested against hitArea if it is defined
                if (!displayObject.hitArea && displayObject.containsPoint) {
                    if (displayObject.containsPoint(point)) {
                        hit = true;
                    }
                }
            }

            if (displayObject.interactive) {
                if (hit && !interactionEvent.target) {
                    interactionEvent.target = displayObject;
                }

                if (func) {
                    func(interactionEvent, displayObject, !!hit);
                }
            }
        }

        return hit;
    };

    /**
     * Is called when the pointer button is pressed down on the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being pressed down
     */

    InteractionManager.prototype.onPointerDown = function onPointerDown(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;

        var events = this.normalizeToPointerData(originalEvent);

        /**
         * No need to prevent default on natural pointer events, as there are no side effects
         * Normalized events, however, may have the double mousedown/touchstart issue on the native android browser,
         * so still need to be prevented.
         */

        // Guaranteed that there will be at least one event in events, and all events must have the same pointer type

        if (this.autoPreventDefault && events[0].isNormalized) {
            originalEvent.preventDefault();
        }

        var eventLen = events.length;

        for (var i = 0; i < eventLen; i++) {
            var event = events[i];

            var interactionData = this.getInteractionDataForPointerId(event);

            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

            interactionEvent.data.originalEvent = originalEvent;

            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerDown, true);

            this.emit('pointerdown', interactionEvent);
            if (event.pointerType === 'touch') {
                this.emit('touchstart', interactionEvent);
            }
            // emit a mouse event for "pen" pointers, the way a browser would emit a fallback event
            else if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
                    var isRightButton = event.button === 2;

                    this.emit(isRightButton ? 'rightdown' : 'mousedown', this.eventData);
                }
        }
    };

    /**
     * Processes the result of the pointer down check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */

    InteractionManager.prototype.processPointerDown = function processPointerDown(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;
        var id = interactionEvent.data.identifier;

        if (hit) {
            if (!displayObject.trackedPointers[id]) {
                displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
            }
            this.dispatchEvent(displayObject, 'pointerdown', interactionEvent);

            if (data.pointerType === 'touch') {
                this.dispatchEvent(displayObject, 'touchstart', interactionEvent);
            } else if (data.pointerType === 'mouse' || data.pointerType === 'pen') {
                var isRightButton = data.button === 2;

                if (isRightButton) {
                    displayObject.trackedPointers[id].rightDown = true;
                } else {
                    displayObject.trackedPointers[id].leftDown = true;
                }

                this.dispatchEvent(displayObject, isRightButton ? 'rightdown' : 'mousedown', interactionEvent);
            }
        }
    };

    /**
     * Is called when the pointer button is released on the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being released
     * @param {boolean} cancelled - true if the pointer is cancelled
     * @param {Function} func - Function passed to {@link processInteractive}
     */

    InteractionManager.prototype.onPointerComplete = function onPointerComplete(originalEvent, cancelled, func) {
        var events = this.normalizeToPointerData(originalEvent);

        var eventLen = events.length;

        // if the event wasn't targeting our canvas, then consider it to be pointerupoutside
        // in all cases (unless it was a pointercancel)
        var eventAppend = originalEvent.target !== this.interactionDOMElement ? 'outside' : '';

        for (var i = 0; i < eventLen; i++) {
            var event = events[i];

            var interactionData = this.getInteractionDataForPointerId(event);

            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

            interactionEvent.data.originalEvent = originalEvent;

            // perform hit testing for events targeting our canvas or cancel events
            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, func, cancelled || !eventAppend);

            this.emit(cancelled ? 'pointercancel' : 'pointerup' + eventAppend, interactionEvent);

            if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
                var isRightButton = event.button === 2;

                this.emit(isRightButton ? 'rightup' + eventAppend : 'mouseup' + eventAppend, interactionEvent);
            } else if (event.pointerType === 'touch') {
                this.emit(cancelled ? 'touchcancel' : 'touchend' + eventAppend, interactionEvent);
                this.releaseInteractionDataForPointerId(event.pointerId, interactionData);
            }
        }
    };

    /**
     * Is called when the pointer button is cancelled
     *
     * @private
     * @param {PointerEvent} event - The DOM event of a pointer button being released
     */

    InteractionManager.prototype.onPointerCancel = function onPointerCancel(event) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && event.pointerType === 'touch') return;

        this.onPointerComplete(event, true, this.processPointerCancel);
    };

    /**
     * Processes the result of the pointer cancel check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
     */

    InteractionManager.prototype.processPointerCancel = function processPointerCancel(interactionEvent, displayObject) {
        var data = interactionEvent.data;

        var id = interactionEvent.data.identifier;

        if (displayObject.trackedPointers[id] !== undefined) {
            delete displayObject.trackedPointers[id];
            this.dispatchEvent(displayObject, 'pointercancel', interactionEvent);

            if (data.pointerType === 'touch') {
                this.dispatchEvent(displayObject, 'touchcancel', interactionEvent);
            }
        }
    };

    /**
     * Is called when the pointer button is released on the renderer element
     *
     * @private
     * @param {PointerEvent} event - The DOM event of a pointer button being released
     */

    InteractionManager.prototype.onPointerUp = function onPointerUp(event) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && event.pointerType === 'touch') return;

        this.onPointerComplete(event, false, this.processPointerUp);
    };

    /**
     * Processes the result of the pointer up check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */

    InteractionManager.prototype.processPointerUp = function processPointerUp(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;

        var id = interactionEvent.data.identifier;

        var trackingData = displayObject.trackedPointers[id];

        var isTouch = data.pointerType === 'touch';

        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
        // need to track mouse down status in the mouse block so that we can emit
        // event in a later block
        var isMouseTap = false;

        // Mouse only
        if (isMouse) {
            var isRightButton = data.button === 2;

            var flags = _InteractionTrackingData2.default.FLAGS;

            var test = isRightButton ? flags.RIGHT_DOWN : flags.LEFT_DOWN;

            var isDown = trackingData !== undefined && trackingData.flags & test;

            if (hit) {
                this.dispatchEvent(displayObject, isRightButton ? 'rightup' : 'mouseup', interactionEvent);

                if (isDown) {
                    this.dispatchEvent(displayObject, isRightButton ? 'rightclick' : 'click', interactionEvent);
                    // because we can confirm that the mousedown happened on this object, flag for later emit of pointertap
                    isMouseTap = true;
                }
            } else if (isDown) {
                this.dispatchEvent(displayObject, isRightButton ? 'rightupoutside' : 'mouseupoutside', interactionEvent);
            }
            // update the down state of the tracking data
            if (trackingData) {
                if (isRightButton) {
                    trackingData.rightDown = false;
                } else {
                    trackingData.leftDown = false;
                }
            }
        }

        // Pointers and Touches, and Mouse
        if (hit) {
            this.dispatchEvent(displayObject, 'pointerup', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchend', interactionEvent);

            if (trackingData) {
                // emit pointertap if not a mouse, or if the mouse block decided it was a tap
                if (!isMouse || isMouseTap) {
                    this.dispatchEvent(displayObject, 'pointertap', interactionEvent);
                }
                if (isTouch) {
                    this.dispatchEvent(displayObject, 'tap', interactionEvent);
                    // touches are no longer over (if they ever were) when we get the touchend
                    // so we should ensure that we don't keep pretending that they are
                    trackingData.over = false;
                }
            }
        } else if (trackingData) {
            this.dispatchEvent(displayObject, 'pointerupoutside', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchendoutside', interactionEvent);
        }
        // Only remove the tracking data if there is no over/down state still associated with it
        if (trackingData && trackingData.none) {
            delete displayObject.trackedPointers[id];
        }
    };

    /**
     * Is called when the pointer moves across the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer moving
     */

    InteractionManager.prototype.onPointerMove = function onPointerMove(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;

        var events = this.normalizeToPointerData(originalEvent);

        if (events[0].pointerType === 'mouse' || events[0].pointerType === 'pen') {
            this.didMove = true;

            this.cursor = null;
        }

        var eventLen = events.length;

        for (var i = 0; i < eventLen; i++) {
            var event = events[i];

            var interactionData = this.getInteractionDataForPointerId(event);

            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

            interactionEvent.data.originalEvent = originalEvent;

            var interactive = event.pointerType === 'touch' ? this.moveWhenInside : true;

            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerMove, interactive);
            this.emit('pointermove', interactionEvent);
            if (event.pointerType === 'touch') this.emit('touchmove', interactionEvent);
            if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mousemove', interactionEvent);
        }

        if (events[0].pointerType === 'mouse') {
            this.setCursorMode(this.cursor);

            // TODO BUG for parents interactive object (border order issue)
        }
    };

    /**
     * Processes the result of the pointer move check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */

    InteractionManager.prototype.processPointerMove = function processPointerMove(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;

        var isTouch = data.pointerType === 'touch';

        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';

        if (isMouse) {
            this.processPointerOverOut(interactionEvent, displayObject, hit);
        }

        if (!this.moveWhenInside || hit) {
            this.dispatchEvent(displayObject, 'pointermove', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchmove', interactionEvent);
            if (isMouse) this.dispatchEvent(displayObject, 'mousemove', interactionEvent);
        }
    };

    /**
     * Is called when the pointer is moved out of the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer being moved out
     */

    InteractionManager.prototype.onPointerOut = function onPointerOut(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;

        var events = this.normalizeToPointerData(originalEvent);

        // Only mouse and pointer can call onPointerOut, so events will always be length 1
        var event = events[0];

        if (event.pointerType === 'mouse') {
            this.mouseOverRenderer = false;
            this.setCursorMode(null);
        }

        var interactionData = this.getInteractionDataForPointerId(event);

        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

        interactionEvent.data.originalEvent = event;

        this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, false);

        this.emit('pointerout', interactionEvent);
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
            this.emit('mouseout', interactionEvent);
        } else {
            // we can get touchleave events after touchend, so we want to make sure we don't
            // introduce memory leaks
            this.releaseInteractionDataForPointerId(interactionData.identifier);
        }
    };

    /**
     * Processes the result of the pointer over/out check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */

    InteractionManager.prototype.processPointerOverOut = function processPointerOverOut(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;

        var id = interactionEvent.data.identifier;

        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';

        var trackingData = displayObject.trackedPointers[id];

        // if we just moused over the display object, then we need to track that state
        if (hit && !trackingData) {
            trackingData = displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
        }

        if (trackingData === undefined) return;

        if (hit && this.mouseOverRenderer) {
            if (!trackingData.over) {
                trackingData.over = true;
                this.dispatchEvent(displayObject, 'pointerover', interactionEvent);
                if (isMouse) {
                    this.dispatchEvent(displayObject, 'mouseover', interactionEvent);
                }
            }

            // only change the cursor if it has not already been changed (by something deeper in the
            // display tree)
            if (isMouse && this.cursor === null) {
                this.cursor = displayObject.cursor;
            }
        } else if (trackingData.over) {
            trackingData.over = false;
            this.dispatchEvent(displayObject, 'pointerout', this.eventData);
            if (isMouse) {
                this.dispatchEvent(displayObject, 'mouseout', interactionEvent);
            }
            // if there is no mouse down information for the pointer, then it is safe to delete
            if (trackingData.none) {
                delete displayObject.trackedPointers[id];
            }
        }
    };

    /**
     * Is called when the pointer is moved into the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being moved into the renderer view
     */

    InteractionManager.prototype.onPointerOver = function onPointerOver(originalEvent) {
        var events = this.normalizeToPointerData(originalEvent);

        // Only mouse and pointer can call onPointerOver, so events will always be length 1
        var event = events[0];

        var interactionData = this.getInteractionDataForPointerId(event);

        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

        interactionEvent.data.originalEvent = event;

        if (event.pointerType === 'mouse') {
            this.mouseOverRenderer = true;
        }

        this.emit('pointerover', interactionEvent);
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
            this.emit('mouseover', interactionEvent);
        }
    };

    /**
     * Get InteractionData for a given pointerId. Store that data as well
     *
     * @private
     * @param {PointerEvent} event - Normalized pointer event, output from normalizeToPointerData
     * @return {PIXI.interaction.InteractionData} - Interaction data for the given pointer identifier
     */

    InteractionManager.prototype.getInteractionDataForPointerId = function getInteractionDataForPointerId(event) {
        var pointerId = event.pointerId;

        var interactionData = void 0;

        if (pointerId === MOUSE_POINTER_ID || event.pointerType === 'mouse') {
            interactionData = this.mouse;
        } else if (this.activeInteractionData[pointerId]) {
            interactionData = this.activeInteractionData[pointerId];
        } else {
            interactionData = this.interactionDataPool.pop() || new _InteractionData2.default();
            interactionData.identifier = pointerId;
            this.activeInteractionData[pointerId] = interactionData;
        }
        // copy properties from the event, so that we can make sure that touch/pointer specific
        // data is available
        interactionData.copyEvent(event);

        return interactionData;
    };

    /**
     * Return unused InteractionData to the pool, for a given pointerId
     *
     * @private
     * @param {number} pointerId - Identifier from a pointer event
     */

    InteractionManager.prototype.releaseInteractionDataForPointerId = function releaseInteractionDataForPointerId(pointerId) {
        var interactionData = this.activeInteractionData[pointerId];

        if (interactionData) {
            delete this.activeInteractionData[pointerId];
            interactionData.reset();
            this.interactionDataPool.push(interactionData);
        }
    };

    /**
     * Configure an InteractionEvent to wrap a DOM PointerEvent and InteractionData
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The event to be configured
     * @param {PointerEvent} pointerEvent - The DOM event that will be paired with the InteractionEvent
     * @param {PIXI.interaction.InteractionData} interactionData - The InteractionData that will be paired
     *        with the InteractionEvent
     * @return {PIXI.interaction.InteractionEvent} the interaction event that was passed in
     */

    InteractionManager.prototype.configureInteractionEventForDOMEvent = function configureInteractionEventForDOMEvent(interactionEvent, pointerEvent, interactionData) {
        interactionEvent.data = interactionData;

        this.mapPositionToPoint(interactionData.global, pointerEvent.clientX, pointerEvent.clientY);

        // This is the way InteractionManager processed touch events before the refactoring, so I've kept
        // it here. But it doesn't make that much sense to me, since mapPositionToPoint already factors
        // in this.resolution, so this just divides by this.resolution twice for touch events...
        if (navigator.isCocoonJS && pointerEvent.pointerType === 'touch') {
            interactionData.global.x = interactionData.global.x / this.resolution;
            interactionData.global.y = interactionData.global.y / this.resolution;
        }

        // Not really sure why this is happening, but it's how a previous version handled things
        if (pointerEvent.pointerType === 'touch') {
            pointerEvent.globalX = interactionData.global.x;
            pointerEvent.globalY = interactionData.global.y;
        }

        interactionData.originalEvent = pointerEvent;
        interactionEvent.reset();

        return interactionEvent;
    };

    /**
     * Ensures that the original event object contains all data that a regular pointer event would have
     *
     * @private
     * @param {TouchEvent|MouseEvent|PointerEvent} event - The original event data from a touch or mouse event
     * @return {PointerEvent[]} An array containing a single normalized pointer event, in the case of a pointer
     *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
     */

    InteractionManager.prototype.normalizeToPointerData = function normalizeToPointerData(event) {
        var normalizedEvents = [];

        if (this.supportsTouchEvents && event instanceof TouchEvent) {
            for (var i = 0, li = event.changedTouches.length; i < li; i++) {
                var touch = event.changedTouches[i];

                if (typeof touch.button === 'undefined') touch.button = event.touches.length ? 1 : 0;
                if (typeof touch.buttons === 'undefined') touch.buttons = event.touches.length ? 1 : 0;
                if (typeof touch.isPrimary === 'undefined') {
                    touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
                }
                if (typeof touch.width === 'undefined') touch.width = touch.radiusX || 1;
                if (typeof touch.height === 'undefined') touch.height = touch.radiusY || 1;
                if (typeof touch.tiltX === 'undefined') touch.tiltX = 0;
                if (typeof touch.tiltY === 'undefined') touch.tiltY = 0;
                if (typeof touch.pointerType === 'undefined') touch.pointerType = 'touch';
                if (typeof touch.pointerId === 'undefined') touch.pointerId = touch.identifier || 0;
                if (typeof touch.pressure === 'undefined') touch.pressure = touch.force || 0.5;
                if (typeof touch.twist === 'undefined') touch.twist = 0;
                if (typeof touch.tangentialPressure === 'undefined') touch.tangentialPressure = 0;
                // TODO: Remove these, as layerX/Y is not a standard, is deprecated, has uneven
                // support, and the fill ins are not quite the same
                // offsetX/Y might be okay, but is not the same as clientX/Y when the canvas's top
                // left is not 0,0 on the page
                if (typeof touch.layerX === 'undefined') touch.layerX = touch.offsetX = touch.clientX;
                if (typeof touch.layerY === 'undefined') touch.layerY = touch.offsetY = touch.clientY;

                // mark the touch as normalized, just so that we know we did it
                touch.isNormalized = true;

                normalizedEvents.push(touch);
            }
        }
        // apparently PointerEvent subclasses MouseEvent, so yay
        else if (event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof window.PointerEvent))) {
                if (typeof event.isPrimary === 'undefined') event.isPrimary = true;
                if (typeof event.width === 'undefined') event.width = 1;
                if (typeof event.height === 'undefined') event.height = 1;
                if (typeof event.tiltX === 'undefined') event.tiltX = 0;
                if (typeof event.tiltY === 'undefined') event.tiltY = 0;
                if (typeof event.pointerType === 'undefined') event.pointerType = 'mouse';
                if (typeof event.pointerId === 'undefined') event.pointerId = MOUSE_POINTER_ID;
                if (typeof event.pressure === 'undefined') event.pressure = 0.5;
                if (typeof event.twist === 'undefined') event.twist = 0;
                if (typeof event.tangentialPressure === 'undefined') event.tangentialPressure = 0;

                // mark the mouse event as normalized, just so that we know we did it
                event.isNormalized = true;

                normalizedEvents.push(event);
            } else {
                normalizedEvents.push(event);
            }

        return normalizedEvents;
    };

    /**
     * Destroys the interaction manager
     *
     */

    InteractionManager.prototype.destroy = function destroy() {
        this.removeEvents();

        this.removeAllListeners();

        this.renderer = null;

        this.mouse = null;

        this.eventData = null;

        this.interactionDOMElement = null;

        this.onPointerDown = null;
        this.processPointerDown = null;

        this.onPointerUp = null;
        this.processPointerUp = null;

        this.onPointerCancel = null;
        this.processPointerCancel = null;

        this.onPointerMove = null;
        this.processPointerMove = null;

        this.onPointerOut = null;
        this.processPointerOverOut = null;

        this.onPointerOver = null;

        this._tempPoint = null;
    };

    return InteractionManager;
}(_eventemitter2.default);

exports.default = InteractionManager;

core.WebGLRenderer.registerPlugin('interaction', InteractionManager);
core.CanvasRenderer.registerPlugin('interaction', InteractionManager);
//# sourceMappingURL=InteractionManager.js.map

/***/ }),

/***/ "IdVv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Rows_1 = __webpack_require__("Pu1Z");
var Seat_1 = __webpack_require__("pKi2");
var TicketMappingMixin_1 = __webpack_require__("kWdy");

var RowsBase = function (_Rows_1$default) {
    _inherits(RowsBase, _Rows_1$default);

    function RowsBase() {
        _classCallCheck(this, RowsBase);

        return _possibleConstructorReturn(this, _Rows_1$default.apply(this, arguments));
    }

    RowsBase.prototype.seatsInit = function seatsInit(seats, disableInteraction) {
        var _this2 = this;

        var seatCount = seats.length;
        return seats.map(function (seat, i) {
            var constructionValue = _extends({ pos: _this2.getSeatPos(i, seatCount), seatlabelStartAt: _this2.seatlabelStartAt, bookByTable: _this2.bookByTable, tableId: _this2._id, sectionId: _this2.sectionId, sectionName: _this2.sectionName, tableName: _this2.name }, seat);
            return new Seat_1.default(constructionValue, _this2.actions, disableInteraction);
        });
    };

    RowsBase.prototype.updateTexture = function updateTexture() {};

    return RowsBase;
}(Rows_1.default);

exports.RowsBase = RowsBase;

var Rows = function (_TicketMappingMixin_) {
    _inherits(Rows, _TicketMappingMixin_);

    function Rows() {
        _classCallCheck(this, Rows);

        return _possibleConstructorReturn(this, _TicketMappingMixin_.apply(this, arguments));
    }

    return Rows;
}(TicketMappingMixin_1.default(RowsBase));

exports.Rows = Rows;
//# sourceMappingURL=Rows.js.map

/***/ }),

/***/ "IpUV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var SDFRenderer_1 = __webpack_require__("LEJh");
var InteractionManager_1 = __webpack_require__("dUAP");
__webpack_require__("h+SF");
var Views_1 = __webpack_require__("xsdn");
var Selector_1 = __webpack_require__("8Y7Z");
var SpriteLoader_1 = __webpack_require__("oGbJ");
var Config_1 = __webpack_require__("gH/r");
var bound_1 = __webpack_require__("USDo");
var Viewport = __webpack_require__("Ycoe");
var _Config_1$default$sty = Config_1.default.style,
    backgroundConstructionColor = _Config_1$default$sty.backgroundConstructionColor,
    backgroundReservationColor = _Config_1$default$sty.backgroundReservationColor;

Viewport.prototype.handleWheel = function (e) {
    if (this.pause || !this.worldVisible) {
        return;
    }
    var result = void 0;
    for (var _iterator = this.pluginsList, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var plugin = _ref;

        if (plugin.wheel(e)) {
            result = true;
        }
    }
    return result;
};

var SeatingMap = function () {
    function SeatingMap(seatingData, actions, styles, config) {
        var ticketTypeIds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

        _classCallCheck(this, SeatingMap);

        var construction = config.construction,
            onConsole = config.onConsole,
            ticketMapping = config.ticketMapping,
            customerView = config.customerView,
            useClientDimensions = config.useClientDimensions;

        this.setTicketTypes(ticketTypeIds);
        PIXI.WebGLRenderer.registerPlugin('sdf', SDFRenderer_1.default);
        var maskGroup = new PIXI.display.Group(1, true);
        var spriteGroup = new PIXI.display.Group(2, true);
        var textGroup = new PIXI.display.Group(3, true);
        var graphicsGroup = new PIXI.display.Group(4, true);
        Config_1.default.graphicsGroup = graphicsGroup;
        Config_1.default.textGroup = textGroup;
        Config_1.default.spriteGroup = spriteGroup;
        Config_1.default.maskGroup = maskGroup;
        if (construction) {
            Selector_1.init();
        }
        var canvas = document.getElementById("seatingMap");
        canvas.onwheel = function (e) {
            e.preventDefault();
        };
        Config_1.default.onConsole = onConsole;
        Config_1.default.canvasBounding = canvas.getBoundingClientRect();
        Config_1.default.xPadding = styles.canvasPadding || 0;
        this.name = seatingData.seatingName || "Venue Map 1";
        var w = useClientDimensions ? canvas.clientWidth : Config_1.default.canvasBounding.width - (styles.canvasPadding ? styles.canvasPadding : 0);
        var h = useClientDimensions ? canvas.clientHeight : Config_1.default.canvasBounding.height;
        window.addEventListener('resize', this.listenForResize);
        Config_1.default.app = new PIXI.Application({
            width: w,
            height: h,
            backgroundColor: construction || customerView ? backgroundConstructionColor : backgroundReservationColor,
            antialias: true
        });
        Config_1.default.app.stage = new PIXI.display.Stage();
        Config_1.default.app.stage.position.set(Config_1.default.canvasBounding.left, Config_1.default.canvasBounding.top);
        Config_1.default.viewport = new Viewport({
            screenWidth: w,
            screenHeight: h,
            worldWidth: w,
            worldHeight: h,
            divWheel: canvas,
            interaction: Config_1.default.app.renderer.plugins.interaction
        });
        PIXI.settings.PRECISION_FRAGMENT = 'highp';
        canvas.appendChild(Config_1.default.app.view);
        this.hitArea = new PIXI.Rectangle(0, 0, w, h);
        this.hitArea.contains = function () {
            return true;
        };
        Config_1.default.viewport.forceHitArea = this.hitArea;
        var container = new PIXI.Container();
        container.addChild(Config_1.default.viewport);
        Config_1.default.app.stage.addChild(container);
        Config_1.default.app.stage.addChild(new PIXI.display.Layer(maskGroup));
        Config_1.default.app.stage.addChild(new PIXI.display.Layer(spriteGroup));
        Config_1.default.app.stage.addChild(new PIXI.display.Layer(textGroup));
        Config_1.default.app.stage.addChild(new PIXI.display.Layer(graphicsGroup));
        Config_1.default.viewport.pinch().clampZoom({
            minWidth: 100,
            minHeight: 100,
            maxWidth: 10000,
            maxHeight: 10000
        }).wheel({ percent: 0.05 }).drag().decelerate();
        if (construction) {
            this.initialiseConstruction(seatingData, actions);
        } else if (customerView) {
            this.initialiseCustomer(seatingData);
        } else if (ticketMapping) {
            this.initialiseTicketMapping(seatingData);
        } else {
            this.initialiseReservation(seatingData, actions);
        }
        this.graphics = new PIXI.Graphics();
        Config_1.default.viewport.addChild(this.graphics);
    }

    SeatingMap.createTicketMappingView = function createTicketMappingView(SeatingMapData, actions, host, ticketTypeIds) {
        var config = {
            construction: false,
            onConsole: false,
            customerView: false,
            ticketMapping: true,
            useClientDimensions: true
        };
        return new Promise(function (res, rej) {
            if (!SeatingMap.ticketingInitialised) {
                SeatingMap.loading = true;
                SeatingMap.ticketingInitialised = true;
                SpriteLoader_1.loadReservation(host, false, function () {
                    SeatingMap.loading = false;
                    Selector_1.init(true);
                    SeatingMap.instance = new SeatingMap(SeatingMapData, actions, {}, config, ticketTypeIds);
                    Selector_1.initialiseInteractionManager();
                    res(SeatingMap.instance);
                });
            } else {
                Selector_1.init(true);
                SeatingMap.instance = new SeatingMap(SeatingMapData, actions, {}, config, ticketTypeIds);
                Selector_1.initialiseInteractionManager();
                res(SeatingMap.instance);
            }
        });
    };

    SeatingMap.createTicketingSeatingMap = function createTicketingSeatingMap(SeatingMapData, actions, host, styles) {
        var onConsole = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        var config = {
            construction: false,
            onConsole: onConsole,
            customerView: false,
            ticketMapping: false,
            useClientDimensions: false
        };
        return new Promise(function (res, rej) {
            if (!SeatingMap.ticketingInitialised) {
                SeatingMap.loading = true;
                SeatingMap.ticketingInitialised = true;
                SpriteLoader_1.loadReservation(host, onConsole, function () {
                    SeatingMap.loading = false;
                    Selector_1.init(true);
                    SeatingMap.instance = new SeatingMap(SeatingMapData, actions, styles, config);
                    Selector_1.initialiseInteractionManager();
                    res(SeatingMap.instance);
                });
            } else {
                Selector_1.init(true);
                SeatingMap.instance = new SeatingMap(SeatingMapData, actions, styles, config);
                Selector_1.initialiseInteractionManager();
                res(SeatingMap.instance);
            }
        });
    };

    SeatingMap.createSeatingMap = function createSeatingMap(SeatingMapData, actions, host, styles, ticketTypeIds, undoActions) {
        var config = {
            construction: true,
            onConsole: false,
            customerView: false,
            ticketMapping: false,
            useClientDimensions: false
        };
        Config_1.default.undoActions = undoActions;
        return new Promise(function (res, rej) {
            if (!SeatingMap.constructionInitialised) {
                SeatingMap.loading = true;
                SeatingMap.constructionInitialised = true;
                SpriteLoader_1.loadConstruction(host, function () {
                    SeatingMap.loading = false;
                    Selector_1.init();
                    SeatingMap.instance = new SeatingMap(SeatingMapData, actions, styles, config, ticketTypeIds);
                    Selector_1.initialiseInteractionManager();
                    res(SeatingMap.instance);
                });
            } else {
                Selector_1.init();
                SeatingMap.instance = new SeatingMap(SeatingMapData, actions, styles, config, ticketTypeIds);
                Selector_1.initialiseInteractionManager();
                res(SeatingMap.instance);
            }
        });
    };

    SeatingMap.loadCustomerSeatingMap = function loadCustomerSeatingMap(SeatingMapData, actions, host, styles) {
        var config = {
            construction: false,
            onConsole: true,
            customerView: true,
            ticketMapping: false,
            useClientDimensions: false
        };
        return new Promise(function (res, rej) {
            if (!SeatingMap.constructionInitialised) {
                SeatingMap.loading = true;
                SeatingMap.constructionInitialised = true;
                SpriteLoader_1.loadConstruction(host, function () {
                    SeatingMap.loading = false;
                    Selector_1.init();
                    SeatingMap.instance = new SeatingMap(SeatingMapData, actions, styles, config);
                    Selector_1.initialiseInteractionManager();
                    res(SeatingMap.instance);
                });
            } else {
                Selector_1.init();
                SeatingMap.instance = new SeatingMap(SeatingMapData, actions, styles, config);
                Selector_1.initialiseInteractionManager();
                res(SeatingMap.instance);
            }
        });
    };

    SeatingMap.removeSeatingMap = function removeSeatingMap() {
        Config_1.default.viewport.destroy({
            children: true,
            texture: false,
            baseTexture: false
        });
        Config_1.default.app.destroy(true);
        PIXI.loader.destroy();
        Views_1.SeatingConstruction.initialised = false;
        Views_1.SeatingConstruction.instance = null;
        Views_1.SectionOverview.initialised = false;
        Views_1.SectionOverview.instance = null;
        delete SeatingMap.instance.seatingConstruction;
        delete SeatingMap.instance;
        delete InteractionManager_1.default.instance;
    };

    SeatingMap.getCurrentMap = function getCurrentMap() {
        return SeatingMap.instance;
    };

    SeatingMap.prototype.getPercentiles = function getPercentiles(width, height) {
        return {
            widthPerc: +width.replace("%", "") / 100,
            heightPerc: +height.replace("%", "") / 100
        };
    };

    SeatingMap.prototype.initialiseTicketMapping = function initialiseTicketMapping(seatingData) {
        var _this = this;

        Config_1.default.ticketMappingRepo = new Map();
        this.ticketMappingView = Views_1.SeatingMapping.createSeatingMappingView(seatingData.seatingConstruction);
        Config_1.default.viewport.addChild(this.ticketMappingView.getContainer());
        var bounds = this.ticketMappingView.getDimensions();
        setTimeout(function () {
            _this.zoomFit(bounds);
            _this.cornerFit(bounds);
        }, 50);
    };

    SeatingMap.prototype.initialiseConstruction = function initialiseConstruction(seatingData, actions) {
        var _this2 = this;

        Config_1.default.ticketMappingRepo = new Map();
        this.seatingConstruction = Views_1.SeatingConstruction.createSeatingConstructionView(seatingData.seatingConstruction, actions);
        this.seatingConstruction.listenForShiftDrag(Config_1.default.canvasBounding);
        this.sectionOverview = Views_1.SectionOverview.createSectionOverviewView(seatingData.sectionOverview.sections, seatingData.sectionOverview.objects, actions, false);
        Config_1.default.viewport.addChild(this.seatingConstruction.getContainer());
        Config_1.default.viewport.addChild(this.sectionOverview.getContainer());
        Config_1.default.viewport.addChild(Selector_1.getGraphics());
        setTimeout(function () {
            if (_this2.seatingConstruction.sections.length > 0) {
                var bounds = _this2.seatingConstruction.getDimensions();
                _this2.zoomFit(bounds);
                _this2.cornerFit(bounds);
            }
        }, 50);
    };

    SeatingMap.prototype.initialiseCustomer = function initialiseCustomer(seatingData) {
        var _this3 = this;

        this.seatingManagement = Views_1.SeatingManagement.createSeatingManagementView(seatingData.seatingConstruction, true);
        Config_1.default.viewport.addChild(this.seatingManagement.getContainer());
        Config_1.default.viewport.addChild(Selector_1.getGraphics());
        this.seatingManagement.show();
        var bounds = this.seatingManagement.getDimensions();
        setTimeout(function () {
            _this3.zoomFit(bounds);
            _this3.cornerFit(bounds);
        }, 50);
    };

    SeatingMap.prototype.initialiseReservation = function initialiseReservation(seatingData, actions) {
        this.seatingReservation = Views_1.SeatingReservation.createSeatingReservationView(seatingData.seatingConstruction, actions);
        actions.onSectionClicked = this.switchToSeatingReservationView;
        this.sectionOverview = Views_1.SectionOverview.createSectionOverviewView(seatingData.sectionOverview.sections, seatingData.sectionOverview.objects, actions, true);
        Config_1.default.viewport.addChild(this.seatingReservation.getContainer());
        Config_1.default.app.stage.addChild(this.seatingReservation.getBackButtonContainer());
        Config_1.default.viewport.addChild(this.sectionOverview.getContainer());
        Config_1.default.viewport.addChild(Selector_1.getGraphics());
        Config_1.default.hasSections = this.sectionOverview.hasSections();
        if (!Config_1.default.hasSections) {
            this.switchToSeatingReservationView(this.seatingReservation.sections[0]._id);
        } else {
            this.switchToSectionReservationView();
        }
    };

    SeatingMap.prototype.toggleTicketTypeColors = function toggleTicketTypeColors(enable) {
        this.seatingConstruction.toggleTicketTypeColors(enable);
    };

    SeatingMap.prototype.setTicketTypes = function setTicketTypes(ticketTypes) {
        Config_1.default.setTicketTypeColor(ticketTypes);
    };

    SeatingMap.prototype.getTicketTypeColorMap = function getTicketTypeColorMap() {
        return Config_1.default.getTicketTypeColor();
    };

    SeatingMap.prototype.onUnmount = function onUnmount() {
        window.removeEventListener('resize', this.listenForResize);
    };

    SeatingMap.prototype.zoom = function zoom(perc) {
        Config_1.default.viewport.zoomPercent(perc / Config_1.default.viewport.scale._x, true);
        var view = Config_1.default.viewport;
        var v = {
            "viewport": view
        };
        Config_1.default.viewport.emit("zoomed", v);
        return Config_1.default.viewport.scale._x;
    };

    SeatingMap.prototype.listenForZoom = function listenForZoom(zoomCb) {
        var _this4 = this;

        this.zoomCb = zoomCb;
        Config_1.default.viewport.on("zoomed", function (_ref2) {
            var viewport = _ref2.viewport;

            _this4.zoomCb(viewport.scale._x);
        });
    };

    SeatingMap.prototype.listenForResize = function listenForResize() {
        var canvas = document.getElementById("seatingMap");
        if (canvas) {
            var w = Config_1.default.canvasBounding.width - Config_1.default.xPadding;
            var h = Config_1.default.canvasBounding.height;
            Config_1.default.app.renderer.resize(w, h);
            if (!canvas.hasChildNodes()) {
                Config_1.default.viewport.div = canvas;
                canvas.appendChild(Config_1.default.app.view);
            }
        }
    };

    SeatingMap.prototype.getSectionImage = function getSectionImage() {
        if (this.sectionOverview.sectionsViews.length > 1) {
            this.sectionOverview.show();
            var img = Config_1.default.app.renderer.plugins.extract.image(this.sectionOverview.getContainer());
            this.sectionOverview.hide();
            return img;
        } else {
            return { src: undefined };
        }
    };

    SeatingMap.prototype.getSeatingImage = function getSeatingImage() {
        this.seatingConstruction.show();
        this.seatingConstruction.hideSection(true);
        var img = Config_1.default.app.renderer.plugins.extract.image(this.seatingConstruction.getContainer());
        this.seatingConstruction.hideSection(false);
        return img;
    };

    SeatingMap.prototype.snap = function snap(x, y) {
        Config_1.default.viewport.snap(x, y);
    };

    SeatingMap.prototype.move = function move(x, y) {
        Config_1.default.viewport.moveCorner({ x: x, y: y });
    };

    SeatingMap.prototype.zoomFit = function zoomFit(bounds) {
        Config_1.default.viewport.transform.scale._x = 1;
        Config_1.default.viewport.transform.scale._y = 1;
        Config_1.default.viewport.transform.position._x = 0;
        Config_1.default.viewport.transform.position._y = 0;
        var width = bounds.right - bounds.left;
        var height = bounds.bottom - bounds.top;
        Config_1.default.viewport.fit(true, width * 1.0, height * 1.0);
        if (this.zoomCb) {
            this.zoomCb(Config_1.default.viewport.scale._x);
        }
    };

    SeatingMap.prototype.cornerFit = function cornerFit(bounds) {
        var scale = Config_1.default.viewport.transform.scale;

        var paddingWidth = (Config_1.default.canvasBounding.width - (bounds.right - bounds.left) * scale._x) / 2;
        var paddingHeight = (Config_1.default.canvasBounding.height - (bounds.bottom - bounds.top) * scale._y) / 2;
        var left = Config_1.default.canvasBounding.left / scale._x;
        var top = Config_1.default.canvasBounding.top / scale._y;
        Config_1.default.viewport.moveCorner({ x: left + bounds.left - paddingWidth / scale._x, y: top + bounds.top - paddingHeight / scale._y });
    };

    SeatingMap.prototype.switchToSectionReservationView = function switchToSectionReservationView() {
        var _this5 = this;

        Selector_1.clear();
        this.sectionOverview.show();
        this.seatingReservation.hide();
        var bounds = this.sectionOverview.getDimensions();
        setTimeout(function () {
            _this5.zoomFit(bounds);
            _this5.cornerFit(bounds);
        }, 50);
    };

    SeatingMap.prototype.switchToSeatingReservationView = function switchToSeatingReservationView(sectionId) {
        var _this6 = this;

        Selector_1.clear();
        this.seatingReservation.focusOnSection(sectionId);
        var bounds = this.seatingReservation.getDimensions();
        this.sectionOverview.hide();
        this.seatingReservation.show();
        setTimeout(function () {
            _this6.zoomFit(bounds);
            _this6.cornerFit(bounds);
            _this6.seatingReservation.listenOnzoom();
        }, 50);
    };

    SeatingMap.prototype.switchToSectionView = function switchToSectionView() {
        var _this7 = this;

        this.sectionOverview.newSections(this.seatingConstruction.getSections());
        this.sectionOverview.newObjects(this.seatingConstruction.getObjects());
        this.seatingConstruction.hide();
        if (this.seatingManagement) {
            this.seatingManagement.hide();
        }
        if (!this.viewportContains(Selector_1.getGraphics())) {
            Config_1.default.viewport.addChild(Selector_1.getGraphics());
        }
        this.sectionOverview.show();
        var bounds = this.sectionOverview.getDimensions();
        setTimeout(function () {
            _this7.zoomFit(bounds);
            _this7.cornerFit(bounds);
        }, 50);
        Selector_1.clear();
    };

    SeatingMap.prototype.switchToSeatView = function switchToSeatView() {
        var _this8 = this;

        this.seatingConstruction.show();
        if (this.seatingManagement) {
            this.seatingManagement.hide();
        }
        if (!this.viewportContains(Selector_1.getGraphics())) {
            Config_1.default.viewport.addChild(Selector_1.getGraphics());
        }
        this.sectionOverview.hide();
        if (this.seatingConstruction.sections.length > 0) {
            var bounds = this.seatingConstruction.getDimensions();
            setTimeout(function () {
                _this8.zoomFit(bounds);
                _this8.cornerFit(bounds);
            }, 50);
        }
        Selector_1.clear();
    };

    SeatingMap.prototype.switchToManagementView = function switchToManagementView(seatingManagementData) {
        var _this9 = this;

        if (this.seatingManagement) {
            Config_1.default.viewport.removeChild(this.seatingManagement.getContainer());
        }
        this.seatingManagement = Views_1.SeatingManagement.createSeatingManagementView(seatingManagementData.seatingConstruction, false);
        if (this.viewportContains(Selector_1.getGraphics())) {
            Config_1.default.viewport.removeChild(Selector_1.getGraphics());
        }
        Config_1.default.viewport.addChildAt(this.seatingManagement.getContainer(), 2);
        this.seatingConstruction.hide();
        this.sectionOverview.hide();
        this.seatingManagement.show();
        var bounds = this.seatingManagement.getDimensions();
        setTimeout(function () {
            _this9.zoomFit(bounds);
            _this9.cornerFit(bounds);
        }, 50);
        Selector_1.clear();
    };

    SeatingMap.prototype.getName = function getName() {
        return this.name;
    };

    SeatingMap.prototype.changeName = function changeName(name) {
        this.name = name;
    };

    SeatingMap.prototype.toJSON = function toJSON() {
        return {
            seatingName: this.name,
            seatingConstruction: this.seatingConstruction.toJSON(),
            sectionOverview: this.sectionOverview.toJSON(),
            image: this.getSectionImage().src,
            seatingImage: this.getSeatingImage().src
        };
    };

    SeatingMap.prototype.getFPS = function getFPS() {
        return Config_1.default.app.ticker.FPS;
    };

    SeatingMap.prototype.viewportContains = function viewportContains(container) {
        try {
            Config_1.default.viewport.getChildIndex(container);
        } catch (err) {
            return false;
        }
        return true;
    };

    return SeatingMap;
}();

SeatingMap.constructionInitialised = false;
SeatingMap.ticketingInitialised = false;
__decorate([bound_1.default], SeatingMap.prototype, "toggleTicketTypeColors", null);
__decorate([bound_1.default], SeatingMap.prototype, "setTicketTypes", null);
__decorate([bound_1.default], SeatingMap.prototype, "getTicketTypeColorMap", null);
__decorate([bound_1.default], SeatingMap.prototype, "onUnmount", null);
__decorate([bound_1.default], SeatingMap.prototype, "listenForZoom", null);
__decorate([bound_1.default], SeatingMap.prototype, "getSectionImage", null);
__decorate([bound_1.default], SeatingMap.prototype, "getSeatingImage", null);
__decorate([bound_1.default], SeatingMap.prototype, "zoomFit", null);
__decorate([bound_1.default], SeatingMap.prototype, "switchToSectionReservationView", null);
__decorate([bound_1.default], SeatingMap.prototype, "switchToSeatingReservationView", null);
__decorate([bound_1.default], SeatingMap.prototype, "switchToSectionView", null);
__decorate([bound_1.default], SeatingMap.prototype, "switchToSeatView", null);
__decorate([bound_1.default], SeatingMap.prototype, "switchToManagementView", null);
__decorate([bound_1.default], SeatingMap.prototype, "getName", null);
__decorate([bound_1.default], SeatingMap.prototype, "changeName", null);
__decorate([bound_1.default], SeatingMap.prototype, "toJSON", null);
exports.default = SeatingMap;
//# sourceMappingURL=SeatingMap.js.map

/***/ }),

/***/ "J21P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLEAR_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_ORDER_REQ_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_ORDER_REQ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_ORDER_REQ_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SAVE_ORDER_DATA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SAVE_ORDER_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SAVE_ORDER_DATA_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PAYMENT_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHECKOUT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PAYMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PAYMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PAYMENT_ERROR; });
/* unused harmony export AUTH_KEY_REQUEST */
/* unused harmony export AUTH_KEY_SUCCESS */
/* unused harmony export AUTH_KEY_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_ORDER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_DUMMY_ORDER_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_DUMMY_ORDER_SUCCESS; });
/* unused harmony export GET_DUMMY_ORDER_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_DISCOUNT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_DISCOUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_DISCOUNT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return REMOVE_DISCOUNT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return REMOVE_DISCOUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return REMOVE_DISCOUNT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_GIFT_CARD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_GIFT_CARD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_GIFT_CARD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COMPLETE_GIFT_CARD_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return COMPLETE_GIFT_CARD_ORDER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return COMPLETE_GIFT_CARD_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return REMOVE_GIFT_CARD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return REMOVE_GIFT_CARD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return REMOVE_GIFT_CARD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return TIME_EXPIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHANGE_PAYMENT_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CREDIT_AND_DEBIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return INVOICING; });
/* unused harmony export QUANTITY_VALIDATION_ERROR */
/* unused harmony export QUANTITY_VALIDATION_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return timeExpired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return clearOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return payByCreditDebit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return payByInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getOrderPublic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return saveOrderPublic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return addDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return removeDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return completeGiftCardOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return addGiftCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return removeGiftCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return generateDummyOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return requestOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return saveOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return saveAfterCheckoutQuestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return payClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return checkoutError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return orderComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return redirectToComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return pay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_OrderService__ = __webpack_require__("l/4+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_tracking_TrackingService__ = __webpack_require__("03y+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__merchandiseActions__ = __webpack_require__("pb6B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orderSummaryActions__ = __webpack_require__("E70C");




var CLEAR_ORDER = "CLEAR_ORDER";

var GET_ORDER_REQ_REQUEST = "GET_ORDER_REQ_REQUEST";
var GET_ORDER_REQ_SUCCESS = "GET_ORDER_REQ_SUCCESS";
var GET_ORDER_REQ_ERROR = "GET_ORDER_REQ_ERROR";

var SAVE_ORDER_DATA_REQUEST = "SAVE_ORDER_DATA_REQUEST";
var SAVE_ORDER_DATA_SUCCESS = "SAVE_ORDER_DATA_SUCCESS";
var SAVE_ORDER_DATA_ERROR = "SAVE_ORDER_DATA_ERROR";

var PAYMENT_CLICKED = "PAYMENT_CLICKED";
var CHECKOUT_ERROR = "CHECKOUT_ERROR";

var PAYMENT_REQUEST = "PAYMENT_REQUEST";
var PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
var PAYMENT_ERROR = "PAYMENT_ERROR";

var AUTH_KEY_REQUEST = "AUTH_KEY_REQUEST";
var AUTH_KEY_SUCCESS = "AUTH_KEY_SUCCESS";
var AUTH_KEY_ERROR = "AUTH_KEY_ERROR";

var GET_ORDER_REQUEST = "GET_ORDER_REQUEST";
var GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
var GET_ORDER_ERROR = "GET_ORDER_ERROR";

var GET_DUMMY_ORDER_LOADING = "GET_DUMMY_ORDER_LOADING";
var GET_DUMMY_ORDER_SUCCESS = "GET_DUMMY_ORDER_SUCCESS";
var GET_DUMMY_ORDER_ERROR = "GET_DUMMY_ORDER_ERROR";

var ADD_DISCOUNT_REQUEST = "ADD_DISCOUNT_REQUEST";
var ADD_DISCOUNT_SUCCESS = "ADD_DISCOUNT_SUCCESS";
var ADD_DISCOUNT_ERROR = "ADD_DISCOUNT_ERROR";

var REMOVE_DISCOUNT_REQUEST = "REMOVE_DISCOUNT_REQUEST";
var REMOVE_DISCOUNT_SUCCESS = "REMOVE_DISCOUNT_SUCCESS";
var REMOVE_DISCOUNT_ERROR = "REMOVE_DISCOUNT_ERROR";

var ADD_GIFT_CARD_REQUEST = "ADD_GIFT_CARD_REQUEST";
var ADD_GIFT_CARD_SUCCESS = "ADD_GIFT_CARD_SUCCESS";
var ADD_GIFT_CARD_ERROR = "ADD_GIFT_CARD_ERROR";

var COMPLETE_GIFT_CARD_ORDER_REQUEST = "COMPLETE_GIFT_CARD_ORDER_REQUEST";
var COMPLETE_GIFT_CARD_ORDER_ERROR = "COMPLETE_GIFT_CARD_ORDER_ERROR";
var COMPLETE_GIFT_CARD_ORDER_SUCCESS = "COMPLETE_GIFT_CARD_ORDER_SUCCESS";

var REMOVE_GIFT_CARD_REQUEST = "REMOVE_GIFT_CARD_REQUEST";
var REMOVE_GIFT_CARD_SUCCESS = "REMOVE_GIFT_CARD_SUCCESS";
var REMOVE_GIFT_CARD_ERROR = "REMOVE_GIFT_CARD_ERROR";

var TIME_EXPIRED = "TIME_EXPIRED";

var CHANGE_PAYMENT_METHOD = "CHANGE_PAYMENT_METHOD";

var CREDIT_AND_DEBIT = "CREDIT_AND_DEBIT";
var INVOICING = "INVOICING";

var QUANTITY_VALIDATION_ERROR = "QUANTITY_VALIDATION_ERROR";
var QUANTITY_VALIDATION_REQUEST = "QUANTITY_VALIDATION_REQUEST";



var timeExpired = function timeExpired() {
  return function (dispatch) {
    dispatch({ type: TIME_EXPIRED });
  };
};

var clearOrder = function clearOrder() {
  return function (dispatch) {
    dispatch({ type: CLEAR_ORDER });
  };
};

var payByCreditDebit = function payByCreditDebit() {
  return function (dispatch) {
    dispatch({ type: CHANGE_PAYMENT_METHOD, method: CREDIT_AND_DEBIT });
  };
};

var payByInvoice = function payByInvoice() {
  return function (dispatch) {
    dispatch({ type: CHANGE_PAYMENT_METHOD, method: INVOICING });
  };
};

var getOrder = function getOrder(id) {
  var getMerch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function (dispatch) {
    dispatch({ type: GET_ORDER_REQUEST, id: id });
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].get(id).then(function (order) {
      dispatch({ type: GET_ORDER_SUCCESS, order: order });
      if (getMerch) {
        Object(__WEBPACK_IMPORTED_MODULE_3__merchandiseActions__["l" /* getMerchandise */])(id)(dispatch);
      }
    }).catch(function (err) {
      dispatch({ type: GET_ORDER_ERROR, error: err });
    });
  };
};

var getOrderPublic = function getOrderPublic(eventId, orderId, token) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var order;
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (err) {
        try {
          dispatch({ type: GET_ORDER_ERROR, error: err });
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: GET_ORDER_REQUEST });
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].getPublicOrder(eventId, orderId, token)).then(function ($await_3) {
          try {
            order = $await_3;
            dispatch({ type: GET_ORDER_SUCCESS, order: order });
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (err) {
        $Try_1_Catch(err)
      }
    });
  };
};

var saveOrderPublic = function saveOrderPublic(eventId, orderId, token, orderData) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var order;
      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_2_Catch = function (err) {
        try {
          dispatch({ type: SAVE_ORDER_DATA_ERROR, error: err });
          return $Try_2_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: SAVE_ORDER_DATA_REQUEST });
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].savePublicOrder(eventId, orderId, token, orderData)).then(function ($await_4) {
          try {
            order = $await_4;
            dispatch({ type: SAVE_ORDER_DATA_SUCCESS, order: order });
            return $Try_2_Post();
          } catch ($boundEx) {
            return $Try_2_Catch($boundEx);
          }
        }, $Try_2_Catch);
      } catch (err) {
        $Try_2_Catch(err)
      }
    });
  };
};

var addDiscount = function addDiscount(eventId, orderId, discountCode) {
  return function (dispatch, getState) {
    dispatch({ type: ADD_DISCOUNT_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].addDiscount(eventId, orderId, discountCode).then(function (result) {
      dispatch({ type: ADD_DISCOUNT_SUCCESS, order: result.order });
      var state = getState();
      Object(__WEBPACK_IMPORTED_MODULE_4__orderSummaryActions__["d" /* loadSummary */])(state.event.id, state.ticketSelection.requestedTickets, state.ticketSelection.clientDonation, result.order, state.merchandise.merch.display || [])(dispatch);
    }).catch(function (err) {
      var error = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : err;
      dispatch({ type: ADD_DISCOUNT_ERROR, error: error });
    });
  };
};

var removeDiscount = function removeDiscount(orderId) {
  return function (dispatch, getState) {
    dispatch({ type: REMOVE_DISCOUNT_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].removeDiscount(orderId).then(function (result) {
      dispatch({ type: REMOVE_DISCOUNT_SUCCESS, order: result.order });
      var state = getState();
      Object(__WEBPACK_IMPORTED_MODULE_4__orderSummaryActions__["d" /* loadSummary */])(state.event.id, state.ticketSelection.requestedTickets, state.ticketSelection.clientDonation, result.order, state.merchandise.merch.display || [])(dispatch);
    }).catch(function (err) {
      var error = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : err;
      dispatch({ type: REMOVE_DISCOUNT_ERROR, error: error });
    });
  };
};

var completeGiftCardOrder = function completeGiftCardOrder(orderId) {
  return function (dispatch, getState) {
    dispatch({ type: COMPLETE_GIFT_CARD_ORDER_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].completeOrderWithGiftCard(orderId).then(function (result) {
      dispatch({
        type: COMPLETE_GIFT_CARD_ORDER_SUCCESS,
        order: result.order
      });
      var state = getState();
      orderComplete(state.event.data.slug, state.event.data, state.order.data, false, false);
    }).catch(function (err) {
      var error = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : err;
      dispatch({ type: COMPLETE_GIFT_CARD_ORDER_ERROR, error: error });
    });
  };
};

var addGiftCard = function addGiftCard(eventId, orderId, giftCardCode) {
  return function (dispatch, getState) {
    dispatch({ type: ADD_GIFT_CARD_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].addGiftCard(eventId, orderId, giftCardCode).then(function (result) {
      dispatch({
        type: ADD_GIFT_CARD_SUCCESS,
        order: result.order,
        isFullPayment: result.isFullPayment
      });
      var state = getState();
      Object(__WEBPACK_IMPORTED_MODULE_4__orderSummaryActions__["d" /* loadSummary */])(state.event.id, state.ticketSelection.requestedTickets, state.ticketSelection.clientDonation, result.order)(dispatch);
    }).catch(function (err) {
      var error = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : err;
      dispatch({ type: ADD_GIFT_CARD_ERROR, error: error });
    });
  };
};

var removeGiftCard = function removeGiftCard(orderId) {
  return function (dispatch, getState) {
    dispatch({ type: REMOVE_GIFT_CARD_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].removeGiftCard(orderId).then(function (result) {
      dispatch({ type: REMOVE_GIFT_CARD_SUCCESS, order: result.order });
      var state = getState();
      Object(__WEBPACK_IMPORTED_MODULE_4__orderSummaryActions__["d" /* loadSummary */])(state.event.id, state.ticketSelection.requestedTickets, state.ticketSelection.clientDonation, result.order)(dispatch);
    }).catch(function (err) {
      var error = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : err;
      dispatch({ type: REMOVE_GIFT_CARD_ERROR, error: error });
    });
  };
};

var generateDummyOrder = function generateDummyOrder(event) {
  var ticketTypes = event.data.ticketTypes.map(function (ticket, index) {
    ticket.ticketTypeName = ticket.name;
    ticket.ticketTypeId = ticket._id;
    ticket.order = index + 1;
    return ticket;
  });
  return function (dispatch) {
    dispatch({ type: GET_DUMMY_ORDER_LOADING });
    var dummyOrder = {
      timeExpired: false,
      data: {
        createdAt: new Date().getTime(),
        incompleteAt: new Date().getTime() + 10000000,
        tickets: ticketTypes
      }
    };
    dispatch({ type: GET_DUMMY_ORDER_SUCCESS, order: dummyOrder });
  };
};

var requestOrder = function requestOrder(slug, id, eventDateId, requestedItems, discountCode, clientDonation, lastOrderId, isGlobal, manualOrderValues) {
  return function (dispatch, getState) {
    dispatch({ type: GET_ORDER_REQ_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].request(id, eventDateId, requestedItems, discountCode, clientDonation, lastOrderId, isGlobal, manualOrderValues).then(function (result) {
      var state = getState();
      var order = result.order;
      var additionalQuestions = result.additionalQuestions || false;
      dispatch({
        type: GET_ORDER_REQ_SUCCESS,
        order: order,
        additionalQuestions: additionalQuestions
      });
      if (isGlobal) {
        __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route("/gift-cards/" + slug + "/details/" + order._id);
      } else {
        if (result.offerMerch) {
          __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route("/" + slug + "/add-ons/" + order._id);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route("/" + slug + "/details/" + order._id);
        }
      }
      if (!isGlobal) {
        Object(__WEBPACK_IMPORTED_MODULE_4__orderSummaryActions__["d" /* loadSummary */])(state.event.id, state.ticketSelection.requestedTickets, state.ticketSelection.clientDonation, order)(dispatch);
        __WEBPACK_IMPORTED_MODULE_1__services_tracking_TrackingService__["a" /* default */].ticketsAdded(state.event.data, order);
      }
    }).catch(function (err) {
      var error = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : err;
      dispatch({ type: GET_ORDER_REQ_ERROR, error: error });
    });
  };
};

var saveOrderData = function saveOrderData(slug, eventId, orderData, tickets, ticketData, hasAdditionalSteps, isGlobal) {
  return function (dispatch, getState) {
    dispatch({ type: SAVE_ORDER_DATA_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].saveDetails(orderData, tickets, ticketData, hasAdditionalSteps, isGlobal).then(function (result) {
      var order = result.order;
      var authKey = result.authKey;
      dispatch({ type: SAVE_ORDER_DATA_SUCCESS, order: order, authKey: authKey });
      var state = getState();
      __WEBPACK_IMPORTED_MODULE_1__services_tracking_TrackingService__["a" /* default */].enteredDetails(state.event.data, order);
      if (order.status === "complete") {
        // the order is complete show thank you
        orderComplete(slug, state.event.data, order, hasAdditionalSteps);
      } else {
        if (isGlobal) {
          var _state$giftCards = state.giftCards,
              giftCardsOrder = _state$giftCards.giftCardsOrder,
              giftCardPage = _state$giftCards.giftCardPage;

          Object(__WEBPACK_IMPORTED_MODULE_4__orderSummaryActions__["d" /* loadSummary */])(giftCardPage.userId, [], 0, {}, [], giftCardsOrder, false)(dispatch);
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_4__orderSummaryActions__["d" /* loadSummary */])(state.event.id, state.ticketSelection.tickets, state.ticketSelection.clientDonation, order, state.merchandise.merch.display || [])(dispatch);
        }
        if (hasAdditionalSteps && state.event.data.settings.enableTicketAssigning) {
          __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route("/" + slug + "/assign/" + order._id);
        } else if (hasAdditionalSteps) {
          redirectToSeatingReservation(slug, order._id);
        } else {
          // the order is not complete payment is needed
          __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route((isGlobal ? "/gift-cards" : "") + "/" + slug + "/payment/" + order._id);
        }
      }
    }).catch(function (err) {
      console.error(err);
      var error = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : err;
      var additionalQuestionQuantityError = err && err.response && err.response.data && err.response.data.error && err.response.data.error.additionalQuestionQuantityError ? err.response.data.error.additionalQuestionQuantityError : false;
      dispatch({
        type: SAVE_ORDER_DATA_ERROR,
        error: error,
        additionalQuestionQuantityError: additionalQuestionQuantityError
      });
    });
  };
};

var redirectToSeatingReservation = function redirectToSeatingReservation(eventSlug, orderId) {
  __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route("/" + eventSlug + "/seatingmap/" + orderId);
};

var saveAfterCheckoutQuestions = function saveAfterCheckoutQuestions(event, order, orderData, ticketData) {
  var tickets = order.data.tickets;
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].saveAfterCheckoutQuestions(event.data, orderData, tickets, ticketData).then(function (result) {
      __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route("/" + event.data.slug + "/complete/" + order.data._id);
      __WEBPACK_IMPORTED_MODULE_1__services_tracking_TrackingService__["a" /* default */].complete(event.data, order.data);
    }).catch(function (err) {
      var error = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : err;
      var additionalQuestionQuantityError = err && err.response && err.response.data && err.response.data.error && err.response.data.error.additionalQuestionQuantityError ? err.response.data.error.additionalQuestionQuantityError : false;
      dispatch({
        type: SAVE_ORDER_DATA_ERROR,
        error: error,
        additionalQuestionQuantityError: additionalQuestionQuantityError
      });
    });
  };
};

var payClicked = function payClicked() {
  return function (dispatch) {
    dispatch({ type: PAYMENT_CLICKED });
  };
};

var checkoutError = function checkoutError() {
  return function (dispatch) {
    dispatch({ type: CHECKOUT_ERROR });
  };
};

var orderComplete = function orderComplete(eventSlug, event, order, hasAdditionalSteps, isGlobal) {
  var afterCheckoutQuestions = event && event.additionalQuestions ? event.additionalQuestions.filter(function (q) {
    return q.askAfterCheckout;
  }) : [];
  var newAfterCheckoutQuestions = [];
  order.tickets.forEach(function (ticket) {
    afterCheckoutQuestions.forEach(function (q) {
      if (!q.appliesTo || !q.appliesTo.length || q.appliesTo.indexOf(ticket.ticketTypeId) !== -1) {
        newAfterCheckoutQuestions.push(q);
      }
    });
  });

  if (hasAdditionalSteps) {
    redirectToSeatingReservation(eventSlug, order._id);
  } else if (hasAdditionalSteps && event.settings.enableTicketAssigning) {
    __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route("/" + eventSlug + "/assign/" + order._id);
  } else if (newAfterCheckoutQuestions && newAfterCheckoutQuestions.length) {
    __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route("/" + eventSlug + "/afterCheckout/" + order._id);
  } else {
    __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route((isGlobal ? "/gift-cards" : "") + "/" + eventSlug + "/complete/" + order._id);
  }
  __WEBPACK_IMPORTED_MODULE_1__services_tracking_TrackingService__["a" /* default */].complete(event, order);
};

var redirectToComplete = function redirectToComplete(eventSlug, event, order) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_2_preact_router__["Router"].route("/" + eventSlug + "/complete/" + order._id);
  };
};

var pay = function pay(eventSlug, orderId, gateway, details, id, isGlobal) {
  return function (dispatch, getState) {
    dispatch({ type: PAYMENT_REQUEST });
    __WEBPACK_IMPORTED_MODULE_0__services_OrderService__["a" /* default */].pay(orderId, gateway, details, id, isGlobal).then(function (result) {
      var order = result.order;
      if (result.success && order.status === "complete") {
        // the order is complete show thank you
        var state = getState();
        orderComplete(eventSlug, state.event.data, order, false, isGlobal);
        dispatch({ type: PAYMENT_SUCCESS, order: order });
        return;
      }
      dispatch({ type: PAYMENT_ERROR, order: order, error: result.error });
    }).catch(function (err) {
      var error = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : err;
      dispatch({ type: PAYMENT_ERROR, error: error });
    });
  };
};

/***/ }),

/***/ "J4Nk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(_extends({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),

/***/ "J6GP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function (qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr,
        vstr,
        k,
        v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

/***/ }),

/***/ "JJWE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Config_1 = __webpack_require__("gH/r");
var Selector_1 = __webpack_require__("8Y7Z");
var bound_1 = __webpack_require__("USDo");

var MoveableContainer = function () {
    function MoveableContainer() {
        _classCallCheck(this, MoveableContainer);
    }

    MoveableContainer.prototype.move = function move(e) {
        var xInc = e.data.originalEvent.movementX / Config_1.default.viewport.transform.scale._x;
        var yInc = e.data.originalEvent.movementY / Config_1.default.viewport.transform.scale._y;
        this.moveableContainer.position.x += xInc;
        this.moveableContainer.position.y += yInc;
    };

    MoveableContainer.prototype.setPosition = function setPosition(_ref) {
        var x = _ref.x,
            y = _ref.y;

        var oldPos = {
            x: this.moveableContainer.position.x,
            y: this.moveableContainer.position.y
        };
        this.moveableContainer.position.x = x;
        this.moveableContainer.position.y = y;
        this.drawSelectionBox();
        if (this.onTableMoved) {
            this.onTableMoved();
        }
        return { functionCall: this.setPosition, params: [{ x: oldPos.x, y: oldPos.y }] };
    };

    MoveableContainer.prototype.getPosition = function getPosition() {
        var _moveableContainer$po = this.moveableContainer.position,
            x = _moveableContainer$po.x,
            y = _moveableContainer$po.y;

        return { x: x, y: y };
    };

    MoveableContainer.prototype.setPivot = function setPivot(x, y) {
        var width = this.moveableContainer.width;
        var height = this.moveableContainer.height;
        var newPivot = {
            x: width * x,
            y: height * y
        };
        this.moveableContainer.pivot.x = newPivot.x;
        this.moveableContainer.pivot.y = newPivot.y;
    };

    MoveableContainer.prototype.rotate = function rotate(e, p3) {
        var localBounds = this.moveableContainer.getLocalBounds();
        var p4 = {
            x: localBounds.width / 2,
            y: localBounds.height / 2
        };
        var xInc = e.data.originalEvent.movementX / Config_1.default.viewport.transform.scale._x;
        var yInc = e.data.originalEvent.movementY / Config_1.default.viewport.transform.scale._y;
        var p1 = this.moveableContainer.position;
        p3.x += xInc;
        p3.y += yInc;
        var angle = Math.atan2(p3.y - p1.y, p3.x - p1.x);
        this.moveableContainer.rotation = angle;
        this.drawSelectionBox();
    };

    MoveableContainer.prototype.setRotation = function setRotation(angle) {
        var oldRotation = this.moveableContainer.rotation;
        this.moveableContainer.rotation = angle;
        this.drawSelectionBox();
        if (this.onTableMoved) {
            this.onTableMoved();
        }
        return { functionCall: this.setRotation, params: [oldRotation] };
    };

    MoveableContainer.prototype.applyCurrentRotation = function applyCurrentRotation(x, y) {
        var rotation = this.moveableContainer.rotation;
        var testX = x;
        var testY = y;
        var newX = testX * Math.cos(rotation) - testY * Math.sin(rotation);
        var newY = testX * Math.sin(rotation) + testY * Math.cos(rotation);
        return { x: newX, y: newY };
    };

    MoveableContainer.prototype.setContainerOffset = function setContainerOffset(xOff, yOff) {
        this.contXOffset = xOff;
        this.contXOffset = yOff;
    };

    MoveableContainer.prototype.drawSelectionBox = function drawSelectionBox() {
        var _getSelectionBoxBound = this.getSelectionBoxBounds(),
            x = _getSelectionBoxBound.x,
            y = _getSelectionBoxBound.y,
            width = _getSelectionBoxBound.width,
            height = _getSelectionBoxBound.height;

        Selector_1.drawSelectionBox(x, y, width, height);
    };

    MoveableContainer.prototype.onElementClicked = function onElementClicked(e) {
        this.onEleClicked(e);
    };

    MoveableContainer.prototype.onChange = function onChange() {
        if (this._onChange) {
            this._onChange();
        }
    };

    MoveableContainer.prototype.setOnChange = function setOnChange(cb) {
        this._onChange = cb;
    };

    return MoveableContainer;
}();

__decorate([bound_1.default], MoveableContainer.prototype, "setPosition", null);
__decorate([bound_1.default], MoveableContainer.prototype, "getPosition", null);
__decorate([bound_1.default], MoveableContainer.prototype, "setRotation", null);
exports.default = MoveableContainer;
//# sourceMappingURL=MoveableContainer.js.map

/***/ }),

/***/ "JUot":
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) {// .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' && selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function (range) {
        selection.addRange(range);
      });
    }

    active && active.focus();
  };
};

/***/ }),

/***/ "JVKT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = canUploadSameBuffer;
function canUploadSameBuffer() {
	// Uploading the same buffer multiple times in a single frame can cause perf issues.
	// Apparent on IOS so only check for that at the moment
	// this check may become more complex if this issue pops up elsewhere.
	var ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

	return !ios;
}
//# sourceMappingURL=canUploadSameBuffer.js.map

/***/ }),

/***/ "Jb0W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _BaseRenderTexture = __webpack_require__("8ODW");

var _BaseRenderTexture2 = _interopRequireDefault(_BaseRenderTexture);

var _Texture2 = __webpack_require__("xUki");

var _Texture3 = _interopRequireDefault(_Texture2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A RenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
 *
 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded
 * otherwise black rectangles will be drawn instead.
 *
 * A RenderTexture takes a snapshot of any Display Object given to its render method. For example:
 *
 * ```js
 * let renderer = PIXI.autoDetectRenderer(1024, 1024);
 * let renderTexture = PIXI.RenderTexture.create(800, 600);
 * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
 *
 * sprite.position.x = 800/2;
 * sprite.position.y = 600/2;
 * sprite.anchor.x = 0.5;
 * sprite.anchor.y = 0.5;
 *
 * renderer.render(sprite, renderTexture);
 * ```
 *
 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
 * you can clear the transform
 *
 * ```js
 *
 * sprite.setTransform()
 *
 * let renderTexture = new PIXI.RenderTexture.create(100, 100);
 *
 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
 * ```
 *
 * @class
 * @extends PIXI.Texture
 * @memberof PIXI
 */
var RenderTexture = function (_Texture) {
  _inherits(RenderTexture, _Texture);

  /**
   * @param {PIXI.BaseRenderTexture} baseRenderTexture - The renderer used for this RenderTexture
   * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
   */
  function RenderTexture(baseRenderTexture, frame) {
    _classCallCheck(this, RenderTexture);

    // support for legacy..
    var _legacyRenderer = null;

    if (!(baseRenderTexture instanceof _BaseRenderTexture2.default)) {
      /* eslint-disable prefer-rest-params, no-console */
      var width = arguments[1];
      var height = arguments[2];
      var scaleMode = arguments[3];
      var resolution = arguments[4];

      // we have an old render texture..
      console.warn('Please use RenderTexture.create(' + width + ', ' + height + ') instead of the ctor directly.');
      _legacyRenderer = arguments[0];
      /* eslint-enable prefer-rest-params, no-console */

      frame = null;
      baseRenderTexture = new _BaseRenderTexture2.default(width, height, scaleMode, resolution);
    }

    /**
     * The base texture object that this texture uses
     *
     * @member {BaseTexture}
     */

    var _this = _possibleConstructorReturn(this, _Texture.call(this, baseRenderTexture, frame));

    _this.legacyRenderer = _legacyRenderer;

    /**
     * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
     *
     * @member {boolean}
     */
    _this.valid = true;

    _this._updateUvs();
    return _this;
  }

  /**
   * Resizes the RenderTexture.
   *
   * @param {number} width - The width to resize to.
   * @param {number} height - The height to resize to.
   * @param {boolean} doNotResizeBaseTexture - Should the baseTexture.width and height values be resized as well?
   */

  RenderTexture.prototype.resize = function resize(width, height, doNotResizeBaseTexture) {
    width = Math.ceil(width);
    height = Math.ceil(height);

    // TODO - could be not required..
    this.valid = width > 0 && height > 0;

    this._frame.width = this.orig.width = width;
    this._frame.height = this.orig.height = height;

    if (!doNotResizeBaseTexture) {
      this.baseTexture.resize(width, height);
    }

    this._updateUvs();
  };

  /**
   * A short hand way of creating a render texture.
   *
   * @param {number} [width=100] - The width of the render texture
   * @param {number} [height=100] - The height of the render texture
   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
   * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
   * @return {PIXI.RenderTexture} The new render texture
   */

  RenderTexture.create = function create(width, height, scaleMode, resolution) {
    return new RenderTexture(new _BaseRenderTexture2.default(width, height, scaleMode, resolution));
  };

  return RenderTexture;
}(_Texture3.default);

exports.default = RenderTexture;
//# sourceMappingURL=RenderTexture.js.map

/***/ }),

/***/ "JgNJ":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/index.scss
var style_0 = __webpack_require__("yY49");
var style_default = /*#__PURE__*/__webpack_require__.n(style_0);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__("jYI/");

// EXTERNAL MODULE: ../node_modules/preact-async-route/dist/index.js
var dist = __webpack_require__("F5z4");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./assets/images/logos/Logo.js



var defaultColor = {
  twoTone: {
    twoToneColor: "#57CFC7",
    color: "#fff"
  },
  white: {
    twoToneColor: "#fff",
    color: "#fff"
  },
  black: {
    twoToneColor: "#000",
    color: "#000"
  }
};

var Logo_Logo = function Logo(_ref) {
  var footerLogoColor = _ref.footerLogoColor,
      width = _ref.width,
      height = _ref.height;

  var logoColor = defaultColor[footerLogoColor];

  return Object(preact_min["h"])(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width,
      height: height,
      viewBox: "0 0 185 32"
    },
    Object(preact_min["h"])(
      "g",
      { fill: "none", "fill-rule": "nonzero" },
      Object(preact_min["h"])("path", {
        fill: logoColor.color,
        d: "M16.446 18.45c-1.411 0-2.155-.75-2.155-2.168V12.64a.886.886 0 0 0-.254-.7.875.875 0 0 0-.696-.256H8.442a.875.875 0 0 0-.696.256.886.886 0 0 0-.254.7v3.643c0 1.417-.746 2.168-2.157 2.168h-3.18C.746 18.45 0 17.7 0 16.282V2.684C0 1.264.746.514 2.155.514h3.18c1.411 0 2.157.75 2.157 2.17V5.14c-.022.26.07.516.254.7a.875.875 0 0 0 .696.255h4.899a.875.875 0 0 0 .696-.255.886.886 0 0 0 .254-.7V2.684c0-1.42.744-2.17 2.155-2.17h3.18c1.41 0 2.157.75 2.157 2.17v13.598c0 1.417-.746 2.168-2.157 2.168h-3.18zM30.517 18.745c-3.443 0-5.19-1.584-5.19-4.705V2.684c0-1.42.746-2.17 2.157-2.17h2.924c1.41 0 2.157.75 2.157 2.17v8.893c0 1.219.895 1.36 1.571 1.36.682 0 1.364-.05 2.039-.148a.906.906 0 0 0 .65-.306.917.917 0 0 0 .228-.685V2.684c0-1.42.746-2.17 2.157-2.17h2.96c1.411 0 2.155.75 2.155 2.17v13.598c0 1.417-.744 2.168-2.155 2.168h-1.608c-1.034 0-1.697-.272-2.083-.857l-.074-.11a.853.853 0 0 0-.659-.408.907.907 0 0 0-.47.152 16.308 16.308 0 0 1-6.759 1.518zM71.452 18.45c-1.411 0-2.157-.75-2.157-2.168V7.386c0-.937-.413-1.324-1.424-1.324h-.529a5.808 5.808 0 0 0-1.008.084.99.99 0 0 0-.803 1.062v9.074c0 1.417-.746 2.168-2.157 2.168h-2.633c-1.412 0-2.155-.75-2.155-2.168V7.386c0-.913-.453-1.324-1.464-1.324-.473-.008-.946.017-1.416.075a.978.978 0 0 0-.878 1.064v9.081c0 1.417-.746 2.168-2.155 2.168H49.78c-1.411 0-2.157-.75-2.157-2.168V2.684c0-1.42.746-2.17 2.157-2.17h1.499c.908 0 1.536.22 1.944.687l.138.207c.156.247.365.505.705.505a.975.975 0 0 0 .46-.139A11.839 11.839 0 0 1 60.599.01c1.756 0 3.048.48 3.851 1.43.175.23.442.37.729.382.209-.01.41-.08.581-.201C67.372.53 69.23 0 71.452 0 74.8 0 76.5 1.657 76.5 4.926v11.356c0 1.417-.747 2.168-2.158 2.168h-2.89zM84.929 18.964c-1.688 0-3.209-.442-4.284-1.27a4.503 4.503 0 0 1-1.782-3.727v-1.83c0-2.789 2.225-4.521 5.811-4.521H89.9c.659 0 .659-.525.659-.697v-.331c-.046-1.19-.792-1.397-2.34-1.397a205.3 205.3 0 0 0-5.925.11h-.088c-1.277 0-2.02-.753-2.21-2.236-.094-.592.048-1.199.398-1.686.365-.47.906-.767 1.496-.823C84.6.226 87.325.04 90.055 0c5.528 0 7.784 2.108 7.784 7.283v8.962a2.138 2.138 0 0 1-.62 1.584 2.114 2.114 0 0 1-1.574.623H93.67c-.74 0-1.425-.342-1.668-.834l-.147-.256c-.13-.294-.31-.356-.44-.356a.545.545 0 0 0-.333.135c-1.569 1.21-3.638 1.823-6.153 1.823zm2.567-8.086c-.976 0-1.608.534-1.608 1.361v.587c0 .663.46 1.362 1.755 1.362a15.304 15.304 0 0 0 2.221-.187.835.835 0 0 0 .74-.883v-1.421c0-.53-.279-.81-.805-.81l-2.303-.01zM115.09 18.45c-1.41 0-2.154-.75-2.154-2.168V7.386c0-.926-.461-1.324-1.537-1.324-.778-.008-1.556.03-2.33.117-.595.093-.878.442-.878 1.029v9.074c0 1.417-.746 2.168-2.157 2.168h-2.93c-1.411 0-2.157-.75-2.157-2.168V2.684c0-1.42.746-2.17 2.157-2.17h1.576c.75-.028 1.47.299 1.946.883l.108.143c.139.278.412.461.72.484.192-.009.38-.065.546-.164C110.4.64 112.69 0 114.617 0c3.684 0 5.554 2.152 5.554 6.4v9.887c0 1.417-.746 2.167-2.157 2.167l-2.923-.004z"
      }),
      Object(preact_min["h"])("rect", {
        width: "7.2",
        height: "17.935",
        x: "123.498",
        y: ".514",
        fill: logoColor.color,
        rx: "2.153"
      }),
      Object(preact_min["h"])("path", {
        fill: logoColor.twoToneColor,
        d: "M141.348 18.45c-1.41 0-2.157-.709-2.157-2.053V7.755h-3.606c-1.512 0-2.313-.75-2.313-2.17V2.685c0-1.42.801-2.17 2.313-2.17h14.412c1.514 0 2.313.75 2.313 2.17v2.902c0 1.419-.799 2.169-2.313 2.169h-3.606v8.642c0 1.344-.746 2.053-2.157 2.053h-2.886zM179.898 18.496c-.593 0-1.181-.267-1.756-.792l-3.37-3.119-3.378 3.119c-.57.525-1.159.792-1.756.792s-1.18-.267-1.755-.792l-2.31-2.132c-.56-.519-.848-1.055-.848-1.59 0-.533.287-1.07.849-1.59l3.419-3.145-3.406-3.143c-.562-.52-.85-1.055-.85-1.59 0-.537.288-1.071.85-1.592l2.309-2.13c.568-.525 1.156-.792 1.742-.792.586 0 1.18.267 1.756.792l3.375 3.119 3.38-3.119c.568-.525 1.156-.792 1.755-.792.6 0 1.183.267 1.756.792l2.306 2.13c.564.52.85 1.055.85 1.591s-.286 1.07-.85 1.591l-3.414 3.143 3.403 3.145c.564.52.85 1.055.85 1.59 0 .537-.286 1.071-.85 1.59l-2.306 2.132c-.568.525-1.159.792-1.751.792z"
      }),
      Object(preact_min["h"])("rect", {
        width: "7.2",
        height: "17.935",
        x: "154.823",
        y: ".514",
        fill: logoColor.twoToneColor,
        rx: "2.153"
      }),
      Object(preact_min["h"])("path", {
        fill: logoColor.twoToneColor,
        d: "M161.382 32c-1.09 0-2.179-.068-3.26-.203a2.383 2.383 0 0 1-1.649-.989 2.45 2.45 0 0 1-.397-1.918l.333-1.575a2.435 2.435 0 0 1 2.638-1.93c.775.092 1.555.138 2.335.138 4.359 0 8.533-1.479 10.64-3.767a2.404 2.404 0 0 1 2.945-.468l1.446.816a2.437 2.437 0 0 1 .658 3.701C173.73 29.676 167.87 32 161.382 32z"
      })
    )
  );
};

/* harmony default export */ var logos_Logo = (Logo_Logo);
// EXTERNAL MODULE: ./assets/images/logos/registered_charity_logo.png
var registered_charity_logo = __webpack_require__("NM9i");
var registered_charity_logo_default = /*#__PURE__*/__webpack_require__.n(registered_charity_logo);

// EXTERNAL MODULE: ./config.js
var config = __webpack_require__("aSYM");

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/emotion/dist/index.esm.js
var index_esm = __webpack_require__("mibh");

// CONCATENATED MODULE: ./utils/Location.js
var getCountry = function getCountry(event) {
  if (!event || !event.location || event.location.type !== "address" || !event.location.addressComponents) {
    return false;
  }
  var addressComponents = event.location.addressComponents;
  var country = addressComponents.find(function (component) {
    return component.types.includes("country");
  });
  if (country) {
    return country.long_name.toLowerCase();
  }
  return false;
};

var getLocality = function getLocality(event) {
  if (!event || !event.location || event.location.type !== "address" || !event.location.addressComponents) {
    return false;
  }
  var addressComponents = event.location.addressComponents;
  var locality = addressComponents.find(function (component) {
    return component.types.includes("locality");
  });
  if (locality) {
    return locality.long_name.toLowerCase();
  }
  return false;
};
// EXTERNAL MODULE: ./utils/CssUtils.js
var CssUtils = __webpack_require__("iYSS");

// CONCATENATED MODULE: ./components/Breadcrumbs.js






var Breadcrumbs__ref2 = Object(preact_min["h"])(
  "span",
  { itemprop: "name" },
  "All Events"
);

var Breadcrumbs__ref3 = Object(preact_min["h"])("meta", { itemprop: "position", content: "1" });

var Breadcrumbs__ref4 = Object(preact_min["h"])(
  "span",
  { "aria-hidden": true },
  ">"
);

var Breadcrumbs__ref5 = Object(preact_min["h"])("meta", { itemprop: "position", content: "2" });

var Breadcrumbs__ref6 = Object(preact_min["h"])(
  "span",
  { "aria-hidden": true },
  ">"
);

var Breadcrumbs__ref7 = Object(preact_min["h"])("meta", { itemprop: "position", content: "3" });

var Breadcrumbs_Breadcrumbs = function Breadcrumbs(_ref) {
  var _li;

  var event = _ref.event,
      color = _ref.color;

  var overBar = Object(index_esm["css"])({
    margin: "0 auto",
    maxWidth: "1200px",
    padding: "12px 60px",
    span: {
      margin: "0 8px"
    },
    ol: {
      listStyle: "none"
    },
    li: (_li = {
      margin: 0,
      display: "inline-block",
      a: {
        color: color + " !important",
        textDecoration: "underline",
        textTransform: "capitalize",
        fontSize: 14,
        fontWeight: 400
      }
    }, _li[Object(CssUtils["b" /* lastOfType */])()] = {
      a: {
        textDecoration: "none"
      }
    }, _li),

    "@media(max-width: 500px)": {
      padding: "8px 14px"
    }
  });
  var country = getCountry(event.data);
  var locality = getLocality(event.data);
  var locale = Object(config["a" /* default */])("CURRENCY") === "NZD" ? "nz" : "au";
  var marketingUrl = Object(config["a" /* default */])("WEBSITE_URL");

  if (!country || !locality || !locale || !marketingUrl) {
    return null;
  }

  return Object(preact_min["h"])(
    "div",
    { style: { borderBottom: "1px solid white" } },
    Object(preact_min["h"])(
      "ol",
      {
        className: overBar,
        itemscope: true,
        itemtype: "https://schema.org/BreadcrumbList"
      },
      Object(preact_min["h"])(
        "li",
        {
          itemprop: "itemListElement",
          itemscope: true,
          itemtype: "https://schema.org/ListItem"
        },
        Object(preact_min["h"])(
          "a",
          {
            itemprop: "item",
            href: marketingUrl + "/" + locale + "/search",
            "aria-label": "All Events"
          },
          Breadcrumbs__ref2
        ),
        Breadcrumbs__ref3,
        Breadcrumbs__ref4
      ),
      Object(preact_min["h"])(
        "li",
        {
          itemprop: "itemListElement",
          itemscope: true,
          itemtype: "https://schema.org/ListItem"
        },
        Object(preact_min["h"])(
          "a",
          {
            itemprop: "item",
            href: marketingUrl + "/" + locale + "/events/" + country + "/" + locality.split(" ").join("-"),
            "aria-label": locality.charAt(0).toUpperCase() + locality.slice(1) + " Events"
          },
          Object(preact_min["h"])(
            "span",
            { itemprop: "name" },
            locality.charAt(0).toUpperCase() + locality.slice(1),
            " Events"
          )
        ),
        Breadcrumbs__ref5,
        Breadcrumbs__ref6
      ),
      Object(preact_min["h"])(
        "li",
        {
          itemprop: "itemListElement",
          itemscope: true,
          itemtype: "https://schema.org/ListItem"
        },
        Object(preact_min["h"])(
          "a",
          {
            itemprop: "item",
            href: event.data.slug,
            "aria-label": event.data.name
          },
          Object(preact_min["h"])(
            "span",
            { itemprop: "name" },
            event.data.name
          )
        ),
        Breadcrumbs__ref7
      )
    )
  );
};

/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs_Breadcrumbs);
// CONCATENATED MODULE: ./components/Footer.js
var Footer__css;












var squareLogo = __webpack_require__("yfZu");

var headings = {
  fontSize: 14,
  fontWeight: 600,
  marginBottom: 14,
  textTransform: "uppercase"
};

var widthWrapper = Object(index_esm["css"])({
  margin: "0 auto",
  maxWidth: "1200px",
  position: "relative",
  minHeight: 250,
  padding: 12,
  paddingLeft: 60,
  paddingTop: 45,
  "@media(max-width: 500px)": {
    padding: 14
  }
});

var underBar = Object(index_esm["css"])({
  margin: "0 auto",
  maxWidth: "1200px",
  padding: "12px 60px",
  textAlign: "center",
  "@media(max-width: 500px)": {
    padding: "8px 14px"
  }
});

var desktop = Object(index_esm["css"])((Footer__css = {}, Footer__css[Object(CssUtils["c" /* max */])(768)] = {
  display: "none"
}, Footer__css));

var Footer__ref2 = Object(preact_min["h"])(
  "li",
  null,
  Object(preact_min["h"])(
    "h3",
    { style: headings },
    "Get In Touch"
  )
);

var Footer__ref3 = Object(preact_min["h"])(
  "li",
  null,
  Object(preact_min["h"])(
    "h3",
    { style: headings },
    "Create Your Events"
  )
);

var Footer__ref4 = Object(preact_min["h"])(
  "li",
  null,
  Object(preact_min["h"])(
    "h3",
    { style: headings },
    "Get Help"
  )
);

var Footer__ref5 = Object(preact_min["h"])("img", { src: squareLogo });

var Footer_Footer = function Footer(_ref) {
  var _divA, _css2;

  var event = _ref.event,
      _ref$tours$tour = _ref.tours.tour,
      tour = _ref$tours$tour === undefined ? {} : _ref$tours$tour;

  var theme = event && event.data && event.data.theme ? event.data.theme : {};

  if (typeof window !== "undefined" && window.location) {
    var pathName = window.location.pathname;
    if (pathName.search("tours/") > 0 && tour) {
      theme = tour.theme;
    }
  }

  var color = theme && theme.footerTextColor ? "" + theme.footerTextColor : "#fff";
  var background = theme && theme.footerTextColor ? theme.footerColor : "#4e4757";
  var FooterStyles = {
    width: "100%",
    color: color,
    position: "relative",
    background: background
  };

  var footerLogoColor = theme && theme.footerLogoColor ? theme.footerLogoColor : "twoTone";

  var columnStyle = Object(index_esm["css"])({
    display: "inline-block",
    marginRight: 85,
    verticalAlign: "top",
    a: {
      color: color
    },
    ul: {
      verticalAlign: "top",
      listStyleType: "none",
      margin: 0,
      fontSize: 14
    },
    li: {
      margin: 0,
      marginBottom: 14
    }
  });

  var logoStyles = Object(index_esm["css"])({
    width: "135px",
    height: "32px",
    display: "inline-block",
    marginRight: 85,
    "@media(max-width: 500px)": {
      display: "block",
      margin: "14px auto"
    }
  });

  var registeredCharity = Object(index_esm["css"])({
    background: "url(" + registered_charity_logo_default.a + ")",
    width: "80px",
    height: "80px",
    display: "block",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    textIndent: "-9999px",
    position: "absolute",
    right: 60,
    bottom: 65,
    fontSize: 12,
    "@media(max-width: 500px)": {
      position: "static",
      margin: "0 auto",
      display: "block",
      textAlign: "center"
    }
  });

  var mobile = Object(index_esm["css"])((_css2 = {
    display: "none",
    padding: 16
  }, _css2[Object(CssUtils["c" /* max */])(768)] = {
    display: "block",
    backgroundColor: "#fff",
    color: "#323232",
    textAlign: "center",
    paddingBottom: 100,
    div: {
      marginBottom: 12
    },
    "div>a": (_divA = {
      color: "#323232",
      fontSize: 14,
      padding: "0px 12px"
    }, _divA[Object(CssUtils["a" /* firstOfType */])()] = {
      borderRight: "1px solid #323232"
    }, _divA),
    img: {
      width: 40,
      height: 40
    }
  }, _css2));

  return Object(preact_min["h"])(
    "footer",
    { style: FooterStyles },
    Object(preact_min["h"])(
      "div",
      { className: desktop },
      Object(preact_min["h"])(components_Breadcrumbs, { event: event, color: color }),
      Object(preact_min["h"])(
        "div",
        { className: widthWrapper },
        Object(preact_min["h"])(
          "div",
          { className: logoStyles },
          Object(preact_min["h"])(logos_Logo, { footerLogoColor: footerLogoColor, width: 135, height: 32 })
        ),
        Object(preact_min["h"])(
          "div",
          { className: columnStyle },
          Object(preact_min["h"])(
            "ul",
            null,
            Footer__ref2,
            Object(preact_min["h"])(
              "li",
              null,
              Object(preact_min["h"])(
                "a",
                { href: Object(config["a" /* default */])("WEBSITE_URL") + "/contact-us/buyer-support" },
                "Contact Us"
              )
            )
          )
        ),
        Object(preact_min["h"])(
          "div",
          { className: columnStyle },
          Object(preact_min["h"])(
            "ul",
            null,
            Footer__ref3,
            Object(preact_min["h"])(
              "li",
              null,
              Object(preact_min["h"])(
                "a",
                { href: Object(config["a" /* default */])("WEBSITE_URL") + "/host-events" },
                "Host Events"
              )
            ),
            Object(preact_min["h"])(
              "li",
              null,
              Object(preact_min["h"])(
                "a",
                { href: "" + Object(config["a" /* default */])("CONSOLE_URL") },
                "Create an Event"
              )
            ),
            Object(preact_min["h"])(
              "li",
              null,
              Object(preact_min["h"])(
                "a",
                { href: Object(config["a" /* default */])("WEBSITE_URL") + "/pricing" },
                "Pricing"
              )
            )
          )
        ),
        Object(preact_min["h"])(
          "div",
          { className: columnStyle },
          Object(preact_min["h"])(
            "ul",
            null,
            Footer__ref4,
            Object(preact_min["h"])(
              "li",
              null,
              Object(preact_min["h"])(
                "a",
                { href: Object(config["a" /* default */])("WEBSITE_URL") + "/contact-us/buyer-support" },
                "Support"
              )
            ),
            Object(preact_min["h"])(
              "li",
              null,
              Object(preact_min["h"])(
                "a",
                {
                  href: Object(config["a" /* default */])("CONSOLE_URL") + "/public/pdfs/humanitix_promoter_agreement.pdf"
                },
                "Terms of use"
              )
            ),
            Object(preact_min["h"])(
              "li",
              null,
              Object(preact_min["h"])(
                "a",
                {
                  href: Object(config["a" /* default */])("CONSOLE_URL") + "/public/pdfs/humanitix_privacy_policy.pdf"
                },
                "Privacy policy"
              )
            ),
            Object(preact_min["h"])(
              "li",
              null,
              Object(preact_min["h"])(
                "a",
                {
                  href: "https://humanitix.helpdocs.io/category/6tj7pgphsh-event-attendees"
                },
                "Help"
              )
            ),
            Object(preact_min["h"])(
              "li",
              null,
              Object(preact_min["h"])(
                "a",
                { href: Object(config["a" /* default */])("WEBSITE_URL") + "/contact-us/buyer-support" },
                "Contact"
              )
            )
          )
        ),
        Object(preact_min["h"])("span", { className: registeredCharity })
      ),
      Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "div",
          { className: underBar },
          "\xA9",
          " ",
          Object(config["a" /* default */])("CURRENCY") === "AUD" ? "Humanitix Limited" : "Humanitix New Zealand Charitable Trust",
          " ",
          new Date().getFullYear()
        )
      )
    ),
    Object(preact_min["h"])(
      "div",
      { className: mobile },
      Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "a",
          {
            href: "https://humanitix.helpdocs.io/category/6tj7pgphsh-event-attendees"
          },
          "Help"
        ),
        Object(preact_min["h"])(
          "a",
          { href: Object(config["a" /* default */])("WEBSITE_URL") + "/contact-us/buyer-support" },
          "Contact"
        )
      ),
      Object(preact_min["h"])(
        "a",
        { href: Object(config["a" /* default */])("WEBSITE_URL") },
        Footer__ref5
      )
    )
  );
};

/* harmony default export */ var components_Footer = (Object(es["b" /* connect */])(function (state) {
  return { event: state.event, tours: state.tours };
}, {})(Footer_Footer));
// EXTERNAL MODULE: ./components/Page.js + 2 modules
var Page = __webpack_require__("QYBl");

// EXTERNAL MODULE: ./components/Content.js
var Content = __webpack_require__("FcPK");

// EXTERNAL MODULE: ./utils/PolyFill.js
var PolyFill = __webpack_require__("BPe0");
var PolyFill_default = /*#__PURE__*/__webpack_require__.n(PolyFill);

// EXTERNAL MODULE: ../node_modules/redux/es/index.js + 6 modules
var redux_es = __webpack_require__("fpuT");

// EXTERNAL MODULE: ../node_modules/redux-thunk/lib/index.js
var lib = __webpack_require__("i/8a");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./state/actions/contactActions.js + 1 modules
var contactActions = __webpack_require__("50FS");

// CONCATENATED MODULE: ./state/reducers/contactReducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  loading: false,
  error: false,
  sent: false
};

var contactReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case contactActions["c" /* CONTACT_RESET */]:
      return initialState;
    case contactActions["b" /* CONTACT_REQUEST */]:
      return _extends({}, state, {
        loading: true,
        error: false
      });
    case contactActions["d" /* CONTACT_SUCCESS */]:
      return _extends({}, state, {
        loading: false,
        sent: true,
        error: false
      });
    case contactActions["a" /* CONTACT_ERROR */]:
      return _extends({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state;
  }
};
/* harmony default export */ var contactReducer = ({ initialState: initialState, reducer: contactReducer_reducer });
// EXTERNAL MODULE: ./state/actions/eventActions.js
var eventActions = __webpack_require__("Hstv");

// EXTERNAL MODULE: ./state/actions/orderActions.js
var orderActions = __webpack_require__("J21P");

// CONCATENATED MODULE: ./utils/css-vars-ponyfill/dist/css-vars-ponyfill.esm.js
/*!
 * css-vars-ponyfill
 * v1.8.0
 * https://github.com/jhildenbiddle/css-vars-ponyfill
 * (c) 2018 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
/*!
 * get-css-data
 * v1.3.2
 * https://github.com/jhildenbiddle/get-css-data
 * (c) 2018 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
function getUrls(urls) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var settings = {
        mimeType: options.mimeType || null,
        onBeforeSend: options.onBeforeSend || Function.prototype,
        onSuccess: options.onSuccess || Function.prototype,
        onError: options.onError || Function.prototype,
        onComplete: options.onComplete || Function.prototype
    };
    var urlArray = Array.isArray(urls) ? urls : [urls];
    var urlQueue = Array.apply(null, Array(urlArray.length)).map(function (x) {
        return null;
    });
    function onError(xhr, urlIndex) {
        settings.onError(xhr, urlArray[urlIndex], urlIndex);
    }
    function onSuccess(responseText, urlIndex) {
        var returnVal = settings.onSuccess(responseText, urlArray[urlIndex], urlIndex);
        responseText = returnVal === false ? "" : returnVal || responseText;
        urlQueue[urlIndex] = responseText;
        if (urlQueue.indexOf(null) === -1) {
            settings.onComplete(urlQueue);
        }
    }
    urlArray.forEach(function (url, i) {
        var parser = document.createElement("a");
        parser.setAttribute("href", url);
        parser.href = parser.href;
        var isCrossDomain = parser.host !== location.host;
        var isSameProtocol = parser.protocol === location.protocol;
        if (isCrossDomain && typeof XDomainRequest !== "undefined") {
            if (isSameProtocol) {
                var xdr = new XDomainRequest();
                xdr.open("GET", url);
                xdr.timeout = 0;
                xdr.onprogress = Function.prototype;
                xdr.ontimeout = Function.prototype;
                xdr.onload = function () {
                    onSuccess(xdr.responseText, i);
                };
                xdr.onerror = function (err) {
                    onError(xdr, i);
                };
                setTimeout(function () {
                    xdr.send();
                }, 0);
            } else {
                console.log("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol");
                onError(null, i);
            }
        } else {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url);
            if (settings.mimeType && xhr.overrideMimeType) {
                xhr.overrideMimeType(settings.mimeType);
            }
            settings.onBeforeSend(xhr, url, i);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        onSuccess(xhr.responseText, i);
                    } else {
                        onError(xhr, i);
                    }
                }
            };
            xhr.send();
        }
    });
}

/**
 * Gets CSS data from <style> and <link> nodes (including @imports), then
 * returns data in order processed by DOM. Allows specifying nodes to
 * include/exclude and filtering CSS data using RegEx.
 *
 * @preserve
 * @param {object}   [options] The options object
 * @param {string}   [options.include] CSS selector matching <link> and <style>
 *                   nodes to include
 * @param {string}   [options.exclude] CSS selector matching <link> and <style>
 *                   nodes to exclude
 * @param {object}   [options.filter] Regular expression used to filter node CSS
 *                   data. Each block of CSS data is tested against the filter,
 *                   and only matching data is included.
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments.
 * @param {function} [options.onSuccess] Callback on each CSS node read. Passes
 *                   1) CSS text, 2) source node reference, and 3) the source
 *                   URL as arguments.
 * @param {function} [options.onError] Callback on each error. Passes 1) the XHR
 *                   object for inspection, 2) soure node reference, and 3) the
 *                   source URL that failed (either a <link> href or an @import)
 *                   as arguments
 * @param {function} [options.onComplete] Callback after all nodes have been
 *                   processed. Passes 1) concatenated CSS text, 2) an array of
 *                   CSS text in DOM order, and 3) an array of nodes in DOM
 *                   order as arguments.
 *
 * @example
 *
 *   getCssData({
 *     include: 'style,link[rel="stylesheet"]', // default
 *     exclude: '[href="skip.css"]',
 *     filter : /red/,
 *     onBeforeSend(xhr, node, url) {
 *       // ...
 *     }
 *     onSuccess(cssText, node, url) {
 *       // ...
 *     }
 *     onError(xhr, node, url) {
 *       // ...
 *     },
 *     onComplete(cssText, cssArray) {
 *       // ...
 *     },
 *   });
 */function getCssData(options) {
    var regex = {
        cssComments: /\/\*[\s\S]+?\*\//g,
        cssImports: /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g
    };
    var settings = {
        include: options.include || 'style,link[rel="stylesheet"]',
        exclude: options.exclude || null,
        filter: options.filter || null,
        onBeforeSend: options.onBeforeSend || Function.prototype,
        onSuccess: options.onSuccess || Function.prototype,
        onError: options.onError || Function.prototype,
        onComplete: options.onComplete || Function.prototype
    };
    var sourceNodes = Array.apply(null, document.querySelectorAll(settings.include)).filter(function (node) {
        return !matchesSelector(node, settings.exclude);
    });
    var cssArray = Array.apply(null, Array(sourceNodes.length)).map(function (x) {
        return null;
    });
    function handleComplete() {
        var isComplete = cssArray.indexOf(null) === -1;
        if (isComplete) {
            var cssText = cssArray.join("");
            settings.onComplete(cssText, cssArray, sourceNodes);
        }
    }
    function handleSuccess(cssText, cssIndex, node, sourceUrl) {
        var returnVal = settings.onSuccess(cssText, node, sourceUrl);
        cssText = returnVal === false ? "" : returnVal || cssText;
        resolveImports(cssText, node, sourceUrl, function (resolvedCssText, errorData) {
            if (cssArray[cssIndex] === null) {
                errorData.forEach(function (data) {
                    return settings.onError(data.xhr, node, data.url);
                });
                if (!settings.filter || settings.filter.test(resolvedCssText)) {
                    cssArray[cssIndex] = resolvedCssText;
                } else {
                    cssArray[cssIndex] = "";
                }
                handleComplete();
            }
        });
    }
    function parseImportData(cssText, baseUrl) {
        var ignoreRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var importData = {};
        importData.rules = (cssText.replace(regex.cssComments, "").match(regex.cssImports) || []).filter(function (rule) {
            return ignoreRules.indexOf(rule) === -1;
        });
        importData.urls = importData.rules.map(function (rule) {
            return rule.replace(regex.cssImports, "$1");
        });
        importData.absoluteUrls = importData.urls.map(function (url) {
            return getFullUrl(url, baseUrl);
        });
        importData.absoluteRules = importData.rules.map(function (rule, i) {
            var oldUrl = importData.urls[i];
            var newUrl = getFullUrl(importData.absoluteUrls[i], baseUrl);
            return rule.replace(oldUrl, newUrl);
        });
        return importData;
    }
    function resolveImports(cssText, node, baseUrl, callbackFn) {
        var __errorData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var __errorRules = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var importData = parseImportData(cssText, baseUrl, __errorRules);
        if (importData.rules.length) {
            getUrls(importData.absoluteUrls, {
                onBeforeSend: function onBeforeSend(xhr, url, urlIndex) {
                    settings.onBeforeSend(xhr, node, url);
                },
                onSuccess: function onSuccess(cssText, url, urlIndex) {
                    var returnVal = settings.onSuccess(cssText, node, url);
                    cssText = returnVal === false ? "" : returnVal || cssText;
                    var responseImportData = parseImportData(cssText, url, __errorRules);
                    responseImportData.rules.forEach(function (rule, i) {
                        cssText = cssText.replace(rule, responseImportData.absoluteRules[i]);
                    });
                    return cssText;
                },
                onError: function onError(xhr, url, urlIndex) {
                    __errorData.push({
                        xhr: xhr,
                        url: url
                    });
                    __errorRules.push(importData.rules[urlIndex]);
                    resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
                },
                onComplete: function onComplete(responseArray) {
                    responseArray.forEach(function (importText, i) {
                        cssText = cssText.replace(importData.rules[i], importText);
                    });
                    resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
                }
            });
        } else {
            callbackFn(cssText, __errorData);
        }
    }
    if (sourceNodes.length) {
        sourceNodes.forEach(function (node, i) {
            var linkHref = node.getAttribute("href");
            var linkRel = node.getAttribute("rel");
            var isLink = node.nodeName === "LINK" && linkHref && linkRel && linkRel.toLowerCase() === "stylesheet";
            var isStyle = node.nodeName === "STYLE";
            if (isLink) {
                getUrls(linkHref, {
                    mimeType: "text/css",
                    onBeforeSend: function onBeforeSend(xhr, url, urlIndex) {
                        settings.onBeforeSend(xhr, node, url);
                    },
                    onSuccess: function onSuccess(cssText, url, urlIndex) {
                        var sourceUrl = getFullUrl(linkHref, location.href);
                        handleSuccess(cssText, i, node, sourceUrl);
                    },
                    onError: function onError(xhr, url, urlIndex) {
                        cssArray[i] = "";
                        settings.onError(xhr, node, url);
                        handleComplete();
                    }
                });
            } else if (isStyle) {
                handleSuccess(node.textContent, i, node, location.href);
            } else {
                cssArray[i] = "";
                handleComplete();
            }
        });
    } else {
        settings.onComplete("", []);
    }
}

function getFullUrl(url) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
    var d = document.implementation.createHTMLDocument("");
    var b = d.createElement("base");
    var a = d.createElement("a");
    d.head.appendChild(b);
    d.body.appendChild(a);
    b.href = base;
    a.href = url;
    return a.href;
}

function matchesSelector(elm, selector) {
    var matches = elm.matches || elm.matchesSelector || elm.webkitMatchesSelector || elm.mozMatchesSelector || elm.msMatchesSelector || elm.oMatchesSelector;
    return matches.call(elm, selector);
}

function mergeDeep() {
    var isObject = function isObject(obj) {
        return obj instanceof Object && obj.constructor === Object;
    };
    for (var _len = arguments.length, objects = Array(_len), _key = 0; _key < _len; _key++) {
        objects[_key] = arguments[_key];
    }
    return objects.reduce(function (prev, obj) {
        Object.keys(obj).forEach(function (key) {
            var pVal = prev[key];
            var oVal = obj[key];
            if (isObject(pVal) && isObject(oVal)) {
                prev[key] = mergeDeep(pVal, oVal);
            } else {
                prev[key] = oVal;
            }
        });
        return prev;
    }, {});
}

var balancedMatch = balanced;

function balanced(a, b, str) {
    if (a instanceof RegExp) a = maybeMatch(a, str);
    if (b instanceof RegExp) b = maybeMatch(b, str);
    var r = range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}

function maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}

balanced.range = range;

function range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        begs = [];
        left = str.length;
        while (i >= 0 && !result) {
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) {
                result = [begs.pop(), bi];
            } else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) {
            result = [left, right];
        }
    }
    return result;
}

function cssParse(css) {
    var errors = [];
    function error(msg) {
        throw new Error("CSS parse error: " + msg);
    }
    function match(re) {
        var m = re.exec(css);
        if (m) {
            css = css.slice(m[0].length);
            return m;
        }
    }
    function whitespace() {
        match(/^\s*/);
    }
    function open() {
        return match(/^{\s*/);
    }
    function close() {
        return match(/^}/);
    }
    function comment() {
        whitespace();
        if (css[0] !== "/" || css[1] !== "*") {
            return;
        }
        var i = 2;
        while (css[i] && (css[i] !== "*" || css[i + 1] !== "/")) {
            i++;
        }
        if (!css[i]) {
            return error("end of comment is missing");
        }
        var str = css.slice(2, i);
        css = css.slice(i + 2);
        return {
            type: "comment",
            comment: str
        };
    }
    function comments() {
        var cmnts = [];
        var c = void 0;
        while (c = comment()) {
            cmnts.push(c);
        }
        return cmnts;
    }
    function selector() {
        whitespace();
        while (css[0] === "}") {
            error("extra closing bracket");
        }
        var m = match(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
        if (m) {
            return m[0].trim().replace(/\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*\/+/g, "").replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function (m) {
                return m.replace(/,/g, "‌");
            }).split(/\s*(?![^(]*\)),\s*/).map(function (s) {
                return s.replace(/\u200C/g, ",");
            });
        }
    }
    function declaration() {
        match(/^([;\s]*)+/);
        var comment_regexp = /\/\*[^*]*\*+([^\/*][^*]*\*+)*\//g;
        var prop = match(/^(\*?[-#\/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
        if (!prop) {
            return;
        }
        prop = prop[0].trim();
        if (!match(/^:\s*/)) {
            return error("property missing ':'");
        }
        var val = match(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/);
        var ret = {
            type: "declaration",
            property: prop.replace(comment_regexp, ""),
            value: val ? val[0].replace(comment_regexp, "").trim() : ""
        };
        match(/^[;\s]*/);
        return ret;
    }
    function declarations() {
        if (!open()) {
            return error("missing '{'");
        }
        var d = void 0,
            decls = comments();
        while (d = declaration()) {
            decls.push(d);
            decls = decls.concat(comments());
        }
        if (!close()) {
            return error("missing '}'");
        }
        return decls;
    }
    function keyframe() {
        whitespace();
        var vals = [];
        var m = void 0;
        while (m = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)) {
            vals.push(m[1]);
            match(/^,\s*/);
        }
        if (vals.length) {
            return {
                type: "keyframe",
                values: vals,
                declarations: declarations()
            };
        }
    }
    function at_keyframes() {
        var m = match(/^@([-\w]+)?keyframes\s*/);
        if (!m) {
            return;
        }
        var vendor = m[1];
        m = match(/^([-\w]+)\s*/);
        if (!m) {
            return error("@keyframes missing name");
        }
        var name = m[1];
        if (!open()) {
            return error("@keyframes missing '{'");
        }
        var frame = void 0,
            frames = comments();
        while (frame = keyframe()) {
            frames.push(frame);
            frames = frames.concat(comments());
        }
        if (!close()) {
            return error("@keyframes missing '}'");
        }
        return {
            type: "keyframes",
            name: name,
            vendor: vendor,
            keyframes: frames
        };
    }
    function at_page() {
        var m = match(/^@page */);
        if (m) {
            var sel = selector() || [];
            return {
                type: "page",
                selectors: sel,
                declarations: declarations()
            };
        }
    }
    function at_fontface() {
        var m = match(/^@font-face\s*/);
        if (m) {
            return {
                type: "font-face",
                declarations: declarations()
            };
        }
    }
    function at_supports() {
        var m = match(/^@supports *([^{]+)/);
        if (m) {
            return {
                type: "supports",
                supports: m[1].trim(),
                rules: rules()
            };
        }
    }
    function at_host() {
        var m = match(/^@host\s*/);
        if (m) {
            return {
                type: "host",
                rules: rules()
            };
        }
    }
    function at_media() {
        var m = match(/^@media *([^{]+)/);
        if (m) {
            return {
                type: "media",
                media: m[1].trim(),
                rules: rules()
            };
        }
    }
    function at_custom_m() {
        var m = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
        if (m) {
            return {
                type: "custom-media",
                name: m[1].trim(),
                media: m[2].trim()
            };
        }
    }
    function at_document() {
        var m = match(/^@([-\w]+)?document *([^{]+)/);
        if (m) {
            return {
                type: "document",
                document: m[2].trim(),
                vendor: m[1] ? m[1].trim() : null,
                rules: rules()
            };
        }
    }
    function at_x() {
        var m = match(/^@(import|charset|namespace)\s*([^;]+);/);
        if (m) {
            return {
                type: m[1],
                name: m[2].trim()
            };
        }
    }
    function at_rule() {
        whitespace();
        if (css[0] === "@") {
            return at_keyframes() || at_supports() || at_host() || at_media() || at_custom_m() || at_page() || at_document() || at_fontface() || at_x();
        }
    }
    function rule() {
        var sel = selector() || [];
        if (!sel.length) {
            error("selector missing");
        }
        var decls = declarations();
        return {
            type: "rule",
            selectors: sel,
            declarations: decls
        };
    }
    function rules(core) {
        if (!core && !open()) {
            return error("missing '{'");
        }
        var node = void 0,
            rules = comments();
        while (css.length && (core || css[0] !== "}") && (node = at_rule() || rule())) {
            rules.push(node);
            rules = rules.concat(comments());
        }
        if (!core && !close()) {
            return error("missing '}'");
        }
        return rules;
    }
    return {
        type: "stylesheet",
        stylesheet: {
            rules: rules(true),
            errors: errors
        }
    };
}

function stringifyCss(tree) {
    var delim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var cb = arguments[2];
    var renderMethods = {
        charset: function charset(node) {
            return "@charset " + node.name + ";";
        },
        comment: function comment(node) {
            return node.comment.indexOf("__CSSVARSPONYFILL") === 0 ? "/*" + node.comment + "*/" : "";
        },
        "custom-media": function customMedia(node) {
            return "@custom-media " + node.name + " " + node.media + ";";
        },
        declaration: function declaration(node) {
            return node.property + ":" + node.value + ";";
        },
        document: function document(node) {
            return "@" + (node.vendor || "") + "document " + node.document + "{" + visit(node.rules) + "}";
        },
        "font-face": function fontFace(node) {
            return "@font-face" + "{" + visit(node.declarations) + "}";
        },
        host: function host(node) {
            return "@host" + "{" + visit(node.rules) + "}";
        },
        import: function _import(node) {
            return "@import " + node.name + ";";
        },
        keyframe: function keyframe(node) {
            return node.values.join(",") + "{" + visit(node.declarations) + "}";
        },
        keyframes: function keyframes(node) {
            return "@" + (node.vendor || "") + "keyframes " + node.name + "{" + visit(node.keyframes) + "}";
        },
        media: function media(node) {
            return "@media " + node.media + "{" + visit(node.rules) + "}";
        },
        namespace: function namespace(node) {
            return "@namespace " + node.name + ";";
        },
        page: function page(node) {
            return "@page " + (node.selectors.length ? node.selectors.join(", ") : "") + "{" + visit(node.declarations) + "}";
        },
        rule: function rule(node) {
            var decls = node.declarations;
            if (decls.length) {
                return node.selectors.join(",") + "{" + visit(decls) + "}";
            }
        },
        supports: function supports(node) {
            return "@supports " + node.supports + "{" + visit(node.rules) + "}";
        }
    };
    function visit(nodes) {
        var buf = "";
        for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            if (cb) {
                cb(n);
            }
            var txt = renderMethods[n.type](n);
            if (txt) {
                buf += txt;
                if (txt.length && n.selectors) {
                    buf += delim;
                }
            }
        }
        return buf;
    }
    return visit(tree.stylesheet.rules);
}

function walkCss(node, fn) {
    node.rules.forEach(function (rule) {
        if (rule.rules) {
            walkCss(rule, fn);
            return;
        }
        if (rule.keyframes) {
            rule.keyframes.forEach(function (keyframe) {
                if (keyframe.type === "keyframe") {
                    fn(keyframe.declarations, rule);
                }
            });
            return;
        }
        if (!rule.declarations) {
            return;
        }
        fn(rule.declarations, node);
    });
}

var persistStore = {};

var VAR_PROP_IDENTIFIER = "--";

var VAR_FUNC_IDENTIFIER = "var";

function transformVars(cssText) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        fixNestedCalc: true,
        onlyVars: true,
        persist: false,
        preserve: false,
        variables: {},
        onWarning: function onWarning() {}
    };
    var map = {};
    var settings = mergeDeep(defaults, options);
    var varSource = settings.persist ? persistStore : settings.variables;
    var cssTree = cssParse(cssText);
    if (settings.onlyVars) {
        cssTree.stylesheet.rules = filterVars(cssTree.stylesheet.rules);
    }
    cssTree.stylesheet.rules.forEach(function (rule) {
        var varNameIndices = [];
        if (rule.type !== "rule") {
            return;
        }
        if (rule.selectors.length !== 1 || rule.selectors[0] !== ":root") {
            return;
        }
        rule.declarations.forEach(function (decl, i) {
            var prop = decl.property;
            var value = decl.value;
            if (prop && prop.indexOf(VAR_PROP_IDENTIFIER) === 0) {
                map[prop] = value;
                varNameIndices.push(i);
            }
        });
        if (!settings.preserve) {
            for (var i = varNameIndices.length - 1; i >= 0; i--) {
                rule.declarations.splice(varNameIndices[i], 1);
            }
        }
    });
    Object.keys(settings.variables).forEach(function (key) {
        var prop = "--" + key.replace(/^-+/, "");
        var value = settings.variables[key];
        if (key !== prop) {
            settings.variables[prop] = value;
            delete settings.variables[key];
        }
        if (settings.persist) {
            persistStore[prop] = value;
        }
    });
    if (Object.keys(varSource).length) {
        var newRule = {
            declarations: [],
            selectors: [":root"],
            type: "rule"
        };
        Object.keys(varSource).forEach(function (key) {
            map[key] = varSource[key];
            newRule.declarations.push({
                type: "declaration",
                property: key,
                value: varSource[key]
            });
            if (settings.persist) {
                persistStore[key] = varSource[key];
            }
        });
        if (settings.preserve) {
            cssTree.stylesheet.rules.push(newRule);
        }
    }
    walkCss(cssTree.stylesheet, function (declarations, node) {
        var decl = void 0;
        var resolvedValue = void 0;
        var value = void 0;
        for (var i = 0; i < declarations.length; i++) {
            decl = declarations[i];
            value = decl.value;
            if (decl.type !== "declaration") {
                continue;
            }
            if (!value || value.indexOf(VAR_FUNC_IDENTIFIER + "(") === -1) {
                continue;
            }
            resolvedValue = resolveValue(value, map, settings);
            if (resolvedValue !== "undefined") {
                if (!settings.preserve) {
                    decl.value = resolvedValue;
                } else {
                    declarations.splice(i, 0, {
                        type: decl.type,
                        property: decl.property,
                        value: resolvedValue
                    });
                    i++;
                }
            }
        }
    });
    if (settings.fixNestedCalc) {
        fixNestedCalc(cssTree.stylesheet.rules);
    }
    return stringifyCss(cssTree);
}

function filterVars(rules) {
    return rules.filter(function (rule) {
        if (rule.declarations) {
            var declArray = rule.declarations.filter(function (d) {
                var hasVarProp = d.property && d.property.indexOf(VAR_PROP_IDENTIFIER) === 0;
                var hasVarVal = d.value && d.value.indexOf(VAR_FUNC_IDENTIFIER + "(") > -1;
                return hasVarProp || hasVarVal;
            });
            if (rule.type !== "font-face") {
                rule.declarations = declArray;
            }
            return Boolean(declArray.length);
        } else if (rule.keyframes) {
            return Boolean(rule.keyframes.filter(function (k) {
                return Boolean(k.declarations.filter(function (d) {
                    var hasVarProp = d.property && d.property.indexOf(VAR_PROP_IDENTIFIER) === 0;
                    var hasVarVal = d.value && d.value.indexOf(VAR_FUNC_IDENTIFIER + "(") > -1;
                    return hasVarProp || hasVarVal;
                }).length);
            }).length);
        } else if (rule.rules) {
            rule.rules = filterVars(rule.rules).filter(function (r) {
                return r.declarations && r.declarations.length;
            });
            return Boolean(rule.rules.length);
        }
        return true;
    });
}

function fixNestedCalc(rules) {
    var reCalcExp = /(-[a-z]+-)?calc\(/;
    rules.forEach(function (rule) {
        if (rule.declarations) {
            rule.declarations.forEach(function (decl) {
                var oldValue = decl.value;
                var newValue = "";
                while (reCalcExp.test(oldValue)) {
                    var rootCalc = balancedMatch("calc(", ")", oldValue || "");
                    oldValue = oldValue.slice(rootCalc.end);
                    while (reCalcExp.test(rootCalc.body)) {
                        var nestedCalc = balancedMatch(reCalcExp, ")", rootCalc.body);
                        rootCalc.body = nestedCalc.pre + "(" + nestedCalc.body + ")" + nestedCalc.post;
                    }
                    newValue += rootCalc.pre + "calc(" + rootCalc.body;
                    newValue += !reCalcExp.test(oldValue) ? ")" + rootCalc.post : "";
                }
                decl.value = newValue || decl.value;
            });
        }
    });
}

function resolveValue(value, map, settings) {
    var RE_VAR = /([\w-]+)(?:\s*,\s*)?(.*)?/;
    var balancedParens = balancedMatch("(", ")", value);
    var varStartIndex = value.indexOf("var(");
    var varRef = balancedMatch("(", ")", value.substring(varStartIndex)).body;
    var warningIntro = "CSS transform warning:";
    if (!balancedParens) {
        settings.onWarning(warningIntro + ' missing closing ")" in the value "' + value + '"');
    }
    if (varRef === "") {
        settings.onWarning(warningIntro + " var() must contain a non-whitespace string");
    }
    var varFunc = VAR_FUNC_IDENTIFIER + "(" + varRef + ")";
    var varResult = varRef.replace(RE_VAR, function (_, name, fallback) {
        var replacement = map[name];
        var hasReplacement = replacement !== undefined && replacement !== "";
        var hasFallback = fallback !== undefined && fallback !== "";
        if (!hasReplacement && !hasFallback) {
            settings.onWarning(warningIntro + ' variable "' + name + '" is undefined');
        }
        if (!hasReplacement && hasFallback) {
            return fallback;
        }
        return replacement;
    });
    value = value.split(varFunc).join(varResult);
    if (value.indexOf(VAR_FUNC_IDENTIFIER + "(") !== -1) {
        value = resolveValue(value, map, settings);
    }
    return value;
}

var css_vars_ponyfill_esm_name = "css-vars-ponyfill";

var defaults = {
    include: "style,link[rel=stylesheet]",
    exclude: "",
    fixNestedCalc: true,
    onlyLegacy: true,
    onlyVars: false,
    preserve: false,
    silent: false,
    updateDOM: true,
    updateURLs: true,
    variables: {},
    watch: false,
    onBeforeSend: function onBeforeSend() {},
    onSuccess: function onSuccess() {},
    onWarning: function onWarning() {},
    onError: function onError() {},
    onComplete: function onComplete() {}
};

var css_vars_ponyfill_esm_isBrowser = typeof window !== 'undefined';
var hasNativeSupport = css_vars_ponyfill_esm_isBrowser && window && window.CSS && window.CSS.supports && window.CSS.supports("(--a: 0)");

var regex = {
    cssComments: /\/\*[\s\S]+?\*\//g,
    cssKeyframes: /@(?:-\w*-)?keyframes/,
    cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,
    cssVars: /(?:(?::root\s*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/
};

var cssVarsObserver = null;

/**
 * Fetches, parses, and transforms CSS custom properties from specified
 * <style> and <link> elements into static values, then appends a new <style>
 * element with static values to the DOM to provide CSS custom property
 * compatibility for legacy browsers. Also provides a single interface for
 * live updates of runtime values in both modern and legacy browsers.
 *
 * @preserve
 * @param {object}   [options] Options object
 * @param {string}   [options.include="style,link[rel=stylesheet]"] CSS selector
 *                   matching <link re="stylesheet"> and <style> nodes to
 *                   process
 * @param {string}   [options.exclude] CSS selector matching <link
 *                   rel="stylehseet"> and <style> nodes to exclude from those
 *                   matches by options.include
 * @param {boolean}  [options.fixNestedCalc=true] Removes nested 'calc' keywords
 *                   for legacy browser compatibility.
 * @param {boolean}  [options.onlyLegacy=true] Determines if the ponyfill will
 *                   only generate legacy-compatible CSS in browsers that lack
 *                   native support (i.e., legacy browsers)
 * @param {boolean}  [options.onlyVars=false] Determines if CSS rulesets and
 *                   declarations without a custom property value should be
 *                   removed from the ponyfill-generated CSS
 * @param {boolean}  [options.preserve=false] Determines if the original CSS
 *                   custom property declaration will be retained in the
 *                   ponyfill-generated CSS.
 * @param {boolean}  [options.silent=false] Determines if warning and error
 *                   messages will be displayed on the console
 * @param {boolean}  [options.updateDOM=true] Determines if the ponyfill will
 *                   update the DOM after processing CSS custom properties
 * @param {boolean}  [options.updateURLs=true] Determines if the ponyfill will
 *                   convert relative url() paths to absolute urls.
 * @param {object}   [options.variables] A map of custom property name/value
 *                   pairs. Property names can omit or include the leading
 *                   double-hyphen (—), and values specified will override
 *                   previous values.
 * @param {boolean}  [options.watch=false] Determines if a MutationObserver will
 *                   be created that will execute the ponyfill when a <link> or
 *                   <style> DOM mutation is observed.
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments.
 * @param {function} [options.onSuccess] Callback after CSS data has been
 *                   collected from each node and before CSS custom properties
 *                   have been transformed. Allows modifying the CSS data before
 *                   it is transformed by returning any string value (or false
 *                   to skip). Passes 1) CSS text, 2) source node reference, and
 *                   3) the source URL as arguments.
 * @param {function} [options.onWarning] Callback after each CSS parsing warning
 *                   has occurred. Passes 1) a warning message as an argument.
 * @param {function} [options.onError] Callback after a CSS parsing error has
 *                   occurred or an XHR request has failed. Passes 1) an error
 *                   message, and 2) source node reference, 3) xhr, and 4 url as
 *                   arguments.
 * @param {function} [options.onComplete] Callback after all CSS has been
 *                   processed, legacy-compatible CSS has been generated, and
 *                   (optionally) the DOM has been updated. Passes 1) a CSS
 *                   string with CSS variable values resolved, and 2) a
 *                   reference to the appended <style> node.
 *
 * @example
 *
 *   cssVars({
 *     include      : 'style,link[rel="stylesheet"]', // default
 *     exclude      : '',
 *     fixNestedCalc: true,  // default
 *     onlyLegacy   : true,  // default
 *     onlyVars     : false, // default
 *     preserve     : false, // default
 *     silent       : false, // default
 *     updateDOM    : true,  // default
 *     updateURLs   : true,  // default
 *     variables    : {
 *       // ...
 *     },
 *     onBeforeSend(xhr, node, url) {
 *       // ...
 *     }
 *     onSuccess(cssText, node, url) {
 *       // ...
 *     },
 *     onWarning(message) {
 *       // ...
 *     },
 *     onError(message, node) {
 *       // ...
 *     },
 *     onComplete(cssText, styleNode) {
 *       // ...
 *     }
 *   });
 */function cssVars() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var settings = mergeDeep(defaults, options);
    function handleError(message, sourceNode, xhr, url) {
        if (!settings.silent) {
            console.error(message + "\n", sourceNode);
        }
        settings.onError(message, sourceNode, xhr, url);
    }
    function handleWarning(message) {
        if (!settings.silent) {
            console.warn(message);
        }
        settings.onWarning(message);
    }
    var isBrowser = typeof window !== 'undefined';
    if (isBrowser && document.readyState !== "loading") {
        if (!hasNativeSupport || !settings.onlyLegacy) {
            var styleNodeId = css_vars_ponyfill_esm_name;
            if (settings.watch) {
                addMutationObserver(settings, styleNodeId);
            }
            getCssData({
                include: settings.include,
                exclude: "#" + styleNodeId + (settings.exclude ? "," + settings.exclude : ""),
                filter: settings.onlyVars ? regex.cssVars : null,
                onBeforeSend: settings.onBeforeSend,
                onSuccess: function onSuccess(cssText, node, url) {
                    var returnVal = settings.onSuccess(cssText, node, url);
                    cssText = returnVal === false ? "" : returnVal || cssText;
                    if (settings.updateURLs) {
                        var cssUrls = cssText.replace(regex.cssComments, "").match(regex.cssUrls) || [];
                        cssUrls.forEach(function (cssUrl) {
                            var oldUrl = cssUrl.replace(regex.cssUrls, "$1");
                            var newUrl = getFullUrl$1(oldUrl, url);
                            cssText = cssText.replace(cssUrl, cssUrl.replace(oldUrl, newUrl));
                        });
                    }
                    return cssText;
                },
                onError: function onError(xhr, node, url) {
                    var responseUrl = xhr.responseURL || getFullUrl$1(url, location.href);
                    var statusText = xhr.statusText ? "(" + xhr.statusText + ")" : "Unspecified Error" + (xhr.status === 0 ? " (possibly CORS related)" : "");
                    var errorMsg = "CSS XHR Error: " + responseUrl + " " + xhr.status + " " + statusText;
                    handleError(errorMsg, node, xhr, responseUrl);
                },
                onComplete: function onComplete(cssText, cssArray, nodeArray) {
                    var cssMarker = /\/\*__CSSVARSPONYFILL-(\d+)__\*\//g;
                    var styleNode = null;
                    cssText = cssArray.map(function (css, i) {
                        return regex.cssVars.test(css) ? css : "/*__CSSVARSPONYFILL-" + i + "__*/";
                    }).join("");
                    try {
                        cssText = transformVars(cssText, {
                            fixNestedCalc: settings.fixNestedCalc,
                            onlyVars: settings.onlyVars,
                            persist: settings.updateDOM,
                            preserve: settings.preserve,
                            variables: settings.variables,
                            onWarning: handleWarning
                        });
                        var hasKeyframes = regex.cssKeyframes.test(cssText);
                        var cssMarkerMatch = cssMarker.exec(cssText);
                        while (cssMarkerMatch !== null) {
                            var matchedText = cssMarkerMatch[0];
                            var cssArrayIndex = cssMarkerMatch[1];
                            cssText = cssText.replace(matchedText, cssArray[cssArrayIndex]);
                            cssMarkerMatch = cssMarker.exec(cssText);
                        }
                        if (settings.updateDOM && nodeArray && nodeArray.length) {
                            var lastNode = nodeArray[nodeArray.length - 1];
                            styleNode = document.querySelector("#" + styleNodeId) || document.createElement("style");
                            styleNode.setAttribute("id", styleNodeId);
                            if (styleNode.textContent !== cssText) {
                                styleNode.textContent = cssText;
                            }
                            if (lastNode.nextSibling !== styleNode) {
                                lastNode.parentNode.insertBefore(styleNode, lastNode.nextSibling);
                            }
                            if (hasKeyframes) {
                                fixKeyframes();
                            }
                        }
                    } catch (err) {
                        var errorThrown = false;
                        cssArray.forEach(function (cssText, i) {
                            try {
                                cssText = transformVars(cssText, settings);
                            } catch (err) {
                                var errorNode = nodeArray[i - 0];
                                errorThrown = true;
                                handleError(err.message, errorNode);
                            }
                        });
                        if (!errorThrown) {
                            handleError(err.message || err);
                        }
                    }
                    settings.onComplete(cssText, styleNode);
                }
            });
        } else if (hasNativeSupport && settings.updateDOM) {
            Object.keys(settings.variables).forEach(function (key) {
                var prop = "--" + key.replace(/^-+/, "");
                var value = settings.variables[key];
                document.documentElement.style.setProperty(prop, value);
            });
        }
    } else if (isBrowser) {
        document.addEventListener("DOMContentLoaded", function init(evt) {
            cssVars(options);
            document.removeEventListener("DOMContentLoaded", init);
        });
    }
}

function addMutationObserver(settings, ignoreId) {
    if (window.MutationObserver && !cssVarsObserver) {
        var isLink = function isLink(node) {
            return node.tagName === "LINK" && (node.getAttribute("rel") || "").indexOf("stylesheet") !== -1;
        };
        var isStyle = function isStyle(node) {
            return node.tagName === "STYLE" && (ignoreId ? node.id !== ignoreId : true);
        };
        var debounceTimer = null;
        cssVarsObserver = new MutationObserver(function (mutations) {
            var isUpdateMutation = false;
            mutations.forEach(function (mutation) {
                if (mutation.type === "attributes") {
                    isUpdateMutation = isLink(mutation.target) || isStyle(mutation.target);
                } else if (mutation.type === "childList") {
                    var addedNodes = Array.apply(null, mutation.addedNodes);
                    var removedNodes = Array.apply(null, mutation.removedNodes);
                    isUpdateMutation = [].concat(addedNodes, removedNodes).some(function (node) {
                        var isValidLink = isLink(node) && !node.disabled;
                        var isValidStyle = isStyle(node) && !node.disabled && regex.cssVars.test(node.textContent);
                        return isValidLink || isValidStyle;
                    });
                }
                if (isUpdateMutation) {
                    clearTimeout(debounceTimer);
                    debounceTimer = setTimeout(function () {
                        cssVars(settings);
                    }, 1);
                }
            });
        });
        cssVarsObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["disabled", "href"],
            childList: true,
            subtree: true
        });
    }
}

function fixKeyframes() {
    var allNodes = document.body.getElementsByTagName("*");
    var keyframeNodes = [];
    var nameMarker = "__css-vars-keyframe__";
    for (var i = 0, len = allNodes.length; i < len; i++) {
        var node = allNodes[i];
        var animationName = window.getComputedStyle(node).animationName;
        if (animationName !== "none") {
            node.style.animationName += nameMarker;
            keyframeNodes.push(node);
        }
    }
    void document.body.offsetHeight;
    for (var _i = 0, _len = keyframeNodes.length; _i < _len; _i++) {
        var nodeStyle = keyframeNodes[_i].style;
        nodeStyle.animationName = nodeStyle.animationName.replace(nameMarker, "");
    }
}

function getFullUrl$1(url) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
    var d = document.implementation.createHTMLDocument("");
    var b = d.createElement("base");
    var a = d.createElement("a");
    d.head.appendChild(b);
    d.body.appendChild(a);
    b.href = base;
    a.href = url;
    return a.href;
}

/* harmony default export */ var css_vars_ponyfill_esm = (cssVars);
//# sourceMappingURL=css-vars-ponyfill.esm.js.map
// CONCATENATED MODULE: ./state/reducers/eventReducer.js
var eventReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var eventReducer_initialState = {
  id: null,
  widget: false,
  data: false,
  loading: false,
  error: false
};
var eventReducer_parseEvent = function parseEvent(event, widget) {
  event.validDates = event.dates.filter(function (date) {
    return date.valid;
  });
  // add theme
  var variables = {};
  var theme = event.theme;

  // determines which banner to use, either new style or old style
  event.useOldBannerStyle = !event.bannerImage && event.featureImage ? true : false;

  event.displayImage = event.useOldBannerStyle ? event.featureImage : event.bannerImage;

  if (!theme) {
    return event;
  }

  if (theme.primaryColor) {
    variables["--primary-color"] = theme.primaryColor;
  }
  if (theme.primaryColorHover) {
    variables["--primary-color-hover"] = theme.primaryColorHover;
  } else if (theme.primaryColor) {
    variables["--primary-color-hover"] = theme.primaryColor;
  }
  if (theme.primaryColorFade) {
    variables["--primary-color-fade"] = theme.primaryColorFade;
  }
  if (theme.primaryShadowColour) {
    variables["--primary-shadow-color"] = theme.primaryShadowColour;
  }
  if (theme.primaryTextColor) {
    variables["--primary-text-color"] = theme.primaryTextColor;
  }
  if (theme.linkColor || theme.primaryColor) {
    variables["--link-color"] = theme.linkColor ? theme.linkColor : "#196097";
  }
  if (theme.footerColor) {
    variables["--footer-color"] = theme.footerColor;
  }
  css_vars_ponyfill_esm({ variables: variables });
  return event;
};

var eventReducer_changeFooterColor = function changeFooterColor(trueOrFalse, footerColor) {
  var variables = {};
  footerColor = footerColor || "#fff";
  if (trueOrFalse) variables["--footer-color"] = footerColor;
  css_vars_ponyfill_esm({ variables: variables });
};

var eventReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eventReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case eventActions["a" /* CLEAR_EVENT */]:
      return eventReducer__extends({}, state, {
        data: null
      });
    case eventActions["i" /* GET_EVENT_REQUEST */]:
      return eventReducer__extends({}, state, {
        id: null,
        loading: true,
        error: false
      });
    case eventActions["j" /* GET_EVENT_SUCCESS */]:
      return eventReducer__extends({}, state, {
        id: action.event._id,
        data: eventReducer_parseEvent(action.event, state.widget),
        loading: false,
        error: false
      });
    case eventActions["h" /* GET_EVENT_ERROR */]:
      return { data: false, loading: false, error: action.error };

    case eventActions["o" /* GET_USER_EVENTS_REQUEST */]:
      return eventReducer__extends({}, state, {
        id: null,
        loading: true,
        error: false
      });
    case eventActions["p" /* GET_USER_EVENTS_SUCCESS */]:
      eventReducer_changeFooterColor(true, "#fff");
      return eventReducer__extends({}, state, {
        data: action.events,
        loading: false,
        error: false
      });
    case eventActions["n" /* GET_USER_EVENTS_ERROR */]:
      return { data: false, loading: false, error: action.error };

    case orderActions["t" /* GET_ORDER_REQ_SUCCESS */]:
      if (action.additionalQuestions && action.additionalQuestions.length) {
        var event = state.data;
        event.additionalQuestions = action.additionalQuestions;
        return eventReducer__extends({}, state, {
          data: event
        });
      } else {
        return state;
      }

    case eventActions["a" /* CLEAR_EVENT */]:
      return eventReducer__extends({}, state, {
        data: null
      });
    default:
      return state;
  }
};
/* harmony default export */ var eventReducer = ({
  initialState: eventReducer_initialState,
  reducer: eventReducer_reducer,
  parseEvent: eventReducer_parseEvent
});
// EXTERNAL MODULE: ../node_modules/load-script/index.js
var load_script = __webpack_require__("zX5E");
var load_script_default = /*#__PURE__*/__webpack_require__.n(load_script);

// CONCATENATED MODULE: ./state/actions/zipMoneyActions.js




var LOAD_ZIP_SCRIPTS_REQUEST = "LOAD_ZIP_SCRIPTS_REQUEST";
var LOAD_ZIP_SCRIPTS_SUCCESS = "LOAD_ZIP_SCRIPTS_SUCCESS";
var LOAD_ZIP_SCRIPTS_ERROR = "LOAD_ZIP_SCRIPTS_ERROR";

var ZIP_CHECKOUT_REQUEST = "ZIP_CHECKOUT_REQUEST";
var ZIP_CHECKOUT_SUCCESS = "ZIP_CHECKOUT_SUCCESS";
var ZIP_CHECKOUT_ERROR = "ZIP_CHECKOUT_ERROR";



var zipMoneyActions_loadScripts = function loadScripts() {
    return function (dispatch) {
        dispatch({ type: LOAD_ZIP_SCRIPTS_REQUEST });
        load_script_default()(Object(config["a" /* default */])('ZIPMONEY_LIBARY_URL'), function (err, script) {
            if (err) {
                dispatch({ type: LOAD_ZIP_SCRIPTS_ERROR });
                return;
            }
            dispatch({ type: LOAD_ZIP_SCRIPTS_SUCCESS });
        });
    };
};

var zipMoneyActions_checkout = function checkout(eventSlug, orderId) {
    return function (dispatch) {

        try {
            Zip.Checkout.init({
                checkoutUri: Object(config["a" /* default */])('API_URL') + 'zip-money/checkout?orderId=' + orderId,
                redirectUri: '/zipmoney/return',
                onComplete: function onComplete(args) {
                    if (args.state !== "approved") {
                        dispatch({ type: ZIP_CHECKOUT_ERROR, error: args.state });
                    }
                    dispatch({ type: ZIP_CHECKOUT_SUCCESS, args: args });
                    dispatch(Object(orderActions["T" /* pay */])(eventSlug, orderId, 'zipmoney', args));
                },
                onError: function onError(args) {
                    console.error(args);
                    dispatch({ type: ZIP_CHECKOUT_ERROR, error: err });
                }
            });
        } catch (err) {
            console.error(err);
            dispatch({ type: ZIP_CHECKOUT_ERROR, error: err });
        }
    };
};
// EXTERNAL MODULE: ./state/actions/ticketsActions.js
var ticketsActions = __webpack_require__("tyHu");

// CONCATENATED MODULE: ./state/reducers/orderReducer.js
var orderReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var orderReducer_initialState = {
  data: null,
  providedOrderData: null,
  paymentMethod: orderActions["m" /* CREDIT_AND_DEBIT */],
  timeExpired: false,
  orderGet: {
    loading: false,
    error: false
  },
  orderRequest: {
    loading: false,
    error: false
  },
  detailsRequest: {
    loading: false,
    error: false,
    additionalQuestionQuantityError: false,
    saved: false
  },
  waitingToPay: false,
  paymentRequest: {
    loading: false,
    error: false
  },
  authRequest: {
    loading: false,
    error: false
  },
  addDiscountRequest: {
    loading: false,
    error: false
  },
  removeDiscountRequest: {
    loading: false,
    error: false
  },
  giftCardsRequest: {
    loading: false,
    error: false,
    isFullPayment: false
  }
};

function convertOrder(order) {
  var tickets = !order.tickets ? [] : order.tickets.sort(function (a, b) {
    var textA = a.ticketTypeName.toUpperCase();
    var textB = b.ticketTypeName.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });
  return orderReducer__extends({}, order, {
    tickets: tickets
  });
}

var orderReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : orderReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case orderActions["i" /* CLEAR_ORDER */]:
      return orderReducer_initialState;
    case orderActions["g" /* CHANGE_PAYMENT_METHOD */]:
      {
        return orderReducer__extends({}, state, {
          paymentMethod: action.method
        });
      }
    case ticketsActions["b" /* ADD_TICKET_QUANTITY */]:
      var _id = state.data && state.data._id ? state.data._id : null;
      return orderReducer__extends({}, state, {
        data: {
          _id: _id
        },
        orderRequest: {
          loading: false,
          error: false
        }
      });
    case ticketsActions["k" /* SELECT_DATE */]:
      return orderReducer__extends({}, state, {
        data: orderReducer__extends({}, state.data, {
          discountCodes: null
        }),
        orderRequest: {
          loading: false,
          error: false
        }
      });
    case orderActions["q" /* GET_ORDER_REQUEST */]:
      return orderReducer__extends({}, state, {
        orderGet: {
          loading: true,
          error: false
        }
      });
    case orderActions["u" /* GET_ORDER_SUCCESS */]:
      return orderReducer__extends({}, state, {
        timeExpired: false,
        data: convertOrder(action.order),
        orderGet: {
          loading: false,
          error: false
        }
      });
    case orderActions["p" /* GET_ORDER_ERROR */]:
      return orderReducer__extends({}, state, {
        data: false,
        orderGet: {
          loading: false,
          error: action.error
        }
      });

    case orderActions["b" /* ADD_DISCOUNT_REQUEST */]:
      return orderReducer__extends({}, state, {
        addDiscountRequest: {
          loading: true,
          error: false
        }
      });
    case orderActions["c" /* ADD_DISCOUNT_SUCCESS */]:
      return orderReducer__extends({}, state, {
        data: convertOrder(action.order),
        addDiscountRequest: {
          loading: false,
          error: false
        }
      });
    case orderActions["a" /* ADD_DISCOUNT_ERROR */]:
      return orderReducer__extends({}, state, {
        addDiscountRequest: {
          loading: false,
          error: action.error
        }
      });
    case orderActions["B" /* REMOVE_DISCOUNT_REQUEST */]:
      return orderReducer__extends({}, state, {
        removeDiscountRequest: {
          loading: true,
          error: false
        }
      });
    case orderActions["C" /* REMOVE_DISCOUNT_SUCCESS */]:
      return orderReducer__extends({}, state, {
        data: convertOrder(action.order),
        removeDiscountRequest: {
          loading: false,
          error: false
        }
      });
    case orderActions["A" /* REMOVE_DISCOUNT_ERROR */]:
      return orderReducer__extends({}, state, {
        removeDiscountRequest: {
          loading: false,
          error: action.error
        }
      });

    case orderActions["e" /* ADD_GIFT_CARD_REQUEST */]:
      return orderReducer__extends({}, state, {
        giftCardsRequest: orderReducer__extends({}, state.giftCardsRequest, {
          loading: true,
          error: false
        })
      });
    case orderActions["f" /* ADD_GIFT_CARD_SUCCESS */]:
      return orderReducer__extends({}, state, {
        data: convertOrder(action.order),
        giftCardsRequest: orderReducer__extends({}, state.giftCardsRequest, {
          loading: false,
          error: false,
          isFullPayment: action.isFullPayment
        })
      });
    case orderActions["d" /* ADD_GIFT_CARD_ERROR */]:
      return orderReducer__extends({}, state, {
        giftCardsRequest: orderReducer__extends({}, state.giftCardsRequest, {
          loading: false,
          error: action.error
        })
      });
    case orderActions["E" /* REMOVE_GIFT_CARD_REQUEST */]:
      return orderReducer__extends({}, state, {
        giftCardsRequest: orderReducer__extends({}, state.giftCardsRequest, {
          loading: true,
          error: false
        })
      });
    case orderActions["F" /* REMOVE_GIFT_CARD_SUCCESS */]:
      return orderReducer__extends({}, state, {
        data: convertOrder(action.order),
        giftCardsRequest: {
          loading: false,
          error: false,
          isFullPayment: false
        }
      });
    case orderActions["D" /* REMOVE_GIFT_CARD_ERROR */]:
      return orderReducer__extends({}, state, {
        giftCardsRequest: orderReducer__extends({}, state.giftCardsRequest, {
          loading: false,
          error: action.error
        })
      });
    case orderActions["k" /* COMPLETE_GIFT_CARD_ORDER_REQUEST */]:
      return orderReducer__extends({}, state, {
        giftCardsRequest: orderReducer__extends({}, state.giftCardsRequest, {
          loading: true,
          error: false
        })
      });
    case orderActions["l" /* COMPLETE_GIFT_CARD_ORDER_SUCCESS */]:
      return orderReducer__extends({}, state, {
        data: convertOrder(action.order),
        giftCardsRequest: orderReducer__extends({}, state.giftCardsRequest, {
          loading: false,
          error: false
        })
      });
    case orderActions["j" /* COMPLETE_GIFT_CARD_ORDER_ERROR */]:
      return orderReducer__extends({}, state, {
        giftCardsRequest: orderReducer__extends({}, state.giftCardsRequest, {
          loading: false,
          error: action.error
        })
      });
    case orderActions["s" /* GET_ORDER_REQ_REQUEST */]:
      return orderReducer__extends({}, state, {
        data: null,
        orderRequest: {
          loading: true,
          error: false
        }
      });
    case orderActions["t" /* GET_ORDER_REQ_SUCCESS */]:
      return orderReducer__extends({}, state, {
        data: convertOrder(action.order),
        timeExpired: false,
        orderRequest: {
          loading: false,
          error: false
        },
        paymentRequest: {
          loading: false,
          error: false
        }
      });
    case orderActions["n" /* GET_DUMMY_ORDER_LOADING */]:
      return orderReducer__extends({}, state, {
        data: null,
        orderRequest: {
          loading: true,
          error: false
        }
      });
    case orderActions["o" /* GET_DUMMY_ORDER_SUCCESS */]:
      return orderReducer__extends({}, state, action.order);
    case orderActions["r" /* GET_ORDER_REQ_ERROR */]:
      return orderReducer__extends({}, state, {
        data: null,
        orderRequest: {
          loading: false,
          error: action.error
        }
      });
    case orderActions["H" /* SAVE_ORDER_DATA_REQUEST */]:
      return orderReducer__extends({}, state, {
        detailsRequest: {
          loading: true,
          error: false,
          saved: false,
          additionalQuestionQuantityError: false
        }
      });
    case orderActions["I" /* SAVE_ORDER_DATA_SUCCESS */]:
      return orderReducer__extends({}, state, {
        data: convertOrder(action.order),
        detailsRequest: {
          loading: false,
          error: false,
          saved: true,
          additionalQuestionQuantityError: false
        },
        paymentRequest: {
          loading: false,
          error: false
        },
        waitingToPay: false
      });
    case orderActions["G" /* SAVE_ORDER_DATA_ERROR */]:
      return orderReducer__extends({}, state, {
        detailsRequest: {
          loading: false,
          error: action.error,
          saved: false,
          additionalQuestionQuantityError: action.additionalQuestionQuantityError
        }
      });

    case orderActions["w" /* PAYMENT_CLICKED */]:
      return orderReducer__extends({}, state, {
        waitingToPay: true
      });
    case orderActions["h" /* CHECKOUT_ERROR */]:
    case ZIP_CHECKOUT_ERROR:
      return orderReducer__extends({}, state, {
        waitingToPay: false
      });
    case orderActions["y" /* PAYMENT_REQUEST */]:
      return orderReducer__extends({}, state, {
        waitingToPay: false,
        paymentRequest: {
          loading: true,
          error: false
        }
      });
    case orderActions["z" /* PAYMENT_SUCCESS */]:
      return orderReducer__extends({}, state, {
        data: convertOrder(action.order),
        waitingToPay: false,
        paymentRequest: {
          loading: false,
          error: false
        }
      });
    case orderActions["x" /* PAYMENT_ERROR */]:
      return orderReducer__extends({}, state, {
        data: action.order ? convertOrder(action.order) : state.data,
        waitingToPay: false,
        paymentRequest: {
          loading: false,
          error: action.error
        }
      });

    case orderActions["J" /* TIME_EXPIRED */]:
      return orderReducer__extends({}, state, {
        timeExpired: true
      });

    default:
      return state;
  }
};

/* harmony default export */ var orderReducer = ({
  initialState: orderReducer_initialState,
  reducer: orderReducer_reducer
});
// EXTERNAL MODULE: ./state/actions/orderSummaryActions.js
var orderSummaryActions = __webpack_require__("E70C");

// CONCATENATED MODULE: ./state/reducers/ticketsReducer.js
var ticketsReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var ticketsReducer_initialState = {
  tickets: null,
  requestedTickets: false,
  clientDonation: 0,
  donationOtherOption: false,
  selectedDateId: null,
  selectedDateDisplay: null,
  accessCode: null,
  showAccessCode: false,
  ticketsRequest: {
    loaded: false,
    loading: false,
    error: false
  },
  accessCodeRequest: {
    loading: false,
    error: false
  }
};

var eventReduce = function eventReduce(event, state, eventDate) {
  return ticketsReducer__extends({}, state, {
    tickets: null,
    requestedTickets: false,
    selectedDateId: null,
    selectedDateDisplay: null,
    selectedStartDate: null,
    showAccessCode: false,
    accessCode: null,
    clientDonation: 0
  });
};

var ticketsFromOrder = function ticketsFromOrder(order, selectedTickets) {
  var selectedTicketsLookUp = {};
  if (selectedTickets) {
    selectedTickets.forEach(function (selectedTicket) {
      selectedTicket.quantity = 0;
      selectedTicketsLookUp[selectedTicket._id] = selectedTicket;
    });
  }
  var tickets = order && order.tickets ? order.tickets : [];
  tickets.forEach(function (orderTicket) {
    if (!selectedTicketsLookUp[orderTicket.ticketTypeId]) {
      var ticketData = {
        _id: orderTicket.ticketTypeId,
        quantity: 0,
        name: orderTicket.ticketTypeName,
        price: orderTicket.price,
        discountCodes: []
      };
      selectedTicketsLookUp[orderTicket.ticketTypeId] = ticketData;
    }
    if (orderTicket.discountCodes && orderTicket.discountCodes.length) {
      selectedTicketsLookUp[orderTicket.ticketTypeId].discountCodes = orderTicket.discountCodes;
    }
    selectedTicketsLookUp[orderTicket.ticketTypeId].quantity++;
  });
  return Object.keys(selectedTicketsLookUp).map(function (id) {
    return selectedTicketsLookUp[id];
  });
};

var resetTicketQuantity = function resetTicketQuantity(tickets) {
  tickets = tickets.map(function (ticket) {
    if (ticket.ticketGroup && ticket.tickets.length) {
      ticket.tickets = ticket.ticketsWithInfo.map(function (t) {
        t.quantity = 0;
        return t;
      });
    }
    ticket.quantity = 0;
    return ticket;
  });
  return tickets;
};

var ticketsReducer_addTicketQuantity = function addTicketQuantity(ticket, ticketTypeId, quantity) {
  if (ticket.ticketGroup && ticket.tickets) {
    for (var i = 0; i < ticket.tickets.length; i++) {
      var ticketInGroup = ticket.tickets[i];
      if (ticketInGroup._id === ticketTypeId) {
        ticketInGroup.quantity = quantity;
        break;
      }
    }
  }
  if (ticket._id === ticketTypeId) {
    ticket.quantity = quantity;
  }
  return ticket;
};

var ticketsReducer_addTicketPrice = function addTicketPrice(ticket, ticketTypeId, price) {
  if (ticket.ticketGroup && ticket.tickets) {
    for (var i = 0; i < ticket.tickets.length; i++) {
      var ticketInGroup = ticket.tickets[i];
      if (ticketInGroup._id === ticketTypeId) {
        ticketInGroup.price = price;
        break;
      }
    }
  }
  if (ticket._id === ticketTypeId) {
    ticket.price = price;
  }
  return ticket;
};

var ticketsReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ticketsReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case ticketsActions["f" /* CLEAR_TICKETS */]:
      return ticketsReducer_initialState;
    case orderSummaryActions["c" /* GET_SUMMARY_SUCCESS */]:
      return ticketsReducer__extends({}, state, {
        requestedTickets: action.tickets
      });
    case ticketsActions["j" /* REMOVE_ACCESS_CODE */]:
      return ticketsReducer__extends({}, state, {
        accessCode: null
      });
    case ticketsActions["l" /* SHOW_ACCESS_CODES */]:
      return ticketsReducer__extends({}, state, {
        showAccessCode: true
      });
    case ticketsActions["d" /* CHECK_ACCESS_CODE_REQUEST */]:
      return ticketsReducer__extends({}, state, {
        showAccessCode: true,
        accessCode: null,
        accessCodeRequest: {
          loading: true,
          error: false
        }
      });
    case ticketsActions["e" /* CHECK_ACCESS_CODE_SUCCESS */]:
      return ticketsReducer__extends({}, state, {
        accessCode: action.accessCode,
        accessCodeRequest: {
          loading: false,
          error: false
        }
      });
    case ticketsActions["c" /* CHECK_ACCESS_CODE_ERROR */]:
      return ticketsReducer__extends({}, state, {
        accessCode: null,
        accessCodeRequest: {
          loading: false,
          error: action.error
        }
      });
    case eventActions["j" /* GET_EVENT_SUCCESS */]:
      return eventReduce(action.event, state);
    case eventActions["i" /* GET_EVENT_REQUEST */]:
    case orderActions["i" /* CLEAR_ORDER */]:
    case eventActions["h" /* GET_EVENT_ERROR */]:
      return ticketsReducer__extends({}, state, {
        tickets: []
      });

    case ticketsActions["h" /* GET_TICKETS_REQUEST */]:
      return ticketsReducer__extends({}, state, {
        tickets: [],
        ticketsRequest: {
          loading: true,
          error: false
        }
      });
    case ticketsActions["i" /* GET_TICKETS_SUCCESS */]:
      return ticketsReducer__extends({}, state, {
        tickets: resetTicketQuantity(action.tickets),
        ticketsRequest: {
          loaded: true,
          loading: false,
          error: false
        }
      });
    case ticketsActions["g" /* GET_TICKETS_ERROR */]:
      return ticketsReducer__extends({}, state, {
        tickets: [],
        ticketsRequest: {
          loading: false,
          error: action.error
        }
      });
    case ticketsActions["b" /* ADD_TICKET_QUANTITY */]:
      var tickets = state.tickets.map(function (t) {
        var ticket = ticketsReducer__extends({}, t);
        ticket = ticketsReducer_addTicketQuantity(ticket, action.ticketTypeId, action.quantity);
        delete ticket.discountCodes;
        ticket.errors = null;
        return ticket;
      });
      return ticketsReducer__extends({}, state, {
        tickets: tickets
      });
    case ticketsActions["a" /* ADD_TICKET_PRICE */]:
      var updatedTickets = state.tickets.map(function (t) {
        var ticket = ticketsReducer__extends({}, t);
        ticket = ticketsReducer_addTicketPrice(ticket, action.ticketTypeId, action.price);
        delete ticket.discountCodes;
        ticket.errors = null;
        return ticket;
      });
      return ticketsReducer__extends({}, state, {
        tickets: updatedTickets
      });
    case ticketsActions["n" /* UPDATE_DOTATION_AMOUNT */]:
      return ticketsReducer__extends({}, state, {
        clientDonation: Number(action.amount)
      });
    case orderActions["z" /* PAYMENT_SUCCESS */]:
    case orderActions["u" /* GET_ORDER_SUCCESS */]:
      {
        var _tickets = ticketsFromOrder(action.order, state.tickets || []);
        var clientDonation = action.order.clientDonation;
        return ticketsReducer__extends({}, state, {
          tickets: _tickets,
          requestedTickets: action.order.tickets,
          clientDonation: isNaN(clientDonation) ? 0 : Number(clientDonation)
        });
      }
    case orderActions["r" /* GET_ORDER_REQ_ERROR */]:
      {
        if (!action.error || !action.error.ticketErrors) {
          return state;
        }
        var errorLookUp = {};
        action.error.ticketErrors.forEach(function (ticketError) {
          if (!errorLookUp[ticketError.ticketId]) {
            errorLookUp[ticketError.ticketId] = [];
          }
          errorLookUp[ticketError.ticketId].push(ticketError.error);
        });
        var _tickets2 = state.tickets.map(function (t) {
          t.errors = errorLookUp[t._id];
          return t;
        });
        return ticketsReducer__extends({}, state, {
          tickets: _tickets2
        });
      }
    case ticketsActions["k" /* SELECT_DATE */]:
      {
        return ticketsReducer__extends({}, state, {
          tickets: [],
          selectedDateId: action.dateId,
          selectedDateDisplay: action.dateDisplay,
          selectedStartDate: action.startDate
        });
      }
    case ticketsActions["m" /* SHOW_CUSTOM_DONATION_FIELD */]:
      {
        return ticketsReducer__extends({}, state, {
          donationOtherOption: action.donationOtherOption
        });
      }
    default:
      return state;
  }
};
/* harmony default export */ var ticketsReducer = ({
  initialState: ticketsReducer_initialState,
  reducer: ticketsReducer_reducer,
  eventReduce: eventReduce,
  ticketsFromOrder: ticketsFromOrder
});
// CONCATENATED MODULE: ./state/reducers/orderSummaryReducer.js
var orderSummaryReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var orderSummaryReducer_initialState = {
  data: null,
  eventDate: null,
  loading: false,
  error: false
};
var orderSummaryReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : orderSummaryReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case orderActions["i" /* CLEAR_ORDER */]:
      {
        return orderSummaryReducer_initialState;
      }
    case orderSummaryActions["b" /* GET_SUMMARY_REQUEST */]:
      return orderSummaryReducer__extends({}, state, {
        data: null,
        loading: true,
        error: false
      });
    case orderSummaryActions["c" /* GET_SUMMARY_SUCCESS */]:
      return orderSummaryReducer__extends({}, state, {
        data: action.summary,
        loading: false,
        error: false
      });
    case orderSummaryActions["a" /* GET_SUMMARY_ERROR */]:
      return orderSummaryReducer__extends({}, state, {
        data: null,
        loading: false,
        error: action.error
      });
    case ticketsActions["k" /* SELECT_DATE */]:
      {
        return orderSummaryReducer__extends({}, state, {
          eventDate: action.dateDisplay
        });
      }
    case eventActions["j" /* GET_EVENT_SUCCESS */]:
      if (!action.event.validDates || !action.event.validDates.length) {
        return orderSummaryReducer__extends({}, state);
      }
      return orderSummaryReducer__extends({}, state, {
        eventDate: action.event.validDates[0].display
      });
    default:
      return state;
  }
};
/* harmony default export */ var orderSummaryReducer = ({ initialState: orderSummaryReducer_initialState, reducer: orderSummaryReducer_reducer });
// CONCATENATED MODULE: ./state/actions/payPalActions.js


var LOAD_CHECKOUT_SCRIPT_REQUEST = "LOAD_CHECKOUT_SCRIPT_REQUEST";
var LOAD_CHECKOUT_SCRIPT_SUCCESS = "LOAD_CHECKOUT_SCRIPT_SUCCESS";
var LOAD_CHECKOUT_SCRIPT_ERROR = "LOAD_CHECKOUT_SCRIPT_ERROR";

var payPalActions_loadCheckOutScript = function loadCheckOutScript() {
  return function (dispatch) {
    dispatch({ type: LOAD_CHECKOUT_SCRIPT_REQUEST });
    load_script_default()('https://www.paypalobjects.com/api/checkout.js', function (err, script) {
      if (err) {
        dispatch({ type: LOAD_CHECKOUT_SCRIPT_ERROR });
        return;
      }
      dispatch({ type: LOAD_CHECKOUT_SCRIPT_SUCCESS });
    });
  };
};
// CONCATENATED MODULE: ./state/reducers/payPalReducer.js
var payPalReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var payPalReducer_initialState = {
    checkoutScript: {
        loading: false,
        error: false,
        loaded: false
    }

};

var payPalReducer_reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : payPalReducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case LOAD_CHECKOUT_SCRIPT_REQUEST:
            return payPalReducer__extends({}, state, {
                checkoutScript: {
                    loading: true,
                    error: false
                }
            });
        case LOAD_CHECKOUT_SCRIPT_SUCCESS:
            return payPalReducer__extends({}, state, {
                checkoutScript: {
                    loading: false,
                    loaded: true,
                    error: false
                }
            });
        case LOAD_CHECKOUT_SCRIPT_ERROR:
            return payPalReducer__extends({}, state, {
                checkoutScript: {
                    loading: false,
                    error: true
                }
            });
        default:
            return state;
    }
};
/* harmony default export */ var payPalReducer = ({
    initialState: payPalReducer_initialState,
    reducer: payPalReducer_reducer
});
// CONCATENATED MODULE: ./state/actions/stripeActions.js


var LOAD_STRIPE_SCRIPT_REQUEST = "LOAD_STRIPE_SCRIPT_REQUEST";
var LOAD_STRIPE_SCRIPT_SUCCESS = "LOAD_STRIPE_SCRIPT_SUCCESS";
var LOAD_STRIPE_SCRIPT_ERROR = "LOAD_STRIPE_SCRIPT_ERROR";

var stripeActions_loadCheckOutScript = function loadCheckOutScript() {
  return function (dispatch) {
    dispatch({ type: LOAD_STRIPE_SCRIPT_REQUEST });
    load_script_default()('https://js.stripe.com/v3/', function (err, script) {
      if (err) {
        dispatch({ type: LOAD_STRIPE_SCRIPT_ERROR });
        return;
      }
      dispatch({ type: LOAD_STRIPE_SCRIPT_SUCCESS });
    });
  };
};
// CONCATENATED MODULE: ./state/reducers/stripeReducer.js
var stripeReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var stripeReducer_initialState = {
    checkoutScript: {
        loading: false,
        error: false,
        loaded: false
    }

};

var stripeReducer_reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stripeReducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case LOAD_STRIPE_SCRIPT_REQUEST:
            return stripeReducer__extends({}, state, {
                checkoutScript: {
                    loading: true,
                    error: false
                }
            });
        case LOAD_STRIPE_SCRIPT_SUCCESS:
            return stripeReducer__extends({}, state, {
                checkoutScript: {
                    loading: false,
                    loaded: true,
                    error: false
                }
            });
        case LOAD_STRIPE_SCRIPT_ERROR:
            return stripeReducer__extends({}, state, {
                checkoutScript: {
                    loading: false,
                    error: true
                }
            });
        default:
            return state;
    }
};
/* harmony default export */ var stripeReducer = ({
    initialState: stripeReducer_initialState,
    reducer: stripeReducer_reducer
});
// CONCATENATED MODULE: ./state/reducers/zipMoneyReducer.js
var zipMoneyReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var zipMoneyReducer_initialState = {
    scripts: {
        loading: false,
        error: false,
        loaded: false
    },
    checkout: {
        loading: false,
        error: false,
        loaded: false,
        id: null
    }
};

var zipMoneyReducer_reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : zipMoneyReducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case LOAD_ZIP_SCRIPTS_REQUEST:
            return zipMoneyReducer__extends({}, state, {
                scripts: {
                    loading: true,
                    error: false
                }
            });
        case LOAD_ZIP_SCRIPTS_SUCCESS:
            return zipMoneyReducer__extends({}, state, {
                scripts: {
                    loading: false,
                    loaded: true,
                    error: false
                }
            });
        case LOAD_ZIP_SCRIPTS_ERROR:
            return zipMoneyReducer__extends({}, state, {
                scripts: {
                    loading: false,
                    error: true
                }
            });
        case ZIP_CHECKOUT_REQUEST:
            return zipMoneyReducer__extends({}, state, {
                checkout: {
                    loading: true,
                    error: false
                }
            });
        case ZIP_CHECKOUT_SUCCESS:
            return zipMoneyReducer__extends({}, state, {
                checkout: {
                    loading: false,
                    loaded: true,
                    error: false,
                    id: action.checkout_id
                }
            });
        case ZIP_CHECKOUT_ERROR:
            return zipMoneyReducer__extends({}, state, {
                checkout: {
                    loading: false,
                    error: true
                }
            });
        default:
            return state;
    }
};
/* harmony default export */ var zipMoneyReducer = ({
    initialState: zipMoneyReducer_initialState,
    reducer: zipMoneyReducer_reducer
});
// EXTERNAL MODULE: ./state/actions/seatingMapActions.js + 1 modules
var seatingMapActions = __webpack_require__("Te0X");

// CONCATENATED MODULE: ./state/reducers/seatingMapReducer.js
var seatingMapReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var seatingMapReducer_initialState = {
  selectedSeatingMap: false,
  seatingMaps: [],
  loading: false,
  error: false,
  orderContainsMap: false,
  seatingMapRequired: false,
  seatingMapEvaluated: false,
  save: {
    loading: false,
    error: false,
    conflicts: []
  }
};

var seatingMapReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : seatingMapReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case seatingMapActions["e" /* GET_SEATING_MAP_REQUEST */]:
      return seatingMapReducer__extends({}, state, {
        loading: true,
        error: false
      });
    case seatingMapActions["f" /* GET_SEATING_MAP_SUCCESS */]:
      return seatingMapReducer__extends({}, state, {
        orderContainsMap: true,
        loading: false,
        error: false,
        selectedSeatingMap: action.seatingMap
      });
    case seatingMapActions["d" /* GET_SEATING_MAP_ERROR */]:
      return seatingMapReducer__extends({}, state, {
        loading: false,
        error: action.error
      });

    case seatingMapActions["b" /* GET_SEATING_MAPS_REQUEST */]:
      return seatingMapReducer__extends({}, state, {
        loading: true,
        error: false
      });
    case seatingMapActions["c" /* GET_SEATING_MAPS_SUCCESS */]:
      return seatingMapReducer__extends({}, state, {
        orderContainsMap: true,
        loading: false,
        error: false,
        seatingMaps: action.seatingMaps
      });
    case seatingMapActions["a" /* GET_SEATING_MAPS_ERROR */]:
      return seatingMapReducer__extends({}, state, {
        loading: false,
        error: action.error
      });

    case seatingMapActions["j" /* SAVE_TICKET_MAPPING_REQUEST */]:
      return seatingMapReducer__extends({}, state, {
        save: {
          loading: true,
          error: false,
          conflicts: []
        }
      });
    case seatingMapActions["k" /* SAVE_TICKET_MAPPING_SUCCESS */]:
      return seatingMapReducer__extends({}, state, {
        save: {
          loading: false,
          error: false,
          conflicts: []
        }
      });
    case seatingMapActions["h" /* SAVE_TICKET_MAPPING_CONFLICT */]:
      return seatingMapReducer__extends({}, state, {
        save: {
          loading: false,
          error: false,
          conflicts: action.conflicts
        }
      });
    case seatingMapActions["i" /* SAVE_TICKET_MAPPING_ERROR */]:
      return seatingMapReducer__extends({}, state, {
        save: {
          loading: false,
          error: true,
          conflicts: []
        }
      });
    case seatingMapActions["l" /* SEATING_MAP_REQUIRED */]:
      return seatingMapReducer__extends({}, state, {
        seatingMapRequired: action.required,
        seatingMapEvaluated: true
      });
    case seatingMapActions["g" /* RESET_SEATING_MAP_EVAL */]:
      return seatingMapReducer__extends({}, state, {
        seatingMapEvaluated: false
      });
    default:
      return state;
  }
};

/* harmony default export */ var seatingMapReducer = ({
  initialState: seatingMapReducer_initialState,
  reducer: seatingMapReducer_reducer
});
// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__("dZBD");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./services/OrganiserService.js



var OrganiserService = {
  get: function get(organiserId) {
    return new Promise(function (resolve, reject) {
      axios_default.a.get(Object(config["a" /* default */])('API_URL') + 'organisers/' + organiserId).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getCharitiesOrganiserId: function getCharitiesOrganiserId(organiserId) {
    return new Promise(function (resolve, reject) {
      axios_default.a.get(Object(config["a" /* default */])("API_URL") + 'organisers/charities/' + organiserId).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getEventsbyOrganiserId: function getEventsbyOrganiserId(organiserId, page, tab) {
    return new Promise(function (resolve, reject) {
      axios_default.a.get(Object(config["a" /* default */])("API_URL") + 'organisers/events/' + organiserId, { params: { page: page, tab: tab } }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  sanitiseURLs: function sanitiseURLs(url) {
    var siteLink = url;
    var pattern = /^((http|https|ftp):\/\/)/;
    if (!pattern.test(siteLink)) {
      siteLink = 'https://' + siteLink;
    }
    return siteLink;
  }
};

/* harmony default export */ var services_OrganiserService = (OrganiserService);
// CONCATENATED MODULE: ./state/actions/organiserActions.js


var GET_ORGANISER_SUCCESS = "GET_ORGANISER_SUCCESS";
var GET_ORGANISER_FAILURE = "GET_ORGANISER_FAILURE";
var GET_ORGANISER_LOADING = "GET_ORGANISER_LOADING";
var GET_LIVE_EVENTS_SUCCESS = "GET_LIVE_EVENTS_SUCCESS";
var GET_LIVE_EVENTS_FAILURE = "GET_LIVE_EVENTS_FAILURE";
var GET_LIVE_EVENTS_LOADING = "GET_LIVE_EVENTS_LOADING";
var GET_PAST_EVENTS_SUCCESS = "GET_PAST_EVENTS_SUCCESS";
var GET_PAST_EVENTS_FAILURE = "GET_PAST_EVENTS_FAILURE";
var GET_PAST_EVENTS_LOADING = "GET_PAST_EVENTS_LOADING";
var UPDATE_TAB_PAGE = "UPDATE_TAB_PAGE";

var organiserActions_getOrganiser = function getOrganiser(id) {
  return function (dispatch) {
    dispatch({ type: GET_ORGANISER_LOADING });
    services_OrganiserService.get(id).then(function (organiser) {
      dispatch({ type: GET_ORGANISER_SUCCESS, organiser: organiser });
    }).catch(function (err) {
      dispatch({ type: GET_ORGANISER_FAILURE, organiser: organiser });
    });
  };
};

var organiserActions_loadLiveEventsByOrganiser = function loadLiveEventsByOrganiser(organiserId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var tab = arguments[2];

  return function (dispatch) {
    dispatch({ type: GET_LIVE_EVENTS_LOADING, page: page });
    services_OrganiserService.getEventsbyOrganiserId(organiserId, page, tab).then(function (response) {
      dispatch({
        type: GET_LIVE_EVENTS_SUCCESS,
        events: response.events,
        numEvents: response.total
      });
    }).catch(function (err) {
      dispatch({ type: GET_LIVE_EVENTS_FAILURE });
    });
  };
};

var organiserActions_loadPastEventsByOrganiser = function loadPastEventsByOrganiser(organiserId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var tab = arguments[2];

  return function (dispatch) {
    dispatch({ type: GET_PAST_EVENTS_LOADING, page: page });
    services_OrganiserService.getEventsbyOrganiserId(organiserId, page, tab).then(function (response) {
      dispatch({
        type: GET_PAST_EVENTS_SUCCESS,
        events: response.events,
        numEvents: response.total
      });
    }).catch(function (err) {
      dispatch({ type: GET_PAST_EVENTS_FAILURE });
    });
  };
};

var organiserActions_changeTab = function changeTab(tab) {
  return function (dispatch) {
    dispatch({ type: UPDATE_TAB_PAGE, tab: tab });
  };
};
// CONCATENATED MODULE: ./state/reducers/organiserReducer.js
var organiserReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var organiserReducer_initialState = {
  organiserLoading: true,
  organiser: null,
  organiserFailure: false,
  tab: "live",
  liveEvents: {
    page: 0,
    loading: false,
    events: null,
    total: 0,
    errors: false
  },
  pastEvents: {
    page: 0,
    loading: false,
    events: null,
    total: 0,
    errors: false
  }
};

var organiserReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : organiserReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET_LIVE_EVENTS_LOADING:
      return organiserReducer__extends({}, state, {
        liveEvents: organiserReducer__extends({}, state.liveEvents, {
          page: action.page,
          loading: true
        })
      });
    case GET_LIVE_EVENTS_SUCCESS:
      return organiserReducer__extends({}, state, {
        liveEvents: organiserReducer__extends({}, state.liveEvents, {
          loading: false,
          events: action.events,
          total: action.numEvents
        })
      });
    case GET_LIVE_EVENTS_FAILURE:
      return organiserReducer__extends({}, state);
    case GET_PAST_EVENTS_LOADING:
      return organiserReducer__extends({}, state, {
        pastEvents: organiserReducer__extends({}, state.pastEvents, {
          page: action.page,
          loading: true
        })
      });

    case GET_PAST_EVENTS_SUCCESS:
      return organiserReducer__extends({}, state, {
        pastEvents: organiserReducer__extends({}, state.pastEvents, {
          loading: false,
          events: action.events,
          total: action.numEvents
        })
      });
    case GET_PAST_EVENTS_FAILURE:
      return organiserReducer__extends({}, state);

    case GET_ORGANISER_FAILURE:
      return organiserReducer__extends({}, state, {
        organiserFailure: true
      });
    case GET_ORGANISER_LOADING:
      return organiserReducer__extends({}, state, {
        organiserLoading: true
      });
    case GET_ORGANISER_SUCCESS:
      return organiserReducer__extends({}, state, {
        organiser: action.organiser,
        organiserLoading: false
      });
    case UPDATE_TAB_PAGE:
      return organiserReducer__extends({}, state, {
        tab: action.tab
      });
    default:
      return state;
  }
};
/* harmony default export */ var organiserReducer = ({ initialState: organiserReducer_initialState, reducer: organiserReducer_reducer });
// EXTERNAL MODULE: ./state/actions/waitlistActions.js + 1 modules
var waitlistActions = __webpack_require__("mVfy");

// CONCATENATED MODULE: ./state/reducers/waitlistReducer.js
var waitlistReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var waitlistReducer_initialState = {
  add: {
    loading: false,
    error: false,
    added: false
  },
  pass: {
    loading: true,
    error: false,
    added: false
  }
};

var waitlistReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : waitlistReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case waitlistActions["d" /* CLEAR_WAITLIST_REQUEST */]:
      return waitlistReducer__extends({}, state, waitlistReducer_initialState);
    case waitlistActions["b" /* ADD_TO_WAITLIST_REQUEST */]:
      return waitlistReducer__extends({}, state, {
        add: waitlistReducer__extends({}, state.add, {
          loading: true,
          error: false
        })
      });
    case waitlistActions["c" /* ADD_TO_WAITLIST_SUCCESS */]:
      return waitlistReducer__extends({}, state, {
        add: waitlistReducer__extends({}, state.add, {
          added: true,
          loading: false,
          error: false
        })
      });
    case waitlistActions["a" /* ADD_TO_WAITLIST_ERROR */]:
      return waitlistReducer__extends({}, state, {
        add: waitlistReducer__extends({}, state.add, {
          added: false,
          loading: false,
          error: action.error
        })
      });
    case waitlistActions["f" /* PASS_WAITLIST_REQUEST */]:
      return waitlistReducer__extends({}, state, {
        pass: waitlistReducer__extends({}, state.pass, {
          loading: true,
          error: false
        })
      });
    case waitlistActions["g" /* PASS_WAITLIST_SUCCESS */]:
      return waitlistReducer__extends({}, state, {
        pass: waitlistReducer__extends({}, state.pass, {
          passed: true,
          loading: false,
          error: false
        })
      });
    case waitlistActions["e" /* PASS_WAITLIST_ERROR */]:
      return waitlistReducer__extends({}, state, {
        pass: waitlistReducer__extends({}, state.pass, {
          loading: false,
          error: action.error
        })
      });
    default:
      return state;
  }
};
/* harmony default export */ var waitlistReducer = ({
  initialState: waitlistReducer_initialState,
  reducer: waitlistReducer_reducer
});
// CONCATENATED MODULE: ./services/GiftCardService.js



var GifCardService = {
  getPage: function getPage(slug) {
    return new Promise(function ($return, $error) {
      return $return(new Promise(function (res, rej) {
        axios_default.a.get(Object(config["a" /* default */])("API_URL") + "gift-cards/page/" + slug).then(function (response) {
          res(response.data);
        }).catch(function (err) {
          rej(err);
        });
      }));
    });
  },
  getEvents: function getEvents(giftCardTypeId, page) {
    return new Promise(function ($return, $error) {
      return $return(new Promise(function (res, rej) {
        axios_default.a.get(Object(config["a" /* default */])("API_URL") + "gift-cards/events/" + giftCardTypeId, {
          params: { page: page }
        }).then(function (response) {
          res(response.data);
        }).catch(function (err) {
          rej(err);
        });
      }));
    });
  }
};

/* harmony default export */ var GiftCardService = (GifCardService);
// CONCATENATED MODULE: ./state/actions/giftCardActions.js



var GET_GIFT_CARD_PAGE_REQUEST = "GET_GIFT_CARD_PAGE_REQUEST";
var GET_GIFT_CARD_PAGE_SUCCESS = "GET_GIFT_CARD_PAGE_SUCCESS";
var GET_GIFT_CARD_PAGE_ERROR = "GET_GIFT_CARD_PAGE_ERROR";

var GET_GIFT_CARD_EVENTS_REQUEST = "GET_GIFT_CARD_EVENTS_REQUEST";
var GET_GIFT_CARD_EVENTS_SUCCESS = "GET_GIFT_CARD_EVENTS_SUCCESS";
var GET_GIFT_CARD_EVENTS_ERROR = "GET_GIFT_CARD_EVENTS_ERROR";

var giftCardActions_getGiftCardPage = function getGiftCardPage(slug) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var pageData;

      dispatch({ type: GET_GIFT_CARD_PAGE_REQUEST });
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (err) {
        try {
          dispatch({ type: GET_GIFT_CARD_PAGE_ERROR, error: err });
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        return Promise.resolve(GiftCardService.getPage(slug)).then(function ($await_3) {
          try {
            pageData = $await_3;
            dispatch({
              type: GET_GIFT_CARD_PAGE_SUCCESS,
              giftCardPage: pageData.page,
              giftCards: pageData.giftCards
            });
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (err) {
        $Try_1_Catch(err)
      }
    });
  };
};

var giftCardActions_getGiftCardEvents = function getGiftCardEvents(id, page) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var _ref, events, total;

      dispatch({ type: GET_GIFT_CARD_EVENTS_REQUEST, page: page });
      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_2_Catch = function (err) {
        try {
          dispatch({ type: GET_GIFT_CARD_EVENTS_ERROR, error: err });
          return $Try_2_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        return Promise.resolve(GiftCardService.getEvents(id, page)).then(function ($await_4) {
          try {
            _ref = $await_4, events = _ref.events, total = _ref.total;

            dispatch({
              type: GET_GIFT_CARD_EVENTS_SUCCESS,
              events: events,
              total: total
            });
            return $Try_2_Post();
          } catch ($boundEx) {
            return $Try_2_Catch($boundEx);
          }
        }, $Try_2_Catch);
      } catch (err) {
        $Try_2_Catch(err)
      }
    });
  };
};
// CONCATENATED MODULE: ./state/reducers/giftCardReducer.js
var giftCardReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var giftCardReducer_initialState = {
  loading: false,
  error: false,
  giftCardPage: false,
  giftCardList: [],
  giftCardsOrder: [],
  events: {
    loading: false,
    error: false,
    list: [],
    page: 0
  }
};

var giftCardReducer_setStyling = function setStyling(giftCardPage) {
  var style = giftCardPage.style;

  var variables = {};
  if (style) {
    variables["--primary-color"] = style.primaryColor;
  }
  if (style.primaryColorHover) {
    variables["--primary-color-hover"] = style.primaryColorHover;
  } else if (style.primaryColor) {
    variables["--primary-color-hover"] = style.primaryColor;
  }
  if (style.primaryColorFade) {
    variables["--primary-color-fade"] = style.primaryColorFade;
  }
  if (style.primaryShadowColour) {
    variables["--primary-shadow-color"] = style.primaryShadowColour;
  }
  if (style.primaryTextColor) {
    variables["--primary-text-color"] = style.primaryTextColor;
  }
  if (style.primaryColor) {
    variables["--link-color"] = style.primaryColor;
  }
  css_vars_ponyfill_esm({ variables: variables });
  return event;
};

var giftCardReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : giftCardReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET_GIFT_CARD_PAGE_REQUEST:
      return giftCardReducer__extends({}, state, {
        loading: true,
        error: false
      });

    case GET_GIFT_CARD_PAGE_ERROR:
      return giftCardReducer__extends({}, state, {
        loading: false,
        error: action.error
      });

    case GET_GIFT_CARD_PAGE_SUCCESS:
      giftCardReducer_setStyling(action.giftCardPage);
      return giftCardReducer__extends({}, state, {
        loading: false,
        giftCardPage: action.giftCardPage,
        giftCardList: action.giftCards
      });
    case orderActions["u" /* GET_ORDER_SUCCESS */]:
      {
        var giftCards = giftCardsFromOrder(action.order);
        return giftCardReducer__extends({}, state, {
          giftCardsOrder: giftCards
        });
      }
    case orderActions["I" /* SAVE_ORDER_DATA_SUCCESS */]:
      {
        var _giftCards = giftCardsFromOrder(action.order);
        return giftCardReducer__extends({}, state, {
          giftCardsOrder: _giftCards
        });
      }
    case GET_GIFT_CARD_EVENTS_ERROR:
      {
        return giftCardReducer__extends({}, state, {
          events: giftCardReducer__extends({}, state.events, {
            loading: false,
            error: false
          })
        });
      }
    case GET_GIFT_CARD_EVENTS_SUCCESS:
      {
        return giftCardReducer__extends({}, state, {
          events: giftCardReducer__extends({}, state.events, {
            loading: false,
            error: false,
            list: action.events,
            total: action.total
          })
        });
      }
    case GET_GIFT_CARD_EVENTS_REQUEST:
      {
        return giftCardReducer__extends({}, state, {
          events: giftCardReducer__extends({}, state.events, {
            page: action.page,
            loading: true,
            error: false
          })
        });
      }
    default:
      return state;
  }
};

var giftCardsFromOrder = function giftCardsFromOrder(order) {
  var selectedGiftCardsLookUp = {};
  (order.giftCards || []).forEach(function (giftCard) {
    if (!selectedGiftCardsLookUp[giftCard.giftCardTypeId]) {
      var giftCardData = {
        _id: giftCard.giftCardTypeId,
        quantity: 0,
        name: giftCard.giftCardTypeName,
        price: giftCard.price,
        discountCodes: []
      };
      selectedGiftCardsLookUp[giftCard.giftCardTypeId] = giftCardData;
    }
    if (giftCard.discountCodes && giftCard.discountCodes.length) {
      selectedGiftCardsLookUp[giftCard.giftCardTypeId].discountCodes = giftCard.discountCodes;
    }
    selectedGiftCardsLookUp[giftCard.giftCardTypeId].quantity++;
  });
  return Object.keys(selectedGiftCardsLookUp).map(function (id) {
    return selectedGiftCardsLookUp[id];
  });
};

/* harmony default export */ var giftCardReducer = ({
  initialState: giftCardReducer_initialState,
  reducer: giftCardReducer_reducer,
  setStyling: giftCardReducer_setStyling,
  giftCardsFromOrder: giftCardsFromOrder
});
// CONCATENATED MODULE: ./state/reducers/dateReducer.js
var dateReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var dateReducer_initialState = {
  dates: undefined,
  month: new Date(),
  loading: false,
  error: false,
  selectedDate: false
};

var dateReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dateReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case eventActions["e" /* GET_EVENT_DATES_ERROR */]:
      return dateReducer__extends({}, state, {
        error: true,
        loading: false
      });
    case eventActions["g" /* GET_EVENT_DATES_SUCCESS */]:
      return dateReducer__extends({}, state, {
        error: false,
        loading: false,
        dates: action.dates
      });
    case eventActions["f" /* GET_EVENT_DATES_REQUEST */]:
      return dateReducer__extends({}, state, {
        error: false,
        loading: true,
        month: action.month
      });
    case eventActions["l" /* GET_NEAREST_EVENT_DATES_REQUEST */]:
      return dateReducer__extends({}, state, {
        error: false,
        loading: true
      });
    case eventActions["m" /* GET_NEAREST_EVENT_DATES_SUCCESS */]:
      return dateReducer__extends({}, state, {
        error: false,
        loading: false,
        dates: action.dates,
        month: action.month
      });
    case eventActions["k" /* GET_NEAREST_EVENT_DATES_ERROR */]:
      return dateReducer__extends({}, state, {
        error: true,
        loading: false
      });
    case eventActions["d" /* GET_DATE_SUCCESS */]:
      return dateReducer__extends({}, state, {
        error: false,
        loading: false,
        selectedDate: action.date
      });
    case eventActions["b" /* GET_DATE_ERROR */]:
      return dateReducer__extends({}, state, {
        error: true,
        loading: false
      });
    case eventActions["c" /* GET_DATE_REQUEST */]:
      return dateReducer__extends({}, state, {
        error: false,
        loading: true
      });
    default:
      return state;
  }
};
/* harmony default export */ var dateReducer = ({
  initialState: dateReducer_initialState,
  reducer: dateReducer_reducer
});
// EXTERNAL MODULE: ./state/actions/merchandiseActions.js + 1 modules
var merchandiseActions = __webpack_require__("pb6B");

// CONCATENATED MODULE: ./state/reducers/merchandiseReducer.js
var merchandiseReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var merchandiseReducer_initialState = {
  includesMerch: false,
  listMerch: {
    loading: false,
    error: false,
    data: false
  },
  merch: {
    loading: false,
    error: false,
    data: [],
    display: []
  }
};

var merchandiseReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : merchandiseReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case merchandiseActions["j" /* RESET_MERCHANDISE */]:
      return merchandiseReducer__extends({}, merchandiseReducer_initialState);

    case merchandiseActions["f" /* GET_MERCHANDISE_LIST_REQUEST */]:
      return merchandiseReducer__extends({}, state, {
        listMerch: merchandiseReducer__extends({}, state.listMerch, {
          loading: true,
          error: false
        })
      });

    case merchandiseActions["g" /* GET_MERCHANDISE_LIST_SUCCESS */]:
      return merchandiseReducer__extends({}, state, {
        listMerch: merchandiseReducer__extends({}, state.listMerch, {
          loading: false,
          error: false,
          data: action.merchList
        })
      });

    case merchandiseActions["e" /* GET_MERCHANDISE_LIST_ERROR */]:
      return merchandiseReducer__extends({}, state, {
        listMerch: merchandiseReducer__extends({}, state.listMerch, {
          loading: false,
          error: true
        })
      });
    case merchandiseActions["b" /* CREATE_MERCHANDISE_REQUEST */]:
      return merchandiseReducer__extends({}, state, {
        merch: merchandiseReducer__extends({}, state.merch, {
          loading: true,
          error: false
        })
      });
    case merchandiseActions["c" /* CREATE_MERCHANDISE_SUCCESS */]:
      return merchandiseReducer__extends({}, state, {
        merch: merchandiseReducer__extends({}, state.merch, {
          loading: false,
          data: action.data,
          display: createMerchDisplay(action.data),
          error: false
        })
      });
    case merchandiseActions["a" /* CREATE_MERCHANDISE_ERROR */]:
      return merchandiseReducer__extends({}, state, {
        merch: merchandiseReducer__extends({}, state.merch, {
          loading: false,
          error: action.error
        })
      });
    case merchandiseActions["h" /* GET_MERCHANDISE_REQUEST */]:
      return merchandiseReducer__extends({}, state, {
        merch: merchandiseReducer__extends({}, state.merch, {
          loading: true,
          error: false
        })
      });
    case merchandiseActions["i" /* GET_MERCHANDISE_SUCCESS */]:
      return merchandiseReducer__extends({}, state, {
        includesMerch: action.offer,
        merch: merchandiseReducer__extends({}, state.merch, {
          loading: false,
          data: action.data,
          display: createMerchDisplay(action.data),
          error: false
        })
      });
    case merchandiseActions["d" /* GET_MERCHANDISE_ERROR */]:
      return merchandiseReducer__extends({}, state, {
        merch: merchandiseReducer__extends({}, state.merch, {
          loading: false,
          error: true
        })
      });
    default:
      return state;
  }
};

var createMerchDisplay = function createMerchDisplay(merchandise) {
  return merchandise.reduce(function (cur, merch) {
    var merchFound = cur.find(function (m) {
      return m.merchandiseTypeId === merch.merchandiseTypeId && m.merchandiseOptionId === merch.merchandiseOptionId;
    });
    if (merchFound) {
      merchFound.quantity = merchFound.quantity + 1;
    } else {
      cur.push(merchandiseReducer__extends({}, merch, {
        quantity: 1
      }));
    }
    return cur;
  }, []);
};

/* harmony default export */ var merchandiseReducer = ({
  initialState: merchandiseReducer_initialState,
  reducer: merchandiseReducer_reducer,
  createMerchDisplay: createMerchDisplay
});
// CONCATENATED MODULE: ./services/TourService.js



var TourService = {
  getTour: function getTour(slug, query, token) {
    var params = { params: { query: query, token: token } };
    var result = axios_default.a.get(Object(config["a" /* default */])("API_URL") + "tours/" + slug, params);
    return result;
  },
  getTourPreview: function getTourPreview(slug, query) {
    var params = { params: query };
    var result = axios_default.a.get(Object(config["a" /* default */])("API_URL") + "tours/preview/" + slug, params);
    return result;
  },
  getTourFilterOptions: function getTourFilterOptions(slug, query) {
    var params = { params: query };
    var result = axios_default.a.get(Object(config["a" /* default */])("API_URL") + "tours/tour-options/" + slug, params);
    return result;
  }
};

/* harmony default export */ var services_TourService = (TourService);
// CONCATENATED MODULE: ./state/actions/tourActions.js


var GET_TOUR_REQUEST = "GET_TOUR_REQUEST";
var GET_TOUR_SUCCESS = "GET_TOUR_SUCCESS";
var GET_TOUR_ERROR = "GET_TOUR_ERROR";

var GET_TOUR_EVENTS_REQUEST = "GET_TOUR_EVENTS_REQUEST";
var GET_TOUR_EVENTS_SUCCESS = "GET_TOUR_EVENTS_SUCCESS";
var GET_TOUR_EVENTS_ERROR = "GET_TOUR_EVENTS_ERROR";

var GET_TOUR_OPTIONS_REQUEST = "GET_TOUR_OPTIONS_REQUEST";
var GET_TOUR_OPTIONS_SUCCESS = "GET_TOUR_OPTIONS_SUCCESS";

var onlyEventUpdate = function onlyEventUpdate(query) {
  return query.date || query.location || query.onlyEventLoading ? true : false;
};

var tourActions_getTour = function getTour(slug, query, token) {
  return function (dispatch) {
    if (onlyEventUpdate(query)) {
      dispatch({ type: GET_TOUR_EVENTS_REQUEST });
    } else {
      dispatch({ type: GET_TOUR_REQUEST });
    }
    services_TourService.getTour(slug, query, token).then(function (result) {
      var tour = result.data;
      var tourEvents = tour.events ? tour.events : [];
      var featuredEvents = tour.featuredEvents ? tour.featuredEvents : [];
      var totalEventSize = tour.totalEventSize ? tour.totalEventSize : 0;
      if (onlyEventUpdate(query)) {
        dispatch({
          type: GET_TOUR_EVENTS_SUCCESS,
          tourEvents: tourEvents,
          featuredEvents: featuredEvents,
          totalEventSize: totalEventSize
        });
      } else {
        dispatch({
          type: GET_TOUR_SUCCESS,
          tour: tour,
          tourEvents: tourEvents,
          featuredEvents: featuredEvents,
          totalEventSize: totalEventSize
        });
      }
    }).catch(function (err) {
      dispatch({ type: GET_TOUR_ERROR, error: err });
    });
  };
};

var tourActions_getTourFilterOptions = function getTourFilterOptions(slug, query) {
  return function (dispatch) {
    dispatch({ type: GET_TOUR_OPTIONS_REQUEST });
    services_TourService.getTourFilterOptions(slug, query).then(function (result) {
      dispatch({
        type: GET_TOUR_OPTIONS_SUCCESS,
        tourLocations: result.data.locationOptions,
        tourDates: result.data.dateOptions
      });
    });
  };
};

var tourActions_getTourPreview = function getTourPreview(slug, query) {
  return function (dispatch) {
    if (onlyEventUpdate(query)) {
      dispatch({ type: GET_TOUR_EVENTS_REQUEST });
    } else {
      dispatch({ type: GET_TOUR_REQUEST });
    }
    services_TourService.getTourPreview(slug, query).then(function (result) {
      var tour = result.data;
      var tourEvents = tour.events ? tour.events : [];
      var featuredEvents = tour.featuredEvents ? tour.featuredEvents : [];
      var totalEventSize = tour.totalEventSize ? tour.totalEventSize : 0;
      if (onlyEventUpdate(query)) {
        dispatch({
          type: GET_TOUR_EVENTS_SUCCESS,
          tourEvents: tourEvents,
          featuredEvents: featuredEvents,
          totalEventSize: totalEventSize
        });
      } else {
        dispatch({
          type: GET_TOUR_SUCCESS,
          tour: tour,
          tourEvents: tourEvents,
          featuredEvents: featuredEvents,
          totalEventSize: totalEventSize
        });
      }
    }).catch(function (err) {
      dispatch({ type: GET_TOUR_ERROR, error: err });
    });
  };
};
// CONCATENATED MODULE: ./state/reducers/tourReducer.js
var tourReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var tourReducer_initialState = {
  loading: false,
  tour: null,
  tourEvents: [],
  featuredEvents: [],
  eventLoading: false,
  tourDates: [],
  tourLocations: [],
  totalEventSize: 0,
  error: false
};
var tourReducer_parseTour = function parseTour(tour) {
  if (!tour) {
    return null;
  }
  // add theme
  var variables = {};
  var theme = tour.theme;

  if (!theme) {
    return tour;
  }

  if (theme.primaryColor) {
    variables["--primary-color"] = theme.primaryColor;
  }
  if (theme.primaryColorHover) {
    variables["--primary-color-hover"] = theme.primaryColorHover;
  }
  if (theme.primaryColorFade) {
    variables["--primary-color-fade"] = theme.primaryColorFade;
  }
  if (theme.primaryShadowColour) {
    variables["--primary-shadow-color"] = theme.primaryShadowColour;
  }
  if (theme.primaryTextColor) {
    variables["--primary-text-color"] = theme.primaryTextColor;
  }
  if (theme.linkColor || theme.primaryColor) {
    variables["--link-color"] = theme.linkColor ? theme.linkColor : theme.primaryColor;
  }
  if (theme.footerColor) {
    variables["--footer-color"] = theme.footerColor;
  }
  css_vars_ponyfill_esm({ variables: variables });
  return tour;
};

var constructInitTour = function constructInitTour(tour) {
  var defaults = {
    settings: {
      showName: true,
      pageLayout: "tiles",
      listViewType: "image",
      showPrice: true,
      namePlacement: "below"
    },
    groups: [],
    theme: {
      primaryColor: "#6621c0",
      ticketButtonText: "Get Tickets",
      background: {
        type: "color",
        image: {
          url: ""
        },
        color: "#fafafa"
      },
      sponsorBoxBackgroundColor: "#fff",
      titleBackgroundColor: "#fff",
      titleTextColor: "#323232",
      eventCardBackgroundColor: "#ffffff",
      cardAndBarOpacity: 100,
      type: "default"
    },
    bannerImage: {
      url: ""
    },
    events: [],
    featuredEvents: [],
    sponsorsLogos: []
  };
  if (!tour) {
    return null;
  }
  if (!tour.theme) {
    tour.theme = defaults.theme;
  }
  if (!tour.theme.background) {
    tour.theme.background = defaults.theme.background;
  }
  if (!tour.theme.background.image) {
    tour.theme.background.image = defaults.theme.background.image;
  }
  if (!tour.theme.ticketButtonText) {
    tour.theme.ticketButtonText = defaults.theme.ticketButtonText;
  }
  if (!tour.theme.titleBackgroundColor) {
    tour.theme.titleBackgroundColor = defaults.theme.titleBackgroundColor;
  }
  if (!tour.theme.titleTextColor) {
    tour.theme.titleTextColor = defaults.theme.titleTextColor;
  }
  if (!tour.bannerImage) {
    tour.bannerImage = defaults.bannerImage;
  }
  if (!tour.settings) {
    tour.settings = defaults.settings;
  }
  if (!tour.theme.eventCardBackgroundColor) {
    tour.theme.eventCardBackgroundColor = defaults.theme.eventCardBackgroundColor;
  }
  if (!tour.theme.cardAndBarOpacity) {
    tour.theme.cardAndBarOpacity = defaults.theme.cardAndBarOpacity;
  }
  if (!tour.theme.cardTitleColor) {
    tour.theme.cardTitleColor = tour.theme.type === "dark" || tour.theme.type === "funkyPlum" ? "#ffffff" : "#323232";
  }
  if (!tour.theme.cardTextColor) {
    tour.theme.cardTextColor = tour.theme.type === "dark" || tour.theme.type === "funkyPlum" ? "#ffffff" : "#323232";
  }
  return tour;
};

var tourReducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tourReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET_TOUR_REQUEST:
      return tourReducer__extends({}, state, {
        tour: null,
        tourEvents: [],
        featuredEvents: [],
        totalEventSize: 0,
        loading: true,
        error: false
      });
    case GET_TOUR_SUCCESS:
      return tourReducer__extends({}, state, {
        loading: false,
        tour: tourReducer_parseTour(constructInitTour(action.tour, state.tour)),
        tourEvents: action.tourEvents,
        featuredEvents: action.featuredEvents,
        totalEventSize: action.totalEventSize
      });
    case GET_TOUR_ERROR:
      return tourReducer__extends({}, state, {
        loading: false,
        error: action.error
      });
    case GET_TOUR_OPTIONS_REQUEST:
      return tourReducer__extends({}, state, {
        tourLocations: [],
        tourDates: []
      });
    case GET_TOUR_OPTIONS_SUCCESS:
      return tourReducer__extends({}, state, {
        tourLocations: action.tourLocations,
        tourDates: action.tourDates
      });
    case GET_TOUR_EVENTS_REQUEST:
      return tourReducer__extends({}, state, {
        eventLoading: true,
        tourEvents: [],
        featuredEvents: [],
        totalEventSize: 0
      });
    case GET_TOUR_EVENTS_SUCCESS:
      return tourReducer__extends({}, state, {
        eventLoading: false,
        tourEvents: action.tourEvents,
        featuredEvents: action.featuredEvents,
        totalEventSize: action.totalEventSize
      });
    default:
      return state;
  }
};
/* harmony default export */ var tourReducer = ({ initialState: tourReducer_initialState, reducer: tourReducer_reducer, constructInitTour: constructInitTour, parseTour: tourReducer_parseTour });
// CONCATENATED MODULE: ./services/AttendeeProfileService.js



var setParams = function setParams(token) {
  if (token) {
    return {
      params: {
        token: token
      }
    };
  } else {
    return {};
  }
};
var AttendeeProfileService = {
  check: function check(identifier) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(axios_default.a.get(Object(config["a" /* default */])("API_URL") + "attendee-profile/check/" + identifier)).then(function ($await_1) {
        try {
          response = $await_1;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  checkIfComplete: function checkIfComplete(orderId) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(axios_default.a.post(Object(config["a" /* default */])("API_URL") + "attendee-profile/order/" + orderId + "/determine-complete-order")).then(function ($await_2) {
        try {
          response = $await_2;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  createAndAssign: function createAndAssign(ticketId, profileData, token) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(axios_default.a.post(Object(config["a" /* default */])("API_URL") + "attendee-profile/" + ticketId, profileData, setParams(token))).then(function ($await_3) {
        try {
          response = $await_3;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  assign: function assign(ticketId, profileId, token) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(axios_default.a.post(Object(config["a" /* default */])("API_URL") + "attendee-profile/" + ticketId + "/" + profileId, {}, setParams(token))).then(function ($await_4) {
        try {
          response = $await_4;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  getAssignedProfiles: function getAssignedProfiles(orderId, token) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(axios_default.a.get(Object(config["a" /* default */])("API_URL") + "attendee-profile/assigned/" + orderId, setParams(token))).then(function ($await_5) {
        try {
          response = $await_5;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  updateProfile: function updateProfile(orderId, attendeeProfileId, profile, token) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(axios_default.a.post(Object(config["a" /* default */])("API_URL") + "attendee-profile/update/" + orderId + "/" + attendeeProfileId, profile, setParams(token))).then(function ($await_6) {
        try {
          response = $await_6;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  unAssignTicket: function unAssignTicket(ticketId, token) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(axios_default.a.post(Object(config["a" /* default */])("API_URL") + "attendee-profile/ticket/un-assign/" + ticketId, {}, setParams(token))).then(function ($await_7) {
        try {
          response = $await_7;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  updateAssignedAdditionalQuestions: function updateAssignedAdditionalQuestions(ticketId, additionalQuestions, token) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(axios_default.a.post(Object(config["a" /* default */])("API_URL") + "attendee-profile/ticket/additionalQuestions/" + ticketId, additionalQuestions, setParams(token))).then(function ($await_8) {
        try {
          response = $await_8;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  getAttendeeData: function getAttendeeData(orderId, eventId, attendeeProfileId, token) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(axios_default.a.get(Object(config["a" /* default */])("API_URL") + "public/edit-ticket/order/" + orderId + "/" + eventId + "/" + attendeeProfileId + "/" + token)).then(function ($await_9) {
        try {
          response = $await_9;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  updateAttendeeProfilePublic: function updateAttendeeProfilePublic(routeParams, profileData) {
    return new Promise(function ($return, $error) {
      var orderId, eventId, attendeeProfileId, token, response;
      orderId = routeParams.orderId, eventId = routeParams.eventId, attendeeProfileId = routeParams.attendeeProfileId, token = routeParams.token;
      return Promise.resolve(axios_default.a.post(Object(config["a" /* default */])("API_URL") + "public/edit-ticket/order/" + orderId + "/" + eventId + "/" + attendeeProfileId + "/" + token, profileData)).then(function ($await_10) {
        try {
          response = $await_10;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  updateAdditionalQuestionPublic: function updateAdditionalQuestionPublic(routeParams, tickets) {
    return new Promise(function ($return, $error) {
      var orderId, eventId, attendeeProfileId, token, response;
      orderId = routeParams.orderId, eventId = routeParams.eventId, attendeeProfileId = routeParams.attendeeProfileId, token = routeParams.token;
      return Promise.resolve(axios_default.a.post(Object(config["a" /* default */])("API_URL") + "public/edit-ticket/additional-question/" + orderId + "/" + eventId + "/" + attendeeProfileId + "/" + token, tickets)).then(function ($await_11) {
        try {
          response = $await_11;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
};

/* harmony default export */ var services_AttendeeProfileService = (AttendeeProfileService);
// CONCATENATED MODULE: ./state/actions/attendeeProfileActions.js




var CHECK_ATTENDEE_PROFILE_REQUEST = "CHECK_ATTENDEE_PROFILE_REQUEST";
var CHECK_ATTENDEE_PROFILE_ERROR = "CHECK_ATTENDEE_PROFILE_SUCCESS";
var CHECK_ATTENDEE_PROFILE_SUCCESS = "CHECK_ATTENDEE_PROFILE_ERROR";

var CREATE_ATTENDEE_PROFILE_REQUEST = "CREATE_ATTENDEE_PROFILE_REQUEST";
var CREATE_ATTENDEE_PROFILE_ERROR = "CREATE_ATTENDEE_PROFILE_ERROR";
var CREATE_ATTENDEE_PROFILE_SUCCESS = "CREATE_ATTENDEE_PROFILE_SUCCESS";

var ASSIGN_ATTENDEE_PROFILE_REQUEST = "ASSIGN_ATTENDEE_PROFILE_REQUEST";
var ASSIGN_ATTENDEE_PROFILE_ERROR = "ASSIGN_ATTENDEE_PROFILE_ERROR";
var ASSIGN_ATTENDEE_PROFILE_SUCCESS = "ASSIGN_ATTENDEE_PROFILE_SUCCESS";

var ADD_EXISTING_ATTENDEE = "ADD_EXISTING_ATTENDEE";
var CLEAR_EXISTING_ATTENDEE = "CLEAR_EXISTING_ATTENDEE";

var OPEN_ATTENDEE_MODAL = "OPEN_ATTENDEE_MODAL";
var CLOSE_ATTENDEE_MODAL = "CLOSE_ATTENDEE_MODAL";

var GET_ASSIGNED_PROFILES_REQUEST = "GET_ASSIGNED_PROFILES_REQUEST";
var GET_ASSIGNED_PROFILES_SUCCESS = "GET_ASSIGNED_PROFILES_SUCCESS";
var GET_ASSIGNED_PROFILES_ERROR = "GET_ASSIGNED_PROFILES_ERROR";

var UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST";
var UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
var UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR";

var UNASSIGN_TICKET_REQUEST = "UNASSIGN_TICKET_REQUEST";
var UNASSIGN_TICKET_SUCCESS = "UNASSIGN_TICKET_SUCCESS";
var UNASSIGN_TICKET_ERROR = "UNASSIGN_TICKET_ERROR";

var GET_ATTENDEE_PROFILE_REQUEST = "GET_ATTENDEE_PROFILE_REQUEST";
var GET_ATTENDEE_PROFILE_SUCCESS = "GET_ATTENDEE_PROFILE_SUCCESS";
var GET_ATTENDEE_PROFILE_ERROR = "GET_ATTENDEE_PROFILE_ERROR";

var UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_REQUEST = "UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_REQUEST";
var UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_SUCCESS = "UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_SUCCESS";
var UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_ERROR = "UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_ERROR";

var UPDATE_ADDITIONAL_QUESTIONS_REQUEST = "UPDATE_ADDITIONAL_QUESTIONS_REQUEST";
var UPDATE_ADDITIONAL_QUESTIONS_SUCCESS = "UPDATE_ADDITIONAL_QUESTIONS_SUCCESS";
var UPDATE_ADDITIONAL_QUESTIONS_ERROR = "UPDATE_ADDITIONAL_QUESTIONS_ERROR";

var OPEN_ADDITIONAL_QUESTIONS = "OPEN_ADDITIONAL_QUESTIONS";
var CLOSE_ADDITIONAL_QUESTIONS = "CLOSE_ADDITIONAL_QUESTIONS";

var CHECK_ORDER_COMPLETE_REQUEST = "CHECK_ORDER_COMPLETE_REQUEST";
var CHECK_ORDER_COMPLETE_SUCCESS = "CHECK_ORDER_COMPLETE_SUCCESS";
var CHECK_ORDER_COMPLETE_ERROR = "CHECK_ORDER_COMPLETE_ERROR";

var SET_TOKEN = "SET_TOKEN";

var getToken = function getToken(getState) {
  var state = getState();
  return state.attendeeProfile.token;
};

var createIdentifier = function createIdentifier(profileData) {
  var normalisedFirstName = String(profileData.firstName).toLowerCase().trim();
  var normalisedLastName = String(profileData.lastName).toLowerCase().trim();
  var normalisedEmail = String(profileData.email).toLowerCase().trim();
  return "" + normalisedFirstName + normalisedLastName + normalisedEmail;
};

var attendeeProfileActions_loadAttendeeProfileData = function loadAttendeeProfileData(orderId, eventId, attendeeProfileId, token) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var _ref, tickets, attendeeProfile, event;

      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (err) {
        try {
          dispatch({ type: GET_ATTENDEE_PROFILE_ERROR, error: err });
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: GET_ATTENDEE_PROFILE_REQUEST });
        return Promise.resolve(services_AttendeeProfileService.getAttendeeData(orderId, eventId, attendeeProfileId, token)).then(function ($await_13) {
          try {
            _ref = $await_13, tickets = _ref.tickets, attendeeProfile = _ref.attendeeProfile, event = _ref.event;

            dispatch({
              type: GET_ATTENDEE_PROFILE_SUCCESS,
              profile: attendeeProfile
            });
            dispatch({ type: eventActions["j" /* GET_EVENT_SUCCESS */], event: event });
            dispatch({ type: orderActions["u" /* GET_ORDER_SUCCESS */], order: { tickets: tickets } });
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (err) {
        $Try_1_Catch(err)
      }
    });
  };
};

var attendeeProfileActions_updateAttendeeProfilePublic = function updateAttendeeProfilePublic(routeParams, profileData) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var profile;
      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_2_Catch = function (err) {
        try {
          dispatch({ type: UPDATE_PROFILE_ERROR, error: err });
          return $Try_2_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: UPDATE_PROFILE_REQUEST });
        return Promise.resolve(services_AttendeeProfileService.updateAttendeeProfilePublic(routeParams, profileData)).then(function ($await_14) {
          try {
            profile = $await_14;
            dispatch({ type: GET_ATTENDEE_PROFILE_SUCCESS, profile: profile });
            dispatch({ type: UPDATE_PROFILE_SUCCESS });
            return $Try_2_Post();
          } catch ($boundEx) {
            return $Try_2_Catch($boundEx);
          }
        }, $Try_2_Catch);
      } catch (err) {
        $Try_2_Catch(err)
      }
    });
  };
};

var attendeeProfileActions_updateAdditionalQuestionPublic = function updateAdditionalQuestionPublic(routeParams, tickets) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var updatedTickets;
      var $Try_3_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_3_Catch = function (err) {
        try {
          dispatch({ type: UPDATE_ADDITIONAL_QUESTIONS_ERROR, error: err });
          return $Try_3_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: UPDATE_ADDITIONAL_QUESTIONS_REQUEST });
        return Promise.resolve(services_AttendeeProfileService.updateAdditionalQuestionPublic(routeParams, tickets)).then(function ($await_15) {
          try {
            updatedTickets = $await_15;
            dispatch({ type: orderActions["u" /* GET_ORDER_SUCCESS */], order: { tickets: updatedTickets } });
            dispatch({ type: UPDATE_ADDITIONAL_QUESTIONS_SUCCESS });
            return $Try_3_Post();
          } catch ($boundEx) {
            return $Try_3_Catch($boundEx);
          }
        }, $Try_3_Catch);
      } catch (err) {
        $Try_3_Catch(err)
      }
    });
  };
};

var attendeeProfileActions_finishAssigning = function finishAssigning(eventSlug, event, order, requiresSeatingReservation) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var updatedOrder;
      var $Try_4_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_4_Catch = function (err) {
        try {
          dispatch({ type: CHECK_ORDER_COMPLETE_ERROR, error: err });
          return $Try_4_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: CHECK_ORDER_COMPLETE_REQUEST });
        return Promise.resolve(services_AttendeeProfileService.checkIfComplete(order._id)).then(function ($await_16) {
          try {
            updatedOrder = $await_16;
            dispatch({ type: CHECK_ORDER_COMPLETE_SUCCESS });
            if (updatedOrder.status !== "complete") {
              // the order is not complete payment is needed
              preact_router_es["Router"].route("/" + eventSlug + "/payment/" + order._id);
            } else {
              Object(orderActions["S" /* orderComplete */])(eventSlug, event, updatedOrder, requiresSeatingReservation, false)(dispatch);
            }
            return $Try_4_Post();
          } catch ($boundEx) {
            return $Try_4_Catch($boundEx);
          }
        }, $Try_4_Catch);
      } catch (err) {
        $Try_4_Catch(err)
      }
    });
  };
};

var setToken = function setToken(token) {
  return function (dispatch) {
    dispatch({ type: SET_TOKEN, token: token });
  };
};

var attendeeProfileActions_openAdditionalQuestions = function openAdditionalQuestions(ticketId) {
  return function (dispatch) {
    dispatch({ type: OPEN_ADDITIONAL_QUESTIONS, ticketId: ticketId });
  };
};

var attendeeProfileActions_closeAdditionalQuestions = function closeAdditionalQuestions(ticketId) {
  return function (dispatch) {
    dispatch({ type: CLOSE_ADDITIONAL_QUESTIONS, ticketId: ticketId });
  };
};

var attendeeProfileActions_updateAssignedAdditionalQuestions = function updateAssignedAdditionalQuestions(ticketId, additionalQuestionsObj) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var normalisedAdditionalQuestions, order;
      var $Try_5_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_5_Catch = function (err) {
        try {
          dispatch({
            type: UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_ERROR,
            error: err,
            ticketId: ticketId
          });
          return $Try_5_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        normalisedAdditionalQuestions = Object.keys(additionalQuestionsObj).map(function (key) {
          return {
            questionId: key,
            value: additionalQuestionsObj[key]
          };
        });
        dispatch({
          type: UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_REQUEST,
          ticketId: ticketId
        });
        return Promise.resolve(services_AttendeeProfileService.updateAssignedAdditionalQuestions(ticketId, normalisedAdditionalQuestions, getToken(getState))).then(function ($await_17) {
          try {
            order = $await_17;
            dispatch({
              type: UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_SUCCESS,
              ticketId: ticketId
            });
            dispatch({ type: orderActions["u" /* GET_ORDER_SUCCESS */], order: order });
            return $Try_5_Post();
          } catch ($boundEx) {
            return $Try_5_Catch($boundEx);
          }
        }, $Try_5_Catch);
      } catch (err) {
        $Try_5_Catch(err)
      }
    });
  };
};

var attendeeProfileActions_openModal = function openModal(defaultValues, ticketId) {
  var isNew = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return function (dispatch) {
    dispatch({ type: OPEN_ATTENDEE_MODAL, defaultValues: defaultValues, ticketId: ticketId, isNew: isNew });
  };
};

var attendeeProfileActions_closeModal = function closeModal() {
  return function (dispatch) {
    dispatch({ type: CLOSE_ATTENDEE_MODAL });
  };
};

var attendeeProfileActions_updateProfile = function updateProfile(orderId, attendeeProfileId, profile) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var profiles;
      var $Try_6_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_6_Catch = function (err) {
        try {
          dispatch({ type: UPDATE_PROFILE_ERROR, error: err });
          return $Try_6_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: UPDATE_PROFILE_REQUEST });
        return Promise.resolve(services_AttendeeProfileService.updateProfile(orderId, attendeeProfileId, profile, getToken(getState))).then(function ($await_18) {
          try {
            profiles = $await_18;
            if (profiles.error) {
              dispatch({ type: UPDATE_PROFILE_ERROR, error: profiles.message });
            } else {
              dispatch({ type: UPDATE_PROFILE_SUCCESS, profiles: profiles });
              attendeeProfileActions_closeModal()(dispatch);
            }
            return $Try_6_Post();
          } catch ($boundEx) {
            return $Try_6_Catch($boundEx);
          }
        }, $Try_6_Catch);
      } catch (err) {
        $Try_6_Catch(err)
      }
    });
  };
};

var attendeeProfileActions_getAssignedProfiles = function getAssignedProfiles(orderId) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var profiles;
      var $Try_7_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_7_Catch = function (err) {
        try {
          dispatch({ type: GET_ASSIGNED_PROFILES_ERROR, error: err });
          return $Try_7_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: GET_ASSIGNED_PROFILES_REQUEST });
        return Promise.resolve(services_AttendeeProfileService.getAssignedProfiles(orderId, getToken(getState))).then(function ($await_19) {
          try {
            profiles = $await_19;
            dispatch({ type: GET_ASSIGNED_PROFILES_SUCCESS, profiles: profiles });
            return $Try_7_Post();
          } catch ($boundEx) {
            return $Try_7_Catch($boundEx);
          }
        }, $Try_7_Catch);
      } catch (err) {
        $Try_7_Catch(err)
      }
    });
  };
};

var attendeeProfileActions_addExistingAttendee = function addExistingAttendee(ticketId, profile) {
  return function (dispatch, getState) {
    attendeeProfileActions_assignAttendee(ticketId, profile._id)(dispatch, getState);
    dispatch({ type: ADD_EXISTING_ATTENDEE, profile: profile });
  };
};

var attendeeProfileActions_checkForExistingAttendee = function checkForExistingAttendee(profile, ticketId) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var state, profiles, identifier, attendeeProfile, profileCheck;
      var $Try_8_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_8_Catch = function (err) {
        try {
          dispatch({ type: CHECK_ATTENDEE_PROFILE_ERROR, error: err });
          return $Try_8_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        state = getState();
        profiles = state.attendeeProfile.profiles;
        identifier = createIdentifier(profile);
        attendeeProfile = profiles.find(function (profile) {
          return profile.profileIdentifier === identifier;
        });
        if (attendeeProfile) {
          attendeeProfileActions_assignAttendee(ticketId, attendeeProfile._id)(dispatch, getState);
          attendeeProfileActions_closeModal()(dispatch);
          return $If_12.call(this);
        } else {
          dispatch({ type: CHECK_ATTENDEE_PROFILE_REQUEST });
          return Promise.resolve(services_AttendeeProfileService.check(identifier)).then(function ($await_20) {
            try {
              profileCheck = $await_20;
              dispatch({
                type: CHECK_ATTENDEE_PROFILE_SUCCESS,
                profile: profileCheck.profile,
                ticketId: ticketId
              });
              if (!profileCheck.profileFound) {
                attendeeProfileActions_createAndAssignAttendee(ticketId, profile)(dispatch, getState);
              } else {
                attendeeProfileActions_closeModal()(dispatch);
              }
              return $If_12.call(this);
            } catch ($boundEx) {
              return $Try_8_Catch($boundEx);
            }
          }.bind(this), $Try_8_Catch);
        }

        function $If_12() {
          return $Try_8_Post();
        }
      } catch (err) {
        $Try_8_Catch(err)
      }
    });
  };
};

var attendeeProfileActions_createAndAssignAttendee = function createAndAssignAttendee(ticketId, profileData) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _ref2, order, profile;

      var $Try_9_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_9_Catch = function (err) {
        try {
          dispatch({ type: CREATE_ATTENDEE_PROFILE_ERROR, error: err });
          return $Try_9_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: CREATE_ATTENDEE_PROFILE_REQUEST });
        return Promise.resolve(services_AttendeeProfileService.createAndAssign(ticketId, profileData, getToken(getState))).then(function ($await_21) {
          try {
            _ref2 = $await_21, order = _ref2.order, profile = _ref2.profile;

            dispatch({ type: CREATE_ATTENDEE_PROFILE_SUCCESS, order: order, profile: profile });
            dispatch({ type: orderActions["u" /* GET_ORDER_SUCCESS */], order: order });
            attendeeProfileActions_closeModal()(dispatch);
            return $Try_9_Post();
          } catch ($boundEx) {
            return $Try_9_Catch($boundEx);
          }
        }, $Try_9_Catch);
      } catch (err) {
        $Try_9_Catch(err)
      }
    });
  };
};

var attendeeProfileActions_unAssignTicket = function unAssignTicket(ticketId, closeModalAfter) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var order;
      var $Try_10_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_10_Catch = function (err) {
        try {
          dispatch({ type: UNASSIGN_TICKET_ERROR, error: err });
          return $Try_10_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: UNASSIGN_TICKET_REQUEST });
        return Promise.resolve(services_AttendeeProfileService.unAssignTicket(ticketId, getToken(getState))).then(function ($await_22) {
          try {
            order = $await_22;
            dispatch({ type: UNASSIGN_TICKET_SUCCESS, order: order, ticketId: ticketId });
            dispatch({ type: orderActions["u" /* GET_ORDER_SUCCESS */], order: order });
            if (closeModalAfter) {
              attendeeProfileActions_closeModal()(dispatch);
            }
            return $Try_10_Post();
          } catch ($boundEx) {
            return $Try_10_Catch($boundEx);
          }
        }, $Try_10_Catch);
      } catch (err) {
        $Try_10_Catch(err)
      }
    });
  };
};

var attendeeProfileActions_assignAttendee = function assignAttendee(ticketId, profileId) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var order;
      var $Try_11_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_11_Catch = function (err) {
        try {
          dispatch({ type: ASSIGN_ATTENDEE_PROFILE_ERROR, error: err });
          return $Try_11_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({ type: ASSIGN_ATTENDEE_PROFILE_REQUEST, ticketId: ticketId });
        return Promise.resolve(services_AttendeeProfileService.assign(ticketId, profileId, getToken(getState))).then(function ($await_23) {
          try {
            order = $await_23;
            dispatch({ type: ASSIGN_ATTENDEE_PROFILE_SUCCESS, order: order, ticketId: ticketId });
            dispatch({ type: orderActions["u" /* GET_ORDER_SUCCESS */], order: order });
            return $Try_11_Post();
          } catch ($boundEx) {
            return $Try_11_Catch($boundEx);
          }
        }, $Try_11_Catch);
      } catch (err) {
        $Try_11_Catch(err)
      }
    });
  };
};

var attendeeProfileActions_clearAttendee = function clearAttendee() {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      dispatch({ type: CLEAR_EXISTING_ATTENDEE });
      return $return();
    });
  };
};
// CONCATENATED MODULE: ./state/reducers/attendeeProfileReducer.js
var attendeeProfileReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var profileCheckDefault = {
  profile: false,
  complete: false,
  ticketId: false
};

var attendeeModalDefault = {
  show: false,
  defaultValues: {},
  ticketId: false,
  isNew: true
};

var assigningDefault = {
  loading: false,
  error: false,
  ticketId: false
};

var attendeeProfileReducer_additionalQuestionDefault = {
  loading: false,
  open: true,
  error: false
};

var attendeeProfileReducer_initialState = {
  loading: false,
  error: false,
  sent: false,
  token: false,
  profile: false,
  profiles: [],
  profileCheck: attendeeProfileReducer__extends({}, profileCheckDefault),
  attendeeModal: attendeeProfileReducer__extends({}, attendeeModalDefault),
  assigning: attendeeProfileReducer__extends({}, assigningDefault),
  additionalQuestionDefault: { default: attendeeProfileReducer__extends({}, attendeeProfileReducer_additionalQuestionDefault) }
};

var getTicketState = function getTicketState(state, ticketId) {
  var ticketState = state.additionalQuestionDefault[ticketId];
  if (!ticketState) {
    ticketState = attendeeProfileReducer__extends({}, attendeeProfileReducer_additionalQuestionDefault);
  }
  return ticketState;
};

var attendeeProfileReducer_reducer = function reducer() {
  var _extends8;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : attendeeProfileReducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case CHECK_ORDER_COMPLETE_REQUEST:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: true,
          error: false
        });
      }
    case CHECK_ORDER_COMPLETE_SUCCESS:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: false
        });
      }
    case CHECK_ORDER_COMPLETE_ERROR:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: false,
          error: action.error
        });
      }
    case SET_TOKEN:
      {
        return attendeeProfileReducer__extends({}, state, {
          token: action.token
        });
      }

    case UPDATE_ADDITIONAL_QUESTIONS_REQUEST:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: true,
          error: false
        });
      }
    case UPDATE_ADDITIONAL_QUESTIONS_SUCCESS:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: false
        });
      }
    case UPDATE_ADDITIONAL_QUESTIONS_ERROR:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: false,
          error: action.error
        });
      }
    case GET_ATTENDEE_PROFILE_REQUEST:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: true,
          error: false
        });
      }

    case GET_ATTENDEE_PROFILE_SUCCESS:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: false,
          profile: action.profile
        });
      }

    case GET_ATTENDEE_PROFILE_ERROR:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: false,
          error: action.error
        });
      }

    case OPEN_ADDITIONAL_QUESTIONS:
      {
        var _extends2;

        var ticketState = getTicketState(state, action.ticketId);
        return attendeeProfileReducer__extends({}, state, {
          additionalQuestionDefault: attendeeProfileReducer__extends({}, state.additionalQuestionDefault, (_extends2 = {}, _extends2[action.ticketId] = attendeeProfileReducer__extends({}, ticketState, {
            open: true
          }), _extends2))
        });
      }

    case CLOSE_ADDITIONAL_QUESTIONS:
      {
        var _extends3;

        var _ticketState = getTicketState(state, action.ticketId);
        return attendeeProfileReducer__extends({}, state, {
          additionalQuestionDefault: attendeeProfileReducer__extends({}, state.additionalQuestionDefault, (_extends3 = {}, _extends3[action.ticketId] = attendeeProfileReducer__extends({}, _ticketState, {
            open: false
          }), _extends3))
        });
      }

    case UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_REQUEST:
      {
        var _extends4;

        var _ticketState2 = getTicketState(state, action.ticketId);
        return attendeeProfileReducer__extends({}, state, {
          additionalQuestionDefault: attendeeProfileReducer__extends({}, state.additionalQuestionDefault, (_extends4 = {}, _extends4[action.ticketId] = attendeeProfileReducer__extends({}, _ticketState2, {
            loading: true,
            error: false
          }), _extends4))
        });
      }

    case UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_ERROR:
      {
        var _extends5;

        var _ticketState3 = getTicketState(state, action.ticketId);
        return attendeeProfileReducer__extends({}, state, {
          additionalQuestionDefault: attendeeProfileReducer__extends({}, state.additionalQuestionDefault, (_extends5 = {}, _extends5[action.ticketId] = attendeeProfileReducer__extends({}, _ticketState3, {
            loading: false,
            error: action.error
          }), _extends5))
        });
      }

    case UPDATE_ASSIGNED_ADDITIONAL_QUESTIONS_SUCCESS:
      {
        var _extends6;

        var _ticketState4 = getTicketState(state, action.ticketId);
        return attendeeProfileReducer__extends({}, state, {
          additionalQuestionDefault: attendeeProfileReducer__extends({}, state.additionalQuestionDefault, (_extends6 = {}, _extends6[action.ticketId] = attendeeProfileReducer__extends({}, _ticketState4, {
            loading: false,
            open: false
          }), _extends6))
        });
      }

    case UNASSIGN_TICKET_ERROR:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: false,
          error: action.error
        });
      }
    case UNASSIGN_TICKET_REQUEST:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: true,
          error: false
        });
      }
    case UNASSIGN_TICKET_SUCCESS:
      {
        var _extends7;

        return attendeeProfileReducer__extends({}, state, {
          loading: false,
          additionalQuestionDefault: attendeeProfileReducer__extends({}, state.additionalQuestionDefault, (_extends7 = {}, _extends7[action.ticketId] = {
            open: false
          }, _extends7))
        });
      }
    case UPDATE_PROFILE_REQUEST:
      return attendeeProfileReducer__extends({}, state, {
        loading: true,
        error: false
      });
    case UPDATE_PROFILE_SUCCESS:
      var profiles = action.profiles ? action.profiles : state.profiles;
      return attendeeProfileReducer__extends({}, state, {
        loading: false,
        profiles: profiles
      });
    case UPDATE_PROFILE_ERROR:
      return attendeeProfileReducer__extends({}, state, {
        error: action.error,
        loading: false
      });
    case CHECK_ATTENDEE_PROFILE_ERROR:
      return attendeeProfileReducer__extends({}, state, {
        error: action.error,
        profileCheck: attendeeProfileReducer__extends({}, profileCheckDefault)
      });
    case CHECK_ATTENDEE_PROFILE_REQUEST:
      return attendeeProfileReducer__extends({}, state, {
        loading: true,
        error: false,
        profileCheck: attendeeProfileReducer__extends({}, profileCheckDefault)
      });
    case CHECK_ATTENDEE_PROFILE_SUCCESS:
      return attendeeProfileReducer__extends({}, state, {
        loading: false,
        profileCheck: {
          profile: action.profile,
          complete: true,
          ticketId: action.ticketId
        }
      });
    case ADD_EXISTING_ATTENDEE:
      return attendeeProfileReducer__extends({}, state, {
        profiles: state.profiles.concat([action.profile]),
        profileCheck: attendeeProfileReducer__extends({}, profileCheckDefault)
      });
    case CREATE_ATTENDEE_PROFILE_REQUEST:
      return attendeeProfileReducer__extends({}, state, {
        loading: true,
        error: false
      });
    case CREATE_ATTENDEE_PROFILE_SUCCESS:
      return attendeeProfileReducer__extends({}, state, {
        loading: false,
        profiles: state.profiles.concat(action.profile)
      });
    case CREATE_ATTENDEE_PROFILE_ERROR:
      return attendeeProfileReducer__extends({}, state, {
        loading: false,
        error: action.error
      });
    case ASSIGN_ATTENDEE_PROFILE_REQUEST:
      return attendeeProfileReducer__extends({}, state, {
        assigning: {
          loading: true,
          error: false,
          ticketId: action.ticketId
        }
      });
    case ASSIGN_ATTENDEE_PROFILE_ERROR:
      return attendeeProfileReducer__extends({}, state, {
        assigning: {
          loading: false,
          error: action.error
        }
      });
    case ASSIGN_ATTENDEE_PROFILE_SUCCESS:
      return attendeeProfileReducer__extends({}, state, {
        assigning: attendeeProfileReducer__extends({}, assigningDefault),
        additionalQuestionDefault: attendeeProfileReducer__extends({}, state.additionalQuestionDefault, (_extends8 = {}, _extends8[action.ticketId] = attendeeProfileReducer__extends({}, attendeeProfileReducer_additionalQuestionDefault), _extends8))
      });
    case OPEN_ATTENDEE_MODAL:
      return attendeeProfileReducer__extends({}, state, {
        attendeeModal: {
          show: true,
          defaultValues: action.defaultValues,
          ticketId: action.ticketId,
          isNew: action.isNew
        }
      });
    case CLOSE_ATTENDEE_MODAL:
      return attendeeProfileReducer__extends({}, state, {
        attendeeModal: attendeeProfileReducer__extends({}, attendeeModalDefault)
      });
    case CLEAR_EXISTING_ATTENDEE:
      {
        return attendeeProfileReducer__extends({}, state, {
          profileCheck: attendeeProfileReducer__extends({}, profileCheckDefault)
        });
      }
    case GET_ASSIGNED_PROFILES_REQUEST:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: true,
          error: false
        });
      }
    case GET_ASSIGNED_PROFILES_SUCCESS:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: false,
          profiles: action.profiles
        });
      }
    case GET_ASSIGNED_PROFILES_ERROR:
      {
        return attendeeProfileReducer__extends({}, state, {
          loading: false,
          error: action.error
        });
      }
    default:
      return state;
  }
};
/* harmony default export */ var attendeeProfileReducer = ({ initialState: attendeeProfileReducer_initialState, reducer: attendeeProfileReducer_reducer });
// EXTERNAL MODULE: ../node_modules/redux-form/es/index.js + 233 modules
var redux_form_es = __webpack_require__("BQ2S");

// EXTERNAL MODULE: ./utils/Format.js
var Format = __webpack_require__("84la");

// CONCATENATED MODULE: ./state/store.js
var store__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



//reducers




















var store_reducer = Object(redux_es["c" /* combineReducers */])({
  contact: contactReducer.reducer,
  event: eventReducer.reducer,
  order: orderReducer.reducer,
  ticketSelection: ticketsReducer.reducer,
  orderSummary: orderSummaryReducer.reducer,
  payPal: payPalReducer.reducer,
  stripe: stripeReducer.reducer,
  zipMoney: zipMoneyReducer.reducer,
  seatingMap: seatingMapReducer.reducer,
  organiser: organiserReducer.reducer,
  eventDates: dateReducer.reducer,
  merchandise: merchandiseReducer.reducer,
  waitlist: waitlistReducer.reducer,
  tours: tourReducer.reducer,
  giftCards: giftCardReducer.reducer,
  attendeeProfile: attendeeProfileReducer.reducer,
  form: redux_form_es["e" /* reducer */]
});

var composeEnhancers = Object(config["a" /* default */])("DEV") === true && typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_es["d" /* compose */];

var store_create = function create(eventData, orderData, providedOrderData, eventDateIds, merchData, tourData, giftCardPageData) {
  var widget = eventData ? eventData.widget : false;
  if (typeof window !== "undefined") {
    var params = Object(Format["parseQueryString"])(location.search.replace("?", ""));
    widget = params.w ? true : false;
  }

  var eventId = null;
  var ticketData = null;
  var eventDate = null;

  if (eventData) {
    eventData = eventReducer.parseEvent(eventData);
    eventId = eventData._id;

    if (eventData.validDates && eventData.validDates.length) {
      // select first valid date
      if (eventDateIds) {
        // id a list of eventDateIds was passed select the first one
        var eventDateList = eventDateIds.split(",");
        eventDate = eventData.validDates.find(function (date) {
          if (eventDateList.indexOf(String(date._id)) !== -1) {
            return true;
          }
          return false;
        });
        if (!eventDate) {
          eventDate = eventData.validDates[0];
        }
      } else {
        eventDate = eventData.validDates[0];
      }
    }

    ticketData = ticketsReducer.eventReduce(eventData, ticketsReducer.initialState, eventDate);
  }

  if (orderData) {
    var tickets = !orderData.tickets ? [] : orderData.tickets.sort(function (a, b) {
      return a.ticketTypeName > b.ticketTypeName;
    });
    orderData = store__extends({}, orderData, {
      tickets: tickets
    });
    if (ticketData) {
      ticketData.tickets = ticketsReducer.ticketsFromOrder(orderData, ticketData.tickets);
      ticketData.clientDonation = orderData.clientDonation;
    }
  }

  var eventIntState = store__extends({}, eventReducer.initialState, {
    data: eventData,
    id: eventId,
    widget: widget
  });
  var orderIntState = store__extends({}, orderReducer.initialState, {
    data: orderData,
    providedOrderData: providedOrderData
  });
  var ticketSelectionIntState = store__extends({}, ticketsReducer.initialState, ticketData);

  var orderSummaryIntDate = store__extends({}, orderSummaryReducer.initialState, {
    eventDate: eventDate ? eventDate.display : null
  });

  var merchandiseIntState = store__extends({}, merchandiseReducer.initialState, {
    includesMerch: merchData && merchData.length > 0,
    merch: store__extends({}, merchandiseReducer.initialState.merch, {
      data: merchData,
      display: merchandiseReducer.createMerchDisplay(merchData ? merchData : [])
    })
  });

  var giftCardInitialState = store__extends({}, giftCardReducer.initialState);
  if (giftCardPageData) {
    giftCardReducer.setStyling(giftCardPageData.page);
    giftCardInitialState.giftCardPage = giftCardPageData.page;
    giftCardInitialState.giftCards = giftCardPageData.giftCards;
  }
  if (orderData && orderData.giftCards) {
    giftCardInitialState.giftCardsOrder = giftCardReducer.giftCardsFromOrder(orderData);
  }

  var tour = tourReducer.constructInitTour(tourData, tourReducer.initialState.tour);
  tour = tourReducer.parseTour(tour);
  var tourEvents = tour && tour.events ? tour.events : [];
  var featuredEvents = tour && tour.featuredEvents ? tour.featuredEvents : [];
  var totalEventSize = tour && tour.totalEventSize ? tour.totalEventSize : 0;
  var tourState = store__extends({}, tourReducer.initialState, {
    tour: tour,
    tourEvents: tourEvents,
    featuredEvents: featuredEvents,
    totalEventSize: totalEventSize
  });

  var store = Object(redux_es["e" /* createStore */])(store_reducer, {
    event: eventIntState,
    order: orderIntState,
    ticketSelection: ticketSelectionIntState,
    orderSummary: orderSummaryIntDate,
    merchandise: merchandiseIntState,
    tours: tourState,
    giftCards: giftCardInitialState
  }, composeEnhancers(Object(redux_es["a" /* applyMiddleware */])(lib_default.a)));
  return store;
};

/* harmony default export */ var state_store = (store_create);
// EXTERNAL MODULE: ../node_modules/query-string/index.js
var query_string = __webpack_require__("/Fvp");
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./components/DatesDisplay.js
var DatesDisplay = __webpack_require__("f0Ws");

// EXTERNAL MODULE: ./assets/images/icon-date.svg
var icon_date = __webpack_require__("tLgl");
var icon_date_default = /*#__PURE__*/__webpack_require__.n(icon_date);

// CONCATENATED MODULE: ./components/Dates.js






var Dates_Dates = function Dates(_ref) {
  var dates = _ref.dates,
      eventSlug = _ref.eventSlug,
      oldStyle = _ref.oldStyle;

  var style = Object(index_esm["css"])({
    marginBottom: 40,
    background: oldStyle ? "url(" + icon_date_default.a + ")" : "",
    backgroundSize: oldStyle ? "24px 24px" : "",
    backgroundRepeat: oldStyle ? "no-repeat" : "",
    backgroundPosition: oldStyle ? "left top" : "",
    paddingLeft: oldStyle ? 30 : "",
    "@media(max-width: 600px)": {
      background: "url(" + icon_date_default.a + ")",
      backgroundSize: "24px 24px",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "left top",
      paddingLeft: 30,
      marginBottom: 32
    }
  });
  if (!dates) {
    return "";
  }
  return Object(preact_min["h"])(
    "div",
    { className: style },
    Object(preact_min["h"])(
      "h3",
      { style: { marginBottom: 12, fontWeight: 600, paddingTop: 3 } },
      "Date and time"
    ),
    Object(preact_min["h"])(DatesDisplay["a" /* default */], { dates: dates, eventSlug: eventSlug })
  );
};
/* harmony default export */ var components_Dates = (Dates_Dates);
// EXTERNAL MODULE: ./components/EditEvent.js
var EditEvent = __webpack_require__("dYGj");

// CONCATENATED MODULE: ./components/Picture.js



var Picture_Picture = function Picture(_ref) {
  var img = _ref.img,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 1000 : _ref$width,
      alt = _ref.alt;

  var handle = "VbieTVjAQvq5BTkE9vIi";
  if (img) {
    handle = img.handle;
  }
  var cdn = "https://cdn.filestackcontent.com";
  return Object(preact_min["h"])(
    "picture",
    null,
    Object(preact_min["h"])("source", {
      srcset: cdn + "/quality=value:100/output=format:webp/resize=width:" + width + "/" + handle,
      type: "image/webp"
    }),
    Object(preact_min["h"])("source", {
      srcset: cdn + "/quality=value:100/output=format:png/resize=width:" + width + "/" + handle,
      type: "image/png"
    }),
    Object(preact_min["h"])("source", {
      srcset: cdn + "/quality=value:100/output=format:jpg/resize=width:" + width + "/" + handle,
      type: "image/jpg"
    }),
    Object(preact_min["h"])("img", {
      src: cdn + "/quality=value:100/output=compress:true,background:FFFFFF/resize=width:" + width + "/" + handle,
      alt: alt,
      width: width,
      srcset: cdn + "/quality=value:100/output=compress:true,background:FFFFFF/resize=width:" + width + "/" + handle + " 1x, " + cdn + "/quality=value:100/output=compress:true,background:FFFFFF/resize=width:" + width * 2 + "/" + handle + " 2x"
    })
  );
};
/* harmony default export */ var components_Picture = (Picture_Picture);
// CONCATENATED MODULE: ./components/EventCharity.js





var eventCharity = Object(index_esm["css"])({
  padding: 20,
  textAlign: "center",
  border: "1px solid #DEDEDE",
  borderRadius: 4,
  color: "#323232",
  textDecoration: "none",
  display: "block"
});

var supportingMsg = Object(index_esm["css"])({
  fontWeight: 600,
  fontSize: 14,
  borderBottom: "solid 2px #dedede",
  display: "inline-block",
  padding: "0 0 4px 0",
  margin: "0 0 4px 0"
});

var charityName = Object(index_esm["css"])({
  color: "#5a626c",
  marginBottom: 8,
  fontSize: 16,
  fontWeight: 600,
  textTransform: "upperCase"
});

var impactMsg = Object(index_esm["css"])({ marginBottom: 0, fontSize: 16 });

var roundImg = Object(index_esm["css"])({
  overflow: "hidden",
  borderRadius: 120,
  height: 120,
  width: 120
});

var imageWrapper = Object(index_esm["css"])({
  height: 120,
  margin: "0px auto",
  marginBottom: 16
});

var EventCharity__ref2 = Object(preact_min["h"])(
  "h3",
  { className: supportingMsg },
  "Your booking fee is supporting"
);

var EventCharity_EventCharity = function EventCharity(_ref) {
  var charity = _ref.charity;

  var impactString = charity.impactCreated ? charity.impactCreated : charity.oneLiner;
  return Object(preact_min["h"])(
    "a",
    { href: charity.website, className: eventCharity },
    Object(preact_min["h"])(
      "div",
      {
        className: Object(index_esm["css"])([imageWrapper, Object(index_esm["css"])({ width: charity.impactCreated ? 120 : 100 })])
      },
      charity.impactCreated ? Object(preact_min["h"])(
        "div",
        { className: roundImg },
        Object(preact_min["h"])(components_Picture, {
          alt: charity.name,
          img: charity.logo,
          width: 120,
          height: 120
        })
      ) : Object(preact_min["h"])(components_Picture, { alt: charity.name, img: charity.logo, width: 100 })
    ),
    EventCharity__ref2,
    Object(preact_min["h"])(
      "h2",
      { className: charityName },
      charity.name
    ),
    Object(preact_min["h"])(
      "p",
      { className: impactMsg },
      impactString
    )
  );
};
/* harmony default export */ var components_EventCharity = (EventCharity_EventCharity);
// EXTERNAL MODULE: ./components/Image.js
var Image = __webpack_require__("kL2R");

// CONCATENATED MODULE: ./components/EventError.js







var ic_plane = __webpack_require__("BJd1");
var ic_binoculars = __webpack_require__("Qq8P");

var notPublishedClouds = "notPublished/ic_clouds.svg";
var notFoundClouds = "notFound/ic_clouds.svg";

var styleImage = Object(index_esm["css"])({
  width: "137px",
  height: "165px",
  marginBottom: "8px"
});

var EventError__ref2 = Object(preact_min["h"])(
  "button",
  {
    "class": "btn btn-primary",
    "aria-label": "Search Events",
    "aria-hidden": true
  },
  "Search Events"
);

var EventError_EventError = function EventError(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? "notFound" : _ref$type;

  var websiteURL = Object(config["a" /* default */])("WEBSITE_URL");

  var clouds = null;
  var icon = null;
  var heading = null;
  var message = null;
  if (type === "notFound") {
    clouds = notFoundClouds;
    icon = ic_binoculars;
    heading = "Event not Found";
    message = "Check if your events URL is correct or continue exploring events";
  } else if (type === "noEvents") {
    clouds = notFoundClouds;
    icon = ic_binoculars;
    heading = "No Events Found";
    message = "";
  } else {
    clouds = notPublishedClouds;
    icon = ic_plane;
    heading = "This event is yet to launch";
    message = "Publish your event or contact your event organiser";
  }

  var styleDiv = {
    maxWidth: "800px",
    height: "454px",
    background: "url('../assets/pages/" + clouds + "') no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center 9%",
    textAlign: "center",
    backgroundColor: "#F7FAFF",
    paddingTop: "80px",
    margin: "0 auto"
  };

  if (type === "notFound") {
    styleDiv.maxWidth = "487px";
    styleDiv.padding = "80px 14px";
  }

  var styleHeading = {
    fontWeight: "700",
    marginBottom: "6px"
  };

  var styleMessage = {
    color: "#6F7782",
    fontWeight: "700",
    marginBottom: "20px"
  };

  return Object(preact_min["h"])(
    "div",
    { style: { backgroundColor: "#F7FAFF" } },
    Object(preact_min["h"])(
      "div",
      { style: styleDiv },
      Object(preact_min["h"])(Image["a" /* default */], { src: icon, className: styleImage, alt: "Error Image" }),
      Object(preact_min["h"])(
        "h2",
        { style: styleHeading },
        heading
      ),
      Object(preact_min["h"])(
        "h3",
        { style: styleMessage },
        message
      ),
      type !== "noEvents" ? Object(preact_min["h"])(
        "a",
        { href: websiteURL + "/search" },
        EventError__ref2
      ) : null
    )
  );
};
/* harmony default export */ var components_EventError = (EventError_EventError);
// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// CONCATENATED MODULE: ./utils/ObjectUtils.js
var checkObjNotEmpty = function checkObjNotEmpty(obj) {
  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (typeof obj[property] == "object") {
        return checkObjNotEmpty(obj[property]);
      }
      if (obj[property] !== "" && obj[property] !== false && property !== "_id") {
        return true;
      }
    }
  }
  return false;
};
// CONCATENATED MODULE: ./components/EventLinks.js






var EventLinks_EventLinks = function EventLinks(_ref) {
  var event = _ref.event;

  var links = [];

  if (event.accessibility) {
    links.push({
      label: "ACCESSIBILITY",
      path: "/" + event.slug + "/accessibility"
    });
  }

  var displayLink = checkObjNotEmpty(event.accessibility);

  if (!links.length || !displayLink) {
    return null;
  }

  return Object(preact_min["h"])(
    "div",
    { style: { marginBottom: 40, marginTop: 40 } },
    Object(preact_min["h"])(
      "h3",
      { style: { marginBottom: 16, fontWeight: 600 } },
      "Accessibility Information"
    ),
    links.map(function (link) {
      var linkStyle = {
        marginRight: 20,
        fontWeight: 600,
        color: "#196097"
      };
      if (link.icon) {
        linkStyle.padding = 2;
        linkStyle.paddingLeft = 26;
        linkStyle.background = "url(" + iconAccessibility + ") no-repeat";
        linkStyle.backgroundSize = 22;
      }
      return Object(preact_min["h"])(
        match["Link"],
        { style: linkStyle, href: link.path },
        link.label
      );
    })
  );
};
/* harmony default export */ var components_EventLinks = (EventLinks_EventLinks);
// EXTERNAL MODULE: ../node_modules/react-google-map/lib/index.js
var react_google_map_lib = __webpack_require__("OQY8");
var react_google_map_lib_default = /*#__PURE__*/__webpack_require__.n(react_google_map_lib);

// EXTERNAL MODULE: ../node_modules/react-google-maps-loader/node_modules/prop-types/index.js
var prop_types = __webpack_require__("loE9");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ../node_modules/little-loader/lib/little-loader.js
var little_loader = __webpack_require__("N+bu");
var little_loader_default = /*#__PURE__*/__webpack_require__.n(little_loader);

// EXTERNAL MODULE: ../node_modules/react-google-maps-loader/node_modules/query-string/index.js
var node_modules_query_string = __webpack_require__("aXgl");
var node_modules_query_string_default = /*#__PURE__*/__webpack_require__.n(node_modules_query_string);

// CONCATENATED MODULE: ../node_modules/react-google-maps-loader/es/loadGoogleMapsSdk/index.js



var GOOGLE_MAP_PLACES_API = "https://maps.googleapis.com/maps/api/js";
var NOT_LOADED = 0;
var LOADING = 1;
var LOADED = 2;

var queue = [];
var loadGoogleMapsSdk_state = NOT_LOADED;
var loadGoogleMapsSdk_googleMaps = null;
var loadGoogleMapsSdk_error = null;

function loadGoogleMapsSdk(params, callback) {
  if (typeof window !== "undefined") {
    window.gm_authFailure = function () {
      callback({ googleMaps: loadGoogleMapsSdk_googleMaps, error: "SDK Authentication Error" });
    };

    if (loadGoogleMapsSdk_state === LOADED) {
      callback({ googleMaps: loadGoogleMapsSdk_googleMaps, error: loadGoogleMapsSdk_error });
    } else if (loadGoogleMapsSdk_state === LOADING) {
      queue.push(callback);
    } else {
      if (!window.google) {
        window.google = undefined;
      }

      loadGoogleMapsSdk_state = LOADING;
      queue.push(callback);

      little_loader_default()(GOOGLE_MAP_PLACES_API + "?" + node_modules_query_string_default.a.stringify(params), function (err) {
        loadGoogleMapsSdk_state = LOADED;
        loadGoogleMapsSdk_error = err ? "Network Error" : null;
        loadGoogleMapsSdk_googleMaps = window.google ? window.google.maps : null;

        while (queue.length > 0) {
          queue.pop()({ googleMaps: loadGoogleMapsSdk_googleMaps, error: loadGoogleMapsSdk_error });
        }
      });
    }
  }
}

/* harmony default export */ var es_loadGoogleMapsSdk = (loadGoogleMapsSdk);
// CONCATENATED MODULE: ../node_modules/react-google-maps-loader/es/index.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}






var es_GoogleMapsLoader = function (_React$Component) {
  _inherits(GoogleMapsLoader, _React$Component);

  function GoogleMapsLoader() {
    _classCallCheck(this, GoogleMapsLoader);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this._isMounted = false;
    _this.state = {
      googleMaps: null,
      error: null
    };
    return _this;
  }

  GoogleMapsLoader.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._isMounted = true;
    var params = this.props.params;

    es_loadGoogleMapsSdk(params, function (_ref) {
      var googleMaps = _ref.googleMaps,
          error = _ref.error;
      return _this2._isMounted && _this2.setState({ googleMaps: googleMaps, error: error });
    });
  };

  GoogleMapsLoader.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
  };

  GoogleMapsLoader.prototype.render = function render() {
    var _state = this.state,
        googleMaps = _state.googleMaps,
        error = _state.error;
    var render = this.props.render;

    return render(googleMaps, error);
  };

  return GoogleMapsLoader;
}(preact_compat_es["default"].Component);

es_GoogleMapsLoader.propTypes =  false ? {
  params: PropTypes.shape({
    key: PropTypes.string.isRequired,
    libraries: PropTypes.string
  }).isRequired,
  render: PropTypes.func.isRequired
} : {};

/* harmony default export */ var react_google_maps_loader_es = (es_GoogleMapsLoader);
// EXTERNAL MODULE: ./assets/images/map-marker.svg
var map_marker = __webpack_require__("ldGe");
var map_marker_default = /*#__PURE__*/__webpack_require__.n(map_marker);

// CONCATENATED MODULE: ./components/Map.js
var Map__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/* global google */








var Map_wrapper = Object(index_esm["css"])({
  height: 84,
  margin: "12px 0 20px 0",
  "@media(max-width: 600px)": { marginLeft: -30 }
});

var Map_MapComp = function MapComp(_ref) {
  var googleMaps = _ref.googleMaps,
      markerPos = _ref.markerPos,
      zoom = _ref.zoom,
      center = _ref.center;

  var markers = markerPos ? [{
    icon: map_marker_default.a,
    position: markerPos
  }] : [];
  var options = {
    gestureHandling: "greedy",
    scrollwheel: false
  };

  return Object(preact_min["h"])(
    "div",
    { className: Map_wrapper },
    Object(preact_min["h"])(react_google_map_lib_default.a, {
      googleMaps: googleMaps,
      coordinates: markers,
      center: center,
      zoom: zoom,
      autoFitBounds: true,
      boundsOffset: 0.0005,
      options: options
    })
  );
};

var Map_Map = function Map(props) {
  var apiKey = Object(config["a" /* default */])("GOOGLE_API_KEY");
  return Object(preact_min["h"])(react_google_maps_loader_es, {
    params: {
      key: apiKey, // Define your api key here
      libraries: "places"
    },
    render: function render(googleMaps) {
      return googleMaps && Object(preact_min["h"])(Map_MapComp, Map__extends({}, props, { googleMaps: googleMaps }));
    }
  });
};
/* harmony default export */ var components_Map = (Map_Map);
// CONCATENATED MODULE: ./components/EventMap.js
var _templateObject = _taggedTemplateLiteralLoose(["\n    max-width: 280px;\n    height: 120px;\n    width: 100%;\n    border-radius: 4px;\n  "], ["\n    max-width: 280px;\n    height: 120px;\n    width: 100%;\n    border-radius: 4px;\n  "]);



function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }






var EventMap_styles = {
  img: Object(index_esm["css"])(_templateObject)
};

var EventMap_EventMap = function EventMap(_ref) {
  var location = _ref.location;

  var markerPos = location && location.latLng && location.latLng[0] ? {
    lat: location.latLng[0],
    lng: location.latLng[1]
  } : false;

  var showMap = markerPos && location.type === "address";
  var hasStaticMap = location.mapUrl;
  if (window && window.innerWidth < 700) {
    return null;
  }
  return Object(preact_min["h"])(
    "div",
    null,
    showMap && !hasStaticMap ? Object(preact_min["h"])(components_Map, { center: markerPos, markerPos: markerPos, zoom: 16 }) : null,
    showMap && hasStaticMap ? Object(preact_min["h"])(
      "a",
      {
        href: "https://www.google.com/maps/search/?api=1&query=" + location.latLng[0] + "," + location.latLng[1],
        target: "_blank"
      },
      Object(preact_min["h"])("img", {
        src: location.mapUrl,
        className: EventMap_styles.img,
        alt: "Event location map"
      })
    ) : null
  );
};
/* harmony default export */ var components_EventMap = (EventMap_EventMap);
// EXTERNAL MODULE: ./assets/images/icon-location.svg
var icon_location = __webpack_require__("zbw2");
var icon_location_default = /*#__PURE__*/__webpack_require__.n(icon_location);

// EXTERNAL MODULE: ./components/LocationStr.js
var LocationStr = __webpack_require__("VVKR");

// CONCATENATED MODULE: ./components/Directions.js

var Directions_Directions = function Directions(_ref) {
  var location = _ref.location;

  if (location && location.latLng && location.latLng.length && location.placeId) {
    return Object(preact_min["h"])(
      "a",
      {
        href: "https://www.google.com/maps/search/?api=1&query=" + location.latLng[0] + "," + location.latLng[0] + "&query_place_id=" + location.placeId
      },
      "Get directions"
    );
  }
  return null;
};
/* harmony default export */ var components_Directions = (Directions_Directions);
// CONCATENATED MODULE: ./components/Location.js








var Location_Location = function Location(_ref) {
  var _a;

  var location = _ref.location,
      oldStyle = _ref.oldStyle;

  var style = Object(index_esm["css"])({
    marginBottom: 40,
    background: oldStyle ? "url(" + icon_location_default.a + ")" : "",
    backgroundSize: oldStyle ? "24px 24px" : "",
    backgroundRepeat: oldStyle ? "no-repeat" : "",
    backgroundPosition: oldStyle ? "left top" : "",
    paddingLeft: oldStyle ? 30 : "",
    "@media(max-width: 600px)": {
      background: "url(" + icon_location_default.a + ")",
      backgroundSize: "24px 24px",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "left top",
      paddingLeft: 30,
      paddingBottom: 5,
      marginBottom: 24
    },
    p: {
      marginBottom: 4
    },
    a: (_a = {
      marginBottom: 12,
      display: "block",
      textDecoration: "underline",
      fontWeight: 600
    }, _a["textDecoration"] = "none", _a)
  });

  var title = location.type === "online" ? "Online Event" : "Location";
  return Object(preact_min["h"])(
    "div",
    { className: style },
    Object(preact_min["h"])(
      "h3",
      { style: { marginBottom: 12, fontWeight: 600, paddingTop: 3 } },
      title
    ),
    location.type === "online" ? location.instructions : Object(preact_min["h"])(LocationStr["a" /* default */], { location: location }),
    Object(preact_min["h"])(components_Directions, { location: location }),
    Object(preact_min["h"])(components_EventMap, { location: location })
  );
};
/* harmony default export */ var components_Location = (Location_Location);
// CONCATENATED MODULE: ./components/Slider.js




var Slider_wrapper = Object(index_esm["css"])({
  overflow: "hidden"
});

var slider = Object(index_esm["css"])({
  whiteSpace: "nowrap",
  display: "flex",
  overflowY: "hidden",
  overflowX: "scroll",
  width: "1px",
  minWidth: "100%",
  "-webkit-overflow-scrolling": "touch"
});

var Slider_Slider = function Slider(_ref) {
  var children = _ref.children;
  return Object(preact_min["h"])(
    "div",
    { className: Slider_wrapper },
    Object(preact_min["h"])(
      "div",
      { "class": slider },
      children
    )
  );
};

/* harmony default export */ var components_Slider = (Slider_Slider);
// EXTERNAL MODULE: ./components/Button.js
var components_Button = __webpack_require__("PabG");

// CONCATENATED MODULE: ./components/moreEvents/MoreEvents.js
var MoreEvents__templateObject = MoreEvents__taggedTemplateLiteralLoose(["\n    display: none;\n    @media (max-width: 600px) {\n      display: block;\n    }\n  "], ["\n    display: none;\n    @media (max-width: 600px) {\n      display: block;\n    }\n  "]),
    _templateObject2 = MoreEvents__taggedTemplateLiteralLoose(["\n    display: block;\n    @media (max-width: 600px) {\n      display: none;\n    }\n  "], ["\n    display: block;\n    @media (max-width: 600px) {\n      display: none;\n    }\n  "]),
    _templateObject3 = MoreEvents__taggedTemplateLiteralLoose(["\n    width: 100%;\n    padding: 72px 80px;\n    text-align: left;\n    background: #f9f9fa;\n    display: flex;\n    @media (max-width: 600px) {\n      padding: 40px 0px 40px 12px;\n      display: block;\n    }\n  "], ["\n    width: 100%;\n    padding: 72px 80px;\n    text-align: left;\n    background: #f9f9fa;\n    display: flex;\n    @media (max-width: 600px) {\n      padding: 40px 0px 40px 12px;\n      display: block;\n    }\n  "]),
    _templateObject4 = MoreEvents__taggedTemplateLiteralLoose(["\n    font-weight: 600;\n    margin-left: 10px;\n    margin-bottom: 8px !important;\n    color: #323232;\n    @media (max-width: 600px) {\n      font-size: 18px;\n    }\n  "], ["\n    font-weight: 600;\n    margin-left: 10px;\n    margin-bottom: 8px !important;\n    color: #323232;\n    @media (max-width: 600px) {\n      font-size: 18px;\n    }\n  "]),
    _templateObject5 = MoreEvents__taggedTemplateLiteralLoose(["\n    max-width: 1062px;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  "], ["\n    max-width: 1062px;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  "]),
    _templateObject6 = MoreEvents__taggedTemplateLiteralLoose(["\n    display: block;\n    float: left;\n    margin: 12px;\n    width: 100%;\n    text-align: left;\n    max-width: 330px;\n    background: #fff;\n    box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n    border-radius: 3px;\n    height: 340px;\n    position: relative;\n    @media (max-width: 600px) {\n      float: none;\n      max-width: 260px;\n      height: 308px;\n      display: inline-block;\n    }\n  "], ["\n    display: block;\n    float: left;\n    margin: 12px;\n    width: 100%;\n    text-align: left;\n    max-width: 330px;\n    background: #fff;\n    box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n    border-radius: 3px;\n    height: 340px;\n    position: relative;\n    @media (max-width: 600px) {\n      float: none;\n      max-width: 260px;\n      height: 308px;\n      display: inline-block;\n    }\n  "]),
    _templateObject7 = MoreEvents__taggedTemplateLiteralLoose(["\n    width: 96%;\n    margin: 16px 12px;\n    @media (max-width: 600px) {\n      width: 240px;\n    }\n  "], ["\n    width: 96%;\n    margin: 16px 12px;\n    @media (max-width: 600px) {\n      width: 240px;\n    }\n  "]),
    _templateObject8 = MoreEvents__taggedTemplateLiteralLoose(["\n    text-algin: left;\n    text-decoration: none !important;\n    color: #323232;\n    width: 100%;\n  "], ["\n    text-algin: left;\n    text-decoration: none !important;\n    color: #323232;\n    width: 100%;\n  "]),
    _templateObject9 = MoreEvents__taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-width: 100%;\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px;\n    height: auto;\n    max-height: 165px;\n    padding: 0;\n  "], ["\n    width: 100%;\n    max-width: 100%;\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px;\n    height: auto;\n    max-height: 165px;\n    padding: 0;\n  "]),
    _templateObject10 = MoreEvents__taggedTemplateLiteralLoose(["\n    color: #5a626c;\n    height: 50px;\n    font-size: 14px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "], ["\n    color: #5a626c;\n    height: 50px;\n    font-size: 14px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "]),
    _templateObject11 = MoreEvents__taggedTemplateLiteralLoose(["\n    margin-top: 12px;\n    margin-left: 10px;\n  "], ["\n    margin-top: 12px;\n    margin-left: 10px;\n  "]),
    _templateObject12 = MoreEvents__taggedTemplateLiteralLoose(["\n    height: 38px;\n    border-top: solid 3px #f9f9fa;\n    padding-top: 7px;\n    padding-left: 12px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n  "], ["\n    height: 38px;\n    border-top: solid 3px #f9f9fa;\n    padding-top: 7px;\n    padding-left: 12px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n  "]),
    _templateObject13 = MoreEvents__taggedTemplateLiteralLoose(["\n    font-size: 14px;\n    font-weight: 600;\n    color: #323232;\n  "], ["\n    font-size: 14px;\n    font-weight: 600;\n    color: #323232;\n  "]),
    _templateObject14 = MoreEvents__taggedTemplateLiteralLoose(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-weight: 600;\n    font-size: 18px !important;\n    color: #323232;\n    @media (max-width: 600px) {\n      margin-bottom: 8px;\n    }\n  "], ["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-weight: 600;\n    font-size: 18px !important;\n    color: #323232;\n    @media (max-width: 600px) {\n      margin-bottom: 8px;\n    }\n  "]);



function MoreEvents__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }







var maxDisplayItems = 3;
var MoreEvents_styles = {
  mobile: Object(index_esm["css"])(MoreEvents__templateObject),
  desktop: Object(index_esm["css"])(_templateObject2),
  wrapper: Object(index_esm["css"])(_templateObject3),
  title: Object(index_esm["css"])(_templateObject4),
  container: Object(index_esm["css"])(_templateObject5),
  card: Object(index_esm["css"])(_templateObject6),
  description: Object(index_esm["css"])(_templateObject7),
  eventButton: Object(index_esm["css"])(_templateObject8),
  img: Object(index_esm["css"])(_templateObject9),
  contents: Object(index_esm["css"])(_templateObject10),
  moreButton: Object(index_esm["css"])(_templateObject11),
  priceContainer: Object(index_esm["css"])(_templateObject12),
  priceText: Object(index_esm["css"])(_templateObject13),
  cardTitle: Object(index_esm["css"])(_templateObject14)
};

var MoreEvents__ref = Object(preact_min["h"])("br", null);

var MoreEvents_EventCard = function EventCard(props) {
  var eventUrl = props.eventUrl,
      imageUrl = props.imageUrl,
      ticketsPriceStr = props.ticketsPriceStr,
      item = props.item;


  return Object(preact_min["h"])(
    "div",
    { className: MoreEvents_styles.card, key: item._id },
    Object(preact_min["h"])(
      "a",
      { className: MoreEvents_styles.eventButton, href: eventUrl },
      Object(preact_min["h"])(Image["a" /* default */], { className: MoreEvents_styles.img, src: imageUrl, alt: "" + item.name }),
      Object(preact_min["h"])(
        "div",
        { className: MoreEvents_styles.description },
        Object(preact_min["h"])(
          "h3",
          { className: MoreEvents_styles.cardTitle },
          item.name
        ),
        Object(preact_min["h"])(
          "p",
          { className: MoreEvents_styles.contents },
          item.dates[0].display.date,
          ", ",
          item.dates[0].display.time,
          MoreEvents__ref,
          item.location.address
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: MoreEvents_styles.priceContainer },
        Object(preact_min["h"])(
          "p",
          { className: MoreEvents_styles.priceText },
          ticketsPriceStr
        )
      )
    )
  );
};

var MoreEvents_EventCardList = function EventCardList(props) {
  var moreEvents = props.moreEvents;


  return Object(preact_min["h"])(
    "div",
    null,
    moreEvents.map(function (item, index) {
      if (index < maxDisplayItems) {
        var eventUrl = Object(config["a" /* default */])("TICKETING_URL") + "/" + item.slug;
        var useOldBannerStyle = !item.bannerImage && item.featureImage ? true : false;

        var imageHandleOld = item.socialImage ? item.socialImage.url : item.featureImage ? item.featureImage.url : "VbieTVjAQvq5BTkE9vIi";

        var imageHandleNew = item.bannerImage ? item.bannerImage.url : "VbieTVjAQvq5BTkE9vIi";

        var imageUrl = "https://process.filestackapi.com/resize=h:165,w:330,fit:crop/" + (useOldBannerStyle ? imageHandleOld : imageHandleNew);
        var ticketsPriceStr = item.settings.ticketPriceRangeDisplay ? item.ticketsPriceStr : "";
        return Object(preact_min["h"])(MoreEvents_EventCard, {
          eventUrl: eventUrl,
          imageUrl: imageUrl,
          ticketsPriceStr: ticketsPriceStr,
          item: item
        });
      }
    })
  );
};

var MoreEvents__ref2 = Object(preact_min["h"])(
  components_Button["a" /* default */],
  {
    type: "secondary",
    "aria-label": "See more button",
    "aria-hidden": true,
    tabIndex: -1
  },
  "See more"
);

var MoreEvents_MoreEvents = function MoreEvents(props) {
  var event = props.event,
      _props$title = props.title,
      title = _props$title === undefined ? "More events from this organiser" : _props$title;

  var moreEvents = event && event.moreEvents ? event.moreEvents : [];
  moreEvents = moreEvents.filter(function (event) {
    return event.public === true;
  });
  if (moreEvents.length < 1) {
    return null;
  }

  return Object(preact_min["h"])(
    "div",
    { className: MoreEvents_styles.wrapper },
    Object(preact_min["h"])(
      "div",
      { className: MoreEvents_styles.container },
      Object(preact_min["h"])(
        "h2",
        { className: MoreEvents_styles.title },
        title
      ),
      Object(preact_min["h"])(
        "div",
        { className: MoreEvents_styles.mobile },
        Object(preact_min["h"])(
          components_Slider,
          null,
          Object(preact_min["h"])(MoreEvents_EventCardList, { moreEvents: moreEvents })
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: MoreEvents_styles.desktop },
        Object(preact_min["h"])(MoreEvents_EventCardList, { moreEvents: moreEvents })
      ),
      Object(preact_min["h"])("div", { style: { clear: "both" } }),
      moreEvents.length >= maxDisplayItems && Object(preact_min["h"])(
        "div",
        { style: { marginLeft: 10, marginTop: 12 } },
        Object(preact_min["h"])(
          "a",
          {
            href: Object(config["a" /* default */])("TICKETING_URL") + "/organisers/" + event.moreEvents[0].organiserId,
            "aria-label": "See more button"
          },
          MoreEvents__ref2
        )
      )
    )
  );
};

/* harmony default export */ var moreEvents_MoreEvents = (MoreEvents_MoreEvents);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var node_modules_prop_types = __webpack_require__("5D9O");
var node_modules_prop_types_default = /*#__PURE__*/__webpack_require__.n(node_modules_prop_types);

// EXTERNAL MODULE: ../node_modules/@emotion/memoize/dist/memoize.esm.js
var memoize_esm = __webpack_require__("MvwA");

// CONCATENATED MODULE: ../node_modules/@emotion/is-prop-valid/dist/is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
var is_prop_valid_esm_index = Object(memoize_esm["a" /* default */])(reactPropsRegex.test.bind(reactPropsRegex));

/* harmony default export */ var is_prop_valid_esm = (is_prop_valid_esm_index);
// CONCATENATED MODULE: ../node_modules/create-emotion-styled/dist/index.esm.js



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var channel = '__EMOTION_THEMING__';

// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js

var _contextTypes;
var contextTypes = (_contextTypes = {}, _contextTypes[channel] = node_modules_prop_types_default.a.object, _contextTypes);

function setTheme(theme) {
  this.setState({
    theme: theme
  });
}
var testPickPropsOnStringTag = is_prop_valid_esm;
var testPickPropsOnComponent = function testPickPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};
var testAlwaysTrue = function testAlwaysTrue() {
  return true;
};
var pickAssign = function pickAssign(testFn, target) {
  var i = 2;
  var length = arguments.length;

  for (; i < length; i++) {
    var source = arguments[i];

    var _key = void 0;

    for (_key in source) {
      if (testFn(_key)) {
        target[_key] = source[_key];
      }
    }
  }

  return target;
};

var warnedAboutExtractStatic = false;

function createEmotionStyled(emotion, view) {
  var _createStyled = function createStyled(tag, options) {
    if (false) {
      if (tag === undefined) {
        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
      }
    }

    var staticClassName;
    var identifierName;
    var stableClassName;
    var shouldForwardProp;

    if (options !== undefined) {
      staticClassName = options.e;
      identifierName = options.label;
      stableClassName = options.target;
      shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
        return tag.__emotion_forwardProp(propName) && // $FlowFixMe
        options.shouldForwardProp(propName);
      } : options.shouldForwardProp;
    }

    var isReal = tag.__emotion_real === tag;
    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;

    if (typeof shouldForwardProp !== 'function') {
      shouldForwardProp = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testPickPropsOnStringTag : testPickPropsOnComponent;
    }

    return function () {
      var args = arguments;
      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

      if (identifierName !== undefined) {
        styles.push("label:" + identifierName + ";");
      }

      if (staticClassName === undefined) {
        if (args[0] == null || args[0].raw === undefined) {
          styles.push.apply(styles, args);
        } else {
          styles.push(args[0][0]);
          var len = args.length;
          var i = 1;

          for (; i < len; i++) {
            styles.push(args[i], args[0][i]);
          }
        }
      } else if (false) {
        console.warn('extractStatic is deprecated and will be removed in emotion@10. We recommend disabling extractStatic or using other libraries like linaria or css-literal-loader');
        warnedAboutExtractStatic = true;
      }

      var Styled =
      /*#__PURE__*/
      function (_view$Component) {
        _inheritsLoose(Styled, _view$Component);

        function Styled() {
          return _view$Component.apply(this, arguments) || this;
        }

        var _proto = Styled.prototype;

        _proto.componentWillMount = function componentWillMount() {
          if (this.context[channel] !== undefined) {
            this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
          }
        };

        _proto.componentWillUnmount = function componentWillUnmount() {
          if (this.unsubscribe !== undefined) {
            this.context[channel].unsubscribe(this.unsubscribe);
          }
        };

        _proto.render = function render() {
          var props = this.props,
              state = this.state;
          this.mergedProps = pickAssign(testAlwaysTrue, {}, props, {
            theme: state !== null && state.theme || props.theme || {}
          });
          var className = '';
          var classInterpolations = [];

          if (props.className) {
            if (staticClassName === undefined) {
              className += emotion.getRegisteredStyles(classInterpolations, props.className);
            } else {
              className += props.className + " ";
            }
          }

          if (staticClassName === undefined) {
            className += emotion.css.apply(this, styles.concat(classInterpolations));
          } else {
            className += staticClassName;
          }

          if (stableClassName !== undefined) {
            className += " " + stableClassName;
          }

          return view.createElement(baseTag, // $FlowFixMe
          pickAssign(shouldForwardProp, {}, props, {
            className: className,
            ref: props.innerRef
          }));
        };

        return Styled;
      }(view.Component);

      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";

      if (tag.defaultProps !== undefined) {
        // $FlowFixMe
        Styled.defaultProps = tag.defaultProps;
      }

      Styled.contextTypes = contextTypes;
      Styled.__emotion_styles = styles;
      Styled.__emotion_base = baseTag;
      Styled.__emotion_real = Styled;
      Styled.__emotion_forwardProp = shouldForwardProp;
      Object.defineProperty(Styled, 'toString', {
        value: function value() {
          if (false) {
            return 'NO_COMPONENT_SELECTOR';
          } // $FlowFixMe


          return "." + stableClassName;
        }
      });

      Styled.withComponent = function (nextTag, nextOptions) {
        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
        pickAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, styles);
      };

      return Styled;
    };
  };

  if (false) {
    _createStyled = new Proxy(_createStyled, {
      get: function get(target, property) {
        switch (property) {
          // react-hot-loader tries to access this stuff
          case '__proto__':
          case 'name':
          case 'prototype':
          case 'displayName':
            {
              return target[property];
            }

          default:
            {
              throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
            }
        }
      }
    });
  }

  return _createStyled;
}

/* harmony default export */ var dist_index_esm = (createEmotionStyled);
// CONCATENATED MODULE: ../node_modules/preact-emotion/dist/index.esm.js





var index_esm_index = dist_index_esm(index_esm, preact_min_default.a);

/* harmony default export */ var preact_emotion_dist_index_esm = (index_esm_index);
// EXTERNAL MODULE: ../node_modules/color-contrast/dist/index.js
var color_contrast_dist = __webpack_require__("c7R4");
var color_contrast_dist_default = /*#__PURE__*/__webpack_require__.n(color_contrast_dist);

// CONCATENATED MODULE: ./components/OrganiserInfo.js







var OrganiserInfo_ContactLink = function ContactLink(_ref) {
  var event = _ref.event;

  return Object(preact_min["h"])(
    match["Link"],
    { href: "/" + event.slug + "/contact", style: { color: "#6621c0" } },
    "CONTACT ORGANISER"
  );
};

var OrganiserInfo_OrganiserLink = function OrganiserLink(_ref2) {
  var event = _ref2.event,
      linkSpans = _ref2.linkSpans;

  if (!event.organiserId) {
    return null;
  }
  return Object(preact_min["h"])(
    "span",
    { className: linkSpans, style: { marginLeft: 24 } },
    Object(preact_min["h"])(
      "a",
      { href: "/organisers/" + event.organiserId, style: { color: "#6621c0" } },
      "VIEW PROFILE"
    )
  );
};

var OrganiserInfo_OrganiserInfo = function OrganiserInfo(_ref3) {
  var _mediaMaxWidth;

  var event = _ref3.event,
      hideContactLink = _ref3.hideContactLink,
      hideLogo = _ref3.hideLogo;

  if (!event) {
    return null;
  }
  var primaryColor = event.theme && event.theme.primaryColor ? event.theme.primaryColor : "#6621c0";

  var outerWrapper = Object(index_esm["css"])({
    width: "100%",
    "@media(max-width: 600px)": {
      borderTop: "1px solid #DEDEDE"
    }
  });

  var colorCode = ["#323232", "#FFFFFF"];
  var primaryTextColor = "#323232";
  if (event.theme && event.theme.primaryColor) {
    colorCode.forEach(function (color) {
      if (color_contrast_dist_default()(primaryColor, color) >= 4.5) {
        primaryTextColor = color;
      }
    });
  }

  var wrapper = Object(index_esm["css"])({
    border: "1px solid #DEDEDE",
    borderRadius: 5,
    padding: 24,
    textAlign: "center",
    "@media(max-width: 700px)": {
      border: "none",
      paddingLeft: 0,
      paddingRight: 0
    }
  });

  var pictureStyle = Object(index_esm["css"])({
    width: 100,
    height: 100,
    display: "inline-block",
    marginBottom: 16,
    overflow: "hidden",
    borderRadius: "50%",
    "@media(max-width: 700px)": {
      marginBottom: 12,
      width: 80,
      height: 80
    }
  });

  var noPicture = Object(index_esm["css"])({
    backgroundColor: "" + primaryColor,
    fontSize: 26,
    borderRadius: 4,
    width: "100%",
    height: "100%",
    paddingTop: 30,
    "@media(max-width: 700px)": {
      fontSize: 18
    }
  });

  var eventDescription = Object(index_esm["css"])({
    margin: "0 auto",
    maxWidth: 500,
    fontSize: 14,
    "@media(max-width: 700px)": (_mediaMaxWidth = {
      textAlign: "left",
      maxWidth: "100%",
      overflowWrap: "break-word",
      wordBreak: "break-all"
    }, _mediaMaxWidth["wordBreak"] = "break-word", _mediaMaxWidth.hyphens = "auto", _mediaMaxWidth)
  });

  var infoLinks = Object(index_esm["css"])({
    paddingLeft: 8,
    marginBottom: 16,
    paddingRight: 8,
    "@media(max-width: 700px)": {
      fontSize: 14,
      marginBottom: 12,
      padding: 0
    }
  });

  var linkColor = event.theme && event.theme.linkColor ? event.theme.linkColor : "#6621c0";

  var linkSpans = Object(index_esm["css"])({
    a: {
      color: linkColor,
      fontWeight: 600
    },
    svg: {
      fill: linkColor
    }
  });

  var title = event.organiser ? "" + event.organiser.name : "Event organiser";
  var phone = event.customerContact.mobile ? Object(preact_min["h"])(
    "p",
    null,
    "Contact number:",
    " ",
    Object(preact_min["h"])(
      "a",
      { href: "tel:" + event.customerContact.mobile },
      event.customerContact.mobile
    )
  ) : null;
  var contactInfo = hideContactLink ? phone : Object(preact_min["h"])(OrganiserInfo_ContactLink, { event: event });

  //getting acronym from event organisers name if no picture supplied
  var organiserName = event.organiser ? event.organiser.name : false;
  var acronym = organiserName ? organiserName.split(/\s/).reduce(function (response, word) {
    return response += word.slice(0, 1);
  }, "") : false;

  var eventDescText = event.organiser && event.organiser.description ? event.organiser.description : null;

  var showReadMore = eventDescText && eventDescText.length > 290 ? true : false;
  eventDescText = showReadMore ? eventDescText.substring(0, 290) : eventDescText;
  var organiserLogo = event.organiser && event.organiser.logo ? event.organiser.logo : false;

  var showPicture = organiserLogo || organiserName ? true : false;

  return Object(preact_min["h"])(
    "div",
    { className: outerWrapper },
    Object(preact_min["h"])(
      "div",
      { className: wrapper },
      showPicture ? Object(preact_min["h"])(
        "div",
        { className: pictureStyle },
        organiserLogo ? Object(preact_min["h"])(components_Picture, {
          img: organiserLogo,
          alt: organiserName + " logo",
          width: 100
        }) : organiserName ? Object(preact_min["h"])(
          "div",
          { className: noPicture },
          Object(preact_min["h"])(
            "div",
            {
              style: { display: "inline-block", color: primaryTextColor }
            },
            acronym
          )
        ) : null
      ) : null,
      Object(preact_min["h"])(
        "h3",
        { id: "organiserInfoBox", style: { fontWeight: 600, marginBottom: 12 } },
        title
      ),
      Object(preact_min["h"])(
        "div",
        { className: infoLinks },
        Object(preact_min["h"])(
          "span",
          { className: linkSpans },
          contactInfo
        ),
        Object(preact_min["h"])(OrganiserInfo_OrganiserLink, { event: event, linkSpans: linkSpans })
      ),
      Object(preact_min["h"])(
        "p",
        { className: eventDescription },
        eventDescText,
        showReadMore ? Object(preact_min["h"])(
          "span",
          null,
          "... ",
          Object(preact_min["h"])(
            "a",
            { href: "/organisers/" + event.organiserId },
            "Read more"
          )
        ) : null
      )
    )
  );
};

/* harmony default export */ var components_OrganiserInfo = (OrganiserInfo_OrganiserInfo);
// CONCATENATED MODULE: ./components/RefundPolicy.js

var RefundPolicy_RefundPolicy = function RefundPolicy(_ref) {
  var event = _ref.event;

  var refundPolicy = event.refundPolicy && event.refundPolicy !== "" ? event.refundPolicy : false;
  refundPolicy = refundPolicy === "Custom" ? event.customRefundPolicy : refundPolicy;

  if (!refundPolicy) {
    return null;
  }
  return Object(preact_min["h"])(
    "div",
    { style: { marginTop: 40 } },
    Object(preact_min["h"])(
      "h3",
      { style: { fontWeight: 600 } },
      "Refund Policy"
    ),
    Object(preact_min["h"])(
      "p",
      null,
      refundPolicy
    )
  );
};

/* harmony default export */ var components_RefundPolicy = (RefundPolicy_RefundPolicy);
// CONCATENATED MODULE: ./components/RichTextDisplay.js


var RichTextDisplay_RichTextDisplay = function RichTextDisplay(_ref) {
  var html = _ref.html;

  return Object(preact_min["h"])("div", { "class": "rich-text", dangerouslySetInnerHTML: { __html: html } });
};
/* harmony default export */ var components_RichTextDisplay = (RichTextDisplay_RichTextDisplay);
// EXTERNAL MODULE: ./assets/icons/ic_facebook.svg
var ic_facebook = __webpack_require__("N+iG");
var ic_facebook_default = /*#__PURE__*/__webpack_require__.n(ic_facebook);

// EXTERNAL MODULE: ./assets/icons/ic_twitter.svg
var ic_twitter = __webpack_require__("qWpA");
var ic_twitter_default = /*#__PURE__*/__webpack_require__.n(ic_twitter);

// EXTERNAL MODULE: ./assets/images/ic_copy_link.svg
var ic_copy_link = __webpack_require__("5xRX");
var ic_copy_link_default = /*#__PURE__*/__webpack_require__.n(ic_copy_link);

// EXTERNAL MODULE: ./assets/icons/ic_linkedin.svg
var ic_linkedin = __webpack_require__("1BGf");
var ic_linkedin_default = /*#__PURE__*/__webpack_require__.n(ic_linkedin);

// EXTERNAL MODULE: ../node_modules/react-copy-to-clipboard/lib/index.js
var react_copy_to_clipboard_lib = __webpack_require__("y78Y");
var react_copy_to_clipboard_lib_default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard_lib);

// CONCATENATED MODULE: ./components/SharingLinks.js











var copyButton = Object(index_esm["css"])({
  width: 32,
  height: 32,
  padding: 0,
  backgroundImage: "url(" + ic_copy_link_default.a + ")",
  backgroundSize: "32px 32px",
  margin: "0px 4px",
  display: "inline-flex",
  "@media(max-width: 600px)": {
    margin: "0px 2px 0px 2px"
  }
});

var SharingLinks_Link = function Link(_ref) {
  var href = _ref.href,
      children = _ref.children,
      label = _ref.label;

  var style = Object(index_esm["css"])({
    display: "inline-block",
    height: 32,
    width: 32,
    padding: 0,
    margin: "0px 4px 0px 4px",
    "@media(max-width: 600px)": {
      margin: "0px 2px 0px 2px"
    }
  });
  var styleIcon = {
    width: 32,
    height: 32
  };

  return Object(preact_min["h"])(
    "a",
    {
      className: style,
      href: href,
      target: "_blank",
      "aria-label": label,
      rel: "noopener"
    },
    Object(preact_min["h"])(
      "div",
      { style: styleIcon },
      children
    )
  );
};

var SharingLinks__ref3 = Object(preact_min["h"])(Image["a" /* default */], { src: ic_facebook_default.a, alt: "facebook" });

var SharingLinks__ref4 = Object(preact_min["h"])(Image["a" /* default */], { src: ic_twitter_default.a, alt: "twitter" });

var SharingLinks__ref5 = Object(preact_min["h"])(Image["a" /* default */], { src: ic_linkedin_default.a, alt: "linkedIn" });

var SharingLinks__ref6 = Object(preact_min["h"])("button", {
  "aria-label": "Copy Button Link",
  "aria-hidden": true,
  className: copyButton
});

var SharingLinks_SharingLinks = function SharingLinks(_ref2) {
  var event = _ref2.event;

  var style = Object(index_esm["css"])("\n    margin: 36px 0;\n    position: relative;\n    @media(max-width: 760px){\n        margin: 24px 0 0 0;\n    }\n  ");
  var label = {
    display: "inline",
    padding: 0,
    lineHeight: 0,
    position: "absolute",
    top: "17px",
    left: 0,
    fontWeight: 600
  };
  var origin = Object(config["a" /* default */])("TICKETING_URL");
  var sharingUrl = origin + "/" + event.slug;
  var sharingName = "" + event.name;
  var sharingMsg = "" + event.name;
  sharingMsg = encodeURI(sharingMsg.substr(0, 255));
  var featureImageUrl = event && event.featureImage ? event.featureImage.url : null;
  var socialImageUrl = event && event.socialImage ? event.socialImage.url : null;
  var imageUrl = socialImageUrl ? socialImageUrl : featureImageUrl;
  return Object(preact_min["h"])(
    "div",
    { className: style },
    Object(preact_min["h"])(
      "p",
      { style: label },
      "Share event"
    ),
    Object(preact_min["h"])(
      "div",
      { style: { marginLeft: 101 } },
      Object(preact_min["h"])(
        SharingLinks_Link,
        {
          label: "Share on facebook",
          href: "https://facebook.com/sharer/sharer.php?u=" + sharingUrl
        },
        SharingLinks__ref3
      ),
      Object(preact_min["h"])(
        SharingLinks_Link,
        {
          label: "Share on Twitter",
          href: "https://twitter.com/intent/tweet/?text=" + sharingMsg + "&url=" + sharingUrl
        },
        SharingLinks__ref4
      ),
      Object(preact_min["h"])(
        SharingLinks_Link,
        {
          label: "Share on Linked In",
          href: "https://www.linkedin.com/shareArticle?mini=true&url=" + sharingUrl
        },
        SharingLinks__ref5
      ),
      Object(preact_min["h"])(
        react_copy_to_clipboard_lib["CopyToClipboard"],
        { text: sharingUrl },
        SharingLinks__ref6
      )
    )
  );
};
/* harmony default export */ var components_SharingLinks = (SharingLinks_SharingLinks);
// CONCATENATED MODULE: ./components/PriceRangeDisplay.js
var PriceRangeDisplay__css;






var feesStr = Object(index_esm["css"])((PriceRangeDisplay__css = {
  color: "#5A626C",
  fontSize: 11,
  fontWeight: "normal",
  display: "inline-block",
  marginBottom: 0
}, PriceRangeDisplay__css[Object(CssUtils["c" /* max */])(700)] = {
  display: "block"
}, PriceRangeDisplay__css));

var PriceRangeDisplay_PriceRangeDisplay = function PriceRangeDisplay(_ref) {
  var event = _ref.event;

  var ticketsPriceStr = event.settings.ticketPriceRangeDisplay ? event.ticketsPriceStr.replace("From ", "").replace("To", "-") : "";

  var priceParts = ticketsPriceStr.split("+");
  var ticketsPriceRange = priceParts[0];
  var feesList = priceParts.splice(1).map(function (fee) {
    return "+" + fee;
  });
  return Object(preact_min["h"])(
    "div",
    null,
    ticketsPriceRange,
    Object(preact_min["h"])(
      "p",
      { className: feesStr },
      feesList
    )
  );
};

/* harmony default export */ var components_PriceRangeDisplay = (PriceRangeDisplay_PriceRangeDisplay);
// EXTERNAL MODULE: ./components/ActionButton.js
var ActionButton = __webpack_require__("UxTy");

// CONCATENATED MODULE: ./components/TicketsBar.js


function TicketsBar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TicketsBar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TicketsBar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var buttonStyling = Object(index_esm["css"])({
  height: "40px !important",
  minWidth: 150,
  fontWeight: "600 !important"
});

var TicketsBar_EventBtn = function EventBtn(_ref) {
  var ticketButtonText = _ref.ticketButtonText,
      disabled = _ref.disabled;
  return Object(preact_min["h"])(
    ActionButton["a" /* default */],
    {
      disabled: disabled,
      dataCY: "GetTickets",
      "aria-hidden": true,
      tabIndex: -1,
      classNames: buttonStyling
    },
    ticketButtonText
  );
};

var TicketsBar_EventLink = function EventLink(_ref2) {
  var event = _ref2.event,
      eventSlug = _ref2.eventSlug,
      theme = _ref2.theme,
      hasValidDates = _ref2.hasValidDates,
      accessCode = _ref2.accessCode,
      discountCode = _ref2.discountCode;

  var extraParameters = [];
  if (accessCode) {
    extraParameters.push("accesscode=" + encodeURIComponent(accessCode));
  }
  if (discountCode) {
    extraParameters.push("discountcode=" + encodeURIComponent(discountCode));
  }
  var isBrowser = typeof window !== "undefined";
  if (isBrowser && window.fb_oea) {
    extraParameters.push("fb_oea=" + encodeURIComponent(window.fb_oea));
  }

  var ticketsLink = extraParameters.length > 0 ? "/" + eventSlug + "/tickets?" + extraParameters.join("&") : "/" + eventSlug + "/tickets";

  var ticketButtonText = theme && theme.ticketButtonText ? theme.ticketButtonText : "Get Tickets";

  var waitlistEnabled = hasValidDates && !event.suspendSales && event.waitlistSettings ? event.waitlistSettings.enabled : false;

  ticketButtonText = event.soldOut && waitlistEnabled ? "Join waitlist" : ticketButtonText;

  var disabled = !hasValidDates || event.suspendSales || event.soldOut && !waitlistEnabled;

  if (disabled) {
    return Object(preact_min["h"])(TicketsBar_EventBtn, { ticketButtonText: ticketButtonText, disabled: disabled });
  }

  return Object(preact_min["h"])(
    match["Link"],
    {
      href: ticketsLink,
      style: {
        maxWidth: 268,
        width: "100%"
      },
      "aria-label": ticketButtonText
    },
    Object(preact_min["h"])(TicketsBar_EventBtn, { ticketButtonText: ticketButtonText })
  );
};

var TicketsBar_SalesWarning = function SalesWarning(_ref3) {
  var event = _ref3.event,
      hasValidDates = _ref3.hasValidDates;

  var eventWarningMessage = !hasValidDates ? "This event has passed" : false;
  eventWarningMessage = event.suspendSales ? "Ticket sales have ended" : eventWarningMessage;
  eventWarningMessage = event.soldOut ? "Sold Out" : eventWarningMessage;

  if (!eventWarningMessage) {
    return null;
  }
  var eventWarningMessageColor = event.soldOut ? "#dd1c60" : "inherit";
  return Object(preact_min["h"])(
    "div",
    {
      style: {
        color: eventWarningMessageColor,
        marginRight: 12,
        marginTop: 6
      }
    },
    eventWarningMessage
  );
};

var TicketsBar_TicketsBar = function (_Component) {
  TicketsBar__inherits(TicketsBar, _Component);

  function TicketsBar() {
    TicketsBar__classCallCheck(this, TicketsBar);

    var _this = TicketsBar__possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      showPriceStr: true,
      displayString: false
    };
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  TicketsBar.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  };

  TicketsBar.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  };

  TicketsBar.prototype.handleScroll = function handleScroll() {
    var isBrowser = typeof window !== "undefined";
    if (isBrowser && window.pageYOffset > 400) {
      this.setState({ displayString: true });
    } else {
      this.setState({ displayString: false });
    }
  };

  TicketsBar.prototype.render = function render() {
    var _mediaMaxWidth, _css;

    var _props = this.props,
        event = _props.event,
        eventSlug = _props.eventSlug,
        theme = _props.theme,
        accessCode = _props.accessCode,
        discountCode = _props.discountCode;
    var displayString = this.state.displayString;

    var wrapper = Object(index_esm["css"])((_css = {
      padding: "10px 14px",
      borderRadius: "0 0 2px 2px",
      width: "100%",
      maxWidth: "100vw",
      top: "-1px",
      zIndex: 10000,
      boxShadow: "0 1px 3px 0 rgba(9,30,66,0.13), 0 0 1px 0 #F1F1F1",
      position: "-webkit-sticky"
    }, _css["position"] = "sticky", _css.background = "#f9f9f9", _css["@media(min-width: 1015px)"] = {
      "& button": {
        width: 250
      }
    }, _css["@media(max-width: 700px)"] = (_mediaMaxWidth = {
      top: "initial",
      bottom: 0,
      position: "fixed !important",
      padding: "10px 12px",
      paddingBottom: "6px",
      background: "#fafafa",
      borderRadius: "0 0 2px 2px",
      width: "100%",
      zIndex: 10000,
      boxShadow: "0 1px 3px 0 rgba(9,30,66,0.13), 0 0 1px 0 #F1F1F1"
    }, _mediaMaxWidth["background"] = "#fff", _mediaMaxWidth.borderTop = "1px solid #dedede", _mediaMaxWidth), _css));

    var bar = Object(index_esm["css"])({
      display: "flex",
      alignItems: "center",
      verticalAlign: "middle",
      justifyContent: "space-between",
      width: "100%",
      minHeight: 36,
      margin: 0,
      "& h3": {
        margin: 0
      }
    });
    var displayPriceStr = displayString || event.useOldBannerStyle;
    var priceStr = Object(index_esm["css"])({
      display: displayPriceStr ? "block" : "none",
      "@media(max-width: 1015px)": {
        display: "block !important",
        paddingRight: 16
      }
    });

    var hasValidDates = event.validDates && event.validDates.length ? true : false;

    return Object(preact_min["h"])(
      "div",
      { className: wrapper, id: "tickets-bar" },
      Object(preact_min["h"])(
        "div",
        { className: bar },
        Object(preact_min["h"])(
          "div",
          { style: { flex: 1 } },
          Object(preact_min["h"])(
            "h3",
            { className: priceStr },
            Object(preact_min["h"])(components_PriceRangeDisplay, { event: event })
          )
        ),
        Object(preact_min["h"])(
          "div",
          { style: { display: "flex", flex: 1, justifyContent: "flex-end" } },
          Object(preact_min["h"])(TicketsBar_SalesWarning, { event: event, hasValidDates: hasValidDates }),
          Object(preact_min["h"])(TicketsBar_EventLink, {
            event: event,
            eventSlug: eventSlug,
            theme: theme,
            hasValidDates: hasValidDates,
            accessCode: accessCode,
            discountCode: discountCode
          })
        )
      )
    );
  };

  return TicketsBar;
}(preact_min["Component"]);

/* harmony default export */ var components_TicketsBar = (TicketsBar_TicketsBar);
// EXTERNAL MODULE: ../node_modules/fecha/fecha.js
var fecha = __webpack_require__("5jj8");
var fecha_default = /*#__PURE__*/__webpack_require__.n(fecha);

// CONCATENATED MODULE: ./components/addToCalender/helpers/index.js
function helpers__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var helpers = function () {
  function helpers() {
    helpers__classCallCheck(this, helpers);
  }

  helpers.prototype.getRandomKey = function getRandomKey() {
    var n = Math.floor(Math.random() * 999999999999).toString();
    return new Date().getTime().toString() + "_" + n;
  };

  helpers.prototype.formatTime = function formatTime(date) {
    var dateStr = date.replace(/-/g, "").replace(/:/g, "").split(".")[0].substr(0, 13) + "00Z";
    return dateStr;
  };

  helpers.prototype.calculateDuration = function calculateDuration(startTime, endTime) {
    var diffMs = new Date(endTime) - new Date(startTime); // milliseconds between
    var diffHrs = Math.floor(diffMs / 3600000); // hours
    var diffMins = Math.round(diffMs % 86400000 % 3600000 / 60000); // minutes
    return diffHrs + ":" + diffMins;
  };

  helpers.prototype.buildUrl = function buildUrl(event, type, isCrappyIE) {
    var calendarUrl = "";

    // allow mobile browsers to open the gmail data URI within native calendar app
    // type = (type == "google" && this.isMobile()) ? "outlook" : type;
    switch (type) {
      case "google":
        calendarUrl = "https://calendar.google.com/calendar/render";
        calendarUrl += "?action=TEMPLATE";
        calendarUrl += "&dates=" + this.formatTime(event.startTime);
        calendarUrl += "/" + this.formatTime(event.endTime);
        calendarUrl += "&location=" + encodeURIComponent(event.location);
        calendarUrl += "&text=" + encodeURIComponent(event.title);
        calendarUrl += "&details=" + encodeURIComponent(event.description);
        break;

      case "yahoo":
        // yahoo doesn't utilize endTime so we need to calulate duration
        var duration = this.calculateDuration(event.startTime, event.endTime);
        calendarUrl = "https://calendar.yahoo.com/?v=60&view=d&type=20";
        calendarUrl += "&title=" + encodeURIComponent(event.title);
        calendarUrl += "&st=" + this.formatTime(event.startTime);
        calendarUrl += "&dur=" + duration;
        calendarUrl += "&desc=" + encodeURIComponent(event.description);
        calendarUrl += "&in_loc=" + encodeURIComponent(event.location);
        break;

      case "outlookcom":
        calendarUrl = "https://outlook.live.com/owa/?rru=addevent";
        calendarUrl += "&startdt=" + this.formatTime(event.startTime);
        calendarUrl += "&enddt=" + this.formatTime(event.endTime);
        calendarUrl += "&subject=" + encodeURIComponent(event.title);
        calendarUrl += "&location=" + encodeURIComponent(event.location);
        calendarUrl += "&body=" + encodeURIComponent(event.description);
        calendarUrl += "&allday=false";
        calendarUrl += "&uid=" + this.getRandomKey();
        calendarUrl += "&path=/calendar/view/Month";
        break;

      default:
        calendarUrl = ["BEGIN:VCALENDAR", "VERSION:2.0", "BEGIN:VEVENT", "URL:" + document.URL, "DTSTART:" + this.formatTime(event.startTime), "DTEND:" + this.formatTime(event.endTime), "SUMMARY:" + event.title, "DESCRIPTION:" + event.description, "LOCATION:" + event.location, "END:VEVENT", "END:VCALENDAR"].join("\n");

        if (!isCrappyIE && this.isMobile()) {
          calendarUrl = encodeURI("data:text/calendar;charset=utf8," + calendarUrl);
        }
    }

    return calendarUrl;
  };

  // determine if a mobile browser is being used


  helpers.prototype.isMobile = function isMobile() {
    var mobile = false;

    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) mobile = true;
    })(window.navigator.userAgent || window.navigator.vendor || window.opera);

    return mobile;
  };

  return helpers;
}();


// CONCATENATED MODULE: ./components/addToCalender/ReactAddToCalendar.js


function ReactAddToCalendar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ReactAddToCalendar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ReactAddToCalendar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ReactAddToCalendar_helpers = new helpers();

var ReactAddToCalendar_ReactAddToCalendar = function (_React$Component) {
  ReactAddToCalendar__inherits(ReactAddToCalendar, _React$Component);

  function ReactAddToCalendar(props) {
    ReactAddToCalendar__classCallCheck(this, ReactAddToCalendar);

    var _this = ReactAddToCalendar__possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      optionsOpen: props.optionsOpen || false,
      isCrappyIE: false
    };
    _this.closeDropDown = _this.closeDropDown.bind(_this);
    _this.toggleCalendarDropdown = _this.toggleCalendarDropdown.bind(_this);
    _this.handleDropdownLinkClick = _this.handleDropdownLinkClick.bind(_this);
    return _this;
  }

  ReactAddToCalendar.prototype.componentWillMount = function componentWillMount() {
    // polyfill for startsWith to fix IE bug
    if (!String.prototype.startsWith) {
      String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
      };
    }

    var isCrappyIE = false;
    if (typeof window !== "undefined" && window.navigator.msSaveOrOpenBlob && window.Blob) {
      isCrappyIE = true;
    }

    this.setState({ isCrappyIE: isCrappyIE });
  };

  ReactAddToCalendar.prototype.closeDropDown = function closeDropDown() {
    this.setState({ optionsOpen: false });
    document.removeEventListener("click", this.closeDropDown);
  };

  ReactAddToCalendar.prototype.toggleCalendarDropdown = function toggleCalendarDropdown() {
    var _this2 = this;

    var showOptions = !this.state.optionsOpen;
    setTimeout(function () {
      if (showOptions) {
        document.addEventListener("click", _this2.closeDropDown, false);
      } else {
        document.removeEventListener("click", _this2.closeDropDown);
      }
    }, 200);
    this.setState({ optionsOpen: showOptions });
  };

  ReactAddToCalendar.prototype.handleDropdownLinkClick = function handleDropdownLinkClick(e) {
    e.preventDefault();
    var url = e.currentTarget.getAttribute("href");

    if (!ReactAddToCalendar_helpers.isMobile() && (url.startsWith("data") || url.startsWith("BEGIN"))) {
      var filename = "download.ics";
      var blob = new Blob([url], { type: "text/calendar;charset=utf-8" });

      if (this.state.isCrappyIE) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        /****************************************************************
        // many browsers do not properly support downloading data URIs
        // (even with "download" attribute in use) so this solution
        // ensures the event will download cross-browser
        ****************************************************************/
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      window.open(url, "_blank");
    }

    this.toggleCalendarDropdown();
  };

  ReactAddToCalendar.prototype.renderDropdown = function renderDropdown() {
    var self = this;

    var items = this.props.listItems.map(function (listItem) {
      var currentItem = Object.keys(listItem)[0];
      var currentLabel = listItem[currentItem];

      var icon = null;
      if (self.props.displayItemIcons) {
        var currentIcon = currentItem === "outlook" || currentItem === "outlookcom" ? "windows" : currentItem;
        icon = Object(preact_min["h"])("i", { className: "fa fa-" + currentIcon });
      }
      return Object(preact_min["h"])(
        "li",
        { key: ReactAddToCalendar_helpers.getRandomKey() },
        Object(preact_min["h"])(
          "a",
          {
            className: currentItem + "-link",
            onClick: self.handleDropdownLinkClick,
            href: ReactAddToCalendar_helpers.buildUrl(self.props.event, currentItem, self.state.isCrappyIE),
            target: "_blank"
          },
          icon,
          currentLabel
        )
      );
    });

    return Object(preact_min["h"])(
      "div",
      { className: this.props.dropdownClass },
      Object(preact_min["h"])(
        "ul",
        null,
        items
      )
    );
  };

  ReactAddToCalendar.prototype.renderButton = function renderButton() {
    var children = this.props.children;

    var childrenWithProps = preact_compat_es["default"].cloneElement(children, {
      onClick: this.toggleCalendarDropdown,
      "aria-label": "toggle calendar dropdown"
    });
    return Object(preact_min["h"])(
      "div",
      { className: this.props.buttonWrapperClass },
      childrenWithProps
    );
  };

  ReactAddToCalendar.prototype.render = function render() {
    var options = null;
    if (this.state.optionsOpen) {
      options = this.renderDropdown();
    }

    var addToCalendarBtn = null;
    if (this.props.event) {
      addToCalendarBtn = this.renderButton();
    }

    return Object(preact_min["h"])(
      "div",
      { className: this.props.rootClass },
      addToCalendarBtn,
      options
    );
  };

  return ReactAddToCalendar;
}(preact_compat_es["default"].Component);




ReactAddToCalendar_ReactAddToCalendar.displayName = "Add To Calendar";

ReactAddToCalendar_ReactAddToCalendar.defaultProps = {
  buttonClassClosed: "react-add-to-calendar__button",
  buttonClassOpen: "react-add-to-calendar__button--light",
  buttonLabel: "Add to Calendar",
  buttonTemplate: { caret: "right" },
  buttonIconClass: "react-add-to-calendar__icon--",
  useFontAwesomeIcons: true,
  buttonWrapperClass: "react-add-to-calendar__wrapper",
  displayItemIcons: true,
  optionsOpen: false,
  dropdownClass: "react-add-to-calendar__dropdown",
  event: {
    title: "Sample Event",
    description: "This is the sample event provided as an example only",
    location: "Portland, OR",
    startTime: "2016-09-16T20:15:00-04:00",
    endTime: "2016-09-16T21:45:00-04:00"
  },
  listItems: [{ apple: "Apple Calendar" }, { google: "Google" }, { outlook: "Outlook" }, { outlookcom: "Outlook.com" }, { yahoo: "Yahoo" }],
  rootClass: "react-add-to-calendar"
};
// EXTERNAL MODULE: ./services/EventsService.js
var EventsService = __webpack_require__("4Q11");

// EXTERNAL MODULE: ./assets/images/ic_calender.svg
var ic_calender = __webpack_require__("QsbM");
var ic_calender_default = /*#__PURE__*/__webpack_require__.n(ic_calender);

// CONCATENATED MODULE: ./routes/event/EventAddToCalender.js







var btnWrapper = Object(index_esm["css"])({
  margin: "-40px 0 42px 0",
  "@media(max-width: 600px)": {
    margin: "-24px 0 24px 30px"
  }
});

var btnClass = Object(index_esm["css"])({
  fontSize: 14,
  fontWeight: 600,
  display: "block",
  minWidth: 200,
  color: "#196097"
});

var EventAddToCalender__ref2 = Object(preact_min["h"])(
  "a",
  { className: btnClass },
  "Add to calendar"
);

var EventAddToCalender_EventAddToCalender = function EventAddToCalender(_ref) {
  var event = _ref.event,
      theme = _ref.theme,
      eventDate = _ref.eventDate;

  if (!event) {
    return null;
  }
  if (!eventDate) {
    var validDates = event.data.dates.filter(function (date) {
      return date.valid;
    });
    if (validDates.length === 1) {
      eventDate = validDates[0];
    } else {
      return null;
    }
  }
  if (!eventDate) {
    return null;
  }
  var hideCalendar = event.data.settings.hideAddToCalendar;
  if (hideCalendar) {
    return null;
  }

  var parts = [];
  if (event.data.location.venueName) {
    parts.push(event.data.location.venueName);
  }
  if (event.data.location.address) {
    parts.push(event.data.location.address.replace(",", ""));
  }

  var eventCalender = {
    title: event.data.name,
    description: EventsService["a" /* default */].getCalendarDescription(event.data),
    location: parts.join(" "),
    startTime: eventDate.startDate,
    endTime: eventDate.endDate
  };

  return Object(preact_min["h"])(
    "div",
    { className: btnWrapper },
    Object(preact_min["h"])(
      ReactAddToCalendar_ReactAddToCalendar,
      { event: eventCalender },
      EventAddToCalender__ref2
    )
  );
};

/* harmony default export */ var event_EventAddToCalender = (EventAddToCalender_EventAddToCalender);
// EXTERNAL MODULE: ./assets/icons/ic_accessibility.svg
var ic_accessibility = __webpack_require__("FRMY");
var ic_accessibility_default = /*#__PURE__*/__webpack_require__.n(ic_accessibility);

// EXTERNAL MODULE: ./components/DateModal.js
var DateModal = __webpack_require__("87nI");

// CONCATENATED MODULE: ./components/EventInfoBox.js


function EventInfoBox__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EventInfoBox__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EventInfoBox__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EventInfoBox_wrapper = Object(index_esm["css"])({
  width: 300,
  height: 360,
  float: "right",
  display: "inline",
  overflow: "hidden",
  position: "relative",
  backgroundColor: "#fafafa",
  borderRadius: 4,
  padding: "32px 16px 12px 16px",
  "@media (max-width: 1030px)": {
    display: "none"
  }
});

var EventInfoBox_eventOrganiser = Object(index_esm["css"])({
  fontSize: 12,
  fontWeight: 400,
  color: "#5a626c",
  marginBottom: 12,
  ":hover": {
    color: "#5a626c",
    cursor: "pointer"
  }
});

var EventInfoBox_eventTitle = Object(index_esm["css"])({
  fontSize: 20,
  fontWeight: 600,
  color: "#323232",
  marginBottom: 16,
  overflow: "hidden",
  textOverflow: "ellipsis",
  lineHeight: 1.5,
  maxHeight: 150
});

var EventInfoBox_datesWrapper = Object(index_esm["css"])({
  fontSize: 14,
  background: "url(" + icon_date_default.a + ")",
  backgroundSize: "20px 20px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "top left",
  paddingLeft: 24,
  fontWeight: 400,
  color: "#323232",
  marginBottom: 8
});

var accessibilityLink = Object(index_esm["css"])({
  background: "url(" + ic_accessibility_default.a + ")",
  backgroundSize: "20px 20px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "top left",
  paddingLeft: 24,
  fontWeight: 400,
  fontSize: 14,
  color: "#196097",
  ":hover": {
    color: "#196097"
  }
});

var priceContainer = Object(index_esm["css"])({
  width: "100%",
  height: 41,
  position: "absolute",
  left: 0,
  bottom: 0,
  borderTop: "solid 1px #dedede",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0px 14px"
});

var priceLabel = Object(index_esm["css"])({
  fontSize: 16,
  color: "black",
  bottom: 9,
  left: 16,
  marginBottom: 0
});

var priceAmount = Object(index_esm["css"])({
  fontSize: 16,
  color: "black",
  float: "right",
  fontWeight: 600,
  marginBottom: 0
});

var whiteLine = Object(index_esm["css"])({
  width: 300,
  height: 1,
  backgroundColor: "#fff",
  position: "absolute",
  bottom: 45,
  left: 0
});

var EventInfoBox__ref = Object(preact_min["h"])(
  "p",
  { className: priceLabel },
  "Price"
);

var EventInfoBox_EventInfoBox = function (_Component) {
  EventInfoBox__inherits(EventInfoBox, _Component);

  function EventInfoBox(props) {
    EventInfoBox__classCallCheck(this, EventInfoBox);

    var _this = EventInfoBox__possibleConstructorReturn(this, _Component.call(this, props));

    _this.toggleDateModal = function () {
      var datesModalOpen = _this.state.datesModalOpen;

      _this.setState({
        datesModalOpen: !datesModalOpen
      });
    };

    _this.state = {
      datesModalOpen: false
    };
    return _this;
  }

  EventInfoBox.prototype.render = function render() {
    var datesModalOpen = this.state.datesModalOpen;
    var event = this.props.event;

    if (!event) {
      return;
    }
    var displayPrice = event && event.settings.ticketPriceRangeDisplay ? true : false;
    var organiserName = event.organiser ? event.organiser.name : null;
    var eventDates = event.validDates && event.validDates.length && !event.suspendSales ? event.dates : false;
    var validDates = eventDates ? eventDates.filter(function (date) {
      return date.valid;
    }) : [];
    var displayDate = false;
    var multipleDates = false;
    if (validDates && validDates.length) {
      displayDate = "" + validDates[0].display.combined;
      multipleDates = validDates.length > 1 ? true : false;
    }

    var displayAccessibility = event.accessibility ? checkObjNotEmpty(event.accessibility) : false;
    return Object(preact_min["h"])(
      "div",
      { className: EventInfoBox_wrapper },
      Object(preact_min["h"])(
        "div",
        { style: { marginBottom: 8 } },
        organiserName ? Object(preact_min["h"])(
          "a",
          { href: "#organiserInfoBox", className: EventInfoBox_eventOrganiser },
          organiserName
        ) : null
      ),
      Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "h2",
          { className: EventInfoBox_eventTitle },
          event.name
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: EventInfoBox_datesWrapper },
        displayDate,
        multipleDates ? Object(preact_min["h"])(
          "div",
          null,
          Object(preact_min["h"])(
            "a",
            {
              style: { textDecoration: "underline" },
              href: "#",
              onClick: this.toggleDateModal
            },
            "+ ",
            validDates.length - 1,
            " more dates"
          )
        ) : null
      ),
      displayAccessibility ? Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "a",
          {
            href: "/" + event.slug + "/accessibility",
            className: accessibilityLink
          },
          "Accessibility"
        )
      ) : null,
      displayPrice ? Object(preact_min["h"])(
        "div",
        { className: priceContainer },
        EventInfoBox__ref,
        Object(preact_min["h"])(
          "p",
          { className: priceAmount },
          Object(preact_min["h"])(components_PriceRangeDisplay, { event: event })
        )
      ) : "",
      Object(preact_min["h"])(DateModal["a" /* default */], {
        open: datesModalOpen,
        closeHandler: this.toggleDateModal,
        title: "More dates",
        dates: validDates,
        eventSlug: event.slug
      })
    );
  };

  return EventInfoBox;
}(preact_min["Component"]);

/* harmony default export */ var components_EventInfoBox = (EventInfoBox_EventInfoBox);
// CONCATENATED MODULE: ./routes/event/EventBanner.js






var EventBanner_EventBanner = function EventBanner(_ref) {
  var event = _ref.event,
      theme = _ref.theme;

  var removeBlur = theme && theme.background && (theme.type === "custom" || theme.type === "dark") && (theme.background.image && theme.background.image.handle || theme.background.color) ? true : false;
  var blurBackgroundColor = theme && theme.background && theme.type === "dark" ? "#1d1d1d" : "#fff";

  var blurDiv = event.useOldBannerStyle ? Object(index_esm["css"])({
    backgroundImage: !removeBlur ? "url(https://cdn.filestackcontent.com/blur=amount:10/resize=width:300/" + event.displayImage.handle + ")" : "none",
    backgroundSize: "cover",
    backgroundColor: !removeBlur ? blurBackgroundColor : "transparent",
    zIndex: 99999
  }) : Object(index_esm["css"])({
    backgroundImage: !removeBlur ? "url(https://cdn.filestackcontent.com/blur=amount:10/resize=width:300/" + (event.displayImage ? event.displayImage.handle : "VbieTVjAQvq5BTkE9vIi") + ")" : "none",
    backgroundSize: "cover",
    backgroundColor: !removeBlur ? blurBackgroundColor : "transparent",
    zIndex: 99999
  });

  var wrapperDiv = Object(index_esm["css"])({
    maxWidth: 1040,
    margin: "auto",
    padding: "30px 0",
    "@media(max-width:600px)": {
      padding: 0
    }
  });

  var bannerImageWrapper = Object(index_esm["css"])({
    maxWidth: 720,
    border: event.displayImage ? "none" : "1px solid #d7dee6",
    borderRadius: 4,
    float: "left",
    margin: 0,
    img: {
      borderRadius: 4
    },
    "@media(max-width:600px)": {
      borderRadius: 0,
      img: {
        borderRadius: 0
      }
    },
    "@media(max-width:1030px)": {
      float: "none",
      margin: "0 auto"
    }
  });

  return event.useOldBannerStyle ? Object(preact_min["h"])(
    "div",
    { className: blurDiv },
    Object(preact_min["h"])(
      "div",
      {
        style: {
          margin: "0px auto",
          maxWidth: 1000,
          display: "block",
          borderRadius: 4
        }
      },
      Object(preact_min["h"])(components_Picture, {
        img: event.displayImage,
        alt: event.name + " Event Banner",
        width: 1000
      })
    )
  ) : Object(preact_min["h"])(
    "div",
    { className: blurDiv },
    Object(preact_min["h"])(
      "div",
      { className: wrapperDiv },
      Object(preact_min["h"])(
        "div",
        { className: bannerImageWrapper },
        Object(preact_min["h"])(components_Picture, {
          img: event.displayImage,
          alt: event.name + " Event Banner",
          width: 720
        })
      ),
      Object(preact_min["h"])(components_EventInfoBox, { event: event }),
      Object(preact_min["h"])("div", {
        style: {
          clear: "both"
        }
      })
    )
  );
};

/* harmony default export */ var event_EventBanner = (EventBanner_EventBanner);
// CONCATENATED MODULE: ./routes/event/Event.js


function Event__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Event__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Event__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var Event_mobile = Object(index_esm["css"])({
  display: "none",
  "@media(max-width: 600px)": {
    display: "block"
  }
});

var Event_desktop = Object(index_esm["css"])({
  display: "block",
  "@media(max-width: 600px)": {
    display: "none"
  }
});

var eventContainer = Object(index_esm["css"])({
  padding: "48px 60px 72px",
  boxSizing: "border-box",
  marginBottom: "12",
  margin: "0 auto",
  "@media (max-width: 700px)": {
    padding: "24px 12px 0px",
    margin: 0,
    width: "100%"
  }
});

var cols = Object(index_esm["css"])({
  display: "flex",
  marginBottom: 24
});

var Event_eventInfo = Object(index_esm["css"])({
  padding: "0 140px 0 0",
  flex: 1,
  "@media (max-width: 700px)": {
    padding: "0 0 0 0"
  }
});

var eventAside = Object(index_esm["css"])([{
  width: 280
}, Event_desktop]);

var Event__ref2 = Object(preact_min["h"])(
  Content["a" /* default */],
  null,
  Object(preact_min["h"])(components_EventError, { type: "notFound" })
);

var Event__ref3 = Object(preact_min["h"])(
  Content["a" /* default */],
  null,
  Object(preact_min["h"])(components_EventError, { type: "notPublished" })
);

var Event_Event = function (_Component) {
  Event__inherits(Event, _Component);

  function Event(props) {
    Event__classCallCheck(this, Event);

    return Event__possibleConstructorReturn(this, _Component.call(this, props));
  }

  Event.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        event = _props.event,
        getEvent = _props.getEvent,
        eventSlug = _props.eventSlug,
        location = _props.location;

    var parsed = query_string_default.a.parse(window.location.search);
    if (!event.data && !event.loading) {
      getEvent(eventSlug, parsed.token);
    } else if (event.data && event.data.slug !== eventSlug) {
      getEvent(eventSlug, parsed.token);
      Object(ticketsActions["r" /* clearTickets */])();
    }
  };

  Event.prototype.render = function render(_ref) {
    var event = _ref.event,
        eventSlug = _ref.eventSlug;

    var isBrowser = typeof window !== "undefined";
    var accessCode = void 0;
    var discountCode = void 0;
    var parsedTheme = void 0;
    if (isBrowser) {
      var parsed = query_string_default.a.parse(window.location.search);
      parsedTheme = parsed.theme && parsed.theme !== "undefined" ? JSON.parse(parsed.theme) : false;
      accessCode = parsed.accesscode;
      discountCode = parsed.discountcode ? encodeURIComponent(parsed.discountcode) : null;
    }
    var locationType = event && event.data && event.data.location && event.data.location.type ? event.data.location.type : false;

    if (event.error) {
      return Event__ref2;
    }

    if (event.data && !event.data.published) {
      return Event__ref3;
    }
    if (event.loading || !event.data) {
      return Object(preact_min["h"])(
        Page["a" /* default */],
        null,
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])("div", { "class": "loading loading-lg", style: { minHeight: 500 } })
        )
      );
    }

    var headingTitle = Object(index_esm["css"])({
      margin: "0 0 50px 0 !important",
      display: event.data.useOldBannerStyle ? "block" : "none",
      marginBottom: event.data.useOldBannerStyle ? 50 : "inherit",
      marginTop: event.data.useOldBannerStyle ? 50 : "inherit",
      "@media (max-width: 700px)": {
        margin: "0 0 30px 0 !important"
      },
      "@media(max-width: 1015px)": {
        display: "block",
        marginBottom: 24,
        fontSize: 18,
        fontWeight: 600,
        color: "#323232"
      }
    });

    var eventOrganiser = Object(index_esm["css"])({
      marginTop: event.data.useOldBannerStyle ? 50 : 0,
      display: "none",
      "@media(max-width: 1015px)": {
        display: !event.data.useOldBannerStyle ? "block" : "none"
      },
      fontSize: 12,
      fontWeight: 600,
      color: "#5a626c",
      marginBottom: 12
    });

    var description = Object(index_esm["css"])({
      fontWeight: 600,
      "@media (max-width: 700px)": {
        marginTop: locationType === "online" ? 0 : 24
      }
    });

    var theme = parsedTheme ? parsedTheme : event && event.data && event.data.theme ? event.data.theme : null;
    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        Page["a" /* default */],
        {
          header: true,
          background: false,
          border: false,
          banner: Object(preact_min["h"])(event_EventBanner, { event: event.data, theme: theme })
        },
        Object(preact_min["h"])(EditEvent["a" /* default */], { event: event.data }),
        Object(preact_min["h"])(components_TicketsBar, {
          event: event.data,
          theme: theme,
          accessCode: accessCode,
          discountCode: discountCode,
          eventSlug: eventSlug
        }),
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])(
            "div",
            { className: eventContainer },
            Object(preact_min["h"])(
              "div",
              { className: cols },
              Object(preact_min["h"])(
                "div",
                { className: Event_eventInfo },
                event.data.organiser && event.data.organiser.name ? Object(preact_min["h"])(
                  "a",
                  { className: eventOrganiser, href: "#organiserInfoBox" },
                  event.data.organiser.name
                ) : null,
                Object(preact_min["h"])(
                  "h1",
                  { className: headingTitle },
                  event.data.name
                ),
                Object(preact_min["h"])(
                  "div",
                  { className: Event_mobile },
                  Object(preact_min["h"])(components_Dates, {
                    dates: event.data.dates,
                    eventSlug: eventSlug,
                    oldStyle: event.data.useOldBannerStyle
                  }),
                  Object(preact_min["h"])(event_EventAddToCalender, { event: event, theme: theme }),
                  Object(preact_min["h"])(components_Location, {
                    location: event.data.location,
                    oldStyle: event.data.useOldBannerStyle
                  })
                ),
                Object(preact_min["h"])(
                  "h3",
                  { className: description },
                  "Event description"
                ),
                Object(preact_min["h"])(components_RichTextDisplay, { html: event.data.description }),
                event.data.public ? Object(preact_min["h"])(components_SharingLinks, { event: event.data }) : null,
                Object(preact_min["h"])(components_EventLinks, { event: event.data }),
                Object(preact_min["h"])(components_RefundPolicy, { event: event.data })
              ),
              Object(preact_min["h"])(
                "div",
                { className: eventAside, "data-cy": "events-aside" },
                Object(preact_min["h"])(components_Dates, {
                  dates: event.data.dates,
                  eventSlug: eventSlug,
                  oldStyle: event.data.useOldBannerStyle
                }),
                Object(preact_min["h"])(event_EventAddToCalender, { event: event, theme: theme }),
                Object(preact_min["h"])(components_Location, {
                  location: event.data.location,
                  oldStyle: event.data.useOldBannerStyle
                }),
                event.data.showCharity ? Object(preact_min["h"])(components_EventCharity, { charity: event.data.charity }) : null
              )
            ),
            Object(preact_min["h"])(components_OrganiserInfo, { event: event.data }),
            Object(preact_min["h"])(
              "div",
              { className: Event_mobile },
              event.data.showCharity ? Object(preact_min["h"])(components_EventCharity, { charity: event.data.charity }) : null
            )
          )
        )
      ),
      Object(preact_min["h"])(moreEvents_MoreEvents, { event: event.data })
    );
  };

  return Event;
}(preact_min["Component"]);

/* harmony default export */ var event_Event = (Object(es["b" /* connect */])(function (state) {
  return { event: state.event };
}, { getEvent: eventActions["u" /* getEvent */], clearTickets: ticketsActions["r" /* clearTickets */] })(Event_Event));
// CONCATENATED MODULE: ./routes/organiser/OrganiserBanner.js
var OrganiserBanner__templateObject = OrganiserBanner__taggedTemplateLiteralLoose(["\n    display: none;\n    border-right: 4px;\n    @media (max-width: 760px) {\n      display: block;\n      width: 100px;\n      height: 100px;\n      margin: 0px auto 16px auto;\n    }\n  "], ["\n    display: none;\n    border-right: 4px;\n    @media (max-width: 760px) {\n      display: block;\n      width: 100px;\n      height: 100px;\n      margin: 0px auto 16px auto;\n    }\n  "]),
    OrganiserBanner__templateObject2 = OrganiserBanner__taggedTemplateLiteralLoose(["\n    width: 100px;\n    height: 100px;\n    margin: 0px auto 16px auto;\n    display: block;\n    border-radius: 50%;\n    @media (max-width: 600px) {\n      width: 80px;\n      height: 80px;\n    }\n  "], ["\n    width: 100px;\n    height: 100px;\n    margin: 0px auto 16px auto;\n    display: block;\n    border-radius: 50%;\n    @media (max-width: 600px) {\n      width: 80px;\n      height: 80px;\n    }\n  "]),
    OrganiserBanner__templateObject3 = OrganiserBanner__taggedTemplateLiteralLoose(["\n      max-width: 1000px;\n      height: 250px;\n      background-color: ", ";\n      position: relative;\n      padding-top: 32px;\n      padding-bottom: 32px;\n      margin-bottom: 24px;\n      @media (max-width: 600px) {\n        height: 196px;\n        position: absolute;\n        width: 100%;\n        left: 0;\n        top: 0;\n      }\n    "], ["\n      max-width: 1000px;\n      height: 250px;\n      background-color: ", ";\n      position: relative;\n      padding-top: 32px;\n      padding-bottom: 32px;\n      margin-bottom: 24px;\n      @media (max-width: 600px) {\n        height: 196px;\n        position: absolute;\n        width: 100%;\n        left: 0;\n        top: 0;\n      }\n    "]),
    OrganiserBanner__templateObject4 = OrganiserBanner__taggedTemplateLiteralLoose(["\n      color: ", ";\n      text-align: center;\n      font-size: 32px;\n      margin-bottom: 8px;\n      text-transform: capitalize;\n      @media (max-width: 760px) {\n        font-size: 18px;\n      }\n    "], ["\n      color: ", ";\n      text-align: center;\n      font-size: 32px;\n      margin-bottom: 8px;\n      text-transform: capitalize;\n      @media (max-width: 760px) {\n        font-size: 18px;\n      }\n    "]);



function OrganiserBanner__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }







var OrganiserBanner_styles = {
  organiserLogo: Object(index_esm["css"])(OrganiserBanner__templateObject),
  image: Object(index_esm["css"])(OrganiserBanner__templateObject2)
};

var OrganiserBanner_OrganiserBanner = function OrganiserBanner(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? "#fff" : _ref$backgroundColor,
      logo = _ref.logo,
      name = _ref.name,
      website = _ref.website;

  var colorCode = ["#323232", "#FFFFFF"];
  var primaryTextColor = void 0;
  colorCode.forEach(function (color) {
    if (color_contrast_dist_default()(backgroundColor, color) >= 4.5) {
      primaryTextColor = color;
    }
  });

  var customStyles = {
    wrapper: Object(index_esm["css"])(OrganiserBanner__templateObject3, backgroundColor),
    heading: Object(index_esm["css"])(OrganiserBanner__templateObject4, primaryTextColor)
  };

  var siteLink = services_OrganiserService.sanitiseURLs(website);
  return Object(preact_min["h"])(
    "div",
    { className: customStyles.wrapper },
    logo ? Object(preact_min["h"])(Image["a" /* default */], { src: logo, className: OrganiserBanner_styles.image, alt: name + " Logo" }) : Object(preact_min["h"])("div", { className: OrganiserBanner_styles.organiserLogo }),
    Object(preact_min["h"])(
      "h2",
      { className: customStyles.heading },
      name
    ),
    Object(preact_min["h"])(
      "a",
      {
        href: siteLink,
        style: {
          color: primaryTextColor,
          textAlign: "center",
          display: "block"
        },
        target: "_blank"
      },
      website
    )
  );
};

/* harmony default export */ var organiser_OrganiserBanner = (OrganiserBanner_OrganiserBanner);
// EXTERNAL MODULE: ./assets/images/icon-arrow-down.svg
var icon_arrow_down = __webpack_require__("D4Hc");
var icon_arrow_down_default = /*#__PURE__*/__webpack_require__.n(icon_arrow_down);

// EXTERNAL MODULE: ./assets/images/icon-arrow-up.svg
var icon_arrow_up = __webpack_require__("L/PD");
var icon_arrow_up_default = /*#__PURE__*/__webpack_require__.n(icon_arrow_up);

// CONCATENATED MODULE: ./routes/organiser/OrganiserInfo.js
var OrganiserInfo__css;

var OrganiserInfo__templateObject = OrganiserInfo__taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding: 24px 10px 18px 20px;\n  background-color: #fff;\n  box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);\n  min-width: 280px;\n  display: inline-block;\n  border-radius: 4px;\n  margin-bottom: 12px;\n  @media (max-width: 1000px) {\n    padding: 14px;\n  }\n  @media (max-width: 600px) {\n    margin-top: 208px;\n    margin-bottom: 16px;\n  }\n"], ["\n  width: 100%;\n  padding: 24px 10px 18px 20px;\n  background-color: #fff;\n  box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);\n  min-width: 280px;\n  display: inline-block;\n  border-radius: 4px;\n  margin-bottom: 12px;\n  @media (max-width: 1000px) {\n    padding: 14px;\n  }\n  @media (max-width: 600px) {\n    margin-top: 208px;\n    margin-bottom: 16px;\n  }\n"]);



function OrganiserInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrganiserInfo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function OrganiserInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function OrganiserInfo__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }





var OrganiserInfo_heading = Object(index_esm["css"])({
  textTransform: "capitalize",
  fontWeight: 600
});

var OrganiserInfo_wrapper = Object(index_esm["css"])(OrganiserInfo__templateObject);

var descriptionText = Object(index_esm["css"])((OrganiserInfo__css = {
  textAlign: "left",
  overflowWrap: "break-word",
  wordBreak: "break-all"
}, OrganiserInfo__css["wordBreak"] = "break-word", OrganiserInfo__css.hyphens = "auto", OrganiserInfo__css));

var OrganiserInfo__ref = Object(preact_min["h"])(
  "h2",
  { className: OrganiserInfo_heading },
  "About"
);

var organiser_OrganiserInfo_OrganiserInfo = function (_Component) {
  OrganiserInfo__inherits(OrganiserInfo, _Component);

  function OrganiserInfo(props) {
    OrganiserInfo__classCallCheck(this, OrganiserInfo);

    var _this = OrganiserInfo__possibleConstructorReturn(this, _Component.call(this, props));

    _this.clickShowMore = function () {
      _this.setState({ showMore: !_this.state.showMore });
    };

    _this.state = { showMore: false };
    return _this;
  }

  OrganiserInfo.prototype.render = function render() {
    var description = this.props.description;
    var showMore = this.state.showMore;


    var tooLong = description && description.length > 182 ? true : false;
    if (tooLong && !showMore) {
      description = description.substring(0, 182) + "...";
    }
    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        "div",
        { className: OrganiserInfo_wrapper },
        OrganiserInfo__ref,
        description && description !== "" ? Object(preact_min["h"])(
          "p",
          { className: descriptionText },
          description
        ) : null,
        tooLong && !showMore ? Object(preact_min["h"])(
          "button",
          { onClick: this.clickShowMore, style: { padding: 0 } },
          "Read more",
          " ",
          Object(preact_min["h"])("img", { src: icon_arrow_down_default.a, style: { width: 12, marginLeft: 6 } }),
          " "
        ) : null,
        tooLong && showMore ? Object(preact_min["h"])(
          "button",
          { onClick: this.clickShowMore, style: { padding: 0 } },
          "Show less",
          " ",
          Object(preact_min["h"])("img", { src: icon_arrow_up_default.a, style: { width: 12, marginLeft: 6 } }),
          " "
        ) : null
      )
    );
  };

  return OrganiserInfo;
}(preact_min["Component"]);

/* harmony default export */ var organiser_OrganiserInfo = (organiser_OrganiserInfo_OrganiserInfo);
// CONCATENATED MODULE: ./routes/organiser/OrganiserCharities.js
var OrganiserCharities__templateObject = OrganiserCharities__taggedTemplateLiteralLoose(["\n  display: inline-block;\n  margin-right: 12px;\n  margin-bottom: 12px;\n  &:nth-child(3) {\n    margin-right: 0;\n  }\n  @media (max-width: 1000px) {\n    &:nth-child(3) {\n      margin-right: 12px;\n    }\n    &:nth-child(calc(100% / 82)) {\n      margin-right: 0;\n    }\n  }\n"], ["\n  display: inline-block;\n  margin-right: 12px;\n  margin-bottom: 12px;\n  &:nth-child(3) {\n    margin-right: 0;\n  }\n  @media (max-width: 1000px) {\n    &:nth-child(3) {\n      margin-right: 12px;\n    }\n    &:nth-child(calc(100% / 82)) {\n      margin-right: 0;\n    }\n  }\n"]),
    OrganiserCharities__templateObject2 = OrganiserCharities__taggedTemplateLiteralLoose(["\n  width: 100%;\n  background-color: #fff;\n  box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);\n  padding: 24px 20px;\n  border-radius: 4px;\n"], ["\n  width: 100%;\n  background-color: #fff;\n  box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);\n  padding: 24px 20px;\n  border-radius: 4px;\n"]);



function OrganiserCharities__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }





var charityImgWrapper = Object(index_esm["css"])(OrganiserCharities__templateObject);

var OrganiserCharities_wrapper = Object(index_esm["css"])(OrganiserCharities__templateObject2);

var imageStyling = Object(index_esm["css"])({
  width: 70,
  height: 70,
  border: "solid 1.2px #DEDEDE",
  borderRadius: 4
});

var OrganiserCharities_ImageBlock = function ImageBlock(charity) {
  return Object(preact_min["h"])(
    "a",
    { href: charity.charity.website, className: charityImgWrapper },
    Object(preact_min["h"])(Image["a" /* default */], {
      src: charity.charity.logo.url,
      className: imageStyling,
      alt: charity.charity.name + " Logo"
    })
  );
};

var OrganiserCharities_OrganiserCharities = function OrganiserCharities(_ref) {
  var charities = _ref.charities,
      name = _ref.name;

  if (charities && charities.length > 0) {
    return Object(preact_min["h"])(
      "div",
      { className: OrganiserCharities_wrapper },
      Object(preact_min["h"])(
        "h3",
        { style: { textAlign: "left", fontWeight: 600 } },
        Object(preact_min["h"])(
          "span",
          { style: { textTransform: "capitalize" } },
          name
        ),
        " is supporting"
      ),
      Object(preact_min["h"])(
        "div",
        { style: { textAlign: "left" } },
        charities.map(function (charity) {
          return Object(preact_min["h"])(OrganiserCharities_ImageBlock, { charity: charity });
        })
      )
    );
  }
};

/* harmony default export */ var organiser_OrganiserCharities = (OrganiserCharities_OrganiserCharities);
// EXTERNAL MODULE: ../node_modules/react-scrolllock/dist/index.js
var react_scrolllock_dist = __webpack_require__("IPtN");
var react_scrolllock_dist_default = /*#__PURE__*/__webpack_require__.n(react_scrolllock_dist);

// CONCATENATED MODULE: ./components/Share.js


function Share__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Share__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Share__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var shareIcon = __webpack_require__("qSyn");
var closeIcon = __webpack_require__("dty5");
var facebookIcon = __webpack_require__("bbZ0");
var linkedInIcon = __webpack_require__("WS6J");
var twitterIcon = __webpack_require__("ir0y");
var copyIcon = __webpack_require__("5xRX");

var Share__ref = Object(preact_min["h"])(Image["a" /* default */], { src: shareIcon, alt: "Share Icon" });

var Share__ref2 = Object(preact_min["h"])(react_scrolllock_dist_default.a, null);

var Share__ref3 = Object(preact_min["h"])(
  "h2",
  { className: "heading" },
  "Share Event"
);

var Share__ref4 = Object(preact_min["h"])(Image["a" /* default */], { src: closeIcon, alt: "Close Icon" });

var Share__ref5 = Object(preact_min["h"])(
  "button",
  {
    className: "buttonSocial",
    "aria-label": "Copy Button",
    "aria-hidden": true
  },
  Object(preact_min["h"])(Image["a" /* default */], {
    className: "shareLogo",
    src: copyIcon,
    alt: "Copy Button"
  })
);

var Share__ref6 = Object(preact_min["h"])(Image["a" /* default */], {
  className: "shareLogo",
  src: facebookIcon,
  alt: "Facebook Icon"
});

var Share__ref7 = Object(preact_min["h"])(Image["a" /* default */], {
  className: "shareLogo",
  src: twitterIcon,
  alt: "Twitter Icon"
});

var Share__ref8 = Object(preact_min["h"])(Image["a" /* default */], {
  className: "shareLogo",
  src: linkedInIcon,
  alt: "LinkedIn Icon"
});

var Share__ref9 = Object(preact_min["h"])("div", null);

var Share_Share = function (_Component) {
  Share__inherits(Share, _Component);

  function Share() {
    Share__classCallCheck(this, Share);

    var _this = Share__possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      open: false,
      copied: false
    };
    _this.shareClicked = _this.shareClicked.bind(_this);
    _this.closeClicked = _this.closeClicked.bind(_this);
    _this.killClick = _this.killClick.bind(_this);
    return _this;
  }

  Share.prototype.killClick = function killClick(evt) {
    evt.stopPropagation();
    evt.preventDefault();
  };

  Share.prototype.shareClicked = function shareClicked(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    this.setState({
      open: true
    });
  };

  Share.prototype.closeClicked = function closeClicked(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    this.setState({
      open: false
    });
  };

  Share.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        open = _state.open,
        copied = _state.copied;
    var _props = this.props,
        iconPosition = _props.iconPosition,
        eventLink = _props.eventLink,
        _props$icon = _props.icon,
        icon = _props$icon === undefined ? true : _props$icon;


    var textPosition = copied ? "385px" : "404px";
    return Object(preact_min["h"])(
      "div",
      { style: iconPosition },
      icon ? Object(preact_min["h"])(
        "button",
        { onClick: this.shareClicked },
        Share__ref
      ) : Object(preact_min["h"])(
        components_Button["a" /* default */],
        { type: "primary", onClick: this.shareClicked },
        "Share"
      ),
      open ? Object(preact_min["h"])(
        "div",
        { className: "fadeDiv", onClick: this.killClick },
        Share__ref2,
        Object(preact_min["h"])(
          "div",
          {
            className: "shareWrapper",
            style: window.innerWidth < 820 ? { top: window.innerHeight - 165 } : {}
          },
          Object(preact_min["h"])(
            "div",
            { className: "shareHeading" },
            Share__ref3,
            Object(preact_min["h"])(
              "button",
              {
                className: "closeButton",
                onClick: this.closeClicked,
                "aria-label": "Close button"
              },
              Share__ref4
            )
          ),
          Object(preact_min["h"])(
            "div",
            { className: "shareBody" },
            Object(preact_min["h"])(
              "div",
              { className: "iconWrapper" },
              Object(preact_min["h"])(
                "div",
                { className: "copyBubble" },
                Object(preact_min["h"])(
                  react_copy_to_clipboard_lib["CopyToClipboard"],
                  { text: eventLink },
                  Share__ref5
                )
              ),
              Object(preact_min["h"])(
                "button",
                {
                  className: "buttonSocial",
                  onClick: function onClick() {
                    return window.open("http://www.facebook.com/sharer.php?u=" + eventLink, "_blank");
                  },
                  "aria-label": "Share - Facebook"
                },
                Share__ref6
              ),
              Object(preact_min["h"])(
                "button",
                {
                  className: "buttonSocial",
                  onClick: function onClick() {
                    return window.open("https://twitter.com/share?url=" + eventLink + "&amp;hashtags=humanitix", "_blank");
                  },
                  "aria-label": "Share - Twitter"
                },
                Share__ref7
              ),
              Object(preact_min["h"])(
                "button",
                {
                  className: "buttonSocial",
                  onClick: function onClick() {
                    return window.open("https://www.linkedin.com/sharing/share-offsite/?url=" + eventLink, "_blank");
                  },
                  "aria-label": "Share - Linked In"
                },
                Share__ref8
              )
            ),
            Object(preact_min["h"])(
              "div",
              { className: "copySection" },
              Object(preact_min["h"])("input", {
                className: "linkBox",
                type: "text",
                value: eventLink,
                readonly: true
              }),
              Object(preact_min["h"])(
                react_copy_to_clipboard_lib["CopyToClipboard"],
                {
                  text: eventLink,
                  onCopy: function onCopy() {
                    return _this2.setState({ copied: true });
                  }
                },
                Object(preact_min["h"])(
                  "button",
                  {
                    className: "copyButton",
                    style: {
                      left: "" + textPosition,
                      color: copied ? "#5A626C" : "#6621c0"
                    },
                    "aria-label": "Copy Button",
                    "aria-hidden": true
                  },
                  copied ? "Copied" : "Copy"
                )
              )
            )
          )
        )
      ) : Share__ref9
    );
  };

  return Share;
}(preact_compat_es["Component"]);

/* harmony default export */ var components_Share = (Share_Share);
// CONCATENATED MODULE: ./components/TabBar.js
var TabBar__templateObject = TabBar__taggedTemplateLiteralLoose(["\n  border-bottom: solid 2px #dedede;\n  margin-bottom: 24px;\n  height: 27px;\n  @media (max-width: 700px) {\n    height: 24px;\n  }\n"], ["\n  border-bottom: solid 2px #dedede;\n  margin-bottom: 24px;\n  height: 27px;\n  @media (max-width: 700px) {\n    height: 24px;\n  }\n"]),
    TabBar__templateObject2 = TabBar__taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  margin-bottom: 0;\n  margin-top: 0;\n"], ["\n  list-style-type: none;\n  margin-bottom: 0;\n  margin-top: 0;\n"]),
    TabBar__templateObject3 = TabBar__taggedTemplateLiteralLoose(["\n  display: inline-block;\n  margin-right: 32px;\n  cursor: pointer;\n  margin-top: 0;\n"], ["\n  display: inline-block;\n  margin-right: 32px;\n  cursor: pointer;\n  margin-top: 0;\n"]),
    TabBar__templateObject4 = TabBar__taggedTemplateLiteralLoose(["\n  ", ";\n  border-bottom: 3px solid #2074d9;\n"], ["\n  ", ";\n  border-bottom: 3px solid #2074d9;\n"]),
    TabBar__templateObject5 = TabBar__taggedTemplateLiteralLoose(["\n  color: #323232;\n  &:hover {\n    color: #6621c0;\n    text-decoration: none;\n  }\n"], ["\n  color: #323232;\n  &:hover {\n    color: #6621c0;\n    text-decoration: none;\n  }\n"]),
    TabBar__templateObject6 = TabBar__taggedTemplateLiteralLoose(["\n  ", ";\n  font-weight: 600;\n  color: #2074d9;\n  &:hover {\n    color: #2074d9;\n  }\n"], ["\n  ", ";\n  font-weight: 600;\n  color: #2074d9;\n  &:hover {\n    color: #2074d9;\n  }\n"]);



function TabBar__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }



var TabBar_wrapper = Object(index_esm["css"])(TabBar__templateObject);

var list = Object(index_esm["css"])(TabBar__templateObject2);
var listElement = Object(index_esm["css"])(TabBar__templateObject3);

var listElementActive = Object(index_esm["css"])(TabBar__templateObject4, listElement);

var TabBar_link = Object(index_esm["css"])(TabBar__templateObject5);

var linkActive = Object(index_esm["css"])(TabBar__templateObject6, TabBar_link);

var TabBar_TabBar = function TabBar(_ref) {
  var options = _ref.options,
      selected = _ref.selected,
      changeTab = _ref.changeTab;

  return Object(preact_min["h"])(
    "div",
    { className: TabBar_wrapper },
    Object(preact_min["h"])(
      "ul",
      { className: list },
      options.map(function (option, i) {
        var isSelected = option.value === selected;
        return Object(preact_min["h"])(
          "li",
          {
            key: i,
            className: isSelected ? listElementActive : listElement,
            onClick: function onClick() {
              return changeTab(option.value);
            }
          },
          Object(preact_min["h"])(
            "a",
            { className: isSelected ? linkActive : TabBar_link },
            option.label
          )
        );
      })
    )
  );
};

/* harmony default export */ var components_TabBar = (TabBar_TabBar);
// CONCATENATED MODULE: ./routes/organiser/OrganiserEvents.js
var OrganiserEvents__templateObject = OrganiserEvents__taggedTemplateLiteralLoose(["\n  border: none;\n  background-color: #6621c0;\n  border-radius: 4px;\n  margin: 6px;\n  color: #fff;\n  padding: 0px 14px;\n"], ["\n  border: none;\n  background-color: #6621c0;\n  border-radius: 4px;\n  margin: 6px;\n  color: #fff;\n  padding: 0px 14px;\n"]),
    OrganiserEvents__templateObject2 = OrganiserEvents__taggedTemplateLiteralLoose(["\n  border: none;\n  background-color: #c7c7c7;\n  border-radius: 4px;\n  margin: 6px;\n  color: #323232;\n  padding: 0px 14px;\n"], ["\n  border: none;\n  background-color: #c7c7c7;\n  border-radius: 4px;\n  margin: 6px;\n  color: #323232;\n  padding: 0px 14px;\n"]),
    OrganiserEvents__templateObject3 = OrganiserEvents__taggedTemplateLiteralLoose(["\n    max-width: ", ";\n    height: 148px;\n    background-color: #fff;\n    margin-bottom: 12px;\n    border-radius: 4px;\n    box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n    padding: 24px 20px;\n    position: relative;\n    @media (max-width: 800px) {\n      padding: 0px;\n      min-height: 339px;\n      height: auto;\n    }\n  "], ["\n    max-width: ", ";\n    height: 148px;\n    background-color: #fff;\n    margin-bottom: 12px;\n    border-radius: 4px;\n    box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n    padding: 24px 20px;\n    position: relative;\n    @media (max-width: 800px) {\n      padding: 0px;\n      min-height: 339px;\n      height: auto;\n    }\n  "]),
    OrganiserEvents__templateObject4 = OrganiserEvents__taggedTemplateLiteralLoose(["\n    float: left;\n    margin-right: 16px;\n    @media (max-width: 800px) {\n      float: none;\n      display: block;\n      margin-right: 0;\n    }\n  "], ["\n    float: left;\n    margin-right: 16px;\n    @media (max-width: 800px) {\n      float: none;\n      display: block;\n      margin-right: 0;\n    }\n  "]),
    OrganiserEvents__templateObject5 = OrganiserEvents__taggedTemplateLiteralLoose(["\n    width: 200px;\n    height: 100px;\n    border-radius: 4px;\n    @media (max-width: 800px) {\n      width: 100%;\n      height: auto;\n      border-bottom-left-radius: 0px;\n      border-bottom-right-radius: 0px;\n    }\n  "], ["\n    width: 200px;\n    height: 100px;\n    border-radius: 4px;\n    @media (max-width: 800px) {\n      width: 100%;\n      height: auto;\n      border-bottom-left-radius: 0px;\n      border-bottom-right-radius: 0px;\n    }\n  "]),
    OrganiserEvents__templateObject6 = OrganiserEvents__taggedTemplateLiteralLoose(["\n    float: left;\n    max-width: 350px;\n    @media (max-width: 800px) {\n      float: none;\n      display: block;\n      padding: 10px 8px;\n    }\n  "], ["\n    float: left;\n    max-width: 350px;\n    @media (max-width: 800px) {\n      float: none;\n      display: block;\n      padding: 10px 8px;\n    }\n  "]),
    OrganiserEvents__templateObject7 = OrganiserEvents__taggedTemplateLiteralLoose(["\n    display: none;\n    @media (max-width: 800px) {\n      display: block;\n      height: 2px;\n      border-bottom: 2px solid #f7faff;\n      margin-bottom: 12px;\n    }\n  "], ["\n    display: none;\n    @media (max-width: 800px) {\n      display: block;\n      height: 2px;\n      border-bottom: 2px solid #f7faff;\n      margin-bottom: 12px;\n    }\n  "]);



function OrganiserEvents__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }













var OrganiserEvents_ticketingUrl = Object(config["a" /* default */])("TICKETING_URL");

var OrganiserEvents_button = Object(index_esm["css"])(OrganiserEvents__templateObject);

var buttonDisabled = Object(index_esm["css"])(OrganiserEvents__templateObject2);

var noEventResults = Object(index_esm["css"])({
  maxHeight: 100
});

var OrganiserEvents_EventRow = function EventRow(event, maxWidth) {
  var card = Object(index_esm["css"])(OrganiserEvents__templateObject3, maxWidth);
  var imgWrapper = Object(index_esm["css"])(OrganiserEvents__templateObject4);

  var cardImg = Object(index_esm["css"])(OrganiserEvents__templateObject5);

  var textWrapper = Object(index_esm["css"])(OrganiserEvents__templateObject6);
  var divider = Object(index_esm["css"])(OrganiserEvents__templateObject7);

  var datesWrapper = Object(index_esm["css"])({
    fontSize: 14,
    color: "#5a626c",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipses"
  });

  var priceText = Object(index_esm["css"])({
    marginBottom: 2,
    fontSize: 14,
    color: "#5a626c"
  });

  var description = Object(index_esm["css"])({
    "@media(max-width:800px)": {
      minHeight: 156
    }
  });

  var eventName = Object(index_esm["css"])({
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 400,
    fontSize: 18,
    color: "#323232",
    fontWeight: 600,
    marginBottom: 8
  });

  var addressWrapper = Object(index_esm["css"])({
    marginBottom: 2,
    fontSize: 14,
    color: "#5a626c"
  });

  var image = "https://process.filestackapi.com/VbieTVjAQvq5BTkE9vIi";
  if (event.event.featureImage) {
    image = event.event.featureImage.url;
  }
  if (event.event.bannerImage) {
    image = event.event.bannerImage.url;
  }
  var address = "";
  if (event.event.location && event.event.location.address) {
    address = event.event.location.address;
    if (event.event.location.address.length > 40) {
      address = event.event.location.address.substring(0, 40) + "...";
    }
  }
  if (event.event.published) {
    return Object(preact_min["h"])(
      "a",
      {
        href: Object(config["a" /* default */])("TICKETING_URL") + "/" + event.event.slug,
        target: "_blank",
        style: { color: "#323232" }
      },
      Object(preact_min["h"])(
        "div",
        { className: card },
        Object(preact_min["h"])(
          "div",
          { className: imgWrapper },
          Object(preact_min["h"])(Image["a" /* default */], {
            src: image,
            className: cardImg,
            alt: event.event.name + " event image"
          })
        ),
        Object(preact_min["h"])(
          "div",
          { className: textWrapper },
          Object(preact_min["h"])(
            "div",
            { className: description },
            Object(preact_min["h"])(
              "h3",
              { className: eventName },
              event.event.name
            ),
            Object(preact_min["h"])(
              "div",
              { className: datesWrapper },
              Object(preact_min["h"])(DatesDisplay["a" /* default */], { dates: event.event.dates, singleLine: true })
            ),
            Object(preact_min["h"])(
              "p",
              { className: addressWrapper },
              address
            )
          ),
          Object(preact_min["h"])(
            "p",
            { className: priceText },
            event.event.ticketsPriceStr
          )
        )
      )
    );
  } else {
    return null;
  }
};

var OrganiserEvents__ref2 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var OrganiserEvents__ref3 = Object(preact_min["h"])(
  "div",
  { className: noEventResults },
  Object(preact_min["h"])(components_EventError, { type: "noEvents" })
);

var OrganiserEvents_OrganiserEvents = function OrganiserEvents(_ref) {
  var _ref$events = _ref.events,
      events = _ref$events === undefined ? [] : _ref$events,
      nextPage = _ref.nextPage,
      previousPage = _ref.previousPage,
      changeTab = _ref.changeTab,
      tab = _ref.tab,
      page = _ref.page,
      numEvents = _ref.numEvents,
      size = _ref.size,
      loadingEvents = _ref.loadingEvents,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === undefined ? "700px" : _ref$maxWidth;

  var eventsPerPage = 20;
  if (!events) {
    return Object(preact_min["h"])("div", { style: { maxWidth: maxWidth }, id: "event-list-" + size });
  }
  var firstPage = page === 0;
  var lastPage = (page + 1) * eventsPerPage >= numEvents;
  return Object(preact_min["h"])(
    "div",
    {
      style: { maxWidth: maxWidth },
      id: "event-list-" + size,
      className: "clear-fix"
    },
    loadingEvents ? OrganiserEvents__ref2 : "",
    events.length === 0 && !loadingEvents ? OrganiserEvents__ref3 : null,
    !loadingEvents && events.map(function (event) {
      return Object(preact_min["h"])(OrganiserEvents_EventRow, { event: event, maxWidth: maxWidth });
    }),
    numEvents <= eventsPerPage ? null : Object(preact_min["h"])(
      "div",
      { style: { float: "right" } },
      Object(preact_min["h"])(
        "button",
        {
          className: firstPage ? buttonDisabled : OrganiserEvents_button,
          onClick: previousPage,
          "aria-label": "Previous"
        },
        "Prev"
      ),
      Object(preact_min["h"])(
        "button",
        {
          className: lastPage ? buttonDisabled : OrganiserEvents_button,
          onClick: lastPage ? null : nextPage,
          "aria-label": "Next"
        },
        "Next"
      )
    )
  );
};

/* harmony default export */ var organiser_OrganiserEvents = (OrganiserEvents_OrganiserEvents);
// EXTERNAL MODULE: ./utils/ScrollTo.js
var ScrollTo = __webpack_require__("2PS8");

// EXTERNAL MODULE: ./utils/BrowserUtils.js
var BrowserUtils = __webpack_require__("WCoG");

// CONCATENATED MODULE: ./routes/organiser/OrganiserSocial.js
var OrganiserSocial__templateObject = OrganiserSocial__taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-width: 280px;\n    border-radius: 4px;\n    background-color: #ffffff;\n    padding: 24px;\n    @media (max-width: 600px) {\n      max-width: 100%;\n    }\n  "], ["\n    width: 100%;\n    max-width: 280px;\n    border-radius: 4px;\n    background-color: #ffffff;\n    padding: 24px;\n    @media (max-width: 600px) {\n      max-width: 100%;\n    }\n  "]),
    OrganiserSocial__templateObject2 = OrganiserSocial__taggedTemplateLiteralLoose(["\n    margin: 0 12px;\n  "], ["\n    margin: 0 12px;\n  "]),
    OrganiserSocial__templateObject3 = OrganiserSocial__taggedTemplateLiteralLoose(["\n    width: 32px;\n  "], ["\n    width: 32px;\n  "]);



function OrganiserSocial__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }






var fbIcon = __webpack_require__("iVZy");
var OrganiserSocial_twitterIcon = __webpack_require__("QTOC");
var instagramIcon = __webpack_require__("0U4Q");
var OrganiserSocial_linkedInIcon = __webpack_require__("gwPP");

var OrganiserSocial_styles = {
  wrapper: Object(index_esm["css"])(OrganiserSocial__templateObject),
  link: Object(index_esm["css"])(OrganiserSocial__templateObject2),
  icon: Object(index_esm["css"])(OrganiserSocial__templateObject3)
};

var OrganiserSocial_OrganiserSocial = function OrganiserSocial(_ref) {
  var twitter = _ref.twitter,
      facebook = _ref.facebook,
      instagram = _ref.instagram,
      linkedIn = _ref.linkedIn;

  return Object(preact_min["h"])(
    "div",
    { className: OrganiserSocial_styles.wrapper },
    facebook ? Object(preact_min["h"])(
      "a",
      {
        href: services_OrganiserService.sanitiseURLs(facebook),
        className: OrganiserSocial_styles.link,
        target: "_blank"
      },
      Object(preact_min["h"])(Image["a" /* default */], { src: fbIcon, alt: "Facebook Icon", className: OrganiserSocial_styles.icon })
    ) : null,
    twitter ? Object(preact_min["h"])(
      "a",
      {
        href: services_OrganiserService.sanitiseURLs(twitter),
        className: OrganiserSocial_styles.link,
        target: "_blank"
      },
      Object(preact_min["h"])(Image["a" /* default */], { src: OrganiserSocial_twitterIcon, alt: "Twitter Icon", className: OrganiserSocial_styles.icon })
    ) : null,
    instagram ? Object(preact_min["h"])(
      "a",
      {
        href: services_OrganiserService.sanitiseURLs(instagram),
        className: OrganiserSocial_styles.link,
        target: "_blank"
      },
      Object(preact_min["h"])(Image["a" /* default */], {
        src: instagramIcon,
        alt: "Instagram Icon",
        className: OrganiserSocial_styles.icon
      })
    ) : null,
    linkedIn ? Object(preact_min["h"])(
      "a",
      {
        href: services_OrganiserService.sanitiseURLs(linkedIn),
        className: OrganiserSocial_styles.link,
        target: "_blank"
      },
      Object(preact_min["h"])(Image["a" /* default */], {
        src: OrganiserSocial_linkedInIcon,
        alt: "Linked In Icon",
        className: OrganiserSocial_styles.icon
      })
    ) : null
  );
};

/* harmony default export */ var organiser_OrganiserSocial = (OrganiserSocial_OrganiserSocial);
// CONCATENATED MODULE: ./routes/organiser/Organiser.js
var Organiser__templateObject = Organiser__taggedTemplateLiteralLoose(["\n  background-color: #f9f9fa;\n"], ["\n  background-color: #f9f9fa;\n"]),
    Organiser__templateObject2 = Organiser__taggedTemplateLiteralLoose(["\n  max-width: 1000px;\n  display: block;\n  width: 100%;\n  margin: 0 auto;\n  padding-bottom: 38px;\n  background-color: #f9f9fa;\n  &:after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n\n  @media (max-width: 1000px) {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n"], ["\n  max-width: 1000px;\n  display: block;\n  width: 100%;\n  margin: 0 auto;\n  padding-bottom: 38px;\n  background-color: #f9f9fa;\n  &:after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n\n  @media (max-width: 1000px) {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n"]),
    Organiser__templateObject3 = Organiser__taggedTemplateLiteralLoose(["\n  display: flex;\n  @media (max-width: 760px) {\n    display: none;\n  }\n"], ["\n  display: flex;\n  @media (max-width: 760px) {\n    display: none;\n  }\n"]),
    Organiser__templateObject4 = Organiser__taggedTemplateLiteralLoose(["\n  max-width: 280px;\n  margin-right: 20px;\n"], ["\n  max-width: 280px;\n  margin-right: 20px;\n"]),
    Organiser__templateObject5 = Organiser__taggedTemplateLiteralLoose(["\n  max-width: 700px;\n  width: 100%;\n"], ["\n  max-width: 700px;\n  width: 100%;\n"]),
    Organiser__templateObject6 = Organiser__taggedTemplateLiteralLoose(["\n  background-color: #f9f9fa;\n  display: none;\n  @media (max-width: 760px) {\n    display: block;\n  }\n"], ["\n  background-color: #f9f9fa;\n  display: none;\n  @media (max-width: 760px) {\n    display: block;\n  }\n"]);



function Organiser__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Organiser__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Organiser__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Organiser__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

















var content = Object(index_esm["css"])(Organiser__templateObject);

var Organiser_wrapperDiv = Object(index_esm["css"])(Organiser__templateObject2);

var Organiser_desktop = Object(index_esm["css"])(Organiser__templateObject3);

var left = Object(index_esm["css"])(Organiser__templateObject4);
var right = Object(index_esm["css"])(Organiser__templateObject5);

var Organiser_mobile = Object(index_esm["css"])(Organiser__templateObject6);
var eventsWrapper = Object(index_esm["css"])({
  marginBottom: 60,
  "@media(max-width: 800px)": {
    marginBottom: 24
  }
});

var Organiser_Organiser = function (_Component) {
  Organiser__inherits(Organiser, _Component);

  function Organiser(props) {
    Organiser__classCallCheck(this, Organiser);

    var _this = Organiser__possibleConstructorReturn(this, _Component.call(this, props));

    _this.nextPage = _this.nextPage.bind(_this);
    _this.previousPage = _this.previousPage.bind(_this);
    _this.switchTab = _this.switchTab.bind(_this);
    _this.loadPage = _this.loadPage.bind(_this);
    return _this;
  }

  Organiser.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        organiserId = _props.organiserId,
        getOrganiser = _props.getOrganiser,
        organiser = _props.organiser;

    getOrganiser(organiserId);
    this.loadPage(organiser.tab, 0);
  };

  Organiser.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    var organiser = this.props.organiser;

    if (organiser.organiser) {
      Object(BrowserUtils["a" /* pageChange */])(organiser.organiser.name);
    }
  };

  Organiser.prototype.nextPage = function nextPage() {
    var organiser = this.props.organiser;

    var tab = organiser.tab;
    var eventList = tab === "live" ? organiser.liveEvents : organiser.pastEvents;
    var page = eventList.page;
    this.scrollToList();
    this.loadPage(tab, page + 1);
  };

  Organiser.prototype.previousPage = function previousPage() {
    var organiser = this.props.organiser;

    var tab = organiser.tab;
    var eventList = tab === "live" ? organiser.liveEvents : organiser.pastEvents;
    var page = eventList.page;
    if (page !== 0) {
      this.scrollToList();
      this.loadPage(tab, page - 1);
    }
  };

  Organiser.prototype.scrollToList = function scrollToList() {
    var size = window.innerWidth < 600 ? "small" : "large";
    Object(ScrollTo["a" /* scrollToId */])("event-list-" + size, 0, 0);
  };

  Organiser.prototype.switchTab = function switchTab(tab) {
    var changeTab = this.props.changeTab;

    changeTab(tab);
    this.loadPage(tab);
  };

  Organiser.prototype.loadPage = function loadPage(tab, page) {
    var _props2 = this.props,
        organiserId = _props2.organiserId,
        organiser = _props2.organiser,
        loadLiveEventsByOrganiser = _props2.loadLiveEventsByOrganiser,
        loadPastEventsByOrganiser = _props2.loadPastEventsByOrganiser;

    var loadAction = loadPastEventsByOrganiser;
    var eventList = organiser.pastEvent;
    if (tab === "live") {
      loadAction = loadLiveEventsByOrganiser;
      eventList = organiser.liveEvent;
    }
    var loadPage = page !== null ? page : eventList.page;

    loadAction(organiserId, loadPage, tab);
  };

  Organiser.prototype.render = function render() {
    var _this2 = this;

    var _props$organiser = this.props.organiser,
        organiser = _props$organiser.organiser,
        tab = _props$organiser.tab,
        liveEvents = _props$organiser.liveEvents,
        pastEvents = _props$organiser.pastEvents;

    var eventList = tab === "live" ? liveEvents : pastEvents;
    var Info = function Info() {
      return Object(preact_min["h"])(organiser_OrganiserInfo, {
        name: organiser.name,
        description: organiser.description,
        twitter: organiser.twitter,
        facebook: organiser.facebook,
        instagram: organiser.instagram
      });
    };

    var EventsList = function EventsList(_ref) {
      var size = _ref.size;

      return Object(preact_min["h"])(organiser_OrganiserEvents, {
        events: eventList.events,
        nextPage: _this2.nextPage,
        previousPage: _this2.previousPage,
        tab: tab,
        changeTab: _this2.switchTab,
        page: eventList.page,
        numEvents: eventList.total,
        loadingEvents: eventList.loading,
        size: size
      });
    };

    if (organiser) {
      var logoUrl = organiser.logo ? organiser.logo.url : null;
      return Object(preact_min["h"])(
        "div",
        { className: content },
        Object(preact_min["h"])(
          "div",
          { className: Organiser_wrapperDiv },
          Object(preact_min["h"])(organiser_OrganiserBanner, {
            backgroundColor: organiser.bannerBackground,
            logo: logoUrl,
            name: organiser.name,
            website: organiser.website
          }),
          Object(preact_min["h"])(
            "div",
            { className: Organiser_desktop },
            Object(preact_min["h"])(
              "div",
              { className: left },
              Object(preact_min["h"])(Info, null),
              Object(preact_min["h"])(organiser_OrganiserSocial, {
                twitter: organiser.twitter,
                facebook: organiser.facebook,
                instagram: organiser.instagram,
                linkedIn: organiser.linkedIn
              })
            ),
            Object(preact_min["h"])(
              "div",
              { className: right },
              Object(preact_min["h"])(EventsList, { size: "large" })
            )
          ),
          Object(preact_min["h"])(
            "div",
            { className: Organiser_mobile },
            Object(preact_min["h"])(Info, null),
            Object(preact_min["h"])(
              "div",
              { className: eventsWrapper },
              Object(preact_min["h"])(EventsList, { size: "small" })
            ),
            Object(preact_min["h"])(organiser_OrganiserSocial, {
              twitter: organiser.twitter,
              facebook: organiser.facebook,
              instagram: organiser.instagram,
              linkedIn: organiser.linkedIn
            })
          )
        )
      );
    }
  };

  return Organiser;
}(preact_min["Component"]);

/* harmony default export */ var organiser_Organiser = (Object(es["b" /* connect */])(function (state, ownProps) {
  return { organiser: state.organiser };
}, {
  getOrganiser: organiserActions_getOrganiser,
  loadLiveEventsByOrganiser: organiserActions_loadLiveEventsByOrganiser,
  loadPastEventsByOrganiser: organiserActions_loadPastEventsByOrganiser,
  changeTab: organiserActions_changeTab
})(Organiser_Organiser));
// CONCATENATED MODULE: ./routes/noEvent/NoEvent.js


function NoEvent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NoEvent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NoEvent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var NoEvent__ref = Object(preact_min["h"])(
  Page["a" /* default */],
  { border: false },
  Object(preact_min["h"])(
    Content["a" /* default */],
    null,
    Object(preact_min["h"])(components_EventError, { type: "notFound" })
  )
);

var NoEvent = function (_Component) {
  NoEvent__inherits(NoEvent, _Component);

  function NoEvent() {
    NoEvent__classCallCheck(this, NoEvent);

    return NoEvent__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  NoEvent.prototype.render = function render() {
    return NoEvent__ref;
  };

  return NoEvent;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/BookingHeader.js + 2 modules
var BookingHeader = __webpack_require__("mUiR");

// EXTERNAL MODULE: ./components/TwoCols.js
var TwoCols = __webpack_require__("+QT2");

// EXTERNAL MODULE: ./components/fields/InputField.js
var InputField = __webpack_require__("5XUh");

// EXTERNAL MODULE: ./assets/images/icon-cross.svg
var icon_cross = __webpack_require__("CLzQ");
var icon_cross_default = /*#__PURE__*/__webpack_require__.n(icon_cross);

// EXTERNAL MODULE: ./assets/images/icon-success.svg
var icon_success = __webpack_require__("Wjl/");
var icon_success_default = /*#__PURE__*/__webpack_require__.n(icon_success);

// CONCATENATED MODULE: ./components/DiscountCode.js


function DiscountCode__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DiscountCode__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function DiscountCode__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var DiscountCode_DiscountCode = function (_Component) {
  DiscountCode__inherits(DiscountCode, _Component);

  function DiscountCode(props) {
    DiscountCode__classCallCheck(this, DiscountCode);

    var _this = DiscountCode__possibleConstructorReturn(this, _Component.call(this, props));

    _this.save = function (values) {
      var _this$props = _this.props,
          addDiscount = _this$props.addDiscount,
          order = _this$props.order,
          event = _this$props.event;

      var code = values.discountCode;
      if (code) {
        addDiscount(event.data._id, order.data._id, values.discountCode);
      }
    };

    _this.remove = function () {
      var _this$props2 = _this.props,
          removeDiscount = _this$props2.removeDiscount,
          order = _this$props2.order;

      removeDiscount(order.data._id);
    };

    _this.state = {};
    return _this;
  }

  DiscountCode.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        initialCode = _props.initialCode,
        addDiscount = _props.addDiscount,
        order = _props.order,
        event = _props.event;

    if (initialCode) {
      // addDiscount(event.data._id, order.data._id, initialCode);
    }
  };

  DiscountCode.prototype.render = function render() {
    var _props2 = this.props,
        event = _props2.event,
        order = _props2.order,
        _props2$allowAdd = _props2.allowAdd,
        allowAdd = _props2$allowAdd === undefined ? false : _props2$allowAdd,
        ticketSelection = _props2.ticketSelection,
        handleSubmit = _props2.handleSubmit,
        initialCode = _props2.initialCode;

    var discountCodeStyle = {
      background: "url(" + icon_success_default.a + ") no-repeat left 5px center",
      backgroundSize: 20,
      color: "#157e77",
      margin: "0",
      padding: "4px 0 4px 28px",
      display: "inline-block",
      fontWeight: 600
    };
    var removeStyle = {
      background: "url(" + icon_cross_default.a + ") no-repeat right 5px center",
      backgroundSize: 20,
      paddingLeft: 30,
      cursor: "pointer",
      float: "right",
      height: 30
    };
    var discountStyle = {
      paddingTop: 12,
      paddingBottom: 12,
      marginBottom: 24,
      borderBottom: "1px solid #dedede"
    };
    var discountDisplay = false;
    var ticketsWithCodes = order.data && order.data.tickets ? order.data.tickets.filter(function (t) {
      // only show discount codes not auto discounts
      var codeDiscounts = t.discountCodes ? t.discountCodes.filter(function (d) {
        return d.type !== "auto";
      }) : [];
      if (codeDiscounts.length) {
        return true;
      }
      return false;
    }) : false;
    var ticketWithCodes = ticketsWithCodes && ticketsWithCodes.length ? ticketsWithCodes[0] : false;
    var discountCode = ticketWithCodes ? ticketWithCodes.discountCodes.filter(function (d) {
      return d.type !== "auto";
    })[0] : false;
    if (allowAdd && discountCode) {
      discountDisplay = Object(preact_min["h"])(
        "span",
        null,
        "Discount code:",
        " ",
        Object(preact_min["h"])(
          "span",
          { style: discountCodeStyle },
          discountCode.code
        ),
        Object(preact_min["h"])("a", { onClick: this.remove, style: removeStyle })
      );
    }

    if (!allowAdd && discountCode) {
      discountDisplay = Object(preact_min["h"])(
        "span",
        null,
        "Discount code: ",
        discountCode.code
      );
    }

    if (discountDisplay) {
      return Object(preact_min["h"])(
        "div",
        { style: discountStyle },
        discountDisplay
      );
    }

    return allowAdd && event && event.data && event.data.hasDiscounts ? Object(preact_min["h"])(
      "div",
      { style: discountStyle },
      Object(preact_min["h"])(
        "form",
        { onSubmit: handleSubmit(this.save) },
        Object(preact_min["h"])(
          "div",
          { style: { display: "flex" } },
          Object(preact_min["h"])(redux_form_es["a" /* Field */], {
            style: {
              width: "80%"
            },
            inputStyle: {
              borderRadius: "4px 0 0 4px"
            },
            type: "text",
            name: "discountCode",
            label: "Enter discount code",
            component: InputField["a" /* default */],
            placeholder: "Discount Code"
          }),
          Object(preact_min["h"])(
            ActionButton["a" /* default */],
            {
              loading: order.addDiscountRequest.loading,
              classNames: "btn-secondary",
              dataCY: "DiscountCodeApply",
              style: {
                borderRadius: "0 4px 4px 0",
                padding: "4px 10px",
                marginTop: 24,
                minWidth: 90
              }
            },
            "Apply"
          )
        ),
        order.addDiscountRequest.error ? Object(preact_min["h"])(
          "p",
          { "class": "text-error error-icon" },
          order.addDiscountRequest.error
        ) : ""
      )
    ) : "";
  };

  return DiscountCode;
}(preact_min["Component"]);

DiscountCode_DiscountCode = Object(redux_form_es["f" /* reduxForm */])({
  form: "discountCode"
})(DiscountCode_DiscountCode);

/* harmony default export */ var components_DiscountCode = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order
  };
}, { addDiscount: orderActions["K" /* addDiscount */], removeDiscount: orderActions["Y" /* removeDiscount */] })(DiscountCode_DiscountCode));
// CONCATENATED MODULE: ./components/OrderCharityMsg.js




var container = Object(index_esm["css"])({
  display: "flex"
});

var charityStyle = Object(index_esm["css"])({
  borderRadius: 44,
  width: 44,
  height: 44,
  minWidth: 44,
  margin: "0 16px 0 0"
});

var OrderCharityMsg_OrderCharityMsg = function OrderCharityMsg(_ref) {
  var charity = _ref.charity;

  if (!charity) {
    return null;
  }
  var charityUrl = "https://cdn.filestackcontent.com/resize=width:150/" + charity.logo.handle;
  var charityBg = Object(index_esm["css"])({
    background: "url(" + charityUrl + ") no-repeat center",
    backgroundSize: "cover"
  });
  return Object(preact_min["h"])(
    "div",
    { className: container },
    Object(preact_min["h"])("div", { className: Object(index_esm["css"])([charityStyle, charityBg]) }),
    Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        "h4",
        { style: { fontWeight: 600, margin: 0 } },
        "Thank you!"
      ),
      Object(preact_min["h"])(
        "p",
        { style: { margin: 0 } },
        "100% of profits from Humanitix fees are funding",
        " ",
        Object(preact_min["h"])(
          "a",
          {
            style: { textDecoration: "underline" },
            href: charity.website,
            target: "_blank"
          },
          charity.name
        )
      )
    )
  );
};
/* harmony default export */ var components_OrderCharityMsg = (OrderCharityMsg_OrderCharityMsg);
// CONCATENATED MODULE: ./components/YourOrder.js
var YourOrder__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function YourOrder__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function YourOrder__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function YourOrder__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var YourOrder_feesStr = Object(index_esm["css"])({
  color: "#5A626C",
  fontSize: 11,
  fontWeight: "normal"
});
var yourOrder = Object(index_esm["css"])({
  background: "#F7FAFF",
  marginBottom: 24,
  borderRadius: 4,
  boxShadow: "0 1px 4px 0 rgba(32, 7, 64, 0.13)",
  backgroundColor: "#f9f9fa",
  "@media(max-width:600px)": {
    ".table th": {
      padding: "9px 12px"
    },
    ".table td": {
      padding: "9px 12px"
    }
  },
  h3: {
    margin: 0
  }
});

var yourOrderHeading = Object(index_esm["css"])({
  padding: 18,
  "@media(max-width:600px)": {
    padding: 12
  }
});

var YourOrder_YourOrderWrapper = function (_Component) {
  YourOrder__inherits(YourOrderWrapper, _Component);

  function YourOrderWrapper() {
    var _temp, _this, _ret;

    YourOrder__classCallCheck(this, YourOrderWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = YourOrder__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.eventLoad = function () {
      var _this$props = _this.props,
          event = _this$props.event,
          ticketSelection = _this$props.ticketSelection,
          loadSummary = _this$props.loadSummary,
          order = _this$props.order,
          merchandise = _this$props.merchandise;

      var tickets = ticketSelection.requestedTickets ? ticketSelection.requestedTickets : ticketSelection.tickets;
      var clientDonation = order && order.data ? order.data.clientDonation : 0;
      loadSummary(event.id, tickets, clientDonation, order, merchandise.merch.display);
    }, _this.globalLoad = function () {
      var _this$props2 = _this.props,
          loadSummary = _this$props2.loadSummary,
          giftCards = _this$props2.giftCards;
      var giftCardPage = giftCards.giftCardPage,
          giftCardsOrder = giftCards.giftCardsOrder;

      loadSummary(giftCardPage.userId, [], 0, {}, [], giftCardsOrder, false);
    }, _temp), YourOrder__possibleConstructorReturn(_this, _ret);
  }

  YourOrderWrapper.prototype.render = function render() {
    var isGlobal = this.props.isGlobal;

    var load = isGlobal ? this.globalLoad : this.eventLoad;
    return Object(preact_min["h"])(YourOrder_YourOrder, YourOrder__extends({ load: load }, this.props));
  };

  return YourOrderWrapper;
}(preact_min["Component"]);

var YourOrder__ref2 = Object(preact_min["h"])(
  "h2",
  null,
  "Your order"
);

var YourOrder__ref3 = Object(preact_min["h"])(components_DiscountCode, { allowAdd: false });

var YourOrder__ref4 = Object(preact_min["h"])(
  "span",
  { className: YourOrder_feesStr },
  "inc GST"
);

var YourOrder__ref5 = Object(preact_min["h"])(
  "th",
  null,
  "Donation"
);

var YourOrder__ref6 = Object(preact_min["h"])(
  "th",
  null,
  "Subtotal"
);

var YourOrder__ref7 = Object(preact_min["h"])(
  "th",
  null,
  "Discounts"
);

var YourOrder__ref8 = Object(preact_min["h"])(
  "th",
  null,
  "Gift card"
);

var YourOrder__ref9 = Object(preact_min["h"])(
  "span",
  { className: YourOrder_feesStr },
  "inc GST"
);

var _ref10 = Object(preact_min["h"])(
  "td",
  null,
  Object(preact_min["h"])(
    "h3",
    null,
    "Total"
  )
);

var YourOrder_YourOrder = function (_Component2) {
  YourOrder__inherits(YourOrder, _Component2);

  function YourOrder() {
    YourOrder__classCallCheck(this, YourOrder);

    return YourOrder__possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  YourOrder.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        event = _props.event,
        orderSummary = _props.orderSummary,
        ticketSelection = _props.ticketSelection,
        load = _props.load;

    if (!orderSummary.loading && !orderSummary.data) {
      load();
    }
  };

  YourOrder.prototype.componentDidUpdate = function componentDidUpdate(perviousProps) {
    var _props2 = this.props,
        order = _props2.order,
        load = _props2.load;

    if (perviousProps.order && order && order.paymentMethod !== perviousProps.order.paymentMethod) {
      load();
    }
  };

  YourOrder.prototype.render = function render(_ref) {
    var orderSummary = _ref.orderSummary,
        order = _ref.order,
        event = _ref.event,
        _ref$allowDiscountsAd = _ref.allowDiscountsAdd,
        allowDiscountsAdd = _ref$allowDiscountsAd === undefined ? false : _ref$allowDiscountsAd,
        load = _ref.load;

    var currencyCode = Object(config["a" /* default */])("CURRENCY");
    var valueCel = {
      textAlign: "right"
    };
    if (orderSummary.error) {
      return Object(preact_min["h"])(
        "div",
        null,
        YourOrder__ref2,
        Object(preact_min["h"])(
          "p",
          null,
          orderSummary.error
        ),
        Object(preact_min["h"])(
          "button",
          { onClick: load, "class": "btn", "aria-label": "Retry button" },
          "Retry"
        )
      );
    }

    return Object(preact_min["h"])(
      "div",
      { className: yourOrder },
      event.data ? Object(preact_min["h"])(
        "div",
        { "class": "hide-mobile" },
        Object(preact_min["h"])(components_Picture, {
          img: event.data.displayImage,
          width: 600,
          alt: event.data.name + " Event Banner"
        })
      ) : "",
      Object(preact_min["h"])(
        "div",
        { className: yourOrderHeading },
        Object(preact_min["h"])(
          "h3",
          { style: { fontWeight: 600, margin: 0 } },
          "Your order"
        ),
        orderSummary.loading || !orderSummary.data || !orderSummary.data.eventDate ? "" : Object(preact_min["h"])(
          "p",
          null,
          orderSummary.data.eventDate.time,
          ",",
          " ",
          orderSummary.data.eventDate.date
        )
      ),
      orderSummary.loading || !orderSummary.data || order.addDiscountRequest.loading || order.removeDiscountRequest.loading ? Object(preact_min["h"])("div", { "class": "loading loading-lg", style: { padding: "0 0 180px 0" } }) : Object(preact_min["h"])(
        "div",
        null,
        !allowDiscountsAdd ? Object(preact_min["h"])(
          "div",
          { style: { padding: "0 18px" } },
          YourOrder__ref3
        ) : null,
        Object(preact_min["h"])(
          "table",
          { "class": "table" },
          orderSummary.data.ticketSummary.map(function (line, index) {
            return Object(preact_min["h"])(
              "tr",
              { "class": "border" },
              Object(preact_min["h"])(
                "th",
                null,
                line.label,
                " ",
                orderSummary.data.taxes && line.total ? YourOrder__ref4 : null,
                line.includesMsg ? Object(preact_min["h"])("p", {
                  dangerouslySetInnerHTML: {
                    __html: line.includesMsg
                  }
                }) : null
              ),
              Object(preact_min["h"])(
                "td",
                { "data-cy": "ticket-" + line.label, style: valueCel },
                Object(Format["currency"])(line.total, { prefix: currencyCode })
              )
            );
          }),
          orderSummary.data.merchandiseSummary.map(function (line, index) {
            return Object(preact_min["h"])(
              "tr",
              null,
              Object(preact_min["h"])(
                "th",
                null,
                line.label,
                " "
              ),
              Object(preact_min["h"])(
                "td",
                { "data-cy": "merch-" + line.label, style: valueCel },
                Object(Format["currency"])(line.total, { prefix: currencyCode })
              )
            );
          }),
          orderSummary.data.giftCardSummary.map(function (line, index) {
            return Object(preact_min["h"])(
              "tr",
              null,
              Object(preact_min["h"])(
                "th",
                null,
                line.label,
                " "
              ),
              Object(preact_min["h"])(
                "td",
                { "data-cy": "gift-card-" + line.label, style: valueCel },
                Object(Format["currency"])(line.total, { prefix: currencyCode })
              )
            );
          }),
          orderSummary.data.clientDonation ? Object(preact_min["h"])(
            "tr",
            null,
            YourOrder__ref5,
            Object(preact_min["h"])(
              "td",
              { "data-cy": "client-donation", style: valueCel },
              Object(Format["currency"])(orderSummary.data.clientDonation, {
                prefix: currencyCode
              })
            )
          ) : null,
          Object(preact_min["h"])(
            "tr",
            { "class": "border" },
            YourOrder__ref6,
            Object(preact_min["h"])(
              "td",
              { "data-cy": "sub-total", style: valueCel },
              Object(Format["currency"])(orderSummary.data.subtotal, {
                prefix: currencyCode
              })
            )
          ),
          orderSummary.data.discounts ? Object(preact_min["h"])(
            "tr",
            null,
            YourOrder__ref7,
            Object(preact_min["h"])(
              "td",
              { "data-cy": "discounts", style: valueCel },
              Object(Format["currency"])(orderSummary.data.discounts, {
                prefix: currencyCode
              })
            )
          ) : "",
          orderSummary.data && orderSummary.data.giftCardCredit > 0 ? Object(preact_min["h"])(
            "tr",
            null,
            YourOrder__ref8,
            Object(preact_min["h"])(
              "td",
              { "data-cy": "gift-card", style: valueCel },
              Object(Format["currency"])(orderSummary.data.giftCardCredit, {
                prefix: currencyCode
              })
            )
          ) : "",
          orderSummary.data.autoDiscountSummaries && orderSummary.data.autoDiscountSummaries.length ? Object(preact_min["h"])(
            "tr",
            null,
            Object(preact_min["h"])(
              "td",
              { colspan: "2" },
              orderSummary.data.autoDiscountSummaries.join(", ")
            )
          ) : "",
          orderSummary.data.passedOnFee ? Object(preact_min["h"])(
            "tr",
            null,
            Object(preact_min["h"])(
              "th",
              { style: { paddingBottom: 8 } },
              "Booking Fees ",
              YourOrder__ref9
            ),
            Object(preact_min["h"])(
              "td",
              {
                "data-cy": "booking-fee",
                style: YourOrder__extends({}, valueCel, { paddingBottom: 8 })
              },
              Object(Format["currency"])(orderSummary.data.passedOnFee, {
                prefix: currencyCode
              })
            )
          ) : null,
          event.data && event.data.showCharity ? Object(preact_min["h"])(
            "tr",
            { "class": "border" },
            Object(preact_min["h"])(
              "td",
              { colspan: "2" },
              Object(preact_min["h"])(components_OrderCharityMsg, { charity: event.data.charity })
            )
          ) : null,
          Object(preact_min["h"])(
            "tr",
            { "class": "border" },
            _ref10,
            Object(preact_min["h"])(
              "td",
              { style: valueCel },
              Object(preact_min["h"])(
                "h3",
                { "data-cy": "total", role: "presentation" },
                Object(Format["currency"])(orderSummary.data.outstandingAmount, {
                  prefix: currencyCode
                })
              )
            )
          )
        )
      )
    );
  };

  return YourOrder;
}(preact_min["Component"]);

/* harmony default export */ var components_YourOrder = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    order: state.order,
    orderSummary: state.orderSummary,
    event: state.event,
    ticketSelection: state.ticketSelection,
    merchandise: state.merchandise,
    giftCards: state.giftCards
  };
}, { loadSummary: orderSummaryActions["d" /* loadSummary */] })(YourOrder_YourOrderWrapper));
// EXTERNAL MODULE: ./services/tracking/TrackingService.js + 1 modules
var TrackingService = __webpack_require__("03y+");

// CONCATENATED MODULE: ./routes/tickets/components/AccessibilityComponent.js




var AccessibilityComponent_accessibilityLink = Object(index_esm["css"])({
  color: "#196097",
  background: "url(" + ic_accessibility_default.a + ")",
  backgroundSize: "20px 20px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "calc(50% - 38px) 50%",
  paddingLeft: 40,
  fontWeight: 600,
  borderRadius: 4,
  fontSize: 14,
  backgroundColor: "#f9f9fa",
  width: "100%",
  display: "block",
  marginBottom: 24,
  textAlign: "center",
  height: 32,
  paddingTop: 6,
  ":hover": {
    color: "#196097"
  }
});

var AccessibilityComponent_AccessibilityComponent = function AccessibilityComponent(_ref) {
  var displayAccessibility = _ref.displayAccessibility,
      event = _ref.event;

  if (displayAccessibility) {
    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        "a",
        {
          href: "/" + event.data.slug + "/accessibility?source=tickets",
          className: AccessibilityComponent_accessibilityLink
        },
        "Accessibility"
      )
    );
  }
  return null;
};

/* harmony default export */ var components_AccessibilityComponent = (AccessibilityComponent_AccessibilityComponent);
// CONCATENATED MODULE: ./utils/ManualOrderUtils.js
var determineManualOrder = function determineManualOrder() {
  if (window) {
    return window.manualOrderToken && window.isManualOrder && window.manualOrderSettings;
  }
  return false;
};


// CONCATENATED MODULE: ./components/DateSelector.js




var DateSelector__ref2 = Object(preact_min["h"])(
  "span",
  null,
  " (Sold Out)"
);

var DateSelector_DateSelector = function DateSelector(_ref) {
  var selectedDateId = _ref.selectedDateId,
      dates = _ref.dates,
      selectDate = _ref.selectDate,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? "Select Date" : _ref$name;

  var isManualOrder = determineManualOrder();
  var buttonStyle = {
    margin: "0px 10px 20px 0"
  };
  if (dates.length === 1) {
    return "";
  }
  var sortedDates = dates.sort(function (a, b) {
    a = new Date(a.startDate);
    b = new Date(b.startDate);
    return a > b ? 1 : a < b ? -1 : 0;
  });

  var dateChange = function dateChange(e) {
    var id = e.target.value;
    var date = void 0;
    dates.forEach(function (d) {
      if (d._id === id) {
        date = d;
      }
    });
    selectDate(id, date.display, date.startDate);
  };
  return Object(preact_min["h"])(
    "div",
    { style: { margin: "0 0 40px 0" } },
    Object(preact_min["h"])(
      "label",
      { "for": "date-selector", style: { marginBottom: 4, fontWeight: 600 } },
      name
    ),
    Object(preact_min["h"])(
      "select",
      {
        id: "date-selector",
        "class": "form-select",
        onChange: dateChange,
        value: selectedDateId
      },
      sortedDates.map(function (date) {
        if (date.valid || isManualOrder) {
          return Object(preact_min["h"])(
            "option",
            { value: date._id, disabled: !date.valid && !isManualOrder },
            date.display.combined,
            date.soldOut && DateSelector__ref2
          );
        }
      })
    )
  );
};
/* harmony default export */ var components_DateSelector = (DateSelector_DateSelector);
// EXTERNAL MODULE: ../node_modules/react-day-picker/DayPicker.js
var DayPicker = __webpack_require__("8pGs");
var DayPicker_default = /*#__PURE__*/__webpack_require__.n(DayPicker);

// EXTERNAL MODULE: ./components/DayPickerStyle.css
var DayPickerStyle = __webpack_require__("m/r8");
var DayPickerStyle_default = /*#__PURE__*/__webpack_require__.n(DayPickerStyle);

// CONCATENATED MODULE: ./components/DayPickerStyleProxy.js
// Proxy object to map classnames when css modules are not used

/* harmony default export */ var DayPickerStyleProxy = ({
  container: DayPickerStyle_default.a.CustomDayPicker,
  wrapper: DayPickerStyle_default.a["CustomDayPicker-wrapper"],
  interactionDisabled: DayPickerStyle_default.a["CustomDayPicker--interactionDisabled"],
  months: DayPickerStyle_default.a["CustomDayPicker-Months"],
  month: DayPickerStyle_default.a["CustomDayPicker-Month"],

  navBar: DayPickerStyle_default.a["CustomDayPicker-NavBar"],
  navButton: DayPickerStyle_default.a["CustomDayPicker-NavButton"],
  navButtonPrev: DayPickerStyle_default.a["CustomDayPicker-NavButton--prev"],
  navButtonNext: DayPickerStyle_default.a["CustomDayPicker-NavButton--next"],
  navButtonInteractionDisabled: DayPickerStyle_default.a["CustomDayPicker-NavButton--interactionDisabled"],

  caption: DayPickerStyle_default.a["CustomDayPicker-Caption"],
  weekdays: DayPickerStyle_default.a["CustomDayPicker-Weekdays"],
  weekdaysRow: DayPickerStyle_default.a["CustomDayPicker-WeekdaysRow"],
  weekday: DayPickerStyle_default.a["CustomDayPicker-Weekday"],
  body: DayPickerStyle_default.a["CustomDayPicker-Body"],
  week: DayPickerStyle_default.a["CustomDayPicker-Week"],
  weekNumber: DayPickerStyle_default.a["CustomDayPicker-WeekNumber"],
  day: DayPickerStyle_default.a["CustomDayPicker-Day"],
  footer: DayPickerStyle_default.a["CustomDayPicker-Footer"],
  todayButton: DayPickerStyle_default.a["CustomDayPicker-TodayButton"],

  // default modifiers
  today: DayPickerStyle_default.a.today,
  selected: DayPickerStyle_default.a.selected,
  disabled: DayPickerStyle_default.a.disabled,
  outside: DayPickerStyle_default.a.outside,

  available: DayPickerStyle_default.a.available,
  unavailable: DayPickerStyle_default.a.unavailable
});
// CONCATENATED MODULE: ./components/CalendarPicker.js


function CalendarPicker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CalendarPicker__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CalendarPicker__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var dateAvailable = __webpack_require__("l9ls");
var dateUnavailable = __webpack_require__("WvP3");

var CalendarPicker_wrapper = Object(index_esm["css"])({
  display: "flex",
  "@media(max-width: 600px)": {
    display: "block"
  }
});

var legendWrapper = Object(index_esm["css"])({
  padding: 12,
  "@media(max-width: 600px)": {
    paddingLeft: "calc(50% - 119px)",
    "&:after": {
      content: '""',
      clear: "both",
      display: "block"
    }
  }
});

var legendAvailabilityWrapper = Object(index_esm["css"])({
  "@media(max-width: 600px)": {
    float: "left"
  },
  "@media(max-width: 340px)": {
    float: "none"
  }
});

var dateAvailableStyling = Object(index_esm["css"])({
  marginLeft: 8,
  verticalAlign: "text-bottom"
});

var legendUnavailableWrapper = Object(index_esm["css"])({
  "@media(max-width: 600px)": {
    float: "left",
    marginLeft: 10
  },
  "@media(max-width: 340px)": {
    float: "none",
    marginLeft: 0
  }
});

var CalendarPicker__ref2 = Object(preact_min["h"])(
  "label",
  { "for": "date-selector" },
  Object(preact_min["h"])(
    "h3",
    null,
    "Select Date"
  )
);

var CalendarPicker__ref4 = Object(preact_min["h"])(
  "h2",
  null,
  "Selected Date"
);

var CalendarPicker_CalendarPicker = function (_Component) {
  CalendarPicker__inherits(CalendarPicker, _Component);

  function CalendarPicker(props) {
    CalendarPicker__classCallCheck(this, CalendarPicker);

    var _this = CalendarPicker__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      selectedDay: new Date(),
      relevantDates: []
    };
    _this.getStartingMonth = _this.getStartingMonth.bind(_this);
    _this.handleDayClick = _this.handleDayClick.bind(_this);
    _this.checkDateDisabled = _this.checkDateDisabled.bind(_this);
    _this.getDateSelection = _this.getDateSelection.bind(_this);
    _this.isUnavailable = _this.isUnavailable.bind(_this);
    _this.isAvailable = _this.isAvailable.bind(_this);
    _this.onMonthChange = _this.onMonthChange.bind(_this);
    return _this;
  }

  CalendarPicker.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        event = _props.event,
        getNextAvailableDates = _props.getNextAvailableDates;

    var date = new Date();
    getNextAvailableDates(event.data._id);
  };

  CalendarPicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (newProps.eventDates.dates && !this.props.eventDates.dates) {
      var firstValidDate = this.getFirstValidDate(newProps.eventDates.dates);
      if (firstValidDate) {
        var _id = firstValidDate._id,
            display = firstValidDate.display,
            startDate = firstValidDate.startDate;

        this.props.selectDate(_id, display, startDate);
        var date = new Date(firstValidDate.startDate);
        var relevantDates = newProps.eventDates.dates[date.getDate()];
        this.setState({
          selectedDay: date,
          relevantDates: relevantDates
        });
      } else {
        var selectedDate = this.getDateSelection(newProps);
        if (selectedDate) {
          var _date = new Date(selectedDate.startDate);
          var _relevantDates = newProps.eventDates.dates[_date.getDate()];
          this.setState({
            selectedDay: _date,
            relevantDates: _relevantDates
          });
        }
      }
    }
  };

  CalendarPicker.prototype.getFirstValidDate = function getFirstValidDate(datesObj) {
    var firstValidDate = void 0;
    for (var key in datesObj) {
      var dates = datesObj[key];
      firstValidDate = dates.reduce(function (cur, date) {
        if (date.valid && !cur) {
          return date;
        }
        return cur;
      }, undefined);
      if (firstValidDate) {
        break;
      }
    }
    return firstValidDate;
  };

  CalendarPicker.prototype.getDateSelection = function getDateSelection(props) {
    var selectedDateId = props.selectedDateId,
        selectedStartDate = props.selectedStartDate;

    var selectedDateDay = new Date(selectedStartDate);
    var datesFallingOnDay = props.eventDates.dates[selectedDateDay.getDate()] || [];
    var selectedDate = datesFallingOnDay.find(function (date) {
      return date._id === selectedDateId;
    });
    return selectedDate;
  };

  CalendarPicker.prototype.getRelevantDates = function getRelevantDates(monthDays, day) {
    var calendarDate = day;
    return monthDays[calendarDate.getDate()] || [];
  };

  CalendarPicker.prototype.checkDateDisabled = function checkDateDisabled(day) {
    var dates = this.props.eventDates.dates;

    if (dates) {
      var isContainedInEvent = dates[day.getDate()] && dates[day.getDate()].length > 0;
      //.filter(date => date.valid)
      return !isContainedInEvent;
    }
    return false;
  };

  CalendarPicker.prototype.handleDayClick = function handleDayClick(day, _ref) {
    var selected = _ref.selected,
        disabled = _ref.disabled;

    if (disabled) {
      // Day is disabled, do nothing
      return;
    }
    var relevantDates = this.props.eventDates.dates[day.getDate()] || [];
    if (selected) {
      // Unselect the day if already selected
      this.setState({
        selectedDay: undefined
      });
      return;
    }
    var validDates = relevantDates.filter(function (date) {
      return date.valid;
    });
    if (validDates.length > 0) {
      var _validDates$ = validDates[0],
          _id = _validDates$._id,
          display = _validDates$.display,
          startDate = _validDates$.startDate;

      this.props.selectDate(_id, display, startDate);
    }
    if (validDates.length > 0) {
      var selectedDate = validDates[0];
      var date = new Date(selectedDate.startDate);
      this.setState({
        selectedDay: date,
        relevantDates: relevantDates
      });
    }
  };

  CalendarPicker.prototype.getStartingMonth = function getStartingMonth() {
    //todo fix this
    return new Date();
  };

  CalendarPicker.prototype.onMonthChange = function onMonthChange(month) {
    var _props2 = this.props,
        event = _props2.event,
        getDates = _props2.getDates;

    var date = new Date(month);
    getDates(event.data._id, date.getMonth(), date.getFullYear(), date);
  };

  CalendarPicker.prototype.isUnavailable = function isUnavailable(day) {
    var dates = this.props.eventDates.dates;

    if (dates) {
      var sessionsInDay = dates[day.getDate()] || [];
      if (sessionsInDay.length > 0) {
        return sessionsInDay.filter(function (date) {
          return !date.valid;
        }).length === sessionsInDay.length;
      }
    }
    return false;
  };

  CalendarPicker.prototype.isAvailable = function isAvailable(day) {
    var dates = this.props.eventDates.dates;

    if (dates) {
      var sessionsInDay = dates[day.getDate()] || [];
      if (sessionsInDay.length > 0) {
        return sessionsInDay.filter(function (date) {
          return date.valid;
        }).length > 0;
      }
      return false;
    }
  };

  CalendarPicker.prototype.render = function render() {
    var _ref3;

    var _state = this.state,
        selectedDay = _state.selectedDay,
        relevantDates = _state.relevantDates;
    var _props3 = this.props,
        selectedDateId = _props3.selectedDateId,
        selectDate = _props3.selectDate,
        eventDates = _props3.eventDates;
    var dates = eventDates.dates,
        loading = eventDates.loading,
        month = eventDates.month;

    var floatLeft = Object(index_esm["css"])({
      // "@media(max-width: 600px)": {
      //   float: "none",
      //   display: "block"
      // }
    });
    return Object(preact_min["h"])(
      "div",
      null,
      CalendarPicker__ref2,
      Object(preact_min["h"])(
        "div",
        { className: CalendarPicker_wrapper },
        Object(preact_min["h"])(
          "div",
          { className: floatLeft },
          loading ? Object(preact_min["h"])(
            "div",
            { className: floatLeft },
            Object(preact_min["h"])(
              "div",
              { className: DayPickerStyle_default.a.CustomDayPicker },
              Object(preact_min["h"])(
                "div",
                {
                  className: DayPickerStyle_default.a["CustomDayPicker-wrapper"]
                },
                Object(preact_min["h"])(
                  "div",
                  {
                    className: DayPickerStyle_default.a["CustomDayPicker-Months"]
                  },
                  Object(preact_min["h"])("div", {
                    "class": "loading loading-lg",
                    style: { width: 294, height: 234 }
                  })
                )
              )
            )
          ) : Object(preact_min["h"])(DayPicker_default.a, {
            className: floatLeft,
            classNames: DayPickerStyleProxy,
            selectedDays: selectedDay,
            month: month,
            onDayClick: this.handleDayClick,
            disabledDays: this.checkDateDisabled,
            onMonthChange: this.onMonthChange,
            modifiers: (_ref3 = {}, _ref3[DayPickerStyleProxy.available] = this.isAvailable, _ref3[DayPickerStyleProxy.unavailable] = this.isUnavailable, _ref3)
          })
        ),
        Object(preact_min["h"])(
          "div",
          { className: floatLeft },
          Object(preact_min["h"])(CalendarPicker_DatePickerLegend, { className: floatLeft })
        )
      ),
      Object(preact_min["h"])(components_DateSelector, {
        name: "Select Time",
        dates: relevantDates || [],
        selectDate: selectDate,
        selectedDateId: selectedDateId
      }),
      relevantDates.length === 1 ? Object(preact_min["h"])(
        "div",
        { style: { marginBottom: 15 } },
        CalendarPicker__ref4,
        relevantDates[0].display.time,
        ", ",
        relevantDates[0].display.date
      ) : null
    );
  };

  return CalendarPicker;
}(preact_min["Component"]);

/* harmony default export */ var components_CalendarPicker = (Object(es["b" /* connect */])(function (state) {
  return {
    event: state.event,
    eventDates: state.eventDates
  };
}, {
  getDates: eventActions["t" /* getDates */],
  getNextAvailableDates: eventActions["w" /* getNextAvailableDates */]
})(CalendarPicker_CalendarPicker));

var DisableDate = Object(index_esm["css"])({
  backgroundColor: "#f7faff",
  marginTop: 20,
  marginLeft: 12,
  "@media(max-width: 600px)": {
    marginLeft: 0
  }
});

var CalendarPicker__ref5 = Object(preact_min["h"])(
  "div",
  { className: legendAvailabilityWrapper },
  Object(preact_min["h"])(Image["a" /* default */], { src: dateAvailable }),
  Object(preact_min["h"])(
    "span",
    { className: dateAvailableStyling },
    "Date Available"
  )
);

var CalendarPicker__ref6 = Object(preact_min["h"])(
  "div",
  { className: legendUnavailableWrapper },
  Object(preact_min["h"])(Image["a" /* default */], { src: dateUnavailable }),
  Object(preact_min["h"])(
    "span",
    { className: dateAvailableStyling },
    "Date Unavailable"
  )
);

var CalendarPicker_DatePickerLegend = function DatePickerLegend() {
  return Object(preact_min["h"])(
    "div",
    { className: DisableDate },
    Object(preact_min["h"])(
      "div",
      { className: legendWrapper },
      CalendarPicker__ref5,
      CalendarPicker__ref6
    )
  );
};
// CONCATENATED MODULE: ./routes/tickets/components/DateSelectorComponent.js




var DateSelectorComponent_DateSelectorComponent = function DateSelectorComponent(_ref) {
  var event = _ref.event,
      ticketSelection = _ref.ticketSelection,
      selectDate = _ref.selectDate;

  if (event.data.datesUseCalendar) {
    return Object(preact_min["h"])(components_CalendarPicker, {
      selectedDateId: ticketSelection.selectedDateId,
      selectedStartDate: ticketSelection.selectedStartDate,
      selectedDateDisplay: ticketSelection.selectedDateDisplay,
      selectDate: selectDate
    });
  }
  return Object(preact_min["h"])(components_DateSelector, {
    selectedDateId: ticketSelection.selectedDateId,
    dates: event.data.dates,
    selectDate: selectDate,
    name: "Select event date"
  });
};

/* harmony default export */ var components_DateSelectorComponent = (DateSelectorComponent_DateSelectorComponent);
// CONCATENATED MODULE: ./routes/tickets/components/OrderErrorMessage.js

var OrderErrorMessage_OrderErrorMessage = function OrderErrorMessage(_ref) {
  var order = _ref.order;

  if (order && order.orderRequest && order.orderRequest.error) {
    return Object(preact_min["h"])(
      "p",
      { "class": "text-error" },
      order.orderRequest.error.message
    );
  }
  return null;
};

/* harmony default export */ var components_OrderErrorMessage = (OrderErrorMessage_OrderErrorMessage);
// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__("kfMo");

// CONCATENATED MODULE: ../node_modules/preact-loadable/dist/es/index.js
function es__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function es__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function es__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Loadable = function (_Component) {
    es__inherits(Loadable, _Component);

    function Loadable() {
        es__classCallCheck(this, Loadable);

        var _this = es__possibleConstructorReturn(this, _Component.apply(this, arguments));

        _this.state = {
            result: undefined,
            showLoader: false
        };
        _this.timer = 0;
        _this.durationTimer = 0;
        _this.showLoader = function () {
            _this.setState({ showLoader: true });
            _this.durationTimer = setTimeout(_this.loaderDuration, _this.props.minLoaderVisible);
        };
        _this.loaderDuration = function () {
            return _this.setState({ showLoader: false });
        };
        return _this;
    }

    Loadable.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        var _props = this.props,
            fn = _props.fn,
            error = _props.error,
            success = _props.success,
            waitUntil = _props.waitUntil;

        var result = void 0;
        try {
            result = fn();
        } catch (err) {
            return this.update(error(err));
        }
        if (result.then !== undefined) {
            this.timer = setTimeout(this.showLoader, waitUntil);
            return result.then(function (c) {
                return _this2.update(success(c));
            }).catch(function (err) {
                return _this2.update(error(err));
            });
        } else {
            this.update(success(result));
        }
    };

    Loadable.prototype.update = function update(result) {
        this.componentWillUnmount();
        this.setState({ result: result, showLoader: false });
    };

    Loadable.prototype.componentWillUnmount = function componentWillUnmount() {
        clearTimeout(this.timer);
        clearTimeout(this.durationTimer);
    };

    Loadable.prototype.render = function render() {
        var _state = this.state,
            result = _state.result,
            showLoader = _state.showLoader;

        if (result === undefined && !showLoader) {
            return null;
        }
        return result === undefined ? this.props.loading() : result;
    };

    return Loadable;
}(preact_min["Component"]);
//# sourceMappingURL=index.js.map



// EXTERNAL MODULE: ./routes/seatingMap/Zoom.js
var Zoom = __webpack_require__("o16n");

// CONCATENATED MODULE: ./components/TicketMapping.js


function TicketMapping__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TicketMapping__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TicketMapping__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SeatingMap = void 0;

var seatingMapStyle = Object(index_esm["css"])({
  width: "80vw",
  height: "80vh",
  position: "relative",
  "@media(max-width: 600px)": {
    width: "100vw",
    height: "calc(100vh - 56px)"
  }
});
var legendStyle = Object(index_esm["css"])({
  zIndex: 10,
  position: "absolute",
  right: 27,
  maxWidth: 300,
  width: "100%",
  background: "white",
  marginTop: 8,
  borderRadius: 4,
  boxShadow: "0 1px 10px 0 rgba(9,30,66,0.13)",
  "@media(max-width: 600px)": {
    width: "100vw",
    height: 100,
    bottom: 0,
    overflowY: "auto",
    maxWidth: "none",
    left: 0,
    margin: 0
  },
  div: {
    "&:last-child": {
      marginBottom: 0
    }
  }
});

var listStyle = Object(index_esm["css"])({
  listStyleType: "none",
  width: "100%",
  background: "white",
  padding: 14,
  margin: 0,
  div: {
    "&:last-child": {
      marginBottom: 0
    }
  }
});

var legendMargin = Object(index_esm["css"])({
  marginBottom: 12,
  display: "flex"
});

var TicketMapping_headerStyle = Object(index_esm["css"])({
  display: "none",
  width: "100%",
  backgroundColor: "#FFF9E1",
  "@media(max-width: 600px)": {
    display: "inline-block"
  }
});

var footerStyle = Object(index_esm["css"])({
  display: "inline-block",
  width: "100%",
  backgroundColor: "#FFF9E1",
  "@media(max-width: 600px)": {
    display: "none"
  }
});

var TicketMapping_getDisclaimer = function getDisclaimer(className, dividerBottom) {
  var divider = Object(preact_min["h"])("div", {
    style: { width: "100%", borderBottom: "1px solid #DEDEDE", height: 1 }
  });
  return Object(preact_min["h"])(
    "div",
    { className: className },
    !dividerBottom ? divider : null,
    Object(preact_min["h"])(
      "p",
      {
        style: {
          paddingLeft: 14,
          paddingRight: 14,
          margin: "4px 0px 4px 0px",
          fontSize: 11,
          textAlign: "center"
        }
      },
      "You will select your table/seats prior to check out"
    ),
    dividerBottom ? divider : null
  );
};

var TicketMapping_Legend = function Legend(_ref) {
  var ticketTypeColors = _ref.ticketTypeColors,
      ticketTypes = _ref.ticketTypes;

  var colorRow = [];
  for (var key in ticketTypes) {
    var name = ticketTypes[key];
    var color = ticketTypeColors[key];
    colorRow.push({ name: name, color: color });
  }
  var convertToHexString = function convertToHexString(num) {
    return ("000000" + num.toString(16)).substr(-6);
  };
  var header = TicketMapping_getDisclaimer(TicketMapping_headerStyle, true);
  var footer = TicketMapping_getDisclaimer(footerStyle, false);
  return Object(preact_min["h"])(
    "div",
    { className: legendStyle },
    header,
    Object(preact_min["h"])(
      "ul",
      { className: listStyle },
      colorRow.map(function (_ref2, i) {
        var name = _ref2.name,
            color = _ref2.color;

        return Object(preact_min["h"])(
          "li",
          { className: legendMargin },
          Object(preact_min["h"])(
            "div",
            {
              style: {
                float: "left",
                marginRight: 8,
                paddingTop: 2,
                height: 14
              }
            },
            Object(preact_min["h"])("div", {
              style: {
                width: 14,
                height: 14,
                backgroundColor: "#" + convertToHexString(color)
              }
            })
          ),
          Object(preact_min["h"])(
            "div",
            {
              style: {
                fontSize: 12
              }
            },
            name
          )
        );
      })
    ),
    footer
  );
};

var TicketMapping__ref3 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var TicketMapping__ref4 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var TicketMapping_TicketMapping = function (_Component) {
  TicketMapping__inherits(TicketMapping, _Component);

  function TicketMapping(props) {
    TicketMapping__classCallCheck(this, TicketMapping);

    var _this = TicketMapping__possibleConstructorReturn(this, _Component.call(this, props));

    _this.ticketTypeIsIncludedInSeatingMap = function (ticketTypeId) {
      var event = _this.props.event;

      var seatingMaps = event.data.seatingMaps;
      if (!seatingMaps || seatingMaps.length === 0) {
        return false;
      }
      var seatingMap = seatingMaps[0];
      return seatingMap.ticketTypeSet.findIndex(function (id) {
        return String(id) === String(ticketTypeId);
      }) > -1;
    };

    _this.state = {
      libraryLoaded: false,
      loaded: false,
      loading: false,
      seatingMap: false
    };
    return _this;
  }

  TicketMapping.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getAllSeatingMaps = _props.getAllSeatingMaps,
        event = _props.event,
        ticketSelection = _props.ticketSelection;

    var eventId = event.id;
    var eventDateId = ticketSelection.selectedDateId;
    getAllSeatingMaps(eventId, eventDateId);
  };

  TicketMapping.prototype.getTicketTypes = function getTicketTypes() {
    var _this2 = this;

    var event = this.props.event;

    return event.data.ticketTypes.concat(event.data.packagedTickets).filter(function (ticketType) {
      return !ticketType.disabled && !ticketType.deleted && ticketType.onSale && !ticketType.isDonation;
    }).filter(function (ticketType) {
      return _this2.ticketTypeIsIncludedInSeatingMap(ticketType._id);
    }).map(function (ticketType) {
      return String(ticketType._id);
    });
  };

  TicketMapping.prototype.getTicketTypeMap = function getTicketTypeMap() {
    var _this3 = this;

    var event = this.props.event;

    return event.data.ticketTypes.concat(event.data.packagedTickets).filter(function (ticketType) {
      return !ticketType.disabled && !ticketType.deleted && ticketType.onSale && !ticketType.isDonation;
    }).filter(function (ticketType) {
      return _this3.ticketTypeIsIncludedInSeatingMap(ticketType._id);
    }).reduce(function (map, ticketType) {
      map[String(ticketType._id)] = ticketType.name;
      return map;
    }, {});
  };

  TicketMapping.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    var _this4 = this;

    var seatingMap = nextProps.seatingMap;
    var libraryLoaded = nextState.libraryLoaded,
        loaded = nextState.loaded,
        loading = nextState.loading;

    if (libraryLoaded && !loaded && !loading && seatingMap.seatingMaps.length > 0) {
      this.setState({ loading: true });
      var ticketTypes = this.getTicketTypes();
      SeatingMap.createTicketMappingView(seatingMap.seatingMaps[0].seatingMapData, {}, Object(config["a" /* default */])("API_URL"), ticketTypes).then(function (seatingMap) {
        _this4.setState({ loaded: true, seatingMap: seatingMap });
      });
    }
  };

  TicketMapping.prototype.render = function render() {
    var _this5 = this;

    var _state = this.state,
        libraryLoaded = _state.libraryLoaded,
        seatingMap = _state.seatingMap;

    var ticketTypes = this.getTicketTypeMap();
    var seatingMapInfo = this.state.loaded ? Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(TicketMapping_Legend, {
        ticketTypes: ticketTypes,
        ticketTypeColors: SeatingMap.getCurrentMap().getTicketTypeColorMap()
      }),
      Object(preact_min["h"])(Zoom["a" /* default */], { seatingMap: seatingMap, left: true })
    ) : TicketMapping__ref3;
    return Object(preact_min["h"])(
      "div",
      { id: "seatingMap", className: seatingMapStyle },
      !libraryLoaded ? Object(preact_min["h"])(
        "div",
        null,
        TicketMapping__ref4,
        Object(preact_min["h"])(Loadable
        // Can be sync or async
        , { fn: function fn() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "aNaN"));
          },
          error: function error(err) {
            return "Oops, an error occurred: " + err.message;
          },
          loading: function loading() {},
          success: function success(HumanitixSeatingMap) {
            _this5.setState({ libraryLoaded: true });
            SeatingMap = HumanitixSeatingMap.SeatingMap;
          }
        })
      ) : seatingMapInfo
    );
  };

  return TicketMapping;
}(preact_min["Component"]);

TicketMapping_TicketMapping = Object(es["b" /* connect */])(function (state) {
  return {
    event: state.event,
    ticketSelection: state.ticketSelection,
    seatingMap: state.seatingMap
  };
}, {
  getAllSeatingMaps: seatingMapActions["m" /* getAllSeatingMaps */]
})(TicketMapping_TicketMapping);

/* harmony default export */ var components_TicketMapping = (TicketMapping_TicketMapping);
// CONCATENATED MODULE: ./components/TicketMappingModal.js


function TicketMappingModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TicketMappingModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TicketMappingModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TicketMappingModal__ref = Object(preact_min["h"])(components_TicketMapping, null);

var TicketMappingModal_TicketMappingModal = function (_Component) {
  TicketMappingModal__inherits(TicketMappingModal, _Component);

  function TicketMappingModal(props) {
    TicketMappingModal__classCallCheck(this, TicketMappingModal);

    var _this = TicketMappingModal__possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateDimensions = function () {
      var isBrowser = typeof window !== "undefined";
      var isMobile = !isBrowser || !window || window.innerWidth <= 600;
      _this.setState({ isMobile: isMobile });
    };

    _this.state = {
      isMobile: false
    };
    return _this;
  }

  TicketMappingModal.prototype.componentWillMount = function componentWillMount() {
    this.updateDimensions();
    var isBrowser = typeof window !== "undefined";
    if (isBrowser) {
      window.removeEventListener("resize", this.updateDimensions);
    }
  };

  TicketMappingModal.prototype.render = function render() {
    var _props = this.props,
        showModal = _props.showModal,
        onClose = _props.onClose;
    var isMobile = this.state.isMobile;

    if (showModal) {
      return Object(preact_min["h"])(
        Modal["a" /* default */],
        {
          padding: isMobile ? 0 : 20,
          closeMargin: isMobile ? "20px 20px 0px 0px" : 0,
          showModal: showModal,
          closeHandler: onClose,
          destroy: false
        },
        TicketMappingModal__ref
      );
    }
  };

  return TicketMappingModal;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/tickets/components/SeatingMapModal.js



var SeatingMapModal_SeatingMapModal = function SeatingMapModal(_ref) {
  var showSeatingMapOverview = _ref.showSeatingMapOverview,
      showModal = _ref.showModal,
      closeModal = _ref.closeModal;

  if (showSeatingMapOverview) {
    return Object(preact_min["h"])(TicketMappingModal_TicketMappingModal, { showModal: showModal, onClose: closeModal });
  }
  return null;
};
/* harmony default export */ var components_SeatingMapModal = (SeatingMapModal_SeatingMapModal);
// EXTERNAL MODULE: ./components/WarningMessage.js
var WarningMessage = __webpack_require__("6bgb");

// EXTERNAL MODULE: ./assets/images/icon-info.svg
var icon_info = __webpack_require__("MZQ5");
var icon_info_default = /*#__PURE__*/__webpack_require__.n(icon_info);

// CONCATENATED MODULE: ./components/Note.js




var Note_Note = function Note(_ref) {
    var children = _ref.children;

    return Object(preact_min["h"])(
        'p',
        { style: { fontWeight: 300, paddingLeft: 26, color: '#5A626C', background: 'url(' + icon_info_default.a + ') no-repeat left center' } },
        children
    );
};
/* harmony default export */ var components_Note = (Note_Note);
// CONCATENATED MODULE: ./components/AccessCode.js











var AccessCode_AccessCode = function AccessCode(_ref) {
  var event = _ref.event,
      ticketSelection = _ref.ticketSelection,
      showAccessCodes = _ref.showAccessCodes,
      checkAccessCode = _ref.checkAccessCode,
      removeAccessCode = _ref.removeAccessCode;

  if (!event.data.hasAccessCodes) {
    return null;
  }
  var ticketStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 14
  };
  var ticketWrap = {
    borderBottom: "1px solid #d9d9d9",
    padding: "17px 0"
  };
  var infoStyle = {
    flex: 1
  };

  return !ticketSelection.showAccessCode ? Object(preact_min["h"])(
    "div",
    { style: ticketWrap },
    Object(preact_min["h"])(
      "div",
      { style: ticketStyle },
      Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "a",
          {
            onClick: showAccessCodes,
            style: {
              margin: "18px 0 0 0",
              cursor: "pointer",
              textDecoration: "underline"
            },
            "data-cy": "EnterAccessCode",
            href: "#"
          },
          "Access hidden tickets"
        )
      )
    )
  ) : Object(preact_min["h"])(AccessCode_AccessCodeForm, {
    event: event,
    ticketSelection: ticketSelection,
    removeAccessCode: removeAccessCode,
    checkAccessCode: checkAccessCode
  });
};

var AccessCode__ref3 = Object(preact_min["h"])(
  components_Note,
  null,
  "Discount codes can be entered in the next step"
);

var AccessCode_AccessCodeForm = function AccessCodeForm(_ref2) {
  var event = _ref2.event,
      ticketSelection = _ref2.ticketSelection,
      handleSubmit = _ref2.handleSubmit,
      removeAccessCode = _ref2.removeAccessCode,
      checkAccessCode = _ref2.checkAccessCode;

  var save = function save(values) {
    var code = values.accessCode;
    if (code) {
      checkAccessCode(event.data._id, code);
    }
  };
  var remove = function remove() {
    removeAccessCode();
  };
  var accessCodeStyle = {
    background: "url(" + icon_success_default.a + ") no-repeat left 5px center",
    backgroundSize: 20,
    color: "#157e77",
    margin: "0px 12px",
    padding: "4px 0 4px 28px",
    display: "inline-block"
  };
  var removeStyle = {
    background: "url(" + icon_cross_default.a + ") no-repeat right 5px center",
    backgroundSize: 20,
    paddingLeft: 30,
    cursor: "pointer",
    float: "right",
    height: 30
  };
  var accessStyle = {
    padding: "12px 0",
    borderBottom: "1px solid rgb(217, 217, 217)"
  };
  if (ticketSelection.accessCode) {
    return Object(preact_min["h"])(
      "div",
      { style: accessStyle },
      Object(preact_min["h"])(
        "span",
        null,
        "Access password:",
        " ",
        Object(preact_min["h"])(
          "span",
          { style: accessCodeStyle },
          ticketSelection.accessCode
        ),
        Object(preact_min["h"])("a", { onClick: remove, style: removeStyle })
      )
    );
  }

  return Object(preact_min["h"])(
    "div",
    { style: accessStyle },
    Object(preact_min["h"])(
      "form",
      { onSubmit: handleSubmit(save) },
      Object(preact_min["h"])(
        "div",
        {
          style: {
            display: "flex"
          }
        },
        Object(preact_min["h"])(redux_form_es["a" /* Field */], {
          label: "Access Code",
          style: {
            flex: "1"
          },
          inputStyle: {
            borderRadius: "4px 0 0 4px"
          },
          type: "text",
          name: "accessCode",
          component: InputField["a" /* default */],
          placeholder: "Code",
          autofocus: true
        }),
        Object(preact_min["h"])(
          ActionButton["a" /* default */],
          {
            loading: ticketSelection.accessCodeRequest.loading,
            classNames: "btn-secondary",
            dataCY: "AccessCodeApply",
            style: {
              borderRadius: "0 3px 3px 0",
              padding: "4px 10px",
              width: 150,
              marginTop: 24
            }
          },
          "Apply"
        )
      ),
      ticketSelection.accessCodeRequest.error ? Object(preact_min["h"])(
        "p",
        { "class": "text-error error-icon" },
        ticketSelection.accessCodeRequest.error
      ) : "",
      AccessCode__ref3
    )
  );
};

AccessCode_AccessCodeForm = Object(redux_form_es["f" /* reduxForm */])({ form: "accessCode" })(AccessCode_AccessCodeForm);

/* harmony default export */ var components_AccessCode = (Object(es["b" /* connect */])(function (state) {
  return { event: state.event, ticketSelection: state.ticketSelection };
}, { showAccessCodes: ticketsActions["v" /* showAccessCodes */], checkAccessCode: ticketsActions["q" /* checkAccessCode */], removeAccessCode: ticketsActions["t" /* removeAccessCode */] })(AccessCode_AccessCode));
// CONCATENATED MODULE: ./utils/Debouce.js
/* harmony default export */ var Debouce = (function (fn, delay) {
  var timer = null;
  return function () {
    var context = this,
        args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
});
// CONCATENATED MODULE: ./routes/tickets/components/Donation.js


function Donation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Donation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Donation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Donation__ref2 = Object(preact_min["h"])(
  "option",
  { value: 0, selected: true },
  "0"
);

var Donation__ref3 = Object(preact_min["h"])(
  "option",
  { value: "other" },
  "Other"
);

var Donation__ref4 = Object(preact_min["h"])(
  "label",
  { "for": "donation" },
  "Amount: $"
);

var Donation_Donation = function (_Component) {
  Donation__inherits(Donation, _Component);

  function Donation() {
    Donation__classCallCheck(this, Donation);

    var _this = Donation__possibleConstructorReturn(this, _Component.call(this));

    _this.updateSelect = function (event) {
      var _this$props = _this.props,
          updateDonationAmount = _this$props.updateDonationAmount,
          showCustomDonationField = _this$props.showCustomDonationField;

      var value = event.target.value;
      if (value === "other") {
        showCustomDonationField();
      } else {
        updateDonationAmount(value);
      }
    };

    _this.updateDebouched = Debouce(function (event) {
      _this.update(event);
    }, 300);

    _this.update = _this.update.bind(_this);
    _this.updateDebouched = _this.updateDebouched.bind(_this);
    return _this;
  }

  Donation.prototype.update = function update(event) {
    var updateDonationAmount = this.props.updateDonationAmount;

    var value = Number(event.target.value);
    value = isNaN(value) ? 0 : value;
    updateDonationAmount(value);
  };

  Donation.prototype.render = function render(_ref) {
    var ticket = _ref.ticket,
        donationOtherOption = _ref.donationOtherOption;

    if (ticket.hidden && !ticket.accessGranted) {
      return null;
    }
    var ticketStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    };
    var ticketWrap = {
      borderBottom: "1px solid #d9d9d9",
      padding: "10px 0"
    };
    var descriptionStyle = {
      margin: "6px 0 0",
      fontSize: 14,
      color: "#5A626C",
      whiteSpace: "pre-line",
      wordBreak: "break-word"
    };
    var infoStyle = {
      flex: 1
    };

    var options = ticket.donationOptionsOn && ticket.donationOptions.length ? ticket.donationOptions.map(function (option) {
      return Object(preact_min["h"])(
        "option",
        { value: option.value },
        option.value
      );
    }) : [];
    options.unshift(Donation__ref2);
    options.push(Donation__ref3);

    return Object(preact_min["h"])(
      "div",
      { style: ticketWrap },
      Object(preact_min["h"])(
        "div",
        { style: ticketStyle },
        Object(preact_min["h"])(
          "div",
          { style: infoStyle },
          Object(preact_min["h"])(
            "h4",
            {
              style: {
                margin: 0
              }
            },
            ticket.name
          ),
          Object(preact_min["h"])(
            "p",
            { style: descriptionStyle },
            ticket.description
          ),
          ticket.dateError ? Object(preact_min["h"])(
            "p",
            {
              style: {
                margin: 0
              }
            },
            ticket.dateError
          ) : ""
        ),
        Object(preact_min["h"])(
          "h4",
          {
            style: {
              margin: "0 10px 0 0"
            }
          },
          Donation__ref4
        ),
        Object(preact_min["h"])(
          "div",
          {
            style: {
              width: 80
            }
          },
          ticket.donationOptionsOn && !donationOtherOption ? Object(preact_min["h"])(
            "select",
            {
              "class": "form-select",
              onChange: this.updateSelect,
              onKeyUp: this.updateDebouched
            },
            options
          ) : Object(preact_min["h"])("input", {
            id: "donation",
            "class": "form-input",
            type: "number",
            onChange: this.update,
            onKeyUp: this.updateDebouched,
            min: "0"
          })
        )
      ),
      Object(preact_min["h"])(
        "span",
        { "class": "text-error" },
        ticket.errors ? ticket.errors.map(function (err) {
          return Object(preact_min["h"])(
            "p",
            null,
            err
          );
        }) : ""
      )
    );
  };

  return Donation;
}(preact_min["Component"]);

/* harmony default export */ var components_Donation = (Donation_Donation);
// EXTERNAL MODULE: ./components/fields/Required.js
var Required = __webpack_require__("0KR6");

// EXTERNAL MODULE: ./components/fields/Description.js
var Description = __webpack_require__("CuFb");

// EXTERNAL MODULE: ./assets/images/icon-down.svg
var icon_down = __webpack_require__("lLHp");
var icon_down_default = /*#__PURE__*/__webpack_require__.n(icon_down);

// CONCATENATED MODULE: ./components/fields/multipleOptions/MultipleOptions.js
var MultipleOptions__templateObject = MultipleOptions__taggedTemplateLiteralLoose(["\n        text-transform: capitalize;\n        font-size: 14px;\n        border-radius: 2px;\n        padding: 0 10px 0 10px;\n        margin: 0 4px 4px 0;\n        border: solid 1px #ddd;\n        display: inline-block;\n        background: hsl(0, 0%, 98%);\n        cursor: pointer;\n        &:after {\n          content: \"\xD7\";\n          cursor: pointer;\n          margin-left: 5px;\n          vertical-align: middle;\n          color: rgba(0, 0, 0, 0.45);\n        }\n        &:hover {\n          background: hsl(0, 0%, 88%);\n        }\n      "], ["\n        text-transform: capitalize;\n        font-size: 14px;\n        border-radius: 2px;\n        padding: 0 10px 0 10px;\n        margin: 0 4px 4px 0;\n        border: solid 1px #ddd;\n        display: inline-block;\n        background: hsl(0, 0%, 98%);\n        cursor: pointer;\n        &:after {\n          content: \"\xD7\";\n          cursor: pointer;\n          margin-left: 5px;\n          vertical-align: middle;\n          color: rgba(0, 0, 0, 0.45);\n        }\n        &:hover {\n          background: hsl(0, 0%, 88%);\n        }\n      "]),
    MultipleOptions__templateObject2 = MultipleOptions__taggedTemplateLiteralLoose(["\n        cursor: default;\n        margin-bottom: 2px;\n        text-transform: capitalize;\n        padding: 2px 15px 2px 5px;\n      "], ["\n        cursor: default;\n        margin-bottom: 2px;\n        text-transform: capitalize;\n        padding: 2px 15px 2px 5px;\n      "]),
    MultipleOptions__templateObject3 = MultipleOptions__taggedTemplateLiteralLoose(["\n        cursor: default;\n        text-transform: capitalize;\n        padding: 2px 15px 2px 5px;\n        background: #fafafa;\n        position: relative;\n        font-weight: 600;\n        margin: 2px;\n      "], ["\n        cursor: default;\n        text-transform: capitalize;\n        padding: 2px 15px 2px 5px;\n        background: #fafafa;\n        position: relative;\n        font-weight: 600;\n        margin: 2px;\n      "]),
    MultipleOptions__templateObject4 = MultipleOptions__taggedTemplateLiteralLoose(["\n        pointer-events: none;\n        opacity: 0.5;\n        cursor: default;\n        margin-bottom: 2px;\n        text-transform: capitalize;\n        padding: 2px 15px 2px 5px;\n      "], ["\n        pointer-events: none;\n        opacity: 0.5;\n        cursor: default;\n        margin-bottom: 2px;\n        text-transform: capitalize;\n        padding: 2px 15px 2px 5px;\n      "]),
    MultipleOptions__templateObject5 = MultipleOptions__taggedTemplateLiteralLoose(["\n        margin: auto;\n        display: inline-block;\n        cursor: pointer;\n        font-size: 12px;\n        width: 20px;\n        display: inline-block;\n        cursor: pointer;\n      "], ["\n        margin: auto;\n        display: inline-block;\n        cursor: pointer;\n        font-size: 12px;\n        width: 20px;\n        display: inline-block;\n        cursor: pointer;\n      "]),
    MultipleOptions__templateObject6 = MultipleOptions__taggedTemplateLiteralLoose(["\n        position: absolute;\n        right: 0px;\n        top: 4px;\n      "], ["\n        position: absolute;\n        right: 0px;\n        top: 4px;\n      "]),
    MultipleOptions__templateObject7 = MultipleOptions__taggedTemplateLiteralLoose(["\n        font-weight: 400;\n        text-align: left;\n        vertical-align: middle;\n        display: inline-block;\n        width: calc(100% - 40px);\n        white-space: wrap;\n        text-overflow: clip;\n        overflow: hidden;\n      "], ["\n        font-weight: 400;\n        text-align: left;\n        vertical-align: middle;\n        display: inline-block;\n        width: calc(100% - 40px);\n        white-space: wrap;\n        text-overflow: clip;\n        overflow: hidden;\n      "]),
    MultipleOptions__templateObject8 = MultipleOptions__taggedTemplateLiteralLoose(["\n        vertical-align: middle;\n        height: inherit;\n\n        border-radius: 4px;\n        display: inline-block;\n        padding: 5px 0px 5px 10px;\n        width: inherit;\n      "], ["\n        vertical-align: middle;\n        height: inherit;\n\n        border-radius: 4px;\n        display: inline-block;\n        padding: 5px 0px 5px 10px;\n        width: inherit;\n      "]),
    MultipleOptions__templateObject9 = MultipleOptions__taggedTemplateLiteralLoose(["\n                z-index: 10001;\n                overflow-x: auto;\n                background-color: #fff;\n                position: absolute;\n                margin: 0;\n                border: 0.05rem solid #e7e7e7;\n                border-radius: 4px;\n                //border-top-width: 0;\n                // border-top-left-radius: 0;\n                //border-top-right-radius: 0;\n                width: 100%;\n                padding: 0;\n                display: ", ";\n                color: #323232,\n                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15;\n            "], ["\n                z-index: 10001;\n                overflow-x: auto;\n                background-color: #fff;\n                position: absolute;\n                margin: 0;\n                border: 0.05rem solid #e7e7e7;\n                border-radius: 4px;\n                //border-top-width: 0;\n                // border-top-left-radius: 0;\n                //border-top-right-radius: 0;\n                width: 100%;\n                padding: 0;\n                display: ", ";\n                color: #323232,\n                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15;\n            "]),
    MultipleOptions__templateObject10 = MultipleOptions__taggedTemplateLiteralLoose(["\n        position: relative;\n        display: block;\n        font-size: 16;\n        margin-top: 0;\n        margin-bottom: 0;\n      "], ["\n        position: relative;\n        display: block;\n        font-size: 16;\n        margin-top: 0;\n        margin-bottom: 0;\n      "]);



function MultipleOptions__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function MultipleOptions__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MultipleOptions__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MultipleOptions__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MultipleOptions__ref = Object(preact_min["h"])(
  "span",
  null,
  "(Not available)"
);

var MultipleOptions_MultipleOptions = function (_Component) {
  MultipleOptions__inherits(MultipleOptions, _Component);

  function MultipleOptions() {
    MultipleOptions__classCallCheck(this, MultipleOptions);

    var _this = MultipleOptions__possibleConstructorReturn(this, _Component.call(this));

    _this.selectedOptionsClick = function (id) {
      var _this$props = _this.props,
          options = _this$props.options,
          optionClicked = _this$props.optionClicked;

      var filteredToasts = options.slice();

      filteredToasts.map(function (obj) {
        if (obj.id === id) {
          obj.value = false;
        }
      });
      _this.setState({ dropDownClicked: false });
      optionClicked(filteredToasts);
    };

    _this.optionsOnChange = function (index, value) {
      var _this$props2 = _this.props,
          options = _this$props2.options,
          selectedBadgeClicked = _this$props2.selectedBadgeClicked;

      var optionsCopy = options.slice();
      optionsCopy[index].value = value;
      selectedBadgeClicked(optionsCopy);
    };

    _this.openOptions = function () {
      var dropDownClicked = _this.state.dropDownClicked;

      _this.setState({ dropDownClicked: !dropDownClicked });
    };

    _this.state = {
      dropDownClicked: false
    };
    return _this;
  }

  MultipleOptions.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        options = _props.options,
        touched = _props.touched,
        error = _props.error,
        trackQuantity = _props.trackQuantity,
        disabled = _props.disabled;
    var dropDownClicked = this.state.dropDownClicked;

    var selected = [];
    options.map(function (day) {
      if (day.value) {
        selected.push({ label: day.label, id: day.id });
      }
    });

    var styles = {
      selectedOptionsBadges: Object(index_esm["css"])(MultipleOptions__templateObject),
      optionList: Object(index_esm["css"])(MultipleOptions__templateObject2),
      optionListSelect: Object(index_esm["css"])(MultipleOptions__templateObject3),
      optionListDisable: Object(index_esm["css"])(MultipleOptions__templateObject4),
      arrow: Object(index_esm["css"])(MultipleOptions__templateObject5),
      optionListSelectIcon: Object(index_esm["css"])(MultipleOptions__templateObject6),
      selectedOptionsBadgesList: Object(index_esm["css"])(MultipleOptions__templateObject7),
      selectedOptions: Object(index_esm["css"])(MultipleOptions__templateObject8),
      options: Object(index_esm["css"])(MultipleOptions__templateObject9, dropDownClicked ? "block" : "none"),
      list: Object(index_esm["css"])(MultipleOptions__templateObject10)
    };

    var selectedList = Object(preact_min["h"])(
      "label",
      { "class": styles.selectedOptionsBadgesList },
      selected.map(function (obj) {
        return Object(preact_min["h"])(
          "span",
          {
            key: obj.id,
            onClick: function onClick() {
              return _this2.selectedOptionsClick(obj.id);
            },
            "class": styles.selectedOptionsBadges
          },
          obj.label
        );
      })
    );
    return Object(preact_min["h"])(
      "div",
      {
        "class": "multiple-options-input",
        tabIndex: "0",
        onBlur: function onBlur() {
          _this2.setState({ dropDownClicked: false });
        },
        disabled: disabled,
        error: touched && error ? true : false
      },
      Object(preact_min["h"])(
        "div",
        { "class": styles.selectedOptions, onClick: this.openOptions },
        selectedList,
        Object(preact_min["h"])(
          "div",
          { "class": styles.arrow },
          Object(preact_min["h"])("img", { src: icon_down_default.a, "class": styles.optionListSelectIcon })
        )
      ),
      Object(preact_min["h"])(
        "ul",
        { "class": styles.options },
        options.map(function (option, index) {
          var liClass = option.value ? styles.optionListSelect : styles.optionList;
          var quantityLeft = option.hasOwnProperty("quantityLeft") === true ? option.quantityLeft : 1000000;
          var disabled = quantityLeft > 0 ? false : true;
          liClass = disabled ? styles.optionListDisable : liClass;
          var onClick = disabled ? null : function () {
            return _this2.optionsOnChange(index, !option.value);
          };
          return Object(preact_min["h"])(
            "li",
            {
              "class": styles.list,
              key: option.id,
              value: option.value,
              disabled: disabled
            },
            Object(preact_min["h"])(
              "div",
              { "class": liClass, onClick: onClick },
              option.label,
              " ",
              quantityLeft > 0 && quantityLeft < 11 && Object(preact_min["h"])(
                "span",
                null,
                "(",
                quantityLeft,
                " available)"
              ),
              trackQuantity && disabled && MultipleOptions__ref,
              option.value ? Object(preact_min["h"])("img", {
                src: icon_success_default.a,
                "class": styles.optionListSelectIcon
              }) : null
            )
          );
        })
      )
    );
  };

  return MultipleOptions;
}(preact_min["Component"]);

/* harmony default export */ var multipleOptions_MultipleOptions = (MultipleOptions_MultipleOptions);
// CONCATENATED MODULE: ./components/fields/MultipleOptionsField.js
var MultipleOptionsField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function MultipleOptionsField__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MultipleOptionsField__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MultipleOptionsField__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MultipleOptionsField_MultipleOptionsField = function (_Component) {
  MultipleOptionsField__inherits(MultipleOptionsField, _Component);

  function MultipleOptionsField() {
    MultipleOptionsField__classCallCheck(this, MultipleOptionsField);

    var _this = MultipleOptionsField__possibleConstructorReturn(this, _Component.call(this));

    _this.changeValue = function (options) {
      var _this$props = _this.props,
          meta = _this$props.meta,
          formName = _this$props.formName,
          input = _this$props.input,
          _this$props$valueFiel = _this$props.valueField,
          valueField = _this$props$valueFiel === undefined ? "name" : _this$props$valueFiel;

      meta.dispatch(Object(redux_form_es["g" /* touch */])(formName, input.name));
      var optionsString = options.filter(function (option) {
        return option.value;
      }).map(function (option) {
        var value = option[valueField];
        return value;
      }).join("{|}");
      meta.dispatch(Object(redux_form_es["c" /* change */])(formName, input.name, optionsString));
    };

    _this.changeValue = _this.changeValue.bind(_this);
    return _this;
  }

  MultipleOptionsField.prototype.render = function render(_ref) {
    var input = _ref.input,
        options = _ref.options,
        label = _ref.label,
        description = _ref.description,
        required = _ref.required,
        disabled = _ref.disabled,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error,
        warning = _ref$meta.warning,
        _ref$valueField = _ref.valueField,
        valueField = _ref$valueField === undefined ? "name" : _ref$valueField,
        trackQuantity = _ref.trackQuantity;

    var setOptions = options ? options.concat([]) : [];
    var value = input.value ? input.value : "";
    var selectedValues = value && typeof value === "string" ? value.split("{|}") : value;
    var newOptions = setOptions.map(function (option) {
      if (selectedValues.indexOf(option[valueField]) !== -1) {
        option.value = true;
      } else {
        option.value = false;
      }
      return MultipleOptionsField__extends({}, option);
    });

    return Object(preact_min["h"])(
      "div",
      { "class": touched && error ? "form-group has-error" : "form-group" },
      Object(preact_min["h"])(
        "label",
        { "for": input.name, "class": "form-label" },
        label,
        " ",
        Object(preact_min["h"])(Required["a" /* default */], { required: required })
      ),
      Object(preact_min["h"])(Description["a" /* default */], { description: description }),
      Object(preact_min["h"])(multipleOptions_MultipleOptions, {
        options: newOptions,
        touched: touched,
        error: error,
        disabled: disabled,
        optionClicked: this.changeValue,
        selectedBadgeClicked: this.changeValue,
        trackQuantity: trackQuantity
      }),
      touched && error && Object(preact_min["h"])(
        "p",
        { "class": "form-input-hint" },
        error
      )
    );
  };

  return MultipleOptionsField;
}(preact_min["Component"]);

/* harmony default export */ var fields_MultipleOptionsField = (MultipleOptionsField_MultipleOptionsField);
// EXTERNAL MODULE: ./utils/ScrollToErrors.js
var ScrollToErrors = __webpack_require__("pj9u");

// EXTERNAL MODULE: ./utils/Validators.js
var Validators = __webpack_require__("RFUj");

// EXTERNAL MODULE: ./components/ActionBar.js
var ActionBar = __webpack_require__("4e4/");

// CONCATENATED MODULE: ./components/waitlist/WaitlistForm.js
var WaitlistForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var formWrapper = Object(index_esm["css"])({
  minWidth: 400,
  "@media(max-width: 600px)": {
    minWidth: 200
  }
});

var WaitlistForm__ref2 = Object(preact_min["h"])(
  "h3",
  null,
  "Added to waitlist"
);

var WaitlistForm_WaitlistForm = function WaitlistForm(_ref) {
  var add = _ref.add,
      waitlist = _ref.waitlist,
      event = _ref.event,
      ticketSelection = _ref.ticketSelection,
      handleSubmit = _ref.handleSubmit,
      ticket = _ref.ticket;

  var save = function save(values) {
    var ticketIds = values.ticketIds.split("{|}");
    var data = WaitlistForm__extends({}, values, {
      ticketIds: ticketIds,
      eventId: event.data._id
    });
    add(data);
  };
  var dateOptions = event.data.dates.reduce(function (options, date) {
    options.push({
      label: date.display.time + ", " + date.display.date,
      _id: date._id
    });
    return options;
  }, []);
  var ticketOptions = ticketSelection.tickets.reduce(function (options, ticket) {
    if (ticket.showWaitlist) {
      options.push({
        label: ticket.name,
        _id: ticket._id
      });
    }
    return options;
  }, []);

  if (waitlist.add.added) {
    return Object(preact_min["h"])(
      "div",
      { className: formWrapper },
      Object(preact_min["h"])(
        "div",
        {
          style: {
            background: "url(" + icon_success_default.a + ") no-repeat center",
            backgroundSize: 120,
            padding: "170px 0 40px 0",
            textAlign: "center"
          }
        },
        WaitlistForm__ref2
      )
    );
  }

  return Object(preact_min["h"])(
    "div",
    { className: formWrapper },
    Object(preact_min["h"])(
      "form",
      { onSubmit: handleSubmit(save) },
      waitlist && waitlist.add.error ? Object(preact_min["h"])(
        "p",
        { "class": "text-error" },
        waitlist.add.error
      ) : "",
      Object(preact_min["h"])(redux_form_es["a" /* Field */], {
        label: "First name",
        type: "text",
        name: "firstName",
        component: InputField["a" /* default */],
        required: true,
        disabled: waitlist.add.loading,
        validate: Validators["b" /* required */]
      }),
      Object(preact_min["h"])(redux_form_es["a" /* Field */], {
        label: "Last name",
        type: "text",
        name: "lastName",
        component: InputField["a" /* default */],
        required: true,
        disabled: waitlist.add.loading,
        validate: Validators["b" /* required */]
      }),
      Object(preact_min["h"])(redux_form_es["a" /* Field */], {
        label: "Email",
        type: "email",
        name: "email",
        component: InputField["a" /* default */],
        required: true,
        disabled: waitlist.add.loading,
        validate: [Validators["b" /* required */], Validators["a" /* email */]]
      }),
      event.data.dates.length > 1 ? Object(preact_min["h"])(redux_form_es["a" /* Field */], {
        label: "Which dates are interested in?",
        type: "text",
        name: "eventDateIds",
        formName: "waitlist",
        disabled: waitlist.add.loading,
        component: fields_MultipleOptionsField,
        valueField: "_id",
        options: dateOptions
      }) : null,
      Object(preact_min["h"])(redux_form_es["a" /* Field */], {
        label: "Which tickets are interested in?",
        type: "text",
        name: "ticketIds",
        formName: "waitlist",
        disabled: waitlist.add.loading,
        component: fields_MultipleOptionsField,
        valueField: "_id",
        validate: [Validators["b" /* required */]],
        options: ticketOptions
      }),
      Object(preact_min["h"])(
        ActionBar["a" /* default */],
        null,
        Object(preact_min["h"])(
          ActionButton["a" /* default */],
          {
            disabled: waitlist.add.loading,
            loading: waitlist.add.loading
          },
          "Join"
        ),
        Object(preact_min["h"])(
          match["Link"],
          {
            style: {
              padding: "18px 0px",
              display: "inline-block"
            },
            href: "/" + event.data.slug
          },
          "Cancel"
        )
      )
    )
  );
};

WaitlistForm_WaitlistForm = Object(redux_form_es["f" /* reduxForm */])({
  form: "waitlist",
  onSubmitFail: function onSubmitFail(errors) {
    Object(ScrollToErrors["a" /* scrollToErrors */])();
  }
})(WaitlistForm_WaitlistForm);

/* harmony default export */ var waitlist_WaitlistForm = (Object(es["b" /* connect */])(function (state, ownProps) {
  var _ref3;

  return _ref3 = {
    initialValues: {
      ticketIds: ownProps.ticket._id,
      eventDateIds: [state.ticketSelection.selectedDateId]
    },
    event: state.event,
    ticketSelection: state.ticketSelection,
    waitlist: state.waitlist
  }, _ref3["ticketSelection"] = state.ticketSelection, _ref3;
}, { add: waitlistActions["h" /* add */] })(WaitlistForm_WaitlistForm));
// CONCATENATED MODULE: ./components/waitlist/Waitlist.js


function Waitlist__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Waitlist__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Waitlist__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Waitlist_Waitlist = function (_Component) {
  Waitlist__inherits(Waitlist, _Component);

  function Waitlist() {
    Waitlist__classCallCheck(this, Waitlist);

    var _this = Waitlist__possibleConstructorReturn(this, _Component.call(this));

    _this.toggleModal = function () {
      var clear = _this.props.clear;

      var open = !_this.state.showModal;
      if (open) {
        clear();
      }
      _this.setState({
        showModal: open
      });
    };

    _this.state = {
      showModal: false
    };
    return _this;
  }

  Waitlist.prototype.render = function render(_ref) {
    var ticket = _ref.ticket,
        event = _ref.event,
        eventDateId = _ref.eventDateId;

    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        components_Button["a" /* default */],
        {
          type: "secondary",
          "aria-label": "Join waitlist",
          size: "small",
          onClick: this.toggleModal
        },
        "Join waitlist"
      ),
      Object(preact_min["h"])(Modal["a" /* default */], {
        showModal: this.state.showModal,
        closeHandler: this.toggleModal,
        title: "Join waitlist",
        maxWidth: 600,
        contents: Object(preact_min["h"])(waitlist_WaitlistForm, { event: event, ticket: ticket })
      })
    );
  };

  return Waitlist;
}(preact_min["Component"]);

/* harmony default export */ var waitlist_Waitlist = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {};
}, { clear: waitlistActions["i" /* clear */] })(Waitlist_Waitlist));
// CONCATENATED MODULE: ./routes/tickets/components/Ticket.js



var format = __webpack_require__("84la");


var Ticket_feesStr = Object(index_esm["css"])({
  color: "#5A626C",
  fontSize: 11,
  fontWeight: "normal",
  display: "block"
});

var accessGrantedAnimation = Object(index_esm["keyframes"])({
  "0%": {
    backgroundColor: "#e8fcf5",
    color: "#157e77"
  },
  "40%": {
    backgroundColor: "#e8fcf5",
    color: "#157e77"
  },
  "60%": {
    backgroundColor: "#e8fcf5",
    color: "#157e77"
  },
  "100%": {
    backgroundColor: "#fff",
    color: "#323232"
  }
});

var ticketPriceStyle = Object(index_esm["css"])({
  width: 180,
  marginLeft: 8,
  alignItems: "center",
  display: "flex",
  "@media(max-width: 600px)": {
    marginTop: 8
  }
});

var Ticket__ref2 = Object(preact_min["h"])(
  "option",
  null,
  "0"
);

var Ticket_TicketsSelect = function TicketsSelect(_ref) {
  var ticket = _ref.ticket,
      addQuantity = _ref.addQuantity,
      addPrice = _ref.addPrice,
      ticketGroupIndex = _ref.ticketGroupIndex;

  var options = [];
  options.push(Ticket__ref2);
  var minTickets = ticket.minTickets ? ticket.minTickets : 1;
  var isManualOrder = determineManualOrder();
  if (isManualOrder) {
    ticket.maxTickets = 10;
  }
  for (var i = 1; i <= ticket.maxTickets; i++) {
    var disabled = i < minTickets;
    if (ticket.multiplesOf) {
      disabled = i % ticket.multiplesOf === 0 ? false : true;
    }
    options.push(Object(preact_min["h"])(
      "option",
      { value: i, disabled: disabled && !isManualOrder },
      i
    ));
  }
  return Object(preact_min["h"])(
    "div",
    {
      style: {
        alignItems: "center",
        display: "flex",
        flexWrap: "wrap"
      }
    },
    Object(preact_min["h"])(
      "div",
      {
        style: {
          alignItems: "center",
          display: "flex"
        }
      },
      Object(preact_min["h"])(
        "h5",
        {
          style: {
            margin: "0 10px 0 0",
            fontSize: 16
          }
        },
        Object(preact_min["h"])(
          "label",
          {
            "for": "select-tickets-" + ticket._id,
            id: (ticketGroupIndex ? ticketGroupIndex : ticket.name.replace(/\s/g, "-").toLowerCase()) + "-price"
          },
          ticket.price === 0 ? "Free" : "$" + format.checkPad(ticket.displayPrice),
          ticket.extraChargesNote ? Object(preact_min["h"])(
            "span",
            { className: Ticket_feesStr },
            ticket.extraChargesNote
          ) : null
        )
      ),
      Object(preact_min["h"])(
        "div",
        {
          style: {
            width: 80
          }
        },
        Object(preact_min["h"])(
          "select",
          {
            id: "select-tickets-" + ticket._id,
            "aria-labelledby": (ticketGroupIndex ? ticketGroupIndex : ticket.name.replace(/\s/g, "-").toLowerCase()) + "-price " + (ticketGroupIndex ? ticketGroupIndex : ticket.name.replace(/\s/g, "-").toLowerCase()) + "-name",
            disabled: ticket.maxTickets ? false : true,
            "class": "form-select",
            onChange: function onChange(evt) {
              return addQuantity(ticket._id, Number(evt.target.value));
            },
            value: ticket.quantity
          },
          options
        )
      )
    ),
    ticket.quantity > 0 && isManualOrder ? Object(preact_min["h"])(
      "div",
      { className: ticketPriceStyle },
      Object(preact_min["h"])(
        "h5",
        {
          style: {
            margin: "0 10px 0 0",
            fontSize: 16,
            textAlign: "right"
          }
        },
        Object(preact_min["h"])(
          "label",
          { "for": "price-" + ticket._id },
          "Amount Paid Per Ticket"
        )
      ),
      Object(preact_min["h"])("input", {
        style: {
          width: 80
        },
        id: "price-" + ticket._id,
        "class": "form-input",
        type: "number",
        value: ticket.price,
        onChange: function onChange(evt) {
          return addPrice(ticket._id, Number(evt.target.value));
        },
        min: "0"
      })
    ) : null
  );
};

var Ticket_Ticket = function Ticket(_ref3) {
  var ticket = _ref3.ticket,
      addQuantity = _ref3.addQuantity,
      addPrice = _ref3.addPrice,
      _ref3$ticketsRemainin = _ref3.ticketsRemainingDisplay,
      ticketsRemainingDisplay = _ref3$ticketsRemainin === undefined ? false : _ref3$ticketsRemainin,
      _ref3$eventSoldOut = _ref3.eventSoldOut,
      eventSoldOut = _ref3$eventSoldOut === undefined ? false : _ref3$eventSoldOut,
      ticketGroupIndex = _ref3.ticketGroupIndex;

  var isManualOrder = determineManualOrder();
  if (isManualOrder) {
    ticket.soldOut = false;
    ticket.showWaitlist = false;
    ticket.hidden = false;
  } else {
    ticket.soldOut = eventSoldOut === true ? true : ticket.soldOut;
  }
  if (ticket.hidden && !ticket.accessGranted && !isManualOrder) {
    return null;
  }

  var ticketStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  };
  var ticketWrap = {
    borderBottom: "1px solid #d9d9d9",
    padding: "10px 0",
    animation: ticket.hidden && ticket.accessGranted ? accessGrantedAnimation + " 5000ms 1" : "none"
  };
  var infoStyle = {
    flex: 1,
    paddingRight: 24
  };

  var ticketRemainingText = void 0,
      ticketRemainingTextColour = "#DD1C1C";
  if (ticket.soldOut) {
    ticketRemainingText = "Sold out";
    ticketRemainingTextColour = "#DD1C1C";
  } else if (ticket.available && ticket.available < 10) {
    ticketRemainingText = "Only " + ticket.available + " tickets left!";
  } else if (ticket.available) {
    ticketRemainingText = ticket.available + " tickets left";
  }
  var descriptionStyle = {
    margin: "6px 0 0",
    fontSize: 14,
    color: "#5A626C",
    whiteSpace: "pre-line",
    wordBreak: "break-word"
  };
  return Object(preact_min["h"])(
    "div",
    { style: ticketWrap },
    Object(preact_min["h"])(
      "div",
      { style: ticketStyle },
      Object(preact_min["h"])(
        "div",
        { style: infoStyle },
        Object(preact_min["h"])(
          "h4",
          {
            id: ticketGroupIndex ? ticketGroupIndex + "-name" : ticket.name + "-name",
            style: {
              margin: 0
            }
          },
          ticket.name
        ),
        ticket.includesMsg ? Object(preact_min["h"])("p", {
          style: descriptionStyle,
          dangerouslySetInnerHTML: {
            __html: ticket.includesMsg
          }
        }) : null,
        Object(preact_min["h"])(
          "p",
          { style: descriptionStyle },
          ticket.description
        ),
        ticket.dateError ? Object(preact_min["h"])(
          "p",
          { style: descriptionStyle },
          ticket.dateError
        ) : "",
        (ticketsRemainingDisplay || ticket.soldOut) && Object(preact_min["h"])(
          "div",
          {
            style: {
              fontSize: 12,
              color: ticketRemainingTextColour
            }
          },
          ticketRemainingText
        )
      ),
      ticket.showWaitlist ? Object(preact_min["h"])(waitlist_Waitlist, { ticket: ticket }) : Object(preact_min["h"])(Ticket_TicketsSelect, {
        ticket: ticket,
        addQuantity: addQuantity,
        addPrice: addPrice,
        ticketGroupIndex: ticketGroupIndex
      })
    ),
    Object(preact_min["h"])(
      "span",
      { "class": "text-error" },
      ticket.errors ? ticket.errors.map(function (err) {
        return Object(preact_min["h"])(
          "p",
          null,
          err
        );
      }) : ""
    )
  );
};

/* harmony default export */ var components_Ticket = (Ticket_Ticket);
// CONCATENATED MODULE: ./routes/tickets/components/TicketDisplay.js




var TicketDisplay_TicketDisplay = function TicketDisplay(_ref) {
  var ticket = _ref.ticket,
      tickets = _ref.tickets,
      updateDonationAmount = _ref.updateDonationAmount,
      addQuantity = _ref.addQuantity,
      addPrice = _ref.addPrice,
      ticketsRemainingDisplay = _ref.ticketsRemainingDisplay,
      eventSoldOut = _ref.eventSoldOut,
      showCustomDonationField = _ref.showCustomDonationField,
      donationOtherOption = _ref.donationOtherOption,
      ticketGroupIndex = _ref.ticketGroupIndex;

  if (ticket.isDonation) {
    return Object(preact_min["h"])(components_Donation, {
      ticket: ticket,
      updateDonationAmount: updateDonationAmount,
      showCustomDonationField: showCustomDonationField,
      donationOtherOption: donationOtherOption
    });
  } else {
    return Object(preact_min["h"])(components_Ticket, {
      ticket: ticket,
      addQuantity: addQuantity,
      addPrice: addPrice,
      eventSoldOut: eventSoldOut,
      ticketsRemainingDisplay: ticketsRemainingDisplay,
      ticketGroupIndex: ticketGroupIndex
    });
  }
};

/* harmony default export */ var components_TicketDisplay = (TicketDisplay_TicketDisplay);
// EXTERNAL MODULE: ./utils/Accessability.js
var Accessability = __webpack_require__("kbGH");
var Accessability_default = /*#__PURE__*/__webpack_require__.n(Accessability);

// CONCATENATED MODULE: ./routes/tickets/components/TicketGroup.js


function TicketGroup__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TicketGroup__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TicketGroup__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var dropDown = Object(index_esm["css"])({
  transition: "height 0.3s ease-out",
  height: 0,
  overflowY: "hidden"
});

var defaultCarrotStyles = {
  borderBottom: "1px solid #DEDEDE",
  padding: "16px 6px 16px 0",
  margin: 0,
  backgroundSize: "16px auto",
  fontSize: 16,
  display: "flex",
  justifyContent: "space-between"
};

var TicketGroup_carot = function carot(open) {
  var currentColour = open ? "#6621c0" : "#67717e";
  var degree = open ? "-45deg" : "135deg";

  return Object(index_esm["css"])({
    "&::after": {
      content: "''",
      width: 7,
      height: 7,
      borderTop: "solid 2px " + currentColour,
      borderRight: "solid 2px " + currentColour,
      transform: "rotate(" + degree + ")",
      marginTop: open ? 9 : 7,
      marginRight: 2,
      transitionProperty: "transform, borderTop, borderRight",
      transitionDuration: "0.1s",
      transitionTimingFunction: "ease-out"
    }
  });
};

var TicketGroup_TicketGroup = function (_Component) {
  TicketGroup__inherits(TicketGroup, _Component);

  function TicketGroup(props) {
    TicketGroup__classCallCheck(this, TicketGroup);

    var _this = TicketGroup__possibleConstructorReturn(this, _Component.call(this, props));

    _this.toggle = function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      }, _this.toggleChanged);
    };

    _this.toggleChanged = function () {
      var open = _this.state.open;

      if (!open) {
        _this.collapseSection();
        return;
      }
      _this.expandSection();
    };

    _this.collapseSection = function () {
      var elem = _this.dropDown;
      var sectionHeight = elem.scrollHeight;
      var elementTransition = elem.style.transition;
      elem.style.transition = "";
      elem.style.display = "none";
      window.requestAnimationFrame(function () {
        elem.style.height = sectionHeight + "px";
        elem.style.transition = elementTransition;
        window.requestAnimationFrame(function () {
          elem.style.height = 0 + "px";
        });
      });
    };

    _this.expandSection = function () {
      var elem = _this.dropDown;
      elem.style.display = "block";
      var sectionHeight = elem.scrollHeight;
      elem.style.height = sectionHeight + "px";
    };

    _this.state = {
      open: false
    };
    return _this;
  }

  TicketGroup.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        group = _props.group,
        tickets = _props.tickets,
        updateDonationAmount = _props.updateDonationAmount,
        addQuantity = _props.addQuantity,
        ticketsRemainingDisplay = _props.ticketsRemainingDisplay,
        showCustomDonationField = _props.showCustomDonationField,
        donationOtherOption = _props.donationOtherOption,
        addPrice = _props.addPrice;
    var open = this.state.open;

    var buttonStyle = Object(index_esm["css"])({
      textDecoration: "none",
      color: open ? "#6621c0" : "#323232",
      width: "100%",
      padding: "0",
      ":hover": {
        textDecoration: "none",
        color: open ? "#6621c0" : "#323232"
      }
    });
    var isManualOrder = determineManualOrder();

    var visibleTickets = isManualOrder ? group.ticketsWithInfo : group.ticketsWithInfo.filter(function (ticket) {
      return !ticket.hidden || ticket.accessGranted;
    });

    var groupStyle = Object(index_esm["css"])([defaultCarrotStyles, TicketGroup_carot(open)]);

    if (!visibleTickets.length) {
      // the group is empty
      return null;
    }
    var ticketsList = visibleTickets.map(function (ticket, index) {
      return Object(preact_min["h"])(
        "div",
        { style: { marginLeft: 12 } },
        Object(preact_min["h"])(components_TicketDisplay, {
          tickets: tickets,
          ticket: ticket,
          updateDonationAmount: updateDonationAmount,
          addQuantity: addQuantity,
          addPrice: addPrice,
          ticketsRemainingDisplay: ticketsRemainingDisplay,
          showCustomDonationField: showCustomDonationField,
          donationOtherOption: donationOtherOption,
          ticketGroupIndex: group.name.replace(/\s/g, "-").toLowerCase() + "-" + (index + 1)
        })
      );
    });
    return Object(preact_min["h"])(
      "div",
      {
        style: {
          marginBottom: open ? 20 : 0
        }
      },
      Object(preact_min["h"])(
        "button",
        {
          className: buttonStyle,
          onClick: this.toggle,
          tabIndex: 0,
          "aria-expanded": open ? "true" : "false"
        },
        Object(preact_min["h"])(
          "h3",
          { className: groupStyle },
          group.name
        )
      ),
      Object(preact_min["h"])(
        "div",
        { ref: function ref(elem) {
            return _this2.dropDown = elem;
          }, className: dropDown },
        ticketsList
      )
    );
  };

  return TicketGroup;
}(preact_min["Component"]);

/* harmony default export */ var components_TicketGroup = (TicketGroup_TicketGroup);
// CONCATENATED MODULE: ./routes/tickets/components/TicketOrder.js


function TicketOrder__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TicketOrder__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TicketOrder__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TicketOrder_TicketOrder = function (_Component) {
  TicketOrder__inherits(TicketOrder, _Component);

  function TicketOrder() {
    TicketOrder__classCallCheck(this, TicketOrder);

    return TicketOrder__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TicketOrder.prototype.render = function render(_ref) {
    var tickets = _ref.tickets,
        ticketGroups = _ref.ticketGroups,
        addTicketQuantity = _ref.addTicketQuantity,
        ticketSelection = _ref.ticketSelection,
        updateDonationAmount = _ref.updateDonationAmount,
        ticketsRemainingDisplay = _ref.ticketsRemainingDisplay,
        showCustomDonationField = _ref.showCustomDonationField,
        addTicketPrice = _ref.addTicketPrice;

    // find tickets which are not in the groups
    var ticketIdsInGroups = ticketGroups.reduce(function (ticketIds, group) {
      return ticketIds.concat(group.tickets);
    }, []);
    var ticketsNotInGroups = ticketSelection.tickets.reduce(function (tickets, ticket) {
      if (ticketIdsInGroups.indexOf(ticket._id) == -1) {
        tickets.push(ticket);
      }
      return tickets;
    }, []);
    var donationOtherOption = ticketSelection.donationOtherOption ? ticketSelection.donationOtherOption : false;
    return Object(preact_min["h"])(
      "div",
      null,
      ticketsNotInGroups.map(function (ticket) {
        if (ticket.ticketGroup) {
          return Object(preact_min["h"])(components_TicketGroup, {
            group: ticket,
            tickets: tickets,
            updateDonationAmount: updateDonationAmount,
            addQuantity: addTicketQuantity,
            addPrice: addTicketPrice,
            ticketsRemainingDisplay: ticketsRemainingDisplay,
            showCustomDonationField: showCustomDonationField,
            donationOtherOption: donationOtherOption
          });
        }
        return Object(preact_min["h"])(components_TicketDisplay, {
          tickets: tickets,
          ticket: ticket,
          updateDonationAmount: updateDonationAmount,
          addQuantity: addTicketQuantity,
          addPrice: addTicketPrice,
          ticketsRemainingDisplay: ticketsRemainingDisplay,
          showCustomDonationField: showCustomDonationField,
          donationOtherOption: donationOtherOption
        });
      })
    );
  };

  return TicketOrder;
}(preact_min["Component"]);

/* harmony default export */ var components_TicketOrder = (TicketOrder_TicketOrder);
// CONCATENATED MODULE: ./components/OrderTotal.js
var OrderTotal__css;





var totalBlock = Object(index_esm["css"])((OrderTotal__css = {
  display: "none"
}, OrderTotal__css[Object(CssUtils["c" /* max */])(768)] = {
  display: "inline-block",
  p: {
    fontWeight: 600,
    marginBottom: 2,
    fontSize: 14,
    lineHeight: "14px"
  }
}, OrderTotal__css));

var OrderTotal__ref2 = Object(preact_min["h"])(
  "p",
  null,
  "Total:"
);

var OrderTotal_OrderTotal = function OrderTotal(_ref) {
  var orderSummary = _ref.orderSummary;

  if (orderSummary && !orderSummary.loading && orderSummary.data && orderSummary.data.total) {
    return Object(preact_min["h"])(
      "div",
      { className: totalBlock },
      OrderTotal__ref2,
      Object(preact_min["h"])(
        "p",
        null,
        "$",
        orderSummary.data.total.toFixed(2)
      )
    );
  }
};

/* harmony default export */ var components_OrderTotal = (OrderTotal_OrderTotal);
// CONCATENATED MODULE: ./routes/tickets/components/TicketSelectionComponent.js









var headingCustomStyling = {
  borderBottom: "1px solid #dedede",
  paddingBottom: 8,
  marginBottom: 0
};

var nextStageButton = Object(index_esm["css"])({ height: "40px !important", minWidth: 150 });

var TicketSelectionComponent__ref2 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var TicketSelectionComponent__ref4 = Object(preact_min["h"])(
  "div",
  null,
  Object(preact_min["h"])(WarningMessage["a" /* default */], { title: "There are no publicly available tickets" }),
  Object(preact_min["h"])(components_AccessCode, null)
);

var TicketSelectionComponent__ref5 = Object(preact_min["h"])(
  "h2",
  { style: headingCustomStyling },
  "Choose your tickets"
);

var TicketSelectionComponent__ref6 = Object(preact_min["h"])(components_AccessCode, null);

var TicketSelectionComponent_TicketSelectionComponent = function TicketSelectionComponent(_ref) {
  var event = _ref.event,
      ticketSelection = _ref.ticketSelection,
      addTicketPrice = _ref.addTicketPrice,
      addTicketQuantity = _ref.addTicketQuantity,
      requestOrder = _ref.requestOrder,
      orderSummary = _ref.orderSummary,
      order = _ref.order,
      updateDonationAmount = _ref.updateDonationAmount,
      showCustomDonationField = _ref.showCustomDonationField,
      openModal = _ref.openModal;

  if (ticketSelection.ticketsRequest.loading) {
    return TicketSelectionComponent__ref2;
  }
  if (!ticketSelection.ticketsRequest.loaded) {
    return null;
  }
  var eventSoldOut = event.data && event.data.soldOut ? event.data.soldOut : false;

  var validTickets = ticketSelection.tickets.filter(function (ticket) {
    if (ticket.hidden && !ticket.accessGranted) {
      return false;
    }
    return true;
  });
  var hasTickets = validTickets.length ? true : false;

  var ticketsOnSale = !hasTickets ? false : true;
  var totalTickets = ticketSelection.tickets.reduce(function (sum, _ref3) {
    var quantity = _ref3.quantity;
    return sum + quantity;
  }, 0);
  var ticketsRemainingDisplay = event.data.settings.ticketsRemainingDisplay;
  var clientDonation = ticketSelection.clientDonation;
  var showSeatingMapOverview = event.data.seatingMaps && event.data.seatingMaps.length > 0 && event.data.seatingMaps.reduce(function (show, seatingMap) {
    return show || seatingMap.public;
  }, false);

  if (!ticketsOnSale) {
    return TicketSelectionComponent__ref4;
  }
  return Object(preact_min["h"])(
    "div",
    null,
    TicketSelectionComponent__ref5,
    showSeatingMapOverview ? Object(preact_min["h"])(
      "a",
      { style: { cursor: "pointer" }, onclick: openModal },
      "Preview Seating Map"
    ) : null,
    Object(preact_min["h"])(components_TicketOrder, {
      ticketGroups: event.data.ticketGroups,
      tickets: ticketSelection.tickets,
      addTicketQuantity: addTicketQuantity,
      addTicketPrice: addTicketPrice,
      ticketSelection: ticketSelection,
      updateDonationAmount: updateDonationAmount,
      ticketsRemainingDisplay: ticketsRemainingDisplay,
      eventSoldOut: eventSoldOut,
      showCustomDonationField: showCustomDonationField
    }),
    TicketSelectionComponent__ref6,
    Object(preact_min["h"])(
      ActionBar["a" /* default */],
      null,
      Object(preact_min["h"])(components_OrderTotal, { orderSummary: orderSummary }),
      Object(preact_min["h"])(
        ActionButton["a" /* default */],
        {
          disabled: orderSummary.loading || order.orderRequest.loading || !totalTickets && !clientDonation || clientDonation < 0,
          onClick: requestOrder,
          loading: order.orderRequest.loading || orderSummary.loading,
          dataCY: "EnterDetails",
          classNames: nextStageButton
        },
        "Enter Details"
      )
    )
  );
};
/* harmony default export */ var components_TicketSelectionComponent = (TicketSelectionComponent_TicketSelectionComponent);
// CONCATENATED MODULE: ./routes/tickets/components/EventDataChecks.js






var EventDataChecks__ref = Object(preact_min["h"])(Page["a" /* default */], null);

var EventDataChecks__ref2 = Object(preact_min["h"])(
  Page["a" /* default */],
  { background: true, border: true },
  Object(preact_min["h"])(
    Content["a" /* default */],
    null,
    Object(preact_min["h"])(WarningMessage["a" /* default */], {
      title: "Ticket Sales Unavailable",
      message: "Ticket sales have ended"
    })
  )
);

var EventDataChecks__ref3 = Object(preact_min["h"])(
  Page["a" /* default */],
  { background: true, border: true },
  Object(preact_min["h"])(
    Content["a" /* default */],
    null,
    Object(preact_min["h"])(WarningMessage["a" /* default */], { title: "Ticket Sales Unavailable" })
  )
);

var EventDataChecks_EventDataChecks = function EventDataChecks(event) {
  var isManualOrder = determineManualOrder();
  if (event.loading || !event.data) {
    return EventDataChecks__ref;
  }
  if (event.data.suspendSales && !isManualOrder) {
    return EventDataChecks__ref2;
  }
  if (!event.data.validDates.length && !isManualOrder) {
    return EventDataChecks__ref3;
  }
  return false;
};

/* harmony default export */ var components_EventDataChecks = (EventDataChecks_EventDataChecks);
// CONCATENATED MODULE: ./routes/tickets/Tickets.js
var Tickets__css;



function Tickets__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Tickets__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Tickets__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var colSpacing = Object(index_esm["css"])((Tickets__css = {
  marginRight: 10
}, Tickets__css[Object(CssUtils["c" /* max */])(700)] = {
  marginRight: 0
}, Tickets__css));

var Tickets__ref3 = Object(preact_min["h"])(BookingHeader["a" /* default */], null);

var Tickets__ref4 = Object(preact_min["h"])(components_YourOrder, { allowDiscountsAdd: false });

var Tickets_Tickets = function (_Component) {
  Tickets__inherits(Tickets, _Component);

  function Tickets() {
    Tickets__classCallCheck(this, Tickets);

    var _this = Tickets__possibleConstructorReturn(this, _Component.call(this));

    _this.closeModal = function () {
      _this.setState({
        showModal: false
      });
    };

    _this.openModal = function () {
      _this.setState({
        showModal: true
      });
    };

    _this.addTicketQuantity = _this.addTicketQuantity.bind(_this);
    _this.addTicketPrice = _this.addTicketPrice.bind(_this);
    _this.requestOrder = _this.requestOrder.bind(_this);
    _this.state = {
      showModal: false
    };
    return _this;
  }

  Tickets.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        event = _props.event,
        order = _props.order,
        getEvent = _props.getEvent,
        eventSlug = _props.eventSlug,
        clearOrder = _props.clearOrder,
        resetSeatingMapEvaluation = _props.resetSeatingMapEvaluation,
        resetMerchOrder = _props.resetMerchOrder,
        selectDate = _props.selectDate;

    resetMerchOrder();
    var parsed = query_string_default.a.parse(window.location.search);
    resetSeatingMapEvaluation();
    if (!event.data && !event.loading) {
      getEvent(eventSlug, null, false, null, false);
    } else if (event.data && event.data.slug !== eventSlug) {
      getEvent(eventSlug, null, false, null, false);
    }

    if (parsed.dateId) {
      var parsedDate = void 0;
      event.data.dates.forEach(function (date) {
        if (parsed.dateId === date._id) {
          parsedDate = date;
        }
      });
      selectDate(parsedDate._id, parsedDate.display, parsedDate.startDate);
    }
    if (order && order.data && order.data.status === "complete") {
      clearOrder();
    }
    Object(BrowserUtils["a" /* pageChange */])("Select Tickets", event);
    TrackingService["a" /* default */].ticketsViewed(event.data);
  };

  Tickets.prototype.componentDidUpdate = function componentDidUpdate() {
    var _props2 = this.props,
        event = _props2.event,
        selectDate = _props2.selectDate,
        ticketSelection = _props2.ticketSelection,
        checkAccessCode = _props2.checkAccessCode;

    var parsed = query_string_default.a.parse(window.location.search);
    var isManualOrder = determineManualOrder();
    var hasAppliedAccessCode = ticketSelection.accessCode && parsed.accesscode || !parsed.accesscode;
    if (event && event.data && event.data.validDates && ticketSelection && !ticketSelection.tickets && hasAppliedAccessCode) {
      if (isManualOrder) {
        selectDate(event.data.dates[0]._id, event.data.dates[0].display, event.data.dates[0].startDate);
      } else {
        if (event.data.validDates.length === 1) {
          selectDate(event.data.validDates[0]._id, event.data.validDates[0].display, event.data.validDates[0].startDate);
        }
      }
    }
    if (!ticketSelection.accessCode && ticketSelection.accessCodeRequest && !ticketSelection.accessCodeRequest.loading && event && event.data && parsed.accesscode) {
      checkAccessCode(event.data._id, parsed.accesscode, false);
    }
  };

  Tickets.prototype.addTicketQuantity = function addTicketQuantity(ticketTypeId, quantity) {
    var addQuantity = this.props.addQuantity;

    addQuantity(ticketTypeId, quantity);
  };

  Tickets.prototype.addTicketPrice = function addTicketPrice(ticketTypeId, price) {
    var addPrice = this.props.addPrice;

    addPrice(ticketTypeId, price);
  };

  Tickets.prototype.requestOrder = function requestOrder() {
    var _props3 = this.props,
        eventSlug = _props3.eventSlug,
        event = _props3.event,
        order = _props3.order,
        ticketSelection = _props3.ticketSelection,
        requestOrder = _props3.requestOrder;

    var totalTickets = ticketSelection.tickets.reduce(function (sum, _ref) {
      var quantity = _ref.quantity;
      return sum + quantity;
    }, 0);
    if (!order.orderRequest.loading && (totalTickets || ticketSelection.clientDonation)) {
      var lastOrderId = order.data ? order.data._id : null;
      var parsed = query_string_default.a.parse(window.location.search);
      var discountCode = parsed.discountcode ? parsed.discountcode : order.discountCode;
      var manualOrderValues = {};
      if (window) {
        manualOrderValues.token = window.manualOrderToken;
        manualOrderValues.manualOrder = window.isManualOrder;
        manualOrderValues.manualOrderSettings = window.manualOrderSettings;
      }
      requestOrder(eventSlug, event.id, ticketSelection.selectedDateId, ticketSelection.requestedTickets, discountCode, ticketSelection.clientDonation, lastOrderId, false, manualOrderValues);
    }
  };

  Tickets.prototype.render = function render(_ref2) {
    var event = _ref2.event,
        order = _ref2.order,
        ticketSelection = _ref2.ticketSelection,
        selectDate = _ref2.selectDate,
        updateDonationAmount = _ref2.updateDonationAmount,
        orderSummary = _ref2.orderSummary,
        showCustomDonationField = _ref2.showCustomDonationField;

    var eventDataChecks = components_EventDataChecks(event);
    if (eventDataChecks) {
      return eventDataChecks;
    }
    var displayAccessibility = event.data && event.data.accessibility ? checkObjNotEmpty(event.data.accessibility) : false;
    var showSeatingMapOverview = event.data.seatingMaps && event.data.seatingMaps.length > 0 && event.data.seatingMaps.reduce(function (show, seatingMap) {
      return show || seatingMap.public;
    }, false);
    return Object(preact_min["h"])(
      Page["a" /* default */],
      null,
      Object(preact_min["h"])(components_SeatingMapModal, {
        showSeatingMapOverview: showSeatingMapOverview,
        showModal: this.state.showModal,
        closeModal: this.closeModal
      }),
      Object(preact_min["h"])(
        Content["a" /* default */],
        null,
        Tickets__ref3,
        Object(preact_min["h"])(
          TwoCols["a" /* default */],
          null,
          Object(preact_min["h"])(
            "div",
            { className: colSpacing },
            Object(preact_min["h"])(components_AccessibilityComponent, {
              displayAccessibility: displayAccessibility,
              event: event
            }),
            Object(preact_min["h"])(components_OrderErrorMessage, { order: order }),
            Object(preact_min["h"])(components_DateSelectorComponent, {
              datesUseCalendar: event.data.datesUseCalendar,
              event: event,
              ticketSelection: ticketSelection,
              selectDate: selectDate
            }),
            Object(preact_min["h"])(components_TicketSelectionComponent, {
              event: event,
              ticketSelection: ticketSelection,
              addTicketPrice: this.addTicketPrice,
              addTicketQuantity: this.addTicketQuantity,
              requestOrder: this.requestOrder,
              orderSummary: orderSummary,
              order: order,
              updateDonationAmount: updateDonationAmount,
              showCustomDonationField: showCustomDonationField,
              openModal: this.openModal
            })
          ),
          Tickets__ref4
        )
      )
    );
  };

  return Tickets;
}(preact_min["Component"]);

/* harmony default export */ var tickets_Tickets = (Object(es["b" /* connect */])(function (state) {
  return {
    event: state.event,
    ticketSelection: state.ticketSelection,
    order: state.order,
    orderSummary: state.orderSummary
  };
}, {
  getEvent: eventActions["u" /* getEvent */],
  requestOrder: orderActions["_0" /* requestOrder */],
  addQuantity: ticketsActions["p" /* addQuantity */],
  selectDate: ticketsActions["u" /* selectDate */],
  loadTickets: ticketsActions["s" /* loadTickets */],
  clearOrder: orderActions["N" /* clearOrder */],
  updateDonationAmount: ticketsActions["x" /* updateDonationAmount */],
  resetSeatingMapEvaluation: seatingMapActions["o" /* resetSeatingMapEvaluation */],
  resetMerchOrder: merchandiseActions["n" /* resetMerchOrder */],
  showCustomDonationField: ticketsActions["w" /* showCustomDonationField */],
  checkAccessCode: ticketsActions["q" /* checkAccessCode */],
  addPrice: ticketsActions["o" /* addPrice */]
})(Tickets_Tickets));
// CONCATENATED MODULE: ./routes/widgets/EventListings.js


function EventListings__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EventListings__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EventListings__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * Display event listings (Used only for widget)
 *
 * @class EventListings
 * @extends {Component}
 */

var EventListings_EventListings = function (_Component) {
  EventListings__inherits(EventListings, _Component);

  function EventListings() {
    EventListings__classCallCheck(this, EventListings);

    return EventListings__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  EventListings.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        event = _props.event,
        getUserEvents = _props.getUserEvents;

    var params = Object(Format["parseQueryString"])(location.search.replace("?", ""));
    var userId = params.u;
    var organiserId = params.o;
    if (!event.data && !event.loading) {
      getUserEvents(userId, organiserId);
    }
  };

  EventListings.prototype.render = function render() {
    var params = {};
    if (typeof window !== "undefined") {
      params = Object(Format["parseQueryString"])(location.search.replace("?", ""));
    }
    var _params = params,
        _params$bc = _params.bc,
        bc = _params$bc === undefined ? "#6621c0" : _params$bc,
        _params$bt = _params.bt,
        bt = _params$bt === undefined ? "Get Tickets" : _params$bt,
        _params$tc = _params.tc,
        tc = _params$tc === undefined ? "#fff" : _params$tc;

    var events = this.props.event.data || [];
    var styles = {
      container: {
        width: "100%",
        background: "#fff",
        margin: 0
      },
      row: {
        width: "99%",
        maxWidth: 800,
        margin: "10px auto 8px",
        height: 132,
        padding: "16px 20px",
        display: "flex",
        background: "#FFFFFF",
        boxShadow: "0 1px 8px 0 rgba(32, 7, 64, 0.13)",
        borderRadius: 4
      },
      leftColumn: {
        marginRight: 10
      },
      column: {
        marginRight: 10,
        whiteSpace: "nowrap",
        overflow: "hidden"
      },
      btnColumn: {
        paddingTop: 65,
        marginLeft: "auto"
      },
      img: {
        width: 200,
        height: 100
      },
      title: {
        fontSize: 18,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      },
      contents: {
        fontSize: 14,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      },
      price: {
        fontSize: 14,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#5A626C"
      },
      button: {
        background: bc,
        color: tc,
        minWidth: 129,
        width: "100%",
        height: 36,
        borderRadius: 4,
        paddingTop: 7,
        fontSize: 16,
        textAlign: "center"
      },
      link: {
        color: "inherit",
        textDecoration: "none"
      }
    };
    var columns = events.map(function (event) {
      var url = "https://process.filestackapi.com/resize=h:100,w:200,fit:crop/VbieTVjAQvq5BTkE9vIi";
      if (event.featureImage) {
        url = event.featureImage.url;
      }
      if (event.bannerImage) {
        url = event.bannerImage.url;
      }
      var location = !event.location ? "" : event.location.type === "online" ? "Online" : event.location.address;
      var ticketslink = Object(config["a" /* default */])("TICKETING_URL") + "/" + event.slug;
      var validDates = event.dates.filter(function (date) {
        return !date.deleted && !date.disabled;
      });

      return Object(preact_min["h"])(
        "a",
        { style: styles.link, href: ticketslink, target: "_top" },
        Object(preact_min["h"])(
          "div",
          { style: styles.row },
          Object(preact_min["h"])(
            "div",
            { style: styles.leftColumn },
            Object(preact_min["h"])("img", { src: url, style: styles.img, alt: event.name })
          ),
          Object(preact_min["h"])(
            "div",
            { style: styles.column },
            Object(preact_min["h"])(
              "div",
              { style: styles.title },
              event.name
            ),
            Object(preact_min["h"])(
              "div",
              { style: styles.contents },
              validDates[0].display.date,
              " ",
              validDates[0].display.time
            ),
            Object(preact_min["h"])(
              "div",
              { style: styles.contents },
              location
            ),
            Object(preact_min["h"])(
              "div",
              { style: styles.price },
              event.ticketsPriceStr
            )
          ),
          Object(preact_min["h"])(
            "div",
            { style: styles.btnColumn },
            Object(preact_min["h"])(
              "div",
              { style: styles.button },
              bt
            )
          )
        )
      );
    });

    return Object(preact_min["h"])(
      "div",
      { style: styles.container },
      columns
    );
  };

  return EventListings;
}(preact_min["Component"]);

/* harmony default export */ var widgets_EventListings = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event
  };
}, {
  getUserEvents: eventActions["x" /* getUserEvents */]
})(EventListings_EventListings));
// EXTERNAL MODULE: ./components/CountDown.js
var CountDown = __webpack_require__("ZZUN");

// CONCATENATED MODULE: ./components/fields/CheckboxField.js
var CheckboxField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function CheckboxField__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CheckboxField__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CheckboxField__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var CheckboxField_CheckboxField = function (_Component) {
  CheckboxField__inherits(CheckboxField, _Component);

  function CheckboxField(props) {
    CheckboxField__classCallCheck(this, CheckboxField);

    var _this = CheckboxField__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      focus: false
    };
    _this.checkboxBlur = _this.checkboxBlur.bind(_this);
    _this.checkboxFocus = _this.checkboxFocus.bind(_this);
    return _this;
  }

  CheckboxField.prototype.checkboxFocus = function checkboxFocus() {
    this.setState({
      focus: true
    });
  };

  CheckboxField.prototype.checkboxBlur = function checkboxBlur() {
    this.setState({
      focus: false
    });
  };

  CheckboxField.prototype.render = function render() {
    var focus = this.state.focus;
    var _props = this.props,
        input = _props.input,
        label = _props.label,
        description = _props.description,
        required = _props.required,
        _props$meta = _props.meta,
        touched = _props$meta.touched,
        error = _props$meta.error,
        warning = _props$meta.warning;

    var checked = false;
    if (input && (input.value === "true" || input.value === true)) {
      checked = true;
    }
    return Object(preact_min["h"])(
      "div",
      { "class": touched && error ? "form-group has-error" : "form-group" },
      Object(preact_min["h"])(
        "label",
        { "for": input.name, "class": "form-checkbox" },
        Object(preact_min["h"])("input", CheckboxField__extends({
          type: "checkbox",
          id: input.name
        }, input, {
          checked: checked,
          "aria-label": "" + label,
          onFocus: this.checkboxFocus,
          onBlur: this.checkboxBlur,
          "aria-required": required ? "true" : "false",
          "aria-describedby": input.name + "Error"
        })),
        Object(preact_min["h"])("i", {
          "class": "form-icon",
          style: { border: focus ? "2px solid blue" : "1px solid #8d949e" }
        }),
        " ",
        label,
        Object(preact_min["h"])(Required["a" /* default */], { required: required }),
        Object(preact_min["h"])(Description["a" /* default */], { description: description })
      ),
      touched && error && Object(preact_min["h"])(
        "p",
        { "class": "form-input-hint", id: input.name + "Error" },
        error
      )
    );
  };

  return CheckboxField;
}(preact_min["Component"]);

/* harmony default export */ var fields_CheckboxField = (CheckboxField_CheckboxField);
// CONCATENATED MODULE: ./components/fields/RadioField.js
var RadioField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var RadioField__css;

var RadioField__templateObject = RadioField__taggedTemplateLiteralLoose(["\n    position: relative;\n  "], ["\n    position: relative;\n  "]),
    RadioField__templateObject2 = RadioField__taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 10px;\n    left: 5px;\n    width: 10px;\n    height: 10px;\n    background-color: #6621c0;\n    border-radius: 50%;\n  "], ["\n    position: absolute;\n    top: 10px;\n    left: 5px;\n    width: 10px;\n    height: 10px;\n    background-color: #6621c0;\n    border-radius: 50%;\n  "]);



function RadioField__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }







var RadioField_styles = {
  container: Object(index_esm["css"])(RadioField__templateObject),
  radioChecked: Object(index_esm["css"])(RadioField__templateObject2)
};

var RadioField_textWrapper = Object(index_esm["css"])((RadioField__css = {}, RadioField__css[Object(CssUtils["c" /* max */])(768)] = {
  fontSize: 14
}, RadioField__css));

var RadioField__ref2 = Object(preact_min["h"])("i", { "class": "form-icon" });

var RadioField__ref3 = Object(preact_min["h"])("br", null);

var RadioField_RadioField = function RadioField(_ref) {
  var input = _ref.input,
      label = _ref.label,
      description = _ref.description,
      required = _ref.required,
      inline = _ref.inline,
      options = _ref.options,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning;

  var radio = Object(index_esm["css"])({
    position: "absolute",
    top: 5,
    width: 20,
    height: 20,
    left: 0,
    bottom: 0,
    zIndex: 1,
    cursor: "pointer",
    opacity: 0,
    "&:focus": {
      "+ span": {
        borderColor: "orange !important"
      }
    }
  });
  var style = inline ? { display: "inline-block", marginRight: 40 } : null;
  return Object(preact_min["h"])(
    "fieldset",
    { "class": touched && error ? "form-group has-error" : "form-group" },
    Object(preact_min["h"])(
      "legend",
      { "for": input.name, className: RadioField_textWrapper },
      RadioField__ref2,
      " ",
      label,
      Object(preact_min["h"])(Required["a" /* default */], { required: required }),
      RadioField__ref3,
      Object(preact_min["h"])(Description["a" /* default */], { description: description }),
      options.map(function (option) {
        var _css2;

        var checked = input.value === option.value ? true : false;
        var radioInner = Object(index_esm["css"])((_css2 = {
          position: "relative",
          top: 5,
          left: 0,
          display: "block",
          width: 20,
          height: 20,
          marginRight: 10,
          backgroundColor: "white",
          borderStyle: "solid",
          borderWidth: 2,
          borderRadius: 100,
          transition: "all 0.3s",
          borderColor: checked ? "#6621c0" : "#67717e"
        }, _css2["display"] = inline ? "inline-block" : null, _css2));
        return Object(preact_min["h"])(
          "div",
          { key: option.label, className: RadioField_styles.container, style: style },
          Object(preact_min["h"])("input", RadioField__extends({
            type: "radio"
          }, input, {
            checked: checked,
            onChange: function onChange(e) {
              input.onChange(e);
            },
            name: label,
            id: option.label,
            value: option.value,
            className: radio,
            "aria-describedby": input.name + "Error"
          })),
          Object(preact_min["h"])("span", { id: "inner", className: radioInner }),
          checked ? Object(preact_min["h"])("span", { className: RadioField_styles.radioChecked, id: "checked" }) : null,
          Object(preact_min["h"])(
            "label",
            { "for": option.label },
            option.label
          )
        );
      })
    ),
    touched && error && Object(preact_min["h"])(
      "p",
      { "class": "form-input-hint", id: input.name + "Error" },
      error
    )
  );
};

/* harmony default export */ var fields_RadioField = (RadioField_RadioField);
// EXTERNAL MODULE: ./components/fields/TextareaField.js
var TextareaField = __webpack_require__("W6NO");

// CONCATENATED MODULE: ./routes/giftCards/GiftCardPageHeader.js
var GiftCardPageHeader__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var imageCropper = Object(index_esm["css"])({
  width: 32,
  height: 32,
  position: "relative",
  overflow: "hidden",
  borderRadius: "50%"
});

var companyInfo = Object(index_esm["css"])({
  flexGrow: 1,
  display: "flex",
  marginTop: 4
});
var GiftCardPageHeader_linkStyle = {
  color: "#196097",
  textDecoration: "underline"
};

var GiftCardPageHeader_GiftCardPageHeader = function GiftCardPageHeader(_ref) {
  var giftCards = _ref.giftCards,
      overrideHeaderColor = _ref.overrideHeaderColor,
      overrideTextColor = _ref.overrideTextColor,
      titleIsLink = _ref.titleIsLink;
  var giftCardPage = giftCards.giftCardPage;
  var style = giftCardPage.style,
      companyLogo = giftCardPage.companyLogo,
      companyName = giftCardPage.companyName,
      name = giftCardPage.name,
      slug = giftCardPage.slug;
  var headerColor = style.headerColor,
      headerTextColor = style.headerTextColor;

  var headerStyle = Object(index_esm["css"])({
    width: "100%",
    position: "relative",
    backgroundColor: overrideHeaderColor ? overrideHeaderColor : headerColor,
    paddingLeft: 14,
    paddingRight: 14,
    paddingBottom: 16,
    paddingTop: 20,
    display: "flex",
    boxShadow: "0 0 1px 0 #f1f1f1, 0 1px 3px 0 rgba(9, 30, 66, 0.13)",
    zIndex: 100,
    "@media (max-width: 800px)": {
      display: "block",
      paddingTop: 12
    }
  });

  var textColor = overrideTextColor ? overrideTextColor : headerTextColor;
  var mainHeader = Object(index_esm["css"])(GiftCardPageHeader__extends({
    color: textColor,
    marginRight: 8,
    fontSize: 26
  }, titleIsLink ? GiftCardPageHeader_linkStyle : {}, {
    "@media (max-width: 800px)": {
      fontSize: 20,
      marginTop: 4,
      marginBottom: 0
    }
  }));
  var header = Object(preact_min["h"])(
    "h1",
    { className: mainHeader },
    name.toUpperCase()
  );
  return Object(preact_min["h"])(
    "div",
    { className: headerStyle },
    Object(preact_min["h"])(
      "div",
      { className: companyInfo },
      Object(preact_min["h"])(GiftCardPageHeader_CompanyLogo, { companyLogo: companyLogo }),
      Object(preact_min["h"])(
        "h2",
        {
          style: {
            color: textColor,
            marginTop: 4,
            marginLeft: 8,
            marginBottom: 0
          }
        },
        companyName
      )
    ),
    titleIsLink ? Object(preact_min["h"])(
      match["Link"],
      { href: "/gift-cards/" + slug },
      header
    ) : header
  );
};

var GiftCardPageHeader_CompanyLogo = function CompanyLogo(_ref2) {
  var companyLogo = _ref2.companyLogo;

  if (!companyLogo || !companyLogo.handle) {
    return null;
  } else {
    return Object(preact_min["h"])(
      "div",
      { className: imageCropper },
      Object(preact_min["h"])(components_Picture, { width: 32, img: companyLogo })
    );
  }
};

/* harmony default export */ var giftCards_GiftCardPageHeader = (Object(es["b" /* connect */])(function (state) {
  return {
    giftCards: state.giftCards
  };
}, {})(GiftCardPageHeader_GiftCardPageHeader));
// EXTERNAL MODULE: ../node_modules/react-day-picker/DayPickerInput.js
var DayPickerInput = __webpack_require__("YPsP");
var DayPickerInput_default = /*#__PURE__*/__webpack_require__.n(DayPickerInput);

// EXTERNAL MODULE: ../node_modules/react-day-picker/lib/style.css
var lib_style = __webpack_require__("uGyY");
var lib_style_default = /*#__PURE__*/__webpack_require__.n(lib_style);

// CONCATENATED MODULE: ./components/fields/DateField.js
var DateField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var DateField_DateField = function DateField(_ref) {
  var input = _ref.input,
      label = _ref.label,
      description = _ref.description,
      inputType = _ref.inputType,
      required = _ref.required,
      type = _ref.type,
      style = _ref.style,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning;

  var dateStyle = Object(index_esm["css"])({
    width: "100%",
    input: {
      width: "100%"
    },
    ".DayPickerInput": {
      width: "100%"
    }
  });

  var handleDayChange = function handleDayChange(day) {
    var newDate = new Date(day);
    if (newDate.getFullYear() > 3000) {
      newDate.setFullYear(newDate.getFullYear() - 200000);
    }
    newDate.setHours(0, 0, 0, 0);
    var value = newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-" + newDate.getDate();
    input.onChange(value);
  };
  inputType = inputType ? inputType : type;
  var value = "";
  if (input.value) {
    value = new Date(input.value);
    if (value.getFullYear() > 3000) {
      value.setFullYear(value.getFullYear() - 200000);
    }
    value.setHours(0, 0, 0, 0);
    value = value.getDate() + "/" + (value.getMonth() + 1) + "/" + value.getFullYear();
  }

  return Object(preact_min["h"])(
    "div",
    {
      "class": touched && error ? "form-group has-error" : "form-group",
      style: style
    },
    Object(preact_min["h"])(
      "div",
      { className: dateStyle },
      label ? Object(preact_min["h"])(
        "label",
        { "for": input.name, "class": "form-label" },
        label,
        Object(preact_min["h"])(Required["a" /* default */], { required: required })
      ) : "",
      Object(preact_min["h"])(Description["a" /* default */], { description: description }),
      Object(preact_min["h"])(DayPickerInput_default.a, {
        placeholder: "DD/MM/YYYY",
        value: value,
        onDayChange: function onDayChange(day) {
          return handleDayChange(day);
        },
        component: function component(props) {
          return Object(preact_min["h"])("input", DateField__extends({
            "class": "form-input"
          }, props, {
            onBlur: input.onBlur,
            id: input.name,
            "aria-required": required ? "true" : "false",
            "aria-describedby": input.name + "Error"
          }));
        }
      }),
      touched && error && Object(preact_min["h"])(
        "p",
        { "class": "form-input-hint", id: input.name + "Error" },
        error
      )
    )
  );
};

/* harmony default export */ var fields_DateField = (DateField_DateField);
// CONCATENATED MODULE: ./components/fields/OptionsField.js
var OptionsField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function OptionsField__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OptionsField__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function OptionsField__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OptionsField__ref2 = Object(preact_min["h"])(
  "option",
  { value: -1 },
  "Select"
);

var OptionsField__ref3 = Object(preact_min["h"])(
  "span",
  null,
  "(Not available)"
);

var OptionsField_OptionsField = function (_Component) {
  OptionsField__inherits(OptionsField, _Component);

  function OptionsField() {
    OptionsField__classCallCheck(this, OptionsField);

    var _this = OptionsField__possibleConstructorReturn(this, _Component.call(this));

    _this.changeValue = _this.changeValue.bind(_this);
    _this.changeDescription = _this.changeDescription.bind(_this);
    return _this;
  }

  OptionsField.prototype.changeValue = function changeValue(index) {
    var _props = this.props,
        meta = _props.meta,
        input = _props.input,
        options = _props.options,
        formName = _props.formName;

    meta.dispatch(Object(redux_form_es["g" /* touch */])(formName, input.name));

    if (Number(index) === -1) {
      meta.dispatch(Object(redux_form_es["c" /* change */])(formName, input.name, null));
      return;
    }
    var option = options[index];
    meta.dispatch(Object(redux_form_es["c" /* change */])(formName, input.name, option.value));
  };

  OptionsField.prototype.changeDescription = function changeDescription(value) {
    var _props2 = this.props,
        meta = _props2.meta,
        input = _props2.input,
        formName = _props2.formName;
    var option = this.state.option;

    meta.dispatch(Object(redux_form_es["c" /* change */])(formName, input.name, option.value + ": " + value));
  };

  OptionsField.prototype.render = function render(_ref) {
    var _this2 = this;

    var input = _ref.input,
        options = _ref.options,
        label = _ref.label,
        description = _ref.description,
        required = _ref.required,
        type = _ref.type,
        dispatch = _ref.dispatch,
        defaultValue = _ref.defaultValue,
        trackQuantity = _ref.trackQuantity,
        _ref$includeSelectOpt = _ref.includeSelectOption,
        includeSelectOption = _ref$includeSelectOpt === undefined ? true : _ref$includeSelectOpt,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error,
        warning = _ref$meta.warning;

    var option = options.find(function (opt) {
      return opt.value === input.value;
    });
    var invalidObj = {};
    if (required) {
      invalidObj = {
        "aria-invalid": error && touched ? "true" : "false"
      };
    }
    return Object(preact_min["h"])(
      "div",
      { "class": touched && error ? "form-group has-error" : "form-group" },
      Object(preact_min["h"])(
        "label",
        { "for": input.name, "class": "form-label" },
        label,
        " ",
        Object(preact_min["h"])(Required["a" /* default */], { required: required })
      ),
      Object(preact_min["h"])(Description["a" /* default */], { description: description }),
      Object(preact_min["h"])("input", OptionsField__extends({
        type: "hidden",
        id: input.name
      }, input, {
        "aria-label": "" + input.name
      })),
      Object(preact_min["h"])(
        "select",
        {
          "class": "form-select",
          "aria-required": required ? "true" : "false",
          onChange: function onChange(event) {
            return _this2.changeValue(event.target.value);
          }
          // onBlur={(e) => input.onBlur(e)}
        },
        includeSelectOption ? OptionsField__ref2 : null,
        options.map(function (opt, index) {
          var quantityLeft = opt.quantityLeft || 0;
          var disabled = !trackQuantity || quantityLeft > 0 ? false : true;

          return Object(preact_min["h"])(
            "option",
            {
              value: index,
              selected: defaultValue === opt.value || option && opt.value === option.value ? true : false,
              disabled: disabled
            },
            opt.label ? opt.label : opt.value,
            " ",
            quantityLeft > 0 && quantityLeft < 11 && Object(preact_min["h"])(
              "span",
              null,
              "(",
              quantityLeft,
              " available)"
            ),
            trackQuantity && disabled && OptionsField__ref3
          );
        })
      ),
      option && option.descriptionRequired ? Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "label",
          { "for": input.name + "-description", "class": "form-label" },
          "Please specify",
          Object(preact_min["h"])(Required["a" /* default */], { required: required })
        ),
        " ",
        Object(preact_min["h"])(Description["a" /* default */], { description: description }),
        Object(preact_min["h"])("input", OptionsField__extends({
          "class": "form-input",
          type: "text",
          id: input.name + "-description",
          onChange: function onChange(event) {
            return _this2.changeDescription(event.target.value);
          },
          "aria-label": "" + input.name
        }, invalidObj, {
          "aria-describedby": input.name + "Error"
        }))
      ) : null,
      touched && error && Object(preact_min["h"])(
        "p",
        { "class": "form-input-hint", id: input.name + "Error" },
        error
      )
    );
  };

  return OptionsField;
}(preact_min["Component"]);

/* harmony default export */ var fields_OptionsField = (OptionsField_OptionsField);
// CONCATENATED MODULE: ./components/fields/NoteField.js




var NoteField_NoteField = function NoteField(_ref) {
  var input = _ref.input,
      label = _ref.label,
      required = _ref.required;

  return Object(preact_min["h"])(
    "div",
    { style: { marginBottom: 33 } },
    "Note: ",
    label
  );
};

/* harmony default export */ var fields_NoteField = (NoteField_NoteField);
// CONCATENATED MODULE: ./services/ImageService.js



var fsClient = void 0;

var ImageService_loadScripts = function loadScripts() {
    return new Promise(function (resolve, reject) {
        if (typeof window !== "undefined") {
            load_script_default()('https://static.filestackapi.com/filestack-js/1.5.1/filestack.min.js', function (err, script) {
                if (err) {
                    console.error(err);
                    reject();
                    return;
                }
                fsClient = filestack.init(Object(config["a" /* default */])('FILESTACK_KEY'));
                resolve();
            });
        } else {
            reject();
            return;
        }
    });
};

var getImageUrl = function getImageUrl(image, width, height) {
    var handle = image.handle ? image.handle : image;
    var resizeParams = 'width:' + width;
    resizeParams = height ? resizeParams + ',height:' + height : resizeParams;
    resizeParams = resizeParams + ',fit:crop';
    return 'https://process.filestackapi.com/resize=' + resizeParams + '/' + handle;
};


// EXTERNAL MODULE: ./assets/images/ic_image.svg
var ic_image = __webpack_require__("5ocZ");
var ic_image_default = /*#__PURE__*/__webpack_require__.n(ic_image);

// CONCATENATED MODULE: ./components/ImageUpload.js
var ImageUpload__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function ImageUpload__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ImageUpload__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ImageUpload__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ImageUpload__ref2 = Object(preact_min["h"])(Image["a" /* default */], { src: ic_image_default.a, alt: "Image upload icon" });

var ImageUpload_ImageUpload = function (_Component) {
  ImageUpload__inherits(ImageUpload, _Component);

  function ImageUpload() {
    ImageUpload__classCallCheck(this, ImageUpload);

    var _this = ImageUpload__possibleConstructorReturn(this, _Component.call(this));

    _this.state = { scriptsLoad: false };
    return _this;
  }

  ImageUpload.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    ImageService_loadScripts().then(function () {
      _this2.setState({ scriptsLoad: true });
    });
  };

  ImageUpload.prototype.render = function render(props) {
    var scriptsLoad = this.state.scriptsLoad;

    var image = props.value;
    var _props$aspectRatio = props.aspectRatio,
        aspectRatio = _props$aspectRatio === undefined ? 1 : _props$aspectRatio,
        uploadLabel = props.uploadLabel,
        uploadDescription = props.uploadDescription,
        _props$uploadOutsideD = props.uploadOutsideDescription,
        uploadOutsideDescription = _props$uploadOutsideD === undefined ? "" : _props$uploadOutsideD;

    uploadLabel = uploadLabel ? uploadLabel : "Upload an image";
    uploadDescription = uploadDescription ? uploadDescription : "Images should be smaller than 10 mb";
    var padding = 100 / aspectRatio;
    padding = padding > 50 ? 50 : padding;
    var url = image ? getImageUrl(image, 800) : image;
    var styles = {
      imageArea: {
        background: image ? "url(" + url + ") no-repeat" : "transparent",
        backgroundSize: "contain",
        backgroundPosition: "center",
        width: "100%",
        paddingTop: padding + "%",
        border: !image ? "1px dashed #d9d9d9" : "none",
        position: "relative",
        textAlign: "center",
        cursor: "pointer"
      },
      noImage: {
        position: "absolute",
        top: "calc(50% - 75px)",
        bottom: 0,
        left: 0,
        right: 0,
        height: 150,
        textAlign: "center"
      },
      icon: {
        fontSize: "90px",
        color: "#eee",
        margin: 0,
        lineHeight: 1.2
      },
      text: {
        fontSize: "16px",
        margin: "0 0 4px"
      },
      hint: {
        fontSize: "14px",
        color: "#323232",
        marginTop: 15
      },
      buttonRow: {
        marginTop: 10,
        textAlign: "center"
      }
    };

    if (!scriptsLoad) {
      return Object(preact_min["h"])(
        "div",
        { style: ImageUpload__extends({}, styles.imageArea, { padding: 0 }) },
        Object(preact_min["h"])("div", {
          "class": "loading loading-lg",
          style: { margin: "80px 0", display: "block" }
        })
      );
    }
    var uploadImage = function uploadImage() {
      var aspectRatio = props.aspectRatio;

      var options = {
        fromSources: ["local_file_system", "url", "facebook", "instagram", "googledrive", "dropbox", "evernote", "flickr"],
        maxSize: 102400000,
        maxFiles: 1,
        minFiles: 1,
        imageMax: [1000, 1000],
        uploadInBackground: false,
        transformations: {
          crop: true,
          rotate: true
        },
        accept: ["image/*"],
        onUploadDone: imageUploaded
      };
      fsClient.picker(options).open();
    };

    var editImage = function editImage() {
      var image = props.value;
      var aspectRatio = props.aspectRatio;
      var options = {
        transformations: {
          crop: {
            force: true,
            aspectRatio: aspectRatio
          },
          rotate: true
        },
        accept: ["image/*"],
        onUploadDone: imageUploaded
      };
      fsClient.picker(options).crop(image.url);
    };

    var imageUploaded = function imageUploaded(_ref) {
      var filesUploaded = _ref.filesUploaded,
          filesFailed = _ref.filesFailed;
      var onChange = props.onChange;

      if (filesFailed.length) {
        message.error("Image failed to upload");
        return;
      }
      var uploadedImage = filesUploaded[0];
      var image = {
        name: uploadedImage.filename,
        size: uploadedImage.size,
        url: uploadedImage.url,
        source: uploadedImage.source,
        handle: uploadedImage.handle
      };

      if (onChange) {
        onChange(image);
      }
    };

    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        "div",
        { style: styles.imageArea, onClick: uploadImage },
        !image ? Object(preact_min["h"])(
          "div",
          { style: styles.noImage },
          Object(preact_min["h"])(
            "p",
            { style: styles.icon },
            ImageUpload__ref2
          ),
          Object(preact_min["h"])(
            "button",
            {
              type: "button",
              "class": "btn btn-primary btn-lg",
              style: styles.button,
              "aria-label": "upload",
              "aria-hidden": true
            },
            uploadLabel
          ),
          Object(preact_min["h"])(
            "p",
            { style: styles.hint },
            uploadDescription
          )
        ) : ""
      ),
      image ? Object(preact_min["h"])(
        "div",
        { style: styles.buttonRow },
        Object(preact_min["h"])(
          "button",
          {
            type: "button",
            "class": "btn btn-lg",
            onClick: editImage,
            "aria-label": "edit"
          },
          "Edit"
        ),
        " ",
        Object(preact_min["h"])(
          "button",
          {
            type: "button",
            "class": "btn btn-lg",
            onClick: uploadImage,
            "aria-label": "upload"
          },
          "Upload"
        )
      ) : "",
      Object(preact_min["h"])(
        "p",
        { style: styles.hint },
        uploadOutsideDescription
      )
    );
  };

  return ImageUpload;
}(preact_min["Component"]);

/* harmony default export */ var components_ImageUpload = (ImageUpload_ImageUpload);
// CONCATENATED MODULE: ./components/fields/ImageUploadField.js
var ImageUploadField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var ImageUploadField_ImageUploadField = function ImageUploadField(_ref) {
  var input = _ref.input,
      label = _ref.label,
      description = _ref.description,
      inputType = _ref.inputType,
      required = _ref.required,
      type = _ref.type,
      style = _ref.style,
      aspectRatio = _ref.aspectRatio,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning;

  inputType = inputType ? inputType : type;
  return Object(preact_min["h"])(
    "div",
    {
      "class": touched && error ? "form-group has-error" : "form-group",
      style: style
    },
    label ? Object(preact_min["h"])(
      "label",
      { "for": input.name, "class": "form-label" },
      label,
      Object(preact_min["h"])(Required["a" /* default */], { required: required })
    ) : "",
    Object(preact_min["h"])(Description["a" /* default */], { description: description }),
    Object(preact_min["h"])(components_ImageUpload, ImageUploadField__extends({}, input, { aspectRatio: aspectRatio })),
    touched && error && Object(preact_min["h"])(
      "p",
      { "class": "form-input-hint" },
      error
    )
  );
};

/* harmony default export */ var fields_ImageUploadField = (ImageUploadField_ImageUploadField);
// CONCATENATED MODULE: ./components/fields/TermsAndConditionsField.js
var TermsAndConditionsField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function TermsAndConditionsField__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TermsAndConditionsField__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TermsAndConditionsField__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TermsAndConditionsField_wrapper = Object(index_esm["css"])({
  width: "80vw"
});

var TermsAndConditionsField__ref2 = Object(preact_min["h"])("i", { "class": "form-icon", style: "1px solid #8d949e" });

var TermsAndConditionsField_TermsAndConditionsField = function (_Component) {
  TermsAndConditionsField__inherits(TermsAndConditionsField, _Component);

  function TermsAndConditionsField() {
    TermsAndConditionsField__classCallCheck(this, TermsAndConditionsField);

    var _this = TermsAndConditionsField__possibleConstructorReturn(this, _Component.call(this));

    _this.toggleOpen = function () {
      _this.setState({ showModal: !_this.state.showModal });
    };

    _this.state = {
      showModal: false
    };
    return _this;
  }

  TermsAndConditionsField.prototype.render = function render(_ref) {
    var input = _ref.input,
        rename = _ref.rename,
        label = _ref.label,
        required = _ref.required,
        inputType = _ref.inputType,
        options = _ref.options,
        settings = _ref.settings,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error,
        warning = _ref$meta.warning;

    var fieldName = rename || "Terms & Conditions";
    var contents = "";

    var invalidObj = {};
    if (required) {
      invalidObj = {
        "aria-invalid": error && touched ? "true" : "false"
      };
    }
    if (inputType === "text") {
      contents = settings ? Object(preact_min["h"])(components_RichTextDisplay, { html: settings.text }) : null;
    } else {
      contents = settings ? Object(preact_min["h"])(
        "div",
        { className: TermsAndConditionsField_wrapper },
        Object(preact_min["h"])("embed", {
          src: "https://process.filestackapi.com/" + settings.pdf,
          width: "100%",
          height: "480",
          type: "application/pdf"
        })
      ) : null;
    }
    return Object(preact_min["h"])(
      "div",
      { "class": touched && error ? "form-group has-error" : "form-group" },
      Object(preact_min["h"])(
        "label",
        { "for": input.name, "class": "form-checkbox" },
        Object(preact_min["h"])("input", TermsAndConditionsField__extends({
          type: "checkbox",
          "aria-required": required ? "true" : "false",
          id: input.name
        }, input, {
          checked: input.value,
          "aria-label": "checkbox field:" + input.name
        }, invalidObj)),
        TermsAndConditionsField__ref2,
        " I have read and agree to (",
        inputType === "url" && settings && settings.link ? Object(preact_min["h"])(
          "a",
          { href: settings.link, target: "_blank" },
          fieldName
        ) : Object(preact_min["h"])(
          "a",
          { href: "#", onClick: this.toggleOpen },
          fieldName
        ),
        ")",
        Object(preact_min["h"])(Required["a" /* default */], { required: required })
      ),
      Object(preact_min["h"])(Modal["a" /* default */], {
        showModal: this.state.showModal,
        closeHandler: this.toggleOpen,
        title: label,
        contents: contents
      }),
      touched && error && Object(preact_min["h"])(
        "p",
        { "class": "form-input-hint" },
        error
      )
    );
  };

  return TermsAndConditionsField;
}(preact_min["Component"]);

/* harmony default export */ var fields_TermsAndConditionsField = (TermsAndConditionsField_TermsAndConditionsField);
// EXTERNAL MODULE: ./utils/Address.js
var Address = __webpack_require__("C1th");
var Address_default = /*#__PURE__*/__webpack_require__.n(Address);

// CONCATENATED MODULE: ./components/fields/LocationField.js
var LocationField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function LocationField__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocationField__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LocationField__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var LocationField_styles = {
  locationWrapper: Object(index_esm["css"])({
    display: "flex",
    "@media(max-width: 600px)": {
      display: "block"
    }
  }),
  leftColumn: Object(index_esm["css"])({
    flex: 1,
    "@media(max-width: 600px)": {
      marginRight: 0,
      display: "block"
    }
  }),
  list: Object(index_esm["css"])({
    position: "relative",
    display: "block",
    fontSize: 16,
    marginTop: 0,
    marginBottom: 0,
    cursor: "pointer"
  }),
  locationManualContainer: Object(index_esm["css"])({
    display: "flex",
    flexWrap: "wrap"
  }),
  streetAddress: Object(index_esm["css"])({
    width: "100%"
  }),
  locationManualFields: Object(index_esm["css"])({
    width: "49%"
  }),
  locationManualLeftFields: Object(index_esm["css"])({
    width: "49%",
    marginRight: 8
  })
};

var LocationField_AddressField = function AddressField(_ref) {
  var input = _ref.input,
      label = _ref.label,
      description = _ref.description,
      inputType = _ref.inputType,
      required = _ref.required,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      style = _ref.style,
      inputStyle = _ref.inputStyle,
      onPlaceChanged = _ref.onPlaceChanged,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;

  var invalidObj = {};
  if (required) {
    invalidObj = {
      "aria-invalid": error && touched ? "true" : "false"
    };
  }
  return Object(preact_min["h"])(
    "div",
    {
      "class": touched && error ? "form-group has-error" : "form-group",
      style: style
    },
    label ? Object(preact_min["h"])(
      "label",
      { "for": input.name, "class": "form-label" },
      label,
      Object(preact_min["h"])(Required["a" /* default */], { required: required })
    ) : "",
    Object(preact_min["h"])(Description["a" /* default */], { description: description }),
    Object(preact_min["h"])("input", LocationField__extends({
      "class": "form-input",
      id: input.name,
      disabled: disabled,
      type: inputType,
      placeholder: placeholder
    }, input, {
      style: inputStyle,
      "aria-label": label ? "" + label : "" + inputType
    }, invalidObj, {
      "aria-required": required ? "true" : "false",
      onkeyup: function onkeyup(e) {
        onPlaceChanged(e);
        input.onChange(e);
      },
      "aria-describedby": input.name + "Error"
    })),
    touched && error && Object(preact_min["h"])(
      "p",
      { "class": "form-input-hint", id: input.name + "Error" },
      error
    )
  );
};

var LocationField_Location = function (_Component) {
  LocationField__inherits(Location, _Component);

  function Location(props) {
    LocationField__classCallCheck(this, Location);

    var _this = LocationField__possibleConstructorReturn(this, _Component.call(this, props));

    _this.nameRequired = Object(Validators["b" /* required */])("Ticket Type is required");

    _this.onPlaceChanged = function (e) {
      var value = e.target.value ? e.target.value : false;

      if (value) {
        var displaySuggestions = function displaySuggestions(predictions, status) {
          if (status != _this.googleMaps.places.PlacesServiceStatus.OK) {
            return;
          }
          _this.setState({ predictions: predictions });
        };
        _this.autocomplete.getQueryPredictions({ input: value, sessionToken: _this.sessionToken }, displaySuggestions);
        _this.setState({ showAddressList: true });
      }
    };

    _this.clickAddress = function (value) {
      return new Promise(function ($return, $error) {
        var _this$props, changeFieldValue, questionName, fullAddress, country, state, suburb, postalCode, streetAddress;

        _this$props = _this.props, changeFieldValue = _this$props.changeFieldValue, questionName = _this$props.questionName;

        if (value === "noAddress") {
          changeFieldValue(questionName + ".location", "");
          changeFieldValue(questionName + ".details.country", "");
          changeFieldValue(questionName + ".details.state", "");
          changeFieldValue(questionName + ".details.postalCode", "");
          changeFieldValue(questionName + ".details.suburb", "");
          changeFieldValue(questionName + ".details.street", "");
          _this.setState({ noAddress: true });
          return $If_1.call(this);
        } else {
          return Promise.resolve(_this.getAddressDetails(value)).then(function ($await_2) {
            try {
              fullAddress = $await_2;
              country = Object(Address["getCountry"])(fullAddress.address_components);
              state = Object(Address["getState"])(fullAddress.address_components);
              suburb = Object(Address["getSuburb"])(fullAddress.address_components);
              postalCode = Object(Address["getPostalCode"])(fullAddress.address_components);
              streetAddress = value.structured_formatting.main_text;
              changeFieldValue(questionName + ".location", value.description);
              changeFieldValue(questionName + ".details.country", country);
              changeFieldValue(questionName + ".details.state", state);
              changeFieldValue(questionName + ".details.postalCode", postalCode);
              changeFieldValue(questionName + ".details.suburb", suburb);
              changeFieldValue(questionName + ".details.street", streetAddress);
              return $If_1.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        }

        function $If_1() {
          _this.setState({ showAddressList: false, showAddressManualFields: true });
          return $return();
        }
      });
    };

    _this.getAddressDetails = function (value) {
      return new Promise(function ($return, $error) {
        var request = {
          placeId: value.place_id,
          sessionToken: _this.sessionToken,
          fields: ["formatted_address", "address_component"]
        };
        return $return(new Promise(function (resolve, reject) {
          _this.googleService.getDetails(request, function (place, status) {
            if (status == _this.googleMaps.places.PlacesServiceStatus.OK) {
              resolve(place);
            }
          });
        }));
      });
    };

    _this.googleMaps = null;
    _this.autocomplete = null;
    _this.googleService = null;
    _this.sessionToken = null;
    _this.createAutoComplete = _this.createAutoComplete.bind(_this);
    _this.state = {
      showAddressList: false,
      showAddressManualFields: false,
      predictions: [],
      noAddress: false
    };
    return _this;
  }

  Location.prototype.componentDidMount = function componentDidMount() {
    this.createAutoComplete();
  };

  Location.prototype.createAutoComplete = function createAutoComplete() {
    var googleMaps = this.props.googleMaps;

    if (googleMaps) {
      this.googleMaps = googleMaps;
      // token is required to prevent double charges from Google for two API calls of AutocompleteService and PlacesService
      // we only get charged when we call PlacesService with token
      this.sessionToken = new googleMaps.places.AutocompleteSessionToken();
      this.autocomplete = new googleMaps.places.AutocompleteService();
      this.googleService = new googleMaps.places.PlacesService(document.createElement("span"));
    } else {
      setTimeout(this.createAutoComplete, 300);
    }
  };

  Location.prototype.render = function render() {
    var _this2 = this,
        _h,
        _h2,
        _h3,
        _h4,
        _h5;

    var _props = this.props,
        questionName = _props.questionName,
        label = _props.label,
        addQuestionQuantityCheck = _props.addQuestionQuantityCheck,
        _props$meta = _props.meta,
        touched = _props$meta.touched,
        error = _props$meta.error,
        warning = _props$meta.warning;

    var isRequired = this.props.required;
    var _state = this.state,
        showAddressList = _state.showAddressList,
        showAddressManualFields = _state.showAddressManualFields,
        predictions = _state.predictions,
        noAddress = _state.noAddress;

    var customStyles = {
      options: Object(index_esm["css"])({
        zIndex: 10001,
        overflowX: "auto",
        backgroundColor: "#fff",
        position: "absolute",
        margin: 0,
        border: "0.05rem solid #e7e7e7",
        borderRadius: 4,
        width: "100%",
        maxWidth: 522,
        padding: 0,
        paddingLeft: 10,
        display: showAddressList ? "block" : "none",
        color: "#323232",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)"
      })
    };

    var suggestionList = Object(preact_min["h"])(
      "ul",
      { className: customStyles.options },
      predictions.length ? predictions.map(function (prediction) {
        return Object(preact_min["h"])(
          "li",
          {
            className: LocationField_styles.list,
            onClick: function onClick() {
              return _this2.clickAddress(prediction);
            }
          },
          prediction.description
        );
      }) : null,
      Object(preact_min["h"])(
        "li",
        {
          className: LocationField_styles.list,
          onClick: function onClick() {
            return _this2.clickAddress("noAddress");
          }
        },
        "Can't find your address?"
      )
    );
    return Object(preact_min["h"])(
      "div",
      { className: LocationField_styles.locationWrapper },
      Object(preact_min["h"])(
        "div",
        { className: LocationField_styles.leftColumn },
        Object(preact_min["h"])(
          "div",
          { "class": touched && error ? "form-group has-error" : "form-group" },
          !noAddress ? Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(redux_form_es["a" /* Field */], {
              label: label,
              component: LocationField_AddressField,
              showAddressList: showAddressList,
              clickAddress: this.clickAddress,
              onPlaceChanged: this.onPlaceChanged,
              name: questionName + ".location",
              required: isRequired,
              validate: isRequired ? [Validators["b" /* required */], addQuestionQuantityCheck] : [addQuestionQuantityCheck]
            }),
            suggestionList
          ) : null,
          showAddressManualFields ? Object(preact_min["h"])(
            "div",
            { className: LocationField_styles.locationManualContainer },
            Object(preact_min["h"])(
              "div",
              { className: LocationField_styles.streetAddress },
              Object(preact_min["h"])(redux_form_es["a" /* Field */], (_h = {
                label: "Street Address",
                component: InputField["a" /* default */],
                name: questionName + ".details.street",
                autocomplete: "nope"
              }, _h["component"] = InputField["a" /* default */], _h.required = isRequired, _h.validate = isRequired ? [Validators["b" /* required */], addQuestionQuantityCheck] : [addQuestionQuantityCheck], _h)),
              touched && error && Object(preact_min["h"])(
                "p",
                { "class": "form-input-hint" },
                error
              )
            ),
            Object(preact_min["h"])(
              "div",
              { className: LocationField_styles.locationManualLeftFields },
              Object(preact_min["h"])(redux_form_es["a" /* Field */], (_h2 = {
                label: "Suburb",
                component: InputField["a" /* default */],
                name: questionName + ".details.suburb",
                autocomplete: "nope"
              }, _h2["component"] = InputField["a" /* default */], _h2.required = isRequired, _h2.validate = isRequired ? [Validators["b" /* required */], addQuestionQuantityCheck] : [addQuestionQuantityCheck], _h2)),
              touched && error && Object(preact_min["h"])(
                "p",
                { "class": "form-input-hint" },
                error
              )
            ),
            Object(preact_min["h"])(
              "div",
              { className: LocationField_styles.locationManualFields },
              Object(preact_min["h"])(redux_form_es["a" /* Field */], (_h3 = {
                label: "State",
                component: InputField["a" /* default */],
                name: questionName + ".details.state",
                autocomplete: "nope"
              }, _h3["component"] = InputField["a" /* default */], _h3.required = isRequired, _h3.validate = isRequired ? [Validators["b" /* required */], addQuestionQuantityCheck] : [addQuestionQuantityCheck], _h3)),
              touched && error && Object(preact_min["h"])(
                "p",
                { "class": "form-input-hint" },
                error
              )
            ),
            Object(preact_min["h"])(
              "div",
              { className: LocationField_styles.locationManualLeftFields },
              Object(preact_min["h"])(redux_form_es["a" /* Field */], (_h4 = {
                label: "Postcode",
                component: InputField["a" /* default */],
                name: questionName + ".details.postalCode",
                autocomplete: "nope"
              }, _h4["component"] = InputField["a" /* default */], _h4.required = isRequired, _h4.validate = isRequired ? [Validators["b" /* required */], addQuestionQuantityCheck] : [addQuestionQuantityCheck], _h4))
            ),
            Object(preact_min["h"])(
              "div",
              { className: LocationField_styles.locationManualFields },
              Object(preact_min["h"])(redux_form_es["a" /* Field */], (_h5 = {
                label: "Country",
                component: InputField["a" /* default */],
                name: questionName + ".details.country",
                autocomplete: "nope"
              }, _h5["component"] = InputField["a" /* default */], _h5.required = isRequired, _h5.validate = isRequired ? [Validators["b" /* required */], addQuestionQuantityCheck] : [addQuestionQuantityCheck], _h5))
            )
          ) : null
        )
      )
    );
  };

  return Location;
}(preact_min["Component"]);

/**
 * Autocomplete input filed for address
 *
 * @param {*} props
 * @returns
 */


var LocationField__ref2 = Object(preact_min["h"])(
  "p",
  null,
  "isLoading..."
);

var LocationField_LocationField = function LocationField(props) {
  return Object(preact_min["h"])(react_google_maps_loader_es, {
    params: {
      key: Object(config["a" /* default */])("GOOGLE_API_KEY"), // Define your api key here
      libraries: "places"
    },
    render: function render(googleMaps, error) {
      return googleMaps ? Object(preact_min["h"])(
        "div",
        null,
        error ? error : Object(preact_min["h"])(LocationField_Location, LocationField__extends({}, props, { googleMaps: googleMaps }))
      ) : Object(preact_min["h"])(
        "div",
        null,
        error === "Network Error" ? Object(preact_min["h"])(
          "p",
          null,
          error
        ) : LocationField__ref2
      );
    }
  });
};

/* harmony default export */ var fields_LocationField = (LocationField_LocationField);
// CONCATENATED MODULE: ./routes/details/additionalQuestion/AdditionalQuestionQuantityValidator.js


// check additional question quantity left
var AdditionalQuestionQuantityValidator_addQuestionQuantityCheck = function addQuestionQuantityCheck(question) {
  return function (value, allValues) {
    var values = Object(Format["convertValueToArray"])(value, "{|}");
    var isPerOrder = question.perOrder;
    var returnValue = "";
    var returnQuantity = 0;
    var pass = true;

    if (question.trackQuantity) {
      var options = [].concat(question.options) || [];

      // check values if the option has enough quantity
      values.forEach(function (value) {
        var answeredQuantity = 0;

        // if isPerOrder, we don't have to check how many answers since it's only one question per order
        if (isPerOrder) {
          answeredQuantity++;
        } else {
          // create question value array (remove ticket ids and question ids)
          var ticketAdditionalFields = Object.keys(allValues.tickets).reduce(function (allAnswers, ticketId) {
            var additionalFields = allValues.tickets[ticketId];
            allAnswers.push(additionalFields[question._id]);
            return allAnswers;
          }, []);

          ticketAdditionalFields.forEach(function (answer) {
            var answers = Object(Format["convertValueToArray"])(answer, "{|}");
            answers.forEach(function (answer) {
              if (String(value) === String(answer)) {
                answeredQuantity++;
              }
            });
          });
        }
        options.forEach(function (option) {
          var optionValue = question.type === "multiSelect" ? option.label : option.value;
          if (String(value) === String(optionValue)) {
            var totalLeftQuantity = option.quantityLeft - answeredQuantity;
            if (totalLeftQuantity < 0) {
              returnQuantity = option.quantityLeft;
              returnValue = value;
              pass = false;
            }
          }
        });
      });
      return pass ? undefined : returnValue + " (" + returnQuantity + " available)";
    }
  };
};
// CONCATENATED MODULE: ./routes/details/additionalQuestion/CheckCondition.js
var checkingCondition = function checkingCondition(condition, conditionValue, formValue) {
  switch (condition) {
    case "checkboxEqual":
      return formValue.toString() === conditionValue ? true : false;
    case "checkboxNotEqual":
      return formValue.toString() !== conditionValue ? true : false;
    case "===":
      return parseInt(formValue) === parseInt(conditionValue) ? true : false;
    case "!==":
      return parseInt(formValue) !== parseInt(conditionValue) ? true : false;
    case "<":
      return parseInt(formValue) < parseInt(conditionValue) ? true : false;
    case "<=":
      return parseInt(formValue) <= parseInt(conditionValue) ? true : false;
    case ">":
      return parseInt(formValue) > parseInt(conditionValue) ? true : false;
    case ">=":
      return parseInt(formValue) >= parseInt(conditionValue) ? true : false;
    case "isEqualTo":
      return formValue.toLowerCase() === conditionValue.toLowerCase() ? true : false;
    case "isNotEqualTo":
      return formValue.toLowerCase() !== conditionValue.toLowerCase() ? true : false;
    case "beginsWith":
      return formValue.toLowerCase().substring(0, conditionValue.length) === conditionValue.toLowerCase() ? true : false;
    case "endsWith":
      var startingPoint = formValue.length - conditionValue.length;
      var endingPoint = formValue.length;
      return formValue.toLowerCase().substring(startingPoint, endingPoint) === conditionValue.toLowerCase() ? true : false;
    case "contains":
      return formValue.toLowerCase().indexOf(conditionValue.toLowerCase()) !== -1 ? true : false;
    case "notContain":
      return formValue.toLowerCase().indexOf(conditionValue.toLowerCase()) === -1 ? true : false;
    default:
      return false;
  }
};

/**
 * Compare values.
 *
 * @param {string or boolean} formValue
 * @param {string} conditionValue
 * @param {string} condition
 * @returns true or false
 */
var compareValues = function compareValues(formValue, conditionValue, condition) {
  var compareFormValues = function compareFormValues(condition, conditionValue, formValue) {
    if (Array.isArray(formValue)) {
      var result = void 0;
      if (condition === "contains") {
        result = formValue.some(function (fValue) {
          return checkingCondition(condition, conditionValue, fValue);
        });
      } else {
        result = formValue.every(function (fValue) {
          return checkingCondition(condition, conditionValue, fValue);
        });
      }
      return result;
    } else {
      return checkingCondition(condition, conditionValue, formValue);
    }
  };
  conditionValue = (conditionValue && String(conditionValue).indexOf("{|}")) !== -1 ? conditionValue.split("{|}") : conditionValue;
  formValue = formValue && String(formValue).indexOf("{|}") !== -1 ? formValue.split("{|}") : formValue;
  if (Array.isArray(conditionValue)) {
    var result = void 0;
    if (condition === "contains") {
      result = conditionValue.every(function (cValue) {
        return compareFormValues(condition, cValue, formValue);
      });
    } else {
      result = conditionValue.some(function (cValue) {
        return compareFormValues(condition, cValue, formValue);
      });
    }
    return result;
  } else {
    return compareFormValues(condition, conditionValue, formValue);
  }
};

/**
 * Check condition of additional questions
 *
 * @param {object} question
 * @param {array} ticketsAdditionalQuestions
 * @param {objectId} ticketId
 * @returns true or false
 */
var checkCondition = function checkCondition(question, ticketsAdditionalQuestions, ticketId) {
  if (question.showConditions && question.conditions && question.conditions.length > 0) {
    var fakeTrue = false;
    // f.some only stops when it finds true. fakeTrue is used when loop should stop but needs to return false.
    var pass = question.conditions.some(function (condition, index) {
      if (ticketsAdditionalQuestions[ticketId] && condition.additionalQuestionId in ticketsAdditionalQuestions[ticketId]) {
        var formValue = ticketsAdditionalQuestions[ticketId][condition.additionalQuestionId];
        var conditionValue = condition.value;
        var compareValuesTrue = formValue && formValue !== "" ? compareValues(formValue, conditionValue, condition.condition) : false;
        if (condition.options === "||" && compareValuesTrue) {
          return true;
        } else if (condition.options === "&&" && !compareValuesTrue) {
          fakeTrue = true;
          return true;
        } else if (condition.options === "&&" && compareValuesTrue) {
          // If someone adds new condition and delete it, condition.options value is still staying
          // In this case, the function should ignore the && options and return true instead of trying to check next condition
          // That's why the index and length should be checked
          // Check test case 5
          return index + 1 === question.conditions.length ? true : false;
        } else {
          return compareValuesTrue;
        }
      } else if (ticketsAdditionalQuestions[ticketId] && !(condition.additionalQuestionId in ticketsAdditionalQuestions[ticketId])) {
        fakeTrue = true;
        return true;
      }
    });
    return pass && !fakeTrue ? true : false;
  } else {
    return true;
  }
};

var checkOrderQuestionCondition = function checkOrderQuestionCondition(question, orderAdditionalQuestions) {
  if (question.showConditions && question.conditions && question.conditions.length > 0) {
    var fakeTrue = false;
    // f.some only stops when it finds true. fakeTrue is used when loop should stop but needs to return false.
    var pass = question.conditions.some(function (condition, index) {
      if (orderAdditionalQuestions && condition.additionalQuestionId in orderAdditionalQuestions) {
        var formValue = orderAdditionalQuestions[condition.additionalQuestionId];
        var conditionValue = condition.value;
        var compareValuesTrue = formValue && formValue !== "" ? compareValues(formValue, conditionValue, condition.condition) : false;
        if (condition.options === "||" && compareValuesTrue) {
          return true;
        } else if (condition.options === "&&" && !compareValuesTrue) {
          fakeTrue = true;
          return true;
        } else if (condition.options === "&&" && compareValuesTrue) {
          // If someone adds new condition and delete it, condition.options value is still staying
          // In this case, the function should ignore the && options and return true instead of trying to check next condition
          // That's why the index and length should be checked
          // Check test case 5
          return index + 1 === question.conditions.length ? true : false;
        } else {
          return compareValuesTrue;
        }
      } else if (orderAdditionalQuestions && !(condition.additionalQuestionId in orderAdditionalQuestions)) {
        fakeTrue = true;
        return true;
      }
    });
    return pass && !fakeTrue ? true : false;
  } else {
    return true;
  }
};
// CONCATENATED MODULE: ./routes/details/additionalQuestion/AdditionalQuestion.js


function AdditionalQuestion__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AdditionalQuestion__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AdditionalQuestion__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















/**
 * Display form field based on conditions
 *
 * @param {object, string, object, object, objectId, boolean, function} { question, formName, orderAdditionalQuestions, ticketsAdditionalQuestions, ticketId, disabled, changeFieldValue }
 * @returns redux form
 */
var AdditionalQuestion_ConditionalQuestion = function ConditionalQuestion(_ref) {
  var question = _ref.question,
      formName = _ref.formName,
      orderAdditionalQuestions = _ref.orderAdditionalQuestions,
      ticketsAdditionalQuestions = _ref.ticketsAdditionalQuestions,
      ticketId = _ref.ticketId,
      disabled = _ref.disabled,
      changeFieldValue = _ref.changeFieldValue;

  var isBrowser = typeof window !== "undefined";
  var isSafari = false;
  if (isBrowser) {
    isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
      return p.toString() === "[object SafariRemoteNotification]";
    }(!window["safari"] || typeof safari !== "undefined" && safari.pushNotification);
  }
  var trackQuantity = question.trackQuantity ? question.trackQuantity : false;
  var RenderField = question.inputType === "date" && isSafari ? fields_DateField : InputField["a" /* default */];

  switch (question.type) {
    case "options":
      RenderField = fields_OptionsField;
      break;
    case "multiSelect":
      RenderField = fields_MultipleOptionsField;
      break;
    case "textarea":
      RenderField = TextareaField["a" /* default */];
      break;
    case "checkbox":
      RenderField = fields_CheckboxField;
      break;
    case "image":
      RenderField = fields_ImageUploadField;
      break;
    case "terms":
      RenderField = fields_TermsAndConditionsField;
      break;
    case "note":
      RenderField = fields_NoteField;
      break;
    case "address":
      RenderField = fields_LocationField;
      break;
  }
  var defaultValue = question.defaultValue || "";
  var rename = question.rename || "";
  var conditionalQuestion = void 0;

  if (question.type === "address") {
    conditionalQuestion = Object(preact_min["h"])(redux_form_es["b" /* FieldArray */], {
      label: question.question,
      description: question.description,
      type: question.type,
      questionName: question.name,
      name: question.name + "-" + question.type,
      inputType: question.inputType,
      trackQuantity: trackQuantity,
      component: RenderField,
      formName: formName,
      defaultValue: defaultValue,
      rename: rename,
      disabled: disabled,
      aspectRatio: 1,
      options: question.options,
      settings: question.settings,
      required: question.required,
      valueField: "label",
      placeholder: "",
      changeFieldValue: changeFieldValue,
      addQuestionQuantityCheck: AdditionalQuestionQuantityValidator_addQuestionQuantityCheck(question)
    });
  } else {
    conditionalQuestion = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
      label: question.question,
      description: question.description,
      type: question.type,
      name: question.name,
      inputType: question.inputType,
      trackQuantity: trackQuantity,
      component: RenderField,
      formName: formName,
      defaultValue: defaultValue,
      rename: rename,
      disabled: disabled,
      aspectRatio: 1,
      options: question.options,
      settings: question.settings,
      required: question.required,
      valueField: "label",
      placeholder: "",
      changeFieldValue: changeFieldValue,
      validate: question.required ? [Validators["b" /* required */], AdditionalQuestionQuantityValidator_addQuestionQuantityCheck(question)] : [AdditionalQuestionQuantityValidator_addQuestionQuantityCheck(question)]
    });
  }
  if (checkOrderQuestionCondition(question, orderAdditionalQuestions) || ticketId !== "" && checkCondition(question, ticketsAdditionalQuestions, ticketId)) {
    return conditionalQuestion;
  }
};

/**
 * Display additional questions for order and tickets
 *
 * @class AdditionalQuestion
 * @extends {Component}
 */

var AdditionalQuestion_AdditionalQuestion = function (_Component) {
  AdditionalQuestion__inherits(AdditionalQuestion, _Component);

  function AdditionalQuestion(props) {
    AdditionalQuestion__classCallCheck(this, AdditionalQuestion);

    return AdditionalQuestion__possibleConstructorReturn(this, _Component.call(this, props));
  }

  AdditionalQuestion.prototype.render = function render() {
    var _props = this.props,
        question = _props.question,
        _props$ticketAddition = _props.ticketAdditionalFields,
        ticketAdditionalFields = _props$ticketAddition === undefined ? [] : _props$ticketAddition,
        _props$ticketId = _props.ticketId,
        ticketId = _props$ticketId === undefined ? "" : _props$ticketId,
        _props$ticketsAdditio = _props.ticketsAdditionalQuestions,
        ticketsAdditionalQuestions = _props$ticketsAdditio === undefined ? {} : _props$ticketsAdditio,
        _props$orderAdditiona = _props.orderAdditionalQuestions,
        orderAdditionalQuestions = _props$orderAdditiona === undefined ? {} : _props$orderAdditiona,
        _props$orderAdditiona2 = _props.orderAdditionalFields,
        orderAdditionalFields = _props$orderAdditiona2 === undefined ? [] : _props$orderAdditiona2,
        _props$formName = _props.formName,
        formName = _props$formName === undefined ? "details" : _props$formName,
        _props$disabled = _props.disabled,
        disabled = _props$disabled === undefined ? false : _props$disabled,
        changeFieldValue = _props.changeFieldValue;

    ticketAdditionalFields.length > 0 && ticketId !== "" && ticketAdditionalFields.forEach(function (field) {
      ticketsAdditionalQuestions[ticketId] = ticketsAdditionalQuestions[ticketId] || {};
      ticketsAdditionalQuestions[ticketId][field.questionId] = ticketsAdditionalQuestions[ticketId][field.questionId] || field.value;
    });
    orderAdditionalFields.length > 0 && orderAdditionalFields.forEach(function (field) {
      if (field && field.questionId) orderAdditionalQuestions[field.questionId] = orderAdditionalQuestions[field.questionId] || field.value;
    });

    return Object(preact_min["h"])(AdditionalQuestion_ConditionalQuestion, {
      question: question,
      formName: formName,
      ticketsAdditionalQuestions: ticketsAdditionalQuestions,
      ticketId: ticketId,
      orderAdditionalQuestions: orderAdditionalQuestions,
      disabled: disabled,
      changeFieldValue: changeFieldValue
    });
  };

  return AdditionalQuestion;
}(preact_min["Component"]);

/* harmony default export */ var additionalQuestion_AdditionalQuestion = (AdditionalQuestion_AdditionalQuestion);
// CONCATENATED MODULE: ./routes/details/OrderQuestions.js




/**
 * Display additional questions per order
 *
 * @param {object, array} { additionalQuestions, tickets }
 * @returns additional questions
 */
var OrderQuestions_OrderQuestions = function OrderQuestions(_ref) {
  var additionalQuestions = _ref.additionalQuestions,
      tickets = _ref.tickets,
      formName = _ref.formName,
      orderAdditionalQuestions = _ref.orderAdditionalQuestions,
      changeFieldValue = _ref.changeFieldValue;

  var ticketTypeIds = tickets ? tickets.map(function (t) {
    return t.ticketTypeId;
  }) : [];

  var orderQuestions = additionalQuestions.filter(function (question) {
    if (!question.perOrder) {
      return false;
    }
    if (question.appliesTo && question.appliesTo.length) {
      var ticketFound = question.appliesTo.some(function (id) {
        return ticketTypeIds.indexOf(id) >= 0;
      });
      return ticketFound;
    }
    return true;
  });
  return Object(preact_min["h"])(
    "div",
    null,
    orderQuestions.map(function (question) {
      question.name = "order.additionalFields." + question._id;
      return Object(preact_min["h"])(additionalQuestion_AdditionalQuestion, {
        question: question,
        formName: formName,
        orderAdditionalQuestions: orderAdditionalQuestions,
        orderAdditionalFields: orderQuestions,
        changeFieldValue: changeFieldValue
      });
    })
  );
};

/* harmony default export */ var details_OrderQuestions = (OrderQuestions_OrderQuestions);
// CONCATENATED MODULE: ./routes/details/TicketInfo.js


function TicketInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TicketInfo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TicketInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TicketInfo_TicketInfo = function (_Component) {
  TicketInfo__inherits(TicketInfo, _Component);

  function TicketInfo() {
    TicketInfo__classCallCheck(this, TicketInfo);

    var _this = TicketInfo__possibleConstructorReturn(this, _Component.call(this));

    _this.toggleSameAsBuyer = _this.toggleSameAsBuyer.bind(_this);
    return _this;
  }

  TicketInfo.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    var lastBuyerInfo = previousProps.buyerData;
    var _props = this.props,
        buyerData = _props.buyerData,
        sameAsBuyerChecks = _props.sameAsBuyerChecks,
        ticket = _props.ticket;

    var sameAsBuyer = sameAsBuyerChecks && sameAsBuyerChecks[ticket._id] ? sameAsBuyerChecks[ticket._id] : false;
    if (sameAsBuyer && JSON.stringify(buyerData) !== JSON.stringify(lastBuyerInfo)) {
      this.toggleSameAsBuyer(null, true);
    }
  };

  TicketInfo.prototype.toggleSameAsBuyer = function toggleSameAsBuyer(evt, value) {
    var _props2 = this.props,
        questions = _props2.questions,
        buyerData = _props2.buyerData,
        changeFieldValue = _props2.changeFieldValue,
        ticket = _props2.ticket;

    questions.forEach(function (q) {
      var fieldName = "tickets." + ticket._id + "." + q._id;
      if (!value || !buyerData) {
        return;
      }
      switch (q.type) {
        case "firstName":
          changeFieldValue(fieldName, buyerData.firstName);
          break;
        case "lastName":
          changeFieldValue(fieldName, buyerData.lastName);
          break;
        case "mobile":
          changeFieldValue(fieldName, buyerData.mobile);
          break;
        case "email":
          changeFieldValue(fieldName, buyerData.email);
          break;
      }
    });
  };

  TicketInfo.prototype.render = function render() {
    var _props3 = this.props,
        ticket = _props3.ticket,
        questions = _props3.questions,
        ticketsAdditionalQuestions = _props3.ticketsAdditionalQuestions,
        sameAsBuyerChecks = _props3.sameAsBuyerChecks,
        formName = _props3.formName,
        changeFieldValue = _props3.changeFieldValue,
        hideTitles = _props3.hideTitles,
        onChange = _props3.onChange;

    var style = {
      marginBottom: hideTitles ? 0 : 36
    };
    var askSameAsBuyer = questions.reduce(function (fieldMatch, q) {
      if (q.type === "firstName" || q.type === "lastName" || q.type === "mobile" || q.type === "email") {
        fieldMatch = true;
      }
      return fieldMatch;
    }, false);
    var sameAsBuyer = sameAsBuyerChecks && sameAsBuyerChecks[ticket._id] ? sameAsBuyerChecks[ticket._id] : false;

    return Object(preact_min["h"])(
      "div",
      { style: style },
      !hideTitles ? Object(preact_min["h"])(
        "h4",
        { style: { borderBottom: "1px solid #eeeeee", paddingBottom: 8 } },
        ticket.label
      ) : null,
      askSameAsBuyer ? Object(preact_min["h"])(redux_form_es["a" /* Field */], {
        label: "Use the same ticket information as buyer",
        type: "checkbox",
        name: "sameAsBuyerChecks." + ticket._id,
        onChange: this.toggleSameAsBuyer,
        component: fields_CheckboxField
      }) : false,
      questions.map(function (question) {
        var disabled = sameAsBuyer && (question.type === "firstName" || question.type === "lastName" || question.type === "mobile" || question.type === "email") ? true : false;
        question.name = "tickets." + ticket._id + "." + question._id;
        return Object(preact_min["h"])(additionalQuestion_AdditionalQuestion, {
          question: question,
          ticketId: ticket._id,
          ticketAdditionalFields: ticket.additionalFields,
          ticketsAdditionalQuestions: ticketsAdditionalQuestions,
          formName: formName,
          disabled: disabled,
          changeFieldValue: changeFieldValue,
          onChange: onChange
        });
      })
    );
  };

  return TicketInfo;
}(preact_min["Component"]);

/* harmony default export */ var details_TicketInfo = (TicketInfo_TicketInfo);
// CONCATENATED MODULE: ./routes/details/TicketsQuestions.js







var TicketsQuestions__ref3 = Object(preact_min["h"])(
  "h3",
  { "class": "sub-header" },
  "Ticket Information"
);

var TicketsQuestions__ref4 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "Email tickets to each attendee",
  name: "order.emailAttendees",
  component: fields_CheckboxField
});

var TicketsQuestions_TicketsQuestions = function TicketsQuestions(_ref) {
  var tickets = _ref.tickets,
      ticketTypes = _ref.ticketTypes,
      additionalQuestions = _ref.additionalQuestions,
      ticketsAdditionalQuestions = _ref.ticketsAdditionalQuestions,
      formName = _ref.formName,
      buyerData = _ref.buyerData,
      changeFieldValue = _ref.changeFieldValue,
      sameAsBuyerChecks = _ref.sameAsBuyerChecks,
      hideTitles = _ref.hideTitles;

  if (!tickets || !tickets.length) {
    return;
  }

  var ticketsRequireEmail = false;
  if (ticketsAdditionalQuestions) {
    var emailQuestions = additionalQuestions.filter(function (question) {
      return question.type === "email" && !question.perOrder;
    });
    if (emailQuestions && emailQuestions.length) {
      ticketsRequireEmail = true;
    }
  }
  var ticketTypeCounts = {};
  tickets = tickets.map(function (t) {
    if (!ticketTypeCounts[t.ticketTypeName]) {
      ticketTypeCounts[t.ticketTypeName] = 0;
    }
    ticketTypeCounts[t.ticketTypeName]++;
    t.label = "Ticket " + ticketTypeCounts[t.ticketTypeName] + ". " + t.ticketTypeName;
    // add ticketOrder to sort selected ticket
    var ticketOrder = -1;
    ticketTypes.some(function (type, i) {
      if (type._id === t.ticketTypeId) {
        ticketOrder = i;
        return true;
      }
    });
    t.ticketOrder = ticketOrder;
    return t;
  });
  // sort selected ticket by ticket order from ticketTypes
  tickets.sort(function (a, b) {
    return a.ticketOrder - b.ticketOrder;
  });

  var getTicketQuestions = function getTicketQuestions(ticketTypeId, additionalQuestions) {
    return additionalQuestions.filter(function (question) {
      if (question.perOrder) {
        return false;
      }
      if (question.appliesTo && question.appliesTo.length && question.appliesTo.indexOf(ticketTypeId) === -1) {
        return false;
      }
      return question;
    });
  };
  var ticketWithQuestions = tickets.map(function (ticket) {
    return {
      ticket: ticket,
      questions: getTicketQuestions(ticket.ticketTypeId, additionalQuestions)
    };
  }).filter(function (_ref2) {
    var questions = _ref2.questions;
    return questions.length;
  });

  var ticketsQ = ticketWithQuestions.map(function (ticketQ) {
    return Object(preact_min["h"])(details_TicketInfo, {
      ticket: ticketQ.ticket,
      questions: ticketQ.questions,
      ticketsAdditionalQuestions: ticketsAdditionalQuestions,
      formName: formName,
      buyerData: buyerData,
      changeFieldValue: changeFieldValue,
      sameAsBuyerChecks: sameAsBuyerChecks,
      hideTitles: hideTitles
    });
  });

  if (!ticketsQ.length) {
    return;
  }

  return Object(preact_min["h"])(
    "div",
    { style: { borderBottom: "1px solid #dedede" } },
    !hideTitles ? TicketsQuestions__ref3 : null,
    ticketsQ,
    ticketsRequireEmail ? TicketsQuestions__ref4 : null
  );
};

/* harmony default export */ var details_TicketsQuestions = (TicketsQuestions_TicketsQuestions);
// CONCATENATED MODULE: ./utils/stateConstructors.js
function getTicketValues(order, additionalQuestions, formTickets) {
  if (formTickets) {
    return formTickets;
  }
  if (!order || !order.tickets || !order.tickets.length) {
    return null;
  }
  var mappedTicketValues = {};
  order.tickets.forEach(function (ticket) {
    mappedTicketValues[ticket._id] = {};
    if (ticket.additionalFields && ticket.additionalFields.length > 0) {
      ticket.additionalFields.forEach(function (field) {
        var isAddress = field.details && field.details.country;
        if (isAddress) {
          mappedTicketValues[ticket._id][field.questionId] = {
            location: field.value,
            details: field.details
          };
        } else {
          mappedTicketValues[ticket._id][field.questionId] = field.value;
        }
      });
    } else if (additionalQuestions && additionalQuestions.length > 0) {
      additionalQuestions.forEach(function (question) {
        if (question.defaultValue && !question.perOrder && !question.askAfterCheckout) {
          mappedTicketValues[ticket._id][question._id] = question.defaultValue;
        }
      });
    }
  });
  return mappedTicketValues;
}
// CONCATENATED MODULE: ./components/RequiredFields.js



var styling = Object(index_esm["css"])({
  width: "100%",
  height: 36,
  borderRadius: 4,
  backgroundColor: "#f9f9fa",
  textAlign: "center",
  color: "#323232",
  padding: 8,
  marginBottom: 24,
  span: {
    color: "#c0212c"
  }
});

var RequiredFields__ref = Object(preact_min["h"])(
  "div",
  { className: styling },
  "All fields marked with ",
  Object(preact_min["h"])(
    "span",
    null,
    "*"
  ),
  " are required."
);

var RequiredFields = function RequiredFields() {
  return RequiredFields__ref;
};

/* harmony default export */ var components_RequiredFields = (RequiredFields);
// CONCATENATED MODULE: ./routes/details/Details.js
var Details__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Details__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Details__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Details__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


































var Details_formName = "details";

var Details_nextStageButton = Object(index_esm["css"])({ height: "40px !important", minWidth: 150 });

var Details_DetailsWrapper = function (_Component) {
  Details__inherits(DetailsWrapper, _Component);

  function DetailsWrapper() {
    var _temp, _this, _ret;

    Details__classCallCheck(this, DetailsWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Details__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.eventDetailsDidMount = function () {
      var _this$props = _this.props,
          event = _this$props.event,
          eventSlug = _this$props.eventSlug,
          order = _this$props.order,
          orderId = _this$props.orderId,
          getEvent = _this$props.getEvent;

      if (!event.data && !event.loading) {
        getEvent(eventSlug, undefined, false, orderId, true);
      }
      if (event.data && order.data) {
        _this.determineSeatingMap(event.data, order.data);
      }
      Object(BrowserUtils["a" /* pageChange */])("Enter Details", event);
    }, _this.globalDetailsDidMount = function () {
      var _this$props2 = _this.props,
          order = _this$props2.order,
          orderId = _this$props2.orderId,
          getOrder = _this$props2.getOrder,
          giftCards = _this$props2.giftCards,
          eventSlug = _this$props2.eventSlug,
          getGiftCardPage = _this$props2.getGiftCardPage;

      if (!order.data && !order.loading) {
        getOrder(orderId);
      }
      if (!giftCards.giftCardPage && !giftCards.loading) {
        getGiftCardPage(eventSlug);
      }
    }, _this.globalDetailsDidUpdate = function () {}, _this.eventDetailsDidUpdate = function () {
      var _this$props3 = _this.props,
          event = _this$props3.event,
          order = _this$props3.order,
          seatingMap = _this$props3.seatingMap;

      if (event.data && order.data && !seatingMap.seatingMapEvaluated) {
        _this.determineSeatingMap(event.data, order.data);
      }
    }, _this.determineSeatingMap = function (eventData, orderData) {
      var setSeatingMapRequired = _this.props.setSeatingMapRequired;

      var seatingMapId = void 0;
      if (orderData) {
        var tickets = orderData.tickets;

        var event = eventData;
        if (event.seatingMaps && tickets) {
          event.seatingMaps.forEach(function (seatingMap) {
            var isPublic = seatingMap.public !== false;
            seatingMap.ticketTypeSet.forEach(function (ticketType) {
              var containsPackageTicket = tickets.filter(function (ticket) {
                return String(ticket.packageId) === String(ticketType);
              }).length > 0;
              var containsTicketType = tickets.filter(function (ticket) {
                return String(ticket.ticketTypeId) === String(ticketType);
              }).length > 0;
              if ((containsPackageTicket || containsTicketType) && !seatingMapId && isPublic) {
                seatingMapId = seatingMap.id;
              }
            });
          });
        }
      }
      setSeatingMapRequired(seatingMapId);
    }, _this.saveEventDetails = function (values) {
      var _this$props4 = _this.props,
          eventSlug = _this$props4.eventSlug,
          event = _this$props4.event,
          order = _this$props4.order,
          saveOrderData = _this$props4.saveOrderData,
          seatingMap = _this$props4.seatingMap;

      if (order.detailsRequest.loading) {
        return;
      }
      var orderData = Details__extends({}, values.order, {
        _id: order.data._id
      });
      // add the affiliate code to the order if there is one
      try {
        var affiliateCode = localStorage.getItem(eventSlug + "-affiliate");
        if (affiliateCode) {
          orderData.affiliateCode = affiliateCode;
        }
      } catch (err) {}
      saveOrderData(eventSlug, event.id, orderData, order.data.tickets, values.tickets, seatingMap.seatingMapRequired || event.data.settings.enableTicketAssigning);
    }, _this.saveGlobalDetails = function (values) {
      var _this$props5 = _this.props,
          order = _this$props5.order,
          saveOrderData = _this$props5.saveOrderData,
          seatingMap = _this$props5.seatingMap,
          giftCards = _this$props5.giftCards;

      if (order.detailsRequest.loading) {
        return;
      }
      var slug = giftCards.giftCardPage.slug;

      var orderData = Details__extends({}, values.order, {
        _id: order.data._id
      });

      saveOrderData(slug, order.userId, orderData, order.data.giftCards, values.giftCards, false, true);
    }, _this.determineIsGlobal = function () {
      return _this.props.path ? _this.props.path.indexOf("/gift-cards/") > -1 : false;
    }, _this.getForm = function () {
      var _this$props6 = _this.props,
          ticketsAdditionalQuestions = _this$props6.ticketsAdditionalQuestions,
          orderAdditionalQuestions = _this$props6.orderAdditionalQuestions,
          businessPurpose = _this$props6.businessPurpose,
          businessTaxId = _this$props6.businessTaxId,
          businessName = _this$props6.businessName,
          buyerData = _this$props6.buyerData,
          sameAsBuyerChecks = _this$props6.sameAsBuyerChecks,
          seatingMap = _this$props6.seatingMap,
          additionalQuestionsPreview = _this$props6.additionalQuestionsPreview,
          ticketAssigningEnabled = _this$props6.ticketAssigningEnabled,
          orderSummary = _this$props6.orderSummary;

      var isGlobal = _this.determineIsGlobal();
      var detailsProps = {
        saveDetails: _this.saveEventDetails,
        ticketsAdditionalQuestions: ticketsAdditionalQuestions,
        orderAdditionalQuestions: orderAdditionalQuestions,
        businessPurpose: businessPurpose,
        businessTaxId: businessTaxId,
        seatingMapAvailable: seatingMap.seatingMapRequired,
        businessName: businessName,
        buyerData: buyerData,
        sameAsBuyerChecks: sameAsBuyerChecks,
        additionalQuestionsPreview: additionalQuestionsPreview,
        isGlobal: isGlobal,
        ticketAssigningEnabled: ticketAssigningEnabled,
        orderSummary: orderSummary
      };
      if (isGlobal) {
        detailsProps.saveDetails = _this.saveGlobalDetails;
        detailsProps.ticketsAdditionalQuestions = [];
        detailsProps.orderAdditionalQuestions = [];
      }
      return Object(preact_min["h"])(Details_DetailsForm, detailsProps);
    }, _temp), Details__possibleConstructorReturn(_this, _ret);
  }

  DetailsWrapper.prototype.render = function render() {
    var isGlobal = this.determineIsGlobal();
    var childProps = {};
    if (isGlobal) {
      childProps = {
        getForm: this.getForm,
        didMount: this.globalDetailsDidMount,
        didUpdate: this.globalDetailsDidUpdate,
        isGlobal: isGlobal
      };
    } else {
      childProps = {
        save: this.saveEventDetails,
        didMount: this.eventDetailsDidMount,
        didUpdate: this.eventDetailsDidUpdate,
        getForm: this.getForm,
        isGlobal: isGlobal
      };
    }
    return Object(preact_min["h"])(Details_Details, Details__extends({}, this.props, childProps));
  };

  return DetailsWrapper;
}(preact_min["Component"]);

var Details__ref2 = Object(preact_min["h"])(
  Page["a" /* default */],
  null,
  Object(preact_min["h"])(WarningMessage["a" /* default */], { title: "Order could not be loaded" })
);

var Details__ref3 = Object(preact_min["h"])(
  Page["a" /* default */],
  null,
  Object(preact_min["h"])(WarningMessage["a" /* default */], { title: "Order has been completed" })
);

var Details__ref4 = Object(preact_min["h"])(giftCards_GiftCardPageHeader, null);

var Details_Details = function (_Component2) {
  Details__inherits(Details, _Component2);

  function Details() {
    Details__classCallCheck(this, Details);

    return Details__possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  Details.prototype.componentDidMount = function componentDidMount() {
    var didMount = this.props.didMount;

    didMount();
  };

  Details.prototype.componentDidUpdate = function componentDidUpdate() {
    var didUpdate = this.props.didUpdate;

    didUpdate();
  };

  Details.prototype.render = function render(_ref) {
    var event = _ref.event,
        order = _ref.order,
        merchandise = _ref.merchandise,
        seatingMap = _ref.seatingMap,
        additionalQuestionsPreview = _ref.additionalQuestionsPreview,
        isGlobal = _ref.isGlobal,
        getForm = _ref.getForm,
        giftCards = _ref.giftCards;

    if (additionalQuestionsPreview) {
      return Object(preact_min["h"])(
        Page["a" /* default */],
        null,
        getForm()
      );
    }
    if (order && order.orderGet.error) {
      return Details__ref2;
    }
    if (event.loading || !event.data && !isGlobal || giftCards.loading && isGlobal || !giftCards.giftCardPage && isGlobal || !order.data || merchandise.merch.loading) {
      return;
    }
    if (order && order.data.status === "complete") {
      return Details__ref3;
    }

    if (order.detailsRequest.error) {
      window.scrollTo(0, 0);
    }

    return Object(preact_min["h"])(
      "div",
      null,
      isGlobal ? Details__ref4 : null,
      Object(preact_min["h"])(
        Page["a" /* default */],
        { isGlobal: isGlobal },
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])(BookingHeader["a" /* default */], {
            event: event,
            orderId: order.data._id,
            includeSeatingMap: seatingMap.seatingMapRequired,
            isGlobal: isGlobal
          }),
          Object(preact_min["h"])(
            TwoCols["a" /* default */],
            null,
            getForm(),
            Object(preact_min["h"])(components_YourOrder, { allowDiscountsAdd: true, isGlobal: isGlobal })
          )
        )
      )
    );
  };

  return Details;
}(preact_min["Component"]);

var Details__ref6 = Object(preact_min["h"])(components_RequiredFields, null);

var Details__ref7 = Object(preact_min["h"])(
  "p",
  { "class": "text-error" },
  "Some selections are no longer available"
);

var Details__ref8 = Object(preact_min["h"])(components_DiscountCode, { allowAdd: true });

var Details__ref9 = Object(preact_min["h"])(
  "legend",
  null,
  Object(preact_min["h"])(
    "h3",
    { "class": "sub-header" },
    "Buyer Information"
  )
);

var Details__ref10 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "First Name",
  type: "text",
  name: "order.firstName",
  component: InputField["a" /* default */],
  required: true,
  validate: Validators["b" /* required */],
  autocomplete: "given-name"
});

var _ref11 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "Last Name",
  type: "text",
  name: "order.lastName",
  component: InputField["a" /* default */],
  required: true,
  validate: Validators["b" /* required */],
  autocomplete: "family-name"
});

var _ref12 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "Business Name",
  type: "text",
  name: "order.businessName",
  component: InputField["a" /* default */],
  validate: Validators["b" /* required */]
});

var Details__ref13 = Object(preact_min["h"])(
  "div",
  null,
  Object(preact_min["h"])(redux_form_es["a" /* Field */], {
    label: "Keep me posted on new events and updates about the Humanitix journey",
    name: "order.allowMarking",
    component: fields_CheckboxField
  })
);

var Details_DetailsForm = function DetailsForm(_ref5) {
  var event = _ref5.event,
      order = _ref5.order,
      handleSubmit = _ref5.handleSubmit,
      saveDetails = _ref5.saveDetails,
      seatingMapAvailable = _ref5.seatingMapAvailable,
      ticketsAdditionalQuestions = _ref5.ticketsAdditionalQuestions,
      orderAdditionalQuestions = _ref5.orderAdditionalQuestions,
      businessPurpose = _ref5.businessPurpose,
      businessTaxId = _ref5.businessTaxId,
      businessName = _ref5.businessName,
      ticketAssigningEnabled = _ref5.ticketAssigningEnabled,
      buyerData = _ref5.buyerData,
      dispatch = _ref5.dispatch,
      sameAsBuyerChecks = _ref5.sameAsBuyerChecks,
      additionalQuestionsPreview = _ref5.additionalQuestionsPreview,
      isGlobal = _ref5.isGlobal,
      orderSummary = _ref5.orderSummary;

  var openLink = function openLink(link, target) {
    window.open(link, target);
  };
  var changeFieldValue = function changeFieldValue(field, value) {
    dispatch(Object(redux_form_es["c" /* change */])(Details_formName, field, value));
  };

  var mobileRequired = !isGlobal && event.data.settings && event.data.settings.mobileRequired === false ? false : true;
  // quick hard code for Atlassian / Remove after models change
  if (!isGlobal && event.data.userId === "swxRT5dkHLblWjQFhVepr2zJpWG3") {
    mobileRequired = false;
  }

  var isConference = !isGlobal && event.data.settings.enableTicketAssigning;
  var businessPurposeOptions = [{
    label: "Yes",
    value: "true"
  }, {
    label: "No",
    value: "false"
  }];
  var businessTaxIdName = Object(config["a" /* default */])("TAX_NAME") || "Tax ID";
  var detailsAdditionQuestions = !isGlobal && event.data.additionalQuestions && event.data.additionalQuestions.length ? event.data.additionalQuestions.filter(function (q) {
    return !q.askAfterCheckout;
  }) : [];
  detailsAdditionQuestions = detailsAdditionQuestions.map(function (q) {
    if (q.type === "multiSelect" && q.options && q.options.length) {
      q.options = q.options.map(function (o) {
        var newOption = o.label ? Details__extends({}, o) : Details__extends({}, o, {
          id: o._id,
          label: o.value,
          value: false
        });
        return newOption;
      });
    }
    return q;
  });
  var btnText = ticketAssigningEnabled ? "Assign tickets" : "Checkout";
  btnText = seatingMapAvailable ? "Select Seats" : btnText;
  var hideIsBusinessQuestion = event.data && event.data.settings && event.data.settings.hideIsBusinessQuestion;

  var ticketQuestions = !isConference && !isGlobal ? Object(preact_min["h"])(details_TicketsQuestions, {
    tickets: order.data.tickets,
    ticketTypes: event.data.ticketTypes,
    ticketsAdditionalQuestions: ticketsAdditionalQuestions,
    additionalQuestions: detailsAdditionQuestions,
    buyerData: buyerData,
    changeFieldValue: changeFieldValue,
    sameAsBuyerChecks: sameAsBuyerChecks
  }) : null;
  return Object(preact_min["h"])(
    "div",
    null,
    Object(preact_min["h"])(CountDown["a" /* default */], { margin: "0px 0px 12px 0px", isGlobal: isGlobal }),
    Details__ref6,
    Object(preact_min["h"])(
      "form",
      { onSubmit: handleSubmit(saveDetails) },
      Object(preact_min["h"])(
        "div",
        {
          style: order.timeExpired ? {
            pointerEvents: "none"
          } : {}
        },
        Object(preact_min["h"])(
          "div",
          {
            style: {
              marginBottom: 24
            }
          },
          order.detailsRequest.error ? Object(preact_min["h"])(
            "div",
            null,
            order.detailsRequest.additionalQuestionQuantityError ? Object(preact_min["h"])(
              "div",
              null,
              Details__ref7,
              order.detailsRequest.error.message.map(function (msg) {
                return Object(preact_min["h"])(
                  "p",
                  { "class": "text-error" },
                  msg
                );
              })
            ) : Object(preact_min["h"])(
              "p",
              { "class": "text-error" },
              order.detailsRequest.error.message
            )
          ) : "",
          Details__ref8,
          Object(preact_min["h"])(
            "fieldset",
            null,
            Details__ref9,
            Details__ref10,
            _ref11,
            Object(preact_min["h"])(redux_form_es["a" /* Field */], {
              label: "Email",
              type: "text",
              name: "order.email",
              component: InputField["a" /* default */],
              required: true,
              validate: [Validators["b" /* required */], Validators["a" /* email */]],
              autocomplete: "email"
            }),
            Object(preact_min["h"])(redux_form_es["a" /* Field */], {
              label: "Mobile",
              type: "text",
              name: "order.mobile",
              component: InputField["a" /* default */],
              required: mobileRequired,
              validate: mobileRequired ? Validators["b" /* required */] : null,
              autocomplete: "tel"
            }),
            Object(preact_min["h"])("hr", { style: { margin: "24px 0px" } }),
            !isGlobal && !hideIsBusinessQuestion ? Object(preact_min["h"])(redux_form_es["a" /* Field */], {
              label: "Is your purchase for business purposes?",
              name: "order.businessPurpose",
              component: fields_RadioField,
              defaultValue: "false",
              inline: true,
              options: businessPurposeOptions,
              validate: Validators["b" /* required */]
            }) : null,
            businessPurpose === "true" && Object(preact_min["h"])(
              "div",
              {
                style: {
                  background: "#FAFAF9",
                  padding: 12
                }
              },
              Object(preact_min["h"])(redux_form_es["a" /* Field */], {
                label: businessTaxIdName,
                type: "text",
                name: "order.businessTaxId",
                component: InputField["a" /* default */],
                validate: Validators["b" /* required */]
              }),
              _ref12
            ),
            Object(preact_min["h"])("hr", { style: { margin: "0px 0px 24px 0px" } }),
            Object(preact_min["h"])(details_OrderQuestions, {
              additionalQuestions: detailsAdditionQuestions,
              orderAdditionalQuestions: orderAdditionalQuestions,
              changeFieldValue: changeFieldValue,
              tickets: order.data.tickets
            })
          )
        ),
        !isGlobal ? ticketQuestions : Object(preact_min["h"])(Details_GiftCardDetails, { order: order }),
        " ",
        !isGlobal && event.data.settings.mailList ? Details__ref13 : null
      ),
      Object(preact_min["h"])(
        "div",
        null,
        "By clicking ",
        btnText.toLowerCase(),
        ", I agree to the",
        " ",
        Object(preact_min["h"])(
          "a",
          {
            href: "#",
            onClick: function onClick() {
              return openLink("/pdfs/humanitix_purchaser_terms_and_conditions.pdf", "_blank");
            },
            style: { textDecoration: "underline" }
          },
          "Humanitix ticketing terms"
        ),
        " ",
        "and have read the",
        " ",
        Object(preact_min["h"])(
          "a",
          {
            href: "#",
            onClick: function onClick() {
              return openLink("/pdfs/humanitix_privacy_policy.pdf", "_blank");
            },
            style: { textDecoration: "underline" }
          },
          "Humanitix privacy policy"
        ),
        ". I agree that Humanitix may pass on my information to the event organiser."
      ),
      !additionalQuestionsPreview ? Object(preact_min["h"])(
        ActionBar["a" /* default */],
        null,
        Object(preact_min["h"])(components_OrderTotal, { orderSummary: orderSummary }),
        Object(preact_min["h"])(
          ActionButton["a" /* default */],
          {
            disabled: order.detailsRequest.loading || order.timeExpired || order.addDiscountRequest.loading,
            loading: order.detailsRequest.loading || order.addDiscountRequest.loading,
            dataCY: ticketAssigningEnabled ? "assign" : "checkout",
            classNames: Details_nextStageButton
          },
          btnText
        )
      ) : null
    )
  );
};

var _ref15 = Object(preact_min["h"])(
  "h3",
  { "class": "sub-header" },
  "Gift Card Information"
);

var Details_GiftCardDetails = function GiftCardDetails(_ref14) {
  var order = _ref14.order;
  var giftCards = order.data.giftCards;

  return Object(preact_min["h"])(
    "div",
    null,
    _ref15,
    Object(preact_min["h"])(
      "p",
      { style: { borderBottom: "1px solid #eeeeee", paddingBottom: 8 } },
      "Send this gift card to a friend."
    ),
    giftCards.map(function (giftcard, i) {
      return Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "h4",
          { style: { borderBottom: "1px solid #eeeeee", paddingBottom: 8 } },
          i + 1 + ". " + giftcard.giftCardTypeName + " $" + giftcard.price
        ),
        Object(preact_min["h"])(redux_form_es["a" /* Field */], {
          label: "Sender name (From)",
          type: "text",
          name: "giftCards[" + i + "].senderName",
          component: InputField["a" /* default */],
          required: true,
          validate: [Validators["b" /* required */]]
        }),
        Object(preact_min["h"])(redux_form_es["a" /* Field */], {
          label: "Recipient name (To)",
          type: "text",
          name: "giftCards[" + i + "].recipientName",
          component: InputField["a" /* default */],
          required: true,
          validate: [Validators["b" /* required */]]
        }),
        Object(preact_min["h"])(redux_form_es["a" /* Field */], {
          label: "Recipient email",
          type: "text",
          name: "giftCards[" + i + "].recipientEmail",
          component: InputField["a" /* default */],
          required: true,
          validate: [Validators["b" /* required */], Validators["a" /* email */]],
          autocomplete: "email"
        }),
        Object(preact_min["h"])(redux_form_es["a" /* Field */], {
          label: "Message for recipient",
          type: "text",
          name: "giftCards[" + i + "].message",
          component: TextareaField["a" /* default */]
        })
      );
    })
  );
};

Details_DetailsForm = Object(redux_form_es["f" /* reduxForm */])({
  form: Details_formName,
  destroyOnUnmount: false,
  onSubmitFail: function onSubmitFail(errors) {
    Object(ScrollToErrors["a" /* scrollToErrors */])();
  }
})(Details_DetailsForm);

function getOrderValues(order, providedOrderData, additionalQuestions, formOrder) {
  if (formOrder) {
    return formOrder;
  }
  var allowedOrderData = ["firstName", "lastName", "mobile", "email"];
  allowedOrderData.forEach(function (key) {
    order[key] = providedOrderData && providedOrderData[key] ? providedOrderData[key] : null;
  });

  if (order.businessPurpose === false || !order.businessPurpose) {
    order.businessPurpose = "false";
  }
  if (order && order.additionalFields) {
    var mappedOrder = Details__extends({}, order);
    mappedOrder.additionalFields = {};
    if (order.additionalFields && order.additionalFields.length > 0) {
      order.additionalFields.forEach(function (field) {
        mappedOrder.additionalFields[field.questionId] = field.value;
      });
    } else if (additionalQuestions && additionalQuestions.length > 0) {
      additionalQuestions.forEach(function (question) {
        question.defaultValue && question.perOrder && !question.askAfterCheckout ? mappedOrder.additionalFields[question._id] = question.defaultValue : "";
      });
    }

    return mappedOrder;
  }

  return order;
}

var Details_selector = Object(redux_form_es["d" /* formValueSelector */])(Details_formName);

Details_DetailsForm = Object(es["b" /* connect */])(function (state, ownProps) {
  var isGlobal = ownProps.isGlobal;

  var order = getOrderValues(state.order.data, state.order.providedOrderData, isGlobal ? [] : state.event.data.additionalQuestions, Details_selector(state, "order"));
  var initialValues = {
    order: order
  };
  if (!isGlobal) {
    var tickets = getTicketValues(state.order.data, state.event.data.additionalQuestions, Details_selector(state, "tickets"));
    initialValues.tickets = tickets;
  } else {
    var giftCards = state.order.data.giftCards.map(function (giftCard) {
      return {
        giftCardId: giftCard._id
      };
    });
    initialValues.giftCards = giftCards;
  }

  return {
    initialValues: initialValues,
    event: state.event,
    order: state.order
  };
}, {})(Details_DetailsForm);

/* harmony default export */ var details_Details = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order,
    orderSummary: state.orderSummary,
    seatingMap: state.seatingMap,
    merchandise: state.merchandise,
    giftCards: state.giftCards,
    ticketSelection: state.ticketSelection,
    ticketAssigningEnabled: state.event.data ? state.event.data.settings.enableTicketAssigning : false,
    buyerData: {
      firstName: Details_selector(state, "order.firstName"),
      lastName: Details_selector(state, "order.lastName"),
      mobile: Details_selector(state, "order.mobile"),
      email: Details_selector(state, "order.email")
    },
    businessPurpose: Details_selector(state, "order.businessPurpose"),
    businessTaxId: Details_selector(state, "order.businessTaxId"),
    businessName: Details_selector(state, "order.businessName"),
    orderAdditionalQuestions: Details_selector(state, "order.additionalFields"),
    ticketsAdditionalQuestions: Details_selector(state, "tickets"),
    sameAsBuyerChecks: Details_selector(state, "sameAsBuyerChecks")
  };
}, {
  saveOrderData: orderActions["_2" /* saveOrderData */],
  getEvent: eventActions["u" /* getEvent */],
  getOrder: orderActions["Q" /* getOrder */],
  setSeatingMapRequired: seatingMapActions["q" /* setSeatingMapRequired */],
  getGiftCardPage: giftCardActions_getGiftCardPage
})(Details_DetailsWrapper));
// CONCATENATED MODULE: ./routes/widgets/AdditionalQuestionsPreview.js


function AdditionalQuestionsPreview__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AdditionalQuestionsPreview__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AdditionalQuestionsPreview__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var AdditionalQuestionsPreview__ref = Object(preact_min["h"])(
  "div",
  null,
  Object(preact_min["h"])(details_Details, { additionalQuestionsPreview: true })
);

var AdditionalQuestionsPreview = function (_Component) {
  AdditionalQuestionsPreview__inherits(AdditionalQuestionsPreview, _Component);

  function AdditionalQuestionsPreview(props) {
    AdditionalQuestionsPreview__classCallCheck(this, AdditionalQuestionsPreview);

    return AdditionalQuestionsPreview__possibleConstructorReturn(this, _Component.call(this, props));
  }

  AdditionalQuestionsPreview.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        eventSlug = _props.eventSlug,
        event = _props.event,
        getAdditionalQuestionsPreview = _props.getAdditionalQuestionsPreview;

    if (!event.data && !event.loading) {
      getAdditionalQuestionsPreview(eventSlug);
    }
  };

  AdditionalQuestionsPreview.prototype.render = function render() {
    var _props2 = this.props,
        event = _props2.event,
        generateDummyOrder = _props2.generateDummyOrder,
        order = _props2.order;

    if (!event || !event.data || event.loading) {
      return null;
    }
    if ((!order || !order.data) && !order.loading) {
      generateDummyOrder(event);
      return null;
    }
    return AdditionalQuestionsPreview__ref;
  };

  return AdditionalQuestionsPreview;
}(preact_min["Component"]);

/* harmony default export */ var widgets_AdditionalQuestionsPreview = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order
  };
}, {
  getUserEvents: eventActions["x" /* getUserEvents */],
  getEvent: eventActions["u" /* getEvent */],
  generateDummyOrder: orderActions["P" /* generateDummyOrder */],
  getAdditionalQuestionsPreview: eventActions["r" /* getAdditionalQuestionsPreview */]
})(AdditionalQuestionsPreview));
// CONCATENATED MODULE: ./utils/SeatingMapUtils.js
function findApplicableSeatingMapId(eventData, orderData) {
  var seatingMapId = void 0;
  if (orderData) {
    var tickets = orderData.tickets;

    var event = eventData;
    if (event.seatingMaps && tickets) {
      event.seatingMaps.forEach(function (seatingMap) {
        var isPublic = seatingMap.public !== false;
        seatingMap.ticketTypeSet.forEach(function (ticketType) {
          var containsPackageTicket = tickets.filter(function (ticket) {
            return String(ticket.packageId) === String(ticketType);
          }).length > 0;
          var containsTicketType = tickets.filter(function (ticket) {
            return String(ticket.ticketTypeId) === String(ticketType);
          }).length > 0;
          if ((containsPackageTicket || containsTicketType) && !seatingMapId && isPublic) {
            seatingMapId = seatingMap.id;
          }
        });
      });
    }
  }
  return seatingMapId;
}
// EXTERNAL MODULE: ./assets/images/icon-edit.svg
var icon_edit = __webpack_require__("6pik");
var icon_edit_default = /*#__PURE__*/__webpack_require__.n(icon_edit);

// EXTERNAL MODULE: ./assets/images/icon-arrow-left.svg
var icon_arrow_left = __webpack_require__("3I3T");
var icon_arrow_left_default = /*#__PURE__*/__webpack_require__.n(icon_arrow_left);

// EXTERNAL MODULE: ./assets/images/icon-arrow-right.svg
var icon_arrow_right = __webpack_require__("qm7U");
var icon_arrow_right_default = /*#__PURE__*/__webpack_require__.n(icon_arrow_right);

// CONCATENATED MODULE: ./routes/conferences/Colors.js
var colors = ["#CE6CD5", "#81BAFF", "#2D0E54", "#C4C400", "#FC4F95", "#A76E11", "#00D1D5", "#337E80", "#6F0FFF", "#FFC1A6", "#A62273", "#FDBE57"];

/* harmony default export */ var Colors = (colors);
// CONCATENATED MODULE: ./routes/conferences/AssignSummary.js


function AssignSummary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AssignSummary__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AssignSummary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var summaryStyles = Object(index_esm["css"])({
  "@media (max-width: 600px)": {
    display: "flex",
    width: "100%",
    overflowX: "hidden"
  }
});

var profileStyles = Object(index_esm["css"])({
  paddingBottom: 24,
  "@media (max-width: 600px)": {
    minWidth: "100%"
  }
});

var ticketTypeStyle = Object(index_esm["css"])({
  display: "flex",
  alignItems: "center",
  "@media (max-width: 600px)": {
    minWidth: "50%"
  }
});

var ticketTypeListStyle = Object(index_esm["css"])({
  "@media (max-width: 600px)": {
    display: "flex",
    flexWrap: "wrap",
    paddingLeft: 12,
    paddingRight: 12
  }
});

var attendeeTitleStyle = Object(index_esm["css"])({
  marginTop: 24,
  paddingBottom: 11,
  borderBottom: "solid 1px #dedede",
  "@media (max-width: 600px)": {
    borderBottom: "none"
  }
});

var pageIncrementorStyle = Object(index_esm["css"])({
  display: "none",
  "@media (max-width: 600px)": {
    display: "flex",
    padding: "0px 2px"
  }
});

var noAttendeeStyle = Object(index_esm["css"])({
  width: "100%",
  textAlign: "center",
  marginTop: 32,
  paddingBottom: 32,
  "@media (max-width: 600px)": {
    marginTop: 0,
    paddingBottom: 0
  }
});

var summaryId = "attendee-profile-summary";

var AssignSummary__ref2 = Object(preact_min["h"])(
  "div",
  { id: summaryId, className: summaryStyles },
  Object(preact_min["h"])(
    "p",
    { className: noAttendeeStyle },
    "You haven\u2019t assigned any tickets yet"
  )
);

var AssignSummary_TicketAssignSummary = function (_Component) {
  AssignSummary__inherits(TicketAssignSummary, _Component);

  function TicketAssignSummary(props) {
    AssignSummary__classCallCheck(this, TicketAssignSummary);

    var _this = AssignSummary__possibleConstructorReturn(this, _Component.call(this, props));

    _this.pageChange = function (num) {
      Object(ScrollTo["b" /* scrollToNextX */])(num, summaryId);
      _this.setState({ attendeeIndex: num });
    };

    _this.state = {
      attendeeIndex: 0
    };
    return _this;
  }

  TicketAssignSummary.prototype.render = function render(_ref) {
    var _this2 = this;

    var attendeeProfile = _ref.attendeeProfile,
        order = _ref.order,
        ticketsGroupedByType = _ref.ticketsGroupedByType,
        openModal = _ref.openModal;
    var attendeeIndex = this.state.attendeeIndex;
    var profiles = attendeeProfile.profiles;

    var attendeeProfileLength = profiles.length;
    var ticketLookup = ticketsGroupedByType.map(function (ticketTypeGroup, i) {
      return ticketTypeGroup.tickets.map(function (ticket) {
        ticket.color = Colors[i];
        return ticket;
      });
    }).reduce(function (arr, tickets) {
      return arr.concat(tickets);
    }, []).reduce(function (map, ticket) {
      var attendeeProfileId = ticket.attendeeProfileId;

      if (attendeeProfileId) {
        if (!map[attendeeProfileId]) {
          map[attendeeProfileId] = [];
        }
        map[attendeeProfileId].push(ticket);
      }
      return map;
    }, {});
    var profilesExist = profiles.filter(function (profile) {
      var _id = profile._id;

      var assignedTickets = ticketLookup[_id] || [];
      if (assignedTickets.length === 0) {
        return false;
      }
      return true;
    }).length > 0;
    if (!profilesExist) {
      return Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "div",
          { className: attendeeTitleStyle },
          Object(preact_min["h"])(
            "h2",
            { style: { marginLeft: 16, marginBottom: 0 } },
            "Attendees"
          )
        ),
        AssignSummary__ref2
      );
    }
    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        "div",
        { className: attendeeTitleStyle },
        Object(preact_min["h"])(
          "h2",
          { style: { marginLeft: 16, marginBottom: 0 } },
          "Attendees"
        )
      ),
      Object(preact_min["h"])(
        "div",
        { id: summaryId, className: summaryStyles },
        profiles.map(function (profile) {
          var firstName = profile.firstName,
              lastName = profile.lastName,
              email = profile.email,
              _id = profile._id;

          var assignedTickets = ticketLookup[_id] || [];
          if (assignedTickets.length === 0) {
            return null;
          }
          return Object(preact_min["h"])(
            "div",
            { className: profileStyles },
            Object(preact_min["h"])(
              "div",
              {
                style: {
                  backgroundColor: "#f9f9fa",
                  display: "flex",
                  paddingTop: 10,
                  paddingBottom: 10,
                  alignItems: "center",
                  marginBottom: 12
                }
              },
              Object(preact_min["h"])(
                "h4",
                {
                  style: { marginLeft: 16, marginBottom: 0, flexGrow: 1 }
                },
                firstName + " " + lastName
              ),
              Object(preact_min["h"])("div", {
                onClick: function onClick() {
                  return openModal(profile, false, true);
                },
                style: {
                  width: 24,
                  height: 24,
                  background: "url(" + icon_edit_default.a + ")",
                  marginRight: 16,
                  cursor: "pointer"
                }
              })
            ),
            Object(preact_min["h"])(
              "div",
              { className: ticketTypeListStyle },
              assignedTickets.map(function (_ref3) {
                var ticketTypeName = _ref3.ticketTypeName,
                    color = _ref3.color;

                return Object(preact_min["h"])(
                  "div",
                  { className: ticketTypeStyle },
                  Object(preact_min["h"])("div", {
                    style: {
                      height: 32,
                      width: 6,
                      backgroundColor: color,
                      marginRight: 10
                    }
                  }),
                  Object(preact_min["h"])(
                    "div",
                    {
                      "data-cy": firstName + "-" + lastName + "-" + ticketTypeName,
                      style: { flexGrow: 1, fontSize: 14 }
                    },
                    ticketTypeName
                  )
                );
              })
            )
          );
        })
      ),
      Object(preact_min["h"])(
        "div",
        { className: pageIncrementorStyle },
        Object(preact_min["h"])("button", {
          disabled: attendeeIndex === 0,
          onClick: function onClick() {
            return _this2.pageChange(attendeeIndex - 1);
          },
          style: {
            width: 24,
            height: 24,
            background: "url(" + icon_arrow_left_default.a + ")",
            marginRight: 32,
            cursor: "pointer",
            backgroundRepeat: "no-repeat",
            flexGrow: 1,
            backgroundPosition: "right"
          }
        }),
        Object(preact_min["h"])(
          "div",
          { style: { fontSize: 12, color: "#5a626c" } },
          attendeeIndex + 1 + " of " + attendeeProfileLength
        ),
        Object(preact_min["h"])("button", {
          disabled: attendeeIndex === attendeeProfileLength - 1,
          onClick: function onClick() {
            return _this2.pageChange(attendeeIndex + 1);
          },
          style: {
            width: 24,
            height: 24,
            background: "url(" + icon_arrow_right_default.a + ")",
            marginLeft: 32,
            cursor: "pointer",
            backgroundRepeat: "no-repeat",
            flexGrow: 1
          }
        })
      )
    );
  };

  return TicketAssignSummary;
}(preact_min["Component"]);

/* harmony default export */ var AssignSummary = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    attendeeProfile: state.attendeeProfile,
    order: state.order
  };
}, {
  openModal: attendeeProfileActions_openModal
})(AssignSummary_TicketAssignSummary));
// CONCATENATED MODULE: ./routes/conferences/ExistingProfileModal.js






var ExistingProfileModal_ExistingProfileModal = function ExistingProfileModal(_ref) {
  var attendeeProfile = _ref.attendeeProfile,
      addExistingAttendee = _ref.addExistingAttendee,
      clearAttendee = _ref.clearAttendee;
  var profileCheck = attendeeProfile.profileCheck;
  var ticketId = profileCheck.ticketId,
      profile = profileCheck.profile;

  var footer = Object(preact_min["h"])(
    "div",
    { style: { display: "flex", width: "100%", padding: "0px 12px" } },
    Object(preact_min["h"])(
      "div",
      { style: { flexGrow: 1 } },
      Object(preact_min["h"])(
        components_Button["a" /* default */],
        { onClick: clearAttendee },
        "Cancel"
      )
    ),
    Object(preact_min["h"])(
      "div",
      {
        style: { flexGrow: 1, display: "flex", flexDirection: "row-reverse" }
      },
      Object(preact_min["h"])(
        components_Button["a" /* default */],
        { onClick: function onClick() {
            return addExistingAttendee(ticketId, profile);
          } },
        "Add Attendee Profile"
      )
    )
  );
  return Object(preact_min["h"])(
    Modal["a" /* default */],
    {
      closeHandler: clearAttendee,
      showModal: profile,
      footer: footer,
      padding: 0,
      includeCloseButton: false
    },
    Object(preact_min["h"])(
      "p",
      { style: { padding: 20 } },
      "An attendee profile already exists with this email. Add existing attendee profile?"
    )
  );
};

/* harmony default export */ var conferences_ExistingProfileModal = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    attendeeProfile: state.attendeeProfile
  };
}, {
  addExistingAttendee: attendeeProfileActions_addExistingAttendee,
  clearAttendee: attendeeProfileActions_clearAttendee
})(ExistingProfileModal_ExistingProfileModal));
// CONCATENATED MODULE: ./routes/conferences/HybridSummary.js


function HybridSummary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HybridSummary__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HybridSummary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var orderSummaryStyle = Object(index_esm["css"])({
  backgroundColor: "#f9f9fa",
  display: "flex",
  paddingTop: 10,
  paddingBottom: 10,
  alignItems: "center",
  cursor: "pointer"
});

var hybridSummaryStyle = Object(index_esm["css"])({
  boxShadow: "0 1px 4px 0 rgba(9, 30, 66, 0.13)",
  "@media (max-width: 600px)": {
    display: "none"
  }
});

var HybridSummary__ref2 = Object(preact_min["h"])(components_YourOrder, { allowDiscountsAdd: false, isGlobal: false });

var HybridSummary_HybridSummary = function (_Component) {
  HybridSummary__inherits(HybridSummary, _Component);

  function HybridSummary(props) {
    HybridSummary__classCallCheck(this, HybridSummary);

    var _this = HybridSummary__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      expanded: false
    };
    return _this;
  }

  HybridSummary.prototype.render = function render(_ref) {
    var _this2 = this;

    var ticketsGroupedByType = _ref.ticketsGroupedByType,
        token = _ref.token;
    var expanded = this.state.expanded;

    return Object(preact_min["h"])(
      "div",
      { className: hybridSummaryStyle },
      !token ? Object(preact_min["h"])(
        "div",
        {
          className: orderSummaryStyle,
          onClick: function onClick() {
            return _this2.setState({ expanded: !expanded });
          }
        },
        Object(preact_min["h"])(
          "h2",
          { style: { flexGrow: 1, marginLeft: 16, marginBottom: 0 } },
          "View your order"
        ),
        Object(preact_min["h"])("img", {
          src: icon_arrow_down_default.a,
          style: {
            width: 16,
            height: 24,
            marginRight: 16,
            transform: "rotate(" + (expanded ? 180 : 0) + "deg)"
          }
        }),
        " "
      ) : null,
      expanded ? HybridSummary__ref2 : null,
      Object(preact_min["h"])(AssignSummary, { ticketsGroupedByType: ticketsGroupedByType })
    );
  };

  return HybridSummary;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/conferences/ProfileModal.js


function ProfileModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ProfileModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ProfileModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ProfileModal_formName = "attendeeProfile";

var ProfileModal_ProfileModal = function (_Component) {
  ProfileModal__inherits(ProfileModal, _Component);

  function ProfileModal() {
    var _temp, _this, _ret;

    ProfileModal__classCallCheck(this, ProfileModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ProfileModal__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleSubmit = function (profileData) {
      var _this$props = _this.props,
          updateProfile = _this$props.updateProfile,
          checkForExistingAttendee = _this$props.checkForExistingAttendee,
          attendeeProfile = _this$props.attendeeProfile,
          order = _this$props.order;
      var _id = order.data._id;
      var attendeeModal = attendeeProfile.attendeeModal;
      var ticketId = attendeeModal.ticketId,
          isNew = attendeeModal.isNew,
          defaultValues = attendeeModal.defaultValues;

      if (isNew) {
        checkForExistingAttendee(profileData, ticketId);
      } else {
        updateProfile(_id, defaultValues._id, profileData);
      }
    }, _temp), ProfileModal__possibleConstructorReturn(_this, _ret);
  }

  ProfileModal.prototype.render = function render(_ref) {
    var attendeeProfile = _ref.attendeeProfile,
        closeModal = _ref.closeModal,
        order = _ref.order,
        profileLookup = _ref.profileLookup,
        unAssignTicket = _ref.unAssignTicket,
        buyerOrderIdentifier = _ref.buyerOrderIdentifier;
    var attendeeModal = attendeeProfile.attendeeModal,
        loading = attendeeProfile.loading,
        error = attendeeProfile.error;
    var show = attendeeModal.show,
        defaultValues = attendeeModal.defaultValues;
    var _id = order.data._id;
    var creatorOrderId = defaultValues.creatorOrderId;

    if (loading) {
      return Object(preact_min["h"])("div", { "class": "loading loading-lg", style: { padding: "0 0 180px 0" } });
    }

    var assignedTicketTypes = profileLookup[defaultValues._id];
    var hasAssignedTicketTypes = assignedTicketTypes && assignedTicketTypes.length && assignedTicketTypes.length > 0;
    return Object(preact_min["h"])(
      Modal["a" /* default */],
      { closeHandler: closeModal, showModal: show, padding: 0 },
      show ? Object(preact_min["h"])(ProfileModal_AttendeeForm, {
        saveDetails: this.handleSubmit,
        defaultValues: defaultValues,
        createdByOrder: _id === creatorOrderId,
        isBuyer: defaultValues.profileIdentifier === buyerOrderIdentifier,
        errorMessage: error
      }) : null,
      hasAssignedTicketTypes ? Object(preact_min["h"])(
        "div",
        {
          style: {
            borderTop: "solid 1px #dedede",
            paddingTop: 16,
            paddingBottom: 16,
            paddingLeft: 20,
            paddingRight: 20
          }
        },
        Object(preact_min["h"])(
          "h2",
          { style: { marginBottom: 16 } },
          "Assigned Tickets"
        ),
        assignedTicketTypes.map(function (ticket) {
          return Object(preact_min["h"])(
            "div",
            {
              style: {
                display: "flex",
                borderBottom: "solid 1px #dedede",
                paddingBottom: 8,
                marginBottom: 8
              }
            },
            Object(preact_min["h"])(
              "div",
              { style: { flexGrow: 1, fontSize: 14 } },
              ticket.ticketTypeName
            ),
            Object(preact_min["h"])(
              "a",
              {
                onClick: function onClick() {
                  return unAssignTicket(ticket._id, assignedTicketTypes.length === 1);
                }
              },
              "Un-assign"
            )
          );
        })
      ) : null
    );
  };

  return ProfileModal;
}(preact_min["Component"]);

var attendeeFormStyle = Object(index_esm["css"])({
  minWidth: 500,
  padding: 20,
  "@media (max-width: 600px)": {
    minWidth: 0
  }
});

var ProfileModal__ref3 = Object(preact_min["h"])(
  components_Button["a" /* default */],
  {
    key: "payment",
    buttonType: "submit",
    form: ProfileModal_formName,
    ariaLabel: "modalSubmit",
    value: "Submit",
    type: "primary",
    dataCY: "submit"
  },
  "Save"
);

var ProfileModal_AttendeeForm = function AttendeeForm(_ref2) {
  var handleSubmit = _ref2.handleSubmit,
      saveDetails = _ref2.saveDetails,
      errorMessage = _ref2.errorMessage,
      createdByOrder = _ref2.createdByOrder,
      isBuyer = _ref2.isBuyer;

  var allowEdit = createdByOrder && !isBuyer;
  var warningMessage = "";
  if (!createdByOrder || isBuyer) {
    warningMessage = !createdByOrder ? "This attendee profile existed before this order, so its details cannot be changed." : "This attendee profile is the buyer profile, to change it please change buyer details.";
  }
  return Object(preact_min["h"])(
    "form",
    {
      onSubmit: handleSubmit(saveDetails),
      className: attendeeFormStyle,
      id: ProfileModal_formName,
      style: { overflow: "auto" }
    },
    warningMessage ? Object(preact_min["h"])(
      "p",
      { style: { marginTop: 12 } },
      warningMessage
    ) : null,
    Object(preact_min["h"])(redux_form_es["a" /* Field */], {
      label: "First Name",
      type: "text",
      name: "firstName",
      component: InputField["a" /* default */],
      required: true,
      validate: [Validators["b" /* required */]],
      disabled: !allowEdit
    }),
    Object(preact_min["h"])(redux_form_es["a" /* Field */], {
      label: "Last Name",
      type: "text",
      name: "lastName",
      component: InputField["a" /* default */],
      required: true,
      validate: [Validators["b" /* required */]],
      disabled: !allowEdit
    }),
    Object(preact_min["h"])(redux_form_es["a" /* Field */], {
      label: "Email",
      type: "text",
      name: "email",
      component: InputField["a" /* default */],
      required: true,
      validate: [Validators["b" /* required */], Validators["a" /* email */]],
      autocomplete: "email",
      disabled: !allowEdit
    }),
    errorMessage ? Object(preact_min["h"])(
      "p",
      { "class": "text-error" },
      errorMessage
    ) : null,
    Object(preact_min["h"])(
      "div",
      { style: { float: "right" } },
      ProfileModal__ref3
    )
  );
};

ProfileModal_AttendeeForm = Object(redux_form_es["f" /* reduxForm */])({
  form: ProfileModal_formName,
  destroyOnUnmount: true,
  onSubmitFail: function onSubmitFail(errors) {
    scrollToErrors();
  }
})(ProfileModal_AttendeeForm);

ProfileModal_AttendeeForm = Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    initialValues: ownProps.defaultValues
  };
})(ProfileModal_AttendeeForm);

/* harmony default export */ var conferences_ProfileModal = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order,
    attendeeProfile: state.attendeeProfile,
    buyerOrderIdentifier: createIdentifier(state.order.data)
  };
}, {
  checkForExistingAttendee: attendeeProfileActions_checkForExistingAttendee,
  closeModal: attendeeProfileActions_closeModal,
  updateProfile: attendeeProfileActions_updateProfile,
  unAssignTicket: attendeeProfileActions_unAssignTicket
})(ProfileModal_ProfileModal));
// EXTERNAL MODULE: ./assets/images/icon-arrow-down-solid.svg
var icon_arrow_down_solid = __webpack_require__("Mjho");
var icon_arrow_down_solid_default = /*#__PURE__*/__webpack_require__.n(icon_arrow_down_solid);

// CONCATENATED MODULE: ./components/ButtonDropDown.js
var ButtonDropDown__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var dropDownStyles = Object(index_esm["css"])({
  position: "relative",
  display: "inline-block",
  "#dropdown-content": {
    display: "none",
    position: "absolute",
    backgroundColor: "#ffffff",
    borderRadius: 4,
    minWidth: "160px",
    boxShadow: "0 1px 10px 0 rgba(9, 30, 66, 0.13)",
    zIndex: 1,
    padding: "12px 12px"
  },
  ":hover #dropdown-content, :active #dropdown-content": {
    display: "block"
  },
  button: {
    color: "#323232 !important",
    borderColor: "#8e99a8 !important",
    fontSize: 14,
    "&:hover": {
      backgroundColor: "white !important",
      border: "solid 1px #8e99a8"
    }
  }
});

var ButtonDropDown_buttonStyle = Object(index_esm["css"])({
  display: "inherit",
  "@media (max-width:600px)": {
    display: "none"
  }
});

var ButtonDropDown_linkStyle = Object(index_esm["css"])({
  display: "none",
  "@media (max-width:600px)": {
    display: "flex"
  }
});

var linkStyles = Object(index_esm["css"])({
  color: "black",
  textDecoration: "none",
  display: "block",
  cursor: "pointer",
  marginBottom: 12,
  ":last-child": {
    marginBottom: 0
  }
});

var ButtonDropDown__ref2 = Object(preact_min["h"])("img", { src: icon_arrow_down_solid_default.a });

var ButtonDropDown_ButtonDropDown = function ButtonDropDown(_ref) {
  var dropDownOptions = _ref.dropDownOptions,
      buttonLabel = _ref.buttonLabel,
      buttonProps = _ref.buttonProps,
      dataCY = _ref.dataCY;

  return Object(preact_min["h"])(
    "div",
    { className: dropDownStyles },
    Object(preact_min["h"])(
      "div",
      { className: ButtonDropDown_buttonStyle },
      Object(preact_min["h"])(
        components_Button["a" /* default */],
        ButtonDropDown__extends({}, buttonProps, { "data-cy": dataCY }),
        buttonLabel
      )
    ),
    Object(preact_min["h"])(
      "div",
      { className: ButtonDropDown_linkStyle },
      Object(preact_min["h"])(
        "h4",
        { style: { marginBottom: 0, marginTop: 4 } },
        buttonLabel
      ),
      ButtonDropDown__ref2
    ),
    Object(preact_min["h"])(
      "div",
      { id: "dropdown-content" },
      dropDownOptions.map(function (option) {
        return Object(preact_min["h"])(
          "a",
          {
            onClick: option.action,
            className: linkStyles,
            "data-cy": option.dataCY
          },
          option.label
        );
      })
    )
  );
};

/* harmony default export */ var components_ButtonDropDown = (ButtonDropDown_ButtonDropDown);
// CONCATENATED MODULE: ./routes/conferences/AdditionalQuestions.js
var AdditionalQuestions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function AdditionalQuestions__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AdditionalQuestions__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AdditionalQuestions__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var AdditionalQuestions_getTicketQuestions = function getTicketQuestions(ticketTypeId, additionalQuestions) {
  return additionalQuestions.filter(function (question) {
    if (question.perOrder || question.disabled || question.deleted) {
      return false;
    }
    if (question.appliesTo && question.appliesTo.length && question.appliesTo.indexOf(ticketTypeId) === -1) {
      return false;
    }
    return question;
  });
};

var AdditionalQuestions__ref4 = Object(preact_min["h"])(
  components_Button["a" /* default */],
  { buttonType: "submit", type: "primary" },
  "Save"
);

var AdditionalQuestions_AdditionalQuestions = function (_Component) {
  AdditionalQuestions__inherits(AdditionalQuestions, _Component);

  function AdditionalQuestions() {
    var _temp, _this, _ret;

    AdditionalQuestions__classCallCheck(this, AdditionalQuestions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = AdditionalQuestions__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.saveAdditionalQuestions = function (_ref) {
      var tickets = _ref.tickets;
      var _this$props = _this.props,
          updateAssignedAdditionalQuestions = _this$props.updateAssignedAdditionalQuestions,
          ticketId = _this$props.ticketId;

      updateAssignedAdditionalQuestions(ticketId, tickets[ticketId]);
    }, _temp), AdditionalQuestions__possibleConstructorReturn(_this, _ret);
  }

  AdditionalQuestions.prototype.render = function render(_ref2) {
    var order = _ref2.order,
        event = _ref2.event,
        ticketsAdditionalQuestions = _ref2.ticketsAdditionalQuestions,
        buyerData = _ref2.buyerData,
        dispatch = _ref2.dispatch,
        ticketId = _ref2.ticketId,
        handleSubmit = _ref2.handleSubmit,
        form = _ref2.form,
        attendeeProfile = _ref2.attendeeProfile,
        openAdditionalQuestions = _ref2.openAdditionalQuestions,
        closeAdditionalQuestions = _ref2.closeAdditionalQuestions,
        token = _ref2.token;
    var additionalQuestionDefault = attendeeProfile.additionalQuestionDefault;

    var _ref3 = additionalQuestionDefault[ticketId] || {
      open: true
    },
        loading = _ref3.loading,
        open = _ref3.open;

    var ticket = order.data.tickets.find(function (t) {
      return t._id === ticketId;
    });
    var changeFieldValue = function changeFieldValue(field, value) {
      dispatch(Object(redux_form_es["c" /* change */])(form, field, value));
    };
    var detailsAdditionQuestions = event.data.additionalQuestions && event.data.additionalQuestions.length ? event.data.additionalQuestions.filter(function (q) {
      var checkIgnore = function checkIgnore(type, question) {
        return q.type == type && q.question === question;
      };
      var shouldBeIgnored = checkIgnore("firstName", "First Name") || checkIgnore("lastName", "Last Name") || checkIgnore("email", "Email");
      return (!q.askAfterCheckout || token) && !shouldBeIgnored;
    }) : [];
    detailsAdditionQuestions = detailsAdditionQuestions.map(function (q) {
      if (q.type === "multiSelect" && q.options && q.options.length) {
        q.options = q.options.map(function (o) {
          var newOption = o.label ? AdditionalQuestions__extends({}, o) : AdditionalQuestions__extends({}, o, {
            id: o._id,
            label: o.value,
            value: false
          });
          return newOption;
        });
      }
      return q;
    });
    var numberOfQuestions = AdditionalQuestions_getTicketQuestions(ticket.ticketTypeId, detailsAdditionQuestions).length;
    if (numberOfQuestions === 0) {
      return null;
    }
    var openAction = open ? closeAdditionalQuestions : openAdditionalQuestions;
    return Object(preact_min["h"])(
      "form",
      {
        onSubmit: handleSubmit(this.saveAdditionalQuestions),
        style: {
          backgroundColor: "#f9f9fa",
          width: "100%",
          padding: "12px 12px 8px 12px"
        }
      },
      Object(preact_min["h"])(
        "div",
        {
          onClick: function onClick() {
            return openAction(ticketId);
          },
          style: { width: "100%", display: "flex", cursor: "pointer" }
        },
        Object(preact_min["h"])(
          "h3",
          {
            style: { marginBottom: 2, flexGrow: 1 }
          },
          "Additional Questions (" + numberOfQuestions + ")"
        ),
        Object(preact_min["h"])("img", {
          src: icon_arrow_down_default.a,
          style: {
            width: 16,
            height: 24,
            marginRight: 16,
            transform: "rotate(" + (open ? 180 : 0) + "deg)"
          }
        })
      ),
      open ? Object(preact_min["h"])(
        "div",
        null,
        loading ? Object(preact_min["h"])("div", {
          "class": "loading loading-lg",
          style: { padding: "0 0 10px 0", marginRight: 10 }
        }) : Object(preact_min["h"])(
          "div",
          null,
          Object(preact_min["h"])(details_TicketsQuestions, {
            tickets: [ticket],
            ticketTypes: event.data.ticketTypes,
            ticketsAdditionalQuestions: ticketsAdditionalQuestions,
            additionalQuestions: detailsAdditionQuestions,
            buyerData: buyerData,
            changeFieldValue: changeFieldValue,
            sameAsBuyerChecks: false,
            hideTitles: true,
            formName: form
          }),
          Object(preact_min["h"])(
            "div",
            { style: { display: "flex", flexDirection: "row-reverse" } },
            AdditionalQuestions__ref4
          )
        )
      ) : null
    );
  };

  return AdditionalQuestions;
}(preact_min["Component"]);

AdditionalQuestions_AdditionalQuestions = Object(redux_form_es["f" /* reduxForm */])({
  destroyOnUnmount: true,
  enableReinitialize: true,
  onSubmitFail: function onSubmitFail(errors) {
    Object(ScrollToErrors["a" /* scrollToErrors */])();
  }
})(AdditionalQuestions_AdditionalQuestions);

AdditionalQuestions_AdditionalQuestions = Object(es["b" /* connect */])(function (state, ownProps) {
  var tickets = getTicketValues(state.order.data, state.event.data.additionalQuestions, false);
  return {
    initialValues: {
      tickets: tickets
    }
  };
})(AdditionalQuestions_AdditionalQuestions);

AdditionalQuestions_AdditionalQuestions = Object(es["b" /* connect */])(function (state, ownProps) {
  var form = ownProps.form;

  var selector = Object(redux_form_es["d" /* formValueSelector */])(form);
  return {
    event: state.event,
    order: state.order,
    seatingMap: state.seatingMap,
    attendeeProfile: state.attendeeProfile,
    buyerData: {
      firstName: state.order.data.firstName,
      lastName: state.order.data.lastName,
      mobile: state.order.data.mobile,
      email: state.order.data.email
    },
    ticketsAdditionalQuestions: selector(state, "tickets")
  };
}, {
  updateAssignedAdditionalQuestions: attendeeProfileActions_updateAssignedAdditionalQuestions,
  openAdditionalQuestions: attendeeProfileActions_openAdditionalQuestions,
  closeAdditionalQuestions: attendeeProfileActions_closeAdditionalQuestions
})(AdditionalQuestions_AdditionalQuestions);

/* harmony default export */ var conferences_AdditionalQuestions = (AdditionalQuestions_AdditionalQuestions);
// CONCATENATED MODULE: ./routes/conferences/TicketList.js
var TicketList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var TicketList_buttonStyle = Object(index_esm["css"])({
  button: {
    color: "#323232 !important",
    borderColor: "#8e99a8 !important",
    fontSize: 14,
    "&:hover": {
      backgroundColor: "white !important",
      border: "solid 1px #8e99a8"
    }
  }
});
var textStyle = Object(index_esm["css"])({
  color: "#5a626c",
  fontSize: 14,
  fontWeight: 600,
  "@media(max-width: 600px)": {
    fontSize: 12
  }
});
var TicketList_TicketList = function TicketList(props) {
  var ticketTypeName = props.ticketTypeName,
      tickets = props.tickets,
      index = props.index;

  var color = Colors[index];
  return Object(preact_min["h"])(
    "div",
    null,
    Object(preact_min["h"])(
      "h4",
      { className: textStyle },
      ticketTypeName + " (" + tickets.length + ")"
    ),
    tickets.map(function (ticket) {
      return Object(preact_min["h"])(TicketList_TicketAssign, TicketList__extends({ color: color, ticket: ticket }, props));
    })
  );
};

var TicketList_TicketAssign = function TicketAssign(_ref) {
  var ticket = _ref.ticket,
      ticketTypeName = _ref.ticketTypeName,
      color = _ref.color,
      assignAttendee = _ref.assignAttendee,
      openModal = _ref.openModal,
      profileLookup = _ref.profileLookup,
      attendeeProfile = _ref.attendeeProfile,
      buyerOrderIdentifier = _ref.buyerOrderIdentifier,
      disableReassigning = _ref.disableReassigning,
      token = _ref.token;
  var profiles = attendeeProfile.profiles,
      assigning = attendeeProfile.assigning;

  var isAssigned = ticket.attendeeProfileId;
  var profile = isAssigned ? profileLookup[ticket.attendeeProfileId] : {};
  var buyerProfile = profiles.find(function (_ref2) {
    var profileIdentifier = _ref2.profileIdentifier;
    return buyerOrderIdentifier === profileIdentifier;
  });
  var options = [{
    label: "Assign to me",
    dataCY: "assign-to-me",
    action: function action() {
      assignAttendee(ticket._id, buyerProfile._id);
    }
  }, {
    label: "Add new attendee",
    dataCY: "add-new-attendee",
    action: function action() {
      openModal({ creatorOrderId: ticket.orderId }, ticket._id);
    }
  }].concat(profiles.map(function (_ref3) {
    var firstName = _ref3.firstName,
        lastName = _ref3.lastName,
        _id = _ref3._id,
        profileIdentifier = _ref3.profileIdentifier;

    if (buyerOrderIdentifier === profileIdentifier) {
      return false;
    } else {
      return {
        label: firstName + " " + lastName,
        action: function action() {
          assignAttendee(ticket._id, _id);
        }
      };
    }
  }).filter(function (prof) {
    return prof;
  }));

  var loading = assigning.loading && assigning.ticketId === ticket._id;

  return Object(preact_min["h"])(
    "div",
    {
      style: {
        display: "flex",
        border: "1px solid #DEDEDE",
        borderRadius: 4,
        alignItems: "center",
        marginBottom: 12,
        flexDirection: "column"
      }
    },
    Object(preact_min["h"])(
      "div",
      { style: { display: "flex", width: "100%", flexDirection: "row" } },
      Object(preact_min["h"])("div", {
        style: {
          minWidth: 12,
          backgroundColor: color,
          borderTopLeftRadius: 4,
          borderBottomLeftRadius: 4,
          marginRight: 8
        }
      }),
      Object(preact_min["h"])(
        "div",
        {
          style: {
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            paddingTop: 9
          }
        },
        Object(preact_min["h"])(
          "h4",
          { style: { marginBottom: 0, wordBreak: "break-word" } },
          ticketTypeName
        ),
        isAssigned && profile ? Object(preact_min["h"])(
          "div",
          { style: { color: "#323232", fontSize: 12 } },
          profile.firstName + " " + profile.lastName
        ) : null
      ),
      !disableReassigning ? Object(preact_min["h"])(
        "div",
        { style: { margin: 12, minWidth: 125 } },
        loading ? Object(preact_min["h"])("div", {
          "class": "loading loading-lg",
          style: { padding: "0 0 10px 0", marginRight: 10 }
        }) : isAssigned ? Object(preact_min["h"])(
          "div",
          { className: TicketList_buttonStyle },
          Object(preact_min["h"])(
            components_Button["a" /* default */],
            {
              onClick: function onClick() {
                openModal(profile, ticket._id, false);
              },
              height: 32
            },
            "Edit Ticket"
          )
        ) : Object(preact_min["h"])(components_ButtonDropDown, {
          dropDownOptions: options,
          buttonLabel: "Assign Ticket",
          buttonProps: { height: 32 },
          dataCY: "assign-ticket"
        })
      ) : null
    ),
    isAssigned && !loading ? Object(preact_min["h"])(conferences_AdditionalQuestions, {
      form: "assignedAdditionalQuestions-" + ticket._id,
      ticketId: ticket._id,
      token: token
    }) : null
  );
};

TicketList_TicketAssign = Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    attendeeProfile: state.attendeeProfile,
    buyerOrderIdentifier: createIdentifier(state.order.data)
  };
}, {
  openModal: attendeeProfileActions_openModal,
  assignAttendee: attendeeProfileActions_assignAttendee,
  updateProfile: attendeeProfileActions_updateProfile
})(TicketList_TicketAssign);

/* harmony default export */ var conferences_TicketList = (TicketList_TicketList);
// EXTERNAL MODULE: ./assets/images/icon-error.svg
var icon_error = __webpack_require__("ZoQM");
var icon_error_default = /*#__PURE__*/__webpack_require__.n(icon_error);

// EXTERNAL MODULE: ./assets/images/icon-info-blue.svg
var icon_info_blue = __webpack_require__("hbJg");
var icon_info_blue_default = /*#__PURE__*/__webpack_require__.n(icon_info_blue);

// EXTERNAL MODULE: ./assets/images/icon-warning.svg
var icon_warning = __webpack_require__("Rq+a");
var icon_warning_default = /*#__PURE__*/__webpack_require__.n(icon_warning);

// CONCATENATED MODULE: ./components/Alert.js
var Alert__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var stylingMap = {
  error: {
    icon: {
      background: "url(" + icon_error_default.a + ")",
      height: 24
    },
    wrapper: {
      background: "#fff8f8",
      border: "solid 1px #c0212c"
    }
  },
  warning: {
    icon: {
      background: "url(" + icon_warning_default.a + ")",
      height: 20
    },
    wrapper: {
      background: "#fff9e1",
      border: "solid 1px #fcae00"
    }
  },
  info: {
    icon: {
      background: "url(" + icon_info_blue_default.a + ")",
      height: 24
    },
    wrapper: {
      background: "#f7faff",
      border: "solid 1px #196097"
    }
  },
  success: {
    icon: {
      background: "url(" + icon_success_default.a + ")",
      height: 24
    },
    wrapper: {
      background: "#e8fcf5",
      border: "solid 1px #157e77"
    }
  }
};

var Alert_Alert = function Alert(_ref) {
  var children = _ref.children,
      style = _ref.style;
  var _stylingMap$style = stylingMap[style],
      icon = _stylingMap$style.icon,
      wrapper = _stylingMap$style.wrapper;

  var warningImageStyling = Alert__extends({
    marginRight: 8,
    minWidth: 24
  }, icon, {
    backgroundRepeat: "no-repeat",
    alignItems: "center"
  });
  return Object(preact_min["h"])(
    "div",
    {
      style: Alert__extends({
        borderRadius: "4px",
        padding: "12px 16px",
        display: "flex"
      }, wrapper, {
        alignItems: "center"
      })
    },
    Object(preact_min["h"])("div", { style: warningImageStyling }),
    Object(preact_min["h"])(
      "div",
      { style: { flexGrow: "1" } },
      children
    )
  );
};

/* harmony default export */ var components_Alert = (Alert_Alert);
// CONCATENATED MODULE: ./routes/conferences/AssignTickets.js
var AssignTickets__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function AssignTickets__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AssignTickets__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AssignTickets__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




























var assignedTicketSummaryStyle = Object(index_esm["css"])({
  display: "none",
  "@media (max-width:600px)": {
    display: "inherit",
    boxShadow: "0 1px 8px 0 rgba(9, 30, 66, 0.13)",
    padding: "1px 0px 0px 0px"
  }
});

var desktopTimerStyle = Object(index_esm["css"])({
  display: "inherit",
  "@media (max-width:600px)": {
    display: "none"
  }
});

var manualOrderStyle = Object(index_esm["css"])({
  ".columns.two-cols": {
    margin: 0
  }
});

var AssignTickets_formName = "assign";

var AssignTickets__ref2 = Object(preact_min["h"])(
  Page["a" /* default */],
  null,
  Object(preact_min["h"])(WarningMessage["a" /* default */], { title: "Order could not be loaded" })
);

var AssignTickets__ref3 = Object(preact_min["h"])(
  Page["a" /* default */],
  null,
  Object(preact_min["h"])(WarningMessage["a" /* default */], { title: "Order has been completed" })
);

var AssignTickets__ref4 = Object(preact_min["h"])(CountDown["a" /* default */], { margin: "0px 0px 24px 0px" });

var AssignTickets__ref5 = Object(preact_min["h"])(
  "div",
  { className: desktopTimerStyle },
  " ",
  Object(preact_min["h"])(CountDown["a" /* default */], { margin: "0px 0px 24px 0px" })
);

var AssignTickets_AssignTickets = function (_Component) {
  AssignTickets__inherits(AssignTickets, _Component);

  function AssignTickets() {
    var _temp, _this, _ret;

    AssignTickets__classCallCheck(this, AssignTickets);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = AssignTickets__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidMount = function () {
      var _this$props = _this.props,
          event = _this$props.event,
          eventSlug = _this$props.eventSlug,
          orderId = _this$props.orderId,
          getEvent = _this$props.getEvent,
          attendeeProfile = _this$props.attendeeProfile,
          getAssignedProfiles = _this$props.getAssignedProfiles;

      if (!event.data && !event.loading) {
        getEvent(eventSlug, undefined, false, orderId, true);
      }
      if (attendeeProfile.profiles.length === 0 && !attendeeProfile.loading) {
        getAssignedProfiles(orderId);
      }
      Object(BrowserUtils["b" /* updateTitle */])("Assign Tickets", event);
    }, _this.save = function () {
      var _this$props2 = _this.props,
          order = _this$props2.order,
          event = _this$props2.event,
          finishAssigning = _this$props2.finishAssigning,
          seatingMap = _this$props2.seatingMap;

      var seatingMapRequired = seatingMap.seatingMapRequired;
      finishAssigning(event.data.slug, event.data, order.data, seatingMapRequired);
    }, _this.componentDidUpdate = function () {
      var _this$props3 = _this.props,
          event = _this$props3.event,
          order = _this$props3.order,
          seatingMap = _this$props3.seatingMap;

      if (event.data && order.data && !seatingMap.seatingMapEvaluated) {
        _this.determineSeatingMap(event.data, order.data);
      }
    }, _this.determineSeatingMap = function (eventData, orderData) {
      var setSeatingMapRequired = _this.props.setSeatingMapRequired;

      var seatingMapId = findApplicableSeatingMapId(eventData, orderData);
      setSeatingMapRequired(seatingMapId);
    }, _this.getForm = function (ticketsGroupedByType, ticketsGroupedByAttendeeProfile) {
      var _this$props4 = _this.props,
          seatingMap = _this$props4.seatingMap,
          additionalQuestionsPreview = _this$props4.additionalQuestionsPreview,
          attendeeProfile = _this$props4.attendeeProfile;
      var profiles = attendeeProfile.profiles,
          loading = attendeeProfile.loading,
          token = attendeeProfile.token;

      var profileLookup = profiles.reduce(function (map, profile) {
        map[profile._id] = profile;
        return map;
      }, {});

      var detailsProps = {
        saveDetails: _this.save,
        seatingMapAvailable: seatingMap.seatingMapRequired,
        additionalQuestionsPreview: additionalQuestionsPreview,
        ticketsGroupedByType: ticketsGroupedByType,
        profileLookup: profileLookup,
        profiles: profiles,
        ticketsGroupedByAttendeeProfile: ticketsGroupedByAttendeeProfile,
        loading: loading,
        token: token
      };
      return Object(preact_min["h"])(AssignTickets_DetailsForm, detailsProps);
    }, _temp), AssignTickets__possibleConstructorReturn(_this, _ret);
  }

  AssignTickets.prototype.render = function render(_ref) {
    var event = _ref.event,
        order = _ref.order,
        seatingMap = _ref.seatingMap,
        isGlobal = _ref.isGlobal,
        attendeeProfile = _ref.attendeeProfile;
    var token = attendeeProfile.token;
    var attendeeModal = attendeeProfile.attendeeModal;

    if (order && order.orderGet.error) {
      return AssignTickets__ref2;
    }
    if ((event.loading || !event.data || !order.data) && !attendeeModal.show) {
      return;
    }
    if (order && order.data.status === "complete" && !token) {
      return AssignTickets__ref3;
    }
    var ticketsGroupedByType = Object.values(order.data.tickets.reduce(function (map, ticket) {
      if (!map[ticket.ticketTypeId]) {
        map[ticket.ticketTypeId] = {
          tickets: [],
          ticketTypeName: ticket.ticketTypeName
        };
      }
      map[ticket.ticketTypeId].tickets.push(ticket);
      return map;
    }, {}));
    var ticketsGroupedByAttendeeProfile = order.data.tickets.reduce(function (map, ticket) {
      if (!ticket.attendeeProfileId) {
        map["unassigned"].push(ticket);
      } else {
        if (!map[ticket.attendeeProfileId]) {
          map[ticket.attendeeProfileId] = [];
        }
        map[ticket.attendeeProfileId].push(ticket);
      }
      return map;
    }, { unassigned: [] });

    var body = Object(preact_min["h"])(
      "div",
      { className: token ? manualOrderStyle : false },
      Object(preact_min["h"])(
        "div",
        { className: assignedTicketSummaryStyle },
        !token ? AssignTickets__ref4 : null,
        Object(preact_min["h"])(AssignSummary, { ticketsGroupedByType: ticketsGroupedByType })
      ),
      Object(preact_min["h"])(
        TwoCols["a" /* default */],
        null,
        Object(preact_min["h"])(
          "div",
          null,
          !token ? AssignTickets__ref5 : null,
          this.getForm(ticketsGroupedByType, ticketsGroupedByAttendeeProfile)
        ),
        Object(preact_min["h"])(HybridSummary_HybridSummary, {
          token: token,
          ticketsGroupedByType: ticketsGroupedByType
        })
      )
    );
    if (token) {
      return body;
    }
    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        Page["a" /* default */],
        { isGlobal: isGlobal },
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])(BookingHeader["a" /* default */], {
            event: event,
            orderId: order.data._id,
            includeSeatingMap: seatingMap.seatingMapRequired,
            isGlobal: isGlobal
          }),
          body
        )
      )
    );
  };

  return AssignTickets;
}(preact_min["Component"]);

var AssignTickets__ref7 = Object(preact_min["h"])(
  "h2",
  { "class": "sub-header" },
  "Please assign your tickets"
);

var AssignTickets__ref8 = Object(preact_min["h"])(conferences_ExistingProfileModal, null);

var AssignTickets_DetailsForm = function DetailsForm(_ref6) {
  var event = _ref6.event,
      order = _ref6.order,
      handleSubmit = _ref6.handleSubmit,
      saveDetails = _ref6.saveDetails,
      seatingMapAvailable = _ref6.seatingMapAvailable,
      loading = _ref6.loading,
      isGlobal = _ref6.isGlobal,
      ticketsGroupedByType = _ref6.ticketsGroupedByType,
      profileLookup = _ref6.profileLookup,
      profiles = _ref6.profiles,
      ticketsGroupedByAttendeeProfile = _ref6.ticketsGroupedByAttendeeProfile,
      token = _ref6.token;

  var assignLaterText = "If you don\u2019t yet know who your guests are then you can do this at a later date via your order confirmation email.";

  var detailsAdditionQuestions = !isGlobal && event.data.additionalQuestions && event.data.additionalQuestions.length ? event.data.additionalQuestions.filter(function (q) {
    return !q.askAfterCheckout;
  }) : [];
  detailsAdditionQuestions = detailsAdditionQuestions.map(function (q) {
    if (q.type === "multiSelect" && q.options && q.options.length) {
      q.options = q.options.map(function (o) {
        var newOption = o.label ? AssignTickets__extends({}, o) : AssignTickets__extends({}, o, {
          id: o._id,
          label: o.value,
          value: false
        });
        return newOption;
      });
    }
    return q;
  });
  var btnText = seatingMapAvailable ? "Select Seats" : "Save & Checkout";
  return Object(preact_min["h"])(
    "div",
    null,
    !token ? Object(preact_min["h"])(
      "div",
      { style: { marginBottom: 24 } },
      AssignTickets__ref7,
      Object(preact_min["h"])(
        components_Alert,
        { style: "info" },
        Object(preact_min["h"])(
          "p",
          { style: { margin: 0 } },
          "If you don\u2019t know who your guests are, you can",
          " ",
          Object(preact_min["h"])(AssignTickets_AssignLaterLink, { saveDetails: saveDetails })
        )
      )
    ) : null,
    Object(preact_min["h"])(
      "h2",
      { "class": "sub-header", style: { fontWeight: 600 } },
      "Your Tickets"
    ),
    Object(preact_min["h"])(conferences_ProfileModal, { profileLookup: ticketsGroupedByAttendeeProfile }),
    AssignTickets__ref8,
    Object(preact_min["h"])(
      "form",
      { onSubmit: handleSubmit(saveDetails) },
      ticketsGroupedByType.map(function (ticketTypes, i) {
        return Object(preact_min["h"])(conferences_TicketList, AssignTickets__extends({
          profileLookup: profileLookup,
          profiles: profiles
        }, ticketTypes, {
          index: i,
          ticketsGroupedByAttendeeProfile: ticketsGroupedByAttendeeProfile,
          token: token
        }));
      }),
      !token ? Object(preact_min["h"])(
        ActionBar["a" /* default */],
        null,
        Object(preact_min["h"])(
          ActionButton["a" /* default */],
          {
            disabled: order.timeExpired,
            loading: loading || order.loading,
            dataCY: "checkout"
          },
          btnText
        )
      ) : null
    )
  );
};

var AssignTickets_AssignLaterLink = function AssignLaterLink(_ref9) {
  var handleSubmit = _ref9.handleSubmit,
      saveDetails = _ref9.saveDetails;

  return Object(preact_min["h"])(
    "a",
    {
      style: { cursor: "pointer" },
      "data-cy": "assign-later",
      onClick: handleSubmit(saveDetails)
    },
    "Assign tickets later."
  );
};

AssignTickets_AssignLaterLink = Object(redux_form_es["f" /* reduxForm */])({
  form: AssignTickets_formName
})(AssignTickets_AssignLaterLink);

AssignTickets_DetailsForm = Object(redux_form_es["f" /* reduxForm */])({
  form: AssignTickets_formName,
  destroyOnUnmount: false,
  onSubmitFail: function onSubmitFail(errors) {
    Object(ScrollToErrors["a" /* scrollToErrors */])();
  }
})(AssignTickets_DetailsForm);

var AssignTickets_selector = Object(redux_form_es["d" /* formValueSelector */])(AssignTickets_formName);

AssignTickets_DetailsForm = Object(es["b" /* connect */])(function (state, ownProps) {
  var tickets = getTicketValues(state.order.data, state.event.data.additionalQuestions, AssignTickets_selector(state, "tickets"));
  var initialValues = {
    tickets: tickets
  };
  return {
    initialValues: initialValues,
    event: state.event,
    order: state.order
  };
}, {})(AssignTickets_DetailsForm);

/* harmony default export */ var conferences_AssignTickets = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order,
    attendeeProfile: state.attendeeProfile,
    seatingMap: state.seatingMap
  };
}, {
  getEvent: eventActions["u" /* getEvent */],
  getOrder: orderActions["Q" /* getOrder */],
  setSeatingMapRequired: seatingMapActions["q" /* setSeatingMapRequired */],
  getAssignedProfiles: attendeeProfileActions_getAssignedProfiles,
  finishAssigning: attendeeProfileActions_finishAssigning
})(AssignTickets_AssignTickets));
// EXTERNAL MODULE: ./assets/images/icon-amex.svg
var icon_amex = __webpack_require__("WAMM");
var icon_amex_default = /*#__PURE__*/__webpack_require__.n(icon_amex);

// EXTERNAL MODULE: ./assets/images/icon-visa.svg
var icon_visa = __webpack_require__("V/Md");
var icon_visa_default = /*#__PURE__*/__webpack_require__.n(icon_visa);

// EXTERNAL MODULE: ./assets/images/icon-mastercard.svg
var icon_mastercard = __webpack_require__("d61K");
var icon_mastercard_default = /*#__PURE__*/__webpack_require__.n(icon_mastercard);

// EXTERNAL MODULE: ./assets/images/icon-zip.png
var icon_zip = __webpack_require__("Ffi5");
var icon_zip_default = /*#__PURE__*/__webpack_require__.n(icon_zip);

// CONCATENATED MODULE: ./components/CardLogos.js










var iconStyle = Object(index_esm["css"])({
  width: 35,
  height: 25,
  marginRight: 6,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  display: "inline-block"
});

var CardLogos_CardLogos = function CardLogos(_ref) {
  var event = _ref.event,
      isGlobal = _ref.isGlobal;

  var paymentIconsStyle = {
    paddingTop: 18
  };

  var paymentIcons = [{ icon: icon_amex_default.a, name: "American Express" }, { icon: icon_visa_default.a, name: "Visa" }, { icon: icon_mastercard_default.a, name: "MasterCard" }];

  if (!isGlobal && event.data.paymentOptions.zipMoneyEnabled) {
    paymentIcons.push({ icon: icon_zip_default.a, name: "Zip Money" });
  }

  return Object(preact_min["h"])(
    "div",
    { style: paymentIconsStyle },
    paymentIcons.map(function (icon, index) {
      return Object(preact_min["h"])(Image["a" /* default */], {
        src: icon.icon,
        className: iconStyle,
        alt: icon.name + " logo"
      });
    })
  );
};

//<div key={index} style={style}/>
/* harmony default export */ var components_CardLogos = (CardLogos_CardLogos);
// EXTERNAL MODULE: ./assets/images/icon-zip2.png
var icon_zip2 = __webpack_require__("5TyI");
var icon_zip2_default = /*#__PURE__*/__webpack_require__.n(icon_zip2);

// CONCATENATED MODULE: ./routes/payment/ZipMoney.js


function ZipMoney__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ZipMoney__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ZipMoney__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var zipImageStyling = Object(index_esm["css"])({
  margin: "-6px 6px 0 12px",
  height: 34
});

var ZipMoney__ref = Object(preact_min["h"])(
  components_Note,
  null,
  "zipPay can only be used for orders under $1500"
);

var ZipMoney__ref2 = Object(preact_min["h"])(
  "label",
  { "for": "form-label", "class": "form-label" },
  "Or Pay with zipPay"
);

var ZipMoney__ref3 = Object(preact_min["h"])(Image["a" /* default */], { className: zipImageStyling, alt: "Zip", src: icon_zip2_default.a });

var ZipMoney_ZipMoney = function (_Component) {
  ZipMoney__inherits(ZipMoney, _Component);

  function ZipMoney() {
    ZipMoney__classCallCheck(this, ZipMoney);

    var _this = ZipMoney__possibleConstructorReturn(this, _Component.call(this));

    _this.checkout = _this.checkout.bind(_this);
    return _this;
  }

  ZipMoney.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        zipMoney = _props.zipMoney,
        loadScripts = _props.loadScripts;

    if (!zipMoney.scripts.loaded && !zipMoney.scripts.loading) {
      loadScripts();
    }
  };

  ZipMoney.prototype.checkout = function checkout() {
    var _props2 = this.props,
        checkout = _props2.checkout,
        order = _props2.order,
        event = _props2.event,
        payClicked = _props2.payClicked;

    var orderId = order.data._id;
    payClicked();
    checkout(event.data.slug, orderId);
  };

  ZipMoney.prototype.render = function render() {
    var _this2 = this;

    var _props3 = this.props,
        zipMoney = _props3.zipMoney,
        order = _props3.order,
        orderSummary = _props3.orderSummary,
        event = _props3.event;

    var WEBSITE_URL = Object(config["a" /* default */])("WEBSITE_URL");
    var styles = {
      display: "flex",
      padding: "0px"
    };
    // Remove ZIP pay temporarily while we await a fix
    if (!event || !event.data || !event.data.paymentOptions.zipMoneyEnabled) {
      return null;
    }

    if (orderSummary && orderSummary.data && orderSummary.data.total > 1500) {
      return ZipMoney__ref;
    }

    var loading = !zipMoney.scripts.loaded && zipMoney.scripts.loading || zipMoney.checkout.loading || order.paymentRequest.loading || order.waitingToPay ? true : false;

    return Object(preact_min["h"])(
      "div",
      { "class": "form-group" },
      ZipMoney__ref2,
      Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "button",
          {
            type: "button",
            className: "btn btn-simple",
            id: "zip-checkout",
            disabled: loading || order.timeExpired,
            onClick: function onClick() {
              if (loading) {
                return;
              }
              _this2.checkout();
            },
            "aria-label": "Checkout"
          },
          Object(preact_min["h"])(
            "div",
            { style: styles },
            ZipMoney__ref3,
            Object(preact_min["h"])(
              "span",
              {
                style: {
                  padding: "0 12px 0px 6px",
                  borderLeft: "1px solid #e7e7e7"
                }
              },
              loading ? Object(preact_min["h"])("div", {
                "class": "loading",
                style: {
                  margin: "2px 0 0 12px"
                }
              }) : "Own it now, pay later"
            )
          )
        )
      ),
      Object(preact_min["h"])(
        "a",
        {
          href: WEBSITE_URL + "/zipmoney",
          style: { fontSize: 14 },
          target: "_blank"
        },
        "Learn More"
      )
    );
  };

  return ZipMoney;
}(preact_min["Component"]);

/* harmony default export */ var payment_ZipMoney = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order,
    zipMoney: state.zipMoney,
    orderSummary: state.orderSummary,
    seatingMap: state.seatingMap
  };
}, {
  loadScripts: zipMoneyActions_loadScripts,
  checkout: zipMoneyActions_checkout,
  payClicked: orderActions["W" /* payClicked */]
})(ZipMoney_ZipMoney));
// CONCATENATED MODULE: ./routes/payment/PaymentBPoint.js
var PaymentBPoint__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function PaymentBPoint__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PaymentBPoint__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PaymentBPoint__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// the npm react-credit-card-input has errors with preact








var PaymentBPoint_nextStageButton = Object(index_esm["css"])({ height: "40px !important", minWidth: 150 });

var PaymentBPoint_PaymentIframe = function (_Component) {
  PaymentBPoint__inherits(PaymentIframe, _Component);

  function PaymentIframe() {
    PaymentBPoint__classCallCheck(this, PaymentIframe);

    return PaymentBPoint__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  PaymentIframe.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var authKey = this.props.authKey;

    return authKey !== nextProps.authKey;
  };

  PaymentIframe.prototype.render = function render(_ref) {
    var authKey = _ref.authKey,
        paymentFormLoaded = _ref.paymentFormLoaded;

    var BPOINT_API_URL = Object(config["a" /* default */])("BPOINT_API_URL");
    return Object(preact_min["h"])("iframe", {
      id: "payment-iframe",
      src: BPOINT_API_URL + "dvtokens/iframe/add/" + authKey,
      frameborder: "0",
      title: "payment details",
      lang: "en",
      height: "180px",
      width: "100%",
      "overflow-y": "hidden",
      "overflow-x": "hidden",
      onload: function onload() {
        return paymentFormLoaded();
      }
    });
  };

  return PaymentIframe;
}(preact_min["Component"]);

var PaymentBPoint_PaymentBPointWrapper = function (_Component2) {
  PaymentBPoint__inherits(PaymentBPointWrapper, _Component2);

  function PaymentBPointWrapper() {
    var _temp, _this2, _ret;

    PaymentBPoint__classCallCheck(this, PaymentBPointWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = PaymentBPoint__possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.makeEventPayment = function (authKey) {
      var _this2$props = _this2.props,
          event = _this2$props.event,
          order = _this2$props.order,
          orderId = _this2$props.orderId,
          slug = _this2$props.slug,
          pay = _this2$props.pay,
          payClicked = _this2$props.payClicked;

      var eventId = event.data._id;
      payClicked();
      setTimeout(function () {
        pay(slug, orderId, "bpoint", { authKey: authKey }, eventId);
      }, 1000);
    }, _this2.makeGlobalPayment = function (authKey) {
      var _this2$props2 = _this2.props,
          order = _this2$props2.order,
          orderId = _this2$props2.orderId,
          slug = _this2$props2.slug,
          pay = _this2$props2.pay,
          payClicked = _this2$props2.payClicked;

      payClicked();
      setTimeout(function () {
        pay(slug, orderId, "bpoint", { authKey: authKey }, order.userId, true);
      }, 1000);
    }, _temp), PaymentBPoint__possibleConstructorReturn(_this2, _ret);
  }

  PaymentBPointWrapper.prototype.render = function render() {
    var isGlobal = this.props.isGlobal;

    if (isGlobal) {
      return Object(preact_min["h"])(PaymentBPoint_PaymentBPoint, PaymentBPoint__extends({}, this.props, { makePayment: this.makeGlobalPayment }));
    } else {
      return Object(preact_min["h"])(PaymentBPoint_PaymentBPoint, PaymentBPoint__extends({}, this.props, { makePayment: this.makeEventPayment }));
    }
  };

  return PaymentBPointWrapper;
}(preact_min["Component"]);

var PaymentBPoint__ref3 = Object(preact_min["h"])(
  "p",
  null,
  "All transactions are secure and encrypted. Payment information is never stored."
);

var PaymentBPoint__ref4 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var PaymentBPoint__ref5 = Object(preact_min["h"])(payment_ZipMoney, null);

var PaymentBPoint_PaymentBPoint = function (_Component3) {
  PaymentBPoint__inherits(PaymentBPoint, _Component3);

  function PaymentBPoint() {
    PaymentBPoint__classCallCheck(this, PaymentBPoint);

    var _this3 = PaymentBPoint__possibleConstructorReturn(this, _Component3.call(this));

    _this3.paymentFormLoaded = _this3.paymentFormLoaded.bind(_this3);
    _this3.state = {
      formLoaded: false
    };
    return _this3;
  }

  PaymentBPoint.prototype.paymentFormLoaded = function paymentFormLoaded() {
    this.setState({ formLoaded: true });
  };

  PaymentBPoint.prototype.render = function render(_ref2) {
    var event = _ref2.event,
        order = _ref2.order,
        makePayment = _ref2.makePayment,
        isGlobal = _ref2.isGlobal;
    var formLoaded = this.state.formLoaded;


    if (order.paymentRequest.error) {
      window.scrollTo(0, 0);
    }
    var error = order.paymentRequest.error;
    var loading = order.paymentRequest.loading;
    // get the latest payment auth key
    var authKey = order.data && order.data.paymentAuth ? order.data.paymentAuth[order.data.paymentAuth.length - 1] : null;
    var orderId = order.data ? order.data._id : null;
    return Object(preact_min["h"])(
      "div",
      null,
      PaymentBPoint__ref3,
      !isGlobal && event.data.amexFee && event.data.amexFee > 0 ? Object(preact_min["h"])(
        components_Note,
        null,
        "American Express Surcharge Fee ",
        event.data.amexFee,
        "% "
      ) : null,
      error ? Object(preact_min["h"])(
        "p",
        { "class": "text-error" },
        error
      ) : "",
      !formLoaded && !loading ? PaymentBPoint__ref4 : "",
      Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(PaymentBPoint_PaymentIframe, {
          authKey: authKey,
          paymentFormLoaded: this.paymentFormLoaded
        }),
        PaymentBPoint__ref5,
        Object(preact_min["h"])(
          ActionBar["a" /* default */],
          null,
          Object(preact_min["h"])(
            ActionButton["a" /* default */],
            {
              onClick: function onClick() {
                return makePayment(authKey);
              },
              disabled: order.waitingToPay || order.paymentRequest.loading || order.timeExpired,
              dataCY: "paynow",
              loading: order.waitingToPay || order.paymentRequest.loading,
              classNames: PaymentBPoint_nextStageButton
            },
            "Pay Now"
          ),
          Object(preact_min["h"])(components_CardLogos, { event: event, isGlobal: isGlobal })
        )
      )
    );
  };

  return PaymentBPoint;
}(preact_min["Component"]);

/* harmony default export */ var payment_PaymentBPoint = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order,
    giftCards: state.giftCards
  };
}, { payClicked: orderActions["W" /* payClicked */], pay: orderActions["T" /* pay */] })(PaymentBPoint_PaymentBPointWrapper));
// CONCATENATED MODULE: ./services/PayPalService.js



var PayPalService = {
  create: function create(orderId) {
    return new Promise(function (resolve, reject) {
      axios_default.a.put(Object(config["a" /* default */])('API_URL') + 'paypal/create', {
        orderId: orderId
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};

/* harmony default export */ var services_PayPalService = (PayPalService);
// CONCATENATED MODULE: ./routes/payment/PaymentPayPal.js


function PaymentPayPal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PaymentPayPal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PaymentPayPal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var PaymentPayPal__ref2 = Object(preact_min["h"])(
  "p",
  null,
  "All transactions are secure and encrypted. Payment information is never stored."
);

var PaymentPayPal__ref3 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var PaymentPayPal__ref4 = Object(preact_min["h"])(payment_ZipMoney, null);

var PaymentPayPal__ref5 = Object(preact_min["h"])("div", { id: "paypal-button-container" });

var PaymentPayPal_PaymentPayPal = function (_Component) {
  PaymentPayPal__inherits(PaymentPayPal, _Component);

  function PaymentPayPal() {
    PaymentPayPal__classCallCheck(this, PaymentPayPal);

    return PaymentPayPal__possibleConstructorReturn(this, _Component.call(this));
  }

  PaymentPayPal.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        event = _props.event,
        payPal = _props.payPal,
        loadCheckOutScript = _props.loadCheckOutScript,
        payClicked = _props.payClicked,
        pay = _props.pay,
        slug = _props.slug,
        orderId = _props.orderId;


    var parsed = query_string_default.a.parse(window.location.search);
    if (parsed.token && parsed.PayerID) {
      payClicked();
      // Set up the data you need to pass to your server
      var data = {
        orderId: parsed.token,
        payerId: parsed.PayerID
      };
      var eventId = event.data._id;
      // Make a call to your server to execute the payment
      pay(slug, orderId, "paypal", { orderId: data.orderId }, eventId);
      return;
    }

    if (!payPal.checkoutScript.loaded && !payPal.checkoutScript.loading) {
      loadCheckOutScript();
    } else {
      this.addPayPalBtn();
    }
  };

  PaymentPayPal.prototype.addPayPalBtn = function addPayPalBtn() {
    var _props2 = this.props,
        event = _props2.event,
        slug = _props2.slug,
        orderId = _props2.orderId,
        order = _props2.order,
        payPal = _props2.payPal,
        pay = _props2.pay,
        payClicked = _props2.payClicked;

    var eventId = event.data._id;

    window.paypal.Button.render({
      env: Object(config["a" /* default */])("PAYPAL_ENV"),
      commit: true,
      style: {
        label: "pay",
        size: "responsive", // small | medium | large | responsive
        shape: "rect", // pill | rect
        color: "blue" // gold | blue | silver | black
      },
      // payment() is called when the button is clicked
      payment: function payment() {
        // Set up the payment
        return services_PayPalService.create(orderId).then(function (data) {
          return data.id;
        }).catch(function (err) {
          console.error("err", err);
        });
      },
      // onAuthorize() is called when the buyer approves the payment
      onAuthorize: function onAuthorize(data, actions) {
        if (order.timeExpired) {
          return;
        }
        payClicked();
        // Set up the data you need to pass to your server
        var data = {
          orderId: data.paymentToken,
          payerId: data.payerID
        };
        // Make a call to your server to execute the payment
        pay(slug, orderId, "paypal", { orderId: data.orderId }, eventId);
      }
    }, "#paypal-button-container");
  };

  PaymentPayPal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props3 = this.props,
        orderId = _props3.orderId,
        payPal = _props3.payPal,
        loadCheckOutScript = _props3.loadCheckOutScript;

    if (!prevProps.payPal.checkoutScript.loaded && payPal.checkoutScript.loaded) {
      this.addPayPalBtn();
    }
  };

  PaymentPayPal.prototype.render = function render(_ref) {
    var order = _ref.order,
        payPal = _ref.payPal;

    return Object(preact_min["h"])(
      "div",
      null,
      PaymentPayPal__ref2,
      !payPal.checkoutScript.loaded || payPal.checkoutScript.loading || order.waitingToPay || order.paymentRequest.loading ? PaymentPayPal__ref3 : !order.timeExpired ? Object(preact_min["h"])(
        "div",
        null,
        PaymentPayPal__ref4,
        Object(preact_min["h"])(
          ActionBar["a" /* default */],
          null,
          Object(preact_min["h"])(
            "div",
            {
              style: {
                paddingTop: 12
              }
            },
            PaymentPayPal__ref5
          )
        )
      ) : null
    );
  };

  return PaymentPayPal;
}(preact_min["Component"]);

/* harmony default export */ var payment_PaymentPayPal = (Object(es["b" /* connect */])(function (state) {
  return { event: state.event, order: state.order, payPal: state.payPal };
}, { loadCheckOutScript: payPalActions_loadCheckOutScript, pay: orderActions["T" /* pay */], payClicked: orderActions["W" /* payClicked */] })(PaymentPayPal_PaymentPayPal));
// CONCATENATED MODULE: ./routes/payment/PaymentInvoice.js


function PaymentInvoice__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PaymentInvoice__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PaymentInvoice__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var PaymentInvoice__ref2 = Object(preact_min["h"])(
  "p",
  null,
  "Upon purchase you will be sent an invoice with payment instructions. Once payment is received your tickets and receipt will be sent over to you."
);

var PaymentInvoice__ref3 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "Business Name",
  type: "text",
  name: "organisation",
  component: InputField["a" /* default */]
});

var PaymentInvoice__ref4 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "ABN",
  type: "text",
  name: "businessTaxId",
  component: InputField["a" /* default */]
});

var PaymentInvoice__ref5 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "First Name",
  type: "text",
  name: "firstName",
  component: InputField["a" /* default */],
  required: true,
  validate: Validators["b" /* required */],
  autocomplete: "given-name"
});

var PaymentInvoice__ref6 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "Last Name",
  type: "text",
  name: "lastName",
  component: InputField["a" /* default */],
  required: true,
  validate: Validators["b" /* required */],
  autocomplete: "family-name"
});

var PaymentInvoice__ref7 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "Address",
  type: "text",
  name: "address",
  component: TextareaField["a" /* default */],
  required: true,
  validate: Validators["b" /* required */],
  autocomplete: "address"
});

var PaymentInvoice_PaymentInvoice = function (_Component) {
  PaymentInvoice__inherits(PaymentInvoice, _Component);

  function PaymentInvoice() {
    PaymentInvoice__classCallCheck(this, PaymentInvoice);

    var _this = PaymentInvoice__possibleConstructorReturn(this, _Component.call(this));

    _this.purchase = _this.purchase.bind(_this);
    return _this;
  }

  PaymentInvoice.prototype.purchase = function purchase(values) {
    var _props = this.props,
        slug = _props.slug,
        order = _props.order,
        pay = _props.pay,
        payClicked = _props.payClicked,
        event = _props.event;

    var orderId = order.data._id;
    var eventId = event.data._id;
    payClicked();
    pay(slug, orderId, "invoice", values, eventId);
  };

  PaymentInvoice.prototype.render = function render(_ref) {
    var order = _ref.order,
        handleSubmit = _ref.handleSubmit;

    if (order.paymentRequest.error) {
      window.scrollTo(0, 0);
    }
    var error = order.paymentRequest.error;
    var businessPurpose = order && order.data && order.data.businessPurpose ? order.data.businessPurpose : false;

    return Object(preact_min["h"])(
      "div",
      null,
      error ? Object(preact_min["h"])(
        "p",
        { "class": "text-error" },
        error
      ) : "",
      !order.timeExpired ? Object(preact_min["h"])(
        "form",
        { onSubmit: handleSubmit(this.purchase) },
        PaymentInvoice__ref2,
        PaymentInvoice__ref3,
        businessPurpose ? PaymentInvoice__ref4 : null,
        PaymentInvoice__ref5,
        PaymentInvoice__ref6,
        PaymentInvoice__ref7,
        Object(preact_min["h"])(
          ActionBar["a" /* default */],
          null,
          Object(preact_min["h"])(
            ActionButton["a" /* default */],
            {
              disabled: order.waitingToPay || order.paymentRequest.loading || order.timeExpired,
              loading: order.waitingToPay || order.paymentRequest.loading
            },
            "Purchase"
          )
        )
      ) : null
    );
  };

  return PaymentInvoice;
}(preact_min["Component"]);

PaymentInvoice_PaymentInvoice = Object(redux_form_es["f" /* reduxForm */])({
  form: "invoice",
  destroyOnUnmount: false,
  onSubmitFail: function onSubmitFail() {
    Object(ScrollToErrors["a" /* scrollToErrors */])();
  }
})(PaymentInvoice_PaymentInvoice);

/* harmony default export */ var payment_PaymentInvoice = (Object(es["b" /* connect */])(function (state) {
  return {
    initialValues: {
      firstName: state.order.data.firstName,
      lastName: state.order.data.lastName,
      organisation: state.order.data.businessName,
      businessTaxId: state.order.data.businessTaxId
    },
    event: state.event,
    order: state.order,
    orderSummary: state.orderSummary
  };
}, {
  pay: orderActions["T" /* pay */],
  payClicked: orderActions["W" /* payClicked */]
})(PaymentInvoice_PaymentInvoice));
// CONCATENATED MODULE: ./routes/payment/PaymentStripe.js


function PaymentStripe__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PaymentStripe__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PaymentStripe__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var PaymentStripe_nextStageButton = Object(index_esm["css"])({ height: "40px !important", minWidth: 150 });

var PaymentStripe__ref2 = Object(preact_min["h"])(
  "p",
  null,
  "All transactions are secure and encrypted. Payment information is never stored."
);

var PaymentStripe__ref3 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var PaymentStripe__ref4 = Object(preact_min["h"])(
  "label",
  { "class": "form-label", "for": "form-label" },
  "Credit or debit card"
);

var PaymentStripe__ref5 = Object(preact_min["h"])("div", { id: "card-element" });

var PaymentStripe__ref6 = Object(preact_min["h"])("div", { id: "card-errors", role: "alert" });

var PaymentStripe__ref7 = Object(preact_min["h"])(payment_ZipMoney, null);

var PaymentStripe_PaymentStripe = function (_Component) {
  PaymentStripe__inherits(PaymentStripe, _Component);

  function PaymentStripe() {
    PaymentStripe__classCallCheck(this, PaymentStripe);

    var _this = PaymentStripe__possibleConstructorReturn(this, _Component.call(this));

    _this.initCheckout = _this.initCheckout.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.stripe = null;
    _this.card = null;
    return _this;
  }

  PaymentStripe.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        stripe = _props.stripe,
        loadCheckOutScript = _props.loadCheckOutScript;

    if (!stripe.checkoutScript.loaded && !stripe.checkoutScript.loading) {
      loadCheckOutScript();
    } else {
      this.initCheckout();
    }
  };

  PaymentStripe.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props2 = this.props,
        orderId = _props2.orderId,
        stripe = _props2.stripe,
        loadCheckOutScript = _props2.loadCheckOutScript;

    if (!prevProps.stripe.checkoutScript.loaded && stripe.checkoutScript.loaded) {
      this.initCheckout();
    }
  };

  PaymentStripe.prototype.initCheckout = function initCheckout() {
    var gateway = this.props.gateway;
    // Create a Stripe client.

    this.stripe = gateway === "stripe" ? Stripe(Object(config["a" /* default */])("STRIPE_APK_KEY")) : Stripe(Object(config["a" /* default */])("STRIPE_PAYMENTS_APK_KEY"));
    // Create an instance of Elements.
    var elements = this.stripe.elements();
    // Custom styling
    var style = {
      base: {
        color: "#32325d",
        lineHeight: "18px",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };
    // Create an instance of the card Element.
    this.card = elements.create("card", { style: style });
    // Add an instance of the card Element into the `card-element` <div>.
    this.card.mount("#card-element");
    // Handle real-time validation errors from the card Element.
    this.card.addEventListener("change", function (event) {
      var displayError = document.getElementById("card-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    });
  };

  PaymentStripe.prototype.handleSubmit = function handleSubmit(evt) {
    var _props3 = this.props,
        event = _props3.event,
        pay = _props3.pay,
        payClicked = _props3.payClicked,
        checkoutError = _props3.checkoutError,
        slug = _props3.slug,
        orderId = _props3.orderId,
        gateway = _props3.gateway,
        isGlobal = _props3.isGlobal,
        order = _props3.order;

    evt.preventDefault();
    payClicked();
    this.stripe.createToken(this.card).then(function (result) {
      if (result.error) {
        // Inform the user if there was an error.
        var errorElement = document.getElementById("card-errors");
        errorElement.textContent = result.error.message;
        checkoutError();
      } else {
        if (isGlobal) {
          // Send the token to your server. stripeTokenHandler(result.token);
          pay(slug, orderId, gateway, { token: result.token.id }, order.userId, true);
        } else {
          var eventId = event.data._id;
          // Send the token to your server. stripeTokenHandler(result.token);
          pay(slug, orderId, gateway, { token: result.token.id }, eventId);
        }
      }
    });
  };

  PaymentStripe.prototype.render = function render(_ref) {
    var event = _ref.event,
        order = _ref.order,
        stripe = _ref.stripe,
        isGlobal = _ref.isGlobal;

    if (order.paymentRequest.error) {
      window.scrollTo(0, 0);
    }
    var error = order.paymentRequest.error;
    return Object(preact_min["h"])(
      "div",
      null,
      PaymentStripe__ref2,
      error ? Object(preact_min["h"])(
        "p",
        { "class": "text-error" },
        error
      ) : "",
      !stripe.checkoutScript.loaded || stripe.checkoutScript.loading ? PaymentStripe__ref3 : !order.timeExpired ? Object(preact_min["h"])(
        "form",
        { onSubmit: this.handleSubmit },
        Object(preact_min["h"])(
          "div",
          {
            "class": "form-group",
            style: {
              margin: "30px 0"
            }
          },
          PaymentStripe__ref4,
          PaymentStripe__ref5,
          PaymentStripe__ref6
        ),
        PaymentStripe__ref7,
        Object(preact_min["h"])(
          ActionBar["a" /* default */],
          null,
          Object(preact_min["h"])(
            ActionButton["a" /* default */],
            {
              disabled: order.waitingToPay || order.paymentRequest.loading || order.timeExpired,
              loading: order.waitingToPay || order.paymentRequest.loading,
              classNames: PaymentStripe_nextStageButton
            },
            "Pay Now"
          ),
          Object(preact_min["h"])(components_CardLogos, { event: event, isGlobal: isGlobal })
        )
      ) : null
    );
  };

  return PaymentStripe;
}(preact_min["Component"]);

/* harmony default export */ var payment_PaymentStripe = (Object(es["b" /* connect */])(function (state) {
  return { event: state.event, order: state.order, stripe: state.stripe };
}, { loadCheckOutScript: stripeActions_loadCheckOutScript, pay: orderActions["T" /* pay */], payClicked: orderActions["W" /* payClicked */], checkoutError: orderActions["M" /* checkoutError */] })(PaymentStripe_PaymentStripe));
// CONCATENATED MODULE: ./components/GiftCardCode.js


function GiftCardCode__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GiftCardCode__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GiftCardCode__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var GiftCardCode_GiftCardCode = function (_Component) {
  GiftCardCode__inherits(GiftCardCode, _Component);

  function GiftCardCode() {
    var _temp, _this, _ret;

    GiftCardCode__classCallCheck(this, GiftCardCode);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = GiftCardCode__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.save = function (values) {
      var _this$props = _this.props,
          addGiftCard = _this$props.addGiftCard,
          order = _this$props.order,
          event = _this$props.event;

      var code = values.giftCardCode;
      if (code) {
        addGiftCard(event.data._id, order.data._id, code);
      }
    }, _this.remove = function () {
      var _this$props2 = _this.props,
          removeGiftCard = _this$props2.removeGiftCard,
          order = _this$props2.order;

      removeGiftCard(order.data._id);
    }, _temp), GiftCardCode__possibleConstructorReturn(_this, _ret);
  }

  GiftCardCode.prototype.render = function render() {
    var _props = this.props,
        event = _props.event,
        order = _props.order,
        _props$allowAdd = _props.allowAdd,
        allowAdd = _props$allowAdd === undefined ? true : _props$allowAdd,
        handleSubmit = _props.handleSubmit;


    if (!event || !event.data || !event.data.hasGiftCards) {
      return null;
    }

    var discountCodeStyle = {
      background: "url(" + icon_success_default.a + ") no-repeat left 5px center",
      backgroundSize: 20,
      color: "#1bab74",
      margin: "0px 12px",
      padding: "4px 0 4px 28px",
      display: "inline-block"
    };
    var removeStyle = {
      background: "url(" + icon_cross_default.a + ") no-repeat right 5px center",
      backgroundSize: 20,
      paddingLeft: 30,
      cursor: "pointer",
      float: "right",
      height: 30
    };
    var giftCardCode = order.data.giftCard && order.data.giftCard.code ? order.data.giftCard.code : false;
    var discountStyle = { paddingTop: 12, paddingBottom: 12 };
    var giftCardDisplay = false;
    if (allowAdd && giftCardCode) {
      giftCardDisplay = Object(preact_min["h"])(
        "span",
        null,
        "Gift card code: ",
        Object(preact_min["h"])(
          "span",
          { style: discountCodeStyle },
          giftCardCode
        ),
        Object(preact_min["h"])("a", { onClick: this.remove, style: removeStyle })
      );
    }

    if (!allowAdd && giftCardCode) {
      giftCardDisplay = Object(preact_min["h"])(
        "span",
        null,
        "Discount code: ",
        giftCardCode
      );
    }

    if (giftCardDisplay) {
      return Object(preact_min["h"])(
        "div",
        { style: discountStyle },
        giftCardDisplay
      );
    }

    return allowAdd && event && event.data ? Object(preact_min["h"])(
      "div",
      { style: discountStyle },
      order.giftCardsRequest.error ? Object(preact_min["h"])(
        "p",
        { "class": "text-error error-icon" },
        order.giftCardsRequest.error
      ) : "",
      Object(preact_min["h"])(
        "form",
        { onSubmit: handleSubmit(this.save) },
        Object(preact_min["h"])(
          "div",
          { style: { display: "flex" } },
          Object(preact_min["h"])(redux_form_es["a" /* Field */], {
            style: {
              width: "80%"
            },
            inputStyle: {
              borderRadius: "4px 0 0 4px"
            },
            type: "text",
            name: "giftCardCode",
            label: "Enter gift card code",
            component: InputField["a" /* default */],
            placeholder: "Gift card code"
          }),
          Object(preact_min["h"])(
            ActionButton["a" /* default */],
            {
              loading: order.giftCardsRequest.loading,
              classNames: "btn-secondary",
              dataCY: "GiftCardCodeApply",
              style: {
                borderRadius: "0 4px 4px 0",
                padding: "4px 10px",
                marginTop: 24
              }
            },
            "Apply"
          )
        )
      )
    ) : "";
  };

  return GiftCardCode;
}(preact_min["Component"]);

GiftCardCode_GiftCardCode = Object(redux_form_es["f" /* reduxForm */])({
  form: "giftCard"
})(GiftCardCode_GiftCardCode);

/* harmony default export */ var components_GiftCardCode = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order
  };
}, { addGiftCard: orderActions["L" /* addGiftCard */], removeGiftCard: orderActions["Z" /* removeGiftCard */] })(GiftCardCode_GiftCardCode));
// CONCATENATED MODULE: ./routes/payment/Payment.js
var Payment__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Payment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Payment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Payment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























var Payment_PaymentWrapper = function (_Component) {
  Payment__inherits(PaymentWrapper, _Component);

  function PaymentWrapper() {
    var _temp, _this, _ret;

    Payment__classCallCheck(this, PaymentWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Payment__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.eventDidMount = function () {
      var _this$props = _this.props,
          event = _this$props.event,
          order = _this$props.order,
          orderId = _this$props.orderId,
          eventSlug = _this$props.eventSlug,
          getEvent = _this$props.getEvent,
          getOrder = _this$props.getOrder;

      if (!event.data && !event.loading) {
        getEvent(eventSlug, undefined, false, orderId, true);
      }
      Object(BrowserUtils["a" /* pageChange */])("Payment");
    }, _this.globalDidMount = function () {
      var _this$props2 = _this.props,
          order = _this$props2.order,
          orderId = _this$props2.orderId,
          getOrder = _this$props2.getOrder,
          giftCards = _this$props2.giftCards,
          eventSlug = _this$props2.eventSlug,
          getGiftCardPage = _this$props2.getGiftCardPage;

      if (!order.data && !order.loading) {
        getOrder(orderId);
      }
      if (!giftCards.giftCardPage && !giftCards.loading) {
        getGiftCardPage(eventSlug);
      }
    }, _this.determineIsGlobal = function () {
      return _this.props.path ? _this.props.path.indexOf("/gift-cards/") > -1 : false;
    }, _temp), Payment__possibleConstructorReturn(_this, _ret);
  }

  PaymentWrapper.prototype.render = function render() {
    var isGlobal = this.determineIsGlobal();
    var eventSlug = this.props.eventSlug;

    return Object(preact_min["h"])(Payment_Payment, Payment__extends({}, this.props, {
      isGlobal: isGlobal,
      didMount: isGlobal ? this.globalDidMount : this.eventDidMount,
      slug: eventSlug
    }));
  };

  return PaymentWrapper;
}(preact_min["Component"]);

var Payment__ref2 = Object(preact_min["h"])(
  Page["a" /* default */],
  null,
  Object(preact_min["h"])(WarningMessage["a" /* default */], { title: "Order could not be loaded" })
);

var Payment__ref3 = Object(preact_min["h"])(giftCards_GiftCardPageHeader, null);

var Payment__ref4 = Object(preact_min["h"])(
  "h2",
  { "class": "sub-header" },
  "Payment"
);

var Payment__ref5 = Object(preact_min["h"])(components_GiftCardCode, null);

var Payment__ref6 = Object(preact_min["h"])("hr", null);

var Payment_Payment = function (_Component2) {
  Payment__inherits(Payment, _Component2);

  function Payment() {
    Payment__classCallCheck(this, Payment);

    return Payment__possibleConstructorReturn(this, _Component2.call(this));
  }

  Payment.prototype.componentDidMount = function componentDidMount() {
    this.props.didMount();
  };

  Payment.prototype.render = function render(_ref) {
    var orderId = _ref.orderId,
        slug = _ref.slug,
        event = _ref.event,
        order = _ref.order,
        clearOrder = _ref.clearOrder,
        seatingMap = _ref.seatingMap,
        merchandise = _ref.merchandise,
        isGlobal = _ref.isGlobal,
        giftCards = _ref.giftCards,
        completeGiftCardOrder = _ref.completeGiftCardOrder;

    if (order && order.orderGet.error) {
      return Payment__ref2;
    }
    if (event.loading || !event.data && !isGlobal || giftCards.loading && isGlobal || !giftCards.giftCardPage && isGlobal || !order.data || merchandise.merch.loading) {
      return;
    }
    if (order && order.data.status === "complete") {
      clearOrder();
      Object(preact_router_es["route"])("/" + slug, true);
    }

    return Object(preact_min["h"])(
      "div",
      null,
      isGlobal ? Payment__ref3 : null,
      Object(preact_min["h"])(
        Page["a" /* default */],
        { isGlobal: isGlobal },
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])(BookingHeader["a" /* default */], {
            event: event,
            orderId: orderId,
            includeSeatingMap: seatingMap.seatingMapRequired,
            isGlobal: isGlobal
          }),
          Object(preact_min["h"])(
            TwoCols["a" /* default */],
            null,
            Object(preact_min["h"])(
              "div",
              null,
              Object(preact_min["h"])(CountDown["a" /* default */], { margin: "0 0 24px 0", isGlobal: isGlobal }),
              Payment__ref4,
              Payment__ref5,
              order.paymentRequest.error ? Object(preact_min["h"])(
                "p",
                { "class": "text-error" },
                order.paymentRequest.error.message
              ) : "",
              order.giftCardsRequest.isFullPayment ? Object(preact_min["h"])(Payment_GiftCardSuccessMessage, {
                order: order,
                orderId: orderId,
                completeGiftCardOrder: completeGiftCardOrder
              }) : Object(preact_min["h"])(Payment_PaymentMethod, {
                event: event,
                order: order,
                orderId: orderId,
                slug: slug,
                isGlobal: isGlobal
              }),
              Payment__ref6
            ),
            Object(preact_min["h"])(components_YourOrder, { isGlobal: isGlobal })
          )
        )
      )
    );
  };

  return Payment;
}(preact_min["Component"]);

var Payment__ref8 = Object(preact_min["h"])(
  "h2",
  null,
  "Successfully applied gift card!"
);

var Payment_GiftCardSuccessMessage = function GiftCardSuccessMessage(_ref7) {
  var orderId = _ref7.orderId,
      completeGiftCardOrder = _ref7.completeGiftCardOrder,
      order = _ref7.order;

  return Object(preact_min["h"])(
    "div",
    null,
    Object(preact_min["h"])(
      "div",
      {
        style: {
          borderRadius: 4,
          border: "solid 1px #dedede",
          padding: "16px 12px",
          textAlign: "center"
        }
      },
      Payment__ref8
    ),
    Object(preact_min["h"])(
      ActionBar["a" /* default */],
      null,
      Object(preact_min["h"])(
        ActionButton["a" /* default */],
        {
          onClick: function onClick() {
            return completeGiftCardOrder(orderId);
          },
          loading: order.giftCardsRequest.loading
        },
        "Complete"
      )
    )
  );
};

var Payment__ref10 = Object(preact_min["h"])(
  "h4",
  null,
  "Payment Method"
);

var Payment__ref11 = Object(preact_min["h"])("span", { className: "icon icon-credit-card" });

var Payment__ref12 = Object(preact_min["h"])("span", { className: "icon icon-invoice" });

var Payment_Tabs = function (_Component3) {
  Payment__inherits(Tabs, _Component3);

  function Tabs() {
    Payment__classCallCheck(this, Tabs);

    var _this3 = Payment__possibleConstructorReturn(this, _Component3.call(this));

    _this3.checkChange = _this3.checkChange.bind(_this3);
    return _this3;
  }

  Tabs.prototype.checkChange = function checkChange(method) {
    var order = this.props.order;

    if (order.paymentRequest.loading) {
      return;
    }
    method();
  };

  Tabs.prototype.render = function render(_ref9) {
    var _this4 = this;

    var event = _ref9.event,
        order = _ref9.order,
        payByCreditDebit = _ref9.payByCreditDebit,
        payByInvoice = _ref9.payByInvoice,
        children = _ref9.children;

    if (!order || !event.data || !event.data.paymentOptions.invoiceInfo || !event.data.paymentOptions.invoiceInfo.enabled) {
      return { children: children };
    }

    var creditClass = order.paymentMethod === orderActions["m" /* CREDIT_AND_DEBIT */] ? "active" : "";
    var invoicingClass = order.paymentMethod === orderActions["v" /* INVOICING */] ? "active" : "";
    return Object(preact_min["h"])(
      "div",
      null,
      Payment__ref10,
      Object(preact_min["h"])(
        "ul",
        { "class": "tab tab-block" },
        Object(preact_min["h"])(
          "li",
          { "class": "tab-item " + creditClass, style: { minWidth: 180 } },
          Object(preact_min["h"])(
            "a",
            { onClick: function onClick() {
                return _this4.checkChange(payByCreditDebit);
              } },
            Payment__ref11,
            "Credit or debit Card"
          )
        ),
        Object(preact_min["h"])(
          "li",
          { "class": "tab-item " + invoicingClass },
          Object(preact_min["h"])(
            "a",
            { onClick: function onClick() {
                return _this4.checkChange(payByInvoice);
              } },
            Payment__ref12,
            "Invoice"
          )
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: "tab-content" },
        children
      )
    );
  };

  return Tabs;
}(preact_min["Component"]);

Payment_Tabs = Object(es["b" /* connect */])(function (state) {
  return { event: state.event, order: state.order };
}, { payByCreditDebit: orderActions["U" /* payByCreditDebit */], payByInvoice: orderActions["V" /* payByInvoice */] })(Payment_Tabs);

var Payment_PaymentMethod = function PaymentMethod(_ref13) {
  var event = _ref13.event,
      order = _ref13.order,
      orderId = _ref13.orderId,
      slug = _ref13.slug,
      isGlobal = _ref13.isGlobal;

  if (!isGlobal && !event.data || order.timeExpired) {
    return null;
  }
  //for the moment, global orders just used bpoint
  if (isGlobal) {
    if (order.data.paymentGateway === "stripe-payments") {
      return Object(preact_min["h"])(
        Payment_Tabs,
        null,
        Object(preact_min["h"])(payment_PaymentStripe, {
          orderId: orderId,
          slug: slug,
          gateway: order.data.paymentGateway,
          isGlobal: isGlobal
        })
      );
    } else {
      return Object(preact_min["h"])(
        Payment_Tabs,
        null,
        Object(preact_min["h"])(payment_PaymentBPoint, { orderId: orderId, slug: slug, isGlobal: isGlobal })
      );
    }
  } else {
    if (order.paymentMethod === orderActions["v" /* INVOICING */]) {
      return Object(preact_min["h"])(
        Payment_Tabs,
        null,
        Object(preact_min["h"])(payment_PaymentInvoice, { orderId: orderId, slug: slug })
      );
    }

    if (event.data.paymentOptions && event.data.paymentOptions.paymentId === "paypal") {
      return Object(preact_min["h"])(
        Payment_Tabs,
        null,
        Object(preact_min["h"])(payment_PaymentPayPal, { orderId: orderId, slug: slug })
      );
    }
    if (event.data.paymentOptions && (event.data.paymentOptions.paymentId === "stripe" || event.data.paymentOptions.paymentId === "stripe-payments")) {
      return Object(preact_min["h"])(
        Payment_Tabs,
        null,
        Object(preact_min["h"])(payment_PaymentStripe, {
          orderId: orderId,
          slug: slug,
          gateway: event.data.paymentOptions.paymentId
        })
      );
    }
  }

  return Object(preact_min["h"])(
    Payment_Tabs,
    null,
    Object(preact_min["h"])(payment_PaymentBPoint, { orderId: orderId, slug: slug })
  );
};

/* harmony default export */ var payment_Payment = (Object(es["b" /* connect */])(function (state) {
  return {
    event: state.event,
    order: state.order,
    merchandise: state.merchandise,
    seatingMap: state.seatingMap,
    giftCards: state.giftCards
  };
}, {
  getEvent: eventActions["u" /* getEvent */],
  getOrder: orderActions["Q" /* getOrder */],
  clearOrder: orderActions["N" /* clearOrder */],
  payByCreditDebit: orderActions["U" /* payByCreditDebit */],
  payByInvoice: orderActions["V" /* payByInvoice */],
  getGiftCardPage: giftCardActions_getGiftCardPage,
  completeGiftCardOrder: orderActions["O" /* completeGiftCardOrder */]
})(Payment_PaymentWrapper));
// CONCATENATED MODULE: ./components/CompleteSummary.js
var CompleteSummary__templateObject = CompleteSummary__taggedTemplateLiteralLoose(["\n    @media (max-width: 600px) {\n      font-size: 18px;\n    }\n  "], ["\n    @media (max-width: 600px) {\n      font-size: 18px;\n    }\n  "]);



function CompleteSummary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CompleteSummary__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CompleteSummary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function CompleteSummary__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }









var CompleteSummary_ticket = __webpack_require__("koPH");
var headingId = "yourOrderDetailsHeading";

var CompleteSummary_styles = {
  title: Object(index_esm["css"])(CompleteSummary__templateObject)
};

var CompleteSummary__ref = Object(preact_min["h"])(
  components_Button["a" /* default */],
  { type: "secondary" },
  "Add to Calendar"
);

var CompleteSummary_CompleteSummary = function (_Component) {
  CompleteSummary__inherits(CompleteSummary, _Component);

  function CompleteSummary(props) {
    CompleteSummary__classCallCheck(this, CompleteSummary);

    return CompleteSummary__possibleConstructorReturn(this, _Component.call(this, props));
  }

  CompleteSummary.prototype.componentDidMount = function componentDidMount() {
    try {
      // document.getElementById(headingId).focus();
    } catch (err) {}
  };

  CompleteSummary.prototype.render = function render() {
    var _props = this.props,
        order = _props.order,
        event = _props.event,
        date = _props.date;

    var hideCalendar = event.data.settings.hideAddToCalendar;
    var wrapper = Object(index_esm["css"])({
      backgroundColor: "transparent",
      width: 800,
      height: "100%",
      margin: "0 auto",
      backgroundImage: "url(" + CompleteSummary_ticket + ")",
      padding: "41px 41px 5px",
      borderRadius: 4,
      marginBottom: 14,
      "@media(max-width: 800px)": {
        width: "100%",
        height: "auto",
        padding: "24px 12px",
        backgroundImage: "none",
        backgroundColor: "#fff"
      }
    });

    var tickets = order.data.tickets ? order.data.tickets : [];

    var eventDate = void 0;
    if (event.data.datesUseCalendar) {
      eventDate = date;
    } else {
      event.data.dates.forEach(function (date) {
        if (String(date._id) === String(order.data.eventDateId)) {
          eventDate = date;
        }
      });
    }

    var parts = [];
    if (event.data.location.venueName) {
      parts.push(event.data.location.venueName);
    }
    if (event.data.location.address) {
      parts.push(event.data.location.address.replace(",", ""));
    }

    var eventCalender = {
      title: event.data.name,
      description: EventsService["a" /* default */].getCalendarDescription(event.data),
      location: parts.join(" "),
      startTime: eventDate.startDate,
      endTime: eventDate.endDate
    };

    var organizerEmail = event.data.customerContact && event.data.customerContact.email ? event.data.customerContact.email : "";

    var invoiceSendTicketImmediately = event.data && event.data.paymentOptions && event.data.paymentOptions.invoiceInfo && event.data.paymentOptions.invoiceInfo.sendTicketImmediately ? event.data.paymentOptions.invoiceInfo.sendTicketImmediately : false;

    var isInvoice = order && order.paymentMethod === orderActions["v" /* INVOICING */];
    var ticketSent = tickets.length > 0 && (!isInvoice || invoiceSendTicketImmediately);
    var ticketsTxt = tickets.length > 1 ? "tickets" : "ticket";
    var ticketsString = "You have purchased " + (tickets.length > 1 ? tickets.length + " tickets " : "a ticket ") + " to ";

    ticketsTxt = event && event.data && event.data.settings && event.data.settings.sendTickets ? ticketsTxt : "order details";
    ticketsString = tickets.length === 0 || ticketsTxt === "order details" ? "Thank you for your purchase for " : ticketsString;

    var ticketsMsg = ticketSent ? "along with your " + ticketsTxt + " and a tax invoice" : "along with your tax invoice";

    return Object(preact_min["h"])(
      "div",
      { className: wrapper },
      Object(preact_min["h"])(
        "h2",
        { tabIndex: -1, id: headingId, className: CompleteSummary_styles.title },
        "Your order details"
      ),
      Object(preact_min["h"])(
        "p",
        { style: { marginBottom: 8 } },
        ticketsString,
        Object(preact_min["h"])(
          "b",
          { style: { fontWeight: 600 } },
          event.data.name
        ),
        " on",
        " ",
        eventDate.display.combined
      ),
      Object(preact_min["h"])(
        "p",
        { style: { marginBottom: 8, maxWidth: 600 } },
        "An email confirmation has been sent to",
        " ",
        Object(preact_min["h"])(
          "b",
          { style: { fontWeight: 600 } },
          order.data.email
        ),
        " ",
        ticketsMsg,
        ". Please make sure to check your spam/junk folder. If email is not received within 5 minutes, please contact the organiser",
        " ",
        Object(preact_min["h"])(
          "a",
          {
            href: "mailto:" + organizerEmail,
            style: { textDecoration: "underline" }
          },
          "here"
        ),
        " ",
        "to resend your order confirmation."
      ),
      Object(preact_min["h"])(
        "p",
        { style: { marginBottom: 4 } },
        "Order number:",
        " ",
        Object(preact_min["h"])(
          "b",
          { style: { fontWeight: 600 } },
          order.data.orderName
        )
      ),
      Object(preact_min["h"])(
        "p",
        { style: { marginBottom: 24 } },
        "Order date:",
        " ",
        Object(preact_min["h"])(
          "b",
          { style: { fontWeight: 600 } },
          order.data.completedDisplayDate
        )
      ),
      !hideCalendar ? Object(preact_min["h"])(
        ReactAddToCalendar_ReactAddToCalendar,
        { event: eventCalender },
        CompleteSummary__ref
      ) : null,
      event.data.public ? Object(preact_min["h"])(components_SharingLinks, { event: event.data }) : Object(preact_min["h"])("div", { style: { height: 40 } })
    );
  };

  return CompleteSummary;
}(preact_min["Component"]);

/* harmony default export */ var components_CompleteSummary = (CompleteSummary_CompleteSummary);
// CONCATENATED MODULE: ./utils/Personalize.js
var personalize = function personalize(message, firstName, lastName, eventName) {
  var personalizedString = message.replace(new RegExp("@EventName", "g"), eventName);
  personalizedString = personalizedString.replace(new RegExp("@FirstName", "g"), firstName);
  personalizedString = personalizedString.replace(new RegExp("@LastName", "g"), lastName);

  return personalizedString;
};
// CONCATENATED MODULE: ./components/EventMessage.js







var EventMessage__ref2 = Object(preact_min["h"])(
  "h2",
  null,
  "Message from the organiser"
);

var EventMessage_EventMessage = function EventMessage(_ref) {
  var event = _ref.event,
      order = _ref.order;

  var wrapper = Object(index_esm["css"])({
    maxWidth: 800,
    textAlign: "left",
    padding: 32,
    backgroundColor: "#fff",
    boxShadow: "0 1px 10px 2px rgba(32, 7, 64, 0.13)",
    borderRadius: 4,
    margin: "0 auto",
    marginBottom: 20,
    "@media(max-width: 800px)": {
      padding: 12
    }
  });
  if (!event || !event.messages || !event.messages.orderMessage) {
    return null;
  }

  var firstNameForRegex = order.firstName;
  var lastNameForRegex = order.lastName;
  var eventNameForRegex = event.name;

  return Object(preact_min["h"])(
    "div",
    { className: wrapper },
    EventMessage__ref2,
    Object(preact_min["h"])(components_RichTextDisplay, {
      html: personalize(event.messages.orderMessage, firstNameForRegex, lastNameForRegex, eventNameForRegex)
    })
  );
};
/* harmony default export */ var components_EventMessage = (EventMessage_EventMessage);
// CONCATENATED MODULE: ./components/YouTubeVideo.js



var YouTubeVideo_YouTubeVideo = function YouTubeVideo(_ref) {
  var code = _ref.code,
      width = _ref.width,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style;

  return Object(preact_min["h"])("iframe", {
    width: width,
    height: width,
    className: style,
    src: "https://www.youtube.com/embed/" + code,
    frameborder: "0",
    allow: "encrypted-media",
    allowfullscreen: true
  });
};
/* harmony default export */ var components_YouTubeVideo = (YouTubeVideo_YouTubeVideo);
// CONCATENATED MODULE: ./components/ButtonRow.js



var ButtonRow_ButtonRow = function ButtonRow(_ref) {
  var _ref$justify = _ref.justify,
      justify = _ref$justify === undefined ? "center" : _ref$justify,
      children = _ref.children;

  return Object(preact_min["h"])(
    "div",
    { style: { textAlign: justify } },
    children.map(function (child) {
      return Object(preact_min["h"])(
        "div",
        {
          style: {
            margin: "0 4px",
            display: "inline-block",
            verticalAlign: "top"
          }
        },
        child
      );
    })
  );
};
/* harmony default export */ var components_ButtonRow = (ButtonRow_ButtonRow);
// CONCATENATED MODULE: ./assets/images/logos/faces/simle.js



var simle__ref2 = Object(preact_min["h"])("path", { d: "M36.203 40.14c-3.106 0-4.744-1.654-4.744-4.781V27.33a1.953 1.953 0 0 0-.559-1.543 1.925 1.925 0 0 0-1.533-.563H18.585a1.925 1.925 0 0 0-1.533.563 1.953 1.953 0 0 0-.56 1.543v8.029c0 3.127-1.642 4.78-4.748 4.78h-7C1.643 40.14 0 38.486 0 35.36V5.393C0 2.266 1.643.618 4.744.618h7c3.106 0 4.749 1.648 4.749 4.775v5.413c-.051.573.153 1.139.557 1.546.403.407.965.614 1.535.564h10.782c.57.05 1.132-.157 1.535-.564.404-.407.608-.973.557-1.546V5.393c0-3.127 1.638-4.775 4.744-4.775h7c3.106 0 4.749 1.648 4.749 4.775V35.36c0 3.127-1.643 4.78-4.75 4.78h-7zM44.498 70.81c-2.402.001-4.801-.148-7.184-.447a5.255 5.255 0 0 1-3.623-2.179 5.402 5.402 0 0 1-.875-4.226l.73-3.472a5.366 5.366 0 0 1 5.193-4.289c.205 0 .41.014.614.039 1.707.201 3.425.302 5.145.301 9.589 0 18.782-3.258 23.42-8.3a5.289 5.289 0 0 1 6.478-1.032L77.58 49a5.348 5.348 0 0 1 2.632 3.737 5.374 5.374 0 0 1-1.207 4.418c-7.329 8.55-20.232 13.655-34.507 13.655zM88.937 40.752c-1.304 0-2.604-.584-3.865-1.74l-7.425-6.872-7.43 6.871c-1.25 1.157-2.55 1.741-3.864 1.741s-2.6-.584-3.865-1.74l-5.082-4.699c-1.237-1.142-1.865-2.324-1.865-3.5 0-1.178.628-2.36 1.865-3.507l7.522-6.93-7.498-6.925c-1.237-1.148-1.865-2.33-1.865-3.506 0-1.177.628-2.359 1.865-3.506l5.082-4.693C63.768.588 65.058 0 66.362 0c1.305 0 2.604.588 3.865 1.746l7.43 6.871 7.425-6.871C86.333.588 87.632 0 88.947 0c1.314 0 2.599.588 3.865 1.746l5.077 4.693c1.241 1.147 1.87 2.324 1.87 3.506s-.629 2.358-1.87 3.506l-7.517 6.925 7.493 6.93c1.241 1.147 1.87 2.324 1.87 3.506s-.629 2.359-1.87 3.501l-5.078 4.698c-1.25 1.157-2.545 1.741-3.85 1.741z" });

var simle_Smile = function Smile(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? "#57CFC7" : _ref$color,
      style = _ref.style;

  return Object(preact_min["h"])(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "100",
      height: "71",
      viewBox: "0 0 100 71",
      style: style
    },
    Object(preact_min["h"])(
      "g",
      { fill: color, "fill-rule": "nonzero" },
      simle__ref2
    )
  );
};

/* harmony default export */ var simle = (simle_Smile);
// CONCATENATED MODULE: ./components/Thankyou.js












var websiteUrl = Object(config["a" /* default */])("WEBSITE_URL");

var Thankyou_Thankyou = function Thankyou(_ref) {
  var event = _ref.event,
      order = _ref.order,
      _ref$showCharity = _ref.showCharity,
      showCharity = _ref$showCharity === undefined ? true : _ref$showCharity;

  var wrapper = Object(index_esm["css"])({
    maxWidth: 800,
    width: "100%",
    backgroundColor: "#FFF",
    margin: "0 auto",
    borderRadius: 4,
    padding: "32px 12px",
    textAlign: "center",
    boxShadow: "0 1px 10px 0 rgba(32, 7, 64, 0.13)",
    marginBottom: 14,
    "@media(max-width: 800px)": {
      padding: "24px 12px"
    }
  });
  var heading = Object(index_esm["css"])({
    marginBottom: 8
  });
  var paragraph = Object(index_esm["css"])({
    marginBottom: 24
  });

  var youtube = Object(index_esm["css"])({
    width: 400,
    height: 225,
    borderRadius: 4,
    boxShadow: "2px 2px 10px 2px rgba(56, 66, 9, 0.13)",
    marginBottom: 24,
    "@media(max-width: 800px)": {
      width: 268,
      height: 151
    }
  });
  var visualElement = Object(preact_min["h"])("img", {
    src: event.data.charity.logo.url,
    style: {
      borderRadius: 4,
      boxShadow: "2px 2px 10px 2px rgba(56, 66, 9, 0.13)",
      marginBottom: 24,
      maxWidth: 200
    }
  });

  if (event.data.charity.video) {
    visualElement = Object(preact_min["h"])(components_YouTubeVideo, { code: event.data.charity.video, style: youtube });
  }
  var primaryColor = event.data.theme && event.data.theme.primaryColor ? event.data.theme.primaryColor : "#6621c0";
  var title = showCharity ? "Thank you " + order.data.firstName + " for making a difference!" : "Thanks for your purchase, " + order.data.firstName + "!";
  var smileWidth = showCharity ? 60 : 80;

  return Object(preact_min["h"])(
    "div",
    { "class": wrapper },
    Object(preact_min["h"])(simle, {
      color: primaryColor,
      style: { width: smileWidth, marginBottom: 12 }
    }),
    Object(preact_min["h"])(
      "h1",
      { className: heading },
      title
    ),
    showCharity ? Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        "p",
        { className: paragraph },
        "Humanitix is donating 100% of booking fee profits to",
        " ",
        event.data.charity.partnered ? event.data.charity.name.toLowerCase() : event.data.charity.name
      ),
      visualElement,
      Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          components_ButtonRow,
          null,
          Object(preact_min["h"])(
            components_Button["a" /* default */],
            {
              link: event.data.charity.projectPageUrl ? "" + websiteUrl + event.data.charity.projectPageUrl : event.data.charity.website,
              type: "secondary"
            },
            "Learn More"
          ),
          Object(preact_min["h"])(components_Share, {
            eventLink: Object(config["a" /* default */])("TICKETING_URL") + "/" + event.data.slug,
            icon: false
          })
        )
      )
    ) : null
  );
};
/* harmony default export */ var components_Thankyou = (Object(es["b" /* connect */])(function (state) {
  return {
    event: state.event,
    order: state.order
  };
}, {})(Thankyou_Thankyou));
// CONCATENATED MODULE: ./routes/complete/components/Redirect.js


function Redirect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Redirect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Redirect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Redirect_wrapper = Object(index_esm["css"])({
  maxWidth: 800,
  width: "100%",
  backgroundColor: "#FFF",
  margin: "0 auto",
  borderRadius: 4,
  padding: "32px 12px",
  textAlign: "center",
  boxShadow: "0 1px 10px 2px rgba(32, 7, 64, 0.13)",
  marginBottom: 14,
  display: "flex",
  "@media(max-width: 800px)": {
    padding: "24px 12px"
  }
});

var Redirect_Redirect = function (_Component) {
  Redirect__inherits(Redirect, _Component);

  function Redirect() {
    Redirect__classCallCheck(this, Redirect);

    return Redirect__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Redirect.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        redirect = _props.redirect,
        _props$wait = _props.wait,
        wait = _props$wait === undefined ? 0 : _props$wait;

    var isBrowser = typeof window !== "undefined";
    if (isBrowser) {
      var REDIRECT_TIME = Object(config["a" /* default */])("REDIRECT_TIME");
      setTimeout(function () {
        window.top.location = redirect.url;
      }, REDIRECT_TIME);
    }
  };

  Redirect.prototype.render = function render() {
    var _props2 = this.props,
        redirect = _props2.redirect,
        _props2$wait = _props2.wait,
        wait = _props2$wait === undefined ? 0 : _props2$wait;

    if (!redirect) {
      return null;
    }
    return Object(preact_min["h"])(
      "div",
      { className: Redirect_wrapper },
      Object(preact_min["h"])("div", {
        "class": "loading loading-lg",
        style: { display: "inline-block", width: 100 }
      }),
      Object(preact_min["h"])(
        "h2",
        { style: { margin: "16px 0" } },
        redirect.message
      )
    );
  };

  return Redirect;
}(preact_min["Component"]);

/* harmony default export */ var components_Redirect = (Redirect_Redirect);
// CONCATENATED MODULE: ./routes/complete/Complete.js


function Complete__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Complete__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Complete__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Complete_Complete = function (_Component) {
  Complete__inherits(Complete, _Component);

  function Complete() {
    Complete__classCallCheck(this, Complete);

    return Complete__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Complete.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        event = _props.event,
        order = _props.order,
        getEvent = _props.getEvent,
        getOrder = _props.getOrder,
        eventSlug = _props.eventSlug,
        orderId = _props.orderId,
        getDate = _props.getDate,
        eventDates = _props.eventDates;

    if (!event.data && !event.loading) {
      getEvent(eventSlug);
    }
    if (!order.data && !order.orderRequest.loading) {
      getOrder(orderId);
    }
    if (!eventDates.selectedDate && order.data && event.data && event.data.datesUseCalendar) {
      getDate(eventSlug, order.data.eventDateId);
    }
  };

  Complete.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    var event = nextProps.event,
        order = nextProps.order,
        eventSlug = nextProps.eventSlug,
        getDate = nextProps.getDate,
        eventDates = nextProps.eventDates;

    if (event.data && order.data && event.data.datesUseCalendar && !eventDates.selectedDate && !eventDates.loading) {
      getDate(eventSlug, order.data.eventDateId);
    }
    Object(BrowserUtils["a" /* pageChange */])("Order Complete", event);
  };

  Complete.prototype.render = function render(_ref) {
    var event = _ref.event,
        order = _ref.order,
        eventDates = _ref.eventDates;

    if (!event.data || !order.data || eventDates.loading || eventDates.error) {
      return;
    }
    if (event.data && event.data.datesUseCalendar && !eventDates.selectedDate) {
      return;
    }
    var background = event.widget ? false : true;
    var hasMoreEvents = event && event.data && event.data.moreEvents && event.data.moreEvents.length > 0;

    var showCharity = event.data.showCharity && (order.data.totals.donation > 0 || order.data.totals.clientDonation > 0 || order.data.totals.dgrDonation > 0);

    return Object(preact_min["h"])(
      "div",
      {
        style: {
          backgroundColor: "#F9F9FA"
        }
      },
      Object(preact_min["h"])(
        Page["a" /* default */],
        { transparent: true, background: background, border: false },
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])(
            "div",
            {
              style: {
                paddingTop: 40,
                paddingLeft: 14,
                paddingRight: 14
              }
            },
            order.data.redirect ? Object(preact_min["h"])(components_Redirect, { redirect: order.data.redirect }) : null,
            Object(preact_min["h"])(components_Thankyou, { showCharity: showCharity }),
            Object(preact_min["h"])(components_CompleteSummary, {
              order: order,
              event: event,
              date: eventDates.selectedDate
            }),
            Object(preact_min["h"])(components_EventMessage, { event: event.data, order: order.data }),
            " "
          )
        )
      ),
      hasMoreEvents && Object(preact_min["h"])(moreEvents_MoreEvents, {
        event: event.data,
        title: "Similar events you might like"
      })
    );
  };

  return Complete;
}(preact_min["Component"]);

/* harmony default export */ var complete_Complete = (Object(es["b" /* connect */])(function (state) {
  return {
    event: state.event,
    order: state.order,
    eventDates: state.eventDates
  };
}, { getEvent: eventActions["u" /* getEvent */], getOrder: orderActions["Q" /* getOrder */], getDate: eventActions["s" /* getDate */] })(Complete_Complete));
// CONCATENATED MODULE: ./components/PaymentSuccess.js
var PaymentSuccess__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function PaymentSuccess__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PaymentSuccess__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PaymentSuccess__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PaymentSuccess_styles = {
  mainContainer: {
    paddingTop: 40
  },
  messageContainer: Object(index_esm["css"])({
    textAlign: "center",
    maxWidth: 800,
    width: "100%",
    padding: "32px 134px",
    margin: "0px auto 20px auto",
    "@media(max-width: 600px)": {
      padding: "20px 14px"
    }
  }),
  questionContainer: Object(index_esm["css"])({
    maxWidth: 800,
    width: "100%",
    padding: "40px 180px",
    marginLeft: "auto",
    marginRight: "auto",
    "@media(max-width: 600px)": {
      padding: "20px 14px"
    }
  }),
  leftBtn: {
    marginRight: 5,
    marginLeft: 5,
    marginTop: 10,
    minWidth: 180
  },
  rightBtn: {
    marginRight: 5,
    marginLeft: 5,
    marginTop: 10,
    minWidth: 180
  }
};

/**
 * This is the form of after-checkout additional questions
 *
 * @param {object, object, function, function} { event, order, save, handleSubmit }
 * @returns form
 */
var PaymentSuccess_formName = "afterCheckout";

var PaymentSuccess__ref = Object(preact_min["h"])(
  ActionBar["a" /* default */],
  null,
  Object(preact_min["h"])(
    ActionButton["a" /* default */],
    null,
    "Submit"
  )
);

var PaymentSuccess_AfterCheckoutForm = function (_Component) {
  PaymentSuccess__inherits(AfterCheckoutForm, _Component);

  function AfterCheckoutForm() {
    PaymentSuccess__classCallCheck(this, AfterCheckoutForm);

    var _this = PaymentSuccess__possibleConstructorReturn(this, _Component.call(this));

    _this.changeFieldValue = _this.changeFieldValue.bind(_this);
    return _this;
  }

  AfterCheckoutForm.prototype.changeFieldValue = function changeFieldValue(field, value) {
    var dispatch = this.props.dispatch;

    dispatch(Object(redux_form_es["c" /* change */])(PaymentSuccess_formName, field, value));
  };

  AfterCheckoutForm.prototype.render = function render() {
    var _props = this.props,
        event = _props.event,
        order = _props.order,
        save = _props.save,
        handleSubmit = _props.handleSubmit,
        _props$ticketsAdditio = _props.ticketsAdditionalQuestions,
        ticketsAdditionalQuestions = _props$ticketsAdditio === undefined ? {} : _props$ticketsAdditio,
        _props$orderAdditiona = _props.orderAdditionalQuestions,
        orderAdditionalQuestions = _props$orderAdditiona === undefined ? {} : _props$orderAdditiona,
        _props$sameAsBuyerChe = _props.sameAsBuyerChecks,
        sameAsBuyerChecks = _props$sameAsBuyerChe === undefined ? false : _props$sameAsBuyerChe,
        buyerData = _props.buyerData;

    var detailsAdditionQuestions = event && event.data && event.data.additionalQuestions.length ? event.data.additionalQuestions.filter(function (q) {
      return q.askAfterCheckout;
    }) : [];
    detailsAdditionQuestions = detailsAdditionQuestions.map(function (q) {
      if (q.type === "multiSelect" && q.options && q.options.length) {
        q.options = q.options.map(function (o) {
          var newOption = o.label ? PaymentSuccess__extends({}, o) : PaymentSuccess__extends({}, o, { id: o._id, label: o.value, value: false });
          return newOption;
        });
      }
      return q;
    });
    return Object(preact_min["h"])(
      "form",
      { onSubmit: handleSubmit(save) },
      Object(preact_min["h"])(details_OrderQuestions, {
        additionalQuestions: detailsAdditionQuestions,
        orderAdditionalQuestions: orderAdditionalQuestions,
        tickets: order.data.tickets,
        formName: PaymentSuccess_formName,
        changeFieldValue: this.changeFieldValue
      }),
      Object(preact_min["h"])(details_TicketsQuestions, {
        tickets: order.data.tickets,
        ticketTypes: event.data.ticketTypes,
        additionalQuestions: detailsAdditionQuestions,
        ticketsAdditionalQuestions: ticketsAdditionalQuestions,
        formName: PaymentSuccess_formName,
        changeFieldValue: this.changeFieldValue,
        sameAsBuyerChecks: sameAsBuyerChecks,
        buyerData: buyerData
      }),
      PaymentSuccess__ref
    );
  };

  return AfterCheckoutForm;
}(preact_min["Component"]);

/**
 * After payment, if there are after-checkout questions, this component is showed.
 *
 * @class PaymentSuccess
 * @extends {Component}
 */


var PaymentSuccess__ref2 = Object(preact_min["h"])("br", null);

var PaymentSuccess__ref3 = Object(preact_min["h"])("br", null);

var PaymentSuccess__ref4 = Object(preact_min["h"])("br", null);

var PaymentSuccess__ref5 = Object(preact_min["h"])(
  "span",
  null,
  "You can also update this at any time through the link in your confirmation email."
);

var PaymentSuccess_PaymentSuccess = function (_Component2) {
  PaymentSuccess__inherits(PaymentSuccess, _Component2);

  function PaymentSuccess(props) {
    PaymentSuccess__classCallCheck(this, PaymentSuccess);

    var _this2 = PaymentSuccess__possibleConstructorReturn(this, _Component2.call(this, props));

    _this2.save = function (values) {
      var _this2$props = _this2.props,
          event = _this2$props.event,
          order = _this2$props.order,
          saveAfterCheckoutQuestions = _this2$props.saveAfterCheckoutQuestions;

      var orderData = PaymentSuccess__extends({}, values.order, {
        _id: order.data._id
      });
      saveAfterCheckoutQuestions(event, order, orderData, values.tickets);
    };

    return _this2;
  }

  PaymentSuccess.prototype.render = function render() {
    var _props2 = this.props,
        _props2$event = _props2.event,
        event = _props2$event === undefined ? {} : _props2$event,
        order = _props2.order,
        redirectToComplete = _props2.redirectToComplete,
        _props2$ticketsAdditi = _props2.ticketsAdditionalQuestions,
        ticketsAdditionalQuestions = _props2$ticketsAdditi === undefined ? {} : _props2$ticketsAdditi,
        _props2$orderAddition = _props2.orderAdditionalQuestions,
        orderAdditionalQuestions = _props2$orderAddition === undefined ? {} : _props2$orderAddition,
        sameAsBuyerChecks = _props2.sameAsBuyerChecks,
        _props2$buyerData = _props2.buyerData,
        buyerData = _props2$buyerData === undefined ? {} : _props2$buyerData;

    var primaryColor = event.data.theme && event.data.theme.primaryColor ? event.data.theme.primaryColor : "#6621c0";

    if (!event) {
      return null;
    } else {
      return Object(preact_min["h"])(
        "div",
        { style: PaymentSuccess_styles.mainContainer },
        Object(preact_min["h"])(
          "div",
          { className: PaymentSuccess_styles.messageContainer + " box" },
          Object(preact_min["h"])(simle, {
            color: primaryColor,
            style: { width: 60, marginBottom: 12 }
          }),
          Object(preact_min["h"])(
            "h1",
            { style: PaymentSuccess_styles.title },
            "Payment successful"
          ),
          "Thank you! Your order for ",
          event.name,
          " is complete.",
          PaymentSuccess__ref2,
          PaymentSuccess__ref3,
          "Please help us by filling out the additional attendee information below.",
          PaymentSuccess__ref4,
          event.data.settings.allowUserEdit ? PaymentSuccess__ref5 : null,
          Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(
              "button",
              {
                className: "btn btn-lg",
                style: PaymentSuccess_styles.leftBtn,
                onClick: function onClick() {
                  return redirectToComplete(event.data.slug, event.data, order.data);
                },
                "aria-label": "Skip button"
              },
              "Skip"
            ),
            Object(preact_min["h"])(
              "a",
              { href: "#question", "aria-label": "View question button" },
              Object(preact_min["h"])(
                "button",
                {
                  className: "btn btn-lg btn-primary",
                  style: PaymentSuccess_styles.rightBtn,
                  "aria-label": "View question button",
                  "aria-hidden": true
                },
                "View questions"
              )
            )
          )
        ),
        Object(preact_min["h"])(
          "div",
          { id: "question", className: PaymentSuccess_styles.questionContainer + " box" },
          Object(preact_min["h"])(PaymentSuccess_AfterCheckoutForm, {
            event: event.data,
            order: order.data,
            save: this.save,
            ticketsAdditionalQuestions: ticketsAdditionalQuestions,
            orderAdditionalQuestions: orderAdditionalQuestions,
            sameAsBuyerChecks: sameAsBuyerChecks,
            buyerData: buyerData
          })
        )
      );
    }
  };

  return PaymentSuccess;
}(preact_min["Component"]);

var PaymentSuccess_getTicketValues = function getTicketValues(order, additionalQuestions, formTickets) {
  if (formTickets) {
    return formTickets;
  }
  if (!order || !order.tickets || !order.tickets.length) {
    return null;
  }
  var mappedTicketValues = {};
  order.tickets.forEach(function (ticket) {
    mappedTicketValues[ticket._id] = {};
    // When users try to buy ticket, if default values exists, adds the values to details form
    additionalQuestions.forEach(function (question) {
      question.defaultValue && !question.perOrder && question.askAfterCheckout ? mappedTicketValues[ticket._id][question._id] = question.defaultValue : "";
    });
  });
  return mappedTicketValues;
};

var PaymentSuccess_getOrderValues = function getOrderValues(order, additionalQuestions, formOrder) {
  if (formOrder) {
    return formOrder;
  }
  if (order.businessPurpose === false || !order.businessPurpose) {
    order.businessPurpose = "false";
  }
  if (order && order.additionalFields) {
    var mappedOrder = PaymentSuccess__extends({}, order);
    mappedOrder.additionalFields = {};
    // When users try to buy ticket, if default values exists, adds the values to details form
    additionalQuestions.forEach(function (question) {
      question.defaultValue && question.perOrder && question.askAfterCheckout ? mappedOrder.additionalFields[question._id] = question.defaultValue : "";
    });

    return mappedOrder;
  }
};
PaymentSuccess_AfterCheckoutForm = Object(redux_form_es["f" /* reduxForm */])({
  form: PaymentSuccess_formName,
  destroyOnUnmount: false,

  onSubmitFail: function onSubmitFail(errors) {
    Object(ScrollToErrors["a" /* scrollToErrors */])();
  }
})(PaymentSuccess_AfterCheckoutForm);

PaymentSuccess_AfterCheckoutForm = Object(es["b" /* connect */])(function (state) {
  var order = PaymentSuccess_getOrderValues(state.order.data, state.event.data.additionalQuestions, PaymentSuccess_selector(state, "order"));
  var tickets = PaymentSuccess_getTicketValues(state.order.data, state.event.data.additionalQuestions, PaymentSuccess_selector(state, "tickets"));
  var initialValues = {
    order: order,
    tickets: tickets
  };

  return {
    initialValues: initialValues,
    event: state.event,
    order: state.order
  };
}, {})(PaymentSuccess_AfterCheckoutForm);

var PaymentSuccess_selector = Object(redux_form_es["d" /* formValueSelector */])(PaymentSuccess_formName);

/* harmony default export */ var components_PaymentSuccess = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order,
    orderAdditionalQuestions: PaymentSuccess_selector(state, "order.additionalFields"),
    ticketsAdditionalQuestions: PaymentSuccess_selector(state, "tickets"),
    sameAsBuyerChecks: PaymentSuccess_selector(state, "sameAsBuyerChecks"),
    buyerData: {
      firstName: state.order.data.firstName,
      lastName: state.order.data.lastName,
      mobile: state.order.data.mobile,
      email: state.order.data.email
    }
  };
}, { getEvent: eventActions["u" /* getEvent */], getOrder: orderActions["Q" /* getOrder */], redirectToComplete: orderActions["X" /* redirectToComplete */], saveAfterCheckoutQuestions: orderActions["_1" /* saveAfterCheckoutQuestions */] })(PaymentSuccess_PaymentSuccess));
// CONCATENATED MODULE: ./routes/afterCheckout/AfterCheckout.js


function AfterCheckout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AfterCheckout__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AfterCheckout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * Used for additional questions after check out
 *
 * @class AfterCheckout
 * @extends {Component}
 */

var AfterCheckout_AfterCheckout = function (_Component) {
  AfterCheckout__inherits(AfterCheckout, _Component);

  function AfterCheckout() {
    AfterCheckout__classCallCheck(this, AfterCheckout);

    return AfterCheckout__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AfterCheckout.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        event = _props.event,
        order = _props.order,
        getEvent = _props.getEvent,
        getOrder = _props.getOrder,
        eventSlug = _props.eventSlug,
        orderId = _props.orderId;

    if (!event.data && !event.loading) {
      getEvent(eventSlug);
    }
    if (!order.data && !order.orderRequest.loading) {
      getOrder(orderId);
    }
  };

  AfterCheckout.prototype.render = function render(_ref) {
    var event = _ref.event,
        order = _ref.order;

    if (!event.data || !order.data) {
      return;
    }
    var background = event.widget ? false : true;
    return Object(preact_min["h"])(
      "div",
      { style: { backgroundColor: "#F7FBFF" } },
      Object(preact_min["h"])(
        Page["a" /* default */],
        { transparent: true, background: background, border: false },
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])(components_PaymentSuccess, { event: event.data, order: order.data })
        )
      )
    );
  };

  return AfterCheckout;
}(preact_min["Component"]);

/* harmony default export */ var afterCheckout_AfterCheckout = (Object(es["b" /* connect */])(function (state, ownProps) {
  return { event: state.event, order: state.order };
}, { getEvent: eventActions["u" /* getEvent */], getOrder: orderActions["Q" /* getOrder */] })(AfterCheckout_AfterCheckout));
// EXTERNAL MODULE: ./assets/images/plus_increment_enabled.svg
var plus_increment_enabled = __webpack_require__("6dLN");
var plus_increment_enabled_default = /*#__PURE__*/__webpack_require__.n(plus_increment_enabled);

// EXTERNAL MODULE: ./assets/images/plus_increment_disabled.svg
var plus_increment_disabled = __webpack_require__("ffDX");
var plus_increment_disabled_default = /*#__PURE__*/__webpack_require__.n(plus_increment_disabled);

// EXTERNAL MODULE: ./assets/images/minus_decrement_disabled.svg
var minus_decrement_disabled = __webpack_require__("6S93");
var minus_decrement_disabled_default = /*#__PURE__*/__webpack_require__.n(minus_decrement_disabled);

// EXTERNAL MODULE: ./assets/images/minus_decrement_enabled.svg
var minus_decrement_enabled = __webpack_require__("QnHY");
var minus_decrement_enabled_default = /*#__PURE__*/__webpack_require__.n(minus_decrement_enabled);

// CONCATENATED MODULE: ./components/fields/NumberIncrementorField.js


function NumberIncrementorField__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NumberIncrementorField__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NumberIncrementorField__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var NumberIncrementorField_NumberIncrementorField = function (_Component) {
  NumberIncrementorField__inherits(NumberIncrementorField, _Component);

  function NumberIncrementorField(props) {
    NumberIncrementorField__classCallCheck(this, NumberIncrementorField);

    var _this = NumberIncrementorField__possibleConstructorReturn(this, _Component.call(this, props));

    _this.changeValue = function (number) {
      var input = _this.props.input;

      input.onChange(number);
    };

    _this.changeValue = _this.changeValue.bind(_this);
    return _this;
  }

  NumberIncrementorField.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        input = _props.input,
        disabled = _props.disabled,
        max = _props.max,
        label = _props.label;
    var value = input.value;

    var minusDisabled = value === 0 || disabled;
    var plusDisabled = value === max || disabled;
    var minusStyle = Object(index_esm["css"])({
      flex: 1,
      background: "url(" + (minusDisabled ? minus_decrement_disabled_default.a : minus_decrement_enabled_default.a) + ") no-repeat",
      maxWidth: 22,
      maxHeight: 22,
      marginLeft: label ? 8 : 0
    });
    var plusStyle = Object(index_esm["css"])({
      flex: 1,
      background: "url(" + (plusDisabled ? plus_increment_disabled_default.a : plus_increment_enabled_default.a) + ") no-repeat",
      maxWidth: 22,
      maxHeight: 22
    });
    var numberStyle = Object(index_esm["css"])({
      flex: 2,
      marginRight: 16,
      marginLeft: 16,
      textAlign: "center"
    });
    var incrementerStyle = Object(index_esm["css"])({
      display: "flex",
      flexDirection: "row",
      width: label ? 168 : 100
    });
    return Object(preact_min["h"])(
      "div",
      { className: incrementerStyle },
      label ? Object(preact_min["h"])(
        "label",
        { "for": input.name, "class": "form-label" },
        label
      ) : "",
      Object(preact_min["h"])("button", {
        "data-cy": input.name + "-minus",
        disabled: minusDisabled || disabled,
        className: minusStyle,
        type: "button",
        onClick: function onClick() {
          return _this2.changeValue(value - 1);
        }
      }),
      Object(preact_min["h"])(
        "h4",
        { className: numberStyle },
        value
      ),
      Object(preact_min["h"])("button", {
        "data-cy": input.name + "-plus",
        disabled: plusDisabled || disabled,
        className: plusStyle,
        type: "button",
        onClick: function onClick() {
          return _this2.changeValue(value + 1);
        }
      })
    );
  };

  return NumberIncrementorField;
}(preact_min["Component"]);

/* harmony default export */ var fields_NumberIncrementorField = (NumberIncrementorField_NumberIncrementorField);
// CONCATENATED MODULE: ./routes/merchandise/MerchandiseCard.js


function MerchandiseCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MerchandiseCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MerchandiseCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MerchandiseCard_MerchandiseCard = function (_Component) {
  MerchandiseCard__inherits(MerchandiseCard, _Component);

  function MerchandiseCard() {
    MerchandiseCard__classCallCheck(this, MerchandiseCard);

    return MerchandiseCard__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  MerchandiseCard.prototype.render = function render(_ref) {
    var itemName = _ref.itemName,
        description = _ref.description,
        itemImages = _ref.itemImages,
        merchandiseOptions = _ref.merchandiseOptions,
        merchOrder = _ref.merchOrder,
        index = _ref.index;

    var hasMoreThanOneOption = merchandiseOptions.length > 1;
    var allSoldOut = merchandiseOptions.reduce(function (cur, merchOpts) {
      return cur && merchOpts.soldOut;
    }, true);
    var chosenOption = merchandiseOptions[merchOrder.selectedOption];
    var maxAmountPerOrder = merchandiseOptions[merchOrder.selectedOption].maxAmountPerOrder;
    var optionSoldOut = chosenOption.soldOut;
    var soldOutText = "";
    if (allSoldOut) {
      soldOutText = "This item has sold out";
    } else if (optionSoldOut) {
      soldOutText = "This option has sold out, other options are still available";
    }
    var cardStyle = Object(index_esm["css"])({
      display: "flex",
      flexDirection: "row",
      borderBottom: "solid 1px",
      borderColor: "#dedede",
      marginBottom: 15,
      "@media(max-width: 600px)": {
        flexDirection: "column"
      }
    });

    var column = Object(index_esm["css"])({
      flex: 1,
      marginRight: 8
    });
    var column2 = Object(index_esm["css"])({
      flex: 2,
      "@media(max-width: 600px)": {
        marginTop: 8
      }
    });
    var optionsStyle = Object(index_esm["css"])({
      display: "flex",
      marginTop: 18,
      flexDirection: "row",
      "@media(max-width: 600px)": {
        flexDirection: "column"
      }
    });
    var priceStyle = Object(index_esm["css"])({
      flex: 1,
      fontSize: 20,
      fontWeight: 600,
      paddingTop: 9,
      "@media(max-width: 600px)": {
        paddingTop: 0
      }
    });
    var optionStyle = Object(index_esm["css"])({
      flex: 2,
      // marginTop: 18,
      "@media(max-width: 600px)": {
        flexDirection: "column",
        borderRadius: 4,
        backgroundColor: "#f7f8ff",
        padding: 12,
        marginBottom: 16
      }
    });

    var labelStyle = Object(index_esm["css"])({
      flex: 2,
      width: "calc(100% - 100px)",
      textAlign: "right",
      paddingRight: 8,
      "@media(max-width: 600px)": {
        width: "100%"
      }
    });

    var optionFields = merchandiseOptions.map(function (opt, i) {
      return { label: opt.optionName, value: i };
    });
    return Object(preact_min["h"])(
      "div",
      { className: cardStyle },
      Object(preact_min["h"])(
        "div",
        { className: column },
        Object(preact_min["h"])(MerchandiseCard_ImageSelector, { itemImages: itemImages })
      ),
      Object(preact_min["h"])(
        "div",
        { className: column2 },
        Object(preact_min["h"])(
          "h4",
          {
            style: {
              fontSize: 16,
              fontWeight: 600
            }
          },
          itemName
        ),
        Object(preact_min["h"])(
          "div",
          { style: { fontSize: 14 } },
          description
        ),
        Object(preact_min["h"])(
          "div",
          { className: optionsStyle },
          Object(preact_min["h"])(
            "h2",
            { className: priceStyle },
            "$" + chosenOption.price
          ),
          Object(preact_min["h"])(
            "div",
            { className: optionStyle },
            hasMoreThanOneOption ? Object(preact_min["h"])(
              "div",
              { style: { display: "flex", flexDirection: "row" } },
              Object(preact_min["h"])(
                "div",
                {
                  style: {
                    flex: 1,
                    textAlign: "right",
                    paddingTop: 8,
                    paddingRight: 9
                  }
                },
                "Options:"
              ),
              Object(preact_min["h"])(
                "div",
                { style: { flex: 2 } },
                Object(preact_min["h"])(redux_form_es["a" /* Field */], {
                  name: "merchOrder[" + index + "].selectedOption",
                  component: fields_OptionsField,
                  options: optionFields,
                  includeSelectOption: false,
                  defaultValue: merchOrder.selectedOption,
                  formName: "merchandise"
                })
              )
            ) : null,
            Object(preact_min["h"])(
              "div",
              {
                style: { display: "flex", flexDirection: "row", marginTop: 16 }
              },
              Object(preact_min["h"])(
                "div",
                { className: labelStyle },
                "Quantity:"
              ),
              Object(preact_min["h"])(
                "div",
                { style: { flex: 1, paddingTop: 0 } },
                Object(preact_min["h"])(redux_form_es["a" /* Field */], {
                  name: "merchOrder[" + index + "].options[" + merchOrder.selectedOption + "].quantity",
                  component: fields_NumberIncrementorField,
                  disabled: optionSoldOut,
                  formName: "merchandise",
                  max: maxAmountPerOrder
                })
              )
            ),
            optionSoldOut ? Object(preact_min["h"])(
              "div",
              {
                style: {
                  fontSize: 12,
                  color: "#DD1C1C",
                  flex: 1,
                  textAlign: "right"
                }
              },
              soldOutText
            ) : null
          )
        )
      )
    );
  };

  return MerchandiseCard;
}(preact_min["Component"]);




var MerchandiseCard_ImageSelector = function ImageSelector(_ref2) {
  var itemImages = _ref2.itemImages;

  //for now just use the first image
  var firstImage = itemImages[0] || {};
  var imageSelectorStyle = Object(index_esm["css"])({
    width: 180,
    "@media(max-width: 600px)": {
      margin: "0 auto"
    }
  });
  var mainImage = Object(index_esm["css"])({
    width: 180,
    height: 180,
    borderRadius: 4
  });
  var subImageList = Object(index_esm["css"])({
    marginTop: 8,
    display: "flex",
    flexDirection: "row",
    width: 180
  });
  var subImage = Object(index_esm["css"])({
    width: 60,
    height: 60,
    borderRadius: 4,
    flex: 1
  });
  return Object(preact_min["h"])(
    "div",
    { className: imageSelectorStyle },
    Object(preact_min["h"])("img", { className: mainImage, src: firstImage.url })
  );
};
// CONCATENATED MODULE: ./routes/merchandise/Merchandise.js
var Merchandise__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Merchandise__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Merchandise__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Merchandise__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var Merchandise_formName = "merchandise";

var Merchandise__ref2 = Object(preact_min["h"])(Page["a" /* default */], null);

var Merchandise__ref3 = Object(preact_min["h"])(
  Page["a" /* default */],
  { background: true, border: true },
  Object(preact_min["h"])(
    Content["a" /* default */],
    null,
    Object(preact_min["h"])(WarningMessage["a" /* default */], {
      title: "Ticket Sales Unavailable",
      message: "Ticket sales have ended"
    })
  )
);

var Merchandise__ref4 = Object(preact_min["h"])(
  Page["a" /* default */],
  { background: true, border: true },
  Object(preact_min["h"])(
    Content["a" /* default */],
    null,
    Object(preact_min["h"])(WarningMessage["a" /* default */], { title: "Ticket Sales Unavailable" })
  )
);

var Merchandise__ref5 = Object(preact_min["h"])(BookingHeader["a" /* default */], null);

var Merchandise__ref6 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var Merchandise__ref7 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var Merchandise__ref8 = Object(preact_min["h"])(components_YourOrder, { allowDiscountsAdd: false });

var Merchandise_Merchandise = function (_Component) {
  Merchandise__inherits(Merchandise, _Component);

  function Merchandise() {
    Merchandise__classCallCheck(this, Merchandise);

    var _this = Merchandise__possibleConstructorReturn(this, _Component.call(this));

    _this.createMerchandise = _this.createMerchandise.bind(_this);
    return _this;
  }

  Merchandise.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        orderId = _props.orderId,
        getEvent = _props.getEvent,
        eventSlug = _props.eventSlug,
        listMerchandise = _props.listMerchandise,
        getMerchandise = _props.getMerchandise,
        merchandise = _props.merchandise,
        event = _props.event,
        order = _props.order;

    if (!event.data && !event.loading) {
      getEvent(eventSlug, undefined, false, orderId);
    }
    if (!merchandise.listMerch.data && !merchandise.listMerch.loading) {
      listMerchandise(orderId);
      getMerchandise(orderId);
    }
    Object(BrowserUtils["a" /* pageChange */])("Merchandise", event);
  };

  Merchandise.prototype.getMerchSelected = function getMerchSelected(merch) {
    if (!merch) {
      return 0;
    }
    var numberSelected = merch.reduce(function (total, item) {
      var optionsSelected = item.options.reduce(function (total, option) {
        var quantity = option.quantity ? option.quantity : 0;
        return total + quantity;
      }, 0);
      return total + optionsSelected;
    }, 0);
    return numberSelected;
  };

  Merchandise.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props2 = this.props,
        merchOrder = _props2.merchOrder,
        loadSummary = _props2.loadSummary,
        event = _props2.event,
        ticketSelection = _props2.ticketSelection,
        order = _props2.order,
        merchandise = _props2.merchandise;

    if (!merchandise.merch.loading) {
      var lastMerchLength = this.getMerchSelected(prevProps.merchOrder);
      var merchLength = this.getMerchSelected(merchOrder);

      if (merchLength !== lastMerchLength) {
        loadSummary(event.id, ticketSelection.tickets, order.data.clientDonation, order, merchOrder);
      }
    }
  };

  Merchandise.prototype.createMerchandise = function createMerchandise(merchData) {
    var _props3 = this.props,
        order = _props3.order,
        event = _props3.event,
        createMerchandiseOrder = _props3.createMerchandiseOrder;

    createMerchandiseOrder(event.data.slug, order.data._id, merchData.merchOrder);
  };

  Merchandise.prototype.render = function render(_ref) {
    var event = _ref.event,
        merchandise = _ref.merchandise,
        merchOrder = _ref.merchOrder,
        order = _ref.order;

    var isManualOrder = determineManualOrder();
    if (event.loading || !event.data) {
      return Merchandise__ref2;
    }
    if (event.data.suspendSales && !isManualOrder) {
      return Merchandise__ref3;
    }
    if (!event.data.validDates.length && !isManualOrder) {
      return Merchandise__ref4;
    }
    return Object(preact_min["h"])(
      Page["a" /* default */],
      null,
      Object(preact_min["h"])(
        Content["a" /* default */],
        null,
        Merchandise__ref5,
        Object(preact_min["h"])(
          TwoCols["a" /* default */],
          null,
          Object(preact_min["h"])(
            "div",
            null,
            merchandise.listMerch.loading || merchandise.merch.loading || event.loading || !event.data || !order.data ? Merchandise__ref6 : Object(preact_min["h"])(
              "div",
              null,
              Object(preact_min["h"])(Merchandise_MerchForm, {
                merchandise: merchandise,
                merchOrder: merchOrder,
                createMerchandise: this.createMerchandise
              })
            )
          ),
          !order.data || !event.data ? Merchandise__ref7 : Merchandise__ref8
        )
      )
    );
  };

  return Merchandise;
}(preact_min["Component"]);

var Merchandise__ref10 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var Merchandise__ref11 = Object(preact_min["h"])(
  "h2",
  null,
  "Add-ons"
);

var Merchandise__ref12 = Object(preact_min["h"])(CountDown["a" /* default */], null);

var Merchandise_MerchForm = function MerchForm(_ref9) {
  var merchandise = _ref9.merchandise,
      merchOrder = _ref9.merchOrder,
      createMerchandise = _ref9.createMerchandise,
      handleSubmit = _ref9.handleSubmit;
  var listMerch = merchandise.listMerch,
      merch = merchandise.merch;
  var data = listMerch.data;

  if (!merchOrder) {
    return Merchandise__ref10;
  }
  var topLineStyle = Object(index_esm["css"])({
    borderBottom: "solid 1px",
    borderColor: "#dedede",
    marginBottom: 15
  });
  return Object(preact_min["h"])(
    "form",
    { onSubmit: handleSubmit(createMerchandise) },
    Merchandise__ref11,
    Object(preact_min["h"])(
      "div",
      { className: topLineStyle },
      Merchandise__ref12,
      merch.error ? Object(preact_min["h"])(
        "div",
        {
          style: {
            fontSize: 12,
            color: "#DD1C1C",
            textAlign: "left"
          }
        },
        merch.error
      ) : null
    ),
    Object(preact_min["h"])(
      "div",
      null,
      data.map(function (merch, index) {
        return Object(preact_min["h"])(MerchandiseCard_MerchandiseCard, Merchandise__extends({}, merch, {
          merchOrder: merchOrder[index],
          index: index
        }));
      })
    ),
    Object(preact_min["h"])(
      ActionBar["a" /* default */],
      null,
      Object(preact_min["h"])(
        ActionButton["a" /* default */],
        {
          disabled: merch.loading,
          loading: merch.loading,
          dataCY: "EnterDetails"
        },
        "Enter Details"
      )
    )
  );
};

var Merchandise_selector = Object(redux_form_es["d" /* formValueSelector */])(Merchandise_formName);

Merchandise_MerchForm = Object(redux_form_es["f" /* reduxForm */])({
  form: Merchandise_formName,
  destroyOnUnmount: true,
  onSubmitFail: function onSubmitFail(errors) {
    scrollToErrors();
  }
})(Merchandise_MerchForm);

Merchandise_MerchForm = Object(es["b" /* connect */])(function (state) {
  var initialValues = {
    merchOrder: (state.merchandise.listMerch.data || []).map(function (merch) {
      var selectedOption = 0;
      if (merch.merchandiseOptions.length > 1) {
        selectedOption = undefined;
        merch.merchandiseOptions.forEach(function (opt, i) {
          if (selectedOption === undefined && !opt.soldOut) {
            selectedOption = i;
          }
        });
      }
      return {
        merchandiseTypeId: merch._id,
        selectedOption: selectedOption,
        merchandiseTypeName: merch.itemName,
        options: merch.merchandiseOptions.map(function (opt) {
          return {
            merchandiseOptionId: opt._id,
            merchandiseOptionName: opt.optionName,
            quantity: 0,
            price: opt.price
          };
        })
      };
    })
  };
  state.merchandise.merch.data.forEach(function (merch) {
    var foundMerch = initialValues.merchOrder.find(function (m) {
      return m.merchandiseTypeId === merch.merchandiseTypeId;
    });
    if (foundMerch) {
      var foundOpt = foundMerch.options.find(function (opt) {
        return opt.merchandiseOptionId === merch.merchandiseOptionId;
      });
      if (foundOpt) {
        foundOpt.quantity = foundOpt.quantity + 1;
      }
    }
  });
  return {
    initialValues: initialValues
  };
}, {})(Merchandise_MerchForm);

/* harmony default export */ var merchandise_Merchandise = (Object(es["b" /* connect */])(function (state) {
  return {
    event: state.event,
    order: state.order,
    merchandise: state.merchandise,
    merchOrder: Merchandise_selector(state, "merchOrder"),
    ticketSelection: state.ticketSelection
  };
}, {
  getEvent: eventActions["u" /* getEvent */],
  listMerchandise: merchandiseActions["m" /* listMerchandise */],
  getOrder: orderActions["Q" /* getOrder */],
  loadSummary: orderSummaryActions["d" /* loadSummary */],
  createMerchandiseOrder: merchandiseActions["k" /* createMerchandiseOrder */],
  getMerchandise: merchandiseActions["l" /* getMerchandise */]
})(Merchandise_Merchandise));
// CONCATENATED MODULE: ./assets/images/IconLeft.js



var IconLeft__ref2 = Object(preact_min["h"])("path", { d: "M0 0h24v24H0z" });

var IconLeft_IconLeft = function IconLeft(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? "#788391" : _ref$color;

  return Object(preact_min["h"])(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    },
    Object(preact_min["h"])(
      "g",
      { fill: "none", "fill-rule": "evenodd" },
      Object(preact_min["h"])("path", { fill: color, d: "M15.4 7.4L14 6l-6 6 6 6 1.4-1.4-4.6-4.6z" }),
      IconLeft__ref2
    )
  );
};

/* harmony default export */ var images_IconLeft = (IconLeft_IconLeft);
// CONCATENATED MODULE: ./assets/images/IconRight.js



var IconRight__ref2 = Object(preact_min["h"])("path", { d: "M0 0h24v24H0z" });

var IconRight_IconRight = function IconRight(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? "#788391" : _ref$color;

  return Object(preact_min["h"])(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    },
    Object(preact_min["h"])(
      "g",
      { fill: "none", "fill-rule": "evenodd" },
      Object(preact_min["h"])("path", { fill: color, d: "M8 7.4L9.4 6l6 6-6 6L8 16.6l4.6-4.6z" }),
      IconRight__ref2
    )
  );
};

/* harmony default export */ var images_IconRight = (IconRight_IconRight);
// EXTERNAL MODULE: ./assets/images/see-more.svg
var see_more = __webpack_require__("BmeC");
var see_more_default = /*#__PURE__*/__webpack_require__.n(see_more);

// CONCATENATED MODULE: ./components/Pagination.js
var Pagination__templateObject = Pagination__taggedTemplateLiteralLoose(["\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    border: 1px solid #d9d9d9;\n    background-color: #fff;\n    margin-left: 3px;\n    margin-right: 3px;\n    font-size: 12px !important;\n    text-align: center;\n    vertical-align: middle;\n  "], ["\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    border: 1px solid #d9d9d9;\n    background-color: #fff;\n    margin-left: 3px;\n    margin-right: 3px;\n    font-size: 12px !important;\n    text-align: center;\n    vertical-align: middle;\n  "]),
    Pagination__templateObject2 = Pagination__taggedTemplateLiteralLoose(["\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    border: 1px solid #d9d9d9;\n    background-color: #fff;\n    display: flex;\n    justify-content: center;\n    padding: 1px;\n  "], ["\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    border: 1px solid #d9d9d9;\n    background-color: #fff;\n    display: flex;\n    justify-content: center;\n    padding: 1px;\n  "]),
    Pagination__templateObject3 = Pagination__taggedTemplateLiteralLoose(["\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    padding: 1px;\n    position: relative;\n    img:last-child {\n      display: none;\n    }\n    &:hover {\n      img:last-child {\n        display: block;\n      }\n      img:first-child {\n        display: none;\n      }\n    }\n  "], ["\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    padding: 1px;\n    position: relative;\n    img:last-child {\n      display: none;\n    }\n    &:hover {\n      img:last-child {\n        display: block;\n      }\n      img:first-child {\n        display: none;\n      }\n    }\n  "]),
    Pagination__templateObject4 = Pagination__taggedTemplateLiteralLoose(["\n    top: -2px;\n    left: 4px;\n    font-size: 15px;\n    font-weight: 900;\n    position: absolute;\n    letter-spacing: 3px;\n    color: #cccccc;\n  "], ["\n    top: -2px;\n    left: 4px;\n    font-size: 15px;\n    font-weight: 900;\n    position: absolute;\n    letter-spacing: 3px;\n    color: #cccccc;\n  "]),
    Pagination__templateObject5 = Pagination__taggedTemplateLiteralLoose(["\n    &hover: {\n    }\n  "], ["\n    &hover: {\n    }\n  "]),
    Pagination__templateObject6 = Pagination__taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: ", ";\n    margin-top: 32px;\n    @media (max-width: 600px) {\n      justify-content: center;\n    }\n  "], ["\n    display: flex;\n    justify-content: ", ";\n    margin-top: 32px;\n    @media (max-width: 600px) {\n      justify-content: center;\n    }\n  "]),
    Pagination__templateObject7 = Pagination__taggedTemplateLiteralLoose(["\n      border: solid 1px\n        ", " !important;\n      background-color: ", " !important;\n      color: ", " !important;\n    "], ["\n      border: solid 1px\n        ", " !important;\n      background-color: ", " !important;\n      color: ", " !important;\n    "]);



function Pagination__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }









var buttonRepeat = [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4];
var Pagination_styles = {
  button: Object(index_esm["css"])(Pagination__templateObject),
  iconButton: Object(index_esm["css"])(Pagination__templateObject2),
  ellipsisButton: Object(index_esm["css"])(Pagination__templateObject3),
  ellipsis: Object(index_esm["css"])(Pagination__templateObject4),
  leftArrow: Object(index_esm["css"])(Pagination__templateObject5)
};
// create pagination button
var Pagination_Button = function Button(props) {
  var currentPage = props.currentPage,
      selectPagination = props.selectPagination,
      index = props.index,
      value = props.value,
      lastPage = props.lastPage,
      customStyles = props.customStyles;

  var step = currentPage + value;
  var prevCheck = function prevCheck() {
    var checkDiff = lastPage - currentPage;
    // if checkDiff < 4, shows total 5 buttons (prev + current + next)
    if (checkDiff < 4) {
      return checkDiff < index && step > 1;
    }
    // if currentPage > 4, only shows first 2 prev buttons
    if (currentPage > 4 && value < -2) {
      return false;
    }
    return currentPage > -value && currentPage + value !== 1;
  };
  var nextCheck = function nextCheck() {
    // if currentPage < 5, shows total 5 buttons (prev + current + next)
    if (currentPage < 5) {
      return currentPage + value < 6 && step < lastPage;
    }
    // if currentPage > 4, only shows first 2 next buttons
    if (currentPage > 4 && value > 2) {
      return false;
    }
    return currentPage < lastPage - (value - 1) && currentPage + value !== lastPage;
  };
  var conditionCheck = value === 0 ? true : false;
  conditionCheck = value < 0 ? prevCheck() : conditionCheck;
  conditionCheck = value > 0 ? nextCheck() : conditionCheck;

  if (!conditionCheck) {
    return null;
  }
  if (value === 0) {
    return Object(preact_min["h"])(
      "button",
      { className: Pagination_styles.button + " " + customStyles.selectedButton },
      currentPage
    );
  }
  return Object(preact_min["h"])(
    "button",
    {
      className: Pagination_styles.button,
      onClick: step === 0 ? null : function () {
        return selectPagination(step);
      }
    },
    step
  );
};

/**
 * Display pagination
 *
 * @param {*} props
 * @returns
 */

var Pagination__ref = Object(preact_min["h"])("img", { src: see_more_default.a });

var Pagination__ref2 = Object(preact_min["h"])("img", { src: icon_arrow_left_default.a });

var Pagination__ref3 = Object(preact_min["h"])("img", { src: see_more_default.a });

var Pagination__ref4 = Object(preact_min["h"])("img", { src: icon_arrow_right_default.a });

var Pagination_Pagination = function Pagination(props) {
  var _props$totalSize = props.totalSize,
      totalSize = _props$totalSize === undefined ? 0 : _props$totalSize,
      currentPage = props.currentPage,
      selectPagination = props.selectPagination,
      _props$position = props.position,
      position = _props$position === undefined ? "right" : _props$position,
      _props$resultsPerPage = props.resultsPerPage,
      resultsPerPage = _props$resultsPerPage === undefined ? 12 : _props$resultsPerPage,
      _props$theme = props.theme,
      theme = _props$theme === undefined ? null : _props$theme;

  var previousOne = currentPage > 1;
  var lastPage = Math.ceil(totalSize / resultsPerPage);
  var nextOne = currentPage < lastPage;
  var selectEllipsis = function selectEllipsis(isNext) {
    if (isNext) {
      var returnPage = currentPage + 4 > lastPage ? lastPage : currentPage + 4;
      selectPagination(returnPage);
    } else {
      var _returnPage = currentPage - 4 < 1 ? 1 : currentPage - 4;
      selectPagination(_returnPage);
    }
  };
  var justifyContent = "flex-end";
  if (position === "left") {
    justifyContent = "flex-start";
  } else if (position === "center") {
    justifyContent = "center";
  }
  var wrapper = Object(index_esm["css"])(Pagination__templateObject6, justifyContent);
  var customStyles = {
    selectedButton: Object(index_esm["css"])(Pagination__templateObject7, theme && theme.primaryColor ? theme.primaryColor : "#6621c0", theme && theme.primaryColor ? theme.primaryColor : "#6621c0", theme && theme.primaryTextColor ? theme.primaryTextColor : "#fff")
  };
  var hidePagination = resultsPerPage >= totalSize;

  if (hidePagination) {
    return null;
  }
  return Object(preact_min["h"])(
    "div",
    { className: wrapper },
    Object(preact_min["h"])(
      "button",
      {
        className: Pagination_styles.iconButton,
        style: { marginRight: 3 },
        onClick: function onClick() {
          return selectPagination(currentPage - 1);
        },
        disabled: !previousOne
      },
      Object(preact_min["h"])(images_IconLeft, { color: previousOne ? "#323232" : "#dedede" })
    ),
    currentPage !== 1 ? Object(preact_min["h"])(
      "button",
      { className: Pagination_styles.button, onClick: function onClick() {
          return selectPagination(1);
        } },
      "1"
    ) : null,
    currentPage > 4 ? Object(preact_min["h"])(
      "button",
      {
        className: Pagination_styles.ellipsisButton,
        style: { marginRight: 3 },
        onClick: function onClick() {
          return selectEllipsis(false);
        }
      },
      Pagination__ref,
      Pagination__ref2
    ) : null,
    buttonRepeat.map(function (value, index) {
      return Object(preact_min["h"])(Pagination_Button, {
        currentPage: currentPage,
        selectPagination: selectPagination,
        index: index,
        value: value,
        lastPage: lastPage,
        customStyles: customStyles
      });
    }),
    lastPage - currentPage > 3 ? Object(preact_min["h"])(
      "button",
      {
        className: Pagination_styles.ellipsisButton,
        style: { marginRight: 3 },
        onClick: function onClick() {
          return selectEllipsis(true);
        }
      },
      Pagination__ref3,
      Pagination__ref4
    ) : null,
    currentPage !== lastPage ? Object(preact_min["h"])(
      "button",
      {
        className: Pagination_styles.button,
        onClick: function onClick() {
          return selectPagination(lastPage);
        }
      },
      lastPage
    ) : null,
    Object(preact_min["h"])(
      "button",
      {
        className: Pagination_styles.iconButton,
        style: { marginLeft: 3 },
        onClick: function onClick() {
          return selectPagination(currentPage + 1);
        },
        disabled: !nextOne
      },
      Object(preact_min["h"])(images_IconRight, { color: nextOne ? "#323232" : "#dedede" })
    )
  );
};
/* harmony default export */ var components_Pagination = (Pagination_Pagination);
// CONCATENATED MODULE: ./components/TourError.js









var TourError_ic_plane = __webpack_require__("BJd1");
var TourError_ic_binoculars = __webpack_require__("Qq8P");

var TourError_notPublishedClouds = "notPublished/ic_clouds.svg";
var TourError_notFoundClouds = "notFound/ic_clouds.svg";

var TourError_styleImage = Object(index_esm["css"])({
  width: "137px",
  height: "165px",
  marginBottom: "8px"
});

var TourError_TourError = function TourError(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? "notFound" : _ref$type;

  var websiteURL = Object(config["a" /* default */])("WEBSITE_URL");

  var clouds = null;
  var icon = null;
  var heading = null;
  var message = null;
  if (type === "notFound") {
    clouds = TourError_notFoundClouds;
    icon = TourError_ic_binoculars;
    heading = "Tour not Found";
    message = "Check if your tours URL is correct";
    Object(BrowserUtils["a" /* pageChange */])("Tour not found");
  } else if (type === "noTours") {
    clouds = TourError_notFoundClouds;
    icon = TourError_ic_binoculars;
    heading = "No Tours Found";
    message = "";
  } else {
    clouds = TourError_notPublishedClouds;
    icon = TourError_ic_plane;
    heading = "This tour is yet to launch";
    message = "Publish your tour or contact your tour organiser";
    Object(BrowserUtils["a" /* pageChange */])("Tour yet to launch");
  }

  var styleDiv = {
    maxWidth: "800px",
    height: "454px",
    background: "url('../assets/pages/" + clouds + "') no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center 9%",
    textAlign: "center",
    backgroundColor: "#F7FAFF",
    paddingTop: "80px",
    margin: "0 auto"
  };

  if (type === "notFound") {
    styleDiv.maxWidth = "487px";
    styleDiv.padding = "80px 14px";
  }

  var styleHeading = {
    fontWeight: "700",
    marginBottom: "6px"
  };

  var styleMessage = {
    color: "#6F7782",
    fontWeight: "700",
    marginBottom: "20px"
  };

  return Object(preact_min["h"])(
    "div",
    { style: { backgroundColor: "#F7FAFF" } },
    Object(preact_min["h"])(
      "div",
      { style: styleDiv },
      Object(preact_min["h"])(Image["a" /* default */], { src: icon, className: TourError_styleImage, alt: "Error Image" }),
      Object(preact_min["h"])(
        "h2",
        { style: styleHeading },
        heading
      ),
      Object(preact_min["h"])(
        "h3",
        { style: styleMessage },
        message
      )
    )
  );
};
/* harmony default export */ var components_TourError = (TourError_TourError);
// CONCATENATED MODULE: ./routes/tours/FeaturedEventTilesView.js
var FeaturedEventTilesView__templateObject = FeaturedEventTilesView__taggedTemplateLiteralLoose(["\n    max-width: 1000px;\n    max-height: 300px;\n    height: 100%;\n    display: flex;\n    margin-top: 15px;\n    margin-bottom: 15px;\n    border-radius: 4px;\n    overflow: hidden;\n    box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n    @media (max-width: 1000px) {\n      margin-right: 12px;\n      margin-left: 12px;\n    }\n    @media (max-width: 600px) {\n      flex-wrap: wrap;\n      max-width: 100%;\n      max-height: 100%;\n      margin-top: 12px;\n      margin-left: 1px;\n      margin-right: 1px;\n    }\n  "], ["\n    max-width: 1000px;\n    max-height: 300px;\n    height: 100%;\n    display: flex;\n    margin-top: 15px;\n    margin-bottom: 15px;\n    border-radius: 4px;\n    overflow: hidden;\n    box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n    @media (max-width: 1000px) {\n      margin-right: 12px;\n      margin-left: 12px;\n    }\n    @media (max-width: 600px) {\n      flex-wrap: wrap;\n      max-width: 100%;\n      max-height: 100%;\n      margin-top: 12px;\n      margin-left: 1px;\n      margin-right: 1px;\n    }\n  "]),
    FeaturedEventTilesView__templateObject2 = FeaturedEventTilesView__taggedTemplateLiteralLoose(["\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    bottom: 39px;\n    width: 130px;\n    position: absolute;\n    @media (max-width: 600px) {\n      display: none;\n    }\n  "], ["\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    bottom: 39px;\n    width: 130px;\n    position: absolute;\n    @media (max-width: 600px) {\n      display: none;\n    }\n  "]),
    FeaturedEventTilesView__templateObject3 = FeaturedEventTilesView__taggedTemplateLiteralLoose(["\n    text-decoration: none !important;\n    color: inherit !important;\n  "], ["\n    text-decoration: none !important;\n    color: inherit !important;\n  "]),
    FeaturedEventTilesView__templateObject4 = FeaturedEventTilesView__taggedTemplateLiteralLoose(["\n      max-width: 660px;\n      width: 100%;\n      height: 330px;\n      background: url(", ") center center / cover no-repeat\n        rgb(238, 238, 238);\n      @media (max-width: 700px) {\n        max-width: 100%;\n        padding-top: 50%;\n        height: 146px;\n      }\n    "], ["\n      max-width: 660px;\n      width: 100%;\n      height: 330px;\n      background: url(", ") center center / cover no-repeat\n        rgb(238, 238, 238);\n      @media (max-width: 700px) {\n        max-width: 100%;\n        padding-top: 50%;\n        height: 146px;\n      }\n    "]),
    FeaturedEventTilesView__templateObject5 = FeaturedEventTilesView__taggedTemplateLiteralLoose(["\n      width: 100%;\n      max-width: 340px;\n      padding: 32px 24px;\n      position: relative;\n      background: ", ";\n      @media (max-width: 600px) {\n        max-width: 100%;\n        height: 118px;\n        padding: 16px 12px;\n      }\n    "], ["\n      width: 100%;\n      max-width: 340px;\n      padding: 32px 24px;\n      position: relative;\n      background: ", ";\n      @media (max-width: 600px) {\n        max-width: 100%;\n        height: 118px;\n        padding: 16px 12px;\n      }\n    "]),
    FeaturedEventTilesView__templateObject6 = FeaturedEventTilesView__taggedTemplateLiteralLoose(["\n      font-size: 26px;\n      font-weight: 600;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-bottom: 24px;\n      white-space: nowrap;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 16px;\n        margin-bottom: 4px;\n      }\n    "], ["\n      font-size: 26px;\n      font-weight: 600;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-bottom: 24px;\n      white-space: nowrap;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 16px;\n        margin-bottom: 4px;\n      }\n    "]),
    FeaturedEventTilesView__templateObject7 = FeaturedEventTilesView__taggedTemplateLiteralLoose(["\n      font-size: 16px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 14px;\n      }\n    "], ["\n      font-size: 16px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 14px;\n      }\n    "]);



function FeaturedEventTilesView__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }







var FeaturedEventTilesView_styles = {
  wrapper: Object(index_esm["css"])(FeaturedEventTilesView__templateObject),
  buttonContainer: Object(index_esm["css"])(FeaturedEventTilesView__templateObject2),
  link: Object(index_esm["css"])(FeaturedEventTilesView__templateObject3)
};

/**
 * Display tiles view of featured events
 *
 * @param {*} props
 * @returns
 */
var FeaturedEventTilesView_FeaturedEventTilesView = function FeaturedEventTilesView(props) {
  var event = props.event,
      _props$theme = props.theme,
      theme = _props$theme === undefined ? {} : _props$theme,
      showPrice = props.showPrice,
      _props$eventListingLa = props.eventListingLayout,
      eventListingLayout = _props$eventListingLa === undefined ? "eventTitle" : _props$eventListingLa;


  var width = typeof screen !== "undefined" ? screen.width : null;
  var bannerImage = event.featureImage && event.featureImage.url ? event.featureImage.url : null;
  bannerImage = event.socialImage && event.socialImage.url ? event.socialImage.url : bannerImage;
  bannerImage = event.bannerImage && event.bannerImage.url ? event.bannerImage.url : bannerImage;
  var eventLink = "/" + event.slug;
  var mobileEventLink = width < 600 ? eventLink : null;
  var eventTitle = eventListingLayout === "eventTitle" ? event.name : event.location.titleLocation;
  var eventInfo = eventListingLayout === "eventTitle" ? event.location.titleLocation : event.name;

  var customStyles = {
    image: Object(index_esm["css"])(FeaturedEventTilesView__templateObject4, bannerImage),
    rightCol: Object(index_esm["css"])(FeaturedEventTilesView__templateObject5, Object(Format["hexToRgba"])(theme.eventCardBackgroundColor, theme.cardAndBarOpacity)),
    title: Object(index_esm["css"])(FeaturedEventTilesView__templateObject6, theme.eventCardBackgroundColor === "#ffffff" ? theme.cardTitleColor : "#ffffff"),
    contents: Object(index_esm["css"])(FeaturedEventTilesView__templateObject7, theme.eventCardBackgroundColor === "#ffffff" ? theme.cardTitleColor : "#ffffff")
  };

  return Object(preact_min["h"])(
    "div",
    { className: "featured-event-tile" },
    Object(preact_min["h"])(
      match["Link"],
      { href: mobileEventLink, className: FeaturedEventTilesView_styles.link },
      Object(preact_min["h"])(
        "div",
        { className: FeaturedEventTilesView_styles.wrapper },
        Object(preact_min["h"])("div", { className: customStyles.image }),
        Object(preact_min["h"])(
          "div",
          { className: customStyles.rightCol },
          Object(preact_min["h"])(
            "div",
            { className: customStyles.title },
            eventTitle
          ),
          Object(preact_min["h"])(
            "div",
            { className: customStyles.contents },
            event.dates[0].display.combined
          ),
          Object(preact_min["h"])(
            "div",
            { className: customStyles.contents },
            eventInfo
          ),
          showPrice ? Object(preact_min["h"])(
            "div",
            { className: customStyles.contents },
            event.ticketsPriceStr
          ) : null,
          Object(preact_min["h"])(
            "div",
            { className: FeaturedEventTilesView_styles.buttonContainer },
            Object(preact_min["h"])(
              match["Link"],
              { href: eventLink },
              Object(preact_min["h"])(
                components_Button["a" /* default */],
                {
                  tourTheme: theme,
                  type: "primary",
                  ariaLabel: "Get Tickets"
                },
                theme.ticketButtonText
              )
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ var tours_FeaturedEventTilesView = (FeaturedEventTilesView_FeaturedEventTilesView);
// CONCATENATED MODULE: ./routes/tours/EventImageListView.js
var EventImageListView__templateObject = EventImageListView__taggedTemplateLiteralLoose(["\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n    margin-left: 16px;\n    @media (max-width: 600px) {\n      max-width: 292px;\n      height: 118px;\n    }\n  "], ["\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n    margin-left: 16px;\n    @media (max-width: 600px) {\n      max-width: 292px;\n      height: 118px;\n    }\n  "]),
    EventImageListView__templateObject2 = EventImageListView__taggedTemplateLiteralLoose(["\n    margin-left: auto;\n    margin-right: auto;\n    right: 0;\n    bottom: 0;\n    position: absolute;\n    @media (max-width: 600px) {\n      display: none;\n    }\n  "], ["\n    margin-left: auto;\n    margin-right: auto;\n    right: 0;\n    bottom: 0;\n    position: absolute;\n    @media (max-width: 600px) {\n      display: none;\n    }\n  "]),
    EventImageListView__templateObject3 = EventImageListView__taggedTemplateLiteralLoose(["\n    text-decoration: none !important;\n    color: inherit !important;\n  "], ["\n    text-decoration: none !important;\n    color: inherit !important;\n  "]),
    EventImageListView__templateObject4 = EventImageListView__taggedTemplateLiteralLoose(["\n      width: 100%;\n      max-width: 720px;\n      max-height: 132px;\n      height: 100%;\n      display: flex;\n      margin-bottom: 12px;\n      border-radius: 4px;\n      overflow: hidden;\n      padding: 16px;\n      background: ", ";\n      box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n      @media (max-width: 600px) {\n        margin-top: 12px;\n        flex-direction: column;\n        max-width: auto;\n        width: 100%;\n        max-height: 100%;\n        padding: 0px;\n      }\n    "], ["\n      width: 100%;\n      max-width: 720px;\n      max-height: 132px;\n      height: 100%;\n      display: flex;\n      margin-bottom: 12px;\n      border-radius: 4px;\n      overflow: hidden;\n      padding: 16px;\n      background: ", ";\n      box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n      @media (max-width: 600px) {\n        margin-top: 12px;\n        flex-direction: column;\n        max-width: auto;\n        width: 100%;\n        max-height: 100%;\n        padding: 0px;\n      }\n    "]),
    EventImageListView__templateObject5 = EventImageListView__taggedTemplateLiteralLoose(["\n      width: 200px;\n      min-width: 200px;\n      height: 100px;\n      border-radius: 4px;\n      background: url(", ") center center / cover no-repeat\n        rgb(238, 238, 238);\n      @media (max-width: 600px) {\n        width: 100%;\n        max-width: 100%;\n        height: 100%;\n        border-radius: 0px;\n        padding-top: 50%;\n      }\n    "], ["\n      width: 200px;\n      min-width: 200px;\n      height: 100px;\n      border-radius: 4px;\n      background: url(", ") center center / cover no-repeat\n        rgb(238, 238, 238);\n      @media (max-width: 600px) {\n        width: 100%;\n        max-width: 100%;\n        height: 100%;\n        border-radius: 0px;\n        padding-top: 50%;\n      }\n    "]),
    EventImageListView__templateObject6 = EventImageListView__taggedTemplateLiteralLoose(["\n      font-size: 14px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: ", ";\n      max-width: 350px;\n      width: 100%;\n      @media (max-width: 600px) {\n        font-size: 14px;\n      }\n    "], ["\n      font-size: 14px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: ", ";\n      max-width: 350px;\n      width: 100%;\n      @media (max-width: 600px) {\n        font-size: 14px;\n      }\n    "]),
    EventImageListView__templateObject7 = EventImageListView__taggedTemplateLiteralLoose(["\n      font-size: 18px;\n      font-weight: 600;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-bottom: 4px;\n      white-space: nowrap;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 16px;\n        margin-top: 16px;\n      }\n    "], ["\n      font-size: 18px;\n      font-weight: 600;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-bottom: 4px;\n      white-space: nowrap;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 16px;\n        margin-top: 16px;\n      }\n    "]);



function EventImageListView__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }







var EventImageListView_styles = {
  rightCol: Object(index_esm["css"])(EventImageListView__templateObject),
  buttonContainer: Object(index_esm["css"])(EventImageListView__templateObject2),
  link: Object(index_esm["css"])(EventImageListView__templateObject3)
};
/**
 * Display tiles view of featured events
 *
 * @param {*} props
 * @returns
 */
var EventImageListView_EventImageListView = function EventImageListView(props) {
  var event = props.event,
      _props$theme = props.theme,
      theme = _props$theme === undefined ? {} : _props$theme,
      showPrice = props.showPrice,
      eventListingLayout = props.eventListingLayout;


  var bannerImage = event.featureImage && event.featureImage.url ? event.featureImage.url : null;
  bannerImage = event.socialImage && event.socialImage.url ? event.socialImage.url : bannerImage;
  bannerImage = event.bannerImage && event.bannerImage.url ? event.bannerImage.url : bannerImage;
  var eventLink = "/" + event.slug;
  var eventTitle = eventListingLayout === "eventTitle" ? event.name : event.location.titleLocation;
  var eventInfo = eventListingLayout === "eventTitle" ? event.location.titleLocation : event.name;
  var width = typeof screen !== "undefined" ? screen.width : null;
  var mobileEventLink = width < 600 ? eventLink : null;
  var customStyles = {
    wrapper: Object(index_esm["css"])(EventImageListView__templateObject4, Object(Format["hexToRgba"])(theme.eventCardBackgroundColor, theme.cardAndBarOpacity)),
    image: Object(index_esm["css"])(EventImageListView__templateObject5, bannerImage),
    contents: Object(index_esm["css"])(EventImageListView__templateObject6, theme.eventCardBackgroundColor === "#ffffff" ? "#323232" : "#ffffff"),
    title: Object(index_esm["css"])(EventImageListView__templateObject7, theme.eventCardBackgroundColor === "#ffffff" ? "#323232" : "#ffffff")
  };

  return Object(preact_min["h"])(
    match["Link"],
    { href: mobileEventLink, className: EventImageListView_styles.link },
    Object(preact_min["h"])(
      "div",
      { className: customStyles.wrapper },
      Object(preact_min["h"])("div", { className: customStyles.image }),
      Object(preact_min["h"])(
        "div",
        { className: EventImageListView_styles.rightCol },
        Object(preact_min["h"])(
          "div",
          { className: customStyles.title },
          eventTitle
        ),
        Object(preact_min["h"])(
          "div",
          { className: customStyles.contents },
          event.dates[0].display.combined
        ),
        showPrice ? Object(preact_min["h"])(
          "div",
          { className: customStyles.contents },
          event.ticketsPriceStr
        ) : null,
        Object(preact_min["h"])(
          "div",
          { className: customStyles.contents },
          eventInfo
        ),
        Object(preact_min["h"])(
          "div",
          { className: EventImageListView_styles.buttonContainer },
          Object(preact_min["h"])(
            match["Link"],
            { href: eventLink },
            Object(preact_min["h"])(
              components_Button["a" /* default */],
              { tourTheme: theme, type: "primary", ariaLabel: "Get Tickets" },
              theme.ticketButtonText
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ var tours_EventImageListView = (EventImageListView_EventImageListView);
// CONCATENATED MODULE: ./routes/tours/EventDateListView.js
var EventDateListView__templateObject = EventDateListView__taggedTemplateLiteralLoose(["\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n    margin-left: 24px;\n    padding-top: 15px;\n    @media (max-width: 600px) {\n      padding-right: 50px;\n      height: 118px;\n    }\n  "], ["\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n    margin-left: 24px;\n    padding-top: 15px;\n    @media (max-width: 600px) {\n      padding-right: 50px;\n      height: 118px;\n    }\n  "]),
    EventDateListView__templateObject2 = EventDateListView__taggedTemplateLiteralLoose(["\n    height: 36px;\n    position: absolute;\n    margin-top: auto;\n    margin-bottom: auto;\n    top: 0;\n    bottom: 0;\n    right: 16px;\n  "], ["\n    height: 36px;\n    position: absolute;\n    margin-top: auto;\n    margin-bottom: auto;\n    top: 0;\n    bottom: 0;\n    right: 16px;\n  "]),
    EventDateListView__templateObject3 = EventDateListView__taggedTemplateLiteralLoose(["\n    text-decoration: none !important;\n    color: inherit !important;\n  "], ["\n    text-decoration: none !important;\n    color: inherit !important;\n  "]),
    EventDateListView__templateObject4 = EventDateListView__taggedTemplateLiteralLoose(["\n    @media (max-width: 600px) {\n      display: none;\n    }\n  "], ["\n    @media (max-width: 600px) {\n      display: none;\n    }\n  "]),
    EventDateListView__templateObject5 = EventDateListView__taggedTemplateLiteralLoose(["\n    display: none;\n    @media (max-width: 600px) {\n      display: inherit;\n    }\n  "], ["\n    display: none;\n    @media (max-width: 600px) {\n      display: inherit;\n    }\n  "]),
    EventDateListView__templateObject6 = EventDateListView__taggedTemplateLiteralLoose(["\n      width: 100%;\n      height: ", ";\n      display: flex;\n      background: ", ";\n      border-bottom: ", ";\n    "], ["\n      width: 100%;\n      height: ", ";\n      display: flex;\n      background: ", ";\n      border-bottom: ", ";\n    "]),
    EventDateListView__templateObject7 = EventDateListView__taggedTemplateLiteralLoose(["\n      width: 79px;\n      padding-top: 21px;\n      // border-right: 8px dotted\n      //   ", ";\n      border-right: 8px dotted #fafafa;\n      vertical-align: middle;\n      text-align: center;\n      margin-bottom: 3px;\n      margin-top: 3px;\n    "], ["\n      width: 79px;\n      padding-top: 21px;\n      // border-right: 8px dotted\n      //   ", ";\n      border-right: 8px dotted #fafafa;\n      vertical-align: middle;\n      text-align: center;\n      margin-bottom: 3px;\n      margin-top: 3px;\n    "]),
    EventDateListView__templateObject8 = EventDateListView__taggedTemplateLiteralLoose(["\n      font-size: 16px;\n      font-weight: 600;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 14px;\n      }\n    "], ["\n      font-size: 16px;\n      font-weight: 600;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 14px;\n      }\n    "]),
    EventDateListView__templateObject9 = EventDateListView__taggedTemplateLiteralLoose(["\n      font-size: 26px;\n      font-weight: 600;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 20px;\n      }\n    "], ["\n      font-size: 26px;\n      font-weight: 600;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 20px;\n      }\n    "]),
    EventDateListView__templateObject10 = EventDateListView__taggedTemplateLiteralLoose(["\n      max-width: 470px;\n      width: 100%;\n      font-size: 18px;\n      font-weight: 600;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-bottom: 4px;\n      white-space: nowrap;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 16px;\n      }\n    "], ["\n      max-width: 470px;\n      width: 100%;\n      font-size: 18px;\n      font-weight: 600;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-bottom: 4px;\n      white-space: nowrap;\n      color: ", ";\n      @media (max-width: 600px) {\n        font-size: 16px;\n      }\n    "]),
    EventDateListView__templateObject11 = EventDateListView__taggedTemplateLiteralLoose(["\n      font-size: 14px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: ", ";\n      max-width: 470px;\n      width: 100%;\n      @media (max-width: 600px) {\n        font-size: 14px;\n      }\n    "], ["\n      font-size: 14px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: ", ";\n      max-width: 470px;\n      width: 100%;\n      @media (max-width: 600px) {\n        font-size: 14px;\n      }\n    "]);



function EventDateListView__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }








var EventDateListView_styles = {
  rightCol: Object(index_esm["css"])(EventDateListView__templateObject),
  buttonContainer: Object(index_esm["css"])(EventDateListView__templateObject2),
  link: Object(index_esm["css"])(EventDateListView__templateObject3),
  button: Object(index_esm["css"])(EventDateListView__templateObject4),
  buttonIcon: Object(index_esm["css"])(EventDateListView__templateObject5)
};
/**
 * Display tiles view of featured events
 *
 * @param {*} props
 * @returns
 */
var EventDateListView_EventDateListView = function EventDateListView(props) {
  var event = props.event,
      _props$theme = props.theme,
      theme = _props$theme === undefined ? {} : _props$theme,
      showPrice = props.showPrice,
      eventListingLayout = props.eventListingLayout,
      _props$noBottomBorder = props.noBottomBorder,
      noBottomBorder = _props$noBottomBorder === undefined ? false : _props$noBottomBorder;


  var bannerImage = event.featureImage && event.featureImage.url ? event.featureImage.url : null;
  bannerImage = event.socialImage && event.socialImage.url ? event.socialImage.url : bannerImage;
  var eventLink = "/" + event.slug;
  var eventTitle = eventListingLayout === "eventTitle" ? event.name : event.location.titleLocation;
  var eventInfo = eventListingLayout === "eventTitle" ? event.location.titleLocation : event.name;
  var customStyles = {
    wrapper: Object(index_esm["css"])(EventDateListView__templateObject6, showPrice ? "121px" : "100px", Object(Format["hexToRgba"])(theme.eventCardBackgroundColor, theme.cardAndBarOpacity), noBottomBorder ? "none" : "1px solid #dedede"),
    dateCol: Object(index_esm["css"])(EventDateListView__templateObject7, Object(Format["hexToRgba"])(theme.eventCardBackgroundColor, theme.cardAndBarOpacity)),
    month: Object(index_esm["css"])(EventDateListView__templateObject8, theme.eventCardBackgroundColor === "#ffffff" ? "#5a626c" : "#ffffff"),
    day: Object(index_esm["css"])(EventDateListView__templateObject9, theme.eventCardBackgroundColor === "#ffffff" ? "#323232" : "#ffffff"),
    title: Object(index_esm["css"])(EventDateListView__templateObject10, theme.eventCardBackgroundColor === "#ffffff" ? "#323232" : "#ffffff"),
    contents: Object(index_esm["css"])(EventDateListView__templateObject11, theme.eventCardBackgroundColor === "#ffffff" ? "#5a626c" : "#ffffff")
  };

  return Object(preact_min["h"])(
    "div",
    { className: customStyles.wrapper },
    Object(preact_min["h"])(
      "div",
      { className: customStyles.dateCol },
      Object(preact_min["h"])(
        "div",
        { className: customStyles.month },
        event.dates[0].displayMonth
      ),
      Object(preact_min["h"])(
        "div",
        { className: customStyles.day },
        event.dates[0].displayDay
      )
    ),
    Object(preact_min["h"])(
      "div",
      { className: EventDateListView_styles.rightCol },
      Object(preact_min["h"])(
        "div",
        { className: customStyles.title },
        eventTitle
      ),
      Object(preact_min["h"])(
        "div",
        { className: customStyles.contents },
        event.dates[0].display.time
      ),
      showPrice ? Object(preact_min["h"])(
        "div",
        { className: customStyles.contents },
        event.ticketsPriceStr
      ) : null,
      Object(preact_min["h"])(
        "div",
        { className: customStyles.contents },
        eventInfo
      ),
      Object(preact_min["h"])(
        "div",
        { className: EventDateListView_styles.buttonContainer },
        Object(preact_min["h"])(
          match["Link"],
          { href: eventLink },
          Object(preact_min["h"])(
            "div",
            { className: EventDateListView_styles.button },
            Object(preact_min["h"])(
              components_Button["a" /* default */],
              { tourTheme: theme, type: "primary", ariaLabel: "Get Tickets" },
              theme.ticketButtonText
            )
          ),
          Object(preact_min["h"])("img", { src: icon_arrow_right_default.a, className: EventDateListView_styles.buttonIcon })
        )
      )
    )
  );
};

/* harmony default export */ var tours_EventDateListView = (EventDateListView_EventDateListView);
// CONCATENATED MODULE: ./routes/tours/FeaturedEvents.js






/**
 * Display featured event list of tour page
 *
 * @param {*} props
 * @returns
 */
var FeaturedEvents_FeaturedEvents = function FeaturedEvents(props) {
  var _props$events = props.events,
      events = _props$events === undefined ? [] : _props$events,
      pageLayout = props.pageLayout,
      theme = props.theme,
      listViewType = props.listViewType,
      showPrice = props.showPrice,
      eventListingLayout = props.eventListingLayout;


  var ReturnComponent = tours_FeaturedEventTilesView;
  ReturnComponent = pageLayout === "list" && listViewType == "image" ? tours_EventImageListView : ReturnComponent;
  ReturnComponent = pageLayout === "list" && listViewType == "date" ? tours_EventDateListView : ReturnComponent;

  return Object(preact_min["h"])(
    "div",
    null,
    events.map(function (event) {
      return Object(preact_min["h"])(ReturnComponent, {
        event: event,
        featured: true,
        theme: theme,
        showPrice: showPrice,
        eventListingLayout: eventListingLayout
      });
    })
  );
};

/* harmony default export */ var tours_FeaturedEvents = (FeaturedEvents_FeaturedEvents);
// CONCATENATED MODULE: ./routes/tours/EventTilesView.js
var EventTilesView__templateObject = EventTilesView__taggedTemplateLiteralLoose(["\n    text-decoration: none !important;\n    color: inherit !important;\n  "], ["\n    text-decoration: none !important;\n    color: inherit !important;\n  "]),
    EventTilesView__templateObject2 = EventTilesView__taggedTemplateLiteralLoose(["\n      margin-left: auto;\n      width: 320px;\n      height: ", ";\n      margin-top: 10px;\n      margin-bottom: 10px;\n      margin-right: ", ";\n      border-radius: 4px;\n      overflow: hidden;\n      box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n      @media (max-width: 900px) {\n        margin: 6px;\n      }\n      @media (max-width: 600px) {\n        width: auto;\n        margin-top: 12px;\n        margin-left: 1px;\n        margin-right: 1px;\n        max-width: 100%;\n        height: 100%;\n      }\n    "], ["\n      margin-left: auto;\n      width: 320px;\n      height: ", ";\n      margin-top: 10px;\n      margin-bottom: 10px;\n      margin-right: ", ";\n      border-radius: 4px;\n      overflow: hidden;\n      box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n      @media (max-width: 900px) {\n        margin: 6px;\n      }\n      @media (max-width: 600px) {\n        width: auto;\n        margin-top: 12px;\n        margin-left: 1px;\n        margin-right: 1px;\n        max-width: 100%;\n        height: 100%;\n      }\n    "]),
    EventTilesView__templateObject3 = EventTilesView__taggedTemplateLiteralLoose(["\n      max-width: 320px;\n      width: 100%;\n      padding-top: 50%;\n      background: url(", ") center center / cover no-repeat\n        rgb(238, 238, 238);\n      @media (max-width: 600px) {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 0px;\n      }\n    "], ["\n      max-width: 320px;\n      width: 100%;\n      padding-top: 50%;\n      background: url(", ") center center / cover no-repeat\n        rgb(238, 238, 238);\n      @media (max-width: 600px) {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 0px;\n      }\n    "]),
    EventTilesView__templateObject4 = EventTilesView__taggedTemplateLiteralLoose(["\n      width: 100%;\n      max-width: 320px;\n      padding: 16px 12px;\n      background: ", ";\n      height: 100%;\n      @media (max-width: 600px) {\n        max-width: 100%;\n      }\n    "], ["\n      width: 100%;\n      max-width: 320px;\n      padding: 16px 12px;\n      background: ", ";\n      height: 100%;\n      @media (max-width: 600px) {\n        max-width: 100%;\n      }\n    "]),
    EventTilesView__templateObject5 = EventTilesView__taggedTemplateLiteralLoose(["\n      font-size: 18px;\n      font-weight: 600;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-bottom: 6px;\n      white-space: nowrap;\n      color: ", ";\n    "], ["\n      font-size: 18px;\n      font-weight: 600;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-bottom: 6px;\n      white-space: nowrap;\n      color: ", ";\n    "]),
    EventTilesView__templateObject6 = EventTilesView__taggedTemplateLiteralLoose(["\n      font-size: 14px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: ", ";\n    "], ["\n      font-size: 14px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: ", ";\n    "]);



function EventTilesView__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }




var EventTilesView_styles = {
  link: Object(index_esm["css"])(EventTilesView__templateObject)
};
/**
 * Display tiles view of events
 *
 * @param {*} props
 * @returns
 */
var EventTilesView_EventTilesView = function EventTilesView(props) {
  var event = props.event,
      noRightMargin = props.noRightMargin,
      showPrice = props.showPrice,
      eventListingLayout = props.eventListingLayout,
      theme = props.theme;

  var eventLink = "/" + event.slug;
  var bannerImage = event.featureImage && event.featureImage.url ? event.featureImage.url : null;
  bannerImage = event.socialImage && event.socialImage.url ? event.socialImage.url : bannerImage;
  bannerImage = event.bannerImage && event.bannerImage.url ? event.bannerImage.url : bannerImage;
  var eventTitle = eventListingLayout === "eventTitle" ? event.name : event.location.titleLocation;
  var eventInfo = eventListingLayout === "eventTitle" ? event.location.titleLocation : event.name;

  var customStyles = {
    wrapper: Object(index_esm["css"])(EventTilesView__templateObject2, showPrice ? "308px" : "288px", noRightMargin ? "0px" : "20px"),
    image: Object(index_esm["css"])(EventTilesView__templateObject3, bannerImage),
    contentsRow: Object(index_esm["css"])(EventTilesView__templateObject4, Object(Format["hexToRgba"])(theme.eventCardBackgroundColor, theme.cardAndBarOpacity)),
    title: Object(index_esm["css"])(EventTilesView__templateObject5, theme.eventCardBackgroundColor === "#ffffff" ? theme.cardTitleColor : "#ffffff"),
    contents: Object(index_esm["css"])(EventTilesView__templateObject6, theme.eventCardBackgroundColor === "#ffffff" ? theme.cardTextColor : "#ffffff")
  };

  return Object(preact_min["h"])(
    "div",
    null,
    Object(preact_min["h"])(
      "a",
      { href: eventLink, className: EventTilesView_styles.link, "aria-label": "Get Tickets" },
      Object(preact_min["h"])(
        "div",
        { className: customStyles.wrapper },
        Object(preact_min["h"])("div", { className: customStyles.image }),
        Object(preact_min["h"])(
          "div",
          { className: customStyles.contentsRow },
          Object(preact_min["h"])(
            "div",
            { className: customStyles.title },
            eventTitle
          ),
          Object(preact_min["h"])(
            "div",
            { className: customStyles.contents },
            event.dates[0].display.combined
          ),
          Object(preact_min["h"])(
            "div",
            { className: customStyles.contents },
            eventInfo
          ),
          showPrice ? Object(preact_min["h"])(
            "div",
            { className: customStyles.contents },
            event.ticketsPriceStr
          ) : null
        )
      )
    )
  );
};

/* harmony default export */ var tours_EventTilesView = (EventTilesView_EventTilesView);
// CONCATENATED MODULE: ./routes/tours/Events.js
var Events__templateObject = Events__taggedTemplateLiteralLoose(["\n      display: ", ";\n      flex-wrap: wrap;\n      margin-left: auto;\n      margin-right: auto;\n      @media (max-width: 1000px) {\n        justify-content: center;\n      }\n      @media (max-width: 600px) {\n        display: inherit;\n      }\n    "], ["\n      display: ", ";\n      flex-wrap: wrap;\n      margin-left: auto;\n      margin-right: auto;\n      @media (max-width: 1000px) {\n        justify-content: center;\n      }\n      @media (max-width: 600px) {\n        display: inherit;\n      }\n    "]);



function Events__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }







/**
 * Display event list of tour page
 *
 * @param {*} props
 * @returns
 */
var Events_Events = function Events(props) {
  var events = props.events,
      pageLayout = props.pageLayout,
      listViewType = props.listViewType,
      theme = props.theme,
      showPrice = props.showPrice,
      eventListingLayout = props.eventListingLayout;

  var styles = {
    wrapper: Object(index_esm["css"])(Events__templateObject, pageLayout === "tiles" ? "flex" : "inherit")
  };
  var ReturnComponent = tours_EventTilesView;
  ReturnComponent = pageLayout === "list" && listViewType == "image" ? tours_EventImageListView : ReturnComponent;
  ReturnComponent = pageLayout === "list" && listViewType == "date" ? tours_EventDateListView : ReturnComponent;
  return Object(preact_min["h"])(
    "div",
    { className: styles.wrapper },
    events.map(function (event, index) {
      // used in EventTilesView
      var noRightMargin = (index + 1) % 3 === 0;
      // used in EventDateListView
      var noBottomBorder = events.length === index + 1;
      return Object(preact_min["h"])(ReturnComponent, {
        event: event,
        featured: true,
        theme: theme,
        noRightMargin: noRightMargin,
        showPrice: showPrice,
        eventListingLayout: eventListingLayout,
        noBottomBorder: noBottomBorder
      });
    })
  );
};

/* harmony default export */ var tours_Events = (Events_Events);
// CONCATENATED MODULE: ./routes/tours/Sponsors.js
var Sponsors__templateObject = Sponsors__taggedTemplateLiteralLoose(["\n    width: 140px;\n    height: 80px;\n    margin-left: 12px;\n    margin-right: 12px;\n    @media (max-width: 600px) {\n      width: 100px;\n      height: 57px;\n      margin-top: 10px;\n      margin-bottom: 10px;\n    }\n  "], ["\n    width: 140px;\n    height: 80px;\n    margin-left: 12px;\n    margin-right: 12px;\n    @media (max-width: 600px) {\n      width: 100px;\n      height: 57px;\n      margin-top: 10px;\n      margin-bottom: 10px;\n    }\n  "]),
    Sponsors__templateObject2 = Sponsors__taggedTemplateLiteralLoose(["\n      min-height: 120px;\n      width: 100%;\n      display: flex;\n      padding-top: 40px;\n      padding-bottom: 40px;\n      justify-content: center;\n      flex-wrap: wrap;\n      background-color: ", ";\n      margin-top: 72px;\n      @media (max-width: 600px) {\n        padding-top: 30px;\n        padding-bottom: 30px;\n        margin-top: 40px;\n      }\n    "], ["\n      min-height: 120px;\n      width: 100%;\n      display: flex;\n      padding-top: 40px;\n      padding-bottom: 40px;\n      justify-content: center;\n      flex-wrap: wrap;\n      background-color: ", ";\n      margin-top: 72px;\n      @media (max-width: 600px) {\n        padding-top: 30px;\n        padding-bottom: 30px;\n        margin-top: 40px;\n      }\n    "]);



function Sponsors__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }




var Sponsors_styles = {
  item: Object(index_esm["css"])(Sponsors__templateObject)
};

/**
 * Display sponsor logos
 *
 * @param {*} { sponsorsLogos, sponsorBoxBackgroundColor }
 * @returns
 */
var Sponsors_Sponsors = function Sponsors(_ref) {
  var sponsorsLogos = _ref.sponsorsLogos,
      sponsorBoxBackgroundColor = _ref.sponsorBoxBackgroundColor;

  var customStyles = {
    wrapper: Object(index_esm["css"])(Sponsors__templateObject2, sponsorBoxBackgroundColor)
  };
  if (!sponsorsLogos || !sponsorsLogos.length) {
    return Object(preact_min["h"])("div", { style: { width: "100%", height: 72 } });
  }
  return Object(preact_min["h"])(
    "div",
    { className: customStyles.wrapper },
    sponsorsLogos.map(function (sponsor) {
      return Object(preact_min["h"])("img", { src: sponsor.url, className: Sponsors_styles.item });
    })
  );
};

/* harmony default export */ var tours_Sponsors = (Sponsors_Sponsors);
// CONCATENATED MODULE: ./assets/images/ShareIcon.js



var ShareIcon__ref2 = Object(preact_min["h"])(
  "title",
  null,
  "ic_reply"
);

var ShareIcon__ref3 = Object(preact_min["h"])(
  "desc",
  null,
  "Created with Sketch."
);

var ShareIcon__ref4 = Object(preact_min["h"])("defs", null);

var ShareIcon__ref5 = Object(preact_min["h"])("polygon", { id: "Shape", points: "0 0 26 0 26 26 0 26" });

var ShareIcon_ShareIcon = function ShareIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? "#788391" : _ref$color;

  return Object(preact_min["h"])(
    "svg",
    {
      width: "20px",
      height: "17px",
      viewBox: "0 0 20 17",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    },
    ShareIcon__ref2,
    ShareIcon__ref3,
    ShareIcon__ref4,
    Object(preact_min["h"])(
      "g",
      {
        id: "Catalogue/search-page",
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
      },
      Object(preact_min["h"])(
        "g",
        {
          id: "ic_reply",
          transform: "translate(10.000000, 8.000000) scale(-1, 1) translate(-10.000000, -8.000000) translate(-3.000000, -5.000000)"
        },
        Object(preact_min["h"])(
          "g",
          { id: "Icon-24px" },
          Object(preact_min["h"])("path", {
            d: "M10.8333333,9.75 L10.8333333,5.41666667 L3.25,13 L10.8333333,20.5833333 L10.8333333,16.1416667 C16.25,16.1416667 20.0416667,17.875 22.75,21.6666667 C21.6666667,16.25 18.4166667,10.8333333 10.8333333,9.75 L10.8333333,9.75 Z",
            id: "Shape",
            fill: color
          }),
          ShareIcon__ref5
        )
      )
    )
  );
};
/* harmony default export */ var images_ShareIcon = (ShareIcon_ShareIcon);
// CONCATENATED MODULE: ./assets/icons/Facebook.js



var Facebook__ref2 = Object(preact_min["h"])(
  "g",
  { transform: "translate(211.000000, 655.000000)" },
  Object(preact_min["h"])("path", { d: "M0,16 C0,7.16344357 7.16344357,0 16,0 C24.8365564,0 32,7.16344357 32,16 C32,24.8365564 24.8365564,32 16,32 C7.16344357,32 0,24.8365564 0,16 Z M17.1343701,24.8743178 L17.1343701,16.1694731 L19.5372879,16.1694731 L19.8557264,13.1697354 L17.1343701,13.1697354 L17.1384526,11.6683378 C17.1384526,10.88596 17.2127889,10.4667441 18.3365094,10.4667441 L19.8387158,10.4667441 L19.8387158,7.46666667 L17.4354577,7.46666667 C14.5487583,7.46666667 13.532715,8.92186219 13.532715,11.3690434 L13.532715,13.1700751 L11.7333333,13.1700751 L11.7333333,16.1698128 L13.532715,16.1698128 L13.532715,24.8743178 L17.1343701,24.8743178 Z" })
);

var Facebook_Facebook = function Facebook(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? "#788391" : _ref$color;

  return Object(preact_min["h"])(
    "svg",
    {
      width: "32px",
      height: "32px",
      viewBox: "0 0 32 32",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    },
    Object(preact_min["h"])(
      "g",
      { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
      Object(preact_min["h"])(
        "g",
        { transform: "translate(-211.000000, -655.000000)", fill: color },
        Facebook__ref2
      )
    )
  );
};

/* harmony default export */ var icons_Facebook = (Facebook_Facebook);
// CONCATENATED MODULE: ./assets/icons/LinkedIn.js



var LinkedIn__ref2 = Object(preact_min["h"])("path", { d: "M851,551 C851,542.163444 858.163444,535 867,535 C875.836556,535 883,542.163444 883,551 C883,559.836556 875.836556,567 867,567 C858.163444,567 851,559.836556 851,551 Z M862.307028,548.251899 L858.681078,548.251899 L858.681078,559.146373 L862.307028,559.146373 L862.307028,548.251899 Z M862.545842,544.881798 C862.522308,543.813602 861.758436,543 860.518021,543 C859.277607,543 858.466667,543.813602 858.466667,544.881798 C858.466667,545.927869 859.253638,546.764898 860.470954,546.764898 L860.494125,546.764898 C861.758436,546.764898 862.545842,545.927869 862.545842,544.881798 Z M875.38359,552.899815 C875.38359,549.553503 873.594801,547.996076 871.208759,547.996076 C869.283618,547.996076 868.4217,549.053498 867.940451,549.795299 L867.940451,548.252188 L864.314067,548.252188 C864.361858,549.274469 864.314067,559.146662 864.314067,559.146662 L867.940451,559.146662 L867.940451,553.062289 C867.940451,552.736689 867.963985,552.411885 868.059858,552.178766 C868.321916,551.528289 868.91859,550.854818 869.920335,550.854818 C871.232944,550.854818 871.757641,551.853817 871.757641,553.317823 L871.757641,559.146373 L875.383446,559.146373 L875.38359,552.899815 Z" });

var LinkedIn_LinkedIn = function LinkedIn(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? "#788391" : _ref$color;

  return Object(preact_min["h"])(
    "svg",
    {
      width: "32px",
      height: "32px",
      viewBox: "0 0 32 32",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    },
    Object(preact_min["h"])(
      "g",
      { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
      Object(preact_min["h"])(
        "g",
        { transform: "translate(-851.000000, -535.000000)", fill: color },
        LinkedIn__ref2
      )
    )
  );
};
/* harmony default export */ var icons_LinkedIn = (LinkedIn_LinkedIn);
// CONCATENATED MODULE: ./assets/icons/Twitter.js



var Twitter__ref2 = Object(preact_min["h"])(
  "g",
  { transform: "translate(263.000000, 655.000000)" },
  Object(preact_min["h"])("path", {
    d: "M0,16 C0,7.16344357 7.16344357,0 16,0 C24.8365564,0 32,7.16344357 32,16 C32,24.8365564 24.8365564,32 16,32 C7.16344357,32 0,24.8365564 0,16 Z M15.5208017,13.0050004 L15.5543768,13.5586365 L14.9947933,13.4908443 C12.9579095,13.2309743 11.1784341,12.3496761 9.66755872,10.8695469 L8.92890855,10.1351317 L8.73865017,10.6774691 C8.33575008,11.8864295 8.59315847,13.1631822 9.43253367,14.021883 C9.88020044,14.4964283 9.77947541,14.5642204 9.00725023,14.281753 C8.73865017,14.1913635 8.50362512,14.1235713 8.48124178,14.1574674 C8.40290009,14.2365583 8.67150016,15.2647396 8.88414187,15.6714926 C9.17512527,16.2364274 9.76828374,16.7900635 10.4174006,17.1177257 L10.9657924,17.3775957 L10.3166755,17.3888944 C9.68994206,17.3888944 9.66755872,17.4001931 9.73470874,17.6374657 C9.95854212,18.3718809 10.842684,19.151491 11.8275509,19.4904518 L12.5214344,19.7277244 L11.9170842,20.0892827 C11.0217507,20.6090227 9.96973379,20.9027888 8.91771688,20.9253862 C8.41409176,20.9366849 8,20.9818797 8,21.0157758 C8,21.1287627 9.36538365,21.7614897 10.1599922,22.010061 C12.5438177,22.7444762 15.37531,22.4281128 17.5017272,21.1739575 C19.0126026,20.2813605 20.5234779,18.5074653 21.2285531,16.7900635 C21.6090698,15.8748692 21.9895866,14.2026622 21.9895866,13.4004548 C21.9895866,12.8807148 22.0231616,12.8129226 22.6498951,12.1914943 C23.0192202,11.829936 23.3661619,11.4344817 23.4333119,11.3214947 C23.5452286,11.1068195 23.5340369,11.1068195 22.9632618,11.2988973 C22.0119699,11.6378582 21.8776699,11.5926634 22.34772,11.0842221 C22.6946618,10.7226639 23.1087535,10.0673395 23.1087535,9.87526167 C23.1087535,9.84136558 22.9408785,9.89785906 22.7506201,9.99954732 C22.5491701,10.1125343 22.1015033,10.2820147 21.7657532,10.383703 L21.1614031,10.5757808 L20.6130113,10.2029238 C20.3108362,9.99954732 19.8855528,9.7735734 19.6617194,9.70578123 C19.0909442,9.54759949 18.217994,9.57019688 17.7031773,9.75097601 C16.3042186,10.2594173 15.4200767,11.570066 15.5208017,13.0050004 Z",
    id: "Icon Twitter"
  })
);

var Twitter_Twitter = function Twitter(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? "#788391" : _ref$color;

  return Object(preact_min["h"])(
    "svg",
    {
      width: "32px",
      height: "32px",
      viewBox: "0 0 32 32",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    },
    Object(preact_min["h"])(
      "g",
      { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
      Object(preact_min["h"])(
        "g",
        { transform: "translate(-263.000000, -655.000000)", fill: color },
        Twitter__ref2
      )
    )
  );
};
/* harmony default export */ var icons_Twitter = (Twitter_Twitter);
// CONCATENATED MODULE: ./routes/tours/SocialMedia.js
var SocialMedia__templateObject = SocialMedia__taggedTemplateLiteralLoose(["\n    margin-right: 12px;\n    width: 30px;\n    height: 30px;\n    display: inline-block;\n  "], ["\n    margin-right: 12px;\n    width: 30px;\n    height: 30px;\n    display: inline-block;\n  "]),
    SocialMedia__templateObject2 = SocialMedia__taggedTemplateLiteralLoose(["\n        width: 100%;\n        max-width: 264px;\n        height: ", ";\n        padding: 16px;\n        background-color: ", ";\n        border-radius: 4px;\n        box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n        @media (max-width: 900px) {\n          display: none;\n        }\n      "], ["\n        width: 100%;\n        max-width: 264px;\n        height: ", ";\n        padding: 16px;\n        background-color: ", ";\n        border-radius: 4px;\n        box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);\n        @media (max-width: 900px) {\n          display: none;\n        }\n      "]),
    SocialMedia__templateObject3 = SocialMedia__taggedTemplateLiteralLoose(["\n        font-size: 16px;\n        margin-bottom: 16px;\n        font-weight: 600;\n        color: ", ";\n      "], ["\n        font-size: 16px;\n        margin-bottom: 16px;\n        font-weight: 600;\n        color: ", ";\n      "]);



function SocialMedia__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SocialMedia__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SocialMedia__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function SocialMedia__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }











var SocialMedia_styles = {
  icon: Object(index_esm["css"])(SocialMedia__templateObject)
};
/**
 * Display social media sharing links
 * This can be either div box or modal
 *
 * @class SocialMedia
 * @extends {Component}
 */

var SocialMedia_SocialMedia = function (_Component) {
  SocialMedia__inherits(SocialMedia, _Component);

  function SocialMedia(props) {
    SocialMedia__classCallCheck(this, SocialMedia);

    var _this = SocialMedia__possibleConstructorReturn(this, _Component.call(this, props));

    _this.openModal = function () {
      _this.setState({ modalVisibility: !_this.state.modalVisibility });
    };

    _this.state = { modalVisibility: false };
    return _this;
  }

  SocialMedia.prototype.render = function render() {
    var _props = this.props,
        _props$modal = _props.modal,
        modal = _props$modal === undefined ? false : _props$modal,
        slug = _props.slug,
        listViewType = _props.listViewType,
        showPrice = _props.showPrice,
        eventCardBackgroundColor = _props.eventCardBackgroundColor,
        cardAndBarOpacity = _props.cardAndBarOpacity;
    var modalVisibility = this.state.modalVisibility;

    var tourLink = encodeURI(Object(config["a" /* default */])("TICKETING_URL") + "/tours/" + slug);
    var wrapperHeight = "132px";
    if (listViewType === "date") {
      wrapperHeight = showPrice ? "120px" : "100px";
    }
    var customStyles = {
      wrapper: Object(index_esm["css"])(SocialMedia__templateObject2, wrapperHeight, Object(Format["hexToRgba"])(eventCardBackgroundColor, cardAndBarOpacity)),
      title: Object(index_esm["css"])(SocialMedia__templateObject3, eventCardBackgroundColor === "#ffffff" ? "#323232" : "#ffffff")
    };
    var iconColor = eventCardBackgroundColor === "#ffffff" || modalVisibility ? "#788391" : "#ffffff";

    var contents = Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        "a",
        {
          href: "https://www.facebook.com/sharer.php?u=" + tourLink,
          target: "_blank"
        },
        Object(preact_min["h"])(
          "div",
          { className: SocialMedia_styles.icon, id: "tour-social-media-facebook" },
          Object(preact_min["h"])(icons_Facebook, { color: iconColor })
        )
      ),
      Object(preact_min["h"])(
        "a",
        {
          href: "https://www.linkedin.com/sharing/share-offsite/?url=" + tourLink,
          target: "_blank"
        },
        Object(preact_min["h"])(
          "div",
          { className: SocialMedia_styles.icon },
          Object(preact_min["h"])(icons_LinkedIn, { color: iconColor })
        )
      ),
      Object(preact_min["h"])(
        "a",
        {
          href: "https://twitter.com/intent/tweet?url=" + tourLink + "&hashtags=humanitix&original_referer=https%3A%2F%2Fwww.humanitix.com%2Fau%2Fsearch",
          target: "_blank"
        },
        Object(preact_min["h"])(
          "div",
          { className: SocialMedia_styles.icon },
          Object(preact_min["h"])(icons_Twitter, { color: iconColor })
        )
      )
    );
    if (modal) {
      return Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "button",
          { onClick: this.openModal, style: { padding: 0 } },
          Object(preact_min["h"])(images_ShareIcon, { color: iconColor })
        ),
        Object(preact_min["h"])(Modal["a" /* default */], {
          showModal: modalVisibility,
          closeHandler: this.openModal,
          title: "Social Media",
          maxWidth: 100,
          contents: Object(preact_min["h"])(
            "div",
            null,
            contents
          )
        })
      );
    }
    return Object(preact_min["h"])(
      "div",
      { className: customStyles.wrapper },
      Object(preact_min["h"])(
        "div",
        { className: customStyles.title },
        "Share"
      ),
      contents
    );
  };

  return SocialMedia;
}(preact_min["Component"]);

/* harmony default export */ var tours_SocialMedia = (SocialMedia_SocialMedia);
// CONCATENATED MODULE: ./routes/tours/Header.js
var Header__templateObject = Header__taggedTemplateLiteralLoose(["\n    max-width: 1000px;\n    margin-left: auto;\n    margin-right: auto;\n    box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);\n    border-radius: 0px 0px 4px 4px;\n    @media (max-width: 600px) {\n      margin-bottom: 24px;\n      max-width: 100%;\n    }\n  "], ["\n    max-width: 1000px;\n    margin-left: auto;\n    margin-right: auto;\n    box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);\n    border-radius: 0px 0px 4px 4px;\n    @media (max-width: 600px) {\n      margin-bottom: 24px;\n      max-width: 100%;\n    }\n  "]),
    Header__templateObject2 = Header__taggedTemplateLiteralLoose(["\n    background: transparent;\n    border: none;\n    padding: 0;\n    padding-top: 9px;\n    width: 50px;\n    margin-right: 20px;\n    @media (max-width: 600px) {\n      padding-top: 2px;\n      font-size: 14px;\n    }\n  "], ["\n    background: transparent;\n    border: none;\n    padding: 0;\n    padding-top: 9px;\n    width: 50px;\n    margin-right: 20px;\n    @media (max-width: 600px) {\n      padding-top: 2px;\n      font-size: 14px;\n    }\n  "]),
    Header__templateObject3 = Header__taggedTemplateLiteralLoose(["\n      background: url(", ") center center / cover no-repeat\n        rgb(238, 238, 238);\n      width: 100%;\n      max-width: 1000px;\n      height: 100%;\n      height: 500px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding-top: 50%;\n      position: relative;\n      @media (max-width: 600px) {\n        height: 160px;\n      }\n    "], ["\n      background: url(", ") center center / cover no-repeat\n        rgb(238, 238, 238);\n      width: 100%;\n      max-width: 1000px;\n      height: 100%;\n      height: 500px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding-top: 50%;\n      position: relative;\n      @media (max-width: 600px) {\n        height: 160px;\n      }\n    "]),
    Header__templateObject4 = Header__taggedTemplateLiteralLoose(["\n      font-size: 32px;\n      font-weight: 600;\n      text-align: center;\n      padding-top: 13px;\n      padding-bottom: 12px;\n      border-bottom: solid 1px #ffffff;\n      color: ", ";\n      background-color: ", ";\n      @media (max-width: 600px) {\n        font-size: 18px;\n      }\n    "], ["\n      font-size: 32px;\n      font-weight: 600;\n      text-align: center;\n      padding-top: 13px;\n      padding-bottom: 12px;\n      border-bottom: solid 1px #ffffff;\n      color: ", ";\n      background-color: ", ";\n      @media (max-width: 600px) {\n        font-size: 18px;\n      }\n    "]),
    Header__templateObject5 = Header__taggedTemplateLiteralLoose(["\n      height: 50px;\n      font-size: 32px;\n      font-weight: 600;\n      text-align: center;\n      padding: 4px 8px;\n      margin: auto;\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      @media (max-width: 600px) {\n        font-size: 18px;\n      }\n    "], ["\n      height: 50px;\n      font-size: 32px;\n      font-weight: 600;\n      text-align: center;\n      padding: 4px 8px;\n      margin: auto;\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      @media (max-width: 600px) {\n        font-size: 18px;\n      }\n    "]),
    Header__templateObject6 = Header__taggedTemplateLiteralLoose(["\n      color: ", ";\n      background-color: ", ";\n      padding-left: 8px;\n      padding-right: 8px;\n    "], ["\n      color: ", ";\n      background-color: ", ";\n      padding-left: 8px;\n      padding-right: 8px;\n    "]),
    Header__templateObject7 = Header__taggedTemplateLiteralLoose(["\n      padding-top: 4px;\n      padding-bottom: 5px;\n      color: ", ";\n    "], ["\n      padding-top: 4px;\n      padding-bottom: 5px;\n      color: ", ";\n    "]),
    Header__templateObject8 = Header__taggedTemplateLiteralLoose(["\n      padding-top: 4px;\n      padding-bottom: 3px;\n      font-weight: 600;\n      border-bottom: 3px solid ", ";\n      color: ", ";\n      @media (max-width: 600px) {\n        padding-bottom: 5px;\n      }\n    "], ["\n      padding-top: 4px;\n      padding-bottom: 3px;\n      font-weight: 600;\n      border-bottom: 3px solid ", ";\n      color: ", ";\n      @media (max-width: 600px) {\n        padding-bottom: 5px;\n      }\n    "]),
    Header__templateObject9 = Header__taggedTemplateLiteralLoose(["\n      display: ", ";\n      float: right;\n      margin-top: 10px;\n      @media (max-width: 900px) {\n        display: inherit;\n        float: right;\n        margin-top: 5px;\n      }\n    "], ["\n      display: ", ";\n      float: right;\n      margin-top: 10px;\n      @media (max-width: 900px) {\n        display: inherit;\n        float: right;\n        margin-top: 5px;\n      }\n    "]),
    Header__templateObject10 = Header__taggedTemplateLiteralLoose(["\n      height: 44px;\n      padding: 0px 16px 0px 26px;\n      font-size: 16px;\n      background-color: ", ";\n      border-radius: 0px 0px 4px 4px;\n      @media (max-width: 600px) {\n        border-radius: 0px;\n        height: 36px;\n      }\n    "], ["\n      height: 44px;\n      padding: 0px 16px 0px 26px;\n      font-size: 16px;\n      background-color: ", ";\n      border-radius: 0px 0px 4px 4px;\n      @media (max-width: 600px) {\n        border-radius: 0px;\n        height: 36px;\n      }\n    "]);



function Header__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }






var Header_styles = {
  headerContainer: Object(index_esm["css"])(Header__templateObject),
  button: Object(index_esm["css"])(Header__templateObject2)
};

/**
 * Display tab bar, title, and banner image
 *
 * @param {*} props
 * @returns
 */
var Header_Header = function Header(props) {
  var tour = props.tour,
      selectTab = props.selectTab,
      _props$selectedTab = props.selectedTab,
      selectedTab = _props$selectedTab === undefined ? "events" : _props$selectedTab,
      _props$showSocialModa = props.showSocialModal,
      showSocialModal = _props$showSocialModa === undefined ? false : _props$showSocialModa;


  var customStyles = {
    bannerImage: Object(index_esm["css"])(Header__templateObject3, tour.bannerImage.url),
    titleBelow: Object(index_esm["css"])(Header__templateObject4, tour.theme.titleTextColor, Object(Format["hexToRgba"])(tour.theme.titleBackgroundColor, tour.theme.cardAndBarOpacity)),
    titleInside: Object(index_esm["css"])(Header__templateObject5),
    title: Object(index_esm["css"])(Header__templateObject6, tour.theme.titleTextColor, tour.theme.titleBackgroundColor),
    linkItem: Object(index_esm["css"])(Header__templateObject7, tour.theme.eventCardBackgroundColor === "#ffffff" ? tour.theme.cardTitleColor : "#ffffff"),
    selectedItem: Object(index_esm["css"])(Header__templateObject8, tour.theme.primaryColor, tour.theme.eventCardBackgroundColor === "#ffffff" ? tour.theme.cardTitleColor : "#ffffff"),
    socialMedia: Object(index_esm["css"])(Header__templateObject9, showSocialModal ? "inherit" : "none"),
    linkRow: Object(index_esm["css"])(Header__templateObject10, Object(Format["hexToRgba"])(tour.theme.eventCardBackgroundColor, tour.theme.cardAndBarOpacity))
  };
  return Object(preact_min["h"])(
    "div",
    { className: Header_styles.headerContainer },
    tour.bannerImage.url && tour.bannerImage.url !== "" ? Object(preact_min["h"])(
      "div",
      { className: customStyles.bannerImage },
      tour.settings.showName && tour.settings.namePlacement === "inside" ? Object(preact_min["h"])(
        "div",
        { className: customStyles.titleInside },
        Object(preact_min["h"])(
          "span",
          { className: customStyles.title },
          tour.name
        )
      ) : null
    ) : null,
    tour.settings.showName && tour.settings.namePlacement === "below" ? Object(preact_min["h"])(
      "div",
      { className: customStyles.titleBelow },
      tour.name
    ) : null,
    Object(preact_min["h"])(
      "div",
      { className: customStyles.linkRow },
      Object(preact_min["h"])(
        "button",
        { onClick: function onClick() {
            return selectTab("events");
          }, className: Header_styles.button },
        Object(preact_min["h"])(
          "div",
          {
            className: selectedTab === "events" ? customStyles.selectedItem : customStyles.linkItem
          },
          "Events"
        )
      ),
      Object(preact_min["h"])(
        "button",
        { onClick: function onClick() {
            return selectTab("about");
          }, className: Header_styles.button },
        Object(preact_min["h"])(
          "div",
          {
            className: selectedTab === "about" ? customStyles.selectedItem : customStyles.linkItem
          },
          "About"
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: customStyles.socialMedia },
        Object(preact_min["h"])(tours_SocialMedia, {
          modal: true,
          slug: tour.slug,
          eventCardBackgroundColor: tour.theme.eventCardBackgroundColor,
          cardAndBarOpacity: tour.theme.cardAndBarOpacity
        })
      )
    )
  );
};

/* harmony default export */ var tours_Header = (Header_Header);
// EXTERNAL MODULE: ./assets/icons/ic_instagram.svg
var ic_instagram = __webpack_require__("Ncae");
var ic_instagram_default = /*#__PURE__*/__webpack_require__.n(ic_instagram);

// CONCATENATED MODULE: ./routes/tours/About.js
var About__templateObject = About__taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-width: 1000px;\n    margin-top: 32px;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 4px;\n    box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);\n    background: #ffffff;\n    @media (max-width: 600px) {\n      max-width: auto;\n      width: auto;\n      margin-left: 14px;\n      margin-right: 14px;\n      margin-top: 24px;\n    }\n  "], ["\n    width: 100%;\n    max-width: 1000px;\n    margin-top: 32px;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 4px;\n    box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);\n    background: #ffffff;\n    @media (max-width: 600px) {\n      max-width: auto;\n      width: auto;\n      margin-left: 14px;\n      margin-right: 14px;\n      margin-top: 24px;\n    }\n  "]),
    About__templateObject2 = About__taggedTemplateLiteralLoose(["\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 12px;\n    color: #323232;\n  "], ["\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 12px;\n    color: #323232;\n  "]),
    About__templateObject3 = About__taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-width: 700px;\n    margin-left: auto;\n    margin-right: auto;\n  "], ["\n    width: 100%;\n    max-width: 700px;\n    margin-left: auto;\n    margin-right: auto;\n  "]),
    About__templateObject4 = About__taggedTemplateLiteralLoose(["\n    padding: 32px 0px 20px;\n    @media (max-width: 600px) {\n      padding: 20px 12px 16px 12px;\n    }\n  "], ["\n    padding: 32px 0px 20px;\n    @media (max-width: 600px) {\n      padding: 20px 12px 16px 12px;\n    }\n  "]),
    About__templateObject5 = About__taggedTemplateLiteralLoose(["\n    text-align: center;\n    height: 54px;\n    padding: 15px;\n    border-top: solid 1px #dedede;\n    // border-bottom: solid 1px #dedede;\n  "], ["\n    text-align: center;\n    height: 54px;\n    padding: 15px;\n    border-top: solid 1px #dedede;\n    // border-bottom: solid 1px #dedede;\n  "]),
    About__templateObject6 = About__taggedTemplateLiteralLoose(["\n    margin-right: 12px;\n    width: 24px;\n    height: 24px;\n  "], ["\n    margin-right: 12px;\n    width: 24px;\n    height: 24px;\n  "]),
    About__templateObject7 = About__taggedTemplateLiteralLoose(["\n    height: 340px;\n  "], ["\n    height: 340px;\n  "]);



function About__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }









var About_styles = {
  wrapper: Object(index_esm["css"])(About__templateObject),
  title: Object(index_esm["css"])(About__templateObject2),
  container: Object(index_esm["css"])(About__templateObject3),
  topRow: Object(index_esm["css"])(About__templateObject4),
  socialMedia: Object(index_esm["css"])(About__templateObject5),
  icon: Object(index_esm["css"])(About__templateObject6),
  slide: Object(index_esm["css"])(About__templateObject7)
};

/**
 * Tour about page
 *
 * @param {*} props
 * @returns
 */
var About_About = function About(props) {
  var name = props.name,
      description = props.description,
      facebook = props.facebook,
      linkedIn = props.linkedIn,
      twitter = props.twitter,
      instagram = props.instagram,
      eventCardBackgroundColor = props.eventCardBackgroundColor;


  var showSocialMedia = facebook || linkedIn || twitter || instagram;

  return Object(preact_min["h"])(
    "div",
    { className: About_styles.wrapper },
    Object(preact_min["h"])(
      "div",
      { className: About_styles.container },
      Object(preact_min["h"])(
        "div",
        { className: About_styles.topRow },
        Object(preact_min["h"])(
          "div",
          { className: About_styles.title },
          name
        ),
        Object(preact_min["h"])(components_RichTextDisplay, { html: description })
      ),
      showSocialMedia ? Object(preact_min["h"])(
        "div",
        { className: About_styles.socialMedia },
        facebook && facebook !== "" && Object(preact_min["h"])(
          "a",
          { href: facebook, target: "_blank" },
          Object(preact_min["h"])("img", {
            src: ic_facebook_default.a,
            id: "facebook",
            alt: "facebook",
            className: About_styles.icon
          })
        ),
        instagram && instagram !== "" && Object(preact_min["h"])(
          "a",
          { href: instagram, target: "_blank" },
          Object(preact_min["h"])("img", {
            src: ic_instagram_default.a,
            alt: "instagram",
            className: About_styles.icon
          })
        ),
        linkedIn && linkedIn !== "" && Object(preact_min["h"])(
          "a",
          { href: linkedIn, target: "_blank" },
          Object(preact_min["h"])("img", {
            src: ic_linkedin_default.a,
            alt: "linkedIn",
            className: About_styles.icon
          })
        ),
        twitter && twitter !== "" && Object(preact_min["h"])(
          "a",
          { href: twitter, target: "_blank" },
          Object(preact_min["h"])("img", { src: ic_twitter_default.a, alt: "twitter", className: About_styles.icon })
        )
      ) : null
    )
  );
};

/* harmony default export */ var tours_About = (About_About);
// CONCATENATED MODULE: ./routes/tours/TourGroup.js
var TourGroup__templateObject = TourGroup__taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 100%;\n    margin-top: 16px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    @media (max-width: 600px) {\n      margin-left: 14px;\n      margin-right: 14px;\n      margin-top: 0px;\n    }\n  "], ["\n    display: flex;\n    width: 100%;\n    margin-top: 16px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    @media (max-width: 600px) {\n      margin-left: 14px;\n      margin-right: 14px;\n      margin-top: 0px;\n    }\n  "]),
    TourGroup__templateObject2 = TourGroup__taggedTemplateLiteralLoose(["\n    max-width: 480px;\n    width: 100%;\n    height: 240px;\n    position: relative;\n    margin-top: 32px;\n    margin-bottom: 48px;\n    @media (max-width: 600px) {\n      margin-top: 12px;\n      margin-bottom: 48px;\n    }\n  "], ["\n    max-width: 480px;\n    width: 100%;\n    height: 240px;\n    position: relative;\n    margin-top: 32px;\n    margin-bottom: 48px;\n    @media (max-width: 600px) {\n      margin-top: 12px;\n      margin-bottom: 48px;\n    }\n  "]),
    TourGroup__templateObject3 = TourGroup__taggedTemplateLiteralLoose(["\n      max-width: 300px;\n      height: 120px;\n      width: 100%;\n      position: absolute;\n      bottom: -32px;\n      left: 0;\n      right: 0;\n      margin-left: auto;\n      margin-right: auto;\n      background: ", ";\n      text-align: center;\n      padding-top: 16px;\n      border-radius: 4px;\n      box-shadow: 0 1px 4px 0 rgba(9, 30, 66, 0.13);\n    "], ["\n      max-width: 300px;\n      height: 120px;\n      width: 100%;\n      position: absolute;\n      bottom: -32px;\n      left: 0;\n      right: 0;\n      margin-left: auto;\n      margin-right: auto;\n      background: ", ";\n      text-align: center;\n      padding-top: 16px;\n      border-radius: 4px;\n      box-shadow: 0 1px 4px 0 rgba(9, 30, 66, 0.13);\n    "]),
    TourGroup__templateObject4 = TourGroup__taggedTemplateLiteralLoose(["\n      font-size: 26px;\n      font-weight: 600;\n      margin-bottom: 16px;\n      color: ", ";\n    "], ["\n      font-size: 26px;\n      font-weight: 600;\n      margin-bottom: 16px;\n      color: ", ";\n    "]),
    TourGroup__templateObject5 = TourGroup__taggedTemplateLiteralLoose(["\n          width: 100%;\n          height: 220px;\n          border-radius: 4px;\n          background: url(", ") center center / cover no-repeat\n            rgb(238, 238, 238);\n        "], ["\n          width: 100%;\n          height: 220px;\n          border-radius: 4px;\n          background: url(", ") center center / cover no-repeat\n            rgb(238, 238, 238);\n        "]);



function TourGroup__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }






var TourGroup_styles = {
  wrapper: Object(index_esm["css"])(TourGroup__templateObject),
  container: Object(index_esm["css"])(TourGroup__templateObject2)
};

/**
 * Display tour groups
 *
 * @param {*} props
 * @returns
 */
var TourGroup_TourGroup = function TourGroup(props) {
  var theme = props.theme,
      slug = props.slug,
      preview = props.preview,
      _props$token = props.token,
      token = _props$token === undefined ? null : _props$token;
  var groups = props.groups;

  groups = groups.filter(function (group) {
    return !group.deleted;
  });
  var customStyles = {
    contents: Object(index_esm["css"])(TourGroup__templateObject3, Object(Format["hexToRgba"])(theme.eventCardBackgroundColor, theme.cardAndBarOpacity)),
    title: Object(index_esm["css"])(TourGroup__templateObject4, theme.eventCardBackgroundColor === "#ffffff" ? "#323232" : "#ffffff")
  };

  var _ref = Object(preact_min["h"])(
    components_Button["a" /* default */],
    { tourTheme: theme, type: "primary" },
    "Explore"
  );

  return Object(preact_min["h"])(
    "div",
    { className: TourGroup_styles.wrapper },
    groups.map(function (tourGroup) {
      var backgroundImage = tourGroup.image && tourGroup.image.url ? tourGroup.image.url : "";
      var imageContainer = Object(index_esm["css"])(TourGroup__templateObject5, backgroundImage);
      var tokenLink = token ? "token=" + token : "";
      var tourGroupLink = preview ? "/tours/" + slug + "/" + tourGroup._id + "?preview=true&" + tokenLink : "/tours/" + slug + "/" + tourGroup._id + "?" + tokenLink;
      return Object(preact_min["h"])(
        "div",
        { className: TourGroup_styles.container },
        Object(preact_min["h"])("div", { className: imageContainer }),
        Object(preact_min["h"])(
          "div",
          { className: customStyles.contents },
          Object(preact_min["h"])(
            "div",
            { className: customStyles.title },
            tourGroup.name
          ),
          Object(preact_min["h"])(
            "a",
            { href: tourGroupLink },
            _ref
          )
        )
      );
    })
  );
};

/* harmony default export */ var tours_TourGroup = (TourGroup_TourGroup);
// EXTERNAL MODULE: ../node_modules/focus-trap-react/dist/focus-trap-react.js
var focus_trap_react = __webpack_require__("M5Nt");
var focus_trap_react_default = /*#__PURE__*/__webpack_require__.n(focus_trap_react);

// CONCATENATED MODULE: ./components/FullHeightFilterModal.js
var FullHeightFilterModal__templateObject = FullHeightFilterModal__taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid #dedede;\n    text-align: center;\n    position: relative;\n    width: 100%;\n    padding: 18px 14px;\n  "], ["\n    border-bottom: 1px solid #dedede;\n    text-align: center;\n    position: relative;\n    width: 100%;\n    padding: 18px 14px;\n  "]),
    FullHeightFilterModal__templateObject2 = FullHeightFilterModal__taggedTemplateLiteralLoose(["\n    font-size: 18px;\n    font-weight: 600;\n    display: inline-block;\n  "], ["\n    font-size: 18px;\n    font-weight: 600;\n    display: inline-block;\n  "]),
    FullHeightFilterModal__templateObject3 = FullHeightFilterModal__taggedTemplateLiteralLoose(["\n    position: absolute;\n    right: 14px;\n    display: inline-block;\n    & > button {\n      text-decoration: underline;\n      color: #6621c0;\n    }\n  "], ["\n    position: absolute;\n    right: 14px;\n    display: inline-block;\n    & > button {\n      text-decoration: underline;\n      color: #6621c0;\n    }\n  "]),
    FullHeightFilterModal__templateObject4 = FullHeightFilterModal__taggedTemplateLiteralLoose(["\n    border: none;\n    position: absolute;\n    background: #fff;\n    left: 14px;\n    width: 24px;\n    height: 24px;\n    background-image: url(", ");\n  "], ["\n    border: none;\n    position: absolute;\n    background: #fff;\n    left: 14px;\n    width: 24px;\n    height: 24px;\n    background-image: url(", ");\n  "]),
    FullHeightFilterModal__templateObject5 = FullHeightFilterModal__taggedTemplateLiteralLoose(["\n    width: 100%;\n    position: absolute;\n    bottom: 16px;\n    padding: 0px 14px;\n  "], ["\n    width: 100%;\n    position: absolute;\n    bottom: 16px;\n    padding: 0px 14px;\n  "]);



function FullHeightFilterModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FullHeightFilterModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function FullHeightFilterModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function FullHeightFilterModal__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }





var FullHeightFilterModal_closeIcon = __webpack_require__("dty5");

var FullHeightFilterModal_styles = {
  header: Object(index_esm["css"])(FullHeightFilterModal__templateObject),
  title: Object(index_esm["css"])(FullHeightFilterModal__templateObject2),
  clearButton: Object(index_esm["css"])(FullHeightFilterModal__templateObject3),
  closeButton: Object(index_esm["css"])(FullHeightFilterModal__templateObject4, FullHeightFilterModal_closeIcon),
  resultButton: Object(index_esm["css"])(FullHeightFilterModal__templateObject5)
};

/**
 * This modal display filter options (same as marketing page)
 *
 * @class FullHeightFilterModal
 * @extends {Component}
 */

var FullHeightFilterModal_FullHeightFilterModal = function (_Component) {
  FullHeightFilterModal__inherits(FullHeightFilterModal, _Component);

  function FullHeightFilterModal(props) {
    FullHeightFilterModal__classCallCheck(this, FullHeightFilterModal);

    var _this = FullHeightFilterModal__possibleConstructorReturn(this, _Component.call(this, props));

    _this.checkDocumentKeyDown = function (event) {
      var closeHandler = _this.props.closeHandler;

      if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
        closeHandler(event);
      }
    };

    _this.state = {
      hasOpened: false
    };
    return _this;
  }

  FullHeightFilterModal.prototype.componentDidUpdate = function componentDidUpdate() {
    var showModal = this.props.showModal;

    if (showModal) {
      if (!this.state.hasOpened) {
        this.setState({ hasOpened: true });
      }
      this.addKeyDownListener();
      return;
    }
    this.removeKeyDownListener();
  };

  FullHeightFilterModal.prototype.componentDidMount = function componentDidMount() {};

  FullHeightFilterModal.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeKeyDownListener();
  };

  FullHeightFilterModal.prototype.addKeyDownListener = function addKeyDownListener() {
    document.addEventListener("keydown", this.checkDocumentKeyDown);
  };

  FullHeightFilterModal.prototype.removeKeyDownListener = function removeKeyDownListener() {
    document.removeEventListener("keydown", this.checkDocumentKeyDown);
  };

  FullHeightFilterModal.prototype.render = function render(_ref) {
    var showModal = _ref.showModal,
        closeHandler = _ref.closeHandler,
        title = _ref.title,
        contents = _ref.contents,
        footer = _ref.footer,
        children = _ref.children,
        clearFilter = _ref.clearFilter,
        _ref$destroy = _ref.destroy,
        destroy = _ref$destroy === undefined ? true : _ref$destroy,
        mobileFilter = _ref.mobileFilter;

    var hasOpened = this.state.hasOpened;
    var fadeIn = Object(index_esm["keyframes"])({
      from: {
        opacity: 0.5
      },
      to: {
        opacity: 1
      }
    });
    var grow = Object(index_esm["keyframes"])({
      from: {
        transform: "scale(0.9)"
      },
      to: {
        transform: "scale(1)"
      }
    });
    /* The Modal (background) */
    var modal = Object(index_esm["css"])({
      display: showModal ? "flex" : "none",
      justifyContent: "center",
      alignItems: "flex-start",
      position: "fixed",
      zIndex: 100001,
      paddingTop: 80,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      background: "#fafafa",
      "@media(max-width: 600px)": {
        paddingTop: 0
      }
    });

    var modalBackground = Object(index_esm["css"])({
      backgroundColor: "rgba(0,0,0,0.6)",
      animation: fadeIn + " 0.3s ease-in-out",
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      position: "absolute",
      zIndex: 1
    });

    /* Modal Content */
    var modalContent = Object(index_esm["css"])({
      position: "relative",
      backgroundColor: "#fefefe",
      border: "1px solid #888",
      borderRadius: 4,
      display: "inline-block",
      animation: grow + " 0.2s ease-in-out",
      zIndex: 2,
      height: "100%",
      overflow: "scroll",
      minWidth: 300,
      maxHeight: "calc(100vh - 80px)",
      "@media(max-width: 600px)": {
        maxHeight: "100vh",
        paddingBottom: 80,
        minWidth: 200,
        width: "100%",
        borderRadius: 0
      }
    });

    return Object(preact_min["h"])(
      "div",
      { className: modal },
      Object(preact_min["h"])("div", { className: modalBackground }),
      showModal || !destroy && hasOpened ? Object(preact_min["h"])(
        focus_trap_react_default.a,
        null,
        Object(preact_min["h"])(
          "div",
          {
            className: modalContent,
            "aria-modal": "true",
            role: "dialog",
            id: "modal-wrapper"
          },
          Object(preact_min["h"])(
            "div",
            { className: FullHeightFilterModal_styles.header },
            Object(preact_min["h"])("button", {
              type: "button",
              className: FullHeightFilterModal_styles.closeButton,
              onClick: closeHandler,
              "aria-label": "Close",
              "data-cy": "close"
            }),
            Object(preact_min["h"])(
              "div",
              { className: FullHeightFilterModal_styles.title },
              title
            ),
            Object(preact_min["h"])(
              "div",
              { className: FullHeightFilterModal_styles.clearButton },
              Object(preact_min["h"])(
                "button",
                { onClick: clearFilter },
                "Clear"
              )
            )
          ),
          contents ? Object(preact_min["h"])(
            "div",
            null,
            contents
          ) : children,
          Object(preact_min["h"])(
            "div",
            { className: FullHeightFilterModal_styles.resultButton },
            Object(preact_min["h"])(
              components_Button["a" /* default */],
              { type: "primary", fullWidth: true, onClick: mobileFilter },
              "Show results"
            )
          )
        )
      ) : null
    );
  };

  return FullHeightFilterModal;
}(preact_min["Component"]);

/* harmony default export */ var components_FullHeightFilterModal = (FullHeightFilterModal_FullHeightFilterModal);
// CONCATENATED MODULE: ./routes/tours/FilterValueDisplay.js
var FilterValueDisplay__templateObject = FilterValueDisplay__taggedTemplateLiteralLoose(["\n        margin-bottom: ", ";\n        padding-top: ", ";\n        padding-bottom: ", ";\n        padding-left: ", ";\n        background: ", ";\n        border-bottom: ", ";\n        margin-top: ", ";\n        display: ", ";\n        @media (max-width: 600px) {\n          margin-top: 0px;\n          display: block;\n        }\n      "], ["\n        margin-bottom: ", ";\n        padding-top: ", ";\n        padding-bottom: ", ";\n        padding-left: ", ";\n        background: ", ";\n        border-bottom: ", ";\n        margin-top: ", ";\n        display: ", ";\n        @media (max-width: 600px) {\n          margin-top: 0px;\n          display: block;\n        }\n      "]),
    FilterValueDisplay__templateObject2 = FilterValueDisplay__taggedTemplateLiteralLoose(["\n        color: ", ";\n        font-weight: 600;\n        font-size: 16px;\n        display: inline-block;\n        @media (max-width: 600px) {\n          font-size: 14px;\n        }\n      "], ["\n        color: ", ";\n        font-weight: 600;\n        font-size: 16px;\n        display: inline-block;\n        @media (max-width: 600px) {\n          font-size: 14px;\n        }\n      "]),
    FilterValueDisplay__templateObject3 = FilterValueDisplay__taggedTemplateLiteralLoose(["\n        color: ", ";\n        font-weight: 600;\n        font-size: 16px;\n        display: inline-block;\n        margin-left: 5px;\n        @media (max-width: 600px) {\n          font-size: 14px;\n        }\n      "], ["\n        color: ", ";\n        font-weight: 600;\n        font-size: 16px;\n        display: inline-block;\n        margin-left: 5px;\n        @media (max-width: 600px) {\n          font-size: 14px;\n        }\n      "]);



function FilterValueDisplay__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function FilterValueDisplay__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FilterValueDisplay__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function FilterValueDisplay__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * Display filter value (Date, location, and result count)
 *
 * @class FilterValueDisplay
 * @extends {Component}
 */

var FilterValueDisplay__ref = Object(preact_min["h"])("div", null);

var FilterValueDisplay_FilterValueDisplay = function (_Component) {
  FilterValueDisplay__inherits(FilterValueDisplay, _Component);

  function FilterValueDisplay(props) {
    FilterValueDisplay__classCallCheck(this, FilterValueDisplay);

    return FilterValueDisplay__possibleConstructorReturn(this, _Component.call(this, props));
  }

  FilterValueDisplay.prototype.render = function render() {
    var _props = this.props,
        _props$date = _props.date,
        date = _props$date === undefined ? false : _props$date,
        _props$location = _props.location,
        location = _props$location === undefined ? false : _props$location,
        _props$totalSize = _props.totalSize,
        totalSize = _props$totalSize === undefined ? 0 : _props$totalSize,
        _props$listAndDate = _props.listAndDate,
        listAndDate = _props$listAndDate === undefined ? false : _props$listAndDate,
        theme = _props.theme;


    var hideFilter = !date && !location;

    var customStyles = {
      wrapper: Object(index_esm["css"])(FilterValueDisplay__templateObject, listAndDate ? "0px" : "24px", listAndDate ? "16px" : "0px", listAndDate ? "12px" : "0px", listAndDate ? "12px" : "0px", listAndDate ? Object(Format["hexToRgba"])(theme.eventCardBackgroundColor, theme.cardAndBarOpacity) : "transparent", listAndDate ? "1px solid #dedede" : "none", listAndDate ? "0" : "5px", listAndDate ? "none" : "block"),
      filterValue: Object(index_esm["css"])(FilterValueDisplay__templateObject2, theme.eventCardBackgroundColor === "#ffffff" ? "#323232" : "#ffffff"),
      eventCount: Object(index_esm["css"])(FilterValueDisplay__templateObject3, theme.eventCardBackgroundColor === "#ffffff" ? "#5a626c" : "#ffffff")
    };

    if (hideFilter) {
      return FilterValueDisplay__ref;
    }

    return Object(preact_min["h"])(
      "div",
      { className: customStyles.wrapper },
      Object(preact_min["h"])(
        "div",
        { className: customStyles.filterValue },
        location,
        location && date ? ", " : null,
        date,
        ","
      ),
      Object(preact_min["h"])(
        "div",
        { className: customStyles.eventCount },
        totalSize,
        " events"
      )
    );
  };

  return FilterValueDisplay;
}(preact_min["Component"]);

/* harmony default export */ var tours_FilterValueDisplay = (FilterValueDisplay_FilterValueDisplay);
// EXTERNAL MODULE: ./assets/images/icon-filter.svg
var icon_filter = __webpack_require__("DMyS");
var icon_filter_default = /*#__PURE__*/__webpack_require__.n(icon_filter);

// CONCATENATED MODULE: ./routes/tours/Filter.js
var Filter__templateObject = Filter__taggedTemplateLiteralLoose(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "]),
    Filter__templateObject2 = Filter__taggedTemplateLiteralLoose(["\n    @media (max-width: 600px) {\n      display: none;\n    }\n  "], ["\n    @media (max-width: 600px) {\n      display: none;\n    }\n  "]),
    Filter__templateObject3 = Filter__taggedTemplateLiteralLoose(["\n    display: none;\n    width: 100%;\n    height: 36px;\n    @media (max-width: 600px) {\n      display: inline;\n    }\n  "], ["\n    display: none;\n    width: 100%;\n    height: 36px;\n    @media (max-width: 600px) {\n      display: inline;\n    }\n  "]),
    Filter__templateObject4 = Filter__taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-width: 410px;\n    display: flex;\n    @media (max-width: 600px) {\n      flex-wrap: wrap;\n    }\n  "], ["\n    width: 100%;\n    max-width: 410px;\n    display: flex;\n    @media (max-width: 600px) {\n      flex-wrap: wrap;\n    }\n  "]),
    Filter__templateObject5 = Filter__taggedTemplateLiteralLoose(["\n    width: 100%;\n    background: #fff;\n    height: 36px;\n    text-align: center;\n  "], ["\n    width: 100%;\n    background: #fff;\n    height: 36px;\n    text-align: center;\n  "]),
    Filter__templateObject6 = Filter__taggedTemplateLiteralLoose(["\n    position: relative;\n    width: 120px;\n    margin-left: auto;\n    margin-right: auto;\n  "], ["\n    position: relative;\n    width: 120px;\n    margin-left: auto;\n    margin-right: auto;\n  "]),
    Filter__templateObject7 = Filter__taggedTemplateLiteralLoose(["\n    position: absolute;\n    left: 0px;\n    vertical-align: middle;\n  "], ["\n    position: absolute;\n    left: 0px;\n    vertical-align: middle;\n  "]),
    Filter__templateObject8 = Filter__taggedTemplateLiteralLoose(["\n    padding-left: 10px;\n    display: inline-block;\n  "], ["\n    padding-left: 10px;\n    display: inline-block;\n  "]),
    Filter__templateObject9 = Filter__taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-width: 250px;\n    height: 36px;\n    position: relative;\n    @media (max-width: 600px) {\n      width: 100%;\n      max-width: 100%;\n      margin-bottom: 8px;\n    }\n  "], ["\n    width: 100%;\n    max-width: 250px;\n    height: 36px;\n    position: relative;\n    @media (max-width: 600px) {\n      width: 100%;\n      max-width: 100%;\n      margin-bottom: 8px;\n    }\n  "]),
    Filter__templateObject10 = Filter__taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-width: 150px;\n    height: 36px;\n    margin-left: 8px;\n    position: relative;\n    @media (max-width: 600px) {\n      width: 100%;\n      max-width: 100%;\n      margin-left: 0px;\n    }\n  "], ["\n    width: 100%;\n    max-width: 150px;\n    height: 36px;\n    margin-left: 8px;\n    position: relative;\n    @media (max-width: 600px) {\n      width: 100%;\n      max-width: 100%;\n      margin-left: 0px;\n    }\n  "]),
    Filter__templateObject11 = Filter__taggedTemplateLiteralLoose(["\n    position: absolute;\n    width: 20px;\n    top: 9px;\n    left: 10px;\n  "], ["\n    position: absolute;\n    width: 20px;\n    top: 9px;\n    left: 10px;\n  "]),
    Filter__templateObject12 = Filter__taggedTemplateLiteralLoose(["\n    background: #fff;\n    border: 1px solid #788391;\n    border-radius: 4px !important;\n    height: 1.8rem;\n    line-height: 1rem;\n    outline: none;\n    padding: 0.35rem 0.4rem;\n    vertical-align: middle;\n    width: 100%;\n    padding-left: 40px;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    appearance: none;\n  "], ["\n    background: #fff;\n    border: 1px solid #788391;\n    border-radius: 4px !important;\n    height: 1.8rem;\n    line-height: 1rem;\n    outline: none;\n    padding: 0.35rem 0.4rem;\n    vertical-align: middle;\n    width: 100%;\n    padding-left: 40px;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    appearance: none;\n  "]),
    Filter__templateObject13 = Filter__taggedTemplateLiteralLoose(["\n      width: 100%;\n      max-width: 1000px;\n      margin-top: ", ";\n      margin-bottom: 32px;\n      height: 52px;\n      display: flex;\n      border-radius: 4px;\n      background-color: ", ";\n      padding-top: 8px;\n      padding-left: 16px;\n      padding-right: 16px;\n      justify-content: space-between;\n      @media (max-width: 600px) {\n        margin-left: 14px;\n        margin-right: 14px;\n        width: auto;\n        flex-wrap: wrap;\n        margin-top: 8px;\n        padding-left: 0px;\n        padding-right: 0px;\n      }\n    "], ["\n      width: 100%;\n      max-width: 1000px;\n      margin-top: ", ";\n      margin-bottom: 32px;\n      height: 52px;\n      display: flex;\n      border-radius: 4px;\n      background-color: ", ";\n      padding-top: 8px;\n      padding-left: 16px;\n      padding-right: 16px;\n      justify-content: space-between;\n      @media (max-width: 600px) {\n        margin-left: 14px;\n        margin-right: 14px;\n        width: auto;\n        flex-wrap: wrap;\n        margin-top: 8px;\n        padding-left: 0px;\n        padding-right: 0px;\n      }\n    "]);



function Filter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Filter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Filter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Filter__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }










var Filter_styles = {
  wrapper: Object(index_esm["css"])(Filter__templateObject),
  desktop: Object(index_esm["css"])(Filter__templateObject2),
  mobile: Object(index_esm["css"])(Filter__templateObject3),
  filterContainer: Object(index_esm["css"])(Filter__templateObject4),
  filterButton: Object(index_esm["css"])(Filter__templateObject5),
  buttonContents: Object(index_esm["css"])(Filter__templateObject6),
  filterIcon: Object(index_esm["css"])(Filter__templateObject7),
  filterLabel: Object(index_esm["css"])(Filter__templateObject8),
  locationContainer: Object(index_esm["css"])(Filter__templateObject9),
  dateContainer: Object(index_esm["css"])(Filter__templateObject10),
  icon: Object(index_esm["css"])(Filter__templateObject11),
  select: Object(index_esm["css"])(Filter__templateObject12)
};

var Filter_Contents = function Contents(props) {
  var pageLayout = props.pageLayout,
      tourDates = props.tourDates,
      locationOptions = props.locationOptions,
      dateOptions = props.dateOptions,
      selectFilter = props.selectFilter,
      _props$mobile = props.mobile,
      mobile = _props$mobile === undefined ? false : _props$mobile,
      displayDate = props.displayDate,
      location = props.location,
      totalSize = props.totalSize,
      theme = props.theme;


  var customStyles = {
    contentsContainer: Object(index_esm["css"])(Filter__templateObject13, pageLayout === "list" ? "32px" : "41px", mobile ? "#ffffff" : Object(Format["hexToRgba"])(theme.eventCardBackgroundColor, theme.cardAndBarOpacity))
  };

  return Object(preact_min["h"])(
    "div",
    { className: customStyles.contentsContainer },
    Object(preact_min["h"])(tours_FilterValueDisplay, {
      date: displayDate,
      location: location,
      totalSize: totalSize,
      theme: theme
    }),
    Object(preact_min["h"])(
      "div",
      { className: Filter_styles.filterContainer },
      tourDates.length > 1 ? Object(preact_min["h"])(
        "div",
        { className: Filter_styles.locationContainer },
        Object(preact_min["h"])(
          "select",
          {
            className: Filter_styles.select,
            onChange: function onChange(e) {
              return selectFilter(e, "location", mobile);
            },
            id: "select-tour-location"
          },
          locationOptions.map(function (option) {
            return Object(preact_min["h"])(
              "option",
              { value: option.value },
              option.label
            );
          })
        ),
        Object(preact_min["h"])("img", { src: icon_location_default.a, className: Filter_styles.icon })
      ) : null,
      Object(preact_min["h"])(
        "div",
        { className: Filter_styles.dateContainer },
        dateOptions.length > 1 ? Object(preact_min["h"])(
          "select",
          {
            className: Filter_styles.select,
            onChange: function onChange(e) {
              return selectFilter(e, "date", mobile);
            },
            id: "select-tour-date"
          },
          dateOptions.map(function (option) {
            return Object(preact_min["h"])(
              "option",
              { value: option.value },
              option.label
            );
          })
        ) : null,
        Object(preact_min["h"])("img", { src: icon_date_default.a, className: Filter_styles.icon })
      )
    )
  );
};

/**
 * Display filter by dates and locations
 *
 * @class Filter
 * @extends {Component}
 */

var Filter_Filter = function (_Component) {
  Filter__inherits(Filter, _Component);

  function Filter(props) {
    Filter__classCallCheck(this, Filter);

    var _this = Filter__possibleConstructorReturn(this, _Component.call(this, props));

    _this.openModal = function () {
      _this.setState({ modalVisibility: !_this.state.modalVisibility });
    };

    _this.mobileFilter = function () {
      var filter = _this.props.filter;
      var _this$state = _this.state,
          date = _this$state.date,
          displayDate = _this$state.displayDate,
          location = _this$state.location;


      var mobileUpdate = { date: date, displayDate: displayDate, location: location };
      filter(null, null, mobileUpdate);
      _this.openModal();
    };

    _this.selectFilter = function (e, dateOrLocation, mobile) {
      var filter = _this.props.filter;


      if (mobile) {
        var update = {};
        if (dateOrLocation === "date") {
          var index = e.nativeEvent.target.selectedIndex;
          var text = e.nativeEvent.target[index].text;
          update.displayDate = text;
        }
        update[dateOrLocation] = e.target.value;
        _this.setState(update);
      } else {
        filter(e, dateOrLocation);
      }
    };

    _this.state = {
      modalVisibility: false,
      displayDate: props.displayDate,
      location: props.location,
      date: props.date
    };
    return _this;
  }

  Filter.prototype.render = function render() {
    var _props = this.props,
        pageLayout = _props.pageLayout,
        _props$tourDates = _props.tourDates,
        tourDates = _props$tourDates === undefined ? [] : _props$tourDates,
        _props$tourLocations = _props.tourLocations,
        tourLocations = _props$tourLocations === undefined ? [] : _props$tourLocations,
        clearFilter = _props.clearFilter,
        displayDate = _props.displayDate,
        location = _props.location,
        totalSize = _props.totalSize,
        theme = _props.theme;
    var modalVisibility = this.state.modalVisibility;


    var hideFilter = !(tourDates.length > 1 || tourLocations.length > 1);
    var dateOptions = tourDates.map(function (option) {
      return { value: option.value, label: option.display };
    });
    dateOptions.unshift({ value: "all", label: "All Dates" });
    var locationOptions = tourLocations.map(function (option) {
      return { value: option, label: option };
    });
    locationOptions.unshift({ value: "all", label: "All Locations" });

    if (hideFilter) {
      return Object(preact_min["h"])("div", { style: { marginTop: 48 } });
    }

    return Object(preact_min["h"])(
      "div",
      { className: Filter_styles.wrapper },
      Object(preact_min["h"])(
        "div",
        { className: Filter_styles.desktop },
        Object(preact_min["h"])(Filter_Contents, {
          pageLayout: pageLayout,
          tourDates: tourDates,
          locationOptions: locationOptions,
          dateOptions: dateOptions,
          selectFilter: this.selectFilter,
          displayDate: displayDate,
          location: location,
          totalSize: totalSize,
          theme: theme
        })
      ),
      Object(preact_min["h"])(
        "div",
        { className: Filter_styles.mobile },
        Object(preact_min["h"])(
          "button",
          { className: Filter_styles.filterButton, onClick: this.openModal },
          Object(preact_min["h"])(
            "div",
            { className: Filter_styles.buttonContents },
            Object(preact_min["h"])("img", { src: icon_filter_default.a, className: Filter_styles.filterIcon }),
            Object(preact_min["h"])(
              "div",
              { className: Filter_styles.filterLabel },
              "Filter events"
            )
          )
        ),
        Object(preact_min["h"])(components_FullHeightFilterModal, {
          showModal: modalVisibility,
          closeHandler: this.openModal,
          title: "Filter tours",
          maxWidth: 100,
          mobileFilter: this.mobileFilter,
          clearFilter: clearFilter,
          contents: Object(preact_min["h"])(Filter_Contents, {
            pageLayout: pageLayout,
            tourDates: tourDates,
            locationOptions: locationOptions,
            dateOptions: dateOptions,
            selectFilter: this.selectFilter,
            theme: theme,
            mobile: true
          })
        })
      )
    );
  };

  return Filter;
}(preact_min["Component"]);

/* harmony default export */ var tours_Filter = (Filter_Filter);
// CONCATENATED MODULE: ./routes/tours/Tour.js
var Tour__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Tour__templateObject = Tour__taggedTemplateLiteralLoose(["\n        background: url(", ")\n          ", "\n          ", ";\n        padding-top: 40px;\n        @media (max-width: 600px) {\n          padding-top: 0px;\n        }\n      "], ["\n        background: url(", ")\n          ", "\n          ", ";\n        padding-top: 40px;\n        @media (max-width: 600px) {\n          padding-top: 0px;\n        }\n      "]),
    Tour__templateObject2 = Tour__taggedTemplateLiteralLoose(["\n        max-width: 1002px;\n        width: 100%;\n        display: ", ";\n        justify-content: space-between;\n        margin-left: auto;\n        margin-right: auto;\n        flex-wrap: wrap;\n        @media (max-width: 1000px) {\n          ", "\n        }\n        @media (max-width: 600px) {\n          display: flex;\n        }\n      "], ["\n        max-width: 1002px;\n        width: 100%;\n        display: ", ";\n        justify-content: space-between;\n        margin-left: auto;\n        margin-right: auto;\n        flex-wrap: wrap;\n        @media (max-width: 1000px) {\n          ", "\n        }\n        @media (max-width: 600px) {\n          display: flex;\n        }\n      "]),
    Tour__templateObject3 = Tour__taggedTemplateLiteralLoose(["\n        max-width: 1000px;\n        margin-top: 0px;\n        width: 100%;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 12px;\n        @media (max-width: 600px) {\n          padding-left: 14px;\n          padding-right: 14px;\n        }\n      "], ["\n        max-width: 1000px;\n        margin-top: 0px;\n        width: 100%;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 12px;\n        @media (max-width: 600px) {\n          padding-left: 14px;\n          padding-right: 14px;\n        }\n      "]),
    Tour__templateObject4 = Tour__taggedTemplateLiteralLoose(["\n        max-width: 1000px;\n        width: 100%;\n        margin-left: auto;\n        margin-right: auto;\n      "], ["\n        max-width: 1000px;\n        width: 100%;\n        margin-left: auto;\n        margin-right: auto;\n      "]),
    Tour__templateObject5 = Tour__taggedTemplateLiteralLoose(["\n        max-width: ", ";\n      "], ["\n        max-width: ", ";\n      "]),
    Tour__templateObject6 = Tour__taggedTemplateLiteralLoose(["\n        max-width: ", ";\n        width: 100%;\n        box-shadow: ", ";\n        border-radius: ", ";\n        margin-top: 0px;\n        overflow: ", ";\n        @media (max-width: 1000px) {\n          ", ";\n          margin-left: ", ";\n          margin-right: ", ";\n        }\n        @media (max-width: 600px) {\n          max-width: 100%;\n          padding-left: ", ";\n          padding-right: ", ";\n          margin-top: ", ";\n        }\n      "], ["\n        max-width: ", ";\n        width: 100%;\n        box-shadow: ", ";\n        border-radius: ", ";\n        margin-top: 0px;\n        overflow: ", ";\n        @media (max-width: 1000px) {\n          ", ";\n          margin-left: ", ";\n          margin-right: ", ";\n        }\n        @media (max-width: 600px) {\n          max-width: 100%;\n          padding-left: ", ";\n          padding-right: ", ";\n          margin-top: ", ";\n        }\n      "]),
    Tour__templateObject7 = Tour__taggedTemplateLiteralLoose(["\n        background: #fff;\n        font-size: 20px;\n        padding: 16px;\n        @media (max-width: 600px) {\n          font-size: 14px;\n          padding: 16px 12px;\n        }\n      "], ["\n        background: #fff;\n        font-size: 20px;\n        padding: 16px;\n        @media (max-width: 600px) {\n          font-size: 14px;\n          padding: 16px 12px;\n        }\n      "]);



function Tour__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function Tour__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Tour__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Tour__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















/**
 * Display tour page
 *
 * @class Tour
 * @extends {Component}
 */

var Tour__ref = Object(preact_min["h"])(
  Content["a" /* default */],
  null,
  Object(preact_min["h"])("div", { "class": "loading loading-lg" })
);

var Tour__ref2 = Object(preact_min["h"])(
  Content["a" /* default */],
  null,
  Object(preact_min["h"])(components_TourError, { type: "notFound" })
);

var Tour__ref3 = Object(preact_min["h"])(
  Content["a" /* default */],
  null,
  Object(preact_min["h"])(components_TourError, { type: "notPublished" })
);

var Tour__ref4 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var Tour_Tour = function (_Component) {
  Tour__inherits(Tour, _Component);

  function Tour(props) {
    Tour__classCallCheck(this, Tour);

    var _this = Tour__possibleConstructorReturn(this, _Component.call(this, props));

    _this.filter = function (e, dateOrLocation) {
      var mobileUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var update = {};

      if (mobileUpdate) {
        update = mobileUpdate;
      } else {
        if (dateOrLocation === "date") {
          var index = e.nativeEvent.target.selectedIndex;
          var text = e.nativeEvent.target[index].text;
          update.displayDate = text;
        }
        update[dateOrLocation] = e.target.value;
      }
      update.currentPage = 1;
      _this.setState(update);
      _this.load();
    };

    _this.clearFilter = function () {
      _this.setState({ currentPage: 1 });
      _this.load();
    };

    _this.load = function () {
      var onlyEventLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var token = null;
      if (typeof window !== "undefined") {
        var parsed = query_string_default.a.parse(window.location.search);
        token = parsed.token;
      }
      var _this$props = _this.props,
          slug = _this$props.slug,
          preview = _this$props.preview,
          getTour = _this$props.getTour,
          getTourPreview = _this$props.getTourPreview,
          tourGroupId = _this$props.tourGroupId;
      var _this$state = _this.state,
          currentPage = _this$state.currentPage,
          date = _this$state.date,
          location = _this$state.location;

      var query = {
        currentPage: currentPage,
        date: date,
        location: location,
        tourGroupId: tourGroupId,
        onlyEventLoading: onlyEventLoading
      };
      if (preview) {
        getTourPreview(slug, query);
      } else if (slug) {
        getTour(slug, query, token);
      }
    };

    _this.selectTab = function (selectedTab) {
      _this.setState({ selectedTab: selectedTab });
    };

    _this.selectPagination = function (currentPage) {
      _this.setState({ currentPage: currentPage });
      var onlyEventLoading = true;
      _this.load(onlyEventLoading);
    };

    _this.state = {
      selectedTab: "events",
      currentPage: 1,
      date: "",
      displayDate: "",
      location: ""
    };
    return _this;
  }

  Tour.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        slug = _props.slug,
        getTourFilterOptions = _props.getTourFilterOptions,
        tourGroupId = _props.tourGroupId,
        tour = _props.tours.tour,
        event = _props.event,
        order = _props.order,
        clearEvent = _props.clearEvent,
        clearOrder = _props.clearOrder;

    var query = { tourGroupId: tourGroupId };

    getTourFilterOptions(slug, query);
    if (!tour || event && event.data) {
      this.load();
    }
    if (event && event.data) {
      clearEvent();
    }
    if (order && order.data) {
      clearOrder();
    }
  };

  Tour.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.tourGroupId !== prevProps.tourGroupId) {
      var _props2 = this.props,
          tourGroupId = _props2.tourGroupId,
          slug = _props2.slug,
          _getTourFilterOptions = _props2.getTourFilterOptions;

      this.setState({ currentPage: 1 });
      var query = { tourGroupId: tourGroupId };
      _getTourFilterOptions(slug, query);
      this.load();
    }
    if (this.props.tours.tour !== prevProps.tours.tour) {
      if (this.props.tours.tour && this.props.tours.tour.name) {
        Object(BrowserUtils["b" /* updateTitle */])(this.props.tours.tour.name);
      }
    }
  };

  Tour.prototype.render = function render() {
    var _props3 = this.props,
        slug = _props3.slug,
        tourGroupId = _props3.tourGroupId,
        _props3$tours = _props3.tours,
        tour = _props3$tours.tour,
        loading = _props3$tours.loading,
        error = _props3$tours.error,
        tourDates = _props3$tours.tourDates,
        tourLocations = _props3$tours.tourLocations,
        eventLoading = _props3$tours.eventLoading,
        tourEvents = _props3$tours.tourEvents,
        featuredEvents = _props3$tours.featuredEvents;
    var _state = this.state,
        selectedTab = _state.selectedTab,
        currentPage = _state.currentPage,
        displayDate = _state.displayDate,
        location = _state.location,
        date = _state.date;


    var token = void 0,
        preview = void 0;
    if (typeof window !== "undefined") {
      var parsed = query_string_default.a.parse(window.location.search);
      token = parsed.token;
      preview = parsed.preview ? parsed.preview : false;
    }

    if (!tour || loading) {
      return Tour__ref;
    }
    if (error) {
      return Tour__ref2;
    }
    if (tour && !tour.published) {
      return Tour__ref3;
    }

    var pageLayout = tour.settings.pageLayout;
    var listAndDate = pageLayout === "list" && tour.settings.listViewType === "date";

    var events = [];
    if (tourEvents && tourEvents.length && featuredEvents) {
      events = tourEvents.filter(function (event) {
        var isFeaturedEvent = featuredEvents.find(function (featuredEvent) {
          return String(event._id) === String(featuredEvent._id);
        });
        if (!isFeaturedEvent) {
          return event;
        }
      });
    }
    var showGroup = tour.groups && tour.groups.length && !tourGroupId ? true : false;
    var showSocialMedia = !showGroup && pageLayout === "list" ? true : false;
    var showSocialModal = selectedTab === "about" || pageLayout === "tiles" || showGroup ? true : false;
    var background = tour.theme.background.type === "color" ? "" : tour.theme.background.image.url;
    var styles = {
      wrapper: Object(index_esm["css"])(Tour__templateObject, background, tour.theme.background.type === "image" ? "center center / cover no-repeat" : "", tour.theme.background.color),
      container: Object(index_esm["css"])(Tour__templateObject2, pageLayout === "tiles" ? "inherit" : "flex", listAndDate ? "justify-content: center" : ""),
      searchContainer: Object(index_esm["css"])(Tour__templateObject3),
      paginationWrapper: Object(index_esm["css"])(Tour__templateObject4),
      paginationContainer: Object(index_esm["css"])(Tour__templateObject5, pageLayout === "tiles" || showGroup ? "1000px" : "720px"),
      eventCol: Object(index_esm["css"])(Tour__templateObject6, pageLayout === "tiles" || showGroup ? "1002px" : "720px", listAndDate ? "0 1px 10px 2px rgba(32, 7, 64, 0.13)" : "none", listAndDate ? "4px" : "0px", listAndDate ? "hidden" : "visible", listAndDate ? "max-width: 100%" : "", listAndDate ? "14px" : "auto", listAndDate ? "14px" : "auto", listAndDate ? "0px" : "14px", listAndDate ? "0px" : "14px", listAndDate ? "12px" : "0px"),
      locationRow: Object(index_esm["css"])(Tour__templateObject7)
    };

    return Object(preact_min["h"])(
      "div",
      { className: styles.wrapper },
      Object(preact_min["h"])(tours_Header, {
        tour: tour,
        selectTab: this.selectTab,
        selectedTab: selectedTab,
        showSocialModal: showSocialModal
      }),
      selectedTab === "events" ? Object(preact_min["h"])(
        "div",
        { className: "eventContainer" },
        !showGroup ? Object(preact_min["h"])(
          "div",
          { className: styles.searchContainer },
          Object(preact_min["h"])(tours_Filter, {
            pageLayout: pageLayout,
            tourDates: tourDates,
            tourLocations: tourLocations,
            filter: this.filter,
            date: date,
            displayDate: displayDate,
            location: location,
            theme: tour.theme,
            totalSize: tour.totalEventSize,
            clearFilter: this.clearFilter
          })
        ) : null,
        Object(preact_min["h"])(
          "div",
          { className: styles.container },
          showGroup ? Object(preact_min["h"])(tours_TourGroup, {
            slug: slug,
            groups: tour.groups,
            theme: tour.theme,
            preview: preview,
            token: token
          }) : Object(preact_min["h"])(
            "div",
            { className: styles.eventCol },
            listAndDate && Object(preact_min["h"])(tours_FilterValueDisplay, {
              date: displayDate,
              location: location,
              listAndDate: true,
              totalSize: tour.totalEventSize,
              theme: tour.theme
            }),
            eventLoading ? Tour__ref4 : Object(preact_min["h"])(
              "div",
              null,
              Object(preact_min["h"])(tours_FeaturedEvents, {
                events: featuredEvents,
                pageLayout: pageLayout,
                theme: tour.theme,
                eventListingLayout: tour.settings.eventListingLayout,
                listViewType: tour.settings.listViewType,
                showPrice: tour.settings.showPrice
              }),
              Object(preact_min["h"])(tours_Events, {
                events: events,
                pageLayout: pageLayout,
                theme: tour.theme,
                eventListingLayout: tour.settings.eventListingLayout,
                listViewType: tour.settings.listViewType,
                showPrice: tour.settings.showPrice
              })
            )
          ),
          showSocialMedia && Object(preact_min["h"])(tours_SocialMedia, {
            slug: slug,
            listViewType: tour.settings.listViewType,
            showPrice: tour.settings.showPrice,
            eventCardBackgroundColor: tour.theme.eventCardBackgroundColor,
            cardAndBarOpacity: tour.theme.cardAndBarOpacity
          })
        )
      ) : Object(preact_min["h"])(tours_About, Tour__extends({
        name: tour.name,
        description: tour.description,
        eventCardBackgroundColor: tour.theme.eventCardBackgroundColor
      }, tour.social)),
      !showGroup && selectedTab === "events" ? Object(preact_min["h"])(
        "div",
        { className: styles.paginationWrapper },
        Object(preact_min["h"])(
          "div",
          { className: styles.paginationContainer },
          Object(preact_min["h"])(components_Pagination, {
            selectPagination: this.selectPagination,
            currentPage: currentPage,
            totalSize: tour.totalEventSize,
            position: "right",
            theme: tour.theme ? tour.theme : null
          })
        )
      ) : null,
      Object(preact_min["h"])(tours_Sponsors, {
        sponsorsLogos: tour.sponsorsLogos,
        sponsorBoxBackgroundColor: tour.theme.sponsorBoxBackgroundColor
      })
    );
  };

  return Tour;
}(preact_min["Component"]);

/* harmony default export */ var tours_Tour = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    tours: state.tours,
    event: state.event,
    order: state.order
  };
}, {
  getTour: tourActions_getTour,
  getTourPreview: tourActions_getTourPreview,
  getTourFilterOptions: tourActions_getTourFilterOptions,
  clearEvent: eventActions["q" /* clearEvent */],
  clearOrder: orderActions["N" /* clearOrder */]
})(Tour_Tour));
// CONCATENATED MODULE: ./routes/giftCards/GiftCard.js


function GiftCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GiftCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GiftCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var bow = __webpack_require__("FULv");
var cornerPercentWidth = "26%";
var cornerPercentHeight = "43%";

var GiftCard_GiftCard = function (_Component) {
  GiftCard__inherits(GiftCard, _Component);

  function GiftCard(props) {
    GiftCard__classCallCheck(this, GiftCard);

    var _this = GiftCard__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = { width: 200 };
    return _this;
  }

  GiftCard.prototype.componentDidMount = function componentDidMount() {
    var _parent$getBoundingCl = this.parent.getBoundingClientRect(),
        width = _parent$getBoundingCl.width;

    this.setState({ width: width });
  };

  GiftCard.prototype.render = function render() {
    var _this2 = this,
        _ref;

    var _props = this.props,
        backgroundColor = _props.backgroundColor,
        name = _props.name,
        cardNumber = _props.cardNumber,
        expiryDate = _props.expiryDate,
        amount = _props.amount,
        image = _props.image,
        _props$showExpiry = _props.showExpiry,
        showExpiry = _props$showExpiry === undefined ? true : _props$showExpiry,
        _props$showNumber = _props.showNumber,
        showNumber = _props$showNumber === undefined ? true : _props$showNumber;
    var width = this.state.width;

    var fontSize = width / 10;
    var hasImage = image && image.handle;
    return Object(preact_min["h"])(
      "div",
      {
        ref: function ref(_ref2) {
          return _this2.parent = _ref2;
        },
        style: {
          width: "100%",
          height: "100%",
          borderRadius: 4,
          backgroundColor: backgroundColor,
          position: "relative",
          fontSize: fontSize
        }
      },
      Object(preact_min["h"])("div", {
        style: {
          backgroundImage: "url(" + bow + ")",
          position: "absolute",
          width: cornerPercentWidth,
          height: cornerPercentHeight,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat"
        }
      }),
      Object(preact_min["h"])(
        "div",
        {
          style: (_ref = {
            fontSize: "1em",
            fontWeight: 600,
            color: "white",
            position: "absolute",
            right: 8,
            top: 8
          }, _ref["color"] = "white", _ref)
        },
        "$ " + amount
      ),
      Object(preact_min["h"])(
        "div",
        { style: { width: "100%", height: "100%" } },
        Object(preact_min["h"])(
          "div",
          {
            style: {
              position: "absolute",
              width: "55%",
              height: "35%",
              overflow: "auto",
              margin: "auto",
              alignItems: "center",
              textAlign: "center",
              verticalAlign: "middle",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0
            }
          },
          Object(preact_min["h"])(
            "div",
            {
              style: {
                display: "flex",
                marginBottom: "0.2em",
                alignItems: "center",
                textAlign: "center",
                justifyContent: "center"
              }
            },
            hasImage ? Object(preact_min["h"])(
              "div",
              {
                style: { height: fontSize, marginRight: 2, display: "flex" }
              },
              Object(preact_min["h"])("img", {
                style: {
                  width: fontSize,
                  height: fontSize,
                  borderRadius: 4,
                  verticalAlign: "super"
                },
                src: getImageUrl(image.handle, 30, 30)
              })
            ) : null,
            Object(preact_min["h"])(
              "div",
              {
                style: {
                  fontSize: "0.65em",
                  fontWeight: 600,
                  color: "white",
                  display: "flex"
                }
              },
              "" + name
            )
          ),
          showNumber ? Object(preact_min["h"])(
            "div",
            {
              style: {
                borderRadius: 3,
                backgroundColor: "white",
                padding: "2px 6px 2px 6px",
                fontSize: "0.4em",
                width: "auto"
              }
            },
            "Card number: " + cardNumber
          ) : null
        )
      ),
      showExpiry ? Object(preact_min["h"])(
        "div",
        {
          style: {
            position: "absolute",
            bottom: 6,
            textAlign: "center",
            width: "100%",
            fontSize: "0.35em",
            fontWeight: 600,
            color: "white"
          }
        },
        "Expires on: " + expiryDate
      ) : null
    );
  };

  return GiftCard;
}(preact_compat_es["Component"]);


// CONCATENATED MODULE: ./routes/giftCards/GiftCardPage.js
var GiftCardPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function GiftCardPage__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GiftCardPage__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GiftCardPage__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var GiftCardPage_formName = "giftCardOrder";

var giftCardStyleMap = {
  default: "#6621c0",
  royal: "#8D721E",
  breeze: "#1E72D6"
};

var GiftCardPage__ref = Object(preact_min["h"])(giftCards_GiftCardPageHeader, null);

var GiftCardPage__ref2 = Object(preact_min["h"])(
  "div",
  { "class": "column col-4 col-sm-12" },
  Object(preact_min["h"])(components_YourOrder, { allowDiscountsAdd: false, isGlobal: true })
);

var GiftCardPage_GiftCardPage = function (_Component) {
  GiftCardPage__inherits(GiftCardPage, _Component);

  function GiftCardPage(props) {
    GiftCardPage__classCallCheck(this, GiftCardPage);

    var _this = GiftCardPage__possibleConstructorReturn(this, _Component.call(this, props));

    _this.startGiftCardOrder = function (data) {
      var _this$props = _this.props,
          giftCardSlug = _this$props.giftCardSlug,
          giftCards = _this$props.giftCards,
          order = _this$props.order,
          requestOrder = _this$props.requestOrder;
      var giftCardPage = giftCards.giftCardPage;

      if (!order.orderRequest.loading) {
        var lastOrderId = order.data ? order.data._id : null;
        var parsed = query_string_default.a.parse(window.location.search);
        var discountCode = parsed.discountcode ? parsed.discountcode : order.discountCode;
        requestOrder(giftCardSlug, giftCardPage.userId, false, data.giftCardOrder, discountCode, 0, lastOrderId, true);
      }
    };

    return _this;
  }

  GiftCardPage.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        giftCardSlug = _props.giftCardSlug,
        getGiftCardPage = _props.getGiftCardPage;

    getGiftCardPage(giftCardSlug);
  };

  GiftCardPage.prototype.componentDidUpdate = function componentDidUpdate() {
    var _props2 = this.props,
        loadSummary = _props2.loadSummary,
        giftCardOrder = _props2.giftCardOrder;
    var giftCardPage = this.props.giftCards.giftCardPage;

    loadSummary(giftCardPage.userId, [], 0, {}, [], giftCardOrder, false);
  };

  GiftCardPage.prototype.render = function render() {
    var _props3 = this.props,
        giftCards = _props3.giftCards,
        giftCardOrder = _props3.giftCardOrder,
        giftCardSlug = _props3.giftCardSlug,
        order = _props3.order;

    if (giftCards.loading || !giftCards.giftCardPage) {
      return Object(preact_min["h"])(
        Page["a" /* default */],
        null,
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])("div", { "class": "loading loading-lg", style: { minHeight: 500 } })
        )
      );
    }
    var hasAtleastOneCard = (giftCardOrder || []).reduce(function (status, order) {
      var res = status;
      if (!status) {
        res = order.quantity > 0;
      }
      return res;
    }, false);
    var orderRequest = order.orderRequest;
    var _props$giftCards = this.props.giftCards,
        giftCardPage = _props$giftCards.giftCardPage,
        giftCardList = _props$giftCards.giftCardList;
    var style = giftCardPage.style;
    var backgroundColor = style.backgroundColor,
        buttonColor = style.buttonColor;

    return Object(preact_min["h"])(
      "div",
      { style: { backgroundColor: backgroundColor } },
      Object(preact_min["h"])(
        Page["a" /* default */],
        {
          background: backgroundColor,
          border: true,
          banner: GiftCardPage__ref,
          isGlobal: true
        },
        Object(preact_min["h"])(
          "div",
          {
            style: { width: "100%", display: "flex", justifyContent: "center" }
          },
          Object(preact_min["h"])(components_Picture, {
            img: style.banner,
            alt: giftCardPage.name + " Event Banner",
            width: 900
          })
        ),
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])(
            "div",
            { "class": "event" },
            Object(preact_min["h"])(
              "div",
              { "class": "column col-8 col-sm-12 pad-lg gift-card-info" },
              Object(preact_min["h"])(GiftCardPage_GiftCardForm, {
                giftCardPage: giftCardPage,
                giftCardList: giftCardList,
                startGiftCardOrder: this.startGiftCardOrder,
                hasAtleastOneCard: hasAtleastOneCard,
                giftCardSlug: giftCardSlug,
                buttonColor: buttonColor,
                orderRequest: orderRequest
              })
            ),
            GiftCardPage__ref2
          )
        )
      )
    );
  };

  return GiftCardPage;
}(preact_min["Component"]);

var GiftCardPage_Divider = function Divider(_ref3) {
  var style = _ref3.style;

  return Object(preact_min["h"])("div", {
    style: GiftCardPage__extends({
      width: "100%",
      borderBottom: "solid 1px",
      borderColor: "#dedede"
    }, style)
  });
};

var giftCardFormStyle = Object(index_esm["css"])({
  display: "flex",
  marginBottom: 40,
  "@media (max-width: 800px)": {
    flexDirection: "column"
  },
  "&:last-child": {
    marginBottom: 0
  }
});

var giftCardStyle = Object(index_esm["css"])({
  width: 200,
  height: 120,
  minWidth: 200,
  marginRight: 12,
  "@media (max-width: 800px)": {
    marginBottom: 8
  }
});

var GiftCardPage__ref4 = Object(preact_min["h"])(
  "h2",
  null,
  "Choose gift card(s)"
);

var GiftCardPage__ref5 = Object(preact_min["h"])(
  "h4",
  null,
  "Description:"
);

var GiftCardPage_GiftCardForm = function (_Component2) {
  GiftCardPage__inherits(GiftCardForm, _Component2);

  function GiftCardForm() {
    GiftCardPage__classCallCheck(this, GiftCardForm);

    return GiftCardPage__possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  GiftCardForm.prototype.render = function render() {
    var _props4 = this.props,
        giftCardPage = _props4.giftCardPage,
        giftCardList = _props4.giftCardList,
        startGiftCardOrder = _props4.startGiftCardOrder,
        handleSubmit = _props4.handleSubmit,
        hasAtleastOneCard = _props4.hasAtleastOneCard,
        giftCardSlug = _props4.giftCardSlug,
        buttonColor = _props4.buttonColor,
        orderRequest = _props4.orderRequest;

    return Object(preact_min["h"])(
      "form",
      { onSubmit: handleSubmit(startGiftCardOrder) },
      Object(preact_min["h"])(
        "p",
        null,
        giftCardPage.description
      ),
      orderRequest.error ? Object(preact_min["h"])(
        "div",
        {
          style: {
            fontSize: 12,
            color: "#DD1C1C",
            textAlign: "left"
          }
        },
        orderRequest.error
      ) : null,
      Object(preact_min["h"])(
        "div",
        { style: { marginTop: 40 } },
        GiftCardPage__ref4,
        Object(preact_min["h"])(GiftCardPage_Divider, { style: { marginBottom: 24 } }),
        giftCardList.map(function (giftCard, i) {
          var _h;

          var style = giftCard.style,
              description = giftCard.description,
              price = giftCard.price,
              name = giftCard.name,
              companyLogo = giftCard.companyLogo,
              maxPerOrder = giftCard.maxPerOrder,
              _id = giftCard._id,
              remaining = giftCard.remaining;

          var soldOut = remaining <= 0;
          var backgroundColor = style.type === "custom" ? style.backgroundColor : giftCardStyleMap[style.type];
          return Object(preact_min["h"])(
            "div",
            { className: giftCardFormStyle },
            Object(preact_min["h"])(
              "div",
              { className: giftCardStyle },
              Object(preact_min["h"])(GiftCard_GiftCard, {
                backgroundColor: backgroundColor,
                name: name,
                cardNumber: "-",
                expiryDate: "-",
                amount: price,
                image: companyLogo
              })
            ),
            Object(preact_min["h"])(
              "div",
              null,
              soldOut ? Object(preact_min["h"])(
                "div",
                {
                  style: {
                    fontSize: 12,
                    color: "#DD1C1C",
                    textAlign: "left"
                  }
                },
                "Gift card sold out"
              ) : null,
              description ? GiftCardPage__ref5 : null,
              Object(preact_min["h"])(
                "p",
                null,
                description + " ",
                Object(preact_min["h"])(
                  match["Link"],
                  {
                    href: "/gift-cards/" + giftCardSlug + "/event-list/" + _id,
                    style: {
                      color: "#196097",
                      fontSize: "0.8rem",
                      textDecoration: "underline"
                    }
                  },
                  "See events"
                )
              ),
              Object(preact_min["h"])(redux_form_es["a" /* Field */], (_h = {
                name: "giftCardOrder[" + i + "].quantity",
                component: fields_NumberIncrementorField,
                disabled: false,
                formName: GiftCardPage_formName,
                max: remaining < maxPerOrder ? remaining : maxPerOrder
              }, _h["disabled"] = soldOut, _h.label = "Quantity:", _h))
            )
          );
        })
      ),
      Object(preact_min["h"])(
        "div",
        { style: { width: "100%" } },
        Object(preact_min["h"])(
          ActionBar["a" /* default */],
          null,
          Object(preact_min["h"])(
            ActionButton["a" /* default */],
            {
              disabled: !hasAtleastOneCard,
              loading: false,
              dataCY: "EnterDetails"
            },
            "Enter Details"
          )
        )
      )
    );
  };

  return GiftCardForm;
}(preact_min["Component"]);

var GiftCardPage_selector = Object(redux_form_es["d" /* formValueSelector */])(GiftCardPage_formName);

GiftCardPage_GiftCardForm = Object(redux_form_es["f" /* reduxForm */])({
  form: GiftCardPage_formName,
  destroyOnUnmount: true,
  enableReinitialize: true,
  onSubmitFail: function onSubmitFail(errors) {
    Object(ScrollToErrors["a" /* scrollToErrors */])();
  }
})(GiftCardPage_GiftCardForm);

GiftCardPage_GiftCardForm = Object(es["b" /* connect */])(function (state) {
  var initialValues = {
    giftCardOrder: (state.giftCards.giftCardList || []).map(function (giftcard) {
      return {
        giftCardTypeId: giftcard._id,
        name: giftcard.name,
        quantity: 0,
        price: giftcard.price
      };
    })
  };
  return {
    initialValues: initialValues
  };
}, {})(GiftCardPage_GiftCardForm);

/* harmony default export */ var giftCards_GiftCardPage = (Object(es["b" /* connect */])(function (state) {
  return {
    giftCards: state.giftCards,
    order: state.order,
    giftCardOrder: GiftCardPage_selector(state, "giftCardOrder")
  };
}, {
  getGiftCardPage: giftCardActions_getGiftCardPage,
  loadSummary: orderSummaryActions["d" /* loadSummary */],
  requestOrder: orderActions["_0" /* requestOrder */]
})(GiftCardPage_GiftCardPage));
// EXTERNAL MODULE: ./assets/images/icon-arrow-left-blue.svg
var icon_arrow_left_blue = __webpack_require__("HtZT");
var icon_arrow_left_blue_default = /*#__PURE__*/__webpack_require__.n(icon_arrow_left_blue);

// CONCATENATED MODULE: ./routes/giftCards/GiftCardEventPage.js


function GiftCardEventPage__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GiftCardEventPage__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GiftCardEventPage__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var GiftCardEventPage_giftCardStyleMap = {
  default: "#6621c0",
  royal: "#8D721E",
  breeze: "#1E72D6"
};

var GiftCardEventPage_giftCardStyle = Object(index_esm["css"])({
  width: 500,
  height: 270,
  margin: "auto",
  "@media (max-width: 800px)": {
    width: 292,
    height: 158
  }
});

var eventListStyle = Object(index_esm["css"])({
  margin: "auto",
  maxWidth: 800,
  "@media (max-width: 800px)": {
    padding: "0px 14px"
  }
});

var GiftCardEventPage__ref = Object(preact_min["h"])(
  "h2",
  null,
  "Available to use on these events"
);

var GiftCardEventPage_GiftCardEventPage = function (_Component) {
  GiftCardEventPage__inherits(GiftCardEventPage, _Component);

  function GiftCardEventPage(props) {
    GiftCardEventPage__classCallCheck(this, GiftCardEventPage);

    var _this = GiftCardEventPage__possibleConstructorReturn(this, _Component.call(this, props));

    _this.nextPage = function () {
      var _this$props = _this.props,
          giftCards = _this$props.giftCards,
          giftCardTypeId = _this$props.giftCardTypeId,
          getGiftCardEvents = _this$props.getGiftCardEvents;
      var events = giftCards.events;
      var page = events.page;

      getGiftCardEvents(giftCardTypeId, page + 1);
    };

    _this.previousPage = function () {
      var _this$props2 = _this.props,
          giftCards = _this$props2.giftCards,
          giftCardTypeId = _this$props2.giftCardTypeId,
          getGiftCardEvents = _this$props2.getGiftCardEvents;
      var events = giftCards.events;
      var page = events.page;

      getGiftCardEvents(giftCardTypeId, page - 1);
    };

    return _this;
  }

  GiftCardEventPage.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        giftCardSlug = _props.giftCardSlug,
        getGiftCardPage = _props.getGiftCardPage,
        getGiftCardEvents = _props.getGiftCardEvents,
        giftCardTypeId = _props.giftCardTypeId;

    getGiftCardPage(giftCardSlug);
    getGiftCardEvents(giftCardTypeId, 0);
  };

  GiftCardEventPage.prototype.render = function render() {
    var _props2 = this.props,
        giftCards = _props2.giftCards,
        giftCardTypeId = _props2.giftCardTypeId;
    var giftCardPage = giftCards.giftCardPage,
        giftCardList = giftCards.giftCardList,
        events = giftCards.events;

    if (giftCards.loading || !giftCards.giftCardPage) {
      return Object(preact_min["h"])(
        Page["a" /* default */],
        null,
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])("div", { "class": "loading loading-lg", style: { minHeight: 500 } })
        )
      );
    }
    var giftCardType = giftCardList.find(function (giftCard) {
      return giftCard._id === giftCardTypeId;
    });
    var moreEvents = Object(preact_min["h"])(
      "div",
      { className: eventListStyle },
      Object(preact_min["h"])(
        "div",
        { style: { margin: "auto", marginTop: 32 } },
        GiftCardEventPage__ref,
        Object(preact_min["h"])("div", {
          style: {
            borderBottom: "solid 1px #dedede",
            marginTop: 12,
            marginBottom: 18
          }
        }),
        Object(preact_min["h"])(organiser_OrganiserEvents, {
          events: events.list,
          nextPage: this.nextPage,
          previousPage: this.previousPage,
          page: events.page,
          numEvents: events.total,
          loadingEvents: events.loading,
          size: "large",
          maxWidth: "100%"
        })
      )
    );
    return Object(preact_min["h"])(
      "div",
      { style: { backgroundColor: "#f9f9fa", paddingBottom: 70 } },
      Object(preact_min["h"])(
        Page["a" /* default */],
        {
          border: true,
          maxWidth: 800,
          banner: Object(preact_min["h"])(GiftCardEventPage_Header, {
            link: Object(config["a" /* default */])("TICKETING_URL") + "/gift-cards/" + giftCardPage.slug
          }),
          isGlobal: false
        },
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])(GiftCardEventPage_GiftCardHeader, { giftCardType: giftCardType })
        )
      ),
      moreEvents
    );
  };

  return GiftCardEventPage;
}(preact_min["Component"]);

var GiftCardEventPage_GiftCardHeader = function GiftCardHeader(_ref2) {
  var giftCardType = _ref2.giftCardType;
  var style = giftCardType.style,
      price = giftCardType.price,
      name = giftCardType.name,
      companyLogo = giftCardType.companyLogo;

  var backgroundColor = style.type === "custom" ? style.backgroundColor : GiftCardEventPage_giftCardStyleMap[style.type];
  return Object(preact_min["h"])(
    "div",
    { style: { padding: "24px 12px" } },
    Object(preact_min["h"])(
      "div",
      { className: GiftCardEventPage_giftCardStyle },
      Object(preact_min["h"])(GiftCard_GiftCard, {
        backgroundColor: backgroundColor,
        name: name,
        showNumber: false,
        showExpiry: false,
        amount: price,
        image: companyLogo
      })
    )
  );
};

var GiftCardEventPage_headerStyle = Object(index_esm["css"])({
  width: "100%",
  position: "relative",
  backgroundColor: "white",
  minHeight: 70,
  paddingLeft: 60,
  paddingRight: 14,
  paddingBottom: 26,
  paddingTop: 22,
  display: "flex",
  boxShadow: "0 0 1px 0 #f1f1f1, 0 1px 3px 0 rgba(9, 30, 66, 0.13)",
  zIndex: 100,
  "@media (max-width: 800px)": {
    display: "block",
    paddingTop: 16,
    minHeight: 56,
    paddingLeft: 14,
    paddingBottom: 19
  }
});

var GiftCardEventPage_linkStyle = Object(index_esm["css"])({
  background: "url(" + icon_arrow_left_blue_default.a + ") no-repeat left center",
  svg: {
    fill: "#196097"
  },
  color: "#196097",
  padding: "0px 0 0 24px",
  ":hover": {
    color: "#196097"
  },
  cursor: "pointer"
});

var GiftCardEventPage_Header = function Header(_ref3) {
  var link = _ref3.link;

  return Object(preact_min["h"])(
    "div",
    { className: GiftCardEventPage_headerStyle },
    Object(preact_min["h"])(
      "a",
      { href: link, "aria-label": "Back", className: GiftCardEventPage_linkStyle },
      "Back to gift cards"
    )
  );
};

/* harmony default export */ var giftCards_GiftCardEventPage = (Object(es["b" /* connect */])(function (state) {
  return {
    giftCards: state.giftCards,
    order: state.order
  };
}, {
  getGiftCardPage: giftCardActions_getGiftCardPage,
  getGiftCardEvents: giftCardActions_getGiftCardEvents
})(GiftCardEventPage_GiftCardEventPage));
// CONCATENATED MODULE: ./components/WhatToDoNext.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }





var footerBox = Object(index_esm["css"])({
  padding: "12px 16px",
  borderRadius: 4,
  maxWidth: 800,
  width: "100%",
  backgroundColor: "#fafafa",
  marginTop: 24,
  display: "flex",
  justifyContent: "center"
});

var WhatToDoNext__ref2 = Object(preact_min["h"])(
  "h2",
  null,
  "Wondering what to do later?"
);

var WhatToDoNext__ref3 = Object(preact_min["h"])(
  "p",
  null,
  "Be inspired, entertained and educated by the incredible lineup of events on Humanitix."
);

var WhatToDoNext_WhatToDoNext = function WhatToDoNext(_ref) {
  _objectDestructuringEmpty(_ref);

  return Object(preact_min["h"])(
    "div",
    { className: footerBox },
    Object(preact_min["h"])(
      "div",
      { style: { width: 400 } },
      WhatToDoNext__ref2,
      WhatToDoNext__ref3,
      Object(preact_min["h"])(
        components_Button["a" /* default */],
        { link: Object(config["a" /* default */])("WEBSITE_URL") + "/au/search", type: "primary" },
        "Explore events"
      )
    )
  );
};

/* harmony default export */ var components_WhatToDoNext = (WhatToDoNext_WhatToDoNext);
// CONCATENATED MODULE: ./routes/complete/GlobalOrderComplete.js


function GlobalOrderComplete__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GlobalOrderComplete__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GlobalOrderComplete__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










//import Button from "../../components/Button"
var GlobalOrderComplete_wrapper = Object(index_esm["css"])({
  maxWidth: 800,
  width: "100%",
  backgroundColor: "#FFF",
  margin: "0 auto",
  borderRadius: 4,
  padding: "32px 12px",
  textAlign: "center",
  boxShadow: "0 1px 10px 0 rgba(9, 30, 66, 0.13)",
  marginBottom: 14,
  "@media(max-width: 800px)": {
    padding: "24px 12px"
  }
});
var GlobalOrderComplete_heading = Object(index_esm["css"])({
  marginBottom: 8
});
var GlobalOrderComplete_paragraph = Object(index_esm["css"])({
  marginBottom: 24
});
var charityText = Object(index_esm["css"])({
  fontSize: 16,
  width: 400
});

var GlobalOrderComplete__ref2 = Object(preact_min["h"])(components_WhatToDoNext, null);

var GlobalOrderComplete_GlobalOrderComplete = function (_Component) {
  GlobalOrderComplete__inherits(GlobalOrderComplete, _Component);

  function GlobalOrderComplete() {
    GlobalOrderComplete__classCallCheck(this, GlobalOrderComplete);

    return GlobalOrderComplete__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  GlobalOrderComplete.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        order = _props.order,
        orderId = _props.orderId,
        getOrder = _props.getOrder,
        giftCards = _props.giftCards,
        slug = _props.slug,
        getGiftCardPage = _props.getGiftCardPage;

    if (!order.data && !order.loading) {
      getOrder(orderId);
    }
    if (!giftCards.giftCardPage && !giftCards.loading) {
      getGiftCardPage(slug);
    }
  };

  GlobalOrderComplete.prototype.render = function render(_ref) {
    var order = _ref.order,
        giftCards = _ref.giftCards;

    if (!order.data || giftCards.loading) {
      return;
    }
    return Object(preact_min["h"])(
      "div",
      {
        style: {
          backgroundColor: "#F7FBFF"
        }
      },
      Object(preact_min["h"])(
        Page["a" /* default */],
        { transparent: true, border: false, isGlobal: true },
        Object(preact_min["h"])(
          Content["a" /* default */],
          null,
          Object(preact_min["h"])(
            "div",
            {
              style: {
                paddingTop: 40,
                paddingLeft: 14,
                paddingRight: 14
              }
            },
            Object(preact_min["h"])(
              "div",
              { "class": GlobalOrderComplete_wrapper },
              Object(preact_min["h"])(GlobalOrderComplete_Thanks, { order: order, giftCards: giftCards }),
              Object(preact_min["h"])(GlobalOrderComplete_OrderDetails, { order: order }),
              GlobalOrderComplete__ref2
            )
          )
        )
      )
    );
  };

  return GlobalOrderComplete;
}(preact_min["Component"]);

var orderBox = Object(index_esm["css"])({
  padding: "12px 16px",
  borderRadius: 4,
  border: "solid 1px #dedede",
  maxWidth: 800,
  width: "100%",
  textAlign: "left"
});

var GlobalOrderComplete__ref4 = Object(preact_min["h"])(
  "h2",
  null,
  "Your order details"
);

var GlobalOrderComplete_OrderDetails = function OrderDetails(_ref3) {
  var order = _ref3.order;

  var purchaseList = order.data.giftCards.reduce(function (list, giftCard) {
    var index = list.indexOf(function (giftCardQuant) {
      return giftCardQuant._id === giftCard._id;
    });
    if (index >= 0) {
      list[index].quantity++;
    } else {
      list.push({
        _id: giftCard._id,
        name: giftCard.giftCardTypeName,
        quantity: 1
      });
    }
    return list;
  }, []);
  var purchaseString = purchaseList.reduce(function (str, item, i) {
    var last = i === purchaseList.length - 1;
    return "" + str + item.quantity + " x " + item.name + " " + (last ? "" : ",");
  }, "");
  return Object(preact_min["h"])(
    "div",
    { className: orderBox },
    GlobalOrderComplete__ref4,
    Object(preact_min["h"])(
      "p",
      null,
      "You have purchased: " + purchaseString
    ),
    Object(preact_min["h"])(
      "p",
      null,
      "Order name: " + order.data.orderName
    ),
    Object(preact_min["h"])(
      "p",
      null,
      "Order date: " + order.data.completedDisplayDate
    )
  );
};

var GlobalOrderComplete__ref6 = Object(preact_min["h"])(
  "p",
  { className: charityText },
  "Humanitix donates 100% of booking fee profits to programs that \u2028empower disadvantaged students through education."
);

var GlobalOrderComplete_Thanks = function Thanks(_ref5) {
  var order = _ref5.order,
      giftCards = _ref5.giftCards;
  var giftCardPage = giftCards.giftCardPage;
  var style = giftCardPage.style;

  return Object(preact_min["h"])(
    "div",
    null,
    Object(preact_min["h"])(
      "h1",
      { className: GlobalOrderComplete_heading },
      "Thanks for your purchase, ",
      order.data.firstName,
      "!"
    ),
    Object(preact_min["h"])(GlobalOrderComplete_EmailDetails, { order: order }),
    Object(preact_min["h"])(
      "div",
      { style: { width: "100%", display: "flex", justifyContent: "center" } },
      Object(preact_min["h"])(components_Picture, {
        img: style.banner,
        alt: giftCardPage.name + " Event Banner",
        width: 400
      })
    ),
    Object(preact_min["h"])(
      "div",
      { style: { width: "100%", display: "flex", justifyContent: "center" } },
      GlobalOrderComplete__ref6
    )
  );
};

var GlobalOrderComplete_EmailDetails = function EmailDetails(_ref7) {
  var order = _ref7.order;
  var giftCards = order.data.giftCards;

  var emails = Array.from(new Set(giftCards.map(function (giftCard) {
    return giftCard.recipientEmail;
  })));
  var isPlural = giftCards.length > 1;
  var emailString = emails.reduce(function (str, email, i) {
    return "" + str + email + (i === emails.length - 1 ? "" : ", ");
  }, "");
  return Object(preact_min["h"])(
    "p",
    { className: GlobalOrderComplete_paragraph },
    "Your gift card" + (isPlural ? "s have" : " has") + " successfully been sent to " + emailString
  );
};
/* harmony default export */ var complete_GlobalOrderComplete = (Object(es["b" /* connect */])(function (state) {
  return {
    order: state.order,
    giftCards: state.giftCards
  };
}, { getOrder: orderActions["Q" /* getOrder */], getGiftCardPage: giftCardActions_getGiftCardPage })(GlobalOrderComplete_GlobalOrderComplete));
// CONCATENATED MODULE: ./routes/public/editOrder/Header.js
var editOrder_Header__templateObject = editOrder_Header__taggedTemplateLiteralLoose(["\n  flex: 1;\n  @media (max-width: 900px) {\n    margin-bottom: 12px;\n  }\n"], ["\n  flex: 1;\n  @media (max-width: 900px) {\n    margin-bottom: 12px;\n  }\n"]),
    editOrder_Header__templateObject2 = editOrder_Header__taggedTemplateLiteralLoose(["\n      border-radius: 4px;\n      background: rgba(255, 255, 255, 0.9);\n      padding: 18px;\n      margin: 0 0 24px 0;\n      display: flex;\n      @media (max-width: 900px) {\n        display: block;\n        padding: 14px;\n      }\n    "], ["\n      border-radius: 4px;\n      background: rgba(255, 255, 255, 0.9);\n      padding: 18px;\n      margin: 0 0 24px 0;\n      display: flex;\n      @media (max-width: 900px) {\n        display: block;\n        padding: 14px;\n      }\n    "]);



function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function editOrder_Header__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }







var info = Object(index_esm["css"])(editOrder_Header__templateObject);

var actionsBlock = Object(index_esm["css"])({
  maxWidth: 500,
  width: "100%",
  textAlign: "right",
  p: {
    color: "#5a626c",
    marginBottom: 4,
    textAlign: "right"
  },
  "@media(max-width: 900px)": {
    width: "auto",
    textAlign: "left",
    p: {
      textAlign: "right"
    }
  },
  "&:after": {
    clear: "both",
    content: '""',
    display: "block"
  }
});

var viewButton = {
  marginRight: 8,
  "@media (max-width: 900px)": {
    marginRight: 8
  }
};

var editOrder_Header_Header = function (_Component) {
  Header__inherits(Header, _Component);

  function Header(props) {
    Header__classCallCheck(this, Header);

    var _this = Header__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      deleteOpen: false,
      verifyOpen: false
    };
    return _this;
  }

  Header.prototype.render = function render() {
    var currentEvent = this.props.currentEvent;

    var eventUrl = Object(config["a" /* default */])("TICKETING_URL") + "/" + currentEvent.data.slug;
    var viewTxt = "View";

    var eventHeader = Object(index_esm["css"])(editOrder_Header__templateObject2);

    return Object(preact_min["h"])(
      "div",
      { className: eventHeader },
      Object(preact_min["h"])(
        "div",
        { className: info },
        Object(preact_min["h"])(
          "h3",
          { style: { fontSize: 20, fontWeight: 400 } },
          " ",
          currentEvent.data.name
        ),
        Object(preact_min["h"])(Header_DatesListDisplay, { dates: currentEvent.data.dates })
      ),
      Object(preact_min["h"])(
        "div",
        { className: actionsBlock },
        Object(preact_min["h"])(
          "a",
          { href: eventUrl, target: "_blank", style: { float: "right" } },
          Object(preact_min["h"])(
            components_Button["a" /* default */],
            { style: viewButton, ariaLabel: viewTxt },
            viewTxt
          )
        )
      )
    );
  };

  return Header;
}(preact_min["Component"]);

var Header_DatesListDisplay = function DatesListDisplay(_ref) {
  var dates = _ref.dates;

  if (!dates) {
    return null;
  }
  var activeDates = dates.filter(function (date) {
    return !date.disabled;
  });
  var datesInOrder = activeDates.sort(function (a, b) {
    return a.startDate > b.startDate ? 1 : -1;
  });
  var date = datesInOrder[0];
  var dateStr = date && date.display ? date.display.date + ", " + date.display.time : "";
  return Object(preact_min["h"])(
    "span",
    null,
    dateStr,
    " ",
    datesInOrder.length > 1 ? Object(preact_min["h"])(
      "span",
      null,
      "+ ",
      datesInOrder.length - 1,
      " more"
    ) : ""
  );
};
/* harmony default export */ var editOrder_Header = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    currentEvent: state.event
  };
}, {})(editOrder_Header_Header));
// CONCATENATED MODULE: ./routes/public/editOrder/Steps.js
var Steps__css, Steps__css2, _css3, _css4;



function Steps__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Steps__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Steps__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var min = function min(len) {
  return "@media (min-width: " + len + "px)";
};
var Steps_max = function max(len) {
  return "@media (max-width: " + len + "px)";
};

var stepItem = Object(index_esm["css"])((Steps__css = {
  a: {
    color: "#323232",
    fontSize: 16
  }
}, Steps__css[Steps_max(700)] = {
  ":not(:first-of-type)": {
    "::before": {
      content: "''",
      display: "inline-block",
      width: 7,
      height: 7,
      margin: "0px 7px 2px 8.6px",
      borderTop: "2px solid #788391",
      borderRight: "2px solid #788391",
      backgroundColor: "white",
      transform: "rotate(45deg)"
    }
  },
  display: "inline-block",
  "#step-desktop": {
    display: "none"
  },
  "#step-mobile": {
    display: "inline-block"
  }
}, Steps__css[min(700)] = {
  "&::before": {
    content: "counter(li)",
    width: 24,
    height: 24,
    marginRight: 4,
    display: "inline-block",
    color: "white",
    borderRadius: "100%",
    lineHeight: "23px",
    backgroundColor: "#323232"
  },
  "&::after": {
    content: "''",
    backgroundColor: "#dedede",
    verticalAlign: "middle",
    position: "relative",
    left: 8,
    width: 20,
    height: 1,
    marginRight: 16,
    display: "inline-block"
  },
  ":last-child": {
    ":after": {
      display: "none"
    }
  },
  counterIncrement: "li",
  display: "inline-block"
}, Steps__css));

var processSteps = Object(index_esm["css"])({
  margin: "auto",
  paddingTop: 24,
  paddingBottom: 24,
  textAlign: "center"
});

var Steps_wrapper = Object(index_esm["css"])((Steps__css2 = {
  marginBottom: 20,
  marginRight: "auto",
  marginLeft: "auto",
  marginTop: 8,
  boxShadow: "0 0 1px 0 #f1f1f1, 0 1px 3px 0 rgba(9, 30, 66, 0.13)"
}, Steps__css2[Steps_max(700)] = {
  marginTop: 0,
  marginBottom: 8
}, Steps__css2));

var desktopLabel = Object(index_esm["css"])((_css3 = {
  display: "inline-block"
}, _css3[Steps_max(700)] = {
  display: "none"
}, _css3));

var mobileLabel = Object(index_esm["css"])((_css4 = {
  display: "none"
}, _css4[Steps_max(700)] = {
  display: "inline-block"
}, _css4));

var defaultStyle = Object(index_esm["css"])({
  "&::before": {
    backgroundColor: "#A4A9A4"
  }
});

var finished = Object(index_esm["css"])({
  "&::before": {
    backgroundColor: "#6621c0"
  }
});

var active = Object(index_esm["css"])({
  "&::before": {
    backgroundColor: "#6621c0"
  },
  fontWeight: "600",
  a: {
    color: "#6621c0"
  }
});

var Steps_Steps = function (_Component) {
  Steps__inherits(Steps, _Component);

  function Steps(props) {
    Steps__classCallCheck(this, Steps);

    return Steps__possibleConstructorReturn(this, _Component.call(this, props));
  }

  Steps.prototype.render = function render(_ref) {
    var page = _ref.page;

    var steps = [{
      label: "Buyer Details",
      mobileLabel: "Buyer Details"
    }, {
      label: "Ticket Information",
      mobileLabel: "Ticket Information"
    }];

    return Object(preact_min["h"])(
      "div",
      { className: Steps_wrapper },
      Object(preact_min["h"])(
        "ul",
        { className: processSteps },
        steps.map(function (step, index) {
          var classes = [stepItem];
          if (index === page) {
            classes.push(active);
          } else if (page > index) {
            classes.push(finished);
          } else {
            classes.push(defaultStyle);
          }
          return Object(preact_min["h"])(
            "li",
            { key: index, className: Object(index_esm["css"])(classes) },
            Object(preact_min["h"])(
              "div",
              { style: { display: "inherit" } },
              Object(preact_min["h"])(
                "div",
                { className: desktopLabel },
                step.label
              ),
              Object(preact_min["h"])(
                "div",
                { className: mobileLabel },
                step.mobileLabel
              )
            )
          );
        })
      )
    );
  };

  return Steps;
}(preact_min["Component"]);

/* harmony default export */ var editOrder_Steps = (Steps_Steps);
// CONCATENATED MODULE: ./routes/public/editOrder/PublicOrderDetails.js
var PublicOrderDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function PublicOrderDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PublicOrderDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PublicOrderDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var PublicOrderDetails_formName = "details";

var pageStyle = Object(index_esm["css"])({
  position: "relative",
  maxWidth: 1040,
  margin: "0px auto",
  background: "#fff",
  boxShadow: "0 1px 3px 0 rgba(9,30,66,0.13), 0 0 1px 0 #F1F1F1",
  borderTop: "none"
});

var PublicOrderDetails__ref2 = Object(preact_min["h"])(editOrder_Header, null);

var PublicOrderDetails__ref3 = Object(preact_min["h"])(
  "h2",
  null,
  "Order Updated"
);

var PublicOrderDetails_OrderDetails = function (_Component) {
  PublicOrderDetails__inherits(OrderDetails, _Component);

  function OrderDetails(props) {
    PublicOrderDetails__classCallCheck(this, OrderDetails);

    var _this = PublicOrderDetails__possibleConstructorReturn(this, _Component.call(this, props));

    _this.save = function (data) {
      var _this$props = _this.props,
          saveOrderPublic = _this$props.saveOrderPublic,
          orderId = _this$props.orderId,
          eventId = _this$props.eventId,
          token = _this$props.token,
          event = _this$props.event;

      var orderAdditionalFields = [];
      for (var key in data.order.additionalFields) {
        orderAdditionalFields.push({
          questionId: key,
          value: data.order.additionalFields[key]
        });
      }
      var tickets = [];
      var additionalFields = [];
      for (var key in data.tickets) {
        var ticket = data.tickets[key];
        for (var addQId in ticket) {
          additionalFields.push({
            questionId: addQId,
            value: ticket[addQId]
          });
        }
        tickets.push({
          _id: key,
          additionalFields: additionalFields
        });
        additionalFields = [];
      }
      var orderData = PublicOrderDetails__extends({}, data.order, {
        additionalFields: orderAdditionalFields,
        tickets: tickets
      });
      saveOrderPublic(eventId, orderId, token, orderData);
      var isConference = event.data.settings.enableTicketAssigning;
      if (isConference) {
        _this.setState({
          page: 1
        });
      }
    };

    _this.state = {
      page: 0,
      saved: false
    };
    return _this;
  }

  OrderDetails.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getEventPublic = _props.getEventPublic,
        getOrderPublic = _props.getOrderPublic,
        orderId = _props.orderId,
        eventId = _props.eventId,
        token = _props.token,
        setToken = _props.setToken;

    getEventPublic(eventId, orderId, token);
    getOrderPublic(eventId, orderId, token);
    setToken(token);
  };

  OrderDetails.prototype.componentDidUpdate = function componentDidUpdate(perviousProps) {
    var order = this.props.order;

    var isBrowser = typeof window !== "undefined";
    if (order.detailsRequest.saved && !perviousProps.order.detailsRequest.saved) {
      if (isBrowser) {
        window.scroll(0, 0);
      }
    }
  };

  OrderDetails.prototype.render = function render(_ref) {
    var order = _ref.order,
        event = _ref.event,
        ticketsAdditionalQuestions = _ref.ticketsAdditionalQuestions,
        sameAsBuyerChecks = _ref.sameAsBuyerChecks,
        buyerData = _ref.buyerData,
        token = _ref.token;

    var isConference = event && event.data && event.data.settings.enableTicketAssigning;
    var page = this.state.page;

    var orderLoaded = order.data && !order.loading;
    var eventLoaded = event.data && !event.loading;
    if (!orderLoaded || !eventLoaded) {
      return null;
    }
    return Object(preact_min["h"])(
      "div",
      {
        style: {
          background: "#F9F9FA", //this.getBackground(event, theme, background),
          backgroundSize: "cover", ///backgroundSize,
          paddingBottom: 12,
          padding: 7
        }
      },
      Object(preact_min["h"])(
        "div",
        { style: { maxWidth: 1040, margin: "0px auto" } },
        PublicOrderDetails__ref2
      ),
      order.detailsRequest.saved ? Object(preact_min["h"])(
        "div",
        { style: { textAlign: "center" } },
        PublicOrderDetails__ref3,
        Object(preact_min["h"])(simle, { style: { width: 200, marginBottom: 12 } })
      ) : null,
      Object(preact_min["h"])(
        "h2",
        { style: { maxWidth: 1040, margin: "0px auto" } },
        "Edit Order: " + order.data.orderName
      ),
      Object(preact_min["h"])(
        "div",
        { className: pageStyle },
        isConference ? Object(preact_min["h"])(
          "div",
          null,
          Object(preact_min["h"])(editOrder_Steps, { page: page })
        ) : null,
        Object(preact_min["h"])(
          Content["a" /* default */],
          { style: { padding: "20px 24px", marginTop: 28 } },
          page === 1 ? Object(preact_min["h"])(conferences_AssignTickets, { orderId: order.data._id }) : Object(preact_min["h"])(PublicOrderDetails_OrderDetailsForm, PublicOrderDetails__extends({
            saveDetails: this.save,
            order: order,
            event: event
          }, {
            ticketsAdditionalQuestions: ticketsAdditionalQuestions,
            sameAsBuyerChecks: sameAsBuyerChecks,
            buyerData: buyerData
          }))
        )
      )
    );
  };

  return OrderDetails;
}(preact_min["Component"]);

var PublicOrderDetails__ref5 = Object(preact_min["h"])(
  "p",
  { "class": "text-error" },
  "Some selections are no longer available"
);

var PublicOrderDetails__ref6 = Object(preact_min["h"])(
  "h3",
  { "class": "sub-header" },
  "Buyer Information"
);

var PublicOrderDetails__ref7 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "First Name",
  type: "text",
  name: "order.firstName",
  component: InputField["a" /* default */],
  required: true,
  validate: Validators["b" /* required */],
  autocomplete: "given-name"
});

var PublicOrderDetails__ref8 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "Last Name",
  type: "text",
  name: "order.lastName",
  component: InputField["a" /* default */],
  required: true,
  validate: Validators["b" /* required */],
  autocomplete: "family-name"
});

var PublicOrderDetails__ref9 = Object(preact_min["h"])(redux_form_es["a" /* Field */], {
  label: "Business Name",
  type: "text",
  name: "order.businessName",
  component: InputField["a" /* default */],
  validate: Validators["b" /* required */]
});

var PublicOrderDetails_OrderDetailsForm = function OrderDetailsForm(_ref4) {
  var event = _ref4.event,
      order = _ref4.order,
      handleSubmit = _ref4.handleSubmit,
      saveDetails = _ref4.saveDetails,
      orderAdditionalQuestions = _ref4.orderAdditionalQuestions,
      businessPurpose = _ref4.businessPurpose,
      dispatch = _ref4.dispatch,
      isGlobal = _ref4.isGlobal,
      ticketsAdditionalQuestions = _ref4.ticketsAdditionalQuestions,
      sameAsBuyerChecks = _ref4.sameAsBuyerChecks,
      buyerData = _ref4.buyerData;

  var changeFieldValue = function changeFieldValue(field, value) {
    dispatch(Object(redux_form_es["c" /* change */])(PublicOrderDetails_formName, field, value));
  };

  var mobileRequired = event.data.settings.mobileRequired !== false;

  var isConference = event.data.settings.enableTicketAssigning;
  var businessPurposeOptions = [{
    label: "Individual",
    value: "false"
  }, {
    label: "Business",
    value: "true"
  }];
  var businessTaxIdName = Object(config["a" /* default */])("TAX_NAME") || "Tax ID";
  var detailsAdditionQuestions = !isGlobal && event.data.additionalQuestions && event.data.additionalQuestions.length ? event.data.additionalQuestions.filter(function (q) {
    return !q.askAfterCheckout;
  }) : [];
  detailsAdditionQuestions = detailsAdditionQuestions.map(function (q) {
    if (q.type === "multiSelect" && q.options && q.options.length) {
      q.options = q.options.map(function (o) {
        var newOption = o.label ? PublicOrderDetails__extends({}, o) : PublicOrderDetails__extends({}, o, {
          id: o._id,
          label: o.value,
          value: false
        });
        return newOption;
      });
    }
    return q;
  });
  return Object(preact_min["h"])(
    "div",
    null,
    Object(preact_min["h"])(
      "form",
      { onSubmit: handleSubmit(saveDetails) },
      Object(preact_min["h"])(
        "div",
        {
          style: order.timeExpired ? {
            pointerEvents: "none"
          } : {}
        },
        Object(preact_min["h"])(
          "div",
          {
            style: {
              marginBottom: 24
            }
          },
          order.detailsRequest.error ? Object(preact_min["h"])(
            "div",
            null,
            order.detailsRequest.additionalQuestionQuantityError ? Object(preact_min["h"])(
              "div",
              null,
              PublicOrderDetails__ref5,
              order.detailsRequest.error.message.map(function (msg) {
                return Object(preact_min["h"])(
                  "p",
                  { "class": "text-error" },
                  msg
                );
              })
            ) : Object(preact_min["h"])(
              "p",
              { "class": "text-error" },
              order.detailsRequest.error.message
            )
          ) : "",
          PublicOrderDetails__ref6,
          PublicOrderDetails__ref7,
          PublicOrderDetails__ref8,
          Object(preact_min["h"])(redux_form_es["a" /* Field */], {
            label: "Email",
            type: "text",
            name: "order.email",
            component: InputField["a" /* default */],
            required: true,
            validate: [Validators["b" /* required */], Validators["a" /* email */]],
            autocomplete: "email"
          }),
          Object(preact_min["h"])(redux_form_es["a" /* Field */], {
            label: "Mobile",
            type: "text",
            name: "order.mobile",
            component: InputField["a" /* default */],
            required: mobileRequired,
            validate: mobileRequired ? Validators["b" /* required */] : null,
            autocomplete: "tel"
          }),
          !isGlobal && !event.data.settings.hideIsBusinessQuestion ? Object(preact_min["h"])(redux_form_es["a" /* Field */], {
            label: "Is your purchase for business purposes?",
            name: "order.businessPurpose",
            component: fields_RadioField,
            defaultValue: "false",
            inline: true,
            options: businessPurposeOptions,
            validate: Validators["b" /* required */]
          }) : null,
          businessPurpose === "true" && Object(preact_min["h"])(
            "div",
            {
              style: {
                background: "#FAFAF9",
                padding: 12
              }
            },
            Object(preact_min["h"])(redux_form_es["a" /* Field */], {
              label: businessTaxIdName,
              type: "text",
              name: "order.businessTaxId",
              component: InputField["a" /* default */],
              validate: Validators["b" /* required */]
            }),
            PublicOrderDetails__ref9
          ),
          Object(preact_min["h"])(details_OrderQuestions, {
            additionalQuestions: detailsAdditionQuestions,
            orderAdditionalQuestions: orderAdditionalQuestions,
            changeFieldValue: changeFieldValue,
            tickets: order.data.tickets
          }),
          !isConference ? Object(preact_min["h"])(details_TicketsQuestions, {
            tickets: order.data.tickets,
            ticketTypes: event.data.ticketTypes,
            ticketsAdditionalQuestions: ticketsAdditionalQuestions,
            additionalQuestions: detailsAdditionQuestions,
            buyerData: buyerData,
            changeFieldValue: changeFieldValue,
            sameAsBuyerChecks: sameAsBuyerChecks
          }) : null
        )
      ),
      Object(preact_min["h"])(
        ActionBar["a" /* default */],
        null,
        Object(preact_min["h"])(
          ActionButton["a" /* default */],
          {
            disabled: order.detailsRequest.loading || order.timeExpired || order.addDiscountRequest.loading,
            loading: order.detailsRequest.loading || order.addDiscountRequest.loading,
            dataCY: "save"
          },
          isConference ? "Save and continue" : "Save"
        )
      )
    )
  );
};

PublicOrderDetails_OrderDetailsForm = Object(redux_form_es["f" /* reduxForm */])({
  form: PublicOrderDetails_formName,
  destroyOnUnmount: false,
  onSubmitFail: function onSubmitFail(errors) {
    Object(ScrollToErrors["a" /* scrollToErrors */])();
  }
})(PublicOrderDetails_OrderDetailsForm);

function PublicOrderDetails_getOrderValues(order, providedOrderData, additionalQuestions, formOrder) {
  if (formOrder) {
    return formOrder;
  }

  if (order.businessPurpose === false || !order.businessPurpose) {
    order.businessPurpose = "false";
  }
  if (order && order.additionalFields) {
    var mappedOrder = PublicOrderDetails__extends({}, order);
    mappedOrder.additionalFields = {};
    if (order.additionalFields && order.additionalFields.length > 0) {
      order.additionalFields.forEach(function (field) {
        mappedOrder.additionalFields[field.questionId] = field.value;
      });
    } else if (additionalQuestions && additionalQuestions.length > 0) {
      additionalQuestions.forEach(function (question) {
        question.defaultValue && question.perOrder && !question.askAfterCheckout ? mappedOrder.additionalFields[question._id] = question.defaultValue : "";
      });
    }
    return mappedOrder;
  }

  return order;
}

var PublicOrderDetails_selector = Object(redux_form_es["d" /* formValueSelector */])(PublicOrderDetails_formName);

PublicOrderDetails_OrderDetailsForm = Object(es["b" /* connect */])(function (state, ownProps) {
  var isGlobal = ownProps.isGlobal;

  var order = PublicOrderDetails_getOrderValues(state.order.data, state.order.providedOrderData, isGlobal ? [] : state.event.data.additionalQuestions, PublicOrderDetails_selector(state, "order"));

  var tickets = getTicketValues(state.order.data, state.event.data.additionalQuestions, PublicOrderDetails_selector(state, "tickets"));
  var initialValues = {
    order: order,
    tickets: tickets
  };

  return {
    initialValues: initialValues,
    event: state.event,
    order: state.order
  };
}, {})(PublicOrderDetails_OrderDetailsForm);

/* harmony default export */ var PublicOrderDetails = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order,
    seatingMap: state.seatingMap,
    merchandise: state.merchandise,
    giftCards: state.giftCards,
    ticketSelection: state.ticketSelection,
    buyerData: {
      firstName: PublicOrderDetails_selector(state, "order.firstName"),
      lastName: PublicOrderDetails_selector(state, "order.lastName"),
      mobile: PublicOrderDetails_selector(state, "order.mobile"),
      email: PublicOrderDetails_selector(state, "order.email")
    },
    businessPurpose: PublicOrderDetails_selector(state, "order.businessPurpose"),
    businessTaxId: PublicOrderDetails_selector(state, "order.businessTaxId"),
    businessName: PublicOrderDetails_selector(state, "order.businessName"),
    orderAdditionalQuestions: PublicOrderDetails_selector(state, "order.additionalFields"),
    ticketsAdditionalQuestions: PublicOrderDetails_selector(state, "tickets"),
    sameAsBuyerChecks: PublicOrderDetails_selector(state, "sameAsBuyerChecks")
  };
}, {
  saveOrderData: orderActions["_2" /* saveOrderData */],
  getEventPublic: eventActions["v" /* getEventPublic */],
  getOrderPublic: orderActions["R" /* getOrderPublic */],
  setSeatingMapRequired: seatingMapActions["q" /* setSeatingMapRequired */],
  saveOrderPublic: orderActions["_3" /* saveOrderPublic */],
  setToken: setToken
})(PublicOrderDetails_OrderDetails));
// CONCATENATED MODULE: ./routes/public/editTicket/AttendeeProfile.js


function AttendeeProfile__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AttendeeProfile__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AttendeeProfile__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var AttendeeProfile_formName = "existingAttendeeProfile";

var AttendeeProfile__ref2 = Object(preact_min["h"])(
  "h2",
  null,
  "Attendee Profile"
);

var AttendeeProfile__ref3 = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var AttendeeProfile_AttendeeProfile = function (_Component) {
  AttendeeProfile__inherits(AttendeeProfile, _Component);

  function AttendeeProfile(props) {
    AttendeeProfile__classCallCheck(this, AttendeeProfile);

    var _this = AttendeeProfile__possibleConstructorReturn(this, _Component.call(this, props));

    _this.save = function (profileData) {
      var _this$props = _this.props,
          updateAttendeeProfilePublic = _this$props.updateAttendeeProfilePublic,
          routeParams = _this$props.routeParams;

      updateAttendeeProfilePublic(routeParams, profileData);
      _this.setState({ editing: false });
    };

    _this.cancel = function (cb) {
      _this.setState({ editing: false }, cb);
    };

    _this.enableEditing = function () {
      _this.setState({ editing: true });
    };

    _this.openReassigningInfo = function () {
      _this.setState({ modalOpen: true });
    };

    _this.state = {
      editing: false,
      modalOpen: false,
      showExtraInfo: false
    };
    return _this;
  }

  AttendeeProfile.prototype.render = function render(_ref) {
    var _this2 = this;

    var attendeeProfile = _ref.attendeeProfile;
    var _state = this.state,
        editing = _state.editing,
        showExtraInfo = _state.showExtraInfo;
    var profile = attendeeProfile.profile;

    return Object(preact_min["h"])(
      "div",
      null,
      AttendeeProfile__ref2,
      attendeeProfile.loading ? AttendeeProfile__ref3 : Object(preact_min["h"])(AttendeeProfile_AttendeeForm, { allowEdit: editing }),
      Object(preact_min["h"])(
        "div",
        { style: { display: "flex" } },
        Object(preact_min["h"])(
          "div",
          { style: { flexGrow: 1 } },
          editing ? Object(preact_min["h"])(AttendeeProfile_CancelButton, { onClick: this.cancel, profile: profile }) : Object(preact_min["h"])(
            components_Button["a" /* default */],
            {
              type: "secondary",
              ariaLabel: "cancel",
              onClick: function onClick() {
                _this2.setState({ showExtraInfo: true });
              }
            },
            "Re-assign tickets"
          )
        ),
        editing ? Object(preact_min["h"])(AttendeeProfile_SaveButton, { saveDetails: this.save }) : Object(preact_min["h"])(
          components_Button["a" /* default */],
          {
            value: "Edit",
            type: "primary",
            ariaLabel: "edit",
            onClick: this.enableEditing
          },
          "Edit"
        )
      ),
      showExtraInfo ? Object(preact_min["h"])(AttendeeProfile_ExtraInfoModal, {
        showModal: showExtraInfo,
        onClose: function onClose() {
          return _this2.setState({ showExtraInfo: false });
        }
      }) : null
    );
  };

  return AttendeeProfile;
}(preact_min["Component"]);

var AttendeeProfile_AttendeeForm = function AttendeeForm(_ref4) {
  var allowEdit = _ref4.allowEdit;

  return Object(preact_min["h"])(
    "form",
    { style: { padding: 20 }, id: AttendeeProfile_formName },
    Object(preact_min["h"])(redux_form_es["a" /* Field */], {
      label: "First Name",
      type: "text",
      name: "firstName",
      component: InputField["a" /* default */],
      required: true,
      validate: [Validators["b" /* required */]],
      disabled: !allowEdit
    }),
    Object(preact_min["h"])(redux_form_es["a" /* Field */], {
      label: "Last Name",
      type: "text",
      name: "lastName",
      component: InputField["a" /* default */],
      required: true,
      validate: [Validators["b" /* required */]],
      disabled: !allowEdit
    }),
    Object(preact_min["h"])(redux_form_es["a" /* Field */], {
      label: "Email",
      type: "text",
      name: "email",
      component: InputField["a" /* default */],
      required: true,
      validate: [Validators["b" /* required */], Validators["a" /* email */]],
      autocomplete: "email",
      disabled: true
    })
  );
};

var AttendeeProfile__ref6 = Object(preact_min["h"])(
  "p",
  null,
  "Only the buyer can re-assign tickets. If you wish some or all of your tickets to be transfered please contact the buyer."
);

var AttendeeProfile_ExtraInfoModal = function ExtraInfoModal(_ref5) {
  var onClose = _ref5.onClose,
      showModal = _ref5.showModal;

  return Object(preact_min["h"])(
    Modal["a" /* default */],
    {
      showModal: showModal,
      closeHandler: onClose,
      destroy: false,
      padding: 48
    },
    AttendeeProfile__ref6
  );
};

var AttendeeProfile_SaveButton = function SaveButton(_ref7) {
  var handleSubmit = _ref7.handleSubmit,
      saveDetails = _ref7.saveDetails;

  return Object(preact_min["h"])(
    components_Button["a" /* default */],
    {
      buttonType: "submit",
      form: AttendeeProfile_formName,
      ariaLabel: "submit",
      value: "Submit",
      type: "primary",
      onClick: handleSubmit(saveDetails)
    },
    "Save"
  );
};

var AttendeeProfile_CancelButton = function CancelButton(_ref8) {
  var reset = _ref8.reset,
      _onClick = _ref8.onClick,
      dispatch = _ref8.dispatch,
      profile = _ref8.profile;
  var firstName = profile.firstName,
      lastName = profile.lastName,
      email = profile.email;

  var changeFieldValue = function changeFieldValue(field, value) {
    dispatch(Object(redux_form_es["c" /* change */])(AttendeeProfile_formName, field, value));
  };
  return Object(preact_min["h"])(
    components_Button["a" /* default */],
    {
      type: "secondary",
      ariaLabel: "cancel",
      onClick: function onClick() {
        // We need to explicitly set the fields again on cancel
        // Because redux form thinks its a good idea to destory the default data
        // when the field is set to disabled
        if (_onClick) {
          _onClick(function () {
            changeFieldValue("firstName", firstName);
            changeFieldValue("lastName", lastName);
            changeFieldValue("email", email);
          });
        }
      }
    },
    "Cancel"
  );
};

AttendeeProfile_CancelButton = Object(redux_form_es["f" /* reduxForm */])({
  form: AttendeeProfile_formName
})(AttendeeProfile_CancelButton);

AttendeeProfile_SaveButton = Object(redux_form_es["f" /* reduxForm */])({
  form: AttendeeProfile_formName
})(AttendeeProfile_SaveButton);

AttendeeProfile_AttendeeForm = Object(redux_form_es["f" /* reduxForm */])({
  form: AttendeeProfile_formName,
  destroyOnUnmount: true,
  enableReinitialize: true,
  onSubmitFail: function onSubmitFail(errors) {
    scrollToErrors();
  }
})(AttendeeProfile_AttendeeForm);

AttendeeProfile_AttendeeForm = Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    initialValues: state.attendeeProfile.profile
  };
})(AttendeeProfile_AttendeeForm);

/* harmony default export */ var editTicket_AttendeeProfile = (Object(es["b" /* connect */])(function (state) {
  return {
    attendeeProfile: state.attendeeProfile
  };
}, { updateAttendeeProfilePublic: attendeeProfileActions_updateAttendeeProfilePublic })(AttendeeProfile_AttendeeProfile));
// CONCATENATED MODULE: ./routes/public/editTicket/EditTicket.js
var EditTicket__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function EditTicket__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EditTicket__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EditTicket__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var EditTicket_pageStyle = Object(index_esm["css"])({
  position: "relative",
  maxWidth: 1040,
  margin: "0px auto",
  background: "#fff",
  boxShadow: "0 1px 3px 0 rgba(9,30,66,0.13), 0 0 1px 0 #F1F1F1",
  borderTop: "none"
});

var EditTicket__ref2 = Object(preact_min["h"])(
  "p",
  null,
  "There are unanswered questions which need to be answered before you can access your tickets."
);

var EditTicket__ref3 = Object(preact_min["h"])(editOrder_Header, null);

var EditTicket_EditTicket = function (_Component) {
  EditTicket__inherits(EditTicket, _Component);

  function EditTicket(props) {
    EditTicket__classCallCheck(this, EditTicket);

    var _this = EditTicket__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      showModal: props.redirect
    };
    return _this;
  }

  EditTicket.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        loadAttendeeProfileData = _props.loadAttendeeProfileData,
        orderId = _props.orderId,
        eventId = _props.eventId,
        token = _props.token,
        attendeeProfileId = _props.attendeeProfileId,
        setToken = _props.setToken;

    loadAttendeeProfileData(orderId, eventId, attendeeProfileId, token);
    setToken(token);
  };

  EditTicket.prototype.render = function render(_ref) {
    var _profileLookup,
        _this2 = this;

    var order = _ref.order,
        event = _ref.event,
        token = _ref.token,
        orderId = _ref.orderId,
        eventId = _ref.eventId,
        attendeeProfileId = _ref.attendeeProfileId,
        attendeeProfile = _ref.attendeeProfile;
    var showModal = this.state.showModal;

    var routeParams = {
      token: token,
      orderId: orderId,
      eventId: eventId,
      attendeeProfileId: attendeeProfileId
    };
    var eventLoaded = event.data && !event.loading;
    var profileLoaded = attendeeProfile.profile;
    if (!eventLoaded || !profileLoaded) {
      return null;
    }
    var detailsAdditionQuestions = event.data.additionalQuestions && event.data.additionalQuestions.length ? event.data.additionalQuestions : [];
    detailsAdditionQuestions = detailsAdditionQuestions.map(function (q) {
      if (q.type === "multiSelect" && q.options && q.options.length) {
        q.options = q.options.map(function (o) {
          var newOption = o.label ? EditTicket__extends({}, o) : EditTicket__extends({}, o, {
            id: o._id,
            label: o.value,
            value: false
          });
          return newOption;
        });
      }
      return q;
    });

    var ticketsGroupedByType = Object.values(order.data.tickets.reduce(function (map, ticket) {
      if (!map[ticket.ticketTypeId]) {
        map[ticket.ticketTypeId] = {
          tickets: [],
          ticketTypeName: ticket.ticketTypeName
        };
      }
      map[ticket.ticketTypeId].tickets.push(ticket);
      return map;
    }, {}));

    var ticketsGroupedByAttendeeProfile = order.data.tickets.reduce(function (map, ticket) {
      if (!ticket.attendeeProfileId) {
        map["unassigned"].push(ticket);
      } else {
        if (!map[ticket.attendeeProfileId]) {
          map[ticket.attendeeProfileId] = [];
        }
        map[ticket.attendeeProfileId].push(ticket);
      }
      return map;
    }, { unassigned: [] });

    var profile = attendeeProfile.profile;

    var profileLookup = (_profileLookup = {}, _profileLookup[profile._id] = profile, _profileLookup);
    var profiles = [profile];
    return Object(preact_min["h"])(
      "div",
      {
        style: {
          background: "#F9F9FA", //this.getBackground(event, theme, background),
          backgroundSize: "cover", ///backgroundSize,
          paddingBottom: 12,
          padding: 7
        }
      },
      Object(preact_min["h"])(Modal["a" /* default */], {
        showModal: showModal,
        closeHandler: function closeHandler() {
          return _this2.setState({ showModal: false });
        },
        title: "Unanswered questions",
        contents: EditTicket__ref2
      }),
      Object(preact_min["h"])(
        "div",
        { style: { maxWidth: 1040, margin: "0px auto" } },
        EditTicket__ref3
      ),
      Object(preact_min["h"])(
        "div",
        { className: EditTicket_pageStyle },
        Object(preact_min["h"])(
          Content["a" /* default */],
          { style: { padding: "20px 24px", marginTop: 28 } },
          Object(preact_min["h"])(editTicket_AttendeeProfile, { routeParams: routeParams })
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: EditTicket_pageStyle },
        Object(preact_min["h"])(
          Content["a" /* default */],
          { style: { padding: "20px 24px", marginTop: 28 } },
          Object(preact_min["h"])(
            "h2",
            { "class": "sub-header", style: { fontWeight: 600 } },
            "Your Tickets"
          ),
          Object(preact_min["h"])(
            "form",
            null,
            ticketsGroupedByType.map(function (ticketTypes, i) {
              return Object(preact_min["h"])(conferences_TicketList, EditTicket__extends({
                profileLookup: profileLookup,
                profiles: profiles
              }, ticketTypes, {
                index: i,
                ticketsGroupedByAttendeeProfile: ticketsGroupedByAttendeeProfile,
                disableReassigning: true,
                token: token
              }));
            })
          )
        )
      )
    );
  };

  return EditTicket;
}(preact_min["Component"]);

/* harmony default export */ var editTicket_EditTicket = (Object(es["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order,
    attendeeProfile: state.attendeeProfile
  };
}, {
  loadAttendeeProfileData: attendeeProfileActions_loadAttendeeProfileData,
  setToken: setToken
})(EditTicket_EditTicket));
// EXTERNAL MODULE: ./services/tracking/GoogleTagManagerService.js
var GoogleTagManagerService = __webpack_require__("Ys9y");

// CONCATENATED MODULE: ./app.js


function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

































__webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, "fwK4"));
__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "gXX4"));
__webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "aMmw"));





var app__ref = Object(preact_min["h"])("div", { "class": "loading loading-lg" });

var app_PageLoading = function PageLoading() {
  return Object(preact_min["h"])(
    Page["a" /* default */],
    null,
    Object(preact_min["h"])(
      Content["a" /* default */],
      { style: { padding: 30 } },
      app__ref
    )
  );
};

var app__ref2 = Object(preact_min["h"])(app_PageLoading, null);

var app__ref4 = Object(preact_min["h"])(NoEvent, { path: "/" });

var app__ref5 = Object(preact_min["h"])(event_Event, { path: "/:eventSlug" });

var app__ref6 = Object(preact_min["h"])(organiser_Organiser, { path: "/organisers/:organiserId" });

var app__ref7 = Object(preact_min["h"])(widgets_EventListings, { path: "/event-listings" });

var app__ref8 = Object(preact_min["h"])(widgets_AdditionalQuestionsPreview, { path: "/:eventSlug/additional-questions-preview" });

var app__ref9 = Object(preact_min["h"])(tours_Tour, { path: "/tours/:slug/:tourGroupId?" });

var app__ref10 = Object(preact_min["h"])(tickets_Tickets, { path: "/:eventSlug/tickets" });

var app__ref11 = Object(preact_min["h"])(conferences_AssignTickets, { path: "/:eventSlug/assign/:orderId" });

var app__ref12 = Object(preact_min["h"])(merchandise_Merchandise, { path: "/:eventSlug/add-ons/:orderId" });

var app__ref13 = Object(preact_min["h"])(details_Details, { path: "/:eventSlug/details/:orderId" });

var app__ref14 = Object(preact_min["h"])(details_Details, { path: "/gift-cards/:eventSlug/details/:orderId" });

var app__ref15 = Object(preact_min["h"])(payment_Payment, { path: "/:eventSlug/payment/:orderId" });

var _ref16 = Object(preact_min["h"])(payment_Payment, { path: "/gift-cards/:eventSlug/payment/:orderId" });

var _ref17 = Object(preact_min["h"])(complete_Complete, { path: "/:eventSlug/complete/:orderId" });

var _ref18 = Object(preact_min["h"])(complete_GlobalOrderComplete, { path: "/gift-cards/:slug/complete/:orderId" });

var _ref19 = Object(preact_min["h"])(afterCheckout_AfterCheckout, { path: "/:eventSlug/afterCheckout/:orderId" });

var _ref20 = Object(preact_min["h"])(giftCards_GiftCardPage, { path: "/gift-cards/:giftCardSlug" });

var _ref21 = Object(preact_min["h"])(giftCards_GiftCardEventPage, { path: "/gift-cards/:giftCardSlug/event-list/:giftCardTypeId" });

var _ref22 = Object(preact_min["h"])(PublicOrderDetails, { path: "/public/edit-order/:orderId/:eventId" });

var _ref23 = Object(preact_min["h"])(editTicket_EditTicket, { path: "/public/edit-tickets/:orderId/:eventId/:attendeeProfileId" });

var _ref24 = Object(preact_min["h"])(components_Footer, { path: "/:eventSlug" });

var app_App = function (_Component) {
  app__inherits(App, _Component);

  function App() {
    app__classCallCheck(this, App);

    var _this = app__possibleConstructorReturn(this, _Component.call(this));

    _this.getPublicSeatingMap = function (url, cb, props) {
      var componentOrPromise = __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "1LeO"));
      return _this.processComponent(cb, componentOrPromise);
    };

    _this.processComponent = function (cb, componentOrPromise) {
      if (componentOrPromise.then) {
        // for client
        return componentOrPromise.then(function (module) {
          return module.default;
        });
      } else if (componentOrPromise.default) {
        // for node
        cb({ component: componentOrPromise.default });
      }
    };

    _this.getLoadingComponent = _this.getLoadingComponent.bind(_this);

    _this.getSeatingMap = _this.getSeatingMap.bind(_this);
    _this.getContact = _this.getContact.bind(_this);
    _this.getAccessibility = _this.getAccessibility.bind(_this);
    _this.getWaitlistPass = _this.getWaitlistPass.bind(_this);
    _this.handleRoute = _this.handleRoute.bind(_this);
    return _this;
  }

  App.prototype.handleRoute = function handleRoute(evt) {
    if (typeof window !== "undefined") {
      window.scroll(0, 0);
      var canonicalPath = evt.url.split("?")[0];
      var ticketingUrl = Object(config["a" /* default */])("TICKETING_URL");
      try {
        var canonicalElement = document.getElementById("canonical-url");
        if (canonicalElement) {
          canonicalElement.href = "" + ticketingUrl + canonicalPath;
        }
      } catch (err) {}

      if (this.isWidget) {
        var appDom = document.getElementById("app");
        var scrollHeight = appDom ? appDom.scrollHeight : null;
        window.top.postMessage({ scrollHeight: scrollHeight, pageChange: true }, "*");
      }
    }
  };

  App.prototype.componentWillMount = function componentWillMount() {
    this.isWidget = false;
    var isBrowser = typeof window !== "undefined";
    if (isBrowser && window.self !== window.top) {
      this.isWidget = true;
    }
    css_vars_ponyfill_esm();
  };

  App.prototype.componentDidMount = function componentDidMount() {
    if (typeof window !== "undefined" && this.isWidget) {
      var appDom = document.getElementById("app");
      setInterval(function () {
        appDom = appDom ? appDom : document.getElementById("app");
        if (appDom) {
          window.top.postMessage({
            scrollHeight: appDom.scrollHeight,
            location: window.location.href
          }, "*");
        }
      }, 100);
    }
  };

  App.prototype.getSeatingMap = function getSeatingMap(url, cb, props) {
    var componentOrPromise = __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "E4XO"));
    return this.processComponent(cb, componentOrPromise);
  };

  App.prototype.getContact = function getContact(url, cb, props) {
    var componentOrPromise = __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, "fwK4"));
    return this.processComponent(cb, componentOrPromise);
  };

  App.prototype.getAccessibility = function getAccessibility(url, cb, props) {
    var componentOrPromise = __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "gXX4"));
    return this.processComponent(cb, componentOrPromise);
  };

  App.prototype.getWaitlistPass = function getWaitlistPass(url, cb, props) {
    var componentOrPromise = __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "aMmw"));
    return this.processComponent(cb, componentOrPromise);
  };

  App.prototype.getLoadingComponent = function getLoadingComponent() {
    return app__ref2;
  };

  App.prototype.render = function render(_ref3) {
    var _ref3$url = _ref3.url,
        url = _ref3$url === undefined ? null : _ref3$url,
        _ref3$eventData = _ref3.eventData,
        eventData = _ref3$eventData === undefined ? null : _ref3$eventData,
        _ref3$orderData = _ref3.orderData,
        orderData = _ref3$orderData === undefined ? null : _ref3$orderData,
        _ref3$merchData = _ref3.merchData,
        merchData = _ref3$merchData === undefined ? null : _ref3$merchData,
        _ref3$tourData = _ref3.tourData,
        tourData = _ref3$tourData === undefined ? null : _ref3$tourData;

    var providedOrderData = {};
    var eventDateIds = void 0;
    if (typeof window !== "undefined") {
      url = window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.url ? window.__PRELOADED_STATE__.url : url;
      eventData = window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.eventData ? window.__PRELOADED_STATE__.eventData : eventData;
      orderData = window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.orderData ? window.__PRELOADED_STATE__.orderData : orderData;
      merchData = window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.merchData ? window.__PRELOADED_STATE__.merchData : merchData;
      tourData = window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.tourData ? window.__PRELOADED_STATE__.tourData : tourData;
      delete window.__PRELOADED_STATE__;
      // load the params passed in
      var params = Object(Format["parseQueryString"])(location.search.replace("?", ""));
      // save pre set order data
      var allowedOrderData = ["firstName", "lastName", "mobile", "email"];
      allowedOrderData.forEach(function (key) {
        if (params[key.toLowerCase()]) {
          providedOrderData[key] = params[key.toLowerCase()];
        }
      });

      // track affiliateCode
      var affiliateCode = params.c;
      if (affiliateCode && eventData && eventData.affiliateCodes) {
        // check ref
        var affiliateCodes = eventData.affiliateCodes.filter(function (affiliate) {
          return affiliate.code === affiliateCode;
        });
        var existingCode = affiliateCodes.length ? affiliateCodes[0] : false;
        // save ref link for affiliate tracking
        if (existingCode) {
          try {
            localStorage.setItem(eventData.slug + "-affiliate", existingCode.code);
          } catch (err) {}
        }
      }
      eventDateIds = params.eventDateIds;
      // track affiliateCode
      var fb_oea = params.fb_oea;
      if (fb_oea) {
        window.fb_oea = fb_oea;
      }
      var token = params.token,
          manualOrder = params.manualOrder,
          manualOrderSettings = params.manualOrderSettings;

      if (token && manualOrder) {
        window.manualOrderToken = token;
        window.isManualOrder = manualOrder === "true";
        window.manualOrderSettings = manualOrderSettings;
      }
    }
    var store = state_store(eventData, orderData, providedOrderData, eventDateIds, merchData, tourData);

    return Object(preact_min["h"])(
      es["a" /* Provider */],
      { store: store },
      Object(preact_min["h"])(
        "main",
        { id: "app", "class": this.isWidget ? "widget" : "" },
        Object(preact_min["h"])(
          preact_router_es["Router"],
          { url: url, onChange: this.handleRoute },
          app__ref4,
          app__ref5,
          app__ref6,
          app__ref7,
          app__ref8,
          app__ref9,
          app__ref10,
          app__ref11,
          app__ref12,
          app__ref13,
          app__ref14,
          app__ref15,
          _ref16,
          _ref17,
          _ref18,
          _ref19,
          _ref20,
          _ref21,
          _ref22,
          _ref23,
          Object(preact_min["h"])(dist_default.a, {
            loading: this.getLoadingComponent,
            getComponent: this.getPublicSeatingMap,
            path: "/public/view-seating-map/:orderId/:eventId"
          }),
          Object(preact_min["h"])(dist_default.a, {
            loading: this.getLoadingComponent,
            path: "/:eventSlug/contact",
            getComponent: this.getContact
          }),
          Object(preact_min["h"])(dist_default.a, {
            loading: this.getLoadingComponent,
            path: "/:eventSlug/accessibility",
            getComponent: this.getAccessibility
          }),
          Object(preact_min["h"])(dist_default.a, {
            loading: this.getLoadingComponent,
            path: "/:eventSlug/seatingmap/:orderId",
            getComponent: this.getSeatingMap
          }),
          Object(preact_min["h"])(dist_default.a, {
            loading: this.getLoadingComponent,
            path: "/:eventSlug/waitlist-pass/:waitlistId",
            getComponent: this.getWaitlistPass
          })
        ),
        this.isWidget === false ? _ref24 : null
      )
    );
  };

  return App;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./utils/ErrorTracking.js
var ErrorTracking = __webpack_require__("QyN2");

// CONCATENATED MODULE: ./index.js




ErrorTracking["default"].init();
/* harmony default export */ var index_0 = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "K5Tb":
/***/ (function(module, exports) {

module.exports = extend;

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {};

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
}

/***/ }),

/***/ "KK7d":
/***/ (function(module, exports) {

/**
 * @class
 * @memberof PIXI.glCore.shader
 * @param type {String}
 * @return {Number}
 */
var mapSize = function mapSize(type) {
    return GLSL_TO_SIZE[type];
};

var GLSL_TO_SIZE = {
    'float': 1,
    'vec2': 2,
    'vec3': 3,
    'vec4': 4,

    'int': 1,
    'ivec2': 2,
    'ivec3': 3,
    'ivec4': 4,

    'bool': 1,
    'bvec2': 2,
    'bvec3': 3,
    'bvec4': 4,

    'mat2': 4,
    'mat3': 9,
    'mat4': 16,

    'sampler2D': 1
};

module.exports = mapSize;

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "KM7c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var MoveableContainer_1 = __webpack_require__("JJWE");
var PIXI = __webpack_require__("ix37");
var uuid = __webpack_require__("qQO4");
var Utils_1 = __webpack_require__("o6Mn");
var Config_1 = __webpack_require__("gH/r");
var Selector_1 = __webpack_require__("8Y7Z");
var SelectionListener_1 = __webpack_require__("//Eg");
var InteractionManager_1 = __webpack_require__("dUAP");
var MoveableText_1 = __webpack_require__("Q5l6");
var MoveableIcon_1 = __webpack_require__("gNnq");
var ActionTracker_1 = __webpack_require__("h0Oq");

var MapObject = function (_MoveableContainer_1$) {
    _inherits(MapObject, _MoveableContainer_1$);

    function MapObject(_ref, actions, reservationMode) {
        var _id = _ref._id,
            objectId = _ref.objectId,
            name = _ref.name,
            textData = _ref.textData,
            iconData = _ref.iconData,
            pos = _ref.pos,
            objectType = _ref.objectType,
            scale = _ref.scale,
            locked = _ref.locked,
            basicType = _ref.basicType;

        _classCallCheck(this, MapObject);

        var _this = _possibleConstructorReturn(this, _MoveableContainer_1$.call(this));

        _this._id = _id || uuid();
        _this.reservationMode = reservationMode;
        _this.objectId = objectId;
        _this.textData = textData || {};
        _this.locked = locked === true;
        _this.name = name;
        _this.label = name;
        _this.iconData = iconData || {};
        _this.pos = pos;
        _this.objectType = objectType;
        _this.scale = scale ? new PIXI.Point(scale.x, scale.y) : new PIXI.Point(0.5, 0.5);
        _this.selected = false;
        _this.actions = actions;
        _this.basicType = basicType || "object";
        _this.initialise();
        return _this;
    }

    MapObject.prototype.toJSON = function toJSON() {
        return {
            _id: this._id,
            objectId: this.objectId,
            name: this.name,
            textData: this.moveableText.toJSON(),
            iconData: this.moveableIcon.toJSON(),
            pos: { x: this.moveableContainer.position.x, y: this.moveableContainer.position.y },
            objectType: this.objectType,
            scale: this.scale,
            locked: this.locked,
            iconVisible: this.iconVisible
        };
    };

    MapObject.prototype.onAnyObjectChange = function onAnyObjectChange() {
        if (this.locked === false) {
            this.locked = true;
            if (this.cb) {
                this.cb();
            }
        }
    };

    MapObject.prototype.listenOnLock = function listenOnLock(cb) {
        this.cb = cb;
    };

    MapObject.prototype.lockChanged = function lockChanged(locked) {
        this.locked = locked;
    };

    MapObject.prototype.onSelect = function onSelect() {
        this.selected = true;
        this.updateTexture();
    };

    MapObject.prototype.onDeselect = function onDeselect() {
        this.selected = false;
        this.updateTexture();
    };

    MapObject.prototype.updateTexture = function updateTexture() {
        var currentTexture = this.determineTexture();
        this.objectTexture = PIXI.loader.resources[currentTexture].texture;
        this.objectTexture.baseTexture.mipmap = true;
        this.object.texture = this.objectTexture;
    };

    MapObject.prototype.getContainer = function getContainer() {
        return this.moveableContainer;
    };

    MapObject.prototype.onClick = function onClick() {
        this.interactionManager.itemSelected(this);
    };

    MapObject.prototype.scaleXPos = function scaleXPos(id, e) {
        var redraw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var xInc = e.data.originalEvent.movementX / Config_1.default.viewport.transform.scale._x;
        var width = void 0;
        if (id < 6 && id !== 0) {
            width = this.objectTexture.width * this.scale.x + xInc;
        } else {
            width = this.objectTexture.width * this.scale.x - xInc;
        }
        this.scale.x = width / this.objectTexture.width;
        this.object.scale = this.scale;
        if (redraw) {
            this.drawSelectionBox();
            this.onAnyObjectChange();
        }
    };

    MapObject.prototype.scaleYPos = function scaleYPos(id, e) {
        var redraw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var yInc = e.data.originalEvent.movementY / Config_1.default.viewport.transform.scale._y;
        var height = void 0;
        if (id <= 2) {
            height = this.objectTexture.height * this.scale.y - yInc;
        } else {
            height = this.objectTexture.height * this.scale.y + yInc;
        }
        this.scale.y = height / this.objectTexture.height;
        this.object.scale = this.scale;
        if (redraw) {
            this.drawSelectionBox();
            this.onAnyObjectChange();
        }
    };

    MapObject.prototype.scaleBothXY = function scaleBothXY(id, e) {
        this.scaleXPos(id, e, false);
        this.scaleYPos(id, e, false);
        this.drawSelectionBox();
        this.onAnyObjectChange();
    };

    MapObject.prototype.setIcon = function setIcon(iconName) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setIcon", this.setIcon, [this.moveableIcon.icon]);
        this.moveableIcon.setIcon(iconName);
        this.onAnyObjectChange();
        this.onChange();
        return undoValue;
    };

    MapObject.prototype.showIcon = function showIcon(show) {
        var undoValue = ActionTracker_1.default.constructUndoValue("showIcon", this.showIcon, [this.moveableIcon.iconVisible]);
        this.moveableIcon.showIcon(show);
        this.onAnyObjectChange();
        this.onChange();
        return undoValue;
    };

    MapObject.prototype.changeIcon = function changeIcon() {
        this.iconSprite.texture = this.iconTexture;
        this.iconSprite.visible = this.iconVisible;
    };

    MapObject.prototype.move = function move(e) {
        this.moveableContainer.position.x += e.data.originalEvent.movementX / Config_1.default.viewport.transform.scale._x;
        this.moveableContainer.position.y += e.data.originalEvent.movementY / Config_1.default.viewport.transform.scale._y;
        this.moveableText.setContainerOffset(this.moveableContainer.position.x, this.moveableContainer.position.y);
        this.moveableIcon.setContainerOffset(this.moveableContainer.position.x, this.moveableContainer.position.y);
        this.onAnyObjectChange();
    };

    MapObject.prototype.onRename = function onRename(cb) {
        this.renameCB = cb;
    };

    MapObject.prototype.setObjectId = function setObjectId(newObjectId) {
        this.objectId = newObjectId;
    };

    MapObject.prototype.setLabel = function setLabel(name) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setLabel", this.setLabel, [this.name]);
        this.name = name;
        this.label = name;
        this.moveableText.changeText(name);
        if (this.renameCB) {
            this.renameCB();
        }
        this.onAnyObjectChange();
        this.onChange();
        return undoValue;
    };

    MapObject.prototype.getSelectionBoxBounds = function getSelectionBoxBounds() {
        var xOffset = 10;
        var yOffset = 10;
        var width = this.objectTexture.width * this.scale.x + xOffset;
        var height = this.objectTexture.height * this.scale.y + yOffset;
        var x = this.moveableContainer.position.x - width / 2;
        var y = this.moveableContainer.position.y - height / 2;
        return { x: x, y: y, width: width, height: height };
    };

    MapObject.prototype.getCorner = function getCorner() {
        var bounds = this.getSelectionBoxBounds();
        return {
            left: bounds.x,
            top: bounds.y,
            right: bounds.x + bounds.width,
            bottom: bounds.y + bounds.height
        };
    };

    MapObject.prototype.drawSelectionBox = function drawSelectionBox() {
        var _getSelectionBoxBound = this.getSelectionBoxBounds(),
            x = _getSelectionBoxBound.x,
            y = _getSelectionBoxBound.y,
            width = _getSelectionBoxBound.width,
            height = _getSelectionBoxBound.height;

        Selector_1.drawScalableBox(x, y, width, height, this.scaleXPos, this.scaleYPos, this.scaleBothXY);
    };

    MapObject.prototype.initialise = function initialise() {
        this.initialiseMoveableContainer();
        this.initialiseObjectSprite();
        this.initialisedmoveableText();
        this.initialiseIcon();
        this.establishObjectHierarchy();
        this.bindFunctions();
        this.initialiseActions();
        if (!this.reservationMode) {
            this.initialiseInteraction();
        }
    };

    MapObject.prototype.initialiseIcon = function initialiseIcon() {
        this.moveableIcon = new MoveableIcon_1.default(this.iconData, this.reservationMode);
        this.moveableIcon.setContainerOffset(this.moveableContainer.position.x, this.moveableContainer.position.y);
    };

    MapObject.prototype.initialiseInteraction = function initialiseInteraction() {
        this.interactionManager = InteractionManager_1.default.createInteractionManager();
        this.selectedionListener = new SelectionListener_1.default(this.moveableContainer, this, this.onClick);
    };

    MapObject.prototype.initialiseActions = function initialiseActions() {
        if (this.actions.onElementClicked) {
            this.onElementClicked = this.actions.onElementClicked;
        }
    };

    MapObject.prototype.bindFunctions = function bindFunctions() {
        this.getContainer = this.getContainer.bind(this);
        this.onClick = this.onClick.bind(this);
        this.getSelectionBoxBounds = this.getSelectionBoxBounds.bind(this);
        this.scaleXPos = this.scaleXPos.bind(this);
        this.scaleYPos = this.scaleYPos.bind(this);
        this.scaleBothXY = this.scaleBothXY.bind(this);
        this.drawSelectionBox = this.drawSelectionBox.bind(this);
        this.setLabel = this.setLabel.bind(this);
        this.onRename = this.onRename.bind(this);
        this.showIcon = this.showIcon.bind(this);
        this.setIcon = this.setIcon.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onDeselect = this.onDeselect.bind(this);
    };

    MapObject.prototype.initialiseMoveableContainer = function initialiseMoveableContainer() {
        this.moveableContainer = new PIXI.Container();
        this.moveableContainer.position = this.pos;
    };

    MapObject.prototype.initialiseObjectSprite = function initialiseObjectSprite() {
        this.objectTexture = PIXI.loader.resources[this.determineTexture()].texture;
        this.object = new PIXI.Sprite(this.objectTexture);
        this.object.anchor = new PIXI.ObservablePoint(function () {}, undefined, 0.5, 0.5);
        this.object.scale = this.scale;
    };

    MapObject.prototype.initialisedmoveableText = function initialisedmoveableText() {
        this.moveableText = new MoveableText_1.default(this.textData, this.reservationMode);
        this.moveableText.setAnchor({ x: 0.5, y: 0.7 });
        this.moveableText.setContainerOffset(this.moveableContainer.position.x, this.moveableContainer.position.y);
    };

    MapObject.prototype.establishObjectHierarchy = function establishObjectHierarchy() {
        this.moveableContainer.addChild(this.object);
        this.moveableContainer.addChild(this.moveableIcon.getContainer());
        this.moveableContainer.addChild(this.moveableText.getContainer());
    };

    MapObject.prototype.determineTexture = function determineTexture() {
        if (this.objectType === "square") {
            if (this.selected) {
                return Utils_1.squareObjectSelectedTexture;
            } else {
                return Utils_1.squareObjectNotSelectedTexture;
            }
        } else if (this.objectType === "circle") {
            if (this.selected) {
                return Utils_1.circleObjectSelectedTexture;
            } else {
                return Utils_1.circleObjectNotSelectedTexture;
            }
        }
    };

    return MapObject;
}(MoveableContainer_1.default);

exports.default = MapObject;
//# sourceMappingURL=MapObject.js.map

/***/ }),

/***/ "KNjQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Loader = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _miniSignals = __webpack_require__("vKdq");

var _miniSignals2 = _interopRequireDefault(_miniSignals);

var _parseUri = __webpack_require__("01sX");

var _parseUri2 = _interopRequireDefault(_parseUri);

var _async = __webpack_require__("bC3n");

var async = _interopRequireWildcard(_async);

var _Resource = __webpack_require__("F/bs");

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

// some constants
var MAX_PROGRESS = 100;
var rgxExtractUrlHash = /(#[\w-]+)?$/;

/**
 * Manages the state and loading of multiple resources to load.
 *
 * @class
 */

var Loader = exports.Loader = function () {
    /**
     * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
     * @param {number} [concurrency=10] - The number of resources to load concurrently.
     */
    function Loader() {
        var _this = this;

        var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var concurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

        _classCallCheck(this, Loader);

        /**
         * The base url for all resources loaded by this loader.
         *
         * @member {string}
         */
        this.baseUrl = baseUrl;

        /**
         * The progress percent of the loader going through the queue.
         *
         * @member {number}
         */
        this.progress = 0;

        /**
         * Loading state of the loader, true if it is currently loading resources.
         *
         * @member {boolean}
         */
        this.loading = false;

        /**
         * A querystring to append to every URL added to the loader.
         *
         * This should be a valid query string *without* the question-mark (`?`). The loader will
         * also *not* escape values for you. Make sure to escape your parameters with
         * [`encodeURIComponent`](https://mdn.io/encodeURIComponent) before assigning this property.
         *
         * @example
         * const loader = new Loader();
         *
         * loader.defaultQueryString = 'user=me&password=secret';
         *
         * // This will request 'image.png?user=me&password=secret'
         * loader.add('image.png').load();
         *
         * loader.reset();
         *
         * // This will request 'image.png?v=1&user=me&password=secret'
         * loader.add('iamge.png?v=1').load();
         *
         * @member {string}
         */
        this.defaultQueryString = '';

        /**
         * The middleware to run before loading each resource.
         *
         * @private
         * @member {function[]}
         */
        this._beforeMiddleware = [];

        /**
         * The middleware to run after loading each resource.
         *
         * @private
         * @member {function[]}
         */
        this._afterMiddleware = [];

        /**
         * The tracks the resources we are currently completing parsing for.
         *
         * @private
         * @member {Resource[]}
         */
        this._resourcesParsing = [];

        /**
         * The `_loadResource` function bound with this object context.
         *
         * @private
         * @member {function}
         * @param {Resource} r - The resource to load
         * @param {Function} d - The dequeue function
         * @return {undefined}
         */
        this._boundLoadResource = function (r, d) {
            return _this._loadResource(r, d);
        };

        /**
         * The resources waiting to be loaded.
         *
         * @private
         * @member {Resource[]}
         */
        this._queue = async.queue(this._boundLoadResource, concurrency);

        this._queue.pause();

        /**
         * All the resources for this loader keyed by name.
         *
         * @member {object<string, Resource>}
         */
        this.resources = {};

        /**
         * Dispatched once per loaded or errored resource.
         *
         * The callback looks like {@link Loader.OnProgressSignal}.
         *
         * @member {Signal<Loader.OnProgressSignal>}
         */
        this.onProgress = new _miniSignals2.default();

        /**
         * Dispatched once per errored resource.
         *
         * The callback looks like {@link Loader.OnErrorSignal}.
         *
         * @member {Signal<Loader.OnErrorSignal>}
         */
        this.onError = new _miniSignals2.default();

        /**
         * Dispatched once per loaded resource.
         *
         * The callback looks like {@link Loader.OnLoadSignal}.
         *
         * @member {Signal<Loader.OnLoadSignal>}
         */
        this.onLoad = new _miniSignals2.default();

        /**
         * Dispatched when the loader begins to process the queue.
         *
         * The callback looks like {@link Loader.OnStartSignal}.
         *
         * @member {Signal<Loader.OnStartSignal>}
         */
        this.onStart = new _miniSignals2.default();

        /**
         * Dispatched when the queued resources all load.
         *
         * The callback looks like {@link Loader.OnCompleteSignal}.
         *
         * @member {Signal<Loader.OnCompleteSignal>}
         */
        this.onComplete = new _miniSignals2.default();

        // Add default before middleware
        for (var i = 0; i < Loader._defaultBeforeMiddleware.length; ++i) {
            this.pre(Loader._defaultBeforeMiddleware[i]);
        }

        // Add default after middleware
        for (var _i = 0; _i < Loader._defaultAfterMiddleware.length; ++_i) {
            this.use(Loader._defaultAfterMiddleware[_i]);
        }
    }

    /**
     * When the progress changes the loader and resource are disaptched.
     *
     * @memberof Loader
     * @callback OnProgressSignal
     * @param {Loader} loader - The loader the progress is advancing on.
     * @param {Resource} resource - The resource that has completed or failed to cause the progress to advance.
     */

    /**
     * When an error occurrs the loader and resource are disaptched.
     *
     * @memberof Loader
     * @callback OnErrorSignal
     * @param {Loader} loader - The loader the error happened in.
     * @param {Resource} resource - The resource that caused the error.
     */

    /**
     * When a load completes the loader and resource are disaptched.
     *
     * @memberof Loader
     * @callback OnLoadSignal
     * @param {Loader} loader - The loader that laoded the resource.
     * @param {Resource} resource - The resource that has completed loading.
     */

    /**
     * When the loader starts loading resources it dispatches this callback.
     *
     * @memberof Loader
     * @callback OnStartSignal
     * @param {Loader} loader - The loader that has started loading resources.
     */

    /**
     * When the loader completes loading resources it dispatches this callback.
     *
     * @memberof Loader
     * @callback OnCompleteSignal
     * @param {Loader} loader - The loader that has finished loading resources.
     */

    /**
     * Options for a call to `.add()`.
     *
     * @see Loader#add
     *
     * @typedef {object} IAddOptions
     * @property {string} [name] - The name of the resource to load, if not passed the url is used.
     * @property {string} [key] - Alias for `name`.
     * @property {string} [url] - The url for this resource, relative to the baseUrl of this loader.
     * @property {string|boolean} [crossOrigin] - Is this request cross-origin? Default is to
     *      determine automatically.
     * @property {number} [timeout=0] - A timeout in milliseconds for the load. If the load takes
     *      longer than this time it is cancelled and the load is considered a failure. If this value is
     *      set to `0` then there is no explicit timeout.
     * @property {Resource.LOAD_TYPE} [loadType=Resource.LOAD_TYPE.XHR] - How should this resource
     *      be loaded?
     * @property {Resource.XHR_RESPONSE_TYPE} [xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
     *      should the data being loaded be interpreted when using XHR?
     * @property {Resource.OnCompleteSignal} [onComplete] - Callback to add an an onComplete signal istener.
     * @property {Resource.OnCompleteSignal} [callback] - Alias for `onComplete`.
     * @property {Resource.IMetadata} [metadata] - Extra configuration for middleware and the Resource object.
     */

    /* eslint-disable require-jsdoc,valid-jsdoc */
    /**
     * Adds a resource (or multiple resources) to the loader queue.
     *
     * This function can take a wide variety of different parameters. The only thing that is always
     * required the url to load. All the following will work:
     *
     * ```js
     * loader
     *     // normal param syntax
     *     .add('key', 'http://...', function () {})
     *     .add('http://...', function () {})
     *     .add('http://...')
     *
     *     // object syntax
     *     .add({
     *         name: 'key2',
     *         url: 'http://...'
     *     }, function () {})
     *     .add({
     *         url: 'http://...'
     *     }, function () {})
     *     .add({
     *         name: 'key3',
     *         url: 'http://...'
     *         onComplete: function () {}
     *     })
     *     .add({
     *         url: 'https://...',
     *         onComplete: function () {},
     *         crossOrigin: true
     *     })
     *
     *     // you can also pass an array of objects or urls or both
     *     .add([
     *         { name: 'key4', url: 'http://...', onComplete: function () {} },
     *         { url: 'http://...', onComplete: function () {} },
     *         'http://...'
     *     ])
     *
     *     // and you can use both params and options
     *     .add('key', 'http://...', { crossOrigin: true }, function () {})
     *     .add('http://...', { crossOrigin: true }, function () {});
     * ```
     *
     * @function
     * @variation 1
     * @param {string} name - The name of the resource to load.
     * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
     * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
     * @return {this} Returns itself.
     */ /**
        * @function
        * @variation 2
        * @param {string} name - The name of the resource to load.
        * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
        * @param {IAddOptions} [options] - The options for the load.
        * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
        * @return {this} Returns itself.
        */ /**
           * @function
           * @variation 3
           * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
           * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
           * @return {this} Returns itself.
           */ /**
              * @function
              * @variation 4
              * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
              * @param {IAddOptions} [options] - The options for the load.
              * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
              * @return {this} Returns itself.
              */ /**
                 * @function
                 * @variation 5
                 * @param {IAddOptions} options - The options for the load. This object must contain a `url` property.
                 * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
                 * @return {this} Returns itself.
                 */ /**
                    * @function
                    * @variation 6
                    * @param {Array<IAddOptions|string>} resources - An array of resources to load, where each is
                    *      either an object with the options or a string url. If you pass an object, it must contain a `url` property.
                    * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
                    * @return {this} Returns itself.
                    */

    Loader.prototype.add = function add(name, url, options, cb) {
        // special case of an array of objects or urls
        if (Array.isArray(name)) {
            for (var i = 0; i < name.length; ++i) {
                this.add(name[i]);
            }

            return this;
        }

        // if an object is passed instead of params
        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
            cb = url || name.callback || name.onComplete;
            options = name;
            url = name.url;
            name = name.name || name.key || name.url;
        }

        // case where no name is passed shift all args over by one.
        if (typeof url !== 'string') {
            cb = options;
            options = url;
            url = name;
        }

        // now that we shifted make sure we have a proper url.
        if (typeof url !== 'string') {
            throw new Error('No url passed to add resource to loader.');
        }

        // options are optional so people might pass a function and no options
        if (typeof options === 'function') {
            cb = options;
            options = null;
        }

        // if loading already you can only add resources that have a parent.
        if (this.loading && (!options || !options.parentResource)) {
            throw new Error('Cannot add resources while the loader is running.');
        }

        // check if resource already exists.
        if (this.resources[name]) {
            throw new Error('Resource named "' + name + '" already exists.');
        }

        // add base url if this isn't an absolute url
        url = this._prepareUrl(url);

        // create the store the resource
        this.resources[name] = new _Resource.Resource(name, url, options);

        if (typeof cb === 'function') {
            this.resources[name].onAfterMiddleware.once(cb);
        }

        // if actively loading, make sure to adjust progress chunks for that parent and its children
        if (this.loading) {
            var parent = options.parentResource;
            var incompleteChildren = [];

            for (var _i2 = 0; _i2 < parent.children.length; ++_i2) {
                if (!parent.children[_i2].isComplete) {
                    incompleteChildren.push(parent.children[_i2]);
                }
            }

            var fullChunk = parent.progressChunk * (incompleteChildren.length + 1); // +1 for parent
            var eachChunk = fullChunk / (incompleteChildren.length + 2); // +2 for parent & new child

            parent.children.push(this.resources[name]);
            parent.progressChunk = eachChunk;

            for (var _i3 = 0; _i3 < incompleteChildren.length; ++_i3) {
                incompleteChildren[_i3].progressChunk = eachChunk;
            }

            this.resources[name].progressChunk = eachChunk;
        }

        // add the resource to the queue
        this._queue.push(this.resources[name]);

        return this;
    };
    /* eslint-enable require-jsdoc,valid-jsdoc */

    /**
     * Sets up a middleware function that will run *before* the
     * resource is loaded.
     *
     * @param {function} fn - The middleware function to register.
     * @return {this} Returns itself.
     */

    Loader.prototype.pre = function pre(fn) {
        this._beforeMiddleware.push(fn);

        return this;
    };

    /**
     * Sets up a middleware function that will run *after* the
     * resource is loaded.
     *
     * @param {function} fn - The middleware function to register.
     * @return {this} Returns itself.
     */

    Loader.prototype.use = function use(fn) {
        this._afterMiddleware.push(fn);

        return this;
    };

    /**
     * Resets the queue of the loader to prepare for a new load.
     *
     * @return {this} Returns itself.
     */

    Loader.prototype.reset = function reset() {
        this.progress = 0;
        this.loading = false;

        this._queue.kill();
        this._queue.pause();

        // abort all resource loads
        for (var k in this.resources) {
            var res = this.resources[k];

            if (res._onLoadBinding) {
                res._onLoadBinding.detach();
            }

            if (res.isLoading) {
                res.abort();
            }
        }

        this.resources = {};

        return this;
    };

    /**
     * Starts loading the queued resources.
     *
     * @param {function} [cb] - Optional callback that will be bound to the `complete` event.
     * @return {this} Returns itself.
     */

    Loader.prototype.load = function load(cb) {
        // register complete callback if they pass one
        if (typeof cb === 'function') {
            this.onComplete.once(cb);
        }

        // if the queue has already started we are done here
        if (this.loading) {
            return this;
        }

        if (this._queue.idle()) {
            this._onStart();
            this._onComplete();
        } else {
            // distribute progress chunks
            var numTasks = this._queue._tasks.length;
            var chunk = MAX_PROGRESS / numTasks;

            for (var i = 0; i < this._queue._tasks.length; ++i) {
                this._queue._tasks[i].data.progressChunk = chunk;
            }

            // notify we are starting
            this._onStart();

            // start loading
            this._queue.resume();
        }

        return this;
    };

    /**
     * The number of resources to load concurrently.
     *
     * @member {number}
     * @default 10
     */

    /**
     * Prepares a url for usage based on the configuration of this object
     *
     * @private
     * @param {string} url - The url to prepare.
     * @return {string} The prepared url.
     */
    Loader.prototype._prepareUrl = function _prepareUrl(url) {
        var parsedUrl = (0, _parseUri2.default)(url, { strictMode: true });
        var result = void 0;

        // absolute url, just use it as is.
        if (parsedUrl.protocol || !parsedUrl.path || url.indexOf('//') === 0) {
            result = url;
        }
        // if baseUrl doesn't end in slash and url doesn't start with slash, then add a slash inbetween
        else if (this.baseUrl.length && this.baseUrl.lastIndexOf('/') !== this.baseUrl.length - 1 && url.charAt(0) !== '/') {
                result = this.baseUrl + '/' + url;
            } else {
                result = this.baseUrl + url;
            }

        // if we need to add a default querystring, there is a bit more work
        if (this.defaultQueryString) {
            var hash = rgxExtractUrlHash.exec(result)[0];

            result = result.substr(0, result.length - hash.length);

            if (result.indexOf('?') !== -1) {
                result += '&' + this.defaultQueryString;
            } else {
                result += '?' + this.defaultQueryString;
            }

            result += hash;
        }

        return result;
    };

    /**
     * Loads a single resource.
     *
     * @private
     * @param {Resource} resource - The resource to load.
     * @param {function} dequeue - The function to call when we need to dequeue this item.
     */

    Loader.prototype._loadResource = function _loadResource(resource, dequeue) {
        var _this2 = this;

        resource._dequeue = dequeue;

        // run before middleware
        async.eachSeries(this._beforeMiddleware, function (fn, next) {
            fn.call(_this2, resource, function () {
                // if the before middleware marks the resource as complete,
                // break and don't process any more before middleware
                next(resource.isComplete ? {} : null);
            });
        }, function () {
            if (resource.isComplete) {
                _this2._onLoad(resource);
            } else {
                resource._onLoadBinding = resource.onComplete.once(_this2._onLoad, _this2);
                resource.load();
            }
        }, true);
    };

    /**
     * Called once loading has started.
     *
     * @private
     */

    Loader.prototype._onStart = function _onStart() {
        this.progress = 0;
        this.loading = true;
        this.onStart.dispatch(this);
    };

    /**
     * Called once each resource has loaded.
     *
     * @private
     */

    Loader.prototype._onComplete = function _onComplete() {
        this.progress = MAX_PROGRESS;
        this.loading = false;
        this.onComplete.dispatch(this, this.resources);
    };

    /**
     * Called each time a resources is loaded.
     *
     * @private
     * @param {Resource} resource - The resource that was loaded
     */

    Loader.prototype._onLoad = function _onLoad(resource) {
        var _this3 = this;

        resource._onLoadBinding = null;

        // remove this resource from the async queue, and add it to our list of resources that are being parsed
        this._resourcesParsing.push(resource);
        resource._dequeue();

        // run all the after middleware for this resource
        async.eachSeries(this._afterMiddleware, function (fn, next) {
            fn.call(_this3, resource, next);
        }, function () {
            resource.onAfterMiddleware.dispatch(resource);

            _this3.progress = Math.min(MAX_PROGRESS, _this3.progress + resource.progressChunk);
            _this3.onProgress.dispatch(_this3, resource);

            if (resource.error) {
                _this3.onError.dispatch(resource.error, _this3, resource);
            } else {
                _this3.onLoad.dispatch(_this3, resource);
            }

            _this3._resourcesParsing.splice(_this3._resourcesParsing.indexOf(resource), 1);

            // do completion check
            if (_this3._queue.idle() && _this3._resourcesParsing.length === 0) {
                _this3._onComplete();
            }
        }, true);
    };

    _createClass(Loader, [{
        key: 'concurrency',
        get: function get() {
            return this._queue.concurrency;
        }
        // eslint-disable-next-line require-jsdoc

        , set: function set(concurrency) {
            this._queue.concurrency = concurrency;
        }
    }]);

    return Loader;
}();

/**
 * A default array of middleware to run before loading each resource.
 * Each of these middlewares are added to any new Loader instances when they are created.
 *
 * @private
 * @member {function[]}
 */

Loader._defaultBeforeMiddleware = [];

/**
 * A default array of middleware to run after loading each resource.
 * Each of these middlewares are added to any new Loader instances when they are created.
 *
 * @private
 * @member {function[]}
 */
Loader._defaultAfterMiddleware = [];

/**
 * Sets up a middleware function that will run *before* the
 * resource is loaded.
 *
 * @static
 * @param {function} fn - The middleware function to register.
 * @return {Loader} Returns itself.
 */
Loader.pre = function LoaderPreStatic(fn) {
    Loader._defaultBeforeMiddleware.push(fn);

    return Loader;
};

/**
 * Sets up a middleware function that will run *after* the
 * resource is loaded.
 *
 * @static
 * @param {function} fn - The middleware function to register.
 * @return {Loader} Returns itself.
 */
Loader.use = function LoaderUseStatic(fn) {
    Loader._defaultAfterMiddleware.push(fn);

    return Loader;
};
//# sourceMappingURL=Loader.js.map

/***/ }),

/***/ "KPDt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.default = withTouchListeners;

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__("RKsu");

var _utils = __webpack_require__("H4Cu");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function withTouchListeners(WrappedComponent) {
  return function (_PureComponent) {
    _inherits(TouchProvider, _PureComponent);

    function TouchProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TouchProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
        capture: false,
        passive: false
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TouchProvider, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // account for touch devices
        if (target && (0, _utils.isTouchDevice)()) {
          // Mobile Safari ignores { overflow: hidden } declaration on the body.
          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          // Allow scroll on provided target
          if (touchScrollTarget) {
            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // remove touch listeners
        if (target && (0, _utils.isTouchDevice)()) {
          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          if (touchScrollTarget) {
            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return TouchProvider;
  }(_react.PureComponent);
}

/***/ }),

/***/ "KRVa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.BitmapText = exports.TilingSpriteRenderer = exports.TilingSprite = exports.AnimatedSprite = undefined;

var _AnimatedSprite = __webpack_require__("Qekk");

Object.defineProperty(exports, 'AnimatedSprite', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AnimatedSprite).default;
  }
});

var _TilingSprite = __webpack_require__("+ghv");

Object.defineProperty(exports, 'TilingSprite', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TilingSprite).default;
  }
});

var _TilingSpriteRenderer = __webpack_require__("PpCh");

Object.defineProperty(exports, 'TilingSpriteRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TilingSpriteRenderer).default;
  }
});

var _BitmapText = __webpack_require__("qyFb");

Object.defineProperty(exports, 'BitmapText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BitmapText).default;
  }
});

__webpack_require__("64fV");

__webpack_require__("yM7h");

__webpack_require__("7F5b");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// imported for side effect of extending the prototype only, contains no exports
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "KRuG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var settle = __webpack_require__("aS8y");
var buildURL = __webpack_require__("H6Qo");
var parseHeaders = __webpack_require__("ZeD7");
var isURLSameOrigin = __webpack_require__("/w7L");
var createError = __webpack_require__("3bIi");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("dn2M");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),

/***/ "KYHG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _generateBlurVertSource = __webpack_require__("Ga9O");

var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);

var _generateBlurFragSource = __webpack_require__("z7q+");

var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);

var _getMaxBlurKernelSize = __webpack_require__("39pn");

var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The BlurYFilter applies a horizontal Gaussian blur to an object.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var BlurYFilter = function (_core$Filter) {
    _inherits(BlurYFilter, _core$Filter);

    /**
     * @param {number} strength - The strength of the blur filter.
     * @param {number} quality - The quality of the blur filter.
     * @param {number} resolution - The resolution of the blur filter.
     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
     */
    function BlurYFilter(strength, quality, resolution, kernelSize) {
        _classCallCheck(this, BlurYFilter);

        kernelSize = kernelSize || 5;
        var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
        var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        vertSrc,
        // fragment shader
        fragSrc));

        _this.resolution = resolution || core.settings.RESOLUTION;

        _this._quality = 0;

        _this.quality = quality || 4;
        _this.strength = strength || 8;

        _this.firstRun = true;
        return _this;
    }

    /**
     * Applies the filter.
     *
     * @param {PIXI.FilterManager} filterManager - The manager.
     * @param {PIXI.RenderTarget} input - The input target.
     * @param {PIXI.RenderTarget} output - The output target.
     * @param {boolean} clear - Should the output be cleared before rendering?
     */

    BlurYFilter.prototype.apply = function apply(filterManager, input, output, clear) {
        if (this.firstRun) {
            var gl = filterManager.renderer.gl;
            var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);

            this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
            this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);

            this.firstRun = false;
        }

        this.uniforms.strength = 1 / output.size.height * (output.size.height / input.size.height);

        this.uniforms.strength *= this.strength;
        this.uniforms.strength /= this.passes;

        if (this.passes === 1) {
            filterManager.applyFilter(this, input, output, clear);
        } else {
            var renderTarget = filterManager.getRenderTarget(true);
            var flip = input;
            var flop = renderTarget;

            for (var i = 0; i < this.passes - 1; i++) {
                filterManager.applyFilter(this, flip, flop, true);

                var temp = flop;

                flop = flip;
                flip = temp;
            }

            filterManager.applyFilter(this, flip, output, clear);

            filterManager.returnRenderTarget(renderTarget);
        }
    };

    /**
     * Sets the strength of both the blur.
     *
     * @member {number}
     * @default 2
     */

    _createClass(BlurYFilter, [{
        key: 'blur',
        get: function get() {
            return this.strength;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.padding = Math.abs(value) * 2;
            this.strength = value;
        }

        /**
         * Sets the quality of the blur by modifying the number of passes. More passes means higher
         * quaility bluring but the lower the performance.
         *
         * @member {number}
         * @default 4
         */

    }, {
        key: 'quality',
        get: function get() {
            return this._quality;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._quality = value;
            this.passes = value;
        }
    }]);

    return BlurYFilter;
}(core.Filter);

exports.default = BlurYFilter;
//# sourceMappingURL=BlurYFilter.js.map

/***/ }),

/***/ "KoUQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = mapWebGLBlendModesToPixi;

var _const = __webpack_require__("YEQi");

/**
 * Maps gl blend combinations to WebGL.
 *
 * @memberof PIXI
 * @function mapWebGLBlendModesToPixi
 * @private
 * @param {WebGLRenderingContext} gl - The rendering context.
 * @param {string[]} [array=[]] - The array to output into.
 * @return {string[]} Mapped modes.
 */
function mapWebGLBlendModesToPixi(gl) {
    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    // TODO - premultiply alpha would be different.
    // add a boolean for that!
    array[_const.BLEND_MODES.NORMAL] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.ADD] = [gl.ONE, gl.ONE];
    array[_const.BLEND_MODES.MULTIPLY] = [gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.SCREEN] = [gl.ONE, gl.ONE_MINUS_SRC_COLOR, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.OVERLAY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.DARKEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.LIGHTEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.COLOR_DODGE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.COLOR_BURN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.HARD_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.SOFT_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.DIFFERENCE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.EXCLUSION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.HUE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.SATURATION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.COLOR] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.LUMINOSITY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];

    // not-premultiplied blend modes
    array[_const.BLEND_MODES.NORMAL_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.ADD_NPM] = [gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE];
    array[_const.BLEND_MODES.SCREEN_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_COLOR, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];

    return array;
}
//# sourceMappingURL=mapWebGLBlendModesToPixi.js.map

/***/ }),

/***/ "KtQ5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var bound_1 = __webpack_require__("USDo");
var InteractionManager_1 = __webpack_require__("dUAP");
var Table_1 = __webpack_require__("QfCP");
var Seat_1 = __webpack_require__("pKi2");
var TicketMappingMixin_1 = __webpack_require__("kWdy");

var TableBase = function (_Table_1$default) {
    _inherits(TableBase, _Table_1$default);

    function TableBase(tableData, actions, disableInteraction) {
        _classCallCheck(this, TableBase);

        var _this = _possibleConstructorReturn(this, _Table_1$default.call(this, tableData, actions, disableInteraction, true));

        _this.interactionManager = InteractionManager_1.default.createInteractionManager();
        return _this;
    }

    TableBase.prototype.draw = function draw() {
        _Table_1$default.prototype.draw.call(this);
        if (!this.reserved && !this.locked) {
            this.setupInteraction();
        }
    };

    TableBase.prototype.seatsInit = function seatsInit(seats, disableInteraction) {
        var _this2 = this;

        var seatCount = seats.length;
        return seats.map(function (seat, i) {
            var constructionValue = _extends({ pos: _this2.getSeatPos(i, seatCount), seatlabelStartAt: _this2.seatlabelStartAt, bookByTable: _this2.bookByTable, tableId: _this2._id, sectionId: _this2.sectionId, sectionName: _this2.sectionName, tableName: _this2.name }, seat);
            return new Seat_1.default(constructionValue, _this2.actions, disableInteraction);
        });
    };

    TableBase.prototype.listenForMouse = function listenForMouse() {
        var _this3 = this;

        this.moveableContainer.on("mouseover", function () {
            _this3.showText(true);
        });
        this.moveableContainer.on("mouseout", function () {
            _this3.showText(false);
        });
    };

    TableBase.prototype.getSeatPos = function getSeatPos(i, seatCount) {
        var posX = Math.ceil(this.seatCircleRadius * Math.cos(i * (2 * Math.PI) / seatCount));
        var posY = Math.ceil(this.seatCircleRadius * Math.sin(i * (2 * Math.PI) / seatCount));
        return { x: posX, y: posY };
    };

    TableBase.prototype.tableContainerInit = function tableContainerInit(_ref) {
        var x = _ref.x,
            y = _ref.y;

        var containerScale = new PIXI.Point(1, 1);
        this.moveableContainer = new PIXI.Container();
        this.moveableContainer.position = new PIXI.Point(x, y);
        this.moveableContainer.pivot.x = this.pivot.x;
        this.moveableContainer.pivot.y = this.pivot.y;
        this.moveableContainer.rotation = this.rotation;
        this.moveableContainer.interactive = true;
        this.moveableContainer.buttonMode = true;
        this.moveableContainer.addChild(this.table);
        this.moveableContainer.addChild(this.seatContainer);
        this.moveableContainer.addChild(this.text);
        this.moveableContainer.scale = containerScale;
    };

    return TableBase;
}(Table_1.default);

TableBase.tableTypes = {
    ROUND: "round",
    RECT: "rect"
};
TableBase.labelPatterns = {
    COUNT: "count",
    ALPHABET: "alphabet"
};
__decorate([bound_1.default], TableBase.prototype, "listenForMouse", null);

var Table = function (_TicketMappingMixin_) {
    _inherits(Table, _TicketMappingMixin_);

    function Table(tableData, actions) {
        var disableInteraction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        _classCallCheck(this, Table);

        return _possibleConstructorReturn(this, _TicketMappingMixin_.call(this, tableData, actions, disableInteraction));
    }

    return Table;
}(TicketMappingMixin_1.default(TableBase));

exports.default = Table;
//# sourceMappingURL=Table.js.map

/***/ }),

/***/ "L/PD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a26d4f11296d51fedf88e6ce7a39010b.svg";

/***/ }),

/***/ "L9l0":
/***/ (function(module, exports) {

var newline = /\n/;
var newlineChar = '\n';
var whitespace = /\s/;

module.exports = function (text, opt) {
    var lines = module.exports.lines(text, opt);
    return lines.map(function (line) {
        return text.substring(line.start, line.end);
    }).join('\n');
};

module.exports.lines = function wordwrap(text, opt) {
    opt = opt || {};

    //zero width results in nothing visible
    if (opt.width === 0 && opt.mode !== 'nowrap') return [];

    text = text || '';
    var width = typeof opt.width === 'number' ? opt.width : Number.MAX_VALUE;
    var start = Math.max(0, opt.start || 0);
    var end = typeof opt.end === 'number' ? opt.end : text.length;
    var mode = opt.mode;

    var measure = opt.measure || monospace;
    if (mode === 'pre') return pre(measure, text, start, end, width);else return greedy(measure, text, start, end, width, mode);
};

function idxOf(text, chr, start, end) {
    var idx = text.indexOf(chr, start);
    if (idx === -1 || idx > end) return end;
    return idx;
}

function isWhitespace(chr) {
    return whitespace.test(chr);
}

function pre(measure, text, start, end, width) {
    var lines = [];
    var lineStart = start;
    for (var i = start; i < end && i < text.length; i++) {
        var chr = text.charAt(i);
        var isNewline = newline.test(chr);

        //If we've reached a newline, then step down a line
        //Or if we've reached the EOF
        if (isNewline || i === end - 1) {
            var lineEnd = isNewline ? i : i + 1;
            var measured = measure(text, lineStart, lineEnd, width);
            lines.push(measured);

            lineStart = i + 1;
        }
    }
    return lines;
}

function greedy(measure, text, start, end, width, mode) {
    //A greedy word wrapper based on LibGDX algorithm
    //https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/BitmapFontCache.java
    var lines = [];

    var testWidth = width;
    //if 'nowrap' is specified, we only wrap on newline chars
    if (mode === 'nowrap') testWidth = Number.MAX_VALUE;

    while (start < end && start < text.length) {
        //get next newline position
        var newLine = idxOf(text, newlineChar, start, end);

        //eat whitespace at start of line
        while (start < newLine) {
            if (!isWhitespace(text.charAt(start))) break;
            start++;
        }

        //determine visible # of glyphs for the available width
        var measured = measure(text, start, newLine, testWidth);

        var lineEnd = start + (measured.end - measured.start);
        var nextStart = lineEnd + newlineChar.length;

        //if we had to cut the line before the next newline...
        if (lineEnd < newLine) {
            //find char to break on
            while (lineEnd > start) {
                if (isWhitespace(text.charAt(lineEnd))) break;
                lineEnd--;
            }
            if (lineEnd === start) {
                if (nextStart > start + newlineChar.length) nextStart--;
                lineEnd = nextStart; // If no characters to break, show all.
            } else {
                nextStart = lineEnd;
                //eat whitespace at end of line
                while (lineEnd > start) {
                    if (!isWhitespace(text.charAt(lineEnd - newlineChar.length))) break;
                    lineEnd--;
                }
            }
        }
        if (lineEnd >= start) {
            var result = measure(text, start, lineEnd, testWidth);
            lines.push(result);
        }
        start = nextStart;
    }
    return lines;
}

//determines the visible number of glyphs within a given width
function monospace(text, start, end, width) {
    var glyphs = Math.min(width, end - start);
    return {
        start: start,
        end: start + glyphs
    };
}

/***/ }),

/***/ "LEJh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var sdfVert_1 = __webpack_require__("3yKM");
var sdfFrag_1 = __webpack_require__("/uM6");
var utils_1 = __webpack_require__("wzjF");
var glCore = PIXI.glCore;

var SDFRenderer = function (_PIXI$ObjectRenderer) {
    _inherits(SDFRenderer, _PIXI$ObjectRenderer);

    function SDFRenderer(renderer) {
        _classCallCheck(this, SDFRenderer);

        var _this = _possibleConstructorReturn(this, _PIXI$ObjectRenderer.call(this, renderer));

        _this.shader = null;
        _this.count = 0;
        _this.groups = new Map();
        _this.glDataMap = new Map();
        _this.size = PIXI.settings.SPRITE_BATCH_SIZE;
        _this.triggerFlush = false;
        return _this;
    }

    SDFRenderer.prototype.onContextChange = function onContextChange() {
        var gl = this.renderer.gl;
        var maxVertexUniformVectors = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
        if (maxVertexUniformVectors > 1024) {
            maxVertexUniformVectors = 1024;
        }
        this.numMatrixArrayElements = Math.floor(maxVertexUniformVectors / 4);
        this.shader = new PIXI.Shader(gl, sdfVert_1.default(this.numMatrixArrayElements), sdfFrag_1.default);
    };

    SDFRenderer.prototype.render = function render(sdfText) {
        if (this.count >= this.size || this.triggerFlush) {
            this.flush();
            this.triggerFlush = false;
        }
        if (this.groups.has(sdfText.key)) {
            var sdfGroup = this.groups.get(sdfText.key);
            var indexLevel = sdfGroup.indices.length / sdfText.indices.length;
            if (indexLevel === this.numMatrixArrayElements - 1) {
                this.triggerFlush = true;
            }
            sdfGroup.text.push(sdfText);
            sdfGroup.transform = utils_1.float32Concat(sdfGroup.transform, sdfText.transform.worldTransform.toArray(true));
            sdfGroup.indices = utils_1.UInt16Concat(sdfGroup.indices, sdfText.indices.map(function (v) {
                return v + (sdfText.indices[sdfText.indices.length - 1] + 1) * indexLevel;
            }));
            this.groups.set(sdfText.key, sdfGroup);
        } else {
            var indices = sdfText.indices;
            var vertices = sdfText.vertices;
            var uvs = sdfText.uvs;
            var max = this.numMatrixArrayElements;
            var vertArr = new Float32Array();
            var uvsArr = new Float32Array();
            var indexArr = new Float32Array();
            for (var i = 0; i < max; i++) {
                vertArr = utils_1.float32Concat(vertArr, vertices);
                uvsArr = utils_1.float32Concat(uvsArr, uvs);
                var indexes = new Float32Array(sdfText.vertices.length / 2);
                indexes.fill(i);
                indexArr = utils_1.float32Concat(indexArr, indexes);
            }
            this.groups.set(sdfText.key, {
                text: [sdfText],
                transform: sdfText.transform.worldTransform.toArray(true),
                indices: indices,
                vertices: vertArr,
                uvs: uvsArr,
                indexes: indexArr,
                max: max
            });
        }
        this.count++;
    };

    SDFRenderer.prototype.flush = function flush() {
        this.renderGroup(this.groups);
        this.groups.forEach(function (group) {
            group.text = [];
            group.transform = new Float32Array();
            group.indices = new Int16Array();
        });
        this.count = 0;
    };

    SDFRenderer.prototype.renderGroup = function renderGroup(sdfTextGroups) {
        var _this2 = this;

        var renderer = this.renderer;
        var gl = renderer.gl;
        sdfTextGroups.forEach(function (group) {
            if (group.text.length === 0) {
                return;
            }
            var sdfTextGroup = group.text;
            var transform = group.transform,
                indices = group.indices,
                vertices = group.vertices,
                uvs = group.uvs,
                indexes = group.indexes;

            var sdfText = sdfTextGroup[0];
            var texture = sdfText.texture;
            var font = sdfText.font;
            var glData = _this2.glDataMap.get(sdfText.key);
            if (!glData) {
                var indicesBuf = glCore.GLBuffer.createIndexBuffer(gl, indices, gl.STATIC_DRAW);
                var verticesBuf = glCore.GLBuffer.createVertexBuffer(gl, vertices, gl.STREAM_DRAW);
                var uvsBuf = glCore.GLBuffer.createVertexBuffer(gl, uvs, gl.STREAM_DRAW);
                var indexesBuf = glCore.GLBuffer.createVertexBuffer(gl, indexes, gl.STATIC_DRAW);
                renderer.bindVao(null);
                glData = {
                    shader: _this2.shader,
                    vertexBuffer: verticesBuf,
                    uvBuffer: uvsBuf,
                    indexBuffer: indicesBuf,
                    indexes: indexesBuf,
                    vao: null,
                    dirty: sdfText.dirty,
                    indexDirty: sdfText.indexDirty
                };
                glData.vao = new glCore.VertexArrayObject(gl).addIndex(glData.indexBuffer).addAttribute(glData.vertexBuffer, glData.shader.attributes.aVertexPosition, gl.FLOAT, false, 2 * 4, 0).addAttribute(glData.indexes, glData.shader.attributes.a_idoff, gl.FLOAT, false, 4, 0).addAttribute(glData.uvBuffer, glData.shader.attributes.aTextureCoord, gl.FLOAT, false, 2 * 4, 0);
                _this2.glDataMap.set(sdfText.key, glData);
            }
            renderer.bindVao(glData.vao);
            glData.indexBuffer.upload(indices);
            renderer.bindShader(glData.shader);
            glData.shader.uniforms.uSampler = renderer.bindTexture(texture);
            renderer.state.setBlendMode(sdfText.blendMode);
            var target = gl.getUniformLocation(_this2.shader.program, "translationMatrix");
            gl.uniformMatrix3fv(target, false, transform);
            glData.shader.uniforms.u_alpha = sdfText.worldAlpha;
            glData.shader.uniforms.u_color = sdfText.style.fill;
            glData.shader.uniforms.u_fontSize = sdfText.style.fontSize;
            glData.shader.uniforms.u_fontInfoSize = sdfText.style.fontSize / font.info.size;
            glData.shader.uniforms.u_weight = sdfText.style.weight;
            var drawMode = sdfText.drawMode = gl.TRIANGLES;
            glData.vao.draw(drawMode, sdfText.indices.length * sdfTextGroup.length, 0);
        });
    };

    return SDFRenderer;
}(PIXI.ObjectRenderer);

exports.default = SDFRenderer;
PIXI.WebGLRenderer.registerPlugin('sdf', SDFRenderer);
//# sourceMappingURL=SDFRenderer.js.map

/***/ }),

/***/ "LN7j":
/***/ (function(module, exports, __webpack_require__) {


var mapType = __webpack_require__("3hrJ");
var mapSize = __webpack_require__("KK7d");

/**
 * Extracts the attributes
 * @class
 * @memberof PIXI.glCore.shader
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param program {WebGLProgram} The shader program to get the attributes from
 * @return attributes {Object}
 */
var extractAttributes = function extractAttributes(gl, program) {
    var attributes = {};

    var totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);

    for (var i = 0; i < totalAttributes; i++) {
        var attribData = gl.getActiveAttrib(program, i);
        var type = mapType(gl, attribData.type);

        attributes[attribData.name] = {
            type: type,
            size: mapSize(type),
            location: gl.getAttribLocation(program, attribData.name),
            //TODO - make an attribute object
            pointer: pointer
        };
    }

    return attributes;
};

var pointer = function pointer(type, normalized, stride, start) {
    // console.log(this.location)
    gl.vertexAttribPointer(this.location, this.size, type || gl.FLOAT, normalized || false, stride || 0, start || 0);
};

module.exports = extractAttributes;

/***/ }),

/***/ "M5Nt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__("eW0v");
var ReactDOM = __webpack_require__("eW0v");
var createFocusTrap = __webpack_require__("ySUw");

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap(props) {
    _classCallCheck(this, FocusTrap);

    var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));

    _this.setFocusTrapElement = function (element) {
      _this.focusTrapElement = element;
    };

    if (typeof document !== 'undefined') {
      _this.previouslyFocusedElement = document.activeElement;
    }
    return _this;
  }

  _createClass(FocusTrap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      var specifiedFocusTrapOptions = this.props.focusTrapOptions;
      var tailoredFocusTrapOptions = {
        returnFocusOnDeactivate: false
      };
      for (var optionName in specifiedFocusTrapOptions) {
        if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
        if (optionName === 'returnFocusOnDeactivate') continue;
        tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
      }

      var focusTrapElementDOMNode = ReactDOM.findDOMNode(this.focusTrapElement);

      this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNode, tailoredFocusTrapOptions);
      if (this.props.active) {
        this.focusTrap.activate();
      }
      if (this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.active && !this.props.active) {
        var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;

        var returnFocus = returnFocusOnDeactivate || false;
        var config = { returnFocus: returnFocus };
        this.focusTrap.deactivate(config);
      } else if (!prevProps.active && this.props.active) {
        this.focusTrap.activate();
      }

      if (prevProps.paused && !this.props.paused) {
        this.focusTrap.unpause();
      } else if (!prevProps.paused && this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.focusTrap.deactivate();
      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var child = React.Children.only(this.props.children);

      var composedRefCallback = function composedRefCallback(element) {
        _this2.setFocusTrapElement(element);
        if (typeof child.ref === 'function') {
          child.ref(element);
        }
      };

      var childWithRef = React.cloneElement(child, { ref: composedRefCallback });

      return childWithRef;
    }
  }]);

  return FocusTrap;
}(React.Component);

FocusTrap.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};

module.exports = FocusTrap;

/***/ }),

/***/ "M8l6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),

/***/ "MC1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("d+s/");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);

/***/ }),

/***/ "MEjA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (graphicsData, webGLData, webGLDataNativeLines) {
    if (graphicsData.nativeLines) {
        buildNativeLine(graphicsData, webGLDataNativeLines);
    } else {
        buildLine(graphicsData, webGLData);
    }
};

var _math = __webpack_require__("e3iB");

var _utils = __webpack_require__("dDI1");

/**
 * Builds a line to draw using the poligon method.
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 */
function buildLine(graphicsData, webGLData) {
    // TODO OPTIMISE!
    var points = graphicsData.points;

    if (points.length === 0) {
        return;
    }
    // if the line width is an odd number add 0.5 to align to a whole pixel
    // commenting this out fixes #711 and #1620
    // if (graphicsData.lineWidth%2)
    // {
    //     for (i = 0; i < points.length; i++)
    //     {
    //         points[i] += 0.5;
    //     }
    // }

    // get first and last point.. figure out the middle!
    var firstPoint = new _math.Point(points[0], points[1]);
    var lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);

    // if the first point is the last point - gonna have issues :)
    if (firstPoint.x === lastPoint.x && firstPoint.y === lastPoint.y) {
        // need to clone as we are going to slightly modify the shape..
        points = points.slice();

        points.pop();
        points.pop();

        lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);

        var midPointX = lastPoint.x + (firstPoint.x - lastPoint.x) * 0.5;
        var midPointY = lastPoint.y + (firstPoint.y - lastPoint.y) * 0.5;

        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }

    var verts = webGLData.points;
    var indices = webGLData.indices;
    var length = points.length / 2;
    var indexCount = points.length;
    var indexStart = verts.length / 6;

    // DRAW the Line
    var width = graphicsData.lineWidth / 2;

    // sort color
    var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
    var alpha = graphicsData.lineAlpha;
    var r = color[0] * alpha;
    var g = color[1] * alpha;
    var b = color[2] * alpha;

    var p1x = points[0];
    var p1y = points[1];
    var p2x = points[2];
    var p2y = points[3];
    var p3x = 0;
    var p3y = 0;

    var perpx = -(p1y - p2y);
    var perpy = p1x - p2x;
    var perp2x = 0;
    var perp2y = 0;
    var perp3x = 0;
    var perp3y = 0;

    var dist = Math.sqrt(perpx * perpx + perpy * perpy);

    perpx /= dist;
    perpy /= dist;
    perpx *= width;
    perpy *= width;

    var ratio = graphicsData.lineAlignment; // 0.5;
    var r1 = (1 - ratio) * 2;
    var r2 = ratio * 2;

    // start
    verts.push(p1x - perpx * r1, p1y - perpy * r1, r, g, b, alpha);

    verts.push(p1x + perpx * r2, p1y + perpy * r2, r, g, b, alpha);

    for (var i = 1; i < length - 1; ++i) {
        p1x = points[(i - 1) * 2];
        p1y = points[(i - 1) * 2 + 1];

        p2x = points[i * 2];
        p2y = points[i * 2 + 1];

        p3x = points[(i + 1) * 2];
        p3y = points[(i + 1) * 2 + 1];

        perpx = -(p1y - p2y);
        perpy = p1x - p2x;

        dist = Math.sqrt(perpx * perpx + perpy * perpy);
        perpx /= dist;
        perpy /= dist;
        perpx *= width;
        perpy *= width;

        perp2x = -(p2y - p3y);
        perp2y = p2x - p3x;

        dist = Math.sqrt(perp2x * perp2x + perp2y * perp2y);
        perp2x /= dist;
        perp2y /= dist;
        perp2x *= width;
        perp2y *= width;

        var a1 = -perpy + p1y - (-perpy + p2y);
        var b1 = -perpx + p2x - (-perpx + p1x);
        var c1 = (-perpx + p1x) * (-perpy + p2y) - (-perpx + p2x) * (-perpy + p1y);
        var a2 = -perp2y + p3y - (-perp2y + p2y);
        var b2 = -perp2x + p2x - (-perp2x + p3x);
        var c2 = (-perp2x + p3x) * (-perp2y + p2y) - (-perp2x + p2x) * (-perp2y + p3y);

        var denom = a1 * b2 - a2 * b1;

        if (Math.abs(denom) < 0.1) {
            denom += 10.1;
            verts.push(p2x - perpx * r1, p2y - perpy * r1, r, g, b, alpha);

            verts.push(p2x + perpx * r2, p2y + perpy * r2, r, g, b, alpha);

            continue;
        }

        var px = (b1 * c2 - b2 * c1) / denom;
        var py = (a2 * c1 - a1 * c2) / denom;
        var pdist = (px - p2x) * (px - p2x) + (py - p2y) * (py - p2y);

        if (pdist > 196 * width * width) {
            perp3x = perpx - perp2x;
            perp3y = perpy - perp2y;

            dist = Math.sqrt(perp3x * perp3x + perp3y * perp3y);
            perp3x /= dist;
            perp3y /= dist;
            perp3x *= width;
            perp3y *= width;

            verts.push(p2x - perp3x * r1, p2y - perp3y * r1);
            verts.push(r, g, b, alpha);

            verts.push(p2x + perp3x * r2, p2y + perp3y * r2);
            verts.push(r, g, b, alpha);

            verts.push(p2x - perp3x * r2 * r1, p2y - perp3y * r1);
            verts.push(r, g, b, alpha);

            indexCount++;
        } else {
            verts.push(p2x + (px - p2x) * r1, p2y + (py - p2y) * r1);
            verts.push(r, g, b, alpha);

            verts.push(p2x - (px - p2x) * r2, p2y - (py - p2y) * r2);
            verts.push(r, g, b, alpha);
        }
    }

    p1x = points[(length - 2) * 2];
    p1y = points[(length - 2) * 2 + 1];

    p2x = points[(length - 1) * 2];
    p2y = points[(length - 1) * 2 + 1];

    perpx = -(p1y - p2y);
    perpy = p1x - p2x;

    dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist;
    perpy /= dist;
    perpx *= width;
    perpy *= width;

    verts.push(p2x - perpx * r1, p2y - perpy * r1);
    verts.push(r, g, b, alpha);

    verts.push(p2x + perpx * r2, p2y + perpy * r2);
    verts.push(r, g, b, alpha);

    indices.push(indexStart);

    for (var _i = 0; _i < indexCount; ++_i) {
        indices.push(indexStart++);
    }

    indices.push(indexStart - 1);
}

/**
 * Builds a line to draw using the gl.drawArrays(gl.LINES) method
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 */

/**
 * Builds a line to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
 */
function buildNativeLine(graphicsData, webGLData) {
    var i = 0;
    var points = graphicsData.points;

    if (points.length === 0) return;

    var verts = webGLData.points;
    var length = points.length / 2;

    // sort color
    var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
    var alpha = graphicsData.lineAlpha;
    var r = color[0] * alpha;
    var g = color[1] * alpha;
    var b = color[2] * alpha;

    for (i = 1; i < length; i++) {
        var p1x = points[(i - 1) * 2];
        var p1y = points[(i - 1) * 2 + 1];

        var p2x = points[i * 2];
        var p2y = points[i * 2 + 1];

        verts.push(p1x, p1y);
        verts.push(r, g, b, alpha);

        verts.push(p2x, p2y);
        verts.push(r, g, b, alpha);
    }
}
//# sourceMappingURL=buildLine.js.map

/***/ }),

/***/ "MOCJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("Tz/S");

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "MWLY":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// Version 0.7.1 - Copyright 2012 - 2018 -  Jim Riecken <jimr@jimr.ca>
//
// Released under the MIT License - https://github.com/jriecken/sat-js
//
// A simple library for determining intersections of circles and
// polygons using the Separating Axis Theorem.
/** @preserve SAT.js - Version 0.7.1 - Copyright 2012 - 2018 - Jim Riecken <jimr@jimr.ca> - released under the MIT License. https://github.com/jriecken/sat-js */

/*global define: false, module: false*/
/*jshint shadow:true, sub:true, forin:true, noarg:true, noempty:true,
  eqeqeq:true, bitwise:true, strict:true, undef:true,
  curly:true, browser:true */

// Create a UMD wrapper for SAT. Works in:
//
//  - Plain browser via global SAT variable
//  - AMD loader (like require.js)
//  - Node.js
//
// The quoted properties all over the place are used so that the Closure Compiler
// does not mangle the exposed API in advanced mode.
/**
 * @param {*} root - The global scope
 * @param {Function} factory - Factory that creates SAT module
 */
(function (root, factory) {
  "use strict";

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module['exports'] = factory();
  } else {
    root['SAT'] = factory();
  }
})(this, function () {
  "use strict";

  var SAT = {};

  //
  // ## Vector
  //
  // Represents a vector in two dimensions with `x` and `y` properties.


  // Create a new Vector, optionally passing in the `x` and `y` coordinates. If
  // a coordinate is not specified, it will be set to `0`
  /**
   * @param {?number=} x The x position.
   * @param {?number=} y The y position.
   * @constructor
   */
  function Vector(x, y) {
    this['x'] = x || 0;
    this['y'] = y || 0;
  }
  SAT['Vector'] = Vector;
  // Alias `Vector` as `V`
  SAT['V'] = Vector;

  // Copy the values of another Vector into this one.
  /**
   * @param {Vector} other The other Vector.
   * @return {Vector} This for chaining.
   */
  Vector.prototype['copy'] = Vector.prototype.copy = function (other) {
    this['x'] = other['x'];
    this['y'] = other['y'];
    return this;
  };

  // Create a new vector with the same coordinates as this on.
  /**
   * @return {Vector} The new cloned vector
   */
  Vector.prototype['clone'] = Vector.prototype.clone = function () {
    return new Vector(this['x'], this['y']);
  };

  // Change this vector to be perpendicular to what it was before. (Effectively
  // roatates it 90 degrees in a clockwise direction)
  /**
   * @return {Vector} This for chaining.
   */
  Vector.prototype['perp'] = Vector.prototype.perp = function () {
    var x = this['x'];
    this['x'] = this['y'];
    this['y'] = -x;
    return this;
  };

  // Rotate this vector (counter-clockwise) by the specified angle (in radians).
  /**
   * @param {number} angle The angle to rotate (in radians)
   * @return {Vector} This for chaining.
   */
  Vector.prototype['rotate'] = Vector.prototype.rotate = function (angle) {
    var x = this['x'];
    var y = this['y'];
    this['x'] = x * Math.cos(angle) - y * Math.sin(angle);
    this['y'] = x * Math.sin(angle) + y * Math.cos(angle);
    return this;
  };

  // Reverse this vector.
  /**
   * @return {Vector} This for chaining.
   */
  Vector.prototype['reverse'] = Vector.prototype.reverse = function () {
    this['x'] = -this['x'];
    this['y'] = -this['y'];
    return this;
  };

  // Normalize this vector.  (make it have length of `1`)
  /**
   * @return {Vector} This for chaining.
   */
  Vector.prototype['normalize'] = Vector.prototype.normalize = function () {
    var d = this.len();
    if (d > 0) {
      this['x'] = this['x'] / d;
      this['y'] = this['y'] / d;
    }
    return this;
  };

  // Add another vector to this one.
  /**
   * @param {Vector} other The other Vector.
   * @return {Vector} This for chaining.
   */
  Vector.prototype['add'] = Vector.prototype.add = function (other) {
    this['x'] += other['x'];
    this['y'] += other['y'];
    return this;
  };

  // Subtract another vector from this one.
  /**
   * @param {Vector} other The other Vector.
   * @return {Vector} This for chaiing.
   */
  Vector.prototype['sub'] = Vector.prototype.sub = function (other) {
    this['x'] -= other['x'];
    this['y'] -= other['y'];
    return this;
  };

  // Scale this vector. An independant scaling factor can be provided
  // for each axis, or a single scaling factor that will scale both `x` and `y`.
  /**
   * @param {number} x The scaling factor in the x direction.
   * @param {?number=} y The scaling factor in the y direction.  If this
   *   is not specified, the x scaling factor will be used.
   * @return {Vector} This for chaining.
   */
  Vector.prototype['scale'] = Vector.prototype.scale = function (x, y) {
    this['x'] *= x;
    this['y'] *= typeof y != 'undefined' ? y : x;
    return this;
  };

  // Project this vector on to another vector.
  /**
   * @param {Vector} other The vector to project onto.
   * @return {Vector} This for chaining.
   */
  Vector.prototype['project'] = Vector.prototype.project = function (other) {
    var amt = this.dot(other) / other.len2();
    this['x'] = amt * other['x'];
    this['y'] = amt * other['y'];
    return this;
  };

  // Project this vector onto a vector of unit length. This is slightly more efficient
  // than `project` when dealing with unit vectors.
  /**
   * @param {Vector} other The unit vector to project onto.
   * @return {Vector} This for chaining.
   */
  Vector.prototype['projectN'] = Vector.prototype.projectN = function (other) {
    var amt = this.dot(other);
    this['x'] = amt * other['x'];
    this['y'] = amt * other['y'];
    return this;
  };

  // Reflect this vector on an arbitrary axis.
  /**
   * @param {Vector} axis The vector representing the axis.
   * @return {Vector} This for chaining.
   */
  Vector.prototype['reflect'] = Vector.prototype.reflect = function (axis) {
    var x = this['x'];
    var y = this['y'];
    this.project(axis).scale(2);
    this['x'] -= x;
    this['y'] -= y;
    return this;
  };

  // Reflect this vector on an arbitrary axis (represented by a unit vector). This is
  // slightly more efficient than `reflect` when dealing with an axis that is a unit vector.
  /**
   * @param {Vector} axis The unit vector representing the axis.
   * @return {Vector} This for chaining.
   */
  Vector.prototype['reflectN'] = Vector.prototype.reflectN = function (axis) {
    var x = this['x'];
    var y = this['y'];
    this.projectN(axis).scale(2);
    this['x'] -= x;
    this['y'] -= y;
    return this;
  };

  // Get the dot product of this vector and another.
  /**
   * @param {Vector}  other The vector to dot this one against.
   * @return {number} The dot product.
   */
  Vector.prototype['dot'] = Vector.prototype.dot = function (other) {
    return this['x'] * other['x'] + this['y'] * other['y'];
  };

  // Get the squared length of this vector.
  /**
   * @return {number} The length^2 of this vector.
   */
  Vector.prototype['len2'] = Vector.prototype.len2 = function () {
    return this.dot(this);
  };

  // Get the length of this vector.
  /**
   * @return {number} The length of this vector.
   */
  Vector.prototype['len'] = Vector.prototype.len = function () {
    return Math.sqrt(this.len2());
  };

  // ## Circle
  //
  // Represents a circle with a position and a radius.

  // Create a new circle, optionally passing in a position and/or radius. If no position
  // is given, the circle will be at `(0,0)`. If no radius is provided, the circle will
  // have a radius of `0`.
  /**
   * @param {Vector=} pos A vector representing the position of the center of the circle
   * @param {?number=} r The radius of the circle
   * @constructor
   */
  function Circle(pos, r) {
    this['pos'] = pos || new Vector();
    this['r'] = r || 0;
  }
  SAT['Circle'] = Circle;

  // Compute the axis-aligned bounding box (AABB) of this Circle.
  //
  // Note: Returns a _new_ `Polygon` each time you call this.
  /**
   * @return {Polygon} The AABB
   */
  Circle.prototype['getAABB'] = Circle.prototype.getAABB = function () {
    var r = this['r'];
    var corner = this["pos"].clone().sub(new Vector(r, r));
    return new Box(corner, r * 2, r * 2).toPolygon();
  };

  // ## Polygon
  //
  // Represents a *convex* polygon with any number of points (specified in counter-clockwise order)
  //
  // Note: Do _not_ manually change the `points`, `angle`, or `offset` properties. Use the
  // provided setters. Otherwise the calculated properties will not be updated correctly.
  //
  // `pos` can be changed directly.

  // Create a new polygon, passing in a position vector, and an array of points (represented
  // by vectors relative to the position vector). If no position is passed in, the position
  // of the polygon will be `(0,0)`.
  /**
   * @param {Vector=} pos A vector representing the origin of the polygon. (all other
   *   points are relative to this one)
   * @param {Array.<Vector>=} points An array of vectors representing the points in the polygon,
   *   in counter-clockwise order.
   * @constructor
   */
  function Polygon(pos, points) {
    this['pos'] = pos || new Vector();
    this['angle'] = 0;
    this['offset'] = new Vector();
    this.setPoints(points || []);
  }
  SAT['Polygon'] = Polygon;

  // Set the points of the polygon.
  //
  // Note: The points are counter-clockwise *with respect to the coordinate system*.
  // If you directly draw the points on a screen that has the origin at the top-left corner
  // it will _appear_ visually that the points are being specified clockwise. This is just
  // because of the inversion of the Y-axis when being displayed.
  /**
   * @param {Array.<Vector>=} points An array of vectors representing the points in the polygon,
   *   in counter-clockwise order.
   * @return {Polygon} This for chaining.
   */
  Polygon.prototype['setPoints'] = Polygon.prototype.setPoints = function (points) {
    // Only re-allocate if this is a new polygon or the number of points has changed.
    var lengthChanged = !this['points'] || this['points'].length !== points.length;
    if (lengthChanged) {
      var i;
      var calcPoints = this['calcPoints'] = [];
      var edges = this['edges'] = [];
      var normals = this['normals'] = [];
      // Allocate the vector arrays for the calculated properties
      for (i = 0; i < points.length; i++) {
        calcPoints.push(new Vector());
        edges.push(new Vector());
        normals.push(new Vector());
      }
    }
    this['points'] = points;
    this._recalc();
    return this;
  };

  // Set the current rotation angle of the polygon.
  /**
   * @param {number} angle The current rotation angle (in radians).
   * @return {Polygon} This for chaining.
   */
  Polygon.prototype['setAngle'] = Polygon.prototype.setAngle = function (angle) {
    this['angle'] = angle;
    this._recalc();
    return this;
  };

  // Set the current offset to apply to the `points` before applying the `angle` rotation.
  /**
   * @param {Vector} offset The new offset vector.
   * @return {Polygon} This for chaining.
   */
  Polygon.prototype['setOffset'] = Polygon.prototype.setOffset = function (offset) {
    this['offset'] = offset;
    this._recalc();
    return this;
  };

  // Rotates this polygon counter-clockwise around the origin of *its local coordinate system* (i.e. `pos`).
  //
  // Note: This changes the **original** points (so any `angle` will be applied on top of this rotation).
  /**
   * @param {number} angle The angle to rotate (in radians)
   * @return {Polygon} This for chaining.
   */
  Polygon.prototype['rotate'] = Polygon.prototype.rotate = function (angle) {
    var points = this['points'];
    var len = points.length;
    for (var i = 0; i < len; i++) {
      points[i].rotate(angle);
    }
    this._recalc();
    return this;
  };

  // Translates the points of this polygon by a specified amount relative to the origin of *its own coordinate
  // system* (i.e. `pos`).
  //
  // This is most useful to change the "center point" of a polygon. If you just want to move the whole polygon, change
  // the coordinates of `pos`.
  //
  // Note: This changes the **original** points (so any `offset` will be applied on top of this translation)
  /**
   * @param {number} x The horizontal amount to translate.
   * @param {number} y The vertical amount to translate.
   * @return {Polygon} This for chaining.
   */
  Polygon.prototype['translate'] = Polygon.prototype.translate = function (x, y) {
    var points = this['points'];
    var len = points.length;
    for (var i = 0; i < len; i++) {
      points[i]["x"] += x;
      points[i]["y"] += y;
    }
    this._recalc();
    return this;
  };

  // Computes the calculated collision polygon. Applies the `angle` and `offset` to the original points then recalculates the
  // edges and normals of the collision polygon.
  /**
   * @return {Polygon} This for chaining.
   */
  Polygon.prototype._recalc = function () {
    // Calculated points - this is what is used for underlying collisions and takes into account
    // the angle/offset set on the polygon.
    var calcPoints = this['calcPoints'];
    // The edges here are the direction of the `n`th edge of the polygon, relative to
    // the `n`th point. If you want to draw a given edge from the edge value, you must
    // first translate to the position of the starting point.
    var edges = this['edges'];
    // The normals here are the direction of the normal for the `n`th edge of the polygon, relative
    // to the position of the `n`th point. If you want to draw an edge normal, you must first
    // translate to the position of the starting point.
    var normals = this['normals'];
    // Copy the original points array and apply the offset/angle
    var points = this['points'];
    var offset = this['offset'];
    var angle = this['angle'];
    var len = points.length;
    var i;
    for (i = 0; i < len; i++) {
      var calcPoint = calcPoints[i].copy(points[i]);
      calcPoint["x"] += offset["x"];
      calcPoint["y"] += offset["y"];
      if (angle !== 0) {
        calcPoint.rotate(angle);
      }
    }
    // Calculate the edges/normals
    for (i = 0; i < len; i++) {
      var p1 = calcPoints[i];
      var p2 = i < len - 1 ? calcPoints[i + 1] : calcPoints[0];
      var e = edges[i].copy(p2).sub(p1);
      normals[i].copy(e).perp().normalize();
    }
    return this;
  };

  // Compute the axis-aligned bounding box. Any current state
  // (translations/rotations) will be applied before constructing the AABB.
  //
  // Note: Returns a _new_ `Polygon` each time you call this.
  /**
   * @return {Polygon} The AABB
   */
  Polygon.prototype["getAABB"] = Polygon.prototype.getAABB = function () {
    var points = this["calcPoints"];
    var len = points.length;
    var xMin = points[0]["x"];
    var yMin = points[0]["y"];
    var xMax = points[0]["x"];
    var yMax = points[0]["y"];
    for (var i = 1; i < len; i++) {
      var point = points[i];
      if (point["x"] < xMin) {
        xMin = point["x"];
      } else if (point["x"] > xMax) {
        xMax = point["x"];
      }
      if (point["y"] < yMin) {
        yMin = point["y"];
      } else if (point["y"] > yMax) {
        yMax = point["y"];
      }
    }
    return new Box(this["pos"].clone().add(new Vector(xMin, yMin)), xMax - xMin, yMax - yMin).toPolygon();
  };

  // Compute the centroid (geometric center) of the polygon. Any current state
  // (translations/rotations) will be applied before computing the centroid.
  //
  // See https://en.wikipedia.org/wiki/Centroid#Centroid_of_a_polygon
  //
  // Note: Returns a _new_ `Vector` each time you call this.
  /**
   * @return {Vector} A Vector that contains the coordinates of the Centroid.
   */
  Polygon.prototype["getCentroid"] = Polygon.prototype.getCentroid = function () {
    var points = this["calcPoints"];
    var len = points.length;
    var cx = 0;
    var cy = 0;
    var ar = 0;
    for (var i = 0; i < len; i++) {
      var p1 = points[i];
      var p2 = i === len - 1 ? points[0] : points[i + 1]; // Loop around if last point
      var a = p1["x"] * p2["y"] - p2["x"] * p1["y"];
      cx += (p1["x"] + p2["x"]) * a;
      cy += (p1["y"] + p2["y"]) * a;
      ar += a;
    }
    ar = ar * 3; // we want 1 / 6 the area and we currently have 2*area
    cx = cx / ar;
    cy = cy / ar;
    return new Vector(cx, cy);
  };

  // ## Box
  //
  // Represents an axis-aligned box, with a width and height.


  // Create a new box, with the specified position, width, and height. If no position
  // is given, the position will be `(0,0)`. If no width or height are given, they will
  // be set to `0`.
  /**
   * @param {Vector=} pos A vector representing the bottom-left of the box (i.e. the smallest x and smallest y value).
   * @param {?number=} w The width of the box.
   * @param {?number=} h The height of the box.
   * @constructor
   */
  function Box(pos, w, h) {
    this['pos'] = pos || new Vector();
    this['w'] = w || 0;
    this['h'] = h || 0;
  }
  SAT['Box'] = Box;

  // Returns a polygon whose edges are the same as this box.
  /**
   * @return {Polygon} A new Polygon that represents this box.
   */
  Box.prototype['toPolygon'] = Box.prototype.toPolygon = function () {
    var pos = this['pos'];
    var w = this['w'];
    var h = this['h'];
    return new Polygon(new Vector(pos['x'], pos['y']), [new Vector(), new Vector(w, 0), new Vector(w, h), new Vector(0, h)]);
  };

  // ## Response
  //
  // An object representing the result of an intersection. Contains:
  //  - The two objects participating in the intersection
  //  - The vector representing the minimum change necessary to extract the first object
  //    from the second one (as well as a unit vector in that direction and the magnitude
  //    of the overlap)
  //  - Whether the first object is entirely inside the second, and vice versa.
  /**
   * @constructor
   */
  function Response() {
    this['a'] = null;
    this['b'] = null;
    this['overlapN'] = new Vector();
    this['overlapV'] = new Vector();
    this.clear();
  }
  SAT['Response'] = Response;

  // Set some values of the response back to their defaults.  Call this between tests if
  // you are going to reuse a single Response object for multiple intersection tests (recommented
  // as it will avoid allcating extra memory)
  /**
   * @return {Response} This for chaining
   */
  Response.prototype['clear'] = Response.prototype.clear = function () {
    this['aInB'] = true;
    this['bInA'] = true;
    this['overlap'] = Number.MAX_VALUE;
    return this;
  };

  // ## Object Pools

  // A pool of `Vector` objects that are used in calculations to avoid
  // allocating memory.
  /**
   * @type {Array.<Vector>}
   */
  var T_VECTORS = [];
  for (var i = 0; i < 10; i++) {
    T_VECTORS.push(new Vector());
  }

  // A pool of arrays of numbers used in calculations to avoid allocating
  // memory.
  /**
   * @type {Array.<Array.<number>>}
   */
  var T_ARRAYS = [];
  for (var i = 0; i < 5; i++) {
    T_ARRAYS.push([]);
  }

  // Temporary response used for polygon hit detection.
  /**
   * @type {Response}
   */
  var T_RESPONSE = new Response();

  // Tiny "point" polygon used for polygon hit detection.
  /**
   * @type {Polygon}
   */
  var TEST_POINT = new Box(new Vector(), 0.000001, 0.000001).toPolygon();

  // ## Helper Functions

  // Flattens the specified array of points onto a unit vector axis,
  // resulting in a one dimensional range of the minimum and
  // maximum value on that axis.
  /**
   * @param {Array.<Vector>} points The points to flatten.
   * @param {Vector} normal The unit vector axis to flatten on.
   * @param {Array.<number>} result An array.  After calling this function,
   *   result[0] will be the minimum value,
   *   result[1] will be the maximum value.
   */
  function flattenPointsOn(points, normal, result) {
    var min = Number.MAX_VALUE;
    var max = -Number.MAX_VALUE;
    var len = points.length;
    for (var i = 0; i < len; i++) {
      // The magnitude of the projection of the point onto the normal
      var dot = points[i].dot(normal);
      if (dot < min) {
        min = dot;
      }
      if (dot > max) {
        max = dot;
      }
    }
    result[0] = min;result[1] = max;
  }

  // Check whether two convex polygons are separated by the specified
  // axis (must be a unit vector).
  /**
   * @param {Vector} aPos The position of the first polygon.
   * @param {Vector} bPos The position of the second polygon.
   * @param {Array.<Vector>} aPoints The points in the first polygon.
   * @param {Array.<Vector>} bPoints The points in the second polygon.
   * @param {Vector} axis The axis (unit sized) to test against.  The points of both polygons
   *   will be projected onto this axis.
   * @param {Response=} response A Response object (optional) which will be populated
   *   if the axis is not a separating axis.
   * @return {boolean} true if it is a separating axis, false otherwise.  If false,
   *   and a response is passed in, information about how much overlap and
   *   the direction of the overlap will be populated.
   */
  function isSeparatingAxis(aPos, bPos, aPoints, bPoints, axis, response) {
    var rangeA = T_ARRAYS.pop();
    var rangeB = T_ARRAYS.pop();
    // The magnitude of the offset between the two polygons
    var offsetV = T_VECTORS.pop().copy(bPos).sub(aPos);
    var projectedOffset = offsetV.dot(axis);
    // Project the polygons onto the axis.
    flattenPointsOn(aPoints, axis, rangeA);
    flattenPointsOn(bPoints, axis, rangeB);
    // Move B's range to its position relative to A.
    rangeB[0] += projectedOffset;
    rangeB[1] += projectedOffset;
    // Check if there is a gap. If there is, this is a separating axis and we can stop
    if (rangeA[0] > rangeB[1] || rangeB[0] > rangeA[1]) {
      T_VECTORS.push(offsetV);
      T_ARRAYS.push(rangeA);
      T_ARRAYS.push(rangeB);
      return true;
    }
    // This is not a separating axis. If we're calculating a response, calculate the overlap.
    if (response) {
      var overlap = 0;
      // A starts further left than B
      if (rangeA[0] < rangeB[0]) {
        response['aInB'] = false;
        // A ends before B does. We have to pull A out of B
        if (rangeA[1] < rangeB[1]) {
          overlap = rangeA[1] - rangeB[0];
          response['bInA'] = false;
          // B is fully inside A.  Pick the shortest way out.
        } else {
          var option1 = rangeA[1] - rangeB[0];
          var option2 = rangeB[1] - rangeA[0];
          overlap = option1 < option2 ? option1 : -option2;
        }
        // B starts further left than A
      } else {
        response['bInA'] = false;
        // B ends before A ends. We have to push A out of B
        if (rangeA[1] > rangeB[1]) {
          overlap = rangeA[0] - rangeB[1];
          response['aInB'] = false;
          // A is fully inside B.  Pick the shortest way out.
        } else {
          var option1 = rangeA[1] - rangeB[0];
          var option2 = rangeB[1] - rangeA[0];
          overlap = option1 < option2 ? option1 : -option2;
        }
      }
      // If this is the smallest amount of overlap we've seen so far, set it as the minimum overlap.
      var absOverlap = Math.abs(overlap);
      if (absOverlap < response['overlap']) {
        response['overlap'] = absOverlap;
        response['overlapN'].copy(axis);
        if (overlap < 0) {
          response['overlapN'].reverse();
        }
      }
    }
    T_VECTORS.push(offsetV);
    T_ARRAYS.push(rangeA);
    T_ARRAYS.push(rangeB);
    return false;
  }
  SAT['isSeparatingAxis'] = isSeparatingAxis;

  // Calculates which Voronoi region a point is on a line segment.
  // It is assumed that both the line and the point are relative to `(0,0)`
  //
  //            |       (0)      |
  //     (-1)  [S]--------------[E]  (1)
  //            |       (0)      |
  /**
   * @param {Vector} line The line segment.
   * @param {Vector} point The point.
   * @return  {number} LEFT_VORONOI_REGION (-1) if it is the left region,
   *          MIDDLE_VORONOI_REGION (0) if it is the middle region,
   *          RIGHT_VORONOI_REGION (1) if it is the right region.
   */
  function voronoiRegion(line, point) {
    var len2 = line.len2();
    var dp = point.dot(line);
    // If the point is beyond the start of the line, it is in the
    // left voronoi region.
    if (dp < 0) {
      return LEFT_VORONOI_REGION;
    }
    // If the point is beyond the end of the line, it is in the
    // right voronoi region.
    else if (dp > len2) {
        return RIGHT_VORONOI_REGION;
      }
      // Otherwise, it's in the middle one.
      else {
          return MIDDLE_VORONOI_REGION;
        }
  }
  // Constants for Voronoi regions
  /**
   * @const
   */
  var LEFT_VORONOI_REGION = -1;
  /**
   * @const
   */
  var MIDDLE_VORONOI_REGION = 0;
  /**
   * @const
   */
  var RIGHT_VORONOI_REGION = 1;

  // ## Collision Tests

  // Check if a point is inside a circle.
  /**
   * @param {Vector} p The point to test.
   * @param {Circle} c The circle to test.
   * @return {boolean} true if the point is inside the circle, false if it is not.
   */
  function pointInCircle(p, c) {
    var differenceV = T_VECTORS.pop().copy(p).sub(c['pos']);
    var radiusSq = c['r'] * c['r'];
    var distanceSq = differenceV.len2();
    T_VECTORS.push(differenceV);
    // If the distance between is smaller than the radius then the point is inside the circle.
    return distanceSq <= radiusSq;
  }
  SAT['pointInCircle'] = pointInCircle;

  // Check if a point is inside a convex polygon.
  /**
   * @param {Vector} p The point to test.
   * @param {Polygon} poly The polygon to test.
   * @return {boolean} true if the point is inside the polygon, false if it is not.
   */
  function pointInPolygon(p, poly) {
    TEST_POINT['pos'].copy(p);
    T_RESPONSE.clear();
    var result = testPolygonPolygon(TEST_POINT, poly, T_RESPONSE);
    if (result) {
      result = T_RESPONSE['aInB'];
    }
    return result;
  }
  SAT['pointInPolygon'] = pointInPolygon;

  // Check if two circles collide.
  /**
   * @param {Circle} a The first circle.
   * @param {Circle} b The second circle.
   * @param {Response=} response Response object (optional) that will be populated if
   *   the circles intersect.
   * @return {boolean} true if the circles intersect, false if they don't.
   */
  function testCircleCircle(a, b, response) {
    // Check if the distance between the centers of the two
    // circles is greater than their combined radius.
    var differenceV = T_VECTORS.pop().copy(b['pos']).sub(a['pos']);
    var totalRadius = a['r'] + b['r'];
    var totalRadiusSq = totalRadius * totalRadius;
    var distanceSq = differenceV.len2();
    // If the distance is bigger than the combined radius, they don't intersect.
    if (distanceSq > totalRadiusSq) {
      T_VECTORS.push(differenceV);
      return false;
    }
    // They intersect.  If we're calculating a response, calculate the overlap.
    if (response) {
      var dist = Math.sqrt(distanceSq);
      response['a'] = a;
      response['b'] = b;
      response['overlap'] = totalRadius - dist;
      response['overlapN'].copy(differenceV.normalize());
      response['overlapV'].copy(differenceV).scale(response['overlap']);
      response['aInB'] = a['r'] <= b['r'] && dist <= b['r'] - a['r'];
      response['bInA'] = b['r'] <= a['r'] && dist <= a['r'] - b['r'];
    }
    T_VECTORS.push(differenceV);
    return true;
  }
  SAT['testCircleCircle'] = testCircleCircle;

  // Check if a polygon and a circle collide.
  /**
   * @param {Polygon} polygon The polygon.
   * @param {Circle} circle The circle.
   * @param {Response=} response Response object (optional) that will be populated if
   *   they interset.
   * @return {boolean} true if they intersect, false if they don't.
   */
  function testPolygonCircle(polygon, circle, response) {
    // Get the position of the circle relative to the polygon.
    var circlePos = T_VECTORS.pop().copy(circle['pos']).sub(polygon['pos']);
    var radius = circle['r'];
    var radius2 = radius * radius;
    var points = polygon['calcPoints'];
    var len = points.length;
    var edge = T_VECTORS.pop();
    var point = T_VECTORS.pop();

    // For each edge in the polygon:
    for (var i = 0; i < len; i++) {
      var next = i === len - 1 ? 0 : i + 1;
      var prev = i === 0 ? len - 1 : i - 1;
      var overlap = 0;
      var overlapN = null;

      // Get the edge.
      edge.copy(polygon['edges'][i]);
      // Calculate the center of the circle relative to the starting point of the edge.
      point.copy(circlePos).sub(points[i]);

      // If the distance between the center of the circle and the point
      // is bigger than the radius, the polygon is definitely not fully in
      // the circle.
      if (response && point.len2() > radius2) {
        response['aInB'] = false;
      }

      // Calculate which Voronoi region the center of the circle is in.
      var region = voronoiRegion(edge, point);
      // If it's the left region:
      if (region === LEFT_VORONOI_REGION) {
        // We need to make sure we're in the RIGHT_VORONOI_REGION of the previous edge.
        edge.copy(polygon['edges'][prev]);
        // Calculate the center of the circle relative the starting point of the previous edge
        var point2 = T_VECTORS.pop().copy(circlePos).sub(points[prev]);
        region = voronoiRegion(edge, point2);
        if (region === RIGHT_VORONOI_REGION) {
          // It's in the region we want.  Check if the circle intersects the point.
          var dist = point.len();
          if (dist > radius) {
            // No intersection
            T_VECTORS.push(circlePos);
            T_VECTORS.push(edge);
            T_VECTORS.push(point);
            T_VECTORS.push(point2);
            return false;
          } else if (response) {
            // It intersects, calculate the overlap.
            response['bInA'] = false;
            overlapN = point.normalize();
            overlap = radius - dist;
          }
        }
        T_VECTORS.push(point2);
        // If it's the right region:
      } else if (region === RIGHT_VORONOI_REGION) {
        // We need to make sure we're in the left region on the next edge
        edge.copy(polygon['edges'][next]);
        // Calculate the center of the circle relative to the starting point of the next edge.
        point.copy(circlePos).sub(points[next]);
        region = voronoiRegion(edge, point);
        if (region === LEFT_VORONOI_REGION) {
          // It's in the region we want.  Check if the circle intersects the point.
          var dist = point.len();
          if (dist > radius) {
            // No intersection
            T_VECTORS.push(circlePos);
            T_VECTORS.push(edge);
            T_VECTORS.push(point);
            return false;
          } else if (response) {
            // It intersects, calculate the overlap.
            response['bInA'] = false;
            overlapN = point.normalize();
            overlap = radius - dist;
          }
        }
        // Otherwise, it's the middle region:
      } else {
        // Need to check if the circle is intersecting the edge,
        // Change the edge into its "edge normal".
        var normal = edge.perp().normalize();
        // Find the perpendicular distance between the center of the
        // circle and the edge.
        var dist = point.dot(normal);
        var distAbs = Math.abs(dist);
        // If the circle is on the outside of the edge, there is no intersection.
        if (dist > 0 && distAbs > radius) {
          // No intersection
          T_VECTORS.push(circlePos);
          T_VECTORS.push(normal);
          T_VECTORS.push(point);
          return false;
        } else if (response) {
          // It intersects, calculate the overlap.
          overlapN = normal;
          overlap = radius - dist;
          // If the center of the circle is on the outside of the edge, or part of the
          // circle is on the outside, the circle is not fully inside the polygon.
          if (dist >= 0 || overlap < 2 * radius) {
            response['bInA'] = false;
          }
        }
      }

      // If this is the smallest overlap we've seen, keep it.
      // (overlapN may be null if the circle was in the wrong Voronoi region).
      if (overlapN && response && Math.abs(overlap) < Math.abs(response['overlap'])) {
        response['overlap'] = overlap;
        response['overlapN'].copy(overlapN);
      }
    }

    // Calculate the final overlap vector - based on the smallest overlap.
    if (response) {
      response['a'] = polygon;
      response['b'] = circle;
      response['overlapV'].copy(response['overlapN']).scale(response['overlap']);
    }
    T_VECTORS.push(circlePos);
    T_VECTORS.push(edge);
    T_VECTORS.push(point);
    return true;
  }
  SAT['testPolygonCircle'] = testPolygonCircle;

  // Check if a circle and a polygon collide.
  //
  // **NOTE:** This is slightly less efficient than polygonCircle as it just
  // runs polygonCircle and reverses everything at the end.
  /**
   * @param {Circle} circle The circle.
   * @param {Polygon} polygon The polygon.
   * @param {Response=} response Response object (optional) that will be populated if
   *   they interset.
   * @return {boolean} true if they intersect, false if they don't.
   */
  function testCirclePolygon(circle, polygon, response) {
    // Test the polygon against the circle.
    var result = testPolygonCircle(polygon, circle, response);
    if (result && response) {
      // Swap A and B in the response.
      var a = response['a'];
      var aInB = response['aInB'];
      response['overlapN'].reverse();
      response['overlapV'].reverse();
      response['a'] = response['b'];
      response['b'] = a;
      response['aInB'] = response['bInA'];
      response['bInA'] = aInB;
    }
    return result;
  }
  SAT['testCirclePolygon'] = testCirclePolygon;

  // Checks whether polygons collide.
  /**
   * @param {Polygon} a The first polygon.
   * @param {Polygon} b The second polygon.
   * @param {Response=} response Response object (optional) that will be populated if
   *   they interset.
   * @return {boolean} true if they intersect, false if they don't.
   */
  function testPolygonPolygon(a, b, response) {
    var aPoints = a['calcPoints'];
    var aLen = aPoints.length;
    var bPoints = b['calcPoints'];
    var bLen = bPoints.length;
    // If any of the edge normals of A is a separating axis, no intersection.
    for (var i = 0; i < aLen; i++) {
      if (isSeparatingAxis(a['pos'], b['pos'], aPoints, bPoints, a['normals'][i], response)) {
        return false;
      }
    }
    // If any of the edge normals of B is a separating axis, no intersection.
    for (var i = 0; i < bLen; i++) {
      if (isSeparatingAxis(a['pos'], b['pos'], aPoints, bPoints, b['normals'][i], response)) {
        return false;
      }
    }
    // Since none of the edge normals of A or B are a separating axis, there is an intersection
    // and we've already calculated the smallest overlap (in isSeparatingAxis).  Calculate the
    // final overlap vector.
    if (response) {
      response['a'] = a;
      response['b'] = b;
      response['overlapV'].copy(response['overlapN']).scale(response['overlap']);
    }
    return true;
  }
  SAT['testPolygonPolygon'] = testPolygonPolygon;

  return SAT;
});

/***/ }),

/***/ "MZQ5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3680fc60947d080a62c76a55cafc43b9.svg";

/***/ }),

/***/ "MZrl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Rows_1 = __webpack_require__("Pu1Z");
var Seat_1 = __webpack_require__("S77k");

var Rows = function (_Rows_1$default) {
    _inherits(Rows, _Rows_1$default);

    function Rows() {
        _classCallCheck(this, Rows);

        return _possibleConstructorReturn(this, _Rows_1$default.apply(this, arguments));
    }

    Rows.prototype.draw = function draw() {
        this.setScales(this.seatData);
        this.tableInit(this.pos);
        this.seats = this.seatsInit(this.seatData, this.actions);
        this.seatContainer = this.getSeatContainer(this.pos);
        this.tableContainerInit(this.pos);
        this.renderRowLabels();
    };

    Rows.prototype.seatsInit = function seatsInit(seats, disableInteraction) {
        var _this2 = this;

        var seatCount = seats.length;
        return seats.map(function (seat, i) {
            var constructionValue = _extends({ pos: _this2.getSeatPos(i, seatCount), seatlabelStartAt: _this2.seatlabelStartAt, bookByTable: _this2.bookByTable, tableId: _this2._id, sectionId: _this2.sectionId, sectionName: _this2.sectionName, tableName: _this2.name }, seat);
            return new Seat_1.default(constructionValue, _this2.actions, disableInteraction);
        });
    };

    return Rows;
}(Rows_1.default);

exports.default = Rows;
//# sourceMappingURL=Rows.js.map

/***/ }),

/***/ "Mag4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Mixins functionality to make an object have "plugins".
 *
 * @example
 *      function MyObject() {}
 *
 *      pluginTarget.mixin(MyObject);
 *
 * @mixin
 * @memberof PIXI.utils
 * @param {object} obj - The object to mix into.
 */
function pluginTarget(obj) {
    obj.__plugins = {};

    /**
     * Adds a plugin to an object
     *
     * @param {string} pluginName - The events that should be listed.
     * @param {Function} ctor - The constructor function for the plugin.
     */
    obj.registerPlugin = function registerPlugin(pluginName, ctor) {
        obj.__plugins[pluginName] = ctor;
    };

    /**
     * Instantiates all the plugins of this object
     *
     */
    obj.prototype.initPlugins = function initPlugins() {
        this.plugins = this.plugins || {};

        for (var o in obj.__plugins) {
            this.plugins[o] = new obj.__plugins[o](this);
        }
    };

    /**
     * Removes all the plugins of this object
     *
     */
    obj.prototype.destroyPlugins = function destroyPlugins() {
        for (var o in this.plugins) {
            this.plugins[o].destroy();
            this.plugins[o] = null;
        }

        this.plugins = null;
    };
}

exports.default = {
    /**
     * Mixes in the properties of the pluginTarget into another object
     *
     * @param {object} obj - The obj to mix into
     */
    mixin: function mixin(obj) {
        pluginTarget(obj);
    }
};
//# sourceMappingURL=pluginTarget.js.map

/***/ }),

/***/ "Me0q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _math = __webpack_require__("e3iB");

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * 'Builder' pattern for bounds rectangles
 * Axis-Aligned Bounding Box
 * It is not a shape! Its mutable thing, no 'EMPTY' or that kind of problems
 *
 * @class
 * @memberof PIXI
 */
var Bounds = function () {
    /**
     *
     */
    function Bounds() {
        _classCallCheck(this, Bounds);

        /**
         * @member {number}
         * @default 0
         */
        this.minX = Infinity;

        /**
         * @member {number}
         * @default 0
         */
        this.minY = Infinity;

        /**
         * @member {number}
         * @default 0
         */
        this.maxX = -Infinity;

        /**
         * @member {number}
         * @default 0
         */
        this.maxY = -Infinity;

        this.rect = null;
    }

    /**
     * Checks if bounds are empty.
     *
     * @return {boolean} True if empty.
     */

    Bounds.prototype.isEmpty = function isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    };

    /**
     * Clears the bounds and resets.
     *
     */

    Bounds.prototype.clear = function clear() {
        this.updateID++;

        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
    };

    /**
     * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
     * It is not guaranteed that it will return tempRect
     *
     * @param {PIXI.Rectangle} rect - temporary object will be used if AABB is not empty
     * @returns {PIXI.Rectangle} A rectangle of the bounds
     */

    Bounds.prototype.getRectangle = function getRectangle(rect) {
        if (this.minX > this.maxX || this.minY > this.maxY) {
            return _math.Rectangle.EMPTY;
        }

        rect = rect || new _math.Rectangle(0, 0, 1, 1);

        rect.x = this.minX;
        rect.y = this.minY;
        rect.width = this.maxX - this.minX;
        rect.height = this.maxY - this.minY;

        return rect;
    };

    /**
     * This function should be inlined when its possible.
     *
     * @param {PIXI.Point} point - The point to add.
     */

    Bounds.prototype.addPoint = function addPoint(point) {
        this.minX = Math.min(this.minX, point.x);
        this.maxX = Math.max(this.maxX, point.x);
        this.minY = Math.min(this.minY, point.y);
        this.maxY = Math.max(this.maxY, point.y);
    };

    /**
     * Adds a quad, not transformed
     *
     * @param {Float32Array} vertices - The verts to add.
     */

    Bounds.prototype.addQuad = function addQuad(vertices) {
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;

        var x = vertices[0];
        var y = vertices[1];

        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = vertices[2];
        y = vertices[3];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = vertices[4];
        y = vertices[5];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = vertices[6];
        y = vertices[7];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };

    /**
     * Adds sprite frame, transformed.
     *
     * @param {PIXI.TransformBase} transform - TODO
     * @param {number} x0 - TODO
     * @param {number} y0 - TODO
     * @param {number} x1 - TODO
     * @param {number} y1 - TODO
     */

    Bounds.prototype.addFrame = function addFrame(transform, x0, y0, x1, y1) {
        var matrix = transform.worldTransform;
        var a = matrix.a;
        var b = matrix.b;
        var c = matrix.c;
        var d = matrix.d;
        var tx = matrix.tx;
        var ty = matrix.ty;

        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;

        var x = a * x0 + c * y0 + tx;
        var y = b * x0 + d * y0 + ty;

        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };

    /**
     * Add an array of vertices
     *
     * @param {PIXI.TransformBase} transform - TODO
     * @param {Float32Array} vertices - TODO
     * @param {number} beginOffset - TODO
     * @param {number} endOffset - TODO
     */

    Bounds.prototype.addVertices = function addVertices(transform, vertices, beginOffset, endOffset) {
        var matrix = transform.worldTransform;
        var a = matrix.a;
        var b = matrix.b;
        var c = matrix.c;
        var d = matrix.d;
        var tx = matrix.tx;
        var ty = matrix.ty;

        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;

        for (var i = beginOffset; i < endOffset; i += 2) {
            var rawX = vertices[i];
            var rawY = vertices[i + 1];
            var x = a * rawX + c * rawY + tx;
            var y = d * rawY + b * rawX + ty;

            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }

        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };

    /**
     * Adds other Bounds
     *
     * @param {PIXI.Bounds} bounds - TODO
     */

    Bounds.prototype.addBounds = function addBounds(bounds) {
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;

        this.minX = bounds.minX < minX ? bounds.minX : minX;
        this.minY = bounds.minY < minY ? bounds.minY : minY;
        this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX;
        this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
    };

    /**
     * Adds other Bounds, masked with Bounds
     *
     * @param {PIXI.Bounds} bounds - TODO
     * @param {PIXI.Bounds} mask - TODO
     */

    Bounds.prototype.addBoundsMask = function addBoundsMask(bounds, mask) {
        var _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX;
        var _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY;
        var _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX;
        var _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;

        if (_minX <= _maxX && _minY <= _maxY) {
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;

            this.minX = _minX < minX ? _minX : minX;
            this.minY = _minY < minY ? _minY : minY;
            this.maxX = _maxX > maxX ? _maxX : maxX;
            this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    };

    /**
     * Adds other Bounds, masked with Rectangle
     *
     * @param {PIXI.Bounds} bounds - TODO
     * @param {PIXI.Rectangle} area - TODO
     */

    Bounds.prototype.addBoundsArea = function addBoundsArea(bounds, area) {
        var _minX = bounds.minX > area.x ? bounds.minX : area.x;
        var _minY = bounds.minY > area.y ? bounds.minY : area.y;
        var _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width;
        var _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;

        if (_minX <= _maxX && _minY <= _maxY) {
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;

            this.minX = _minX < minX ? _minX : minX;
            this.minY = _minY < minY ? _minY : minY;
            this.maxX = _maxX > maxX ? _maxX : maxX;
            this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    };

    return Bounds;
}();

exports.default = Bounds;
//# sourceMappingURL=Bounds.js.map

/***/ }),

/***/ "Mej7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__("FIMm");
var util = __webpack_require__("5YsI");

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,


// Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,


// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],


// RFC 2396: characters not allowed for various reasons.
unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),


// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = ['\''].concat(unwise),

// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,

// protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that never have a hostname.
hostlessProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that always contain a // bit.
slashedProtocol = {
  'http': true,
  'https': true,
  'ftp': true,
  'gopher': true,
  'file': true,
  'http:': true,
  'https:': true,
  'ftp:': true,
  'gopher:': true,
  'file:': true
},
    querystring = __webpack_require__("+00f");

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && util.isObject(this.query) && Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || query && '?' + query || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) {}
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
      isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
      mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname,
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || result.host && srcPath.length;

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

/***/ }),

/***/ "MfA+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _resourceLoader = __webpack_require__("6Jqp");

var _resourceLoader2 = _interopRequireDefault(_resourceLoader);

var _blob = __webpack_require__("bkHk");

var _eventemitter = __webpack_require__("wCSE");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _textureParser = __webpack_require__("08UO");

var _textureParser2 = _interopRequireDefault(_textureParser);

var _spritesheetParser = __webpack_require__("ESZJ");

var _spritesheetParser2 = _interopRequireDefault(_spritesheetParser);

var _bitmapFontParser = __webpack_require__("Eh8S");

var _bitmapFontParser2 = _interopRequireDefault(_bitmapFontParser);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 *
 * The new loader, extends Resource Loader by Chad Engler: https://github.com/englercj/resource-loader
 *
 * ```js
 * const loader = PIXI.loader; // PixiJS exposes a premade instance for you to use.
 * //or
 * const loader = new PIXI.loaders.Loader(); // you can also create your own if you want
 *
 * const sprites = {};
 *
 * // Chainable `add` to enqueue a resource
 * loader.add('bunny', 'data/bunny.png')
 *       .add('spaceship', 'assets/spritesheet.json');
 * loader.add('scoreFont', 'assets/score.fnt');
 *
 * // Chainable `pre` to add a middleware that runs for each resource, *before* loading that resource.
 * // This is useful to implement custom caching modules (using filesystem, indexeddb, memory, etc).
 * loader.pre(cachingMiddleware);
 *
 * // Chainable `use` to add a middleware that runs for each resource, *after* loading that resource.
 * // This is useful to implement custom parsing modules (like spritesheet parsers, spine parser, etc).
 * loader.use(parsingMiddleware);
 *
 * // The `load` method loads the queue of resources, and calls the passed in callback called once all
 * // resources have loaded.
 * loader.load((loader, resources) => {
 *     // resources is an object where the key is the name of the resource loaded and the value is the resource object.
 *     // They have a couple default properties:
 *     // - `url`: The URL that the resource was loaded from
 *     // - `error`: The error that happened when trying to load (if any)
 *     // - `data`: The raw data that was loaded
 *     // also may contain other properties based on the middleware that runs.
 *     sprites.bunny = new PIXI.TilingSprite(resources.bunny.texture);
 *     sprites.spaceship = new PIXI.TilingSprite(resources.spaceship.texture);
 *     sprites.scoreFont = new PIXI.TilingSprite(resources.scoreFont.texture);
 * });
 *
 * // throughout the process multiple signals can be dispatched.
 * loader.onProgress.add(() => {}); // called once per loaded/errored file
 * loader.onError.add(() => {}); // called once per errored file
 * loader.onLoad.add(() => {}); // called once per loaded file
 * loader.onComplete.add(() => {}); // called once when the queued resources all load.
 * ```
 *
 * @see https://github.com/englercj/resource-loader
 *
 * @class
 * @extends module:resource-loader.ResourceLoader
 * @memberof PIXI.loaders
 */
var Loader = function (_ResourceLoader) {
    _inherits(Loader, _ResourceLoader);

    /**
     * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
     * @param {number} [concurrency=10] - The number of resources to load concurrently.
     */
    function Loader(baseUrl, concurrency) {
        _classCallCheck(this, Loader);

        var _this = _possibleConstructorReturn(this, _ResourceLoader.call(this, baseUrl, concurrency));

        _eventemitter2.default.call(_this);

        for (var i = 0; i < Loader._pixiMiddleware.length; ++i) {
            _this.use(Loader._pixiMiddleware[i]());
        }

        // Compat layer, translate the new v2 signals into old v1 events.
        _this.onStart.add(function (l) {
            return _this.emit('start', l);
        });
        _this.onProgress.add(function (l, r) {
            return _this.emit('progress', l, r);
        });
        _this.onError.add(function (e, l, r) {
            return _this.emit('error', e, l, r);
        });
        _this.onLoad.add(function (l, r) {
            return _this.emit('load', l, r);
        });
        _this.onComplete.add(function (l, r) {
            return _this.emit('complete', l, r);
        });
        return _this;
    }

    /**
     * Adds a default middleware to the PixiJS loader.
     *
     * @static
     * @param {Function} fn - The middleware to add.
     */

    Loader.addPixiMiddleware = function addPixiMiddleware(fn) {
        Loader._pixiMiddleware.push(fn);
    };

    /**
     * Destroy the loader, removes references.
     */

    Loader.prototype.destroy = function destroy() {
        this.removeAllListeners();
        this.reset();
    };

    return Loader;
}(_resourceLoader2.default);

// Copy EE3 prototype (mixin)


exports.default = Loader;
for (var k in _eventemitter2.default.prototype) {
    Loader.prototype[k] = _eventemitter2.default.prototype[k];
}

Loader._pixiMiddleware = [
// parse any blob into more usable objects (e.g. Image)
_blob.blobMiddlewareFactory,
// parse any Image objects into textures
_textureParser2.default,
// parse any spritesheet data into multiple textures
_spritesheetParser2.default,
// parse bitmap font data into multiple textures
_bitmapFontParser2.default];

// Add custom extentions
var Resource = _resourceLoader2.default.Resource;

Resource.setExtensionXhrType('fnt', Resource.XHR_RESPONSE_TYPE.DOCUMENT);
//# sourceMappingURL=loader.js.map

/***/ }),

/***/ "Mjho":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d8458b6cbd04c7e8fcd08831f8c453c9.svg";

/***/ }),

/***/ "MvwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);
//# sourceMappingURL=memoize.esm.js.map

/***/ }),

/***/ "MxpT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _const = __webpack_require__("YEQi");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Rectangle object is an area defined by its position, as indicated by its top-left corner
 * point (x, y) and by its width and its height.
 *
 * @class
 * @memberof PIXI
 */
var Rectangle = function () {
  /**
   * @param {number} [x=0] - The X coordinate of the upper-left corner of the rectangle
   * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rectangle
   * @param {number} [width=0] - The overall width of this rectangle
   * @param {number} [height=0] - The overall height of this rectangle
   */
  function Rectangle() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck(this, Rectangle);

    /**
     * @member {number}
     * @default 0
     */
    this.x = Number(x);

    /**
     * @member {number}
     * @default 0
     */
    this.y = Number(y);

    /**
     * @member {number}
     * @default 0
     */
    this.width = Number(width);

    /**
     * @member {number}
     * @default 0
     */
    this.height = Number(height);

    /**
     * The type of the object, mainly used to avoid `instanceof` checks
     *
     * @member {number}
     * @readOnly
     * @default PIXI.SHAPES.RECT
     * @see PIXI.SHAPES
     */
    this.type = _const.SHAPES.RECT;
  }

  /**
   * returns the left edge of the rectangle
   *
   * @member {number}
   */

  /**
   * Creates a clone of this Rectangle
   *
   * @return {PIXI.Rectangle} a copy of the rectangle
   */
  Rectangle.prototype.clone = function clone() {
    return new Rectangle(this.x, this.y, this.width, this.height);
  };

  /**
   * Copies another rectangle to this one.
   *
   * @param {PIXI.Rectangle} rectangle - The rectangle to copy.
   * @return {PIXI.Rectangle} Returns itself.
   */

  Rectangle.prototype.copy = function copy(rectangle) {
    this.x = rectangle.x;
    this.y = rectangle.y;
    this.width = rectangle.width;
    this.height = rectangle.height;

    return this;
  };

  /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   *
   * @param {number} x - The X coordinate of the point to test
   * @param {number} y - The Y coordinate of the point to test
   * @return {boolean} Whether the x/y coordinates are within this Rectangle
   */

  Rectangle.prototype.contains = function contains(x, y) {
    if (this.width <= 0 || this.height <= 0) {
      return false;
    }

    if (x >= this.x && x < this.x + this.width) {
      if (y >= this.y && y < this.y + this.height) {
        return true;
      }
    }

    return false;
  };

  /**
   * Pads the rectangle making it grow in all directions.
   *
   * @param {number} paddingX - The horizontal padding amount.
   * @param {number} [paddingY] - The vertical padding amount.
   */

  Rectangle.prototype.pad = function pad(paddingX, paddingY) {
    paddingX = paddingX || 0;
    paddingY = paddingY || (paddingY !== 0 ? paddingX : 0);

    this.x -= paddingX;
    this.y -= paddingY;

    this.width += paddingX * 2;
    this.height += paddingY * 2;
  };

  /**
   * Fits this rectangle around the passed one.
   *
   * @param {PIXI.Rectangle} rectangle - The rectangle to fit.
   */

  Rectangle.prototype.fit = function fit(rectangle) {
    var x1 = Math.max(this.x, rectangle.x);
    var x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
    var y1 = Math.max(this.y, rectangle.y);
    var y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);

    this.x = x1;
    this.width = Math.max(x2 - x1, 0);
    this.y = y1;
    this.height = Math.max(y2 - y1, 0);
  };

  /**
   * Enlarges this rectangle to include the passed rectangle.
   *
   * @param {PIXI.Rectangle} rectangle - The rectangle to include.
   */

  Rectangle.prototype.enlarge = function enlarge(rectangle) {
    var x1 = Math.min(this.x, rectangle.x);
    var x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
    var y1 = Math.min(this.y, rectangle.y);
    var y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);

    this.x = x1;
    this.width = x2 - x1;
    this.y = y1;
    this.height = y2 - y1;
  };

  /**
   * Enlarges rectangle that way its corners lie on grid
   *
   * @param {number} [resolution=1] resolution
   * @param {number} [eps=0.001] precision
   */

  Rectangle.prototype.ceil = function ceil() {
    var resolution = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var eps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.001;

    var x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
    var y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;

    this.x = Math.floor((this.x + eps) * resolution) / resolution;
    this.y = Math.floor((this.y + eps) * resolution) / resolution;

    this.width = x2 - this.x;
    this.height = y2 - this.y;
  };

  _createClass(Rectangle, [{
    key: 'left',
    get: function get() {
      return this.x;
    }

    /**
     * returns the right edge of the rectangle
     *
     * @member {number}
     */

  }, {
    key: 'right',
    get: function get() {
      return this.x + this.width;
    }

    /**
     * returns the top edge of the rectangle
     *
     * @member {number}
     */

  }, {
    key: 'top',
    get: function get() {
      return this.y;
    }

    /**
     * returns the bottom edge of the rectangle
     *
     * @member {number}
     */

  }, {
    key: 'bottom',
    get: function get() {
      return this.y + this.height;
    }

    /**
     * A constant empty rectangle.
     *
     * @static
     * @constant
     */

  }], [{
    key: 'EMPTY',
    get: function get() {
      return new Rectangle(0, 0, 0, 0);
    }
  }]);

  return Rectangle;
}();

exports.default = Rectangle;
//# sourceMappingURL=Rectangle.js.map

/***/ }),

/***/ "N+bu":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Script loading is difficult thanks to IE. We need callbacks to fire
 * immediately following the script's execution, with no other scripts
 * running in between. If other scripts on the page are able to run
 * between our script and its callback, bad things can happen, such as
 * `jQuery.noConflict` not being called in time, resulting in plugins
 * latching onto our version of jQuery, etc.
 *
 * For IE<10 we use a relatively well-documented "preloading" strategy,
 * which ensures that the script is ready to execute *before* appending
 * it to the DOM. That way when it is finally appended, it is
 * executed immediately.
 *
 * References:
 * - http://www.html5rocks.com/en/tutorials/speed/script-loading/
 * - http://blog.getify.com/ie11-please-bring-real-script-preloading-back/
 * - https://github.com/jrburke/requirejs/issues/526
 * - https://connect.microsoft.com/IE/feedback/details/729164/
 *           ie10-dynamic-script-element-fires-loaded-readystate-prematurely
 */
(function () {

  // Global state.
  var pendingScripts = {};
  var scriptCounter = 0;

  /**
   * Insert script into the DOM
   *
   * @param {Object} script Script DOM object
   * @returns {void}
   */
  var _addScript = function _addScript(script) {
    // Get the first script element, we're just going to use it
    // as a reference for where to insert ours. Do NOT try to do
    // this just once at the top and then re-use the same script
    // as a reference later. Some weird loaders *remove* script
    // elements after the browser has executed their contents,
    // so the same reference might not have a parentNode later.
    var firstScript = document.getElementsByTagName("script")[0];

    // Append the script to the DOM, triggering execution.
    firstScript.parentNode.insertBefore(script, firstScript);
  };

  /**
   * Load Script.
   *
   * @param {String}    src       URI of script
   * @param {Function}  callback  (Optional) Called on script load completion
   * @param {Object}    context   (Optional) Callback context (`this`)
   * @returns {void}
   */
  var _lload = function _lload(src, callback, context) {
    /*eslint max-statements: [2, 25]*/
    var script = document.createElement("script");
    var done = false;
    var err;
    var _cleanup; // _must_ be set below.

    /**
     * Final handler for error or completion.
     *
     * **Note**: Will only be called _once_.
     *
     * @returns {void}
     */
    var _finish = function _finish() {
      // Only call once.
      if (done) {
        return;
      }
      done = true;

      // Internal cleanup.
      _cleanup();

      // Callback.
      if (callback) {
        callback.call(context, err);
      }
    };

    /**
     * Error handler
     *
     * @returns {void}
     */
    var _error = function _error() {
      err = new Error(src || "EMPTY");
      _finish();
    };

    if (script.readyState && !("async" in script)) {
      /*eslint-disable consistent-return*/

      // This section is only for IE<10. Some other old browsers may
      // satisfy the above condition and enter this branch, but we don't
      // support those browsers anyway.

      var id = scriptCounter++;
      var isReady = { loaded: true, complete: true };
      var inserted = false;

      // Clear out listeners, state.
      _cleanup = function _cleanup() {
        script.onreadystatechange = script.onerror = null;
        pendingScripts[id] = void 0;
      };

      // Attach the handler before setting src, otherwise we might
      // miss events (consider that IE could fire them synchronously
      // upon setting src, for example).
      script.onreadystatechange = function () {
        var firstState = script.readyState;

        // Protect against any errors from state change randomness.
        if (err) {
          return;
        }

        if (!inserted && isReady[firstState]) {
          inserted = true;

          // Append to DOM.
          _addScript(script);
        }

        // --------------------------------------------------------------------
        //                       GLORIOUS IE8 HACKAGE!!!
        // --------------------------------------------------------------------
        //
        // Oh IE8, how you disappoint. IE8 won't call `script.onerror`, so
        // we have to resort to drastic measures.
        // See, e.g. http://www.quirksmode.org/dom/events/error.html#t02
        //
        // As with all things development, there's a Stack Overflow comment that
        // asserts the following combinations of state changes in IE8 indicate a
        // script load error. And crazily, it seems to work!
        //
        // http://stackoverflow.com/a/18840568/741892
        //
        // The `script.readyState` transitions we're interested are:
        //
        // * If state starts as `loaded`
        // * Call `script.children`, which _should_ change state to `complete`
        // * If state is now `loading`, then **we have a load error**
        //
        // For the reader's amusement, here is HeadJS's catalog of various
        // `readyState` transitions in normal operation for IE:
        // https://github.com/headjs/headjs/blob/master/src/2.0.0/load.js#L379-L419
        if (firstState === "loaded") {
          // The act of accessing the property should change the script's
          // `readyState`.
          //
          // And, oh yeah, this hack is so hacky-ish we need the following
          // eslint disable...
          /*eslint-disable no-unused-expressions*/
          script.children;
          /*eslint-enable no-unused-expressions*/

          if (script.readyState === "loading") {
            // State transitions indicate we've hit the load error.
            //
            // **Note**: We are not intending to _return_ a value, just have
            // a shorter short-circuit code path here.
            return _error();
          }
        }

        // It's possible for readyState to be "complete" immediately
        // after we insert (and execute) the script in the branch
        // above. So check readyState again here and react without
        // waiting for another onreadystatechange.
        if (script.readyState === "complete") {
          _finish();
        }
      };

      // Onerror handler _may_ work here.
      script.onerror = _error;

      // Since we're not appending the script to the DOM yet, the
      // reference to our script element might get garbage collected
      // when this function ends, without onreadystatechange ever being
      // fired. This has been witnessed to happen. Adding it to
      // `pendingScripts` ensures this can't happen.
      pendingScripts[id] = script;

      // This triggers a request for the script, but its contents won't
      // be executed until we append it to the DOM.
      script.src = src;

      // In some cases, the readyState is already "loaded" immediately
      // after setting src. It's a lie! Don't append to the DOM until
      // the onreadystatechange event says so.
    } else {
      // This section is for modern browsers, including IE10+.

      // Clear out listeners.
      _cleanup = function _cleanup() {
        script.onload = script.onerror = null;
      };

      script.onerror = _error;
      script.onload = _finish;
      script.async = true;
      script.charset = "utf-8";
      script.src = src;

      // Append to DOM.
      _addScript(script);
    }
  };

  // UMD wrapper.
  /*global define:false*/
  if (true) {
    // CommonJS
    module.exports = _lload;
  } else if (typeof define === "function" && define.amd) {
    // AMD
    define([], function () {
      return _lload;
    });
  } else {
    // VanillaJS
    window._lload = _lload;
  }
})();

/***/ }),

/***/ "N+iG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "398ff6d54edc1d484f974eed25578492.svg";

/***/ }),

/***/ "ND05":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),

/***/ "NEc+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _CountLimiter = __webpack_require__("4EC6");

var _CountLimiter2 = _interopRequireDefault(_CountLimiter);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var SharedTicker = core.ticker.shared;

/**
 * Default number of uploads per frame using prepare plugin.
 *
 * @static
 * @memberof PIXI.settings
 * @name UPLOADS_PER_FRAME
 * @type {number}
 * @default 4
 */
core.settings.UPLOADS_PER_FRAME = 4;

/**
 * The prepare manager provides functionality to upload content to the GPU. BasePrepare handles
 * basic queuing functionality and is extended by {@link PIXI.prepare.WebGLPrepare} and {@link PIXI.prepare.CanvasPrepare}
 * to provide preparation capabilities specific to their respective renderers.
 *
 * @example
 * // Create a sprite
 * const sprite = new PIXI.Sprite.fromImage('something.png');
 *
 * // Load object into GPU
 * app.renderer.plugins.prepare.upload(sprite, () => {
 *
 *     //Texture(s) has been uploaded to GPU
 *     app.stage.addChild(sprite);
 *
 * })
 *
 * @abstract
 * @class
 * @memberof PIXI.prepare
 */

var BasePrepare = function () {
    /**
     * @param {PIXI.SystemRenderer} renderer - A reference to the current renderer
     */
    function BasePrepare(renderer) {
        var _this = this;

        _classCallCheck(this, BasePrepare);

        /**
         * The limiter to be used to control how quickly items are prepared.
         * @type {PIXI.prepare.CountLimiter|PIXI.prepare.TimeLimiter}
         */
        this.limiter = new _CountLimiter2.default(core.settings.UPLOADS_PER_FRAME);

        /**
         * Reference to the renderer.
         * @type {PIXI.SystemRenderer}
         * @protected
         */
        this.renderer = renderer;

        /**
         * The only real difference between CanvasPrepare and WebGLPrepare is what they pass
         * to upload hooks. That different parameter is stored here.
         * @type {PIXI.prepare.CanvasPrepare|PIXI.WebGLRenderer}
         * @protected
         */
        this.uploadHookHelper = null;

        /**
         * Collection of items to uploads at once.
         * @type {Array<*>}
         * @private
         */
        this.queue = [];

        /**
         * Collection of additional hooks for finding assets.
         * @type {Array<Function>}
         * @private
         */
        this.addHooks = [];

        /**
         * Collection of additional hooks for processing assets.
         * @type {Array<Function>}
         * @private
         */
        this.uploadHooks = [];

        /**
         * Callback to call after completed.
         * @type {Array<Function>}
         * @private
         */
        this.completes = [];

        /**
         * If prepare is ticking (running).
         * @type {boolean}
         * @private
         */
        this.ticking = false;

        /**
         * 'bound' call for prepareItems().
         * @type {Function}
         * @private
         */
        this.delayedTick = function () {
            // unlikely, but in case we were destroyed between tick() and delayedTick()
            if (!_this.queue) {
                return;
            }
            _this.prepareItems();
        };

        // hooks to find the correct texture
        this.registerFindHook(findText);
        this.registerFindHook(findTextStyle);
        this.registerFindHook(findMultipleBaseTextures);
        this.registerFindHook(findBaseTexture);
        this.registerFindHook(findTexture);

        // upload hooks
        this.registerUploadHook(drawText);
        this.registerUploadHook(calculateTextStyle);
    }

    /**
     * Upload all the textures and graphics to the GPU.
     *
     * @param {Function|PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} item -
     *        Either the container or display object to search for items to upload, the items to upload themselves,
     *        or the callback function, if items have been added using `prepare.add`.
     * @param {Function} [done] - Optional callback when all queued uploads have completed
     */

    BasePrepare.prototype.upload = function upload(item, done) {
        if (typeof item === 'function') {
            done = item;
            item = null;
        }

        // If a display object, search for items
        // that we could upload
        if (item) {
            this.add(item);
        }

        // Get the items for upload from the display
        if (this.queue.length) {
            if (done) {
                this.completes.push(done);
            }

            if (!this.ticking) {
                this.ticking = true;
                SharedTicker.addOnce(this.tick, this, core.UPDATE_PRIORITY.UTILITY);
            }
        } else if (done) {
            done();
        }
    };

    /**
     * Handle tick update
     *
     * @private
     */

    BasePrepare.prototype.tick = function tick() {
        setTimeout(this.delayedTick, 0);
    };

    /**
     * Actually prepare items. This is handled outside of the tick because it will take a while
     * and we do NOT want to block the current animation frame from rendering.
     *
     * @private
     */

    BasePrepare.prototype.prepareItems = function prepareItems() {
        this.limiter.beginFrame();
        // Upload the graphics
        while (this.queue.length && this.limiter.allowedToUpload()) {
            var item = this.queue[0];
            var uploaded = false;

            if (item && !item._destroyed) {
                for (var i = 0, len = this.uploadHooks.length; i < len; i++) {
                    if (this.uploadHooks[i](this.uploadHookHelper, item)) {
                        this.queue.shift();
                        uploaded = true;
                        break;
                    }
                }
            }

            if (!uploaded) {
                this.queue.shift();
            }
        }

        // We're finished
        if (!this.queue.length) {
            this.ticking = false;

            var completes = this.completes.slice(0);

            this.completes.length = 0;

            for (var _i = 0, _len = completes.length; _i < _len; _i++) {
                completes[_i]();
            }
        } else {
            // if we are not finished, on the next rAF do this again
            SharedTicker.addOnce(this.tick, this, core.UPDATE_PRIORITY.UTILITY);
        }
    };

    /**
     * Adds hooks for finding items.
     *
     * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
     *          function must return `true` if it was able to add item to the queue.
     * @return {PIXI.BasePrepare} Instance of plugin for chaining.
     */

    BasePrepare.prototype.registerFindHook = function registerFindHook(addHook) {
        if (addHook) {
            this.addHooks.push(addHook);
        }

        return this;
    };

    /**
     * Adds hooks for uploading items.
     *
     * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
     *          function must return `true` if it was able to handle upload of item.
     * @return {PIXI.BasePrepare} Instance of plugin for chaining.
     */

    BasePrepare.prototype.registerUploadHook = function registerUploadHook(uploadHook) {
        if (uploadHook) {
            this.uploadHooks.push(uploadHook);
        }

        return this;
    };

    /**
     * Manually add an item to the uploading queue.
     *
     * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
     *        add to the queue
     * @return {PIXI.CanvasPrepare} Instance of plugin for chaining.
     */

    BasePrepare.prototype.add = function add(item) {
        // Add additional hooks for finding elements on special
        // types of objects that
        for (var i = 0, len = this.addHooks.length; i < len; i++) {
            if (this.addHooks[i](item, this.queue)) {
                break;
            }
        }

        // Get childen recursively
        if (item instanceof core.Container) {
            for (var _i2 = item.children.length - 1; _i2 >= 0; _i2--) {
                this.add(item.children[_i2]);
            }
        }

        return this;
    };

    /**
     * Destroys the plugin, don't use after this.
     *
     */

    BasePrepare.prototype.destroy = function destroy() {
        if (this.ticking) {
            SharedTicker.remove(this.tick, this);
        }
        this.ticking = false;
        this.addHooks = null;
        this.uploadHooks = null;
        this.renderer = null;
        this.completes = null;
        this.queue = null;
        this.limiter = null;
        this.uploadHookHelper = null;
    };

    return BasePrepare;
}();

/**
 * Built-in hook to find multiple textures from objects like AnimatedSprites.
 *
 * @private
 * @param {PIXI.DisplayObject} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.Texture object was found.
 */

exports.default = BasePrepare;
function findMultipleBaseTextures(item, queue) {
    var result = false;

    // Objects with mutliple textures
    if (item && item._textures && item._textures.length) {
        for (var i = 0; i < item._textures.length; i++) {
            if (item._textures[i] instanceof core.Texture) {
                var baseTexture = item._textures[i].baseTexture;

                if (queue.indexOf(baseTexture) === -1) {
                    queue.push(baseTexture);
                    result = true;
                }
            }
        }
    }

    return result;
}

/**
 * Built-in hook to find BaseTextures from Sprites.
 *
 * @private
 * @param {PIXI.DisplayObject} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.Texture object was found.
 */
function findBaseTexture(item, queue) {
    // Objects with textures, like Sprites/Text
    if (item instanceof core.BaseTexture) {
        if (queue.indexOf(item) === -1) {
            queue.push(item);
        }

        return true;
    }

    return false;
}

/**
 * Built-in hook to find textures from objects.
 *
 * @private
 * @param {PIXI.DisplayObject} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.Texture object was found.
 */
function findTexture(item, queue) {
    if (item._texture && item._texture instanceof core.Texture) {
        var texture = item._texture.baseTexture;

        if (queue.indexOf(texture) === -1) {
            queue.push(texture);
        }

        return true;
    }

    return false;
}

/**
 * Built-in hook to draw PIXI.Text to its texture.
 *
 * @private
 * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
 * @param {PIXI.DisplayObject} item - Item to check
 * @return {boolean} If item was uploaded.
 */
function drawText(helper, item) {
    if (item instanceof core.Text) {
        // updating text will return early if it is not dirty
        item.updateText(true);

        return true;
    }

    return false;
}

/**
 * Built-in hook to calculate a text style for a PIXI.Text object.
 *
 * @private
 * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
 * @param {PIXI.DisplayObject} item - Item to check
 * @return {boolean} If item was uploaded.
 */
function calculateTextStyle(helper, item) {
    if (item instanceof core.TextStyle) {
        var font = item.toFontString();

        core.TextMetrics.measureFont(font);

        return true;
    }

    return false;
}

/**
 * Built-in hook to find Text objects.
 *
 * @private
 * @param {PIXI.DisplayObject} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.Text object was found.
 */
function findText(item, queue) {
    if (item instanceof core.Text) {
        // push the text style to prepare it - this can be really expensive
        if (queue.indexOf(item.style) === -1) {
            queue.push(item.style);
        }
        // also push the text object so that we can render it (to canvas/texture) if needed
        if (queue.indexOf(item) === -1) {
            queue.push(item);
        }
        // also push the Text's texture for upload to GPU
        var texture = item._texture.baseTexture;

        if (queue.indexOf(texture) === -1) {
            queue.push(texture);
        }

        return true;
    }

    return false;
}

/**
 * Built-in hook to find TextStyle objects.
 *
 * @private
 * @param {PIXI.TextStyle} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.TextStyle object was found.
 */
function findTextStyle(item, queue) {
    if (item instanceof core.TextStyle) {
        if (queue.indexOf(item) === -1) {
            queue.push(item);
        }

        return true;
    }

    return false;
}
//# sourceMappingURL=BasePrepare.js.map

/***/ }),

/***/ "NEt2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("ZtmO");

var zeroWidthSpace = '\u200B';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};

/***/ }),

/***/ "NM9i":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5c3ccc4aac630cb7799b6cf6a396b488.png";

/***/ }),

/***/ "NMJ1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = __webpack_require__("sh3Y");

module.exports = function (_Plugin) {
    _inherits(Pinch, _Plugin);

    /**
     * @private
     * @param {Viewport} parent
     * @param {object} [options]
     * @param {boolean} [options.noDrag] disable two-finger dragging
     * @param {number} [options.percent=1.0] percent to modify pinch speed
     * @param {PIXI.Point} [options.center] place this point at center during zoom instead of center of two fingers
     */
    function Pinch(parent, options) {
        _classCallCheck(this, Pinch);

        var _this = _possibleConstructorReturn(this, (Pinch.__proto__ || Object.getPrototypeOf(Pinch)).call(this, parent));

        options = options || {};
        _this.percent = options.percent || 1.0;
        _this.noDrag = options.noDrag;
        _this.center = options.center;
        return _this;
    }

    _createClass(Pinch, [{
        key: 'down',
        value: function down() {
            if (this.parent.countDownPointers() >= 2) {
                this.active = true;
                return true;
            }
        }
    }, {
        key: 'move',
        value: function move(e) {
            if (this.paused || !this.active) {
                return;
            }

            var x = e.data.global.x;
            var y = e.data.global.y;

            var pointers = this.parent.getTouchPointers();
            if (pointers.length >= 2) {
                var first = pointers[0];
                var second = pointers[1];
                var last = first.last && second.last ? Math.sqrt(Math.pow(second.last.x - first.last.x, 2) + Math.pow(second.last.y - first.last.y, 2)) : null;
                if (first.pointerId === e.data.pointerId) {
                    first.last = { x: x, y: y, data: e.data };
                } else if (second.pointerId === e.data.pointerId) {
                    second.last = { x: x, y: y, data: e.data };
                }
                if (last) {
                    var oldPoint = void 0;
                    var point = { x: first.last.x + (second.last.x - first.last.x) / 2, y: first.last.y + (second.last.y - first.last.y) / 2 };
                    if (!this.center) {
                        oldPoint = this.parent.toLocal(point);
                    }
                    var dist = Math.sqrt(Math.pow(second.last.x - first.last.x, 2) + Math.pow(second.last.y - first.last.y, 2));
                    var change = (dist - last) / this.parent.screenWidth * this.parent.scale.x * this.percent;
                    this.parent.scale.x += change;
                    this.parent.scale.y += change;
                    this.parent.emit('zoomed', { viewport: this.parent, type: 'pinch' });
                    var clamp = this.parent.plugins['clamp-zoom'];
                    if (clamp) {
                        clamp.clamp();
                    }
                    if (this.center) {
                        this.parent.moveCenter(this.center);
                    } else {
                        var newPoint = this.parent.toGlobal(oldPoint);
                        this.parent.x += point.x - newPoint.x;
                        this.parent.y += point.y - newPoint.y;
                        this.parent.emit('moved', { viewport: this.parent, type: 'pinch' });
                    }
                    if (!this.noDrag && this.lastCenter) {
                        this.parent.x += point.x - this.lastCenter.x;
                        this.parent.y += point.y - this.lastCenter.y;
                        this.parent.emit('moved', { viewport: this.parent, type: 'pinch' });
                    }
                    this.lastCenter = point;
                    this.moved = true;
                } else {
                    if (!this.pinching) {
                        this.parent.emit('pinch-start', this.parent);
                        this.pinching = true;
                    }
                }
                return true;
            }
        }
    }, {
        key: 'up',
        value: function up() {
            if (this.pinching) {
                if (this.parent.touches.length <= 1) {
                    this.active = false;
                    this.lastCenter = null;
                    this.pinching = false;
                    this.moved = false;
                    this.parent.emit('pinch-end', this.parent);
                    return true;
                }
            }
        }
    }]);

    return Pinch;
}(Plugin);

/***/ }),

/***/ "NMNZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("MC1R");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("pv+l")(module)))

/***/ }),

/***/ "NNKX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
        } else {
            return get(parent, property, receiver);
        }
    } else if ("value" in desc) {
        return desc.value;
    } else {
        var getter = desc.get;if (getter === undefined) {
            return undefined;
        }return getter.call(receiver);
    }
};

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = __webpack_require__("sh3Y");
var utils = __webpack_require__("GZIj");

module.exports = function (_Plugin) {
    _inherits(SnapZoom, _Plugin);

    /**
     * @private
     * @param {Viewport} parent
     * @param {object} [options]
     * @param {number} [options.width] the desired width to snap (to maintain aspect ratio, choose only width or height)
     * @param {number} [options.height] the desired height to snap (to maintain aspect ratio, choose only width or height)
     * @param {number} [options.time=1000]
     * @param {string|function} [options.ease=easeInOutSine] ease function or name (see http://easings.net/ for supported names)
     * @param {PIXI.Point} [options.center] place this point at center during zoom instead of center of the viewport
     * @param {boolean} [options.interrupt=true] pause snapping with any user input on the viewport
     * @param {boolean} [options.removeOnComplete] removes this plugin after snapping is complete
     * @param {boolean} [options.removeOnInterrupt] removes this plugin if interrupted by any user input
     * @param {boolean} [options.forceStart] starts the snap immediately regardless of whether the viewport is at the desired zoom
     * @param {boolean} [options.noMove] zoom but do not move
     *
     * @event snap-zoom-start(Viewport) emitted each time a fit animation starts
     * @event snap-zoom-end(Viewport) emitted each time fit reaches its target
     * @event snap-zoom-end(Viewport) emitted each time fit reaches its target
     */
    function SnapZoom(parent, options) {
        _classCallCheck(this, SnapZoom);

        var _this = _possibleConstructorReturn(this, (SnapZoom.__proto__ || Object.getPrototypeOf(SnapZoom)).call(this, parent));

        options = options || {};
        _this.width = options.width;
        _this.height = options.height;
        if (_this.width > 0) {
            _this.x_scale = parent._screenWidth / _this.width;
        }
        if (_this.height > 0) {
            _this.y_scale = parent._screenHeight / _this.height;
        }
        _this.xIndependent = utils.exists(_this.x_scale);
        _this.yIndependent = utils.exists(_this.y_scale);
        _this.x_scale = _this.xIndependent ? _this.x_scale : _this.y_scale;
        _this.y_scale = _this.yIndependent ? _this.y_scale : _this.x_scale;

        _this.time = utils.defaults(options.time, 1000);
        _this.ease = utils.ease(options.ease, 'easeInOutSine');
        _this.center = options.center;
        _this.noMove = options.noMove;
        _this.stopOnResize = options.stopOnResize;
        _this.removeOnInterrupt = options.removeOnInterrupt;
        _this.removeOnComplete = utils.defaults(options.removeOnComplete, true);
        _this.interrupt = utils.defaults(options.interrupt, true);
        if (_this.time === 0) {
            parent.container.scale.x = _this.x_scale;
            parent.container.scale.y = _this.y_scale;
            if (_this.removeOnComplete) {
                _this.parent.removePlugin('snap-zoom');
            }
        } else if (options.forceStart) {
            _this.createSnapping();
        }
        return _this;
    }

    _createClass(SnapZoom, [{
        key: 'createSnapping',
        value: function createSnapping() {
            var scale = this.parent.scale;
            this.snapping = { time: 0, startX: scale.x, startY: scale.y, deltaX: this.x_scale - scale.x, deltaY: this.y_scale - scale.y };
            this.parent.emit('snap-zoom-start', this.parent);
        }
    }, {
        key: 'resize',
        value: function resize() {
            this.snapping = null;

            if (this.width > 0) {
                this.x_scale = this.parent._screenWidth / this.width;
            }
            if (this.height > 0) {
                this.y_scale = this.parent._screenHeight / this.height;
            }
            this.x_scale = this.xIndependent ? this.x_scale : this.y_scale;
            this.y_scale = this.yIndependent ? this.y_scale : this.x_scale;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.snapping = null;
        }
    }, {
        key: 'wheel',
        value: function wheel() {
            if (this.removeOnInterrupt) {
                this.parent.removePlugin('snap-zoom');
            }
        }
    }, {
        key: 'down',
        value: function down() {
            if (this.removeOnInterrupt) {
                this.parent.removePlugin('snap-zoom');
            } else if (this.interrupt) {
                this.snapping = null;
            }
        }
    }, {
        key: 'update',
        value: function update(elapsed) {
            if (this.paused) {
                return;
            }
            if (this.interrupt && this.parent.countDownPointers() !== 0) {
                return;
            }

            var oldCenter = void 0;
            if (!this.center && !this.noMove) {
                oldCenter = this.parent.center;
            }
            if (!this.snapping) {
                if (this.parent.scale.x !== this.x_scale || this.parent.scale.y !== this.y_scale) {
                    this.createSnapping();
                }
            } else if (this.snapping) {
                var snapping = this.snapping;
                snapping.time += elapsed;
                if (snapping.time >= this.time) {
                    this.parent.scale.set(this.x_scale, this.y_scale);
                    if (this.removeOnComplete) {
                        this.parent.removePlugin('snap-zoom');
                    }
                    this.parent.emit('snap-zoom-end', this.parent);
                    this.snapping = null;
                } else {
                    var _snapping = this.snapping;
                    this.parent.scale.x = this.ease(_snapping.time, _snapping.startX, _snapping.deltaX, this.time);
                    this.parent.scale.y = this.ease(_snapping.time, _snapping.startY, _snapping.deltaY, this.time);
                }
                var clamp = this.parent.plugins['clamp-zoom'];
                if (clamp) {
                    clamp.clamp();
                }
                if (!this.noMove) {
                    if (!this.center) {
                        this.parent.moveCenter(oldCenter);
                    } else {
                        this.parent.moveCenter(this.center);
                    }
                }
            }
        }
    }, {
        key: 'resume',
        value: function resume() {
            this.snapping = null;
            _get(SnapZoom.prototype.__proto__ || Object.getPrototypeOf(SnapZoom.prototype), 'resume', this).call(this);
        }
    }]);

    return SnapZoom;
}(Plugin);

/***/ }),

/***/ "Ncae":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a1935f207416c7ed14d9b54e1af40c7e.svg";

/***/ }),

/***/ "NfzK":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*global XDomainRequest:false */

var TraceKit = __webpack_require__("uSo9");
var stringify = __webpack_require__("uh8Y");
var md5 = __webpack_require__("q84K");
var RavenConfigError = __webpack_require__("n3E9");

var utils = __webpack_require__("kAhx");
var isErrorEvent = utils.isErrorEvent;
var isDOMError = utils.isDOMError;
var isDOMException = utils.isDOMException;
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__("fg+O").wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
    dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback) ? function (data) {
    return callback(data, original);
  } : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    keepalive: true,
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.26.4',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function config(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function (key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length ? joinRegExp(globalOptions.ignoreUrls) : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length ? joinRegExp(globalOptions.whitelistUrls) : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(0, Math.min(globalOptions.maxBreadcrumbs || 100, 100)); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function install() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function () {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function setDSN(dsn) {
    var self = this,
        uri = self._parseDSN(dsn),
        lastSlash = uri.path.lastIndexOf('/'),
        path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint = self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function context(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = {};
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function wrap(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
          i = arguments.length,
          deep = !options || options && options.deep !== false;

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) {
        args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
      }try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function uninstall() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function _promiseRejectionHandler(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      mechanism: {
        type: 'onunhandledrejection',
        handled: false
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function _attachPromiseRejectionHandler() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener && _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function _detachPromiseRejectionHandler() {
    _window.removeEventListener && _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function captureException(ex, options) {
    options = objectMerge({ trimHeadFrames: 0 }, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isDOMError(ex) || isDOMException(ex)) {
      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
      // then we just extract the name and message, as they don't provide anything else
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
      var message = ex.message ? name + ': ' + ex.message : name;

      return this.captureMessage(message, objectMerge(options, {
        // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
        // but it's barely any overhead so we may at least try
        stacktrace: true,
        trimHeadFrames: options.trimHeadFrames + 1
      }));
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a DOMError/DOMException
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(ex, objectMerge(options, {
        stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
        trimHeadFrames: options.trimHeadFrames + 1
      }));
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function _getCaptureExceptionOptionsFromPlainObject(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message: 'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function captureMessage(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(msg)) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge({
      message: msg
    }, options);

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = initialCall && initialCall.url || '';

    if (!!this._globalOptions.ignoreUrls.test && this._globalOptions.ignoreUrls.test(fileurl)) {
      return;
    }

    if (!!this._globalOptions.whitelistUrls.test && !this._globalOptions.whitelistUrls.test(fileurl)) {
      return;
    }

    // Always attempt to get stacktrace if message is empty.
    // It's the only way to provide any helpful information to the user.
    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge({
        trimHeadFrames: 0
      }, options);
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint) ? data.fingerprint : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function captureBreadcrumb(obj) {
    var crumb = objectMerge({
      timestamp: now() / 1000
    }, obj);

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function addPlugin(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function setUserContext(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function setExtraContext(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function setTagsContext(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function clearContext() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function getContext() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function setEnvironment(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function setRelease(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function setDataCallback(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function setBreadcrumbCallback(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function setShouldSendCallback(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function setTransport(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function lastException() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function lastEventId() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function isSetup() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function afterLoad() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function showReportDialog(options) {
    if (!_document // doesn't work without a document (React native)
    ) return;

    options = _extends({
      eventId: this.lastEventId(),
      dsn: this._dsn,
      user: this._globalContext.user || {}
    }, options);

    if (!options.eventId) {
      throw new RavenConfigError('Missing eventId');
    }

    if (!options.dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var encodedOptions = [];

    for (var key in options) {
      if (key === 'user') {
        var user = options.user;
        if (user.name) encodedOptions.push('name=' + encode(user.name));
        if (user.email) encodedOptions.push('email=' + encode(user.email));
      } else {
        encodedOptions.push(encode(key) + '=' + encode(options[key]));
      }
    }
    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function _ignoreNextOnError() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function () {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function _triggerEvent(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options) {
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }
    }if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function _breadcrumbEventHandler(evtName) {
    var self = this;
    return function (evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function _keypressEventHandler() {
    var self = this,
        debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable) return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function () {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function _captureUrlChange(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function _patchFunctionToString() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function () {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function _unpatchFunctionToString() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function _instrumentTryCatch() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function (fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap({
            mechanism: {
              type: 'instrument',
              data: { function: orig.name || '<anonymous>' }
            }
          }, originalCallback);
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(proto, 'addEventListener', function (orig) {
          return function (evtName, fn, capture, secure) {
            // preserve arity
            try {
              if (fn && fn.handleEvent) {
                fn.handleEvent = self.wrap({
                  mechanism: {
                    type: 'instrument',
                    data: {
                      target: global,
                      function: 'handleEvent',
                      handler: fn && fn.name || '<anonymous>'
                    }
                  }
                }, fn.handleEvent);
              }
            } catch (err) {}
            // can sometimes get 'Permission denied to access property "handle Event'


            // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
            // so that we don't have more than one wrapper function
            var before, clickHandler, keypressHandler;

            if (autoBreadcrumbs && autoBreadcrumbs.dom && (global === 'EventTarget' || global === 'Node')) {
              // NOTE: generating multiple handlers per addEventListener invocation, should
              //       revisit and verify we can just use one (almost certainly)
              clickHandler = self._breadcrumbEventHandler('click');
              keypressHandler = self._keypressEventHandler();
              before = function before(evt) {
                // need to intercept every DOM event in `before` argument, in case that
                // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                // see #724
                if (!evt) return;

                var eventType;
                try {
                  eventType = evt.type;
                } catch (e) {
                  // just accessing event properties can throw an exception in some rare circumstances
                  // see: https://github.com/getsentry/raven-js/issues/838
                  return;
                }
                if (eventType === 'click') return clickHandler(evt);else if (eventType === 'keypress') return keypressHandler(evt);
              };
            }
            return orig.call(this, evtName, self.wrap({
              mechanism: {
                type: 'instrument',
                data: {
                  target: global,
                  function: 'addEventListener',
                  handler: fn && fn.name || '<anonymous>'
                }
              }
            }, fn, before), capture, secure);
          };
        }, wrappedBuiltIns);
        fill(proto, 'removeEventListener', function (orig) {
          return function (evt, fn, capture, secure) {
            try {
              fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
            } catch (e) {
              // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
            }
            return orig.call(this, evt, fn, capture, secure);
          };
        }, wrappedBuiltIns);
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(_window, 'requestAnimationFrame', function (orig) {
        return function (cb) {
          return orig(self.wrap({
            mechanism: {
              type: 'instrument',
              data: {
                function: 'requestAnimationFrame',
                handler: orig && orig.name || '<anonymous>'
              }
            }
          }, cb));
        };
      }, wrappedBuiltIns);
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function _instrumentBreadcrumbs() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function (orig) {
          return self.wrap({
            mechanism: {
              type: 'instrument',
              data: { function: prop, handler: orig && orig.name || '<anonymous>' }
            }
          }, orig);
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(xhrproto, 'open', function (origOpen) {
        return function (method, url) {
          // preserve arity

          // if Sentry key appears in URL, don't capture
          if (isString(url) && url.indexOf(self._globalKey) === -1) {
            this.__raven_xhr = {
              method: method,
              url: url,
              status_code: null
            };
          }

          return origOpen.apply(this, arguments);
        };
      }, wrappedBuiltIns);

      fill(xhrproto, 'send', function (origSend) {
        return function () {
          // preserve arity
          var xhr = this;

          function onreadystatechangeHandler() {
            if (xhr.__raven_xhr && xhr.readyState === 4) {
              try {
                // touching statusCode in some platforms throws
                // an exception
                xhr.__raven_xhr.status_code = xhr.status;
              } catch (e) {
                /* do nothing */
              }

              self.captureBreadcrumb({
                type: 'http',
                category: 'xhr',
                data: xhr.__raven_xhr
              });
            }
          }

          var props = ['onload', 'onerror', 'onprogress'];
          for (var j = 0; j < props.length; j++) {
            wrapProp(props[j], xhr);
          }

          if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
            fill(xhr, 'onreadystatechange', function (orig) {
              return self.wrap({
                mechanism: {
                  type: 'instrument',
                  data: {
                    function: 'onreadystatechange',
                    handler: orig && orig.name || '<anonymous>'
                  }
                }
              }, orig, onreadystatechangeHandler);
            } /* intentionally don't track this instrumentation */
            );
          } else {
            // if onreadystatechange wasn't actually set by the page on this xhr, we
            // are free to set our own and capture the breadcrumb
            xhr.onreadystatechange = onreadystatechangeHandler;
          }

          return origSend.apply(this, arguments);
        };
      }, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(_window, 'fetch', function (origFetch) {
        return function () {
          // preserve arity
          // Make a copy of the arguments to prevent deoptimization
          // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
          var args = new Array(arguments.length);
          for (var i = 0; i < args.length; ++i) {
            args[i] = arguments[i];
          }

          var fetchInput = args[0];
          var method = 'GET';
          var url;

          if (typeof fetchInput === 'string') {
            url = fetchInput;
          } else if ('Request' in _window && fetchInput instanceof _window.Request) {
            url = fetchInput.url;
            if (fetchInput.method) {
              method = fetchInput.method;
            }
          } else {
            url = '' + fetchInput;
          }

          // if Sentry key appears in URL, don't capture, as it's our own request
          if (url.indexOf(self._globalKey) !== -1) {
            return origFetch.apply(this, args);
          }

          if (args[1] && args[1].method) {
            method = args[1].method;
          }

          var fetchData = {
            method: method,
            url: url,
            status_code: null
          };

          return origFetch.apply(this, args).then(function (response) {
            fetchData.status_code = response.status;

            self.captureBreadcrumb({
              type: 'http',
              category: 'fetch',
              data: fetchData
            });

            return response;
          })['catch'](function (err) {
            // if there is an error performing the request
            self.captureBreadcrumb({
              type: 'http',
              category: 'fetch',
              data: fetchData,
              level: 'error'
            });

            throw err;
          });
        };
      }, wrappedBuiltIns);
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState = !isChromePackagedApp && _window.history && _window.history.pushState && _window.history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function () {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function historyReplacementFunction(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function () /* state, title, url */{
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function consoleMethodCallback(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function (_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function _restoreBuiltIns() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
          name = builtin[1],
          orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function _restoreConsole() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function _drainPlugins() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function (_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function _parseDSN(str) {
    var m = dsnPattern.exec(str),
        dsn = {},
        i = 7;

    try {
      while (i--) {
        dsn[dsnKeys[i]] = m[i] || '';
      }
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError('Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key');
    }

    return dsn;
  },

  _getGlobalServer: function _getGlobalServer(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function _handleOnErrorStackInfo(stackInfo, options) {
    options = options || {};
    options.mechanism = options.mechanism || {
      type: 'onerror',
      handled: false
    };

    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo(stackInfo, options);
    }
  },

  _handleStackInfo: function _handleStackInfo(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(stackInfo.name, stackInfo.message, stackInfo.url, stackInfo.lineno, frames, options);
  },

  _prepareFrames: function _prepareFrames(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function (i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function _normalizeFrame(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !( // determine if an exception came from outside of our app
    // first we check the global includePaths list.
    !!this._globalOptions.includePaths.test && !this._globalOptions.includePaths.test(normalized.filename) ||
    // Now we check for fun, if the function name is Raven or TraceKit
    /(Raven|TraceKit)\./.test(normalized['function']) ||
    // finally, we do a last ditch effort and check for raven.min.js
    /raven\.(min\.)?js$/.test(normalized.filename));

    return normalized;
  },

  _processException: function _processException(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (!!this._globalOptions.ignoreErrors.test && (this._globalOptions.ignoreErrors.test(message) || this._globalOptions.ignoreErrors.test(prefixedMessage))) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = { frames: frames };
    } else if (fileurl) {
      stacktrace = {
        frames: [{
          filename: fileurl,
          lineno: lineno,
          in_app: true
        }]
      };
    }

    if (!!this._globalOptions.ignoreUrls.test && this._globalOptions.ignoreUrls.test(fileurl)) {
      return;
    }

    if (!!this._globalOptions.whitelistUrls.test && !this._globalOptions.whitelistUrls.test(fileurl)) {
      return;
    }

    var data = objectMerge({
      // sentry.interfaces.Exception
      exception: {
        values: [{
          type: type,
          value: message,
          stacktrace: stacktrace
        }]
      },
      transaction: fileurl
    }, options);

    var ex = data.exception.values[0];
    if (ex.type == null && ex.value === '') {
      ex.value = 'Unrecoverable error caught';
    }

    // Move mechanism from options to exception interface
    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
    // too much
    if (!data.exception.mechanism && data.mechanism) {
      data.exception.mechanism = data.mechanism;
      delete data.mechanism;
    }

    data.exception.mechanism = objectMerge({
      type: 'generic',
      handled: true
    }, data.exception.mechanism || {});

    // Fire away!
    this._send(data);
  },

  _trimPacket: function _trimPacket(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values) this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function _trimBreadcrumbs(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
        urlProp,
        crumb,
        data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (!crumb.hasOwnProperty('data') || !isObject(crumb.data) || objectFrozen(crumb.data)) continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function _getHttpData() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': _navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function _resetBackoff() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function _shouldBackoff() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function _isRepeatData(current) {
    var last = this._lastData;

    if (!last || current.message !== last.message || // defined for captureMessage
    current.transaction !== last.transaction // defined for captureException/onerror
    ) return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    }

    return true;
  },

  _setBackoffState: function _setBackoffState(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry ? // If Sentry server returned a Retry-After value, use it
    retry : // Otherwise, double the last backoff duration (starts at 1 sec)
    this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function _send(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
      project: this._globalProject,
      logger: globalOptions.logger,
      platform: 'javascript'
    },
        httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function (key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function _sanitizeData(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function _getUuid() {
    return uuid4();
  },

  _sendProcessedPayload: function _sendProcessedPayload(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (this._globalOptions.autoBreadcrumbs && this._globalOptions.autoBreadcrumbs.sentry) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception ? (exception.type ? exception.type + ': ' : '') + exception.value : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function _makeRequest(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window.fetch(url, fetchOptions).then(function (response) {
        if (response.ok) {
          opts.onSuccess && opts.onSuccess();
        } else {
          var error = new Error('Sentry error code: ' + response.status);
          // It's called request only to keep compatibility with XHR interface
          // and not add more redundant checks in setBackoffState method
          error.request = response;
          opts.onError && opts.onError(error);
        }
      })['catch'](function () {
        opts.onError && opts.onError(new Error('Sentry error code: network unavailable'));
      });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function () {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function () {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function (key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function _evaluateHash(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function _logDebug(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (this._originalConsoleMethods[level] && (this.debug || this._globalOptions.debug)) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(this._originalConsoleMethods[level], this._originalConsole, [].slice.call(arguments, 1));
    }
  },

  _mergeContext: function _mergeContext(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "NwWY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("58Ti");
var define = __webpack_require__("VxKF");

var implementation = __webpack_require__("ZtmO");
var getPolyfill = __webpack_require__("NEt2");
var shim = __webpack_require__("VBgO");

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;

/***/ }),

/***/ "O/+F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Table_1 = __webpack_require__("5i8b");
var bound_1 = __webpack_require__("USDo");
var Seat_1 = __webpack_require__("ETAJ");
var Selector_1 = __webpack_require__("8Y7Z");
var Utils_1 = __webpack_require__("o6Mn");
var SAT = __webpack_require__("MWLY");
var Text_js_1 = __webpack_require__("h2Qz");
var Config_1 = __webpack_require__("gH/r");
var ActionTracker_1 = __webpack_require__("h0Oq");

var Rows = function (_Table_1$default) {
    _inherits(Rows, _Table_1$default);

    function Rows(tableConfig, actions) {
        _classCallCheck(this, Rows);

        var _this = _possibleConstructorReturn(this, _Table_1$default.call(this, tableConfig, actions));

        _this.seatsPerRow = 5;
        _this.numberOfRows = 2;
        _this.xSeatSeperationSpace = 5;
        _this.ySeatSeperationSpace = 5;
        _this.rowLabels = [];
        _this.seatsPerRow = tableConfig.seatsPerRow || 5;
        _this.numberOfRows = tableConfig.numberOfRows || 2;
        _this.rowLabels = tableConfig.rowLabels;
        _this.seatLabelRight = tableConfig.seatLabelRight;
        _this.xSeatSeperationSpace = tableConfig.xSeatSeperationSpace || 5;
        _this.ySeatSeperationSpace = tableConfig.ySeatSeperationSpace || 5;
        _this.type = tableConfig.type || "rows";
        _this.rowOffset = tableConfig.rowOffset;
        _this.rowNumberStartAt = tableConfig.rowNumberStartAt;
        if (!_this.rowLabels) {
            _this.rowLabels = [];
            for (var i = 0; i < _this.numberOfRows; i++) {
                _this.rowLabels.push(String.fromCharCode(65 + i));
            }
        }
        if (!_this.rowOffset) {
            _this.rowOffset = [];
            for (var i = 0; i < _this.numberOfRows; i++) {
                _this.rowOffset.push(0);
            }
        }
        if (!_this.rowNumberStartAt) {
            _this.rowNumberStartAt = [];
            for (var i = 0; i < _this.numberOfRows; i++) {
                _this.rowNumberStartAt.push(_this.seatlabelStartAt);
            }
        }
        return _this;
    }

    Rows.prototype.tableContainerInit = function tableContainerInit(_ref) {
        var x = _ref.x,
            y = _ref.y;

        this.containerScale = new PIXI.Point(1, 1);
        this.moveableContainer = new PIXI.Container();
        this.rowLabelContainer = new PIXI.Container();
        this.moveableContainer.position = new PIXI.Point(x, y);
        this.moveableContainer.pivot.x = this.pivot.x;
        this.moveableContainer.pivot.y = this.pivot.y;
        this.moveableContainer.rotation = this.rotation;
        this.moveableContainer.interactive = true;
        this.moveableContainer.buttonMode = true;
        this.rowsContainer = new PIXI.Container();
        this.rowsContainer.addChild(this.seatContainer);
        var labels = new PIXI.Container();
        labels.position = new PIXI.Point(Utils_1.seatWidth / 2, Utils_1.seatHeight / 2);
        labels.addChild(this.rowLabelContainer);
        this.rowsContainer.position = new PIXI.Point(Utils_1.seatWidth / 2, Utils_1.seatHeight / 2);
        this.moveableContainer.addChild(this.rowsContainer);
        this.moveableContainer.addChild(labels);
        this.updatePivot(false);
        this.moveableContainer.scale = this.containerScale;
    };

    Rows.prototype.draw = function draw() {
        var _this2 = this;

        _Table_1$default.prototype.draw.call(this);
        this.setSeatLabel();
        this.renderRowLabels();
        this.seats.forEach(function (seat, i) {
            var j = Math.floor(i / _this2.seatsPerRow);
            var startAt = _this2.rowNumberStartAt[j];
            seat.setOnDisable(_this2.onDisable);
            seat.setSeatLabelStartAt(startAt);
            seat.setPos(_this2.getSeatPos(i, 0));
        });
        this.ensurePreviousOutskirtSeatsDisabled();
    };

    Rows.prototype.ensurePreviousOutskirtSeatsDisabled = function ensurePreviousOutskirtSeatsDisabled() {
        var _this3 = this;

        var rows = [];
        this.seats.forEach(function (seat, i) {
            var rowNum = Math.floor(i / _this3.seatsPerRow);
            if (i % _this3.seatsPerRow === 0) {
                rows.push({ seats: [] });
            }
            rows[rowNum].seats.push(seat);
        });
        rows.forEach(function (row) {
            var leftOutskirtReached = false;
            var rightOutskirtReached = false;
            row.seats.forEach(function (seat) {
                if (!leftOutskirtReached) {
                    if (seat.disabled) {
                        seat.disable(true, false, true);
                    } else {
                        leftOutskirtReached = true;
                    }
                }
            });
            row.seats.reverse().forEach(function (seat) {
                if (!rightOutskirtReached) {
                    if (seat.disabled) {
                        seat.disable(true, false, true);
                    } else {
                        rightOutskirtReached = true;
                    }
                }
            });
        });
    };

    Rows.prototype.getLeftMostRightMostSeatForRows = function getLeftMostRightMostSeatForRows() {
        var _this4 = this;

        var rows = [];
        this.seats.forEach(function (seat, i) {
            var rowNum = Math.floor(i / _this4.seatsPerRow);
            if (i % _this4.seatsPerRow === 0) {
                rows.push({ seats: [] });
            }
            rows[rowNum].seats.push(seat);
        });
        return rows.map(function (row) {
            var leftOutskirtReached = false;
            var rightOutskirtReached = false;
            row.seats.forEach(function (seat) {
                if (!leftOutskirtReached) {
                    if (!seat.disabled) {
                        leftOutskirtReached = seat;
                    }
                }
            });
            row.seats.reverse().forEach(function (seat) {
                if (!rightOutskirtReached) {
                    if (!seat.disabled) {
                        rightOutskirtReached = seat;
                    }
                }
            });
            return { left: leftOutskirtReached, right: rightOutskirtReached };
        });
    };

    Rows.prototype.renderRowLabels = function renderRowLabels() {
        this.rowLabelContainer.removeChildren();
        var rowsLeftRight = this.getLeftMostRightMostSeatForRows();
        var buffer = 2;
        for (var i = 0; i < rowsLeftRight.length; i++) {
            var _rowsLeftRight$i = rowsLeftRight[i],
                left = _rowsLeftRight$i.left,
                right = _rowsLeftRight$i.right;

            if (left && right) {
                var letter = this.rowLabels[i];
                var leftText = Text_js_1.TextWrapper.createText(letter, Config_1.default.fontStyle);
                var rightText = Text_js_1.TextWrapper.createText(letter, Config_1.default.fontStyle);
                var leftSeatPos = left.getSeat().position;
                var rightSeatPos = right.getSeat().position;
                var heightField = Config_1.default.isWebGl ? "textHeight" : "height";
                var widthField = Config_1.default.isWebGl ? "textWidth" : "width";
                var leftHeight = Config_1.default.isWebGl ? rightSeatPos.y + rightText[heightField] / 2 : rightSeatPos.y - rightText[heightField] / 2;
                var rightHeight = Config_1.default.isWebGl ? rightSeatPos.y + rightText[heightField] / 2 : rightSeatPos.y - rightText[heightField] / 2;
                leftText.position = new PIXI.Point(leftSeatPos.x - leftText[widthField] - Utils_1.seatWidth + buffer, leftHeight);
                rightText.position = new PIXI.Point(rightSeatPos.x + Utils_1.seatWidth - buffer, rightHeight);
                this.rowLabelContainer.addChild(leftText);
                this.rowLabelContainer.addChild(rightText);
            }
        }
    };

    Rows.prototype.drawSelectionBox = function drawSelectionBox() {
        var _getSelectionBoxBound = this.getSelectionBoxBounds(),
            x = _getSelectionBoxBound.x,
            y = _getSelectionBoxBound.y,
            width = _getSelectionBoxBound.width,
            height = _getSelectionBoxBound.height,
            left = _getSelectionBoxBound.left,
            right = _getSelectionBoxBound.right;

        var rotation = this.moveableContainer.rotation;
        var pivot = {
            x: this.moveableContainer.pivot.x,
            y: this.moveableContainer.pivot.y
        };
        Selector_1.drawSelectionBoxTest(left, right, width, height, pivot, rotation, true, true);
    };

    Rows.prototype.getSeatRowLabel = function getSeatRowLabel(i) {
        var j = Math.floor(i / this.seatsPerRow);
        return this.rowLabels[j];
    };

    Rows.prototype.toJSON = function toJSON() {
        var _this5 = this;

        return {
            _id: this._id,
            type: this.type,
            seats: this.seats.map(function (seat, i) {
                return seat.toJSON(true, _this5.getSeatRowLabel(i));
            }),
            pos: {
                x: this.moveableContainer.position.x,
                y: this.moveableContainer.position.y
            },
            globalPos: {
                x: this.moveableContainer.getGlobalPosition().x,
                y: this.moveableContainer.getGlobalPosition().y
            },
            tableId: this.tableId,
            label: this.label,
            name: "",
            sectionId: this.sectionId,
            ticketIds: this.ticketIds,
            locked: this.locked,
            bookByTable: this.bookByTable,
            seatsPerRow: this.seatsPerRow,
            numberOfRows: this.numberOfRows,
            xSeatSeperationSpace: this.xSeatSeperationSpace,
            ySeatSeperationSpace: this.ySeatSeperationSpace,
            rowLabels: this.rowLabels,
            rotation: this.moveableContainer.rotation,
            pivot: { x: this.moveableContainer.pivot.x, y: this.moveableContainer.pivot.y },
            seatLabelRight: this.seatLabelRight,
            seatlabelStartAt: this.seatlabelStartAt,
            rowOffset: this.rowOffset,
            rowNumberStartAt: this.rowNumberStartAt
        };
    };

    Rows.prototype.getPoints = function getPoints() {
        var _getRowBounds = this.getRowBounds(),
            x = _getRowBounds.x,
            y = _getRowBounds.y,
            width = _getRowBounds.width,
            height = _getRowBounds.height;

        return this.pointsBetween(x, y, width, height);
    };

    Rows.prototype.calcRotTransPoint = function calcRotTransPoint(x1, y1, x0, y0) {
        var rotPoint = this.applyCurrentRotation(x1, y1);
        return { x: rotPoint.x + x0, y: rotPoint.y + y0 };
    };

    Rows.prototype.pointsBetween = function pointsBetween(x, y, width, height) {
        var points = [];
        var amountBetween = 10;
        for (var i = 0; i <= amountBetween; i++) {
            var newPos = this.calcRotTransPoint(-width / 2 + width * i / amountBetween, -height / 2, x, y);
            points.push([newPos.x, newPos.y]);
        }
        for (var i = 0; i <= amountBetween; i++) {
            var _newPos = this.calcRotTransPoint(width / 2, -height / 2 + height * i / amountBetween, x, y);
            points.push([_newPos.x, _newPos.y]);
        }
        for (var i = 0; i <= amountBetween; i++) {
            var _newPos2 = this.calcRotTransPoint(-width / 2 + width - i * width / amountBetween, height / 2, x, y);
            points.push([_newPos2.x, _newPos2.y]);
        }
        for (var i = 0; i <= amountBetween; i++) {
            var _newPos3 = this.calcRotTransPoint(-width / 2, height / 2 - height * i / amountBetween, x, y);
            points.push([_newPos3.x, _newPos3.y]);
        }
        return points;
    };

    Rows.prototype.getSeatPos = function getSeatPos(i, seatCount) {
        var rowNumber = Math.floor(i / this.seatsPerRow);
        var seatXoffset = i % this.seatsPerRow;
        var seatYoffset = Math.floor(i / this.seatsPerRow);
        var xSpace = seatXoffset !== 0 ? this.xSeatSeperationSpace : 0;
        var ySpace = seatYoffset !== 0 ? this.ySeatSeperationSpace : 0;
        var posX = (Utils_1.seatWidth + xSpace) * seatXoffset + this.rowOffset[rowNumber] * Utils_1.seatWidth;
        var posY = (Utils_1.seatHeight + ySpace) * seatYoffset;
        return { x: posX, y: posY };
    };

    Rows.prototype.getRows = function getRows() {
        var _this6 = this;

        var rows = [];
        this.seats.forEach(function (seat, i) {
            var rowNum = Math.floor(i / _this6.seatsPerRow);
            if (i % _this6.seatsPerRow === 0) {
                rows.push({ rowLabel: _this6.rowLabels[rowNum], seats: [], rowOffset: _this6.rowOffset[rowNum], rowNumberStartAt: _this6.rowNumberStartAt[rowNum] });
            }
            rows[rowNum].seats.push(seat);
        });
        return rows.map(function (row) {
            row.seats = row.seats.filter(function (seat) {
                return !seat.isDisabled();
            });
            return row;
        });
    };

    Rows.prototype.align = function align(alignType) {
        var oldSeatJSON = this.getCurrentSeatRef();
        var oldSeatsPerRow = this.seatsPerRow;
        switch (alignType) {
            case "left":
                this.alignLeftRight(false);
                break;
            case "right":
                this.alignLeftRight(true);
                break;
            case "center":
                this.alignCenter();
                break;
        }
        this.removeInvisibleColumns();
        return ActionTracker_1.default.constructUndoValue("align", this.undoMajorChange, [oldSeatsPerRow, oldSeatJSON]);
    };

    Rows.prototype.alignLeftRight = function alignLeftRight(isRight) {
        var _this7 = this;

        var _loop = function _loop() {
            var row = isRight ? [].concat(_this7.getRow(i)).reverse() : _this7.getRow(i);
            var furthestDisbaled = -1;
            row.forEach(function (seat, j) {
                if (!seat.isDisabled() && j !== 0 && furthestDisbaled !== -1) {
                    seat.disable(true, false, true);
                    row[furthestDisbaled].disable(false, false, false);
                    furthestDisbaled = row.reduce(function (c, s, index) {
                        if (s.isDisabled()) {
                            if (c === -1) {
                                return index;
                            }
                        }
                        return c;
                    }, -1);
                } else if (seat.isDisabled() && furthestDisbaled === -1) {
                    furthestDisbaled = j;
                }
            });
        };

        for (var i = 0; i < this.numberOfRows; i++) {
            _loop();
        }
        this.renderRowLabels();
    };

    Rows.prototype.alignCenter = function alignCenter() {
        for (var i = 0; i < this.numberOfRows; i++) {
            var _row = this.getRow(i);
            var numOfDisabled = _row.filter(function (seat) {
                return seat.disabled;
            }).length;
            var numOfEnabledSeats = _row.length - numOfDisabled;
            var startFrom = Math.floor(numOfDisabled / 2);
            if (numOfEnabledSeats < _row.length) {
                _row.forEach(function (seat) {
                    return seat.disable(true, false, true);
                });
                for (var j = 0; j < numOfEnabledSeats; j++) {
                    var seat = _row[j + startFrom];
                    seat.disable(false, false, false);
                }
            }
        }
        this.renderRowLabels();
    };

    Rows.prototype.offSetRow = function offSetRow(rowLoc, offsetNumber) {
        var _this8 = this;

        var oldRow = this.getRow(rowLoc);
        if (offsetNumber > 0) {
            for (var i = 0; i < offsetNumber; i++) {
                this.changeSeatsPerRow(oldRow.length + 1, true);
            }
            var edgeNoLongerHasSeat = false;
            var _row2 = this.getRow(rowLoc);
            [].concat(_row2).reverse().forEach(function (seat, i) {
                if (!seat.isDisabled()) {
                    seat.disable(true, false, true);
                    _row2[_row2.length - 1 - i + offsetNumber].disable(false, true, false);
                    edgeNoLongerHasSeat = edgeNoLongerHasSeat || _row2.length - 1 - i === 0;
                }
            });
            if (edgeNoLongerHasSeat) {
                var leavingEmptyRow = true;
                for (var i = 0; i < this.numberOfRows; i++) {
                    var j = this.seatsPerRow * i;
                    leavingEmptyRow = leavingEmptyRow && this.seats[j].isDisabled();
                }
            }
        } else {
            for (var i = offsetNumber; i < 0; i++) {
                this.changeSeatsPerRow(oldRow.length + 1, true, true);
            }
            var _row3 = this.getRow(rowLoc);
            var edgeHasSeat = false;
            _row3.forEach(function (seat, i) {
                if (!seat.isDisabled()) {
                    seat.disable(true, false, true);
                    _row3[i + offsetNumber].disable(false, true, false);
                    edgeHasSeat = edgeHasSeat || i + offsetNumber % _this8.seatsPerRow === 0;
                }
            });
        }
        this.removeInvisibleColumns();
        this.renderRowLabels();
    };

    Rows.prototype.shift = function shift(left) {
        var rotation = this.moveableContainer.rotation;
        this.moveableContainer.rotation = 0;
        var x = this.moveableContainer.position.x;

        var newX = void 0;
        if (left) {
            newX = x - (Utils_1.seatWidth + this.xSeatSeperationSpace);
        } else {
            newX = x + (Utils_1.seatWidth + this.xSeatSeperationSpace);
        }
        this.moveableContainer.position.x = newX;
        this.moveableContainer.rotation = rotation;
    };

    Rows.prototype.updateRowLength = function updateRowLength(rowLoc, num) {
        var oldRow = this.getRow(rowLoc);
        var oldNum = oldRow.filter(function (seat) {
            return !seat.isDisabled();
        }).length;
        var undoValue = ActionTracker_1.default.constructUndoValue("updateRowLength", this.updateRowLength, [rowLoc, oldNum]);
        var isIncrease = num > oldNum;
        if (num > this.seatsPerRow || !oldRow[oldRow.length - 1].isDisabled() && isIncrease) {
            this.changeSeatsPerRow(oldRow.length + 1, true);
        }
        var row = this.getRow(rowLoc);
        if (isIncrease) {
            var loc = void 0;
            [].concat(row).reverse().forEach(function (seat, i) {
                if (!loc && !seat.isDisabled()) {
                    loc = row.length - i;
                }
            });
            if (!loc) {
                loc = 0;
            }
            row[loc].disable(false, true, true);
        } else {
            var _loc = void 0;
            [].concat(row).reverse().forEach(function (seat, i) {
                if (!_loc && !seat.isDisabled()) {
                    _loc = row.length - 1 - i;
                }
            });
            row[_loc].disable(true, true, true);
        }
        this.renderRowLabels();
        this.onChange();
        return undoValue;
    };

    Rows.prototype.getRow = function getRow(rowLoc) {
        var startIndex = rowLoc * this.seatsPerRow;
        var endIndex = rowLoc * this.seatsPerRow + this.seatsPerRow;
        return this.seats.slice(startIndex, endIndex);
    };

    Rows.prototype.getSelectionBoxBounds = function getSelectionBoxBounds() {
        var offset = this.actions.getOffset();

        var _getRowBounds2 = this.getRowBounds(),
            x = _getRowBounds2.x,
            y = _getRowBounds2.y,
            width = _getRowBounds2.width,
            height = _getRowBounds2.height;

        var newPos = this.calcRotTransPoint(-width / 2 - 27, -height / 2 - 27, x, y);
        var newPosRight = this.calcRotTransPoint(width / 2 + 10, -height / 2 - 27, x, y);
        return { x: newPos.x + offset.x, y: newPos.y + offset.y, width: width, height: height, left: { x: newPos.x + offset.x, y: newPos.y + offset.y }, right: { x: newPosRight.x + offset.x, y: newPosRight.y + offset.y } };
    };

    Rows.prototype.getRowBounds = function getRowBounds() {
        var numberOfRows = Math.floor(this.seats.length / this.seatsPerRow);
        var width = (Utils_1.seatWidth + this.xSeatSeperationSpace) * this.seatsPerRow;
        var height = numberOfRows * (Utils_1.seatHeight + this.ySeatSeperationSpace);
        var x = this.moveableContainer.position.x;
        var y = this.moveableContainer.position.y;
        return { x: x, y: y, width: width, height: height };
    };

    Rows.prototype.changeSeatsPerRow = function changeSeatsPerRow(num) {
        var allDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var appendToEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isUndoableAction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var seatData = { disabled: allDisabled, reserved: false, locked: false, tableSelected: true };
        var undoValue = ActionTracker_1.default.constructUndoValue("changeSeatsPerRow", this.changeSeatsPerRow, [this.seatsPerRow, false, false, true]);
        if (this.seatsPerRow < num) {
            var diff = num - this.seatsPerRow;
            this.addSeatsPerRow(seatData, diff, num, appendToEnd);
        } else {
            var _diff = this.seatsPerRow - num;
            this.removeSeatsPerRow(_diff, num, appendToEnd);
        }
        this.seatsPerRow = num;
        this.setSeatLabel();
        this.renderRowLabels();
        this.updatePivot();
        this.onChange();
        if (isUndoableAction) {
            return undoValue;
        }
    };

    Rows.prototype.addSeatsPerRow = function addSeatsPerRow(seatData, num, newSeatsPerRow, addingToLeft) {
        var _this9 = this;

        seatData.pos = { x: -100, y: -100 };
        for (var i = 0; i < num; i++) {
            if (i > 0) {
                this.seatsPerRow = this.seatsPerRow + 1;
            }
            var seatsToAdd = [];
            var startAt = addingToLeft ? 0 : this.seatsPerRow;
            for (var j = startAt; addingToLeft ? j < this.seats.length : j <= this.seats.length; j = j + this.seatsPerRow) {
                seatData.seatId = this.seats.length;
                seatData.seatlabelStartAt = this.seatlabelStartAt;
                var newSeat = new Seat_1.default(seatData, this.actions);
                newSeat.setOnDisable(this.onDisable);
                seatsToAdd.push({ pos: j, seat: newSeat });
            }
            seatsToAdd.forEach(function (seatData, i) {
                var pos = seatData.pos,
                    seat = seatData.seat;

                _this9.seats.splice(pos + i, 0, seat);
                _this9.seatContainer.addChildAt(seat.getSeat(), pos + i);
            });
        }
        this.seatsPerRow = newSeatsPerRow;
        this.interactionManager.drawBounds(this);
        var seatCount = this.seats.length;
        this.seats.forEach(function (seat, i) {
            seat.setPos(_this9.getSeatPos(i, seatCount));
            seat.setSeatId(i);
        });
        this.updatePivot();
        this.renderRowLabels();
    };

    Rows.prototype.removeSeatsPerRow = function removeSeatsPerRow(num, newSeatsPerRow, removingFromLeft) {
        var _this10 = this;

        for (var i = 0; i < num; i++) {
            if (i > 0) {
                this.seatsPerRow = this.seatsPerRow - 1;
            }
            var seatsToRemove = [];
            var startAt = removingFromLeft ? 0 : this.seatsPerRow - 1;
            for (var j = startAt; removingFromLeft ? j < this.seats.length : j <= this.seats.length; j = j + this.seatsPerRow) {
                seatsToRemove.push({ pos: j });
            }
            seatsToRemove.forEach(function (seatData, i) {
                var pos = seatData.pos;

                _this10.seats.splice(pos - i, 1);
                _this10.seatContainer.removeChildAt(pos - i);
            });
        }
        this.seatsPerRow = newSeatsPerRow;
        this.interactionManager.drawBounds(this);
        var seatCount = this.seats.length;
        this.seats.forEach(function (seat, i) {
            seat.setPos(_this10.getSeatPos(i, seatCount));
            seat.setSeatId(i);
        });
        this.updatePivot();
        this.renderRowLabels();
    };

    Rows.prototype.changeNumberOfRows = function changeNumberOfRows(num) {
        var seatData = { disabled: false, reserved: false, locked: false, tableSelected: true };
        var undoValue = ActionTracker_1.default.constructUndoValue("changeNumberOfRows", this.changeNumberOfRows, [this.numberOfRows]);
        if (this.numberOfRows < num) {
            var diff = num - this.numberOfRows;
            this.addRows(seatData, diff);
        } else {
            var _diff2 = this.numberOfRows - num;
            this.removeRows(_diff2);
        }
        this.numberOfRows = num;
        this.renderRowLabels();
        this.updatePivot();
        this.setSeatLabel();
        this.onChange();
        return undoValue;
    };

    Rows.prototype.addRows = function addRows(seatData, num) {
        var _this11 = this;

        var subarray = [];
        var rowNumStartAtSub = [];
        for (var i = 0; i < num; i++) {
            subarray.push(0);
            if (this.seatlabelStartAt !== undefined) {
                rowNumStartAtSub.push(this.seatlabelStartAt);
            } else {
                rowNumStartAtSub.push(0);
            }
        }
        this.rowNumberStartAt = this.rowNumberStartAt.concat(rowNumStartAtSub);
        this.rowOffset = this.rowOffset.concat(subarray);
        _Table_1$default.prototype.addSeats.call(this, seatData, num * this.seatsPerRow);
        for (var i = 0; i < num; i++) {
            this.rowLabels.push(String.fromCharCode(65 + this.rowLabels.length));
        }
        this.seats.forEach(function (seat) {
            seat.setOnDisable(_this11.onDisable);
        });
        this.updatePivot();
    };

    Rows.prototype.changeRowLabel = function changeRowLabel(text, i) {
        var undoValue = ActionTracker_1.default.constructUndoValue("changeRowLabel", this.changeRowLabel, [this.rowLabels[i], i]);
        this.rowLabels[i] = text;
        this.renderRowLabels();
        this.onChange();
        return undoValue;
    };

    Rows.prototype.changeRowOffset = function changeRowOffset(num, i) {
        var _this12 = this;

        var undoValue = ActionTracker_1.default.constructUndoValue("changeRowOffset", this.changeRowOffset, [this.rowOffset[i], i]);
        this.rowOffset[i] = num;
        this.seats.forEach(function (seat, i) {
            return seat.setPos(_this12.getSeatPos(i, 0));
        });
        this.renderRowLabels();
        this.onChange();
        return undoValue;
    };

    Rows.prototype.setRowStartAt = function setRowStartAt(num, i) {
        var _this13 = this;

        var undoValue = ActionTracker_1.default.constructUndoValue("setRowStartAt", this.setRowStartAt, [this.rowNumberStartAt[i], i]);
        this.rowNumberStartAt[i] = num;
        this.updatePivot();
        this.updateRowStartAt();
        this.seats.forEach(function (seat, i) {
            return seat.setPos(_this13.getSeatPos(i, 0));
        });
        this.onChange();
        return undoValue;
    };

    Rows.prototype.updateRowStartAt = function updateRowStartAt() {
        var _this14 = this;

        this.seats.forEach(function (seat, i) {
            var j = Math.floor(i / _this14.seatsPerRow);
            var startAt = _this14.rowNumberStartAt[j];
            seat.setSeatLabelStartAt(startAt);
        });
    };

    Rows.prototype.removeRows = function removeRows(num) {
        this.rowLabels.pop();
        _Table_1$default.prototype.removeSeats.call(this, num * this.seatsPerRow);
    };

    Rows.prototype.setSeatLabelOrder = function setSeatLabelOrder(seatLabelRight) {
        var undoVal = ActionTracker_1.default.constructUndoValue("setSeatLabelOrder", this.setSeatLabelOrder, [this.seatLabelRight]);
        this.seatLabelRight = seatLabelRight;
        this.setSeatLabel();
        this.onChange();
        return undoVal;
    };

    Rows.prototype.setSeatLabel = function setSeatLabel() {
        var _this15 = this;

        this.seats.forEach(function (seat, i) {
            var num = void 0;
            if (_this15.seatLabelRight) {
                num = (_this15.seats.length - 1 - i) % _this15.seatsPerRow;
            } else {
                num = i % _this15.seatsPerRow;
            }
            seat.setLabelOverride(num);
        });
    };

    Rows.prototype.move = function move(e) {
        this.seats.forEach(function (seat) {
            return seat.disableNextClick();
        });
        _Table_1$default.prototype.move.call(this, e);
    };

    Rows.prototype.onDisable = function onDisable() {
        this.removeInvisibleColumns();
    };

    Rows.prototype.removeInvisibleColumns = function removeInvisibleColumns() {
        var isInvisible = true;
        for (var i = 0; i < this.numberOfRows; i++) {
            var j = this.seatsPerRow - 1 + this.seatsPerRow * i;
            isInvisible = isInvisible && this.seats[j].isDisabled();
        }
        if (isInvisible) {
            this.changeSeatsPerRow(this.seatsPerRow - 1);
        }
        isInvisible = true;
        for (var i = 0; i < this.numberOfRows; i++) {
            var _j = this.seatsPerRow * i;
            isInvisible = isInvisible && this.seats[_j].isDisabled();
        }
        if (isInvisible) {
            this.changeSeatsPerRow(this.seatsPerRow - 1, false, true);
        }
        this.updatePivot();
    };

    Rows.prototype.updatePivot = function updatePivot() {
        var updateTable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        this.moveableContainer.pivot.x = this.rowsContainer.width / 2;
        this.moveableContainer.pivot.y = this.rowsContainer.height / 2;
        if (updateTable) {
            this.onTableMoved();
        }
    };

    Rows.prototype.getSeatLabelStartAt = function getSeatLabelStartAt() {
        return this.seatlabelStartAt;
    };

    Rows.prototype.getSeatsBoundBy = function getSeatsBoundBy(p3, p4) {
        var _this16 = this;

        var _getRowBounds3 = this.getRowBounds(),
            x = _getRowBounds3.x,
            y = _getRowBounds3.y,
            width = _getRowBounds3.width,
            height = _getRowBounds3.height;

        var beginningXPos = -width / 2;
        var beginningYPos = -height / 2;
        var selectionPoints = [p3, { x: p4.x, y: p3.y }, p4, { x: p3.x, y: p4.y }].map(function (points) {
            return new SAT.Vector(points.x, points.y);
        });
        var selectionPolygon = new SAT.Polygon(new SAT.Vector(), selectionPoints);
        return this.seats.map(function (seat) {
            var seatPosition = seat.getPosition();
            var points = [];
            var leftTopCorner = _this16.calcRotTransPoint(beginningXPos + seatPosition.x, beginningYPos + seatPosition.y, x, y);
            points.push(new SAT.Vector(leftTopCorner.x, leftTopCorner.y));
            var rightTopCorner = _this16.calcRotTransPoint(beginningXPos + seatPosition.x + Utils_1.seatWidth, beginningYPos + seatPosition.y, x, y);
            points.push(new SAT.Vector(rightTopCorner.x, rightTopCorner.y));
            var rightBottomCorner = _this16.calcRotTransPoint(beginningXPos + seatPosition.x + Utils_1.seatWidth, beginningYPos + seatPosition.y + Utils_1.seatHeight, x, y);
            points.push(new SAT.Vector(rightBottomCorner.x, rightBottomCorner.y));
            var leftBottomCorner = _this16.calcRotTransPoint(beginningXPos + seatPosition.x, beginningYPos + seatPosition.y + Utils_1.seatHeight, x, y);
            points.push(new SAT.Vector(leftBottomCorner.x, leftBottomCorner.y));
            var seatPolygon = new SAT.Polygon(new SAT.Vector(), points);
            if (SAT.testPolygonPolygon(selectionPolygon, seatPolygon)) {
                seat.select();
                return seat;
            }
        }).filter(function (seat) {
            return seat;
        });
    };

    Rows.prototype.updateTexture = function updateTexture() {};

    Rows.prototype.setTableLabel = function setTableLabel() {};

    Rows.prototype.getCurrentSeatRef = function getCurrentSeatRef() {
        var _this17 = this;

        return {
            seatRef: [].concat(this.seats),
            seatJSON: this.seats.map(function (seat, i) {
                return seat.toJSON(true, _this17.getSeatRowLabel(i));
            })
        };
    };

    Rows.prototype.undoMajorChange = function undoMajorChange(seatsPerRow, _ref2) {
        var _this18 = this;

        var seatRef = _ref2.seatRef,
            seatJSON = _ref2.seatJSON;

        var oldSeatData = this.getCurrentSeatRef();
        var oldSeatsPerRow = this.seatsPerRow;
        this.seatsPerRow = seatsPerRow;
        this.seatContainer.removeChildren();
        this.seats = seatRef.map(function (seat, i) {
            seat.setState(seatJSON[i]);
            _this18.seatContainer.addChild(seat.getSeat());
            return seat;
        });
        this.removeInvisibleColumns();
        this.setSeatLabel();
        this.renderRowLabels();
        return ActionTracker_1.default.constructUndoValue("undoMajorChange", this.undoMajorChange, [oldSeatsPerRow, oldSeatData]);
    };

    return Rows;
}(Table_1.default);

__decorate([bound_1.default], Rows.prototype, "tableContainerInit", null);
__decorate([bound_1.default], Rows.prototype, "renderRowLabels", null);
__decorate([bound_1.default], Rows.prototype, "toJSON", null);
__decorate([bound_1.default], Rows.prototype, "getPoints", null);
__decorate([bound_1.default], Rows.prototype, "getSeatPos", null);
__decorate([bound_1.default], Rows.prototype, "getRows", null);
__decorate([bound_1.default], Rows.prototype, "align", null);
__decorate([bound_1.default], Rows.prototype, "alignLeftRight", null);
__decorate([bound_1.default], Rows.prototype, "alignCenter", null);
__decorate([bound_1.default], Rows.prototype, "offSetRow", null);
__decorate([bound_1.default], Rows.prototype, "shift", null);
__decorate([bound_1.default], Rows.prototype, "updateRowLength", null);
__decorate([bound_1.default], Rows.prototype, "getRow", null);
__decorate([bound_1.default], Rows.prototype, "getSelectionBoxBounds", null);
__decorate([bound_1.default], Rows.prototype, "getRowBounds", null);
__decorate([bound_1.default], Rows.prototype, "changeSeatsPerRow", null);
__decorate([bound_1.default], Rows.prototype, "addSeatsPerRow", null);
__decorate([bound_1.default], Rows.prototype, "removeSeatsPerRow", null);
__decorate([bound_1.default], Rows.prototype, "changeNumberOfRows", null);
__decorate([bound_1.default], Rows.prototype, "addRows", null);
__decorate([bound_1.default], Rows.prototype, "changeRowLabel", null);
__decorate([bound_1.default], Rows.prototype, "changeRowOffset", null);
__decorate([bound_1.default], Rows.prototype, "setRowStartAt", null);
__decorate([bound_1.default], Rows.prototype, "removeRows", null);
__decorate([bound_1.default], Rows.prototype, "setSeatLabelOrder", null);
__decorate([bound_1.default], Rows.prototype, "setSeatLabel", null);
__decorate([bound_1.default], Rows.prototype, "onDisable", null);
__decorate([bound_1.default], Rows.prototype, "removeInvisibleColumns", null);
__decorate([bound_1.default], Rows.prototype, "getSeatLabelStartAt", null);
__decorate([bound_1.default], Rows.prototype, "updateTexture", null);
__decorate([bound_1.default], Rows.prototype, "setTableLabel", null);
__decorate([bound_1.default], Rows.prototype, "getCurrentSeatRef", null);
__decorate([bound_1.default], Rows.prototype, "undoMajorChange", null);
exports.default = Rows;
//# sourceMappingURL=Rows.js.map

/***/ }),

/***/ "O70i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.calculateScreenSpaceMatrix = calculateScreenSpaceMatrix;
exports.calculateNormalizedScreenSpaceMatrix = calculateNormalizedScreenSpaceMatrix;
exports.calculateSpriteMatrix = calculateSpriteMatrix;

var _math = __webpack_require__("e3iB");

/**
 * Calculates the mapped matrix
 * @param filterArea {Rectangle} The filter area
 * @param sprite {Sprite} the target sprite
 * @param outputMatrix {Matrix} @alvin
 * @private
 */
// TODO playing around here.. this is temporary - (will end up in the shader)
// this returns a matrix that will normalise map filter cords in the filter to screen space
function calculateScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
    // let worldTransform = sprite.worldTransform.copy(Matrix.TEMP_MATRIX),
    // let texture = {width:1136, height:700};//sprite._texture.baseTexture;

    // TODO unwrap?
    var mappedMatrix = outputMatrix.identity();

    mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);

    mappedMatrix.scale(textureSize.width, textureSize.height);

    return mappedMatrix;
}

function calculateNormalizedScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
    var mappedMatrix = outputMatrix.identity();

    mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);

    var translateScaleX = textureSize.width / filterArea.width;
    var translateScaleY = textureSize.height / filterArea.height;

    mappedMatrix.scale(translateScaleX, translateScaleY);

    return mappedMatrix;
}

// this will map the filter coord so that a texture can be used based on the transform of a sprite
function calculateSpriteMatrix(outputMatrix, filterArea, textureSize, sprite) {
    var orig = sprite._texture.orig;
    var mappedMatrix = outputMatrix.set(textureSize.width, 0, 0, textureSize.height, filterArea.x, filterArea.y);
    var worldTransform = sprite.worldTransform.copy(_math.Matrix.TEMP_MATRIX);

    worldTransform.invert();
    mappedMatrix.prepend(worldTransform);
    mappedMatrix.scale(1.0 / orig.width, 1.0 / orig.height);
    mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);

    return mappedMatrix;
}
//# sourceMappingURL=filterTransforms.js.map

/***/ }),

/***/ "OCym":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Seat_1 = __webpack_require__("cC7r");
var Utils_1 = __webpack_require__("o6Mn");
var Table_1 = __webpack_require__("QfCP");
var bound_1 = __webpack_require__("USDo");

var Table = function (_Table_1$default) {
    _inherits(Table, _Table_1$default);

    function Table() {
        _classCallCheck(this, Table);

        return _possibleConstructorReturn(this, _Table_1$default.apply(this, arguments));
    }

    Table.prototype.draw = function draw() {
        this.setScales(this.seatData);
        this.tableInit(this.pos);
        this.seats = this.seatsInit(this.seatData, this.actions);
        this.seatContainer = this.getSeatContainer(this.pos);
        this.tableContainerInit(this.pos);
    };

    Table.prototype.determineTextureType = function determineTextureType() {
        var currentTexture = Utils_1.circleTableUnassignedTexture;
        this.text.fill = 0x000000;
        this.tableTexture = PIXI.loader.resources[currentTexture].texture;
        this.tableTexture.baseTexture.mipmap = true;
    };

    Table.prototype.seatsInit = function seatsInit(seats, disableInteraction) {
        var _this2 = this;

        var seatCount = seats.length;
        return seats.map(function (seat, i) {
            var constructionValue = _extends({ pos: _this2.getSeatPos(i, seatCount), seatlabelStartAt: _this2.seatlabelStartAt, bookByTable: _this2.bookByTable, tableId: _this2._id, sectionId: _this2.sectionId, sectionName: _this2.sectionName, tableName: _this2.name }, seat);
            return new Seat_1.default(constructionValue, {}, disableInteraction);
        });
    };

    return Table;
}(Table_1.default);

__decorate([bound_1.default], Table.prototype, "seatsInit", null);
exports.default = Table;
//# sourceMappingURL=Table.js.map

/***/ }),

/***/ "OOwQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLManager2 = __webpack_require__("ClQe");

var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

var _SpriteMaskFilter = __webpack_require__("VuLC");

var _SpriteMaskFilter2 = _interopRequireDefault(_SpriteMaskFilter);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * @class
 * @extends PIXI.WebGLManager
 * @memberof PIXI
 */
var MaskManager = function (_WebGLManager) {
    _inherits(MaskManager, _WebGLManager);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
     */
    function MaskManager(renderer) {
        _classCallCheck(this, MaskManager);

        // TODO - we don't need both!
        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));

        _this.scissor = false;
        _this.scissorData = null;
        _this.scissorRenderTarget = null;

        _this.enableScissor = true;

        _this.alphaMaskPool = [];
        _this.alphaMaskIndex = 0;
        return _this;
    }

    /**
     * Applies the Mask and adds it to the current filter stack.
     *
     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
     */

    MaskManager.prototype.pushMask = function pushMask(target, maskData) {
        // TODO the root check means scissor rect will not
        // be used on render textures more info here:
        // https://github.com/pixijs/pixi.js/pull/3545

        if (maskData.texture) {
            this.pushSpriteMask(target, maskData);
        } else if (this.enableScissor && !this.scissor && this.renderer._activeRenderTarget.root && !this.renderer.stencilManager.stencilMaskStack.length && maskData.isFastRect()) {
            var matrix = maskData.worldTransform;

            var rot = Math.atan2(matrix.b, matrix.a);

            // use the nearest degree!
            rot = Math.round(rot * (180 / Math.PI));

            if (rot % 90) {
                this.pushStencilMask(maskData);
            } else {
                this.pushScissorMask(target, maskData);
            }
        } else {
            this.pushStencilMask(maskData);
        }
    };

    /**
     * Removes the last mask from the mask stack and doesn't return it.
     *
     * @param {PIXI.DisplayObject} target - Display Object to pop the mask from
     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
     */

    MaskManager.prototype.popMask = function popMask(target, maskData) {
        if (maskData.texture) {
            this.popSpriteMask(target, maskData);
        } else if (this.enableScissor && !this.renderer.stencilManager.stencilMaskStack.length) {
            this.popScissorMask(target, maskData);
        } else {
            this.popStencilMask(target, maskData);
        }
    };

    /**
     * Applies the Mask and adds it to the current filter stack.
     *
     * @param {PIXI.RenderTarget} target - Display Object to push the sprite mask to
     * @param {PIXI.Sprite} maskData - Sprite to be used as the mask
     */

    MaskManager.prototype.pushSpriteMask = function pushSpriteMask(target, maskData) {
        var alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex];

        if (!alphaMaskFilter) {
            alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [new _SpriteMaskFilter2.default(maskData)];
        }

        alphaMaskFilter[0].resolution = this.renderer.resolution;
        alphaMaskFilter[0].maskSprite = maskData;

        var stashFilterArea = target.filterArea;

        target.filterArea = maskData.getBounds(true);
        this.renderer.filterManager.pushFilter(target, alphaMaskFilter);
        target.filterArea = stashFilterArea;

        this.alphaMaskIndex++;
    };

    /**
     * Removes the last filter from the filter stack and doesn't return it.
     *
     */

    MaskManager.prototype.popSpriteMask = function popSpriteMask() {
        this.renderer.filterManager.popFilter();
        this.alphaMaskIndex--;
    };

    /**
     * Applies the Mask and adds it to the current filter stack.
     *
     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
     */

    MaskManager.prototype.pushStencilMask = function pushStencilMask(maskData) {
        this.renderer.currentRenderer.stop();
        this.renderer.stencilManager.pushStencil(maskData);
    };

    /**
     * Removes the last filter from the filter stack and doesn't return it.
     *
     */

    MaskManager.prototype.popStencilMask = function popStencilMask() {
        this.renderer.currentRenderer.stop();
        this.renderer.stencilManager.popStencil();
    };

    /**
     *
     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
     * @param {PIXI.Graphics} maskData - The masking data.
     */

    MaskManager.prototype.pushScissorMask = function pushScissorMask(target, maskData) {
        maskData.renderable = true;

        var renderTarget = this.renderer._activeRenderTarget;

        var bounds = maskData.getBounds();

        bounds.fit(renderTarget.size);
        maskData.renderable = false;

        this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST);

        var resolution = this.renderer.resolution;

        this.renderer.gl.scissor(bounds.x * resolution, (renderTarget.root ? renderTarget.size.height - bounds.y - bounds.height : bounds.y) * resolution, bounds.width * resolution, bounds.height * resolution);

        this.scissorRenderTarget = renderTarget;
        this.scissorData = maskData;
        this.scissor = true;
    };

    /**
     *
     *
     */

    MaskManager.prototype.popScissorMask = function popScissorMask() {
        this.scissorRenderTarget = null;
        this.scissorData = null;
        this.scissor = false;

        // must be scissor!
        var gl = this.renderer.gl;

        gl.disable(gl.SCISSOR_TEST);
    };

    return MaskManager;
}(_WebGLManager3.default);

exports.default = MaskManager;
//# sourceMappingURL=MaskManager.js.map

/***/ }),

/***/ "OQY8":
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

!function (e, t) {
	 true ? module.exports = t(__webpack_require__("eW0v")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports["react-google-map"] = t(require("react")) : e["react-google-map"] = t(e.React);
}(this, function (e) {
	return function (e) {
		function t(r) {
			if (n[r]) return n[r].exports;var o = n[r] = { exports: {}, id: r, loaded: !1 };return e[r].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
		}var n = {};return t.m = e, t.c = n, t.p = "", t(0);
	}([function (e, t, n) {
		"use strict";
		function r(e) {
			return e && e.__esModule ? e : { default: e };
		}function o(e) {
			if (Array.isArray(e)) {
				for (var t = 0, n = Array(e.length); t < e.length; t++) {
					n[t] = e[t];
				}return n;
			}return Array.from(e);
		}function a(e, t) {
			var n = {};for (var r in e) {
				t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
			}return n;
		}function i(e, t) {
			if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
		}function u(e, t) {
			if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != typeof t && "function" != typeof t ? e : t;
		}function s(e, t) {
			if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
		}Object.defineProperty(t, "__esModule", { value: !0 });var c = Object.assign || function (e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];for (var r in n) {
					Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
				}
			}return e;
		},
		    f = function () {
			function e(e, t) {
				for (var n = 0; n < t.length; n++) {
					var r = t[n];r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
				}
			}return function (t, n, r) {
				return n && e(t.prototype, n), r && e(t, r), t;
			};
		}(),
		    l = n(10),
		    p = r(l),
		    d = n(11),
		    y = r(d),
		    v = { position: "relative", overflow: "hidden", height: "100%", width: "100%" },
		    h = function (e) {
			function t() {
				i(this, t);var e = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));return e.state = { map: null, markers: new Map() }, e;
			}return s(t, e), f(t, [{ key: "componentDidMount", value: function value() {
					var e = this,
					    t = this.props,
					    n = t.coordinates,
					    r = t.googleMaps,
					    o = t.onLoaded,
					    i = a(t, ["coordinates", "googleMaps", "onLoaded"]),
					    u = new r.Map(this.ref_map, c({}, i));this.setState({ map: u }, function () {
						e.addNewMarkers(n);
					}), o && o(r, u);
				} }, { key: "componentWillReceiveProps", value: function value(e) {
					var t = this,
					    n = e.coordinates.some(function (e) {
						return !t.state.markers.has(t.getMarkerId(e));
					}),
					    r = [].concat(o(this.state.markers.keys())).some(function (n) {
						return !e.coordinates.some(function (e) {
							return n === t.getMarkerId(e);
						});
					});r && this.removeOldMarkers(e.coordinates), n && this.addNewMarkers(e.coordinates);
				} }, { key: "shouldComponentUpdate", value: function value(e, t) {
					return this.props.coordinates.length !== e.coordinates.length;
				} }, { key: "getMarkerId", value: function value(e) {
					return e.position.lat + "_" + e.position.lng;
				} }, { key: "removeOldMarkers", value: function value(e) {
					var t = this,
					    n = this.state.markers,
					    r = this.props.autoFitBounds;n.forEach(function (r, o) {
						var a = e.some(function (e) {
							return t.getMarkerId(e) === o;
						});a || (r.setMap(null), n.delete(o));
					}), this.setState({ markers: n }), r && this.fitBounds();
				} }, { key: "addNewMarkers", value: function value(e) {
					var t = this,
					    n = this.state.markers,
					    r = this.props.autoFitBounds;e.forEach(function (e) {
						var r = t.getMarkerId(e);n.has(r) || n.set(r, t.addMarker(r, e));
					}), this.setState({ markers: n }), r && this.fitBounds();
				} }, { key: "addMarker", value: function value(e, t) {
					var n = this.state.map,
					    r = this.props.googleMaps,
					    o = t.onLoaded,
					    i = a(t, ["onLoaded"]),
					    u = new r.Marker(c({ map: n }, i));return o && o(r, n, u), u;
				} }, { key: "fitBounds", value: function value() {
					var e = this.state,
					    t = e.map,
					    n = e.markers,
					    r = this.props,
					    o = r.boundsOffset,
					    a = r.googleMaps;if (t && 0 !== n.size) {
						var i = Array.from(n.values()).reduce(function (e, t) {
							return e.extend(t.getPosition());
						}, new a.LatLngBounds()),
						    u = i.getCenter();i.extend(new a.LatLng(u.lat() + o, u.lng() + o)).extend(new a.LatLng(u.lat() - o, u.lng() - o)), t.setCenter(u), t.fitBounds(i);
					}
				} }, { key: "render", value: function value() {
					var e = this;return y.default.createElement("div", { ref: function ref(t) {
							return e.ref_map = t;
						}, style: v });
				} }]), t;
		}(y.default.Component);h.propTypes = { autoFitBounds: p.default.bool, boundsOffset: p.default.number, coordinates: p.default.arrayOf(p.default.shape({ onLoaded: p.default.func })), googleMaps: p.default.object.isRequired, onLoaded: p.default.func }, h.defaultProps = { autoFitBounds: !1, boundsOffset: .002, coordinates: [], onLoaded: null }, t.default = h;
	}, function (e, t) {
		function n() {
			throw new Error("setTimeout has not been defined");
		}function r() {
			throw new Error("clearTimeout has not been defined");
		}function o(e) {
			if (f === setTimeout) return setTimeout(e, 0);if ((f === n || !f) && setTimeout) return f = setTimeout, setTimeout(e, 0);try {
				return f(e, 0);
			} catch (t) {
				try {
					return f.call(null, e, 0);
				} catch (t) {
					return f.call(this, e, 0);
				}
			}
		}function a(e) {
			if (l === clearTimeout) return clearTimeout(e);if ((l === r || !l) && clearTimeout) return l = clearTimeout, clearTimeout(e);try {
				return l(e);
			} catch (t) {
				try {
					return l.call(null, e);
				} catch (t) {
					return l.call(this, e);
				}
			}
		}function i() {
			v && d && (v = !1, d.length ? y = d.concat(y) : h = -1, y.length && u());
		}function u() {
			if (!v) {
				var e = o(i);v = !0;for (var t = y.length; t;) {
					for (d = y, y = []; ++h < t;) {
						d && d[h].run();
					}h = -1, t = y.length;
				}d = null, v = !1, a(e);
			}
		}function s(e, t) {
			this.fun = e, this.array = t;
		}function c() {}var f,
		    l,
		    p = e.exports = {};!function () {
			try {
				f = "function" == typeof setTimeout ? setTimeout : n;
			} catch (e) {
				f = n;
			}try {
				l = "function" == typeof clearTimeout ? clearTimeout : r;
			} catch (e) {
				l = r;
			}
		}();var d,
		    y = [],
		    v = !1,
		    h = -1;p.nextTick = function (e) {
			var t = new Array(arguments.length - 1);if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
				t[n - 1] = arguments[n];
			}y.push(new s(e, t)), 1 !== y.length || v || o(u);
		}, s.prototype.run = function () {
			this.fun.apply(null, this.array);
		}, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = c, p.addListener = c, p.once = c, p.off = c, p.removeListener = c, p.removeAllListeners = c, p.emit = c, p.prependListener = c, p.prependOnceListener = c, p.listeners = function (e) {
			return [];
		}, p.binding = function (e) {
			throw new Error("process.binding is not supported");
		}, p.cwd = function () {
			return "/";
		}, p.chdir = function (e) {
			throw new Error("process.chdir is not supported");
		}, p.umask = function () {
			return 0;
		};
	}, function (e, t) {
		"use strict";
		function n(e) {
			return function () {
				return e;
			};
		}var r = function r() {};r.thatReturns = n, r.thatReturnsFalse = n(!1), r.thatReturnsTrue = n(!0), r.thatReturnsNull = n(null), r.thatReturnsThis = function () {
			return this;
		}, r.thatReturnsArgument = function (e) {
			return e;
		}, e.exports = r;
	}, function (e, t, n) {
		(function (t) {
			"use strict";
			function n(e, t, n, o, a, i, u, s) {
				if (r(t), !e) {
					var c;if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
						var f = [n, o, a, i, u, s],
						    l = 0;c = new Error(t.replace(/%s/g, function () {
							return f[l++];
						})), c.name = "Invariant Violation";
					}throw c.framesToPop = 1, c;
				}
			}var r = function r(e) {};"production" !== t.env.NODE_ENV && (r = function r(e) {
				if (void 0 === e) throw new Error("invariant requires an error message argument");
			}), e.exports = n;
		}).call(t, n(1));
	}, function (e, t) {
		"use strict";
		var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports = n;
	}, function (e, t, n) {
		(function (t) {
			"use strict";
			var r = n(2),
			    o = r;if ("production" !== t.env.NODE_ENV) {
				var a = function a(e) {
					for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
						n[r - 1] = arguments[r];
					}var o = 0,
					    a = "Warning: " + e.replace(/%s/g, function () {
						return n[o++];
					});"undefined" != typeof console && console.error(a);try {
						throw new Error(a);
					} catch (e) {}
				};o = function o(e, t) {
					if (void 0 === t) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if (0 !== t.indexOf("Failed Composite propType: ") && !e) {
						for (var n = arguments.length, r = Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) {
							r[o - 2] = arguments[o];
						}a.apply(void 0, [t].concat(r));
					}
				};
			}e.exports = o;
		}).call(t, n(1));
	}, function (e, t) {
		/*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
		"use strict";
		function n(e) {
			if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e);
		}function r() {
			try {
				if (!Object.assign) return !1;var e = new String("abc");if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;for (var t = {}, n = 0; n < 10; n++) {
					t["_" + String.fromCharCode(n)] = n;
				}var r = Object.getOwnPropertyNames(t).map(function (e) {
					return t[e];
				});if ("0123456789" !== r.join("")) return !1;var o = {};return "abcdefghijklmnopqrst".split("").forEach(function (e) {
					o[e] = e;
				}), "abcdefghijklmnopqrst" === Object.keys(_extends({}, o)).join("");
			} catch (e) {
				return !1;
			}
		}var o = Object.getOwnPropertySymbols,
		    a = Object.prototype.hasOwnProperty,
		    i = Object.prototype.propertyIsEnumerable;e.exports = r() ? Object.assign : function (e, t) {
			for (var r, u, s = n(e), c = 1; c < arguments.length; c++) {
				r = Object(arguments[c]);for (var f in r) {
					a.call(r, f) && (s[f] = r[f]);
				}if (o) {
					u = o(r);for (var l = 0; l < u.length; l++) {
						i.call(r, u[l]) && (s[u[l]] = r[u[l]]);
					}
				}
			}return s;
		};
	}, function (e, t, n) {
		(function (t) {
			"use strict";
			function r(e, n, r, s, c) {
				if ("production" !== t.env.NODE_ENV) for (var f in e) {
					if (e.hasOwnProperty(f)) {
						var l;try {
							o("function" == typeof e[f], "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", s || "React class", r, f, typeof e[f]), l = e[f](n, f, s, r, null, i);
						} catch (e) {
							l = e;
						}if (a(!l || l instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", s || "React class", r, f, typeof l), l instanceof Error && !(l.message in u)) {
							u[l.message] = !0;var p = c ? c() : "";a(!1, "Failed %s type: %s%s", r, l.message, null != p ? p : "");
						}
					}
				}
			}if ("production" !== t.env.NODE_ENV) var o = n(3),
			    a = n(5),
			    i = n(4),
			    u = {};e.exports = r;
		}).call(t, n(1));
	}, function (e, t, n) {
		"use strict";
		var r = n(2),
		    o = n(3),
		    a = n(4);e.exports = function () {
			function e(e, t, n, r, i, u) {
				u !== a && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
			}function t() {
				return e;
			}e.isRequired = e;var n = { array: e, bool: e, func: e, number: e, object: e, string: e, symbol: e, any: e, arrayOf: t, element: e, instanceOf: t, node: e, objectOf: t, oneOf: t, oneOfType: t, shape: t, exact: t };return n.checkPropTypes = r, n.PropTypes = n, n;
		};
	}, function (e, t, n) {
		(function (t) {
			"use strict";
			var r = n(2),
			    o = n(3),
			    a = n(5),
			    i = n(6),
			    u = n(4),
			    s = n(7);e.exports = function (e, n) {
				function c(e) {
					var t = e && (R && e[R] || e[M]);if ("function" == typeof t) return t;
				}function f(e, t) {
					return e === t ? 0 !== e || 1 / e === 1 / t : e !== e && t !== t;
				}function l(e) {
					this.message = e, this.stack = "";
				}function p(e) {
					function r(r, c, f, p, d, y, v) {
						if (p = p || I, y = y || f, v !== u) if (n) o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if ("production" !== t.env.NODE_ENV && "undefined" != typeof console) {
							var h = p + ":" + f;!i[h] && s < 3 && (a(!1, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", y, p), i[h] = !0, s++);
						}return null == c[f] ? r ? new l(null === c[f] ? "The " + d + " `" + y + "` is marked as required " + ("in `" + p + "`, but its value is `null`.") : "The " + d + " `" + y + "` is marked as required in " + ("`" + p + "`, but its value is `undefined`.")) : null : e(c, f, p, d, y);
					}if ("production" !== t.env.NODE_ENV) var i = {},
					    s = 0;var c = r.bind(null, !1);return c.isRequired = r.bind(null, !0), c;
				}function d(e) {
					function t(t, n, r, o, a, i) {
						var u = t[n],
						    s = E(u);if (s !== e) {
							var c = P(u);return new l("Invalid " + o + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."));
						}return null;
					}return p(t);
				}function y() {
					return p(r.thatReturnsNull);
				}function v(e) {
					function t(t, n, r, o, a) {
						if ("function" != typeof e) return new l("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");var i = t[n];if (!Array.isArray(i)) {
							var s = E(i);return new l("Invalid " + o + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected an array."));
						}for (var c = 0; c < i.length; c++) {
							var f = e(i, c, r, o, a + "[" + c + "]", u);if (f instanceof Error) return f;
						}return null;
					}return p(t);
				}function h() {
					function t(t, n, r, o, a) {
						var i = t[n];if (!e(i)) {
							var u = E(i);return new l("Invalid " + o + " `" + a + "` of type " + ("`" + u + "` supplied to `" + r + "`, expected a single ReactElement."));
						}return null;
					}return p(t);
				}function m(e) {
					function t(t, n, r, o, a) {
						if (!(t[n] instanceof e)) {
							var i = e.name || I,
							    u = N(t[n]);return new l("Invalid " + o + " `" + a + "` of type " + ("`" + u + "` supplied to `" + r + "`, expected ") + ("instance of `" + i + "`."));
						}return null;
					}return p(t);
				}function g(e) {
					function n(t, n, r, o, a) {
						for (var i = t[n], u = 0; u < e.length; u++) {
							if (f(i, e[u])) return null;
						}var s = JSON.stringify(e);return new l("Invalid " + o + " `" + a + "` of value `" + i + "` " + ("supplied to `" + r + "`, expected one of " + s + "."));
					}return Array.isArray(e) ? p(n) : ("production" !== t.env.NODE_ENV ? a(!1, "Invalid argument supplied to oneOf, expected an instance of array.") : void 0, r.thatReturnsNull);
				}function b(e) {
					function t(t, n, r, o, a) {
						if ("function" != typeof e) return new l("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");var i = t[n],
						    s = E(i);if ("object" !== s) return new l("Invalid " + o + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected an object."));for (var c in i) {
							if (i.hasOwnProperty(c)) {
								var f = e(i, c, r, o, a + "." + c, u);if (f instanceof Error) return f;
							}
						}return null;
					}return p(t);
				}function O(e) {
					function n(t, n, r, o, a) {
						for (var i = 0; i < e.length; i++) {
							var s = e[i];if (null == s(t, n, r, o, a, u)) return null;
						}return new l("Invalid " + o + " `" + a + "` supplied to " + ("`" + r + "`."));
					}if (!Array.isArray(e)) return "production" !== t.env.NODE_ENV ? a(!1, "Invalid argument supplied to oneOfType, expected an instance of array.") : void 0, r.thatReturnsNull;for (var o = 0; o < e.length; o++) {
						var i = e[o];if ("function" != typeof i) return a(!1, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", _(i), o), r.thatReturnsNull;
					}return p(n);
				}function w() {
					function e(e, t, n, r, o) {
						return j(e[t]) ? null : new l("Invalid " + r + " `" + o + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
					}return p(e);
				}function k(e) {
					function t(t, n, r, o, a) {
						var i = t[n],
						    s = E(i);if ("object" !== s) return new l("Invalid " + o + " `" + a + "` of type `" + s + "` " + ("supplied to `" + r + "`, expected `object`."));for (var c in e) {
							var f = e[c];if (f) {
								var p = f(i, c, r, o, a + "." + c, u);if (p) return p;
							}
						}return null;
					}return p(t);
				}function T(e) {
					function t(t, n, r, o, a) {
						var s = t[n],
						    c = E(s);if ("object" !== c) return new l("Invalid " + o + " `" + a + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));var f = i({}, t[n], e);for (var p in f) {
							var d = e[p];if (!d) return new l("Invalid " + o + " `" + a + "` key `" + p + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));var y = d(s, p, r, o, a + "." + p, u);if (y) return y;
						}return null;
					}return p(t);
				}function j(t) {
					switch (typeof t) {case "number":case "string":case "undefined":
							return !0;case "boolean":
							return !t;case "object":
							if (Array.isArray(t)) return t.every(j);if (null === t || e(t)) return !0;var n = c(t);if (!n) return !1;var r,
							    o = n.call(t);if (n !== t.entries) {
								for (; !(r = o.next()).done;) {
									if (!j(r.value)) return !1;
								}
							} else for (; !(r = o.next()).done;) {
								var a = r.value;if (a && !j(a[1])) return !1;
							}return !0;default:
							return !1;}
				}function x(e, t) {
					return "symbol" === e || "Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol;
				}function E(e) {
					var t = typeof e;return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : x(t, e) ? "symbol" : t;
				}function P(e) {
					if ("undefined" == typeof e || null === e) return "" + e;var t = E(e);if ("object" === t) {
						if (e instanceof Date) return "date";if (e instanceof RegExp) return "regexp";
					}return t;
				}function _(e) {
					var t = P(e);switch (t) {case "array":case "object":
							return "an " + t;case "boolean":case "date":case "regexp":
							return "a " + t;default:
							return t;}
				}function N(e) {
					return e.constructor && e.constructor.name ? e.constructor.name : I;
				}var R = "function" == typeof Symbol && Symbol.iterator,
				    M = "@@iterator",
				    I = "<<anonymous>>",
				    S = { array: d("array"), bool: d("boolean"), func: d("function"), number: d("number"), object: d("object"), string: d("string"), symbol: d("symbol"), any: y(), arrayOf: v, element: h(), instanceOf: m, node: w(), objectOf: b, oneOf: g, oneOfType: O, shape: k, exact: T };return l.prototype = Error.prototype, S.checkPropTypes = s, S.PropTypes = S, S;
			};
		}).call(t, n(1));
	}, function (e, t, n) {
		(function (t) {
			if ("production" !== t.env.NODE_ENV) {
				var r = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
				    o = function o(e) {
					return "object" == typeof e && null !== e && e.$$typeof === r;
				},
				    a = !0;e.exports = n(9)(o, a);
			} else e.exports = n(8)();
		}).call(t, n(1));
	}, function (t, n) {
		t.exports = e;
	}]);
});

/***/ }),

/***/ "OvAf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var buildURL = __webpack_require__("H6Qo");
var InterceptorManager = __webpack_require__("rj2i");
var dispatchRequest = __webpack_require__("uz6X");
var mergeConfig = __webpack_require__("2OHv");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);
  config.method = config.method ? config.method.toLowerCase() : 'get';

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),

/***/ "OzBO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _utils = __webpack_require__("dDI1");

var _DisplayObject2 = __webpack_require__("rGF6");

var _DisplayObject3 = _interopRequireDefault(_DisplayObject2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A Container represents a collection of display objects.
 * It is the base class of all display objects that act as a container for other objects.
 *
 *```js
 * let container = new PIXI.Container();
 * container.addChild(sprite);
 * ```
 *
 * @class
 * @extends PIXI.DisplayObject
 * @memberof PIXI
 */
var Container = function (_DisplayObject) {
    _inherits(Container, _DisplayObject);

    /**
     *
     */
    function Container() {
        _classCallCheck(this, Container);

        /**
         * The array of children of this container.
         *
         * @member {PIXI.DisplayObject[]}
         * @readonly
         */
        var _this = _possibleConstructorReturn(this, _DisplayObject.call(this));

        _this.children = [];
        return _this;
    }

    /**
     * Overridable method that can be used by Container subclasses whenever the children array is modified
     *
     * @private
     */

    Container.prototype.onChildrenChange = function onChildrenChange() {}
    /* empty */

    /**
     * Adds one or more children to the container.
     *
     * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
     *
     * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to add to the container
     * @return {PIXI.DisplayObject} The first child that was added.
     */
    ;

    Container.prototype.addChild = function addChild(child) {
        var argumentsLength = arguments.length;

        // if there is only one argument we can bypass looping through the them
        if (argumentsLength > 1) {
            // loop through the arguments property and add all children
            // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
            for (var i = 0; i < argumentsLength; i++) {
                this.addChild(arguments[i]);
            }
        } else {
            // if the child has a parent then lets remove it as PixiJS objects can only exist in one place
            if (child.parent) {
                child.parent.removeChild(child);
            }

            child.parent = this;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;

            this.children.push(child);

            // ensure bounds will be recalculated
            this._boundsID++;

            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange(this.children.length - 1);
            child.emit('added', this);
        }

        return child;
    };

    /**
     * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
     *
     * @param {PIXI.DisplayObject} child - The child to add
     * @param {number} index - The index to place the child in
     * @return {PIXI.DisplayObject} The child that was added.
     */

    Container.prototype.addChildAt = function addChildAt(child, index) {
        if (index < 0 || index > this.children.length) {
            throw new Error(child + 'addChildAt: The index ' + index + ' supplied is out of bounds ' + this.children.length);
        }

        if (child.parent) {
            child.parent.removeChild(child);
        }

        child.parent = this;
        // ensure child transform will be recalculated
        child.transform._parentID = -1;

        this.children.splice(index, 0, child);

        // ensure bounds will be recalculated
        this._boundsID++;

        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange(index);
        child.emit('added', this);

        return child;
    };

    /**
     * Swaps the position of 2 Display Objects within this container.
     *
     * @param {PIXI.DisplayObject} child - First display object to swap
     * @param {PIXI.DisplayObject} child2 - Second display object to swap
     */

    Container.prototype.swapChildren = function swapChildren(child, child2) {
        if (child === child2) {
            return;
        }

        var index1 = this.getChildIndex(child);
        var index2 = this.getChildIndex(child2);

        this.children[index1] = child2;
        this.children[index2] = child;
        this.onChildrenChange(index1 < index2 ? index1 : index2);
    };

    /**
     * Returns the index position of a child DisplayObject instance
     *
     * @param {PIXI.DisplayObject} child - The DisplayObject instance to identify
     * @return {number} The index position of the child display object to identify
     */

    Container.prototype.getChildIndex = function getChildIndex(child) {
        var index = this.children.indexOf(child);

        if (index === -1) {
            throw new Error('The supplied DisplayObject must be a child of the caller');
        }

        return index;
    };

    /**
     * Changes the position of an existing child in the display object container
     *
     * @param {PIXI.DisplayObject} child - The child DisplayObject instance for which you want to change the index number
     * @param {number} index - The resulting index number for the child display object
     */

    Container.prototype.setChildIndex = function setChildIndex(child, index) {
        if (index < 0 || index >= this.children.length) {
            throw new Error('The index ' + index + ' supplied is out of bounds ' + this.children.length);
        }

        var currentIndex = this.getChildIndex(child);

        (0, _utils.removeItems)(this.children, currentIndex, 1); // remove from old position
        this.children.splice(index, 0, child); // add at new position

        this.onChildrenChange(index);
    };

    /**
     * Returns the child at the specified index
     *
     * @param {number} index - The index to get the child at
     * @return {PIXI.DisplayObject} The child at the given index, if any.
     */

    Container.prototype.getChildAt = function getChildAt(index) {
        if (index < 0 || index >= this.children.length) {
            throw new Error('getChildAt: Index (' + index + ') does not exist.');
        }

        return this.children[index];
    };

    /**
     * Removes one or more children from the container.
     *
     * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to remove
     * @return {PIXI.DisplayObject} The first child that was removed.
     */

    Container.prototype.removeChild = function removeChild(child) {
        var argumentsLength = arguments.length;

        // if there is only one argument we can bypass looping through the them
        if (argumentsLength > 1) {
            // loop through the arguments property and add all children
            // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
            for (var i = 0; i < argumentsLength; i++) {
                this.removeChild(arguments[i]);
            }
        } else {
            var index = this.children.indexOf(child);

            if (index === -1) return null;

            child.parent = null;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;
            (0, _utils.removeItems)(this.children, index, 1);

            // ensure bounds will be recalculated
            this._boundsID++;

            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange(index);
            child.emit('removed', this);
        }

        return child;
    };

    /**
     * Removes a child from the specified index position.
     *
     * @param {number} index - The index to get the child from
     * @return {PIXI.DisplayObject} The child that was removed.
     */

    Container.prototype.removeChildAt = function removeChildAt(index) {
        var child = this.getChildAt(index);

        // ensure child transform will be recalculated..
        child.parent = null;
        child.transform._parentID = -1;
        (0, _utils.removeItems)(this.children, index, 1);

        // ensure bounds will be recalculated
        this._boundsID++;

        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange(index);
        child.emit('removed', this);

        return child;
    };

    /**
     * Removes all children from this container that are within the begin and end indexes.
     *
     * @param {number} [beginIndex=0] - The beginning position.
     * @param {number} [endIndex=this.children.length] - The ending position. Default value is size of the container.
     * @returns {DisplayObject[]} List of removed children
     */

    Container.prototype.removeChildren = function removeChildren() {
        var beginIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var endIndex = arguments[1];

        var begin = beginIndex;
        var end = typeof endIndex === 'number' ? endIndex : this.children.length;
        var range = end - begin;
        var removed = void 0;

        if (range > 0 && range <= end) {
            removed = this.children.splice(begin, range);

            for (var i = 0; i < removed.length; ++i) {
                removed[i].parent = null;
                if (removed[i].transform) {
                    removed[i].transform._parentID = -1;
                }
            }

            this._boundsID++;

            this.onChildrenChange(beginIndex);

            for (var _i = 0; _i < removed.length; ++_i) {
                removed[_i].emit('removed', this);
            }

            return removed;
        } else if (range === 0 && this.children.length === 0) {
            return [];
        }

        throw new RangeError('removeChildren: numeric values are outside the acceptable range.');
    };

    /**
     * Updates the transform on all children of this container for rendering
     */

    Container.prototype.updateTransform = function updateTransform() {
        this._boundsID++;

        this.transform.updateTransform(this.parent.transform);

        // TODO: check render flags, how to process stuff here
        this.worldAlpha = this.alpha * this.parent.worldAlpha;

        for (var i = 0, j = this.children.length; i < j; ++i) {
            var child = this.children[i];

            if (child.visible) {
                child.updateTransform();
            }
        }
    };

    /**
     * Recalculates the bounds of the container.
     *
     */

    Container.prototype.calculateBounds = function calculateBounds() {
        this._bounds.clear();

        this._calculateBounds();

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];

            if (!child.visible || !child.renderable) {
                continue;
            }

            child.calculateBounds();

            // TODO: filter+mask, need to mask both somehow
            if (child._mask) {
                child._mask.calculateBounds();
                this._bounds.addBoundsMask(child._bounds, child._mask._bounds);
            } else if (child.filterArea) {
                this._bounds.addBoundsArea(child._bounds, child.filterArea);
            } else {
                this._bounds.addBounds(child._bounds);
            }
        }

        this._lastBoundsID = this._boundsID;
    };

    /**
     * Recalculates the bounds of the object. Override this to
     * calculate the bounds of the specific object (not including children).
     *
     */

    Container.prototype._calculateBounds = function _calculateBounds() {}
    // FILL IN//


    /**
     * Renders the object using the WebGL renderer
     *
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */
    ;

    Container.prototype.renderWebGL = function renderWebGL(renderer) {
        // if the object is not visible or the alpha is 0 then no need to render this element
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
            return;
        }

        // do a quick check to see if this element has a mask or a filter.
        if (this._mask || this._filters) {
            this.renderAdvancedWebGL(renderer);
        } else {
            this._renderWebGL(renderer);

            // simple render children!
            for (var i = 0, j = this.children.length; i < j; ++i) {
                this.children[i].renderWebGL(renderer);
            }
        }
    };

    /**
     * Render the object using the WebGL renderer and advanced features.
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */

    Container.prototype.renderAdvancedWebGL = function renderAdvancedWebGL(renderer) {
        renderer.flush();

        var filters = this._filters;
        var mask = this._mask;

        // push filter first as we need to ensure the stencil buffer is correct for any masking
        if (filters) {
            if (!this._enabledFilters) {
                this._enabledFilters = [];
            }

            this._enabledFilters.length = 0;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].enabled) {
                    this._enabledFilters.push(filters[i]);
                }
            }

            if (this._enabledFilters.length) {
                renderer.filterManager.pushFilter(this, this._enabledFilters);
            }
        }

        if (mask) {
            renderer.maskManager.pushMask(this, this._mask);
        }

        // add this object to the batch, only rendered if it has a texture.
        this._renderWebGL(renderer);

        // now loop through the children and make sure they get rendered
        for (var _i2 = 0, j = this.children.length; _i2 < j; _i2++) {
            this.children[_i2].renderWebGL(renderer);
        }

        renderer.flush();

        if (mask) {
            renderer.maskManager.popMask(this, this._mask);
        }

        if (filters && this._enabledFilters && this._enabledFilters.length) {
            renderer.filterManager.popFilter();
        }
    };

    /**
     * To be overridden by the subclasses.
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */

    Container.prototype._renderWebGL = function _renderWebGL(renderer) // eslint-disable-line no-unused-vars
    {}
    // this is where content itself gets rendered...


    /**
     * To be overridden by the subclass
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The renderer
     */
    ;

    Container.prototype._renderCanvas = function _renderCanvas(renderer) // eslint-disable-line no-unused-vars
    {}
    // this is where content itself gets rendered...


    /**
     * Renders the object using the Canvas renderer
     *
     * @param {PIXI.CanvasRenderer} renderer - The renderer
     */
    ;

    Container.prototype.renderCanvas = function renderCanvas(renderer) {
        // if not visible or the alpha is 0 then no need to render this
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
            return;
        }

        if (this._mask) {
            renderer.maskManager.pushMask(this._mask);
        }

        this._renderCanvas(renderer);
        for (var i = 0, j = this.children.length; i < j; ++i) {
            this.children[i].renderCanvas(renderer);
        }

        if (this._mask) {
            renderer.maskManager.popMask(renderer);
        }
    };

    /**
     * Removes all internal references and listeners as well as removes children from the display list.
     * Do not use a Container after calling `destroy`.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *  method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */

    Container.prototype.destroy = function destroy(options) {
        _DisplayObject.prototype.destroy.call(this);

        var destroyChildren = typeof options === 'boolean' ? options : options && options.children;

        var oldChildren = this.removeChildren(0, this.children.length);

        if (destroyChildren) {
            for (var i = 0; i < oldChildren.length; ++i) {
                oldChildren[i].destroy(options);
            }
        }
    };

    /**
     * The width of the Container, setting this will actually modify the scale to achieve the value set
     *
     * @member {number}
     */

    _createClass(Container, [{
        key: 'width',
        get: function get() {
            return this.scale.x * this.getLocalBounds().width;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            var width = this.getLocalBounds().width;

            if (width !== 0) {
                this.scale.x = value / width;
            } else {
                this.scale.x = 1;
            }

            this._width = value;
        }

        /**
         * The height of the Container, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            return this.scale.y * this.getLocalBounds().height;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            var height = this.getLocalBounds().height;

            if (height !== 0) {
                this.scale.y = value / height;
            } else {
                this.scale.y = 1;
            }

            this._height = value;
        }
    }]);

    return Container;
}(_DisplayObject3.default);

// performance increase to avoid using call.. (10x faster)


exports.default = Container;
Container.prototype.containerUpdateTransform = Container.prototype.updateTransform;
//# sourceMappingURL=Container.js.map

/***/ }),

/***/ "PGIZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Matrix = __webpack_require__("dh7x");

var _Matrix2 = _interopRequireDefault(_Matrix);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var ux = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1]; // Your friendly neighbour https://en.wikipedia.org/wiki/Dihedral_group of order 16

var uy = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1];
var vx = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1];
var vy = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1];
var tempMatrices = [];

var mul = [];

function signum(x) {
    if (x < 0) {
        return -1;
    }
    if (x > 0) {
        return 1;
    }

    return 0;
}

function init() {
    for (var i = 0; i < 16; i++) {
        var row = [];

        mul.push(row);

        for (var j = 0; j < 16; j++) {
            var _ux = signum(ux[i] * ux[j] + vx[i] * uy[j]);
            var _uy = signum(uy[i] * ux[j] + vy[i] * uy[j]);
            var _vx = signum(ux[i] * vx[j] + vx[i] * vy[j]);
            var _vy = signum(uy[i] * vx[j] + vy[i] * vy[j]);

            for (var k = 0; k < 16; k++) {
                if (ux[k] === _ux && uy[k] === _uy && vx[k] === _vx && vy[k] === _vy) {
                    row.push(k);
                    break;
                }
            }
        }
    }

    for (var _i = 0; _i < 16; _i++) {
        var mat = new _Matrix2.default();

        mat.set(ux[_i], uy[_i], vx[_i], vy[_i], 0, 0);
        tempMatrices.push(mat);
    }
}

init();

/**
 * Implements Dihedral Group D_8, see [group D4]{@link http://mathworld.wolfram.com/DihedralGroupD4.html},
 * D8 is the same but with diagonals. Used for texture rotations.
 *
 * Vector xX(i), xY(i) is U-axis of sprite with rotation i
 * Vector yY(i), yY(i) is V-axis of sprite with rotation i
 * Rotations: 0 grad (0), 90 grad (2), 180 grad (4), 270 grad (6)
 * Mirrors: vertical (8), main diagonal (10), horizontal (12), reverse diagonal (14)
 * This is the small part of gameofbombs.com portal system. It works.
 *
 * @author Ivan @ivanpopelyshev
 * @class
 * @memberof PIXI
 */
var GroupD8 = {
    E: 0,
    SE: 1,
    S: 2,
    SW: 3,
    W: 4,
    NW: 5,
    N: 6,
    NE: 7,
    MIRROR_VERTICAL: 8,
    MIRROR_HORIZONTAL: 12,
    uX: function uX(ind) {
        return ux[ind];
    },
    uY: function uY(ind) {
        return uy[ind];
    },
    vX: function vX(ind) {
        return vx[ind];
    },
    vY: function vY(ind) {
        return vy[ind];
    },
    inv: function inv(rotation) {
        if (rotation & 8) {
            return rotation & 15;
        }

        return -rotation & 7;
    },
    add: function add(rotationSecond, rotationFirst) {
        return mul[rotationSecond][rotationFirst];
    },
    sub: function sub(rotationSecond, rotationFirst) {
        return mul[rotationSecond][GroupD8.inv(rotationFirst)];
    },

    /**
     * Adds 180 degrees to rotation. Commutative operation.
     *
     * @memberof PIXI.GroupD8
     * @param {number} rotation - The number to rotate.
     * @returns {number} rotated number
     */
    rotate180: function rotate180(rotation) {
        return rotation ^ 4;
    },

    /**
     * Direction of main vector can be horizontal, vertical or diagonal.
     * Some objects work with vertical directions different.
     *
     * @memberof PIXI.GroupD8
     * @param {number} rotation - The number to check.
     * @returns {boolean} Whether or not the direction is vertical
     */
    isVertical: function isVertical(rotation) {
        return (rotation & 3) === 2;
    },

    /**
     * @memberof PIXI.GroupD8
     * @param {number} dx - TODO
     * @param {number} dy - TODO
     *
     * @return {number} TODO
     */
    byDirection: function byDirection(dx, dy) {
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) {
                return GroupD8.S;
            }

            return GroupD8.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) {
                return GroupD8.E;
            }

            return GroupD8.W;
        } else if (dy > 0) {
            if (dx > 0) {
                return GroupD8.SE;
            }

            return GroupD8.SW;
        } else if (dx > 0) {
            return GroupD8.NE;
        }

        return GroupD8.NW;
    },

    /**
     * Helps sprite to compensate texture packer rotation.
     *
     * @memberof PIXI.GroupD8
     * @param {PIXI.Matrix} matrix - sprite world matrix
     * @param {number} rotation - The rotation factor to use.
     * @param {number} tx - sprite anchoring
     * @param {number} ty - sprite anchoring
     */
    matrixAppendRotationInv: function matrixAppendRotationInv(matrix, rotation) {
        var tx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var ty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        // Packer used "rotation", we use "inv(rotation)"
        var mat = tempMatrices[GroupD8.inv(rotation)];

        mat.tx = tx;
        mat.ty = ty;
        matrix.append(mat);
    }
};

exports.default = GroupD8;
//# sourceMappingURL=GroupD8.js.map

/***/ }),

/***/ "PJsv":
/***/ (function(module, exports, __webpack_require__) {

var gl = {
    createContext: __webpack_require__("yTo9"),
    setVertexAttribArrays: __webpack_require__("FtW/"),
    GLBuffer: __webpack_require__("aBLe"),
    GLFramebuffer: __webpack_require__("rtye"),
    GLShader: __webpack_require__("VwmF"),
    GLTexture: __webpack_require__("l5aM"),
    VertexArrayObject: __webpack_require__("iM49"),
    shader: __webpack_require__("5ZOS")
};

// Export for Node-compatible environments
if (typeof module !== 'undefined' && module.exports) {
    // Export the module
    module.exports = gl;
}

// Add to the browser window pixi.gl
if (typeof window !== 'undefined') {
    // add the window object
    window.PIXI = window.PIXI || {};
    window.PIXI.glCore = gl;
}

/***/ }),

/***/ "PK7H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.shared = exports.Resource = exports.textureParser = exports.getResourcePath = exports.spritesheetParser = exports.parseBitmapFontData = exports.bitmapFontParser = exports.Loader = undefined;

var _bitmapFontParser = __webpack_require__("Eh8S");

Object.defineProperty(exports, 'bitmapFontParser', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_bitmapFontParser).default;
    }
});
Object.defineProperty(exports, 'parseBitmapFontData', {
    enumerable: true,
    get: function get() {
        return _bitmapFontParser.parse;
    }
});

var _spritesheetParser = __webpack_require__("ESZJ");

Object.defineProperty(exports, 'spritesheetParser', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_spritesheetParser).default;
    }
});
Object.defineProperty(exports, 'getResourcePath', {
    enumerable: true,
    get: function get() {
        return _spritesheetParser.getResourcePath;
    }
});

var _textureParser = __webpack_require__("08UO");

Object.defineProperty(exports, 'textureParser', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_textureParser).default;
    }
});

var _resourceLoader = __webpack_require__("6Jqp");

Object.defineProperty(exports, 'Resource', {
    enumerable: true,
    get: function get() {
        return _resourceLoader.Resource;
    }
});

var _Application = __webpack_require__("Y4lo");

var _Application2 = _interopRequireDefault(_Application);

var _loader = __webpack_require__("MfA+");

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * This namespace contains APIs which extends the {@link https://github.com/englercj/resource-loader resource-loader} module
 * for loading assets, data, and other resources dynamically.
 * @example
 * const loader = new PIXI.loaders.Loader();
 * loader.add('bunny', 'data/bunny.png')
 *       .add('spaceship', 'assets/spritesheet.json');
 * loader.load((loader, resources) => {
 *    // resources.bunny
 *    // resources.spaceship
 * });
 * @namespace PIXI.loaders
 */
exports.Loader = _loader2.default;

/**
 * A premade instance of the loader that can be used to load resources.
 * @name shared
 * @memberof PIXI.loaders
 * @type {PIXI.loaders.Loader}
 */
var shared = new _loader2.default();

shared.destroy = function () {
    // protect destroying shared loader
};

exports.shared = shared;

// Mixin the loader construction

var AppPrototype = _Application2.default.prototype;

AppPrototype._loader = null;

/**
 * Loader instance to help with asset loading.
 * @name PIXI.Application#loader
 * @type {PIXI.loaders.Loader}
 */
Object.defineProperty(AppPrototype, 'loader', {
    get: function get() {
        if (!this._loader) {
            var sharedLoader = this._options.sharedLoader;

            this._loader = sharedLoader ? shared : new _loader2.default();
        }

        return this._loader;
    }
});

// Override the destroy function
// making sure to destroy the current Loader
AppPrototype._parentDestroy = AppPrototype.destroy;
AppPrototype.destroy = function destroy(removeView, stageOptions) {
    if (this._loader) {
        this._loader.destroy();
        this._loader = null;
    }
    this._parentDestroy(removeView, stageOptions);
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "PabG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emotion__ = __webpack_require__("mibh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("jYI/");
var _templateObject = _taggedTemplateLiteralLoose(["\n        ", ";\n        ", "\n      "], ["\n        ", ";\n        ", "\n      "]);



function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }




var Button = function Button(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? "secondary" : _ref$type,
      _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === undefined ? "button" : _ref$buttonType,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? "default" : _ref$size,
      link = _ref.link,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function (_) {} : _ref$onClick,
      event = _ref.event,
      _ref$tourTheme = _ref.tourTheme,
      tourTheme = _ref$tourTheme === undefined ? false : _ref$tourTheme,
      order = _ref.order,
      children = _ref.children,
      ariaLabel = _ref.ariaLabel,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === undefined ? false : _ref$fullWidth,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 40 : _ref$height,
      form = _ref.form,
      _ref$dataCY = _ref.dataCY,
      dataCY = _ref$dataCY === undefined ? "default" : _ref$dataCY;

  var theme = event && event.data && event.data.theme ? event.data.theme : false;
  theme = tourTheme ? tourTheme : theme;
  var buttonDefaults = {
    width: fullWidth ? "100%" : "auto",
    display: "flex",
    justifyContent: "center",
    verticalAlign: "top",
    fontWeight: 600,
    fontSize: size === "small" ? 14 : 16,
    borderRadius: 4,
    paddingLeft: 16,
    paddingRight: 16,
    height: height,
    paddingTop: link ? 5 : 0
  };

  var styles = {
    primary: {
      backgroundColor: theme && theme.primaryColor ? theme.primaryColor : "#6621c0",
      border: "none",
      color: theme && theme.primaryTextColor ? theme.primaryTextColor : "#fff",
      "&:hover": {
        backgroundColor: theme && theme.primaryTextColor ? theme.primaryTextColor : "#fff",
        border: theme && theme.primaryColor ? "solid 1px " + theme.primaryColor : "solid 1px #2074d9",
        color: theme && theme.primaryColor ? "" + theme.primaryColor : "#2074d9"
      }
    },
    secondary: {
      backgroundColor: "transparent",
      border: theme && theme.primaryColor ? "solid 1px " + theme.primaryColor : "solid 1px #6621c0",
      color: theme && theme.primaryColor ? "" + theme.primaryColor : "#6621c0",
      "&:hover": {
        backgroundColor: theme && theme.primaryColor ? theme.primaryColor : "#6621c0",
        border: "none",
        color: theme && theme.primaryTextColor ? theme.primaryTextColor : "#fff"
      }
    },
    tertiary: {
      backgroundColor: "transparent",
      border: "solid 1px #788391",
      color: "#323232",
      "&:hover": {
        backgroundColor: "#788391",
        border: "none",
        color: "#fff"
      }
    }
  };

  return link ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "a",
    {
      className: Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["css"])(_templateObject, buttonDefaults, styles[type]),
      href: link
    },
    children
  ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "button",
    {
      className: Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["css"])(_templateObject, buttonDefaults, styles[type]),
      type: buttonType,
      onClick: onClick,
      "aria-label": ariaLabel,
      formId: form,
      "data-cy": dataCY
    },
    children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
  return {
    event: state.event,
    order: state.order
  };
})(Button));

/***/ }),

/***/ "PleT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

/***/ }),

/***/ "PpCh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _const = __webpack_require__("YEQi");

var _path = __webpack_require__("UUq2");

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var tempMat = new core.Matrix();

/**
 * WebGL renderer plugin for tiling sprites
 *
 * @class
 * @memberof PIXI.extras
 * @extends PIXI.ObjectRenderer
 */

var TilingSpriteRenderer = function (_core$ObjectRenderer) {
    _inherits(TilingSpriteRenderer, _core$ObjectRenderer);

    /**
     * constructor for renderer
     *
     * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
     */
    function TilingSpriteRenderer(renderer) {
        _classCallCheck(this, TilingSpriteRenderer);

        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));

        _this.shader = null;
        _this.simpleShader = null;
        _this.quad = null;
        return _this;
    }

    /**
     * Sets up the renderer context and necessary buffers.
     *
     * @private
     */

    TilingSpriteRenderer.prototype.onContextChange = function onContextChange() {
        var gl = this.renderer.gl;

        this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = mod(vTextureCoord - uClampOffset, vec2(1.0, 1.0)) + uClampOffset;\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 sample = texture2D(uSampler, coord);\n    gl_FragColor = sample * uColor;\n}\n');
        this.simpleShader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 sample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = sample * uColor;\n}\n');

        this.renderer.bindVao(null);
        this.quad = new core.Quad(gl, this.renderer.state.attribState);
        this.quad.initVao(this.shader);
    };

    /**
     *
     * @param {PIXI.extras.TilingSprite} ts tilingSprite to be rendered
     */

    TilingSpriteRenderer.prototype.render = function render(ts) {
        var renderer = this.renderer;
        var quad = this.quad;

        renderer.bindVao(quad.vao);

        var vertices = quad.vertices;

        vertices[0] = vertices[6] = ts._width * -ts.anchor.x;
        vertices[1] = vertices[3] = ts._height * -ts.anchor.y;

        vertices[2] = vertices[4] = ts._width * (1.0 - ts.anchor.x);
        vertices[5] = vertices[7] = ts._height * (1.0 - ts.anchor.y);

        if (ts.uvRespectAnchor) {
            vertices = quad.uvs;

            vertices[0] = vertices[6] = -ts.anchor.x;
            vertices[1] = vertices[3] = -ts.anchor.y;

            vertices[2] = vertices[4] = 1.0 - ts.anchor.x;
            vertices[5] = vertices[7] = 1.0 - ts.anchor.y;
        }

        quad.upload();

        var tex = ts._texture;
        var baseTex = tex.baseTexture;
        var lt = ts.tileTransform.localTransform;
        var uv = ts.uvTransform;
        var isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;

        // auto, force repeat wrapMode for big tiling textures
        if (isSimple) {
            if (!baseTex._glTextures[renderer.CONTEXT_UID]) {
                if (baseTex.wrapMode === _const.WRAP_MODES.CLAMP) {
                    baseTex.wrapMode = _const.WRAP_MODES.REPEAT;
                }
            } else {
                isSimple = baseTex.wrapMode !== _const.WRAP_MODES.CLAMP;
            }
        }

        var shader = isSimple ? this.simpleShader : this.shader;

        renderer.bindShader(shader);

        var w = tex.width;
        var h = tex.height;
        var W = ts._width;
        var H = ts._height;

        tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H);

        // that part is the same as above:
        // tempMat.identity();
        // tempMat.scale(tex.width, tex.height);
        // tempMat.prepend(lt);
        // tempMat.scale(1.0 / ts._width, 1.0 / ts._height);

        tempMat.invert();
        if (isSimple) {
            tempMat.prepend(uv.mapCoord);
        } else {
            shader.uniforms.uMapCoord = uv.mapCoord.toArray(true);
            shader.uniforms.uClampFrame = uv.uClampFrame;
            shader.uniforms.uClampOffset = uv.uClampOffset;
        }

        shader.uniforms.uTransform = tempMat.toArray(true);
        shader.uniforms.uColor = core.utils.premultiplyTintToRgba(ts.tint, ts.worldAlpha, shader.uniforms.uColor, baseTex.premultipliedAlpha);
        shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(true);

        shader.uniforms.uSampler = renderer.bindTexture(tex);

        renderer.setBlendMode(core.utils.correctBlendMode(ts.blendMode, baseTex.premultipliedAlpha));

        quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);
    };

    return TilingSpriteRenderer;
}(core.ObjectRenderer);

exports.default = TilingSpriteRenderer;

core.WebGLRenderer.registerPlugin('tilingSprite', TilingSpriteRenderer);
//# sourceMappingURL=TilingSpriteRenderer.js.map

/***/ }),

/***/ "Pszr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _math = __webpack_require__("e3iB");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Generic class to deal with traditional 2D matrix transforms
 *
 * @class
 * @memberof PIXI
 */
var TransformBase = function () {
  /**
   *
   */
  function TransformBase() {
    _classCallCheck(this, TransformBase);

    /**
     * The global matrix transform. It can be swapped temporarily by some functions like getLocalBounds()
     *
     * @member {PIXI.Matrix}
     */
    this.worldTransform = new _math.Matrix();

    /**
     * The local matrix transform
     *
     * @member {PIXI.Matrix}
     */
    this.localTransform = new _math.Matrix();

    this._worldID = 0;
    this._parentID = 0;
  }

  /**
   * TransformBase does not have decomposition, so this function wont do anything
   */

  TransformBase.prototype.updateLocalTransform = function updateLocalTransform() {}
  // empty


  /**
   * Updates the values of the object and applies the parent's transform.
   *
   * @param {PIXI.TransformBase} parentTransform - The transform of the parent of this object
   */
  ;

  TransformBase.prototype.updateTransform = function updateTransform(parentTransform) {
    var pt = parentTransform.worldTransform;
    var wt = this.worldTransform;
    var lt = this.localTransform;

    // concat the parent matrix with the objects transform.
    wt.a = lt.a * pt.a + lt.b * pt.c;
    wt.b = lt.a * pt.b + lt.b * pt.d;
    wt.c = lt.c * pt.a + lt.d * pt.c;
    wt.d = lt.c * pt.b + lt.d * pt.d;
    wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
    wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;

    this._worldID++;
  };

  return TransformBase;
}();

/**
 * Updates the values of the object and applies the parent's transform.
 * @param  parentTransform {PIXI.Transform} The transform of the parent of this object
 *
 */

exports.default = TransformBase;
TransformBase.prototype.updateWorldTransform = TransformBase.prototype.updateTransform;

TransformBase.IDENTITY = new TransformBase();
//# sourceMappingURL=TransformBase.js.map

/***/ }),

/***/ "Pu1Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var bound_1 = __webpack_require__("USDo");
var Text_js_1 = __webpack_require__("h2Qz");
var Utils_1 = __webpack_require__("o6Mn");
var Config_1 = __webpack_require__("gH/r");
var Table_1 = __webpack_require__("QfCP");

var NonConstructionRows = function (_Table_1$default) {
    _inherits(NonConstructionRows, _Table_1$default);

    function NonConstructionRows(tableConfig, actions, disableInteraction, isTicketing) {
        _classCallCheck(this, NonConstructionRows);

        var _this = _possibleConstructorReturn(this, _Table_1$default.call(this, tableConfig, actions, disableInteraction, isTicketing));

        _this.seatsPerRow = 5;
        _this.numberOfRows = 2;
        _this.xSeatSeperationSpace = 5;
        _this.ySeatSeperationSpace = 5;
        _this.rowLabels = [];
        _this.seatsPerRow = tableConfig.seatsPerRow || 5;
        _this.numberOfRows = tableConfig.numberOfRows || 2;
        _this.seatLabelRight = tableConfig.seatLabelRight;
        _this.xSeatSeperationSpace = tableConfig.xSeatSeperationSpace || 5;
        _this.ySeatSeperationSpace = tableConfig.ySeatSeperationSpace || 5;
        _this.type = tableConfig.type || "rows";
        _this.rowLabels = tableConfig.rowLabels;
        return _this;
    }

    NonConstructionRows.prototype.tableContainerInit = function tableContainerInit(_ref) {
        var x = _ref.x,
            y = _ref.y;

        this.containerScale = new PIXI.Point(1, 1);
        this.moveableContainer = new PIXI.Container();
        this.rowLabelContainer = new PIXI.Container();
        this.moveableContainer.position = new PIXI.Point(x, y);
        this.moveableContainer.pivot.x = this.pivot.x;
        this.moveableContainer.pivot.y = this.pivot.y;
        this.moveableContainer.rotation = this.rotation;
        this.moveableContainer.interactive = true;
        this.moveableContainer.buttonMode = true;
        this.moveableContainer.addChild(this.seatContainer);
        this.moveableContainer.addChild(this.rowLabelContainer);
        this.moveableContainer.scale = this.containerScale;
    };

    NonConstructionRows.prototype.draw = function draw() {
        _Table_1$default.prototype.draw.call(this);
        this.setSeatLabel();
        this.renderRowLabels();
        this.table.visible = false;
    };

    NonConstructionRows.prototype.setSeatLabel = function setSeatLabel() {
        var _this2 = this;

        this.seats.forEach(function (seat, i) {
            var num = void 0;
            if (_this2.seatLabelRight) {
                num = (_this2.seats.length - 1 - i) % _this2.seatsPerRow;
            } else {
                num = i % _this2.seatsPerRow;
            }
            seat.setLabelOverride(num);
        });
    };

    NonConstructionRows.prototype.getLeftMostRightMostSeatForRows = function getLeftMostRightMostSeatForRows() {
        var _this3 = this;

        var rows = [];
        this.seats.forEach(function (seat, i) {
            var rowNum = Math.floor(i / _this3.seatsPerRow);
            if (i % _this3.seatsPerRow === 0) {
                rows.push({ seats: [] });
            }
            rows[rowNum].seats.push(seat);
        });
        return rows.map(function (row) {
            var leftOutskirtReached = false;
            var rightOutskirtReached = false;
            row.seats.forEach(function (seat) {
                if (!leftOutskirtReached) {
                    if (!seat.disabled) {
                        leftOutskirtReached = seat;
                    }
                }
            });
            row.seats.reverse().forEach(function (seat) {
                if (!rightOutskirtReached) {
                    if (!seat.disabled) {
                        rightOutskirtReached = seat;
                    }
                }
            });
            return { left: leftOutskirtReached, right: rightOutskirtReached };
        });
    };

    NonConstructionRows.prototype.renderRowLabels = function renderRowLabels() {
        this.rowLabelContainer.removeChildren();
        var rowsLeftRight = this.getLeftMostRightMostSeatForRows();
        var buffer = 2;
        for (var i = 0; i < rowsLeftRight.length; i++) {
            var _rowsLeftRight$i = rowsLeftRight[i],
                left = _rowsLeftRight$i.left,
                right = _rowsLeftRight$i.right;

            if (left && right) {
                var letter = this.rowLabels[i];
                var leftText = Text_js_1.TextWrapper.createText(letter, Config_1.default.fontStyle);
                var rightText = Text_js_1.TextWrapper.createText(letter, Config_1.default.fontStyle);
                var leftSeatPos = left.getSeat().position;
                var rightSeatPos = right.getSeat().position;
                var heightField = Config_1.default.isWebGl ? "textHeight" : "height";
                var widthField = Config_1.default.isWebGl ? "textWidth" : "width";
                var leftHeight = Config_1.default.isWebGl ? rightSeatPos.y + rightText[heightField] / 2 : rightSeatPos.y - rightText[heightField] / 2;
                var rightHeight = Config_1.default.isWebGl ? rightSeatPos.y + rightText[heightField] / 2 : rightSeatPos.y - rightText[heightField] / 2;
                leftText.position = new PIXI.Point(leftSeatPos.x - leftText[widthField] - Utils_1.seatWidth + buffer, leftHeight);
                rightText.position = new PIXI.Point(rightSeatPos.x + Utils_1.seatWidth - buffer, rightHeight);
                this.rowLabelContainer.addChild(leftText);
                this.rowLabelContainer.addChild(rightText);
            }
        }
    };

    NonConstructionRows.prototype.getSeatPos = function getSeatPos(i, seatCount) {
        var seatXoffset = i % this.seatsPerRow;
        var seatYoffset = Math.floor(i / this.seatsPerRow);
        var xSpace = seatXoffset !== 0 ? this.xSeatSeperationSpace : 0;
        var ySpace = seatYoffset !== 0 ? this.ySeatSeperationSpace : 0;
        var posX = (Utils_1.seatWidth + xSpace) * seatXoffset;
        var posY = (Utils_1.seatHeight + ySpace) * seatYoffset;
        return { x: posX, y: posY };
    };

    NonConstructionRows.prototype.getRows = function getRows() {
        var _this4 = this;

        var rows = [];
        this.seats.forEach(function (seat, i) {
            var rowNum = Math.floor(i / _this4.seatsPerRow);
            if (i % _this4.seatsPerRow === 0) {
                rows.push({ rowLabel: String.fromCharCode(65 + rowNum), seats: [] });
            }
            rows[rowNum].seats.push(seat);
        });
        return rows.map(function (row) {
            row.seats = row.seats.filter(function (seat) {
                return !seat.isDisabled();
            });
            return row;
        });
    };

    NonConstructionRows.prototype.getSelectionBoxBounds = function getSelectionBoxBounds() {
        var offset = this.actions.getOffset();

        var _getRowBounds = this.getRowBounds(),
            x = _getRowBounds.x,
            y = _getRowBounds.y,
            width = _getRowBounds.width,
            height = _getRowBounds.height;

        return { x: x + offset.x, y: y + offset.y, width: width, height: height };
    };

    NonConstructionRows.prototype.getRowBounds = function getRowBounds() {
        var numberOfRows = Math.floor(this.seats.length / this.seatsPerRow);
        var width = (Utils_1.seatWidth + this.xSeatSeperationSpace) * this.seatsPerRow;
        var height = numberOfRows * (Utils_1.seatHeight + this.ySeatSeperationSpace);
        var x = this.moveableContainer.position.x + this.table.position.x - Utils_1.seatWidth / 2;
        var y = this.moveableContainer.position.y + this.table.position.y - Utils_1.seatHeight / 2;
        return { x: x, y: y, width: width, height: height };
    };

    NonConstructionRows.prototype.getNames = function getNames(seatData) {
        var seat = void 0,
            seatIndex = void 0;
        this.seats.forEach(function (s, i) {
            if (s.id === seatData.seatId) {
                seat = s;
                seatIndex = i;
            }
        });
        if (seat) {
            return seat.getNames(this.getSeatRowLabel(seatIndex));
        }
    };

    NonConstructionRows.prototype.getSeatRowLabel = function getSeatRowLabel(i) {
        var j = Math.floor(i / this.seatsPerRow);
        return this.rowLabels[j];
    };

    NonConstructionRows.prototype.updateTexture = function updateTexture() {};

    NonConstructionRows.prototype.setTableLabel = function setTableLabel() {};

    NonConstructionRows.prototype.determineTextureType = function determineTextureType() {};

    return NonConstructionRows;
}(Table_1.default);

__decorate([bound_1.default], NonConstructionRows.prototype, "tableContainerInit", null);
__decorate([bound_1.default], NonConstructionRows.prototype, "setSeatLabel", null);
__decorate([bound_1.default], NonConstructionRows.prototype, "renderRowLabels", null);
__decorate([bound_1.default], NonConstructionRows.prototype, "getSeatPos", null);
__decorate([bound_1.default], NonConstructionRows.prototype, "getRows", null);
__decorate([bound_1.default], NonConstructionRows.prototype, "getSelectionBoxBounds", null);
__decorate([bound_1.default], NonConstructionRows.prototype, "getRowBounds", null);
exports.default = NonConstructionRows;
//# sourceMappingURL=Rows.js.map

/***/ }),

/***/ "Q1sA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _utils = __webpack_require__("dDI1");

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The ParticleContainer class is a really fast version of the Container built solely for speed,
 * so use when you need a lot of sprites or particles. The tradeoff of the ParticleContainer is that most advanced
 * functionality will not work. ParticleContainer implements the basic object transform (position, scale, rotation)
 * and some advanced functionality like tint (as of v4.5.6).
 * Other more advanced functionality like masking, children, filters, etc will not work on sprites in this batch.
 *
 * It's extremely easy to use :
 *
 * ```js
 * let container = new ParticleContainer();
 *
 * for (let i = 0; i < 100; ++i)
 * {
 *     let sprite = new PIXI.Sprite.fromImage("myImage.png");
 *     container.addChild(sprite);
 * }
 * ```
 *
 * And here you have a hundred sprites that will be rendered at the speed of light.
 *
 * @class
 * @extends PIXI.Container
 * @memberof PIXI.particles
 */
var ParticleContainer = function (_core$Container) {
    _inherits(ParticleContainer, _core$Container);

    /**
     * @param {number} [maxSize=1500] - The maximum number of particles that can be rendered by the container.
     *  Affects size of allocated buffers.
     * @param {object} [properties] - The properties of children that should be uploaded to the gpu and applied.
     * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
     *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
     * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
     * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
     * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
     * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
     * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
     * @param {boolean} [autoResize=false] If true, container allocates more batches in case
     *  there are more than `maxSize` particles.
     */
    function ParticleContainer() {
        var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1500;
        var properties = arguments[1];
        var batchSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16384;
        var autoResize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        _classCallCheck(this, ParticleContainer);

        // Making sure the batch size is valid
        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
        // so max number of particles is 65536 / 4 = 16384
        var _this = _possibleConstructorReturn(this, _core$Container.call(this));

        var maxBatchSize = 16384;

        if (batchSize > maxBatchSize) {
            batchSize = maxBatchSize;
        }

        if (batchSize > maxSize) {
            batchSize = maxSize;
        }

        /**
         * Set properties to be dynamic (true) / static (false)
         *
         * @member {boolean[]}
         * @private
         */
        _this._properties = [false, true, false, false, false];

        /**
         * @member {number}
         * @private
         */
        _this._maxSize = maxSize;

        /**
         * @member {number}
         * @private
         */
        _this._batchSize = batchSize;

        /**
         * @member {object<number, WebGLBuffer>}
         * @private
         */
        _this._glBuffers = {};

        /**
         * for every batch stores _updateID corresponding to the last change in that batch
         * @member {number[]}
         * @private
         */
        _this._bufferUpdateIDs = [];

        /**
         * when child inserted, removed or changes position this number goes up
         * @member {number[]}
         * @private
         */
        _this._updateID = 0;

        /**
         * @member {boolean}
         *
         */
        _this.interactiveChildren = false;

        /**
         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL`
         * to reset the blend mode.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL
         * @see PIXI.BLEND_MODES
         */
        _this.blendMode = core.BLEND_MODES.NORMAL;

        /**
         * If true, container allocates more batches in case there are more than `maxSize` particles.
         * @member {boolean}
         * @default false
         */
        _this.autoResize = autoResize;

        /**
         * Used for canvas renderering. If true then the elements will be positioned at the
         * nearest pixel. This provides a nice speed boost.
         *
         * @member {boolean}
         * @default true;
         */
        _this.roundPixels = true;

        /**
         * The texture used to render the children.
         *
         * @readonly
         * @member {BaseTexture}
         */
        _this.baseTexture = null;

        _this.setProperties(properties);

        /**
         * The tint applied to the container.
         * This is a hex value. A value of 0xFFFFFF will remove any tint effect.
         *
         * @private
         * @member {number}
         * @default 0xFFFFFF
         */
        _this._tint = 0;
        _this.tintRgb = new Float32Array(4);
        _this.tint = 0xFFFFFF;
        return _this;
    }

    /**
     * Sets the private properties array to dynamic / static based on the passed properties object
     *
     * @param {object} properties - The properties to be uploaded
     */

    ParticleContainer.prototype.setProperties = function setProperties(properties) {
        if (properties) {
            this._properties[0] = 'vertices' in properties || 'scale' in properties ? !!properties.vertices || !!properties.scale : this._properties[0];
            this._properties[1] = 'position' in properties ? !!properties.position : this._properties[1];
            this._properties[2] = 'rotation' in properties ? !!properties.rotation : this._properties[2];
            this._properties[3] = 'uvs' in properties ? !!properties.uvs : this._properties[3];
            this._properties[4] = 'tint' in properties || 'alpha' in properties ? !!properties.tint || !!properties.alpha : this._properties[4];
        }
    };

    /**
     * Updates the object transform for rendering
     *
     * @private
     */

    ParticleContainer.prototype.updateTransform = function updateTransform() {
        // TODO don't need to!
        this.displayObjectUpdateTransform();
        //  PIXI.Container.prototype.updateTransform.call( this );
    };

    /**
     * The tint applied to the container. This is a hex value.
     * A value of 0xFFFFFF will remove any tint effect.
     ** IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
     * @member {number}
     * @default 0xFFFFFF
     */

    /**
     * Renders the container using the WebGL renderer
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The webgl renderer
     */
    ParticleContainer.prototype.renderWebGL = function renderWebGL(renderer) {
        var _this2 = this;

        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
            return;
        }

        if (!this.baseTexture) {
            this.baseTexture = this.children[0]._texture.baseTexture;
            if (!this.baseTexture.hasLoaded) {
                this.baseTexture.once('update', function () {
                    return _this2.onChildrenChange(0);
                });
            }
        }

        renderer.setObjectRenderer(renderer.plugins.particle);
        renderer.plugins.particle.render(this);
    };

    /**
     * Set the flag that static data should be updated to true
     *
     * @private
     * @param {number} smallestChildIndex - The smallest child index
     */

    ParticleContainer.prototype.onChildrenChange = function onChildrenChange(smallestChildIndex) {
        var bufferIndex = Math.floor(smallestChildIndex / this._batchSize);

        while (this._bufferUpdateIDs.length < bufferIndex) {
            this._bufferUpdateIDs.push(0);
        }
        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
     */

    ParticleContainer.prototype.renderCanvas = function renderCanvas(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
            return;
        }

        var context = renderer.context;
        var transform = this.worldTransform;
        var isRotated = true;

        var positionX = 0;
        var positionY = 0;

        var finalWidth = 0;
        var finalHeight = 0;

        renderer.setBlendMode(this.blendMode);

        context.globalAlpha = this.worldAlpha;

        this.displayObjectUpdateTransform();

        for (var i = 0; i < this.children.length; ++i) {
            var child = this.children[i];

            if (!child.visible) {
                continue;
            }

            var frame = child._texture.frame;

            context.globalAlpha = this.worldAlpha * child.alpha;

            if (child.rotation % (Math.PI * 2) === 0) {
                // this is the fastest  way to optimise! - if rotation is 0 then we can avoid any kind of setTransform call
                if (isRotated) {
                    context.setTransform(transform.a, transform.b, transform.c, transform.d, transform.tx * renderer.resolution, transform.ty * renderer.resolution);

                    isRotated = false;
                }

                positionX = child.anchor.x * (-frame.width * child.scale.x) + child.position.x + 0.5;
                positionY = child.anchor.y * (-frame.height * child.scale.y) + child.position.y + 0.5;

                finalWidth = frame.width * child.scale.x;
                finalHeight = frame.height * child.scale.y;
            } else {
                if (!isRotated) {
                    isRotated = true;
                }

                child.displayObjectUpdateTransform();

                var childTransform = child.worldTransform;

                if (renderer.roundPixels) {
                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution | 0, childTransform.ty * renderer.resolution | 0);
                } else {
                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution, childTransform.ty * renderer.resolution);
                }

                positionX = child.anchor.x * -frame.width + 0.5;
                positionY = child.anchor.y * -frame.height + 0.5;

                finalWidth = frame.width;
                finalHeight = frame.height;
            }

            var resolution = child._texture.baseTexture.resolution;

            context.drawImage(child._texture.baseTexture.source, frame.x * resolution, frame.y * resolution, frame.width * resolution, frame.height * resolution, positionX * renderer.resolution, positionY * renderer.resolution, finalWidth * renderer.resolution, finalHeight * renderer.resolution);
        }
    };

    /**
     * Destroys the container
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their
     *  destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */

    ParticleContainer.prototype.destroy = function destroy(options) {
        _core$Container.prototype.destroy.call(this, options);

        if (this._buffers) {
            for (var i = 0; i < this._buffers.length; ++i) {
                this._buffers[i].destroy();
            }
        }

        this._properties = null;
        this._buffers = null;
        this._bufferUpdateIDs = null;
    };

    _createClass(ParticleContainer, [{
        key: 'tint',
        get: function get() {
            return this._tint;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._tint = value;
            (0, _utils.hex2rgb)(value, this.tintRgb);
        }
    }]);

    return ParticleContainer;
}(core.Container);

exports.default = ParticleContainer;
//# sourceMappingURL=ParticleContainer.js.map

/***/ }),

/***/ "Q5l6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var InteractionManager_1 = __webpack_require__("dUAP");
var Config_1 = __webpack_require__("gH/r");
var SelectionListener_1 = __webpack_require__("//Eg");
var Utils_1 = __webpack_require__("o6Mn");
var MoveableContainer_1 = __webpack_require__("JJWE");
var bound_1 = __webpack_require__("USDo");
var Text_js_1 = __webpack_require__("h2Qz");
var ActionTracker_1 = __webpack_require__("h0Oq");

var MoveableText = function (_MoveableContainer_1$) {
    _inherits(MoveableText, _MoveableContainer_1$);

    function MoveableText(_ref) {
        var textData = _ref.textData,
            pos = _ref.pos,
            fontSize = _ref.fontSize,
            color = _ref.color;
        var reservationMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _classCallCheck(this, MoveableText);

        var _this = _possibleConstructorReturn(this, _MoveableContainer_1$.call(this));

        _this.moveableContainer = new PIXI.Container();
        _this.color = color || 0x000000;
        _this.interactionManager = InteractionManager_1.default.createInteractionManager();
        _this.textData = textData || "";
        _this.moveableContainer.position = pos || new PIXI.Point(0, 0);
        _this.fontSize = fontSize;
        _this.createText();
        _this.moveableContainer.addChild(_this.text);
        _this.contXOffset = 0;
        _this.contYOffset = 0;
        if (!reservationMode) {
            _this.selectionListener = new SelectionListener_1.default(_this.moveableContainer, _this, _this.onClick);
        }
        return _this;
    }

    MoveableText.prototype.createText = function createText() {
        this.text = Text_js_1.TextWrapper.createText(this.textData, _extends({}, Config_1.default.fontStyle, { fontSize: this.fontSize, fontFamily: Utils_1.font, anchor: new PIXI.Point(0, 1), ignoreWorldScale: true }));
        this.text.style.fill = this.color;
    };

    MoveableText.prototype.changeColor = function changeColor(hex) {
        this.color = hex;
        this.text.style.fill = this.color;
    };

    MoveableText.prototype.changeText = function changeText(text) {
        this.textData = text;
        this.text.text = this.textData;
    };

    MoveableText.prototype.onSelect = function onSelect() {};

    MoveableText.prototype.onDeselect = function onDeselect() {};

    MoveableText.prototype.getContainer = function getContainer() {
        return this.moveableContainer;
    };

    MoveableText.prototype.toJSON = function toJSON() {
        var _moveableContainer$po = this.moveableContainer.position,
            x = _moveableContainer$po.x,
            y = _moveableContainer$po.y;

        return {
            textData: this.textData,
            pos: { x: x, y: y },
            fontSize: this.fontSize,
            color: this.color
        };
    };

    MoveableText.prototype.setFontSize = function setFontSize(fontSize) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setFontSize", this.setFontSize, [this.fontSize]);
        this.fontSize = fontSize;
        this.moveableContainer.removeChild(this.text);
        this.createText();
        this.moveableContainer.addChild(this.text);
        this.onChange();
        return undoValue;
    };

    MoveableText.prototype.setAnchor = function setAnchor(anchor) {};

    MoveableText.prototype.getSelectionBoxBounds = function getSelectionBoxBounds() {
        var width = this.text.width;
        var height = this.text.height;
        var x = this.moveableContainer.position.x + this.contXOffset;
        var y = this.moveableContainer.position.y + this.contYOffset;
        return { x: x, y: y, width: width, height: height };
    };

    MoveableText.prototype.onElementClicked = function onElementClicked() {};

    MoveableText.prototype.onClick = function onClick() {
        this.interactionManager.itemSelected(this);
    };

    return MoveableText;
}(MoveableContainer_1.default);

__decorate([bound_1.default], MoveableText.prototype, "createText", null);
__decorate([bound_1.default], MoveableText.prototype, "changeColor", null);
__decorate([bound_1.default], MoveableText.prototype, "changeText", null);
__decorate([bound_1.default], MoveableText.prototype, "getContainer", null);
__decorate([bound_1.default], MoveableText.prototype, "toJSON", null);
__decorate([bound_1.default], MoveableText.prototype, "setFontSize", null);
__decorate([bound_1.default], MoveableText.prototype, "getSelectionBoxBounds", null);
__decorate([bound_1.default], MoveableText.prototype, "onElementClicked", null);
__decorate([bound_1.default], MoveableText.prototype, "onClick", null);
exports.default = MoveableText;
//# sourceMappingURL=MoveableText.js.map

/***/ }),

/***/ "QFWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var TEMP_RECT = new core.Rectangle();

/**
 * The extract manager provides functionality to export content from the renderers.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
 *
 * @class
 * @memberof PIXI.extract
 */

var CanvasExtract = function () {
    /**
     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
     */
    function CanvasExtract(renderer) {
        _classCallCheck(this, CanvasExtract);

        this.renderer = renderer;
        /**
         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
         *
         * @member {PIXI.extract.CanvasExtract} extract
         * @memberof PIXI.CanvasRenderer#
         * @see PIXI.extract.CanvasExtract
         */
        renderer.extract = this;
    }

    /**
     * Will return a HTML Image of the target
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {HTMLImageElement} HTML Image of the target
     */

    CanvasExtract.prototype.image = function image(target) {
        var image = new Image();

        image.src = this.base64(target);

        return image;
    };

    /**
     * Will return a a base64 encoded string of this target. It works by calling
     *  `CanvasExtract.getCanvas` and then running toDataURL on that.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {string} A base64 encoded string of the texture.
     */

    CanvasExtract.prototype.base64 = function base64(target) {
        return this.canvas(target).toDataURL();
    };

    /**
     * Creates a Canvas element, renders this target to it and then returns it.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
     */

    CanvasExtract.prototype.canvas = function canvas(target) {
        var renderer = this.renderer;
        var context = void 0;
        var resolution = void 0;
        var frame = void 0;
        var renderTexture = void 0;

        if (target) {
            if (target instanceof core.RenderTexture) {
                renderTexture = target;
            } else {
                renderTexture = renderer.generateTexture(target);
            }
        }

        if (renderTexture) {
            context = renderTexture.baseTexture._canvasRenderTarget.context;
            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
            frame = renderTexture.frame;
        } else {
            context = renderer.rootContext;
            resolution = renderer.resolution;
            frame = TEMP_RECT;
            frame.width = this.renderer.width;
            frame.height = this.renderer.height;
        }

        var width = frame.width * resolution;
        var height = frame.height * resolution;

        var canvasBuffer = new core.CanvasRenderTarget(width, height, 1);
        var canvasData = context.getImageData(frame.x * resolution, frame.y * resolution, width, height);

        canvasBuffer.context.putImageData(canvasData, 0, 0);

        // send the canvas back..
        return canvasBuffer.canvas;
    };

    /**
     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
     * order, with integer values between 0 and 255 (included).
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
     */

    CanvasExtract.prototype.pixels = function pixels(target) {
        var renderer = this.renderer;
        var context = void 0;
        var resolution = void 0;
        var frame = void 0;
        var renderTexture = void 0;

        if (target) {
            if (target instanceof core.RenderTexture) {
                renderTexture = target;
            } else {
                renderTexture = renderer.generateTexture(target);
            }
        }

        if (renderTexture) {
            context = renderTexture.baseTexture._canvasRenderTarget.context;
            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
            frame = renderTexture.frame;
        } else {
            context = renderer.rootContext;

            frame = TEMP_RECT;
            frame.width = renderer.width;
            frame.height = renderer.height;
        }

        return context.getImageData(0, 0, frame.width * resolution, frame.height * resolution).data;
    };

    /**
     * Destroys the extract
     *
     */

    CanvasExtract.prototype.destroy = function destroy() {
        this.renderer.extract = null;
        this.renderer = null;
    };

    return CanvasExtract;
}();

exports.default = CanvasExtract;

core.CanvasRenderer.registerPlugin('extract', CanvasExtract);
//# sourceMappingURL=CanvasExtract.js.map

/***/ }),

/***/ "QTOC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1ca3840f9b2c7f5a9d2ad3a8c150e200.svg";

/***/ }),

/***/ "QYBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__("jYI/");

// EXTERNAL MODULE: ../node_modules/query-string/index.js
var query_string = __webpack_require__("/Fvp");
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./assets/images/logos/humanitix.svg
var humanitix = __webpack_require__("6xpY");
var humanitix_default = /*#__PURE__*/__webpack_require__.n(humanitix);

// CONCATENATED MODULE: ./components/PoweredByHumanitix.js




var PoweredByHumanitix_PoweredByHumanitix = function PoweredByHumanitix() {
  return Object(preact_min["h"])(
    "div",
    {
      style: {
        fontWeight: 300,
        padding: "0 12px 12px 12px",
        display: "flex",
        justifyContent: "flex-end"
      }
    },
    Object(preact_min["h"])(
      "p",
      {
        style: {
          fontSize: 10,
          margin: 0,
          color: "#5A626C"
        }
      },
      "Powered by"
    ),
    " ",
    Object(preact_min["h"])("img", {
      src: humanitix_default.a,
      alt: "Humanitix",
      style: {
        height: 15,
        marginLeft: 5,
        marginTop: 3
      }
    })
  );
};
/* harmony default export */ var components_PoweredByHumanitix = (PoweredByHumanitix_PoweredByHumanitix);
// EXTERNAL MODULE: ./assets/images/logos/humanitix-purple.svg
var humanitix_purple = __webpack_require__("qALj");
var humanitix_purple_default = /*#__PURE__*/__webpack_require__.n(humanitix_purple);

// EXTERNAL MODULE: ../node_modules/emotion/dist/index.esm.js
var index_esm = __webpack_require__("mibh");

// EXTERNAL MODULE: ./config.js
var config = __webpack_require__("aSYM");

// CONCATENATED MODULE: ./components/Header.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }






var headerStyles = Object(index_esm["css"])({
  background: "#ffffff",
  zIndex: 1000,
  height: 70,
  width: "100%",
  position: "relative",
  boxShadow: "0 0 1px 0 #f1f1f1, 0 2px 3px 0 rgba(32, 7, 64, 0.13)",
  "@media(max-width:1100px)": {
    height: 60
  }
});
var logoStyles = Object(index_esm["css"])({
  background: "url(" + humanitix_purple_default.a + ")",
  width: "185px",
  height: "32px",
  display: "inline-block",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "left center",
  margin: "26px 0 0 60px",
  textIndent: "-9999px",
  "@media(max-width:1100px)": {
    width: "140px",
    height: "24px",
    margin: "24px 0 0 14px"
  }
});

var Header_Header = function Header(_ref) {
  _objectDestructuringEmpty(_ref);

  var websiteURL = Object(config["a" /* default */])("WEBSITE_URL");
  return Object(preact_min["h"])(
    "header",
    { className: headerStyles },
    Object(preact_min["h"])(
      "div",
      {
        style: {
          margin: "0 auto"
        }
      },
      Object(preact_min["h"])(
        "a",
        {
          href: websiteURL,
          className: logoStyles,
          "aria-label": "Humanitix",
          label: "Humanitix"
        },
        "Humanitix"
      )
    )
  );
};
/* harmony default export */ var components_Header = (Header_Header);
// CONCATENATED MODULE: ./components/Page.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref2 = Object(preact_min["h"])(components_Header, null);

var _ref3 = Object(preact_min["h"])(components_PoweredByHumanitix, null);

var Page_Page = function (_Component) {
  _inherits(Page, _Component);

  function Page() {
    _classCallCheck(this, Page);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Page.prototype.componentDidMount = function componentDidMount() {
    var isBrowser = typeof window !== "undefined";
    this.isWidget = false;
    if (isBrowser && window.self !== window.top) {
      this.isWidget = true;
    }
  };

  Page.prototype.getBackground = function getBackground(event, theme, background) {
    var backgroundType = theme && theme.background && theme.background.type;

    var image = theme && theme.background && theme.background.image ? theme.background.image : false;

    if (backgroundType === "image" && image) {
      return "url(" + image.url + ") no-repeat center #eee";
    }

    if (backgroundType === "pattern" && image) {
      return "url(" + image.url + ")";
    }

    if (backgroundType === "color") {
      return "" + theme.background.color;
    }

    if (background && !event.widget) {
      return "#F9F9FA";
    }

    return "#fff";
  };

  Page.prototype.render = function render(_ref) {
    var _ref$header = _ref.header,
        header = _ref$header === undefined ? false : _ref$header,
        _ref$background = _ref.background,
        background = _ref$background === undefined ? true : _ref$background,
        _ref$border = _ref.border,
        border = _ref$border === undefined ? true : _ref$border,
        _ref$transparent = _ref.transparent,
        transparent = _ref$transparent === undefined ? false : _ref$transparent,
        children = _ref.children,
        event = _ref.event,
        banner = _ref.banner,
        _ref$maxWidth = _ref.maxWidth,
        maxWidth = _ref$maxWidth === undefined ? 1040 : _ref$maxWidth;

    var isBrowser = typeof window !== "undefined";
    var parsedTheme = void 0;
    if (isBrowser) {
      var parsed = query_string_default.a.parse(window.location.search);
      parsedTheme = parsed.theme && parsed.theme !== "undefined" ? JSON.parse(parsed.theme) : false;
    }
    var isWidget = false;
    if (isBrowser && window.self !== window.top) {
      isWidget = true;
    }
    var theme = parsedTheme ? parsedTheme : event && event.data ? event.data.theme : false;
    var backgroundSize = "cover";
    if (theme && theme.background && theme.background.type === "pattern") {
      backgroundSize = "initial";
    }
    var wrapperStyle = {
      background: this.getBackground(event, theme, background),
      backgroundSize: backgroundSize,
      paddingBottom: 12
    };
    if (isWidget) {
      wrapperStyle.paddingTop = 1;
    }
    var pageStyle = {
      position: "relative",
      maxWidth: maxWidth,
      margin: "0px auto",
      background: "#fff",
      boxShadow: border ? "0 1px 3px 0 rgba(9,30,66,0.13), 0 0 1px 0 #F1F1F1" : "none",
      borderTop: "none"
    };
    var showHeader = header && !theme.hideHeader;

    pageStyle.background = transparent ? "transparent" : "#fff";
    return Object(preact_min["h"])(
      "div",
      { style: wrapperStyle },
      showHeader ? _ref2 : null,
      banner ? banner : null,
      Object(preact_min["h"])(
        "div",
        { "class": "page", style: pageStyle },
        children,
        this.isWidget ? _ref3 : null
      )
    );
  };

  return Page;
}(preact_min["Component"]);

var emulateEvent = function emulateEvent(_ref4) {
  var giftCardPage = _ref4.giftCardPage;
  var style = giftCardPage.style;

  return {
    data: {
      theme: {
        background: {
          type: "color",
          color: style.backgroundColor
        }
      }
    }
  };
};

/* harmony default export */ var components_Page = __webpack_exports__["a"] = (Object(es["b" /* connect */])(function (state, ownProps) {
  var isGlobal = ownProps.isGlobal;

  return {
    event: isGlobal ? emulateEvent(state.giftCards) : state.event
  };
}, {})(Page_Page));

/***/ }),

/***/ "QdUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/@emotion/memoize/dist/memoize.esm.js
var memoize_esm = __webpack_require__("MvwA");

// CONCATENATED MODULE: ../node_modules/@emotion/unitless/dist/unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_esm = (unitlessKeys);
// CONCATENATED MODULE: ../node_modules/@emotion/hash/dist/hash.esm.js
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ var hash_esm = (murmurhash2_32_gc);
//# sourceMappingURL=hash.esm.js.map
// CONCATENATED MODULE: ../node_modules/create-emotion/node_modules/@emotion/stylis/dist/stylis.esm.js
var W = function da(X) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, J = 0, k, u = k = q = 0, l = 0, r = 0, z = 0, t = 0, K = e.length, I = K - 1, y, f = '', p = '', F = '', G = '', C; l < K;) {
      g = e.charCodeAt(l);
      l === I && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, K++, I++);

      if (0 === b + n + v + m) {
        if (l === I && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < K;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < I; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < I && e.charCodeAt(l) !== g;) {}

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ea, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < B && (r = Y(O, f, z), C = H(3, k, r, c, D, A, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(fa, ha);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(ia, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, Y(c, f, z), k, h, a + 1);
            }

            F += k;
            k = z = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < B && void 0 !== (C = H(1, f, c, d, D, A, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            z = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < B * Z && H(0, f, c, d, D, A, p.length, h, a, h);
          A = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            A++;
            break;
          }

        default:
          A++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = z = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === J && (E = J);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * J) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      J = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < B && (C = H(2, p, r, d, D, A, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ja, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function Y(d, c, e) {
    var h = c.trim().split(ka);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = aa(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = aa(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function aa(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(la, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ma.test(a) ? a.replace(ba, ':-webkit-') + a.replace(ba, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ca, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ca, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === na.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(oa, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(pa, '$1'), e, c);
  }

  function ha(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(qa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < B; ++g) {
      switch (w = S[g].call(z, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        B = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[B++] = d;
            break;

          case Boolean:
            Z = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function z(d, c) {
    if (void 0 !== this && this.constructor === z) return da(d);
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < B) {
      var h = H(-1, c, e, e, D, A, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < B && (h = H(-2, a, e, e, D, A, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    A = D = 1;
    return a;
  }

  var ea = /^\0+/g,
      N = /[\0\r\f]/g,
      ba = /: */g,
      ma = /zoo|gra/,
      oa = /([,: ])(transform)/g,
      ka = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      ia = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ja = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      fa = /\(\s*(.*)\s*\)/g,
      qa = /([\s\S]*?);/g,
      ca = /-self|flex-/g,
      pa = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      na = /stretch|:\s*\w+\-(?:conte|avail)/,
      la = /([^-])(image-set\()/,
      A = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      B = 0,
      R = null,
      Z = 0,
      V = '';
  z.use = T;
  z.set = U;
  void 0 !== X && U(X);
  return z;
};

/* harmony default export */ var stylis_esm = (W);
//# sourceMappingURL=stylis.esm.js.map
// EXTERNAL MODULE: ../node_modules/stylis-rule-sheet/index.js
var stylis_rule_sheet = __webpack_require__("UYYs");
var stylis_rule_sheet_default = /*#__PURE__*/__webpack_require__.n(stylis_rule_sheet);

// CONCATENATED MODULE: ../node_modules/create-emotion/dist/index.esm.js






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(memoize_esm["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var index_esm_processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (unitless_esm[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = index_esm_processStyleValue;

  index_esm_processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = stylis_rule_sheet_default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new stylis_esm(stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + index_esm_processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + index_esm_processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return hash_esm(styles + identifierName) + identifierName;
  };

  if (false) {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (false) {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ var index_esm = __webpack_exports__["a"] = (createEmotion);
//# sourceMappingURL=index.esm.js.map

/***/ }),

/***/ "Qekk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * @typedef PIXI.extras.AnimatedSprite~FrameObject
 * @type {object}
 * @property {PIXI.Texture} texture - The {@link PIXI.Texture} of the frame
 * @property {number} time - the duration of the frame in ms
 */

/**
 * An AnimatedSprite is a simple way to display an animation depicted by a list of textures.
 *
 * ```js
 * let alienImages = ["image_sequence_01.png","image_sequence_02.png","image_sequence_03.png","image_sequence_04.png"];
 * let textureArray = [];
 *
 * for (let i=0; i < 4; i++)
 * {
 *      let texture = PIXI.Texture.fromImage(alienImages[i]);
 *      textureArray.push(texture);
 * };
 *
 * let animatedSprite = new PIXI.extras.AnimatedSprite(textureArray);
 * ```
 *
 * The more efficient and simpler way to create an animated sprite is using a {@link PIXI.Spritesheet}
 * containing the animation definitions:
 *
 * ```js
 * PIXI.loader.add("assets/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.loader.resources["assets/spritesheet.json"].spritesheet;
 *   animatedSprite = new PIXI.extras.AnimatedSprite(sheet.animations["image_sequence"]);
 *   ...
 * }
 * ```
 *
 * @class
 * @extends PIXI.Sprite
 * @memberof PIXI.extras
 */
var AnimatedSprite = function (_core$Sprite) {
    _inherits(AnimatedSprite, _core$Sprite);

    /**
     * @param {PIXI.Texture[]|PIXI.extras.AnimatedSprite~FrameObject[]} textures - an array of {@link PIXI.Texture} or frame
     *  objects that make up the animation
     * @param {boolean} [autoUpdate=true] - Whether to use PIXI.ticker.shared to auto update animation time.
     */
    function AnimatedSprite(textures, autoUpdate) {
        _classCallCheck(this, AnimatedSprite);

        /**
         * @private
         */
        var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, textures[0] instanceof core.Texture ? textures[0] : textures[0].texture));

        _this._textures = null;

        /**
         * @private
         */
        _this._durations = null;

        _this.textures = textures;

        /**
         * `true` uses PIXI.ticker.shared to auto update animation time.
         * @type {boolean}
         * @default true
         * @private
         */
        _this._autoUpdate = autoUpdate !== false;

        /**
         * The speed that the AnimatedSprite will play at. Higher is faster, lower is slower
         *
         * @member {number}
         * @default 1
         */
        _this.animationSpeed = 1;

        /**
         * Whether or not the animate sprite repeats after playing.
         *
         * @member {boolean}
         * @default true
         */
        _this.loop = true;

        /**
         * Update anchor to [Texture's defaultAnchor]{@link PIXI.Texture#defaultAnchor} when frame changes.
         *
         * Useful with [sprite sheet animations]{@link PIXI.Spritesheet#animations} created with tools.
         * Changing anchor for each frame allows to pin sprite origin to certain moving feature
         * of the frame (e.g. left foot).
         *
         * Note: Enabling this will override any previously set `anchor` on each frame change.
         *
         * @member {boolean}
         * @default false
         */
        _this.updateAnchor = false;

        /**
         * Function to call when a AnimatedSprite finishes playing
         *
         * @member {Function}
         */
        _this.onComplete = null;

        /**
         * Function to call when a AnimatedSprite changes which texture is being rendered
         *
         * @member {Function}
         */
        _this.onFrameChange = null;

        /**
        * Function to call when 'loop' is true, and an AnimatedSprite is played and loops around to start again
        *
        * @member {Function}
        */
        _this.onLoop = null;

        /**
         * Elapsed time since animation has been started, used internally to display current texture
         *
         * @member {number}
         * @private
         */
        _this._currentTime = 0;

        /**
         * Indicates if the AnimatedSprite is currently playing
         *
         * @member {boolean}
         * @readonly
         */
        _this.playing = false;
        return _this;
    }

    /**
     * Stops the AnimatedSprite
     *
     */

    AnimatedSprite.prototype.stop = function stop() {
        if (!this.playing) {
            return;
        }

        this.playing = false;
        if (this._autoUpdate) {
            core.ticker.shared.remove(this.update, this);
        }
    };

    /**
     * Plays the AnimatedSprite
     *
     */

    AnimatedSprite.prototype.play = function play() {
        if (this.playing) {
            return;
        }

        this.playing = true;
        if (this._autoUpdate) {
            core.ticker.shared.add(this.update, this, core.UPDATE_PRIORITY.HIGH);
        }
    };

    /**
     * Stops the AnimatedSprite and goes to a specific frame
     *
     * @param {number} frameNumber - frame index to stop at
     */

    AnimatedSprite.prototype.gotoAndStop = function gotoAndStop(frameNumber) {
        this.stop();

        var previousFrame = this.currentFrame;

        this._currentTime = frameNumber;

        if (previousFrame !== this.currentFrame) {
            this.updateTexture();
        }
    };

    /**
     * Goes to a specific frame and begins playing the AnimatedSprite
     *
     * @param {number} frameNumber - frame index to start at
     */

    AnimatedSprite.prototype.gotoAndPlay = function gotoAndPlay(frameNumber) {
        var previousFrame = this.currentFrame;

        this._currentTime = frameNumber;

        if (previousFrame !== this.currentFrame) {
            this.updateTexture();
        }

        this.play();
    };

    /**
     * Updates the object transform for rendering.
     *
     * @private
     * @param {number} deltaTime - Time since last tick.
     */

    AnimatedSprite.prototype.update = function update(deltaTime) {
        var elapsed = this.animationSpeed * deltaTime;
        var previousFrame = this.currentFrame;

        if (this._durations !== null) {
            var lag = this._currentTime % 1 * this._durations[this.currentFrame];

            lag += elapsed / 60 * 1000;

            while (lag < 0) {
                this._currentTime--;
                lag += this._durations[this.currentFrame];
            }

            var sign = Math.sign(this.animationSpeed * deltaTime);

            this._currentTime = Math.floor(this._currentTime);

            while (lag >= this._durations[this.currentFrame]) {
                lag -= this._durations[this.currentFrame] * sign;
                this._currentTime += sign;
            }

            this._currentTime += lag / this._durations[this.currentFrame];
        } else {
            this._currentTime += elapsed;
        }

        if (this._currentTime < 0 && !this.loop) {
            this.gotoAndStop(0);

            if (this.onComplete) {
                this.onComplete();
            }
        } else if (this._currentTime >= this._textures.length && !this.loop) {
            this.gotoAndStop(this._textures.length - 1);

            if (this.onComplete) {
                this.onComplete();
            }
        } else if (previousFrame !== this.currentFrame) {
            if (this.loop && this.onLoop) {
                if (this.animationSpeed > 0 && this.currentFrame < previousFrame) {
                    this.onLoop();
                } else if (this.animationSpeed < 0 && this.currentFrame > previousFrame) {
                    this.onLoop();
                }
            }

            this.updateTexture();
        }
    };

    /**
     * Updates the displayed texture to match the current frame index
     *
     * @private
     */

    AnimatedSprite.prototype.updateTexture = function updateTexture() {
        this._texture = this._textures[this.currentFrame];
        this._textureID = -1;
        this.cachedTint = 0xFFFFFF;

        if (this.updateAnchor) {
            this._anchor.copy(this._texture.defaultAnchor);
        }

        if (this.onFrameChange) {
            this.onFrameChange(this.currentFrame);
        }
    };

    /**
     * Stops the AnimatedSprite and destroys it
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
     */

    AnimatedSprite.prototype.destroy = function destroy(options) {
        this.stop();
        _core$Sprite.prototype.destroy.call(this, options);
    };

    /**
     * A short hand way of creating a movieclip from an array of frame ids
     *
     * @static
     * @param {string[]} frames - The array of frames ids the movieclip will use as its texture frames
     * @return {AnimatedSprite} The new animated sprite with the specified frames.
     */

    AnimatedSprite.fromFrames = function fromFrames(frames) {
        var textures = [];

        for (var i = 0; i < frames.length; ++i) {
            textures.push(core.Texture.fromFrame(frames[i]));
        }

        return new AnimatedSprite(textures);
    };

    /**
     * A short hand way of creating a movieclip from an array of image ids
     *
     * @static
     * @param {string[]} images - the array of image urls the movieclip will use as its texture frames
     * @return {AnimatedSprite} The new animate sprite with the specified images as frames.
     */

    AnimatedSprite.fromImages = function fromImages(images) {
        var textures = [];

        for (var i = 0; i < images.length; ++i) {
            textures.push(core.Texture.fromImage(images[i]));
        }

        return new AnimatedSprite(textures);
    };

    /**
     * totalFrames is the total number of frames in the AnimatedSprite. This is the same as number of textures
     * assigned to the AnimatedSprite.
     *
     * @readonly
     * @member {number}
     * @default 0
     */

    _createClass(AnimatedSprite, [{
        key: 'totalFrames',
        get: function get() {
            return this._textures.length;
        }

        /**
         * The array of textures used for this AnimatedSprite
         *
         * @member {PIXI.Texture[]}
         */

    }, {
        key: 'textures',
        get: function get() {
            return this._textures;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (value[0] instanceof core.Texture) {
                this._textures = value;
                this._durations = null;
            } else {
                this._textures = [];
                this._durations = [];

                for (var i = 0; i < value.length; i++) {
                    this._textures.push(value[i].texture);
                    this._durations.push(value[i].time);
                }
            }
            this.gotoAndStop(0);
            this.updateTexture();
        }

        /**
        * The AnimatedSprites current frame index
        *
        * @member {number}
        * @readonly
        */

    }, {
        key: 'currentFrame',
        get: function get() {
            var currentFrame = Math.floor(this._currentTime) % this._textures.length;

            if (currentFrame < 0) {
                currentFrame += this._textures.length;
            }

            return currentFrame;
        }
    }]);

    return AnimatedSprite;
}(core.Sprite);

exports.default = AnimatedSprite;
//# sourceMappingURL=AnimatedSprite.js.map

/***/ }),

/***/ "QfCP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var bound_1 = __webpack_require__("USDo");
var SelectableObject_1 = __webpack_require__("5t/1");
var SelectionListener_1 = __webpack_require__("//Eg");
var Text_js_1 = __webpack_require__("h2Qz");
var Utils_1 = __webpack_require__("o6Mn");
var Config_1 = __webpack_require__("gH/r");
var Seat_1 = __webpack_require__("qrdL");

var NonConstructionTable = function (_SelectableObject_1$d) {
    _inherits(NonConstructionTable, _SelectableObject_1$d);

    function NonConstructionTable(_ref, actions, disableInteraction, isTicketing) {
        var _id = _ref._id,
            type = _ref.type,
            pos = _ref.pos,
            seats = _ref.seats,
            tableId = _ref.tableId,
            sectionId = _ref.sectionId,
            ticketIds = _ref.ticketIds,
            label = _ref.label,
            name = _ref.name,
            sectionName = _ref.sectionName,
            seatLabelPattern = _ref.seatLabelPattern,
            seatlabelStartAt = _ref.seatlabelStartAt,
            tablePrefix = _ref.tablePrefix,
            seatPrefix = _ref.seatPrefix,
            reserved = _ref.reserved,
            locked = _ref.locked,
            bookByTable = _ref.bookByTable,
            rotation = _ref.rotation,
            pivot = _ref.pivot;

        _classCallCheck(this, NonConstructionTable);

        var _this = _possibleConstructorReturn(this, _SelectableObject_1$d.call(this, _id, pos, reserved, false, locked, ticketIds, bookByTable));

        _this.actions = actions;
        _this.type = type;
        _this.rotation = rotation || 0;
        _this.sectionName = sectionName;
        _this.basicType = "table";
        _this.pos = pos;
        _this.tableId = tableId;
        _this.sectionId = sectionId;
        _this.tablePrefix = tablePrefix;
        _this.seatPrefix = seatPrefix;
        _this.seatlabelStartAt = seatlabelStartAt;
        _this.label = label;
        _this.bookByTable = bookByTable;
        _this.seatLabelPattern = seatLabelPattern;
        _this.name = name;
        _this.ticketIds = ticketIds || [];
        _this.contXOffset = 0;
        _this.contYOffset = 0;
        _this.mappedTicketIds = [];
        _this.focused = true;
        _this.tableTexture = PIXI.loader.resources[Utils_1.circleTableAvailableTexture].texture;
        _this.tableTexture.baseTexture.mipmap = true;
        _this.drag = false;
        _this.reserved = reserved;
        _this.locked = locked;
        _this.valid = true;
        _this.selected = false;
        _this.seatData = seats;
        _this.isTicketing = isTicketing;
        _this.pivot = pivot || { x: 0, y: 0 };
        _this.setTableLabel();
        _this.determineTextureType();
        return _this;
    }

    NonConstructionTable.prototype.draw = function draw() {
        this.setScales(this.seatData);
        this.tableInit(this.pos);
        this.seats = this.seatsInit(this.seatData, this.actions);
        this.seatContainer = this.getSeatContainer(this.pos);
        this.tableContainerInit(this.pos);
    };

    NonConstructionTable.prototype.showTextSeat = function showTextSeat(show) {
        this.seats.forEach(function (seat) {
            return seat.showText(show);
        });
    };

    NonConstructionTable.prototype.showText = function showText(show) {
        this.text.visible = show;
    };

    NonConstructionTable.prototype.setTableLabel = function setTableLabel() {
        this.text = Text_js_1.TextWrapper.createText(this.name, Config_1.default.fontStyle);
    };

    NonConstructionTable.prototype.addTicketDataTo = function addTicketDataTo(seatingData, ticketData) {
        var seat = this.seats.find(function (seat) {
            return seat.id === seatingData.seatId;
        });
        if (seat) {
            seat.addTicketDataTo(ticketData);
        }
    };

    NonConstructionTable.prototype.removeTicketDataFrom = function removeTicketDataFrom(seatingData) {
        var seat = this.seats.find(function (seat) {
            return seat.id === seatingData.seatId;
        });
        if (seat) {
            seat.removeTicketDataFrom();
        }
    };

    NonConstructionTable.prototype.enableClick = function enableClick(enable) {
        this.seats.forEach(function (seat) {
            seat.enableClick(enable);
        });
    };

    NonConstructionTable.prototype.getNames = function getNames(seatData) {
        var seat = this.seats.find(function (seat) {
            return seat.id === seatData.seatId;
        });
        if (seat) {
            return seat.getNames();
        }
    };

    NonConstructionTable.prototype.highlight = function highlight(_highlight, seatData) {
        var seat = this.seats.find(function (seat) {
            return seat.id === seatData.seatId;
        });
        if (seat) {
            seat.highlight(_highlight);
        }
    };

    NonConstructionTable.prototype.changeSeat = function changeSeat(seatData) {
        var seat = this.seats.find(function (seat) {
            return seat.id === seatData.seatId;
        });
        if (seat) {
            return seat.changeSeat();
        }
    };

    NonConstructionTable.prototype.unClickSeat = function unClickSeat(seatingData) {
        var seat = this.seats.find(function (seat) {
            return seat.id === seatingData.seatId;
        });
        if (seat) {
            seat.unClickSeat();
        }
    };

    NonConstructionTable.prototype.unAssignSeat = function unAssignSeat(seatingData) {
        var seat = this.seats.find(function (seat) {
            return seat.id === seatingData.seatId;
        });
        if (seat) {
            seat.unAssignSeat();
        }
    };

    NonConstructionTable.prototype.seatSelected = function seatSelected(seatCurrentlySelected) {
        this.seats.forEach(function (seat) {
            seat.seatSelected(seatCurrentlySelected);
        });
    };

    NonConstructionTable.prototype.deselectSeat = function deselectSeat() {
        this.seats.forEach(function (seat) {
            seat.deselectSeat();
        });
    };

    NonConstructionTable.prototype.setupInteraction = function setupInteraction() {
        this.selectionListener = new SelectionListener_1.default(this.moveableContainer, this, this.onClick);
    };

    NonConstructionTable.prototype.setContainerOffset = function setContainerOffset(x, y) {
        this.contXOffset = x;
        this.contYOffset = y;
    };

    NonConstructionTable.prototype.getDimensions = function getDimensions() {
        var _Config_1$default$can = Config_1.default.canvasBounding,
            top = _Config_1$default$can.top,
            left = _Config_1$default$can.left;

        var width = (this.seatCircleRadius + Utils_1.seatWidth / 2) * 2;
        var height = (this.seatCircleRadius + Utils_1.seatWidth / 2) * 2;
        var x = this.moveableContainer.position.x + this.table.position.x - width / 2 - left;
        var y = this.moveableContainer.position.y + this.table.position.y - height / 2 - top;
        return { left: x, top: y, right: x + width, bottom: y + height };
    };

    NonConstructionTable.prototype.updateTexture = function updateTexture() {
        this.determineTextureType();
        this.table.texture = this.tableTexture;
    };

    NonConstructionTable.prototype.determineTextureType = function determineTextureType() {
        var currentTexture = void 0;
        if (this.reserved) {
            currentTexture = Utils_1.circleTableAssignedTexture;
            this.text.fill = 0xFFFFFF;
        } else {
            currentTexture = Utils_1.circleTableUnassignedTexture;
            this.text.fill = 0x000000;
        }
        this.tableTexture = PIXI.loader.resources[currentTexture].texture;
        this.tableTexture.baseTexture.mipmap = true;
    };

    NonConstructionTable.prototype.getSeatPos = function getSeatPos(i, seatCount) {
        var posX = Math.ceil(this.seatCircleRadius * Math.cos(i * (2 * Math.PI) / seatCount));
        var posY = Math.ceil(this.seatCircleRadius * Math.sin(i * (2 * Math.PI) / seatCount));
        return { x: posX, y: posY };
    };

    NonConstructionTable.prototype.seatsInit = function seatsInit(seats, disableInteraction) {
        var _this2 = this;

        var seatCount = seats.length;
        return seats.map(function (seat, i) {
            var constructionValue = _extends({ pos: _this2.getSeatPos(i, seatCount), seatlabelStartAt: _this2.seatlabelStartAt, bookByTable: _this2.bookByTable, tableId: _this2._id, sectionId: _this2.sectionId, sectionName: _this2.sectionName, tableName: _this2.name }, seat);
            return new Seat_1.default(constructionValue, _this2.actions, disableInteraction, _this2.isTicketing);
        });
    };

    NonConstructionTable.prototype.tableInit = function tableInit(pos) {
        this.table = new PIXI.Sprite(this.tableTexture);
        this.table.anchor = new PIXI.ObservablePoint(function () {}, undefined, 0.5, 0.5);
        this.table.scale = new PIXI.Point(this.scale, this.scale);
    };

    NonConstructionTable.prototype.setScales = function setScales(seats) {
        this.scale = seats.length > 8 ? seats.length / 8 * 0.2 : 0.2;
        this.seatCircleRadius = this.tableTexture.orig.width * this.scale / 2 + Utils_1.seatWidth / 2 + 5;
    };

    NonConstructionTable.prototype.tableContainerInit = function tableContainerInit(_ref2) {
        var x = _ref2.x,
            y = _ref2.y;

        this.containerScale = new PIXI.Point(1, 1);
        this.moveableContainer = new PIXI.Container();
        this.moveableContainer.position = new PIXI.Point(x, y);
        this.moveableContainer.pivot.x = this.pivot.x;
        this.moveableContainer.pivot.y = this.pivot.y;
        this.moveableContainer.interactive = true;
        this.moveableContainer.buttonMode = true;
        this.moveableContainer.rotation = this.rotation;
        this.moveableContainer.addChild(this.table);
        this.moveableContainer.addChild(this.text);
        this.moveableContainer.addChild(this.seatContainer);
        this.moveableContainer.scale = this.containerScale;
    };

    NonConstructionTable.prototype.getSeatContainer = function getSeatContainer(_ref3) {
        var x = _ref3.x,
            y = _ref3.y;

        var seatContainer = new PIXI.Container();
        this.seats.forEach(function (seat) {
            return seatContainer.addChild(seat.getSeat());
        });
        return seatContainer;
    };

    NonConstructionTable.prototype.getTableContainer = function getTableContainer() {
        return this.moveableContainer;
    };

    NonConstructionTable.prototype.setActions = function setActions(actions) {
        this.actions = actions;
        this.seats.forEach(function (seat) {
            return seat.setActions(actions);
        });
    };

    NonConstructionTable.prototype.onClick = function onClick() {};

    return NonConstructionTable;
}(SelectableObject_1.default);

NonConstructionTable.tableTypes = {
    ROUND: "round",
    RECT: "rect"
};
NonConstructionTable.labelPatterns = {
    COUNT: "count",
    ALPHABET: "alphabet"
};
__decorate([bound_1.default], NonConstructionTable.prototype, "showTextSeat", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "showText", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "addTicketDataTo", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "removeTicketDataFrom", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "enableClick", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "highlight", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "changeSeat", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "unClickSeat", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "unAssignSeat", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "seatSelected", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "deselectSeat", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "setupInteraction", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "setContainerOffset", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "getDimensions", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "tableInit", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "setScales", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "getSeatContainer", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "getTableContainer", null);
__decorate([bound_1.default], NonConstructionTable.prototype, "setActions", null);
exports.default = NonConstructionTable;
//# sourceMappingURL=Table.js.map

/***/ }),

/***/ "QnHY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "efd801d8065724d371491b272800332d.svg";

/***/ }),

/***/ "Qq8P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "736dffa00cb8526472eac1034d686615.svg";

/***/ }),

/***/ "QsbM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "01c234a7a162bdd44e3af892911bf3e7.svg";

/***/ }),

/***/ "QyN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__("jYBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("aSYM");



var init = function init() {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */])("SENTRY_ERROR_ACCESS_APP")) {
    __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.config(Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */])("SENTRY_ERROR_ACCESS_APP"), {
      whitelistUrls: [Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */])("TICKETING_URL")]
    }).install();
  }
};

var track = function track(err) {
  try {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */])("SENTRY_ERROR_ACCESS_APP")) {
      __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.captureException(err);
      return;
    }
    console.error(err);
  } catch (err) {}
};

/* harmony default export */ __webpack_exports__["default"] = ({ init: init, track: track });

/***/ }),

/***/ "REa7":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/***/ }),

/***/ "RFUj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return email; });
/* unused harmony export match */
var required = function required(value, allValues, props, name) {
  var requiredMsg = "This field is required";

  value = typeof value === "string" || value instanceof String ? value.trim() : value;
  if (typeof value === "object" && value !== null) {
    if (value.location || value.details) {
      var details = value.details || {};
      return details.country && details.postalCode && details.state && details.street && details.suburb ? undefined : requiredMsg;
    }
  }
  return value || value === 0 ? undefined : requiredMsg;
};

var email = function email(value) {
  value = typeof value === "string" || value instanceof String ? value.trim() : value;
  return value && !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(value) ? "Invalid email address" : undefined;
};

var match = function match(value, allValues) {
  return value === allValues.order.email ? undefined : "Emails must match";
};
country: "AU";
postalCode: "3230";
state: "VIC";
street: "3 Manna Gum Close";
suburb: "Anglesea";

/***/ }),

/***/ "RISe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var utils = __webpack_require__("GZIj");
var Plugin = __webpack_require__("sh3Y");

module.exports = function (_Plugin) {
    _inherits(MouseEdges, _Plugin);

    /**
     * Scroll viewport when mouse hovers near one of the edges.
     * @private
     * @param {Viewport} parent
     * @param {object} [options]
     * @param {number} [options.radius] distance from center of screen in screen pixels
     * @param {number} [options.distance] distance from all sides in screen pixels
     * @param {number} [options.top] alternatively, set top distance (leave unset for no top scroll)
     * @param {number} [options.bottom] alternatively, set bottom distance (leave unset for no top scroll)
     * @param {number} [options.left] alternatively, set left distance (leave unset for no top scroll)
     * @param {number} [options.right] alternatively, set right distance (leave unset for no top scroll)
     * @param {number} [options.speed=8] speed in pixels/frame to scroll viewport
     * @param {boolean} [options.reverse] reverse direction of scroll
     * @param {boolean} [options.noDecelerate] don't use decelerate plugin even if it's installed
     * @param {boolean} [options.linear] if using radius, use linear movement (+/- 1, +/- 1) instead of angled movement (Math.cos(angle from center), Math.sin(angle from center))
     * @param {boolean} [options.allowButtons] allows plugin to continue working even when there's a mousedown event
     *
     * @event mouse-edge-start(Viewport) emitted when mouse-edge starts
     * @event mouse-edge-end(Viewport) emitted when mouse-edge ends
     */
    function MouseEdges(parent, options) {
        _classCallCheck(this, MouseEdges);

        var _this = _possibleConstructorReturn(this, (MouseEdges.__proto__ || Object.getPrototypeOf(MouseEdges)).call(this, parent));

        options = options || {};
        _this.options = options;
        _this.reverse = options.reverse ? 1 : -1;
        _this.noDecelerate = options.noDecelerate;
        _this.linear = options.linear;
        _this.radiusSquared = Math.pow(options.radius, 2);
        _this.resize();
        _this.speed = options.speed || 8;
        return _this;
    }

    _createClass(MouseEdges, [{
        key: 'resize',
        value: function resize() {
            var options = this.options;
            var distance = options.distance;
            if (utils.exists(distance)) {
                this.left = distance;
                this.top = distance;
                this.right = window.innerWidth - distance;
                this.bottom = window.innerHeight - distance;
            } else if (!this.radius) {
                this.left = utils.exists(options.left) ? options.left : null;
                this.top = utils.exists(options.top) ? options.top : null;
                this.right = utils.exists(options.right) ? window.innerWidth - options.right : null;
                this.bottom = utils.exists(options.bottom) ? window.innerHeight - options.bottom : null;
            }
        }
    }, {
        key: 'down',
        value: function down() {
            if (!this.options.allowButtons) {
                this.horizontal = this.vertical = null;
            }
        }
    }, {
        key: 'move',
        value: function move(e) {
            if (e.data.identifier !== 'MOUSE' && e.data.identifier !== 1 || !this.options.allowButtons && e.data.buttons !== 0) {
                return;
            }
            var x = e.data.global.x;
            var y = e.data.global.y;

            if (this.radiusSquared) {
                var center = this.parent.toScreen(this.parent.center);
                var distance = Math.pow(center.x - x, 2) + Math.pow(center.y - y, 2);
                if (distance >= this.radiusSquared) {
                    var angle = Math.atan2(center.y - y, center.x - x);
                    if (this.linear) {
                        this.horizontal = Math.round(Math.cos(angle)) * this.speed * this.reverse * (60 / 1000);
                        this.vertical = Math.round(Math.sin(angle)) * this.speed * this.reverse * (60 / 1000);
                    } else {
                        this.horizontal = Math.cos(angle) * this.speed * this.reverse * (60 / 1000);
                        this.vertical = Math.sin(angle) * this.speed * this.reverse * (60 / 1000);
                    }
                } else {
                    if (this.horizontal) {
                        this.decelerateHorizontal();
                    }
                    if (this.vertical) {
                        this.decelerateVertical();
                    }
                    this.horizontal = this.vertical = 0;
                }
            } else {
                if (utils.exists(this.left) && x < this.left) {
                    this.horizontal = 1 * this.reverse * this.speed * (60 / 1000);
                } else if (utils.exists(this.right) && x > this.right) {
                    this.horizontal = -1 * this.reverse * this.speed * (60 / 1000);
                } else {
                    this.decelerateHorizontal();
                    this.horizontal = 0;
                }
                if (utils.exists(this.top) && y < this.top) {
                    this.vertical = 1 * this.reverse * this.speed * (60 / 1000);
                } else if (utils.exists(this.bottom) && y > this.bottom) {
                    this.vertical = -1 * this.reverse * this.speed * (60 / 1000);
                } else {
                    this.decelerateVertical();
                    this.vertical = 0;
                }
            }
        }
    }, {
        key: 'decelerateHorizontal',
        value: function decelerateHorizontal() {
            var decelerate = this.parent.plugins['decelerate'];
            if (this.horizontal && decelerate && !this.noDecelerate) {
                decelerate.activate({ x: this.horizontal * this.speed * this.reverse / (1000 / 60) });
            }
        }
    }, {
        key: 'decelerateVertical',
        value: function decelerateVertical() {
            var decelerate = this.parent.plugins['decelerate'];
            if (this.vertical && decelerate && !this.noDecelerate) {
                decelerate.activate({ y: this.vertical * this.speed * this.reverse / (1000 / 60) });
            }
        }
    }, {
        key: 'up',
        value: function up() {
            if (this.horizontal) {
                this.decelerateHorizontal();
            }
            if (this.vertical) {
                this.decelerateVertical();
            }
            this.horizontal = this.vertical = null;
        }
    }, {
        key: 'update',
        value: function update() {
            if (this.paused) {
                return;
            }

            if (this.horizontal || this.vertical) {
                var center = this.parent.center;
                if (this.horizontal) {
                    center.x += this.horizontal * this.speed;
                }
                if (this.vertical) {
                    center.y += this.vertical * this.speed;
                }
                this.parent.moveCenter(center);
                this.parent.emit('moved', { viewport: this.parent, type: 'mouse-edges' });
            }
        }
    }]);

    return MouseEdges;
}(Plugin);

/***/ }),

/***/ "RKsu":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}
})();

/***/ }),

/***/ "ReEC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("Ywoo");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Caption = __webpack_require__("5cLE");

var _Caption2 = _interopRequireDefault(_Caption);

var _Navbar = __webpack_require__("Yp9R");

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Month = __webpack_require__("Rjnf");

var _Month2 = _interopRequireDefault(_Month);

var _Weekday = __webpack_require__("FQbN");

var _Weekday2 = _interopRequireDefault(_Weekday);

var _Helpers = __webpack_require__("2M8e");

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__("s8Q5");

var DateUtils = _interopRequireWildcard(_DateUtils);

var _LocaleUtils = __webpack_require__("Awug");

var LocaleUtils = _interopRequireWildcard(_LocaleUtils);

var _ModifiersUtils = __webpack_require__("ogP8");

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _classNames = __webpack_require__("ESgF");

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__("SdFt");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DayPicker = exports.DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.dayPicker = null;

    _this.showNextMonth = function (callback) {
      if (!_this.allowNextMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var nextMonth = DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
      _this.showMonth(nextMonth, callback);
    };

    _this.showPreviousMonth = function (callback) {
      if (!_this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var previousMonth = DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
      _this.showMonth(previousMonth, callback);
    };

    _this.handleKeyDown = function (e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          _this.showPreviousMonth();
          break;
        case _keys.RIGHT:
          _this.showNextMonth();
          break;
        case _keys.UP:
          _this.showPreviousYear();
          break;
        case _keys.DOWN:
          _this.showNextYear();
          break;
        default:
          break;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleDayKeyDown = function (day, modifiers, e) {
      e.persist();
      switch (e.keyCode) {
        case _keys.LEFT:
          Helpers.cancelEvent(e);
          _this.focusPreviousDay(e.target);
          break;
        case _keys.RIGHT:
          Helpers.cancelEvent(e);
          _this.focusNextDay(e.target);
          break;
        case _keys.UP:
          Helpers.cancelEvent(e);
          _this.focusPreviousWeek(e.target);
          break;
        case _keys.DOWN:
          Helpers.cancelEvent(e);
          _this.focusNextWeek(e.target);
          break;
        case _keys.ENTER:
        case _keys.SPACE:
          Helpers.cancelEvent(e);
          if (_this.props.onDayClick) {
            _this.handleDayClick(day, modifiers, e);
          }
          break;
        default:
          break;
      }
      if (_this.props.onDayKeyDown) {
        _this.props.onDayKeyDown(day, modifiers, e);
      }
    };

    _this.handleDayClick = function (day, modifiers, e) {
      e.persist();
      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
        _this.handleOutsideDayClick(day);
      }
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, modifiers, e);
      }
    };

    _this.handleTodayButtonClick = function (e) {
      var today = new Date();
      var month = new Date(today.getFullYear(), today.getMonth());
      _this.showMonth(month);
      e.target.blur();
      if (_this.props.onTodayButtonClick) {
        e.persist();
        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
      }
    };

    var currentMonth = _this.getCurrentMonthFromProps(props);
    _this.state = { currentMonth: currentMonth };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Changing the `month` props means changing the current displayed month
      if (prevProps.month !== this.props.month && !DateUtils.isSameMonth(prevProps.month, this.props.month)) {
        var currentMonth = this.getCurrentMonthFromProps(this.props);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ currentMonth: currentMonth });
      }
    }

    /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */

  }, {
    key: 'getCurrentMonthFromProps',
    value: function getCurrentMonthFromProps(props) {
      var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth);
      var currentMonth = initialMonth;

      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
        var diffInMonths = Helpers.getMonthsDiff(props.fromMonth, currentMonth);
        currentMonth = DateUtils.addMonths(props.fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
        currentMonth = DateUtils.addMonths(props.toMonth, 1 - this.props.numberOfMonths);
      }
      return currentMonth;
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        month: this.state.currentMonth,
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);
      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils.addMonths(this.state.currentMonth, i);
        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.props.todayButton) {
        return _react2.default.createElement('div', { className: this.props.classNames.footer }, this.renderTodayButton());
      }
      return null;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement('button', {
        type: 'button',
        tabIndex: 0,
        className: this.props.classNames.todayButton,
        'aria-label': this.props.todayButton,
        onClick: this.handleTodayButtonClick
      }, this.props.todayButton);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement('div', _extends({}, this.props.containerProps, {
        className: className,
        ref: function ref(el) {
          return _this7.dayPicker = el;
        },
        lang: this.props.locale
      }), _react2.default.createElement('div', {
        className: this.props.classNames.wrapper,
        tabIndex: this.props.canChangeMonth && this.props.tabIndex ? this.props.tabIndex : -1,
        onKeyDown: this.handleKeyDown,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur
      }, this.renderNavbar(), _react2.default.createElement('div', { className: this.props.classNames.months }, this.renderMonths()), this.renderFooter()));
    }
  }]);

  return DayPicker;
}(_react.Component);

DayPicker.VERSION = '7.1.6';
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  initialMonth: new Date(),
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils,
  showOutsideDays: false,
  enableOutsideDaysClick: true,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  showWeekDays: true,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  renderWeek: function renderWeek(weekNumber) {
    return weekNumber;
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};
DayPicker.propTypes =  false ? {
  // Rendering months
  initialMonth: _propTypes2.default.instanceOf(Date),
  month: _propTypes2.default.instanceOf(Date),
  numberOfMonths: _propTypes2.default.number,
  fromMonth: _propTypes2.default.instanceOf(Date),
  toMonth: _propTypes2.default.instanceOf(Date),
  canChangeMonth: _propTypes2.default.bool,
  reverseMonths: _propTypes2.default.bool,
  pagedNavigation: _propTypes2.default.bool,
  todayButton: _propTypes2.default.string,
  showWeekNumbers: _propTypes2.default.bool,
  showWeekDays: _propTypes2.default.bool,

  // Modifiers
  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),

  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,

  // Localization
  dir: _propTypes2.default.string,
  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _propTypes2.default.shape({
    nextMonth: _propTypes2.default.string.isRequired,
    previousMonth: _propTypes2.default.string.isRequired
  }),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Customization
  showOutsideDays: _propTypes2.default.bool,
  enableOutsideDaysClick: _propTypes2.default.bool,
  fixedWeeks: _propTypes2.default.bool,

  // CSS and HTML
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string,
    container: _propTypes2.default.string,
    day: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    footer: _propTypes2.default.string,
    interactionDisabled: _propTypes2.default.string,
    months: _propTypes2.default.string,
    month: _propTypes2.default.string,
    navBar: _propTypes2.default.string,
    outside: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    todayButton: _propTypes2.default.string,
    week: _propTypes2.default.string,
    wrapper: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  containerProps: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,

  // Custom elements
  renderDay: _propTypes2.default.func,
  renderWeek: _propTypes2.default.func,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),

  // Events
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onCaptionClick: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func,
  onTodayButtonClick: _propTypes2.default.func
} : {};

DayPicker.DateUtils = DateUtils;
DayPicker.LocaleUtils = LocaleUtils;
DayPicker.ModifiersUtils = ModifiersUtils;

exports.DateUtils = DateUtils;
exports.LocaleUtils = LocaleUtils;
exports.ModifiersUtils = ModifiersUtils;
exports.default = DayPicker;
//# sourceMappingURL=DayPicker.js.map

/***/ }),

/***/ "RjZD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.autoDetectRenderer = exports.Application = exports.Filter = exports.SpriteMaskFilter = exports.Quad = exports.RenderTarget = exports.ObjectRenderer = exports.WebGLManager = exports.Shader = exports.CanvasRenderTarget = exports.TextureUvs = exports.VideoBaseTexture = exports.BaseRenderTexture = exports.RenderTexture = exports.BaseTexture = exports.TextureMatrix = exports.Texture = exports.Spritesheet = exports.CanvasGraphicsRenderer = exports.GraphicsRenderer = exports.GraphicsData = exports.Graphics = exports.TextMetrics = exports.TextStyle = exports.Text = exports.SpriteRenderer = exports.CanvasTinter = exports.CanvasSpriteRenderer = exports.Sprite = exports.TransformBase = exports.TransformStatic = exports.Transform = exports.Container = exports.DisplayObject = exports.Bounds = exports.glCore = exports.WebGLRenderer = exports.CanvasRenderer = exports.ticker = exports.utils = exports.settings = undefined;

var _const = __webpack_require__("YEQi");

Object.keys(_const).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _const[key];
    }
  });
});

var _math = __webpack_require__("e3iB");

Object.keys(_math).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _math[key];
    }
  });
});

var _pixiGlCore = __webpack_require__("PJsv");

Object.defineProperty(exports, 'glCore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pixiGlCore).default;
  }
});

var _Bounds = __webpack_require__("Me0q");

Object.defineProperty(exports, 'Bounds', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Bounds).default;
  }
});

var _DisplayObject = __webpack_require__("rGF6");

Object.defineProperty(exports, 'DisplayObject', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DisplayObject).default;
  }
});

var _Container = __webpack_require__("OzBO");

Object.defineProperty(exports, 'Container', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Container).default;
  }
});

var _Transform = __webpack_require__("ThH+");

Object.defineProperty(exports, 'Transform', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Transform).default;
  }
});

var _TransformStatic = __webpack_require__("pc4T");

Object.defineProperty(exports, 'TransformStatic', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TransformStatic).default;
  }
});

var _TransformBase = __webpack_require__("Pszr");

Object.defineProperty(exports, 'TransformBase', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TransformBase).default;
  }
});

var _Sprite = __webpack_require__("oWLW");

Object.defineProperty(exports, 'Sprite', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sprite).default;
  }
});

var _CanvasSpriteRenderer = __webpack_require__("3rZB");

Object.defineProperty(exports, 'CanvasSpriteRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasSpriteRenderer).default;
  }
});

var _CanvasTinter = __webpack_require__("xwA8");

Object.defineProperty(exports, 'CanvasTinter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasTinter).default;
  }
});

var _SpriteRenderer = __webpack_require__("lQAb");

Object.defineProperty(exports, 'SpriteRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SpriteRenderer).default;
  }
});

var _Text = __webpack_require__("sdh2");

Object.defineProperty(exports, 'Text', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Text).default;
  }
});

var _TextStyle = __webpack_require__("gZse");

Object.defineProperty(exports, 'TextStyle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextStyle).default;
  }
});

var _TextMetrics = __webpack_require__("nMdc");

Object.defineProperty(exports, 'TextMetrics', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextMetrics).default;
  }
});

var _Graphics = __webpack_require__("f5iX");

Object.defineProperty(exports, 'Graphics', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Graphics).default;
  }
});

var _GraphicsData = __webpack_require__("i0q3");

Object.defineProperty(exports, 'GraphicsData', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GraphicsData).default;
  }
});

var _GraphicsRenderer = __webpack_require__("tXzk");

Object.defineProperty(exports, 'GraphicsRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GraphicsRenderer).default;
  }
});

var _CanvasGraphicsRenderer = __webpack_require__("bG99");

Object.defineProperty(exports, 'CanvasGraphicsRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasGraphicsRenderer).default;
  }
});

var _Spritesheet = __webpack_require__("hX4Q");

Object.defineProperty(exports, 'Spritesheet', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Spritesheet).default;
  }
});

var _Texture = __webpack_require__("xUki");

Object.defineProperty(exports, 'Texture', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Texture).default;
  }
});

var _TextureMatrix = __webpack_require__("vusc");

Object.defineProperty(exports, 'TextureMatrix', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextureMatrix).default;
  }
});

var _BaseTexture = __webpack_require__("ce6K");

Object.defineProperty(exports, 'BaseTexture', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BaseTexture).default;
  }
});

var _RenderTexture = __webpack_require__("Jb0W");

Object.defineProperty(exports, 'RenderTexture', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RenderTexture).default;
  }
});

var _BaseRenderTexture = __webpack_require__("8ODW");

Object.defineProperty(exports, 'BaseRenderTexture', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BaseRenderTexture).default;
  }
});

var _VideoBaseTexture = __webpack_require__("U1Rh");

Object.defineProperty(exports, 'VideoBaseTexture', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VideoBaseTexture).default;
  }
});

var _TextureUvs = __webpack_require__("sUm+");

Object.defineProperty(exports, 'TextureUvs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextureUvs).default;
  }
});

var _CanvasRenderTarget = __webpack_require__("khQn");

Object.defineProperty(exports, 'CanvasRenderTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasRenderTarget).default;
  }
});

var _Shader = __webpack_require__("wBQE");

Object.defineProperty(exports, 'Shader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Shader).default;
  }
});

var _WebGLManager = __webpack_require__("ClQe");

Object.defineProperty(exports, 'WebGLManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WebGLManager).default;
  }
});

var _ObjectRenderer = __webpack_require__("oXPp");

Object.defineProperty(exports, 'ObjectRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ObjectRenderer).default;
  }
});

var _RenderTarget = __webpack_require__("Xw9x");

Object.defineProperty(exports, 'RenderTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RenderTarget).default;
  }
});

var _Quad = __webpack_require__("tknA");

Object.defineProperty(exports, 'Quad', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Quad).default;
  }
});

var _SpriteMaskFilter = __webpack_require__("VuLC");

Object.defineProperty(exports, 'SpriteMaskFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SpriteMaskFilter).default;
  }
});

var _Filter = __webpack_require__("AVkB");

Object.defineProperty(exports, 'Filter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Filter).default;
  }
});

var _Application = __webpack_require__("Y4lo");

Object.defineProperty(exports, 'Application', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Application).default;
  }
});

var _autoDetectRenderer = __webpack_require__("DqsF");

Object.defineProperty(exports, 'autoDetectRenderer', {
  enumerable: true,
  get: function get() {
    return _autoDetectRenderer.autoDetectRenderer;
  }
});

var _utils = __webpack_require__("dDI1");

var utils = _interopRequireWildcard(_utils);

var _ticker = __webpack_require__("5u59");

var ticker = _interopRequireWildcard(_ticker);

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

var _CanvasRenderer = __webpack_require__("GzOR");

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _WebGLRenderer = __webpack_require__("i77b");

var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.settings = _settings2.default;
exports.utils = utils;
exports.ticker = ticker;
exports.CanvasRenderer = _CanvasRenderer2.default;
exports.WebGLRenderer = _WebGLRenderer2.default; /**
                                                  * @namespace PIXI
                                                  */
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "Rjnf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("Ywoo");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Weekdays = __webpack_require__("ulr3");

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _Day = __webpack_require__("DpAE");

var _Day2 = _interopRequireDefault(_Day);

var _keys = __webpack_require__("SdFt");

var _ModifiersUtils = __webpack_require__("ogP8");

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _Helpers = __webpack_require__("2M8e");

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__("s8Q5");

var DateUtils = _interopRequireWildcard(_DateUtils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(_Day2.default, {
        key: '' + (isOutside ? 'outside-' : '') + key,
        classNames: _this.props.classNames,
        day: day,
        modifiers: modifiers,
        modifiersStyles: _this.props.modifiersStyles,
        empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
        tabIndex: tabIndex,
        ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
        ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
        ariaSelected: dayModifiers.indexOf('selected') > -1,
        onClick: _this.props.onDayClick,
        onFocus: _this.props.onDayFocus,
        onKeyDown: _this.props.onDayKeyDown,
        onMouseEnter: _this.props.onDayMouseEnter,
        onMouseLeave: _this.props.onDayMouseLeave,
        onMouseDown: _this.props.onDayMouseDown,
        onMouseUp: _this.props.onDayMouseUp,
        onTouchEnd: _this.props.onDayTouchEnd,
        onTouchStart: _this.props.onDayTouchStart
      }, _this.props.renderDay(day, modifiers));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          showWeekNumbers = _props.showWeekNumbers,
          showWeekDays = _props.showWeekDays,
          onWeekClick = _props.onWeekClick;

      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
      return _react2.default.createElement('div', { className: classNames.month, role: 'grid' }, caption, showWeekDays && _react2.default.createElement(_Weekdays2.default, {
        classNames: classNames,
        weekdaysShort: weekdaysShort,
        weekdaysLong: weekdaysLong,
        firstDayOfWeek: firstDayOfWeek,
        showWeekNumbers: showWeekNumbers,
        locale: locale,
        localeUtils: localeUtils,
        weekdayElement: weekdayElement
      }), _react2.default.createElement('div', { className: classNames.body, role: 'rowgroup' }, weeks.map(function (week) {
        var weekNumber = void 0;
        if (showWeekNumbers) {
          weekNumber = DateUtils.getWeekNumber(week[6]);
        }
        return _react2.default.createElement('div', {
          key: week[0].getTime(),
          className: classNames.week,
          role: 'row'
        }, showWeekNumbers && _react2.default.createElement('div', {
          className: classNames.weekNumber,
          tabIndex: 0,
          role: 'gridcell',
          onClick: onWeekClick ? function (e) {
            return onWeekClick(weekNumber, week, e);
          } : undefined,
          onKeyUp: onWeekClick ? function (e) {
            return e.keyCode === _keys.ENTER && onWeekClick(weekNumber, week, e);
          } : undefined
        }, _this2.props.renderWeek(weekNumber, week, month)), week.map(_this2.renderDay));
      })));
    }
  }]);

  return Month;
}(_react.Component);

exports.default = Month;
Month.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    month: _propTypes2.default.string.isRequired,
    outside: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    week: _propTypes2.default.string.isRequired
  }).isRequired,
  tabIndex: _propTypes2.default.number,

  month: _propTypes2.default.instanceOf(Date).isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),

  modifiersStyles: _propTypes2.default.object,

  showWeekDays: _propTypes2.default.bool,
  showOutsideDays: _propTypes2.default.bool,

  renderDay: _propTypes2.default.func.isRequired,
  renderWeek: _propTypes2.default.func.isRequired,

  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),

  fixedWeeks: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,

  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  firstDayOfWeek: _propTypes2.default.number.isRequired,

  onCaptionClick: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
} : {};
//# sourceMappingURL=Month.js.map

/***/ }),

/***/ "Rq+a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5bcdda2684769a43ac09ec4c3f95f13b.svg";

/***/ }),

/***/ "Rtmq":
/***/ (function(module, exports, __webpack_require__) {

var dtype = __webpack_require__("iMMC");
var anArray = __webpack_require__("VYcd");
var isBuffer = __webpack_require__("q/Zl");

var CW = [0, 2, 3];
var CCW = [2, 1, 3];

module.exports = function createQuadElements(array, opt) {
    //if user didn't specify an output array
    if (!array || !(anArray(array) || isBuffer(array))) {
        opt = array || {};
        array = null;
    }

    if (typeof opt === 'number') //backwards-compatible
        opt = { count: opt };else opt = opt || {};

    var type = typeof opt.type === 'string' ? opt.type : 'uint16';
    var count = typeof opt.count === 'number' ? opt.count : 1;
    var start = opt.start || 0;

    var dir = opt.clockwise !== false ? CW : CCW,
        a = dir[0],
        b = dir[1],
        c = dir[2];

    var numIndices = count * 6;

    var indices = array || new (dtype(type))(numIndices);
    for (var i = 0, j = 0; i < numIndices; i += 6, j += 4) {
        var x = i + start;
        indices[x + 0] = j + 0;
        indices[x + 1] = j + 1;
        indices[x + 2] = j + 2;
        indices[x + 3] = j + a;
        indices[x + 4] = j + b;
        indices[x + 5] = j + c;
    }
    return indices;
};

/***/ }),

/***/ "S1cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("ED/T");
var isBuffer = __webpack_require__("p/oJ");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};

/***/ }),

/***/ "S5Wx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLManager2 = __webpack_require__("ClQe");

var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

var _RenderTarget = __webpack_require__("Xw9x");

var _RenderTarget2 = _interopRequireDefault(_RenderTarget);

var _Quad = __webpack_require__("tknA");

var _Quad2 = _interopRequireDefault(_Quad);

var _math = __webpack_require__("e3iB");

var _Shader = __webpack_require__("wBQE");

var _Shader2 = _interopRequireDefault(_Shader);

var _filterTransforms = __webpack_require__("O70i");

var filterTransforms = _interopRequireWildcard(_filterTransforms);

var _bitTwiddle = __webpack_require__("gXRl");

var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * @ignore
 * @class
 */
var FilterState = function () {
    /**
     *
     */
    function FilterState() {
        _classCallCheck(this, FilterState);

        this.renderTarget = null;
        this.target = null;
        this.resolution = 1;

        // those three objects are used only for root
        // re-assigned for everything else
        this.sourceFrame = new _math.Rectangle();
        this.destinationFrame = new _math.Rectangle();
        this.filters = [];
    }

    /**
     * clears the state
     */

    FilterState.prototype.clear = function clear() {
        this.filters = null;
        this.target = null;
        this.renderTarget = null;
    };

    return FilterState;
}();

var screenKey = 'screen';

/**
 * @class
 * @memberof PIXI
 * @extends PIXI.WebGLManager
 */

var FilterManager = function (_WebGLManager) {
    _inherits(FilterManager, _WebGLManager);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
     */
    function FilterManager(renderer) {
        _classCallCheck(this, FilterManager);

        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));

        _this.gl = _this.renderer.gl;
        // know about sprites!
        _this.quad = new _Quad2.default(_this.gl, renderer.state.attribState);

        _this.shaderCache = {};
        // todo add default!
        _this.pool = {};

        _this.filterData = null;

        _this.managedFilters = [];

        _this.renderer.on('prerender', _this.onPrerender, _this);

        _this._screenWidth = renderer.view.width;
        _this._screenHeight = renderer.view.height;
        return _this;
    }

    /**
     * Adds a new filter to the manager.
     *
     * @param {PIXI.DisplayObject} target - The target of the filter to render.
     * @param {PIXI.Filter[]} filters - The filters to apply.
     */

    FilterManager.prototype.pushFilter = function pushFilter(target, filters) {
        var renderer = this.renderer;

        var filterData = this.filterData;

        if (!filterData) {
            filterData = this.renderer._activeRenderTarget.filterStack;

            // add new stack
            var filterState = new FilterState();

            filterState.sourceFrame = filterState.destinationFrame = this.renderer._activeRenderTarget.size;
            filterState.renderTarget = renderer._activeRenderTarget;

            this.renderer._activeRenderTarget.filterData = filterData = {
                index: 0,
                stack: [filterState]
            };

            this.filterData = filterData;
        }

        // get the current filter state..
        var currentState = filterData.stack[++filterData.index];
        var renderTargetFrame = filterData.stack[0].destinationFrame;

        if (!currentState) {
            currentState = filterData.stack[filterData.index] = new FilterState();
        }

        var fullScreen = target.filterArea && target.filterArea.x === 0 && target.filterArea.y === 0 && target.filterArea.width === renderer.screen.width && target.filterArea.height === renderer.screen.height;

        // for now we go off the filter of the first resolution..
        var resolution = filters[0].resolution;
        var padding = filters[0].padding | 0;
        var targetBounds = fullScreen ? renderer.screen : target.filterArea || target.getBounds(true);
        var sourceFrame = currentState.sourceFrame;
        var destinationFrame = currentState.destinationFrame;

        sourceFrame.x = (targetBounds.x * resolution | 0) / resolution;
        sourceFrame.y = (targetBounds.y * resolution | 0) / resolution;
        sourceFrame.width = (targetBounds.width * resolution | 0) / resolution;
        sourceFrame.height = (targetBounds.height * resolution | 0) / resolution;

        if (!fullScreen) {
            if (filterData.stack[0].renderTarget.transform) {//

                // TODO we should fit the rect around the transform..
            } else if (filters[0].autoFit) {
                sourceFrame.fit(renderTargetFrame);
            }

            // lets apply the padding After we fit the element to the screen.
            // this should stop the strange side effects that can occur when cropping to the edges
            sourceFrame.pad(padding);
        }

        destinationFrame.width = sourceFrame.width;
        destinationFrame.height = sourceFrame.height;

        // lets play the padding after we fit the element to the screen.
        // this should stop the strange side effects that can occur when cropping to the edges

        var renderTarget = this.getPotRenderTarget(renderer.gl, sourceFrame.width, sourceFrame.height, resolution);

        currentState.target = target;
        currentState.filters = filters;
        currentState.resolution = resolution;
        currentState.renderTarget = renderTarget;

        // bind the render target to draw the shape in the top corner..

        renderTarget.setFrame(destinationFrame, sourceFrame);

        // bind the render target
        renderer.bindRenderTarget(renderTarget);
        renderTarget.clear();
    };

    /**
     * Pops off the filter and applies it.
     *
     */

    FilterManager.prototype.popFilter = function popFilter() {
        var filterData = this.filterData;

        var lastState = filterData.stack[filterData.index - 1];
        var currentState = filterData.stack[filterData.index];

        this.quad.map(currentState.renderTarget.size, currentState.sourceFrame).upload();

        var filters = currentState.filters;

        if (filters.length === 1) {
            filters[0].apply(this, currentState.renderTarget, lastState.renderTarget, false, currentState);
            this.freePotRenderTarget(currentState.renderTarget);
        } else {
            var flip = currentState.renderTarget;
            var flop = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, currentState.resolution);

            flop.setFrame(currentState.destinationFrame, currentState.sourceFrame);

            // finally lets clear the render target before drawing to it..
            flop.clear();

            var i = 0;

            for (i = 0; i < filters.length - 1; ++i) {
                filters[i].apply(this, flip, flop, true, currentState);

                var t = flip;

                flip = flop;
                flop = t;
            }

            filters[i].apply(this, flip, lastState.renderTarget, false, currentState);

            this.freePotRenderTarget(flip);
            this.freePotRenderTarget(flop);
        }

        currentState.clear();
        filterData.index--;

        if (filterData.index === 0) {
            this.filterData = null;
        }
    };

    /**
     * Draws a filter.
     *
     * @param {PIXI.Filter} filter - The filter to draw.
     * @param {PIXI.RenderTarget} input - The input render target.
     * @param {PIXI.RenderTarget} output - The target to output to.
     * @param {boolean} clear - Should the output be cleared before rendering to it
     */

    FilterManager.prototype.applyFilter = function applyFilter(filter, input, output, clear) {
        var renderer = this.renderer;
        var gl = renderer.gl;

        var shader = filter.glShaders[renderer.CONTEXT_UID];

        // caching..
        if (!shader) {
            if (filter.glShaderKey) {
                shader = this.shaderCache[filter.glShaderKey];

                if (!shader) {
                    shader = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);

                    filter.glShaders[renderer.CONTEXT_UID] = this.shaderCache[filter.glShaderKey] = shader;
                    this.managedFilters.push(filter);
                }
            } else {
                shader = filter.glShaders[renderer.CONTEXT_UID] = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);
                this.managedFilters.push(filter);
            }

            // TODO - this only needs to be done once?
            renderer.bindVao(null);

            this.quad.initVao(shader);
        }

        renderer.bindVao(this.quad.vao);

        renderer.bindRenderTarget(output);

        if (clear) {
            gl.disable(gl.SCISSOR_TEST);
            renderer.clear(); // [1, 1, 1, 1]);
            gl.enable(gl.SCISSOR_TEST);
        }

        // in case the render target is being masked using a scissor rect
        if (output === renderer.maskManager.scissorRenderTarget) {
            renderer.maskManager.pushScissorMask(null, renderer.maskManager.scissorData);
        }

        renderer.bindShader(shader);

        // free unit 0 for us, doesn't matter what was there
        // don't try to restore it, because syncUniforms can upload it to another slot
        // and it'll be a problem
        var tex = this.renderer.emptyTextures[0];

        this.renderer.boundTextures[0] = tex;
        // this syncs the PixiJS filters  uniforms with glsl uniforms
        this.syncUniforms(shader, filter);

        renderer.state.setBlendMode(filter.blendMode);

        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, input.texture.texture);

        this.quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);

        gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
    };

    /**
     * Uploads the uniforms of the filter.
     *
     * @param {GLShader} shader - The underlying gl shader.
     * @param {PIXI.Filter} filter - The filter we are synchronizing.
     */

    FilterManager.prototype.syncUniforms = function syncUniforms(shader, filter) {
        var uniformData = filter.uniformData;
        var uniforms = filter.uniforms;

        // 0 is reserved for the PixiJS texture so we start at 1!
        var textureCount = 1;
        var currentState = void 0;

        // filterArea and filterClamp that are handled by FilterManager directly
        // they must not appear in uniformData

        if (shader.uniforms.filterArea) {
            currentState = this.filterData.stack[this.filterData.index];

            var filterArea = shader.uniforms.filterArea;

            filterArea[0] = currentState.renderTarget.size.width;
            filterArea[1] = currentState.renderTarget.size.height;
            filterArea[2] = currentState.sourceFrame.x;
            filterArea[3] = currentState.sourceFrame.y;

            shader.uniforms.filterArea = filterArea;
        }

        // use this to clamp displaced texture coords so they belong to filterArea
        // see displacementFilter fragment shader for an example
        if (shader.uniforms.filterClamp) {
            currentState = currentState || this.filterData.stack[this.filterData.index];

            var filterClamp = shader.uniforms.filterClamp;

            filterClamp[0] = 0;
            filterClamp[1] = 0;
            filterClamp[2] = (currentState.sourceFrame.width - 1) / currentState.renderTarget.size.width;
            filterClamp[3] = (currentState.sourceFrame.height - 1) / currentState.renderTarget.size.height;

            shader.uniforms.filterClamp = filterClamp;
        }

        // TODO Caching layer..
        for (var i in uniformData) {
            if (!shader.uniforms.data[i]) {
                continue;
            }

            var type = uniformData[i].type;

            if (type === 'sampler2d' && uniforms[i] !== 0) {
                if (uniforms[i].baseTexture) {
                    shader.uniforms[i] = this.renderer.bindTexture(uniforms[i].baseTexture, textureCount);
                } else {
                    shader.uniforms[i] = textureCount;

                    // TODO
                    // this is helpful as renderTargets can also be set.
                    // Although thinking about it, we could probably
                    // make the filter texture cache return a RenderTexture
                    // rather than a renderTarget
                    var gl = this.renderer.gl;

                    this.renderer.boundTextures[textureCount] = this.renderer.emptyTextures[textureCount];
                    gl.activeTexture(gl.TEXTURE0 + textureCount);

                    uniforms[i].texture.bind();
                }

                textureCount++;
            } else if (type === 'mat3') {
                // check if its PixiJS matrix..
                if (uniforms[i].a !== undefined) {
                    shader.uniforms[i] = uniforms[i].toArray(true);
                } else {
                    shader.uniforms[i] = uniforms[i];
                }
            } else if (type === 'vec2') {
                // check if its a point..
                if (uniforms[i].x !== undefined) {
                    var val = shader.uniforms[i] || new Float32Array(2);

                    val[0] = uniforms[i].x;
                    val[1] = uniforms[i].y;
                    shader.uniforms[i] = val;
                } else {
                    shader.uniforms[i] = uniforms[i];
                }
            } else if (type === 'float') {
                if (shader.uniforms.data[i].value !== uniformData[i]) {
                    shader.uniforms[i] = uniforms[i];
                }
            } else {
                shader.uniforms[i] = uniforms[i];
            }
        }
    };

    /**
     * Gets a render target from the pool, or creates a new one.
     *
     * @param {boolean} clear - Should we clear the render texture when we get it?
     * @param {number} resolution - The resolution of the target.
     * @return {PIXI.RenderTarget} The new render target
     */

    FilterManager.prototype.getRenderTarget = function getRenderTarget(clear, resolution) {
        var currentState = this.filterData.stack[this.filterData.index];
        var renderTarget = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, resolution || currentState.resolution);

        renderTarget.setFrame(currentState.destinationFrame, currentState.sourceFrame);

        return renderTarget;
    };

    /**
     * Returns a render target to the pool.
     *
     * @param {PIXI.RenderTarget} renderTarget - The render target to return.
     */

    FilterManager.prototype.returnRenderTarget = function returnRenderTarget(renderTarget) {
        this.freePotRenderTarget(renderTarget);
    };

    /**
     * Calculates the mapped matrix.
     *
     * TODO playing around here.. this is temporary - (will end up in the shader)
     * this returns a matrix that will normalise map filter cords in the filter to screen space
     *
     * @param {PIXI.Matrix} outputMatrix - the matrix to output to.
     * @return {PIXI.Matrix} The mapped matrix.
     */

    FilterManager.prototype.calculateScreenSpaceMatrix = function calculateScreenSpaceMatrix(outputMatrix) {
        var currentState = this.filterData.stack[this.filterData.index];

        return filterTransforms.calculateScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size);
    };

    /**
     * Multiply vTextureCoord to this matrix to achieve (0,0,1,1) for filterArea
     *
     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
     * @return {PIXI.Matrix} The mapped matrix.
     */

    FilterManager.prototype.calculateNormalizedScreenSpaceMatrix = function calculateNormalizedScreenSpaceMatrix(outputMatrix) {
        var currentState = this.filterData.stack[this.filterData.index];

        return filterTransforms.calculateNormalizedScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, currentState.destinationFrame);
    };

    /**
     * This will map the filter coord so that a texture can be used based on the transform of a sprite
     *
     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
     * @param {PIXI.Sprite} sprite - The sprite to map to.
     * @return {PIXI.Matrix} The mapped matrix.
     */

    FilterManager.prototype.calculateSpriteMatrix = function calculateSpriteMatrix(outputMatrix, sprite) {
        var currentState = this.filterData.stack[this.filterData.index];

        return filterTransforms.calculateSpriteMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, sprite);
    };

    /**
     * Destroys this Filter Manager.
     *
     * @param {boolean} [contextLost=false] context was lost, do not free shaders
     *
     */

    FilterManager.prototype.destroy = function destroy() {
        var contextLost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var renderer = this.renderer;
        var filters = this.managedFilters;

        renderer.off('prerender', this.onPrerender, this);

        for (var i = 0; i < filters.length; i++) {
            if (!contextLost) {
                filters[i].glShaders[renderer.CONTEXT_UID].destroy();
            }
            delete filters[i].glShaders[renderer.CONTEXT_UID];
        }

        this.shaderCache = {};
        if (!contextLost) {
            this.emptyPool();
        } else {
            this.pool = {};
        }
    };

    /**
     * Gets a Power-of-Two render texture.
     *
     * TODO move to a separate class could be on renderer?
     * also - could cause issue with multiple contexts?
     *
     * @private
     * @param {WebGLRenderingContext} gl - The webgl rendering context
     * @param {number} minWidth - The minimum width of the render target.
     * @param {number} minHeight - The minimum height of the render target.
     * @param {number} resolution - The resolution of the render target.
     * @return {PIXI.RenderTarget} The new render target.
     */

    FilterManager.prototype.getPotRenderTarget = function getPotRenderTarget(gl, minWidth, minHeight, resolution) {
        var key = screenKey;

        minWidth *= resolution;
        minHeight *= resolution;

        if (minWidth !== this._screenWidth || minHeight !== this._screenHeight) {
            // TODO you could return a bigger texture if there is not one in the pool?
            minWidth = _bitTwiddle2.default.nextPow2(minWidth);
            minHeight = _bitTwiddle2.default.nextPow2(minHeight);
            key = (minWidth & 0xFFFF) << 16 | minHeight & 0xFFFF;
        }

        if (!this.pool[key]) {
            this.pool[key] = [];
        }

        var renderTarget = this.pool[key].pop();

        // creating render target will cause texture to be bound!
        if (!renderTarget) {
            // temporary bypass cache..
            var tex = this.renderer.boundTextures[0];

            gl.activeTexture(gl.TEXTURE0);

            // internally - this will cause a texture to be bound..
            renderTarget = new _RenderTarget2.default(gl, minWidth, minHeight, null, 1);

            // set the current one back
            gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
        }

        // manually tweak the resolution...
        // this will not modify the size of the frame buffer, just its resolution.
        renderTarget.resolution = resolution;
        renderTarget.defaultFrame.width = renderTarget.size.width = minWidth / resolution;
        renderTarget.defaultFrame.height = renderTarget.size.height = minHeight / resolution;
        renderTarget.filterPoolKey = key;

        return renderTarget;
    };

    /**
     * Empties the texture pool.
     *
     */

    FilterManager.prototype.emptyPool = function emptyPool() {
        for (var i in this.pool) {
            var textures = this.pool[i];

            if (textures) {
                for (var j = 0; j < textures.length; j++) {
                    textures[j].destroy(true);
                }
            }
        }

        this.pool = {};
    };

    /**
     * Frees a render target back into the pool.
     *
     * @param {PIXI.RenderTarget} renderTarget - The renderTarget to free
     */

    FilterManager.prototype.freePotRenderTarget = function freePotRenderTarget(renderTarget) {
        this.pool[renderTarget.filterPoolKey].push(renderTarget);
    };

    /**
     * Called before the renderer starts rendering.
     *
     */

    FilterManager.prototype.onPrerender = function onPrerender() {
        if (this._screenWidth !== this.renderer.view.width || this._screenHeight !== this.renderer.view.height) {
            this._screenWidth = this.renderer.view.width;
            this._screenHeight = this.renderer.view.height;

            var textures = this.pool[screenKey];

            if (textures) {
                for (var j = 0; j < textures.length; j++) {
                    textures[j].destroy(true);
                }
            }
            this.pool[screenKey] = [];
        }
    };

    return FilterManager;
}(_WebGLManager3.default);

exports.default = FilterManager;
//# sourceMappingURL=FilterManager.js.map

/***/ }),

/***/ "S77k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Seat_1 = __webpack_require__("qrdL");
var bound_1 = __webpack_require__("USDo");

var Seat = function (_Seat_1$default) {
    _inherits(Seat, _Seat_1$default);

    function Seat() {
        _classCallCheck(this, Seat);

        return _possibleConstructorReturn(this, _Seat_1$default.apply(this, arguments));
    }

    Seat.prototype.onClick = function onClick() {
        var seatInfo = {
            seatId: this._id,
            seatNum: this.seatId + this.seatlabelStartAt,
            tableId: this.tableId,
            tableName: this.tableName,
            sectionId: this.sectionId,
            sectionName: this.sectionName
        };
        if (!this.disableClick) {
            if (this.seatCurrentlySelected && !this.ticketInfo) {
                this.actions.onSecondSeatClicked(seatInfo);
                this.moveToSelected = true;
                this.setTexture();
            } else if (!this.seatCurrentlySelected && this.ticketInfo) {
                this.actions.onSeatClicked(seatInfo, this.ticketInfo);
                this.moveSelected = true;
                this.setTexture();
            } else if (this.seatCurrentlySelected && this.ticketInfo) {
                this.actions.onSeatSwapClicked(seatInfo, this.ticketInfo);
                this.moveToSelected = true;
                this.setTexture();
            }
        }
    };

    return Seat;
}(Seat_1.default);

__decorate([bound_1.default], Seat.prototype, "onClick", null);
exports.default = Seat;
//# sourceMappingURL=Seat.js.map

/***/ }),

/***/ "SIdQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__("TD7O");
var $isFinite = __webpack_require__("lJl4");

var sign = __webpack_require__("mhfJ");
var mod = __webpack_require__("eYhx");

var IsCallable = __webpack_require__("b4C7");
var toPrimitive = __webpack_require__("v4E7");

var has = __webpack_require__("ar57");

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) {
			return 0;
		}
		if (number === 0 || !$isFinite(number)) {
			return number;
		}
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) {
			return 0;
		}
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) {
			// 0 === -0, but they are not identical.
			if (x === 0) {
				return 1 / x === 1 / y;
			}
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};
		// jscs:disable
		for (var key in Desc) {
			// eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}
		// jscs:enable
		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;

/***/ }),

/***/ "SdFt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var TAB = exports.TAB = 9;
//# sourceMappingURL=keys.js.map

/***/ }),

/***/ "Sh+V":
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach(obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};

/***/ }),

/***/ "StZv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = canUseNewCanvasBlendModes;
/**
 * Creates a little colored canvas
 *
 * @ignore
 * @param {string} color - The color to make the canvas
 * @return {canvas} a small canvas element
 */
function createColoredCanvas(color) {
    var canvas = document.createElement('canvas');

    canvas.width = 6;
    canvas.height = 1;

    var context = canvas.getContext('2d');

    context.fillStyle = color;
    context.fillRect(0, 0, 6, 1);

    return canvas;
}

/**
 * Checks whether the Canvas BlendModes are supported by the current browser
 *
 * @return {boolean} whether they are supported
 */
function canUseNewCanvasBlendModes() {
    if (typeof document === 'undefined') {
        return false;
    }

    var magenta = createColoredCanvas('#ff00ff');
    var yellow = createColoredCanvas('#ffff00');

    var canvas = document.createElement('canvas');

    canvas.width = 6;
    canvas.height = 1;

    var context = canvas.getContext('2d');

    context.globalCompositeOperation = 'multiply';
    context.drawImage(magenta, 0, 0);
    context.drawImage(yellow, 2, 0);

    var imageData = context.getImageData(2, 0, 1, 1);

    if (!imageData) {
        return false;
    }

    var data = imageData.data;

    return data[0] === 255 && data[1] === 0 && data[2] === 0;
}
//# sourceMappingURL=canUseNewCanvasBlendModes.js.map

/***/ }),

/***/ "TD7O":
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

/***/ }),

/***/ "TKYo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Rectangle = __webpack_require__("MxpT");

var _Rectangle2 = _interopRequireDefault(_Rectangle);

var _const = __webpack_require__("YEQi");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * The Ellipse object can be used to specify a hit area for displayObjects
 *
 * @class
 * @memberof PIXI
 */
var Ellipse = function () {
  /**
   * @param {number} [x=0] - The X coordinate of the center of this ellipse
   * @param {number} [y=0] - The Y coordinate of the center of this ellipse
   * @param {number} [halfWidth=0] - The half width of this ellipse
   * @param {number} [halfHeight=0] - The half height of this ellipse
   */
  function Ellipse() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var halfWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var halfHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck(this, Ellipse);

    /**
     * @member {number}
     * @default 0
     */
    this.x = x;

    /**
     * @member {number}
     * @default 0
     */
    this.y = y;

    /**
     * @member {number}
     * @default 0
     */
    this.width = halfWidth;

    /**
     * @member {number}
     * @default 0
     */
    this.height = halfHeight;

    /**
     * The type of the object, mainly used to avoid `instanceof` checks
     *
     * @member {number}
     * @readOnly
     * @default PIXI.SHAPES.ELIP
     * @see PIXI.SHAPES
     */
    this.type = _const.SHAPES.ELIP;
  }

  /**
   * Creates a clone of this Ellipse instance
   *
   * @return {PIXI.Ellipse} a copy of the ellipse
   */

  Ellipse.prototype.clone = function clone() {
    return new Ellipse(this.x, this.y, this.width, this.height);
  };

  /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   *
   * @param {number} x - The X coordinate of the point to test
   * @param {number} y - The Y coordinate of the point to test
   * @return {boolean} Whether the x/y coords are within this ellipse
   */

  Ellipse.prototype.contains = function contains(x, y) {
    if (this.width <= 0 || this.height <= 0) {
      return false;
    }

    // normalize the coords to an ellipse with center 0,0
    var normx = (x - this.x) / this.width;
    var normy = (y - this.y) / this.height;

    normx *= normx;
    normy *= normy;

    return normx + normy <= 1;
  };

  /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   *
   * @return {PIXI.Rectangle} the framing rectangle
   */

  Ellipse.prototype.getBounds = function getBounds() {
    return new _Rectangle2.default(this.x - this.width, this.y - this.height, this.width, this.height);
  };

  return Ellipse;
}();

exports.default = Ellipse;
//# sourceMappingURL=Ellipse.js.map

/***/ }),

/***/ "TO+D":
/***/ (function(module, exports) {

var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];
var candidateSelector = candidateSelectors.join(',');

var matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function tabbable(el, options) {
  options = options || {};

  var elementDocument = el.ownerDocument || el;
  var regularTabbables = [];
  var orderedTabbables = [];

  var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
  var candidates = el.querySelectorAll(candidateSelector);

  if (options.includeContainer) {
    if (matches.call(el, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var i, candidate, candidateTabindex;
  for (i = 0; i < candidates.length; i++) {
    candidate = candidates[i];

    if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;

    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  }

  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
    return a.node;
  }).concat(regularTabbables);

  return tabbableNodes;
}

tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;

function isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
  if (!isNodeMatchingSelectorFocusable(node, untouchabilityChecker) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
    return false;
  }
  return true;
}

function isTabbable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
}

function isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
  untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node.ownerDocument || node);
  if (node.disabled || isHiddenInput(node) || untouchabilityChecker.isUntouchable(node)) {
    return false;
  }
  return true;
}

var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
}

function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) return 0;
  return node.tabIndex;
}

function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}

// Array.prototype.find not available in IE.
function find(list, predicate) {
  for (var i = 0, length = list.length; i < length; i++) {
    if (predicate(list[i])) return list[i];
  }
}

function isContentEditable(node) {
  return node.contentEditable === 'true';
}

function isInput(node) {
  return node.tagName === 'INPUT';
}

function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}

function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}

function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}

function getCheckedRadio(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}

function isTabbableRadio(node) {
  if (!node.name) return true;
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}

// An element is "untouchable" if *it or one of its ancestors* has
// `visibility: hidden` or `display: none`.
function UntouchabilityChecker(elementDocument) {
  this.doc = elementDocument;
  // Node cache must be refreshed on every check, in case
  // the content of the element has changed. The cache contains tuples
  // mapping nodes to their boolean result.
  this.cache = [];
}

// getComputedStyle accurately reflects `visibility: hidden` of ancestors
// but not `display: none`, so we need to recursively check parents.
UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
  if (node.nodeType !== Node.ELEMENT_NODE) return false;

  // Search for a cached result.
  var cached = find(this.cache, function (item) {
    return item === node;
  });
  if (cached) return cached[1];

  nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);

  var result = false;

  if (nodeComputedStyle.display === 'none') {
    result = true;
  } else if (node.parentNode) {
    result = this.hasDisplayNone(node.parentNode);
  }

  this.cache.push([node, result]);

  return result;
};

UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
  if (node === this.doc.documentElement) return false;
  var computedStyle = this.doc.defaultView.getComputedStyle(node);
  if (this.hasDisplayNone(node, computedStyle)) return true;
  return computedStyle.visibility === 'hidden';
};

module.exports = tabbable;

/***/ }),

/***/ "TSIo":
/***/ (function(module, exports) {

function Grid(points, cellSize) {
    this._cells = [];
    this._cellSize = cellSize;
    this._reverseCellSize = 1 / cellSize;

    for (var i = 0; i < points.length; i++) {
        var point = points[i];
        var x = this.coordToCellNum(point[0]);
        var y = this.coordToCellNum(point[1]);
        if (!this._cells[x]) {
            var array = [];
            array[y] = [point];
            this._cells[x] = array;
        } else if (!this._cells[x][y]) {
            this._cells[x][y] = [point];
        } else {
            this._cells[x][y].push(point);
        }
    }
}

Grid.prototype = {
    cellPoints: function cellPoints(x, y) {
        // (Number, Number) -> Array
        return this._cells[x] !== undefined && this._cells[x][y] !== undefined ? this._cells[x][y] : [];
    },

    rangePoints: function rangePoints(bbox) {
        // (Array) -> Array
        var tlCellX = this.coordToCellNum(bbox[0]);
        var tlCellY = this.coordToCellNum(bbox[1]);
        var brCellX = this.coordToCellNum(bbox[2]);
        var brCellY = this.coordToCellNum(bbox[3]);
        var points = [];

        for (var x = tlCellX; x <= brCellX; x++) {
            for (var y = tlCellY; y <= brCellY; y++) {
                Array.prototype.push.apply(points, this.cellPoints(x, y));
            }
        }

        return points;
    },

    removePoint: function removePoint(point) {
        // (Array) -> Array
        var cellX = this.coordToCellNum(point[0]);
        var cellY = this.coordToCellNum(point[1]);
        var cell = this._cells[cellX][cellY];
        var pointIdxInCell = void 0;

        for (var i = 0; i < cell.length; i++) {
            if (cell[i][0] === point[0] && cell[i][1] === point[1]) {
                pointIdxInCell = i;
                break;
            }
        }

        cell.splice(pointIdxInCell, 1);

        return cell;
    },

    trunc: Math.trunc || function (val) {
        // (number) -> number
        return val - val % 1;
    },

    coordToCellNum: function coordToCellNum(x) {
        // (number) -> number
        return this.trunc(x * this._reverseCellSize);
    },

    extendBbox: function extendBbox(bbox, scaleFactor) {
        // (Array, Number) -> Array
        return [bbox[0] - scaleFactor * this._cellSize, bbox[1] - scaleFactor * this._cellSize, bbox[2] + scaleFactor * this._cellSize, bbox[3] + scaleFactor * this._cellSize];
    }
};

function grid(points, cellSize) {
    return new Grid(points, cellSize);
}

module.exports = grid;

/***/ }),

/***/ "TVBW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mapWebGLBlendModesToPixi = __webpack_require__("KoUQ");

var _mapWebGLBlendModesToPixi2 = _interopRequireDefault(_mapWebGLBlendModesToPixi);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var BLEND = 0;
var DEPTH_TEST = 1;
var FRONT_FACE = 2;
var CULL_FACE = 3;
var BLEND_FUNC = 4;

/**
 * A WebGL state machines
 *
 * @memberof PIXI
 * @class
 */

var WebGLState = function () {
    /**
     * @param {WebGLRenderingContext} gl - The current WebGL rendering context
     */
    function WebGLState(gl) {
        _classCallCheck(this, WebGLState);

        /**
         * The current active state
         *
         * @member {Uint8Array}
         */
        this.activeState = new Uint8Array(16);

        /**
         * The default state
         *
         * @member {Uint8Array}
         */
        this.defaultState = new Uint8Array(16);

        // default blend mode..
        this.defaultState[0] = 1;

        /**
         * The current state index in the stack
         *
         * @member {number}
         * @private
         */
        this.stackIndex = 0;

        /**
         * The stack holding all the different states
         *
         * @member {Array<*>}
         * @private
         */
        this.stack = [];

        /**
         * The current WebGL rendering context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;

        this.maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);

        this.attribState = {
            tempAttribState: new Array(this.maxAttribs),
            attribState: new Array(this.maxAttribs)
        };

        this.blendModes = (0, _mapWebGLBlendModesToPixi2.default)(gl);

        // check we have vao..
        this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') || gl.getExtension('MOZ_OES_vertex_array_object') || gl.getExtension('WEBKIT_OES_vertex_array_object');
    }

    /**
     * Pushes a new active state
     */

    WebGLState.prototype.push = function push() {
        // next state..
        var state = this.stack[this.stackIndex];

        if (!state) {
            state = this.stack[this.stackIndex] = new Uint8Array(16);
        }

        ++this.stackIndex;

        // copy state..
        // set active state so we can force overrides of gl state
        for (var i = 0; i < this.activeState.length; i++) {
            state[i] = this.activeState[i];
        }
    };

    /**
     * Pops a state out
     */

    WebGLState.prototype.pop = function pop() {
        var state = this.stack[--this.stackIndex];

        this.setState(state);
    };

    /**
     * Sets the current state
     *
     * @param {*} state - The state to set.
     */

    WebGLState.prototype.setState = function setState(state) {
        this.setBlend(state[BLEND]);
        this.setDepthTest(state[DEPTH_TEST]);
        this.setFrontFace(state[FRONT_FACE]);
        this.setCullFace(state[CULL_FACE]);
        this.setBlendMode(state[BLEND_FUNC]);
    };

    /**
     * Enables or disabled blending.
     *
     * @param {boolean} value - Turn on or off webgl blending.
     */

    WebGLState.prototype.setBlend = function setBlend(value) {
        value = value ? 1 : 0;

        if (this.activeState[BLEND] === value) {
            return;
        }

        this.activeState[BLEND] = value;
        this.gl[value ? 'enable' : 'disable'](this.gl.BLEND);
    };

    /**
     * Sets the blend mode.
     *
     * @param {number} value - The blend mode to set to.
     */

    WebGLState.prototype.setBlendMode = function setBlendMode(value) {
        if (value === this.activeState[BLEND_FUNC]) {
            return;
        }

        this.activeState[BLEND_FUNC] = value;

        var mode = this.blendModes[value];

        if (mode.length === 2) {
            this.gl.blendFunc(mode[0], mode[1]);
        } else {
            this.gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]);
        }
    };

    /**
     * Sets whether to enable or disable depth test.
     *
     * @param {boolean} value - Turn on or off webgl depth testing.
     */

    WebGLState.prototype.setDepthTest = function setDepthTest(value) {
        value = value ? 1 : 0;

        if (this.activeState[DEPTH_TEST] === value) {
            return;
        }

        this.activeState[DEPTH_TEST] = value;
        this.gl[value ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
    };

    /**
     * Sets whether to enable or disable cull face.
     *
     * @param {boolean} value - Turn on or off webgl cull face.
     */

    WebGLState.prototype.setCullFace = function setCullFace(value) {
        value = value ? 1 : 0;

        if (this.activeState[CULL_FACE] === value) {
            return;
        }

        this.activeState[CULL_FACE] = value;
        this.gl[value ? 'enable' : 'disable'](this.gl.CULL_FACE);
    };

    /**
     * Sets the gl front face.
     *
     * @param {boolean} value - true is clockwise and false is counter-clockwise
     */

    WebGLState.prototype.setFrontFace = function setFrontFace(value) {
        value = value ? 1 : 0;

        if (this.activeState[FRONT_FACE] === value) {
            return;
        }

        this.activeState[FRONT_FACE] = value;
        this.gl.frontFace(this.gl[value ? 'CW' : 'CCW']);
    };

    /**
     * Disables all the vaos in use
     *
     */

    WebGLState.prototype.resetAttributes = function resetAttributes() {
        for (var i = 0; i < this.attribState.tempAttribState.length; i++) {
            this.attribState.tempAttribState[i] = 0;
        }

        for (var _i = 0; _i < this.attribState.attribState.length; _i++) {
            this.attribState.attribState[_i] = 0;
        }

        // im going to assume one is always active for performance reasons.
        for (var _i2 = 1; _i2 < this.maxAttribs; _i2++) {
            this.gl.disableVertexAttribArray(_i2);
        }
    };

    // used
    /**
     * Resets all the logic and disables the vaos
     */

    WebGLState.prototype.resetToDefault = function resetToDefault() {
        // unbind any VAO if they exist..
        if (this.nativeVaoExtension) {
            this.nativeVaoExtension.bindVertexArrayOES(null);
        }

        // reset all attributes..
        this.resetAttributes();

        // set active state so we can force overrides of gl state
        for (var i = 0; i < this.activeState.length; ++i) {
            this.activeState[i] = 32;
        }

        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);

        this.setState(this.defaultState);
    };

    return WebGLState;
}();

exports.default = WebGLState;
//# sourceMappingURL=WebGLState.js.map

/***/ }),

/***/ "TbMi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var bound_1 = __webpack_require__("USDo");
var StaticContainer_1 = __webpack_require__("dUhe");
var Rows_1 = __webpack_require__("IdVv");
var Table_1 = __webpack_require__("KtQ5");
var hull = __webpack_require__("rWY2");
var events = {
    onSeatClicked: function onSeatClicked() {
        return console.log("onSeatClicked not implemented");
    },
    onTableClicked: function onTableClicked() {
        return console.log("onTableClicked not implemented");
    }
};

var Section = function (_StaticContainer_1$de) {
    _inherits(Section, _StaticContainer_1$de);

    function Section(_ref, actions) {
        var _id = _ref._id,
            pos = _ref.pos,
            name = _ref.name,
            sectionId = _ref.sectionId,
            tables = _ref.tables,
            ticketIds = _ref.ticketIds;

        _classCallCheck(this, Section);

        var _this = _possibleConstructorReturn(this, _StaticContainer_1$de.call(this, _id, actions));

        _this.focused = false;
        _this.name = name;
        _this.sectionId = sectionId;
        _this.basicType = "section";
        _this.ticketIds = ticketIds;
        _this.sectionContainer = new PIXI.Container();
        _this.sectionContainer.position = pos;
        _this.tables = tables.map(function (table, i) {
            table.tableId = i;
            table.sectionId = _this._id;
            table.sectionName = _this.name;
            var newTable = _this.determineTable(table, _this.actions);
            newTable.draw();
            return newTable;
        });
        _this.tables.forEach(function (table) {
            return _this.sectionContainer.addChild(table.getTableContainer());
        });
        _this.tables.forEach(function (table) {
            return table.setContainerOffset(_this.sectionContainer.position.x, _this.sectionContainer.position.y);
        });
        _this.bounds = _this.sectionContainer.getBounds();
        return _this;
    }

    Section.prototype.determineTable = function determineTable(table, actions) {
        console.log("table.type", table.type);
        switch (table.type) {
            case "circle":
                return new Table_1.default(table, actions, false);
            case "row":
                return new Rows_1.Rows(table, actions, false);
        }
    };

    Section.prototype.showTextSeat = function showTextSeat(show) {
        this.tables.forEach(function (table) {
            return table.showTextSeat(show);
        });
    };

    Section.prototype.showTextTable = function showTextTable(show) {
        this.tables.forEach(function (table) {
            return table.showText(show);
        });
    };

    Section.prototype.determineFocus = function determineFocus(sectionId) {
        var _this2 = this;

        if (sectionId === this._id) {
            this.focused = true;
        } else {
            this.focused = false;
        }
        this.tables.forEach(function (table) {
            return table.determineFocus(_this2.focused);
        });
        return this.focused;
    };

    Section.prototype.getTable = function getTable(tableId) {
        return this.tables[tableId];
    };

    Section.prototype.getSectionContainer = function getSectionContainer() {
        return this.sectionContainer;
    };

    Section.prototype.getBounds = function getBounds() {
        return this.bounds;
    };

    Section.prototype.mapExistingTicket = function mapExistingTicket(ticketId, ticketTypeId, packageGroupId, packageId, sectionId, tableId, seatId) {
        if (this._id === sectionId) {
            this.tables.forEach(function (table) {
                return table.mapExistingTicket(ticketId, ticketTypeId, packageGroupId, packageId, tableId, seatId);
            });
        }
    };

    Section.prototype.setTicketMapping = function setTicketMapping(currentTicketData) {
        this.ticketData = currentTicketData;
        this.tables.forEach(function (table) {
            return table.setTicketMapping(currentTicketData);
        });
    };

    Section.prototype.getDimensions = function getDimensions() {
        var dim = this.tables[0].getDimensions();
        var top = dim.top;
        var bottom = dim.bottom;
        var left = dim.left;
        var right = dim.right;
        this.tables.forEach(function (table) {
            var dimension = table.getDimensions();
            if (dimension.left < left) {
                left = dimension.left;
            }
            if (dimension.right > right) {
                right = dimension.right;
            }
            if (dimension.top < top) {
                top = dimension.top;
            }
            if (dimension.bottom > bottom) {
                bottom = dimension.bottom;
            }
        });
        return {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
    };

    Section.prototype.applicableTicketType = function applicableTicketType(ticketTypeId) {
        var applicable = this.ticketIds.includes(ticketTypeId);
        return {
            _id: this._id,
            applicable: applicable
        };
    };

    return Section;
}(StaticContainer_1.default);

__decorate([bound_1.default], Section.prototype, "determineTable", null);
__decorate([bound_1.default], Section.prototype, "showTextSeat", null);
__decorate([bound_1.default], Section.prototype, "showTextTable", null);
__decorate([bound_1.default], Section.prototype, "determineFocus", null);
__decorate([bound_1.default], Section.prototype, "getTable", null);
__decorate([bound_1.default], Section.prototype, "getSectionContainer", null);
__decorate([bound_1.default], Section.prototype, "getBounds", null);
__decorate([bound_1.default], Section.prototype, "mapExistingTicket", null);
__decorate([bound_1.default], Section.prototype, "setTicketMapping", null);
__decorate([bound_1.default], Section.prototype, "getDimensions", null);
__decorate([bound_1.default], Section.prototype, "applicableTicketType", null);
exports.default = Section;
//# sourceMappingURL=Section.js.map

/***/ }),

/***/ "TceE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * The Point object represents a location in a two-dimensional coordinate system, where x represents
 * the horizontal axis and y represents the vertical axis.
 *
 * @class
 * @memberof PIXI
 */
var Point = function () {
  /**
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  function Point() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, Point);

    /**
     * @member {number}
     * @default 0
     */
    this.x = x;

    /**
     * @member {number}
     * @default 0
     */
    this.y = y;
  }

  /**
   * Creates a clone of this point
   *
   * @return {PIXI.Point} a copy of the point
   */

  Point.prototype.clone = function clone() {
    return new Point(this.x, this.y);
  };

  /**
   * Copies x and y from the given point
   *
   * @param {PIXI.Point} p - The point to copy.
   */

  Point.prototype.copy = function copy(p) {
    this.set(p.x, p.y);
  };

  /**
   * Returns true if the given point is equal to this point
   *
   * @param {PIXI.Point} p - The point to check
   * @returns {boolean} Whether the given point equal to this point
   */

  Point.prototype.equals = function equals(p) {
    return p.x === this.x && p.y === this.y;
  };

  /**
   * Sets the point to a new x and y position.
   * If y is omitted, both x and y will be set to x.
   *
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */

  Point.prototype.set = function set(x, y) {
    this.x = x || 0;
    this.y = y || (y !== 0 ? this.x : 0);
  };

  return Point;
}();

exports.default = Point;
//# sourceMappingURL=Point.js.map

/***/ }),

/***/ "Te0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__("dZBD");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./config.js
var config = __webpack_require__("aSYM");

// CONCATENATED MODULE: ./services/SeatingMapService.js



var SeatingMapService = {
  saveTicketMapping: function saveTicketMapping(ticketMappingData, seatingMapId, eventId, eventDateId) {
    return new Promise(function (resolve, reject) {
      axios_default.a.post(Object(config["a" /* default */])("API_URL") + "seatingmaps/ticketmapping/" + eventId + "/" + eventDateId + "/" + seatingMapId, { ticketMapping: ticketMappingData }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  get: function get(eventId, seatingMapId) {
    return new Promise(function (resolve, reject) {
      axios_default.a.get(Object(config["a" /* default */])("API_URL") + "seatingmaps/" + eventId + "/" + seatingMapId).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  getAll: function getAll(eventId, eventDateId) {
    return new Promise(function (resolve, reject) {
      axios_default.a.get(Object(config["a" /* default */])("API_URL") + "seatingmaps/all/" + eventId + "/" + eventDateId).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  getPublic: function getPublic(eventId, token, orderId) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(axios_default.a.get(Object(config["a" /* default */])("API_URL") + "public/seating-map/" + eventId + "/" + orderId + "/" + token)).then(function ($await_1) {
        try {
          response = $await_1;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
};

/* harmony default export */ var services_SeatingMapService = (SeatingMapService);
// EXTERNAL MODULE: ./state/actions/orderActions.js
var orderActions = __webpack_require__("J21P");

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// CONCATENATED MODULE: ./state/actions/seatingMapActions.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_SEATING_MAP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_SEATING_MAP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_SEATING_MAP_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_SEATING_MAPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_SEATING_MAPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SEATING_MAPS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_TICKET_MAPPING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_TICKET_MAPPING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_TICKET_MAPPING_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_TICKET_MAPPING_CONFLICT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SEATING_MAP_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESET_SEATING_MAP_EVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return seatingMapActions_saveTicketMapping; });
/* unused harmony export getSeatingMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return seatingMapActions_getSeatingMapPublic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return seatingMapActions_getAllSeatingMaps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return resetSeatingMapEvaluation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setSeatingMapRequired; });


var GET_SEATING_MAP_REQUEST = "GET_SEATING_MAP_REQUEST";
var GET_SEATING_MAP_SUCCESS = "GET_SEATING_MAP_SUCCESS";
var GET_SEATING_MAP_ERROR = "GET_SEATING_MAP_ERROR";

var GET_SEATING_MAPS_REQUEST = "GET_SEATING_MAPS_REQUEST";
var GET_SEATING_MAPS_SUCCESS = "GET_SEATING_MAPS_SUCCESS";
var GET_SEATING_MAPS_ERROR = "GET_SEATING_MAPS_ERROR";

var SAVE_TICKET_MAPPING_REQUEST = "SAVE_TICKET_MAPPING_REQUEST";
var SAVE_TICKET_MAPPING_SUCCESS = "SAVE_TICKET_MAPPING_SUCCESS";
var SAVE_TICKET_MAPPING_ERROR = "SAVE_TICKET_MAPPING_ERROR";
var SAVE_TICKET_MAPPING_CONFLICT = "SAVE_TICKET_MAPPING_CONFLICT";

var SEATING_MAP_REQUIRED = "SEATING_MAP_REQUIRED";
var RESET_SEATING_MAP_EVAL = "RESET_SEATING_MAP_EVAL";


var seatingMapActions_saveTicketMapping = function saveTicketMapping(ticketMappingData, eventSlug, order, seatingMapId, event) {
  return function (dispatch) {
    var eventId = event._id;
    var orderId = order._id;
    var eventDateId = order.eventDateId;
    dispatch({ type: SAVE_TICKET_MAPPING_REQUEST });
    services_SeatingMapService.saveTicketMapping(ticketMappingData, seatingMapId, eventId, eventDateId).then(function (result) {
      //{conflict: true, conflicts: conflictedSeats}
      if (result.conflict) {
        dispatch({
          type: SAVE_TICKET_MAPPING_CONFLICT,
          conflicts: result.conflicts
        });
      } else {
        if (order.status === "complete" || order.totals.total <= 0 || result.orderComplete) {
          Object(orderActions["S" /* orderComplete */])(eventSlug, event, order, false);
        } else {
          dispatch({ type: SAVE_TICKET_MAPPING_SUCCESS });
          preact_router_es["Router"].route("/" + eventSlug + "/payment/" + orderId);
        }
      }
    }).catch(function (err) {
      dispatch({ type: SAVE_TICKET_MAPPING_ERROR, error: err });
    });
  };
};

var seatingMapActions_getSeatingMap = function getSeatingMap(eventId, seatingMapId) {
  return function (dispatch) {
    dispatch({ type: GET_SEATING_MAP_REQUEST });
    services_SeatingMapService.get(eventId, seatingMapId).then(function (seatingMap) {
      dispatch({ type: GET_SEATING_MAP_SUCCESS, seatingMap: seatingMap });
    }).catch(function (err) {
      dispatch({ type: GET_SEATING_MAP_ERROR, error: err });
    });
  };
};

var seatingMapActions_getSeatingMapPublic = function getSeatingMapPublic(eventId, token, orderId) {
  return function (dispatch) {
    dispatch({ type: GET_SEATING_MAP_REQUEST });
    services_SeatingMapService.getPublic(eventId, token, orderId).then(function (seatingMap) {
      dispatch({ type: GET_SEATING_MAP_SUCCESS, seatingMap: seatingMap });
    }).catch(function (err) {
      dispatch({ type: GET_SEATING_MAP_ERROR, error: err });
    });
  };
};

var seatingMapActions_getAllSeatingMaps = function getAllSeatingMaps(eventId, eventDateId) {
  return function (dispatch) {
    dispatch({ type: GET_SEATING_MAPS_REQUEST });
    services_SeatingMapService.getAll(eventId, eventDateId).then(function (seatingMaps) {
      dispatch({ type: GET_SEATING_MAPS_SUCCESS, seatingMaps: seatingMaps });
    }).catch(function (err) {
      dispatch({ type: GET_SEATING_MAPS_ERROR, error: err });
    });
  };
};

var resetSeatingMapEvaluation = function resetSeatingMapEvaluation() {
  return function (dispatch) {
    dispatch({ type: RESET_SEATING_MAP_EVAL });
  };
};

var setSeatingMapRequired = function setSeatingMapRequired(required) {
  return function (dispatch) {
    dispatch({ type: SEATING_MAP_REQUIRED, required: required });
  };
};

/***/ }),

/***/ "ThH+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _math = __webpack_require__("e3iB");

var _TransformBase2 = __webpack_require__("Pszr");

var _TransformBase3 = _interopRequireDefault(_TransformBase2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Generic class to deal with traditional 2D matrix transforms
 * local transformation is calculated from position,scale,skew and rotation
 *
 * @class
 * @extends PIXI.TransformBase
 * @memberof PIXI
 */
var Transform = function (_TransformBase) {
  _inherits(Transform, _TransformBase);

  /**
   *
   */
  function Transform() {
    _classCallCheck(this, Transform);

    /**
    * The coordinate of the object relative to the local coordinates of the parent.
    *
    * @member {PIXI.Point}
    */
    var _this = _possibleConstructorReturn(this, _TransformBase.call(this));

    _this.position = new _math.Point(0, 0);

    /**
     * The scale factor of the object.
     *
     * @member {PIXI.Point}
     */
    _this.scale = new _math.Point(1, 1);

    /**
     * The skew amount, on the x and y axis.
     *
     * @member {PIXI.ObservablePoint}
     */
    _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);

    /**
     * The pivot point of the displayObject that it rotates around.
     *
     * @member {PIXI.Point}
     */
    _this.pivot = new _math.Point(0, 0);

    /**
     * The rotation value of the object, in radians
     *
     * @member {Number}
     * @private
     */
    _this._rotation = 0;

    _this._cx = 1; // cos rotation + skewY;
    _this._sx = 0; // sin rotation + skewY;
    _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
    _this._sy = 1; // sin rotation + Math.PI/2 - skewX;
    return _this;
  }

  /**
   * Updates the skew values when the skew or rotation changes.
   *
   * @private
   */

  Transform.prototype.updateSkew = function updateSkew() {
    this._cx = Math.cos(this._rotation + this.skew._y);
    this._sx = Math.sin(this._rotation + this.skew._y);
    this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
    this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2
  };

  /**
   * Updates only local matrix
   */

  Transform.prototype.updateLocalTransform = function updateLocalTransform() {
    var lt = this.localTransform;

    lt.a = this._cx * this.scale.x;
    lt.b = this._sx * this.scale.x;
    lt.c = this._cy * this.scale.y;
    lt.d = this._sy * this.scale.y;

    lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
    lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
  };

  /**
   * Updates the values of the object and applies the parent's transform.
   *
   * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
   */

  Transform.prototype.updateTransform = function updateTransform(parentTransform) {
    var lt = this.localTransform;

    lt.a = this._cx * this.scale.x;
    lt.b = this._sx * this.scale.x;
    lt.c = this._cy * this.scale.y;
    lt.d = this._sy * this.scale.y;

    lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
    lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);

    // concat the parent matrix with the objects transform.
    var pt = parentTransform.worldTransform;
    var wt = this.worldTransform;

    wt.a = lt.a * pt.a + lt.b * pt.c;
    wt.b = lt.a * pt.b + lt.b * pt.d;
    wt.c = lt.c * pt.a + lt.d * pt.c;
    wt.d = lt.c * pt.b + lt.d * pt.d;
    wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
    wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;

    this._worldID++;
  };

  /**
   * Decomposes a matrix and sets the transforms properties based on it.
   *
   * @param {PIXI.Matrix} matrix - The matrix to decompose
   */

  Transform.prototype.setFromMatrix = function setFromMatrix(matrix) {
    matrix.decompose(this);
  };

  /**
   * The rotation of the object in radians.
   *
   * @member {number}
   */

  _createClass(Transform, [{
    key: 'rotation',
    get: function get() {
      return this._rotation;
    },
    set: function set(value) // eslint-disable-line require-jsdoc
    {
      this._rotation = value;
      this.updateSkew();
    }
  }]);

  return Transform;
}(_TransformBase3.default);

exports.default = Transform;
//# sourceMappingURL=Transform.js.map

/***/ }),

/***/ "Tz/S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "U/Ks":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = __webpack_require__("o6Mn");
function getConstructionSprites(host) {
    var _ref;

    return _ref = {}, _ref[Utils_1.circle_av_256] = host + "public/sprites/circle_av_256.png", _ref[Utils_1.circle_av_64] = host + "public/sprites/circle_av_64.png", _ref[Utils_1.circle_unav_256] = host + "public/sprites/circle_unav_256.png", _ref[Utils_1.circle_unav_64] = host + "public/sprites/circle_unav_64.png", _ref[Utils_1.circle_ns_256] = host + "public/sprites/circle_ns_256.png", _ref[Utils_1.circle_ns_64] = host + "public/sprites/circle_ns_64.png", _ref[Utils_1.square_ns_256] = host + "public/sprites/square_ns_256.png", _ref[Utils_1.circle_s_256] = host + "public/sprites/circle_s_256.png", _ref[Utils_1.circle_s_64] = host + "public/sprites/circle_s_64.png", _ref[Utils_1.square_s_256] = host + "public/sprites/square_s_256.png", _ref[Utils_1.circle_sel_64] = host + "public/sprites/circle_sel_64.png", _ref[Utils_1.circle_unass_64] = host + "public/sprites/circle_unass_64.png", _ref[Utils_1.circle_unass_256] = host + "public/sprites/circle_unass_256.png", _ref[Utils_1.circle_ass_64] = host + "public/sprites/circle_ass_64.png", _ref[Utils_1.circle_ass_256] = host + "public/sprites/circle_ass_256.png", _ref[Utils_1.circle_m_64] = host + "public/sprites/circle_m_64.png", _ref[Utils_1.duplicateElementName] = host + "public/sprites/icon_duplicate.png", _ref[Utils_1.deleteElementName] = host + "public/sprites/icon_delete.png", _ref[Utils_1.rotateElementName] = host + "public/sprites/icon_rotate.png", _ref[Utils_1.barIcon] = host + "public/sprites/icons/bar.png", _ref[Utils_1.blindIcon] = host + "public/sprites/icons/blind.png", _ref[Utils_1.exitIcon] = host + "public/sprites/icons/exit.png", _ref[Utils_1.foodIcon] = host + "public/sprites/icons/food.png", _ref[Utils_1.smokingIcon] = host + "public/sprites/icons/smoking.png", _ref[Utils_1.wheelchairIcon] = host + "public/sprites/icons/wheelchair.png", _ref[Utils_1.bathroomIcon] = host + "public/sprites/icons/bathroom.png", _ref[Utils_1.dancefloorIcon] = host + "public/sprites/icons/dance_floor.png", _ref[Utils_1.firstAidIcon] = host + "public/sprites/icons/first_aid.png", _ref[Utils_1.infoIcon] = host + "public/sprites/icons/info.png", _ref[Utils_1.stairsIcon] = host + "public/sprites/icons/stairs.png", _ref[Utils_1.stageIcon] = host + "public/sprites/icons/stage.png", _ref[Utils_1.stairsUpDownIcon] = host + "public/sprites/icons/stairs_up_down.png", _ref[Utils_1.background] = host + "public/sprites/background.png", _ref[Utils_1.lato] = host + "public/sprites/lato.png", _ref;
}
exports.default = getConstructionSprites;
//# sourceMappingURL=ConstructionSprites.js.map

/***/ }),

/***/ "U1Rh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _BaseTexture2 = __webpack_require__("ce6K");

var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);

var _utils = __webpack_require__("dDI1");

var _ticker = __webpack_require__("5u59");

var _const = __webpack_require__("YEQi");

var _determineCrossOrigin = __webpack_require__("f1vj");

var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A texture of a [playing] Video.
 *
 * Video base textures mimic PixiJS BaseTexture.from.... method in their creation process.
 *
 * This can be used in several ways, such as:
 *
 * ```js
 * let texture = PIXI.VideoBaseTexture.fromUrl('http://mydomain.com/video.mp4');
 *
 * let texture = PIXI.VideoBaseTexture.fromUrl({ src: 'http://mydomain.com/video.mp4', mime: 'video/mp4' });
 *
 * let texture = PIXI.VideoBaseTexture.fromUrls(['/video.webm', '/video.mp4']);
 *
 * let texture = PIXI.VideoBaseTexture.fromUrls([
 *     { src: '/video.webm', mime: 'video/webm' },
 *     { src: '/video.mp4', mime: 'video/mp4' }
 * ]);
 * ```
 *
 * See the ["deus" demo](http://www.goodboydigital.com/pixijs/examples/deus/).
 *
 * @class
 * @extends PIXI.BaseTexture
 * @memberof PIXI
 */
var VideoBaseTexture = function (_BaseTexture) {
    _inherits(VideoBaseTexture, _BaseTexture);

    /**
     * @param {HTMLVideoElement} source - Video source
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {boolean} [autoPlay=true] - Start playing video as soon as it is loaded
     */
    function VideoBaseTexture(source, scaleMode) {
        var autoPlay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        _classCallCheck(this, VideoBaseTexture);

        if (!source) {
            throw new Error('No video source element specified.');
        }

        // hook in here to check if video is already available.
        // BaseTexture looks for a source.complete boolean, plus width & height.

        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) {
            source.complete = true;
        }

        var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, source, scaleMode));

        _this.width = source.videoWidth;
        _this.height = source.videoHeight;

        _this._autoUpdate = true;
        _this._isAutoUpdating = false;

        /**
         * When set to true will automatically play videos used by this texture once
         * they are loaded. If false, it will not modify the playing state.
         *
         * @member {boolean}
         * @default true
         */
        _this.autoPlay = autoPlay;

        _this.update = _this.update.bind(_this);
        _this._onCanPlay = _this._onCanPlay.bind(_this);

        source.addEventListener('play', _this._onPlayStart.bind(_this));
        source.addEventListener('pause', _this._onPlayStop.bind(_this));
        _this.hasLoaded = false;
        _this.__loaded = false;

        if (!_this._isSourceReady()) {
            source.addEventListener('canplay', _this._onCanPlay);
            source.addEventListener('canplaythrough', _this._onCanPlay);
        } else {
            _this._onCanPlay();
        }
        return _this;
    }

    /**
     * Returns true if the underlying source is playing.
     *
     * @private
     * @return {boolean} True if playing.
     */

    VideoBaseTexture.prototype._isSourcePlaying = function _isSourcePlaying() {
        var source = this.source;

        return source.currentTime > 0 && source.paused === false && source.ended === false && source.readyState > 2;
    };

    /**
     * Returns true if the underlying source is ready for playing.
     *
     * @private
     * @return {boolean} True if ready.
     */

    VideoBaseTexture.prototype._isSourceReady = function _isSourceReady() {
        return this.source.readyState === 3 || this.source.readyState === 4;
    };

    /**
     * Runs the update loop when the video is ready to play
     *
     * @private
     */

    VideoBaseTexture.prototype._onPlayStart = function _onPlayStart() {
        // Just in case the video has not received its can play even yet..
        if (!this.hasLoaded) {
            this._onCanPlay();
        }

        if (!this._isAutoUpdating && this.autoUpdate) {
            _ticker.shared.add(this.update, this, _const.UPDATE_PRIORITY.HIGH);
            this._isAutoUpdating = true;
        }
    };

    /**
     * Fired when a pause event is triggered, stops the update loop
     *
     * @private
     */

    VideoBaseTexture.prototype._onPlayStop = function _onPlayStop() {
        if (this._isAutoUpdating) {
            _ticker.shared.remove(this.update, this);
            this._isAutoUpdating = false;
        }
    };

    /**
     * Fired when the video is loaded and ready to play
     *
     * @private
     */

    VideoBaseTexture.prototype._onCanPlay = function _onCanPlay() {
        this.hasLoaded = true;

        if (this.source) {
            this.source.removeEventListener('canplay', this._onCanPlay);
            this.source.removeEventListener('canplaythrough', this._onCanPlay);

            this.width = this.source.videoWidth;
            this.height = this.source.videoHeight;

            // prevent multiple loaded dispatches..
            if (!this.__loaded) {
                this.__loaded = true;
                this.emit('loaded', this);
            }

            if (this._isSourcePlaying()) {
                this._onPlayStart();
            } else if (this.autoPlay) {
                this.source.play();
            }
        }
    };

    /**
     * Destroys this texture
     *
     */

    VideoBaseTexture.prototype.destroy = function destroy() {
        if (this._isAutoUpdating) {
            _ticker.shared.remove(this.update, this);
        }

        if (this.source && this.source._pixiId) {
            _BaseTexture3.default.removeFromCache(this.source._pixiId);
            delete this.source._pixiId;

            this.source.pause();
            this.source.src = '';
            this.source.load();
        }

        _BaseTexture.prototype.destroy.call(this);
    };

    /**
     * Mimic PixiJS BaseTexture.from.... method.
     *
     * @static
     * @param {HTMLVideoElement} video - Video to create texture from
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {boolean} [autoPlay=true] - Start playing video as soon as it is loaded
     * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
     */

    VideoBaseTexture.fromVideo = function fromVideo(video, scaleMode, autoPlay) {
        if (!video._pixiId) {
            video._pixiId = 'video_' + (0, _utils.uid)();
        }

        var baseTexture = _utils.BaseTextureCache[video._pixiId];

        if (!baseTexture) {
            baseTexture = new VideoBaseTexture(video, scaleMode, autoPlay);
            _BaseTexture3.default.addToCache(baseTexture, video._pixiId);
        }

        return baseTexture;
    };

    /**
     * Helper function that creates a new BaseTexture based on the given video element.
     * This BaseTexture can then be used to create a texture
     *
     * @static
     * @param {string|object|string[]|object[]} videoSrc - The URL(s) for the video.
     * @param {string} [videoSrc.src] - One of the source urls for the video
     * @param {string} [videoSrc.mime] - The mimetype of the video (e.g. 'video/mp4'). If not specified
     *  the url's extension will be used as the second part of the mime type.
     * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
     * @param {boolean} [autoPlay=true] - Start playing video as soon as it is loaded
     * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
     */

    VideoBaseTexture.fromUrl = function fromUrl(videoSrc, scaleMode, crossorigin, autoPlay) {
        var video = document.createElement('video');

        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('playsinline', '');

        var url = Array.isArray(videoSrc) ? videoSrc[0].src || videoSrc[0] : videoSrc.src || videoSrc;

        if (crossorigin === undefined && url.indexOf('data:') !== 0) {
            video.crossOrigin = (0, _determineCrossOrigin2.default)(url);
        } else if (crossorigin) {
            video.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
        }

        // array of objects or strings
        if (Array.isArray(videoSrc)) {
            for (var i = 0; i < videoSrc.length; ++i) {
                video.appendChild(createSource(videoSrc[i].src || videoSrc[i], videoSrc[i].mime));
            }
        }
        // single object or string
        else {
                video.appendChild(createSource(url, videoSrc.mime));
            }

        video.load();

        return VideoBaseTexture.fromVideo(video, scaleMode, autoPlay);
    };

    /**
     * Should the base texture automatically update itself, set to true by default
     *
     * @member {boolean}
     */

    _createClass(VideoBaseTexture, [{
        key: 'autoUpdate',
        get: function get() {
            return this._autoUpdate;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (value !== this._autoUpdate) {
                this._autoUpdate = value;

                if (!this._autoUpdate && this._isAutoUpdating) {
                    _ticker.shared.remove(this.update, this);
                    this._isAutoUpdating = false;
                } else if (this._autoUpdate && !this._isAutoUpdating) {
                    _ticker.shared.add(this.update, this, _const.UPDATE_PRIORITY.HIGH);
                    this._isAutoUpdating = true;
                }
            }
        }
    }]);

    return VideoBaseTexture;
}(_BaseTexture3.default);

exports.default = VideoBaseTexture;

VideoBaseTexture.fromUrls = VideoBaseTexture.fromUrl;

function createSource(path, type) {
    if (!type) {
        var purePath = path.split('?').shift().toLowerCase();

        type = 'video/' + purePath.substr(purePath.lastIndexOf('.') + 1);
    }

    var source = document.createElement('source');

    source.src = path;
    source.type = type;

    return source;
}
//# sourceMappingURL=VideoBaseTexture.js.map

/***/ }),

/***/ "UALW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = mapPremultipliedBlendModes;

var _const = __webpack_require__("YEQi");

/**
 * Corrects PixiJS blend, takes premultiplied alpha into account
 *
 * @memberof PIXI
 * @function mapPremultipliedBlendModes
 * @private
 * @param {Array<number[]>} [array] - The array to output into.
 * @return {Array<number[]>} Mapped modes.
 */

function mapPremultipliedBlendModes() {
    var pm = [];
    var npm = [];

    for (var i = 0; i < 32; i++) {
        pm[i] = i;
        npm[i] = i;
    }

    pm[_const.BLEND_MODES.NORMAL_NPM] = _const.BLEND_MODES.NORMAL;
    pm[_const.BLEND_MODES.ADD_NPM] = _const.BLEND_MODES.ADD;
    pm[_const.BLEND_MODES.SCREEN_NPM] = _const.BLEND_MODES.SCREEN;

    npm[_const.BLEND_MODES.NORMAL] = _const.BLEND_MODES.NORMAL_NPM;
    npm[_const.BLEND_MODES.ADD] = _const.BLEND_MODES.ADD_NPM;
    npm[_const.BLEND_MODES.SCREEN] = _const.BLEND_MODES.SCREEN_NPM;

    var array = [];

    array.push(npm);
    array.push(pm);

    return array;
}
//# sourceMappingURL=mapPremultipliedBlendModes.js.map

/***/ }),

/***/ "UHtZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyToClipboard = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _copyToClipboard = __webpack_require__("xbqV");

var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CopyToClipboard = exports.CopyToClipboard = function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  function CopyToClipboard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CopyToClipboard.__proto__ || Object.getPrototypeOf(CopyToClipboard)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react2.default.Children.only(children);

      var result = (0, _copyToClipboard2.default)(text, options);

      if (onCopy) {
        onCopy(text, result);
      }

      // Bypass onClick if it was present
      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CopyToClipboard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _text = _props.text,
          _onCopy = _props.onCopy,
          _options = _props.options,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['text', 'onCopy', 'options', 'children']);

      var elem = _react2.default.Children.only(children);

      return _react2.default.cloneElement(elem, _extends({}, props, { onClick: this.onClick }));
    }
  }]);

  return CopyToClipboard;
}(_react2.default.PureComponent);

CopyToClipboard.defaultProps = {
  onCopy: undefined,
  options: undefined
};

/***/ }),

/***/ "UQex":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "USDo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
function bound(target, propKey) {
    var originalMethod = target[propKey];
    if (typeof originalMethod !== "function") throw new TypeError("@bound can only be used on methods.");
    if (typeof target === "function") {
        return {
            value: function value() {
                return originalMethod.apply(target, arguments);
            }
        };
    } else if (typeof target === "object") {
        return {
            get: function get() {
                var instance = this;
                Object.defineProperty(instance, propKey.toString(), {
                    value: function value() {
                        return originalMethod.apply(instance, arguments);
                    }
                });
                return instance[propKey];
            }
        };
    }
}
exports.default = bound;
//# sourceMappingURL=bound.js.map

/***/ }),

/***/ "UUq2":
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function splitPath(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function () {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = i >= 0 ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function (p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function (path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function (p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function (path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function () {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function (p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};

// path.relative(from, to)
// posix version
exports.relative = function (from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};

exports.basename = function (path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  return splitPath(path)[3];
};

function filter(xs, f) {
  if (xs.filter) return xs.filter(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    if (f(xs[i], i, xs)) res.push(xs[i]);
  }
  return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b' ? function (str, start, len) {
  return str.substr(start, len);
} : function (str, start, len) {
  if (start < 0) start = str.length + start;
  return str.substr(start, len);
};

/***/ }),

/***/ "UYYs":
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? module['exports'] = factory() : typeof define === 'function' && define['amd'] ? define(factory()) : window['stylisRuleSheet'] = factory();
})(function () {

	'use strict';

	return function (insertRule) {
		var delimiter = '/*|*/';
		var needle = delimiter + '}';

		function toSheet(block) {
			if (block) try {
				insertRule(block + '}');
			} catch (e) {}
		}

		return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
					break;
				// selector
				case 2:
					if (ns === 0) return content + delimiter;
					break;
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0] + content), '';
						default:
							return content + (at === 0 ? delimiter : '');
					}
				case -2:
					content.split(needle).forEach(toSheet);
			}
		};
	};
});

/***/ }),

/***/ "UxTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var ActionButton = function ActionButton(_ref) {
  var onClick = _ref.onClick,
      loading = _ref.loading,
      disabled = _ref.disabled,
      children = _ref.children,
      style = _ref.style,
      classNames = _ref.classNames,
      _ref$dataCY = _ref.dataCY,
      dataCY = _ref$dataCY === undefined ? "default" : _ref$dataCY;

  style = style ? style : {
    float: "right"
  };
  classNames = classNames ? classNames : "btn-primary btn-lg";
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "button",
    {
      disabled: disabled,
      onClick: onClick,
      style: style,
      "class": loading ? "btn btn-primary btn-lg " + classNames + " loading" : "btn btn-primary btn-lg " + classNames,
      "data-cy": dataCY
    },
    children
  );
};
/* harmony default export */ __webpack_exports__["a"] = (ActionButton);

/***/ }),

/***/ "V/Md":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "715940ff03627338e3c92a48f9a6390e.svg";

/***/ }),

/***/ "V3+0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),

/***/ "VBgO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__("VxKF");
var getPolyfill = __webpack_require__("NEt2");

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, { trim: function trim() {
			return String.prototype.trim !== polyfill;
		} });
	return polyfill;
};

/***/ }),

/***/ "VVKR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("br", null);

var LocationStr = function LocationStr(_ref) {
  var location = _ref.location;

  var parts = [];
  if (location.venueName) {
    parts.push(location.venueName);
  }
  if (location.address) {
    parts.push(location.address);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "p",
    null,
    parts.map(function (part, index) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "span",
        { style: { color: "#323232" } },
        part,
        index < part.length - 1 ? _ref2 : ""
      );
    })
  );
};
/* harmony default export */ __webpack_exports__["a"] = (LocationStr);

/***/ }),

/***/ "VYYc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _Plane2 = __webpack_require__("sY57");

var _Plane3 = _interopRequireDefault(_Plane2);

var _CanvasTinter = __webpack_require__("xwA8");

var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEFAULT_BORDER_SIZE = 10;

/**
 * The NineSlicePlane allows you to stretch a texture using 9-slice scaling. The corners will remain unscaled (useful
 * for buttons with rounded corners for example) and the other areas will be scaled horizontally and or vertically
 *
 *```js
 * let Plane9 = new PIXI.NineSlicePlane(PIXI.Texture.fromImage('BoxWithRoundedCorners.png'), 15, 15, 15, 15);
 *  ```
 * <pre>
 *      A                          B
 *    +---+----------------------+---+
 *  C | 1 |          2           | 3 |
 *    +---+----------------------+---+
 *    |   |                      |   |
 *    | 4 |          5           | 6 |
 *    |   |                      |   |
 *    +---+----------------------+---+
 *  D | 7 |          8           | 9 |
 *    +---+----------------------+---+

 *  When changing this objects width and/or height:
 *     areas 1 3 7 and 9 will remain unscaled.
 *     areas 2 and 8 will be stretched horizontally
 *     areas 4 and 6 will be stretched vertically
 *     area 5 will be stretched both horizontally and vertically
 * </pre>
 *
 * @class
 * @extends PIXI.mesh.Plane
 * @memberof PIXI.mesh
 *
 */

var NineSlicePlane = function (_Plane) {
    _inherits(NineSlicePlane, _Plane);

    /**
     * @param {PIXI.Texture} texture - The texture to use on the NineSlicePlane.
     * @param {int} [leftWidth=10] size of the left vertical bar (A)
     * @param {int} [topHeight=10] size of the top horizontal bar (C)
     * @param {int} [rightWidth=10] size of the right vertical bar (B)
     * @param {int} [bottomHeight=10] size of the bottom horizontal bar (D)
     */
    function NineSlicePlane(texture, leftWidth, topHeight, rightWidth, bottomHeight) {
        _classCallCheck(this, NineSlicePlane);

        var _this = _possibleConstructorReturn(this, _Plane.call(this, texture, 4, 4));

        _this._origWidth = texture.orig.width;
        _this._origHeight = texture.orig.height;

        /**
         * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._width = _this._origWidth;

        /**
         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._height = _this._origHeight;

        /**
         * The width of the left column (a)
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._leftWidth = typeof leftWidth !== 'undefined' ? leftWidth : DEFAULT_BORDER_SIZE;

        /**
         * The width of the right column (b)
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._rightWidth = typeof rightWidth !== 'undefined' ? rightWidth : DEFAULT_BORDER_SIZE;

        /**
         * The height of the top row (c)
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._topHeight = typeof topHeight !== 'undefined' ? topHeight : DEFAULT_BORDER_SIZE;

        /**
         * The height of the bottom row (d)
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._bottomHeight = typeof bottomHeight !== 'undefined' ? bottomHeight : DEFAULT_BORDER_SIZE;

        /**
         * Cached tint value so we can tell when the tint is changed.
         *
         * @member {number}
         * @protected
         */
        _this._cachedTint = 0xFFFFFF;

        /**
         * Cached tinted texture.
         *
         * @member {HTMLCanvasElement}
         * @protected
         */
        _this._tintedTexture = null;

        /**
         * Temporary storage for canvas source coords
         *
         * @member {number[]}
         * @private
         */
        _this._canvasUvs = null;

        _this.refresh(true);
        return _this;
    }

    /**
     * Updates the horizontal vertices.
     *
     */

    NineSlicePlane.prototype.updateHorizontalVertices = function updateHorizontalVertices() {
        var vertices = this.vertices;

        var h = this._topHeight + this._bottomHeight;
        var scale = this._height > h ? 1.0 : this._height / h;

        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale;
        vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale;
        vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
    };

    /**
     * Updates the vertical vertices.
     *
     */

    NineSlicePlane.prototype.updateVerticalVertices = function updateVerticalVertices() {
        var vertices = this.vertices;

        var w = this._leftWidth + this._rightWidth;
        var scale = this._width > w ? 1.0 : this._width / w;

        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale;
        vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale;
        vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer to render with.
     */

    NineSlicePlane.prototype._renderCanvas = function _renderCanvas(renderer) {
        var context = renderer.context;
        var transform = this.worldTransform;
        var res = renderer.resolution;
        var isTinted = this.tint !== 0xFFFFFF;
        var texture = this._texture;

        // Work out tinting
        if (isTinted) {
            if (this._cachedTint !== this.tint) {
                // Tint has changed, need to update the tinted texture and use that instead

                this._cachedTint = this.tint;

                this._tintedTexture = _CanvasTinter2.default.getTintedTexture(this, this.tint);
            }
        }

        var textureSource = !isTinted ? texture.baseTexture.source : this._tintedTexture;

        if (!this._canvasUvs) {
            this._canvasUvs = [0, 0, 0, 0, 0, 0, 0, 0];
        }

        var vertices = this.vertices;
        var uvs = this._canvasUvs;
        var u0 = isTinted ? 0 : texture.frame.x;
        var v0 = isTinted ? 0 : texture.frame.y;
        var u1 = u0 + texture.frame.width;
        var v1 = v0 + texture.frame.height;

        uvs[0] = u0;
        uvs[1] = u0 + this._leftWidth;
        uvs[2] = u1 - this._rightWidth;
        uvs[3] = u1;
        uvs[4] = v0;
        uvs[5] = v0 + this._topHeight;
        uvs[6] = v1 - this._bottomHeight;
        uvs[7] = v1;

        for (var i = 0; i < 8; i++) {
            uvs[i] *= texture.baseTexture.resolution;
        }

        context.globalAlpha = this.worldAlpha;
        renderer.setBlendMode(this.blendMode);

        if (renderer.roundPixels) {
            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
        } else {
            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
        }

        for (var row = 0; row < 3; row++) {
            for (var col = 0; col < 3; col++) {
                var ind = col * 2 + row * 8;
                var sw = Math.max(1, uvs[col + 1] - uvs[col]);
                var sh = Math.max(1, uvs[row + 5] - uvs[row + 4]);
                var dw = Math.max(1, vertices[ind + 10] - vertices[ind]);
                var dh = Math.max(1, vertices[ind + 11] - vertices[ind + 1]);

                context.drawImage(textureSource, uvs[col], uvs[row + 4], sw, sh, vertices[ind], vertices[ind + 1], dw, dh);
            }
        }
    };

    /**
     * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
     *
     * @member {number}
     */

    /**
     * Refreshes NineSlicePlane coords. All of them.
     */
    NineSlicePlane.prototype._refresh = function _refresh() {
        _Plane.prototype._refresh.call(this);

        var uvs = this.uvs;
        var texture = this._texture;

        this._origWidth = texture.orig.width;
        this._origHeight = texture.orig.height;

        var _uvw = 1.0 / this._origWidth;
        var _uvh = 1.0 / this._origHeight;

        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0;
        uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0;
        uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
        uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;

        uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth;
        uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth;
        uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight;
        uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight;

        this.updateHorizontalVertices();
        this.updateVerticalVertices();

        this.dirty++;

        this.multiplyUvs();
    };

    _createClass(NineSlicePlane, [{
        key: 'width',
        get: function get() {
            return this._width;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._width = value;
            this._refresh();
        }

        /**
         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            return this._height;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._height = value;
            this._refresh();
        }

        /**
         * The width of the left column
         *
         * @member {number}
         */

    }, {
        key: 'leftWidth',
        get: function get() {
            return this._leftWidth;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._leftWidth = value;
            this._refresh();
        }

        /**
         * The width of the right column
         *
         * @member {number}
         */

    }, {
        key: 'rightWidth',
        get: function get() {
            return this._rightWidth;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._rightWidth = value;
            this._refresh();
        }

        /**
         * The height of the top row
         *
         * @member {number}
         */

    }, {
        key: 'topHeight',
        get: function get() {
            return this._topHeight;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._topHeight = value;
            this._refresh();
        }

        /**
         * The height of the bottom row
         *
         * @member {number}
         */

    }, {
        key: 'bottomHeight',
        get: function get() {
            return this._bottomHeight;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._bottomHeight = value;
            this._refresh();
        }
    }]);

    return NineSlicePlane;
}(_Plane3.default);

exports.default = NineSlicePlane;
//# sourceMappingURL=NineSlicePlane.js.map

/***/ }),

/***/ "VYcd":
/***/ (function(module, exports) {

var str = Object.prototype.toString;

module.exports = anArray;

function anArray(arr) {
  return arr.BYTES_PER_ELEMENT && str.call(arr.buffer) === '[object ArrayBuffer]' || Array.isArray(arr);
}

/***/ }),

/***/ "VcKu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Holds all information related to an Interaction event
 *
 * @class
 * @memberof PIXI.interaction
 */
var InteractionData = function () {
  /**
   *
   */
  function InteractionData() {
    _classCallCheck(this, InteractionData);

    /**
     * This point stores the global coords of where the touch/mouse event happened
     *
     * @member {PIXI.Point}
     */
    this.global = new core.Point();

    /**
     * The target DisplayObject that was interacted with
     *
     * @member {PIXI.DisplayObject}
     */
    this.target = null;

    /**
     * When passed to an event handler, this will be the original DOM Event that was captured
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
     * @see https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent
     * @member {MouseEvent|TouchEvent|PointerEvent}
     */
    this.originalEvent = null;

    /**
     * Unique identifier for this interaction
     *
     * @member {number}
     */
    this.identifier = null;

    /**
     * Indicates whether or not the pointer device that created the event is the primary pointer.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
     * @type {Boolean}
     */
    this.isPrimary = false;

    /**
     * Indicates which button was pressed on the mouse or pointer device to trigger the event.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
     * @type {number}
     */
    this.button = 0;

    /**
     * Indicates which buttons are pressed on the mouse or pointer device when the event is triggered.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
     * @type {number}
     */
    this.buttons = 0;

    /**
     * The width of the pointer's contact along the x-axis, measured in CSS pixels.
     * radiusX of TouchEvents will be represented by this value.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/width
     * @type {number}
     */
    this.width = 0;

    /**
     * The height of the pointer's contact along the y-axis, measured in CSS pixels.
     * radiusY of TouchEvents will be represented by this value.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/height
     * @type {number}
     */
    this.height = 0;

    /**
     * The angle, in degrees, between the pointer device and the screen.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltX
     * @type {number}
     */
    this.tiltX = 0;

    /**
     * The angle, in degrees, between the pointer device and the screen.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltY
     * @type {number}
     */
    this.tiltY = 0;

    /**
     * The type of pointer that triggered the event.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerType
     * @type {string}
     */
    this.pointerType = null;

    /**
     * Pressure applied by the pointing device during the event. A Touch's force property
     * will be represented by this value.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pressure
     * @type {number}
     */
    this.pressure = 0;

    /**
     * From TouchEvents (not PointerEvents triggered by touches), the rotationAngle of the Touch.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Touch/rotationAngle
     * @type {number}
     */
    this.rotationAngle = 0;

    /**
     * Twist of a stylus pointer.
     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
     * @type {number}
     */
    this.twist = 0;

    /**
     * Barrel pressure on a stylus pointer.
     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
     * @type {number}
     */
    this.tangentialPressure = 0;
  }

  /**
   * The unique identifier of the pointer. It will be the same as `identifier`.
   * @readonly
   * @member {number}
   * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerId
   */

  /**
   * This will return the local coordinates of the specified displayObject for this InteractionData
   *
   * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
   *  coords off
   * @param {PIXI.Point} [point] - A Point object in which to store the value, optional (otherwise
   *  will create a new point)
   * @param {PIXI.Point} [globalPos] - A Point object containing your custom global coords, optional
   *  (otherwise will use the current global coords)
   * @return {PIXI.Point} A point containing the coordinates of the InteractionData position relative
   *  to the DisplayObject
   */
  InteractionData.prototype.getLocalPosition = function getLocalPosition(displayObject, point, globalPos) {
    return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
  };

  /**
   * Copies properties from normalized event data.
   *
   * @param {Touch|MouseEvent|PointerEvent} event The normalized event data
   */

  InteractionData.prototype.copyEvent = function copyEvent(event) {
    // isPrimary should only change on touchstart/pointerdown, so we don't want to overwrite
    // it with "false" on later events when our shim for it on touch events might not be
    // accurate
    if (event.isPrimary) {
      this.isPrimary = true;
    }
    this.button = event.button;
    // event.buttons is not available in all browsers (ie. Safari), but it does have a non-standard
    // event.which property instead, which conveys the same information.
    this.buttons = Number.isInteger(event.buttons) ? event.buttons : event.which;
    this.width = event.width;
    this.height = event.height;
    this.tiltX = event.tiltX;
    this.tiltY = event.tiltY;
    this.pointerType = event.pointerType;
    this.pressure = event.pressure;
    this.rotationAngle = event.rotationAngle;
    this.twist = event.twist || 0;
    this.tangentialPressure = event.tangentialPressure || 0;
  };

  /**
   * Resets the data for pooling.
   */

  InteractionData.prototype.reset = function reset() {
    // isPrimary is the only property that we really need to reset - everything else is
    // guaranteed to be overwritten
    this.isPrimary = false;
  };

  _createClass(InteractionData, [{
    key: 'pointerId',
    get: function get() {
      return this.identifier;
    }
  }]);

  return InteractionData;
}();

exports.default = InteractionData;
//# sourceMappingURL=InteractionData.js.map

/***/ }),

/***/ "VgON":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3b37fcf53b8c0c63e431a36064b09c25.svg";

/***/ }),

/***/ "VuLC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Filter2 = __webpack_require__("AVkB");

var _Filter3 = _interopRequireDefault(_Filter2);

var _math = __webpack_require__("e3iB");

var _path = __webpack_require__("UUq2");

var _TextureMatrix = __webpack_require__("vusc");

var _TextureMatrix2 = _interopRequireDefault(_TextureMatrix);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The SpriteMaskFilter class
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI
 */
var SpriteMaskFilter = function (_Filter) {
    _inherits(SpriteMaskFilter, _Filter);

    /**
     * @param {PIXI.Sprite} sprite - the target sprite
     */
    function SpriteMaskFilter(sprite) {
        _classCallCheck(this, SpriteMaskFilter);

        var maskMatrix = new _math.Matrix();

        var _this = _possibleConstructorReturn(this, _Filter.call(this, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n', 'varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\nuniform vec4 maskClamp;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(maskClamp.x, vMaskCoord.x) +\n        step(maskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, maskClamp.z) +\n        step(vMaskCoord.y, maskClamp.w));\n\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n\n    original *= (masky.r * masky.a * alpha * clip);\n\n    gl_FragColor = original;\n}\n'));

        sprite.renderable = false;

        _this.maskSprite = sprite;
        _this.maskMatrix = maskMatrix;
        return _this;
    }

    /**
     * Applies the filter
     *
     * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
     * @param {PIXI.RenderTarget} input - The input render target.
     * @param {PIXI.RenderTarget} output - The target to output to.
     * @param {boolean} clear - Should the output be cleared before rendering to it
     */

    SpriteMaskFilter.prototype.apply = function apply(filterManager, input, output, clear) {
        var maskSprite = this.maskSprite;
        var tex = this.maskSprite.texture;

        if (!tex.valid) {
            return;
        }
        if (!tex.transform) {
            // margin = 0.0, let it bleed a bit, shader code becomes easier
            // assuming that atlas textures were made with 1-pixel padding
            tex.transform = new _TextureMatrix2.default(tex, 0.0);
        }
        tex.transform.update();

        this.uniforms.mask = tex;
        this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.transform.mapCoord);
        this.uniforms.alpha = maskSprite.worldAlpha;
        this.uniforms.maskClamp = tex.transform.uClampFrame;

        filterManager.applyFilter(this, input, output, clear);
    };

    return SpriteMaskFilter;
}(_Filter3.default);

exports.default = SpriteMaskFilter;
//# sourceMappingURL=SpriteMaskFilter.js.map

/***/ }),

/***/ "VwmF":
/***/ (function(module, exports, __webpack_require__) {


var compileProgram = __webpack_require__("x48B"),
    extractAttributes = __webpack_require__("LN7j"),
    extractUniforms = __webpack_require__("sq5Z"),
    setPrecision = __webpack_require__("F9WP"),
    generateUniformAccessObject = __webpack_require__("lval");

/**
 * Helper class to create a webGL Shader
 *
 * @class
 * @memberof PIXI.glCore
 * @param gl {WebGLRenderingContext}
 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
 * @param precision {string} The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
 * @param attributeLocations {object} A key value pair showing which location eact attribute should sit eg {position:0, uvs:1}
 */
var Shader = function Shader(gl, vertexSrc, fragmentSrc, precision, attributeLocations) {
	/**
  * The current WebGL rendering context
  *
  * @member {WebGLRenderingContext}
  */
	this.gl = gl;

	if (precision) {
		vertexSrc = setPrecision(vertexSrc, precision);
		fragmentSrc = setPrecision(fragmentSrc, precision);
	}

	/**
  * The shader program
  *
  * @member {WebGLProgram}
  */
	// First compile the program..
	this.program = compileProgram(gl, vertexSrc, fragmentSrc, attributeLocations);

	/**
  * The attributes of the shader as an object containing the following properties
  * {
  * 	type,
  * 	size,
  * 	location,
  * 	pointer
  * }
  * @member {Object}
  */
	// next extract the attributes
	this.attributes = extractAttributes(gl, this.program);

	this.uniformData = extractUniforms(gl, this.program);

	/**
  * The uniforms of the shader as an object containing the following properties
  * {
  * 	gl,
  * 	data
  * }
  * @member {Object}
  */
	this.uniforms = generateUniformAccessObject(gl, this.uniformData);
};
/**
 * Uses this shader
 * 
 * @return {PIXI.glCore.GLShader} Returns itself.
 */
Shader.prototype.bind = function () {
	this.gl.useProgram(this.program);
	return this;
};

/**
 * Destroys this shader
 * TODO
 */
Shader.prototype.destroy = function () {
	this.attributes = null;
	this.uniformData = null;
	this.uniforms = null;

	var gl = this.gl;
	gl.deleteProgram(this.program);
};

module.exports = Shader;

/***/ }),

/***/ "VxKF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__("ywQn");
var foreach = __webpack_require__("Sh+V");
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function isFunction(fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
		/* eslint-disable no-unused-vars, no-restricted-syntax */
		for (var _ in obj) {
			return false;
		}
		/* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) {
		/* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function defineProperty(object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function defineProperties(object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;

/***/ }),

/***/ "W6Cf":
/***/ (function(module, exports, __webpack_require__) {

var simplifyRadialDist = __webpack_require__("po5f");
var simplifyDouglasPeucker = __webpack_require__("AsaK");

//simplifies using both algorithms
module.exports = function simplify(points, tolerance) {
    points = simplifyRadialDist(points, tolerance);
    points = simplifyDouglasPeucker(points, tolerance);
    return points;
};

module.exports.radialDistance = simplifyRadialDist;
module.exports.douglasPeucker = simplifyDouglasPeucker;

/***/ }),

/***/ "W6NO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Required__ = __webpack_require__("0KR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Description__ = __webpack_require__("CuFb");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var TextareaField = function TextareaField(_ref) {
  var input = _ref.input,
      label = _ref.label,
      description = _ref.description,
      type = _ref.type,
      required = _ref.required,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning;

  var invalidObj = {};
  if (required) {
    invalidObj = {
      "aria-invalid": error && touched ? "true" : "false"
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    { "class": touched && error ? "form-group has-error" : "form-group" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "label",
      { "for": input.name, "class": "form-label" },
      label,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__Required__["a" /* default */], { required: required })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__Description__["a" /* default */], { description: description }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("textarea", _extends({
      "class": "form-input",
      "aria-required": required ? "true" : "false",
      id: input.name
    }, input, {
      type: type,
      rows: "4",
      "aria-label": label
    }, invalidObj, {
      "aria-describedby": input.name + "Error"
    })),
    touched && error && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "p",
      { "class": "form-input-hint", id: input.name + "Error" },
      error
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (TextareaField);

/***/ }),

/***/ "WAMM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9528bf8178f4ebb546839da9ba20d32b.svg";

/***/ }),

/***/ "WAcE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "WCoG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateTitle; });
/* unused harmony export buildTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pageChange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tracking_GoogleTagManagerService__ = __webpack_require__("Ys9y");


var updateTitle = function updateTitle(title, event) {
  if (typeof window !== "undefined") {
    var newTitle = buildTitle(title, event);
    document.title = newTitle;
    return newTitle;
  }
};

var buildTitle = function buildTitle(title, event) {
  var titleParts = [];
  if (title) {
    titleParts.push(title);
  }
  if (event && event.data && event.data.name) {
    titleParts.push(event.data.name);
  }
  titleParts.push("Humanitix");
  return titleParts.join(" | ");
};

var customPageView = function customPageView(title) {
  if (typeof window !== "undefined") {
    __WEBPACK_IMPORTED_MODULE_0__services_tracking_GoogleTagManagerService__["a" /* default */].pageViewCustom(title);
  }
};

var pageChange = function pageChange(title, event) {
  var newTitle = updateTitle(title, event);
  customPageView(newTitle);
};

/***/ }),

/***/ "WS6J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fe64679a2aff8328d1c0d5ed5ec23fa6.svg";

/***/ }),

/***/ "Wjl/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f04a6cc1157e3f288ee8b337fc8db65.svg";

/***/ }),

/***/ "WvP3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0f58ee43f206866418007f367d3d46f3.svg";

/***/ }),

/***/ "X8jb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),

/***/ "XEQk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Mesh2 = __webpack_require__("esRn");

var _Mesh3 = _interopRequireDefault(_Mesh2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The rope allows you to draw a texture across several points and them manipulate these points
 *
 *```js
 * for (let i = 0; i < 20; i++) {
 *     points.push(new PIXI.Point(i * 50, 0));
 * };
 * let rope = new PIXI.Rope(PIXI.Texture.fromImage("snake.png"), points);
 *  ```
 *
 * @class
 * @extends PIXI.mesh.Mesh
 * @memberof PIXI.mesh
 *
 */
var Rope = function (_Mesh) {
    _inherits(Rope, _Mesh);

    /**
     * @param {PIXI.Texture} texture - The texture to use on the rope.
     * @param {PIXI.Point[]} points - An array of {@link PIXI.Point} objects to construct this rope.
     */
    function Rope(texture, points) {
        _classCallCheck(this, Rope);

        /**
         * An array of points that determine the rope
         *
         * @member {PIXI.Point[]}
         */
        var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));

        _this.points = points;

        /**
         * An array of vertices used to construct this rope.
         *
         * @member {Float32Array}
         */
        _this.vertices = new Float32Array(points.length * 4);

        /**
         * The WebGL Uvs of the rope.
         *
         * @member {Float32Array}
         */
        _this.uvs = new Float32Array(points.length * 4);

        /**
         * An array containing the color components
         *
         * @member {Float32Array}
         */
        _this.colors = new Float32Array(points.length * 2);

        /**
         * An array containing the indices of the vertices
         *
         * @member {Uint16Array}
         */
        _this.indices = new Uint16Array(points.length * 2);

        /**
         * refreshes vertices on every updateTransform
         * @member {boolean}
         * @default true
         */
        _this.autoUpdate = true;

        _this.refresh();
        return _this;
    }

    /**
     * Refreshes
     *
     */

    Rope.prototype._refresh = function _refresh() {
        var points = this.points;

        // if too little points, or texture hasn't got UVs set yet just move on.
        if (points.length < 1 || !this._texture._uvs) {
            return;
        }

        // if the number of points has changed we will need to recreate the arraybuffers
        if (this.vertices.length / 4 !== points.length) {
            this.vertices = new Float32Array(points.length * 4);
            this.uvs = new Float32Array(points.length * 4);
            this.colors = new Float32Array(points.length * 2);
            this.indices = new Uint16Array(points.length * 2);
        }

        var uvs = this.uvs;

        var indices = this.indices;
        var colors = this.colors;

        uvs[0] = 0;
        uvs[1] = 0;
        uvs[2] = 0;
        uvs[3] = 1;

        colors[0] = 1;
        colors[1] = 1;

        indices[0] = 0;
        indices[1] = 1;

        var total = points.length;

        for (var i = 1; i < total; i++) {
            // time to do some smart drawing!
            var index = i * 4;
            var amount = i / (total - 1);

            uvs[index] = amount;
            uvs[index + 1] = 0;

            uvs[index + 2] = amount;
            uvs[index + 3] = 1;

            index = i * 2;
            colors[index] = 1;
            colors[index + 1] = 1;

            index = i * 2;
            indices[index] = index;
            indices[index + 1] = index + 1;
        }

        // ensure that the changes are uploaded
        this.dirty++;
        this.indexDirty++;

        this.multiplyUvs();
        this.refreshVertices();
    };

    /**
     * refreshes vertices of Rope mesh
     */

    Rope.prototype.refreshVertices = function refreshVertices() {
        var points = this.points;

        if (points.length < 1) {
            return;
        }

        var lastPoint = points[0];
        var nextPoint = void 0;
        var perpX = 0;
        var perpY = 0;

        // this.count -= 0.2;

        var vertices = this.vertices;
        var total = points.length;

        for (var i = 0; i < total; i++) {
            var point = points[i];
            var index = i * 4;

            if (i < points.length - 1) {
                nextPoint = points[i + 1];
            } else {
                nextPoint = point;
            }

            perpY = -(nextPoint.x - lastPoint.x);
            perpX = nextPoint.y - lastPoint.y;

            var ratio = (1 - i / (total - 1)) * 10;

            if (ratio > 1) {
                ratio = 1;
            }

            var perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
            var num = this._texture.height / 2; // (20 + Math.abs(Math.sin((i + this.count) * 0.3) * 50) )* ratio;

            perpX /= perpLength;
            perpY /= perpLength;

            perpX *= num;
            perpY *= num;

            vertices[index] = point.x + perpX;
            vertices[index + 1] = point.y + perpY;
            vertices[index + 2] = point.x - perpX;
            vertices[index + 3] = point.y - perpY;

            lastPoint = point;
        }
    };

    /**
     * Updates the object transform for rendering
     *
     * @private
     */

    Rope.prototype.updateTransform = function updateTransform() {
        if (this.autoUpdate) {
            this.refreshVertices();
        }
        this.containerUpdateTransform();
    };

    return Rope;
}(_Mesh3.default);

exports.default = Rope;
//# sourceMappingURL=Rope.js.map

/***/ }),

/***/ "XgiD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// References:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign

if (!Math.sign) {
    Math.sign = function mathSign(x) {
        x = Number(x);

        if (x === 0 || isNaN(x)) {
            return x;
        }

        return x > 0 ? 1 : -1;
    };
}
//# sourceMappingURL=Math.sign.js.map

/***/ }),

/***/ "Xw9x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _math = __webpack_require__("e3iB");

var _const = __webpack_require__("YEQi");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

var _pixiGlCore = __webpack_require__("PJsv");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * @class
 * @memberof PIXI
 */
var RenderTarget = function () {
  /**
   * @param {WebGLRenderingContext} gl - The current WebGL drawing context
   * @param {number} [width=0] - the horizontal range of the filter
   * @param {number} [height=0] - the vertical range of the filter
   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
   * @param {number} [resolution=1] - The current resolution / device pixel ratio
   * @param {boolean} [root=false] - Whether this object is the root element or not
   */
  function RenderTarget(gl, width, height, scaleMode, resolution, root) {
    _classCallCheck(this, RenderTarget);

    // TODO Resolution could go here ( eg low res blurs )

    /**
     * The current WebGL drawing context.
     *
     * @member {WebGLRenderingContext}
     */
    this.gl = gl;

    // next time to create a frame buffer and texture

    /**
     * A frame buffer
     *
     * @member {PIXI.glCore.GLFramebuffer}
     */
    this.frameBuffer = null;

    /**
     * The texture
     *
     * @member {PIXI.glCore.GLTexture}
     */
    this.texture = null;

    /**
     * The background colour of this render target, as an array of [r,g,b,a] values
     *
     * @member {number[]}
     */
    this.clearColor = [0, 0, 0, 0];

    /**
     * The size of the object as a rectangle
     *
     * @member {PIXI.Rectangle}
     */
    this.size = new _math.Rectangle(0, 0, 1, 1);

    /**
     * The current resolution / device pixel ratio
     *
     * @member {number}
     * @default 1
     */
    this.resolution = resolution || _settings2.default.RESOLUTION;

    /**
     * The projection matrix
     *
     * @member {PIXI.Matrix}
     */
    this.projectionMatrix = new _math.Matrix();

    /**
     * The object's transform
     *
     * @member {PIXI.Matrix}
     */
    this.transform = null;

    /**
     * The frame.
     *
     * @member {PIXI.Rectangle}
     */
    this.frame = null;

    /**
     * The stencil buffer stores masking data for the render target
     *
     * @member {glCore.GLBuffer}
     */
    this.defaultFrame = new _math.Rectangle();
    this.destinationFrame = null;
    this.sourceFrame = null;

    /**
     * The stencil buffer stores masking data for the render target
     *
     * @member {glCore.GLBuffer}
     */
    this.stencilBuffer = null;

    /**
     * The data structure for the stencil masks
     *
     * @member {PIXI.Graphics[]}
     */
    this.stencilMaskStack = [];

    /**
     * Stores filter data for the render target
     *
     * @member {object[]}
     */
    this.filterData = null;

    /**
     * The key for pooled texture of FilterSystem
     * @private
     * @member {string}
     */
    this.filterPoolKey = '';

    /**
     * The scale mode.
     *
     * @member {number}
     * @default PIXI.settings.SCALE_MODE
     * @see PIXI.SCALE_MODES
     */
    this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;

    /**
     * Whether this object is the root element or not
     *
     * @member {boolean}
     * @default false
     */
    this.root = root || false;

    if (!this.root) {
      this.frameBuffer = _pixiGlCore.GLFramebuffer.createRGBA(gl, 100, 100);

      if (this.scaleMode === _const.SCALE_MODES.NEAREST) {
        this.frameBuffer.texture.enableNearestScaling();
      } else {
        this.frameBuffer.texture.enableLinearScaling();
      }
      /*
          A frame buffer needs a target to render to..
          create a texture and bind it attach it to the framebuffer..
       */

      // this is used by the base texture
      this.texture = this.frameBuffer.texture;
    } else {
      // make it a null framebuffer..
      this.frameBuffer = new _pixiGlCore.GLFramebuffer(gl, 100, 100);
      this.frameBuffer.framebuffer = null;
    }

    this.setFrame();

    this.resize(width, height);
  }

  /**
   * Clears the filter texture.
   *
   * @param {number[]} [clearColor=this.clearColor] - Array of [r,g,b,a] to clear the framebuffer
   */

  RenderTarget.prototype.clear = function clear(clearColor) {
    var cc = clearColor || this.clearColor;

    this.frameBuffer.clear(cc[0], cc[1], cc[2], cc[3]); // r,g,b,a);
  };

  /**
   * Binds the stencil buffer.
   *
   */

  RenderTarget.prototype.attachStencilBuffer = function attachStencilBuffer() {
    // TODO check if stencil is done?
    /**
     * The stencil buffer is used for masking in pixi
     * lets create one and then add attach it to the framebuffer..
     */
    if (!this.root) {
      this.frameBuffer.enableStencil();
    }
  };

  /**
   * Sets the frame of the render target.
   *
   * @param {Rectangle} destinationFrame - The destination frame.
   * @param {Rectangle} sourceFrame - The source frame.
   */

  RenderTarget.prototype.setFrame = function setFrame(destinationFrame, sourceFrame) {
    this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame;
    this.sourceFrame = sourceFrame || this.sourceFrame || this.destinationFrame;
  };

  /**
   * Binds the buffers and initialises the viewport.
   *
   */

  RenderTarget.prototype.activate = function activate() {
    // TODO refactor usage of frame..
    var gl = this.gl;

    // make sure the texture is unbound!
    this.frameBuffer.bind();

    this.calculateProjection(this.destinationFrame, this.sourceFrame);

    if (this.transform) {
      this.projectionMatrix.append(this.transform);
    }

    // TODO add a check as them may be the same!
    if (this.destinationFrame !== this.sourceFrame) {
      gl.enable(gl.SCISSOR_TEST);
      gl.scissor(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
    } else {
      gl.disable(gl.SCISSOR_TEST);
    }

    // TODO - does not need to be updated all the time??
    gl.viewport(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
  };

  /**
   * Updates the projection matrix based on a projection frame (which is a rectangle)
   *
   * @param {Rectangle} destinationFrame - The destination frame.
   * @param {Rectangle} sourceFrame - The source frame.
   */

  RenderTarget.prototype.calculateProjection = function calculateProjection(destinationFrame, sourceFrame) {
    var pm = this.projectionMatrix;

    sourceFrame = sourceFrame || destinationFrame;

    pm.identity();

    // TODO: make dest scale source
    if (!this.root) {
      pm.a = 1 / destinationFrame.width * 2;
      pm.d = 1 / destinationFrame.height * 2;

      pm.tx = -1 - sourceFrame.x * pm.a;
      pm.ty = -1 - sourceFrame.y * pm.d;
    } else {
      pm.a = 1 / destinationFrame.width * 2;
      pm.d = -1 / destinationFrame.height * 2;

      pm.tx = -1 - sourceFrame.x * pm.a;
      pm.ty = 1 - sourceFrame.y * pm.d;
    }
  };

  /**
   * Resizes the texture to the specified width and height
   *
   * @param {number} width - the new width of the texture
   * @param {number} height - the new height of the texture
   */

  RenderTarget.prototype.resize = function resize(width, height) {
    width = width | 0;
    height = height | 0;

    if (this.size.width === width && this.size.height === height) {
      return;
    }

    this.size.width = width;
    this.size.height = height;

    this.defaultFrame.width = width;
    this.defaultFrame.height = height;

    this.frameBuffer.resize(width * this.resolution, height * this.resolution);

    var projectionFrame = this.frame || this.size;

    this.calculateProjection(projectionFrame);
  };

  /**
   * Destroys the render target.
   *
   */

  RenderTarget.prototype.destroy = function destroy() {
    if (this.frameBuffer.stencil) {
      this.gl.deleteRenderbuffer(this.frameBuffer.stencil);
    }
    this.frameBuffer.destroy();

    this.frameBuffer = null;
    this.texture = null;
  };

  return RenderTarget;
}();

exports.default = RenderTarget;
//# sourceMappingURL=RenderTarget.js.map

/***/ }),

/***/ "Y4lo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _autoDetectRenderer = __webpack_require__("DqsF");

var _Container = __webpack_require__("OzBO");

var _Container2 = _interopRequireDefault(_Container);

var _ticker = __webpack_require__("5u59");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

var _const = __webpack_require__("YEQi");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * Convenience class to create a new PIXI application.
 * This class automatically creates the renderer, ticker
 * and root container.
 *
 * @example
 * // Create the application
 * const app = new PIXI.Application();
 *
 * // Add the view to the DOM
 * document.body.appendChild(app.view);
 *
 * // ex, add display objects
 * app.stage.addChild(PIXI.Sprite.fromImage('something.png'));
 *
 * @class
 * @memberof PIXI
 */
var Application = function () {
    // eslint-disable-next-line valid-jsdoc
    /**
     * @param {object} [options] - The optional renderer parameters
     * @param {boolean} [options.autoStart=true] - automatically starts the rendering after the construction.
     *     Note that setting this parameter to false does NOT stop the shared ticker even if you set
     *     options.sharedTicker to true in case that it is already started. Stop it by your own.
     * @param {number} [options.width=800] - the width of the renderers view
     * @param {number} [options.height=600] - the height of the renderers view
     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
     *  need to call toDataUrl on the webgl context
     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
     * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
     *   not before the new render pass.
     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
     *  stopping pixel interpolation.
     * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
     *  FXAA is faster, but may not always look as great **webgl only**
     * @param {boolean} [options.legacy=false] - `true` to ensure compatibility with older / less advanced devices.
     *  If you experience unexplained flickering try setting this to true. **webgl only**
     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
     *  for devices with dual graphics card **webgl only**
     * @param {boolean} [options.sharedTicker=false] - `true` to use PIXI.ticker.shared, `false` to create new ticker.
     * @param {boolean} [options.sharedLoader=false] - `true` to use PIXI.loaders.shared, `false` to create new Loader.
     */
    function Application(options, arg2, arg3, arg4, arg5) {
        _classCallCheck(this, Application);

        // Support for constructor(width, height, options, noWebGL, useSharedTicker)
        if (typeof options === 'number') {
            options = _extends({
                width: options,
                height: arg2 || _settings2.default.RENDER_OPTIONS.height,
                forceCanvas: !!arg4,
                sharedTicker: !!arg5
            }, arg3);
        }

        /**
         * The default options, so we mixin functionality later.
         * @member {object}
         * @protected
         */
        this._options = options = _extends({
            autoStart: true,
            sharedTicker: false,
            forceCanvas: false,
            sharedLoader: false
        }, options);

        /**
         * WebGL renderer if available, otherwise CanvasRenderer
         * @member {PIXI.WebGLRenderer|PIXI.CanvasRenderer}
         */
        this.renderer = (0, _autoDetectRenderer.autoDetectRenderer)(options);

        /**
         * The root display container that's rendered.
         * @member {PIXI.Container}
         */
        this.stage = new _Container2.default();

        /**
         * Internal reference to the ticker
         * @member {PIXI.ticker.Ticker}
         * @private
         */
        this._ticker = null;

        /**
         * Ticker for doing render updates.
         * @member {PIXI.ticker.Ticker}
         * @default PIXI.ticker.shared
         */
        this.ticker = options.sharedTicker ? _ticker.shared : new _ticker.Ticker();

        // Start the rendering
        if (options.autoStart) {
            this.start();
        }
    }

    /**
     * Render the current stage.
     */
    Application.prototype.render = function render() {
        this.renderer.render(this.stage);
    };

    /**
     * Convenience method for stopping the render.
     */

    Application.prototype.stop = function stop() {
        this._ticker.stop();
    };

    /**
     * Convenience method for starting the render.
     */

    Application.prototype.start = function start() {
        this._ticker.start();
    };

    /**
     * Reference to the renderer's canvas element.
     * @member {HTMLCanvasElement}
     * @readonly
     */

    /**
     * Destroy and don't use after this.
     * @param {Boolean} [removeView=false] Automatically remove canvas from DOM.
     * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
     *  method called as well. 'stageOptions' will be passed on to those calls.
     * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
     *  to true. Should it destroy the texture of the child sprite
     * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
     *  to true. Should it destroy the base texture of the child sprite
     */
    Application.prototype.destroy = function destroy(removeView, stageOptions) {
        if (this._ticker) {
            var oldTicker = this._ticker;

            this.ticker = null;
            oldTicker.destroy();
        }

        this.stage.destroy(stageOptions);
        this.stage = null;

        this.renderer.destroy(removeView);
        this.renderer = null;

        this._options = null;
    };

    _createClass(Application, [{
        key: 'ticker',
        set: function set(ticker) // eslint-disable-line require-jsdoc
        {
            if (this._ticker) {
                this._ticker.remove(this.render, this);
            }
            this._ticker = ticker;
            if (ticker) {
                ticker.add(this.render, this, _const.UPDATE_PRIORITY.LOW);
            }
        },
        get: function get() // eslint-disable-line require-jsdoc
        {
            return this._ticker;
        }
    }, {
        key: 'view',
        get: function get() {
            return this.renderer.view;
        }

        /**
         * Reference to the renderer's screen rectangle. Its safe to use as filterArea or hitArea for whole screen
         * @member {PIXI.Rectangle}
         * @readonly
         */

    }, {
        key: 'screen',
        get: function get() {
            return this.renderer.screen;
        }
    }]);

    return Application;
}();

exports.default = Application;
//# sourceMappingURL=Application.js.map

/***/ }),

/***/ "YB4n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = __webpack_require__("o6Mn");
function getReservationSprites(host, onConsole) {
    var _ref;

    return _ref = {}, _ref[Utils_1.circle_av_256] = host + "public/sprites/circle_av_256.png", _ref[Utils_1.circle_av_64] = host + "public/sprites/circle_av_64.png", _ref[Utils_1.circle_s_256] = host + "public/sprites/circle_s" + (onConsole ? "el" : "") + "_256.png", _ref[Utils_1.circle_s_64] = host + "public/sprites/circle_s" + (onConsole ? "el" : "") + "_64.png", _ref[Utils_1.circle_unav_256] = host + "public/sprites/circle_unav_256.png", _ref[Utils_1.circle_unav_64] = host + "public/sprites/circle_unav_64.png", _ref[Utils_1.circle_unass_256] = host + "public/sprites/circle_unass_256.png", _ref[Utils_1.circle_ns_256] = host + "public/sprites/circle_ns_256.png", _ref[Utils_1.square_ns_256] = host + "public/sprites/square_ns_256.png", _ref[Utils_1.square_s_256] = host + "public/sprites/square_s_256.png", _ref[Utils_1.barIcon] = host + "public/sprites/icons/bar.png", _ref[Utils_1.blindIcon] = host + "public/sprites/icons/blind.png", _ref[Utils_1.exitIcon] = host + "public/sprites/icons/exit.png", _ref[Utils_1.foodIcon] = host + "public/sprites/icons/food.png", _ref[Utils_1.smokingIcon] = host + "public/sprites/icons/smoking.png", _ref[Utils_1.wheelchairIcon] = host + "public/sprites/icons/wheelchair.png", _ref[Utils_1.bathroomIcon] = host + "public/sprites/icons/bathroom.png", _ref[Utils_1.dancefloorIcon] = host + "public/sprites/icons/dance_floor.png", _ref[Utils_1.firstAidIcon] = host + "public/sprites/icons/first_aid.png", _ref[Utils_1.infoIcon] = host + "public/sprites/icons/info.png", _ref[Utils_1.stairsIcon] = host + "public/sprites/icons/stairs.png", _ref[Utils_1.stageIcon] = host + "public/sprites/icons/stage.png", _ref[Utils_1.stairsUpDownIcon] = host + "public/sprites/icons/stairs_up_down.png", _ref[Utils_1.backArrowIcon] = host + "public/sprites/icons/back_arrow.png", _ref[Utils_1.lato] = host + "public/sprites/lato.png", _ref;
}
exports.default = getReservationSprites;
//# sourceMappingURL=ReservationSprites.js.map

/***/ }),

/***/ "YEQi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * String of the current PIXI version.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name VERSION
 * @type {string}
 */
var VERSION = exports.VERSION = '4.8.8';

/**
 * Two Pi.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @type {number}
 */
var PI_2 = exports.PI_2 = Math.PI * 2;

/**
 * Conversion factor for converting radians to degrees.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @type {number}
 */
var RAD_TO_DEG = exports.RAD_TO_DEG = 180 / Math.PI;

/**
 * Conversion factor for converting degrees to radians.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @type {number}
 */
var DEG_TO_RAD = exports.DEG_TO_RAD = Math.PI / 180;

/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @type {object}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */
var RENDERER_TYPE = exports.RENDERER_TYPE = {
  UNKNOWN: 0,
  WEBGL: 1,
  CANVAS: 2
};

/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name BLEND_MODES
 * @type {object}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 */
var BLEND_MODES = exports.BLEND_MODES = {
  NORMAL: 0,
  ADD: 1,
  MULTIPLY: 2,
  SCREEN: 3,
  OVERLAY: 4,
  DARKEN: 5,
  LIGHTEN: 6,
  COLOR_DODGE: 7,
  COLOR_BURN: 8,
  HARD_LIGHT: 9,
  SOFT_LIGHT: 10,
  DIFFERENCE: 11,
  EXCLUSION: 12,
  HUE: 13,
  SATURATION: 14,
  COLOR: 15,
  LUMINOSITY: 16,
  NORMAL_NPM: 17,
  ADD_NPM: 18,
  SCREEN_NPM: 19
};

/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name DRAW_MODES
 * @type {object}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */
var DRAW_MODES = exports.DRAW_MODES = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6
};

/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name SCALE_MODES
 * @type {object}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */
var SCALE_MODES = exports.SCALE_MODES = {
  LINEAR: 0,
  NEAREST: 1
};

/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as webGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @static
 * @constant
 * @name WRAP_MODES
 * @memberof PIXI
 * @type {object}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */
var WRAP_MODES = exports.WRAP_MODES = {
  CLAMP: 0,
  REPEAT: 1,
  MIRRORED_REPEAT: 2
};

/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @static
 * @constant
 * @name GC_MODES
 * @memberof PIXI
 * @type {object}
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */
var GC_MODES = exports.GC_MODES = {
  AUTO: 0,
  MANUAL: 1
};

/**
 * Regexp for image type by extension.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @type {RegExp|string}
 * @example `image.png`
 */
var URL_FILE_EXTENSION = exports.URL_FILE_EXTENSION = /\.(\w{3,4})(?:$|\?|#)/i;

/**
 * Regexp for data URI.
 * Based on: {@link https://github.com/ragingwind/data-uri-regex}
 *
 * @static
 * @constant
 * @name DATA_URI
 * @memberof PIXI
 * @type {RegExp|string}
 * @example data:image/png;base64
 */
var DATA_URI = exports.DATA_URI = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;

/**
 * Regexp for SVG size.
 *
 * @static
 * @constant
 * @name SVG_SIZE
 * @memberof PIXI
 * @type {RegExp|string}
 * @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
 */
var SVG_SIZE = exports.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i; // eslint-disable-line max-len

/**
 * Constants that identify shapes, mainly to prevent `instanceof` calls.
 *
 * @static
 * @constant
 * @name SHAPES
 * @memberof PIXI
 * @type {object}
 * @property {number} POLY Polygon
 * @property {number} RECT Rectangle
 * @property {number} CIRC Circle
 * @property {number} ELIP Ellipse
 * @property {number} RREC Rounded Rectangle
 */
var SHAPES = exports.SHAPES = {
  POLY: 0,
  RECT: 1,
  CIRC: 2,
  ELIP: 3,
  RREC: 4
};

/**
 * Constants that specify float precision in shaders.
 *
 * @static
 * @constant
 * @name PRECISION
 * @memberof PIXI
 * @type {object}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */
var PRECISION = exports.PRECISION = {
  LOW: 'lowp',
  MEDIUM: 'mediump',
  HIGH: 'highp'
};

/**
 * Constants that specify the transform type.
 *
 * @static
 * @constant
 * @name TRANSFORM_MODE
 * @memberof PIXI
 * @type {object}
 * @property {number} STATIC
 * @property {number} DYNAMIC
 */
var TRANSFORM_MODE = exports.TRANSFORM_MODE = {
  STATIC: 0,
  DYNAMIC: 1
};

/**
 * Constants that define the type of gradient on text.
 *
 * @static
 * @constant
 * @name TEXT_GRADIENT
 * @memberof PIXI
 * @type {object}
 * @property {number} LINEAR_VERTICAL Vertical gradient
 * @property {number} LINEAR_HORIZONTAL Linear gradient
 */
var TEXT_GRADIENT = exports.TEXT_GRADIENT = {
  LINEAR_VERTICAL: 0,
  LINEAR_HORIZONTAL: 1
};

/**
 * Represents the update priorities used by internal PIXI classes when registered with
 * the {@link PIXI.ticker.Ticker} object. Higher priority items are updated first and lower
 * priority items, such as render, should go later.
 *
 * @static
 * @constant
 * @name UPDATE_PRIORITY
 * @memberof PIXI
 * @type {object}
 * @property {number} INTERACTION=50 Highest priority, used for {@link PIXI.interaction.InteractionManager}
 * @property {number} HIGH=25 High priority updating, {@link PIXI.VideoBaseTexture} and {@link PIXI.extras.AnimatedSprite}
 * @property {number} NORMAL=0 Default priority for ticker events, see {@link PIXI.ticker.Ticker#add}.
 * @property {number} LOW=-25 Low priority used for {@link PIXI.Application} rendering.
 * @property {number} UTILITY=-50 Lowest priority used for {@link PIXI.prepare.BasePrepare} utility.
 */
var UPDATE_PRIORITY = exports.UPDATE_PRIORITY = {
  INTERACTION: 50,
  HIGH: 25,
  NORMAL: 0,
  LOW: -25,
  UTILITY: -50
};
//# sourceMappingURL=const.js.map

/***/ }),

/***/ "YI+C":
/***/ (function(module, exports) {

module.exports = {

    toXy: function toXy(pointset, format) {
        if (format === undefined) {
            return pointset.slice();
        }
        return pointset.map(function (pt) {
            /*jslint evil: true */
            var _getXY = new Function('pt', 'return [pt' + format[0] + ',' + 'pt' + format[1] + '];');
            return _getXY(pt);
        });
    },

    fromXy: function fromXy(pointset, format) {
        if (format === undefined) {
            return pointset.slice();
        }
        return pointset.map(function (pt) {
            /*jslint evil: true */
            var _getObj = new Function('pt', 'const o = {}; o' + format[0] + '= pt[0]; o' + format[1] + '= pt[1]; return o;');
            return _getObj(pt);
        });
    }

};

/***/ }),

/***/ "YPsP":
/***/ (function(module, exports, __webpack_require__) {

/*
  Used to import DayPickerInput. e.g. `import DayPickerInput from 'react-day-picker/DayPickerInput'`
*/

/* eslint-disable no-var */
/* eslint-env node */

var DayPickerInput = __webpack_require__("jYgH");

module.exports = DayPickerInput;

/***/ }),

/***/ "YYLF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("eDyj");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "Ycoe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
        } else {
            return get(parent, property, receiver);
        }
    } else if ("value" in desc) {
        return desc.value;
    } else {
        var getter = desc.get;if (getter === undefined) {
            return undefined;
        }return getter.call(receiver);
    }
};

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PIXI = __webpack_require__("ix37");

var utils = __webpack_require__("GZIj");
var Drag = __webpack_require__("4ORL");
var Pinch = __webpack_require__("NMJ1");
var Clamp = __webpack_require__("Et5b");
var ClampZoom = __webpack_require__("k9g3");
var Decelerate = __webpack_require__("A5+a");
var Bounce = __webpack_require__("cixM");
var Snap = __webpack_require__("jLHJ");
var SnapZoom = __webpack_require__("NNKX");
var Follow = __webpack_require__("ctPN");
var Wheel = __webpack_require__("AQv1");
var MouseEdges = __webpack_require__("RISe");

var PLUGIN_ORDER = ['drag', 'pinch', 'wheel', 'follow', 'mouse-edges', 'decelerate', 'bounce', 'snap-zoom', 'clamp-zoom', 'snap', 'clamp'];

var Viewport = function (_PIXI$Container) {
    _inherits(Viewport, _PIXI$Container);

    /**
     * @extends PIXI.Container
     * @extends EventEmitter
     * @param {object} [options]
     * @param {number} [options.screenWidth=window.innerWidth]
     * @param {number} [options.screenHeight=window.innerHeight]
     * @param {number} [options.worldWidth=this.width]
     * @param {number} [options.worldHeight=this.height]
     * @param {number} [options.threshold=5] number of pixels to move to trigger an input event (e.g., drag, pinch) or disable a clicked event
     * @param {boolean} [options.passiveWheel=true] whether the 'wheel' event is set to passive
     * @param {boolean} [options.stopPropagation=false] whether to stopPropagation of events that impact the viewport
     * @param {(PIXI.Rectangle|PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.RoundedRectangle)} [options.forceHitArea] change the default hitArea from world size to a new value
     * @param {boolean} [options.noTicker] set this if you want to manually call update() function on each frame
     * @param {PIXI.ticker.Ticker} [options.ticker=PIXI.Ticker.shared||PIXI.ticker.shared] use this PIXI.ticker for updates
     * @param {PIXI.InteractionManager} [options.interaction=null] InteractionManager, available from instantiated WebGLRenderer/CanvasRenderer.plugins.interaction - used to calculate pointer postion relative to canvas location on screen
     * @param {HTMLElement} [options.divWheel=document.body] div to attach the wheel event
     * @fires clicked
     * @fires drag-start
     * @fires drag-end
     * @fires drag-remove
     * @fires pinch-start
     * @fires pinch-end
     * @fires pinch-remove
     * @fires snap-start
     * @fires snap-end
     * @fires snap-remove
     * @fires snap-zoom-start
     * @fires snap-zoom-end
     * @fires snap-zoom-remove
     * @fires bounce-x-start
     * @fires bounce-x-end
     * @fires bounce-y-start
     * @fires bounce-y-end
     * @fires bounce-remove
     * @fires wheel
     * @fires wheel-remove
     * @fires wheel-scroll
     * @fires wheel-scroll-remove
     * @fires mouse-edge-start
     * @fires mouse-edge-end
     * @fires mouse-edge-remove
     * @fires moved
     * @fires moved-end
     * @fires zoomed
     * @fires zoomed-end
     */
    function Viewport(options) {
        _classCallCheck(this, Viewport);

        options = options || {};

        var _this = _possibleConstructorReturn(this, (Viewport.__proto__ || Object.getPrototypeOf(Viewport)).call(this));

        _this.plugins = {};
        _this.pluginsList = [];
        _this._screenWidth = options.screenWidth || window.innerWidth;
        _this._screenHeight = options.screenHeight || window.innerHeight;
        _this._worldWidth = options.worldWidth;
        _this._worldHeight = options.worldHeight;
        _this.hitAreaFullScreen = utils.defaults(options.hitAreaFullScreen, true);
        _this.forceHitArea = options.forceHitArea;
        _this.passiveWheel = utils.defaults(options.passiveWheel, true);
        _this.stopEvent = options.stopPropagation;
        _this.threshold = utils.defaults(options.threshold, 5);
        _this.interaction = options.interaction || null;
        _this.div = options.divWheel || document.body;
        _this.listeners(_this.div);
        _this.div.oncontextmenu = function (e) {
            return e.preventDefault();
        };

        /**
         * active touch point ids on the viewport
         * @type {number[]}
         * @readonly
         */
        _this.touches = [];

        if (!options.noTicker) {
            _this.ticker = options.ticker || (PIXI.Ticker ? PIXI.Ticker.shared : PIXI.ticker.shared);
            _this.tickerFunction = function () {
                return _this.update(_this.ticker.elapsedMS);
            };
            _this.ticker.add(_this.tickerFunction);
        }
        return _this;
    }

    /**
     * removes all event listeners from viewport
     * (useful for cleanup of wheel and ticker events when removing viewport)
     */

    _createClass(Viewport, [{
        key: 'removeListeners',
        value: function removeListeners() {
            this.ticker.remove(this.tickerFunction);
            this.div.removeEventListener('wheel', this.wheelFunction);
        }

        /**
         * overrides PIXI.Container's destroy to also remove the 'wheel' and PIXI.Ticker listeners
         */

    }, {
        key: 'destroy',
        value: function destroy(options) {
            _get(Viewport.prototype.__proto__ || Object.getPrototypeOf(Viewport.prototype), 'destroy', this).call(this, options);
            this.removeListeners();
        }

        /**
         * update viewport on each frame
         * by default, you do not need to call this unless you set options.noTicker=true
         */

    }, {
        key: 'update',
        value: function update(elapsed) {
            if (!this.pause) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.pluginsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var plugin = _step.value;

                        plugin.update(elapsed);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (this.lastViewport) {
                    // check for moved-end event
                    if (this.lastViewport.x !== this.x || this.lastViewport.y !== this.y) {
                        this.moving = true;
                    } else {
                        if (this.moving) {
                            this.emit('moved-end', this);
                            this.moving = false;
                        }
                    }
                    // check for zoomed-end event
                    if (this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y) {
                        this.zooming = true;
                    } else {
                        if (this.zooming) {
                            this.emit('zoomed-end', this);
                            this.zooming = false;
                        }
                    }
                }

                if (!this.forceHitArea) {
                    this.hitArea.x = this.left;
                    this.hitArea.y = this.top;
                    this.hitArea.width = this.worldScreenWidth;
                    this.hitArea.height = this.worldScreenHeight;
                }
                this._dirty = this._dirty || !this.lastViewport || this.lastViewport.x !== this.x || this.lastViewport.y !== this.y || this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y;
                this.lastViewport = {
                    x: this.x,
                    y: this.y,
                    scaleX: this.scale.x,
                    scaleY: this.scale.y
                };
            }
        }

        /**
         * use this to set screen and world sizes--needed for pinch/wheel/clamp/bounce
         * @param {number} [screenWidth=window.innerWidth]
         * @param {number} [screenHeight=window.innerHeight]
         * @param {number} [worldWidth]
         * @param {number} [worldHeight]
         */

    }, {
        key: 'resize',
        value: function resize(screenWidth, screenHeight, worldWidth, worldHeight) {
            this._screenWidth = screenWidth || window.innerWidth;
            this._screenHeight = screenHeight || window.innerHeight;
            if (worldWidth) {
                this._worldWidth = worldWidth;
            }
            if (worldHeight) {
                this._worldHeight = worldHeight;
            }
            this.resizePlugins();
        }

        /**
         * called after a worldWidth/Height change
         * @private
         */

    }, {
        key: 'resizePlugins',
        value: function resizePlugins() {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.pluginsList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var plugin = _step2.value;

                    plugin.resize();
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }

        /**
         * screen width in screen pixels
         * @type {number}
         */

    }, {
        key: 'getVisibleBounds',

        /**
         * get visible bounds of viewport
         * @return {object} bounds { x, y, width, height }
         */
        value: function getVisibleBounds() {
            return { x: this.left, y: this.top, width: this.worldScreenWidth, height: this.worldScreenHeight };
        }

        /**
         * add input listeners
         * @private
         */

    }, {
        key: 'listeners',
        value: function listeners(div) {
            var _this2 = this;

            this.interactive = true;
            if (!this.forceHitArea) {
                this.hitArea = new PIXI.Rectangle(0, 0, this.worldWidth, this.worldHeight);
            }
            this.on('pointerdown', this.down);
            this.on('pointermove', this.move);
            this.on('pointerup', this.up);
            this.on('pointerupoutside', this.up);
            this.on('pointercancel', this.up);
            this.on('pointerout', this.up);
            this.wheelFunction = function (e) {
                return _this2.handleWheel(e);
            };
            div.addEventListener('wheel', this.wheelFunction, { passive: this.passiveWheel });
            this.isMouseDown = false;
        }

        /**
         * handle down events
         * @private
         */

    }, {
        key: 'down',
        value: function down(e) {
            if (this.pause || !this.worldVisible) {
                return;
            }
            if (e.data.pointerType === 'mouse') {
                this.isMouseDown = true;
            } else {
                this.touches.push(e.data.pointerId);
            }

            if (this.countDownPointers() === 1) {
                this.last = e.data.global.clone();

                // clicked event does not fire if viewport is decelerating or bouncing
                var decelerate = this.plugins['decelerate'];
                var bounce = this.plugins['bounce'];
                if ((!decelerate || !decelerate.isActive()) && (!bounce || !bounce.isActive())) {
                    this.clickedAvailable = true;
                } else {
                    this.clickedAvailable = false;
                }
            } else {
                this.clickedAvailable = false;
            }

            var stop = void 0;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = this.pluginsList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var plugin = _step3.value;

                    if (plugin.down(e)) {
                        stop = true;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            if (stop && this.stopEvent) {
                e.stopPropagation();
            }
        }

        /**
         * whether change exceeds threshold
         * @private
         * @param {number} change
         */

    }, {
        key: 'checkThreshold',
        value: function checkThreshold(change) {
            if (Math.abs(change) >= this.threshold) {
                return true;
            }
            return false;
        }

        /**
         * handle move events
         * @private
         */

    }, {
        key: 'move',
        value: function move(e) {
            if (this.pause || !this.worldVisible) {
                return;
            }

            var stop = void 0;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = this.pluginsList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var plugin = _step4.value;

                    if (plugin.move(e)) {
                        stop = true;
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            if (this.clickedAvailable) {
                var distX = e.data.global.x - this.last.x;
                var distY = e.data.global.y - this.last.y;
                if (this.checkThreshold(distX) || this.checkThreshold(distY)) {
                    this.clickedAvailable = false;
                }
            }

            if (stop && this.stopEvent) {
                e.stopPropagation();
            }
        }

        /**
         * handle up events
         * @private
         */

    }, {
        key: 'up',
        value: function up(e) {
            if (this.pause || !this.worldVisible) {
                return;
            }
            if (e.data.pointerType === 'mouse') {
                this.isMouseDown = false;
            }
            if (e.data.pointerType !== 'mouse') {
                for (var i = 0; i < this.touches.length; i++) {
                    if (this.touches[i] === e.data.pointerId) {
                        this.touches.splice(i, 1);
                        break;
                    }
                }
            }

            var stop = void 0;
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = this.pluginsList[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var plugin = _step5.value;

                    if (plugin.up(e)) {
                        stop = true;
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            if (this.clickedAvailable && this.countDownPointers() === 0) {
                this.emit('clicked', { screen: this.last, world: this.toWorld(this.last), viewport: this });
                this.clickedAvailable = false;
            }

            if (stop && this.stopEvent) {
                e.stopPropagation();
            }
        }

        /**
         * gets pointer position if this.interaction is set
         * @param {UIEvent} evt
         * @private
         */

    }, {
        key: 'getPointerPosition',
        value: function getPointerPosition(evt) {
            var point = new PIXI.Point();
            if (this.interaction) {
                this.interaction.mapPositionToPoint(point, evt.clientX, evt.clientY);
            } else {
                point.x = evt.clientX;
                point.y = evt.clientY;
            }
            return point;
        }

        /**
         * handle wheel events
         * @private
         */

    }, {
        key: 'handleWheel',
        value: function handleWheel(e) {
            if (this.pause || !this.worldVisible) {
                return;
            }

            // only handle wheel events where the mouse is over the viewport
            var point = this.toLocal(this.getPointerPosition(e));
            if (this.left <= point.x && point.x <= this.right && this.top <= point.y && point.y <= this.bottom) {
                var result = void 0;
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = this.pluginsList[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var plugin = _step6.value;

                        if (plugin.wheel(e)) {
                            result = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }

                return result;
            }
        }

        /**
         * change coordinates from screen to world
         * @param {number|PIXI.Point} x
         * @param {number} [y]
         * @returns {PIXI.Point}
         */

    }, {
        key: 'toWorld',
        value: function toWorld() {
            if (arguments.length === 2) {
                var x = arguments[0];
                var y = arguments[1];
                return this.toLocal({ x: x, y: y });
            } else {
                return this.toLocal(arguments[0]);
            }
        }

        /**
         * change coordinates from world to screen
         * @param {number|PIXI.Point} x
         * @param {number} [y]
         * @returns {PIXI.Point}
         */

    }, {
        key: 'toScreen',
        value: function toScreen() {
            if (arguments.length === 2) {
                var x = arguments[0];
                var y = arguments[1];
                return this.toGlobal({ x: x, y: y });
            } else {
                var point = arguments[0];
                return this.toGlobal(point);
            }
        }

        /**
         * screen width in world coordinates
         * @type {number}
         * @readonly
         */

    }, {
        key: 'moveCenter',

        /**
         * move center of viewport to point
         * @param {(number|PIXI.Point)} x or point
         * @param {number} [y]
         * @return {Viewport} this
         */
        value: function moveCenter() /*x, y | PIXI.Point*/{
            var x = void 0,
                y = void 0;
            if (!isNaN(arguments[0])) {
                x = arguments[0];
                y = arguments[1];
            } else {
                x = arguments[0].x;
                y = arguments[0].y;
            }
            this.position.set((this.worldScreenWidth / 2 - x) * this.scale.x, (this.worldScreenHeight / 2 - y) * this.scale.y);
            this._reset();
            return this;
        }

        /**
         * top-left corner
         * @type {PIXI.Point}
         */

    }, {
        key: 'moveCorner',

        /**
         * move viewport's top-left corner; also clamps and resets decelerate and bounce (as needed)
         * @param {number|PIXI.Point} x|point
         * @param {number} y
         * @return {Viewport} this
         */
        value: function moveCorner() /*x, y | point*/{
            if (arguments.length === 1) {
                this.position.set(-arguments[0].x * this.scale.x, -arguments[0].y * this.scale.y);
            } else {
                this.position.set(-arguments[0] * this.scale.x, -arguments[1] * this.scale.y);
            }
            this._reset();
            return this;
        }

        /**
         * change zoom so the width fits in the viewport
         * @param {number} [width=this._worldWidth] in world coordinates
         * @param {boolean} [center] maintain the same center
         * @param {boolean} [scaleY=true] whether to set scaleY=scaleX
         * @param {boolean} [noClamp=false] whether to disable clamp-zoom
         * @return {Viewport} this
         */

    }, {
        key: 'fitWidth',
        value: function fitWidth(width, center) {
            var scaleY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var noClamp = arguments[3];

            var save = void 0;
            if (center) {
                save = this.center;
            }
            width = width || this.worldWidth;
            this.scale.x = this.screenWidth / width;

            if (scaleY) {
                this.scale.y = this.scale.x;
            }

            var clampZoom = this.plugins['clamp-zoom'];
            if (!noClamp && clampZoom) {
                clampZoom.clamp();
            }

            if (center) {
                this.moveCenter(save);
            }
            return this;
        }

        /**
         * change zoom so the height fits in the viewport
         * @param {number} [height=this._worldHeight] in world coordinates
         * @param {boolean} [center] maintain the same center of the screen after zoom
         * @param {boolean} [scaleX=true] whether to set scaleX = scaleY
         * @param {boolean} [noClamp=false] whether to disable clamp-zoom
         * @return {Viewport} this
         */

    }, {
        key: 'fitHeight',
        value: function fitHeight(height, center) {
            var scaleX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var noClamp = arguments[3];

            var save = void 0;
            if (center) {
                save = this.center;
            }
            height = height || this.worldHeight;
            this.scale.y = this.screenHeight / height;

            if (scaleX) {
                this.scale.x = this.scale.y;
            }

            var clampZoom = this.plugins['clamp-zoom'];
            if (!noClamp && clampZoom) {
                clampZoom.clamp();
            }

            if (center) {
                this.moveCenter(save);
            }
            return this;
        }

        /**
         * change zoom so it fits the entire world in the viewport
         * @param {boolean} [center] maintain the same center of the screen after zoom
         * @return {Viewport} this
         */

    }, {
        key: 'fitWorld',
        value: function fitWorld(center) {
            var save = void 0;
            if (center) {
                save = this.center;
            }
            this.scale.x = this.screenWidth / this.worldWidth;
            this.scale.y = this.screenHeight / this.worldHeight;
            if (this.scale.x < this.scale.y) {
                this.scale.y = this.scale.x;
            } else {
                this.scale.x = this.scale.y;
            }

            var clampZoom = this.plugins['clamp-zoom'];
            if (clampZoom) {
                clampZoom.clamp();
            }

            if (center) {
                this.moveCenter(save);
            }
            return this;
        }

        /**
         * change zoom so it fits the size or the entire world in the viewport
         * @param {boolean} [center] maintain the same center of the screen after zoom
         * @param {number} [width] desired width
         * @param {number} [height] desired height
         * @return {Viewport} this
         */

    }, {
        key: 'fit',
        value: function fit(center, width, height) {
            var save = void 0;
            if (center) {
                save = this.center;
            }
            width = width || this.worldWidth;
            height = height || this.worldHeight;
            this.scale.x = this.screenWidth / width;
            this.scale.y = this.screenHeight / height;
            if (this.scale.x < this.scale.y) {
                this.scale.y = this.scale.x;
            } else {
                this.scale.x = this.scale.y;
            }
            var clampZoom = this.plugins['clamp-zoom'];
            if (clampZoom) {
                clampZoom.clamp();
            }
            if (center) {
                this.moveCenter(save);
            }
            return this;
        }

        /**
         * zoom viewport by a certain percent (in both x and y direction)
         * @param {number} percent change (e.g., 0.25 would increase a starting scale of 1.0 to 1.25)
         * @param {boolean} [center] maintain the same center of the screen after zoom
         * @return {Viewport} the viewport
         */

    }, {
        key: 'zoomPercent',
        value: function zoomPercent(percent, center) {
            var save = void 0;
            if (center) {
                save = this.center;
            }
            var scale = this.scale.x + this.scale.x * percent;
            this.scale.set(scale);
            var clampZoom = this.plugins['clamp-zoom'];
            if (clampZoom) {
                clampZoom.clamp();
            }
            if (center) {
                this.moveCenter(save);
            }
            return this;
        }

        /**
         * zoom viewport by increasing/decreasing width by a certain number of pixels
         * @param {number} change in pixels
         * @param {boolean} [center] maintain the same center of the screen after zoom
         * @return {Viewport} the viewport
         */

    }, {
        key: 'zoom',
        value: function zoom(change, center) {
            this.fitWidth(change + this.worldScreenWidth, center);
            return this;
        }

        /**
         * @param {object} [options]
         * @param {number} [options.width] the desired width to snap (to maintain aspect ratio, choose only width or height)
         * @param {number} [options.height] the desired height to snap (to maintain aspect ratio, choose only width or height)
         * @param {number} [options.time=1000]
         * @param {string|function} [options.ease=easeInOutSine] ease function or name (see http://easings.net/ for supported names)
         * @param {PIXI.Point} [options.center] place this point at center during zoom instead of center of the viewport
         * @param {boolean} [options.interrupt=true] pause snapping with any user input on the viewport
         * @param {boolean} [options.removeOnComplete] removes this plugin after snapping is complete
         * @param {boolean} [options.removeOnInterrupt] removes this plugin if interrupted by any user input
         * @param {boolean} [options.forceStart] starts the snap immediately regardless of whether the viewport is at the desired zoom
         * @param {boolean} [options.noMove] zoom but do not move
         */

    }, {
        key: 'snapZoom',
        value: function snapZoom(options) {
            this.plugins['snap-zoom'] = new SnapZoom(this, options);
            this.pluginsSort();
            return this;
        }

        /**
         * @private
         * @typedef OutOfBounds
         * @type {object}
         * @property {boolean} left
         * @property {boolean} right
         * @property {boolean} top
         * @property {boolean} bottom
         */

        /**
         * is container out of world bounds
         * @return {OutOfBounds}
         * @private
         */

    }, {
        key: 'OOB',
        value: function OOB() {
            var result = {};
            result.left = this.left < 0;
            result.right = this.right > this._worldWidth;
            result.top = this.top < 0;
            result.bottom = this.bottom > this._worldHeight;
            result.cornerPoint = {
                x: this._worldWidth * this.scale.x - this._screenWidth,
                y: this._worldHeight * this.scale.y - this._screenHeight
            };
            return result;
        }

        /**
         * world coordinates of the right edge of the screen
         * @type {number}
         */

    }, {
        key: 'countDownPointers',

        /**
         * count of mouse/touch pointers that are down on the viewport
         * @private
         * @return {number}
         */
        value: function countDownPointers() {
            return (this.isMouseDown ? 1 : 0) + this.touches.length;
        }

        /**
         * array of touch pointers that are down on the viewport
         * @private
         * @return {PIXI.InteractionTrackingData[]}
         */

    }, {
        key: 'getTouchPointers',
        value: function getTouchPointers() {
            var results = [];
            var pointers = this.trackedPointers;
            for (var key in pointers) {
                var pointer = pointers[key];
                if (this.touches.indexOf(pointer.pointerId) !== -1) {
                    results.push(pointer);
                }
            }
            return results;
        }

        /**
         * array of pointers that are down on the viewport
         * @private
         * @return {PIXI.InteractionTrackingData[]}
         */

    }, {
        key: 'getPointers',
        value: function getPointers() {
            var results = [];
            var pointers = this.trackedPointers;
            for (var key in pointers) {
                results.push(pointers[key]);
            }
            return results;
        }

        /**
         * clamps and resets bounce and decelerate (as needed) after manually moving viewport
         * @private
         */

    }, {
        key: '_reset',
        value: function _reset() {
            if (this.plugins['bounce']) {
                this.plugins['bounce'].reset();
                this.plugins['bounce'].bounce();
            }
            if (this.plugins['decelerate']) {
                this.plugins['decelerate'].reset();
            }
            if (this.plugins['snap']) {
                this.plugins['snap'].reset();
            }
            if (this.plugins['clamp']) {
                this.plugins['clamp'].update();
            }
            if (this.plugins['clamp-zoom']) {
                this.plugins['clamp-zoom'].clamp();
            }
        }

        // PLUGINS

        /**
         * Inserts a user plugin into the viewport
         * @param {string} name of plugin
         * @param {Plugin} plugin - instantiated Plugin class
         * @param {number} [index=last element] plugin is called current order: 'drag', 'pinch', 'wheel', 'follow', 'mouse-edges', 'decelerate', 'bounce', 'snap-zoom', 'clamp-zoom', 'snap', 'clamp'
         */

    }, {
        key: 'userPlugin',
        value: function userPlugin(name, plugin) {
            var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PLUGIN_ORDER.length;

            this.plugins[name] = plugin;
            var current = PLUGIN_ORDER.indexOf(name);
            if (current !== -1) {
                PLUGIN_ORDER.splice(current, 1);
            }
            PLUGIN_ORDER.splice(index, 0, name);
            this.pluginsSort();
        }

        /**
         * removes installed plugin
         * @param {string} type of plugin (e.g., 'drag', 'pinch')
         */

    }, {
        key: 'removePlugin',
        value: function removePlugin(type) {
            if (this.plugins[type]) {
                this.plugins[type] = null;
                this.emit(type + '-remove');
                this.pluginsSort();
            }
        }

        /**
         * pause plugin
         * @param {string} type of plugin (e.g., 'drag', 'pinch')
         */

    }, {
        key: 'pausePlugin',
        value: function pausePlugin(type) {
            if (this.plugins[type]) {
                this.plugins[type].pause();
            }
        }

        /**
         * resume plugin
         * @param {string} type of plugin (e.g., 'drag', 'pinch')
         */

    }, {
        key: 'resumePlugin',
        value: function resumePlugin(type) {
            if (this.plugins[type]) {
                this.plugins[type].resume();
            }
        }

        /**
         * sort plugins for updates
         * @private
         */

    }, {
        key: 'pluginsSort',
        value: function pluginsSort() {
            this.pluginsList = [];
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = PLUGIN_ORDER[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var plugin = _step7.value;

                    if (this.plugins[plugin]) {
                        this.pluginsList.push(this.plugins[plugin]);
                    }
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }
        }

        /**
         * enable one-finger touch to drag
         * @param {object} [options]
         * @param {string} [options.direction=all] direction to drag (all, x, or y)
         * @param {boolean} [options.wheel=true] use wheel to scroll in y direction (unless wheel plugin is active)
         * @param {number} [options.wheelScroll=1] number of pixels to scroll with each wheel spin
         * @param {boolean} [options.reverse] reverse the direction of the wheel scroll
         * @param {boolean|string} [options.clampWheel] (true, x, or y) clamp wheel (to avoid weird bounce with mouse wheel)
         * @param {string} [options.underflow=center] (top/bottom/center and left/right/center, or center) where to place world if too small for screen
         * @param {number} [options.factor=1] factor to multiply drag to increase the speed of movement
         * @param {string} [options.mouseButtons=all] changes which mouse buttons trigger drag, use: 'all', 'left', right' 'middle', or some combination, like, 'middle-right'
         */

    }, {
        key: 'drag',
        value: function drag(options) {
            this.plugins['drag'] = new Drag(this, options);
            this.pluginsSort();
            return this;
        }

        /**
         * clamp to world boundaries or other provided boundaries
         * NOTES:
         *   clamp is disabled if called with no options; use { direction: 'all' } for all edge clamping
         *   screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
         * @param {object} [options]
         * @param {(number|boolean)} [options.left] clamp left; true=0
         * @param {(number|boolean)} [options.right] clamp right; true=viewport.worldWidth
         * @param {(number|boolean)} [options.top] clamp top; true=0
         * @param {(number|boolean)} [options.bottom] clamp bottom; true=viewport.worldHeight
         * @param {string} [options.direction] (all, x, or y) using clamps of [0, viewport.worldWidth/viewport.worldHeight]; replaces left/right/top/bottom if set
         * @param {string} [options.underflow=center] (none OR (top/bottom/center and left/right/center) OR center) where to place world if too small for screen (e.g., top-right, center, none, bottomleft)
         * @return {Viewport} this
         */

    }, {
        key: 'clamp',
        value: function clamp(options) {
            this.plugins['clamp'] = new Clamp(this, options);
            this.pluginsSort();
            return this;
        }

        /**
         * decelerate after a move
         * @param {object} [options]
         * @param {number} [options.friction=0.95] percent to decelerate after movement
         * @param {number} [options.bounce=0.8] percent to decelerate when past boundaries (only applicable when viewport.bounce() is active)
         * @param {number} [options.minSpeed=0.01] minimum velocity before stopping/reversing acceleration
         * @return {Viewport} this
         */

    }, {
        key: 'decelerate',
        value: function decelerate(options) {
            this.plugins['decelerate'] = new Decelerate(this, options);
            this.pluginsSort();
            return this;
        }

        /**
         * bounce on borders
         * NOTE: screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
         * @param {object} [options]
         * @param {string} [options.sides=all] all, horizontal, vertical, or combination of top, bottom, right, left (e.g., 'top-bottom-right')
         * @param {number} [options.friction=0.5] friction to apply to decelerate if active
         * @param {number} [options.time=150] time in ms to finish bounce
         * @param {string|function} [options.ease=easeInOutSine] ease function or name (see http://easings.net/ for supported names)
         * @param {string} [options.underflow=center] (top/bottom/center and left/right/center, or center) where to place world if too small for screen
         * @return {Viewport} this
         */

    }, {
        key: 'bounce',
        value: function bounce(options) {
            this.plugins['bounce'] = new Bounce(this, options);
            this.pluginsSort();
            return this;
        }

        /**
         * enable pinch to zoom and two-finger touch to drag
         * NOTE: screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
         * @param {number} [options.percent=1.0] percent to modify pinch speed
         * @param {boolean} [options.noDrag] disable two-finger dragging
         * @param {PIXI.Point} [options.center] place this point at center during zoom instead of center of two fingers
         * @return {Viewport} this
         */

    }, {
        key: 'pinch',
        value: function pinch(options) {
            this.plugins['pinch'] = new Pinch(this, options);
            this.pluginsSort();
            return this;
        }

        /**
         * snap to a point
         * @param {number} x
         * @param {number} y
         * @param {object} [options]
         * @param {boolean} [options.topLeft] snap to the top-left of viewport instead of center
         * @param {number} [options.friction=0.8] friction/frame to apply if decelerate is active
         * @param {number} [options.time=1000]
         * @param {string|function} [options.ease=easeInOutSine] ease function or name (see http://easings.net/ for supported names)
         * @param {boolean} [options.interrupt=true] pause snapping with any user input on the viewport
         * @param {boolean} [options.removeOnComplete] removes this plugin after snapping is complete
         * @param {boolean} [options.removeOnInterrupt] removes this plugin if interrupted by any user input
         * @param {boolean} [options.forceStart] starts the snap immediately regardless of whether the viewport is at the desired location
         * @return {Viewport} this
         */

    }, {
        key: 'snap',
        value: function snap(x, y, options) {
            this.plugins['snap'] = new Snap(this, x, y, options);
            this.pluginsSort();
            return this;
        }

        /**
         * follow a target
         * NOTES:
         *    - uses the (x, y) as the center to follow; for PIXI.Sprite to work properly, use sprite.anchor.set(0.5)
         *    - options.acceleration is not perfect as it doesn't know the velocity of the target;
         *      it does add acceleration to the start of movement and deceleration to the end of movement when the target is stopped
         * @param {PIXI.DisplayObject} target to follow (object must include {x: x-coordinate, y: y-coordinate})
         * @param {object} [options]
         * @param {number} [options.speed=0] to follow in pixels/frame (0=teleport to location)
         * @param {number} [options.acceleration] set acceleration to accelerate and decelerate at this rate; speed cannot be 0 to use acceleration
         * @param {number} [options.radius] radius (in world coordinates) of center circle where movement is allowed without moving the viewport
         * @return {Viewport} this
         */

    }, {
        key: 'follow',
        value: function follow(target, options) {
            this.plugins['follow'] = new Follow(this, target, options);
            this.pluginsSort();
            return this;
        }

        /**
         * zoom using mouse wheel
         * @param {object} [options]
         * @param {number} [options.percent=0.1] percent to scroll with each spin
         * @param {boolean} [options.reverse] reverse the direction of the scroll
         * @param {PIXI.Point} [options.center] place this point at center during zoom instead of current mouse position
         * @return {Viewport} this
         */

    }, {
        key: 'wheel',
        value: function wheel(options) {
            this.plugins['wheel'] = new Wheel(this, options);
            this.pluginsSort();
            return this;
        }

        /**
         * enable clamping of zoom to constraints
         * NOTE: screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
         * @param {object} [options]
         * @param {number} [options.minWidth] minimum width
         * @param {number} [options.minHeight] minimum height
         * @param {number} [options.maxWidth] maximum width
         * @param {number} [options.maxHeight] maximum height
         * @return {Viewport} this
         */

    }, {
        key: 'clampZoom',
        value: function clampZoom(options) {
            this.plugins['clamp-zoom'] = new ClampZoom(this, options);
            this.pluginsSort();
            return this;
        }

        /**
         * Scroll viewport when mouse hovers near one of the edges or radius-distance from center of screen.
         * @param {object} [options]
         * @param {number} [options.radius] distance from center of screen in screen pixels
         * @param {number} [options.distance] distance from all sides in screen pixels
         * @param {number} [options.top] alternatively, set top distance (leave unset for no top scroll)
         * @param {number} [options.bottom] alternatively, set bottom distance (leave unset for no bottom scroll)
         * @param {number} [options.left] alternatively, set left distance (leave unset for no left scroll)
         * @param {number} [options.right] alternatively, set right distance (leave unset for no right scroll)
         * @param {number} [options.speed=8] speed in pixels/frame to scroll viewport
         * @param {boolean} [options.reverse] reverse direction of scroll
         * @param {boolean} [options.noDecelerate] don't use decelerate plugin even if it's installed
         * @param {boolean} [options.linear] if using radius, use linear movement (+/- 1, +/- 1) instead of angled movement (Math.cos(angle from center), Math.sin(angle from center))
         * @param {boolean} [options.allowButtons] allows plugin to continue working even when there's a mousedown event
         */

    }, {
        key: 'mouseEdges',
        value: function mouseEdges(options) {
            this.plugins['mouse-edges'] = new MouseEdges(this, options);
            this.pluginsSort();
            return this;
        }

        /**
         * pause viewport (including animation updates such as decelerate)
         * NOTE: when setting pause=true, all touches and mouse actions are cleared (i.e., if mousedown was active, it becomes inactive for purposes of the viewport)
         * @type {boolean}
         */

    }, {
        key: 'ensureVisible',

        /**
         * move the viewport so the bounding box is visible
         * @param {number} x
         * @param {number} y
         * @param {number} width
         * @param {number} height
         */
        value: function ensureVisible(x, y, width, height) {
            if (x < this.left) {
                this.left = x;
            } else if (x + width > this.right) {
                this.right = x + width;
            }
            if (y < this.top) {
                this.top = y;
            } else if (y + height > this.bottom) {
                this.bottom = y + height;
            }
        }
    }, {
        key: 'screenWidth',
        get: function get() {
            return this._screenWidth;
        },
        set: function set(value) {
            this._screenWidth = value;
        }

        /**
         * screen height in screen pixels
         * @type {number}
         */

    }, {
        key: 'screenHeight',
        get: function get() {
            return this._screenHeight;
        },
        set: function set(value) {
            this._screenHeight = value;
        }

        /**
         * world width in pixels
         * @type {number}
         */

    }, {
        key: 'worldWidth',
        get: function get() {
            if (this._worldWidth) {
                return this._worldWidth;
            } else {
                return this.width;
            }
        },
        set: function set(value) {
            this._worldWidth = value;
            this.resizePlugins();
        }

        /**
         * world height in pixels
         * @type {number}
         */

    }, {
        key: 'worldHeight',
        get: function get() {
            if (this._worldHeight) {
                return this._worldHeight;
            } else {
                return this.height;
            }
        },
        set: function set(value) {
            this._worldHeight = value;
            this.resizePlugins();
        }
    }, {
        key: 'worldScreenWidth',
        get: function get() {
            return this.screenWidth / this.scale.x;
        }

        /**
         * screen height in world coordinates
         * @type {number}
         * @readonly
         */

    }, {
        key: 'worldScreenHeight',
        get: function get() {
            return this.screenHeight / this.scale.y;
        }

        /**
         * world width in screen coordinates
         * @type {number}
         * @readonly
         */

    }, {
        key: 'screenWorldWidth',
        get: function get() {
            return this.worldWidth * this.scale.x;
        }

        /**
         * world height in screen coordinates
         * @type {number}
         * @readonly
         */

    }, {
        key: 'screenWorldHeight',
        get: function get() {
            return this.worldHeight * this.scale.y;
        }

        /**
         * get center of screen in world coordinates
         * @type {PIXI.Point}
         */

    }, {
        key: 'center',
        get: function get() {
            return new PIXI.Point(this.worldScreenWidth / 2 - this.x / this.scale.x, this.worldScreenHeight / 2 - this.y / this.scale.y);
        },
        set: function set(value) {
            this.moveCenter(value);
        }
    }, {
        key: 'corner',
        get: function get() {
            return new PIXI.Point(-this.x / this.scale.x, -this.y / this.scale.y);
        },
        set: function set(value) {
            this.moveCorner(value);
        }
    }, {
        key: 'right',
        get: function get() {
            return -this.x / this.scale.x + this.worldScreenWidth;
        },
        set: function set(value) {
            this.x = -value * this.scale.x + this.screenWidth;
            this._reset();
        }

        /**
         * world coordinates of the left edge of the screen
         * @type {number}
         */

    }, {
        key: 'left',
        get: function get() {
            return -this.x / this.scale.x;
        },
        set: function set(value) {
            this.x = -value * this.scale.x;
            this._reset();
        }

        /**
         * world coordinates of the top edge of the screen
         * @type {number}
         */

    }, {
        key: 'top',
        get: function get() {
            return -this.y / this.scale.y;
        },
        set: function set(value) {
            this.y = -value * this.scale.y;
            this._reset();
        }

        /**
         * world coordinates of the bottom edge of the screen
         * @type {number}
         */

    }, {
        key: 'bottom',
        get: function get() {
            return -this.y / this.scale.y + this.worldScreenHeight;
        },
        set: function set(value) {
            this.y = -value * this.scale.y + this.screenHeight;
            this._reset();
        }
        /**
         * determines whether the viewport is dirty (i.e., needs to be renderered to the screen because of a change)
         * @type {boolean}
         */

    }, {
        key: 'dirty',
        get: function get() {
            return this._dirty;
        },
        set: function set(value) {
            this._dirty = value;
        }

        /**
         * permanently changes the Viewport's hitArea
         * NOTE: normally the hitArea = PIXI.Rectangle(Viewport.left, Viewport.top, Viewport.worldScreenWidth, Viewport.worldScreenHeight)
         * @type {(PIXI.Rectangle|PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.RoundedRectangle)}
         */

    }, {
        key: 'forceHitArea',
        get: function get() {
            return this._forceHitArea;
        },
        set: function set(value) {
            if (value) {
                this._forceHitArea = value;
                this.hitArea = value;
            } else {
                this._forceHitArea = false;
                this.hitArea = new PIXI.Rectangle(0, 0, this.worldWidth, this.worldHeight);
            }
        }
    }, {
        key: 'pause',
        get: function get() {
            return this._pause;
        },
        set: function set(value) {
            this._pause = value;
            this.lastViewport = null;
            this.moving = false;
            this.zooming = false;
            if (value) {
                this.touches = [];
                this.isMouseDown = false;
            }
        }
    }]);

    return Viewport;
}(PIXI.Container);

/**
 * fires after a mouse or touch click
 * @event Viewport#clicked
 * @type {object}
 * @property {PIXI.Point} screen
 * @property {PIXI.Point} world
 * @property {Viewport} viewport
 */

/**
 * fires when a drag starts
 * @event Viewport#drag-start
 * @type {object}
 * @property {PIXI.Point} screen
 * @property {PIXI.Point} world
 * @property {Viewport} viewport
 */

/**
 * fires when a drag ends
 * @event Viewport#drag-end
 * @type {object}
 * @property {PIXI.Point} screen
 * @property {PIXI.Point} world
 * @property {Viewport} viewport
 */

/**
 * fires when a pinch starts
 * @event Viewport#pinch-start
 * @type {Viewport}
 */

/**
 * fires when a pinch end
 * @event Viewport#pinch-end
 * @type {Viewport}
 */

/**
 * fires when a snap starts
 * @event Viewport#snap-start
 * @type {Viewport}
 */

/**
 * fires when a snap ends
 * @event Viewport#snap-end
 * @type {Viewport}
 */

/**
 * fires when a snap-zoom starts
 * @event Viewport#snap-zoom-start
 * @type {Viewport}
 */

/**
 * fires when a snap-zoom ends
 * @event Viewport#snap-zoom-end
 * @type {Viewport}
 */

/**
 * fires when a bounce starts in the x direction
 * @event Viewport#bounce-x-start
 * @type {Viewport}
 */

/**
 * fires when a bounce ends in the x direction
 * @event Viewport#bounce-x-end
 * @type {Viewport}
 */

/**
 * fires when a bounce starts in the y direction
 * @event Viewport#bounce-y-start
 * @type {Viewport}
 */

/**
 * fires when a bounce ends in the y direction
 * @event Viewport#bounce-y-end
 * @type {Viewport}
 */

/**
 * fires when for a mouse wheel event
 * @event Viewport#wheel
 * @type {object}
 * @property {object} wheel
 * @property {number} wheel.dx
 * @property {number} wheel.dy
 * @property {number} wheel.dz
 * @property {Viewport} viewport
 */

/**
 * fires when a wheel-scroll occurs
 * @event Viewport#wheel-scroll
 * @type {Viewport}
 */

/**
 * fires when a mouse-edge starts to scroll
 * @event Viewport#mouse-edge-start
 * @type {Viewport}
 */

/**
 * fires when the mouse-edge scrolling ends
 * @event Viewport#mouse-edge-end
 * @type {Viewport}
 */

/**
 * fires when viewport moves through UI interaction, deceleration, or follow
 * @event Viewport#moved
 * @type {object}
 * @property {Viewport} viewport
 * @property {string} type (drag, snap, pinch, follow, bounce-x, bounce-y, clamp-x, clamp-y, decelerate, mouse-edges, wheel)
 */

/**
 * fires when viewport moves through UI interaction, deceleration, or follow
 * @event Viewport#zoomed
 * @type {object}
 * @property {Viewport} viewport
 * @property {string} type (drag-zoom, pinch, wheel, clamp-zoom)
 */

/**
 * fires when viewport stops moving for any reason
 * @event Viewport#moved-end
 * @type {Viewport}
 */

/**
 * fires when viewport stops zooming for any rason
 * @event Viewport#zoomed-end
 * @type {Viewport}
 */

if (typeof PIXI !== 'undefined') {
    if (PIXI.extras) {
        PIXI.extras.Viewport = Viewport;
    } else {
        PIXI.extras = { Viewport: Viewport };
    }
}

module.exports = Viewport;

/***/ }),

/***/ "YdsM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function () {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/***/ }),

/***/ "Yp9R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("Ywoo");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classNames = __webpack_require__("ESgF");

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__("SdFt");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;

      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement('div', { className: className || classNames.navBar }, dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]);
    }
  }]);

  return Navbar;
}(_react.Component);

Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;
Navbar.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    navBar: _propTypes2.default.string.isRequired,
    navButtonPrev: _propTypes2.default.string.isRequired,
    navButtonNext: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  showPreviousButton: _propTypes2.default.bool,
  showNextButton: _propTypes2.default.bool,
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  dir: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    previousMonth: _propTypes2.default.string.isRequired,
    nextMonth: _propTypes2.default.string.isRequired
  })
} : {};
//# sourceMappingURL=Navbar.js.map

/***/ }),

/***/ "Ys9y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("aSYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ErrorTracking__ = __webpack_require__("QyN2");



var GoogleTagManagerService = {
  ticketsAdded: function ticketsAdded(event, order) {
    try {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "TicketsAdded",
          currency: Object(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])("CURRENCY"),
          totalTickets: order.tickets.length
        });
      }
    } catch (e) {
      __WEBPACK_IMPORTED_MODULE_1__utils_ErrorTracking__["default"].track(e);
    }
  },
  enteredDetails: function enteredDetails(event, order) {
    try {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "EnteredDetails",
          value: order.totals.total,
          currency: Object(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])("CURRENCY"),
          totalTickets: order.tickets ? order.tickets.length : 0
        });
      }
    } catch (e) {
      __WEBPACK_IMPORTED_MODULE_1__utils_ErrorTracking__["default"].track(e);
    }
  },
  checkout: function checkout(event, order) {},
  complete: function complete(event, order) {
    try {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "Purchase",
          value: order.totals.total,
          currency: Object(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])("CURRENCY"),
          totalTickets: order.tickets.length
        });
      }
    } catch (e) {
      __WEBPACK_IMPORTED_MODULE_1__utils_ErrorTracking__["default"].track(e);
    }
  },
  pageViewCustom: function pageViewCustom(title) {
    try {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "Pageview",
          pagePath: window.location.href,
          pageTitle: title
        });
      }
    } catch (err) {
      __WEBPACK_IMPORTED_MODULE_1__utils_ErrorTracking__["default"].track(e);
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (GoogleTagManagerService);

/***/ }),

/***/ "Ywoo":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("MOCJ")();
}

/***/ }),

/***/ "ZZUN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("jYI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_actions_orderActions__ = __webpack_require__("J21P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("aSYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__("kfMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__("PabG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_emotion__ = __webpack_require__("mibh");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var modalContent = Object(__WEBPACK_IMPORTED_MODULE_7_emotion__["css"])({
  textAlign: "center",
  paddingTop: 28,
  maxWidth: 400,
  width: "calc(100vw - 78px)",
  margin: "0 auto",
  h3: {
    marginBottom: 6
  },
  p: {
    marginBottom: 40
  },
  button: {
    height: 40
  }
});

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h3",
  null,
  "Your checkout time has expired"
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "p",
  null,
  "The tickets have now been released."
);

var CountDown = function (_Component) {
  _inherits(CountDown, _Component);

  function CountDown() {
    _classCallCheck(this, CountDown);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getOrderTime = function () {
      var _this$props = _this.props,
          event = _this$props.event,
          isGlobal = _this$props.isGlobal;

      var ORDER_COMPLETE_TIME = !isGlobal && event.data.settings.customTimeout ? event.data.settings.customTimeout : Object(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */])("ORDER_COMPLETE_TIME");
      return ORDER_COMPLETE_TIME;
    };

    _this.state = {
      timeLeft: "19:59"
    };
    return _this;
  }

  CountDown.prototype.componentWillMount = function componentWillMount() {
    var ORDER_COMPLETE_TIME = this.getOrderTime();
    var startMin = ORDER_COMPLETE_TIME - 1;
    this.setState({
      timeLeft: startMin + ":59"
    });
  };

  CountDown.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var order = this.props.order;

    if (!order || !order.data || !order.data.createdAt) {
      return;
    }
    this.updateInterval = setInterval(function () {
      _this2.updateCountdown();
    }, 1000);
    this.updateCountdown();
  };

  CountDown.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.updateInterval) {
      return;
    }
    clearInterval(this.updateInterval);
  };

  CountDown.prototype.pad2 = function pad2(number) {
    return (number < 10 ? "0" : "") + number;
  };

  CountDown.prototype.updateCountdown = function updateCountdown() {
    var _props = this.props,
        order = _props.order,
        timeExpired = _props.timeExpired;

    var ORDER_COMPLETE_TIME = this.getOrderTime();
    var startMin = ORDER_COMPLETE_TIME - 1;
    if (!order || !order.data) {
      return;
    }
    var createdDate = new Date(order.data.createdAt);
    var now = new Date();
    var diff = (now - createdDate) / 1000;
    var minutes = Math.floor(diff / 60) % 60;
    var diffLeft = diff - minutes * 60;
    var seconds = Math.floor(diffLeft % 60);
    var display = startMin - minutes + ":" + this.pad2(59 - seconds);
    if (diff > ORDER_COMPLETE_TIME * 60) {
      timeExpired();
      clearInterval(this.updateInterval);
      this.setState({ timeLeft: "0:00" });
      return;
    }
    this.setState({ timeLeft: display });
  };

  CountDown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!prevProps.order.timeExpired && this.props.order.timeExpired) {
      try {
        document.getElementById("reorderButton").focus();
      } catch (err) {}
    }
  };

  CountDown.prototype.getRestartUrl = function getRestartUrl() {
    var _props2 = this.props,
        isGlobal = _props2.isGlobal,
        event = _props2.event,
        giftCards = _props2.giftCards;

    if (isGlobal) {
      var giftCardPage = giftCards.giftCardPage;

      return "/gift-cards/" + giftCardPage.slug;
    } else {
      return "/" + event.data.slug + "/tickets";
    }
  };

  CountDown.prototype.render = function render(_ref) {
    var _this3 = this;

    var order = _ref.order,
        margin = _ref.margin;
    var timeLeft = this.state.timeLeft;

    var color = "#f6eecd";
    var background = "#fff9e1";
    var style = {
      transition: "all 0.5s ease",
      background: "" + background,
      margin: margin ? margin : "0 0 12px 0",
      border: "1px solid " + color,
      borderRadius: 4,
      display: "block",
      textAlign: "center",
      padding: 8
    };
    var messageStyle = {
      margin: 0,
      fontSize: 14
    };
    if (!order || !order.data || !order.data.createdAt) {
      return "";
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      { style: style },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */],
        {
          showModal: order.timeExpired,
          closeHandler: function closeHandler() {
            return window.location.href = _this3.getRestartUrl();
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "div",
          { className: modalContent },
          _ref2,
          _ref3,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */],
            {
              onClick: function onClick() {
                return window.location.href = _this3.getRestartUrl();
              },
              type: "primary"
            },
            "Reorder"
          )
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "p",
        { style: messageStyle },
        "Checkout time left: ",
        timeLeft
      )
    );
  };

  return CountDown;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    order: state.order,
    event: state.event,
    giftCards: state.giftCards
  };
}, { timeExpired: __WEBPACK_IMPORTED_MODULE_2__state_actions_orderActions__["_4" /* timeExpired */] })(CountDown));

/***/ }),

/***/ "ZcPk":
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}

/***/ }),

/***/ "ZeD7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),

/***/ "ZfHd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var SAT = __webpack_require__("MWLY");
var Config_1 = __webpack_require__("gH/r");
var InteractionManager_1 = __webpack_require__("dUAP");
var SelectionListener_1 = __webpack_require__("//Eg");
var Selector_1 = __webpack_require__("8Y7Z");
var Utils_1 = __webpack_require__("o6Mn");
var Table_1 = __webpack_require__("5i8b");
var Rows_1 = __webpack_require__("O/+F");
var MoveableObject_1 = __webpack_require__("eqVo");
var bound_1 = __webpack_require__("USDo");
var ActionTracker_1 = __webpack_require__("h0Oq");
var hull = __webpack_require__("rWY2");
var events = {
    onSeatClicked: function onSeatClicked() {
        return console.log("onSeatClicked not implemented");
    },
    onTableClicked: function onTableClicked() {
        return console.log("onTableClicked not implemented");
    }
};

var Section = function (_MoveableObject_1$def) {
    _inherits(Section, _MoveableObject_1$def);

    function Section(_ref, actions) {
        var _id = _ref._id,
            pos = _ref.pos,
            name = _ref.name,
            sectionId = _ref.sectionId,
            tables = _ref.tables,
            ticketIds = _ref.ticketIds,
            showSection = _ref.showSection,
            bookByTable = _ref.bookByTable;

        _classCallCheck(this, Section);

        var _this = _possibleConstructorReturn(this, _MoveableObject_1$def.call(this, _id, actions));

        _this.setLabel = _this.setName;
        _this.concavitivity = 100;
        _this.showSection = showSection;
        _this.bookByTable = bookByTable;
        var _this$actions = _this.actions,
            onSeatClicked = _this$actions.onSeatClicked,
            onSectionClicked = _this$actions.onSectionClicked,
            onElementClicked = _this$actions.onElementClicked;

        _this.name = name || "Section " + String.fromCharCode(65 + sectionId);
        _this.label = _this.name;
        _this.sectionId = sectionId;
        _this.basicType = "section";
        _this.update = true;
        _this.ticketIds = ticketIds || [];
        _this.graphics = new PIXI.Graphics();
        _this.graphics.interactive = true;
        _this.bounds = new PIXI.Rectangle();
        _this.onSeatClicked = function (seatId, tableId) {
            onSeatClicked(seatId, tableId, _this.sectionId);
        };
        _this.onSectionClicked = onSectionClicked;
        _this.onEleClicked = onElementClicked;
        _this.interactionManager = InteractionManager_1.default.createInteractionManager();
        _this.moveableContainer = new PIXI.Container();
        new SelectionListener_1.default(_this.graphics, _this, _this.onClick);
        _this.moveableContainer.position = pos ? pos : { x: 0, y: 0 };
        _this.addActions(_this.actions);
        _this.setSectionLabel();
        _this.tables = tables.map(function (table, i) {
            table.tableId = i;
            table.sectionId = _this.sectionId;
            var newTable = _this.determineTable(table, _this.actions);
            newTable.draw();
            return newTable;
        });
        _this.selected = false;
        _this.moveableContainer.addChild(_this.graphics);
        _this.tables.forEach(function (table) {
            return _this.moveableContainer.addChild(table.getTableContainer());
        });
        _this.tables.forEach(function (table) {
            return table.setContainerOffset(_this.moveableContainer.position.x, _this.moveableContainer.position.y);
        });
        _this.updateBounds();
        return _this;
    }

    Section.prototype.determineTable = function determineTable(table, actions) {
        switch (table.type) {
            case "circle":
                return new Table_1.default(table, actions);
            case "row":
                return new Rows_1.default(table, actions);
        }
    };

    Section.prototype.setBookByTable = function setBookByTable(bookByTable) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setBookByTable", this.setBookByTable, [this.bookByTable]);
        this.bookByTable = bookByTable;
        this.ticketIds = [];
        this.tables.forEach(function (table) {
            table.setBookByTable(bookByTable);
        });
        if (this.packageTicketChangeCb) {
            this.packageTicketChangeCb();
        }
        this.onChange();
        return undoValue;
    };

    Section.prototype.onSelect = function onSelect() {
        this.selected = true;
        this.drawBounds();
    };

    Section.prototype.onDeselect = function onDeselect() {
        this.selected = false;
        this.drawBounds();
    };

    Section.prototype.setSectionVisible = function setSectionVisible(showSection) {
        this.showSection = showSection;
        this.updateBounds();
    };

    Section.prototype.setName = function setName(name) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setLabel", this.setLabel, [this.name]);
        this.name = name;
        this.label = this.name;
        this.rename();
        this.onChange();
        return undoValue;
    };

    Section.prototype.rename = function rename() {
        if (this.renameCb) {
            this.renameCb();
        }
        this.text.text = this.name;
    };

    Section.prototype.onRename = function onRename(cb) {
        this.renameCb = cb;
    };

    Section.prototype.onPackageTicketChange = function onPackageTicketChange(cb) {
        this.packageTicketChangeCb = cb;
    };

    Section.prototype.onClick = function onClick() {
        this.onSectionClicked({ sectionId: this.sectionId, name: this.name, type: "section" });
        this.interactionManager.itemSelected(this);
    };

    Section.prototype.assignTicketType = function assignTicketType(ticketId) {
        this.ticketIds.push(ticketId);
        this.tables.forEach(function (table) {
            return table.assignTicketType(ticketId);
        });
        this.onChange();
        return ActionTracker_1.default.constructUndoValue("assignTicketType", this.removeTicketType, [ticketId]);
    };

    Section.prototype.removeTicketType = function removeTicketType(ticketId) {
        var index = this.ticketIds.indexOf(ticketId);
        if (index > -1) {
            this.ticketIds.splice(index, 1);
        }
        this.tables.forEach(function (table) {
            return table.removeTicketType(ticketId);
        });
        this.onChange();
        return ActionTracker_1.default.constructUndoValue("removeTicketType", this.assignTicketType, [ticketId]);
    };

    Section.prototype.setConcavitivity = function setConcavitivity(concavitivity) {
        this.concavitivity = concavitivity;
        this.updateBounds();
    };

    Section.prototype.toJSON = function toJSON() {
        return {
            _id: this._id,
            name: this.name,
            tables: this.tables.map(function (seat) {
                return seat.toJSON();
            }),
            pos: {
                x: this.moveableContainer.position.x,
                y: this.moveableContainer.position.y
            },
            sectionId: this.sectionId,
            ticketIds: this.ticketIds,
            bookByTable: this.bookByTable
        };
    };

    Section.prototype.setSectionLabel = function setSectionLabel() {
        this.text = new PIXI.Text(this.name, { fontFamily: Utils_1.font, fontSize: 12, fill: 0x0000, align: 'center' });
        this.text.texture.baseTexture.scaleMode = PIXI.SCALE_MODES.LINEAR;
        this.text.resolution = 2;
    };

    Section.prototype.move = function move(e) {
        var _this2 = this;

        _MoveableObject_1$def.prototype.move.call(this, e);
        this.outlinePoints = this.boundingPoints.map(function (point) {
            return new PIXI.Point(point.x + _this2.moveableContainer.position.x, point.y + _this2.moveableContainer.position.y);
        });
    };

    Section.prototype.drawSelectionBox = function drawSelectionBox() {
        Selector_1.drawPolySelectionBox(this.outlinePoints);
    };

    Section.prototype.getSelectionBoxBounds = function getSelectionBoxBounds() {
        return this.bounds;
    };

    Section.prototype.findTablesBoundBy = function findTablesBoundBy(p3, p4) {
        var selectedTables = [];
        var selectedPoints = [[p3.x, p3.y], [p3.x, p4.y], [p4.x, p4.y], [p4.x, p3.y]].map(function (point) {
            return new SAT.Vector(point[0], point[1]);
        });
        var selectedPolygon = new SAT.Polygon(new SAT.Vector(), selectedPoints);
        if (this.isContainedWithinSection(selectedPolygon)) {
            selectedTables = this.tables.map(function (table) {
                return table.boundBy(p3, p4);
            }).filter(function (table) {
                return table.isSelected;
            });
        }
        return selectedTables;
    };

    Section.prototype.positionContainedWithinSection = function positionContainedWithinSection(p1, p2) {
        var point1 = new SAT.Vector(p1.x, p1.y);
        var point2 = new SAT.Vector(p2.x, p2.y);
        var selectedPolygon = new SAT.Polygon(new SAT.Vector(), [point1, point2]);
        var result = null;
        if (this.isContainedWithinSection(selectedPolygon) || !this.showSection) {
            result = this.sectionId;
        }
        return result;
    };

    Section.prototype.isContainedWithinSection = function isContainedWithinSection(selectedPolygon) {
        this.boundingPolygon.setPoints(this.outlinePoints.map(function (point) {
            var x = point.x,
                y = point.y;

            return new SAT.Vector(x, y);
        }));
        return SAT.testPolygonPolygon(selectedPolygon, this.boundingPolygon);
    };

    Section.prototype.getBounds = function getBounds() {
        var newBounds = this.tables[0].getBounds();
        this.tables.forEach(function (table) {
            var _table$getBounds = table.getBounds(),
                top = _table$getBounds.top,
                bottom = _table$getBounds.bottom,
                left = _table$getBounds.left,
                right = _table$getBounds.right;

            if (newBounds.left > left) {
                newBounds.left = left;
            }
            if (newBounds.right < right) {
                newBounds.right = right;
            }
            if (newBounds.top > top) {
                newBounds.top = top;
            }
            if (newBounds.bottom < bottom) {
                newBounds.bottom = bottom;
            }
        });
        return newBounds;
    };

    Section.prototype.updateBounds = function updateBounds() {
        var _this3 = this;

        this.points = this.tables.map(function (table) {
            return table.getPoints();
        }).reduce(function (points, current) {
            return current.concat(points);
        }, []);
        this.outlinePoints = [];
        this.boundingPolyPoints = [];
        this.boundingPoints = [];
        var moveX = this.moveableContainer.position.x;
        var moveY = this.moveableContainer.position.y;
        hull(this.points, this.concavitivity).forEach(function (point) {
            if (point) {
                var x = point[0];
                var y = point[1];
                _this3.boundingPoints.push(new PIXI.Point(x, y));
                _this3.outlinePoints.push(new PIXI.Point(x + moveX, y + moveY));
                _this3.boundingPolyPoints.push(new SAT.Vector(x + moveX, y + moveY));
            }
        });
        this.boundingPolygon = new SAT.Polygon(new SAT.Vector(), this.boundingPolyPoints);
        if (this.showSection) {
            this.graphics.visible = true;
            this.drawBounds();
        } else {
            this.graphics.visible = false;
        }
    };

    Section.prototype.drawBounds = function drawBounds() {
        this.graphics.clear();
        this.graphics.beginFill(this.selected ? 0xFFFFFF : 0xE7F2FF, 0.8);
        this.graphics.drawPolygon(this.boundingPoints);
    };

    Section.prototype.addActions = function addActions(actions) {
        var _this4 = this;

        actions.onSeatClicked = this.onSeatClicked;
        actions.onTableMoved = this.onInternalTableMoved;
        this.onTableMoved = this.onInternalTableMoved;
        actions.getOffset = function () {
            return _this4.moveableContainer.position;
        };
    };

    Section.prototype.onInternalTableMoved = function onInternalTableMoved() {
        var _this5 = this;

        if (this.update) {
            this.update = false;
            this.updateBounds();
            setTimeout(function () {
                _this5.update = true;
            }, 100);
        }
    };

    Section.prototype.addTable = function addTable(tableData) {
        var calcNewPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (calcNewPos) {
            tableData.pos.x = this.bounds.x + this.bounds.width / 2;
            tableData.pos.y = this.bounds.y + this.bounds.height / 2;
        } else {
            var _Config_1$default$can = Config_1.default.canvasBounding,
                top = _Config_1$default$can.top,
                left = _Config_1$default$can.left;
            var _Config_1$default$vie = Config_1.default.viewport.transform,
                position = _Config_1$default$vie.position,
                scale = _Config_1$default$vie.scale;

            tableData.pos.x = (tableData.globalPos.x - position.x - left) / scale.x - this.moveableContainer.x;
            tableData.pos.y = (tableData.globalPos.y - position.y - top) / scale.y - this.moveableContainer.y;
        }
        tableData.tableId = this.tables.length;
        tableData.sectionId = this.sectionId;
        this.addActions(this.actions);
        var newTable = void 0;
        if (tableData.type === "row") {
            newTable = new Rows_1.default(tableData, this.actions);
        } else {
            newTable = new Table_1.default(tableData, this.actions);
        }
        newTable.draw();
        newTable.setContainerOffset(this.moveableContainer.position.x, this.moveableContainer.position.y);
        this.tables.push(newTable);
        this.moveableContainer.addChild(newTable.getTableContainer());
        this.updateBounds();
        return newTable;
    };

    Section.prototype.addSeats = function addSeats(tableId, seatData, amount) {
        this.tables[tableId].addSeats(seatData, amount);
        this.updateBounds();
    };

    Section.prototype.getTable = function getTable(tableId) {
        return this.tables[tableId];
    };

    Section.prototype.addTableReference = function addTableReference(table) {
        console.log("BEFORE", this.tables);
        this.tables.splice(table.getTableId(), 0, table);
        console.log("AFTER", this.tables);
        this.moveableContainer.addChildAt(table.getTableContainer(), table.getTableId() + 1);
    };

    Section.prototype.getSectionCapacity = function getSectionCapacity() {
        return this.tables.map(function (table) {
            return table.getTableCapacity();
        }).reduce(function (total, current) {
            return total + current;
        }, 0);
    };

    Section.prototype.setSectionId = function setSectionId(newSectionId) {
        this.sectionId = newSectionId;
    };

    Section.prototype.removeSeats = function removeSeats(tableId, amount) {
        this.tables[tableId].removeSeats(amount);
        this.updateBounds();
    };

    Section.prototype.countTicketMappings = function countTicketMappings() {
        var ticketMapping = this.tables.map(function (table) {
            return table.countTicketMappings();
        });
        return ticketMapping.reduce(function (total, ticketMapping) {
            for (var key in ticketMapping) {
                if (total[key]) {
                    total[key] = total[key] + ticketMapping[key];
                } else {
                    total[key] = ticketMapping[key];
                }
            }
            return total;
        }, {});
    };

    Section.prototype.removeTable = function removeTable(tableId) {
        var removedTable = this.tables.splice(tableId, 1)[0];
        ActionTracker_1.default.addUndoAction("deleteTable", ActionTracker_1.default.generateActionId(), [this.reAddTable], [[removedTable]]);
        this.moveableContainer.removeChildAt(tableId + 1);
        this.tables.forEach(function (table, i) {
            table.setId(i);
        });
        return removedTable;
    };

    Section.prototype.duplicateTable = function duplicateTable(tableId) {
        var table = JSON.parse(JSON.stringify(this.tables[tableId].toJSON()));
        table.tableId = this.tables.length;
        delete table.name;
        delete table.label;
        delete table._id;
        table.seats = table.seats.map(function (seat) {
            delete seat._id;
            return seat;
        });
        table.pos.x = table.pos.x + 20;
        table.pos.y = table.pos.y + 20;
        this.addActions(this.actions);
        var newTable = void 0;
        if (table.type === "row") {
            newTable = new Rows_1.default(table, this.actions);
        } else {
            newTable = new Table_1.default(table, this.actions);
        }
        newTable.draw();
        newTable.setContainerOffset(this.moveableContainer.position.x, this.moveableContainer.position.y);
        this.tables.push(newTable);
        this.moveableContainer.addChild(this.tables[this.tables.length - 1].getTableContainer());
        ActionTracker_1.default.addUndoAction("dupeTable", ActionTracker_1.default.generateActionId(), [this.reRemoveTable], [[table.tableId]]);
        return newTable;
    };

    Section.prototype.getSectionContainer = function getSectionContainer() {
        return this.moveableContainer;
    };

    Section.prototype.hideSection = function hideSection(hide) {
        if (hide === false) {
            this.graphics.visible = !hide && this.showSection;
        } else {
            this.graphics.visible = !hide;
        }
    };

    Section.prototype.toggleTicketTypeColors = function toggleTicketTypeColors(enable) {
        this.tables.forEach(function (table) {
            return table.toggleTicketTypeColors(enable);
        });
    };

    Section.prototype.reAddTable = function reAddTable(tableData) {
        var newTable = tableData;
        this.tables.splice(tableData.tableId, 0, newTable);
        this.tables.forEach(function (table, i) {
            table.setId(i);
        });
        this.moveableContainer.addChildAt(newTable.getTableContainer(), tableData.tableId + 1);
        return { functionCall: this.reRemoveTable, params: [tableData.tableId] };
    };

    Section.prototype.reRemoveTable = function reRemoveTable(tableId) {
        var removedTable = this.tables.splice(tableId, 1)[0];
        this.moveableContainer.removeChildAt(tableId + 1);
        this.tables.forEach(function (table, i) {
            table.setId(i);
        });
        return { functionCall: this.reAddTable, params: [removedTable] };
    };

    return Section;
}(MoveableObject_1.default);

__decorate([bound_1.default], Section.prototype, "determineTable", null);
__decorate([bound_1.default], Section.prototype, "setBookByTable", null);
__decorate([bound_1.default], Section.prototype, "onSelect", null);
__decorate([bound_1.default], Section.prototype, "onDeselect", null);
__decorate([bound_1.default], Section.prototype, "setSectionVisible", null);
__decorate([bound_1.default], Section.prototype, "setName", null);
__decorate([bound_1.default], Section.prototype, "rename", null);
__decorate([bound_1.default], Section.prototype, "onRename", null);
__decorate([bound_1.default], Section.prototype, "onPackageTicketChange", null);
__decorate([bound_1.default], Section.prototype, "onClick", null);
__decorate([bound_1.default], Section.prototype, "assignTicketType", null);
__decorate([bound_1.default], Section.prototype, "removeTicketType", null);
__decorate([bound_1.default], Section.prototype, "setConcavitivity", null);
__decorate([bound_1.default], Section.prototype, "toJSON", null);
__decorate([bound_1.default], Section.prototype, "setSectionLabel", null);
__decorate([bound_1.default], Section.prototype, "move", null);
__decorate([bound_1.default], Section.prototype, "drawSelectionBox", null);
__decorate([bound_1.default], Section.prototype, "getSelectionBoxBounds", null);
__decorate([bound_1.default], Section.prototype, "findTablesBoundBy", null);
__decorate([bound_1.default], Section.prototype, "positionContainedWithinSection", null);
__decorate([bound_1.default], Section.prototype, "isContainedWithinSection", null);
__decorate([bound_1.default], Section.prototype, "getBounds", null);
__decorate([bound_1.default], Section.prototype, "updateBounds", null);
__decorate([bound_1.default], Section.prototype, "drawBounds", null);
__decorate([bound_1.default], Section.prototype, "addActions", null);
__decorate([bound_1.default], Section.prototype, "onInternalTableMoved", null);
__decorate([bound_1.default], Section.prototype, "addTable", null);
__decorate([bound_1.default], Section.prototype, "addSeats", null);
__decorate([bound_1.default], Section.prototype, "getTable", null);
__decorate([bound_1.default], Section.prototype, "addTableReference", null);
__decorate([bound_1.default], Section.prototype, "getSectionCapacity", null);
__decorate([bound_1.default], Section.prototype, "setSectionId", null);
__decorate([bound_1.default], Section.prototype, "removeSeats", null);
__decorate([bound_1.default], Section.prototype, "countTicketMappings", null);
__decorate([bound_1.default], Section.prototype, "removeTable", null);
__decorate([bound_1.default], Section.prototype, "duplicateTable", null);
__decorate([bound_1.default], Section.prototype, "getSectionContainer", null);
__decorate([bound_1.default], Section.prototype, "hideSection", null);
__decorate([bound_1.default], Section.prototype, "toggleTicketTypeColors", null);
__decorate([bound_1.default], Section.prototype, "reAddTable", null);
__decorate([bound_1.default], Section.prototype, "reRemoveTable", null);
exports.default = Section;
//# sourceMappingURL=Section.js.map

/***/ }),

/***/ "ZoQM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c8a1f885d34692a685522589c811c836.svg";

/***/ }),

/***/ "ZtmO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("58Ti");
var ES = __webpack_require__("SIdQ");
var replace = bind.call(Function.call, String.prototype.replace);

var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;

module.exports = function trim() {
	var S = ES.ToString(ES.CheckObjectCoercible(this));
	return replace(replace(S, leftWhitespace, ''), rightWhitespace, '');
};

/***/ }),

/***/ "Zx84":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _generateBlurVertSource = __webpack_require__("Ga9O");

var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);

var _generateBlurFragSource = __webpack_require__("z7q+");

var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);

var _getMaxBlurKernelSize = __webpack_require__("39pn");

var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The BlurXFilter applies a horizontal Gaussian blur to an object.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var BlurXFilter = function (_core$Filter) {
    _inherits(BlurXFilter, _core$Filter);

    /**
     * @param {number} strength - The strength of the blur filter.
     * @param {number} quality - The quality of the blur filter.
     * @param {number} resolution - The resolution of the blur filter.
     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
     */
    function BlurXFilter(strength, quality, resolution, kernelSize) {
        _classCallCheck(this, BlurXFilter);

        kernelSize = kernelSize || 5;
        var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
        var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        vertSrc,
        // fragment shader
        fragSrc));

        _this.resolution = resolution || core.settings.RESOLUTION;

        _this._quality = 0;

        _this.quality = quality || 4;
        _this.strength = strength || 8;

        _this.firstRun = true;
        return _this;
    }

    /**
     * Applies the filter.
     *
     * @param {PIXI.FilterManager} filterManager - The manager.
     * @param {PIXI.RenderTarget} input - The input target.
     * @param {PIXI.RenderTarget} output - The output target.
     * @param {boolean} clear - Should the output be cleared before rendering?
     */

    BlurXFilter.prototype.apply = function apply(filterManager, input, output, clear) {
        if (this.firstRun) {
            var gl = filterManager.renderer.gl;
            var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);

            this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
            this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);

            this.firstRun = false;
        }

        this.uniforms.strength = 1 / output.size.width * (output.size.width / input.size.width);

        // screen space!
        this.uniforms.strength *= this.strength;
        this.uniforms.strength /= this.passes; // / this.passes//Math.pow(1, this.passes);

        if (this.passes === 1) {
            filterManager.applyFilter(this, input, output, clear);
        } else {
            var renderTarget = filterManager.getRenderTarget(true);
            var flip = input;
            var flop = renderTarget;

            for (var i = 0; i < this.passes - 1; i++) {
                filterManager.applyFilter(this, flip, flop, true);

                var temp = flop;

                flop = flip;
                flip = temp;
            }

            filterManager.applyFilter(this, flip, output, clear);

            filterManager.returnRenderTarget(renderTarget);
        }
    };

    /**
     * Sets the strength of both the blur.
     *
     * @member {number}
     * @default 16
     */

    _createClass(BlurXFilter, [{
        key: 'blur',
        get: function get() {
            return this.strength;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.padding = Math.abs(value) * 2;
            this.strength = value;
        }

        /**
        * Sets the quality of the blur by modifying the number of passes. More passes means higher
        * quaility bluring but the lower the performance.
        *
        * @member {number}
        * @default 4
        */

    }, {
        key: 'quality',
        get: function get() {
            return this._quality;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._quality = value;
            this.passes = value;
        }
    }]);

    return BlurXFilter;
}(core.Filter);

exports.default = BlurXFilter;
//# sourceMappingURL=BlurXFilter.js.map

/***/ }),

/***/ "a2Uu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),

/***/ "aBLe":
/***/ (function(module, exports) {

var EMPTY_ARRAY_BUFFER = new ArrayBuffer(0);

/**
 * Helper class to create a webGL buffer
 *
 * @class
 * @memberof PIXI.glCore
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param type {gl.ARRAY_BUFFER | gl.ELEMENT_ARRAY_BUFFER} @mat
 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
 * @param drawType {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
 */
var Buffer = function Buffer(gl, type, data, drawType) {

  /**
      * The current WebGL rendering context
      *
      * @member {WebGLRenderingContext}
      */
  this.gl = gl;

  /**
      * The WebGL buffer, created upon instantiation
      *
      * @member {WebGLBuffer}
      */
  this.buffer = gl.createBuffer();

  /**
      * The type of the buffer
      *
      * @member {gl.ARRAY_BUFFER|gl.ELEMENT_ARRAY_BUFFER}
      */
  this.type = type || gl.ARRAY_BUFFER;

  /**
      * The draw type of the buffer
      *
      * @member {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
      */
  this.drawType = drawType || gl.STATIC_DRAW;

  /**
      * The data in the buffer, as a typed array
      *
      * @member {ArrayBuffer| SharedArrayBuffer|ArrayBufferView}
      */
  this.data = EMPTY_ARRAY_BUFFER;

  if (data) {
    this.upload(data);
  }

  this._updateID = 0;
};

/**
 * Uploads the buffer to the GPU
 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data to upload
 * @param offset {Number} if only a subset of the data should be uploaded, this is the amount of data to subtract
 * @param dontBind {Boolean} whether to bind the buffer before uploading it
 */
Buffer.prototype.upload = function (data, offset, dontBind) {
  // todo - needed?
  if (!dontBind) this.bind();

  var gl = this.gl;

  data = data || this.data;
  offset = offset || 0;

  if (this.data.byteLength >= data.byteLength) {
    gl.bufferSubData(this.type, offset, data);
  } else {
    gl.bufferData(this.type, data, this.drawType);
  }

  this.data = data;
};
/**
 * Binds the buffer
 *
 */
Buffer.prototype.bind = function () {
  var gl = this.gl;
  gl.bindBuffer(this.type, this.buffer);
};

Buffer.createVertexBuffer = function (gl, data, drawType) {
  return new Buffer(gl, gl.ARRAY_BUFFER, data, drawType);
};

Buffer.createIndexBuffer = function (gl, data, drawType) {
  return new Buffer(gl, gl.ELEMENT_ARRAY_BUFFER, data, drawType);
};

Buffer.create = function (gl, type, data, drawType) {
  return new Buffer(gl, type, data, drawType);
};

/**
 * Destroys the buffer
 *
 */
Buffer.prototype.destroy = function () {
  this.gl.deleteBuffer(this.buffer);
};

module.exports = Buffer;

/***/ }),

/***/ "aG0R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * The Point object represents a location in a two-dimensional coordinate system, where x represents
 * the horizontal axis and y represents the vertical axis.
 * An observable point is a point that triggers a callback when the point's position is changed.
 *
 * @class
 * @memberof PIXI
 */
var ObservablePoint = function () {
    /**
     * @param {Function} cb - callback when changed
     * @param {object} scope - owner of callback
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=0] - position of the point on the y axis
     */
    function ObservablePoint(cb, scope) {
        var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        _classCallCheck(this, ObservablePoint);

        this._x = x;
        this._y = y;

        this.cb = cb;
        this.scope = scope;
    }

    /**
     * Creates a clone of this point.
     * The callback and scope params can be overidden otherwise they will default
     * to the clone object's values.
     *
     * @override
     * @param {Function} [cb=null] - callback when changed
     * @param {object} [scope=null] - owner of callback
     * @return {PIXI.ObservablePoint} a copy of the point
     */

    ObservablePoint.prototype.clone = function clone() {
        var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var _cb = cb || this.cb;
        var _scope = scope || this.scope;

        return new ObservablePoint(_cb, _scope, this._x, this._y);
    };

    /**
     * Sets the point to a new x and y position.
     * If y is omitted, both x and y will be set to x.
     *
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=0] - position of the point on the y axis
     */

    ObservablePoint.prototype.set = function set(x, y) {
        var _x = x || 0;
        var _y = y || (y !== 0 ? _x : 0);

        if (this._x !== _x || this._y !== _y) {
            this._x = _x;
            this._y = _y;
            this.cb.call(this.scope);
        }
    };

    /**
     * Copies the data from another point
     *
     * @param {PIXI.Point|PIXI.ObservablePoint} point - point to copy from
     */

    ObservablePoint.prototype.copy = function copy(point) {
        if (this._x !== point.x || this._y !== point.y) {
            this._x = point.x;
            this._y = point.y;
            this.cb.call(this.scope);
        }
    };

    /**
     * Returns true if the given point is equal to this point
     *
     * @param {PIXI.Point|PIXI.ObservablePoint} p - The point to check
     * @returns {boolean} Whether the given point equal to this point
     */

    ObservablePoint.prototype.equals = function equals(p) {
        return p.x === this._x && p.y === this._y;
    };

    /**
     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
     *
     * @member {number}
     */

    _createClass(ObservablePoint, [{
        key: "x",
        get: function get() {
            return this._x;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._x !== value) {
                this._x = value;
                this.cb.call(this.scope);
            }
        }

        /**
         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
         *
         * @member {number}
         */

    }, {
        key: "y",
        get: function get() {
            return this._y;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._y !== value) {
                this._y = value;
                this.cb.call(this.scope);
            }
        }
    }]);

    return ObservablePoint;
}();

exports.default = ObservablePoint;
//# sourceMappingURL=ObservablePoint.js.map

/***/ }),

/***/ "aNaN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var SeatingMap_1 = __webpack_require__("IpUV");
exports.SeatingMap = SeatingMap_1.default;
var Utils_1 = __webpack_require__("o6Mn");
exports.tableElements = Utils_1.tableElements;
var Views_1 = __webpack_require__("xsdn");
exports.SeatingConstruction = Views_1.SeatingConstruction;
exports.SectionOverview = Views_1.SectionOverview;
exports.SeatingReservation = Views_1.SeatingReservation;
exports.SeatingManagement = Views_1.SeatingManagement;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "aS8y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("3bIi");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),

/***/ "aSYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _defaults;

/* harmony default export */ __webpack_exports__["a"] = (function (key) {
  var value = defaults[key];
  if (typeof window !== "undefined") {
    value = window.config && window.config[key] !== undefined ? window.config[key] : defaults[key];
  }
  return value;
});

var defaults = (_defaults = {
  API_URL: "http://localhost:3000/api/",
  TICKETING_URL: "http://localhost:8080",
  WEBSITE_URL: "http://localhost:7070",
  CONSOLE_URL: "http://localhost:3001",
  BPOINT_API_URL: "https://www.bpoint.com.au/webapi/v3/",
  SENTRY_ERROR_ACCESS_APP: null,
  GOOGLE_API_KEY: "AIzaSyBrLKaAEokK10u3KCRKI0WJyXUN6iAT6AI",
  NODE_ENV: "staging",
  DEV: true,
  PAYPAL_ENV: "production",
  STRIPE_APK_KEY: "pk_test_xtsRcoIILJ6EWSxRgSEgnosm",
  STRIPE_PAYMENTS_APK_KEY: "pk_test_xtsRcoIILJ6EWSxRgSEgnosm",
  CURRENCY: "AUD",
  ZIPMONEY_LIBARY_URL: "https://static.zipmoney.com.au/checkout/checkout-v1.min.js",
  ZIPMONEY_ENV: "sandbox",
  ORDER_COMPLETE_TIME: 20
}, _defaults["GOOGLE_API_KEY"] = "AIzaSyBrLKaAEokK10u3KCRKI0WJyXUN6iAT6AI", _defaults.FILESTACK_KEY = "AeJa0mS9cRHyQaj6WeE3yz", _defaults.TAX_NAME = "ABN", _defaults.REDIRECT_TIME = 7000, _defaults);

/***/ }),

/***/ "aVqp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * DisplayObjects with the {@link PIXI.interaction.interactiveTarget} mixin use this class to track interactions
 *
 * @class
 * @private
 * @memberof PIXI.interaction
 */
var InteractionTrackingData = function () {
    /**
     * @param {number} pointerId - Unique pointer id of the event
     */
    function InteractionTrackingData(pointerId) {
        _classCallCheck(this, InteractionTrackingData);

        this._pointerId = pointerId;
        this._flags = InteractionTrackingData.FLAGS.NONE;
    }

    /**
     *
     * @private
     * @param {number} flag - The interaction flag to set
     * @param {boolean} yn - Should the flag be set or unset
     */

    InteractionTrackingData.prototype._doSet = function _doSet(flag, yn) {
        if (yn) {
            this._flags = this._flags | flag;
        } else {
            this._flags = this._flags & ~flag;
        }
    };

    /**
     * Unique pointer id of the event
     *
     * @readonly
     * @member {number}
     */

    _createClass(InteractionTrackingData, [{
        key: "pointerId",
        get: function get() {
            return this._pointerId;
        }

        /**
         * State of the tracking data, expressed as bit flags
         *
         * @member {number}
         * @memberof PIXI.interaction.InteractionTrackingData#
         */

    }, {
        key: "flags",
        get: function get() {
            return this._flags;
        }

        /**
         * Set the flags for the tracking data
         *
         * @param {number} flags - Flags to set
         */

        , set: function set(flags) {
            this._flags = flags;
        }

        /**
         * Is the tracked event inactive (not over or down)?
         *
         * @member {number}
         * @memberof PIXI.interaction.InteractionTrackingData#
         */

    }, {
        key: "none",
        get: function get() {
            return this._flags === this.constructor.FLAGS.NONE;
        }

        /**
         * Is the tracked event over the DisplayObject?
         *
         * @member {boolean}
         * @memberof PIXI.interaction.InteractionTrackingData#
         */

    }, {
        key: "over",
        get: function get() {
            return (this._flags & this.constructor.FLAGS.OVER) !== 0;
        }

        /**
         * Set the over flag
         *
         * @param {boolean} yn - Is the event over?
         */

        , set: function set(yn) {
            this._doSet(this.constructor.FLAGS.OVER, yn);
        }

        /**
         * Did the right mouse button come down in the DisplayObject?
         *
         * @member {boolean}
         * @memberof PIXI.interaction.InteractionTrackingData#
         */

    }, {
        key: "rightDown",
        get: function get() {
            return (this._flags & this.constructor.FLAGS.RIGHT_DOWN) !== 0;
        }

        /**
         * Set the right down flag
         *
         * @param {boolean} yn - Is the right mouse button down?
         */

        , set: function set(yn) {
            this._doSet(this.constructor.FLAGS.RIGHT_DOWN, yn);
        }

        /**
         * Did the left mouse button come down in the DisplayObject?
         *
         * @member {boolean}
         * @memberof PIXI.interaction.InteractionTrackingData#
         */

    }, {
        key: "leftDown",
        get: function get() {
            return (this._flags & this.constructor.FLAGS.LEFT_DOWN) !== 0;
        }

        /**
         * Set the left down flag
         *
         * @param {boolean} yn - Is the left mouse button down?
         */

        , set: function set(yn) {
            this._doSet(this.constructor.FLAGS.LEFT_DOWN, yn);
        }
    }]);

    return InteractionTrackingData;
}();

exports.default = InteractionTrackingData;

InteractionTrackingData.FLAGS = Object.freeze({
    NONE: 0,
    OVER: 1 << 0,
    LEFT_DOWN: 1 << 1,
    RIGHT_DOWN: 1 << 2
});
//# sourceMappingURL=InteractionTrackingData.js.map

/***/ }),

/***/ "aXgl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strictUriEncode = __webpack_require__("A2is");
var objectAssign = __webpack_require__("J4Nk");
var decodeComponent = __webpack_require__("pWxZ");

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [encode(key, opts), '[', index, ']'].join('') : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({ arrayFormat: 'none' }, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};

/***/ }),

/***/ "ainW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = __webpack_require__("o6Mn");
var PIXI = __webpack_require__("ix37");
var SeatingMap_1 = __webpack_require__("IpUV");
var Config_1 = __webpack_require__("gH/r");
var SelectionListener_1 = __webpack_require__("//Eg");
var bound_1 = __webpack_require__("USDo");

var BackButton = function () {
    function BackButton() {
        var _this = this;

        _classCallCheck(this, BackButton);

        this.interactiveContainer = new PIXI.Container();
        var _Config_1$default$can = Config_1.default.canvasBounding,
            top = _Config_1$default$can.top,
            left = _Config_1$default$can.left;

        this.interactiveContainer.position = new PIXI.Point(-left + 20, -top + 5);
        this.interactiveContainer.interactive = true;
        this.setImage();
        this.setText();
        this.setupInteraction();
        this.setupBackground();
        var wind = window;
        wind.setPos = function (x, y) {
            _this.interactiveContainer.position = new PIXI.Point(-left + x, -top + y);
        };
        this.interactiveContainer.visible = Config_1.default.hasSections;
    }

    BackButton.prototype.setImage = function setImage() {
        var texture = PIXI.loader.resources[Utils_1.backArrowIcon].texture;
        this.image = new PIXI.Sprite(texture);
        this.image.position.x = -20;
        this.image.position.y = -2;
        this.interactiveContainer.addChild(this.image);
    };

    BackButton.prototype.setText = function setText() {
        this.text = new PIXI.Text("Back", { fontSize: 18, fontFamily: Utils_1.font, fill: 0x323232 });
        this.interactiveContainer.addChild(this.text);
    };

    BackButton.prototype.setupInteraction = function setupInteraction() {
        this.selectionListener = new SelectionListener_1.default(this.interactiveContainer, this, this.onClick);
    };

    BackButton.prototype.setupBackground = function setupBackground() {
        this.graphics = new PIXI.Graphics();

        var _interactiveContainer = this.interactiveContainer.getBounds(),
            width = _interactiveContainer.width,
            height = _interactiveContainer.height;

        this.graphics.lineColor = 0xFFFFFF;
        this.graphics.beginFill(0xFFFFFF);
        this.graphics.drawRect(-15, -2, width, height);
        this.graphics.endFill();
        this.interactiveContainer.addChildAt(this.graphics, 0);
    };

    BackButton.prototype.onClick = function onClick() {
        SeatingMap_1.default.instance.switchToSectionReservationView();
    };

    BackButton.prototype.hide = function hide() {
        this.interactiveContainer.visible = false;
    };

    BackButton.prototype.show = function show() {
        this.interactiveContainer.visible = Config_1.default.hasSections;
    };

    BackButton.prototype.getContainer = function getContainer() {
        return this.interactiveContainer;
    };

    return BackButton;
}();

__decorate([bound_1.default], BackButton.prototype, "setImage", null);
__decorate([bound_1.default], BackButton.prototype, "setText", null);
__decorate([bound_1.default], BackButton.prototype, "setupInteraction", null);
__decorate([bound_1.default], BackButton.prototype, "setupBackground", null);
__decorate([bound_1.default], BackButton.prototype, "onClick", null);
__decorate([bound_1.default], BackButton.prototype, "hide", null);
__decorate([bound_1.default], BackButton.prototype, "show", null);
__decorate([bound_1.default], BackButton.prototype, "getContainer", null);
exports.default = BackButton;
//# sourceMappingURL=BackButton.js.map

/***/ }),

/***/ "ar57":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("58Ti");

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

/***/ }),

/***/ "awkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normaliseData;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function normaliseData(merchOrder) {
  var isNotNormalised = merchOrder.length > 0 && merchOrder[0].options;
  if (isNotNormalised) {
    var copiedMerch = JSON.parse(JSON.stringify(merchOrder));
    var merchWithQuantity = copiedMerch.filter(function (merch) {
      merch.options = merch.options.filter(function (opts) {
        return opts.quantity > 0;
      });
      return merch.options.length > 0;
    });
    var normalisedMerch = merchWithQuantity.reduce(function (cur, merch) {
      return cur.concat(merch.options.map(function (opt) {
        var parentMerch = _extends({}, merch);
        delete parentMerch.options;
        return _extends({}, parentMerch, opt);
      }));
    }, []);
    return normalisedMerch;
  } else {
    return merchOrder;
  }
}

/***/ }),

/***/ "b4C7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) {
			return false;
		}
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) {
		return false;
	}
	if (typeof value !== 'function' && typeof value !== 'object') {
		return false;
	}
	if (hasToStringTag) {
		return tryFunctionObject(value);
	}
	if (isES6ClassFn(value)) {
		return false;
	}
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};

/***/ }),

/***/ "b6AE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = validateContext;
function validateContext(gl) {
    var attributes = gl.getContextAttributes();

    // this is going to be fairly simple for now.. but at least we have room to grow!
    if (!attributes.stencil) {
        /* eslint-disable no-console */
        console.warn('Provided WebGL context does not have a stencil buffer, masks may not render correctly');
        /* eslint-enable no-console */
    }
}
//# sourceMappingURL=validateContext.js.map

/***/ }),

/***/ "bC3n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.eachSeries = eachSeries;
exports.queue = queue;
/**
 * Smaller version of the async library constructs.
 *
 * @namespace async
 */

/**
 * Noop function
 *
 * @ignore
 * @function
 * @memberof async
 */
function _noop() {} /* empty */

/**
 * Iterates an array in series.
 *
 * @memberof async
 * @param {Array.<*>} array - Array to iterate.
 * @param {function} iterator - Function to call for each element.
 * @param {function} callback - Function to call when done, or on error.
 * @param {boolean} [deferNext=false] - Break synchronous each loop by calling next with a setTimeout of 1.
 */
function eachSeries(array, iterator, callback, deferNext) {
    var i = 0;
    var len = array.length;

    (function next(err) {
        if (err || i === len) {
            if (callback) {
                callback(err);
            }

            return;
        }

        if (deferNext) {
            setTimeout(function () {
                iterator(array[i++], next);
            }, 1);
        } else {
            iterator(array[i++], next);
        }
    })();
}

/**
 * Ensures a function is only called once.
 *
 * @ignore
 * @memberof async
 * @param {function} fn - The function to wrap.
 * @return {function} The wrapping function.
 */
function onlyOnce(fn) {
    return function onceWrapper() {
        if (fn === null) {
            throw new Error('Callback was already called.');
        }

        var callFn = fn;

        fn = null;
        callFn.apply(this, arguments);
    };
}

/**
 * Async queue implementation,
 *
 * @memberof async
 * @param {function} worker - The worker function to call for each task.
 * @param {number} concurrency - How many workers to run in parrallel.
 * @return {*} The async queue object.
 */
function queue(worker, concurrency) {
    if (concurrency == null) {
        // eslint-disable-line no-eq-null,eqeqeq
        concurrency = 1;
    } else if (concurrency === 0) {
        throw new Error('Concurrency must not be zero');
    }

    var workers = 0;
    var q = {
        _tasks: [],
        concurrency: concurrency,
        saturated: _noop,
        unsaturated: _noop,
        buffer: concurrency / 4,
        empty: _noop,
        drain: _noop,
        error: _noop,
        started: false,
        paused: false,
        push: function push(data, callback) {
            _insert(data, false, callback);
        },
        kill: function kill() {
            workers = 0;
            q.drain = _noop;
            q.started = false;
            q._tasks = [];
        },
        unshift: function unshift(data, callback) {
            _insert(data, true, callback);
        },
        process: function process() {
            while (!q.paused && workers < q.concurrency && q._tasks.length) {
                var task = q._tasks.shift();

                if (q._tasks.length === 0) {
                    q.empty();
                }

                workers += 1;

                if (workers === q.concurrency) {
                    q.saturated();
                }

                worker(task.data, onlyOnce(_next(task)));
            }
        },
        length: function length() {
            return q._tasks.length;
        },
        running: function running() {
            return workers;
        },
        idle: function idle() {
            return q._tasks.length + workers === 0;
        },
        pause: function pause() {
            if (q.paused === true) {
                return;
            }

            q.paused = true;
        },
        resume: function resume() {
            if (q.paused === false) {
                return;
            }

            q.paused = false;

            // Need to call q.process once per concurrent
            // worker to preserve full concurrency after pause
            for (var w = 1; w <= q.concurrency; w++) {
                q.process();
            }
        }
    };

    function _insert(data, insertAtFront, callback) {
        if (callback != null && typeof callback !== 'function') {
            // eslint-disable-line no-eq-null,eqeqeq
            throw new Error('task callback must be a function');
        }

        q.started = true;

        if (data == null && q.idle()) {
            // eslint-disable-line no-eq-null,eqeqeq
            // call drain immediately if there are no tasks
            setTimeout(function () {
                return q.drain();
            }, 1);

            return;
        }

        var item = {
            data: data,
            callback: typeof callback === 'function' ? callback : _noop
        };

        if (insertAtFront) {
            q._tasks.unshift(item);
        } else {
            q._tasks.push(item);
        }

        setTimeout(function () {
            return q.process();
        }, 1);
    }

    function _next(task) {
        return function next() {
            workers -= 1;

            task.callback.apply(task, arguments);

            if (arguments[0] != null) {
                // eslint-disable-line no-eq-null,eqeqeq
                q.error(arguments[0], task.data);
            }

            if (workers <= q.concurrency - q.buffer) {
                q.unsaturated();
            }

            if (q.idle()) {
                q.drain();
            }

            q.process();
        };
    }

    return q;
}
//# sourceMappingURL=async.js.map

/***/ }),

/***/ "bG99":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _CanvasRenderer = __webpack_require__("GzOR");

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _const = __webpack_require__("YEQi");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they
 * now share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's CanvasGraphicsRenderer:
 * https://github.com/libgdx/libgdx/blob/1.0.0/gdx/src/com/badlogic/gdx/graphics/glutils/ShapeRenderer.java
 */

/**
 * Renderer dedicated to drawing and batching graphics objects.
 *
 * @class
 * @private
 * @memberof PIXI
 */
var CanvasGraphicsRenderer = function () {
    /**
     * @param {PIXI.CanvasRenderer} renderer - The current PIXI renderer.
     */
    function CanvasGraphicsRenderer(renderer) {
        _classCallCheck(this, CanvasGraphicsRenderer);

        this.renderer = renderer;
    }

    /**
     * Renders a Graphics object to a canvas.
     *
     * @param {PIXI.Graphics} graphics - the actual graphics object to render
     */

    CanvasGraphicsRenderer.prototype.render = function render(graphics) {
        var renderer = this.renderer;
        var context = renderer.context;
        var worldAlpha = graphics.worldAlpha;
        var transform = graphics.transform.worldTransform;
        var resolution = renderer.resolution;

        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);

        // update tint if graphics was dirty
        if (graphics.canvasTintDirty !== graphics.dirty || graphics._prevTint !== graphics.tint) {
            this.updateGraphicsTint(graphics);
        }

        renderer.setBlendMode(graphics.blendMode);

        for (var i = 0; i < graphics.graphicsData.length; i++) {
            var data = graphics.graphicsData[i];
            var shape = data.shape;

            var fillColor = data._fillTint;
            var lineColor = data._lineTint;

            context.lineWidth = data.lineWidth;

            if (data.type === _const.SHAPES.POLY) {
                context.beginPath();

                var points = shape.points;
                var holes = data.holes;
                var outerArea = void 0;
                var innerArea = void 0;
                var px = void 0;
                var py = void 0;

                context.moveTo(points[0], points[1]);

                for (var j = 2; j < points.length; j += 2) {
                    context.lineTo(points[j], points[j + 1]);
                }

                // if the first and last point are the same close the path - much neater :)
                if (shape.closed) {
                    context.closePath();
                }

                if (holes.length > 0) {
                    outerArea = 0;
                    px = points[0];
                    py = points[1];
                    for (var _j = 2; _j + 2 < points.length; _j += 2) {
                        outerArea += (points[_j] - px) * (points[_j + 3] - py) - (points[_j + 2] - px) * (points[_j + 1] - py);
                    }

                    for (var k = 0; k < holes.length; k++) {
                        points = holes[k].points;

                        if (!points) {
                            continue;
                        }

                        innerArea = 0;
                        px = points[0];
                        py = points[1];
                        for (var _j2 = 2; _j2 + 2 < points.length; _j2 += 2) {
                            innerArea += (points[_j2] - px) * (points[_j2 + 3] - py) - (points[_j2 + 2] - px) * (points[_j2 + 1] - py);
                        }

                        if (innerArea * outerArea < 0) {
                            context.moveTo(points[0], points[1]);

                            for (var _j3 = 2; _j3 < points.length; _j3 += 2) {
                                context.lineTo(points[_j3], points[_j3 + 1]);
                            }
                        } else {
                            context.moveTo(points[points.length - 2], points[points.length - 1]);

                            for (var _j4 = points.length - 4; _j4 >= 0; _j4 -= 2) {
                                context.lineTo(points[_j4], points[_j4 + 1]);
                            }
                        }

                        if (holes[k].close) {
                            context.closePath();
                        }
                    }
                }

                if (data.fill) {
                    context.globalAlpha = data.fillAlpha * worldAlpha;
                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                    context.fill();
                }
                if (data.lineWidth) {
                    context.globalAlpha = data.lineAlpha * worldAlpha;
                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                    context.stroke();
                }
            } else if (data.type === _const.SHAPES.RECT) {
                if (data.fillColor || data.fillColor === 0) {
                    context.globalAlpha = data.fillAlpha * worldAlpha;
                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                    context.fillRect(shape.x, shape.y, shape.width, shape.height);
                }
                if (data.lineWidth) {
                    context.globalAlpha = data.lineAlpha * worldAlpha;
                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                    context.strokeRect(shape.x, shape.y, shape.width, shape.height);
                }
            } else if (data.type === _const.SHAPES.CIRC) {
                // TODO - need to be Undefined!
                context.beginPath();
                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
                context.closePath();

                if (data.fill) {
                    context.globalAlpha = data.fillAlpha * worldAlpha;
                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                    context.fill();
                }
                if (data.lineWidth) {
                    context.globalAlpha = data.lineAlpha * worldAlpha;
                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                    context.stroke();
                }
            } else if (data.type === _const.SHAPES.ELIP) {
                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas

                var w = shape.width * 2;
                var h = shape.height * 2;

                var x = shape.x - w / 2;
                var y = shape.y - h / 2;

                context.beginPath();

                var kappa = 0.5522848;
                var ox = w / 2 * kappa; // control point offset horizontal
                var oy = h / 2 * kappa; // control point offset vertical
                var xe = x + w; // x-end
                var ye = y + h; // y-end
                var xm = x + w / 2; // x-middle
                var ym = y + h / 2; // y-middle

                context.moveTo(x, ym);
                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);

                context.closePath();

                if (data.fill) {
                    context.globalAlpha = data.fillAlpha * worldAlpha;
                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                    context.fill();
                }
                if (data.lineWidth) {
                    context.globalAlpha = data.lineAlpha * worldAlpha;
                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                    context.stroke();
                }
            } else if (data.type === _const.SHAPES.RREC) {
                var rx = shape.x;
                var ry = shape.y;
                var width = shape.width;
                var height = shape.height;
                var radius = shape.radius;

                var maxRadius = Math.min(width, height) / 2 | 0;

                radius = radius > maxRadius ? maxRadius : radius;

                context.beginPath();
                context.moveTo(rx, ry + radius);
                context.lineTo(rx, ry + height - radius);
                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
                context.lineTo(rx + width - radius, ry + height);
                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
                context.lineTo(rx + width, ry + radius);
                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
                context.lineTo(rx + radius, ry);
                context.quadraticCurveTo(rx, ry, rx, ry + radius);
                context.closePath();

                if (data.fillColor || data.fillColor === 0) {
                    context.globalAlpha = data.fillAlpha * worldAlpha;
                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                    context.fill();
                }

                if (data.lineWidth) {
                    context.globalAlpha = data.lineAlpha * worldAlpha;
                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                    context.stroke();
                }
            }
        }
    };

    /**
     * Updates the tint of a graphics object
     *
     * @private
     * @param {PIXI.Graphics} graphics - the graphics that will have its tint updated
     */

    CanvasGraphicsRenderer.prototype.updateGraphicsTint = function updateGraphicsTint(graphics) {
        graphics._prevTint = graphics.tint;
        graphics.canvasTintDirty = graphics.dirty;

        var tintR = (graphics.tint >> 16 & 0xFF) / 255;
        var tintG = (graphics.tint >> 8 & 0xFF) / 255;
        var tintB = (graphics.tint & 0xFF) / 255;

        for (var i = 0; i < graphics.graphicsData.length; ++i) {
            var data = graphics.graphicsData[i];

            var fillColor = data.fillColor | 0;
            var lineColor = data.lineColor | 0;

            // super inline, cos optimization :)
            data._fillTint = ((fillColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((fillColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (fillColor & 0xFF) / 255 * tintB * 255;

            data._lineTint = ((lineColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((lineColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (lineColor & 0xFF) / 255 * tintB * 255;
        }
    };

    /**
     * Renders a polygon.
     *
     * @param {PIXI.Point[]} points - The points to render
     * @param {boolean} close - Should the polygon be closed
     * @param {CanvasRenderingContext2D} context - The rendering context to use
     */

    CanvasGraphicsRenderer.prototype.renderPolygon = function renderPolygon(points, close, context) {
        context.moveTo(points[0], points[1]);

        for (var j = 1; j < points.length / 2; ++j) {
            context.lineTo(points[j * 2], points[j * 2 + 1]);
        }

        if (close) {
            context.closePath();
        }
    };

    /**
     * destroy graphics object
     *
     */

    CanvasGraphicsRenderer.prototype.destroy = function destroy() {
        this.renderer = null;
    };

    return CanvasGraphicsRenderer;
}();

exports.default = CanvasGraphicsRenderer;

_CanvasRenderer2.default.registerPlugin('graphics', CanvasGraphicsRenderer);
//# sourceMappingURL=CanvasGraphicsRenderer.js.map

/***/ }),

/***/ "bI+R":
/***/ (function(module, exports) {

module.exports = extend;

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {};

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
}

/***/ }),

/***/ "bPb9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _Mesh = __webpack_require__("esRn");

var _Mesh2 = _interopRequireDefault(_Mesh);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * Renderer dedicated to meshes.
 *
 * @class
 * @private
 * @memberof PIXI
 */
var MeshSpriteRenderer = function () {
    /**
     * @param {PIXI.CanvasRenderer} renderer - The renderer this downport works for
     */
    function MeshSpriteRenderer(renderer) {
        _classCallCheck(this, MeshSpriteRenderer);

        this.renderer = renderer;
    }

    /**
     * Renders the Mesh
     *
     * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
     */

    MeshSpriteRenderer.prototype.render = function render(mesh) {
        var renderer = this.renderer;
        var context = renderer.context;

        var transform = mesh.worldTransform;
        var res = renderer.resolution;

        if (renderer.roundPixels) {
            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
        } else {
            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
        }

        renderer.context.globalAlpha = mesh.worldAlpha;
        renderer.setBlendMode(mesh.blendMode);

        if (mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH) {
            this._renderTriangleMesh(mesh);
        } else {
            this._renderTriangles(mesh);
        }
    };

    /**
     * Draws the object in Triangle Mesh mode
     *
     * @private
     * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
     */

    MeshSpriteRenderer.prototype._renderTriangleMesh = function _renderTriangleMesh(mesh) {
        // draw triangles!!
        var length = mesh.vertices.length / 2;

        for (var i = 0; i < length - 2; i++) {
            // draw some triangles!
            var index = i * 2;

            this._renderDrawTriangle(mesh, index, index + 2, index + 4);
        }
    };

    /**
     * Draws the object in triangle mode using canvas
     *
     * @private
     * @param {PIXI.mesh.Mesh} mesh - the current mesh
     */

    MeshSpriteRenderer.prototype._renderTriangles = function _renderTriangles(mesh) {
        // draw triangles!!
        var indices = mesh.indices;
        var length = indices.length;

        for (var i = 0; i < length; i += 3) {
            // draw some triangles!
            var index0 = indices[i] * 2;
            var index1 = indices[i + 1] * 2;
            var index2 = indices[i + 2] * 2;

            this._renderDrawTriangle(mesh, index0, index1, index2);
        }
    };

    /**
     * Draws one of the triangles that from the Mesh
     *
     * @private
     * @param {PIXI.mesh.Mesh} mesh - the current mesh
     * @param {number} index0 - the index of the first vertex
     * @param {number} index1 - the index of the second vertex
     * @param {number} index2 - the index of the third vertex
     */

    MeshSpriteRenderer.prototype._renderDrawTriangle = function _renderDrawTriangle(mesh, index0, index1, index2) {
        var context = this.renderer.context;
        var uvs = mesh.uvs;
        var vertices = mesh.vertices;
        var texture = mesh._texture;

        if (!texture.valid) {
            return;
        }

        var base = texture.baseTexture;
        var textureSource = base.source;
        var textureWidth = base.width;
        var textureHeight = base.height;

        var u0 = void 0;
        var u1 = void 0;
        var u2 = void 0;
        var v0 = void 0;
        var v1 = void 0;
        var v2 = void 0;

        if (mesh.uploadUvTransform) {
            var ut = mesh._uvTransform.mapCoord;

            u0 = (uvs[index0] * ut.a + uvs[index0 + 1] * ut.c + ut.tx) * base.width;
            u1 = (uvs[index1] * ut.a + uvs[index1 + 1] * ut.c + ut.tx) * base.width;
            u2 = (uvs[index2] * ut.a + uvs[index2 + 1] * ut.c + ut.tx) * base.width;
            v0 = (uvs[index0] * ut.b + uvs[index0 + 1] * ut.d + ut.ty) * base.height;
            v1 = (uvs[index1] * ut.b + uvs[index1 + 1] * ut.d + ut.ty) * base.height;
            v2 = (uvs[index2] * ut.b + uvs[index2 + 1] * ut.d + ut.ty) * base.height;
        } else {
            u0 = uvs[index0] * base.width;
            u1 = uvs[index1] * base.width;
            u2 = uvs[index2] * base.width;
            v0 = uvs[index0 + 1] * base.height;
            v1 = uvs[index1 + 1] * base.height;
            v2 = uvs[index2 + 1] * base.height;
        }

        var x0 = vertices[index0];
        var x1 = vertices[index1];
        var x2 = vertices[index2];
        var y0 = vertices[index0 + 1];
        var y1 = vertices[index1 + 1];
        var y2 = vertices[index2 + 1];

        var canvasPadding = mesh.canvasPadding / this.renderer.resolution;

        if (canvasPadding > 0) {
            var paddingX = canvasPadding / Math.abs(mesh.worldTransform.a);
            var paddingY = canvasPadding / Math.abs(mesh.worldTransform.d);
            var centerX = (x0 + x1 + x2) / 3;
            var centerY = (y0 + y1 + y2) / 3;

            var normX = x0 - centerX;
            var normY = y0 - centerY;

            var dist = Math.sqrt(normX * normX + normY * normY);

            x0 = centerX + normX / dist * (dist + paddingX);
            y0 = centerY + normY / dist * (dist + paddingY);

            //

            normX = x1 - centerX;
            normY = y1 - centerY;

            dist = Math.sqrt(normX * normX + normY * normY);
            x1 = centerX + normX / dist * (dist + paddingX);
            y1 = centerY + normY / dist * (dist + paddingY);

            normX = x2 - centerX;
            normY = y2 - centerY;

            dist = Math.sqrt(normX * normX + normY * normY);
            x2 = centerX + normX / dist * (dist + paddingX);
            y2 = centerY + normY / dist * (dist + paddingY);
        }

        context.save();
        context.beginPath();

        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);

        context.closePath();

        context.clip();

        // Compute matrix transform
        var delta = u0 * v1 + v0 * u2 + u1 * v2 - v1 * u2 - v0 * u1 - u0 * v2;
        var deltaA = x0 * v1 + v0 * x2 + x1 * v2 - v1 * x2 - v0 * x1 - x0 * v2;
        var deltaB = u0 * x1 + x0 * u2 + u1 * x2 - x1 * u2 - x0 * u1 - u0 * x2;
        var deltaC = u0 * v1 * x2 + v0 * x1 * u2 + x0 * u1 * v2 - x0 * v1 * u2 - v0 * u1 * x2 - u0 * x1 * v2;
        var deltaD = y0 * v1 + v0 * y2 + y1 * v2 - v1 * y2 - v0 * y1 - y0 * v2;
        var deltaE = u0 * y1 + y0 * u2 + u1 * y2 - y1 * u2 - y0 * u1 - u0 * y2;
        var deltaF = u0 * v1 * y2 + v0 * y1 * u2 + y0 * u1 * v2 - y0 * v1 * u2 - v0 * u1 * y2 - u0 * y1 * v2;

        context.transform(deltaA / delta, deltaD / delta, deltaB / delta, deltaE / delta, deltaC / delta, deltaF / delta);

        context.drawImage(textureSource, 0, 0, textureWidth * base.resolution, textureHeight * base.resolution, 0, 0, textureWidth, textureHeight);

        context.restore();
        this.renderer.invalidateBlendMode();
    };

    /**
     * Renders a flat Mesh
     *
     * @private
     * @param {PIXI.mesh.Mesh} mesh - The Mesh to render
     */

    MeshSpriteRenderer.prototype.renderMeshFlat = function renderMeshFlat(mesh) {
        var context = this.renderer.context;
        var vertices = mesh.vertices;
        var length = vertices.length / 2;

        // this.count++;

        context.beginPath();

        for (var i = 1; i < length - 2; ++i) {
            // draw some triangles!
            var index = i * 2;

            var x0 = vertices[index];
            var y0 = vertices[index + 1];

            var x1 = vertices[index + 2];
            var y1 = vertices[index + 3];

            var x2 = vertices[index + 4];
            var y2 = vertices[index + 5];

            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
            context.lineTo(x2, y2);
        }

        context.fillStyle = '#FF0000';
        context.fill();
        context.closePath();
    };

    /**
     * destroy the the renderer.
     *
     */

    MeshSpriteRenderer.prototype.destroy = function destroy() {
        this.renderer = null;
    };

    return MeshSpriteRenderer;
}();

exports.default = MeshSpriteRenderer;

core.CanvasRenderer.registerPlugin('mesh', MeshSpriteRenderer);
//# sourceMappingURL=CanvasMeshRenderer.js.map

/***/ }),

/***/ "bPsC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("lp9P");

__webpack_require__("/lqD");

__webpack_require__("XgiD");

__webpack_require__("qjkZ");

if (!window.ArrayBuffer) {
    window.ArrayBuffer = Array;
}

if (!window.Float32Array) {
    window.Float32Array = Array;
}

if (!window.Uint32Array) {
    window.Uint32Array = Array;
}

if (!window.Uint16Array) {
    window.Uint16Array = Array;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "bbZ0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "faf772e27b452aee46108f7726c97025.svg";

/***/ }),

/***/ "bkHk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.blobMiddlewareFactory = blobMiddlewareFactory;

var _Resource = __webpack_require__("F/bs");

var _b = __webpack_require__("5Wbt");

var Url = window.URL || window.webkitURL;

// a middleware for transforming XHR loaded Blobs into more useful objects
function blobMiddlewareFactory() {
    return function blobMiddleware(resource, next) {
        if (!resource.data) {
            next();

            return;
        }

        // if this was an XHR load of a blob
        if (resource.xhr && resource.xhrType === _Resource.Resource.XHR_RESPONSE_TYPE.BLOB) {
            // if there is no blob support we probably got a binary string back
            if (!window.Blob || typeof resource.data === 'string') {
                var type = resource.xhr.getResponseHeader('content-type');

                // this is an image, convert the binary string into a data url
                if (type && type.indexOf('image') === 0) {
                    resource.data = new Image();
                    resource.data.src = 'data:' + type + ';base64,' + (0, _b.encodeBinary)(resource.xhr.responseText);

                    resource.type = _Resource.Resource.TYPE.IMAGE;

                    // wait until the image loads and then callback
                    resource.data.onload = function () {
                        resource.data.onload = null;

                        next();
                    };

                    // next will be called on load
                    return;
                }
            }
            // if content type says this is an image, then we should transform the blob into an Image object
            else if (resource.data.type.indexOf('image') === 0) {
                    var src = Url.createObjectURL(resource.data);

                    resource.blob = resource.data;
                    resource.data = new Image();
                    resource.data.src = src;

                    resource.type = _Resource.Resource.TYPE.IMAGE;

                    // cleanup the no longer used blob after the image loads
                    // TODO: Is this correct? Will the image be invalid after revoking?
                    resource.data.onload = function () {
                        Url.revokeObjectURL(src);
                        resource.data.onload = null;

                        next();
                    };

                    // next will be called on load.
                    return;
                }
        }

        next();
    };
}
//# sourceMappingURL=blob.js.map

/***/ }),

/***/ "bvhO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function stringifyPrimitive(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);
  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map(xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

/***/ }),

/***/ "c7R4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var installedColorSpaces = [],
    undef = function undef(obj) {
    return typeof obj === 'undefined';
},
    channelRegExp = /\s*(\.\d+|\d+(?:\.\d+)?)(%)?\s*/,
    percentageChannelRegExp = /\s*(\.\d+|100|\d?\d(?:\.\d+)?)%\s*/,
    alphaChannelRegExp = /\s*(\.\d+|\d+(?:\.\d+)?)\s*/,
    cssColorRegExp = new RegExp('^(rgb|hsl|hsv)a?' + '\\(' + channelRegExp.source + ',' + channelRegExp.source + ',' + channelRegExp.source + '(?:,' + alphaChannelRegExp.source + ')?' + '\\)$', 'i');

function color(obj) {
    if (Array.isArray(obj)) {
        if (typeof obj[0] === 'string' && typeof color[obj[0]] === 'function') {
            // Assumed array from .toJSON()
            return new color[obj[0]](obj.slice(1, obj.length));
        } else if (obj.length === 4) {
            // Assumed 4 element int RGB array from canvas with all channels [0;255]
            return new color.RGB(obj[0] / 255, obj[1] / 255, obj[2] / 255, obj[3] / 255);
        }
    } else if (typeof obj === 'string') {
        var lowerCased = obj.toLowerCase();
        if (color.namedColors[lowerCased]) {
            obj = '#' + color.namedColors[lowerCased];
        }
        if (lowerCased === 'transparent') {
            obj = 'rgba(0,0,0,0)';
        }
        // Test for CSS rgb(....) string
        var matchCssSyntax = obj.match(cssColorRegExp);
        if (matchCssSyntax) {
            var colorSpaceName = matchCssSyntax[1].toUpperCase(),
                alpha = undef(matchCssSyntax[8]) ? matchCssSyntax[8] : parseFloat(matchCssSyntax[8]),
                hasHue = colorSpaceName[0] === 'H',
                firstChannelDivisor = matchCssSyntax[3] ? 100 : hasHue ? 360 : 255,
                secondChannelDivisor = matchCssSyntax[5] || hasHue ? 100 : 255,
                thirdChannelDivisor = matchCssSyntax[7] || hasHue ? 100 : 255;
            if (undef(color[colorSpaceName])) {
                throw new Error('color.' + colorSpaceName + ' is not installed.');
            }
            return new color[colorSpaceName](parseFloat(matchCssSyntax[2]) / firstChannelDivisor, parseFloat(matchCssSyntax[4]) / secondChannelDivisor, parseFloat(matchCssSyntax[6]) / thirdChannelDivisor, alpha);
        }
        // Assume hex syntax
        if (obj.length < 6) {
            // Allow CSS shorthand
            obj = obj.replace(/^#?([0-9a-f])([0-9a-f])([0-9a-f])$/i, '$1$1$2$2$3$3');
        }
        // Split obj into red, green, and blue components
        var hexMatch = obj.match(/^#?([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])$/i);
        if (hexMatch) {
            return new color.RGB(parseInt(hexMatch[1], 16) / 255, parseInt(hexMatch[2], 16) / 255, parseInt(hexMatch[3], 16) / 255);
        }

        // No match so far. Lets try the less likely ones
        if (color.CMYK) {
            var cmykMatch = obj.match(new RegExp('^cmyk' + '\\(' + percentageChannelRegExp.source + ',' + percentageChannelRegExp.source + ',' + percentageChannelRegExp.source + ',' + percentageChannelRegExp.source + '\\)$', 'i'));
            if (cmykMatch) {
                return new color.CMYK(parseFloat(cmykMatch[1]) / 100, parseFloat(cmykMatch[2]) / 100, parseFloat(cmykMatch[3]) / 100, parseFloat(cmykMatch[4]) / 100);
            }
        }
    } else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj.isColor) {
        return obj;
    }
    return false;
}

color.namedColors = {};

color.installColorSpace = function (colorSpaceName, propertyNames, config) {
    color[colorSpaceName] = function (a1) {
        // ...
        var args = Array.isArray(a1) ? a1 : arguments;
        propertyNames.forEach(function (propertyName, i) {
            var propertyValue = args[i];
            if (propertyName === 'alpha') {
                this._alpha = isNaN(propertyValue) || propertyValue > 1 ? 1 : propertyValue < 0 ? 0 : propertyValue;
            } else {
                if (isNaN(propertyValue)) {
                    throw new Error('[' + colorSpaceName + ']: Invalid color: (' + propertyNames.join(',') + ')');
                }
                if (propertyName === 'hue') {
                    this._hue = propertyValue < 0 ? propertyValue - Math.floor(propertyValue) : propertyValue % 1;
                } else {
                    this['_' + propertyName] = propertyValue < 0 ? 0 : propertyValue > 1 ? 1 : propertyValue;
                }
            }
        }, this);
    };
    color[colorSpaceName].propertyNames = propertyNames;

    var prototype = color[colorSpaceName].prototype;

    ['valueOf', 'hex', 'hexa', 'css', 'cssa'].forEach(function (methodName) {
        prototype[methodName] = prototype[methodName] || (colorSpaceName === 'RGB' ? prototype.hex : function () {
            return this.rgb()[methodName]();
        });
    });

    prototype.isColor = true;

    prototype.equals = function (otherColor, epsilon) {
        if (undef(epsilon)) {
            epsilon = 1e-10;
        }

        otherColor = otherColor[colorSpaceName.toLowerCase()]();

        for (var i = 0; i < propertyNames.length; i = i + 1) {
            if (Math.abs(this['_' + propertyNames[i]] - otherColor['_' + propertyNames[i]]) > epsilon) {
                return false;
            }
        }

        return true;
    };

    prototype.toJSON = function () {
        return [colorSpaceName].concat(propertyNames.map(function (propertyName) {
            return this['_' + propertyName];
        }, this));
    };

    for (var propertyName in config) {
        if (config.hasOwnProperty(propertyName)) {
            var matchFromColorSpace = propertyName.match(/^from(.*)$/);
            if (matchFromColorSpace) {
                color[matchFromColorSpace[1].toUpperCase()].prototype[colorSpaceName.toLowerCase()] = config[propertyName];
            } else {
                prototype[propertyName] = config[propertyName];
            }
        }
    }

    // It is pretty easy to implement the conversion to the same color space:
    prototype[colorSpaceName.toLowerCase()] = function () {
        return this;
    };
    prototype.toString = function () {
        return '[' + colorSpaceName + ' ' + propertyNames.map(function (propertyName) {
            return this['_' + propertyName];
        }, this).join(', ') + ']';
    };

    // Generate getters and setters
    propertyNames.forEach(function (propertyName) {
        var shortName = propertyName === 'black' ? 'k' : propertyName.charAt(0);
        prototype[propertyName] = prototype[shortName] = function (value, isDelta) {
            // Simple getter mode: color.red()
            if (typeof value === 'undefined') {
                return this['_' + propertyName];
            } else if (isDelta) {
                // Adjuster: color.red(+.2, true)
                return new this.constructor(propertyNames.map(function (otherPropertyName) {
                    return this['_' + otherPropertyName] + (propertyName === otherPropertyName ? value : 0);
                }, this));
            } else {
                // Setter: color.red(.2);
                return new this.constructor(propertyNames.map(function (otherPropertyName) {
                    return propertyName === otherPropertyName ? value : this['_' + otherPropertyName];
                }, this));
            }
        };
    });

    function installForeignMethods(targetColorSpaceName, sourceColorSpaceName) {
        var obj = {};
        obj[sourceColorSpaceName.toLowerCase()] = function () {
            return this.rgb()[sourceColorSpaceName.toLowerCase()]();
        };
        color[sourceColorSpaceName].propertyNames.forEach(function (propertyName) {
            var shortName = propertyName === 'black' ? 'k' : propertyName.charAt(0);
            obj[propertyName] = obj[shortName] = function (value, isDelta) {
                return this[sourceColorSpaceName.toLowerCase()]()[propertyName](value, isDelta);
            };
        });
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop) && color[targetColorSpaceName].prototype[prop] === undefined) {
                color[targetColorSpaceName].prototype[prop] = obj[prop];
            }
        }
    }

    installedColorSpaces.forEach(function (otherColorSpaceName) {
        installForeignMethods(colorSpaceName, otherColorSpaceName);
        installForeignMethods(otherColorSpaceName, colorSpaceName);
    });

    installedColorSpaces.push(colorSpaceName);
    return color;
};

color.pluginList = [];

color.use = function (plugin) {
    if (color.pluginList.indexOf(plugin) === -1) {
        this.pluginList.push(plugin);
        plugin(color);
    }
    return color;
};

color.installMethod = function (name, fn) {
    installedColorSpaces.forEach(function (colorSpace) {
        color[colorSpace].prototype[name] = fn;
    });
    return this;
};

color.installColorSpace('RGB', ['red', 'green', 'blue', 'alpha'], {
    hex: function hex() {
        var hexString = (Math.round(255 * this._red) * 0x10000 + Math.round(255 * this._green) * 0x100 + Math.round(255 * this._blue)).toString(16);
        return '#' + '00000'.substr(0, 6 - hexString.length) + hexString;
    },

    hexa: function hexa() {
        var alphaString = Math.round(this._alpha * 255).toString(16);
        return '#' + '00'.substr(0, 2 - alphaString.length) + alphaString + this.hex().substr(1, 6);
    },

    css: function css() {
        return 'rgb(' + Math.round(255 * this._red) + ',' + Math.round(255 * this._green) + ',' + Math.round(255 * this._blue) + ')';
    },

    cssa: function cssa() {
        return 'rgba(' + Math.round(255 * this._red) + ',' + Math.round(255 * this._green) + ',' + Math.round(255 * this._blue) + ',' + this._alpha + ')';
    }
});

var color_1 = color;

var XYZ = function XYZ(color) {
    color.installColorSpace('XYZ', ['x', 'y', 'z', 'alpha'], {
        fromRgb: function fromRgb() {
            // http://www.easyrgb.com/index.php?X=MATH&H=02#text2
            var convert = function convert(channel) {
                return channel > 0.04045 ? Math.pow((channel + 0.055) / 1.055, 2.4) : channel / 12.92;
            },
                r = convert(this._red),
                g = convert(this._green),
                b = convert(this._blue);

            // Reference white point sRGB D65:
            // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
            return new color.XYZ(r * 0.4124564 + g * 0.3575761 + b * 0.1804375, r * 0.2126729 + g * 0.7151522 + b * 0.0721750, r * 0.0193339 + g * 0.1191920 + b * 0.9503041, this._alpha);
        },

        rgb: function rgb() {
            // http://www.easyrgb.com/index.php?X=MATH&H=01#text1
            var x = this._x,
                y = this._y,
                z = this._z,
                convert = function convert(channel) {
                return channel > 0.0031308 ? 1.055 * Math.pow(channel, 1 / 2.4) - 0.055 : 12.92 * channel;
            };

            // Reference white point sRGB D65:
            // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
            return new color.RGB(convert(x * 3.2404542 + y * -1.5371385 + z * -0.4985314), convert(x * -0.9692660 + y * 1.8760108 + z * 0.0415560), convert(x * 0.0556434 + y * -0.2040259 + z * 1.0572252), this._alpha);
        },

        lab: function lab() {
            // http://www.easyrgb.com/index.php?X=MATH&H=07#text7
            var convert = function convert(channel) {
                return channel > 0.008856 ? Math.pow(channel, 1 / 3) : 7.787037 * channel + 4 / 29;
            },
                x = convert(this._x / 95.047),
                y = convert(this._y / 100.000),
                z = convert(this._z / 108.883);

            return new color.LAB(116 * y - 16, 500 * (x - y), 200 * (y - z), this._alpha);
        }
    });
};

var LAB = function LAB(color) {
    color.use(XYZ);

    color.installColorSpace('LAB', ['l', 'a', 'b', 'alpha'], {
        fromRgb: function fromRgb() {
            return this.xyz().lab();
        },

        rgb: function rgb() {
            return this.xyz().rgb();
        },

        xyz: function xyz() {
            // http://www.easyrgb.com/index.php?X=MATH&H=08#text8
            var convert = function convert(channel) {
                var pow = Math.pow(channel, 3);
                return pow > 0.008856 ? pow : (channel - 16 / 116) / 7.87;
            },
                y = (this._l + 16) / 116,
                x = this._a / 500 + y,
                z = y - this._b / 200;

            return new color.XYZ(convert(x) * 95.047, convert(y) * 100.000, convert(z) * 108.883, this._alpha);
        }
    });
};

var HSV = function HSV(color) {
    color.installColorSpace('HSV', ['hue', 'saturation', 'value', 'alpha'], {
        rgb: function rgb() {
            var hue = this._hue,
                saturation = this._saturation,
                value = this._value,
                i = Math.min(5, Math.floor(hue * 6)),
                f = hue * 6 - i,
                p = value * (1 - saturation),
                q = value * (1 - f * saturation),
                t = value * (1 - (1 - f) * saturation),
                red,
                green,
                blue;
            switch (i) {
                case 0:
                    red = value;
                    green = t;
                    blue = p;
                    break;
                case 1:
                    red = q;
                    green = value;
                    blue = p;
                    break;
                case 2:
                    red = p;
                    green = value;
                    blue = t;
                    break;
                case 3:
                    red = p;
                    green = q;
                    blue = value;
                    break;
                case 4:
                    red = t;
                    green = p;
                    blue = value;
                    break;
                case 5:
                    red = value;
                    green = p;
                    blue = q;
                    break;
            }
            return new color.RGB(red, green, blue, this._alpha);
        },

        hsl: function hsl() {
            var l = (2 - this._saturation) * this._value,
                sv = this._saturation * this._value,
                svDivisor = l <= 1 ? l : 2 - l,
                saturation;

            // Avoid division by zero when lightness approaches zero:
            if (svDivisor < 1e-9) {
                saturation = 0;
            } else {
                saturation = sv / svDivisor;
            }
            return new color.HSL(this._hue, saturation, l / 2, this._alpha);
        },

        fromRgb: function fromRgb() {
            // Becomes one.color.RGB.prototype.hsv
            var red = this._red,
                green = this._green,
                blue = this._blue,
                max = Math.max(red, green, blue),
                min = Math.min(red, green, blue),
                delta = max - min,
                hue,
                saturation = max === 0 ? 0 : delta / max,
                value = max;
            if (delta === 0) {
                hue = 0;
            } else {
                switch (max) {
                    case red:
                        hue = (green - blue) / delta / 6 + (green < blue ? 1 : 0);
                        break;
                    case green:
                        hue = (blue - red) / delta / 6 + 1 / 3;
                        break;
                    case blue:
                        hue = (red - green) / delta / 6 + 2 / 3;
                        break;
                }
            }
            return new color.HSV(hue, saturation, value, this._alpha);
        }
    });
};

var HSL = function HSL(color) {
    color.use(HSV);

    color.installColorSpace('HSL', ['hue', 'saturation', 'lightness', 'alpha'], {
        hsv: function hsv() {
            // Algorithm adapted from http://wiki.secondlife.com/wiki/Color_conversion_scripts
            var l = this._lightness * 2,
                s = this._saturation * (l <= 1 ? l : 2 - l),
                saturation;

            // Avoid division by zero when l + s is very small (approaching black):
            if (l + s < 1e-9) {
                saturation = 0;
            } else {
                saturation = 2 * s / (l + s);
            }

            return new color.HSV(this._hue, saturation, (l + s) / 2, this._alpha);
        },

        rgb: function rgb() {
            return this.hsv().rgb();
        },

        fromRgb: function fromRgb() {
            // Becomes one.color.RGB.prototype.hsv
            return this.hsv().hsl();
        }
    });
};

var CMYK = function CMYK(color) {
    color.installColorSpace('CMYK', ['cyan', 'magenta', 'yellow', 'black', 'alpha'], {
        rgb: function rgb() {
            return new color.RGB(1 - this._cyan * (1 - this._black) - this._black, 1 - this._magenta * (1 - this._black) - this._black, 1 - this._yellow * (1 - this._black) - this._black, this._alpha);
        },

        fromRgb: function fromRgb() {
            // Becomes one.color.RGB.prototype.cmyk
            // Adapted from http://www.javascripter.net/faq/rgb2cmyk.htm
            var red = this._red,
                green = this._green,
                blue = this._blue,
                cyan = 1 - red,
                magenta = 1 - green,
                yellow = 1 - blue,
                black = 1;
            if (red || green || blue) {
                black = Math.min(cyan, Math.min(magenta, yellow));
                cyan = (cyan - black) / (1 - black);
                magenta = (magenta - black) / (1 - black);
                yellow = (yellow - black) / (1 - black);
            } else {
                black = 1;
            }
            return new color.CMYK(cyan, magenta, yellow, black, this._alpha);
        }
    });
};

var namedColors = function namedColors(color) {
    color.namedColors = {
        aliceblue: 'f0f8ff',
        antiquewhite: 'faebd7',
        aqua: '0ff',
        aquamarine: '7fffd4',
        azure: 'f0ffff',
        beige: 'f5f5dc',
        bisque: 'ffe4c4',
        black: '000',
        blanchedalmond: 'ffebcd',
        blue: '00f',
        blueviolet: '8a2be2',
        brown: 'a52a2a',
        burlywood: 'deb887',
        cadetblue: '5f9ea0',
        chartreuse: '7fff00',
        chocolate: 'd2691e',
        coral: 'ff7f50',
        cornflowerblue: '6495ed',
        cornsilk: 'fff8dc',
        crimson: 'dc143c',
        cyan: '0ff',
        darkblue: '00008b',
        darkcyan: '008b8b',
        darkgoldenrod: 'b8860b',
        darkgray: 'a9a9a9',
        darkgrey: 'a9a9a9',
        darkgreen: '006400',
        darkkhaki: 'bdb76b',
        darkmagenta: '8b008b',
        darkolivegreen: '556b2f',
        darkorange: 'ff8c00',
        darkorchid: '9932cc',
        darkred: '8b0000',
        darksalmon: 'e9967a',
        darkseagreen: '8fbc8f',
        darkslateblue: '483d8b',
        darkslategray: '2f4f4f',
        darkslategrey: '2f4f4f',
        darkturquoise: '00ced1',
        darkviolet: '9400d3',
        deeppink: 'ff1493',
        deepskyblue: '00bfff',
        dimgray: '696969',
        dimgrey: '696969',
        dodgerblue: '1e90ff',
        firebrick: 'b22222',
        floralwhite: 'fffaf0',
        forestgreen: '228b22',
        fuchsia: 'f0f',
        gainsboro: 'dcdcdc',
        ghostwhite: 'f8f8ff',
        gold: 'ffd700',
        goldenrod: 'daa520',
        gray: '808080',
        grey: '808080',
        green: '008000',
        greenyellow: 'adff2f',
        honeydew: 'f0fff0',
        hotpink: 'ff69b4',
        indianred: 'cd5c5c',
        indigo: '4b0082',
        ivory: 'fffff0',
        khaki: 'f0e68c',
        lavender: 'e6e6fa',
        lavenderblush: 'fff0f5',
        lawngreen: '7cfc00',
        lemonchiffon: 'fffacd',
        lightblue: 'add8e6',
        lightcoral: 'f08080',
        lightcyan: 'e0ffff',
        lightgoldenrodyellow: 'fafad2',
        lightgray: 'd3d3d3',
        lightgrey: 'd3d3d3',
        lightgreen: '90ee90',
        lightpink: 'ffb6c1',
        lightsalmon: 'ffa07a',
        lightseagreen: '20b2aa',
        lightskyblue: '87cefa',
        lightslategray: '789',
        lightslategrey: '789',
        lightsteelblue: 'b0c4de',
        lightyellow: 'ffffe0',
        lime: '0f0',
        limegreen: '32cd32',
        linen: 'faf0e6',
        magenta: 'f0f',
        maroon: '800000',
        mediumaquamarine: '66cdaa',
        mediumblue: '0000cd',
        mediumorchid: 'ba55d3',
        mediumpurple: '9370d8',
        mediumseagreen: '3cb371',
        mediumslateblue: '7b68ee',
        mediumspringgreen: '00fa9a',
        mediumturquoise: '48d1cc',
        mediumvioletred: 'c71585',
        midnightblue: '191970',
        mintcream: 'f5fffa',
        mistyrose: 'ffe4e1',
        moccasin: 'ffe4b5',
        navajowhite: 'ffdead',
        navy: '000080',
        oldlace: 'fdf5e6',
        olive: '808000',
        olivedrab: '6b8e23',
        orange: 'ffa500',
        orangered: 'ff4500',
        orchid: 'da70d6',
        palegoldenrod: 'eee8aa',
        palegreen: '98fb98',
        paleturquoise: 'afeeee',
        palevioletred: 'd87093',
        papayawhip: 'ffefd5',
        peachpuff: 'ffdab9',
        peru: 'cd853f',
        pink: 'ffc0cb',
        plum: 'dda0dd',
        powderblue: 'b0e0e6',
        purple: '800080',
        rebeccapurple: '639',
        red: 'f00',
        rosybrown: 'bc8f8f',
        royalblue: '4169e1',
        saddlebrown: '8b4513',
        salmon: 'fa8072',
        sandybrown: 'f4a460',
        seagreen: '2e8b57',
        seashell: 'fff5ee',
        sienna: 'a0522d',
        silver: 'c0c0c0',
        skyblue: '87ceeb',
        slateblue: '6a5acd',
        slategray: '708090',
        slategrey: '708090',
        snow: 'fffafa',
        springgreen: '00ff7f',
        steelblue: '4682b4',
        tan: 'd2b48c',
        teal: '008080',
        thistle: 'd8bfd8',
        tomato: 'ff6347',
        turquoise: '40e0d0',
        violet: 'ee82ee',
        wheat: 'f5deb3',
        white: 'fff',
        whitesmoke: 'f5f5f5',
        yellow: 'ff0',
        yellowgreen: '9acd32'
    };
};

var clearer = function clearer(color) {
    color.installMethod('clearer', function (amount) {
        return this.alpha(isNaN(amount) ? -0.1 : -amount, true);
    });
};

var darken = function darken(color) {
    color.use(HSL);

    color.installMethod('darken', function (amount) {
        return this.lightness(isNaN(amount) ? -0.1 : -amount, true);
    });
};

var desaturate = function desaturate(color) {
    color.use(HSL);

    color.installMethod('desaturate', function (amount) {
        return this.saturation(isNaN(amount) ? -0.1 : -amount, true);
    });
};

var grayscale = function grayscale(color) {
    function gs() {
        /*jslint strict:false*/
        var rgb = this.rgb(),
            val = rgb._red * 0.3 + rgb._green * 0.59 + rgb._blue * 0.11;

        return new color.RGB(val, val, val, rgb._alpha);
    }

    color.installMethod('greyscale', gs).installMethod('grayscale', gs);
};

var lighten = function lighten(color) {
    color.use(HSL);

    color.installMethod('lighten', function (amount) {
        return this.lightness(isNaN(amount) ? 0.1 : amount, true);
    });
};

var mix = function mix(color) {
    color.installMethod('mix', function (otherColor, weight) {
        otherColor = color(otherColor).rgb();
        weight = 1 - (isNaN(weight) ? 0.5 : weight);

        var w = weight * 2 - 1,
            a = this._alpha - otherColor._alpha,
            weight1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2,
            weight2 = 1 - weight1,
            rgb = this.rgb();

        return new color.RGB(rgb._red * weight1 + otherColor._red * weight2, rgb._green * weight1 + otherColor._green * weight2, rgb._blue * weight1 + otherColor._blue * weight2, rgb._alpha * weight + otherColor._alpha * (1 - weight));
    });
};

var negate = function negate(color) {
    color.installMethod('negate', function () {
        var rgb = this.rgb();
        return new color.RGB(1 - rgb._red, 1 - rgb._green, 1 - rgb._blue, this._alpha);
    });
};

var opaquer = function opaquer(color) {
    color.installMethod('opaquer', function (amount) {
        return this.alpha(isNaN(amount) ? 0.1 : amount, true);
    });
};

var rotate = function rotate(color) {
    color.use(HSL);

    color.installMethod('rotate', function (degrees) {
        return this.hue((degrees || 0) / 360, true);
    });
};

var saturate = function saturate(color) {
    color.use(HSL);

    color.installMethod('saturate', function (amount) {
        return this.saturation(isNaN(amount) ? 0.1 : amount, true);
    });
};

// Adapted from http://gimp.sourcearchive.com/documentation/2.6.6-1ubuntu1/color-to-alpha_8c-source.html
// toAlpha returns a color where the values of the argument have been converted to alpha
var toAlpha = function toAlpha(color) {
    color.installMethod('toAlpha', function (color) {
        var me = this.rgb(),
            other = color(color).rgb(),
            epsilon = 1e-10,
            a = new color.RGB(0, 0, 0, me._alpha),
            channels = ['_red', '_green', '_blue'];

        channels.forEach(function (channel) {
            if (me[channel] < epsilon) {
                a[channel] = me[channel];
            } else if (me[channel] > other[channel]) {
                a[channel] = (me[channel] - other[channel]) / (1 - other[channel]);
            } else if (me[channel] > other[channel]) {
                a[channel] = (other[channel] - me[channel]) / other[channel];
            } else {
                a[channel] = 0;
            }
        });

        if (a._red > a._green) {
            if (a._red > a._blue) {
                me._alpha = a._red;
            } else {
                me._alpha = a._blue;
            }
        } else if (a._green > a._blue) {
            me._alpha = a._green;
        } else {
            me._alpha = a._blue;
        }

        if (me._alpha < epsilon) {
            return me;
        }

        channels.forEach(function (channel) {
            me[channel] = (me[channel] - other[channel]) / me._alpha + other[channel];
        });
        me._alpha *= a._alpha;

        return me;
    });
};

var onecolor = color_1.use(XYZ).use(LAB).use(HSV).use(HSL).use(CMYK)

// Convenience functions
.use(namedColors).use(clearer).use(darken).use(desaturate).use(grayscale).use(lighten).use(mix).use(negate).use(opaquer).use(rotate).use(saturate).use(toAlpha);

function getContrastRatio(foreground, background) {
    var backgroundOnWhite = alphaBlend(background, '#fff');
    var backgroundOnBlack = alphaBlend(background, '#000');

    var LWhite = getRelativeLuminance(backgroundOnWhite);
    var LBlack = getRelativeLuminance(backgroundOnBlack);
    var LForeground = getRelativeLuminance(foreground);

    if (LWhite < LForeground) {
        return getContrastRatioOpaque(foreground, backgroundOnWhite);
    } else if (LBlack > LForeground) {
        return getContrastRatioOpaque(foreground, backgroundOnBlack);
    } else {
        return 1;
    }
}

function alphaBlend(cssForeground, cssBackground) {
    var foreground = onecolor(cssForeground);
    var background = onecolor(cssBackground);
    var result = onecolor('#fff');
    var a = foreground.alpha();

    result._red = foreground._red * a + background._red * (1 - a);
    result._green = foreground._green * a + background._green * (1 - a);
    result._blue = foreground._blue * a + background._blue * (1 - a);

    return result;
}

function getContrastRatioOpaque(foreground, background) {
    var L1 = getRelativeLuminance(background);
    var L2 = getRelativeLuminance(alphaBlend(foreground, background));

    // https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05);
}

function getRelativeLuminance(cssColor) {
    // https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    var color = onecolor(cssColor);

    var R = color._red <= 0.03928 ? color._red / 12.92 : Math.pow((color._red + 0.055) / 1.055, 2.4);
    var G = color._green <= 0.03928 ? color._green / 12.92 : Math.pow((color._green + 0.055) / 1.055, 2.4);
    var B = color._blue <= 0.03928 ? color._blue / 12.92 : Math.pow((color._blue + 0.055) / 1.055, 2.4);

    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;

    return L;
}

module.exports = getContrastRatio;

/***/ }),

/***/ "cC7r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var bound_1 = __webpack_require__("USDo");
var Seat_1 = __webpack_require__("qrdL");
var Utils_1 = __webpack_require__("o6Mn");
var Config_1 = __webpack_require__("gH/r");

var Seat = function (_Seat_1$default) {
    _inherits(Seat, _Seat_1$default);

    function Seat(seatData, actions, disableInteraction) {
        _classCallCheck(this, Seat);

        var _this = _possibleConstructorReturn(this, _Seat_1$default.call(this, seatData, actions, disableInteraction));

        var key = _this.createKey();
        var alreadyExists = Config_1.default.ticketMappingRepo.has(key);
        if (!alreadyExists) {
            _this.createTexture(key);
        }
        var rt = Config_1.default.ticketMappingRepo.get(key);
        var sprite = new PIXI.Sprite(rt);
        sprite.anchor = new PIXI.ObservablePoint(function () {}, undefined, 0.5, 0.5);
        sprite.visible = true;
        _this.seatContainer.addChild(sprite);
        if (_this.disabled) {
            _this.text.visible = false;
            _this.seat.visible = false;
            sprite.visible = false;
        }
        return _this;
    }

    Seat.prototype.createKey = function createKey() {
        return this.ticketIds.reduce(function (str, ticketId) {
            return "" + str + ticketId;
        }, "");
    };

    Seat.prototype.determineTextureType = function determineTextureType() {
        this.text.fill = 0x000000;
        var textureName = Utils_1.seatUnavailableTexture;
        this.seatTexture = PIXI.loader.resources[textureName].texture;
        this.seatTexture.baseTexture.mipmap = true;
    };

    Seat.prototype.createTexture = function createTexture(key) {
        this.ticketTypeGraphics = new PIXI.Graphics();
        this.ticketTypeGraphics.visible = true;
        this.ticketTypeGraphics.clear();
        this.ticketTypeGraphics.drawTicketTypeColor(Config_1.default.getSpecificTicketTypeColors(this.ticketIds), Utils_1.seatWidth / 2 - 1);
        var rt = Config_1.default.app.renderer.generateTexture(this.ticketTypeGraphics);
        Config_1.default.ticketMappingRepo.set(key, rt);
    };

    return Seat;
}(Seat_1.default);

__decorate([bound_1.default], Seat.prototype, "determineTextureType", null);
__decorate([bound_1.default], Seat.prototype, "createTexture", null);
exports.default = Seat;
//# sourceMappingURL=Seat.js.map

/***/ }),

/***/ "cSRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);

/***/ }),

/***/ "ce6K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__("dDI1");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

var _eventemitter = __webpack_require__("wCSE");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _determineCrossOrigin = __webpack_require__("f1vj");

var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);

var _bitTwiddle = __webpack_require__("gXRl");

var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A texture stores the information that represents an image. All textures have a base texture.
 *
 * @class
 * @extends EventEmitter
 * @memberof PIXI
 */
var BaseTexture = function (_EventEmitter) {
    _inherits(BaseTexture, _EventEmitter);

    /**
     * @param {HTMLImageElement|HTMLCanvasElement} [source] - the source object of the texture.
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture
     */
    function BaseTexture(source, scaleMode, resolution) {
        _classCallCheck(this, BaseTexture);

        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        _this.uid = (0, _utils.uid)();

        _this.touched = 0;

        /**
         * The resolution / device pixel ratio of the texture
         *
         * @member {number}
         * @default 1
         */
        _this.resolution = resolution || _settings2.default.RESOLUTION;

        /**
         * The width of the base texture set when the image has loaded
         *
         * @readonly
         * @member {number}
         */
        _this.width = 100;

        /**
         * The height of the base texture set when the image has loaded
         *
         * @readonly
         * @member {number}
         */
        _this.height = 100;

        // TODO docs
        // used to store the actual dimensions of the source
        /**
         * Used to store the actual width of the source of this texture
         *
         * @readonly
         * @member {number}
         */
        _this.realWidth = 100;
        /**
         * Used to store the actual height of the source of this texture
         *
         * @readonly
         * @member {number}
         */
        _this.realHeight = 100;

        /**
         * The scale mode to apply when scaling this texture
         *
         * @member {number}
         * @default PIXI.settings.SCALE_MODE
         * @see PIXI.SCALE_MODES
         */
        _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;

        /**
         * Set to true once the base texture has successfully loaded.
         *
         * This is never true if the underlying source fails to load or has no texture data.
         *
         * @readonly
         * @member {boolean}
         */
        _this.hasLoaded = false;

        /**
         * Set to true if the source is currently loading.
         *
         * If an Image source is loading the 'loaded' or 'error' event will be
         * dispatched when the operation ends. An underyling source that is
         * immediately-available bypasses loading entirely.
         *
         * @readonly
         * @member {boolean}
         */
        _this.isLoading = false;

        /**
         * The image source that is used to create the texture.
         *
         * TODO: Make this a setter that calls loadSource();
         *
         * @readonly
         * @member {HTMLImageElement|HTMLCanvasElement}
         */
        _this.source = null; // set in loadSource, if at all

        /**
         * The image source that is used to create the texture. This is used to
         * store the original Svg source when it is replaced with a canvas element.
         *
         * TODO: Currently not in use but could be used when re-scaling svg.
         *
         * @readonly
         * @member {Image}
         */
        _this.origSource = null; // set in loadSvg, if at all

        /**
         * Type of image defined in source, eg. `png` or `svg`
         *
         * @readonly
         * @member {string}
         */
        _this.imageType = null; // set in updateImageType

        /**
         * Scale for source image. Used with Svg images to scale them before rasterization.
         *
         * @readonly
         * @member {number}
         */
        _this.sourceScale = 1.0;

        /**
         * Controls if RGB channels should be pre-multiplied by Alpha  (WebGL only)
         * All blend modes, and shaders written for default value. Change it on your own risk.
         *
         * @member {boolean}
         * @default true
         */
        _this.premultipliedAlpha = true;

        /**
         * The image url of the texture
         *
         * @member {string}
         */
        _this.imageUrl = null;

        /**
         * Whether or not the texture is a power of two, try to use power of two textures as much
         * as you can
         *
         * @private
         * @member {boolean}
         */
        _this.isPowerOfTwo = false;

        // used for webGL

        /**
         *
         * Set this to true if a mipmap of this texture needs to be generated. This value needs
         * to be set before the texture is used
         * Also the texture must be a power of two size to work
         *
         * @member {boolean}
         * @see PIXI.MIPMAP_TEXTURES
         */
        _this.mipmap = _settings2.default.MIPMAP_TEXTURES;

        /**
         *
         * WebGL Texture wrap mode
         *
         * @member {number}
         * @see PIXI.WRAP_MODES
         */
        _this.wrapMode = _settings2.default.WRAP_MODE;

        /**
         * A map of renderer IDs to webgl textures
         *
         * @private
         * @member {object<number, WebGLTexture>}
         */
        _this._glTextures = {};

        _this._enabled = 0;
        _this._virtalBoundId = -1;

        /**
         * If the object has been destroyed via destroy(). If true, it should not be used.
         *
         * @member {boolean}
         * @private
         * @readonly
         */
        _this._destroyed = false;

        /**
         * The ids under which this BaseTexture has been added to the base texture cache. This is
         * automatically set as long as BaseTexture.addToCache is used, but may not be set if a
         * BaseTexture is added directly to the BaseTextureCache array.
         *
         * @member {string[]}
         */
        _this.textureCacheIds = [];

        // if no source passed don't try to load
        if (source) {
            _this.loadSource(source);
        }

        /**
         * Fired when a not-immediately-available source finishes loading.
         *
         * @protected
         * @event PIXI.BaseTexture#loaded
         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
         */

        /**
         * Fired when a not-immediately-available source fails to load.
         *
         * @protected
         * @event PIXI.BaseTexture#error
         * @param {PIXI.BaseTexture} baseTexture - Resource errored.
         */

        /**
         * Fired when BaseTexture is updated.
         *
         * @protected
         * @event PIXI.BaseTexture#update
         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being updated.
         */

        /**
         * Fired when BaseTexture is destroyed.
         *
         * @protected
         * @event PIXI.BaseTexture#dispose
         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being destroyed.
         */
        return _this;
    }

    /**
     * Updates the texture on all the webgl renderers, this also assumes the src has changed.
     *
     * @fires PIXI.BaseTexture#update
     */

    BaseTexture.prototype.update = function update() {
        // Svg size is handled during load
        if (this.imageType !== 'svg') {
            this.realWidth = this.source.naturalWidth || this.source.videoWidth || this.source.width;
            this.realHeight = this.source.naturalHeight || this.source.videoHeight || this.source.height;

            this._updateDimensions();
        }

        this.emit('update', this);
    };

    /**
     * Update dimensions from real values
     */

    BaseTexture.prototype._updateDimensions = function _updateDimensions() {
        this.width = this.realWidth / this.resolution;
        this.height = this.realHeight / this.resolution;

        this.isPowerOfTwo = _bitTwiddle2.default.isPow2(this.realWidth) && _bitTwiddle2.default.isPow2(this.realHeight);
    };

    /**
     * Load a source.
     *
     * If the source is not-immediately-available, such as an image that needs to be
     * downloaded, then the 'loaded' or 'error' event will be dispatched in the future
     * and `hasLoaded` will remain false after this call.
     *
     * The logic state after calling `loadSource` directly or indirectly (eg. `fromImage`, `new BaseTexture`) is:
     *
     *     if (texture.hasLoaded) {
     *        // texture ready for use
     *     } else if (texture.isLoading) {
     *        // listen to 'loaded' and/or 'error' events on texture
     *     } else {
     *        // not loading, not going to load UNLESS the source is reloaded
     *        // (it may still make sense to listen to the events)
     *     }
     *
     * @protected
     * @param {HTMLImageElement|HTMLCanvasElement} source - the source object of the texture.
     */

    BaseTexture.prototype.loadSource = function loadSource(source) {
        var wasLoading = this.isLoading;

        this.hasLoaded = false;
        this.isLoading = false;

        if (wasLoading && this.source) {
            this.source.onload = null;
            this.source.onerror = null;
        }

        var firstSourceLoaded = !this.source;

        this.source = source;

        // Apply source if loaded. Otherwise setup appropriate loading monitors.
        if ((source.src && source.complete || source.getContext) && source.width && source.height) {
            this._updateImageType();

            if (this.imageType === 'svg') {
                this._loadSvgSource();
            } else {
                this._sourceLoaded();
            }

            if (firstSourceLoaded) {
                // send loaded event if previous source was null and we have been passed a pre-loaded IMG element
                this.emit('loaded', this);
            }
        } else if (!source.getContext) {
            // Image fail / not ready
            this.isLoading = true;

            var scope = this;

            source.onload = function () {
                scope._updateImageType();
                source.onload = null;
                source.onerror = null;

                if (!scope.isLoading) {
                    return;
                }

                scope.isLoading = false;
                scope._sourceLoaded();

                if (scope.imageType === 'svg') {
                    scope._loadSvgSource();

                    return;
                }

                scope.emit('loaded', scope);
            };

            source.onerror = function () {
                source.onload = null;
                source.onerror = null;

                if (!scope.isLoading) {
                    return;
                }

                scope.isLoading = false;
                scope.emit('error', scope);
            };

            // Per http://www.w3.org/TR/html5/embedded-content-0.html#the-img-element
            //   "The value of `complete` can thus change while a script is executing."
            // So complete needs to be re-checked after the callbacks have been added..
            // NOTE: complete will be true if the image has no src so best to check if the src is set.
            if (source.complete && source.src) {
                // ..and if we're complete now, no need for callbacks
                source.onload = null;
                source.onerror = null;

                if (scope.imageType === 'svg') {
                    scope._loadSvgSource();

                    return;
                }

                this.isLoading = false;

                if (source.width && source.height) {
                    this._sourceLoaded();

                    // If any previous subscribers possible
                    if (wasLoading) {
                        this.emit('loaded', this);
                    }
                }
                // If any previous subscribers possible
                else if (wasLoading) {
                        this.emit('error', this);
                    }
            }
        }
    };

    /**
     * Updates type of the source image.
     */

    BaseTexture.prototype._updateImageType = function _updateImageType() {
        if (!this.imageUrl) {
            return;
        }

        var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);
        var imageType = void 0;

        if (dataUri && dataUri.mediaType === 'image') {
            // Check for subType validity
            var firstSubType = dataUri.subType.split('+')[0];

            imageType = (0, _utils.getUrlFileExtension)('.' + firstSubType);

            if (!imageType) {
                throw new Error('Invalid image type in data URI.');
            }
        } else {
            imageType = (0, _utils.getUrlFileExtension)(this.imageUrl);

            if (!imageType) {
                imageType = 'png';
            }
        }

        this.imageType = imageType;
    };

    /**
     * Checks if `source` is an SVG image and whether it's loaded via a URL or a data URI. Then calls
     * `_loadSvgSourceUsingDataUri` or `_loadSvgSourceUsingXhr`.
     */

    BaseTexture.prototype._loadSvgSource = function _loadSvgSource() {
        if (this.imageType !== 'svg') {
            // Do nothing if source is not svg
            return;
        }

        var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);

        if (dataUri) {
            this._loadSvgSourceUsingDataUri(dataUri);
        } else {
            // We got an URL, so we need to do an XHR to check the svg size
            this._loadSvgSourceUsingXhr();
        }
    };

    /**
     * Reads an SVG string from data URI and then calls `_loadSvgSourceUsingString`.
     *
     * @param {string} dataUri - The data uri to load from.
     */

    BaseTexture.prototype._loadSvgSourceUsingDataUri = function _loadSvgSourceUsingDataUri(dataUri) {
        var svgString = void 0;

        if (dataUri.encoding === 'base64') {
            if (!atob) {
                throw new Error('Your browser doesn\'t support base64 conversions.');
            }
            svgString = atob(dataUri.data);
        } else {
            svgString = dataUri.data;
        }

        this._loadSvgSourceUsingString(svgString);
    };

    /**
     * Loads an SVG string from `imageUrl` using XHR and then calls `_loadSvgSourceUsingString`.
     */

    BaseTexture.prototype._loadSvgSourceUsingXhr = function _loadSvgSourceUsingXhr() {
        var _this2 = this;

        var svgXhr = new XMLHttpRequest();

        // This throws error on IE, so SVG Document can't be used
        // svgXhr.responseType = 'document';

        // This is not needed since we load the svg as string (breaks IE too)
        // but overrideMimeType() can be used to force the response to be parsed as XML
        // svgXhr.overrideMimeType('image/svg+xml');

        svgXhr.onload = function () {
            if (svgXhr.readyState !== svgXhr.DONE || svgXhr.status !== 200) {
                throw new Error('Failed to load SVG using XHR.');
            }

            _this2._loadSvgSourceUsingString(svgXhr.response);
        };

        svgXhr.onerror = function () {
            return _this2.emit('error', _this2);
        };

        svgXhr.open('GET', this.imageUrl, true);
        svgXhr.send();
    };

    /**
     * Loads texture using an SVG string. The original SVG Image is stored as `origSource` and the
     * created canvas is the new `source`. The SVG is scaled using `sourceScale`. Called by
     * `_loadSvgSourceUsingXhr` or `_loadSvgSourceUsingDataUri`.
     *
     * @param  {string} svgString SVG source as string
     *
     * @fires PIXI.BaseTexture#loaded
     */

    BaseTexture.prototype._loadSvgSourceUsingString = function _loadSvgSourceUsingString(svgString) {
        var svgSize = (0, _utils.getSvgSize)(svgString);

        var svgWidth = svgSize.width;
        var svgHeight = svgSize.height;

        if (!svgWidth || !svgHeight) {
            throw new Error('The SVG image must have width and height defined (in pixels), canvas API needs them.');
        }

        // Scale realWidth and realHeight
        this.realWidth = Math.round(svgWidth * this.sourceScale);
        this.realHeight = Math.round(svgHeight * this.sourceScale);

        this._updateDimensions();

        // Create a canvas element
        var canvas = document.createElement('canvas');

        canvas.width = this.realWidth;
        canvas.height = this.realHeight;
        canvas._pixiId = 'canvas_' + (0, _utils.uid)();

        // Draw the Svg to the canvas
        canvas.getContext('2d').drawImage(this.source, 0, 0, svgWidth, svgHeight, 0, 0, this.realWidth, this.realHeight);

        // Replace the original source image with the canvas
        this.origSource = this.source;
        this.source = canvas;

        // Add also the canvas in cache (destroy clears by `imageUrl` and `source._pixiId`)
        BaseTexture.addToCache(this, canvas._pixiId);

        this.isLoading = false;
        this._sourceLoaded();
        this.emit('loaded', this);
    };

    /**
     * Used internally to update the width, height, and some other tracking vars once
     * a source has successfully loaded.
     *
     * @private
     */

    BaseTexture.prototype._sourceLoaded = function _sourceLoaded() {
        this.hasLoaded = true;
        this.update();
    };

    /**
     * Destroys this base texture
     *
     */

    BaseTexture.prototype.destroy = function destroy() {
        if (this.imageUrl) {
            delete _utils.TextureCache[this.imageUrl];

            this.imageUrl = null;

            if (!navigator.isCocoonJS) {
                this.source.src = '';
            }
        }

        this.source = null;

        this.dispose();

        BaseTexture.removeFromCache(this);
        this.textureCacheIds = null;

        this._destroyed = true;
    };

    /**
     * Frees the texture from WebGL memory without destroying this texture object.
     * This means you can still use the texture later which will upload it to GPU
     * memory again.
     *
     * @fires PIXI.BaseTexture#dispose
     */

    BaseTexture.prototype.dispose = function dispose() {
        this.emit('dispose', this);
    };

    /**
     * Changes the source image of the texture.
     * The original source must be an Image element.
     *
     * @param {string} newSrc - the path of the image
     */

    BaseTexture.prototype.updateSourceImage = function updateSourceImage(newSrc) {
        this.source.src = newSrc;

        this.loadSource(this.source);
    };

    /**
     * Helper function that creates a base texture from the given image url.
     * If the image is not in the base texture cache it will be created and loaded.
     *
     * @static
     * @param {string} imageUrl - The image url of the texture
     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
     * @return {PIXI.BaseTexture} The new base texture.
     */

    BaseTexture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
        var baseTexture = _utils.BaseTextureCache[imageUrl];

        if (!baseTexture) {
            // new Image() breaks tex loading in some versions of Chrome.
            // See https://code.google.com/p/chromium/issues/detail?id=238071
            var image = new Image(); // document.createElement('img');

            if (crossorigin === undefined && imageUrl.indexOf('data:') !== 0) {
                image.crossOrigin = (0, _determineCrossOrigin2.default)(imageUrl);
            } else if (crossorigin) {
                image.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
            }

            baseTexture = new BaseTexture(image, scaleMode);
            baseTexture.imageUrl = imageUrl;

            if (sourceScale) {
                baseTexture.sourceScale = sourceScale;
            }

            // if there is an @2x at the end of the url we are going to assume its a highres image
            baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);

            image.src = imageUrl; // Setting this triggers load

            BaseTexture.addToCache(baseTexture, imageUrl);
        }

        return baseTexture;
    };

    /**
     * Helper function that creates a base texture from the given canvas element.
     *
     * @static
     * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
     * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
     * @param {string} [origin='canvas'] - A string origin of who created the base texture
     * @return {PIXI.BaseTexture} The new base texture.
     */

    BaseTexture.fromCanvas = function fromCanvas(canvas, scaleMode) {
        var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'canvas';

        if (!canvas._pixiId) {
            canvas._pixiId = origin + '_' + (0, _utils.uid)();
        }

        var baseTexture = _utils.BaseTextureCache[canvas._pixiId];

        if (!baseTexture) {
            baseTexture = new BaseTexture(canvas, scaleMode);
            BaseTexture.addToCache(baseTexture, canvas._pixiId);
        }

        return baseTexture;
    };

    /**
     * Helper function that creates a base texture based on the source you provide.
     * The source can be - image url, image element, canvas element. If the
     * source is an image url or an image element and not in the base texture
     * cache, it will be created and loaded.
     *
     * @static
     * @param {string|HTMLImageElement|HTMLCanvasElement} source - The source to create base texture from.
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
     * @return {PIXI.BaseTexture} The new base texture.
     */

    BaseTexture.from = function from(source, scaleMode, sourceScale) {
        if (typeof source === 'string') {
            return BaseTexture.fromImage(source, undefined, scaleMode, sourceScale);
        } else if (source instanceof HTMLImageElement) {
            var imageUrl = source.src;
            var baseTexture = _utils.BaseTextureCache[imageUrl];

            if (!baseTexture) {
                baseTexture = new BaseTexture(source, scaleMode);
                baseTexture.imageUrl = imageUrl;

                if (sourceScale) {
                    baseTexture.sourceScale = sourceScale;
                }

                // if there is an @2x at the end of the url we are going to assume its a highres image
                baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);

                BaseTexture.addToCache(baseTexture, imageUrl);
            }

            return baseTexture;
        } else if (source instanceof HTMLCanvasElement) {
            return BaseTexture.fromCanvas(source, scaleMode);
        }

        // lets assume its a base texture!
        return source;
    };

    /**
     * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
     *
     * @static
     * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
     * @param {string} id - The id that the BaseTexture will be stored against.
     */

    BaseTexture.addToCache = function addToCache(baseTexture, id) {
        if (id) {
            if (baseTexture.textureCacheIds.indexOf(id) === -1) {
                baseTexture.textureCacheIds.push(id);
            }

            // @if DEBUG
            /* eslint-disable no-console */
            if (_utils.BaseTextureCache[id]) {
                console.warn('BaseTexture added to the cache with an id [' + id + '] that already had an entry');
            }
            /* eslint-enable no-console */
            // @endif

            _utils.BaseTextureCache[id] = baseTexture;
        }
    };

    /**
     * Remove a BaseTexture from the global BaseTextureCache.
     *
     * @static
     * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
     * @return {PIXI.BaseTexture|null} The BaseTexture that was removed.
     */

    BaseTexture.removeFromCache = function removeFromCache(baseTexture) {
        if (typeof baseTexture === 'string') {
            var baseTextureFromCache = _utils.BaseTextureCache[baseTexture];

            if (baseTextureFromCache) {
                var index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);

                if (index > -1) {
                    baseTextureFromCache.textureCacheIds.splice(index, 1);
                }

                delete _utils.BaseTextureCache[baseTexture];

                return baseTextureFromCache;
            }
        } else if (baseTexture && baseTexture.textureCacheIds) {
            for (var i = 0; i < baseTexture.textureCacheIds.length; ++i) {
                delete _utils.BaseTextureCache[baseTexture.textureCacheIds[i]];
            }

            baseTexture.textureCacheIds.length = 0;

            return baseTexture;
        }

        return null;
    };

    return BaseTexture;
}(_eventemitter2.default);

exports.default = BaseTexture;
//# sourceMappingURL=BaseTexture.js.map

/***/ }),

/***/ "cixM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var utils = __webpack_require__("GZIj");
var Plugin = __webpack_require__("sh3Y");

module.exports = function (_Plugin) {
    _inherits(Bounce, _Plugin);

    /**
     * @private
     * @param {Viewport} parent
     * @param {object} [options]
     * @param {string} [options.sides=all] all, horizontal, vertical, or combination of top, bottom, right, left (e.g., 'top-bottom-right')
     * @param {number} [options.friction=0.5] friction to apply to decelerate if active
     * @param {number} [options.time=150] time in ms to finish bounce
     * @param {string|function} [ease=easeInOutSine] ease function or name (see http://easings.net/ for supported names)
     * @param {string} [options.underflow=center] (top/bottom/center and left/right/center, or center) where to place world if too small for screen
     * @fires bounce-start-x
     * @fires bounce.end-x
     * @fires bounce-start-y
     * @fires bounce-end-y
     */
    function Bounce(parent, options) {
        _classCallCheck(this, Bounce);

        var _this = _possibleConstructorReturn(this, (Bounce.__proto__ || Object.getPrototypeOf(Bounce)).call(this, parent));

        options = options || {};
        _this.time = options.time || 150;
        _this.ease = utils.ease(options.ease, 'easeInOutSine');
        _this.friction = options.friction || 0.5;
        options.sides = options.sides || 'all';
        if (options.sides) {
            if (options.sides === 'all') {
                _this.top = _this.bottom = _this.left = _this.right = true;
            } else if (options.sides === 'horizontal') {
                _this.right = _this.left = true;
            } else if (options.sides === 'vertical') {
                _this.top = _this.bottom = true;
            } else {
                _this.top = options.sides.indexOf('top') !== -1;
                _this.bottom = options.sides.indexOf('bottom') !== -1;
                _this.left = options.sides.indexOf('left') !== -1;
                _this.right = options.sides.indexOf('right') !== -1;
            }
        }
        _this.parseUnderflow(options.underflow || 'center');
        _this.last = {};
        _this.reset();
        return _this;
    }

    _createClass(Bounce, [{
        key: 'parseUnderflow',
        value: function parseUnderflow(clamp) {
            clamp = clamp.toLowerCase();
            if (clamp === 'center') {
                this.underflowX = 0;
                this.underflowY = 0;
            } else {
                this.underflowX = clamp.indexOf('left') !== -1 ? -1 : clamp.indexOf('right') !== -1 ? 1 : 0;
                this.underflowY = clamp.indexOf('top') !== -1 ? -1 : clamp.indexOf('bottom') !== -1 ? 1 : 0;
            }
        }
    }, {
        key: 'isActive',
        value: function isActive() {
            return this.toX !== null || this.toY !== null;
        }
    }, {
        key: 'down',
        value: function down() {
            this.toX = this.toY = null;
        }
    }, {
        key: 'up',
        value: function up() {
            this.bounce();
        }
    }, {
        key: 'update',
        value: function update(elapsed) {
            if (this.paused) {
                return;
            }

            this.bounce();
            if (this.toX) {
                var toX = this.toX;
                toX.time += elapsed;
                this.parent.emit('moved', { viewport: this.parent, type: 'bounce-x' });
                if (toX.time >= this.time) {
                    this.parent.x = toX.end;
                    this.toX = null;
                    this.parent.emit('bounce-x-end', this.parent);
                } else {
                    this.parent.x = this.ease(toX.time, toX.start, toX.delta, this.time);
                }
            }
            if (this.toY) {
                var toY = this.toY;
                toY.time += elapsed;
                this.parent.emit('moved', { viewport: this.parent, type: 'bounce-y' });
                if (toY.time >= this.time) {
                    this.parent.y = toY.end;
                    this.toY = null;
                    this.parent.emit('bounce-y-end', this.parent);
                } else {
                    this.parent.y = this.ease(toY.time, toY.start, toY.delta, this.time);
                }
            }
        }
    }, {
        key: 'calcUnderflowX',
        value: function calcUnderflowX() {
            var x = void 0;
            switch (this.underflowX) {
                case -1:
                    x = 0;
                    break;
                case 1:
                    x = this.parent.screenWidth - this.parent.screenWorldWidth;
                    break;
                default:
                    x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
            }
            return x;
        }
    }, {
        key: 'calcUnderflowY',
        value: function calcUnderflowY() {
            var y = void 0;
            switch (this.underflowY) {
                case -1:
                    y = 0;
                    break;
                case 1:
                    y = this.parent.screenHeight - this.parent.screenWorldHeight;
                    break;
                default:
                    y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
            }
            return y;
        }
    }, {
        key: 'bounce',
        value: function bounce() {
            if (this.paused) {
                return;
            }

            var oob = void 0;
            var decelerate = this.parent.plugins['decelerate'];
            if (decelerate && (decelerate.x || decelerate.y)) {
                if (decelerate.x && decelerate.percentChangeX === decelerate.friction || decelerate.y && decelerate.percentChangeY === decelerate.friction) {
                    oob = this.parent.OOB();
                    if (oob.left && this.left || oob.right && this.right) {
                        decelerate.percentChangeX = this.friction;
                    }
                    if (oob.top && this.top || oob.bottom && this.bottom) {
                        decelerate.percentChangeY = this.friction;
                    }
                }
            }
            var drag = this.parent.plugins['drag'] || {};
            var pinch = this.parent.plugins['pinch'] || {};
            decelerate = decelerate || {};
            if (!drag.active && !pinch.active && (!this.toX || !this.toY) && (!decelerate.x || !decelerate.y)) {
                oob = oob || this.parent.OOB();
                var point = oob.cornerPoint;
                if (!this.toX && !decelerate.x) {
                    var x = null;
                    if (oob.left && this.left) {
                        x = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : 0;
                    } else if (oob.right && this.right) {
                        x = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -point.x;
                    }
                    if (x !== null && this.parent.x !== x) {
                        this.toX = { time: 0, start: this.parent.x, delta: x - this.parent.x, end: x };
                        this.parent.emit('bounce-x-start', this.parent);
                    }
                }
                if (!this.toY && !decelerate.y) {
                    var y = null;
                    if (oob.top && this.top) {
                        y = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : 0;
                    } else if (oob.bottom && this.bottom) {
                        y = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -point.y;
                    }
                    if (y !== null && this.parent.y !== y) {
                        this.toY = { time: 0, start: this.parent.y, delta: y - this.parent.y, end: y };
                        this.parent.emit('bounce-y-start', this.parent);
                    }
                }
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.toX = this.toY = null;
        }
    }]);

    return Bounce;
}(Plugin);

/***/ }),

/***/ "ctPN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = __webpack_require__("sh3Y");

module.exports = function (_Plugin) {
    _inherits(Follow, _Plugin);

    /**
     * @private
     * @param {Viewport} parent
     * @param {PIXI.DisplayObject} target to follow (object must include {x: x-coordinate, y: y-coordinate})
     * @param {object} [options]
     * @param {number} [options.speed=0] to follow in pixels/frame (0=teleport to location)
     * @param {number} [options.acceleration] set acceleration to accelerate and decelerate at this rate; speed cannot be 0 to use acceleration
     * @param {number} [options.radius] radius (in world coordinates) of center circle where movement is allowed without moving the viewport
     */
    function Follow(parent, target, options) {
        _classCallCheck(this, Follow);

        var _this = _possibleConstructorReturn(this, (Follow.__proto__ || Object.getPrototypeOf(Follow)).call(this, parent));

        options = options || {};
        _this.speed = options.speed || 0;
        _this.acceleration = options.acceleration || 0;
        _this.velocity = { x: 0, y: 0 };
        _this.target = target;
        _this.radius = options.radius;
        return _this;
    }

    _createClass(Follow, [{
        key: 'update',
        value: function update(elapsed) {
            if (this.paused) {
                return;
            }

            var center = this.parent.center;
            var toX = this.target.x,
                toY = this.target.y;
            if (this.radius) {
                var distance = Math.sqrt(Math.pow(this.target.y - center.y, 2) + Math.pow(this.target.x - center.x, 2));
                if (distance > this.radius) {
                    var angle = Math.atan2(this.target.y - center.y, this.target.x - center.x);
                    toX = this.target.x - Math.cos(angle) * this.radius;
                    toY = this.target.y - Math.sin(angle) * this.radius;
                } else {
                    return;
                }
            }
            var deltaX = toX - center.x;
            var deltaY = toY - center.y;
            if (deltaX || deltaY) {
                if (this.speed) {
                    if (this.acceleration) {
                        var _angle = Math.atan2(toY - center.y, toX - center.x);
                        var _distance = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
                        if (_distance) {
                            var decelerationDistance = (Math.pow(this.velocity.x, 2) + Math.pow(this.velocity.y, 2)) / (2 * this.acceleration);
                            if (_distance > decelerationDistance) {
                                this.velocity = {
                                    x: Math.min(this.velocity.x + this.acceleration * elapsed, this.speed),
                                    y: Math.min(this.velocity.y + this.acceleration * elapsed, this.speed)
                                };
                            } else {
                                this.velocity = {
                                    x: Math.max(this.velocity.x - this.acceleration * this.speed, 0),
                                    y: Math.max(this.velocity.y - this.acceleration * this.speed, 0)
                                };
                            }
                            var changeX = Math.cos(_angle) * this.velocity.x;
                            var changeY = Math.sin(_angle) * this.velocity.y;
                            var x = Math.abs(changeX) > Math.abs(deltaX) ? toX : center.x + changeX;
                            var y = Math.abs(changeY) > Math.abs(deltaY) ? toY : center.y + changeY;
                            this.parent.moveCenter(x, y);
                            this.parent.emit('moved', { viewport: this.parent, type: 'follow' });
                        }
                    } else {
                        var _angle2 = Math.atan2(toY - center.y, toX - center.x);
                        var _changeX = Math.cos(_angle2) * this.speed;
                        var _changeY = Math.sin(_angle2) * this.speed;
                        var _x = Math.abs(_changeX) > Math.abs(deltaX) ? toX : center.x + _changeX;
                        var _y = Math.abs(_changeY) > Math.abs(deltaY) ? toY : center.y + _changeY;
                        this.parent.moveCenter(_x, _y);
                        this.parent.emit('moved', { viewport: this.parent, type: 'follow' });
                    }
                } else {
                    this.parent.moveCenter(toX, toY);
                    this.parent.emit('moved', { viewport: this.parent, type: 'follow' });
                }
            }
        }
    }]);

    return Follow;
}(Plugin);

/***/ }),

/***/ "d+s/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "d61K":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7163ed839bbf3ad33ae9a900434bc7f9.svg";

/***/ }),

/***/ "dAjQ":
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

module.exports = bytesToUuid;

/***/ }),

/***/ "dDI1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.premultiplyBlendMode = exports.BaseTextureCache = exports.TextureCache = exports.earcut = exports.mixins = exports.pluginTarget = exports.EventEmitter = exports.removeItems = exports.isMobile = undefined;
exports.uid = uid;
exports.hex2rgb = hex2rgb;
exports.hex2string = hex2string;
exports.rgb2hex = rgb2hex;
exports.getResolutionOfUrl = getResolutionOfUrl;
exports.decomposeDataUri = decomposeDataUri;
exports.getUrlFileExtension = getUrlFileExtension;
exports.getSvgSize = getSvgSize;
exports.skipHello = skipHello;
exports.sayHello = sayHello;
exports.isWebGLSupported = isWebGLSupported;
exports.sign = sign;
exports.destroyTextureCache = destroyTextureCache;
exports.clearTextureCache = clearTextureCache;
exports.correctBlendMode = correctBlendMode;
exports.premultiplyTint = premultiplyTint;
exports.premultiplyRgba = premultiplyRgba;
exports.premultiplyTintToRgba = premultiplyTintToRgba;

var _const = __webpack_require__("YEQi");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

var _eventemitter = __webpack_require__("wCSE");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _pluginTarget = __webpack_require__("Mag4");

var _pluginTarget2 = _interopRequireDefault(_pluginTarget);

var _mixin = __webpack_require__("hJHU");

var mixins = _interopRequireWildcard(_mixin);

var _ismobilejs = __webpack_require__("nSZq");

var isMobile = _interopRequireWildcard(_ismobilejs);

var _removeArrayItems = __webpack_require__("n9cH");

var _removeArrayItems2 = _interopRequireDefault(_removeArrayItems);

var _mapPremultipliedBlendModes = __webpack_require__("UALW");

var _mapPremultipliedBlendModes2 = _interopRequireDefault(_mapPremultipliedBlendModes);

var _earcut = __webpack_require__("vwhv");

var _earcut2 = _interopRequireDefault(_earcut);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var nextUid = 0;
var saidHello = false;

/**
 * Generalized convenience utilities for PIXI.
 * @example
 * // Extend PIXI's internal Event Emitter.
 * class MyEmitter extends PIXI.utils.EventEmitter {
 *   constructor() {
 *      super();
 *      console.log("Emitter created!");
 *   }
 * }
 *
 * // Get info on current device
 * console.log(PIXI.utils.isMobile);
 *
 * // Convert hex color to string
 * console.log(PIXI.utils.hex2string(0xff00ff)); // returns: "#ff00ff"
 * @namespace PIXI.utils
 */
exports.isMobile = isMobile;
exports.removeItems = _removeArrayItems2.default;
exports.EventEmitter = _eventemitter2.default;
exports.pluginTarget = _pluginTarget2.default;
exports.mixins = mixins;
exports.earcut = _earcut2.default;

/**
 * Gets the next unique identifier
 *
 * @memberof PIXI.utils
 * @function uid
 * @return {number} The next unique identifier to use.
 */

function uid() {
    return ++nextUid;
}

/**
 * Converts a hex color number to an [R, G, B] array
 *
 * @memberof PIXI.utils
 * @function hex2rgb
 * @param {number} hex - The number to convert
 * @param  {number[]} [out=[]] If supplied, this array will be used rather than returning a new one
 * @return {number[]} An array representing the [R, G, B] of the color.
 */
function hex2rgb(hex, out) {
    out = out || [];

    out[0] = (hex >> 16 & 0xFF) / 255;
    out[1] = (hex >> 8 & 0xFF) / 255;
    out[2] = (hex & 0xFF) / 255;

    return out;
}

/**
 * Converts a hex color number to a string.
 *
 * @memberof PIXI.utils
 * @function hex2string
 * @param {number} hex - Number in hex
 * @return {string} The string color.
 */
function hex2string(hex) {
    hex = hex.toString(16);
    hex = '000000'.substr(0, 6 - hex.length) + hex;

    return '#' + hex;
}

/**
 * Converts a color as an [R, G, B] array to a hex number
 *
 * @memberof PIXI.utils
 * @function rgb2hex
 * @param {number[]} rgb - rgb array
 * @return {number} The color number
 */
function rgb2hex(rgb) {
    return (rgb[0] * 255 << 16) + (rgb[1] * 255 << 8) + (rgb[2] * 255 | 0);
}

/**
 * get the resolution / device pixel ratio of an asset by looking for the prefix
 * used by spritesheets and image urls
 *
 * @memberof PIXI.utils
 * @function getResolutionOfUrl
 * @param {string} url - the image path
 * @param {number} [defaultValue=1] - the defaultValue if no filename prefix is set.
 * @return {number} resolution / device pixel ratio of an asset
 */
function getResolutionOfUrl(url, defaultValue) {
    var resolution = _settings2.default.RETINA_PREFIX.exec(url);

    if (resolution) {
        return parseFloat(resolution[1]);
    }

    return defaultValue !== undefined ? defaultValue : 1;
}

/**
 * Typedef for decomposeDataUri return object.
 *
 * @typedef {object} PIXI.utils~DecomposedDataUri
 * @property {mediaType} Media type, eg. `image`
 * @property {subType} Sub type, eg. `png`
 * @property {encoding} Data encoding, eg. `base64`
 * @property {data} The actual data
 */

/**
 * Split a data URI into components. Returns undefined if
 * parameter `dataUri` is not a valid data URI.
 *
 * @memberof PIXI.utils
 * @function decomposeDataUri
 * @param {string} dataUri - the data URI to check
 * @return {PIXI.utils~DecomposedDataUri|undefined} The decomposed data uri or undefined
 */
function decomposeDataUri(dataUri) {
    var dataUriMatch = _const.DATA_URI.exec(dataUri);

    if (dataUriMatch) {
        return {
            mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : undefined,
            subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : undefined,
            charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : undefined,
            encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : undefined,
            data: dataUriMatch[5]
        };
    }

    return undefined;
}

/**
 * Get type of the image by regexp for extension. Returns undefined for unknown extensions.
 *
 * @memberof PIXI.utils
 * @function getUrlFileExtension
 * @param {string} url - the image path
 * @return {string|undefined} image extension
 */
function getUrlFileExtension(url) {
    var extension = _const.URL_FILE_EXTENSION.exec(url);

    if (extension) {
        return extension[1].toLowerCase();
    }

    return undefined;
}

/**
 * Typedef for Size object.
 *
 * @typedef {object} PIXI.utils~Size
 * @property {width} Width component
 * @property {height} Height component
 */

/**
 * Get size from an svg string using regexp.
 *
 * @memberof PIXI.utils
 * @function getSvgSize
 * @param {string} svgString - a serialized svg element
 * @return {PIXI.utils~Size|undefined} image extension
 */
function getSvgSize(svgString) {
    var sizeMatch = _const.SVG_SIZE.exec(svgString);
    var size = {};

    if (sizeMatch) {
        size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
        size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
    }

    return size;
}

/**
 * Skips the hello message of renderers that are created after this is run.
 *
 * @function skipHello
 * @memberof PIXI.utils
 */
function skipHello() {
    saidHello = true;
}

/**
 * Logs out the version and renderer information for this running instance of PIXI.
 * If you don't want to see this message you can run `PIXI.utils.skipHello()` before
 * creating your renderer. Keep in mind that doing that will forever makes you a jerk face.
 *
 * @static
 * @function sayHello
 * @memberof PIXI.utils
 * @param {string} type - The string renderer type to log.
 */
function sayHello(type) {
    if (saidHello) {
        return;
    }

    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
        var args = ['\n %c %c %c PixiJS ' + _const.VERSION + ' - \u2730 ' + type + ' \u2730  %c  %c  http://www.pixijs.com/  %c %c \u2665%c\u2665%c\u2665 \n\n', 'background: #ff66a5; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff66a5; background: #030307; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'background: #ffc3dc; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;'];

        window.console.log.apply(console, args);
    } else if (window.console) {
        window.console.log('PixiJS ' + _const.VERSION + ' - ' + type + ' - http://www.pixijs.com/');
    }

    saidHello = true;
}

/**
 * Helper for checking for webgl support
 *
 * @memberof PIXI.utils
 * @function isWebGLSupported
 * @return {boolean} is webgl supported
 */
function isWebGLSupported() {
    var contextOptions = { stencil: true, failIfMajorPerformanceCaveat: true };

    try {
        if (!window.WebGLRenderingContext) {
            return false;
        }

        var canvas = document.createElement('canvas');
        var gl = canvas.getContext('webgl', contextOptions) || canvas.getContext('experimental-webgl', contextOptions);

        var success = !!(gl && gl.getContextAttributes().stencil);

        if (gl) {
            var loseContext = gl.getExtension('WEBGL_lose_context');

            if (loseContext) {
                loseContext.loseContext();
            }
        }

        gl = null;

        return success;
    } catch (e) {
        return false;
    }
}

/**
 * Returns sign of number
 *
 * @memberof PIXI.utils
 * @function sign
 * @param {number} n - the number to check the sign of
 * @returns {number} 0 if `n` is 0, -1 if `n` is negative, 1 if `n` is positive
 */
function sign(n) {
    if (n === 0) return 0;

    return n < 0 ? -1 : 1;
}

/**
 * @todo Describe property usage
 *
 * @memberof PIXI.utils
 * @private
 */
var TextureCache = exports.TextureCache = Object.create(null);

/**
 * @todo Describe property usage
 *
 * @memberof PIXI.utils
 * @private
 */
var BaseTextureCache = exports.BaseTextureCache = Object.create(null);

/**
 * Destroys all texture in the cache
 *
 * @memberof PIXI.utils
 * @function destroyTextureCache
 */
function destroyTextureCache() {
    var key = void 0;

    for (key in TextureCache) {
        TextureCache[key].destroy();
    }
    for (key in BaseTextureCache) {
        BaseTextureCache[key].destroy();
    }
}

/**
 * Removes all textures from cache, but does not destroy them
 *
 * @memberof PIXI.utils
 * @function clearTextureCache
 */
function clearTextureCache() {
    var key = void 0;

    for (key in TextureCache) {
        delete TextureCache[key];
    }
    for (key in BaseTextureCache) {
        delete BaseTextureCache[key];
    }
}

/**
 * maps premultiply flag and blendMode to adjusted blendMode
 * @memberof PIXI.utils
 * @const premultiplyBlendMode
 * @type {Array<number[]>}
 */
var premultiplyBlendMode = exports.premultiplyBlendMode = (0, _mapPremultipliedBlendModes2.default)();

/**
 * changes blendMode according to texture format
 *
 * @memberof PIXI.utils
 * @function correctBlendMode
 * @param {number} blendMode supposed blend mode
 * @param {boolean} premultiplied  whether source is premultiplied
 * @returns {number} true blend mode for this texture
 */
function correctBlendMode(blendMode, premultiplied) {
    return premultiplyBlendMode[premultiplied ? 1 : 0][blendMode];
}

/**
 * premultiplies tint
 *
 * @memberof PIXI.utils
 * @param {number} tint integet RGB
 * @param {number} alpha floating point alpha (0.0-1.0)
 * @returns {number} tint multiplied by alpha
 */
function premultiplyTint(tint, alpha) {
    if (alpha === 1.0) {
        return (alpha * 255 << 24) + tint;
    }
    if (alpha === 0.0) {
        return 0;
    }
    var R = tint >> 16 & 0xFF;
    var G = tint >> 8 & 0xFF;
    var B = tint & 0xFF;

    R = R * alpha + 0.5 | 0;
    G = G * alpha + 0.5 | 0;
    B = B * alpha + 0.5 | 0;

    return (alpha * 255 << 24) + (R << 16) + (G << 8) + B;
}

/**
 * combines rgb and alpha to out array
 *
 * @memberof PIXI.utils
 * @param {Float32Array|number[]} rgb input rgb
 * @param {number} alpha alpha param
 * @param {Float32Array} [out] output
 * @param {boolean} [premultiply=true] do premultiply it
 * @returns {Float32Array} vec4 rgba
 */
function premultiplyRgba(rgb, alpha, out, premultiply) {
    out = out || new Float32Array(4);
    if (premultiply || premultiply === undefined) {
        out[0] = rgb[0] * alpha;
        out[1] = rgb[1] * alpha;
        out[2] = rgb[2] * alpha;
    } else {
        out[0] = rgb[0];
        out[1] = rgb[1];
        out[2] = rgb[2];
    }
    out[3] = alpha;

    return out;
}

/**
 * converts integer tint and float alpha to vec4 form, premultiplies by default
 *
 * @memberof PIXI.utils
 * @param {number} tint input tint
 * @param {number} alpha alpha param
 * @param {Float32Array} [out] output
 * @param {boolean} [premultiply=true] do premultiply it
 * @returns {Float32Array} vec4 rgba
 */
function premultiplyTintToRgba(tint, alpha, out, premultiply) {
    out = out || new Float32Array(4);
    out[0] = (tint >> 16 & 0xFF) / 255.0;
    out[1] = (tint >> 8 & 0xFF) / 255.0;
    out[2] = (tint & 0xFF) / 255.0;
    if (premultiply || premultiply === undefined) {
        out[0] *= alpha;
        out[1] *= alpha;
        out[2] *= alpha;
    }
    out[3] = alpha;

    return out;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "dG+0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__("RKsu");

var _utils = __webpack_require__("H4Cu");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Sheet = function (_PureComponent) {
  _inherits(Sheet, _PureComponent);

  function Sheet() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Sheet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sheet.__proto__ || Object.getPrototypeOf(Sheet)).call.apply(_ref, [this].concat(args))), _this), _this.addSheet = function () {
      var styles = _this.props.styles;

      var sheet = (0, _utils.makeStyleTag)();
      if (!sheet) return;

      (0, _utils.injectStyles)(sheet, styles);
      (0, _utils.insertStyleTag)(sheet);

      _this.sheet = sheet;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Sheet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_exenv.canUseDOM) return;
      this.addSheet();
    }
  }, {
    key: 'removeSheet',
    value: function removeSheet() {
      if (!this.sheet) return;

      // $FlowFixMe
      this.sheet.parentNode.removeChild(this.sheet);
      this.sheet = null;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeSheet();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Sheet;
}(_react.PureComponent);

exports.default = Sheet;

/***/ }),

/***/ "dUAP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Config_1 = __webpack_require__("gH/r");
var SeatingConstruction_1 = __webpack_require__("EA1K");
var SelectionListener_1 = __webpack_require__("//Eg");
var Selector_1 = __webpack_require__("8Y7Z");
var bound_1 = __webpack_require__("USDo");
var ActionTracker_1 = __webpack_require__("h0Oq");

var InteractionManager = function () {
    function InteractionManager() {
        var _this = this;

        _classCallCheck(this, InteractionManager);

        this.groupSelected = [];
        this.selected = [];
        this.seats = [];
        this.currentlySelected = [];
        this.seats = [];
        this.selected = [];
        this.groupSelected = [];
        this.currentlySelected = [];
        this.interactionMember = Config_1.default.app.renderer.plugins.interaction;
        this.interactionMember.on('mouseup', function () {
            _this.actionId = undefined;
            if (_this.rotAction) {
                _this.interactionMember.removeListener("mousemove", _this.rotAction);
                var onTableMoved = _this.currentlySelected[0].onTableMoved;
                if (onTableMoved) {
                    onTableMoved();
                }
            }
            Config_1.default.viewport.resumePlugin("drag");
            if (_this.selected.length > 0) {
                var _onTableMoved = _this.selected[0].onTableMoved;
                if (_onTableMoved) {
                    _onTableMoved();
                }
            }
            _this.removeSelected();
        });
        this.interactionMember.on("mousemove", function (e) {
            if (!_this.actionId) {
                _this.actionId = ActionTracker_1.default.generateActionId();
            }
            if (_this.selected.length > 0) {
                if (_this.selected[0].basicType !== "pointBox") {
                    ActionTracker_1.default.addUndoAction("tableMove", _this.actionId, _this.selected.map(function (item) {
                        return item.setPosition;
                    }), _this.selected.map(function (item) {
                        return [item.getPosition()];
                    }));
                }
            }
            _this.selected.forEach(function (item) {
                return item.move(e);
            });
            if (_this.selected.length > 1) {
                Selector_1.selectMultipleTables(_this.selected);
            } else if (_this.selected.length > 0) {
                _this.selected[0].drawSelectionBox();
            }
        });
    }

    InteractionManager.createInteractionManager = function createInteractionManager() {
        if (!InteractionManager.instance) {
            InteractionManager.instance = new InteractionManager();
        }
        return InteractionManager.instance;
    };

    InteractionManager.prototype.drawBounds = function drawBounds(item) {
        if (this.groupSelected.indexOf(item) > -1) {
            Selector_1.selectMultipleTables(this.groupSelected);
        } else {
            item.drawSelectionBox();
        }
    };

    InteractionManager.prototype.itemSelected = function itemSelected(item) {
        Config_1.default.viewport.pausePlugin("drag");
        this.unselect();
        if (this.groupSelected.indexOf(item) > -1) {
            this.selected = this.groupSelected;
            this.selected.forEach(function (element) {
                return element.onSelect();
            });
        } else {
            item.onSelect();
            item.drawSelectionBox();
            this.selected = [item];
            this.currentlySelected = [item];
            this.groupSelected = [];
            item.onElementClicked({ type: item.basicType, elements: [item] });
        }
    };

    InteractionManager.prototype.seatSelected = function seatSelected(seat) {
        this.seats.push(seat);
        if (this.seats.length === 1) {
            this.currentlySelected.forEach(function (item) {
                return item.enableNextClick();
            });
        }
        Selector_1.selectMultipleSeats(this.seats);
        this.seats[0].onElementClicked({ type: seat.basicType, elements: this.seats });
    };

    InteractionManager.prototype.seatDeselected = function seatDeselected(seat) {
        var index = this.seats.findIndex(function (s) {
            return s._id === seat._id;
        });
        this.seats.splice(index, 1);
        Selector_1.selectMultipleSeats(this.seats);
    };

    InteractionManager.prototype.selectGroupSeats = function selectGroupSeats(seats) {
        this.seats = seats;
        this.currentlySelected.forEach(function (item) {
            return item.enableNextClick();
        });
        Selector_1.selectMultipleSeats(this.seats);
        this.seats[0].onElementClicked({ type: seats[0].basicType, elements: this.seats });
    };

    InteractionManager.prototype.dupeSelected = function dupeSelected() {
        SelectionListener_1.default.clickWasOnElement = true;
        if (this.currentlySelected.length === 1 && this.currentlySelected[0].basicType === "object") {
            SeatingConstruction_1.default.getInstance().duplicateObjects(this.currentlySelected);
        } else {
            SeatingConstruction_1.default.getInstance().duplicateTables(this.currentlySelected);
        }
    };

    InteractionManager.prototype.deleteSelected = function deleteSelected() {
        SeatingConstruction_1.default.getInstance().removeTables(this.currentlySelected);
    };

    InteractionManager.prototype.rotStart = function rotStart() {
        var _this2 = this;

        Config_1.default.viewport.pausePlugin("drag");
        var bounds = this.currentlySelected[0].getSelectionBoxBounds();
        var pos = this.currentlySelected[0].moveableContainer.position;
        var p1 = { x: pos.x + bounds.width + 10, y: pos.y - 27 };
        var p2 = { x: bounds.x + bounds.width / 2, y: bounds.y - bounds.height / 2 };
        var actionId = ActionTracker_1.default.generateActionId();
        this.rotAction = function (e) {
            var currentRotation = _this2.currentlySelected[0].moveableContainer.rotation;
            ActionTracker_1.default.addUndoAction("rotation", actionId, [_this2.currentlySelected[0].setRotation], [[currentRotation]]);
            _this2.currentlySelected[0].rotate(e, p1, p2);
        };
        this.interactionMember.on("mousemove", this.rotAction);
    };

    InteractionManager.prototype.isSelected = function isSelected(item) {
        return this.currentlySelected.indexOf(item) > -1;
    };

    InteractionManager.prototype.allSelectedTablesCurrentlySelected = function allSelectedTablesCurrentlySelected(items) {
        var _this3 = this;

        if (items.length > 0) {
            var filteredItems = items.filter(function (item) {
                return _this3.currentlySelected.filter(function (sel) {
                    if (sel.isThisTable) {
                        return sel.isThisTable(item.getId());
                    } else {
                        return false;
                    }
                }).length > 0;
            });
            return items.length === filteredItems.length;
        } else {
            return false;
        }
    };

    InteractionManager.prototype.selectGroup = function selectGroup(items) {
        this.unselect();
        this.groupSelected = items;
        if (this.groupSelected.length > 0) {
            var type = this.groupSelected[0].basicType;
            this.groupSelected.forEach(function (item) {
                if (item.basicType !== type) {
                    type = "differentElements";
                }
            });
            this.groupSelected[0].onElementClicked({ type: type, elements: this.groupSelected });
            this.groupSelected.forEach(function (element) {
                return element.onSelect();
            });
            this.currentlySelected = this.groupSelected;
        }
    };

    InteractionManager.prototype.unselect = function unselect() {
        if (this.currentlySelected.length > 0) {
            this.currentlySelected.forEach(function (element) {
                return element.onDeselect();
            });
        }
        this.seats.forEach(function (element) {
            return element.deSelect();
        });
        this.seats = [];
        this.removeSelected();
        return this.currentlySelected;
    };

    InteractionManager.prototype.clearGroup = function clearGroup() {
        this.groupSelected = [];
    };

    InteractionManager.prototype.removeSelected = function removeSelected() {
        this.selected = [];
    };

    return InteractionManager;
}();

__decorate([bound_1.default], InteractionManager.prototype, "drawBounds", null);
__decorate([bound_1.default], InteractionManager.prototype, "itemSelected", null);
__decorate([bound_1.default], InteractionManager.prototype, "seatSelected", null);
__decorate([bound_1.default], InteractionManager.prototype, "seatDeselected", null);
__decorate([bound_1.default], InteractionManager.prototype, "selectGroupSeats", null);
__decorate([bound_1.default], InteractionManager.prototype, "dupeSelected", null);
__decorate([bound_1.default], InteractionManager.prototype, "deleteSelected", null);
__decorate([bound_1.default], InteractionManager.prototype, "rotStart", null);
__decorate([bound_1.default], InteractionManager.prototype, "isSelected", null);
__decorate([bound_1.default], InteractionManager.prototype, "allSelectedTablesCurrentlySelected", null);
__decorate([bound_1.default], InteractionManager.prototype, "selectGroup", null);
__decorate([bound_1.default], InteractionManager.prototype, "unselect", null);
__decorate([bound_1.default], InteractionManager.prototype, "clearGroup", null);
__decorate([bound_1.default], InteractionManager.prototype, "removeSelected", null);
exports.default = InteractionManager;
//# sourceMappingURL=InteractionManager.js.map

/***/ }),

/***/ "dUhe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var uuid = __webpack_require__("qQO4");

var StaticContainer = function () {
    function StaticContainer(_id, actions) {
        _classCallCheck(this, StaticContainer);

        this.selected = false;
        this._id = _id || uuid();
        this.actions = actions;
        this.selected = false;
    }

    _createClass(StaticContainer, [{
        key: "isSelected",
        get: function get() {
            return this.selected;
        }
    }, {
        key: "id",
        get: function get() {
            return this._id;
        }
    }]);

    return StaticContainer;
}();

exports.default = StaticContainer;
//# sourceMappingURL=StaticContainer.js.map

/***/ }),

/***/ "dYGj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("aSYM");




var EditEvent = function EditEvent(_ref) {
  var event = _ref.event;

  return event.preview ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'a',
    { href: Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */])('CONSOLE_URL') + '/console/my-events/' + event._id,
      style: {
        position: "absolute",
        left: 10,
        top: 10,
        background: "rgba(0, 0, 0, 0.3)",
        border: "none",
        padding: "4px 8px",
        fontSize: "14px",
        borderRadius: 4,
        color: "#fff"
      }
    },
    'Edit Event'
  ) : null;
};
/* harmony default export */ __webpack_exports__["a"] = (EditEvent);

/***/ }),

/***/ "dZBD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("nUiQ");

/***/ }),

/***/ "dh7x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _Point = __webpack_require__("TceE");

var _Point2 = _interopRequireDefault(_Point);

var _const = __webpack_require__("YEQi");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * The PixiJS Matrix class as an object, which makes it a lot faster,
 * here is a representation of it :
 * | a | c | tx|
 * | b | d | ty|
 * | 0 | 0 | 1 |
 *
 * @class
 * @memberof PIXI
 */
var Matrix = function () {
    /**
     * @param {number} [a=1] - x scale
     * @param {number} [b=0] - x skew
     * @param {number} [c=0] - y skew
     * @param {number} [d=1] - y scale
     * @param {number} [tx=0] - x translation
     * @param {number} [ty=0] - y translation
     */
    function Matrix() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var tx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var ty = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

        _classCallCheck(this, Matrix);

        /**
         * @member {number}
         * @default 1
         */
        this.a = a;

        /**
         * @member {number}
         * @default 0
         */
        this.b = b;

        /**
         * @member {number}
         * @default 0
         */
        this.c = c;

        /**
         * @member {number}
         * @default 1
         */
        this.d = d;

        /**
         * @member {number}
         * @default 0
         */
        this.tx = tx;

        /**
         * @member {number}
         * @default 0
         */
        this.ty = ty;

        this.array = null;
    }

    /**
     * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
     *
     * a = array[0]
     * b = array[1]
     * c = array[3]
     * d = array[4]
     * tx = array[2]
     * ty = array[5]
     *
     * @param {number[]} array - The array that the matrix will be populated from.
     */

    Matrix.prototype.fromArray = function fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    };

    /**
     * sets the matrix properties
     *
     * @param {number} a - Matrix component
     * @param {number} b - Matrix component
     * @param {number} c - Matrix component
     * @param {number} d - Matrix component
     * @param {number} tx - Matrix component
     * @param {number} ty - Matrix component
     *
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */

    Matrix.prototype.set = function set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;

        return this;
    };

    /**
     * Creates an array from the current Matrix object.
     *
     * @param {boolean} transpose - Whether we need to transpose the matrix or not
     * @param {Float32Array} [out=new Float32Array(9)] - If provided the array will be assigned to out
     * @return {number[]} the newly created array which contains the matrix
     */

    Matrix.prototype.toArray = function toArray(transpose, out) {
        if (!this.array) {
            this.array = new Float32Array(9);
        }

        var array = out || this.array;

        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }

        return array;
    };

    /**
     * Get a new position with the current transformation applied.
     * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
     *
     * @param {PIXI.Point} pos - The origin
     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
     * @return {PIXI.Point} The new point, transformed through this matrix
     */

    Matrix.prototype.apply = function apply(pos, newPos) {
        newPos = newPos || new _Point2.default();

        var x = pos.x;
        var y = pos.y;

        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;

        return newPos;
    };

    /**
     * Get a new position with the inverse of the current transformation applied.
     * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
     *
     * @param {PIXI.Point} pos - The origin
     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
     * @return {PIXI.Point} The new point, inverse-transformed through this matrix
     */

    Matrix.prototype.applyInverse = function applyInverse(pos, newPos) {
        newPos = newPos || new _Point2.default();

        var id = 1 / (this.a * this.d + this.c * -this.b);

        var x = pos.x;
        var y = pos.y;

        newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
        newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;

        return newPos;
    };

    /**
     * Translates the matrix on the x and y.
     *
     * @param {number} x How much to translate x by
     * @param {number} y How much to translate y by
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */

    Matrix.prototype.translate = function translate(x, y) {
        this.tx += x;
        this.ty += y;

        return this;
    };

    /**
     * Applies a scale transformation to the matrix.
     *
     * @param {number} x The amount to scale horizontally
     * @param {number} y The amount to scale vertically
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */

    Matrix.prototype.scale = function scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;

        return this;
    };

    /**
     * Applies a rotation transformation to the matrix.
     *
     * @param {number} angle - The angle in radians.
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */

    Matrix.prototype.rotate = function rotate(angle) {
        var cos = Math.cos(angle);
        var sin = Math.sin(angle);

        var a1 = this.a;
        var c1 = this.c;
        var tx1 = this.tx;

        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;

        return this;
    };

    /**
     * Appends the given Matrix to this Matrix.
     *
     * @param {PIXI.Matrix} matrix - The matrix to append.
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */

    Matrix.prototype.append = function append(matrix) {
        var a1 = this.a;
        var b1 = this.b;
        var c1 = this.c;
        var d1 = this.d;

        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;

        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;

        return this;
    };

    /**
     * Sets the matrix based on all the available properties
     *
     * @param {number} x - Position on the x axis
     * @param {number} y - Position on the y axis
     * @param {number} pivotX - Pivot on the x axis
     * @param {number} pivotY - Pivot on the y axis
     * @param {number} scaleX - Scale on the x axis
     * @param {number} scaleY - Scale on the y axis
     * @param {number} rotation - Rotation in radians
     * @param {number} skewX - Skew on the x axis
     * @param {number} skewY - Skew on the y axis
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */

    Matrix.prototype.setTransform = function setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;

        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);

        return this;
    };

    /**
     * Prepends the given Matrix to this Matrix.
     *
     * @param {PIXI.Matrix} matrix - The matrix to prepend
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */

    Matrix.prototype.prepend = function prepend(matrix) {
        var tx1 = this.tx;

        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            var a1 = this.a;
            var c1 = this.c;

            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }

        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;

        return this;
    };

    /**
     * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
     *
     * @param {PIXI.Transform|PIXI.TransformStatic} transform - The transform to apply the properties to.
     * @return {PIXI.Transform|PIXI.TransformStatic} The transform with the newly applied properties
     */

    Matrix.prototype.decompose = function decompose(transform) {
        // sort out rotation / skew..
        var a = this.a;
        var b = this.b;
        var c = this.c;
        var d = this.d;

        var skewX = -Math.atan2(-c, d);
        var skewY = Math.atan2(b, a);

        var delta = Math.abs(skewX + skewY);

        if (delta < 0.00001 || Math.abs(_const.PI_2 - delta) < 0.00001) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }

        // next set scale
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);

        // next set position
        transform.position.x = this.tx;
        transform.position.y = this.ty;

        return transform;
    };

    /**
     * Inverts this matrix
     *
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */

    Matrix.prototype.invert = function invert() {
        var a1 = this.a;
        var b1 = this.b;
        var c1 = this.c;
        var d1 = this.d;
        var tx1 = this.tx;
        var n = a1 * d1 - b1 * c1;

        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;

        return this;
    };

    /**
     * Resets this Matix to an identity (default) matrix.
     *
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */

    Matrix.prototype.identity = function identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;

        return this;
    };

    /**
     * Creates a new Matrix object with the same values as this one.
     *
     * @return {PIXI.Matrix} A copy of this matrix. Good for chaining method calls.
     */

    Matrix.prototype.clone = function clone() {
        var matrix = new Matrix();

        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;

        return matrix;
    };

    /**
     * Changes the values of the given matrix to be the same as the ones in this matrix
     *
     * @param {PIXI.Matrix} matrix - The matrix to copy from.
     * @return {PIXI.Matrix} The matrix given in parameter with its values updated.
     */

    Matrix.prototype.copy = function copy(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;

        return matrix;
    };

    /**
     * A default (identity) matrix
     *
     * @static
     * @const
     */

    _createClass(Matrix, null, [{
        key: 'IDENTITY',
        get: function get() {
            return new Matrix();
        }

        /**
         * A temp matrix
         *
         * @static
         * @const
         */

    }, {
        key: 'TEMP_MATRIX',
        get: function get() {
            return new Matrix();
        }
    }]);

    return Matrix;
}();

exports.default = Matrix;
//# sourceMappingURL=Matrix.js.map

/***/ }),

/***/ "dn2M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),

/***/ "dskh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("yh9p");
var ieee754 = __webpack_require__("JgNJ");
var isArray = __webpack_require__("REa7");

exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength();

function typedArraySupport() {
  try {
    var arr = new Uint8Array(1);
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
        return 42;
      } };
    return arr.foo() === 42 && // typed array instances can be augmented
    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
  } catch (e) {
    return false;
  }
}

function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}

function createBuffer(that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length');
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }

  return that;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length);
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error('If encoding is specified then the first argument must be a string');
    }
    return allocUnsafe(this, arg);
  }
  return from(this, arg, encodingOrOffset, length);
}

Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr;
};

function from(that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length);
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset);
  }

  return fromObject(that, value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length);
};

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    });
  }
}

function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number');
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative');
  }
}

function alloc(that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
  }
  return createBuffer(that, size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding);
};

function allocUnsafe(that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that;
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size);
};

function fromString(that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding');
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that;
}

function fromArrayLike(that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that;
}

function fromArrayBuffer(that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds');
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds');
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that;
}

function fromObject(that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that;
    }

    obj.copy(that, 0, 0, len);
    return that;
  }

  if (obj) {
    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0);
      }
      return fromArrayLike(that, obj);
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data);
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}

function checked(length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
  }
  return length | 0;
}

function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}

Buffer.isBuffer = function isBuffer(b) {
  return !!(b != null && b._isBuffer);
};

Buffer.compare = function compare(a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers');
  }

  if (a === b) return 0;

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};

Buffer.concat = function concat(list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }

  if (list.length === 0) {
    return Buffer.alloc(0);
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer;
};

function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;

function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return '';
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return '';
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);

      case 'ascii':
        return asciiSlice(this, start, end);

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);

      case 'base64':
        return base64Slice(this, start, end);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;

function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};

Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};

Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};

Buffer.prototype.toString = function toString() {
  var length = this.length | 0;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};

Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};

Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>';
};

Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer');
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0;

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }

  throw new TypeError('val must be string, number or Buffer');
}

function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }

  return -1;
}

Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};

Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};

Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};

function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}

function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}

function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}

function latin1Write(buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length);
}

function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}

function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}

Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
    // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);

      case 'ascii':
        return asciiWrite(this, string, offset, length);

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length);

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};

function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}

function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}

function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}

function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}

function hexSlice(buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out;
}

function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}

Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}

Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val;
};

Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val;
};

Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};

Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};

Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};

Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};

Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};

Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};

Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};

Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};

Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};

Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};

Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};

Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};

function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}

Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = value & 0xff;
  return offset + 1;
};

function objectWriteUInt16(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

function objectWriteUInt32(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};

Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}

function writeFloat(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}

Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};

Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};

function writeDouble(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
  }

  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }

  if (end <= start) {
    return this;
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean(str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}

function stringtrim(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, '');
}

function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}

function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;

        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }

  return bytes;
}

function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}

function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray;
}

function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}

function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

function isnan(val) {
  return val !== val; // eslint-disable-line no-self-compare
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "dt3n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = trimCanvas;
/**
 * Trim transparent borders from a canvas
 *
 * @memberof PIXI
 * @function trimCanvas
 * @private
 * @param {HTMLCanvasElement} canvas - the canvas to trim
 * @returns {object} Trim data
 */
function trimCanvas(canvas) {
    // https://gist.github.com/remy/784508

    var width = canvas.width;
    var height = canvas.height;

    var context = canvas.getContext('2d');
    var imageData = context.getImageData(0, 0, width, height);
    var pixels = imageData.data;
    var len = pixels.length;

    var bound = {
        top: null,
        left: null,
        right: null,
        bottom: null
    };
    var data = null;
    var i = void 0;
    var x = void 0;
    var y = void 0;

    for (i = 0; i < len; i += 4) {
        if (pixels[i + 3] !== 0) {
            x = i / 4 % width;
            y = ~~(i / 4 / width);

            if (bound.top === null) {
                bound.top = y;
            }

            if (bound.left === null) {
                bound.left = x;
            } else if (x < bound.left) {
                bound.left = x;
            }

            if (bound.right === null) {
                bound.right = x + 1;
            } else if (bound.right < x) {
                bound.right = x + 1;
            }

            if (bound.bottom === null) {
                bound.bottom = y;
            } else if (bound.bottom < y) {
                bound.bottom = y;
            }
        }
    }

    if (bound.top !== null) {
        width = bound.right - bound.left;
        height = bound.bottom - bound.top + 1;
        data = context.getImageData(bound.left, bound.top, width, height);
    }

    return {
        height: height,
        width: width,
        data: data
    };
}
//# sourceMappingURL=trimCanvas.js.map

/***/ }),

/***/ "dty5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "06beadadacfea8f41116d0abdb9600eb.svg";

/***/ }),

/***/ "e3iB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Point = __webpack_require__("TceE");

Object.defineProperty(exports, 'Point', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Point).default;
  }
});

var _ObservablePoint = __webpack_require__("aG0R");

Object.defineProperty(exports, 'ObservablePoint', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ObservablePoint).default;
  }
});

var _Matrix = __webpack_require__("dh7x");

Object.defineProperty(exports, 'Matrix', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Matrix).default;
  }
});

var _GroupD = __webpack_require__("PGIZ");

Object.defineProperty(exports, 'GroupD8', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroupD).default;
  }
});

var _Circle = __webpack_require__("8SKy");

Object.defineProperty(exports, 'Circle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _Ellipse = __webpack_require__("TKYo");

Object.defineProperty(exports, 'Ellipse', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Ellipse).default;
  }
});

var _Polygon = __webpack_require__("vamC");

Object.defineProperty(exports, 'Polygon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default;
  }
});

var _Rectangle = __webpack_require__("MxpT");

Object.defineProperty(exports, 'Rectangle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default;
  }
});

var _RoundedRectangle = __webpack_require__("p/wO");

Object.defineProperty(exports, 'RoundedRectangle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RoundedRectangle).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "eDyj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });



var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process === 'undefined' || !Object({}) || "production" !== 'production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, elementProps, element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && component.base || component;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps();
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "eYhx":
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};

/***/ }),

/***/ "eqVo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var MoveableContainer_1 = __webpack_require__("JJWE");
var uuid = __webpack_require__("qQO4");

var MoveableObject = function (_MoveableContainer_1$) {
    _inherits(MoveableObject, _MoveableContainer_1$);

    function MoveableObject(_id, actions) {
        _classCallCheck(this, MoveableObject);

        var _this = _possibleConstructorReturn(this, _MoveableContainer_1$.call(this));

        _this.selected = false;
        _this._id = _id || uuid();
        _this.actions = actions;
        _this.selected = false;
        return _this;
    }

    _createClass(MoveableObject, [{
        key: "isSelected",
        get: function get() {
            return this.selected;
        }
    }]);

    return MoveableObject;
}(MoveableContainer_1.default);

exports.default = MoveableObject;
//# sourceMappingURL=MoveableObject.js.map

/***/ }),

/***/ "esRn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _Texture = __webpack_require__("xUki");

var _Texture2 = _interopRequireDefault(_Texture);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var tempPoint = new core.Point();
var tempPolygon = new core.Polygon();

/**
 * Base mesh class
 * @class
 * @extends PIXI.Container
 * @memberof PIXI.mesh
 */

var Mesh = function (_core$Container) {
    _inherits(Mesh, _core$Container);

    /**
     * @param {PIXI.Texture} texture - The texture to use
     * @param {Float32Array} [vertices] - if you want to specify the vertices
     * @param {Float32Array} [uvs] - if you want to specify the uvs
     * @param {Uint16Array} [indices] - if you want to specify the indices
     * @param {number} [drawMode] - the drawMode, can be any of the Mesh.DRAW_MODES consts
     */
    function Mesh(texture, vertices, uvs, indices, drawMode) {
        _classCallCheck(this, Mesh);

        /**
         * The texture of the Mesh
         *
         * @member {PIXI.Texture}
         * @default PIXI.Texture.EMPTY
         * @private
         */
        var _this = _possibleConstructorReturn(this, _core$Container.call(this));

        _this._texture = texture || _Texture2.default.EMPTY;

        /**
         * The Uvs of the Mesh
         *
         * @member {Float32Array}
         */
        _this.uvs = uvs || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);

        /**
         * An array of vertices
         *
         * @member {Float32Array}
         */
        _this.vertices = vertices || new Float32Array([0, 0, 100, 0, 100, 100, 0, 100]);

        /**
         * An array containing the indices of the vertices
         *
         * @member {Uint16Array}
         */
        //  TODO auto generate this based on draw mode!
        _this.indices = indices || new Uint16Array([0, 1, 3, 2]);

        /**
         * Version of mesh uvs are dirty or not
         *
         * @member {number}
         */
        _this.dirty = 0;

        /**
         * Version of mesh indices
         *
         * @member {number}
         */
        _this.indexDirty = 0;

        /**
         * Version of mesh verticies array
         *
         * @member {number}
         */
        _this.vertexDirty = 0;

        /**
         * For backwards compatibility the default is to re-upload verticies each render call.
         * Set this to `false` and increase `vertexDirty` to manually re-upload the buffer.
         *
         * @member {boolean}
         */
        _this.autoUpdate = true;

        /**
         * The blend mode to be applied to the sprite. Set to `PIXI.BLEND_MODES.NORMAL` to remove
         * any blend mode.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL
         * @see PIXI.BLEND_MODES
         */
        _this.blendMode = core.BLEND_MODES.NORMAL;

        /**
         * Triangles in canvas mode are automatically antialiased, use this value to force triangles
         * to overlap a bit with each other.
         *
         * @member {number}
         */
        _this.canvasPadding = core.settings.MESH_CANVAS_PADDING;

        /**
         * The way the Mesh should be drawn, can be any of the {@link PIXI.mesh.Mesh.DRAW_MODES} consts
         *
         * @member {number}
         * @see PIXI.mesh.Mesh.DRAW_MODES
         */
        _this.drawMode = drawMode || Mesh.DRAW_MODES.TRIANGLE_MESH;

        /**
         * The default shader that is used if a mesh doesn't have a more specific one.
         *
         * @member {PIXI.Shader}
         */
        _this.shader = null;

        /**
         * The tint applied to the mesh. This is a [r,g,b] value. A value of [1,1,1] will remove any
         * tint effect.
         *
         * @member {number}
         */
        _this.tintRgb = new Float32Array([1, 1, 1]);

        /**
         * A map of renderer IDs to webgl render data
         *
         * @private
         * @member {object<number, object>}
         */
        _this._glDatas = {};

        /**
         * transform that is applied to UV to get the texture coords
         * its updated independently from texture uvTransform
         * updates of uvs are tied to that thing
         *
         * @member {PIXI.TextureMatrix}
         * @private
         */
        _this._uvTransform = new core.TextureMatrix(_this._texture);

        /**
         * whether or not upload uvTransform to shader
         * if its false, then uvs should be pre-multiplied
         * if you change it for generated mesh, please call 'refresh(true)'
         * @member {boolean}
         * @default false
         */
        _this.uploadUvTransform = false;

        /**
         * Plugin that is responsible for rendering this element.
         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
         * @member {string}
         * @default 'mesh'
         */
        _this.pluginName = 'mesh';
        return _this;
    }

    /**
     * Renders the object using the WebGL renderer
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - a reference to the WebGL renderer
     */

    Mesh.prototype._renderWebGL = function _renderWebGL(renderer) {
        this.refresh();
        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
     */

    Mesh.prototype._renderCanvas = function _renderCanvas(renderer) {
        this.refresh();
        renderer.plugins[this.pluginName].render(this);
    };

    /**
     * When the texture is updated, this event will fire to update the scale and frame
     *
     * @private
     */

    Mesh.prototype._onTextureUpdate = function _onTextureUpdate() {
        this._uvTransform.texture = this._texture;
        this.refresh();
    };

    /**
     * multiplies uvs only if uploadUvTransform is false
     * call it after you change uvs manually
     * make sure that texture is valid
     */

    Mesh.prototype.multiplyUvs = function multiplyUvs() {
        if (!this.uploadUvTransform) {
            this._uvTransform.multiplyUvs(this.uvs);
        }
    };

    /**
     * Refreshes uvs for generated meshes (rope, plane)
     * sometimes refreshes vertices too
     *
     * @param {boolean} [forceUpdate=false] if true, matrices will be updated any case
     */

    Mesh.prototype.refresh = function refresh(forceUpdate) {
        if (this.autoUpdate) {
            this.vertexDirty++;
        }
        if (this._uvTransform.update(forceUpdate)) {
            this._refresh();
        }
    };

    /**
     * re-calculates mesh coords
     * @protected
     */

    Mesh.prototype._refresh = function _refresh() {}
    /* empty */

    /**
     * Returns the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
     *
     */
    ;

    Mesh.prototype._calculateBounds = function _calculateBounds() {
        // TODO - we can cache local bounds and use them if they are dirty (like graphics)
        this._bounds.addVertices(this.transform, this.vertices, 0, this.vertices.length);
    };

    /**
     * Tests if a point is inside this mesh. Works only for TRIANGLE_MESH
     *
     * @param {PIXI.Point} point - the point to test
     * @return {boolean} the result of the test
     */

    Mesh.prototype.containsPoint = function containsPoint(point) {
        if (!this.getBounds().contains(point.x, point.y)) {
            return false;
        }

        this.worldTransform.applyInverse(point, tempPoint);

        var vertices = this.vertices;
        var points = tempPolygon.points;
        var indices = this.indices;
        var len = this.indices.length;
        var step = this.drawMode === Mesh.DRAW_MODES.TRIANGLES ? 3 : 1;

        for (var i = 0; i + 2 < len; i += step) {
            var ind0 = indices[i] * 2;
            var ind1 = indices[i + 1] * 2;
            var ind2 = indices[i + 2] * 2;

            points[0] = vertices[ind0];
            points[1] = vertices[ind0 + 1];
            points[2] = vertices[ind1];
            points[3] = vertices[ind1 + 1];
            points[4] = vertices[ind2];
            points[5] = vertices[ind2 + 1];

            if (tempPolygon.contains(tempPoint.x, tempPoint.y)) {
                return true;
            }
        }

        return false;
    };

    /**
     * The texture that the mesh uses.
     *
     * @member {PIXI.Texture}
     */

    /**
     * Destroys the Mesh object.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
     *  options have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have
     *  their destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */
    Mesh.prototype.destroy = function destroy(options) {
        // for each webgl data entry, destroy the WebGLGraphicsData
        for (var id in this._glDatas) {
            var data = this._glDatas[id];

            if (data.destroy) {
                data.destroy();
            } else {
                if (data.vertexBuffer) {
                    data.vertexBuffer.destroy();
                    data.vertexBuffer = null;
                }
                if (data.indexBuffer) {
                    data.indexBuffer.destroy();
                    data.indexBuffer = null;
                }
                if (data.uvBuffer) {
                    data.uvBuffer.destroy();
                    data.uvBuffer = null;
                }
                if (data.vao) {
                    data.vao.destroy();
                    data.vao = null;
                }
            }
        }

        this._glDatas = null;

        _core$Container.prototype.destroy.call(this, options);
    };

    _createClass(Mesh, [{
        key: 'texture',
        get: function get() {
            return this._texture;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._texture === value) {
                return;
            }

            this._texture = value;

            if (value) {
                // wait for the texture to load
                if (value.baseTexture.hasLoaded) {
                    this._onTextureUpdate();
                } else {
                    value.once('update', this._onTextureUpdate, this);
                }
            }
        }

        /**
         * The tint applied to the mesh. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
         *
         * @member {number}
         * @default 0xFFFFFF
         */

    }, {
        key: 'tint',
        get: function get() {
            return core.utils.rgb2hex(this.tintRgb);
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.tintRgb = core.utils.hex2rgb(value, this.tintRgb);
        }
    }]);

    return Mesh;
}(core.Container);

/**
 * Different drawing buffer modes supported
 *
 * @static
 * @constant
 * @type {object}
 * @property {number} TRIANGLE_MESH
 * @property {number} TRIANGLES
 */

exports.default = Mesh;
Mesh.DRAW_MODES = {
    TRIANGLE_MESH: 0,
    TRIANGLES: 1
};
//# sourceMappingURL=Mesh.js.map

/***/ }),

/***/ "f+DB":
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

/***/ }),

/***/ "f0Ws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DateModal__ = __webpack_require__("87nI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion__ = __webpack_require__("mibh");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var linkClass = Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])({
  textDecoration: "underline"
});

var Date = function Date(_ref) {
  var date = _ref.date,
      _ref$singleLine = _ref.singleLine,
      singleLine = _ref$singleLine === undefined ? false : _ref$singleLine;

  var styles = {
    container: {
      margin: "0px 0"
      //lineHeight: "18px"
    },
    date: {
      marginBottom: 2
    }
  };
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    { style: styles.container },
    date && date.display ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        { style: styles.date },
        date.display.combined
      )
    ) : ""
  );
};

var DatesDisplay = function (_Component) {
  _inherits(DatesDisplay, _Component);

  function DatesDisplay() {
    _classCallCheck(this, DatesDisplay);

    // set initial time:
    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      showAllDates: false,
      singleLine: false
    };
    _this.togglesDates = _this.togglesDates.bind(_this);
    return _this;
  }

  DatesDisplay.prototype.togglesDates = function togglesDates() {
    this.setState({ showAllDates: !this.state.showAllDates });
  };

  DatesDisplay.prototype.render = function render(_ref2, _ref3) {
    var dates = _ref2.dates,
        singleLine = _ref2.singleLine,
        eventSlug = _ref2.eventSlug;
    var showAllDates = _ref3.showAllDates;

    // create valid dates array
    var validDates = dates.filter(function (date) {
      return date.valid;
    });
    var displayDate = validDates && validDates.length ? validDates[0] : dates[0];
    // select the first one and if null use first date
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "span",
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Date, { date: displayDate, singleLine: singleLine })
      ),
      dates.length > 1 && !singleLine ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "p",
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "a",
          {
            "data-cy": "more-dates",
            className: linkClass,
            onClick: this.togglesDates,
            href: "#"
          },
          "Show more dates for this event"
        )
      ) : "",
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__DateModal__["a" /* default */], {
        open: showAllDates,
        closeHandler: this.togglesDates,
        title: "More dates",
        dates: dates,
        eventSlug: eventSlug
      })
    );
  };

  return DatesDisplay;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DatesDisplay);

/***/ }),

/***/ "f1vj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = determineCrossOrigin;

var _url2 = __webpack_require__("Mej7");

var _url3 = _interopRequireDefault(_url2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var tempAnchor = void 0;

/**
 * Sets the `crossOrigin` property for this resource based on if the url
 * for this resource is cross-origin. If crossOrigin was manually set, this
 * function does nothing.
 * Nipped from the resource loader!
 *
 * @ignore
 * @param {string} url - The url to test.
 * @param {object} [loc=window.location] - The location object to test against.
 * @return {string} The crossOrigin value to use (or empty string for none).
 */
function determineCrossOrigin(url) {
    var loc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;

    // data: and javascript: urls are considered same-origin
    if (url.indexOf('data:') === 0) {
        return '';
    }

    // default is window.location
    loc = loc || window.location;

    if (!tempAnchor) {
        tempAnchor = document.createElement('a');
    }

    // let the browser determine the full href for the url of this resource and then
    // parse with the node url lib, we can't use the properties of the anchor element
    // because they don't work in IE9 :(
    tempAnchor.href = url;
    url = _url3.default.parse(tempAnchor.href);

    var samePort = !url.port && loc.port === '' || url.port === loc.port;

    // if cross origin
    if (url.hostname !== loc.hostname || !samePort || url.protocol !== loc.protocol) {
        return 'anonymous';
    }

    return '';
}
//# sourceMappingURL=determineCrossOrigin.js.map

/***/ }),

/***/ "f5iX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Container2 = __webpack_require__("OzBO");

var _Container3 = _interopRequireDefault(_Container2);

var _RenderTexture = __webpack_require__("Jb0W");

var _RenderTexture2 = _interopRequireDefault(_RenderTexture);

var _Texture = __webpack_require__("xUki");

var _Texture2 = _interopRequireDefault(_Texture);

var _GraphicsData = __webpack_require__("i0q3");

var _GraphicsData2 = _interopRequireDefault(_GraphicsData);

var _Sprite = __webpack_require__("oWLW");

var _Sprite2 = _interopRequireDefault(_Sprite);

var _math = __webpack_require__("e3iB");

var _utils = __webpack_require__("dDI1");

var _const = __webpack_require__("YEQi");

var _Bounds = __webpack_require__("Me0q");

var _Bounds2 = _interopRequireDefault(_Bounds);

var _bezierCurveTo2 = __webpack_require__("AHbX");

var _bezierCurveTo3 = _interopRequireDefault(_bezierCurveTo2);

var _CanvasRenderer = __webpack_require__("GzOR");

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var canvasRenderer = void 0;
var tempMatrix = new _math.Matrix();
var tempPoint = new _math.Point();
var tempColor1 = new Float32Array(4);
var tempColor2 = new Float32Array(4);

/**
 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
 * rectangles to the display, and to color and fill them.
 *
 * @class
 * @extends PIXI.Container
 * @memberof PIXI
 */

var Graphics = function (_Container) {
    _inherits(Graphics, _Container);

    /**
     *
     * @param {boolean} [nativeLines=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
     */
    function Graphics() {
        var nativeLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        _classCallCheck(this, Graphics);

        /**
         * The alpha value used when filling the Graphics object.
         *
         * @member {number}
         * @default 1
         */
        var _this = _possibleConstructorReturn(this, _Container.call(this));

        _this.fillAlpha = 1;

        /**
         * The width (thickness) of any lines drawn.
         *
         * @member {number}
         * @default 0
         */
        _this.lineWidth = 0;

        /**
         * If true the lines will be draw using LINES instead of TRIANGLE_STRIP
         *
         * @member {boolean}
         */
        _this.nativeLines = nativeLines;

        /**
         * The color of any lines drawn.
         *
         * @member {string}
         * @default 0
         */
        _this.lineColor = 0;

        /**
         * The alignment of any lines drawn (0.5 = middle, 1 = outter, 0 = inner).
         *
         * @member {number}
         * @default 0.5
         */
        _this.lineAlignment = 0.5;

        /**
         * Graphics data
         *
         * @member {PIXI.GraphicsData[]}
         * @private
         */
        _this.graphicsData = [];

        /**
         * The tint applied to the graphic shape. This is a hex value. Apply a value of 0xFFFFFF to
         * reset the tint.
         *
         * @member {number}
         * @default 0xFFFFFF
         */
        _this.tint = 0xFFFFFF;

        /**
         * The previous tint applied to the graphic shape. Used to compare to the current tint and
         * check if theres change.
         *
         * @member {number}
         * @private
         * @default 0xFFFFFF
         */
        _this._prevTint = 0xFFFFFF;

        /**
         * The blend mode to be applied to the graphic shape. Apply a value of
         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL;
         * @see PIXI.BLEND_MODES
         */
        _this.blendMode = _const.BLEND_MODES.NORMAL;

        /**
         * Current path
         *
         * @member {PIXI.GraphicsData}
         * @private
         */
        _this.currentPath = null;

        /**
         * Array containing some WebGL-related properties used by the WebGL renderer.
         *
         * @member {object<number, object>}
         * @private
         */
        // TODO - _webgl should use a prototype object, not a random undocumented object...
        _this._webGL = {};

        /**
         * Whether this shape is being used as a mask.
         *
         * @member {boolean}
         */
        _this.isMask = false;

        /**
         * The bounds' padding used for bounds calculation.
         *
         * @member {number}
         */
        _this.boundsPadding = 0;

        /**
         * A cache of the local bounds to prevent recalculation.
         *
         * @member {PIXI.Rectangle}
         * @private
         */
        _this._localBounds = new _Bounds2.default();

        /**
         * Used to detect if the graphics object has changed. If this is set to true then the graphics
         * object will be recalculated.
         *
         * @member {boolean}
         * @private
         */
        _this.dirty = 0;

        /**
         * Used to detect if we need to do a fast rect check using the id compare method
         * @type {Number}
         */
        _this.fastRectDirty = -1;

        /**
         * Used to detect if we clear the graphics webGL data
         * @type {Number}
         */
        _this.clearDirty = 0;

        /**
         * Used to detect if we we need to recalculate local bounds
         * @type {Number}
         */
        _this.boundsDirty = -1;

        /**
         * Used to detect if the cached sprite object needs to be updated.
         *
         * @member {boolean}
         * @private
         */
        _this.cachedSpriteDirty = false;

        _this._spriteRect = null;
        _this._fastRect = false;

        _this._prevRectTint = null;
        _this._prevRectFillColor = null;

        /**
         * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
         * This is useful if your graphics element does not change often, as it will speed up the rendering
         * of the object in exchange for taking up texture memory. It is also useful if you need the graphics
         * object to be anti-aliased, because it will be rendered using canvas. This is not recommended if
         * you are constantly redrawing the graphics element.
         *
         * @name cacheAsBitmap
         * @member {boolean}
         * @memberof PIXI.Graphics#
         * @default false
         */
        return _this;
    }

    /**
     * Creates a new Graphics object with the same values as this one.
     * Note that the only the properties of the object are cloned, not its transform (position,scale,etc)
     *
     * @return {PIXI.Graphics} A clone of the graphics object
     */

    Graphics.prototype.clone = function clone() {
        var clone = new Graphics();

        clone.renderable = this.renderable;
        clone.fillAlpha = this.fillAlpha;
        clone.lineWidth = this.lineWidth;
        clone.lineColor = this.lineColor;
        clone.lineAlignment = this.lineAlignment;
        clone.tint = this.tint;
        clone.blendMode = this.blendMode;
        clone.isMask = this.isMask;
        clone.boundsPadding = this.boundsPadding;
        clone.dirty = 0;
        clone.cachedSpriteDirty = this.cachedSpriteDirty;

        // copy graphics data
        for (var i = 0; i < this.graphicsData.length; ++i) {
            clone.graphicsData.push(this.graphicsData[i].clone());
        }

        clone.currentPath = clone.graphicsData[clone.graphicsData.length - 1];

        clone.updateLocalBounds();

        return clone;
    };

    /**
     * Calculate length of quadratic curve
     * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
     * for the detailed explanation of math behind this.
     *
     * @private
     * @param {number} fromX - x-coordinate of curve start point
     * @param {number} fromY - y-coordinate of curve start point
     * @param {number} cpX - x-coordinate of curve control point
     * @param {number} cpY - y-coordinate of curve control point
     * @param {number} toX - x-coordinate of curve end point
     * @param {number} toY - y-coordinate of curve end point
     * @return {number} Length of quadratic curve
     */

    Graphics.prototype._quadraticCurveLength = function _quadraticCurveLength(fromX, fromY, cpX, cpY, toX, toY) {
        var ax = fromX - 2.0 * cpX + toX;
        var ay = fromY - 2.0 * cpY + toY;
        var bx = 2.0 * cpX - 2.0 * fromX;
        var by = 2.0 * cpY - 2.0 * fromY;
        var a = 4.0 * (ax * ax + ay * ay);
        var b = 4.0 * (ax * bx + ay * by);
        var c = bx * bx + by * by;

        var s = 2.0 * Math.sqrt(a + b + c);
        var a2 = Math.sqrt(a);
        var a32 = 2.0 * a * a2;
        var c2 = 2.0 * Math.sqrt(c);
        var ba = b / a2;

        return (a32 * s + a2 * b * (s - c2) + (4.0 * c * a - b * b) * Math.log((2.0 * a2 + ba + s) / (ba + c2))) / (4.0 * a32);
    };

    /**
     * Calculate length of bezier curve.
     * Analytical solution is impossible, since it involves an integral that does not integrate in general.
     * Therefore numerical solution is used.
     *
     * @private
     * @param {number} fromX - Starting point x
     * @param {number} fromY - Starting point y
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {number} Length of bezier curve
     */

    Graphics.prototype._bezierCurveLength = function _bezierCurveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
        var n = 10;
        var result = 0.0;
        var t = 0.0;
        var t2 = 0.0;
        var t3 = 0.0;
        var nt = 0.0;
        var nt2 = 0.0;
        var nt3 = 0.0;
        var x = 0.0;
        var y = 0.0;
        var dx = 0.0;
        var dy = 0.0;
        var prevX = fromX;
        var prevY = fromY;

        for (var i = 1; i <= n; ++i) {
            t = i / n;
            t2 = t * t;
            t3 = t2 * t;
            nt = 1.0 - t;
            nt2 = nt * nt;
            nt3 = nt2 * nt;

            x = nt3 * fromX + 3.0 * nt2 * t * cpX + 3.0 * nt * t2 * cpX2 + t3 * toX;
            y = nt3 * fromY + 3.0 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY;
            dx = prevX - x;
            dy = prevY - y;
            prevX = x;
            prevY = y;

            result += Math.sqrt(dx * dx + dy * dy);
        }

        return result;
    };

    /**
     * Calculate number of segments for the curve based on its length to ensure its smoothness.
     *
     * @private
     * @param {number} length - length of curve
     * @return {number} Number of segments
     */

    Graphics.prototype._segmentsCount = function _segmentsCount(length) {
        var result = Math.ceil(length / Graphics.CURVES.maxLength);

        if (result < Graphics.CURVES.minSegments) {
            result = Graphics.CURVES.minSegments;
        } else if (result > Graphics.CURVES.maxSegments) {
            result = Graphics.CURVES.maxSegments;
        }

        return result;
    };

    /**
     * Specifies the line style used for subsequent calls to Graphics methods such as the lineTo()
     * method or the drawCircle() method.
     *
     * @param {number} [lineWidth=0] - width of the line to draw, will update the objects stored style
     * @param {number} [color=0] - color of the line to draw, will update the objects stored style
     * @param {number} [alpha=1] - alpha of the line to draw, will update the objects stored style
     * @param {number} [alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outter)
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.lineStyle = function lineStyle() {
        var lineWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var alpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var alignment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;

        this.lineWidth = lineWidth;
        this.lineColor = color;
        this.lineAlpha = alpha;
        this.lineAlignment = alignment;

        if (this.currentPath) {
            if (this.currentPath.shape.points.length) {
                // halfway through a line? start a new one!
                var shape = new _math.Polygon(this.currentPath.shape.points.slice(-2));

                shape.closed = false;

                this.drawShape(shape);
            } else {
                // otherwise its empty so lets just set the line properties
                this.currentPath.lineWidth = this.lineWidth;
                this.currentPath.lineColor = this.lineColor;
                this.currentPath.lineAlpha = this.lineAlpha;
                this.currentPath.lineAlignment = this.lineAlignment;
            }
        }

        return this;
    };

    /**
     * Moves the current drawing position to x, y.
     *
     * @param {number} x - the X coordinate to move to
     * @param {number} y - the Y coordinate to move to
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.moveTo = function moveTo(x, y) {
        var shape = new _math.Polygon([x, y]);

        shape.closed = false;
        this.drawShape(shape);

        return this;
    };

    /**
     * Draws a line using the current line style from the current drawing position to (x, y);
     * The current drawing position is then set to (x, y).
     *
     * @param {number} x - the X coordinate to draw to
     * @param {number} y - the Y coordinate to draw to
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.lineTo = function lineTo(x, y) {
        var points = this.currentPath.shape.points;

        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];

        if (fromX !== x || fromY !== y) {
            points.push(x, y);
            this.dirty++;
        }

        return this;
    };

    /**
     * Calculate the points for a quadratic bezier curve and then draws it.
     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
     *
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.quadraticCurveTo = function quadraticCurveTo(cpX, cpY, toX, toY) {
        if (this.currentPath) {
            if (this.currentPath.shape.points.length === 0) {
                this.currentPath.shape.points = [0, 0];
            }
        } else {
            this.moveTo(0, 0);
        }

        var points = this.currentPath.shape.points;
        var xa = 0;
        var ya = 0;

        if (points.length === 0) {
            this.moveTo(0, 0);
        }

        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        var n = Graphics.CURVES.adaptive ? this._segmentsCount(this._quadraticCurveLength(fromX, fromY, cpX, cpY, toX, toY)) : 20;

        for (var i = 1; i <= n; ++i) {
            var j = i / n;

            xa = fromX + (cpX - fromX) * j;
            ya = fromY + (cpY - fromY) * j;

            points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
        }

        this.dirty++;

        return this;
    };

    /**
     * Calculate the points for a bezier curve and then draws it.
     *
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.bezierCurveTo = function bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
        if (this.currentPath) {
            if (this.currentPath.shape.points.length === 0) {
                this.currentPath.shape.points = [0, 0];
            }
        } else {
            this.moveTo(0, 0);
        }

        var points = this.currentPath.shape.points;

        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];

        points.length -= 2;

        var n = Graphics.CURVES.adaptive ? this._segmentsCount(this._bezierCurveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY)) : 20;

        (0, _bezierCurveTo3.default)(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, n, points);

        this.dirty++;

        return this;
    };

    /**
     * The arcTo() method creates an arc/curve between two tangents on the canvas.
     *
     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
     *
     * @param {number} x1 - The x-coordinate of the beginning of the arc
     * @param {number} y1 - The y-coordinate of the beginning of the arc
     * @param {number} x2 - The x-coordinate of the end of the arc
     * @param {number} y2 - The y-coordinate of the end of the arc
     * @param {number} radius - The radius of the arc
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.arcTo = function arcTo(x1, y1, x2, y2, radius) {
        if (this.currentPath) {
            if (this.currentPath.shape.points.length === 0) {
                this.currentPath.shape.points.push(x1, y1);
            }
        } else {
            this.moveTo(x1, y1);
        }

        var points = this.currentPath.shape.points;
        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        var a1 = fromY - y1;
        var b1 = fromX - x1;
        var a2 = y2 - y1;
        var b2 = x2 - x1;
        var mm = Math.abs(a1 * b2 - b1 * a2);

        if (mm < 1.0e-8 || radius === 0) {
            if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) {
                points.push(x1, y1);
            }
        } else {
            var dd = a1 * a1 + b1 * b1;
            var cc = a2 * a2 + b2 * b2;
            var tt = a1 * a2 + b1 * b2;
            var k1 = radius * Math.sqrt(dd) / mm;
            var k2 = radius * Math.sqrt(cc) / mm;
            var j1 = k1 * tt / dd;
            var j2 = k2 * tt / cc;
            var cx = k1 * b2 + k2 * b1;
            var cy = k1 * a2 + k2 * a1;
            var px = b1 * (k2 + j1);
            var py = a1 * (k2 + j1);
            var qx = b2 * (k1 + j2);
            var qy = a2 * (k1 + j2);
            var startAngle = Math.atan2(py - cy, px - cx);
            var endAngle = Math.atan2(qy - cy, qx - cx);

            this.arc(cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
        }

        this.dirty++;

        return this;
    };

    /**
     * The arc method creates an arc/curve (used to create circles, or parts of circles).
     *
     * @param {number} cx - The x-coordinate of the center of the circle
     * @param {number} cy - The y-coordinate of the center of the circle
     * @param {number} radius - The radius of the circle
     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
     *  of the arc's circle)
     * @param {number} endAngle - The ending angle, in radians
     * @param {boolean} [anticlockwise=false] - Specifies whether the drawing should be
     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
     *  indicates counter-clockwise.
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.arc = function arc(cx, cy, radius, startAngle, endAngle) {
        var anticlockwise = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

        if (startAngle === endAngle) {
            return this;
        }

        if (!anticlockwise && endAngle <= startAngle) {
            endAngle += _const.PI_2;
        } else if (anticlockwise && startAngle <= endAngle) {
            startAngle += _const.PI_2;
        }

        var sweep = endAngle - startAngle;
        var segs = Graphics.CURVES.adaptive ? this._segmentsCount(Math.abs(sweep) * radius) : Math.ceil(Math.abs(sweep) / _const.PI_2) * 40;

        if (sweep === 0) {
            return this;
        }

        var startX = cx + Math.cos(startAngle) * radius;
        var startY = cy + Math.sin(startAngle) * radius;

        // If the currentPath exists, take its points. Otherwise call `moveTo` to start a path.
        var points = this.currentPath ? this.currentPath.shape.points : null;

        if (points) {
            // We check how far our start is from the last existing point
            var xDiff = Math.abs(points[points.length - 2] - startX);
            var yDiff = Math.abs(points[points.length - 1] - startY);

            if (xDiff < 0.001 && yDiff < 0.001) {
                // If the point is very close, we don't add it, since this would lead to artifacts
                // during tesselation due to floating point imprecision.
            } else {
                points.push(startX, startY);
            }
        } else {
            this.moveTo(startX, startY);
            points = this.currentPath.shape.points;
        }

        var theta = sweep / (segs * 2);
        var theta2 = theta * 2;

        var cTheta = Math.cos(theta);
        var sTheta = Math.sin(theta);

        var segMinus = segs - 1;

        var remainder = segMinus % 1 / segMinus;

        for (var i = 0; i <= segMinus; ++i) {
            var real = i + remainder * i;

            var angle = theta + startAngle + theta2 * real;

            var c = Math.cos(angle);
            var s = -Math.sin(angle);

            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
        }

        this.dirty++;

        return this;
    };

    /**
     * Specifies a simple one-color fill that subsequent calls to other Graphics methods
     * (such as lineTo() or drawCircle()) use when drawing.
     *
     * @param {number} [color=0] - the color of the fill
     * @param {number} [alpha=1] - the alpha of the fill
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.beginFill = function beginFill() {
        var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        this.filling = true;
        this.fillColor = color;
        this.fillAlpha = alpha;

        if (this.currentPath) {
            if (this.currentPath.shape.points.length <= 2) {
                this.currentPath.fill = this.filling;
                this.currentPath.fillColor = this.fillColor;
                this.currentPath.fillAlpha = this.fillAlpha;
            }
        }

        return this;
    };

    /**
     * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
     *
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.endFill = function endFill() {
        this.filling = false;
        this.fillColor = null;
        this.fillAlpha = 1;

        return this;
    };

    /**
     *
     * @param {number} x - The X coord of the top-left of the rectangle
     * @param {number} y - The Y coord of the top-left of the rectangle
     * @param {number} width - The width of the rectangle
     * @param {number} height - The height of the rectangle
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.drawRect = function drawRect(x, y, width, height) {
        this.drawShape(new _math.Rectangle(x, y, width, height));

        return this;
    };

    /**
     *
     * @param {number} x - The X coord of the top-left of the rectangle
     * @param {number} y - The Y coord of the top-left of the rectangle
     * @param {number} width - The width of the rectangle
     * @param {number} height - The height of the rectangle
     * @param {number} radius - Radius of the rectangle corners
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.drawRoundedRect = function drawRoundedRect(x, y, width, height, radius) {
        this.drawShape(new _math.RoundedRectangle(x, y, width, height, radius));

        return this;
    };

    /**
     * Draws a circle.
     *
     * @param {number} x - The X coordinate of the center of the circle
     * @param {number} y - The Y coordinate of the center of the circle
     * @param {number} radius - The radius of the circle
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.drawCircle = function drawCircle(x, y, radius) {
        this.drawShape(new _math.Circle(x, y, radius));

        return this;
    };

    /**
     * Draws an ellipse.
     *
     * @param {number} x - The X coordinate of the center of the ellipse
     * @param {number} y - The Y coordinate of the center of the ellipse
     * @param {number} width - The half width of the ellipse
     * @param {number} height - The half height of the ellipse
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.drawEllipse = function drawEllipse(x, y, width, height) {
        this.drawShape(new _math.Ellipse(x, y, width, height));

        return this;
    };

    /**
     * Draws a polygon using the given path.
     *
     * @param {number[]|PIXI.Point[]|PIXI.Polygon} path - The path data used to construct the polygon.
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.drawPolygon = function drawPolygon(path) {
        // prevents an argument assignment deopt
        // see section 3.1: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
        var points = path;

        var closed = true;

        if (points instanceof _math.Polygon) {
            closed = points.closed;
            points = points.points;
        }

        if (!Array.isArray(points)) {
            // prevents an argument leak deopt
            // see section 3.2: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
            points = new Array(arguments.length);

            for (var i = 0; i < points.length; ++i) {
                points[i] = arguments[i]; // eslint-disable-line prefer-rest-params
            }
        }

        var shape = new _math.Polygon(points);

        shape.closed = closed;

        this.drawShape(shape);

        return this;
    };

    /**
     * Draw a star shape with an abitrary number of points.
     *
     * @param {number} x - Center X position of the star
     * @param {number} y - Center Y position of the star
     * @param {number} points - The number of points of the star, must be > 1
     * @param {number} radius - The outer radius of the star
     * @param {number} [innerRadius] - The inner radius between points, default half `radius`
     * @param {number} [rotation=0] - The rotation of the star in radians, where 0 is vertical
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.drawStar = function drawStar(x, y, points, radius, innerRadius) {
        var rotation = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

        innerRadius = innerRadius || radius / 2;

        var startAngle = -1 * Math.PI / 2 + rotation;
        var len = points * 2;
        var delta = _const.PI_2 / len;
        var polygon = [];

        for (var i = 0; i < len; i++) {
            var r = i % 2 ? innerRadius : radius;
            var angle = i * delta + startAngle;

            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
        }

        return this.drawPolygon(polygon);
    };

    /**
     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
     *
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */

    Graphics.prototype.clear = function clear() {
        if (this.lineWidth || this.filling || this.graphicsData.length > 0) {
            this.lineWidth = 0;
            this.lineAlignment = 0.5;

            this.filling = false;

            this.boundsDirty = -1;
            this.canvasTintDirty = -1;
            this.dirty++;
            this.clearDirty++;
            this.graphicsData.length = 0;
        }

        this.currentPath = null;
        this._spriteRect = null;

        return this;
    };

    /**
     * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
     * masked with gl.scissor.
     *
     * @returns {boolean} True if only 1 rect.
     */

    Graphics.prototype.isFastRect = function isFastRect() {
        return this.graphicsData.length === 1 && this.graphicsData[0].shape.type === _const.SHAPES.RECT && !this.graphicsData[0].lineWidth;
    };

    /**
     * Renders the object using the WebGL renderer
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */

    Graphics.prototype._renderWebGL = function _renderWebGL(renderer) {
        // if the sprite is not visible or the alpha is 0 then no need to render this element
        if (this.dirty !== this.fastRectDirty) {
            this.fastRectDirty = this.dirty;
            this._fastRect = this.isFastRect();
        }

        // TODO this check can be moved to dirty?
        if (this._fastRect) {
            this._renderSpriteRect(renderer);
        } else {
            renderer.setObjectRenderer(renderer.plugins.graphics);
            renderer.plugins.graphics.render(this);
        }
    };

    /**
     * Renders a sprite rectangle.
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */

    Graphics.prototype._renderSpriteRect = function _renderSpriteRect(renderer) {
        var rect = this.graphicsData[0].shape;

        if (!this._spriteRect) {
            this._spriteRect = new _Sprite2.default(new _Texture2.default(_Texture2.default.WHITE));
        }

        var sprite = this._spriteRect;
        var fillColor = this.graphicsData[0].fillColor;

        if (this.tint === 0xffffff) {
            sprite.tint = fillColor;
        } else if (this.tint !== this._prevRectTint || fillColor !== this._prevRectFillColor) {
            var t1 = tempColor1;
            var t2 = tempColor2;

            (0, _utils.hex2rgb)(fillColor, t1);
            (0, _utils.hex2rgb)(this.tint, t2);

            t1[0] *= t2[0];
            t1[1] *= t2[1];
            t1[2] *= t2[2];

            sprite.tint = (0, _utils.rgb2hex)(t1);

            this._prevRectTint = this.tint;
            this._prevRectFillColor = fillColor;
        }

        sprite.alpha = this.graphicsData[0].fillAlpha;
        sprite.worldAlpha = this.worldAlpha * sprite.alpha;
        sprite.blendMode = this.blendMode;

        sprite._texture._frame.width = rect.width;
        sprite._texture._frame.height = rect.height;

        sprite.transform.worldTransform = this.transform.worldTransform;

        sprite.anchor.set(-rect.x / rect.width, -rect.y / rect.height);
        sprite._onAnchorUpdate();

        sprite._renderWebGL(renderer);
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The renderer
     */

    Graphics.prototype._renderCanvas = function _renderCanvas(renderer) {
        if (this.isMask === true) {
            return;
        }

        renderer.plugins.graphics.render(this);
    };

    /**
     * Retrieves the bounds of the graphic shape as a rectangle object
     *
     * @private
     */

    Graphics.prototype._calculateBounds = function _calculateBounds() {
        if (this.boundsDirty !== this.dirty) {
            this.boundsDirty = this.dirty;
            this.updateLocalBounds();

            this.cachedSpriteDirty = true;
        }

        var lb = this._localBounds;

        this._bounds.addFrame(this.transform, lb.minX, lb.minY, lb.maxX, lb.maxY);
    };

    /**
     * Tests if a point is inside this graphics object
     *
     * @param {PIXI.Point} point - the point to test
     * @return {boolean} the result of the test
     */

    Graphics.prototype.containsPoint = function containsPoint(point) {
        this.worldTransform.applyInverse(point, tempPoint);

        var graphicsData = this.graphicsData;

        for (var i = 0; i < graphicsData.length; ++i) {
            var data = graphicsData[i];

            if (!data.fill) {
                continue;
            }

            // only deal with fills..
            if (data.shape) {
                if (data.shape.contains(tempPoint.x, tempPoint.y)) {
                    if (data.holes) {
                        for (var _i = 0; _i < data.holes.length; _i++) {
                            var hole = data.holes[_i];

                            if (hole.contains(tempPoint.x, tempPoint.y)) {
                                return false;
                            }
                        }
                    }

                    return true;
                }
            }
        }

        return false;
    };

    /**
     * Update the bounds of the object
     *
     */

    Graphics.prototype.updateLocalBounds = function updateLocalBounds() {
        var minX = Infinity;
        var maxX = -Infinity;

        var minY = Infinity;
        var maxY = -Infinity;

        if (this.graphicsData.length) {
            var shape = 0;
            var x = 0;
            var y = 0;
            var w = 0;
            var h = 0;

            for (var i = 0; i < this.graphicsData.length; i++) {
                var data = this.graphicsData[i];
                var type = data.type;
                var lineWidth = data.lineWidth;
                var lineAlignment = data.lineAlignment;

                var lineOffset = lineWidth * lineAlignment;

                shape = data.shape;

                if (type === _const.SHAPES.RECT || type === _const.SHAPES.RREC) {
                    x = shape.x - lineOffset;
                    y = shape.y - lineOffset;
                    w = shape.width + lineOffset * 2;
                    h = shape.height + lineOffset * 2;

                    minX = x < minX ? x : minX;
                    maxX = x + w > maxX ? x + w : maxX;

                    minY = y < minY ? y : minY;
                    maxY = y + h > maxY ? y + h : maxY;
                } else if (type === _const.SHAPES.CIRC) {
                    x = shape.x;
                    y = shape.y;
                    w = shape.radius + lineOffset;
                    h = shape.radius + lineOffset;

                    minX = x - w < minX ? x - w : minX;
                    maxX = x + w > maxX ? x + w : maxX;

                    minY = y - h < minY ? y - h : minY;
                    maxY = y + h > maxY ? y + h : maxY;
                } else if (type === _const.SHAPES.ELIP) {
                    x = shape.x;
                    y = shape.y;
                    w = shape.width + lineOffset;
                    h = shape.height + lineOffset;

                    minX = x - w < minX ? x - w : minX;
                    maxX = x + w > maxX ? x + w : maxX;

                    minY = y - h < minY ? y - h : minY;
                    maxY = y + h > maxY ? y + h : maxY;
                } else {
                    // POLY
                    var points = shape.points;
                    var x2 = 0;
                    var y2 = 0;
                    var dx = 0;
                    var dy = 0;
                    var rw = 0;
                    var rh = 0;
                    var cx = 0;
                    var cy = 0;

                    for (var j = 0; j + 2 < points.length; j += 2) {
                        x = points[j];
                        y = points[j + 1];
                        x2 = points[j + 2];
                        y2 = points[j + 3];
                        dx = Math.abs(x2 - x);
                        dy = Math.abs(y2 - y);
                        h = lineOffset * 2;
                        w = Math.sqrt(dx * dx + dy * dy);

                        if (w < 1e-9) {
                            continue;
                        }

                        rw = (h / w * dy + dx) / 2;
                        rh = (h / w * dx + dy) / 2;
                        cx = (x2 + x) / 2;
                        cy = (y2 + y) / 2;

                        minX = cx - rw < minX ? cx - rw : minX;
                        maxX = cx + rw > maxX ? cx + rw : maxX;

                        minY = cy - rh < minY ? cy - rh : minY;
                        maxY = cy + rh > maxY ? cy + rh : maxY;
                    }
                }
            }
        } else {
            minX = 0;
            maxX = 0;
            minY = 0;
            maxY = 0;
        }

        var padding = this.boundsPadding;

        this._localBounds.minX = minX - padding;
        this._localBounds.maxX = maxX + padding;

        this._localBounds.minY = minY - padding;
        this._localBounds.maxY = maxY + padding;
    };

    /**
     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
     *
     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
     * @return {PIXI.GraphicsData} The generated GraphicsData object.
     */

    Graphics.prototype.drawShape = function drawShape(shape) {
        if (this.currentPath) {
            // check current path!
            if (this.currentPath.shape.points.length <= 2) {
                this.graphicsData.pop();
            }
        }

        this.currentPath = null;

        var data = new _GraphicsData2.default(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.filling, this.nativeLines, shape, this.lineAlignment);

        this.graphicsData.push(data);

        if (data.type === _const.SHAPES.POLY) {
            data.shape.closed = data.shape.closed;
            this.currentPath = data;
        }

        this.dirty++;

        return data;
    };

    /**
     * Generates a canvas texture.
     *
     * @param {number} scaleMode - The scale mode of the texture.
     * @param {number} resolution - The resolution of the texture.
     * @return {PIXI.Texture} The new texture.
     */

    Graphics.prototype.generateCanvasTexture = function generateCanvasTexture(scaleMode) {
        var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        var bounds = this.getLocalBounds();

        var canvasBuffer = _RenderTexture2.default.create(bounds.width, bounds.height, scaleMode, resolution);

        if (!canvasRenderer) {
            canvasRenderer = new _CanvasRenderer2.default();
        }

        this.transform.updateLocalTransform();
        this.transform.localTransform.copy(tempMatrix);

        tempMatrix.invert();

        tempMatrix.tx -= bounds.x;
        tempMatrix.ty -= bounds.y;

        canvasRenderer.render(this, canvasBuffer, true, tempMatrix);

        var texture = _Texture2.default.fromCanvas(canvasBuffer.baseTexture._canvasRenderTarget.canvas, scaleMode, 'graphics');

        texture.baseTexture.resolution = resolution;
        texture.baseTexture.update();

        return texture;
    };

    /**
     * Closes the current path.
     *
     * @return {PIXI.Graphics} Returns itself.
     */

    Graphics.prototype.closePath = function closePath() {
        // ok so close path assumes next one is a hole!
        var currentPath = this.currentPath;

        if (currentPath && currentPath.shape) {
            currentPath.shape.close();
        }

        return this;
    };

    /**
     * Adds a hole in the current path.
     *
     * @return {PIXI.Graphics} Returns itself.
     */

    Graphics.prototype.addHole = function addHole() {
        // this is a hole!
        var hole = this.graphicsData.pop();

        this.currentPath = this.graphicsData[this.graphicsData.length - 1];

        this.currentPath.addHole(hole.shape);
        this.currentPath = null;

        return this;
    };

    /**
     * Destroys the Graphics object.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
     *  options have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have
     *  their destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */

    Graphics.prototype.destroy = function destroy(options) {
        _Container.prototype.destroy.call(this, options);

        // destroy each of the GraphicsData objects
        for (var i = 0; i < this.graphicsData.length; ++i) {
            this.graphicsData[i].destroy();
        }

        // for each webgl data entry, destroy the WebGLGraphicsData
        for (var id in this._webGL) {
            for (var j = 0; j < this._webGL[id].data.length; ++j) {
                this._webGL[id].data[j].destroy();
            }
        }

        if (this._spriteRect) {
            this._spriteRect.destroy();
        }

        this.graphicsData = null;

        this.currentPath = null;
        this._webGL = null;
        this._localBounds = null;
    };

    return Graphics;
}(_Container3.default);

exports.default = Graphics;

Graphics._SPRITE_TEXTURE = null;

/**
 * Graphics curves resolution settings. If `adaptive` flag is set to `true`,
 * the resolution is calculated based on the curve's length to ensure better visual quality.
 * Adaptive draw works with `bezierCurveTo` and `quadraticCurveTo`.
 *
 * @static
 * @constant
 * @memberof PIXI.Graphics
 * @name CURVES
 * @type {object}
 * @property {boolean} adaptive=false - flag indicating if the resolution should be adaptive
 * @property {number} maxLength=10 - maximal length of a single segment of the curve (if adaptive = false, ignored)
 * @property {number} minSegments=8 - minimal number of segments in the curve (if adaptive = false, ignored)
 * @property {number} maxSegments=2048 - maximal number of segments in the curve (if adaptive = false, ignored)
 */
Graphics.CURVES = {
    adaptive: false,
    maxLength: 10,
    minSegments: 8,
    maxSegments: 2048
};
//# sourceMappingURL=Graphics.js.map

/***/ }),

/***/ "f6ML":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("sNCo");

/***/ }),

/***/ "fRpE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _path = __webpack_require__("UUq2");

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The DisplacementFilter class uses the pixel values from the specified texture
 * (called the displacement map) to perform a displacement of an object. You can
 * use this filter to apply all manor of crazy warping effects. Currently the r
 * property of the texture is used to offset the x and the g property of the texture
 * is used to offset the y.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var DisplacementFilter = function (_core$Filter) {
    _inherits(DisplacementFilter, _core$Filter);

    /**
     * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
     * @param {number} scale - The scale of the displacement
     */
    function DisplacementFilter(sprite, scale) {
        _classCallCheck(this, DisplacementFilter);

        var maskMatrix = new core.Matrix();

        sprite.renderable = false;

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nvoid main(void)\n{\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n   vTextureCoord = aTextureCoord;\n}',
        // fragment shader
        'varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\n\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform vec4 filterArea;\nuniform vec4 filterClamp;\n\nvoid main(void)\n{\n  vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n  map -= 0.5;\n  map.xy *= scale / filterArea.xy;\n\n  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), filterClamp.xy, filterClamp.zw));\n}\n'));

        _this.maskSprite = sprite;
        _this.maskMatrix = maskMatrix;

        _this.uniforms.mapSampler = sprite._texture;
        _this.uniforms.filterMatrix = maskMatrix;
        _this.uniforms.scale = { x: 1, y: 1 };

        if (scale === null || scale === undefined) {
            scale = 20;
        }

        _this.scale = new core.Point(scale, scale);
        return _this;
    }

    /**
     * Applies the filter.
     *
     * @param {PIXI.FilterManager} filterManager - The manager.
     * @param {PIXI.RenderTarget} input - The input target.
     * @param {PIXI.RenderTarget} output - The output target.
     */

    DisplacementFilter.prototype.apply = function apply(filterManager, input, output) {
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
        this.uniforms.scale.x = this.scale.x;
        this.uniforms.scale.y = this.scale.y;

        // draw the filter...
        filterManager.applyFilter(this, input, output);
    };

    /**
     * The texture used for the displacement map. Must be power of 2 sized texture.
     *
     * @member {PIXI.Texture}
     */

    _createClass(DisplacementFilter, [{
        key: 'map',
        get: function get() {
            return this.uniforms.mapSampler;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.mapSampler = value;
        }
    }]);

    return DisplacementFilter;
}(core.Filter);

exports.default = DisplacementFilter;
//# sourceMappingURL=DisplacementFilter.js.map

/***/ }),

/***/ "fUBa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pixiGlCore = __webpack_require__("PJsv");

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

var _createIndicesForQuads = __webpack_require__("DI0o");

var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that
 * they now share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's ParticleBuffer:
 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleBuffer.java
 */

/**
 * The particle buffer manages the static and dynamic buffers for a particle container.
 *
 * @class
 * @private
 * @memberof PIXI
 */
var ParticleBuffer = function () {
    /**
     * @param {WebGLRenderingContext} gl - The rendering context.
     * @param {object} properties - The properties to upload.
     * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
     * @param {number} size - The size of the batch.
     */
    function ParticleBuffer(gl, properties, dynamicPropertyFlags, size) {
        _classCallCheck(this, ParticleBuffer);

        /**
         * The current WebGL drawing context.
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;

        /**
         * The number of particles the buffer can hold
         *
         * @member {number}
         */
        this.size = size;

        /**
         * A list of the properties that are dynamic.
         *
         * @member {object[]}
         */
        this.dynamicProperties = [];

        /**
         * A list of the properties that are static.
         *
         * @member {object[]}
         */
        this.staticProperties = [];

        for (var i = 0; i < properties.length; ++i) {
            var property = properties[i];

            // Make copy of properties object so that when we edit the offset it doesn't
            // change all other instances of the object literal
            property = {
                attribute: property.attribute,
                size: property.size,
                uploadFunction: property.uploadFunction,
                unsignedByte: property.unsignedByte,
                offset: property.offset
            };

            if (dynamicPropertyFlags[i]) {
                this.dynamicProperties.push(property);
            } else {
                this.staticProperties.push(property);
            }
        }

        this.staticStride = 0;
        this.staticBuffer = null;
        this.staticData = null;
        this.staticDataUint32 = null;

        this.dynamicStride = 0;
        this.dynamicBuffer = null;
        this.dynamicData = null;
        this.dynamicDataUint32 = null;

        this._updateID = 0;

        this.initBuffers();
    }

    /**
     * Sets up the renderer context and necessary buffers.
     *
     * @private
     */

    ParticleBuffer.prototype.initBuffers = function initBuffers() {
        var gl = this.gl;
        var dynamicOffset = 0;

        /**
         * Holds the indices of the geometry (quads) to draw
         *
         * @member {Uint16Array}
         */
        this.indices = (0, _createIndicesForQuads2.default)(this.size);
        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);

        this.dynamicStride = 0;

        for (var i = 0; i < this.dynamicProperties.length; ++i) {
            var property = this.dynamicProperties[i];

            property.offset = dynamicOffset;
            dynamicOffset += property.size;
            this.dynamicStride += property.size;
        }

        var dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 4 * 4);

        this.dynamicData = new Float32Array(dynBuffer);
        this.dynamicDataUint32 = new Uint32Array(dynBuffer);
        this.dynamicBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, dynBuffer, gl.STREAM_DRAW);

        // static //
        var staticOffset = 0;

        this.staticStride = 0;

        for (var _i = 0; _i < this.staticProperties.length; ++_i) {
            var _property = this.staticProperties[_i];

            _property.offset = staticOffset;
            staticOffset += _property.size;
            this.staticStride += _property.size;
        }

        var statBuffer = new ArrayBuffer(this.size * this.staticStride * 4 * 4);

        this.staticData = new Float32Array(statBuffer);
        this.staticDataUint32 = new Uint32Array(statBuffer);
        this.staticBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, statBuffer, gl.STATIC_DRAW);

        this.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(this.indexBuffer);

        for (var _i2 = 0; _i2 < this.dynamicProperties.length; ++_i2) {
            var _property2 = this.dynamicProperties[_i2];

            if (_property2.unsignedByte) {
                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.UNSIGNED_BYTE, true, this.dynamicStride * 4, _property2.offset * 4);
            } else {
                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.FLOAT, false, this.dynamicStride * 4, _property2.offset * 4);
            }
        }

        for (var _i3 = 0; _i3 < this.staticProperties.length; ++_i3) {
            var _property3 = this.staticProperties[_i3];

            if (_property3.unsignedByte) {
                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.UNSIGNED_BYTE, true, this.staticStride * 4, _property3.offset * 4);
            } else {
                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.FLOAT, false, this.staticStride * 4, _property3.offset * 4);
            }
        }
    };

    /**
     * Uploads the dynamic properties.
     *
     * @param {PIXI.DisplayObject[]} children - The children to upload.
     * @param {number} startIndex - The index to start at.
     * @param {number} amount - The number to upload.
     */

    ParticleBuffer.prototype.uploadDynamic = function uploadDynamic(children, startIndex, amount) {
        for (var i = 0; i < this.dynamicProperties.length; i++) {
            var property = this.dynamicProperties[i];

            property.uploadFunction(children, startIndex, amount, property.unsignedByte ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
        }

        this.dynamicBuffer.upload();
    };

    /**
     * Uploads the static properties.
     *
     * @param {PIXI.DisplayObject[]} children - The children to upload.
     * @param {number} startIndex - The index to start at.
     * @param {number} amount - The number to upload.
     */

    ParticleBuffer.prototype.uploadStatic = function uploadStatic(children, startIndex, amount) {
        for (var i = 0; i < this.staticProperties.length; i++) {
            var property = this.staticProperties[i];

            property.uploadFunction(children, startIndex, amount, property.unsignedByte ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
        }

        this.staticBuffer.upload();
    };

    /**
     * Destroys the ParticleBuffer.
     *
     */

    ParticleBuffer.prototype.destroy = function destroy() {
        this.dynamicProperties = null;
        this.dynamicBuffer.destroy();
        this.dynamicBuffer = null;
        this.dynamicData = null;
        this.dynamicDataUint32 = null;

        this.staticProperties = null;
        this.staticBuffer.destroy();
        this.staticBuffer = null;
        this.staticData = null;
        this.staticDataUint32 = null;
    };

    return ParticleBuffer;
}();

exports.default = ParticleBuffer;
//# sourceMappingURL=ParticleBuffer.js.map

/***/ }),

/***/ "ffDX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c34fb409c1800a289d45c4e4ca5d0d89.svg";

/***/ }),

/***/ "fg+O":
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__("kAhx");

var wrapMethod = function wrapMethod(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function () {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = { level: sentryLevel, logger: 'console', extra: { arguments: args } };

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg = 'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};

/***/ }),

/***/ "fpuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/isPlainObject.js + 8 modules
var isPlainObject = __webpack_require__("9TS5");

// EXTERNAL MODULE: ../node_modules/symbol-observable/index.js
var symbol_observable = __webpack_require__("f6ML");
var symbol_observable_default = /*#__PURE__*/__webpack_require__.n(symbol_observable);

// CONCATENATED MODULE: ../node_modules/redux/es/createStore.js



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore_createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore_createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(isPlainObject["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[symbol_observable_default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[symbol_observable_default.a] = observable, _ref2;
}
// CONCATENATED MODULE: ../node_modules/redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning_warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
// CONCATENATED MODULE: ../node_modules/redux/es/combineReducers.js




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(isPlainObject["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}
// CONCATENATED MODULE: ../node_modules/redux/es/bindActionCreators.js
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
// CONCATENATED MODULE: ../node_modules/redux/es/compose.js
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}
// CONCATENATED MODULE: ../node_modules/redux/es/applyMiddleware.js
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
// CONCATENATED MODULE: ../node_modules/redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return createStore_createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return compose; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),

/***/ "fst5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = generateMultiTextureShader;

var _Shader = __webpack_require__("wBQE");

var _Shader2 = _interopRequireDefault(_Shader);

var _path = __webpack_require__("UUq2");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var fragTemplate = ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'varying float vTextureId;', 'uniform sampler2D uSamplers[%count%];', 'void main(void){', 'vec4 color;', '%forloop%', 'gl_FragColor = color * vColor;', '}'].join('\n');

function generateMultiTextureShader(gl, maxTextures) {
    var vertexSrc = 'precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = aColor;\n}\n';
    var fragmentSrc = fragTemplate;

    fragmentSrc = fragmentSrc.replace(/%count%/gi, maxTextures);
    fragmentSrc = fragmentSrc.replace(/%forloop%/gi, generateSampleSrc(maxTextures));

    var shader = new _Shader2.default(gl, vertexSrc, fragmentSrc);

    var sampleValues = [];

    for (var i = 0; i < maxTextures; i++) {
        sampleValues[i] = i;
    }

    shader.bind();
    shader.uniforms.uSamplers = sampleValues;

    return shader;
}

function generateSampleSrc(maxTextures) {
    var src = '';

    src += '\n';
    src += '\n';

    for (var i = 0; i < maxTextures; i++) {
        if (i > 0) {
            src += '\nelse ';
        }

        if (i < maxTextures - 1) {
            src += 'if(vTextureId < ' + i + '.5)';
        }

        src += '\n{';
        src += '\n\tcolor = texture2D(uSamplers[' + i + '], vTextureCoord);';
        src += '\n}';
    }

    src += '\n';
    src += '\n';

    return src;
}
//# sourceMappingURL=generateMultiTextureShader.js.map

/***/ }),

/***/ "fxiT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _path = __webpack_require__("UUq2");

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The ColorMatrixFilter class lets you apply a 5x4 matrix transformation on the RGBA
 * color and alpha values of every pixel on your displayObject to produce a result
 * with a new set of RGBA color and alpha values. It's pretty powerful!
 *
 * ```js
 *  let colorMatrix = new PIXI.filters.ColorMatrixFilter();
 *  container.filters = [colorMatrix];
 *  colorMatrix.contrast(2);
 * ```
 * @author Clément Chenebault <clement@goodboydigital.com>
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var ColorMatrixFilter = function (_core$Filter) {
    _inherits(ColorMatrixFilter, _core$Filter);

    /**
     *
     */
    function ColorMatrixFilter() {
        _classCallCheck(this, ColorMatrixFilter);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
        // fragment shader
        'varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\nuniform float uAlpha;\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n\n    if (uAlpha == 0.0) {\n        gl_FragColor = c;\n        return;\n    }\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n\n    vec4 result;\n\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    gl_FragColor = vec4(rgb, result.a);\n}\n'));

        _this.uniforms.m = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];

        _this.alpha = 1;
        return _this;
    }

    /**
     * Transforms current matrix and set the new one
     *
     * @param {number[]} matrix - 5x4 matrix
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype._loadMatrix = function _loadMatrix(matrix) {
        var multiply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var newMatrix = matrix;

        if (multiply) {
            this._multiply(newMatrix, this.uniforms.m, matrix);
            newMatrix = this._colorMatrix(newMatrix);
        }

        // set the new matrix
        this.uniforms.m = newMatrix;
    };

    /**
     * Multiplies two mat5's
     *
     * @private
     * @param {number[]} out - 5x4 matrix the receiving matrix
     * @param {number[]} a - 5x4 matrix the first operand
     * @param {number[]} b - 5x4 matrix the second operand
     * @returns {number[]} 5x4 matrix
     */

    ColorMatrixFilter.prototype._multiply = function _multiply(out, a, b) {
        // Red Channel
        out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
        out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
        out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
        out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
        out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];

        // Green Channel
        out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
        out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
        out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
        out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
        out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];

        // Blue Channel
        out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
        out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
        out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
        out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
        out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];

        // Alpha Channel
        out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
        out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
        out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
        out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
        out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];

        return out;
    };

    /**
     * Create a Float32 Array and normalize the offset component to 0-1
     *
     * @private
     * @param {number[]} matrix - 5x4 matrix
     * @return {number[]} 5x4 matrix with all values between 0-1
     */

    ColorMatrixFilter.prototype._colorMatrix = function _colorMatrix(matrix) {
        // Create a Float32 Array and normalize the offset component to 0-1
        var m = new Float32Array(matrix);

        m[4] /= 255;
        m[9] /= 255;
        m[14] /= 255;
        m[19] /= 255;

        return m;
    };

    /**
     * Adjusts brightness
     *
     * @param {number} b - value of the brigthness (0-1, where 0 is black)
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.brightness = function brightness(b, multiply) {
        var matrix = [b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Set the matrices in grey scales
     *
     * @param {number} scale - value of the grey (0-1, where 0 is black)
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.greyscale = function greyscale(scale, multiply) {
        var matrix = [scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Set the black and white matrice.
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.blackAndWhite = function blackAndWhite(multiply) {
        var matrix = [0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Set the hue property of the color
     *
     * @param {number} rotation - in degrees
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.hue = function hue(rotation, multiply) {
        rotation = (rotation || 0) / 180 * Math.PI;

        var cosR = Math.cos(rotation);
        var sinR = Math.sin(rotation);
        var sqrt = Math.sqrt;

        /* a good approximation for hue rotation
         This matrix is far better than the versions with magic luminance constants
         formerly used here, but also used in the starling framework (flash) and known from this
         old part of the internet: quasimondo.com/archives/000565.php
          This new matrix is based on rgb cube rotation in space. Look here for a more descriptive
         implementation as a shader not a general matrix:
         https://github.com/evanw/glfx.js/blob/58841c23919bd59787effc0333a4897b43835412/src/filters/adjust/huesaturation.js
          This is the source for the code:
         see http://stackoverflow.com/questions/8507885/shift-hue-of-an-rgb-color/8510751#8510751
         */

        var w = 1 / 3;
        var sqrW = sqrt(w); // weight is

        var a00 = cosR + (1.0 - cosR) * w;
        var a01 = w * (1.0 - cosR) - sqrW * sinR;
        var a02 = w * (1.0 - cosR) + sqrW * sinR;

        var a10 = w * (1.0 - cosR) + sqrW * sinR;
        var a11 = cosR + w * (1.0 - cosR);
        var a12 = w * (1.0 - cosR) - sqrW * sinR;

        var a20 = w * (1.0 - cosR) - sqrW * sinR;
        var a21 = w * (1.0 - cosR) + sqrW * sinR;
        var a22 = cosR + w * (1.0 - cosR);

        var matrix = [a00, a01, a02, 0, 0, a10, a11, a12, 0, 0, a20, a21, a22, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Set the contrast matrix, increase the separation between dark and bright
     * Increase contrast : shadows darker and highlights brighter
     * Decrease contrast : bring the shadows up and the highlights down
     *
     * @param {number} amount - value of the contrast (0-1)
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.contrast = function contrast(amount, multiply) {
        var v = (amount || 0) + 1;
        var o = -0.5 * (v - 1);

        var matrix = [v, 0, 0, 0, o, 0, v, 0, 0, o, 0, 0, v, 0, o, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Set the saturation matrix, increase the separation between colors
     * Increase saturation : increase contrast, brightness, and sharpness
     *
     * @param {number} amount - The saturation amount (0-1)
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.saturate = function saturate() {
        var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var multiply = arguments[1];

        var x = amount * 2 / 3 + 1;
        var y = (x - 1) * -0.5;

        var matrix = [x, y, y, 0, 0, y, x, y, 0, 0, y, y, x, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Desaturate image (remove color)
     *
     * Call the saturate function
     *
     */

    ColorMatrixFilter.prototype.desaturate = function desaturate() // eslint-disable-line no-unused-vars
    {
        this.saturate(-1);
    };

    /**
     * Negative image (inverse of classic rgb matrix)
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.negative = function negative(multiply) {
        var matrix = [-1, 0, 0, 1, 0, 0, -1, 0, 1, 0, 0, 0, -1, 1, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Sepia image
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.sepia = function sepia(multiply) {
        var matrix = [0.393, 0.7689999, 0.18899999, 0, 0, 0.349, 0.6859999, 0.16799999, 0, 0, 0.272, 0.5339999, 0.13099999, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.technicolor = function technicolor(multiply) {
        var matrix = [1.9125277891456083, -0.8545344976951645, -0.09155508482755585, 0, 11.793603434377337, -0.3087833385928097, 1.7658908555458428, -0.10601743074722245, 0, -70.35205161461398, -0.231103377548616, -0.7501899197440212, 1.847597816108189, 0, 30.950940869491138, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Polaroid filter
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.polaroid = function polaroid(multiply) {
        var matrix = [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Filter who transforms : Red -> Blue and Blue -> Red
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.toBGR = function toBGR(multiply) {
        var matrix = [0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.kodachrome = function kodachrome(multiply) {
        var matrix = [1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502, -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203, -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Brown delicious browni filter (thanks Dominic Szablewski)
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.browni = function browni(multiply) {
        var matrix = [0.5997023498159715, 0.34553243048391263, -0.2708298674538042, 0, 47.43192855600873, -0.037703249837783157, 0.8609577587992641, 0.15059552388459913, 0, -36.96841498319127, 0.24113635128153335, -0.07441037908422492, 0.44972182064877153, 0, -7.562075277591283, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Vintage filter (thanks Dominic Szablewski)
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.vintage = function vintage(multiply) {
        var matrix = [0.6279345635605994, 0.3202183420819367, -0.03965408211312453, 0, 9.651285835294123, 0.02578397704808868, 0.6441188644374771, 0.03259127616149294, 0, 7.462829176470591, 0.0466055556782719, -0.0851232987247891, 0.5241648018700465, 0, 5.159190588235296, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * We don't know exactly what it does, kind of gradient map, but funny to play with!
     *
     * @param {number} desaturation - Tone values.
     * @param {number} toned - Tone values.
     * @param {string} lightColor - Tone values, example: `0xFFE580`
     * @param {string} darkColor - Tone values, example: `0xFFE580`
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.colorTone = function colorTone(desaturation, toned, lightColor, darkColor, multiply) {
        desaturation = desaturation || 0.2;
        toned = toned || 0.15;
        lightColor = lightColor || 0xFFE580;
        darkColor = darkColor || 0x338000;

        var lR = (lightColor >> 16 & 0xFF) / 255;
        var lG = (lightColor >> 8 & 0xFF) / 255;
        var lB = (lightColor & 0xFF) / 255;

        var dR = (darkColor >> 16 & 0xFF) / 255;
        var dG = (darkColor >> 8 & 0xFF) / 255;
        var dB = (darkColor & 0xFF) / 255;

        var matrix = [0.3, 0.59, 0.11, 0, 0, lR, lG, lB, desaturation, 0, dR, dG, dB, toned, 0, lR - dR, lG - dG, lB - dB, 0, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Night effect
     *
     * @param {number} intensity - The intensity of the night effect.
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.night = function night(intensity, multiply) {
        intensity = intensity || 0.1;
        var matrix = [intensity * -2.0, -intensity, 0, 0, 0, -intensity, 0, intensity, 0, 0, 0, intensity, intensity * 2.0, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Predator effect
     *
     * Erase the current matrix by setting a new indepent one
     *
     * @param {number} amount - how much the predator feels his future victim
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.predator = function predator(amount, multiply) {
        var matrix = [
        // row 1
        11.224130630493164 * amount, -4.794486999511719 * amount, -2.8746118545532227 * amount, 0 * amount, 0.40342438220977783 * amount,
        // row 2
        -3.6330697536468506 * amount, 9.193157196044922 * amount, -2.951810836791992 * amount, 0 * amount, -1.316135048866272 * amount,
        // row 3
        -3.2184197902679443 * amount, -4.2375030517578125 * amount, 7.476448059082031 * amount, 0 * amount, 0.8044459223747253 * amount,
        // row 4
        0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * LSD effect
     *
     * Multiply the current matrix
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */

    ColorMatrixFilter.prototype.lsd = function lsd(multiply) {
        var matrix = [2, -0.4, 0.5, 0, 0, -0.5, 2, -0.4, 0, 0, -0.4, -0.5, 3, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Erase the current matrix by setting the default one
     *
     */

    ColorMatrixFilter.prototype.reset = function reset() {
        var matrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, false);
    };

    /**
     * The matrix of the color matrix filter
     *
     * @member {number[]}
     * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
     */

    _createClass(ColorMatrixFilter, [{
        key: 'matrix',
        get: function get() {
            return this.uniforms.m;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.m = value;
        }

        /**
         * The opacity value to use when mixing the original and resultant colors.
         *
         * When the value is 0, the original color is used without modification.
         * When the value is 1, the result color is used.
         * When in the range (0, 1) the color is interpolated between the original and result by this amount.
         *
         * @member {number}
         * @default 1
         */

    }, {
        key: 'alpha',
        get: function get() {
            return this.uniforms.uAlpha;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.uAlpha = value;
        }
    }]);

    return ColorMatrixFilter;
}(core.Filter);

// Americanized alias


exports.default = ColorMatrixFilter;
ColorMatrixFilter.prototype.grayscale = ColorMatrixFilter.prototype.greyscale;
//# sourceMappingURL=ColorMatrixFilter.js.map

/***/ }),

/***/ "gH/r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = __webpack_require__("o6Mn");
var colors = [0xC362E0, 0x81BAFF, 0x46237A, 0xC4C400, 0xFC4F95, 0xA76E11, 0x00D1D5, 0x337E80, 0x6F0FFF, 0xCF360A, 0xA62273, 0xFF9E00];

var Config = function () {
    function Config() {
        _classCallCheck(this, Config);
    }

    Config.setTicketTypeColor = function setTicketTypeColor(types) {
        var _this = this;

        var dif = 0;
        if (types.length > colors.length) {
            dif = types.length - colors.length;
        }
        for (var i = 0; i < dif; i++) {
            colors.push(Math.floor(Math.random() * 16777215));
        }
        types.forEach(function (t, i) {
            _this._ticketTypeColors[t] = colors[i];
        });
    };

    Config.getTicketTypeColor = function getTicketTypeColor() {
        return this._ticketTypeColors;
    };

    Config.getSpecificTicketTypeColors = function getSpecificTicketTypeColors(tickets) {
        var _this2 = this;

        return tickets.map(function (tId) {
            return _this2._ticketTypeColors[tId];
        }).filter(function (color) {
            return color;
        });
    };

    _createClass(Config, null, [{
        key: "onConsole",
        set: function set(onConsole) {
            this._onConsole = onConsole;
        },
        get: function get() {
            return this._onConsole;
        }
    }, {
        key: "canvasBounding",
        set: function set(canvasBounding) {
            this._canvasBounding = canvasBounding;
        },
        get: function get() {
            return this._canvasBounding;
        }
    }, {
        key: "app",
        set: function set(app) {
            this._app = app;
            this._isWebGl = app.renderer instanceof PIXI.WebGLRenderer;
        },
        get: function get() {
            return this._app;
        }
    }, {
        key: "isWebGl",
        get: function get() {
            return this._isWebGl;
        }
    }, {
        key: "viewport",
        set: function set(viewport) {
            this._viewport = viewport;
        },
        get: function get() {
            return this._viewport;
        }
    }, {
        key: "xPadding",
        get: function get() {
            return this._xPadding;
        },
        set: function set(xPadding) {
            this._xPadding = xPadding;
        }
    }, {
        key: "font",
        set: function set(font) {
            this._font = font;
        },
        get: function get() {
            return this._font;
        }
    }, {
        key: "fontStyle",
        get: function get() {
            if (this._isWebGl) {
                return this._fontStyle;
            } else {
                return this._oldFontStyle;
            }
        }
    }, {
        key: "spriteGroup",
        set: function set(spriteGroup) {
            this._spriteGroup = spriteGroup;
        },
        get: function get() {
            return this._spriteGroup;
        }
    }, {
        key: "graphicsGroup",
        set: function set(graphicsGroup) {
            this._graphicsGroup = graphicsGroup;
        },
        get: function get() {
            return this._graphicsGroup;
        }
    }, {
        key: "textGroup",
        set: function set(textGroup) {
            this._textGroup = textGroup;
        },
        get: function get() {
            return this._textGroup;
        }
    }, {
        key: "maskGroup",
        set: function set(maskGroup) {
            this._maskGroup = maskGroup;
        },
        get: function get() {
            return this._maskGroup;
        }
    }, {
        key: "undoActions",
        set: function set(cb) {
            this._undoActions = cb;
        },
        get: function get() {
            return this._undoActions;
        }
    }, {
        key: "hasSections",
        get: function get() {
            return this._hasSections;
        },
        set: function set(hasSections) {
            this._hasSections = hasSections;
        }
    }, {
        key: "ticketMappingRepo",
        get: function get() {
            return this._ticketMappingRepo;
        },
        set: function set(tmp) {
            this._ticketMappingRepo = tmp;
        }
    }, {
        key: "style",
        get: function get() {
            return {
                backgroundConstructionColor: 0xfafaf9,
                backgroundReservationColor: 0xFFFFFF,
                primaryColor: 0x6621C0
            };
        }
    }]);

    return Config;
}();

Config._onConsole = false;
Config._xPadding = 0;
Config._ticketTypeColors = {};
Config._fontStyle = {
    fontSize: 12,
    fill: 0x000000,
    align: 'center',
    lineHeight: 64,
    anchor: new PIXI.Point(0.5, 0.5)
};
Config._oldFontStyle = {
    fontFamily: Utils_1.font,
    fontSize: 12,
    fill: 0x0000,
    align: "center"
};
exports.default = Config;
//# sourceMappingURL=Config.js.map

/***/ }),

/***/ "gIXU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
    return '%' + x.charCodeAt(0).toString(16).toUpperCase();
  });
};

/***/ }),

/***/ "gNnq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var InteractionManager_1 = __webpack_require__("dUAP");
var Utils_1 = __webpack_require__("o6Mn");
var Selector_1 = __webpack_require__("8Y7Z");
var Config_1 = __webpack_require__("gH/r");
var SelectionListener_1 = __webpack_require__("//Eg");
var MoveableContainer_1 = __webpack_require__("JJWE");
var ActionTracker_1 = __webpack_require__("h0Oq");
var bound_1 = __webpack_require__("USDo");

var MoveableIcon = function (_MoveableContainer_1$) {
    _inherits(MoveableIcon, _MoveableContainer_1$);

    function MoveableIcon(_ref) {
        var icon = _ref.icon,
            pos = _ref.pos,
            iconVisible = _ref.iconVisible,
            anchor = _ref.anchor,
            scale = _ref.scale;
        var reservationMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _classCallCheck(this, MoveableIcon);

        var _this = _possibleConstructorReturn(this, _MoveableContainer_1$.call(this));

        _this.bindFunctions();
        _this.moveableContainer = new PIXI.Container();
        _this.icon = icon || "bar";
        _this.iconVisible = iconVisible || false;
        _this.iconTexture = PIXI.loader.resources[_this.icon].texture;
        _this.iconTexture.baseTexture.mipmap = true;
        _this.iconSprite = new PIXI.Sprite(_this.iconTexture);
        _this.scale = scale || new PIXI.Point(1, 1);
        _this.iconSprite.scale = _this.scale;
        _this.iconSprite.anchor = anchor || { x: 0.5, y: 0.5 };
        _this.iconSprite.visible = _this.iconVisible;
        _this.interactionManager = InteractionManager_1.default.createInteractionManager();
        _this.moveableContainer.position = pos || { x: 0, y: 0 };
        _this.moveableContainer.addChild(_this.iconSprite);
        _this.xOff = 0;
        _this.yOff = 0;
        if (!reservationMode) {
            _this.selectionListener = new SelectionListener_1.default(_this.moveableContainer, _this, _this.onClick);
        }
        return _this;
    }

    MoveableIcon.prototype.bindFunctions = function bindFunctions() {
        this.onClick = this.onClick.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onDeselect = this.onDeselect.bind(this);
        this.setIcon = this.setIcon.bind(this);
        this.showIcon = this.showIcon.bind(this);
    };

    MoveableIcon.prototype.setIcon = function setIcon(iconName) {
        this.icon = iconName;
        this.iconTexture = PIXI.loader.resources[this.icon].texture;
        this.changeIcon();
    };

    MoveableIcon.prototype.setScale = function setScale(scaleValue) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setScale", this.setScale, [this.scale.x]);
        this.scale = new PIXI.Point(scaleValue, scaleValue);
        this.iconSprite.scale = this.scale;
        this.onChange();
        return undoValue;
    };

    MoveableIcon.prototype.showIcon = function showIcon(show) {
        this.iconVisible = show;
        this.changeIcon();
    };

    MoveableIcon.prototype.changeIcon = function changeIcon() {
        this.iconSprite.texture = this.iconTexture;
        this.iconSprite.visible = this.iconVisible;
    };

    MoveableIcon.prototype.toJSON = function toJSON() {
        var _moveableContainer$po = this.moveableContainer.position,
            x = _moveableContainer$po.x,
            y = _moveableContainer$po.y;

        var anchor = this.iconSprite.anchor;
        return {
            icon: this.icon,
            pos: { x: x, y: y },
            iconVisible: this.iconVisible,
            anchor: { x: anchor.x, y: anchor.y },
            scale: this.scale
        };
    };

    MoveableIcon.prototype.changeScale = function changeScale(scale) {
        this.scale = scale;
        this.iconSprite.scale = scale;
    };

    MoveableIcon.prototype.onSelect = function onSelect() {};

    MoveableIcon.prototype.onDeselect = function onDeselect() {};

    MoveableIcon.prototype.getContainer = function getContainer() {
        return this.moveableContainer;
    };

    MoveableIcon.prototype.setAnchor = function setAnchor(anchor) {};

    MoveableIcon.prototype.setContainerOffset = function setContainerOffset(xOff, yOff) {
        this.xOff = xOff;
        this.yOff = yOff;
    };

    MoveableIcon.prototype.move = function move(e) {
        var xInc = e.data.originalEvent.movementX / Config_1.default.viewport.transform.scale._x;
        var yInc = e.data.originalEvent.movementY / Config_1.default.viewport.transform.scale._y;
        this.moveableContainer.position.x += xInc;
        this.moveableContainer.position.y += yInc;
    };

    MoveableIcon.prototype.getSelectionBoxBounds = function getSelectionBoxBounds() {
        var gPoint = this.moveableContainer.getGlobalPosition();
        var width = Utils_1.iconWidth * this.scale.x;
        var height = Utils_1.iconHeight * this.scale.y;
        var y = this.moveableContainer.position.y + this.yOff - height / 2;
        var x = this.moveableContainer.position.x + this.xOff - width / 2;
        return { x: x, y: y, width: width, height: height };
    };

    MoveableIcon.prototype.drawSelectionBox = function drawSelectionBox() {
        var _getSelectionBoxBound = this.getSelectionBoxBounds(),
            x = _getSelectionBoxBound.x,
            y = _getSelectionBoxBound.y,
            width = _getSelectionBoxBound.width,
            height = _getSelectionBoxBound.height;

        Selector_1.drawSelectionBox(x, y, width, height, false);
    };

    MoveableIcon.prototype.onElementClicked = function onElementClicked() {};

    MoveableIcon.prototype.onClick = function onClick() {
        this.interactionManager.itemSelected(this);
    };

    return MoveableIcon;
}(MoveableContainer_1.default);

__decorate([bound_1.default], MoveableIcon.prototype, "setScale", null);
exports.default = MoveableIcon;
//# sourceMappingURL=MoveableIcon.js.map

/***/ }),

/***/ "gTSb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = buildCircle;

var _buildLine = __webpack_require__("MEjA");

var _buildLine2 = _interopRequireDefault(_buildLine);

var _const = __webpack_require__("YEQi");

var _utils = __webpack_require__("dDI1");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Builds a circle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object to draw
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
 */
function buildCircle(graphicsData, webGLData, webGLDataNativeLines) {
    // need to convert points to a nice regular data
    var circleData = graphicsData.shape;
    var x = circleData.x;
    var y = circleData.y;
    var width = void 0;
    var height = void 0;

    // TODO - bit hacky??
    if (graphicsData.type === _const.SHAPES.CIRC) {
        width = circleData.radius;
        height = circleData.radius;
    } else {
        width = circleData.width;
        height = circleData.height;
    }

    if (width === 0 || height === 0) {
        return;
    }

    var totalSegs = Math.floor(30 * Math.sqrt(circleData.radius)) || Math.floor(15 * Math.sqrt(circleData.width + circleData.height));

    var seg = Math.PI * 2 / totalSegs;

    if (graphicsData.fill) {
        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
        var alpha = graphicsData.fillAlpha;

        var r = color[0] * alpha;
        var g = color[1] * alpha;
        var b = color[2] * alpha;

        var verts = webGLData.points;
        var indices = webGLData.indices;

        var vecPos = verts.length / 6;

        indices.push(vecPos);

        for (var i = 0; i < totalSegs + 1; i++) {
            verts.push(x, y, r, g, b, alpha);

            verts.push(x + Math.sin(seg * i) * width, y + Math.cos(seg * i) * height, r, g, b, alpha);

            indices.push(vecPos++, vecPos++);
        }

        indices.push(vecPos - 1);
    }

    if (graphicsData.lineWidth) {
        var tempPoints = graphicsData.points;

        graphicsData.points = [];

        for (var _i = 0; _i < totalSegs; _i++) {
            graphicsData.points.push(x + Math.sin(seg * -_i) * width, y + Math.cos(seg * -_i) * height);
        }

        graphicsData.points.push(graphicsData.points[0], graphicsData.points[1]);

        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);

        graphicsData.points = tempPoints;
    }
}
//# sourceMappingURL=buildCircle.js.map

/***/ }),

/***/ "gXRl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Bit twiddling hacks for JavaScript.
 *
 * Author: Mikola Lysenko
 *
 * Ported from Stanford bit twiddling hack library:
 *    http://graphics.stanford.edu/~seander/bithacks.html
 */

"use restrict";

//Number of bits in an integer

var INT_BITS = 32;

//Constants
exports.INT_BITS = INT_BITS;
exports.INT_MAX = 0x7fffffff;
exports.INT_MIN = -1 << INT_BITS - 1;

//Returns -1, 0, +1 depending on sign of x
exports.sign = function (v) {
  return (v > 0) - (v < 0);
};

//Computes absolute value of integer
exports.abs = function (v) {
  var mask = v >> INT_BITS - 1;
  return (v ^ mask) - mask;
};

//Computes minimum of integers x and y
exports.min = function (x, y) {
  return y ^ (x ^ y) & -(x < y);
};

//Computes maximum of integers x and y
exports.max = function (x, y) {
  return x ^ (x ^ y) & -(x < y);
};

//Checks if a number is a power of two
exports.isPow2 = function (v) {
  return !(v & v - 1) && !!v;
};

//Computes log base 2 of v
exports.log2 = function (v) {
  var r, shift;
  r = (v > 0xFFFF) << 4;v >>>= r;
  shift = (v > 0xFF) << 3;v >>>= shift;r |= shift;
  shift = (v > 0xF) << 2;v >>>= shift;r |= shift;
  shift = (v > 0x3) << 1;v >>>= shift;r |= shift;
  return r | v >> 1;
};

//Computes log base 10 of v
exports.log10 = function (v) {
  return v >= 1000000000 ? 9 : v >= 100000000 ? 8 : v >= 10000000 ? 7 : v >= 1000000 ? 6 : v >= 100000 ? 5 : v >= 10000 ? 4 : v >= 1000 ? 3 : v >= 100 ? 2 : v >= 10 ? 1 : 0;
};

//Counts number of bits
exports.popCount = function (v) {
  v = v - (v >>> 1 & 0x55555555);
  v = (v & 0x33333333) + (v >>> 2 & 0x33333333);
  return (v + (v >>> 4) & 0xF0F0F0F) * 0x1010101 >>> 24;
};

//Counts number of trailing zeros
function countTrailingZeros(v) {
  var c = 32;
  v &= -v;
  if (v) c--;
  if (v & 0x0000FFFF) c -= 16;
  if (v & 0x00FF00FF) c -= 8;
  if (v & 0x0F0F0F0F) c -= 4;
  if (v & 0x33333333) c -= 2;
  if (v & 0x55555555) c -= 1;
  return c;
}
exports.countTrailingZeros = countTrailingZeros;

//Rounds to next power of 2
exports.nextPow2 = function (v) {
  v += v === 0;
  --v;
  v |= v >>> 1;
  v |= v >>> 2;
  v |= v >>> 4;
  v |= v >>> 8;
  v |= v >>> 16;
  return v + 1;
};

//Rounds down to previous power of 2
exports.prevPow2 = function (v) {
  v |= v >>> 1;
  v |= v >>> 2;
  v |= v >>> 4;
  v |= v >>> 8;
  v |= v >>> 16;
  return v - (v >>> 1);
};

//Computes parity of word
exports.parity = function (v) {
  v ^= v >>> 16;
  v ^= v >>> 8;
  v ^= v >>> 4;
  v &= 0xf;
  return 0x6996 >>> v & 1;
};

var REVERSE_TABLE = new Array(256);

(function (tab) {
  for (var i = 0; i < 256; ++i) {
    var v = i,
        r = i,
        s = 7;
    for (v >>>= 1; v; v >>>= 1) {
      r <<= 1;
      r |= v & 1;
      --s;
    }
    tab[i] = r << s & 0xff;
  }
})(REVERSE_TABLE);

//Reverse bits in a 32 bit word
exports.reverse = function (v) {
  return REVERSE_TABLE[v & 0xff] << 24 | REVERSE_TABLE[v >>> 8 & 0xff] << 16 | REVERSE_TABLE[v >>> 16 & 0xff] << 8 | REVERSE_TABLE[v >>> 24 & 0xff];
};

//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
exports.interleave2 = function (x, y) {
  x &= 0xFFFF;
  x = (x | x << 8) & 0x00FF00FF;
  x = (x | x << 4) & 0x0F0F0F0F;
  x = (x | x << 2) & 0x33333333;
  x = (x | x << 1) & 0x55555555;

  y &= 0xFFFF;
  y = (y | y << 8) & 0x00FF00FF;
  y = (y | y << 4) & 0x0F0F0F0F;
  y = (y | y << 2) & 0x33333333;
  y = (y | y << 1) & 0x55555555;

  return x | y << 1;
};

//Extracts the nth interleaved component
exports.deinterleave2 = function (v, n) {
  v = v >>> n & 0x55555555;
  v = (v | v >>> 1) & 0x33333333;
  v = (v | v >>> 2) & 0x0F0F0F0F;
  v = (v | v >>> 4) & 0x00FF00FF;
  v = (v | v >>> 16) & 0x000FFFF;
  return v << 16 >> 16;
};

//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
exports.interleave3 = function (x, y, z) {
  x &= 0x3FF;
  x = (x | x << 16) & 4278190335;
  x = (x | x << 8) & 251719695;
  x = (x | x << 4) & 3272356035;
  x = (x | x << 2) & 1227133513;

  y &= 0x3FF;
  y = (y | y << 16) & 4278190335;
  y = (y | y << 8) & 251719695;
  y = (y | y << 4) & 3272356035;
  y = (y | y << 2) & 1227133513;
  x |= y << 1;

  z &= 0x3FF;
  z = (z | z << 16) & 4278190335;
  z = (z | z << 8) & 251719695;
  z = (z | z << 4) & 3272356035;
  z = (z | z << 2) & 1227133513;

  return x | z << 2;
};

//Extracts nth interleaved component of a 3-tuple
exports.deinterleave3 = function (v, n) {
  v = v >>> n & 1227133513;
  v = (v | v >>> 2) & 3272356035;
  v = (v | v >>> 4) & 251719695;
  v = (v | v >>> 8) & 4278190335;
  v = (v | v >>> 16) & 0x3FF;
  return v << 22 >> 22;
};

//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
exports.nextCombination = function (v) {
  var t = v | v - 1;
  return t + 1 | (~t & -~t) - 1 >>> countTrailingZeros(v) + 1;
};

/***/ }),

/***/ "gZse":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}(); // disabling eslint for now, going to rewrite this in v5
/* eslint-disable */

var _const = __webpack_require__("YEQi");

var _utils = __webpack_require__("dDI1");

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var defaultStyle = {
    align: 'left',
    breakWords: false,
    dropShadow: false,
    dropShadowAlpha: 1,
    dropShadowAngle: Math.PI / 6,
    dropShadowBlur: 0,
    dropShadowColor: 'black',
    dropShadowDistance: 5,
    fill: 'black',
    fillGradientType: _const.TEXT_GRADIENT.LINEAR_VERTICAL,
    fillGradientStops: [],
    fontFamily: 'Arial',
    fontSize: 26,
    fontStyle: 'normal',
    fontVariant: 'normal',
    fontWeight: 'normal',
    letterSpacing: 0,
    lineHeight: 0,
    lineJoin: 'miter',
    miterLimit: 10,
    padding: 0,
    stroke: 'black',
    strokeThickness: 0,
    textBaseline: 'alphabetic',
    trim: false,
    whiteSpace: 'pre',
    wordWrap: false,
    wordWrapWidth: 100,
    leading: 0
};

var genericFontFamilies = ['serif', 'sans-serif', 'monospace', 'cursive', 'fantasy', 'system-ui'];

/**
 * A TextStyle Object decorates a Text Object. It can be shared between
 * multiple Text objects. Changing the style will update all text objects using it.
 * It can be generated [here](https://pixijs.io/pixi-text-style).
 *
 * @class
 * @memberof PIXI
 */

var TextStyle = function () {
    /**
     * @param {object} [style] - The style parameters
     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'),
     *  does not affect single line text
     * @param {boolean} [style.breakWords=false] - Indicates if lines can be wrapped within words, it
     *  needs wordWrap to be set to true
     * @param {boolean} [style.dropShadow=false] - Set a drop shadow for the text
     * @param {number} [style.dropShadowAlpha=1] - Set alpha for the drop shadow
     * @param {number} [style.dropShadowAngle=Math.PI/6] - Set a angle of the drop shadow
     * @param {number} [style.dropShadowBlur=0] - Set a shadow blur radius
     * @param {string|number} [style.dropShadowColor='black'] - A fill style to be used on the dropshadow e.g 'red', '#00FF00'
     * @param {number} [style.dropShadowDistance=5] - Set a distance of the drop shadow
     * @param {string|string[]|number|number[]|CanvasGradient|CanvasPattern} [style.fill='black'] - A canvas
     *  fillstyle that will be used on the text e.g 'red', '#00FF00'. Can be an array to create a gradient
     *  eg ['#000000','#FFFFFF']
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
     * @param {number} [style.fillGradientType=PIXI.TEXT_GRADIENT.LINEAR_VERTICAL] - If fill is an array of colours
     *  to create a gradient, this can change the type/direction of the gradient. See {@link PIXI.TEXT_GRADIENT}
     * @param {number[]} [style.fillGradientStops] - If fill is an array of colours to create a gradient, this array can set
     * the stop points (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
     * @param {string|string[]} [style.fontFamily='Arial'] - The font family
     * @param {number|string} [style.fontSize=26] - The font size (as a number it converts to px, but as a string,
     *  equivalents are '26px','20pt','160%' or '1.6em')
     * @param {string} [style.fontStyle='normal'] - The font style ('normal', 'italic' or 'oblique')
     * @param {string} [style.fontVariant='normal'] - The font variant ('normal' or 'small-caps')
     * @param {string} [style.fontWeight='normal'] - The font weight ('normal', 'bold', 'bolder', 'lighter' and '100',
     *  '200', '300', '400', '500', '600', '700', 800' or '900')
     * @param {number} [style.leading=0] - The space between lines
     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters, default is 0
     * @param {number} [style.lineHeight] - The line height, a number that represents the vertical space that a letter uses
     * @param {string} [style.lineJoin='miter'] - The lineJoin property sets the type of corner created, it can resolve
     *      spiked text issues. Possible values "miter" (creates a sharp corner), "round" (creates a round corner) or "bevel"
     *      (creates a squared corner).
     * @param {number} [style.miterLimit=10] - The miter limit to use when using the 'miter' lineJoin mode. This can reduce
     *      or increase the spikiness of rendered text.
     * @param {number} [style.padding=0] - Occasionally some fonts are cropped. Adding some padding will prevent this from
     *     happening by adding padding to all sides of the text.
     * @param {string|number} [style.stroke='black'] - A canvas fillstyle that will be used on the text stroke
     *  e.g 'blue', '#FCFF00'
     * @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke.
     *  Default is 0 (no stroke)
     * @param {boolean} [style.trim=false] - Trim transparent borders
     * @param {string} [style.textBaseline='alphabetic'] - The baseline of the text that is rendered.
     * @param {boolean} [style.whiteSpace='pre'] - Determines whether newlines & spaces are collapsed or preserved "normal"
     *      (collapse, collapse), "pre" (preserve, preserve) | "pre-line" (preserve, collapse). It needs wordWrap to be set to true
     * @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used
     * @param {number} [style.wordWrapWidth=100] - The width at which text will wrap, it needs wordWrap to be set to true
     */
    function TextStyle(style) {
        _classCallCheck(this, TextStyle);

        this.styleID = 0;

        this.reset();

        deepCopyProperties(this, style, style);
    }

    /**
     * Creates a new TextStyle object with the same values as this one.
     * Note that the only the properties of the object are cloned.
     *
     * @return {PIXI.TextStyle} New cloned TextStyle object
     */

    TextStyle.prototype.clone = function clone() {
        var clonedProperties = {};

        deepCopyProperties(clonedProperties, this, defaultStyle);

        return new TextStyle(clonedProperties);
    };

    /**
     * Resets all properties to the defaults specified in TextStyle.prototype._default
     */

    TextStyle.prototype.reset = function reset() {
        deepCopyProperties(this, defaultStyle, defaultStyle);
    };

    /**
     * Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
     *
     * @member {string}
     */

    /**
     * Generates a font style string to use for `TextMetrics.measureFont()`.
     *
     * @return {string} Font style string, for passing to `TextMetrics.measureFont()`
     */
    TextStyle.prototype.toFontString = function toFontString() {
        // build canvas api font setting from individual components. Convert a numeric this.fontSize to px
        var fontSizeString = typeof this.fontSize === 'number' ? this.fontSize + 'px' : this.fontSize;

        // Clean-up fontFamily property by quoting each font name
        // this will support font names with spaces
        var fontFamilies = this.fontFamily;

        if (!Array.isArray(this.fontFamily)) {
            fontFamilies = this.fontFamily.split(',');
        }

        for (var i = fontFamilies.length - 1; i >= 0; i--) {
            // Trim any extra white-space
            var fontFamily = fontFamilies[i].trim();

            // Check if font is already escaped in quotes except for CSS generic fonts
            if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && genericFontFamilies.indexOf(fontFamily) < 0) {
                fontFamily = '"' + fontFamily + '"';
            }
            fontFamilies[i] = fontFamily;
        }

        return this.fontStyle + ' ' + this.fontVariant + ' ' + this.fontWeight + ' ' + fontSizeString + ' ' + fontFamilies.join(',');
    };

    _createClass(TextStyle, [{
        key: 'align',
        get: function get() {
            return this._align;
        },
        set: function set(align) // eslint-disable-line require-jsdoc
        {
            if (this._align !== align) {
                this._align = align;
                this.styleID++;
            }
        }

        /**
         * Indicates if lines can be wrapped within words, it needs wordWrap to be set to true
         *
         * @member {boolean}
         */

    }, {
        key: 'breakWords',
        get: function get() {
            return this._breakWords;
        },
        set: function set(breakWords) // eslint-disable-line require-jsdoc
        {
            if (this._breakWords !== breakWords) {
                this._breakWords = breakWords;
                this.styleID++;
            }
        }

        /**
         * Set a drop shadow for the text
         *
         * @member {boolean}
         */

    }, {
        key: 'dropShadow',
        get: function get() {
            return this._dropShadow;
        },
        set: function set(dropShadow) // eslint-disable-line require-jsdoc
        {
            if (this._dropShadow !== dropShadow) {
                this._dropShadow = dropShadow;
                this.styleID++;
            }
        }

        /**
         * Set alpha for the drop shadow
         *
         * @member {number}
         */

    }, {
        key: 'dropShadowAlpha',
        get: function get() {
            return this._dropShadowAlpha;
        },
        set: function set(dropShadowAlpha) // eslint-disable-line require-jsdoc
        {
            if (this._dropShadowAlpha !== dropShadowAlpha) {
                this._dropShadowAlpha = dropShadowAlpha;
                this.styleID++;
            }
        }

        /**
         * Set a angle of the drop shadow
         *
         * @member {number}
         */

    }, {
        key: 'dropShadowAngle',
        get: function get() {
            return this._dropShadowAngle;
        },
        set: function set(dropShadowAngle) // eslint-disable-line require-jsdoc
        {
            if (this._dropShadowAngle !== dropShadowAngle) {
                this._dropShadowAngle = dropShadowAngle;
                this.styleID++;
            }
        }

        /**
         * Set a shadow blur radius
         *
         * @member {number}
         */

    }, {
        key: 'dropShadowBlur',
        get: function get() {
            return this._dropShadowBlur;
        },
        set: function set(dropShadowBlur) // eslint-disable-line require-jsdoc
        {
            if (this._dropShadowBlur !== dropShadowBlur) {
                this._dropShadowBlur = dropShadowBlur;
                this.styleID++;
            }
        }

        /**
         * A fill style to be used on the dropshadow e.g 'red', '#00FF00'
         *
         * @member {string|number}
         */

    }, {
        key: 'dropShadowColor',
        get: function get() {
            return this._dropShadowColor;
        },
        set: function set(dropShadowColor) // eslint-disable-line require-jsdoc
        {
            var outputColor = getColor(dropShadowColor);
            if (this._dropShadowColor !== outputColor) {
                this._dropShadowColor = outputColor;
                this.styleID++;
            }
        }

        /**
         * Set a distance of the drop shadow
         *
         * @member {number}
         */

    }, {
        key: 'dropShadowDistance',
        get: function get() {
            return this._dropShadowDistance;
        },
        set: function set(dropShadowDistance) // eslint-disable-line require-jsdoc
        {
            if (this._dropShadowDistance !== dropShadowDistance) {
                this._dropShadowDistance = dropShadowDistance;
                this.styleID++;
            }
        }

        /**
         * A canvas fillstyle that will be used on the text e.g 'red', '#00FF00'.
         * Can be an array to create a gradient eg ['#000000','#FFFFFF']
         * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
         *
         * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
         */

    }, {
        key: 'fill',
        get: function get() {
            return this._fill;
        },
        set: function set(fill) // eslint-disable-line require-jsdoc
        {
            var outputColor = getColor(fill);
            if (this._fill !== outputColor) {
                this._fill = outputColor;
                this.styleID++;
            }
        }

        /**
         * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
         * See {@link PIXI.TEXT_GRADIENT}
         *
         * @member {number}
         */

    }, {
        key: 'fillGradientType',
        get: function get() {
            return this._fillGradientType;
        },
        set: function set(fillGradientType) // eslint-disable-line require-jsdoc
        {
            if (this._fillGradientType !== fillGradientType) {
                this._fillGradientType = fillGradientType;
                this.styleID++;
            }
        }

        /**
         * If fill is an array of colours to create a gradient, this array can set the stop points
         * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
         *
         * @member {number[]}
         */

    }, {
        key: 'fillGradientStops',
        get: function get() {
            return this._fillGradientStops;
        },
        set: function set(fillGradientStops) // eslint-disable-line require-jsdoc
        {
            if (!areArraysEqual(this._fillGradientStops, fillGradientStops)) {
                this._fillGradientStops = fillGradientStops;
                this.styleID++;
            }
        }

        /**
         * The font family
         *
         * @member {string|string[]}
         */

    }, {
        key: 'fontFamily',
        get: function get() {
            return this._fontFamily;
        },
        set: function set(fontFamily) // eslint-disable-line require-jsdoc
        {
            if (this.fontFamily !== fontFamily) {
                this._fontFamily = fontFamily;
                this.styleID++;
            }
        }

        /**
         * The font size
         * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
         *
         * @member {number|string}
         */

    }, {
        key: 'fontSize',
        get: function get() {
            return this._fontSize;
        },
        set: function set(fontSize) // eslint-disable-line require-jsdoc
        {
            if (this._fontSize !== fontSize) {
                this._fontSize = fontSize;
                this.styleID++;
            }
        }

        /**
         * The font style
         * ('normal', 'italic' or 'oblique')
         *
         * @member {string}
         */

    }, {
        key: 'fontStyle',
        get: function get() {
            return this._fontStyle;
        },
        set: function set(fontStyle) // eslint-disable-line require-jsdoc
        {
            if (this._fontStyle !== fontStyle) {
                this._fontStyle = fontStyle;
                this.styleID++;
            }
        }

        /**
         * The font variant
         * ('normal' or 'small-caps')
         *
         * @member {string}
         */

    }, {
        key: 'fontVariant',
        get: function get() {
            return this._fontVariant;
        },
        set: function set(fontVariant) // eslint-disable-line require-jsdoc
        {
            if (this._fontVariant !== fontVariant) {
                this._fontVariant = fontVariant;
                this.styleID++;
            }
        }

        /**
         * The font weight
         * ('normal', 'bold', 'bolder', 'lighter' and '100', '200', '300', '400', '500', '600', '700', 800' or '900')
         *
         * @member {string}
         */

    }, {
        key: 'fontWeight',
        get: function get() {
            return this._fontWeight;
        },
        set: function set(fontWeight) // eslint-disable-line require-jsdoc
        {
            if (this._fontWeight !== fontWeight) {
                this._fontWeight = fontWeight;
                this.styleID++;
            }
        }

        /**
         * The amount of spacing between letters, default is 0
         *
         * @member {number}
         */

    }, {
        key: 'letterSpacing',
        get: function get() {
            return this._letterSpacing;
        },
        set: function set(letterSpacing) // eslint-disable-line require-jsdoc
        {
            if (this._letterSpacing !== letterSpacing) {
                this._letterSpacing = letterSpacing;
                this.styleID++;
            }
        }

        /**
         * The line height, a number that represents the vertical space that a letter uses
         *
         * @member {number}
         */

    }, {
        key: 'lineHeight',
        get: function get() {
            return this._lineHeight;
        },
        set: function set(lineHeight) // eslint-disable-line require-jsdoc
        {
            if (this._lineHeight !== lineHeight) {
                this._lineHeight = lineHeight;
                this.styleID++;
            }
        }

        /**
         * The space between lines
         *
         * @member {number}
         */

    }, {
        key: 'leading',
        get: function get() {
            return this._leading;
        },
        set: function set(leading) // eslint-disable-line require-jsdoc
        {
            if (this._leading !== leading) {
                this._leading = leading;
                this.styleID++;
            }
        }

        /**
         * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
         * Default is 'miter' (creates a sharp corner).
         *
         * @member {string}
         */

    }, {
        key: 'lineJoin',
        get: function get() {
            return this._lineJoin;
        },
        set: function set(lineJoin) // eslint-disable-line require-jsdoc
        {
            if (this._lineJoin !== lineJoin) {
                this._lineJoin = lineJoin;
                this.styleID++;
            }
        }

        /**
         * The miter limit to use when using the 'miter' lineJoin mode
         * This can reduce or increase the spikiness of rendered text.
         *
         * @member {number}
         */

    }, {
        key: 'miterLimit',
        get: function get() {
            return this._miterLimit;
        },
        set: function set(miterLimit) // eslint-disable-line require-jsdoc
        {
            if (this._miterLimit !== miterLimit) {
                this._miterLimit = miterLimit;
                this.styleID++;
            }
        }

        /**
         * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
         * by adding padding to all sides of the text.
         *
         * @member {number}
         */

    }, {
        key: 'padding',
        get: function get() {
            return this._padding;
        },
        set: function set(padding) // eslint-disable-line require-jsdoc
        {
            if (this._padding !== padding) {
                this._padding = padding;
                this.styleID++;
            }
        }

        /**
         * A canvas fillstyle that will be used on the text stroke
         * e.g 'blue', '#FCFF00'
         *
         * @member {string|number}
         */

    }, {
        key: 'stroke',
        get: function get() {
            return this._stroke;
        },
        set: function set(stroke) // eslint-disable-line require-jsdoc
        {
            var outputColor = getColor(stroke);
            if (this._stroke !== outputColor) {
                this._stroke = outputColor;
                this.styleID++;
            }
        }

        /**
         * A number that represents the thickness of the stroke.
         * Default is 0 (no stroke)
         *
         * @member {number}
         */

    }, {
        key: 'strokeThickness',
        get: function get() {
            return this._strokeThickness;
        },
        set: function set(strokeThickness) // eslint-disable-line require-jsdoc
        {
            if (this._strokeThickness !== strokeThickness) {
                this._strokeThickness = strokeThickness;
                this.styleID++;
            }
        }

        /**
         * The baseline of the text that is rendered.
         *
         * @member {string}
         */

    }, {
        key: 'textBaseline',
        get: function get() {
            return this._textBaseline;
        },
        set: function set(textBaseline) // eslint-disable-line require-jsdoc
        {
            if (this._textBaseline !== textBaseline) {
                this._textBaseline = textBaseline;
                this.styleID++;
            }
        }

        /**
         * Trim transparent borders
         *
         * @member {boolean}
         */

    }, {
        key: 'trim',
        get: function get() {
            return this._trim;
        },
        set: function set(trim) // eslint-disable-line require-jsdoc
        {
            if (this._trim !== trim) {
                this._trim = trim;
                this.styleID++;
            }
        }

        /**
         * How newlines and spaces should be handled.
         * Default is 'pre' (preserve, preserve).
         *
         *  value       | New lines     |   Spaces
         *  ---         | ---           |   ---
         * 'normal'     | Collapse      |   Collapse
         * 'pre'        | Preserve      |   Preserve
         * 'pre-line'   | Preserve      |   Collapse
         *
         * @member {string}
         */

    }, {
        key: 'whiteSpace',
        get: function get() {
            return this._whiteSpace;
        },
        set: function set(whiteSpace) // eslint-disable-line require-jsdoc
        {
            if (this._whiteSpace !== whiteSpace) {
                this._whiteSpace = whiteSpace;
                this.styleID++;
            }
        }

        /**
         * Indicates if word wrap should be used
         *
         * @member {boolean}
         */

    }, {
        key: 'wordWrap',
        get: function get() {
            return this._wordWrap;
        },
        set: function set(wordWrap) // eslint-disable-line require-jsdoc
        {
            if (this._wordWrap !== wordWrap) {
                this._wordWrap = wordWrap;
                this.styleID++;
            }
        }

        /**
         * The width at which text will wrap, it needs wordWrap to be set to true
         *
         * @member {number}
         */

    }, {
        key: 'wordWrapWidth',
        get: function get() {
            return this._wordWrapWidth;
        },
        set: function set(wordWrapWidth) // eslint-disable-line require-jsdoc
        {
            if (this._wordWrapWidth !== wordWrapWidth) {
                this._wordWrapWidth = wordWrapWidth;
                this.styleID++;
            }
        }
    }]);

    return TextStyle;
}();

/**
 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
 * @private
 * @param {number|number[]} color
 * @return {string} The color as a string.
 */

exports.default = TextStyle;
function getSingleColor(color) {
    if (typeof color === 'number') {
        return (0, _utils.hex2string)(color);
    } else if (typeof color === 'string') {
        if (color.indexOf('0x') === 0) {
            color = color.replace('0x', '#');
        }
    }

    return color;
}

/**
 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
 * This version can also convert array of colors
 * @private
 * @param {number|number[]} color
 * @return {string} The color as a string.
 */
function getColor(color) {
    if (!Array.isArray(color)) {
        return getSingleColor(color);
    } else {
        for (var i = 0; i < color.length; ++i) {
            color[i] = getSingleColor(color[i]);
        }

        return color;
    }
}

/**
 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
 * This version can also convert array of colors
 * @private
 * @param {Array} array1 First array to compare
 * @param {Array} array2 Second array to compare
 * @return {boolean} Do the arrays contain the same values in the same order
 */
function areArraysEqual(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2)) {
        return false;
    }

    if (array1.length !== array2.length) {
        return false;
    }

    for (var i = 0; i < array1.length; ++i) {
        if (array1[i] !== array2[i]) {
            return false;
        }
    }

    return true;
}

/**
 * Utility function to ensure that object properties are copied by value, and not by reference
 * @private
 * @param {Object} target Target object to copy properties into
 * @param {Object} source Source object for the proporties to copy
 * @param {string} propertyObj Object containing properties names we want to loop over
 */
function deepCopyProperties(target, source, propertyObj) {
    for (var prop in propertyObj) {
        if (Array.isArray(source[prop])) {
            target[prop] = source[prop].slice();
        } else {
            target[prop] = source[prop];
        }
    }
}
//# sourceMappingURL=TextStyle.js.map

/***/ }),

/***/ "gwPP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "61c178066bdffca1a7d1730d9df40491.svg";

/***/ }),

/***/ "gx9Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _ParticleShader = __webpack_require__("zjtw");

var _ParticleShader2 = _interopRequireDefault(_ParticleShader);

var _ParticleBuffer = __webpack_require__("fUBa");

var _ParticleBuffer2 = _interopRequireDefault(_ParticleBuffer);

var _utils = __webpack_require__("dDI1");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
 * share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's ParticleRenderer:
 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleRenderer.java
 */

/**
 *
 * @class
 * @private
 * @memberof PIXI
 */
var ParticleRenderer = function (_core$ObjectRenderer) {
    _inherits(ParticleRenderer, _core$ObjectRenderer);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
     */
    function ParticleRenderer(renderer) {
        _classCallCheck(this, ParticleRenderer);

        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
        // so max number of particles is 65536 / 4 = 16384
        // and max number of element in the index buffer is 16384 * 6 = 98304
        // Creating a full index buffer, overhead is 98304 * 2 = 196Ko
        // let numIndices = 98304;

        /**
         * The default shader that is used if a sprite doesn't have a more specific one.
         *
         * @member {PIXI.Shader}
         */
        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));

        _this.shader = null;

        _this.indexBuffer = null;

        _this.properties = null;

        _this.tempMatrix = new core.Matrix();

        _this.CONTEXT_UID = 0;
        return _this;
    }

    /**
     * When there is a WebGL context change
     *
     * @private
     */

    ParticleRenderer.prototype.onContextChange = function onContextChange() {
        var gl = this.renderer.gl;

        this.CONTEXT_UID = this.renderer.CONTEXT_UID;

        // setup default shader
        this.shader = new _ParticleShader2.default(gl);

        this.properties = [
        // verticesData
        {
            attribute: this.shader.attributes.aVertexPosition,
            size: 2,
            uploadFunction: this.uploadVertices,
            offset: 0
        },
        // positionData
        {
            attribute: this.shader.attributes.aPositionCoord,
            size: 2,
            uploadFunction: this.uploadPosition,
            offset: 0
        },
        // rotationData
        {
            attribute: this.shader.attributes.aRotation,
            size: 1,
            uploadFunction: this.uploadRotation,
            offset: 0
        },
        // uvsData
        {
            attribute: this.shader.attributes.aTextureCoord,
            size: 2,
            uploadFunction: this.uploadUvs,
            offset: 0
        },
        // tintData
        {
            attribute: this.shader.attributes.aColor,
            size: 1,
            unsignedByte: true,
            uploadFunction: this.uploadTint,
            offset: 0
        }];
    };

    /**
     * Starts a new particle batch.
     *
     */

    ParticleRenderer.prototype.start = function start() {
        this.renderer.bindShader(this.shader);
    };

    /**
     * Renders the particle container object.
     *
     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
     */

    ParticleRenderer.prototype.render = function render(container) {
        var children = container.children;
        var maxSize = container._maxSize;
        var batchSize = container._batchSize;
        var renderer = this.renderer;
        var totalChildren = children.length;

        if (totalChildren === 0) {
            return;
        } else if (totalChildren > maxSize) {
            totalChildren = maxSize;
        }

        var buffers = container._glBuffers[renderer.CONTEXT_UID];

        if (!buffers) {
            buffers = container._glBuffers[renderer.CONTEXT_UID] = this.generateBuffers(container);
        }

        var baseTexture = children[0]._texture.baseTexture;

        // if the uvs have not updated then no point rendering just yet!
        this.renderer.setBlendMode(core.utils.correctBlendMode(container.blendMode, baseTexture.premultipliedAlpha));

        var gl = renderer.gl;

        var m = container.worldTransform.copy(this.tempMatrix);

        m.prepend(renderer._activeRenderTarget.projectionMatrix);

        this.shader.uniforms.projectionMatrix = m.toArray(true);

        this.shader.uniforms.uColor = core.utils.premultiplyRgba(container.tintRgb, container.worldAlpha, this.shader.uniforms.uColor, baseTexture.premultipliedAlpha);

        // make sure the texture is bound..
        this.shader.uniforms.uSampler = renderer.bindTexture(baseTexture);

        var updateStatic = false;

        // now lets upload and render the buffers..
        for (var i = 0, j = 0; i < totalChildren; i += batchSize, j += 1) {
            var amount = totalChildren - i;

            if (amount > batchSize) {
                amount = batchSize;
            }

            if (j >= buffers.length) {
                if (!container.autoResize) {
                    break;
                }
                buffers.push(this._generateOneMoreBuffer(container));
            }

            var buffer = buffers[j];

            // we always upload the dynamic
            buffer.uploadDynamic(children, i, amount);

            var bid = container._bufferUpdateIDs[j] || 0;

            updateStatic = updateStatic || buffer._updateID < bid;
            // we only upload the static content when we have to!
            if (updateStatic) {
                buffer._updateID = container._updateID;
                buffer.uploadStatic(children, i, amount);
            }

            // bind the buffer
            renderer.bindVao(buffer.vao);
            buffer.vao.draw(gl.TRIANGLES, amount * 6);
        }
    };

    /**
     * Creates one particle buffer for each child in the container we want to render and updates internal properties
     *
     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
     * @return {PIXI.ParticleBuffer[]} The buffers
     */

    ParticleRenderer.prototype.generateBuffers = function generateBuffers(container) {
        var gl = this.renderer.gl;
        var buffers = [];
        var size = container._maxSize;
        var batchSize = container._batchSize;
        var dynamicPropertyFlags = container._properties;

        for (var i = 0; i < size; i += batchSize) {
            buffers.push(new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize));
        }

        return buffers;
    };

    /**
     * Creates one more particle buffer, because container has autoResize feature
     *
     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
     * @return {PIXI.ParticleBuffer} generated buffer
     * @private
     */

    ParticleRenderer.prototype._generateOneMoreBuffer = function _generateOneMoreBuffer(container) {
        var gl = this.renderer.gl;
        var batchSize = container._batchSize;
        var dynamicPropertyFlags = container._properties;

        return new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize);
    };

    /**
     * Uploads the verticies.
     *
     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
     * @param {number} startIndex - the index to start from in the children array
     * @param {number} amount - the amount of children that will have their vertices uploaded
     * @param {number[]} array - The vertices to upload.
     * @param {number} stride - Stride to use for iteration.
     * @param {number} offset - Offset to start at.
     */

    ParticleRenderer.prototype.uploadVertices = function uploadVertices(children, startIndex, amount, array, stride, offset) {
        var w0 = 0;
        var w1 = 0;
        var h0 = 0;
        var h1 = 0;

        for (var i = 0; i < amount; ++i) {
            var sprite = children[startIndex + i];
            var texture = sprite._texture;
            var sx = sprite.scale.x;
            var sy = sprite.scale.y;
            var trim = texture.trim;
            var orig = texture.orig;

            if (trim) {
                // if the sprite is trimmed and is not a tilingsprite then we need to add the
                // extra space before transforming the sprite coords..
                w1 = trim.x - sprite.anchor.x * orig.width;
                w0 = w1 + trim.width;

                h1 = trim.y - sprite.anchor.y * orig.height;
                h0 = h1 + trim.height;
            } else {
                w0 = orig.width * (1 - sprite.anchor.x);
                w1 = orig.width * -sprite.anchor.x;

                h0 = orig.height * (1 - sprite.anchor.y);
                h1 = orig.height * -sprite.anchor.y;
            }

            array[offset] = w1 * sx;
            array[offset + 1] = h1 * sy;

            array[offset + stride] = w0 * sx;
            array[offset + stride + 1] = h1 * sy;

            array[offset + stride * 2] = w0 * sx;
            array[offset + stride * 2 + 1] = h0 * sy;

            array[offset + stride * 3] = w1 * sx;
            array[offset + stride * 3 + 1] = h0 * sy;

            offset += stride * 4;
        }
    };

    /**
     *
     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
     * @param {number} startIndex - the index to start from in the children array
     * @param {number} amount - the amount of children that will have their positions uploaded
     * @param {number[]} array - The vertices to upload.
     * @param {number} stride - Stride to use for iteration.
     * @param {number} offset - Offset to start at.
     */

    ParticleRenderer.prototype.uploadPosition = function uploadPosition(children, startIndex, amount, array, stride, offset) {
        for (var i = 0; i < amount; i++) {
            var spritePosition = children[startIndex + i].position;

            array[offset] = spritePosition.x;
            array[offset + 1] = spritePosition.y;

            array[offset + stride] = spritePosition.x;
            array[offset + stride + 1] = spritePosition.y;

            array[offset + stride * 2] = spritePosition.x;
            array[offset + stride * 2 + 1] = spritePosition.y;

            array[offset + stride * 3] = spritePosition.x;
            array[offset + stride * 3 + 1] = spritePosition.y;

            offset += stride * 4;
        }
    };

    /**
     *
     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
     * @param {number} startIndex - the index to start from in the children array
     * @param {number} amount - the amount of children that will have their rotation uploaded
     * @param {number[]} array - The vertices to upload.
     * @param {number} stride - Stride to use for iteration.
     * @param {number} offset - Offset to start at.
     */

    ParticleRenderer.prototype.uploadRotation = function uploadRotation(children, startIndex, amount, array, stride, offset) {
        for (var i = 0; i < amount; i++) {
            var spriteRotation = children[startIndex + i].rotation;

            array[offset] = spriteRotation;
            array[offset + stride] = spriteRotation;
            array[offset + stride * 2] = spriteRotation;
            array[offset + stride * 3] = spriteRotation;

            offset += stride * 4;
        }
    };

    /**
     *
     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
     * @param {number} startIndex - the index to start from in the children array
     * @param {number} amount - the amount of children that will have their rotation uploaded
     * @param {number[]} array - The vertices to upload.
     * @param {number} stride - Stride to use for iteration.
     * @param {number} offset - Offset to start at.
     */

    ParticleRenderer.prototype.uploadUvs = function uploadUvs(children, startIndex, amount, array, stride, offset) {
        for (var i = 0; i < amount; ++i) {
            var textureUvs = children[startIndex + i]._texture._uvs;

            if (textureUvs) {
                array[offset] = textureUvs.x0;
                array[offset + 1] = textureUvs.y0;

                array[offset + stride] = textureUvs.x1;
                array[offset + stride + 1] = textureUvs.y1;

                array[offset + stride * 2] = textureUvs.x2;
                array[offset + stride * 2 + 1] = textureUvs.y2;

                array[offset + stride * 3] = textureUvs.x3;
                array[offset + stride * 3 + 1] = textureUvs.y3;

                offset += stride * 4;
            } else {
                // TODO you know this can be easier!
                array[offset] = 0;
                array[offset + 1] = 0;

                array[offset + stride] = 0;
                array[offset + stride + 1] = 0;

                array[offset + stride * 2] = 0;
                array[offset + stride * 2 + 1] = 0;

                array[offset + stride * 3] = 0;
                array[offset + stride * 3 + 1] = 0;

                offset += stride * 4;
            }
        }
    };

    /**
     *
     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
     * @param {number} startIndex - the index to start from in the children array
     * @param {number} amount - the amount of children that will have their rotation uploaded
     * @param {number[]} array - The vertices to upload.
     * @param {number} stride - Stride to use for iteration.
     * @param {number} offset - Offset to start at.
     */

    ParticleRenderer.prototype.uploadTint = function uploadTint(children, startIndex, amount, array, stride, offset) {
        for (var i = 0; i < amount; ++i) {
            var sprite = children[startIndex + i];
            var premultiplied = sprite._texture.baseTexture.premultipliedAlpha;
            var alpha = sprite.alpha;
            // we dont call extra function if alpha is 1.0, that's faster
            var argb = alpha < 1.0 && premultiplied ? (0, _utils.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);

            array[offset] = argb;
            array[offset + stride] = argb;
            array[offset + stride * 2] = argb;
            array[offset + stride * 3] = argb;

            offset += stride * 4;
        }
    };

    /**
     * Destroys the ParticleRenderer.
     *
     */

    ParticleRenderer.prototype.destroy = function destroy() {
        if (this.renderer.gl) {
            this.renderer.gl.deleteBuffer(this.indexBuffer);
        }

        _core$ObjectRenderer.prototype.destroy.call(this);

        this.shader.destroy();

        this.indices = null;
        this.tempMatrix = null;
    };

    return ParticleRenderer;
}(core.ObjectRenderer);

exports.default = ParticleRenderer;

core.WebGLRenderer.registerPlugin('particle', ParticleRenderer);
//# sourceMappingURL=ParticleRenderer.js.map

/***/ }),

/***/ "h+SF":
/***/ (function(module, exports) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var pixi_display;
(function (pixi_display) {
    _extends(PIXI.Container.prototype, {
        renderWebGL: function renderWebGL(renderer) {
            if (this._activeParentLayer && this._activeParentLayer != renderer._activeLayer) {
                return;
            }
            if (!this.visible) {
                this.displayOrder = 0;
                return;
            }
            this.displayOrder = renderer.incDisplayOrder();
            if (this.worldAlpha <= 0 || !this.renderable) {
                return;
            }
            renderer._activeLayer = null;
            this.containerRenderWebGL(renderer);
            renderer._activeLayer = this._activeParentLayer;
        },
        renderCanvas: function renderCanvas(renderer) {
            if (this._activeParentLayer && this._activeParentLayer != renderer._activeLayer) {
                return;
            }
            if (!this.visible) {
                this.displayOrder = 0;
                return;
            }
            this.displayOrder = renderer.incDisplayOrder();
            if (this.worldAlpha <= 0 || !this.renderable) {
                return;
            }
            renderer._activeLayer = null;
            this.containerRenderCanvas(renderer);
            renderer._activeLayer = this._activeParentLayer;
        },
        containerRenderWebGL: PIXI.Container.prototype.renderWebGL,
        containerRenderCanvas: PIXI.Container.prototype.renderCanvas
    });
})(pixi_display || (pixi_display = {}));
_extends(PIXI.DisplayObject.prototype, {
    parentLayer: null,
    _activeParentLayer: null,
    parentGroup: null,
    zOrder: 0,
    zIndex: 0,
    updateOrder: 0,
    displayOrder: 0,
    layerableChildren: true
});
if (PIXI.particles && PIXI.particles.ParticleContainer) {
    PIXI.particles.ParticleContainer.prototype.layerableChildren = false;
} else if (PIXI.ParticleContainer) {
    PIXI.ParticleContainer.prototype.layerableChildren = false;
}
var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var pixi_display;
(function (pixi_display) {
    var utils = PIXI.utils;
    var Group = function (_super) {
        __extends(Group, _super);
        function Group(zIndex, sorting) {
            var _this = _super.call(this) || this;
            _this._activeLayer = null;
            _this._activeStage = null;
            _this._activeChildren = [];
            _this._lastUpdateId = -1;
            _this.useRenderTexture = false;
            _this.useDoubleBuffer = false;
            _this.sortPriority = 0;
            _this.clearColor = new Float32Array([0, 0, 0, 0]);
            _this.canDrawWithoutLayer = false;
            _this.canDrawInParentStage = true;
            _this.zIndex = 0;
            _this.enableSort = false;
            _this._tempResult = [];
            _this._tempZero = [];
            _this.useZeroOptimization = false;
            _this.zIndex = zIndex;
            _this.enableSort = !!sorting;
            if (typeof sorting === 'function') {
                _this.on('sort', sorting);
            }
            return _this;
        }
        Group.prototype.doSort = function (layer, sorted) {
            if (this.listeners('sort', true)) {
                for (var i = 0; i < sorted.length; i++) {
                    this.emit('sort', sorted[i]);
                }
            }
            if (this.useZeroOptimization) {
                this.doSortWithZeroOptimization(layer, sorted);
            } else {
                sorted.sort(Group.compareZIndex);
            }
        };
        Group.compareZIndex = function (a, b) {
            if (a.zIndex !== b.zIndex) {
                return a.zIndex - b.zIndex;
            }
            if (a.zOrder > b.zOrder) {
                return -1;
            }
            if (a.zOrder < b.zOrder) {
                return 1;
            }
            return a.updateOrder - b.updateOrder;
        };
        Group.prototype.doSortWithZeroOptimization = function (layer, sorted) {
            throw new Error("not implemented yet");
        };
        Group.prototype.clear = function () {
            this._activeLayer = null;
            this._activeStage = null;
            this._activeChildren.length = 0;
        };
        Group.prototype.addDisplayObject = function (stage, displayObject) {
            this.check(stage);
            displayObject._activeParentLayer = this._activeLayer;
            if (this._activeLayer) {
                this._activeLayer._activeChildren.push(displayObject);
            } else {
                this._activeChildren.push(displayObject);
            }
        };
        Group.prototype.foundLayer = function (stage, layer) {
            this.check(stage);
            if (this._activeLayer != null) {
                Group.conflict();
            }
            this._activeLayer = layer;
            this._activeStage = stage;
        };
        Group.prototype.foundStage = function (stage) {
            if (!this._activeLayer && !this.canDrawInParentStage) {
                this.clear();
            }
        };
        Group.prototype.check = function (stage) {
            if (this._lastUpdateId < Group._layerUpdateId) {
                this._lastUpdateId = Group._layerUpdateId;
                this.clear();
                this._activeStage = stage;
            } else if (this.canDrawInParentStage) {
                var current = this._activeStage;
                while (current && current != stage) {
                    current = current._activeParentStage;
                }
                this._activeStage = current;
                if (current == null) {
                    this.clear();
                    return;
                }
            }
        };
        Group.conflict = function () {
            if (Group._lastLayerConflict + 5000 < Date.now()) {
                Group._lastLayerConflict = Date.now();
                console.log("PIXI-display plugin found two layers with the same group in one stage - that's not healthy. Please place a breakpoint here and debug it");
            }
        };
        Group._layerUpdateId = 0;
        Group._lastLayerConflict = 0;
        return Group;
    }(utils.EventEmitter);
    pixi_display.Group = Group;
})(pixi_display || (pixi_display = {}));
var pixi_display;
(function (pixi_display) {
    var InteractionManager = PIXI.interaction.InteractionManager;
    _extends(InteractionManager.prototype, {
        _queue: [[], []],
        _displayProcessInteractive: function _displayProcessInteractive(point, displayObject, hitTestOrder, interactive, outOfMask) {
            if (!displayObject || !displayObject.visible) {
                return 0;
            }
            var hit = 0,
                interactiveParent = interactive = displayObject.interactive || interactive;
            if (displayObject.hitArea) {
                interactiveParent = false;
            }
            if (displayObject._activeParentLayer) {
                outOfMask = false;
            }
            var mask = displayObject._mask;
            if (hitTestOrder < Infinity && mask) {
                if (!mask.containsPoint(point)) {
                    outOfMask = true;
                }
            }
            if (hitTestOrder < Infinity && displayObject.filterArea) {
                if (!displayObject.filterArea.contains(point.x, point.y)) {
                    outOfMask = true;
                }
            }
            var children = displayObject.children;
            if (displayObject.interactiveChildren && children) {
                for (var i = children.length - 1; i >= 0; i--) {
                    var child = children[i];
                    var hitChild = this._displayProcessInteractive(point, child, hitTestOrder, interactiveParent, outOfMask);
                    if (hitChild) {
                        if (!child.parent) {
                            continue;
                        }
                        hit = hitChild;
                        hitTestOrder = hitChild;
                    }
                }
            }
            if (interactive) {
                if (!outOfMask) {
                    if (hitTestOrder < displayObject.displayOrder) {
                        if (displayObject.hitArea) {
                            displayObject.worldTransform.applyInverse(point, this._tempPoint);
                            if (displayObject.hitArea.contains(this._tempPoint.x, this._tempPoint.y)) {
                                hit = displayObject.displayOrder;
                            }
                        } else if (displayObject.containsPoint) {
                            if (displayObject.containsPoint(point)) {
                                hit = displayObject.displayOrder;
                            }
                        }
                    }
                    if (displayObject.interactive) {
                        this._queueAdd(displayObject, hit === Infinity ? 0 : hit);
                    }
                } else {
                    if (displayObject.interactive) {
                        this._queueAdd(displayObject, 0);
                    }
                }
            }
            return hit;
        },
        processInteractive: function processInteractive(strangeStuff, displayObject, func, hitTest, interactive) {
            var interactionEvent = null;
            var point = null;
            if (strangeStuff.data && strangeStuff.data.global) {
                interactionEvent = strangeStuff;
                point = interactionEvent.data.global;
            } else {
                point = strangeStuff;
            }
            this._startInteractionProcess();
            this._displayProcessInteractive(point, displayObject, hitTest ? 0 : Infinity, false);
            this._finishInteractionProcess(interactionEvent, func);
        },
        _startInteractionProcess: function _startInteractionProcess() {
            this._eventDisplayOrder = 1;
            if (!this._queue) {
                this._queue = [[], []];
            }
            this._queue[0].length = 0;
            this._queue[1].length = 0;
        },
        _queueAdd: function _queueAdd(displayObject, order) {
            var queue = this._queue;
            if (order < this._eventDisplayOrder) {
                queue[0].push(displayObject);
            } else {
                if (order > this._eventDisplayOrder) {
                    this._eventDisplayOrder = order;
                    var q = queue[1];
                    for (var i = 0, l = q.length; i < l; i++) {
                        queue[0].push(q[i]);
                    }
                    queue[1].length = 0;
                }
                queue[1].push(displayObject);
            }
        },
        _finishInteractionProcess: function _finishInteractionProcess(event, func) {
            var queue = this._queue;
            var q = queue[0];
            for (var i = 0, l = q.length; i < l; i++) {
                if (event) {
                    if (func) {
                        func(event, q[i], false);
                    }
                } else {
                    func(q[i], false);
                }
            }
            q = queue[1];
            for (var i = 0, l = q.length; i < l; i++) {
                if (event) {
                    if (!event.target) {
                        event.target = q[i];
                    }
                    if (func) {
                        func(event, q[i], true);
                    }
                } else {
                    func(q[i], true);
                }
            }
        }
    });
})(pixi_display || (pixi_display = {}));
var pixi_display;
(function (pixi_display) {
    var LayerTextureCache = function () {
        function LayerTextureCache(layer) {
            this.layer = layer;
            this.renderTexture = null;
            this.doubleBuffer = null;
            this.currentBufferIndex = 0;
            this._tempRenderTarget = null;
        }
        LayerTextureCache.prototype.initRenderTexture = function (renderer) {
            var width = renderer ? renderer.screen.width : 100;
            var height = renderer ? renderer.screen.height : 100;
            var resolution = renderer ? renderer.resolution : PIXI.settings.RESOLUTION;
            this.renderTexture = PIXI.RenderTexture.create(width, height, undefined, resolution);
            if (this.layer.group.useDoubleBuffer) {
                this.doubleBuffer = [PIXI.RenderTexture.create(width, height, undefined, resolution), PIXI.RenderTexture.create(width, height, undefined, resolution)];
            }
        };
        LayerTextureCache.prototype.getRenderTexture = function () {
            if (!this.renderTexture) {
                this.initRenderTexture();
            }
            return this.renderTexture;
        };
        LayerTextureCache.prototype.pushTexture = function (renderer) {
            var screen = renderer.screen;
            if (!this.renderTexture) {
                this.initRenderTexture(renderer);
            }
            var rt = this.renderTexture;
            var group = this.layer.group;
            var db = this.doubleBuffer;
            if (rt.width !== screen.width || rt.height !== screen.height || rt.baseTexture.resolution !== renderer.resolution) {
                rt.baseTexture.resolution = renderer.resolution;
                rt.resize(screen.width, screen.height);
                if (db) {
                    db[0].baseTexture.resolution = renderer.resolution;
                    db[0].resize(screen.width, screen.height);
                    db[1].baseTexture.resolution = renderer.resolution;
                    db[1].resize(screen.width, screen.height);
                }
            }
            this._tempRenderTarget = renderer._activeRenderTarget;
            renderer.currentRenderer.flush();
            if (group.useDoubleBuffer) {
                var buffer = db[this.currentBufferIndex];
                if (!buffer.baseTexture._glTextures[renderer.CONTEXT_UID]) {
                    renderer.bindRenderTexture(buffer, null);
                    if (group.clearColor) {
                        renderer.clear(group.clearColor);
                    }
                }
                renderer.unbindTexture(rt);
                rt.baseTexture._glTextures = buffer.baseTexture._glTextures;
                rt.baseTexture._glRenderTargets = buffer.baseTexture._glRenderTargets;
                buffer = db[1 - this.currentBufferIndex];
                renderer.bindRenderTexture(buffer, null);
            } else {
                renderer.bindRenderTexture(rt, undefined);
            }
            if (group.clearColor) {
                renderer.clear(group.clearColor);
            }
            var filterData = renderer.filterManager.filterData;
            if (filterData) {
                filterData.stack[filterData.index].renderTarget = renderer._activeRenderTarget;
            }
        };
        LayerTextureCache.prototype.popTexture = function (renderer) {
            renderer.currentRenderer.flush();
            var filterData = renderer.filterManager.filterData;
            if (filterData) {
                filterData.stack[filterData.index].renderTarget = this._tempRenderTarget;
            }
            renderer.bindRenderTarget(this._tempRenderTarget);
            this._tempRenderTarget = null;
            var rt = this.renderTexture;
            var group = this.layer.group;
            var db = this.doubleBuffer;
            if (group.useDoubleBuffer) {
                renderer.unbindTexture(rt);
                this.currentBufferIndex = 1 - this.currentBufferIndex;
                var buffer = db[this.currentBufferIndex];
                rt.baseTexture._glTextures = buffer.baseTexture._glTextures;
                rt.baseTexture._glRenderTargets = buffer.baseTexture._glRenderTargets;
            }
        };
        LayerTextureCache.prototype.destroy = function () {
            if (this.renderTexture) {
                this.renderTexture.destroy();
                if (this.doubleBuffer) {
                    this.doubleBuffer[0].destroy(true);
                    this.doubleBuffer[1].destroy(true);
                }
            }
        };
        return LayerTextureCache;
    }();
    pixi_display.LayerTextureCache = LayerTextureCache;
    var Layer = function (_super) {
        __extends(Layer, _super);
        function Layer(group) {
            if (group === void 0) {
                group = null;
            }
            var _this = _super.call(this) || this;
            _this.isLayer = true;
            _this.group = null;
            _this._activeChildren = [];
            _this._tempChildren = null;
            _this._activeStageParent = null;
            _this._sortedChildren = [];
            _this._tempLayerParent = null;
            _this.insertChildrenBeforeActive = true;
            _this.insertChildrenAfterActive = true;
            if (group != null) {
                _this.group = group;
                _this.zIndex = group.zIndex;
            } else {
                _this.group = new pixi_display.Group(0, false);
            }
            _this._tempChildren = _this.children;
            return _this;
        }
        Layer.prototype.beginWork = function (stage) {
            var active = this._activeChildren;
            this._activeStageParent = stage;
            this.group.foundLayer(stage, this);
            var groupChildren = this.group._activeChildren;
            active.length = 0;
            for (var i = 0; i < groupChildren.length; i++) {
                groupChildren[i]._activeParentLayer = this;
                active.push(groupChildren[i]);
            }
            groupChildren.length = 0;
        };
        Layer.prototype.endWork = function () {
            var children = this.children;
            var active = this._activeChildren;
            var sorted = this._sortedChildren;
            for (var i = 0; i < active.length; i++) {
                this.emit("display", active[i]);
            }
            sorted.length = 0;
            if (this.insertChildrenBeforeActive) {
                for (var i = 0; i < children.length; i++) {
                    sorted.push(children[i]);
                }
            }
            for (var i = 0; i < active.length; i++) {
                sorted.push(active[i]);
            }
            if (!this.insertChildrenBeforeActive && this.insertChildrenAfterActive) {
                for (var i = 0; i < children.length; i++) {
                    sorted.push(children[i]);
                }
            }
            if (this.group.enableSort) {
                this.doSort();
            }
        };
        Object.defineProperty(Layer.prototype, "useRenderTexture", {
            get: function get() {
                return this.group.useRenderTexture;
            },
            set: function set(value) {
                this.group.useRenderTexture = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Layer.prototype, "useDoubleBuffer", {
            get: function get() {
                return this.group.useDoubleBuffer;
            },
            set: function set(value) {
                this.group.useDoubleBuffer = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Layer.prototype, "clearColor", {
            get: function get() {
                return this.group.clearColor;
            },
            set: function set(value) {
                this.group.clearColor = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Layer.prototype, "sortPriority", {
            get: function get() {
                return this.group.sortPriority;
            },
            set: function set(value) {
                this.group.sortPriority = value;
            },
            enumerable: true,
            configurable: true
        });
        Layer.prototype.getRenderTexture = function () {
            if (!this.textureCache) {
                this.textureCache = new LayerTextureCache(this);
            }
            return this.textureCache.getRenderTexture();
        };
        Layer.prototype.updateDisplayLayers = function () {};
        Layer.prototype.doSort = function () {
            this.group.doSort(this, this._sortedChildren);
        };
        Layer.prototype._preRender = function (renderer) {
            if (this._activeParentLayer && this._activeParentLayer != renderer._activeLayer) {
                return false;
            }
            if (!this.visible) {
                this.displayOrder = 0;
                return false;
            }
            this.displayOrder = renderer.incDisplayOrder();
            if (this.worldAlpha <= 0 || !this.renderable) {
                return false;
            }
            if (this.children !== this._sortedChildren && this._tempChildren != this.children) {
                this._tempChildren = this.children;
            }
            this._boundsID++;
            this.children = this._sortedChildren;
            this._tempLayerParent = renderer._activeLayer;
            renderer._activeLayer = this;
            return true;
        };
        Layer.prototype._postRender = function (renderer) {
            this.children = this._tempChildren;
            renderer._activeLayer = this._tempLayerParent;
            this._tempLayerParent = null;
        };
        Layer.prototype.renderWebGL = function (renderer) {
            if (!this._preRender(renderer)) {
                return;
            }
            if (this.group.useRenderTexture) {
                if (!this.textureCache) {
                    this.textureCache = new LayerTextureCache(this);
                }
                this.textureCache.pushTexture(renderer);
            }
            this.containerRenderWebGL(renderer);
            this._postRender(renderer);
            if (this.group.useRenderTexture) {
                this.textureCache.popTexture(renderer);
            }
        };
        Layer.prototype.renderCanvas = function (renderer) {
            if (this._preRender(renderer)) {
                this.containerRenderCanvas(renderer);
                this._postRender(renderer);
            }
        };
        Layer.prototype.destroy = function (options) {
            if (this.textureCache) {
                this.textureCache.destroy();
                this.textureCache = null;
            }
            _super.prototype.destroy.call(this, options);
        };
        return Layer;
    }(PIXI.Container);
    pixi_display.Layer = Layer;
})(pixi_display || (pixi_display = {}));
var pixi_display;
(function (pixi_display) {
    _extends(PIXI.WebGLRenderer.prototype, {
        _lastDisplayOrder: 0,
        _activeLayer: null,
        incDisplayOrder: function incDisplayOrder() {
            return ++this._lastDisplayOrder;
        },
        _oldRender: PIXI.WebGLRenderer.prototype.render,
        render: function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
            if (!renderTexture) {
                this._lastDisplayOrder = 0;
            }
            this._activeLayer = null;
            if (displayObject.isStage) {
                displayObject.updateStage();
            }
            this._oldRender(displayObject, renderTexture, clear, transform, skipUpdateTransform);
        }
    });
    _extends(PIXI.CanvasRenderer.prototype, {
        _lastDisplayOrder: 0,
        _activeLayer: null,
        incDisplayOrder: function incDisplayOrder() {
            return ++this._lastDisplayOrder;
        },
        _oldRender: PIXI.CanvasRenderer.prototype.render,
        render: function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
            if (!renderTexture) {
                this._lastDisplayOrder = 0;
            }
            this._activeLayer = null;
            if (displayObject.isStage) {
                displayObject.updateStage();
            }
            this._oldRender(displayObject, renderTexture, clear, transform, skipUpdateTransform);
        }
    });
})(pixi_display || (pixi_display = {}));
var pixi_display;
(function (pixi_display) {
    var Stage = function (_super) {
        __extends(Stage, _super);
        function Stage() {
            var _this = _super.call(this) || this;
            _this.isStage = true;
            _this._tempGroups = [];
            _this._activeLayers = [];
            _this._activeParentStage = null;
            return _this;
        }
        Stage.prototype.clear = function () {
            this._activeLayers.length = 0;
            this._tempGroups.length = 0;
        };
        Stage.prototype.destroy = function (options) {
            this.clear();
            _super.prototype.destroy.call(this, options);
        };
        Stage.prototype._addRecursive = function (displayObject) {
            if (!displayObject.visible) {
                return;
            }
            if (displayObject.isLayer) {
                var layer_1 = displayObject;
                this._activeLayers.push(layer_1);
                layer_1.beginWork(this);
            }
            if (displayObject != this && displayObject.isStage) {
                var stage = displayObject;
                stage.updateAsChildStage(this);
                return;
            }
            var group = displayObject.parentGroup;
            if (group != null) {
                group.addDisplayObject(this, displayObject);
            }
            var layer = displayObject.parentLayer;
            if (layer != null) {
                group = layer.group;
                group.addDisplayObject(this, displayObject);
            }
            displayObject.updateOrder = ++Stage._updateOrderCounter;
            if (displayObject.alpha <= 0 || !displayObject.renderable || !displayObject.layerableChildren || group && group.sortPriority) {
                return;
            }
            var children = displayObject.children;
            if (children && children.length) {
                for (var i = 0; i < children.length; i++) {
                    this._addRecursive(children[i]);
                }
            }
        };
        Stage.prototype._addRecursiveChildren = function (displayObject) {
            if (displayObject.alpha <= 0 || !displayObject.renderable || !displayObject.layerableChildren) {
                return;
            }
            var children = displayObject.children;
            if (children && children.length) {
                for (var i = 0; i < children.length; i++) {
                    this._addRecursive(children[i]);
                }
            }
        };
        Stage.prototype._updateStageInner = function () {
            this.clear();
            this._addRecursive(this);
            var layers = this._activeLayers;
            for (var i = 0; i < layers.length; i++) {
                var layer = layers[i];
                if (layer.group.sortPriority) {
                    layer.endWork();
                    var sorted = layer._sortedChildren;
                    for (var j = 0; j < sorted.length; j++) {
                        this._addRecursiveChildren(sorted[j]);
                    }
                }
            }
            for (var i = 0; i < layers.length; i++) {
                var layer = layers[i];
                if (!layer.group.sortPriority) {
                    layer.endWork();
                }
            }
        };
        Stage.prototype.updateAsChildStage = function (stage) {
            this._activeParentStage = stage;
            Stage._updateOrderCounter = 0;
            this._updateStageInner();
        };
        Stage.prototype.updateStage = function () {
            this._activeParentStage = null;
            pixi_display.Group._layerUpdateId++;
            this._updateStageInner();
        };
        ;
        Stage._updateOrderCounter = 0;
        return Stage;
    }(pixi_display.Layer);
    pixi_display.Stage = Stage;
})(pixi_display || (pixi_display = {}));
var pixi_display;
(function (pixi_display) {
    PIXI.display = pixi_display;
})(pixi_display || (pixi_display = {}));
//# sourceMappingURL=pixi-layers.js.map

/***/ }),

/***/ "h0Oq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Config_1 = __webpack_require__("gH/r");
var uuid = __webpack_require__("qQO4");

var ActionTracker = function () {
    function ActionTracker() {
        _classCallCheck(this, ActionTracker);
    }

    ActionTracker.addUndoAction = function addUndoAction(actionType, actionId, functionCalls, params) {
        if (this.previousId !== actionId) {
            this.previousId = actionId;
            Config_1.default.undoActions.undoTrackerCb(actionType, functionCalls, params);
        }
    };

    ActionTracker.generateActionId = function generateActionId() {
        return uuid();
    };

    ActionTracker.constructUndoValue = function constructUndoValue(actionType, functionCall, params) {
        return { type: actionType, functionCall: functionCall, params: params };
    };

    return ActionTracker;
}();

exports.default = ActionTracker;
//# sourceMappingURL=ActionTracker.js.map

/***/ }),

/***/ "h2Qz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Config_1 = __webpack_require__("gH/r");
var text_1 = __webpack_require__("vUdk");
exports.Text = text_1.default;

var TextWrapper = function () {
    function TextWrapper() {
        _classCallCheck(this, TextWrapper);
    }

    TextWrapper.createText = function createText(text) {
        var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (Config_1.default.isWebGl) {
            return new text_1.default(text, style);
        } else {
            var anchor = style.anchor;

            var wrappedText = new WrappedText(text, _extends({}, style));
            return wrappedText;
        }
    };

    return TextWrapper;
}();

exports.TextWrapper = TextWrapper;

var WrappedText = function (_PIXI$Text) {
    _inherits(WrappedText, _PIXI$Text);

    function WrappedText(text, style, canvas) {
        _classCallCheck(this, WrappedText);

        var _this = _possibleConstructorReturn(this, _PIXI$Text.call(this, text, style, canvas));

        _this.textWidth = _this._width;
        _this.textHeight = _this._height;
        return _this;
    }

    WrappedText.prototype.updateText = function updateText(respectDirty) {
        _PIXI$Text.prototype.updateText.call(this, respectDirty);
        this.textWidth = this._width;
        this.textHeight = this._height;
    };

    _createClass(WrappedText, [{
        key: "fill",
        set: function set(value) {
            this.style.fill = value;
            this.updateText(true);
        }
    }]);

    return WrappedText;
}(PIXI.Text);
//# sourceMappingURL=Text.js.map

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "hJHU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.mixin = mixin;
exports.delayMixin = delayMixin;
exports.performMixins = performMixins;
/**
 * Mixes all enumerable properties and methods from a source object to a target object.
 *
 * @memberof PIXI.utils.mixins
 * @function mixin
 * @param {object} target The prototype or instance that properties and methods should be added to.
 * @param {object} source The source of properties and methods to mix in.
 */
function mixin(target, source) {
    if (!target || !source) return;
    // in ES8/ES2017, this would be really easy:
    // Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));

    // get all the enumerable property keys
    var keys = Object.keys(source);

    // loop through properties
    for (var i = 0; i < keys.length; ++i) {
        var propertyName = keys[i];

        // Set the property using the property descriptor - this works for accessors and normal value properties
        Object.defineProperty(target, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
    }
}

var mixins = [];

/**
 * Queues a mixin to be handled towards the end of the initialization of PIXI, so that deprecation
 * can take effect.
 *
 * @memberof PIXI.utils.mixins
 * @function delayMixin
 * @private
 * @param {object} target The prototype or instance that properties and methods should be added to.
 * @param {object} source The source of properties and methods to mix in.
 */
function delayMixin(target, source) {
    mixins.push(target, source);
}

/**
 * Handles all mixins queued via delayMixin().
 *
 * @memberof PIXI.utils.mixins
 * @function performMixins
 * @private
 */
function performMixins() {
    for (var i = 0; i < mixins.length; i += 2) {
        mixin(mixins[i], mixins[i + 1]);
    }
    mixins.length = 0;
}
//# sourceMappingURL=mixin.js.map

/***/ }),

/***/ "hVVj":
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__("f+DB");
var bytesToUuid = __webpack_require__("dAjQ");

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;

/***/ }),

/***/ "hX4Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _ = __webpack_require__("RjZD");

var _utils = __webpack_require__("dDI1");

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * Utility class for maintaining reference to a collection
 * of Textures on a single Spritesheet.
 *
 * To access a sprite sheet from your code pass its JSON data file to Pixi's loader:
 *
 * ```js
 * PIXI.loader.add("images/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.loader.resources["images/spritesheet.json"].spritesheet;
 *   ...
 * }
 * ```
 * With the `sheet.textures` you can create Sprite objects,`sheet.animations` can be used to create an AnimatedSprite.
 *
 * Sprite sheets can be packed using tools like {@link https://codeandweb.com/texturepacker|TexturePacker},
 * {@link https://renderhjs.net/shoebox/|Shoebox} or {@link https://github.com/krzysztof-o/spritesheet.js|Spritesheet.js}.
 * Default anchor points (see {@link PIXI.Texture#defaultAnchor}) and grouping of animation sprites are currently only
 * supported by TexturePacker.
 *
 * @class
 * @memberof PIXI
 */
var Spritesheet = function () {
    _createClass(Spritesheet, null, [{
        key: 'BATCH_SIZE',

        /**
         * The maximum number of Textures to build per process.
         *
         * @type {number}
         * @default 1000
         */
        get: function get() {
            return 1000;
        }

        /**
         * @param {PIXI.BaseTexture} baseTexture Reference to the source BaseTexture object.
         * @param {Object} data - Spritesheet image data.
         * @param {string} [resolutionFilename] - The filename to consider when determining
         *        the resolution of the spritesheet. If not provided, the imageUrl will
         *        be used on the BaseTexture.
         */

    }]);

    function Spritesheet(baseTexture, data) {
        var resolutionFilename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        _classCallCheck(this, Spritesheet);

        /**
         * Reference to ths source texture
         * @type {PIXI.BaseTexture}
         */
        this.baseTexture = baseTexture;

        /**
         * A map containing all textures of the sprite sheet.
         * Can be used to create a {@link PIXI.Sprite|Sprite}:
         * ```js
         * new PIXI.Sprite(sheet.textures["image.png"]);
         * ```
         * @member {Object}
         */
        this.textures = {};

        /**
         * A map containing the textures for each animation.
         * Can be used to create an {@link PIXI.extras.AnimatedSprite|AnimatedSprite}:
         * ```js
         * new PIXI.extras.AnimatedSprite(sheet.animations["anim_name"])
         * ```
         * @member {Object}
         */
        this.animations = {};

        /**
         * Reference to the original JSON data.
         * @type {Object}
         */
        this.data = data;

        /**
         * The resolution of the spritesheet.
         * @type {number}
         */
        this.resolution = this._updateResolution(resolutionFilename || this.baseTexture.imageUrl);

        /**
         * Map of spritesheet frames.
         * @type {Object}
         * @private
         */
        this._frames = this.data.frames;

        /**
         * Collection of frame names.
         * @type {string[]}
         * @private
         */
        this._frameKeys = Object.keys(this._frames);

        /**
         * Current batch index being processed.
         * @type {number}
         * @private
         */
        this._batchIndex = 0;

        /**
         * Callback when parse is completed.
         * @type {Function}
         * @private
         */
        this._callback = null;
    }

    /**
     * Generate the resolution from the filename or fallback
     * to the meta.scale field of the JSON data.
     *
     * @private
     * @param {string} resolutionFilename - The filename to use for resolving
     *        the default resolution.
     * @return {number} Resolution to use for spritesheet.
     */

    Spritesheet.prototype._updateResolution = function _updateResolution(resolutionFilename) {
        var scale = this.data.meta.scale;

        // Use a defaultValue of `null` to check if a url-based resolution is set
        var resolution = (0, _utils.getResolutionOfUrl)(resolutionFilename, null);

        // No resolution found via URL
        if (resolution === null) {
            // Use the scale value or default to 1
            resolution = scale !== undefined ? parseFloat(scale) : 1;
        }

        // For non-1 resolutions, update baseTexture
        if (resolution !== 1) {
            this.baseTexture.resolution = resolution;
            this.baseTexture.update();
        }

        return resolution;
    };

    /**
     * Parser spritesheet from loaded data. This is done asynchronously
     * to prevent creating too many Texture within a single process.
     *
     * @param {Function} callback - Callback when complete returns
     *        a map of the Textures for this spritesheet.
     */

    Spritesheet.prototype.parse = function parse(callback) {
        this._batchIndex = 0;
        this._callback = callback;

        if (this._frameKeys.length <= Spritesheet.BATCH_SIZE) {
            this._processFrames(0);
            this._processAnimations();
            this._parseComplete();
        } else {
            this._nextBatch();
        }
    };

    /**
     * Process a batch of frames
     *
     * @private
     * @param {number} initialFrameIndex - The index of frame to start.
     */

    Spritesheet.prototype._processFrames = function _processFrames(initialFrameIndex) {
        var frameIndex = initialFrameIndex;
        var maxFrames = Spritesheet.BATCH_SIZE;
        var sourceScale = this.baseTexture.sourceScale;

        while (frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length) {
            var i = this._frameKeys[frameIndex];
            var data = this._frames[i];
            var rect = data.frame;

            if (rect) {
                var frame = null;
                var trim = null;
                var sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;

                var orig = new _.Rectangle(0, 0, Math.floor(sourceSize.w * sourceScale) / this.resolution, Math.floor(sourceSize.h * sourceScale) / this.resolution);

                if (data.rotated) {
                    frame = new _.Rectangle(Math.floor(rect.x * sourceScale) / this.resolution, Math.floor(rect.y * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution);
                } else {
                    frame = new _.Rectangle(Math.floor(rect.x * sourceScale) / this.resolution, Math.floor(rect.y * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution);
                }

                //  Check to see if the sprite is trimmed
                if (data.trimmed !== false && data.spriteSourceSize) {
                    trim = new _.Rectangle(Math.floor(data.spriteSourceSize.x * sourceScale) / this.resolution, Math.floor(data.spriteSourceSize.y * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution);
                }

                this.textures[i] = new _.Texture(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0, data.anchor);

                // lets also add the frame to pixi's global cache for fromFrame and fromImage functions
                _.Texture.addToCache(this.textures[i], i);
            }

            frameIndex++;
        }
    };

    /**
     * Parse animations config
     *
     * @private
     */

    Spritesheet.prototype._processAnimations = function _processAnimations() {
        var animations = this.data.animations || {};

        for (var animName in animations) {
            this.animations[animName] = [];
            for (var _iterator = animations[animName], _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var frameName = _ref;

                this.animations[animName].push(this.textures[frameName]);
            }
        }
    };

    /**
     * The parse has completed.
     *
     * @private
     */

    Spritesheet.prototype._parseComplete = function _parseComplete() {
        var callback = this._callback;

        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    };

    /**
     * Begin the next batch of textures.
     *
     * @private
     */

    Spritesheet.prototype._nextBatch = function _nextBatch() {
        var _this = this;

        this._processFrames(this._batchIndex * Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(function () {
            if (_this._batchIndex * Spritesheet.BATCH_SIZE < _this._frameKeys.length) {
                _this._nextBatch();
            } else {
                _this._processAnimations();
                _this._parseComplete();
            }
        }, 0);
    };

    /**
     * Destroy Spritesheet and don't use after this.
     *
     * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
     */

    Spritesheet.prototype.destroy = function destroy() {
        var destroyBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        for (var i in this.textures) {
            this.textures[i].destroy();
        }
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this.baseTexture.destroy();
        }
        this.baseTexture = null;
    };

    return Spritesheet;
}();

exports.default = Spritesheet;
//# sourceMappingURL=Spritesheet.js.map

/***/ }),

/***/ "hYHi":
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__("f+DB");
var bytesToUuid = __webpack_require__("dAjQ");

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;

/***/ }),

/***/ "hbJg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "22c8f53b72bb0520da0bac2aaeb8f342.svg";

/***/ }),

/***/ "i/8a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),

/***/ "i/J7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "i0q3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * A GraphicsData object.
 *
 * @class
 * @memberof PIXI
 */
var GraphicsData = function () {
  /**
   *
   * @param {number} lineWidth - the width of the line to draw
   * @param {number} lineColor - the color of the line to draw
   * @param {number} lineAlpha - the alpha of the line to draw
   * @param {number} fillColor - the color of the fill
   * @param {number} fillAlpha - the alpha of the fill
   * @param {boolean} fill - whether or not the shape is filled with a colour
   * @param {boolean} nativeLines - the method for drawing lines
   * @param {PIXI.Circle|PIXI.Rectangle|PIXI.Ellipse|PIXI.Polygon} shape - The shape object to draw.
   * @param {number} lineAlignment - the alignment of the line.
   */
  function GraphicsData(lineWidth, lineColor, lineAlpha, fillColor, fillAlpha, fill, nativeLines, shape, lineAlignment) {
    _classCallCheck(this, GraphicsData);

    /**
     * the width of the line to draw
     * @member {number}
     */
    this.lineWidth = lineWidth;

    /**
     * The alignment of any lines drawn (0.5 = middle, 1 = outter, 0 = inner).
     *
     * @member {number}
     * @default 0
     */
    this.lineAlignment = lineAlignment;

    /**
     * if true the liens will be draw using LINES instead of TRIANGLE_STRIP
     * @member {boolean}
     */
    this.nativeLines = nativeLines;

    /**
     * the color of the line to draw
     * @member {number}
     */
    this.lineColor = lineColor;

    /**
     * the alpha of the line to draw
     * @member {number}
     */
    this.lineAlpha = lineAlpha;

    /**
     * cached tint of the line to draw
     * @member {number}
     * @private
     */
    this._lineTint = lineColor;

    /**
     * the color of the fill
     * @member {number}
     */
    this.fillColor = fillColor;

    /**
     * the alpha of the fill
     * @member {number}
     */
    this.fillAlpha = fillAlpha;

    /**
     * cached tint of the fill
     * @member {number}
     * @private
     */
    this._fillTint = fillColor;

    /**
     * whether or not the shape is filled with a colour
     * @member {boolean}
     */
    this.fill = fill;

    this.holes = [];

    /**
     * The shape object to draw.
     * @member {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle}
     */
    this.shape = shape;

    /**
     * The type of the shape, see the Const.Shapes file for all the existing types,
     * @member {number}
     */
    this.type = shape.type;
  }

  /**
   * Creates a new GraphicsData object with the same values as this one.
   *
   * @return {PIXI.GraphicsData} Cloned GraphicsData object
   */

  GraphicsData.prototype.clone = function clone() {
    return new GraphicsData(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.fill, this.nativeLines, this.shape, this.lineAlignment);
  };

  /**
   * Adds a hole to the shape.
   *
   * @param {PIXI.Rectangle|PIXI.Circle} shape - The shape of the hole.
   */

  GraphicsData.prototype.addHole = function addHole(shape) {
    this.holes.push(shape);
  };

  /**
   * Destroys the Graphics data.
   */

  GraphicsData.prototype.destroy = function destroy() {
    this.shape = null;
    this.holes = null;
  };

  return GraphicsData;
}();

exports.default = GraphicsData;
//# sourceMappingURL=GraphicsData.js.map

/***/ }),

/***/ "i77b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _SystemRenderer2 = __webpack_require__("Hz2Z");

var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);

var _MaskManager = __webpack_require__("OOwQ");

var _MaskManager2 = _interopRequireDefault(_MaskManager);

var _StencilManager = __webpack_require__("juli");

var _StencilManager2 = _interopRequireDefault(_StencilManager);

var _FilterManager = __webpack_require__("S5Wx");

var _FilterManager2 = _interopRequireDefault(_FilterManager);

var _RenderTarget = __webpack_require__("Xw9x");

var _RenderTarget2 = _interopRequireDefault(_RenderTarget);

var _ObjectRenderer = __webpack_require__("oXPp");

var _ObjectRenderer2 = _interopRequireDefault(_ObjectRenderer);

var _TextureManager = __webpack_require__("+UA8");

var _TextureManager2 = _interopRequireDefault(_TextureManager);

var _BaseTexture = __webpack_require__("ce6K");

var _BaseTexture2 = _interopRequireDefault(_BaseTexture);

var _TextureGarbageCollector = __webpack_require__("qM/P");

var _TextureGarbageCollector2 = _interopRequireDefault(_TextureGarbageCollector);

var _WebGLState = __webpack_require__("TVBW");

var _WebGLState2 = _interopRequireDefault(_WebGLState);

var _mapWebGLDrawModesToPixi = __webpack_require__("p4CC");

var _mapWebGLDrawModesToPixi2 = _interopRequireDefault(_mapWebGLDrawModesToPixi);

var _validateContext = __webpack_require__("b6AE");

var _validateContext2 = _interopRequireDefault(_validateContext);

var _utils = __webpack_require__("dDI1");

var _pixiGlCore = __webpack_require__("PJsv");

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

var _const = __webpack_require__("YEQi");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CONTEXT_UID = 0;

/**
 * The WebGLRenderer draws the scene and all its content onto a webGL enabled canvas. This renderer
 * should be used for browsers that support webGL. This Render works by automatically managing webGLBatchs.
 * So no need for Sprite Batches or Sprite Clouds.
 * Don't forget to add the view to your DOM or you will not see anything :)
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.SystemRenderer
 */

var WebGLRenderer = function (_SystemRenderer) {
    _inherits(WebGLRenderer, _SystemRenderer);

    // eslint-disable-next-line valid-jsdoc
    /**
     *
     * @param {object} [options] - The optional renderer parameters
     * @param {number} [options.width=800] - the width of the screen
     * @param {number} [options.height=600] - the height of the screen
     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
     * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
     * @param {boolean} [options.antialias=false] - sets antialias. If not available natively then FXAA
     *  antialiasing is used
     * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
     *  FXAA is faster, but may not always look as great
     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer.
     *  The resolution of the renderer retina would be 2.
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear
     *  the canvas or not before the new render pass. If you wish to set this to false, you *must* set
     *  preserveDrawingBuffer to `true`.
     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
     *  enable this if you need to call toDataUrl on the webgl context.
     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when
     *  rendering, stopping pixel interpolation.
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {boolean} [options.legacy=false] - If true PixiJS will aim to ensure compatibility
     *  with older / less advanced devices. If you experience unexplained flickering try setting this to true.
     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
     *  for devices with dual graphics card
     */
    function WebGLRenderer(options, arg2, arg3) {
        _classCallCheck(this, WebGLRenderer);

        var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'WebGL', options, arg2, arg3));

        _this.legacy = _this.options.legacy;

        if (_this.legacy) {
            _pixiGlCore2.default.VertexArrayObject.FORCE_NATIVE = true;
        }

        /**
         * The type of this renderer as a standardised const
         *
         * @member {number}
         * @see PIXI.RENDERER_TYPE
         */
        _this.type = _const.RENDERER_TYPE.WEBGL;

        _this.handleContextLost = _this.handleContextLost.bind(_this);
        _this.handleContextRestored = _this.handleContextRestored.bind(_this);

        _this.view.addEventListener('webglcontextlost', _this.handleContextLost, false);
        _this.view.addEventListener('webglcontextrestored', _this.handleContextRestored, false);

        /**
         * The options passed in to create a new webgl context.
         *
         * @member {object}
         * @private
         */
        _this._contextOptions = {
            alpha: _this.transparent,
            antialias: _this.options.antialias,
            premultipliedAlpha: _this.transparent && _this.transparent !== 'notMultiplied',
            stencil: true,
            preserveDrawingBuffer: _this.options.preserveDrawingBuffer,
            powerPreference: _this.options.powerPreference
        };

        _this._backgroundColorRgba[3] = _this.transparent ? 0 : 1;

        /**
         * Manages the masks using the stencil buffer.
         *
         * @member {PIXI.MaskManager}
         */
        _this.maskManager = new _MaskManager2.default(_this);

        /**
         * Manages the stencil buffer.
         *
         * @member {PIXI.StencilManager}
         */
        _this.stencilManager = new _StencilManager2.default(_this);

        /**
         * An empty renderer.
         *
         * @member {PIXI.ObjectRenderer}
         */
        _this.emptyRenderer = new _ObjectRenderer2.default(_this);

        /**
         * The currently active ObjectRenderer.
         *
         * @member {PIXI.ObjectRenderer}
         */
        _this.currentRenderer = _this.emptyRenderer;

        /**
         * Manages textures
         * @member {PIXI.TextureManager}
         */
        _this.textureManager = null;

        /**
         * Manages the filters.
         *
         * @member {PIXI.FilterManager}
         */
        _this.filterManager = null;

        _this.initPlugins();

        /**
         * The current WebGL rendering context, it is created here
         *
         * @member {WebGLRenderingContext}
         */
        // initialize the context so it is ready for the managers.
        if (_this.options.context) {
            // checks to see if a context is valid..
            (0, _validateContext2.default)(_this.options.context);
        }

        _this.gl = _this.options.context || _pixiGlCore2.default.createContext(_this.view, _this._contextOptions);

        _this.CONTEXT_UID = CONTEXT_UID++;

        /**
         * The currently active ObjectRenderer.
         *
         * @member {PIXI.WebGLState}
         */
        _this.state = new _WebGLState2.default(_this.gl);

        _this.renderingToScreen = true;

        /**
         * Holds the current state of textures bound to the GPU.
         * @type {Array}
         */
        _this.boundTextures = null;

        /**
         * Holds the current shader
         *
         * @member {PIXI.Shader}
         */
        _this._activeShader = null;

        _this._activeVao = null;

        /**
         * Holds the current render target
         *
         * @member {PIXI.RenderTarget}
         */
        _this._activeRenderTarget = null;

        _this._initContext();

        // map some webGL blend and drawmodes..
        _this.drawModes = (0, _mapWebGLDrawModesToPixi2.default)(_this.gl);

        _this._nextTextureLocation = 0;

        _this.setBlendMode(0);

        /**
         * Fired after rendering finishes.
         *
         * @event PIXI.WebGLRenderer#postrender
         */

        /**
         * Fired before rendering starts.
         *
         * @event PIXI.WebGLRenderer#prerender
         */

        /**
         * Fired when the WebGL context is set.
         *
         * @event PIXI.WebGLRenderer#context
         * @param {WebGLRenderingContext} gl - WebGL context.
         */
        return _this;
    }

    /**
     * Creates the WebGL context
     *
     * @private
     */

    WebGLRenderer.prototype._initContext = function _initContext() {
        var gl = this.gl;

        // restore a context if it was previously lost
        if (gl.isContextLost() && gl.getExtension('WEBGL_lose_context')) {
            gl.getExtension('WEBGL_lose_context').restoreContext();
        }

        var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);

        this._activeShader = null;
        this._activeVao = null;

        this.boundTextures = new Array(maxTextures);
        this.emptyTextures = new Array(maxTextures);

        /**
         * Did someone temper with textures state? We'll overwrite them when we need to unbind something.
         * @member {boolean}
         * @private
         */
        this._unknownBoundTextures = false;

        // create a texture manager...
        this.textureManager = new _TextureManager2.default(this);
        this.filterManager = new _FilterManager2.default(this);
        this.textureGC = new _TextureGarbageCollector2.default(this);

        this.state.resetToDefault();

        this.rootRenderTarget = new _RenderTarget2.default(gl, this.width, this.height, null, this.resolution, true);
        this.rootRenderTarget.clearColor = this._backgroundColorRgba;

        this.bindRenderTarget(this.rootRenderTarget);

        // now lets fill up the textures with empty ones!
        var emptyGLTexture = new _pixiGlCore2.default.GLTexture.fromData(gl, null, 1, 1);

        var tempObj = { _glTextures: {} };

        tempObj._glTextures[this.CONTEXT_UID] = {};

        for (var i = 0; i < maxTextures; i++) {
            var empty = new _BaseTexture2.default();

            empty._glTextures[this.CONTEXT_UID] = emptyGLTexture;

            this.boundTextures[i] = tempObj;
            this.emptyTextures[i] = empty;
            this.bindTexture(null, i);
        }

        this.emit('context', gl);

        // setup the width/height properties and gl viewport
        this.resize(this.screen.width, this.screen.height);
    };

    /**
     * Renders the object to its webGL view
     *
     * @param {PIXI.DisplayObject} displayObject - the object to be rendered
     * @param {PIXI.RenderTexture} renderTexture - The render texture to render to.
     * @param {boolean} [clear] - Should the canvas be cleared before the new render
     * @param {PIXI.Matrix} [transform] - A transform to apply to the render texture before rendering.
     * @param {boolean} [skipUpdateTransform] - Should we skip the update transform pass?
     */

    WebGLRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
        // can be handy to know!
        this.renderingToScreen = !renderTexture;

        this.emit('prerender');

        // no point rendering if our context has been blown up!
        if (!this.gl || this.gl.isContextLost()) {
            return;
        }

        this._nextTextureLocation = 0;

        if (!renderTexture) {
            this._lastObjectRendered = displayObject;
        }

        if (!skipUpdateTransform) {
            // update the scene graph
            var cacheParent = displayObject.parent;

            displayObject.parent = this._tempDisplayObjectParent;
            displayObject.updateTransform();
            displayObject.parent = cacheParent;
            // displayObject.hitArea = //TODO add a temp hit area
        }

        this.bindRenderTexture(renderTexture, transform);

        this.currentRenderer.start();

        if (clear !== undefined ? clear : this.clearBeforeRender) {
            this._activeRenderTarget.clear();
        }

        displayObject.renderWebGL(this);

        // apply transform..
        this.currentRenderer.flush();

        // this.setObjectRenderer(this.emptyRenderer);

        this.textureGC.update();

        this.emit('postrender');
    };

    /**
     * Changes the current renderer to the one given in parameter
     *
     * @param {PIXI.ObjectRenderer} objectRenderer - The object renderer to use.
     */

    WebGLRenderer.prototype.setObjectRenderer = function setObjectRenderer(objectRenderer) {
        if (this.currentRenderer === objectRenderer) {
            return;
        }

        this.currentRenderer.stop();
        this.currentRenderer = objectRenderer;
        this.currentRenderer.start();
    };

    /**
     * This should be called if you wish to do some custom rendering
     * It will basically render anything that may be batched up such as sprites
     *
     */

    WebGLRenderer.prototype.flush = function flush() {
        this.setObjectRenderer(this.emptyRenderer);
    };

    /**
     * Resizes the webGL view to the specified width and height.
     *
     * @param {number} screenWidth - the new width of the screen
     * @param {number} screenHeight - the new height of the screen
     */

    WebGLRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
        //  if(width * this.resolution === this.width && height * this.resolution === this.height)return;

        _SystemRenderer3.default.prototype.resize.call(this, screenWidth, screenHeight);

        this.rootRenderTarget.resize(screenWidth, screenHeight);

        if (this._activeRenderTarget === this.rootRenderTarget) {
            this.rootRenderTarget.activate();

            if (this._activeShader) {
                this._activeShader.uniforms.projectionMatrix = this.rootRenderTarget.projectionMatrix.toArray(true);
            }
        }
    };

    /**
     * Resizes the webGL view to the specified width and height.
     *
     * @param {number} blendMode - the desired blend mode
     */

    WebGLRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
        this.state.setBlendMode(blendMode);
    };

    /**
     * Erases the active render target and fills the drawing area with a colour
     *
     * @param {number} [clearColor] - The colour
     */

    WebGLRenderer.prototype.clear = function clear(clearColor) {
        this._activeRenderTarget.clear(clearColor);
    };

    /**
     * Sets the transform of the active render target to the given matrix
     *
     * @param {PIXI.Matrix} matrix - The transformation matrix
     */

    WebGLRenderer.prototype.setTransform = function setTransform(matrix) {
        this._activeRenderTarget.transform = matrix;
    };

    /**
     * Erases the render texture and fills the drawing area with a colour
     *
     * @param {PIXI.RenderTexture} renderTexture - The render texture to clear
     * @param {number} [clearColor] - The colour
     * @return {PIXI.WebGLRenderer} Returns itself.
     */

    WebGLRenderer.prototype.clearRenderTexture = function clearRenderTexture(renderTexture, clearColor) {
        var baseTexture = renderTexture.baseTexture;
        var renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];

        if (renderTarget) {
            renderTarget.clear(clearColor);
        }

        return this;
    };

    /**
     * Binds a render texture for rendering
     *
     * @param {PIXI.RenderTexture} renderTexture - The render texture to render
     * @param {PIXI.Matrix} transform - The transform to be applied to the render texture
     * @return {PIXI.WebGLRenderer} Returns itself.
     */

    WebGLRenderer.prototype.bindRenderTexture = function bindRenderTexture(renderTexture, transform) {
        var renderTarget = void 0;

        if (renderTexture) {
            var baseTexture = renderTexture.baseTexture;

            if (!baseTexture._glRenderTargets[this.CONTEXT_UID]) {
                // bind the current texture
                this.textureManager.updateTexture(baseTexture, 0);
            }

            this.unbindTexture(baseTexture);

            renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];
            renderTarget.setFrame(renderTexture.frame);
        } else {
            renderTarget = this.rootRenderTarget;
        }

        renderTarget.transform = transform;
        this.bindRenderTarget(renderTarget);

        return this;
    };

    /**
     * Changes the current render target to the one given in parameter
     *
     * @param {PIXI.RenderTarget} renderTarget - the new render target
     * @return {PIXI.WebGLRenderer} Returns itself.
     */

    WebGLRenderer.prototype.bindRenderTarget = function bindRenderTarget(renderTarget) {
        if (renderTarget !== this._activeRenderTarget) {
            this._activeRenderTarget = renderTarget;
            renderTarget.activate();

            if (this._activeShader) {
                this._activeShader.uniforms.projectionMatrix = renderTarget.projectionMatrix.toArray(true);
            }

            this.stencilManager.setMaskStack(renderTarget.stencilMaskStack);
        }

        return this;
    };

    /**
     * Changes the current shader to the one given in parameter
     *
     * @param {PIXI.Shader} shader - the new shader
     * @param {boolean} [autoProject=true] - Whether automatically set the projection matrix
     * @return {PIXI.WebGLRenderer} Returns itself.
     */

    WebGLRenderer.prototype.bindShader = function bindShader(shader, autoProject) {
        // TODO cache
        if (this._activeShader !== shader) {
            this._activeShader = shader;
            shader.bind();

            // `autoProject` normally would be a default parameter set to true
            // but because of how Babel transpiles default parameters
            // it hinders the performance of this method.
            if (autoProject !== false) {
                // automatically set the projection matrix
                shader.uniforms.projectionMatrix = this._activeRenderTarget.projectionMatrix.toArray(true);
            }
        }

        return this;
    };

    /**
     * Binds the texture. This will return the location of the bound texture.
     * It may not be the same as the one you pass in. This is due to optimisation that prevents
     * needless binding of textures. For example if the texture is already bound it will return the
     * current location of the texture instead of the one provided. To bypass this use force location
     *
     * @param {PIXI.Texture} texture - the new texture
     * @param {number} location - the suggested texture location
     * @param {boolean} forceLocation - force the location
     * @return {number} bound texture location
     */

    WebGLRenderer.prototype.bindTexture = function bindTexture(texture, location, forceLocation) {
        texture = texture || this.emptyTextures[location];
        texture = texture.baseTexture || texture;
        texture.touched = this.textureGC.count;

        if (!forceLocation) {
            // TODO - maybe look into adding boundIds.. save us the loop?
            for (var i = 0; i < this.boundTextures.length; i++) {
                if (this.boundTextures[i] === texture) {
                    return i;
                }
            }

            if (location === undefined) {
                this._nextTextureLocation++;
                this._nextTextureLocation %= this.boundTextures.length;
                location = this.boundTextures.length - this._nextTextureLocation - 1;
            }
        } else {
            location = location || 0;
        }

        var gl = this.gl;
        var glTexture = texture._glTextures[this.CONTEXT_UID];

        if (!glTexture) {
            // this will also bind the texture..
            this.textureManager.updateTexture(texture, location);
        } else {
            // bind the current texture
            this.boundTextures[location] = texture;
            gl.activeTexture(gl.TEXTURE0 + location);
            gl.bindTexture(gl.TEXTURE_2D, glTexture.texture);
        }

        return location;
    };

    /**
    * unbinds the texture ...
    *
    * @param {PIXI.Texture} texture - the texture to unbind
    * @return {PIXI.WebGLRenderer} Returns itself.
    */

    WebGLRenderer.prototype.unbindTexture = function unbindTexture(texture) {
        var gl = this.gl;

        texture = texture.baseTexture || texture;

        if (this._unknownBoundTextures) {
            this._unknownBoundTextures = false;
            // someone changed webGL state,
            // we have to be sure that our texture does not appear in multitexture renderer samplers

            for (var i = 0; i < this.boundTextures.length; i++) {
                if (this.boundTextures[i] === this.emptyTextures[i]) {
                    gl.activeTexture(gl.TEXTURE0 + i);
                    gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[i]._glTextures[this.CONTEXT_UID].texture);
                }
            }
        }

        for (var _i = 0; _i < this.boundTextures.length; _i++) {
            if (this.boundTextures[_i] === texture) {
                this.boundTextures[_i] = this.emptyTextures[_i];

                gl.activeTexture(gl.TEXTURE0 + _i);
                gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[_i]._glTextures[this.CONTEXT_UID].texture);
            }
        }

        return this;
    };

    /**
     * Creates a new VAO from this renderer's context and state.
     *
     * @return {VertexArrayObject} The new VAO.
     */

    WebGLRenderer.prototype.createVao = function createVao() {
        return new _pixiGlCore2.default.VertexArrayObject(this.gl, this.state.attribState);
    };

    /**
     * Changes the current Vao to the one given in parameter
     *
     * @param {PIXI.VertexArrayObject} vao - the new Vao
     * @return {PIXI.WebGLRenderer} Returns itself.
     */

    WebGLRenderer.prototype.bindVao = function bindVao(vao) {
        if (this._activeVao === vao) {
            return this;
        }

        if (vao) {
            vao.bind();
        } else if (this._activeVao) {
            // TODO this should always be true i think?
            this._activeVao.unbind();
        }

        this._activeVao = vao;

        return this;
    };

    /**
     * Resets the WebGL state so you can render things however you fancy!
     *
     * @return {PIXI.WebGLRenderer} Returns itself.
     */

    WebGLRenderer.prototype.reset = function reset() {
        this.setObjectRenderer(this.emptyRenderer);

        this.bindVao(null);
        this._activeShader = null;
        this._activeRenderTarget = this.rootRenderTarget;

        this._unknownBoundTextures = true;

        for (var i = 0; i < this.boundTextures.length; i++) {
            this.boundTextures[i] = this.emptyTextures[i];
        }

        // bind the main frame buffer (the screen);
        this.rootRenderTarget.activate();

        this.state.resetToDefault();

        return this;
    };

    /**
     * Handles a lost webgl context
     *
     * @private
     * @param {WebGLContextEvent} event - The context lost event.
     */

    WebGLRenderer.prototype.handleContextLost = function handleContextLost(event) {
        event.preventDefault();
    };

    /**
     * Handles a restored webgl context
     *
     * @private
     */

    WebGLRenderer.prototype.handleContextRestored = function handleContextRestored() {
        this.textureManager.removeAll();
        this.filterManager.destroy(true);
        this._initContext();
    };

    /**
     * Removes everything from the renderer (event listeners, spritebatch, etc...)
     *
     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
     *  See: https://github.com/pixijs/pixi.js/issues/2233
     */

    WebGLRenderer.prototype.destroy = function destroy(removeView) {
        this.destroyPlugins();

        // remove listeners
        this.view.removeEventListener('webglcontextlost', this.handleContextLost);
        this.view.removeEventListener('webglcontextrestored', this.handleContextRestored);

        this.textureManager.destroy();

        // call base destroy
        _SystemRenderer.prototype.destroy.call(this, removeView);

        this.uid = 0;

        // destroy the managers
        this.maskManager.destroy();
        this.stencilManager.destroy();
        this.filterManager.destroy();

        this.maskManager = null;
        this.filterManager = null;
        this.textureManager = null;
        this.currentRenderer = null;

        this.handleContextLost = null;
        this.handleContextRestored = null;

        this._contextOptions = null;
        this.gl.useProgram(null);

        if (this.gl.getExtension('WEBGL_lose_context')) {
            this.gl.getExtension('WEBGL_lose_context').loseContext();
        }

        this.gl = null;

        // this = null;
    };

    return WebGLRenderer;
}(_SystemRenderer3.default);

/**
 * Collection of installed plugins. These are included by default in PIXI, but can be excluded
 * by creating a custom build. Consult the README for more information about creating custom
 * builds and excluding plugins.
 * @name PIXI.WebGLRenderer#plugins
 * @type {object}
 * @readonly
 * @property {PIXI.accessibility.AccessibilityManager} accessibility Support tabbing interactive elements.
 * @property {PIXI.extract.WebGLExtract} extract Extract image data from renderer.
 * @property {PIXI.interaction.InteractionManager} interaction Handles mouse, touch and pointer events.
 * @property {PIXI.prepare.WebGLPrepare} prepare Pre-render display objects.
 */

/**
 * Adds a plugin to the renderer.
 *
 * @method PIXI.WebGLRenderer#registerPlugin
 * @param {string} pluginName - The name of the plugin.
 * @param {Function} ctor - The constructor function or class for the plugin.
 */

exports.default = WebGLRenderer;
_utils.pluginTarget.mixin(WebGLRenderer);
//# sourceMappingURL=WebGLRenderer.js.map

/***/ }),

/***/ "i99N":
/***/ (function(module, exports) {

module.exports = function xmlparser() {
  //common browsers
  if (typeof self.DOMParser !== 'undefined') {
    return function (str) {
      var parser = new self.DOMParser();
      return parser.parseFromString(str, 'application/xml');
    };
  }

  //IE8 fallback
  if (typeof self.ActiveXObject !== 'undefined' && new self.ActiveXObject('Microsoft.XMLDOM')) {
    return function (str) {
      var xmlDoc = new self.ActiveXObject("Microsoft.XMLDOM");
      xmlDoc.async = "false";
      xmlDoc.loadXML(str);
      return xmlDoc;
    };
  }

  //last resort fallback
  return function (str) {
    var div = document.createElement('div');
    div.innerHTML = str;
    return div;
  };
}();

/***/ }),

/***/ "iEgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("d+s/");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("pv+l")(module)))

/***/ }),

/***/ "iM49":
/***/ (function(module, exports, __webpack_require__) {


// state object//
var setVertexAttribArrays = __webpack_require__("FtW/");

/**
 * Helper class to work with WebGL VertexArrayObjects (vaos)
 * Only works if WebGL extensions are enabled (they usually are)
 *
 * @class
 * @memberof PIXI.glCore
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 */
function VertexArrayObject(gl, state) {
    this.nativeVaoExtension = null;

    if (!VertexArrayObject.FORCE_NATIVE) {
        this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') || gl.getExtension('MOZ_OES_vertex_array_object') || gl.getExtension('WEBKIT_OES_vertex_array_object');
    }

    this.nativeState = state;

    if (this.nativeVaoExtension) {
        this.nativeVao = this.nativeVaoExtension.createVertexArrayOES();

        var maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);

        // VAO - overwrite the state..
        this.nativeState = {
            tempAttribState: new Array(maxAttribs),
            attribState: new Array(maxAttribs)
        };
    }

    /**
     * The current WebGL rendering context
     *
     * @member {WebGLRenderingContext}
     */
    this.gl = gl;

    /**
     * An array of attributes
     *
     * @member {Array}
     */
    this.attributes = [];

    /**
     * @member {PIXI.glCore.GLBuffer}
     */
    this.indexBuffer = null;

    /**
     * A boolean flag
     *
     * @member {Boolean}
     */
    this.dirty = false;
}

VertexArrayObject.prototype.constructor = VertexArrayObject;
module.exports = VertexArrayObject;

/**
* Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
* If you find on older devices that things have gone a bit weird then set this to true.
*/
/**
 * Lets the VAO know if you should use the WebGL extension or the native methods.
 * Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
 * If you find on older devices that things have gone a bit weird then set this to true.
 * @static
 * @property {Boolean} FORCE_NATIVE
 */
VertexArrayObject.FORCE_NATIVE = false;

/**
 * Binds the buffer
 */
VertexArrayObject.prototype.bind = function () {
    if (this.nativeVao) {
        this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);

        if (this.dirty) {
            this.dirty = false;
            this.activate();
            return this;
        }
        if (this.indexBuffer) {
            this.indexBuffer.bind();
        }
    } else {
        this.activate();
    }

    return this;
};

/**
 * Unbinds the buffer
 */
VertexArrayObject.prototype.unbind = function () {
    if (this.nativeVao) {
        this.nativeVaoExtension.bindVertexArrayOES(null);
    }

    return this;
};

/**
 * Uses this vao
 */
VertexArrayObject.prototype.activate = function () {

    var gl = this.gl;
    var lastBuffer = null;

    for (var i = 0; i < this.attributes.length; i++) {
        var attrib = this.attributes[i];

        if (lastBuffer !== attrib.buffer) {
            attrib.buffer.bind();
            lastBuffer = attrib.buffer;
        }

        gl.vertexAttribPointer(attrib.attribute.location, attrib.attribute.size, attrib.type || gl.FLOAT, attrib.normalized || false, attrib.stride || 0, attrib.start || 0);
    }

    setVertexAttribArrays(gl, this.attributes, this.nativeState);

    if (this.indexBuffer) {
        this.indexBuffer.bind();
    }

    return this;
};

/**
 *
 * @param buffer     {PIXI.gl.GLBuffer}
 * @param attribute  {*}
 * @param type       {String}
 * @param normalized {Boolean}
 * @param stride     {Number}
 * @param start      {Number}
 */
VertexArrayObject.prototype.addAttribute = function (buffer, attribute, type, normalized, stride, start) {
    this.attributes.push({
        buffer: buffer,
        attribute: attribute,

        location: attribute.location,
        type: type || this.gl.FLOAT,
        normalized: normalized || false,
        stride: stride || 0,
        start: start || 0
    });

    this.dirty = true;

    return this;
};

/**
 *
 * @param buffer   {PIXI.gl.GLBuffer}
 */
VertexArrayObject.prototype.addIndex = function (buffer /*, options*/) {
    this.indexBuffer = buffer;

    this.dirty = true;

    return this;
};

/**
 * Unbinds this vao and disables it
 */
VertexArrayObject.prototype.clear = function () {
    // var gl = this.gl;

    // TODO - should this function unbind after clear?
    // for now, no but lets see what happens in the real world!
    if (this.nativeVao) {
        this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);
    }

    this.attributes.length = 0;
    this.indexBuffer = null;

    return this;
};

/**
 * @param type  {Number}
 * @param size  {Number}
 * @param start {Number}
 */
VertexArrayObject.prototype.draw = function (type, size, start) {
    var gl = this.gl;

    if (this.indexBuffer) {
        gl.drawElements(type, size || this.indexBuffer.data.length, gl.UNSIGNED_SHORT, (start || 0) * 2);
    } else {
        // TODO need a better way to calculate size..
        gl.drawArrays(type, start, size || this.getSize());
    }

    return this;
};

/**
 * Destroy this vao
 */
VertexArrayObject.prototype.destroy = function () {
    // lose references
    this.gl = null;
    this.indexBuffer = null;
    this.attributes = null;
    this.nativeState = null;

    if (this.nativeVao) {
        this.nativeVaoExtension.deleteVertexArrayOES(this.nativeVao);
    }

    this.nativeVaoExtension = null;
    this.nativeVao = null;
};

VertexArrayObject.prototype.getSize = function () {
    var attrib = this.attributes[0];
    return attrib.buffer.data.length / (attrib.stride / 4 || attrib.attribute.size);
};

/***/ }),

/***/ "iMMC":
/***/ (function(module, exports) {

module.exports = function (dtype) {
  switch (dtype) {
    case 'int8':
      return Int8Array;
    case 'int16':
      return Int16Array;
    case 'int32':
      return Int32Array;
    case 'uint8':
      return Uint8Array;
    case 'uint16':
      return Uint16Array;
    case 'uint32':
      return Uint32Array;
    case 'float32':
      return Float32Array;
    case 'float64':
      return Float64Array;
    case 'array':
      return Array;
    case 'uint8_clamped':
      return Uint8ClampedArray;
  }
};

/***/ }),

/***/ "iMim":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var window = __webpack_require__("tALL");
var isFunction = __webpack_require__("xIVz");
var parseHeaders = __webpack_require__("q9uR");
var xtend = __webpack_require__("K5Tb");

module.exports = createXHR;
// Allow use of default import syntax in TypeScript
module.exports.default = createXHR;
createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;

forEachArray(["get", "put", "post", "patch", "head", "delete"], function (method) {
    createXHR[method === "delete" ? "del" : method] = function (uri, options, callback) {
        options = initParams(uri, options, callback);
        options.method = method.toUpperCase();
        return _createXHR(options);
    };
});

function forEachArray(array, iterator) {
    for (var i = 0; i < array.length; i++) {
        iterator(array[i]);
    }
}

function isEmpty(obj) {
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) return false;
    }
    return true;
}

function initParams(uri, options, callback) {
    var params = uri;

    if (isFunction(options)) {
        callback = options;
        if (typeof uri === "string") {
            params = { uri: uri };
        }
    } else {
        params = xtend(options, { uri: uri });
    }

    params.callback = callback;
    return params;
}

function createXHR(uri, options, callback) {
    options = initParams(uri, options, callback);
    return _createXHR(options);
}

function _createXHR(options) {
    if (typeof options.callback === "undefined") {
        throw new Error("callback argument missing");
    }

    var called = false;
    var callback = function cbOnce(err, response, body) {
        if (!called) {
            called = true;
            options.callback(err, response, body);
        }
    };

    function readystatechange() {
        if (xhr.readyState === 4) {
            setTimeout(loadFunc, 0);
        }
    }

    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined;

        if (xhr.response) {
            body = xhr.response;
        } else {
            body = xhr.responseText || getXml(xhr);
        }

        if (isJson) {
            try {
                body = JSON.parse(body);
            } catch (e) {}
        }

        return body;
    }

    function errorFunc(evt) {
        clearTimeout(timeoutTimer);
        if (!(evt instanceof Error)) {
            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
        }
        evt.statusCode = 0;
        return callback(evt, failureResponse);
    }

    // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return;
        var status;
        clearTimeout(timeoutTimer);
        if (options.useXDR && xhr.status === undefined) {
            //IE8 CORS GET successful response doesn't have a status field, but body is fine
            status = 200;
        } else {
            status = xhr.status === 1223 ? 204 : xhr.status;
        }
        var response = failureResponse;
        var err = null;

        if (status !== 0) {
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            };
            if (xhr.getAllResponseHeaders) {
                //remember xhr can in fact be XDR for CORS in IE
                response.headers = parseHeaders(xhr.getAllResponseHeaders());
            }
        } else {
            err = new Error("Internal XMLHttpRequest Error");
        }
        return callback(err, response, response.body);
    }

    var xhr = options.xhr || null;

    if (!xhr) {
        if (options.cors || options.useXDR) {
            xhr = new createXHR.XDomainRequest();
        } else {
            xhr = new createXHR.XMLHttpRequest();
        }
    }

    var key;
    var aborted;
    var uri = xhr.url = options.uri || options.url;
    var method = xhr.method = options.method || "GET";
    var body = options.body || options.data;
    var headers = xhr.headers = options.headers || {};
    var sync = !!options.sync;
    var isJson = false;
    var timeoutTimer;
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    };

    if ("json" in options && options.json !== false) {
        isJson = true;
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
            body = JSON.stringify(options.json === true ? body : options.json);
        }
    }

    xhr.onreadystatechange = readystatechange;
    xhr.onload = loadFunc;
    xhr.onerror = errorFunc;
    // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function () {
        // IE must die
    };
    xhr.onabort = function () {
        aborted = true;
    };
    xhr.ontimeout = errorFunc;
    xhr.open(method, uri, !sync, options.username, options.password);
    //has to be after open
    if (!sync) {
        xhr.withCredentials = !!options.withCredentials;
    }
    // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0) {
        timeoutTimer = setTimeout(function () {
            if (aborted) return;
            aborted = true; //IE9 may still call readystatechange
            xhr.abort("timeout");
            var e = new Error("XMLHttpRequest timeout");
            e.code = "ETIMEDOUT";
            errorFunc(e);
        }, options.timeout);
    }

    if (xhr.setRequestHeader) {
        for (key in headers) {
            if (headers.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
    } else if (options.headers && !isEmpty(options.headers)) {
        throw new Error("Headers cannot be set on an XDomainRequest object");
    }

    if ("responseType" in options) {
        xhr.responseType = options.responseType;
    }

    if ("beforeSend" in options && typeof options.beforeSend === "function") {
        options.beforeSend(xhr);
    }

    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null);

    return xhr;
}

function getXml(xhr) {
    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
    try {
        if (xhr.responseType === "document") {
            return xhr.responseXML;
        }
        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
        if (xhr.responseType === "" && !firefoxBugTakenEffect) {
            return xhr.responseXML;
        }
    } catch (e) {}

    return null;
}

function noop() {}

/***/ }),

/***/ "iVZy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cd42ac32438cc2b5ea26c7d25f7c3847.svg";

/***/ }),

/***/ "iYSS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return max; });
/* unused harmony export min */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lastOfType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firstOfType; });
var max = function max(len) {
  return "@media (max-width: " + len + "px)";
};
var min = function min(len) {
  return "@media (min-width: " + len + "px)";
};
var lastOfType = function lastOfType() {
  return "&:last-of-type";
};
var firstOfType = function firstOfType() {
  return "&:first-of-type";
};

/***/ }),

/***/ "ir0y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b4b49e509faa6043a3a6b1301551f27d.svg";

/***/ }),

/***/ "iuFh":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("GNKS")();
}

/***/ }),

/***/ "ix37":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.__esModule = true;
exports.loader = exports.prepare = exports.particles = exports.mesh = exports.loaders = exports.interaction = exports.filters = exports.extras = exports.extract = exports.accessibility = undefined;

var _polyfill = __webpack_require__("bPsC");

Object.keys(_polyfill).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _polyfill[key];
        }
    });
});

var _core = __webpack_require__("RjZD");

Object.keys(_core).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _core[key];
        }
    });
});

var _deprecation = __webpack_require__("+E8Q");

var _deprecation2 = _interopRequireDefault(_deprecation);

var _accessibility = __webpack_require__("l7H0");

var accessibility = _interopRequireWildcard(_accessibility);

var _extract = __webpack_require__("jvu7");

var extract = _interopRequireWildcard(_extract);

var _extras = __webpack_require__("KRVa");

var extras = _interopRequireWildcard(_extras);

var _filters = __webpack_require__("lFUL");

var filters = _interopRequireWildcard(_filters);

var _interaction = __webpack_require__("/j6N");

var interaction = _interopRequireWildcard(_interaction);

var _loaders = __webpack_require__("PK7H");

var loaders = _interopRequireWildcard(_loaders);

var _mesh = __webpack_require__("1ZIP");

var mesh = _interopRequireWildcard(_mesh);

var _particles = __webpack_require__("8fQc");

var particles = _interopRequireWildcard(_particles);

var _prepare = __webpack_require__("7BI5");

var prepare = _interopRequireWildcard(_prepare);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// export core
_core.utils.mixins.performMixins();

/**
 * Alias for {@link PIXI.loaders.shared}.
 * @name loader
 * @memberof PIXI
 * @type {PIXI.loader.Loader}
 */

// handle mixins now, after all code has been added, including deprecation


// export libs
// import polyfills. Done as an export to make sure polyfills are imported first
var loader = loaders.shared || null;

exports.accessibility = accessibility;
exports.extract = extract;
exports.extras = extras;
exports.filters = filters;
exports.interaction = interaction;
exports.loaders = loaders;
exports.mesh = mesh;
exports.particles = particles;
exports.prepare = prepare;
exports.loader = loader;

// Apply the deprecations

if (typeof _deprecation2.default === 'function') {
    (0, _deprecation2.default)(exports);
}

// Always export PixiJS globally.
global.PIXI = exports; // eslint-disable-line
//# sourceMappingURL=index.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "jLHJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = __webpack_require__("sh3Y");
var utils = __webpack_require__("GZIj");

module.exports = function (_Plugin) {
    _inherits(Snap, _Plugin);

    /**
     * @private
     * @param {Viewport} parent
     * @param {number} x
     * @param {number} y
     * @param {object} [options]
     * @param {boolean} [options.topLeft] snap to the top-left of viewport instead of center
     * @param {number} [options.friction=0.8] friction/frame to apply if decelerate is active
     * @param {number} [options.time=1000]
     * @param {string|function} [options.ease=easeInOutSine] ease function or name (see http://easings.net/ for supported names)
     * @param {boolean} [options.interrupt=true] pause snapping with any user input on the viewport
     * @param {boolean} [options.removeOnComplete] removes this plugin after snapping is complete
     * @param {boolean} [options.removeOnInterrupt] removes this plugin if interrupted by any user input
     * @param {boolean} [options.forceStart] starts the snap immediately regardless of whether the viewport is at the desired location
     *
     * @event snap-start(Viewport) emitted each time a snap animation starts
     * @event snap-restart(Viewport) emitted each time a snap resets because of a change in viewport size
     * @event snap-end(Viewport) emitted each time snap reaches its target
     * @event snap-remove(Viewport) emitted if snap plugin is removed
     */
    function Snap(parent, x, y, options) {
        _classCallCheck(this, Snap);

        var _this = _possibleConstructorReturn(this, (Snap.__proto__ || Object.getPrototypeOf(Snap)).call(this, parent));

        options = options || {};
        _this.friction = options.friction || 0.8;
        _this.time = options.time || 1000;
        _this.ease = utils.ease(options.ease, 'easeInOutSine');
        _this.x = x;
        _this.y = y;
        _this.topLeft = options.topLeft;
        _this.interrupt = utils.defaults(options.interrupt, true);
        _this.removeOnComplete = options.removeOnComplete;
        _this.removeOnInterrupt = options.removeOnInterrupt;
        if (options.forceStart) {
            _this.startEase();
        }
        return _this;
    }

    _createClass(Snap, [{
        key: 'snapStart',
        value: function snapStart() {
            this.percent = 0;
            this.snapping = { time: 0 };
            var current = this.topLeft ? this.parent.corner : this.parent.center;
            this.deltaX = this.x - current.x;
            this.deltaY = this.y - current.y;
            this.startX = current.x;
            this.startY = current.y;
            this.parent.emit('snap-start', this.parent);
        }
    }, {
        key: 'wheel',
        value: function wheel() {
            if (this.removeOnInterrupt) {
                this.parent.removePlugin('snap');
            }
        }
    }, {
        key: 'down',
        value: function down() {
            if (this.removeOnInterrupt) {
                this.parent.removePlugin('snap');
            } else if (this.interrupt) {
                this.snapping = null;
            }
        }
    }, {
        key: 'up',
        value: function up() {
            if (this.parent.countDownPointers() === 0) {
                var decelerate = this.parent.plugins['decelerate'];
                if (decelerate && (decelerate.x || decelerate.y)) {
                    decelerate.percentChangeX = decelerate.percentChangeY = this.friction;
                }
            }
        }
    }, {
        key: 'update',
        value: function update(elapsed) {
            if (this.paused) {
                return;
            }
            if (this.interrupt && this.parent.countDownPointers() !== 0) {
                return;
            }
            if (!this.snapping) {
                var current = this.topLeft ? this.parent.corner : this.parent.center;
                if (current.x !== this.x || current.y !== this.y) {
                    this.snapStart();
                }
            } else {
                var snapping = this.snapping;
                snapping.time += elapsed;
                var finished = void 0,
                    x = void 0,
                    y = void 0;
                if (snapping.time > this.time) {
                    finished = true;
                    x = this.startX + this.deltaX;
                    y = this.startY + this.deltaY;
                } else {
                    var percent = this.ease(snapping.time, 0, 1, this.time);
                    x = this.startX + this.deltaX * percent;
                    y = this.startY + this.deltaY * percent;
                }
                if (this.topLeft) {
                    this.parent.moveCorner(x, y);
                } else {
                    this.parent.moveCenter(x, y);
                }
                this.parent.emit('moved', { viewport: this.parent, type: 'snap' });
                if (finished) {
                    if (this.removeOnComplete) {
                        this.parent.removePlugin('snap');
                    }
                    this.parent.emit('snap-end', this.parent);
                    this.snapping = null;
                }
            }
        }
    }]);

    return Snap;
}(Plugin);

/***/ }),

/***/ "jYBl":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__("NfzK");

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function () {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/**
 * DISCLAIMER:
 *
 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
 *
 * It's called `Client' to be in-line with Raven Node implementation.
 *
 * HOWTO:
 *
 * import Raven from 'raven-js';
 *
 * const someAppReporter = new Raven.Client();
 * const someOtherAppReporter = new Raven.Client();
 *
 * someAppReporter.config('__DSN__', {
 *   ...config goes here
 * });
 *
 * someOtherAppReporter.config('__OTHER_DSN__', {
 *   ...config goes here
 * });
 *
 * someAppReporter.captureMessage(...);
 * someAppReporter.captureException(...);
 * someAppReporter.captureBreadcrumb(...);
 *
 * someOtherAppReporter.captureMessage(...);
 * someOtherAppReporter.captureException(...);
 * someOtherAppReporter.captureBreadcrumb(...);
 *
 * It should "just work".
 */
module.exports.Client = RavenConstructor;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "jYI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/react-redux/es/utils/PropTypes.js


var subscriptionShape = prop_types_default.a.shape({
  trySubscribe: prop_types_default.a.func.isRequired,
  tryUnsubscribe: prop_types_default.a.func.isRequired,
  notifyNestedSubs: prop_types_default.a.func.isRequired,
  isSubscribed: prop_types_default.a.func.isRequired
});

var storeShape = prop_types_default.a.shape({
  subscribe: prop_types_default.a.func.isRequired,
  dispatch: prop_types_default.a.func.isRequired,
  getState: prop_types_default.a.func.isRequired
});
// CONCATENATED MODULE: ../node_modules/react-redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
// CONCATENATED MODULE: ../node_modules/react-redux/es/components/Provider.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  warning('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return preact_compat_es["Children"].only(this.props.children);
    };

    return Provider;
  }(preact_compat_es["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: storeShape.isRequired,
    children: prop_types_default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = storeShape.isRequired, _Provider$childContex[subscriptionKey] = subscriptionShape, _Provider$childContex);

  return Provider;
}

/* harmony default export */ var components_Provider = (createProvider());
// EXTERNAL MODULE: ../node_modules/react-redux/node_modules/hoist-non-react-statics/index.js
var hoist_non_react_statics = __webpack_require__("PleT");
var hoist_non_react_statics_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics);

// EXTERNAL MODULE: ../node_modules/invariant/browser.js
var browser = __webpack_require__("2gTp");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ../node_modules/react-redux/es/utils/Subscription.js
function Subscription__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    Subscription__classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();


// CONCATENATED MODULE: ../node_modules/react-redux/es/components/connectAdvanced.js
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function connectAdvanced__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function connectAdvanced__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function connectAdvanced__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = storeShape, _contextTypes[subscriptionKey] = subscriptionShape, _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = subscriptionShape, _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    browser_default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      connectAdvanced__inherits(Connect, _Component);

      function Connect(props, context) {
        connectAdvanced__classCallCheck(this, Connect);

        var _this = connectAdvanced__possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        browser_default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        browser_default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new Subscription(this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(preact_compat_es["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(preact_compat_es["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return hoist_non_react_statics_default()(Connect, WrappedComponent);
  };
}
// CONCATENATED MODULE: ../node_modules/react-redux/es/utils/shallowEqual.js
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
// EXTERNAL MODULE: ../node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__("fpuT");

// EXTERNAL MODULE: ../node_modules/lodash-es/isPlainObject.js + 8 modules
var isPlainObject = __webpack_require__("9TS5");

// CONCATENATED MODULE: ../node_modules/react-redux/es/utils/verifyPlainObject.js



function verifyPlainObject_verifyPlainObject(value, displayName, methodName) {
  if (!Object(isPlainObject["a" /* default */])(value)) {
    warning(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}
// CONCATENATED MODULE: ../node_modules/react-redux/es/connect/wrapMapToProps.js


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}
// CONCATENATED MODULE: ../node_modules/react-redux/es/connect/mapDispatchToProps.js



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return Object(es["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ var connect_mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
// CONCATENATED MODULE: ../node_modules/react-redux/es/connect/mapStateToProps.js


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ var connect_mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
// CONCATENATED MODULE: ../node_modules/react-redux/es/connect/mergeProps.js
var mergeProps__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return mergeProps__extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ var connect_mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
// CONCATENATED MODULE: ../node_modules/react-redux/es/connect/verifySubselectors.js


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      warning('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors_verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}
// CONCATENATED MODULE: ../node_modules/react-redux/es/connect/selectorFactory.js
function selectorFactory__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = selectorFactory__objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// CONCATENATED MODULE: ../node_modules/react-redux/es/connect/connect.js
var connect__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function connect__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? connect_mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? connect_mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? connect_mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? shallowEqual : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? shallowEqual : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? shallowEqual : _ref2$areMergedPropsE,
        extraOptions = connect__objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, connect__extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ var connect_connect = (createConnect());
// CONCATENATED MODULE: ../node_modules/react-redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return components_Provider; });
/* unused concated harmony import createProvider */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return createProvider; });
/* unused concated harmony import connectAdvanced */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return connectAdvanced; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return connect_connect; });






/***/ }),

/***/ "jYgH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_TIMEOUT = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.defaultFormat = defaultFormat;
exports.defaultParse = defaultParse;

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("Ywoo");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DayPicker = __webpack_require__("ReEC");

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _DateUtils = __webpack_require__("s8Q5");

var _ModifiersUtils = __webpack_require__("ogP8");

var _keys = __webpack_require__("SdFt");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// When clicking on a day cell, overlay will be hidden after this timeout
var HIDE_TIMEOUT = exports.HIDE_TIMEOUT = 100;

/**
 * The default function used to format a Date to String, passed to the `format` prop.
 * @param {Date} d
 * @return {String}
 */
function defaultFormat(d) {
  if ((0, _DateUtils.isDate)(d)) {
    var year = d.getFullYear();
    var month = '' + (d.getMonth() + 1);
    var day = '' + d.getDate();
    return year + '-' + month + '-' + day;
  }
  return '';
}

/**
 * The default function used to parse a String as Date, passed to the `parse` prop.
 * @param {String} str
 * @return {Date}
 */
function defaultParse(str) {
  if (typeof str !== 'string') {
    return undefined;
  }
  var split = str.split('-');
  if (split.length !== 3) {
    return undefined;
  }
  var year = parseInt(split[0], 10);
  var month = parseInt(split[1], 10) - 1;
  var day = parseInt(split[2], 10);
  if (isNaN(year) || isNaN(month) || isNaN(day) || day <= 0 || day > 31 || month < 0 || month >= 12) {
    return undefined;
  }

  return new Date(year, month, day);
}

var DayPickerInput = function (_React$Component) {
  _inherits(DayPickerInput, _React$Component);

  function DayPickerInput(props) {
    _classCallCheck(this, DayPickerInput);

    var _this = _possibleConstructorReturn(this, (DayPickerInput.__proto__ || Object.getPrototypeOf(DayPickerInput)).call(this, props));

    _this.input = null;
    _this.daypicker = null;
    _this.overlayNode = null;
    _this.clickTimeout = null;
    _this.hideTimeout = null;

    _this.state = _this.getInitialStateFromProps(props);
    _this.state.showOverlay = props.showOverlay;

    _this.hideAfterDayClick = _this.hideAfterDayClick.bind(_this);
    _this.handleInputClick = _this.handleInputClick.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
    _this.handleInputKeyUp = _this.handleInputKeyUp.bind(_this);
    _this.handleDayClick = _this.handleDayClick.bind(_this);
    _this.handleMonthChange = _this.handleMonthChange.bind(_this);
    _this.handleOverlayFocus = _this.handleOverlayFocus.bind(_this);
    _this.handleOverlayBlur = _this.handleOverlayBlur.bind(_this);
    return _this;
  }

  _createClass(DayPickerInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var newState = {};

      // Current props
      var _props = this.props,
          value = _props.value,
          formatDate = _props.formatDate,
          format = _props.format,
          dayPickerProps = _props.dayPickerProps;

      // Update the input value if the `value` prop has changed

      if (value !== prevProps.value) {
        if ((0, _DateUtils.isDate)(value)) {
          newState.value = formatDate(value, format, dayPickerProps.locale);
        } else {
          newState.value = value;
        }
      }

      // Update the month if the months from props changed
      var prevMonth = prevProps.dayPickerProps.month;
      if (dayPickerProps.month && dayPickerProps.month !== prevMonth && !(0, _DateUtils.isSameMonth)(dayPickerProps.month, prevMonth)) {
        newState.month = dayPickerProps.month;
      }

      // Updated the selected days from props if they changed
      if (prevProps.dayPickerProps.selectedDays !== dayPickerProps.selectedDays) {
        newState.selectedDays = dayPickerProps.selectedDays;
      }

      if (Object.keys(newState).length > 0) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState(newState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.clickTimeout);
      clearTimeout(this.hideTimeout);
    }
  }, {
    key: 'getInitialMonthFromProps',
    value: function getInitialMonthFromProps(props) {
      var dayPickerProps = props.dayPickerProps,
          format = props.format;

      var day = void 0;
      if (props.value) {
        if ((0, _DateUtils.isDate)(props.value)) {
          day = props.value;
        } else {
          day = props.parseDate(props.value, format, dayPickerProps.locale);
        }
      }
      return dayPickerProps.initialMonth || dayPickerProps.month || day || new Date();
    }
  }, {
    key: 'getInitialStateFromProps',
    value: function getInitialStateFromProps(props) {
      var dayPickerProps = props.dayPickerProps,
          formatDate = props.formatDate,
          format = props.format;
      var value = props.value;

      if (props.value && (0, _DateUtils.isDate)(props.value)) {
        value = formatDate(props.value, format, dayPickerProps.locale);
      }
      return {
        value: value,
        month: this.getInitialMonthFromProps(props),
        selectedDays: dayPickerProps.selectedDays
      };
    }
  }, {
    key: 'getInput',
    value: function getInput() {
      return this.input;
    }
  }, {
    key: 'getDayPicker',
    value: function getDayPicker() {
      return this.daypicker;
    }
  }, {
    key: 'updateState',

    /**
     * Update the component's state and fire the `onDayChange` event
     * passing the day's modifiers to it
     * @param {Date} day - Will be used for changing the month
     * @param {String} value - Input field value
     * @private
     */
    value: function updateState(day, value, callback) {
      var _props2 = this.props,
          dayPickerProps = _props2.dayPickerProps,
          onDayChange = _props2.onDayChange;

      this.setState({ month: day, value: value }, function () {
        if (callback) {
          callback();
        }
        if (!onDayChange) {
          return;
        }
        var modifiersObj = _extends({
          disabled: dayPickerProps.disabledDays,
          selected: dayPickerProps.selectedDays
        }, dayPickerProps.modifiers);
        var modifiers = (0, _ModifiersUtils.getModifiersForDay)(day, modifiersObj).reduce(function (obj, modifier) {
          var newObj = _extends({}, obj);
          newObj[modifier] = true;
          return newObj;
        }, {});
        onDayChange(day, modifiers);
      });
    }

    /**
     * Show the Day Picker overlay.
     *
     * @memberof DayPickerInput
     */

  }, {
    key: 'showDayPicker',
    value: function showDayPicker() {
      var _props3 = this.props,
          parseDate = _props3.parseDate,
          format = _props3.format,
          dayPickerProps = _props3.dayPickerProps;
      var _state = this.state,
          value = _state.value,
          showOverlay = _state.showOverlay;

      var month = void 0;
      if (showOverlay === false) {
        // Reset the current displayed month when showing the overlay
        month = value ? parseDate(value, format, dayPickerProps.locale) // Use the month in the input field
        : this.getInitialMonthFromProps(this.props); // Restore the month from the props
      }
      this.setState({
        showOverlay: true,
        month: month || this.state.month
      });
    }

    /**
     * Hide the Day Picker overlay
     *
     * @memberof DayPickerInput
     */

  }, {
    key: 'hideDayPicker',
    value: function hideDayPicker() {
      this.setState({ showOverlay: false });
    }
  }, {
    key: 'hideAfterDayClick',
    value: function hideAfterDayClick() {
      var _this2 = this;

      if (!this.props.hideOnDayClick) {
        return;
      }
      this.hideTimeout = setTimeout(function () {
        return _this2.hideDayPicker();
      }, HIDE_TIMEOUT);
    }
  }, {
    key: 'handleInputClick',
    value: function handleInputClick(e) {
      this.showDayPicker();
      if (this.props.inputProps.onClick) {
        e.persist();
        this.props.inputProps.onClick(e);
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus(e) {
      this.showDayPicker();
      if (this.props.inputProps.onFocus) {
        e.persist();
        this.props.inputProps.onFocus(e);
      }
    }
  }, {
    key: 'handleInputBlur',
    value: function handleInputBlur(e) {
      this.setState({
        showOverlay: this.overlayNode && this.overlayNode.contains(e.relatedTarget)
      });
      if (this.props.inputProps.onBlur) {
        e.persist();
        this.props.inputProps.onBlur(e);
      }
    }
  }, {
    key: 'handleOverlayFocus',
    value: function handleOverlayFocus(e) {
      if (this.props.keepFocus === true) {
        e.preventDefault();
        this.input.focus();
      }
    }
  }, {
    key: 'handleOverlayBlur',
    value: function handleOverlayBlur(e) {
      this.setState({
        showOverlay: this.overlayNode && this.overlayNode.contains(e.relatedTarget)
      });
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      var _props4 = this.props,
          dayPickerProps = _props4.dayPickerProps,
          format = _props4.format,
          inputProps = _props4.inputProps,
          onDayChange = _props4.onDayChange,
          parseDate = _props4.parseDate;

      if (inputProps.onChange) {
        e.persist();
        inputProps.onChange(e);
      }
      var value = e.target.value;

      if (value.trim() === '') {
        this.setState({ value: value });
        if (onDayChange) onDayChange(undefined, {});
        return;
      }
      var day = parseDate(value, format, dayPickerProps.locale);
      if (!day) {
        this.setState({ value: value });
        if (onDayChange) onDayChange(undefined, {});
        return;
      }
      this.updateState(day, value);
    }
  }, {
    key: 'handleInputKeyDown',
    value: function handleInputKeyDown(e) {
      if (e.keyCode === _keys.TAB) {
        this.hideDayPicker();
      }
      if (this.props.inputProps.onKeyDown) {
        e.persist();
        this.props.inputProps.onKeyDown(e);
      }
    }
  }, {
    key: 'handleInputKeyUp',
    value: function handleInputKeyUp(e) {
      // Hide the overlay if the ESC key is pressed
      if (e.keyCode === _keys.ESC) {
        this.hideDayPicker();
      }
      if (this.props.inputProps.onKeyUp) {
        e.persist();
        this.props.inputProps.onKeyUp(e);
      }
    }
  }, {
    key: 'handleMonthChange',
    value: function handleMonthChange(month) {
      var _this3 = this;

      this.setState({ month: month }, function () {
        if (_this3.props.dayPickerProps && _this3.props.dayPickerProps.onMonthChange) {
          _this3.props.dayPickerProps.onMonthChange(month);
        }
      });
    }
  }, {
    key: 'handleDayClick',
    value: function handleDayClick(day, modifiers, e) {
      var _this4 = this;

      var _props5 = this.props,
          clickUnselectsDay = _props5.clickUnselectsDay,
          dayPickerProps = _props5.dayPickerProps,
          onDayChange = _props5.onDayChange,
          formatDate = _props5.formatDate,
          format = _props5.format;

      if (dayPickerProps.onDayClick) {
        dayPickerProps.onDayClick(day, modifiers, e);
      }

      // Do nothing if the day is disabled
      if (modifiers.disabled) {
        return;
      }

      // If the clicked day is already selected, remove the clicked day
      // from the selected days and empty the field value
      if (modifiers.selected && clickUnselectsDay) {
        var selectedDays = this.state.selectedDays;

        if (Array.isArray(selectedDays)) {
          selectedDays = selectedDays.slice(0);
          var selectedDayIdx = selectedDays.indexOf(day);
          selectedDays.splice(selectedDayIdx, 1);
        } else if (selectedDays) {
          selectedDays = null;
        }
        this.setState({ value: '', selectedDays: selectedDays }, this.hideAfterDayClick);
        if (onDayChange) {
          onDayChange(undefined, modifiers);
        }
        return;
      }

      var value = formatDate(day, format, dayPickerProps.locale);
      this.setState({ value: value, month: day }, function () {
        if (onDayChange) {
          onDayChange(day, modifiers);
        }
        _this4.hideAfterDayClick();
      });
    }
  }, {
    key: 'renderOverlay',
    value: function renderOverlay() {
      var _this5 = this;

      var _props6 = this.props,
          classNames = _props6.classNames,
          dayPickerProps = _props6.dayPickerProps,
          parseDate = _props6.parseDate,
          formatDate = _props6.formatDate,
          format = _props6.format;
      var _state2 = this.state,
          selectedDays = _state2.selectedDays,
          value = _state2.value;

      var selectedDay = void 0;
      if (!selectedDays && value) {
        var day = parseDate(value, format, dayPickerProps.locale);
        if (day) {
          selectedDay = day;
        }
      } else if (selectedDays) {
        selectedDay = selectedDays;
      }
      var onTodayButtonClick = void 0;
      if (dayPickerProps.todayButton) {
        // Set the current day when clicking the today button
        onTodayButtonClick = function onTodayButtonClick() {
          return _this5.updateState(new Date(), formatDate(new Date(), format, dayPickerProps.locale), _this5.hideAfterDayClick);
        };
      }
      var Overlay = this.props.overlayComponent;
      return _react2.default.createElement('span', {
        onFocus: this.handleOverlayFocus,
        ref: function ref(el) {
          return _this5.overlayNode = el;
        },
        onBlur: this.handleOverlayBlur
      }, _react2.default.createElement(Overlay, {
        classNames: classNames,
        month: this.state.month,
        selectedDay: selectedDay,
        input: this.input
      }, _react2.default.createElement(_DayPicker2.default, _extends({
        ref: function ref(el) {
          return _this5.daypicker = el;
        },
        onTodayButtonClick: onTodayButtonClick
      }, dayPickerProps, {
        month: this.state.month,
        selectedDays: selectedDay,
        onDayClick: this.handleDayClick,
        onMonthChange: this.handleMonthChange
      }))));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var Input = this.props.component;
      var inputProps = this.props.inputProps;

      return _react2.default.createElement('div', { className: this.props.classNames.container }, _react2.default.createElement(Input, _extends({
        ref: function ref(el) {
          return _this6.input = el;
        },
        placeholder: this.props.placeholder
      }, inputProps, {
        value: this.state.value,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        onKeyDown: this.handleInputKeyDown,
        onKeyUp: this.handleInputKeyUp,
        onClick: !inputProps.disabled ? this.handleInputClick : undefined
      })), this.state.showOverlay && this.renderOverlay());
    }
  }]);

  return DayPickerInput;
}(_react2.default.Component);

DayPickerInput.defaultProps = {
  dayPickerProps: {},
  value: '',
  placeholder: 'YYYY-M-D',
  format: 'L',
  formatDate: defaultFormat,
  parseDate: defaultParse,
  showOverlay: false,
  hideOnDayClick: true,
  clickUnselectsDay: false,
  keepFocus: true,
  component: 'input',
  inputProps: {},
  overlayComponent: function overlayComponent(_ref) {
    var children = _ref.children,
        classNames = _ref.classNames;
    return _react2.default.createElement('div', { className: classNames.overlayWrapper }, _react2.default.createElement('div', { className: classNames.overlay }, children));
  },
  classNames: {
    container: 'DayPickerInput',
    overlayWrapper: 'DayPickerInput-OverlayWrapper',
    overlay: 'DayPickerInput-Overlay'
  }
};
exports.default = DayPickerInput;
DayPickerInput.propTypes =  false ? {
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
  inputProps: _propTypes2.default.object,
  placeholder: _propTypes2.default.string,

  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

  formatDate: _propTypes2.default.func,
  parseDate: _propTypes2.default.func,

  showOverlay: _propTypes2.default.bool,
  dayPickerProps: _propTypes2.default.object,
  hideOnDayClick: _propTypes2.default.bool,
  clickUnselectsDay: _propTypes2.default.bool,
  keepFocus: _propTypes2.default.bool,
  component: _propTypes2.default.any,
  overlayComponent: _propTypes2.default.any,

  classNames: _propTypes2.default.shape({
    container: _propTypes2.default.string,
    overlayWrapper: _propTypes2.default.string,
    overlay: _propTypes2.default.string.isRequired
  }),

  onDayChange: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func
} : {};
//# sourceMappingURL=DayPickerInput.js.map

/***/ }),

/***/ "juli":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLManager2 = __webpack_require__("ClQe");

var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * @class
 * @extends PIXI.WebGLManager
 * @memberof PIXI
 */
var StencilManager = function (_WebGLManager) {
    _inherits(StencilManager, _WebGLManager);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
     */
    function StencilManager(renderer) {
        _classCallCheck(this, StencilManager);

        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));

        _this.stencilMaskStack = null;
        return _this;
    }

    /**
     * Changes the mask stack that is used by this manager.
     *
     * @param {PIXI.Graphics[]} stencilMaskStack - The mask stack
     */

    StencilManager.prototype.setMaskStack = function setMaskStack(stencilMaskStack) {
        this.stencilMaskStack = stencilMaskStack;

        var gl = this.renderer.gl;

        if (stencilMaskStack.length === 0) {
            gl.disable(gl.STENCIL_TEST);
        } else {
            gl.enable(gl.STENCIL_TEST);
        }
    };

    /**
     * Applies the Mask and adds it to the current stencil stack. @alvin
     *
     * @param {PIXI.Graphics} graphics - The mask
     */

    StencilManager.prototype.pushStencil = function pushStencil(graphics) {
        this.renderer.setObjectRenderer(this.renderer.plugins.graphics);

        this.renderer._activeRenderTarget.attachStencilBuffer();

        var gl = this.renderer.gl;
        var prevMaskCount = this.stencilMaskStack.length;

        if (prevMaskCount === 0) {
            gl.enable(gl.STENCIL_TEST);
        }

        this.stencilMaskStack.push(graphics);

        // Increment the reference stencil value where the new mask overlaps with the old ones.
        gl.colorMask(false, false, false, false);
        gl.stencilFunc(gl.EQUAL, prevMaskCount, this._getBitwiseMask());
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
        this.renderer.plugins.graphics.render(graphics);

        this._useCurrent();
    };

    /**
     * Removes the last mask from the stencil stack. @alvin
     */

    StencilManager.prototype.popStencil = function popStencil() {
        this.renderer.setObjectRenderer(this.renderer.plugins.graphics);

        var gl = this.renderer.gl;
        var graphics = this.stencilMaskStack.pop();

        if (this.stencilMaskStack.length === 0) {
            // the stack is empty!
            gl.disable(gl.STENCIL_TEST);
            gl.clear(gl.STENCIL_BUFFER_BIT);
            gl.clearStencil(0);
        } else {
            // Decrement the reference stencil value where the popped mask overlaps with the other ones
            gl.colorMask(false, false, false, false);
            gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
            this.renderer.plugins.graphics.render(graphics);

            this._useCurrent();
        }
    };

    /**
     * Setup renderer to use the current stencil data.
     */

    StencilManager.prototype._useCurrent = function _useCurrent() {
        var gl = this.renderer.gl;

        gl.colorMask(true, true, true, true);
        gl.stencilFunc(gl.EQUAL, this.stencilMaskStack.length, this._getBitwiseMask());
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    };

    /**
     * Fill 1s equal to the number of acitve stencil masks.
     *
     * @return {number} The bitwise mask.
     */

    StencilManager.prototype._getBitwiseMask = function _getBitwiseMask() {
        return (1 << this.stencilMaskStack.length) - 1;
    };

    /**
     * Destroys the mask stack.
     *
     */

    StencilManager.prototype.destroy = function destroy() {
        _WebGLManager3.default.prototype.destroy.call(this);

        this.stencilMaskStack.stencilStack = null;
    };

    return StencilManager;
}(_WebGLManager3.default);

exports.default = StencilManager;
//# sourceMappingURL=StencilManager.js.map

/***/ }),

/***/ "jvu7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLExtract = __webpack_require__("rjpc");

Object.defineProperty(exports, 'webgl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WebGLExtract).default;
  }
});

var _CanvasExtract = __webpack_require__("QFWM");

Object.defineProperty(exports, 'canvas', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasExtract).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "k2Y9":
/***/ (function(module, exports) {

function ccw(x1, y1, x2, y2, x3, y3) {
    var cw = (y3 - y1) * (x2 - x1) - (y2 - y1) * (x3 - x1);
    return cw > 0 ? true : cw < 0 ? false : true; // colinear
}

function intersect(seg1, seg2) {
    var x1 = seg1[0][0],
        y1 = seg1[0][1],
        x2 = seg1[1][0],
        y2 = seg1[1][1],
        x3 = seg2[0][0],
        y3 = seg2[0][1],
        x4 = seg2[1][0],
        y4 = seg2[1][1];

    return ccw(x1, y1, x3, y3, x4, y4) !== ccw(x2, y2, x3, y3, x4, y4) && ccw(x1, y1, x2, y2, x3, y3) !== ccw(x1, y1, x2, y2, x4, y4);
}

module.exports = intersect;

/***/ }),

/***/ "k9g3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = __webpack_require__("sh3Y");

module.exports = function (_Plugin) {
    _inherits(ClampZoom, _Plugin);

    /**
     * @private
     * @param {object} [options]
     * @param {number} [options.minWidth] minimum width
     * @param {number} [options.minHeight] minimum height
     * @param {number} [options.maxWidth] maximum width
     * @param {number} [options.maxHeight] maximum height
     */
    function ClampZoom(parent, options) {
        _classCallCheck(this, ClampZoom);

        var _this = _possibleConstructorReturn(this, (ClampZoom.__proto__ || Object.getPrototypeOf(ClampZoom)).call(this, parent));

        _this.minWidth = options.minWidth;
        _this.minHeight = options.minHeight;
        _this.maxWidth = options.maxWidth;
        _this.maxHeight = options.maxHeight;
        _this.clamp();
        return _this;
    }

    _createClass(ClampZoom, [{
        key: 'resize',
        value: function resize() {
            this.clamp();
        }
    }, {
        key: 'clamp',
        value: function clamp() {
            if (this.paused) {
                return;
            }

            var width = this.parent.worldScreenWidth;
            var height = this.parent.worldScreenHeight;
            if (this.minWidth && width < this.minWidth) {
                var original = this.parent.scale.x;
                this.parent.fitWidth(this.minWidth, false, false, true);
                this.parent.scale.y *= this.parent.scale.x / original;
                width = this.parent.worldScreenWidth;
                height = this.parent.worldScreenHeight;
                this.parent.emit('zoomed', { viewport: this.parent, type: 'clamp-zoom' });
            }
            if (this.maxWidth && width > this.maxWidth) {
                var _original = this.parent.scale.x;
                this.parent.fitWidth(this.maxWidth, false, false, true);
                this.parent.scale.y *= this.parent.scale.x / _original;
                width = this.parent.worldScreenWidth;
                height = this.parent.worldScreenHeight;
                this.parent.emit('zoomed', { viewport: this.parent, type: 'clamp-zoom' });
            }
            if (this.minHeight && height < this.minHeight) {
                var _original2 = this.parent.scale.y;
                this.parent.fitHeight(this.minHeight, false, false, true);
                this.parent.scale.x *= this.parent.scale.y / _original2;
                width = this.parent.worldScreenWidth;
                height = this.parent.worldScreenHeight;
                this.parent.emit('zoomed', { viewport: this.parent, type: 'clamp-zoom' });
            }
            if (this.maxHeight && height > this.maxHeight) {
                var _original3 = this.parent.scale.y;
                this.parent.fitHeight(this.maxHeight, false, false, true);
                this.parent.scale.x *= this.parent.scale.y / _original3;
                this.parent.emit('zoomed', { viewport: this.parent, type: 'clamp-zoom' });
            }
        }
    }]);

    return ClampZoom;
}(Plugin);

/***/ }),

/***/ "kAhx":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__("uh8Y");

var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
}

function isDOMError(value) {
  return Object.prototype.toString.call(value) === '[object DOMError]';
}

function isDOMException(value) {
  return Object.prototype.toString.call(value) === '[object DOMException]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMError() {
  try {
    new DOMError(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMException() {
  try {
    new DOMException(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function (key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
      i = 0,
      len = patterns.length,
      pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function (key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = arr[3] & 0xfff | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = arr[4] & 0x3fff | 0x8000;

    var pad = function pad(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
      MAX_OUTPUT_LEN = 80,
      out = [],
      height = 0,
      len = 0,
      separator = ' > ',
      sepLength = separator.length,
      nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
      className,
      classes,
      key,
      attr,
      i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if stacktrace is malformed
  if (frames1 === undefined || frames2 === undefined) return false;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (a.filename !== b.filename || a.lineno !== b.lineno || a.colno !== b.colno || a['function'] !== b['function']) return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'undefined') {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]') return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function (acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function (val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function (key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || isArray(sanitizeKeys) && sanitizeKeys.length === 0) return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function (val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function (acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isDOMError: isDOMError,
  isDOMException: isDOMException,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsDOMError: supportsDOMError,
  supportsDOMException: supportsDOMException,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "kL2R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);

var Image = function Image(_ref) {
  var src = _ref.src,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      alt = _ref.alt;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("img", { src: src, className: className, alt: alt, style: style });
};

/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ "kWdy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Utils_1 = __webpack_require__("o6Mn");
var TicketMapping = function TicketMapping(Base) {
    return function (_Base) {
        _inherits(_class, _Base);

        function _class(tableData, actions, disableInteraction) {
            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, _Base.call(this, tableData, actions, disableInteraction));

            _this.onClick = function () {
                if (!_this.selected) {
                    if (!_this.locked && _this.valid && !_this.reserved && _this.focused) {
                        var availableSeats = _this.seats.filter(function (seat) {
                            return !seat.isUnavailable();
                        });
                        if (_this.bookByTable && _this.ticketData.ticketIds && _this.ticketData.ticketIds.length === availableSeats.length) {
                            _this.selected = true;
                            _this.ticketId = _this.ticketData.ticketId;
                            _this.selectedTicketData = _this.ticketData;
                            _this.mappedTicketIds = [].concat(_this.ticketData.ticketIds);
                            var ticketSeatMapping = availableSeats.map(function (seat, i) {
                                return seat.mapTicket(_this.mappedTicketIds[i], _this.ticketData.ticketTypeId);
                            });
                            _this.ticketData.ticketIds = [];
                            _this.actions.onTicketMapped(_this.ticketData.ticketTypeId, ticketSeatMapping, _this.ticketData.ticketId, { sectionName: _this.sectionName, tableName: _this.name });
                            _this.updateTexture();
                        }
                    }
                } else {
                    var _availableSeats = _this.seats.filter(function (seat) {
                        return !seat.isUnavailable();
                    });
                    _this.selected = false;
                    _this.ticketData.ticketIds = [].concat(_this.mappedTicketIds);
                    _this.mappedTicketIds = [];
                    var seatsToUnmap = _availableSeats.map(function (seat) {
                        return seat.unmapTicket();
                    });
                    _this.actions.onTicketUnmapped(_this.selectedTicketData.ticketTypeId, _this.ticketId, seatsToUnmap);
                    _this.selectedTicketData = null;
                    _this.updateTexture();
                }
            };
            return _this;
        }

        _class.prototype.unselectSeat = function unselectSeat(seatId) {
            var seat = this.seats.find(function (seat) {
                return seat.id === seatId;
            });
            seat.deSelect();
        };

        _class.prototype.disableSeat = function disableSeat(seatId) {
            var seat = this.seats.find(function (seat) {
                return seat.id === seatId;
            });
            seat.disable();
        };

        _class.prototype.determineTextureType = function determineTextureType() {
            var currentTexture = void 0;
            if (this.reserved || this.locked || !(this.valid && this.focused)) {
                currentTexture = Utils_1.circleTableUnavailableTexture;
            } else {
                currentTexture = this.selected ? Utils_1.circleTableSelectedTexture : Utils_1.circleTableAvailableTexture;
            }
            this.tableTexture = PIXI.loader.resources[currentTexture].texture;
            this.tableTexture.baseTexture.mipmap = true;
        };

        _class.prototype.determineFocus = function determineFocus(focused) {
            var _this2 = this;

            this.focused = focused;
            this.updateTexture();
            this.seats.forEach(function (seat) {
                return seat.determineFocus(_this2.focused);
            });
        };

        _class.prototype.setTicketMapping = function setTicketMapping(currentTicketData) {
            console.log("setTicketMapping", currentTicketData);
            this.ticketData = currentTicketData;
            if (this.ticketIds.includes(this.ticketData.ticketTypeId)) {
                this.valid = true;
            } else {
                this.valid = false;
            }
            console.log("this.valid", this.valid);
            var dontLockSeat = this.valid && this.bookByTable;
            this.seats.forEach(function (seat) {
                return seat.setTicketMapping(currentTicketData, dontLockSeat);
            });
        };

        _class.prototype.mapExistingTicket = function mapExistingTicket(ticketId, ticketTypeId, packageGroupId, packageId, tableId, seatId) {
            if (this._id === tableId) {
                if (packageGroupId) {
                    this.selected = true;
                    this.reserved = false;
                    this.ticketId = packageGroupId;
                    this.selectedTicketData = { ticketTypeId: ticketTypeId };
                    this.mappedTicketIds = (this.mappedTicketIds || []).concat([ticketId]);
                    var mappedTicketSeats = this.seats.map(function (seat) {
                        if (seat.id === seatId) {
                            seat.mapTicket(ticketId, ticketTypeId);
                        }
                    }).filter(function (seat) {
                        return seat;
                    });
                    this.actions.onTicketMapped(ticketTypeId, mappedTicketSeats, packageGroupId, { sectionName: this.sectionName, tableName: this.name });
                    this.updateTexture();
                } else {
                    this.seats.forEach(function (seat) {
                        return seat.mapExistingTicket(ticketId, ticketTypeId, seatId);
                    });
                }
                if (!this.selectionListener) {
                    this.setupInteraction();
                }
            }
        };

        return _class;
    }(Base);
};
exports.default = TicketMapping;
//# sourceMappingURL=TicketMappingMixin.js.map

/***/ }),

/***/ "kbGH":
/***/ (function(module, exports) {

var onEnter = function onEnter(onClick) {
  return function (_ref) {
    var key = _ref.key;

    if (key === "Enter") {
      onClick();
    }
  };
};

module.exports = { onEnter: onEnter };

/***/ }),

/***/ "kfMo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emotion__ = __webpack_require__("mibh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_focus_trap_react__ = __webpack_require__("M5Nt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_focus_trap_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_focus_trap_react__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var closeIcon = __webpack_require__("dty5");

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.checkDocumentKeyDown = function (event) {
      var closeHandler = _this.props.closeHandler;

      if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
        closeHandler(event);
      }
    };

    _this.state = {
      hasOpened: false
    };
    return _this;
  }

  Modal.prototype.componentDidUpdate = function componentDidUpdate() {
    var showModal = this.props.showModal;

    if (showModal) {
      if (!this.state.hasOpened) {
        this.setState({ hasOpened: true });
      }
      this.addKeyDownListener();
      return;
    }
    this.removeKeyDownListener();
  };

  Modal.prototype.componentDidMount = function componentDidMount() {};

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeKeyDownListener();
  };

  Modal.prototype.addKeyDownListener = function addKeyDownListener() {
    document.addEventListener("keydown", this.checkDocumentKeyDown);
  };

  Modal.prototype.removeKeyDownListener = function removeKeyDownListener() {
    document.removeEventListener("keydown", this.checkDocumentKeyDown);
  };

  Modal.prototype.render = function render(_ref) {
    var showModal = _ref.showModal,
        closeHandler = _ref.closeHandler,
        title = _ref.title,
        contents = _ref.contents,
        footer = _ref.footer,
        children = _ref.children,
        _ref$padding = _ref.padding,
        padding = _ref$padding === undefined ? 20 : _ref$padding,
        _ref$destroy = _ref.destroy,
        destroy = _ref$destroy === undefined ? true : _ref$destroy,
        _ref$includeCloseButt = _ref.includeCloseButton,
        includeCloseButton = _ref$includeCloseButt === undefined ? true : _ref$includeCloseButt;

    var hasOpened = this.state.hasOpened;
    var fadeIn = Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["keyframes"])({
      from: {
        opacity: 0.5
      },
      to: {
        opacity: 1
      }
    });
    var grow = Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["keyframes"])({
      from: {
        transform: "scale(0.9)"
      },
      to: {
        transform: "scale(1)"
      }
    });
    /* The Modal (background) */
    var modal = Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["css"])({
      display: showModal ? "flex" : "none",
      justifyContent: "center",
      alignItems: "flex-start",
      position: "fixed",
      zIndex: 100001,
      paddingTop: 80,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      background: "transparent",
      "@media(max-width: 600px)": {
        paddingTop: "20vh"
      }
    });

    var modalBackground = Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["css"])({
      backgroundColor: "rgba(0,0,0,0.6)",
      animation: fadeIn + " 0.3s ease-in-out",
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      position: "absolute"
    });

    /* Modal Content */
    var modalContent = Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["css"])({
      position: "relative",
      backgroundColor: "#fefefe",
      padding: padding,
      border: "1px solid #888",
      borderRadius: 4,
      display: "inline-block",
      animation: grow + " 0.2s ease-in-out",
      overflow: "scroll",
      minWidth: 300,
      maxWidth: "calc(100vw - 28px)",
      maxHeight: "calc(100vh - 80px)",
      "@media(max-width: 600px)": {
        maxHeight: "100vh",
        paddingBottom: 80,
        minWidth: 200,
        width: "100%",
        borderRadius: 0
      }
    });

    /* The Close Button */
    var close = Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["css"])({
      border: "none",
      position: "absolute",
      background: "#fff",
      right: 20,
      top: 20,
      width: 24,
      height: 24,
      backgroundImage: "url(" + closeIcon + ")",
      zIndex: 10
    });

    var footerStyle = Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["css"])({
      borderTop: "1px solid #D8D8D8",
      padding: "12px 0 6px",
      margin: "0 0 6px 0",
      display: "flex"
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      { className: modal },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("div", { className: modalBackground }),
      showModal || !destroy && hasOpened ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2_focus_trap_react___default.a,
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "div",
          {
            className: modalContent,
            "aria-modal": "true",
            role: "dialog",
            id: "modal-wrapper"
          },
          includeCloseButton ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("button", {
            type: "button",
            className: close,
            onClick: closeHandler,
            "aria-label": "Close",
            "data-cy": "close"
          }) : null,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "h3",
            null,
            title
          ),
          contents ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "div",
            null,
            contents
          ) : children,
          footer ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "div",
            { className: footerStyle },
            footer
          ) : null
        )
      ) : null
    );
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),

/***/ "khQn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Creates a Canvas element of the given size.
 *
 * @class
 * @memberof PIXI
 */
var CanvasRenderTarget = function () {
  /**
   * @param {number} width - the width for the newly created canvas
   * @param {number} height - the height for the newly created canvas
   * @param {number} [resolution=1] - The resolution / device pixel ratio of the canvas
   */
  function CanvasRenderTarget(width, height, resolution) {
    _classCallCheck(this, CanvasRenderTarget);

    /**
     * The Canvas object that belongs to this CanvasRenderTarget.
     *
     * @member {HTMLCanvasElement}
     */
    this.canvas = document.createElement('canvas');

    /**
     * A CanvasRenderingContext2D object representing a two-dimensional rendering context.
     *
     * @member {CanvasRenderingContext2D}
     */
    this.context = this.canvas.getContext('2d');

    this.resolution = resolution || _settings2.default.RESOLUTION;

    this.resize(width, height);
  }

  /**
   * Clears the canvas that was created by the CanvasRenderTarget class.
   *
   * @private
   */

  CanvasRenderTarget.prototype.clear = function clear() {
    this.context.setTransform(1, 0, 0, 1, 0, 0);
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
  };

  /**
   * Resizes the canvas to the specified width and height.
   *
   * @param {number} width - the new width of the canvas
   * @param {number} height - the new height of the canvas
   */

  CanvasRenderTarget.prototype.resize = function resize(width, height) {
    this.canvas.width = width * this.resolution;
    this.canvas.height = height * this.resolution;
  };

  /**
   * Destroys this canvas.
   *
   */

  CanvasRenderTarget.prototype.destroy = function destroy() {
    this.context = null;
    this.canvas = null;
  };

  /**
   * The width of the canvas buffer in pixels.
   *
   * @member {number}
   */

  _createClass(CanvasRenderTarget, [{
    key: 'width',
    get: function get() {
      return this.canvas.width;
    },
    set: function set(val) // eslint-disable-line require-jsdoc
    {
      this.canvas.width = val;
    }

    /**
     * The height of the canvas buffer in pixels.
     *
     * @member {number}
     */

  }, {
    key: 'height',
    get: function get() {
      return this.canvas.height;
    },
    set: function set(val) // eslint-disable-line require-jsdoc
    {
      this.canvas.height = val;
    }
  }]);

  return CanvasRenderTarget;
}();

exports.default = CanvasRenderTarget;
//# sourceMappingURL=CanvasRenderTarget.js.map

/***/ }),

/***/ "koPH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "60fccb0fd3d0d88b65303fa5598392c6.svg";

/***/ }),

/***/ "l/4+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("dZBD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("/Fvp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_actions_orderActions__ = __webpack_require__("J21P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("aSYM");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapAdditionalFields = function mapAdditionalFields(fieldsObject) {
  return Object.keys(fieldsObject).map(function (key, index) {
    var value = fieldsObject[key];
    return {
      questionId: key,
      value: value
    };
  }).filter(function (q) {
    return q.value !== null;
  });
};

var OrderService = {
  get: function get(id) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "order/" + id).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  addDiscount: function addDiscount(eventId, orderId, discountCode) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "discounts/add", {
        eventId: eventId,
        orderId: orderId,
        discountCode: discountCode
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getPublicOrder: function getPublicOrder(eventId, orderId, token) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "public/edit-order/order/" + orderId + "/" + eventId + "/" + token)).then(function ($await_1) {
        try {
          response = $await_1;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  savePublicOrder: function savePublicOrder(eventId, orderId, token, orderData) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("\n    " + Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "public/edit-order/order/" + orderId + "/" + eventId + "/" + token, orderData)).then(function ($await_2) {
        try {
          response = $await_2;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  addGiftCard: function addGiftCard(eventId, orderId, giftCardCode) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "gift-cards/add", {
        eventId: eventId,
        orderId: orderId,
        giftCardCode: giftCardCode
      })).then(function ($await_3) {
        try {
          response = $await_3;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  completeOrderWithGiftCard: function completeOrderWithGiftCard(orderId) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "gift-cards/complete", {
        orderId: orderId
      })).then(function ($await_4) {
        try {
          response = $await_4;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  removeGiftCard: function removeGiftCard(orderId) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "gift-cards/remove", {
        orderId: orderId
      })).then(function ($await_5) {
        try {
          response = $await_5;
          return $return(response.data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  removeDiscount: function removeDiscount(orderId) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "discounts/remove", {
        orderId: orderId
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  summary: function summary(id, requestedTickets, clientDonation, order, merch, giftCard, isEventId) {
    var tickets = order && order.tickets ? order.tickets : requestedTickets;
    var isInvoice = order && order.paymentMethod === __WEBPACK_IMPORTED_MODULE_2__state_actions_orderActions__["v" /* INVOICING */];
    var orderId = order && order._id ? order._id : false;
    var isManualOrder = false;
    if (window) {
      isManualOrder = window.manualOrderToken && window.isManualOrder && window.manualOrderSettings;
    }
    return new Promise(function (resolve, reject) {
      var _axios$post;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "order" + (!isEventId ? "/global" : "") + "/summary", (_axios$post = {}, _axios$post[isEventId ? "eventId" : "userId"] = id, _axios$post.tickets = tickets ? tickets : [], _axios$post.merch = merch ? merch : [], _axios$post.giftCard = giftCard ? giftCard : [], _axios$post.clientDonation = clientDonation, _axios$post.isInvoice = isInvoice, _axios$post.orderId = orderId, _axios$post.isManualOrder = isManualOrder, _axios$post)).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  request: function request(id, eventDateId, requestedItems, discountCode, clientDonation, lastOrderId, isGlobal, manualOrderValues) {
    var isBrowser = typeof window !== "undefined";
    var offerId = void 0;
    if (isBrowser) {
      var parsed = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(window.location.search);
      // get the offer id for waitlist clients
      offerId = parsed.offerid;
    }
    return new Promise(function (resolve, reject) {
      var _axios$put;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "order" + (isGlobal ? "/global" : "") + "/request", (_axios$put = {}, _axios$put[!isGlobal ? "eventId" : "userId"] = id, _axios$put.eventDateId = eventDateId, _axios$put[!isGlobal ? "requestedTickets" : "requestedGiftCards"] = requestedItems, _axios$put.discountCode = discountCode, _axios$put.clientDonation = clientDonation, _axios$put.lastOrderId = lastOrderId, _axios$put.offerId = offerId, _axios$put), { params: manualOrderValues }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  saveDetails: function saveDetails(orderData, tickets, ticketsData, hasAdditionalSteps, isGlobal) {
    orderData.additionalFields = orderData.additionalFields ? mapAdditionalFields(orderData.additionalFields) : orderData.additionalFields;
    // merge ticket additional fields
    var ticketLookUp = {};
    tickets.forEach(function (ticket, index) {
      ticketLookUp[ticket._id] = index;
    });
    if (isGlobal) {
      ticketsData.forEach(function (giftCard) {
        var index = ticketLookUp[giftCard.giftCardId];
        var giftCardLookup = tickets[index];
        if (giftCardLookup) {
          tickets[index] = _extends({}, giftCardLookup, giftCard);
        }
      });
    } else if (ticketsData) {
      Object.keys(ticketsData).map(function (key, index) {
        var ticket = tickets[ticketLookUp[key]];
        if (ticket) {
          ticket.additionalFields = mapAdditionalFields(ticketsData[key]);
        }
      });
    }
    return new Promise(function (resolve, reject) {
      var _axios$post2;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "order/" + (isGlobal ? "global/" : "") + "details", (_axios$post2 = {
        orderData: orderData
      }, _axios$post2[isGlobal ? "giftCardData" : "ticketData"] = tickets, _axios$post2.hasAdditionalSteps = hasAdditionalSteps, _axios$post2)).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  saveAfterCheckoutQuestions: function saveAfterCheckoutQuestions(event, orderData, tickets, ticketsData) {
    orderData.additionalFields = orderData.additionalFields ? mapAdditionalFields(orderData.additionalFields) : orderData.additionalFields;
    var ticketLookUp = {};
    tickets.forEach(function (ticket, index) {
      ticketLookUp[ticket._id] = index;
    });
    if (ticketsData) {
      Object.keys(ticketsData).map(function (key, index) {
        var ticket = tickets[ticketLookUp[key]];
        if (ticket) {
          ticket.additionalFields = mapAdditionalFields(ticketsData[key]);
        }
      });
    }
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "order/afterCheckout", {
        event: event,
        orderData: orderData,
        ticketData: tickets
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  pay: function pay(orderId, gateway, details, eventId, isGlobal) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])("API_URL") + "order/pay", {
        orderId: orderId,
        gateway: gateway,
        details: details,
        eventId: eventId,
        isGlobal: isGlobal
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (OrderService);

/***/ }),

/***/ "l262":
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "l5aM":
/***/ (function(module, exports) {


/**
 * Helper class to create a WebGL Texture
 *
 * @class
 * @memberof PIXI.glCore
 * @param gl {WebGLRenderingContext} The current WebGL context
 * @param width {number} the width of the texture
 * @param height {number} the height of the texture
 * @param format {number} the pixel format of the texture. defaults to gl.RGBA
 * @param type {number} the gl type of the texture. defaults to gl.UNSIGNED_BYTE
 */
var Texture = function Texture(gl, width, height, format, type) {
	/**
  * The current WebGL rendering context
  *
  * @member {WebGLRenderingContext}
  */
	this.gl = gl;

	/**
  * The WebGL texture
  *
  * @member {WebGLTexture}
  */
	this.texture = gl.createTexture();

	/**
  * If mipmapping was used for this texture, enable and disable with enableMipmap()
  *
  * @member {Boolean}
  */
	// some settings..
	this.mipmap = false;

	/**
  * Set to true to enable pre-multiplied alpha
  *
  * @member {Boolean}
  */
	this.premultiplyAlpha = false;

	/**
  * The width of texture
  *
  * @member {Number}
  */
	this.width = width || -1;
	/**
  * The height of texture
  *
  * @member {Number}
  */
	this.height = height || -1;

	/**
  * The pixel format of the texture. defaults to gl.RGBA
  *
  * @member {Number}
  */
	this.format = format || gl.RGBA;

	/**
  * The gl type of the texture. defaults to gl.UNSIGNED_BYTE
  *
  * @member {Number}
  */
	this.type = type || gl.UNSIGNED_BYTE;
};

/**
 * Uploads this texture to the GPU
 * @param source {HTMLImageElement|ImageData|HTMLVideoElement} the source image of the texture
 */
Texture.prototype.upload = function (source) {
	this.bind();

	var gl = this.gl;

	gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);

	var newWidth = source.videoWidth || source.width;
	var newHeight = source.videoHeight || source.height;

	if (newHeight !== this.height || newWidth !== this.width) {
		gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, source);
	} else {
		gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, this.format, this.type, source);
	}

	// if the source is a video, we need to use the videoWidth / videoHeight properties as width / height will be incorrect.
	this.width = newWidth;
	this.height = newHeight;
};

var FLOATING_POINT_AVAILABLE = false;

/**
 * Use a data source and uploads this texture to the GPU
 * @param data {TypedArray} the data to upload to the texture
 * @param width {number} the new width of the texture
 * @param height {number} the new height of the texture
 */
Texture.prototype.uploadData = function (data, width, height) {
	this.bind();

	var gl = this.gl;

	if (data instanceof Float32Array) {
		if (!FLOATING_POINT_AVAILABLE) {
			var ext = gl.getExtension("OES_texture_float");

			if (ext) {
				FLOATING_POINT_AVAILABLE = true;
			} else {
				throw new Error('floating point textures not available');
			}
		}

		this.type = gl.FLOAT;
	} else {
		// TODO support for other types
		this.type = this.type || gl.UNSIGNED_BYTE;
	}

	// what type of data?
	gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);

	if (width !== this.width || height !== this.height) {
		gl.texImage2D(gl.TEXTURE_2D, 0, this.format, width, height, 0, this.format, this.type, data || null);
	} else {
		gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, this.format, this.type, data || null);
	}

	this.width = width;
	this.height = height;

	//	texSubImage2D
};

/**
 * Binds the texture
 * @param  location
 */
Texture.prototype.bind = function (location) {
	var gl = this.gl;

	if (location !== undefined) {
		gl.activeTexture(gl.TEXTURE0 + location);
	}

	gl.bindTexture(gl.TEXTURE_2D, this.texture);
};

/**
 * Unbinds the texture
 */
Texture.prototype.unbind = function () {
	var gl = this.gl;
	gl.bindTexture(gl.TEXTURE_2D, null);
};

/**
 * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
 */
Texture.prototype.minFilter = function (linear) {
	var gl = this.gl;

	this.bind();

	if (this.mipmap) {
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
	} else {
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR : gl.NEAREST);
	}
};

/**
 * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
 */
Texture.prototype.magFilter = function (linear) {
	var gl = this.gl;

	this.bind();

	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, linear ? gl.LINEAR : gl.NEAREST);
};

/**
 * Enables mipmapping
 */
Texture.prototype.enableMipmap = function () {
	var gl = this.gl;

	this.bind();

	this.mipmap = true;

	gl.generateMipmap(gl.TEXTURE_2D);
};

/**
 * Enables linear filtering
 */
Texture.prototype.enableLinearScaling = function () {
	this.minFilter(true);
	this.magFilter(true);
};

/**
 * Enables nearest neighbour interpolation
 */
Texture.prototype.enableNearestScaling = function () {
	this.minFilter(false);
	this.magFilter(false);
};

/**
 * Enables clamping on the texture so WebGL will not repeat it
 */
Texture.prototype.enableWrapClamp = function () {
	var gl = this.gl;

	this.bind();

	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
};

/**
 * Enable tiling on the texture
 */
Texture.prototype.enableWrapRepeat = function () {
	var gl = this.gl;

	this.bind();

	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
};

Texture.prototype.enableWrapMirrorRepeat = function () {
	var gl = this.gl;

	this.bind();

	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.MIRRORED_REPEAT);
	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
};

/**
 * Destroys this texture
 */
Texture.prototype.destroy = function () {
	var gl = this.gl;
	//TODO
	gl.deleteTexture(this.texture);
};

/**
 * @static
 * @param gl {WebGLRenderingContext} The current WebGL context
 * @param source {HTMLImageElement|ImageData} the source image of the texture
 * @param premultiplyAlpha {Boolean} If we want to use pre-multiplied alpha
 */
Texture.fromSource = function (gl, source, premultiplyAlpha) {
	var texture = new Texture(gl);
	texture.premultiplyAlpha = premultiplyAlpha || false;
	texture.upload(source);

	return texture;
};

/**
 * @static
 * @param gl {WebGLRenderingContext} The current WebGL context
 * @param data {TypedArray} the data to upload to the texture
 * @param width {number} the new width of the texture
 * @param height {number} the new height of the texture
 */
Texture.fromData = function (gl, data, width, height) {
	//console.log(data, width, height);
	var texture = new Texture(gl);
	texture.uploadData(data, width, height);

	return texture;
};

module.exports = Texture;

/***/ }),

/***/ "l7H0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _accessibleTarget = __webpack_require__("2kJT");

Object.defineProperty(exports, 'accessibleTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_accessibleTarget).default;
  }
});

var _AccessibilityManager = __webpack_require__("lTmO");

Object.defineProperty(exports, 'AccessibilityManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AccessibilityManager).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "l9ls":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ead97df5434ca97abc932f92e12eab6e.svg";

/***/ }),

/***/ "lFUL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _FXAAFilter = __webpack_require__("106G");

Object.defineProperty(exports, 'FXAAFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FXAAFilter).default;
  }
});

var _NoiseFilter = __webpack_require__("qmQd");

Object.defineProperty(exports, 'NoiseFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NoiseFilter).default;
  }
});

var _DisplacementFilter = __webpack_require__("fRpE");

Object.defineProperty(exports, 'DisplacementFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DisplacementFilter).default;
  }
});

var _BlurFilter = __webpack_require__("//1e");

Object.defineProperty(exports, 'BlurFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlurFilter).default;
  }
});

var _BlurXFilter = __webpack_require__("Zx84");

Object.defineProperty(exports, 'BlurXFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlurXFilter).default;
  }
});

var _BlurYFilter = __webpack_require__("KYHG");

Object.defineProperty(exports, 'BlurYFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlurYFilter).default;
  }
});

var _ColorMatrixFilter = __webpack_require__("fxiT");

Object.defineProperty(exports, 'ColorMatrixFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorMatrixFilter).default;
  }
});

var _AlphaFilter = __webpack_require__("GkT9");

Object.defineProperty(exports, 'AlphaFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlphaFilter).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "lJl4":
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) {
  return a !== a;
};

module.exports = Number.isFinite || function (x) {
  return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity;
};

/***/ }),

/***/ "lLGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

/* harmony default export */ __webpack_exports__["a"] = (isHotReloading);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("pv+l")(module)))

/***/ }),

/***/ "lLHp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f345cdbd56081497649066ed3222880e.svg";

/***/ }),

/***/ "lQAb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ObjectRenderer2 = __webpack_require__("oXPp");

var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);

var _WebGLRenderer = __webpack_require__("i77b");

var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

var _createIndicesForQuads = __webpack_require__("DI0o");

var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);

var _generateMultiTextureShader = __webpack_require__("fst5");

var _generateMultiTextureShader2 = _interopRequireDefault(_generateMultiTextureShader);

var _checkMaxIfStatmentsInShader = __webpack_require__("GkaI");

var _checkMaxIfStatmentsInShader2 = _interopRequireDefault(_checkMaxIfStatmentsInShader);

var _BatchBuffer = __webpack_require__("llp6");

var _BatchBuffer2 = _interopRequireDefault(_BatchBuffer);

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

var _utils = __webpack_require__("dDI1");

var _pixiGlCore = __webpack_require__("PJsv");

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

var _bitTwiddle = __webpack_require__("gXRl");

var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TICK = 0;
var TEXTURE_TICK = 0;

/**
 * Renderer dedicated to drawing and batching sprites.
 *
 * @class
 * @private
 * @memberof PIXI
 * @extends PIXI.ObjectRenderer
 */

var SpriteRenderer = function (_ObjectRenderer) {
    _inherits(SpriteRenderer, _ObjectRenderer);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
     */
    function SpriteRenderer(renderer) {
        _classCallCheck(this, SpriteRenderer);

        /**
         * Number of values sent in the vertex buffer.
         * aVertexPosition(2), aTextureCoord(1), aColor(1), aTextureId(1) = 5
         *
         * @member {number}
         */
        var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));

        _this.vertSize = 5;

        /**
         * The size of the vertex information in bytes.
         *
         * @member {number}
         */
        _this.vertByteSize = _this.vertSize * 4;

        /**
         * The number of images in the SpriteRenderer before it flushes.
         *
         * @member {number}
         */
        _this.size = _settings2.default.SPRITE_BATCH_SIZE; // 2000 is a nice balance between mobile / desktop

        // the total number of bytes in our batch
        // let numVerts = this.size * 4 * this.vertByteSize;

        _this.buffers = [];
        for (var i = 1; i <= _bitTwiddle2.default.nextPow2(_this.size); i *= 2) {
            _this.buffers.push(new _BatchBuffer2.default(i * 4 * _this.vertByteSize));
        }

        /**
         * Holds the indices of the geometry (quads) to draw
         *
         * @member {Uint16Array}
         */
        _this.indices = (0, _createIndicesForQuads2.default)(_this.size);

        /**
         * The default shaders that is used if a sprite doesn't have a more specific one.
         * there is a shader for each number of textures that can be rendererd.
         * These shaders will also be generated on the fly as required.
         * @member {PIXI.Shader[]}
         */
        _this.shader = null;

        _this.currentIndex = 0;
        _this.groups = [];

        for (var k = 0; k < _this.size; k++) {
            _this.groups[k] = { textures: [], textureCount: 0, ids: [], size: 0, start: 0, blend: 0 };
        }

        _this.sprites = [];

        _this.vertexBuffers = [];
        _this.vaos = [];

        _this.vaoMax = 2;
        _this.vertexCount = 0;

        _this.renderer.on('prerender', _this.onPrerender, _this);
        return _this;
    }

    /**
     * Sets up the renderer context and necessary buffers.
     *
     * @private
     */

    SpriteRenderer.prototype.onContextChange = function onContextChange() {
        var gl = this.renderer.gl;

        if (this.renderer.legacy) {
            this.MAX_TEXTURES = 1;
        } else {
            // step 1: first check max textures the GPU can handle.
            this.MAX_TEXTURES = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), _settings2.default.SPRITE_MAX_TEXTURES);

            // step 2: check the maximum number of if statements the shader can have too..
            this.MAX_TEXTURES = (0, _checkMaxIfStatmentsInShader2.default)(this.MAX_TEXTURES, gl);
        }

        this.shader = (0, _generateMultiTextureShader2.default)(gl, this.MAX_TEXTURES);

        // create a couple of buffers
        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);

        // we use the second shader as the first one depending on your browser may omit aTextureId
        // as it is not used by the shader so is optimized out.

        this.renderer.bindVao(null);

        var attrs = this.shader.attributes;

        for (var i = 0; i < this.vaoMax; i++) {
            /* eslint-disable max-len */
            var vertexBuffer = this.vertexBuffers[i] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
            /* eslint-enable max-len */

            // build the vao object that will render..
            var vao = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(vertexBuffer, attrs.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(vertexBuffer, attrs.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(vertexBuffer, attrs.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);

            if (attrs.aTextureId) {
                vao.addAttribute(vertexBuffer, attrs.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
            }

            this.vaos[i] = vao;
        }

        this.vao = this.vaos[0];
        this.currentBlendMode = 99999;

        this.boundTextures = new Array(this.MAX_TEXTURES);
    };

    /**
     * Called before the renderer starts rendering.
     *
     */

    SpriteRenderer.prototype.onPrerender = function onPrerender() {
        this.vertexCount = 0;
    };

    /**
     * Renders the sprite object.
     *
     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
     */

    SpriteRenderer.prototype.render = function render(sprite) {
        // TODO set blend modes..
        // check texture..
        if (this.currentIndex >= this.size) {
            this.flush();
        }

        // get the uvs for the texture

        // if the uvs have not updated then no point rendering just yet!
        if (!sprite._texture._uvs) {
            return;
        }

        // push a texture.
        // increment the batchsize
        this.sprites[this.currentIndex++] = sprite;
    };

    /**
     * Renders the content and empties the current batch.
     *
     */

    SpriteRenderer.prototype.flush = function flush() {
        if (this.currentIndex === 0) {
            return;
        }

        var gl = this.renderer.gl;
        var MAX_TEXTURES = this.MAX_TEXTURES;

        var np2 = _bitTwiddle2.default.nextPow2(this.currentIndex);
        var log2 = _bitTwiddle2.default.log2(np2);
        var buffer = this.buffers[log2];

        var sprites = this.sprites;
        var groups = this.groups;

        var float32View = buffer.float32View;
        var uint32View = buffer.uint32View;

        var boundTextures = this.boundTextures;
        var rendererBoundTextures = this.renderer.boundTextures;
        var touch = this.renderer.textureGC.count;

        var index = 0;
        var nextTexture = void 0;
        var currentTexture = void 0;
        var groupCount = 1;
        var textureCount = 0;
        var currentGroup = groups[0];
        var vertexData = void 0;
        var uvs = void 0;
        var blendMode = _utils.premultiplyBlendMode[sprites[0]._texture.baseTexture.premultipliedAlpha ? 1 : 0][sprites[0].blendMode];

        currentGroup.textureCount = 0;
        currentGroup.start = 0;
        currentGroup.blend = blendMode;

        TICK++;

        var i = void 0;

        // copy textures..
        for (i = 0; i < MAX_TEXTURES; ++i) {
            var bt = rendererBoundTextures[i];

            if (bt._enabled === TICK) {
                boundTextures[i] = this.renderer.emptyTextures[i];
                continue;
            }

            boundTextures[i] = bt;
            bt._virtalBoundId = i;
            bt._enabled = TICK;
        }
        TICK++;

        for (i = 0; i < this.currentIndex; ++i) {
            // upload the sprite elemetns...
            // they have all ready been calculated so we just need to push them into the buffer.
            var sprite = sprites[i];

            sprites[i] = null;

            nextTexture = sprite._texture.baseTexture;

            var spriteBlendMode = _utils.premultiplyBlendMode[Number(nextTexture.premultipliedAlpha)][sprite.blendMode];

            if (blendMode !== spriteBlendMode) {
                // finish a group..
                blendMode = spriteBlendMode;

                // force the batch to break!
                currentTexture = null;
                textureCount = MAX_TEXTURES;
                TICK++;
            }

            if (currentTexture !== nextTexture) {
                currentTexture = nextTexture;

                if (nextTexture._enabled !== TICK) {
                    if (textureCount === MAX_TEXTURES) {
                        TICK++;

                        currentGroup.size = i - currentGroup.start;

                        textureCount = 0;

                        currentGroup = groups[groupCount++];
                        currentGroup.blend = blendMode;
                        currentGroup.textureCount = 0;
                        currentGroup.start = i;
                    }

                    nextTexture.touched = touch;

                    if (nextTexture._virtalBoundId === -1) {
                        for (var j = 0; j < MAX_TEXTURES; ++j) {
                            var tIndex = (j + TEXTURE_TICK) % MAX_TEXTURES;

                            var t = boundTextures[tIndex];

                            if (t._enabled !== TICK) {
                                TEXTURE_TICK++;

                                t._virtalBoundId = -1;

                                nextTexture._virtalBoundId = tIndex;

                                boundTextures[tIndex] = nextTexture;
                                break;
                            }
                        }
                    }

                    nextTexture._enabled = TICK;

                    currentGroup.textureCount++;
                    currentGroup.ids[textureCount] = nextTexture._virtalBoundId;
                    currentGroup.textures[textureCount++] = nextTexture;
                }
            }

            vertexData = sprite.vertexData;

            // TODO this sum does not need to be set each frame..
            uvs = sprite._texture._uvs.uvsUint32;

            if (this.renderer.roundPixels) {
                var resolution = this.renderer.resolution;

                // xy
                float32View[index] = (vertexData[0] * resolution | 0) / resolution;
                float32View[index + 1] = (vertexData[1] * resolution | 0) / resolution;

                // xy
                float32View[index + 5] = (vertexData[2] * resolution | 0) / resolution;
                float32View[index + 6] = (vertexData[3] * resolution | 0) / resolution;

                // xy
                float32View[index + 10] = (vertexData[4] * resolution | 0) / resolution;
                float32View[index + 11] = (vertexData[5] * resolution | 0) / resolution;

                // xy
                float32View[index + 15] = (vertexData[6] * resolution | 0) / resolution;
                float32View[index + 16] = (vertexData[7] * resolution | 0) / resolution;
            } else {
                // xy
                float32View[index] = vertexData[0];
                float32View[index + 1] = vertexData[1];

                // xy
                float32View[index + 5] = vertexData[2];
                float32View[index + 6] = vertexData[3];

                // xy
                float32View[index + 10] = vertexData[4];
                float32View[index + 11] = vertexData[5];

                // xy
                float32View[index + 15] = vertexData[6];
                float32View[index + 16] = vertexData[7];
            }

            uint32View[index + 2] = uvs[0];
            uint32View[index + 7] = uvs[1];
            uint32View[index + 12] = uvs[2];
            uint32View[index + 17] = uvs[3];
            /* eslint-disable max-len */
            var alpha = Math.min(sprite.worldAlpha, 1.0);
            // we dont call extra function if alpha is 1.0, that's faster
            var argb = alpha < 1.0 && nextTexture.premultipliedAlpha ? (0, _utils.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);

            uint32View[index + 3] = uint32View[index + 8] = uint32View[index + 13] = uint32View[index + 18] = argb;
            float32View[index + 4] = float32View[index + 9] = float32View[index + 14] = float32View[index + 19] = nextTexture._virtalBoundId;
            /* eslint-enable max-len */

            index += 20;
        }

        currentGroup.size = i - currentGroup.start;

        if (!_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
            // this is still needed for IOS performance..
            // it really does not like uploading to the same buffer in a single frame!
            if (this.vaoMax <= this.vertexCount) {
                this.vaoMax++;

                var attrs = this.shader.attributes;

                /* eslint-disable max-len */
                var vertexBuffer = this.vertexBuffers[this.vertexCount] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
                /* eslint-enable max-len */

                // build the vao object that will render..
                var vao = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(vertexBuffer, attrs.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(vertexBuffer, attrs.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(vertexBuffer, attrs.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);

                if (attrs.aTextureId) {
                    vao.addAttribute(vertexBuffer, attrs.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
                }

                this.vaos[this.vertexCount] = vao;
            }

            this.renderer.bindVao(this.vaos[this.vertexCount]);

            this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, false);

            this.vertexCount++;
        } else {
            // lets use the faster option, always use buffer number 0
            this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, true);
        }

        for (i = 0; i < MAX_TEXTURES; ++i) {
            rendererBoundTextures[i]._virtalBoundId = -1;
        }

        // render the groups..
        for (i = 0; i < groupCount; ++i) {
            var group = groups[i];
            var groupTextureCount = group.textureCount;

            for (var _j = 0; _j < groupTextureCount; _j++) {
                currentTexture = group.textures[_j];

                // reset virtual ids..
                // lets do a quick check..
                if (rendererBoundTextures[group.ids[_j]] !== currentTexture) {
                    this.renderer.bindTexture(currentTexture, group.ids[_j], true);
                }

                // reset the virtualId..
                currentTexture._virtalBoundId = -1;
            }

            // set the blend mode..
            this.renderer.state.setBlendMode(group.blend);

            gl.drawElements(gl.TRIANGLES, group.size * 6, gl.UNSIGNED_SHORT, group.start * 6 * 2);
        }

        // reset elements for the next flush
        this.currentIndex = 0;
    };

    /**
     * Starts a new sprite batch.
     */

    SpriteRenderer.prototype.start = function start() {
        this.renderer.bindShader(this.shader);

        if (_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
            // bind buffer #0, we don't need others
            this.renderer.bindVao(this.vaos[this.vertexCount]);

            this.vertexBuffers[this.vertexCount].bind();
        }
    };

    /**
     * Stops and flushes the current batch.
     *
     */

    SpriteRenderer.prototype.stop = function stop() {
        this.flush();
    };

    /**
     * Destroys the SpriteRenderer.
     *
     */

    SpriteRenderer.prototype.destroy = function destroy() {
        for (var i = 0; i < this.vaoMax; i++) {
            if (this.vertexBuffers[i]) {
                this.vertexBuffers[i].destroy();
            }
            if (this.vaos[i]) {
                this.vaos[i].destroy();
            }
        }

        if (this.indexBuffer) {
            this.indexBuffer.destroy();
        }

        this.renderer.off('prerender', this.onPrerender, this);

        _ObjectRenderer.prototype.destroy.call(this);

        if (this.shader) {
            this.shader.destroy();
            this.shader = null;
        }

        this.vertexBuffers = null;
        this.vaos = null;
        this.indexBuffer = null;
        this.indices = null;

        this.sprites = null;

        for (var _i = 0; _i < this.buffers.length; ++_i) {
            this.buffers[_i].destroy();
        }
    };

    return SpriteRenderer;
}(_ObjectRenderer3.default);

exports.default = SpriteRenderer;

_WebGLRenderer2.default.registerPlugin('sprite', SpriteRenderer);
//# sourceMappingURL=SpriteRenderer.js.map

/***/ }),

/***/ "lTmO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _ismobilejs = __webpack_require__("nSZq");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

var _accessibleTarget = __webpack_require__("2kJT");

var _accessibleTarget2 = _interopRequireDefault(_accessibleTarget);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

// add some extra variables to the container..
core.utils.mixins.delayMixin(core.DisplayObject.prototype, _accessibleTarget2.default);

var KEY_CODE_TAB = 9;

var DIV_TOUCH_SIZE = 100;
var DIV_TOUCH_POS_X = 0;
var DIV_TOUCH_POS_Y = 0;
var DIV_TOUCH_ZINDEX = 2;

var DIV_HOOK_SIZE = 1;
var DIV_HOOK_POS_X = -1000;
var DIV_HOOK_POS_Y = -1000;
var DIV_HOOK_ZINDEX = 2;

/**
 * The Accessibility manager recreates the ability to tab and have content read by screen
 * readers. This is very important as it can possibly help people with disabilities access pixi
 * content.
 *
 * Much like interaction any DisplayObject can be made accessible. This manager will map the
 * events as if the mouse was being used, minimizing the effort required to implement.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.accessibility
 *
 * @class
 * @memberof PIXI.accessibility
 */

var AccessibilityManager = function () {
    /**
     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
     */
    function AccessibilityManager(renderer) {
        _classCallCheck(this, AccessibilityManager);

        if ((_ismobilejs2.default.tablet || _ismobilejs2.default.phone) && !navigator.isCocoonJS) {
            this.createTouchHook();
        }

        // first we create a div that will sit over the PixiJS element. This is where the div overlays will go.
        var div = document.createElement('div');

        div.style.width = DIV_TOUCH_SIZE + 'px';
        div.style.height = DIV_TOUCH_SIZE + 'px';
        div.style.position = 'absolute';
        div.style.top = DIV_TOUCH_POS_X + 'px';
        div.style.left = DIV_TOUCH_POS_Y + 'px';
        div.style.zIndex = DIV_TOUCH_ZINDEX;

        /**
         * This is the dom element that will sit over the PixiJS element. This is where the div overlays will go.
         *
         * @type {HTMLElement}
         * @private
         */
        this.div = div;

        /**
         * A simple pool for storing divs.
         *
         * @type {*}
         * @private
         */
        this.pool = [];

        /**
         * This is a tick used to check if an object is no longer being rendered.
         *
         * @type {Number}
         * @private
         */
        this.renderId = 0;

        /**
         * Setting this to true will visually show the divs.
         *
         * @type {boolean}
         */
        this.debug = false;

        /**
         * The renderer this accessibility manager works for.
         *
         * @member {PIXI.SystemRenderer}
         */
        this.renderer = renderer;

        /**
         * The array of currently active accessible items.
         *
         * @member {Array<*>}
         * @private
         */
        this.children = [];

        /**
         * pre-bind the functions
         *
         * @private
         */
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onMouseMove = this._onMouseMove.bind(this);

        /**
         * stores the state of the manager. If there are no accessible objects or the mouse is moving, this will be false.
         *
         * @member {Array<*>}
         * @private
         */
        this.isActive = false;
        this.isMobileAccessabillity = false;

        // let listen for tab.. once pressed we can fire up and show the accessibility layer
        window.addEventListener('keydown', this._onKeyDown, false);
    }

    /**
     * Creates the touch hooks.
     *
     */

    AccessibilityManager.prototype.createTouchHook = function createTouchHook() {
        var _this = this;

        var hookDiv = document.createElement('button');

        hookDiv.style.width = DIV_HOOK_SIZE + 'px';
        hookDiv.style.height = DIV_HOOK_SIZE + 'px';
        hookDiv.style.position = 'absolute';
        hookDiv.style.top = DIV_HOOK_POS_X + 'px';
        hookDiv.style.left = DIV_HOOK_POS_Y + 'px';
        hookDiv.style.zIndex = DIV_HOOK_ZINDEX;
        hookDiv.style.backgroundColor = '#FF0000';
        hookDiv.title = 'HOOK DIV';

        hookDiv.addEventListener('focus', function () {
            _this.isMobileAccessabillity = true;
            _this.activate();
            document.body.removeChild(hookDiv);
        });

        document.body.appendChild(hookDiv);
    };

    /**
     * Activating will cause the Accessibility layer to be shown. This is called when a user
     * preses the tab key.
     *
     * @private
     */

    AccessibilityManager.prototype.activate = function activate() {
        if (this.isActive) {
            return;
        }

        this.isActive = true;

        window.document.addEventListener('mousemove', this._onMouseMove, true);
        window.removeEventListener('keydown', this._onKeyDown, false);

        this.renderer.on('postrender', this.update, this);

        if (this.renderer.view.parentNode) {
            this.renderer.view.parentNode.appendChild(this.div);
        }
    };

    /**
     * Deactivating will cause the Accessibility layer to be hidden. This is called when a user moves
     * the mouse.
     *
     * @private
     */

    AccessibilityManager.prototype.deactivate = function deactivate() {
        if (!this.isActive || this.isMobileAccessabillity) {
            return;
        }

        this.isActive = false;

        window.document.removeEventListener('mousemove', this._onMouseMove, true);
        window.addEventListener('keydown', this._onKeyDown, false);

        this.renderer.off('postrender', this.update);

        if (this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
        }
    };

    /**
     * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
     *
     * @private
     * @param {PIXI.Container} displayObject - The DisplayObject to check.
     */

    AccessibilityManager.prototype.updateAccessibleObjects = function updateAccessibleObjects(displayObject) {
        if (!displayObject.visible) {
            return;
        }

        if (displayObject.accessible && displayObject.interactive) {
            if (!displayObject._accessibleActive) {
                this.addChild(displayObject);
            }

            displayObject.renderId = this.renderId;
        }

        var children = displayObject.children;

        for (var i = 0; i < children.length; i++) {
            this.updateAccessibleObjects(children[i]);
        }
    };

    /**
     * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
     *
     * @private
     */

    AccessibilityManager.prototype.update = function update() {
        if (!this.renderer.renderingToScreen) {
            return;
        }

        // update children...
        this.updateAccessibleObjects(this.renderer._lastObjectRendered);

        var rect = this.renderer.view.getBoundingClientRect();
        var sx = rect.width / this.renderer.width;
        var sy = rect.height / this.renderer.height;

        var div = this.div;

        div.style.left = rect.left + 'px';
        div.style.top = rect.top + 'px';
        div.style.width = this.renderer.width + 'px';
        div.style.height = this.renderer.height + 'px';

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];

            if (child.renderId !== this.renderId) {
                child._accessibleActive = false;

                core.utils.removeItems(this.children, i, 1);
                this.div.removeChild(child._accessibleDiv);
                this.pool.push(child._accessibleDiv);
                child._accessibleDiv = null;

                i--;

                if (this.children.length === 0) {
                    this.deactivate();
                }
            } else {
                // map div to display..
                div = child._accessibleDiv;
                var hitArea = child.hitArea;
                var wt = child.worldTransform;

                if (child.hitArea) {
                    div.style.left = (wt.tx + hitArea.x * wt.a) * sx + 'px';
                    div.style.top = (wt.ty + hitArea.y * wt.d) * sy + 'px';

                    div.style.width = hitArea.width * wt.a * sx + 'px';
                    div.style.height = hitArea.height * wt.d * sy + 'px';
                } else {
                    hitArea = child.getBounds();

                    this.capHitArea(hitArea);

                    div.style.left = hitArea.x * sx + 'px';
                    div.style.top = hitArea.y * sy + 'px';

                    div.style.width = hitArea.width * sx + 'px';
                    div.style.height = hitArea.height * sy + 'px';

                    // update button titles and hints if they exist and they've changed
                    if (div.title !== child.accessibleTitle && child.accessibleTitle !== null) {
                        div.title = child.accessibleTitle;
                    }
                    if (div.getAttribute('aria-label') !== child.accessibleHint && child.accessibleHint !== null) {
                        div.setAttribute('aria-label', child.accessibleHint);
                    }
                }
            }
        }

        // increment the render id..
        this.renderId++;
    };

    /**
     * TODO: docs.
     *
     * @param {Rectangle} hitArea - TODO docs
     */

    AccessibilityManager.prototype.capHitArea = function capHitArea(hitArea) {
        if (hitArea.x < 0) {
            hitArea.width += hitArea.x;
            hitArea.x = 0;
        }

        if (hitArea.y < 0) {
            hitArea.height += hitArea.y;
            hitArea.y = 0;
        }

        if (hitArea.x + hitArea.width > this.renderer.width) {
            hitArea.width = this.renderer.width - hitArea.x;
        }

        if (hitArea.y + hitArea.height > this.renderer.height) {
            hitArea.height = this.renderer.height - hitArea.y;
        }
    };

    /**
     * Adds a DisplayObject to the accessibility manager
     *
     * @private
     * @param {DisplayObject} displayObject - The child to make accessible.
     */

    AccessibilityManager.prototype.addChild = function addChild(displayObject) {
        //    this.activate();

        var div = this.pool.pop();

        if (!div) {
            div = document.createElement('button');

            div.style.width = DIV_TOUCH_SIZE + 'px';
            div.style.height = DIV_TOUCH_SIZE + 'px';
            div.style.backgroundColor = this.debug ? 'rgba(255,0,0,0.5)' : 'transparent';
            div.style.position = 'absolute';
            div.style.zIndex = DIV_TOUCH_ZINDEX;
            div.style.borderStyle = 'none';

            // ARIA attributes ensure that button title and hint updates are announced properly
            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
                // Chrome doesn't need aria-live to work as intended; in fact it just gets more confused.
                div.setAttribute('aria-live', 'off');
            } else {
                div.setAttribute('aria-live', 'polite');
            }

            if (navigator.userAgent.match(/rv:.*Gecko\//)) {
                // FireFox needs this to announce only the new button name
                div.setAttribute('aria-relevant', 'additions');
            } else {
                // required by IE, other browsers don't much care
                div.setAttribute('aria-relevant', 'text');
            }

            div.addEventListener('click', this._onClick.bind(this));
            div.addEventListener('focus', this._onFocus.bind(this));
            div.addEventListener('focusout', this._onFocusOut.bind(this));
        }

        if (displayObject.accessibleTitle && displayObject.accessibleTitle !== null) {
            div.title = displayObject.accessibleTitle;
        } else if (!displayObject.accessibleHint || displayObject.accessibleHint === null) {
            div.title = 'displayObject ' + displayObject.tabIndex;
        }

        if (displayObject.accessibleHint && displayObject.accessibleHint !== null) {
            div.setAttribute('aria-label', displayObject.accessibleHint);
        }

        //

        displayObject._accessibleActive = true;
        displayObject._accessibleDiv = div;
        div.displayObject = displayObject;

        this.children.push(displayObject);
        this.div.appendChild(displayObject._accessibleDiv);
        displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
    };

    /**
     * Maps the div button press to pixi's InteractionManager (click)
     *
     * @private
     * @param {MouseEvent} e - The click event.
     */

    AccessibilityManager.prototype._onClick = function _onClick(e) {
        var interactionManager = this.renderer.plugins.interaction;

        interactionManager.dispatchEvent(e.target.displayObject, 'click', interactionManager.eventData);
    };

    /**
     * Maps the div focus events to pixi's InteractionManager (mouseover)
     *
     * @private
     * @param {FocusEvent} e - The focus event.
     */

    AccessibilityManager.prototype._onFocus = function _onFocus(e) {
        if (!e.target.getAttribute('aria-live', 'off')) {
            e.target.setAttribute('aria-live', 'assertive');
        }
        var interactionManager = this.renderer.plugins.interaction;

        interactionManager.dispatchEvent(e.target.displayObject, 'mouseover', interactionManager.eventData);
    };

    /**
     * Maps the div focus events to pixi's InteractionManager (mouseout)
     *
     * @private
     * @param {FocusEvent} e - The focusout event.
     */

    AccessibilityManager.prototype._onFocusOut = function _onFocusOut(e) {
        if (!e.target.getAttribute('aria-live', 'off')) {
            e.target.setAttribute('aria-live', 'polite');
        }
        var interactionManager = this.renderer.plugins.interaction;

        interactionManager.dispatchEvent(e.target.displayObject, 'mouseout', interactionManager.eventData);
    };

    /**
     * Is called when a key is pressed
     *
     * @private
     * @param {KeyboardEvent} e - The keydown event.
     */

    AccessibilityManager.prototype._onKeyDown = function _onKeyDown(e) {
        if (e.keyCode !== KEY_CODE_TAB) {
            return;
        }

        this.activate();
    };

    /**
     * Is called when the mouse moves across the renderer element
     *
     * @private
     * @param {MouseEvent} e - The mouse event.
     */

    AccessibilityManager.prototype._onMouseMove = function _onMouseMove(e) {
        if (e.movementX === 0 && e.movementY === 0) {
            return;
        }

        this.deactivate();
    };

    /**
     * Destroys the accessibility manager
     *
     */

    AccessibilityManager.prototype.destroy = function destroy() {
        this.div = null;

        for (var i = 0; i < this.children.length; i++) {
            this.children[i].div = null;
        }

        window.document.removeEventListener('mousemove', this._onMouseMove, true);
        window.removeEventListener('keydown', this._onKeyDown);

        this.pool = null;
        this.children = null;
        this.renderer = null;
    };

    return AccessibilityManager;
}();

exports.default = AccessibilityManager;

core.WebGLRenderer.registerPlugin('accessibility', AccessibilityManager);
core.CanvasRenderer.registerPlugin('accessibility', AccessibilityManager);
//# sourceMappingURL=AccessibilityManager.js.map

/***/ }),

/***/ "lVSe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _BasePrepare2 = __webpack_require__("NEc+");

var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CANVAS_START_SIZE = 16;

/**
 * The prepare manager provides functionality to upload content to the GPU
 * This cannot be done directly for Canvas like in WebGL, but the effect can be achieved by drawing
 * textures to an offline canvas.
 * This draw call will force the texture to be moved onto the GPU.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
 *
 * @class
 * @extends PIXI.prepare.BasePrepare
 * @memberof PIXI.prepare
 */

var CanvasPrepare = function (_BasePrepare) {
    _inherits(CanvasPrepare, _BasePrepare);

    /**
     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
     */
    function CanvasPrepare(renderer) {
        _classCallCheck(this, CanvasPrepare);

        var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));

        _this.uploadHookHelper = _this;

        /**
        * An offline canvas to render textures to
        * @type {HTMLCanvasElement}
        * @private
        */
        _this.canvas = document.createElement('canvas');
        _this.canvas.width = CANVAS_START_SIZE;
        _this.canvas.height = CANVAS_START_SIZE;

        /**
         * The context to the canvas
        * @type {CanvasRenderingContext2D}
        * @private
        */
        _this.ctx = _this.canvas.getContext('2d');

        // Add textures to upload
        _this.registerUploadHook(uploadBaseTextures);
        return _this;
    }

    /**
     * Destroys the plugin, don't use after this.
     *
     */

    CanvasPrepare.prototype.destroy = function destroy() {
        _BasePrepare.prototype.destroy.call(this);
        this.ctx = null;
        this.canvas = null;
    };

    return CanvasPrepare;
}(_BasePrepare3.default);

/**
 * Built-in hook to upload PIXI.Texture objects to the GPU.
 *
 * @private
 * @param {*} prepare - Instance of CanvasPrepare
 * @param {*} item - Item to check
 * @return {boolean} If item was uploaded.
 */

exports.default = CanvasPrepare;
function uploadBaseTextures(prepare, item) {
    if (item instanceof core.BaseTexture) {
        var image = item.source;

        // Sometimes images (like atlas images) report a size of zero, causing errors on windows phone.
        // So if the width or height is equal to zero then use the canvas size
        // Otherwise use whatever is smaller, the image dimensions or the canvas dimensions.
        var imageWidth = image.width === 0 ? prepare.canvas.width : Math.min(prepare.canvas.width, image.width);
        var imageHeight = image.height === 0 ? prepare.canvas.height : Math.min(prepare.canvas.height, image.height);

        // Only a small subsections is required to be drawn to have the whole texture uploaded to the GPU
        // A smaller draw can be faster.
        prepare.ctx.drawImage(image, 0, 0, imageWidth, imageHeight, 0, 0, prepare.canvas.width, prepare.canvas.height);

        return true;
    }

    return false;
}

core.CanvasRenderer.registerPlugin('prepare', CanvasPrepare);
//# sourceMappingURL=CanvasPrepare.js.map

/***/ }),

/***/ "laVK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _BasePrepare2 = __webpack_require__("NEc+");

var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The prepare manager provides functionality to upload content to the GPU.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
 *
 * @class
 * @extends PIXI.prepare.BasePrepare
 * @memberof PIXI.prepare
 */
var WebGLPrepare = function (_BasePrepare) {
    _inherits(WebGLPrepare, _BasePrepare);

    /**
     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
     */
    function WebGLPrepare(renderer) {
        _classCallCheck(this, WebGLPrepare);

        var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));

        _this.uploadHookHelper = _this.renderer;

        // Add textures and graphics to upload
        _this.registerFindHook(findGraphics);
        _this.registerUploadHook(uploadBaseTextures);
        _this.registerUploadHook(uploadGraphics);
        return _this;
    }

    return WebGLPrepare;
}(_BasePrepare3.default);
/**
 * Built-in hook to upload PIXI.Texture objects to the GPU.
 *
 * @private
 * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
 * @param {PIXI.DisplayObject} item - Item to check
 * @return {boolean} If item was uploaded.
 */

exports.default = WebGLPrepare;
function uploadBaseTextures(renderer, item) {
    if (item instanceof core.BaseTexture) {
        // if the texture already has a GL texture, then the texture has been prepared or rendered
        // before now. If the texture changed, then the changer should be calling texture.update() which
        // reuploads the texture without need for preparing it again
        if (!item._glTextures[renderer.CONTEXT_UID]) {
            renderer.textureManager.updateTexture(item);
        }

        return true;
    }

    return false;
}

/**
 * Built-in hook to upload PIXI.Graphics to the GPU.
 *
 * @private
 * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
 * @param {PIXI.DisplayObject} item - Item to check
 * @return {boolean} If item was uploaded.
 */
function uploadGraphics(renderer, item) {
    if (item instanceof core.Graphics) {
        // if the item is not dirty and already has webgl data, then it got prepared or rendered
        // before now and we shouldn't waste time updating it again
        if (item.dirty || item.clearDirty || !item._webGL[renderer.plugins.graphics.CONTEXT_UID]) {
            renderer.plugins.graphics.updateGraphics(item);
        }

        return true;
    }

    return false;
}

/**
 * Built-in hook to find graphics.
 *
 * @private
 * @param {PIXI.DisplayObject} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.Graphics object was found.
 */
function findGraphics(item, queue) {
    if (item instanceof core.Graphics) {
        queue.push(item);

        return true;
    }

    return false;
}

core.WebGLRenderer.registerPlugin('prepare', WebGLPrepare);
//# sourceMappingURL=WebGLPrepare.js.map

/***/ }),

/***/ "ldGe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3610935577098a10b62a93f54e49446f.svg";

/***/ }),

/***/ "llp6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * @class
 * @memberof PIXI
 */
var Buffer = function () {
  /**
   * @param {number} size - The size of the buffer in bytes.
   */
  function Buffer(size) {
    _classCallCheck(this, Buffer);

    this.vertices = new ArrayBuffer(size);

    /**
     * View on the vertices as a Float32Array for positions
     *
     * @member {Float32Array}
     */
    this.float32View = new Float32Array(this.vertices);

    /**
     * View on the vertices as a Uint32Array for uvs
     *
     * @member {Float32Array}
     */
    this.uint32View = new Uint32Array(this.vertices);
  }

  /**
   * Destroys the buffer.
   *
   */

  Buffer.prototype.destroy = function destroy() {
    this.vertices = null;
    this.positions = null;
    this.uvs = null;
    this.colors = null;
  };

  return Buffer;
}();

exports.default = Buffer;
//# sourceMappingURL=BatchBuffer.js.map

/***/ }),

/***/ "loE9":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("YYLF")();
}

/***/ }),

/***/ "lp9P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _objectAssign = __webpack_require__("J4Nk");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

if (!Object.assign) {
    Object.assign = _objectAssign2.default;
} // References:
// https://github.com/sindresorhus/object-assign
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
//# sourceMappingURL=Object.assign.js.map

/***/ }),

/***/ "lval":
/***/ (function(module, exports) {

/**
 * Extracts the attributes
 * @class
 * @memberof PIXI.glCore.shader
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param uniforms {Array} @mat ?
 * @return attributes {Object}
 */
var generateUniformAccessObject = function generateUniformAccessObject(gl, uniformData) {
    // this is the object we will be sending back.
    // an object hierachy will be created for structs
    var uniforms = { data: {} };

    uniforms.gl = gl;

    var uniformKeys = Object.keys(uniformData);

    for (var i = 0; i < uniformKeys.length; i++) {
        var fullName = uniformKeys[i];

        var nameTokens = fullName.split('.');
        var name = nameTokens[nameTokens.length - 1];

        var uniformGroup = getUniformGroup(nameTokens, uniforms);

        var uniform = uniformData[fullName];
        uniformGroup.data[name] = uniform;

        uniformGroup.gl = gl;

        Object.defineProperty(uniformGroup, name, {
            get: generateGetter(name),
            set: generateSetter(name, uniform)
        });
    }

    return uniforms;
};

var generateGetter = function generateGetter(name) {
    return function () {
        return this.data[name].value;
    };
};

var GLSL_SINGLE_SETTERS = {
    float: function setSingleFloat(gl, location, value) {
        gl.uniform1f(location, value);
    },
    vec2: function setSingleVec2(gl, location, value) {
        gl.uniform2f(location, value[0], value[1]);
    },
    vec3: function setSingleVec3(gl, location, value) {
        gl.uniform3f(location, value[0], value[1], value[2]);
    },
    vec4: function setSingleVec4(gl, location, value) {
        gl.uniform4f(location, value[0], value[1], value[2], value[3]);
    },

    int: function setSingleInt(gl, location, value) {
        gl.uniform1i(location, value);
    },
    ivec2: function setSingleIvec2(gl, location, value) {
        gl.uniform2i(location, value[0], value[1]);
    },
    ivec3: function setSingleIvec3(gl, location, value) {
        gl.uniform3i(location, value[0], value[1], value[2]);
    },
    ivec4: function setSingleIvec4(gl, location, value) {
        gl.uniform4i(location, value[0], value[1], value[2], value[3]);
    },

    bool: function setSingleBool(gl, location, value) {
        gl.uniform1i(location, value);
    },
    bvec2: function setSingleBvec2(gl, location, value) {
        gl.uniform2i(location, value[0], value[1]);
    },
    bvec3: function setSingleBvec3(gl, location, value) {
        gl.uniform3i(location, value[0], value[1], value[2]);
    },
    bvec4: function setSingleBvec4(gl, location, value) {
        gl.uniform4i(location, value[0], value[1], value[2], value[3]);
    },

    mat2: function setSingleMat2(gl, location, value) {
        gl.uniformMatrix2fv(location, false, value);
    },
    mat3: function setSingleMat3(gl, location, value) {
        gl.uniformMatrix3fv(location, false, value);
    },
    mat4: function setSingleMat4(gl, location, value) {
        gl.uniformMatrix4fv(location, false, value);
    },

    sampler2D: function setSingleSampler2D(gl, location, value) {
        gl.uniform1i(location, value);
    }
};

var GLSL_ARRAY_SETTERS = {
    float: function setFloatArray(gl, location, value) {
        gl.uniform1fv(location, value);
    },
    vec2: function setVec2Array(gl, location, value) {
        gl.uniform2fv(location, value);
    },
    vec3: function setVec3Array(gl, location, value) {
        gl.uniform3fv(location, value);
    },
    vec4: function setVec4Array(gl, location, value) {
        gl.uniform4fv(location, value);
    },
    int: function setIntArray(gl, location, value) {
        gl.uniform1iv(location, value);
    },
    ivec2: function setIvec2Array(gl, location, value) {
        gl.uniform2iv(location, value);
    },
    ivec3: function setIvec3Array(gl, location, value) {
        gl.uniform3iv(location, value);
    },
    ivec4: function setIvec4Array(gl, location, value) {
        gl.uniform4iv(location, value);
    },
    bool: function setBoolArray(gl, location, value) {
        gl.uniform1iv(location, value);
    },
    bvec2: function setBvec2Array(gl, location, value) {
        gl.uniform2iv(location, value);
    },
    bvec3: function setBvec3Array(gl, location, value) {
        gl.uniform3iv(location, value);
    },
    bvec4: function setBvec4Array(gl, location, value) {
        gl.uniform4iv(location, value);
    },
    sampler2D: function setSampler2DArray(gl, location, value) {
        gl.uniform1iv(location, value);
    }
};

function generateSetter(name, uniform) {
    return function (value) {
        this.data[name].value = value;
        var location = this.data[name].location;
        if (uniform.size === 1) {
            GLSL_SINGLE_SETTERS[uniform.type](this.gl, location, value);
        } else {
            // glslSetArray(gl, location, type, value) {
            GLSL_ARRAY_SETTERS[uniform.type](this.gl, location, value);
        }
    };
}

function getUniformGroup(nameTokens, uniform) {
    var cur = uniform;

    for (var i = 0; i < nameTokens.length - 1; i++) {
        var o = cur[nameTokens[i]] || { data: {} };
        cur[nameTokens[i]] = o;
        cur = o;
    }

    return cur;
}

module.exports = generateUniformAccessObject;

/***/ }),

/***/ "m/r8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CustomDayPicker":"CustomDayPicker__1ftUA","CustomDayPicker-wrapper":"CustomDayPicker-wrapper__vbJI5","CustomDayPicker-Months":"CustomDayPicker-Months__2Xbmi","CustomDayPicker-Month":"CustomDayPicker-Month__2ZxDA","CustomDayPicker-NavBar":"CustomDayPicker-NavBar__1GAGI","CustomDayPicker-NavButton":"CustomDayPicker-NavButton__2XSJU","CustomDayPicker-NavButton--prev":"CustomDayPicker-NavButton--prev__3088X","CustomDayPicker-NavButton--next":"CustomDayPicker-NavButton--next__1y7Qd","CustomDayPicker-NavButton--interactionDisabled":"CustomDayPicker-NavButton--interactionDisabled__Vh6sM","CustomDayPicker-Caption":"CustomDayPicker-Caption__3wpU8","CustomDayPicker-Weekdays":"CustomDayPicker-Weekdays__3pfZn","CustomDayPicker-WeekdaysRow":"CustomDayPicker-WeekdaysRow__3dyRk","CustomDayPicker-Weekday":"CustomDayPicker-Weekday__2Q7Dt","CustomDayPicker-Body":"CustomDayPicker-Body__3VBCI","CustomDayPicker-Week":"CustomDayPicker-Week__2VlH6","CustomDayPicker-Day":"CustomDayPicker-Day__1dM4l","CustomDayPicker-WeekNumber":"CustomDayPicker-WeekNumber__116IV","CustomDayPicker--interactionDisabled":"CustomDayPicker--interactionDisabled__1GmW4","CustomDayPicker-Footer":"CustomDayPicker-Footer__GGO6K","CustomDayPicker-TodayButton":"CustomDayPicker-TodayButton__3IxCt","today":"today__23Njk","disabled":"disabled__BnNht","outside":"outside__2fGMn","CustomDayPicker-Day--sunday":"CustomDayPicker-Day--sunday__2uQCN","selected":"selected__X32A3","CustomDayPickerInput":"CustomDayPickerInput__3fKQk","CustomDayPickerInput-OverlayWrapper":"CustomDayPickerInput-OverlayWrapper__3XghF","CustomDayPickerInput-Overlay":"CustomDayPickerInput-Overlay__3vlYR","available":"available__1UtCF","unavailable":"unavailable__2ZdQ7"};

/***/ }),

/***/ "mI+K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),

/***/ "mUiR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/emotion/dist/index.esm.js
var index_esm = __webpack_require__("mibh");

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./assets/images/icon-arrow-left.svg
var icon_arrow_left = __webpack_require__("3I3T");
var icon_arrow_left_default = /*#__PURE__*/__webpack_require__.n(icon_arrow_left);

// CONCATENATED MODULE: ./components/BackButton.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var backStyles = {
  background: "url(" + icon_arrow_left_default.a + ") no-repeat left center",
  border: "none",
  padding: "0 0 0 24px",
  textDecoration: "none",
  color: "#000",
  cursor: "pointer",
  marginRight: "0.4rem"
};

var BackButton_BackButton = function (_Component) {
  _inherits(BackButton, _Component);

  function BackButton() {
    _classCallCheck(this, BackButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = { isInIframe: false };
    return _this;
  }

  BackButton.prototype.componentDidMount = function componentDidMount() {
    this.setState({ isInIframe: this.inIframe() });
  };

  BackButton.prototype.inIframe = function inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  BackButton.prototype.render = function render() {
    var isInIframe = this.state.isInIframe;

    if (!isInIframe) {
      return null;
    }
    return Object(preact_min["h"])(
      "a",
      {
        style: backStyles,
        "aria-label": "Back",
        onClick: function onClick() {
          window.history.back();
        }
      },
      "Back"
    );
  };

  return BackButton;
}(preact_min["Component"]);

/* harmony default export */ var components_BackButton = (BackButton_BackButton);
// CONCATENATED MODULE: ./components/Steps.js
var _css, _css2, _css3, _css4;



function Steps__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Steps__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Steps__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var min = function min(len) {
  return "@media (min-width: " + len + "px)";
};
var max = function max(len) {
  return "@media (max-width: " + len + "px)";
};

var stepItem = Object(index_esm["css"])((_css = {
  a: {
    color: "#323232",
    fontSize: 16
  }
}, _css[max(700)] = {
  ":not(:first-of-type)": {
    "::before": {
      content: "''",
      display: "inline-block",
      width: 7,
      height: 7,
      margin: "0px 7px 2px 8.6px",
      borderTop: "2px solid #788391",
      borderRight: "2px solid #788391",
      backgroundColor: "white",
      transform: "rotate(45deg)"
    }
  },
  display: "inline-block",
  "#step-desktop": {
    display: "none"
  },
  "#step-mobile": {
    display: "inline-block"
  }
}, _css[min(700)] = {
  "&::before": {
    content: "counter(li)",
    width: 24,
    height: 24,
    marginRight: 4,
    display: "inline-block",
    color: "white",
    borderRadius: "100%",
    lineHeight: "23px",
    backgroundColor: "#323232"
  },
  "&::after": {
    content: "''",
    backgroundColor: "#dedede",
    verticalAlign: "middle",
    position: "relative",
    left: 8,
    width: 20,
    height: 1,
    marginRight: 16,
    display: "inline-block"
  },
  ":last-child": {
    ":after": {
      display: "none"
    }
  },
  counterIncrement: "li",
  display: "inline-block"
}, _css));

var disabled = Object(index_esm["css"])({
  "&::before": {
    backgroundColor: "rgb(169, 164, 174)"
  },
  color: "#a9a4ae"
});

var processSteps = Object(index_esm["css"])({
  display: "inline-block",
  margin: "0",
  padding: "0.2rem 0"
});

var pipeStyle = Object(index_esm["css"])({
  marginRight: "0.4rem",
  color: "rgba(153, 153, 153, 0.85)"
});

var wrapper = Object(index_esm["css"])((_css2 = {
  marginBottom: 20,
  marginRight: "auto",
  marginLeft: "auto",
  marginTop: 8
}, _css2[max(700)] = {
  marginTop: 0,
  marginBottom: 8
}, _css2));

var desktopLabel = Object(index_esm["css"])((_css3 = {
  display: "inline-block"
}, _css3[max(700)] = {
  display: "none"
}, _css3));

var mobileLabel = Object(index_esm["css"])((_css4 = {
  display: "none"
}, _css4[max(700)] = {
  display: "inline-block"
}, _css4));

var Steps__ref = Object(preact_min["h"])(
  "span",
  null,
  Object(preact_min["h"])(components_BackButton, null),
  Object(preact_min["h"])(
    "span",
    { className: pipeStyle },
    "|"
  )
);

var Steps_Steps = function (_Component) {
  Steps__inherits(Steps, _Component);

  function Steps(props) {
    Steps__classCallCheck(this, Steps);

    return Steps__possibleConstructorReturn(this, _Component.call(this, props));
  }

  Steps.prototype.componentDidMount = function componentDidMount() {
    try {
      this.isWidget = false;
      var isBrowser = typeof window !== "undefined";
      if (isBrowser && window.self !== window.top) {
        this.isWidget = true;
      }
      if (!this.isWidget) {
        // do not force focus on the widget as it causes the page to scroll
        document.getElementById("activeLink").focus();
      }
    } catch (err) {}
  };

  Steps.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        eventSlug = _props.eventSlug,
        orderId = _props.orderId,
        includeSeatingMap = _props.includeSeatingMap,
        includesMerch = _props.includesMerch,
        isConference = _props.isConference;


    var primaryColor = theme && theme.primaryColor ? theme.primaryColor : "#6621c0";

    var defaultStyle = Object(index_esm["css"])({
      "&::before": {
        backgroundColor: primaryColor
      }
    });

    var active = Object(index_esm["css"])({
      "&::before": {
        backgroundColor: primaryColor
      },
      fontWeight: "600",
      a: {
        color: primaryColor
      }
    });

    var steps = [{
      label: "Select Tickets",
      mobileLabel: "Tickets",
      path: "/" + eventSlug + "/tickets"
    }, {
      label: (isConference ? "Buyer" : "Enter") + " Details",
      mobileLabel: "Details",
      path: "/" + eventSlug + "/details/" + orderId
    }, {
      label: "Payment",
      mobileLabel: "Payment",
      path: "/" + eventSlug + "/payment/" + orderId
    }];
    if (includeSeatingMap) {
      steps.splice(2, 0, {
        label: "Seats",
        mobileLabel: "Seats",
        path: "/" + eventSlug + "/seatingmap/" + orderId
      });
    }

    if (includesMerch) {
      steps.splice(1, 0, {
        label: "Add Ons",
        mobileLabel: "Add Ons",
        path: "/" + eventSlug + "/add-ons/" + orderId
      });
    }

    if (isConference) {
      steps.splice(steps.length - 1, 0, {
        label: "Assign Tickets",
        mobileLabel: "Assign",
        path: "/" + eventSlug + "/assign/" + orderId
      });
    }

    var isBrowser = typeof window !== "undefined";
    var isWidget = false;
    if (isBrowser && window.self !== window.top) {
      isWidget = true;
    }

    var url = Object(preact_router_es["getCurrentUrl"])();
    var path = url.replace(/\?.+$/, "");

    var matched = false;
    steps.forEach(function (step, index) {
      step.ref = step.path.replace("/", "-").toLowerCase();
      if (matched) {
        step.disabled = true;
      }
      if (path.indexOf(step.path) !== -1) {
        step.active = true;
        matched = true;
      }
    });

    return Object(preact_min["h"])(
      "div",
      { className: wrapper },
      Object(preact_min["h"])(
        "ul",
        { className: processSteps },
        isWidget ? Steps__ref : null,
        steps.map(function (step, index) {
          var classes = [stepItem];
          if (step.active) {
            classes.push(active);
          } else if (step.disabled) {
            classes.push(disabled);
          } else {
            classes.push(defaultStyle);
          }
          return Object(preact_min["h"])(
            "li",
            { key: index, className: Object(index_esm["css"])(classes) },
            !step.disabled ? Object(preact_min["h"])(
              match["Link"],
              {
                href: step.path,
                id: step.active ? "activeLink" : "disabled",
                "aria-current": step.active ? "step" : null
              },
              Object(preact_min["h"])(
                "div",
                { "class": "sr-only" },
                "Step ",
                index + 1
              ),
              Object(preact_min["h"])(
                "div",
                { className: desktopLabel },
                step.label
              ),
              Object(preact_min["h"])(
                "div",
                { className: mobileLabel },
                step.mobileLabel
              )
            ) : Object(preact_min["h"])(
              "div",
              { style: { display: "inherit" } },
              Object(preact_min["h"])(
                "div",
                { className: desktopLabel },
                step.label
              ),
              Object(preact_min["h"])(
                "div",
                { className: mobileLabel },
                step.mobileLabel
              )
            )
          );
        })
      )
    );
  };

  return Steps;
}(preact_min["Component"]);

/* harmony default export */ var components_Steps = (Steps_Steps);
// EXTERNAL MODULE: ./components/EditEvent.js
var EditEvent = __webpack_require__("dYGj");

// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__("jYI/");

// CONCATENATED MODULE: ./components/BookingHeader.js








var BookingHeader_BookingHeader = function BookingHeader(_ref) {
  var event = _ref.event,
      order = _ref.order,
      includeSeatingMap = _ref.includeSeatingMap,
      merchandise = _ref.merchandise,
      isGlobal = _ref.isGlobal,
      eventDate = _ref.eventDate;

  var style = {
    textAlign: "center",
    paddingTop: 16,
    paddingLeft: 14,
    paddingRight: 14,
    borderBottom: isGlobal ? "none" : "1px solid #dedede",
    h1: {
      fontSize: 20,
      margin: 0,
      marginBottom: 4
    }
  };
  if (isGlobal) {
    return Object(preact_min["h"])("div", { style: style });
  }
  var includesMerch = merchandise.includesMerch;

  var link = event ? event.widget ? "/" + event.data.slug + "/tickets" : "/" + event.data.slug : "";
  var orderId = order && order.data ? order.data._id : null;
  var isConference = event.data.settings.enableTicketAssigning;
  var compiledStyle = Object(index_esm["css"])(style);
  return Object(preact_min["h"])(
    "div",
    { className: compiledStyle },
    Object(preact_min["h"])(EditEvent["a" /* default */], { event: event.data }),
    Object(preact_min["h"])(
      "h1",
      null,
      Object(preact_min["h"])(
        match["Link"],
        { href: link, style: { color: "#323232" } },
        event.data.name
      )
    ),
    eventDate && eventDate.combined ? Object(preact_min["h"])(
      "p",
      { style: { marginBottom: 8 } },
      eventDate.combined
    ) : null,
    Object(preact_min["h"])(components_Steps, {
      eventSlug: event.data.slug,
      theme: event.data.theme,
      orderId: orderId,
      includeSeatingMap: includeSeatingMap,
      includesMerch: includesMerch,
      isConference: isConference
    })
  );
};

/* harmony default export */ var components_BookingHeader = __webpack_exports__["a"] = (Object(es["b" /* connect */])(function (state) {
  return {
    event: state.event,
    order: state.order,
    merchandise: state.merchandise,
    eventDate: state.ticketSelection.selectedDateDisplay
  };
}, {})(BookingHeader_BookingHeader));

/***/ }),

/***/ "mVfy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__("dZBD");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./config.js
var config = __webpack_require__("aSYM");

// CONCATENATED MODULE: ./services/WaitlistService.js



var WaitlistService = {
  add: function add(data) {
    return new Promise(function (resolve, reject) {
      axios_default.a.post(Object(config["a" /* default */])("API_URL") + "waitlist/add", data).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  pass: function pass(waitlistId) {
    return new Promise(function (resolve, reject) {
      axios_default.a.post(Object(config["a" /* default */])("API_URL") + "waitlist/pass/" + waitlistId).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};

/* harmony default export */ var services_WaitlistService = (WaitlistService);
// CONCATENATED MODULE: ./state/actions/waitlistActions.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_WAITLIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_TO_WAITLIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_TO_WAITLIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TO_WAITLIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PASS_WAITLIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PASS_WAITLIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PASS_WAITLIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return clear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return waitlistActions_add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return waitlistActions_pass; });


var CLEAR_WAITLIST_REQUEST = "CLEAR_WAITLIST_REQUEST";

var ADD_TO_WAITLIST_REQUEST = "ADD_TO_WAITLIST_REQUEST";
var ADD_TO_WAITLIST_SUCCESS = "ADD_TO_WAITLIST_SUCCESS";
var ADD_TO_WAITLIST_ERROR = "ADD_TO_WAITLIST_ERROR";

var PASS_WAITLIST_REQUEST = "PASS_WAITLIST_REQUEST";
var PASS_WAITLIST_SUCCESS = "PASS_WAITLIST_SUCCESS";
var PASS_WAITLIST_ERROR = "PASS_WAITLIST_ERROR";

var clear = function clear() {
  return function (dispatch) {
    dispatch({ type: CLEAR_WAITLIST_REQUEST });
  };
};

var waitlistActions_add = function add(data) {
  return function (dispatch) {
    dispatch({ type: ADD_TO_WAITLIST_REQUEST });
    services_WaitlistService.add(data).then(function () {
      dispatch({ type: ADD_TO_WAITLIST_SUCCESS });
    }).catch(function () {
      dispatch({
        type: ADD_TO_WAITLIST_ERROR,
        error: "Failed to add to waitlist"
      });
    });
  };
};

var waitlistActions_pass = function pass(waitlistId) {
  return function (dispatch) {
    dispatch({ type: PASS_WAITLIST_REQUEST });
    services_WaitlistService.pass(waitlistId).then(function () {
      dispatch({ type: PASS_WAITLIST_SUCCESS });
    }).catch(function () {
      dispatch({
        type: PASS_WAITLIST_ERROR,
        error: "Failed to remove from waitlist"
      });
    });
  };
};

/***/ }),

/***/ "mhfJ":
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};

/***/ }),

/***/ "mibh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return hydrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cx", function() { return cx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegisteredStyles", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sheet", function() { return sheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "caches", function() { return caches; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__("QdUY");


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "mmMt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Rows_1 = __webpack_require__("Pu1Z");
var Seat_1 = __webpack_require__("cC7r");

var Rows = function (_Rows_1$default) {
    _inherits(Rows, _Rows_1$default);

    function Rows() {
        _classCallCheck(this, Rows);

        return _possibleConstructorReturn(this, _Rows_1$default.apply(this, arguments));
    }

    Rows.prototype.seatsInit = function seatsInit(seats, disableInteraction) {
        var _this2 = this;

        var seatCount = seats.length;
        return seats.map(function (seat, i) {
            var constructionValue = _extends({ pos: _this2.getSeatPos(i, seatCount), seatlabelStartAt: _this2.seatlabelStartAt, bookByTable: _this2.bookByTable, tableId: _this2._id, sectionId: _this2.sectionId, sectionName: _this2.sectionName, tableName: _this2.name }, seat);
            return new Seat_1.default(constructionValue, {}, disableInteraction);
        });
    };

    return Rows;
}(Rows_1.default);

exports.default = Rows;
//# sourceMappingURL=Rows.js.map

/***/ }),

/***/ "mnG2":
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || typeof value !== 'function' && typeof value !== 'object';
};

/***/ }),

/***/ "mpmK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Event class that mimics native DOM events.
 *
 * @class
 * @memberof PIXI.interaction
 */
var InteractionEvent = function () {
  /**
   *
   */
  function InteractionEvent() {
    _classCallCheck(this, InteractionEvent);

    /**
     * Whether this event will continue propagating in the tree
     *
     * @member {boolean}
     */
    this.stopped = false;

    /**
     * The object which caused this event to be dispatched.
     * For listener callback see {@link PIXI.interaction.InteractionEvent.currentTarget}.
     *
     * @member {PIXI.DisplayObject}
     */
    this.target = null;

    /**
     * The object whose event listener’s callback is currently being invoked.
     *
     * @member {PIXI.DisplayObject}
     */
    this.currentTarget = null;

    /**
     * Type of the event
     *
     * @member {string}
     */
    this.type = null;

    /**
     * InteractionData related to this event
     *
     * @member {PIXI.interaction.InteractionData}
     */
    this.data = null;
  }

  /**
   * Prevents event from reaching any objects other than the current object.
   *
   */

  InteractionEvent.prototype.stopPropagation = function stopPropagation() {
    this.stopped = true;
  };

  /**
   * Resets the event.
   */

  InteractionEvent.prototype.reset = function reset() {
    this.stopped = false;
    this.currentTarget = null;
    this.target = null;
  };

  return InteractionEvent;
}();

exports.default = InteractionEvent;
//# sourceMappingURL=InteractionEvent.js.map

/***/ }),

/***/ "msqx":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("dskh").Buffer; // for use with browserify

module.exports = function (a, b) {
    if (!Buffer.isBuffer(a)) return undefined;
    if (!Buffer.isBuffer(b)) return undefined;
    if (typeof a.equals === 'function') return a.equals(b);
    if (a.length !== b.length) return false;

    for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }

    return true;
};

/***/ }),

/***/ "n3E9":
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;

/***/ }),

/***/ "n9cH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Remove a range of items from an array
 *
 * @function removeItems
 * @param {Array<*>} arr The target array
 * @param {number} startIdx The index to begin removing from (inclusive)
 * @param {number} removeCount How many items to remove
 */

module.exports = function removeItems(arr, startIdx, removeCount) {
  var i,
      length = arr.length;

  if (startIdx >= length || removeCount === 0) {
    return;
  }

  removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;

  var len = length - removeCount;

  for (i = startIdx; i < len; ++i) {
    arr[i] = arr[i + removeCount];
  }

  arr.length = len;
};

/***/ }),

/***/ "nMdc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * The TextMetrics object represents the measurement of a block of text with a specified style.
 *
 * ```js
 * let style = new PIXI.TextStyle({fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'})
 * let textMetrics = PIXI.TextMetrics.measureText('Your text', style)
 * ```
 *
 * @class
 * @memberOf PIXI
 */
var TextMetrics = function () {
    /**
     * @param {string} text - the text that was measured
     * @param {PIXI.TextStyle} style - the style that was measured
     * @param {number} width - the measured width of the text
     * @param {number} height - the measured height of the text
     * @param {array} lines - an array of the lines of text broken by new lines and wrapping if specified in style
     * @param {array} lineWidths - an array of the line widths for each line matched to `lines`
     * @param {number} lineHeight - the measured line height for this style
     * @param {number} maxLineWidth - the maximum line width for all measured lines
     * @param {Object} fontProperties - the font properties object from TextMetrics.measureFont
     */
    function TextMetrics(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties) {
        _classCallCheck(this, TextMetrics);

        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
    }

    /**
     * Measures the supplied string of text and returns a Rectangle.
     *
     * @param {string} text - the text to measure.
     * @param {PIXI.TextStyle} style - the text style to use for measuring
     * @param {boolean} [wordWrap] - optional override for if word-wrap should be applied to the text.
     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
     * @return {PIXI.TextMetrics} measured width and height of the text.
     */

    TextMetrics.measureText = function measureText(text, style, wordWrap) {
        var canvas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TextMetrics._canvas;

        wordWrap = wordWrap === undefined || wordWrap === null ? style.wordWrap : wordWrap;
        var font = style.toFontString();
        var fontProperties = TextMetrics.measureFont(font);
        var context = canvas.getContext('2d');

        context.font = font;

        var outputText = wordWrap ? TextMetrics.wordWrap(text, style, canvas) : text;
        var lines = outputText.split(/(?:\r\n|\r|\n)/);
        var lineWidths = new Array(lines.length);
        var maxLineWidth = 0;

        for (var i = 0; i < lines.length; i++) {
            var lineWidth = context.measureText(lines[i]).width + (lines[i].length - 1) * style.letterSpacing;

            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        var width = maxLineWidth + style.strokeThickness;

        if (style.dropShadow) {
            width += style.dropShadowDistance;
        }

        var lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
        var height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness) + (lines.length - 1) * (lineHeight + style.leading);

        if (style.dropShadow) {
            height += style.dropShadowDistance;
        }

        return new TextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
    };

    /**
     * Applies newlines to a string to have it optimally fit into the horizontal
     * bounds set by the Text object's wordWrapWidth property.
     *
     * @private
     * @param {string} text - String to apply word wrapping to
     * @param {PIXI.TextStyle} style - the style to use when wrapping
     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
     * @return {string} New string with new lines applied where required
     */

    TextMetrics.wordWrap = function wordWrap(text, style) {
        var canvas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TextMetrics._canvas;

        var context = canvas.getContext('2d');

        var width = 0;
        var line = '';
        var lines = '';

        var cache = {};
        var letterSpacing = style.letterSpacing,
            whiteSpace = style.whiteSpace;

        // How to handle whitespaces

        var collapseSpaces = TextMetrics.collapseSpaces(whiteSpace);
        var collapseNewlines = TextMetrics.collapseNewlines(whiteSpace);

        // whether or not spaces may be added to the beginning of lines
        var canPrependSpaces = !collapseSpaces;

        // There is letterSpacing after every char except the last one
        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!
        // so for convenience the above needs to be compared to width + 1 extra letterSpace
        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!_
        // ________________________________________________
        // And then the final space is simply no appended to each line
        var wordWrapWidth = style.wordWrapWidth + letterSpacing;

        // break text into words, spaces and newline chars
        var tokens = TextMetrics.tokenize(text);

        for (var i = 0; i < tokens.length; i++) {
            // get the word, space or newlineChar
            var token = tokens[i];

            // if word is a new line
            if (TextMetrics.isNewline(token)) {
                // keep the new line
                if (!collapseNewlines) {
                    lines += TextMetrics.addLine(line);
                    canPrependSpaces = !collapseSpaces;
                    line = '';
                    width = 0;
                    continue;
                }

                // if we should collapse new lines
                // we simply convert it into a space
                token = ' ';
            }

            // if we should collapse repeated whitespaces
            if (collapseSpaces) {
                // check both this and the last tokens for spaces
                var currIsBreakingSpace = TextMetrics.isBreakingSpace(token);
                var lastIsBreakingSpace = TextMetrics.isBreakingSpace(line[line.length - 1]);

                if (currIsBreakingSpace && lastIsBreakingSpace) {
                    continue;
                }
            }

            // get word width from cache if possible
            var tokenWidth = TextMetrics.getFromCache(token, letterSpacing, cache, context);

            // word is longer than desired bounds
            if (tokenWidth > wordWrapWidth) {
                // if we are not already at the beginning of a line
                if (line !== '') {
                    // start newlines for overflow words
                    lines += TextMetrics.addLine(line);
                    line = '';
                    width = 0;
                }

                // break large word over multiple lines
                if (TextMetrics.canBreakWords(token, style.breakWords)) {
                    // break word into characters
                    var characters = token.split('');

                    // loop the characters
                    for (var j = 0; j < characters.length; j++) {
                        var char = characters[j];

                        var k = 1;
                        // we are not at the end of the token

                        while (characters[j + k]) {
                            var nextChar = characters[j + k];
                            var lastChar = char[char.length - 1];

                            // should not split chars
                            if (!TextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) {
                                // combine chars & move forward one
                                char += nextChar;
                            } else {
                                break;
                            }

                            k++;
                        }

                        j += char.length - 1;

                        var characterWidth = TextMetrics.getFromCache(char, letterSpacing, cache, context);

                        if (characterWidth + width > wordWrapWidth) {
                            lines += TextMetrics.addLine(line);
                            canPrependSpaces = false;
                            line = '';
                            width = 0;
                        }

                        line += char;
                        width += characterWidth;
                    }
                }

                // run word out of the bounds
                else {
                        // if there are words in this line already
                        // finish that line and start a new one
                        if (line.length > 0) {
                            lines += TextMetrics.addLine(line);
                            line = '';
                            width = 0;
                        }

                        var isLastToken = i === tokens.length - 1;

                        // give it its own line if it's not the end
                        lines += TextMetrics.addLine(token, !isLastToken);
                        canPrependSpaces = false;
                        line = '';
                        width = 0;
                    }
            }

            // word could fit
            else {
                    // word won't fit because of existing words
                    // start a new line
                    if (tokenWidth + width > wordWrapWidth) {
                        // if its a space we don't want it
                        canPrependSpaces = false;

                        // add a new line
                        lines += TextMetrics.addLine(line);

                        // start a new line
                        line = '';
                        width = 0;
                    }

                    // don't add spaces to the beginning of lines
                    if (line.length > 0 || !TextMetrics.isBreakingSpace(token) || canPrependSpaces) {
                        // add the word to the current line
                        line += token;

                        // update width counter
                        width += tokenWidth;
                    }
                }
        }

        lines += TextMetrics.addLine(line, false);

        return lines;
    };

    /**
     * Convienience function for logging each line added during the wordWrap
     * method
     *
     * @private
     * @param  {string}   line        - The line of text to add
     * @param  {boolean}  newLine     - Add new line character to end
     * @return {string}   A formatted line
     */

    TextMetrics.addLine = function addLine(line) {
        var newLine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        line = TextMetrics.trimRight(line);

        line = newLine ? line + '\n' : line;

        return line;
    };

    /**
     * Gets & sets the widths of calculated characters in a cache object
     *
     * @private
     * @param  {string}                    key            The key
     * @param  {number}                    letterSpacing  The letter spacing
     * @param  {object}                    cache          The cache
     * @param  {CanvasRenderingContext2D}  context        The canvas context
     * @return {number}                    The from cache.
     */

    TextMetrics.getFromCache = function getFromCache(key, letterSpacing, cache, context) {
        var width = cache[key];

        if (width === undefined) {
            var spacing = key.length * letterSpacing;

            width = context.measureText(key).width + spacing;
            cache[key] = width;
        }

        return width;
    };

    /**
     * Determines whether we should collapse breaking spaces
     *
     * @private
     * @param  {string}   whiteSpace  The TextStyle property whiteSpace
     * @return {boolean}  should collapse
     */

    TextMetrics.collapseSpaces = function collapseSpaces(whiteSpace) {
        return whiteSpace === 'normal' || whiteSpace === 'pre-line';
    };

    /**
     * Determines whether we should collapse newLine chars
     *
     * @private
     * @param  {string}   whiteSpace  The white space
     * @return {boolean}  should collapse
     */

    TextMetrics.collapseNewlines = function collapseNewlines(whiteSpace) {
        return whiteSpace === 'normal';
    };

    /**
     * trims breaking whitespaces from string
     *
     * @private
     * @param  {string}  text  The text
     * @return {string}  trimmed string
     */

    TextMetrics.trimRight = function trimRight(text) {
        if (typeof text !== 'string') {
            return '';
        }

        for (var i = text.length - 1; i >= 0; i--) {
            var char = text[i];

            if (!TextMetrics.isBreakingSpace(char)) {
                break;
            }

            text = text.slice(0, -1);
        }

        return text;
    };

    /**
     * Determines if char is a newline.
     *
     * @private
     * @param  {string}  char  The character
     * @return {boolean}  True if newline, False otherwise.
     */

    TextMetrics.isNewline = function isNewline(char) {
        if (typeof char !== 'string') {
            return false;
        }

        return TextMetrics._newlines.indexOf(char.charCodeAt(0)) >= 0;
    };

    /**
     * Determines if char is a breaking whitespace.
     *
     * @private
     * @param  {string}  char  The character
     * @return {boolean}  True if whitespace, False otherwise.
     */

    TextMetrics.isBreakingSpace = function isBreakingSpace(char) {
        if (typeof char !== 'string') {
            return false;
        }

        return TextMetrics._breakingSpaces.indexOf(char.charCodeAt(0)) >= 0;
    };

    /**
     * Splits a string into words, breaking-spaces and newLine characters
     *
     * @private
     * @param  {string}  text       The text
     * @return {array}  A tokenized array
     */

    TextMetrics.tokenize = function tokenize(text) {
        var tokens = [];
        var token = '';

        if (typeof text !== 'string') {
            return tokens;
        }

        for (var i = 0; i < text.length; i++) {
            var char = text[i];

            if (TextMetrics.isBreakingSpace(char) || TextMetrics.isNewline(char)) {
                if (token !== '') {
                    tokens.push(token);
                    token = '';
                }

                tokens.push(char);

                continue;
            }

            token += char;
        }

        if (token !== '') {
            tokens.push(token);
        }

        return tokens;
    };

    /**
     * This method exists to be easily overridden
     * It allows one to customise which words should break
     * Examples are if the token is CJK or numbers.
     * It must return a boolean.
     *
     * @private
     * @param  {string}  token       The token
     * @param  {boolean}  breakWords  The style attr break words
     * @return {boolean} whether to break word or not
     */

    TextMetrics.canBreakWords = function canBreakWords(token, breakWords) {
        return breakWords;
    };

    /**
     * This method exists to be easily overridden
     * It allows one to determine whether a pair of characters
     * should be broken by newlines
     * For example certain characters in CJK langs or numbers.
     * It must return a boolean.
     *
     * @private
     * @param  {string}  char      The character
     * @param  {string}  nextChar  The next character
     * @param  {string}  token     The token/word the characters are from
     * @param  {number}  index     The index in the token of the char
     * @param  {boolean}  breakWords  The style attr break words
     * @return {boolean} whether to break word or not
     */

    TextMetrics.canBreakChars = function canBreakChars(char, nextChar, token, index, breakWords) // eslint-disable-line no-unused-vars
    {
        return true;
    };

    /**
     * Calculates the ascent, descent and fontSize of a given font-style
     *
     * @static
     * @param {string} font - String representing the style of the font
     * @return {PIXI.TextMetrics~FontMetrics} Font properties object
     */

    TextMetrics.measureFont = function measureFont(font) {
        // as this method is used for preparing assets, don't recalculate things if we don't need to
        if (TextMetrics._fonts[font]) {
            return TextMetrics._fonts[font];
        }

        var properties = {};

        var canvas = TextMetrics._canvas;
        var context = TextMetrics._context;

        context.font = font;

        var metricsString = TextMetrics.METRICS_STRING + TextMetrics.BASELINE_SYMBOL;
        var width = Math.ceil(context.measureText(metricsString).width);
        var baseline = Math.ceil(context.measureText(TextMetrics.BASELINE_SYMBOL).width);
        var height = 2 * baseline;

        baseline = baseline * TextMetrics.BASELINE_MULTIPLIER | 0;

        canvas.width = width;
        canvas.height = height;

        context.fillStyle = '#f00';
        context.fillRect(0, 0, width, height);

        context.font = font;

        context.textBaseline = 'alphabetic';
        context.fillStyle = '#000';
        context.fillText(metricsString, 0, baseline);

        var imagedata = context.getImageData(0, 0, width, height).data;
        var pixels = imagedata.length;
        var line = width * 4;

        var i = 0;
        var idx = 0;
        var stop = false;

        // ascent. scan from top to bottom until we find a non red pixel
        for (i = 0; i < baseline; ++i) {
            for (var j = 0; j < line; j += 4) {
                if (imagedata[idx + j] !== 255) {
                    stop = true;
                    break;
                }
            }
            if (!stop) {
                idx += line;
            } else {
                break;
            }
        }

        properties.ascent = baseline - i;

        idx = pixels - line;
        stop = false;

        // descent. scan from bottom to top until we find a non red pixel
        for (i = height; i > baseline; --i) {
            for (var _j = 0; _j < line; _j += 4) {
                if (imagedata[idx + _j] !== 255) {
                    stop = true;
                    break;
                }
            }

            if (!stop) {
                idx -= line;
            } else {
                break;
            }
        }

        properties.descent = i - baseline;
        properties.fontSize = properties.ascent + properties.descent;

        TextMetrics._fonts[font] = properties;

        return properties;
    };

    /**
     * Clear font metrics in metrics cache.
     *
     * @static
     * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
     */

    TextMetrics.clearMetrics = function clearMetrics() {
        var font = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        if (font) {
            delete TextMetrics._fonts[font];
        } else {
            TextMetrics._fonts = {};
        }
    };

    return TextMetrics;
}();

/**
 * Internal return object for {@link PIXI.TextMetrics.measureFont `TextMetrics.measureFont`}.
 * @class FontMetrics
 * @memberof PIXI.TextMetrics~
 * @property {number} ascent - The ascent distance
 * @property {number} descent - The descent distance
 * @property {number} fontSize - Font size from ascent to descent
 */

exports.default = TextMetrics;
var canvas = document.createElement('canvas');

canvas.width = canvas.height = 10;

/**
 * Cached canvas element for measuring text
 * @memberof PIXI.TextMetrics
 * @type {HTMLCanvasElement}
 * @private
 */
TextMetrics._canvas = canvas;

/**
 * Cache for context to use.
 * @memberof PIXI.TextMetrics
 * @type {CanvasRenderingContext2D}
 * @private
 */
TextMetrics._context = canvas.getContext('2d');

/**
 * Cache of PIXI.TextMetrics~FontMetrics objects.
 * @memberof PIXI.TextMetrics
 * @type {Object}
 * @private
 */
TextMetrics._fonts = {};

/**
 * String used for calculate font metrics.
 * @static
 * @memberof PIXI.TextMetrics
 * @name METRICS_STRING
 * @type {string}
 * @default |Éq
 */
TextMetrics.METRICS_STRING = '|Éq';

/**
 * Baseline symbol for calculate font metrics.
 * @static
 * @memberof PIXI.TextMetrics
 * @name BASELINE_SYMBOL
 * @type {string}
 * @default M
 */
TextMetrics.BASELINE_SYMBOL = 'M';

/**
 * Baseline multiplier for calculate font metrics.
 * @static
 * @memberof PIXI.TextMetrics
 * @name BASELINE_MULTIPLIER
 * @type {number}
 * @default 1.4
 */
TextMetrics.BASELINE_MULTIPLIER = 1.4;

/**
 * Cache of new line chars.
 * @memberof PIXI.TextMetrics
 * @type {number[]}
 * @private
 */
TextMetrics._newlines = [0x000A, // line feed
0x000D];

/**
 * Cache of breaking spaces.
 * @memberof PIXI.TextMetrics
 * @type {number[]}
 * @private
 */
TextMetrics._breakingSpaces = [0x0009, // character tabulation
0x0020, // space
0x2000, // en quad
0x2001, // em quad
0x2002, // en space
0x2003, // em space
0x2004, // three-per-em space
0x2005, // four-per-em space
0x2006, // six-per-em space
0x2008, // punctuation space
0x2009, // thin space
0x200A, // hair space
0x205F, // medium mathematical space
0x3000];
//# sourceMappingURL=TextMetrics.js.map

/***/ }),

/***/ "nSZq":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function (e) {
  var n = /iPhone/i,
      t = /iPod/i,
      r = /iPad/i,
      a = /\bAndroid(?:.+)Mobile\b/i,
      p = /Android/i,
      b = /\bAndroid(?:.+)SD4930UR\b/i,
      l = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,
      f = /Windows Phone/i,
      s = /\bWindows(?:.+)ARM\b/i,
      u = /BlackBerry/i,
      c = /BB10/i,
      h = /Opera Mini/i,
      v = /\b(CriOS|Chrome)(?:.+)Mobile/i,
      w = /Mobile(?:.+)Firefox\b/i;function m(e, i) {
    return e.test(i);
  }function i(e) {
    var i = e || ("undefined" != typeof navigator ? navigator.userAgent : ""),
        o = i.split("[FBAN");void 0 !== o[1] && (i = o[0]), void 0 !== (o = i.split("Twitter"))[1] && (i = o[0]);var d = { apple: { phone: m(n, i) && !m(f, i), ipod: m(t, i), tablet: !m(n, i) && m(r, i) && !m(f, i), device: (m(n, i) || m(t, i) || m(r, i)) && !m(f, i) }, amazon: { phone: m(b, i), tablet: !m(b, i) && m(l, i), device: m(b, i) || m(l, i) }, android: { phone: !m(f, i) && m(b, i) || !m(f, i) && m(a, i), tablet: !m(f, i) && !m(b, i) && !m(a, i) && (m(l, i) || m(p, i)), device: !m(f, i) && (m(b, i) || m(l, i) || m(a, i) || m(p, i)) || m(/\bokhttp\b/i, i) }, windows: { phone: m(f, i), tablet: m(s, i), device: m(f, i) || m(s, i) }, other: { blackberry: m(u, i), blackberry10: m(c, i), opera: m(h, i), firefox: m(w, i), chrome: m(v, i), device: m(u, i) || m(c, i) || m(h, i) || m(w, i) || m(v, i) } };return d.any = d.apple.device || d.android.device || d.windows.device || d.other.device, d.phone = d.apple.phone || d.android.phone || d.windows.phone, d.tablet = d.apple.tablet || d.android.tablet || d.windows.tablet, d;
  }"undefined" != typeof module && module.exports && "undefined" == typeof window ? module.exports = i : "undefined" != typeof module && module.exports && "undefined" != typeof window ? (module.exports = i(), module.exports.isMobile = i) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e.isMobile = i()),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : e.isMobile = i();
}(this);

/***/ }),

/***/ "nUiQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var bind = __webpack_require__("ED/T");
var Axios = __webpack_require__("OvAf");
var mergeConfig = __webpack_require__("2OHv");
var defaults = __webpack_require__("BXyq");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("mI+K");
axios.CancelToken = __webpack_require__("tsWd");
axios.isCancel = __webpack_require__("V3+0");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("X8jb");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),

/***/ "nuOJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

var _const = __webpack_require__("YEQi");

var _TickerListener = __webpack_require__("3ilc");

var _TickerListener2 = _interopRequireDefault(_TickerListener);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * A Ticker class that runs an update loop that other objects listen to.
 * This class is composed around listeners
 * meant for execution on the next requested animation frame.
 * Animation frames are requested only when necessary,
 * e.g. When the ticker is started and the emitter has listeners.
 *
 * @class
 * @memberof PIXI.ticker
 */
var Ticker = function () {
    /**
     *
     */
    function Ticker() {
        var _this = this;

        _classCallCheck(this, Ticker);

        /**
         * The first listener. All new listeners added are chained on this.
         * @private
         * @type {TickerListener}
         */
        this._head = new _TickerListener2.default(null, null, Infinity);

        /**
         * Internal current frame request ID
         * @private
         */
        this._requestId = null;

        /**
         * Internal value managed by minFPS property setter and getter.
         * This is the maximum allowed milliseconds between updates.
         * @private
         */
        this._maxElapsedMS = 100;

        /**
         * Whether or not this ticker should invoke the method
         * {@link PIXI.ticker.Ticker#start} automatically
         * when a listener is added.
         *
         * @member {boolean}
         * @default false
         */
        this.autoStart = false;

        /**
         * Scalar time value from last frame to this frame.
         * This value is capped by setting {@link PIXI.ticker.Ticker#minFPS}
         * and is scaled with {@link PIXI.ticker.Ticker#speed}.
         * **Note:** The cap may be exceeded by scaling.
         *
         * @member {number}
         * @default 1
         */
        this.deltaTime = 1;

        /**
         * Time elapsed in milliseconds from last frame to this frame.
         * Opposed to what the scalar {@link PIXI.ticker.Ticker#deltaTime}
         * is based, this value is neither capped nor scaled.
         * If the platform supports DOMHighResTimeStamp,
         * this value will have a precision of 1 µs.
         * Defaults to target frame time
         *
         * @member {number}
         * @default 16.66
         */
        this.elapsedMS = 1 / _settings2.default.TARGET_FPMS;

        /**
         * The last time {@link PIXI.ticker.Ticker#update} was invoked.
         * This value is also reset internally outside of invoking
         * update, but only when a new animation frame is requested.
         * If the platform supports DOMHighResTimeStamp,
         * this value will have a precision of 1 µs.
         *
         * @member {number}
         * @default -1
         */
        this.lastTime = -1;

        /**
         * Factor of current {@link PIXI.ticker.Ticker#deltaTime}.
         * @example
         * // Scales ticker.deltaTime to what would be
         * // the equivalent of approximately 120 FPS
         * ticker.speed = 2;
         *
         * @member {number}
         * @default 1
         */
        this.speed = 1;

        /**
         * Whether or not this ticker has been started.
         * `true` if {@link PIXI.ticker.Ticker#start} has been called.
         * `false` if {@link PIXI.ticker.Ticker#stop} has been called.
         * While `false`, this value may change to `true` in the
         * event of {@link PIXI.ticker.Ticker#autoStart} being `true`
         * and a listener is added.
         *
         * @member {boolean}
         * @default false
         */
        this.started = false;

        /**
         * Internal tick method bound to ticker instance.
         * This is because in early 2015, Function.bind
         * is still 60% slower in high performance scenarios.
         * Also separating frame requests from update method
         * so listeners may be called at any time and with
         * any animation API, just invoke ticker.update(time).
         *
         * @private
         * @param {number} time - Time since last tick.
         */
        this._tick = function (time) {
            _this._requestId = null;

            if (_this.started) {
                // Invoke listeners now
                _this.update(time);
                // Listener side effects may have modified ticker state.
                if (_this.started && _this._requestId === null && _this._head.next) {
                    _this._requestId = requestAnimationFrame(_this._tick);
                }
            }
        };
    }

    /**
     * Conditionally requests a new animation frame.
     * If a frame has not already been requested, and if the internal
     * emitter has listeners, a new frame is requested.
     *
     * @private
     */

    Ticker.prototype._requestIfNeeded = function _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            // ensure callbacks get correct delta
            this.lastTime = performance.now();
            this._requestId = requestAnimationFrame(this._tick);
        }
    };

    /**
     * Conditionally cancels a pending animation frame.
     *
     * @private
     */

    Ticker.prototype._cancelIfNeeded = function _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    };

    /**
     * Conditionally requests a new animation frame.
     * If the ticker has been started it checks if a frame has not already
     * been requested, and if the internal emitter has listeners. If these
     * conditions are met, a new frame is requested. If the ticker has not
     * been started, but autoStart is `true`, then the ticker starts now,
     * and continues with the previous conditions to request a new frame.
     *
     * @private
     */

    Ticker.prototype._startIfPossible = function _startIfPossible() {
        if (this.started) {
            this._requestIfNeeded();
        } else if (this.autoStart) {
            this.start();
        }
    };

    /**
     * Register a handler for tick events. Calls continuously unless
     * it is removed or the ticker is stopped.
     *
     * @param {Function} fn - The listener function to be added for updates
     * @param {Function} [context] - The listener context
     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
     * @returns {PIXI.ticker.Ticker} This instance of a ticker
     */

    Ticker.prototype.add = function add(fn, context) {
        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const.UPDATE_PRIORITY.NORMAL;

        return this._addListener(new _TickerListener2.default(fn, context, priority));
    };

    /**
     * Add a handler for the tick event which is only execute once.
     *
     * @param {Function} fn - The listener function to be added for one update
     * @param {Function} [context] - The listener context
     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
     * @returns {PIXI.ticker.Ticker} This instance of a ticker
     */

    Ticker.prototype.addOnce = function addOnce(fn, context) {
        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const.UPDATE_PRIORITY.NORMAL;

        return this._addListener(new _TickerListener2.default(fn, context, priority, true));
    };

    /**
     * Internally adds the event handler so that it can be sorted by priority.
     * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
     * before the rendering.
     *
     * @private
     * @param {TickerListener} listener - Current listener being added.
     * @returns {PIXI.ticker.Ticker} This instance of a ticker
     */

    Ticker.prototype._addListener = function _addListener(listener) {
        // For attaching to head
        var current = this._head.next;
        var previous = this._head;

        // Add the first item
        if (!current) {
            listener.connect(previous);
        } else {
            // Go from highest to lowest priority
            while (current) {
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }

            // Not yet connected
            if (!listener.previous) {
                listener.connect(previous);
            }
        }

        this._startIfPossible();

        return this;
    };

    /**
     * Removes any handlers matching the function and context parameters.
     * If no handlers are left after removing, then it cancels the animation frame.
     *
     * @param {Function} fn - The listener function to be removed
     * @param {Function} [context] - The listener context to be removed
     * @returns {PIXI.ticker.Ticker} This instance of a ticker
     */

    Ticker.prototype.remove = function remove(fn, context) {
        var listener = this._head.next;

        while (listener) {
            // We found a match, lets remove it
            // no break to delete all possible matches
            // incase a listener was added 2+ times
            if (listener.match(fn, context)) {
                listener = listener.destroy();
            } else {
                listener = listener.next;
            }
        }

        if (!this._head.next) {
            this._cancelIfNeeded();
        }

        return this;
    };

    /**
     * Starts the ticker. If the ticker has listeners
     * a new animation frame is requested at this point.
     */

    Ticker.prototype.start = function start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    };

    /**
     * Stops the ticker. If the ticker has requested
     * an animation frame it is canceled at this point.
     */

    Ticker.prototype.stop = function stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    };

    /**
     * Destroy the ticker and don't use after this. Calling
     * this method removes all references to internal events.
     */

    Ticker.prototype.destroy = function destroy() {
        this.stop();

        var listener = this._head.next;

        while (listener) {
            listener = listener.destroy(true);
        }

        this._head.destroy();
        this._head = null;
    };

    /**
     * Triggers an update. An update entails setting the
     * current {@link PIXI.ticker.Ticker#elapsedMS},
     * the current {@link PIXI.ticker.Ticker#deltaTime},
     * invoking all listeners with current deltaTime,
     * and then finally setting {@link PIXI.ticker.Ticker#lastTime}
     * with the value of currentTime that was provided.
     * This method will be called automatically by animation
     * frame callbacks if the ticker instance has been started
     * and listeners are added.
     *
     * @param {number} [currentTime=performance.now()] - the current time of execution
     */

    Ticker.prototype.update = function update() {
        var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();

        var elapsedMS = void 0;

        // If the difference in time is zero or negative, we ignore most of the work done here.
        // If there is no valid difference, then should be no reason to let anyone know about it.
        // A zero delta, is exactly that, nothing should update.
        //
        // The difference in time can be negative, and no this does not mean time traveling.
        // This can be the result of a race condition between when an animation frame is requested
        // on the current JavaScript engine event loop, and when the ticker's start method is invoked
        // (which invokes the internal _requestIfNeeded method). If a frame is requested before
        // _requestIfNeeded is invoked, then the callback for the animation frame the ticker requests,
        // can receive a time argument that can be less than the lastTime value that was set within
        // _requestIfNeeded. This difference is in microseconds, but this is enough to cause problems.
        //
        // This check covers this browser engine timing issue, as well as if consumers pass an invalid
        // currentTime value. This may happen if consumers opt-out of the autoStart, and update themselves.

        if (currentTime > this.lastTime) {
            // Save uncapped elapsedMS for measurement
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;

            // cap the milliseconds elapsed used for deltaTime
            if (elapsedMS > this._maxElapsedMS) {
                elapsedMS = this._maxElapsedMS;
            }

            this.deltaTime = elapsedMS * _settings2.default.TARGET_FPMS * this.speed;

            // Cache a local reference, in-case ticker is destroyed
            // during the emit, we can still check for head.next
            var head = this._head;

            // Invoke listeners added to internal emitter
            var listener = head.next;

            while (listener) {
                listener = listener.emit(this.deltaTime);
            }

            if (!head.next) {
                this._cancelIfNeeded();
            }
        } else {
            this.deltaTime = this.elapsedMS = 0;
        }

        this.lastTime = currentTime;
    };

    /**
     * The frames per second at which this ticker is running.
     * The default is approximately 60 in most modern browsers.
     * **Note:** This does not factor in the value of
     * {@link PIXI.ticker.Ticker#speed}, which is specific
     * to scaling {@link PIXI.ticker.Ticker#deltaTime}.
     *
     * @member {number}
     * @readonly
     */

    _createClass(Ticker, [{
        key: 'FPS',
        get: function get() {
            return 1000 / this.elapsedMS;
        }

        /**
         * Manages the maximum amount of milliseconds allowed to
         * elapse between invoking {@link PIXI.ticker.Ticker#update}.
         * This value is used to cap {@link PIXI.ticker.Ticker#deltaTime},
         * but does not effect the measured value of {@link PIXI.ticker.Ticker#FPS}.
         * When setting this property it is clamped to a value between
         * `0` and `PIXI.settings.TARGET_FPMS * 1000`.
         *
         * @member {number}
         * @default 10
         */

    }, {
        key: 'minFPS',
        get: function get() {
            return 1000 / this._maxElapsedMS;
        },
        set: function set(fps) // eslint-disable-line require-jsdoc
        {
            // Clamp: 0 to TARGET_FPMS
            var minFPMS = Math.min(Math.max(0, fps) / 1000, _settings2.default.TARGET_FPMS);

            this._maxElapsedMS = 1 / minFPMS;
        }
    }]);

    return Ticker;
}();

exports.default = Ticker;
//# sourceMappingURL=Ticker.js.map

/***/ }),

/***/ "nx9B":
/***/ (function(module, exports, __webpack_require__) {


/*
	Copyright © 2001 Robert Penner
	All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, 
	are permitted provided that the following conditions are met:

	Redistributions of source code must retain the above copyright notice, this list of 
	conditions and the following disclaimer.
	Redistributions in binary form must reproduce the above copyright notice, this list 
	of conditions and the following disclaimer in the documentation and/or other materials 
	provided with the distribution.

	Neither the name of the author nor the names of contributors may be used to endorse 
	or promote products derived from this software without specific prior written permission.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
	EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
	MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
	COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
	GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
	AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
	OF THE POSSIBILITY OF SUCH DAMAGE.
 */

(function () {
  var penner, umd;

  umd = function umd(factory) {
    if (true) {
      return module.exports = factory;
    } else if (typeof define === 'function' && define.amd) {
      return define([], factory);
    } else {
      return this.penner = factory;
    }
  };

  penner = {
    linear: function linear(t, b, c, d) {
      return c * t / d + b;
    },
    easeInQuad: function easeInQuad(t, b, c, d) {
      return c * (t /= d) * t + b;
    },
    easeOutQuad: function easeOutQuad(t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    },
    easeInOutQuad: function easeInOutQuad(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t + b;
      } else {
        return -c / 2 * (--t * (t - 2) - 1) + b;
      }
    },
    easeInCubic: function easeInCubic(t, b, c, d) {
      return c * (t /= d) * t * t + b;
    },
    easeOutCubic: function easeOutCubic(t, b, c, d) {
      return c * ((t = t / d - 1) * t * t + 1) + b;
    },
    easeInOutCubic: function easeInOutCubic(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t * t + b;
      } else {
        return c / 2 * ((t -= 2) * t * t + 2) + b;
      }
    },
    easeInQuart: function easeInQuart(t, b, c, d) {
      return c * (t /= d) * t * t * t + b;
    },
    easeOutQuart: function easeOutQuart(t, b, c, d) {
      return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    },
    easeInOutQuart: function easeInOutQuart(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t * t * t + b;
      } else {
        return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
      }
    },
    easeInQuint: function easeInQuint(t, b, c, d) {
      return c * (t /= d) * t * t * t * t + b;
    },
    easeOutQuint: function easeOutQuint(t, b, c, d) {
      return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    easeInOutQuint: function easeInOutQuint(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t * t * t * t + b;
      } else {
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
      }
    },
    easeInSine: function easeInSine(t, b, c, d) {
      return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    },
    easeOutSine: function easeOutSine(t, b, c, d) {
      return c * Math.sin(t / d * (Math.PI / 2)) + b;
    },
    easeInOutSine: function easeInOutSine(t, b, c, d) {
      return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    },
    easeInExpo: function easeInExpo(t, b, c, d) {
      if (t === 0) {
        return b;
      } else {
        return c * Math.pow(2, 10 * (t / d - 1)) + b;
      }
    },
    easeOutExpo: function easeOutExpo(t, b, c, d) {
      if (t === d) {
        return b + c;
      } else {
        return c * (-Math.pow(2, -10 * t / d) + 1) + b;
      }
    },
    easeInOutExpo: function easeInOutExpo(t, b, c, d) {
      if (t === 0) {
        b;
      }
      if (t === d) {
        b + c;
      }
      if ((t /= d / 2) < 1) {
        return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      } else {
        return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
      }
    },
    easeInCirc: function easeInCirc(t, b, c, d) {
      return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
    },
    easeOutCirc: function easeOutCirc(t, b, c, d) {
      return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    },
    easeInOutCirc: function easeInOutCirc(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
      } else {
        return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
      }
    },
    easeInElastic: function easeInElastic(t, b, c, d) {
      var a, p, s;
      s = 1.70158;
      p = 0;
      a = c;
      if (t === 0) {
        b;
      } else if ((t /= d) === 1) {
        b + c;
      }
      if (!p) {
        p = d * .3;
      }
      if (a < Math.abs(c)) {
        a = c;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
      return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    easeOutElastic: function easeOutElastic(t, b, c, d) {
      var a, p, s;
      s = 1.70158;
      p = 0;
      a = c;
      if (t === 0) {
        b;
      } else if ((t /= d) === 1) {
        b + c;
      }
      if (!p) {
        p = d * .3;
      }
      if (a < Math.abs(c)) {
        a = c;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
      return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    easeInOutElastic: function easeInOutElastic(t, b, c, d) {
      var a, p, s;
      s = 1.70158;
      p = 0;
      a = c;
      if (t === 0) {
        b;
      } else if ((t /= d / 2) === 2) {
        b + c;
      }
      if (!p) {
        p = d * (.3 * 1.5);
      }
      if (a < Math.abs(c)) {
        a = c;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
      if (t < 1) {
        return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
      } else {
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
      }
    },
    easeInBack: function easeInBack(t, b, c, d, s) {
      if (s === void 0) {
        s = 1.70158;
      }
      return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    easeOutBack: function easeOutBack(t, b, c, d, s) {
      if (s === void 0) {
        s = 1.70158;
      }
      return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    easeInOutBack: function easeInOutBack(t, b, c, d, s) {
      if (s === void 0) {
        s = 1.70158;
      }
      if ((t /= d / 2) < 1) {
        return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
      } else {
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
      }
    },
    easeInBounce: function easeInBounce(t, b, c, d) {
      var v;
      v = penner.easeOutBounce(d - t, 0, c, d);
      return c - v + b;
    },
    easeOutBounce: function easeOutBounce(t, b, c, d) {
      if ((t /= d) < 1 / 2.75) {
        return c * (7.5625 * t * t) + b;
      } else if (t < 2 / 2.75) {
        return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
      } else if (t < 2.5 / 2.75) {
        return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
      } else {
        return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
      }
    },
    easeInOutBounce: function easeInOutBounce(t, b, c, d) {
      var v;
      if (t < d / 2) {
        v = penner.easeInBounce(t * 2, 0, c, d);
        return v * .5 + b;
      } else {
        v = penner.easeOutBounce(t * 2 - d, 0, c, d);
        return v * .5 + c * .5 + b;
      }
    }
  };

  umd(penner);
}).call(this);

/***/ }),

/***/ "nxZI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifierPropType = undefined;

var _propTypes = __webpack_require__("Ywoo");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var PrimitiveTypes = {
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  range: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  after: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date)
  }),
  before: _propTypes2.default.shape({
    before: _propTypes2.default.instanceOf(Date)
  })
};

var ModifierPropType = exports.ModifierPropType = _propTypes2.default.oneOfType([PrimitiveTypes.after, PrimitiveTypes.before, PrimitiveTypes.range, _propTypes2.default.func, _propTypes2.default.array]);

exports.default = PrimitiveTypes;
//# sourceMappingURL=PropTypes.js.map

/***/ }),

/***/ "o16n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Zoom; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_seating_map_minus_svg__ = __webpack_require__("VgON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_seating_map_minus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_seating_map_minus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_seating_map_plus_svg__ = __webpack_require__("uTLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_seating_map_plus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_seating_map_plus_svg__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Zoom = function (_Component) {
  _inherits(Zoom, _Component);

  function Zoom(props) {
    _classCallCheck(this, Zoom);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.seatingMap = props.seatingMap;
    _this.state = {
      zoom: 1
    };
    _this.onZoom = _this.onZoom.bind(_this);
    if (_this.seatingMap) {
      _this.seatingMap.listenForZoom ? _this.seatingMap.listenForZoom(_this.onZoom) : false;
    }
    return _this;
  }

  Zoom.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!this.seatingMap && nextProps.seatingMap) {
      this.seatingMap = nextProps.seatingMap;
      this.seatingMap.listenForZoom ? this.seatingMap.listenForZoom(this.onZoom) : false;
    }
  };

  Zoom.prototype.onZoom = function onZoom(zoom) {
    this.setState({ zoom: zoom });
  };

  Zoom.prototype.onZoomClick = function onZoomClick(perc) {
    var zoom = this.seatingMap.zoom(perc);
    this.setState({ zoom: zoom });
  };

  Zoom.prototype.render = function render() {
    var _this2 = this;

    var zoom = this.state.zoom;
    var left = this.props.left;

    if (this.seatingMap) {
      var zoomStyle = {
        background: "#FFFFFF",
        boxShadow: "0 1px 10px 2px rgba(32, 7, 64, 0.13)",
        borderRadius: 3,
        position: "absolute",
        top: 14
      };
      if (left) {
        zoomStyle.left = 14;
      } else {
        zoomStyle.right = 14;
      }
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        { style: zoomStyle },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "a",
          {
            style: {
              float: "left",
              margin: "11px 12px 13px 12px",
              cursor: "pointer",
              width: 14,
              height: 14
            },
            onClick: function onClick() {
              return _this2.onZoomClick(0.1);
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("img", { src: __WEBPACK_IMPORTED_MODULE_2__assets_images_seating_map_plus_svg___default.a, style: { width: 14, height: 14 } })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("div", {
          style: {
            width: 1,
            height: "40px",
            borderLeft: "2px solid #DEDEDE",
            float: "left"
          }
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "div",
          {
            style: {
              fontSize: 16,
              color: "#8E99A8",
              letterSpacing: -0.37,
              float: "left",
              marginTop: 9,
              marginLeft: 12,
              marginRight: 12
            }
          },
          (zoom * 100).toFixed(0) + "%"
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("div", {
          style: {
            width: 1,
            height: "40px",
            borderLeft: "2px solid #DEDEDE",
            float: "left"
          }
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "a",
          {
            style: {
              float: "left",
              margin: "11px 12px 13px 12px",
              cursor: "pointer",
              width: 14,
              height: 14
            },
            onClick: function onClick() {
              return _this2.onZoomClick(-0.1);
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("img", { src: __WEBPACK_IMPORTED_MODULE_1__assets_images_seating_map_minus_svg___default.a, style: { width: 14, height: 14 } })
        )
      );
    } else {
      return null;
    }
  };

  return Zoom;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "o6Mn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var Config_1 = __webpack_require__("gH/r");
var PIXI = __webpack_require__("ix37");
exports.seatWidth = 20;
exports.seatHeight = 20;
exports.iconWidth = 32;
exports.iconHeight = 32;
exports.circle_ns_64 = "circle_ns_64";
exports.circle_ns_256 = "circle_ns_256";
exports.circle_s_64 = "circle_s_64";
exports.circle_s_256 = "circle_s_256";
exports.circle_ass_64 = "circle_ass_64";
exports.circle_ass_256 = "circle_ass_256";
exports.circle_unass_64 = "circle_unass_64";
exports.circle_unass_256 = "circle_unass_256";
exports.circle_av_256 = "circle_av_256";
exports.circle_av_64 = "circle_av_64";
exports.circle_m_64 = "circle_m_64";
exports.circle_sel_64 = "circle_sel_64";
exports.circle_unav_256 = "circle_unav_256";
exports.circle_unav_64 = "circle_unav_64";
exports.square_ns_64 = "square_ns_64";
exports.square_ns_256 = "square_ns_256";
exports.square_s_64 = "square_s_64";
exports.square_s_256 = "square_s_256";
exports.lato = "lato";
exports.seatSelectedtexture = exports.circle_s_64;
exports.seatNotSelectedtexture = exports.circle_ns_64;
exports.seatAvailableTexture = exports.circle_av_64;
exports.seatUnavailableTexture = exports.circle_unav_64;
exports.seatAssignedTexture = exports.circle_ass_64;
exports.seatUnassignedTexture = exports.circle_unass_64;
exports.seatMovedTexture = exports.circle_m_64;
exports.seatMovedToTexture = exports.circle_sel_64;
exports.circleTableSelectedTexture = exports.circle_s_256;
exports.circleTableNotSelectedTexture = exports.circle_ns_256;
exports.circleTableAvailableTexture = exports.circle_av_256;
exports.circleTableUnavailableTexture = exports.circle_unav_256;
exports.circleTableAssignedTexture = exports.circle_ass_256;
exports.circleTableUnassignedTexture = exports.circle_unass_256;
exports.squareTableSelectedTexture = exports.square_s_256;
exports.squareTableNotSelectedTexture = exports.square_ns_256;
exports.circleObjectSelectedTexture = exports.circle_s_256;
exports.circleObjectNotSelectedTexture = exports.circle_ns_256;
exports.squareObjectSelectedTexture = exports.square_s_256;
exports.squareObjectNotSelectedTexture = exports.square_ns_256;
exports.barIcon = "bar";
exports.blindIcon = "blind";
exports.exitIcon = "exit";
exports.foodIcon = "food";
exports.smokingIcon = "smoking";
exports.stairsIcon = "stairs";
exports.wheelchairIcon = "wheelchair";
exports.bathroomIcon = "bathroom";
exports.dancefloorIcon = "dancefloor";
exports.firstAidIcon = "first_aid";
exports.infoIcon = "info";
exports.stageIcon = "stage";
exports.stairsUpDownIcon = "stairs_up_down";
exports.backArrowIcon = "back_arrow";
exports.background = "background";
exports.duplicateElementName = "duplicate";
exports.deleteElementName = "delete";
exports.rotateElementName = "rotate";
exports.font = "Helvetica";
exports.tableElements = [{
    sub: true,
    label: "Tables",
    value: "tables",
    data: [{
        label: "Round Table",
        value: "table-round"
    }, {
        label: "Square Table",
        value: "table-square"
    }]
}, {
    sub: false,
    label: "Sections",
    value: "section"
}];
PIXI.Graphics.prototype["drawBoundingBox"] = function (points) {
    var _this = this;

    var _points$ = points[0],
        x = _points$.x,
        y = _points$.y;

    this.moveTo(x, y);
    points.forEach(function (_ref) {
        var x = _ref.x,
            y = _ref.y;

        _this.lineTo(x, y);
        _this.arcTo(x, y, x, y, 55);
        _this.moveTo(x, y);
    });
    this.lineTo(x, y);
};
PIXI.Graphics.prototype["drawTicketTypeColor"] = function (colors, radius) {
    var _this2 = this;

    var numberOfColor = colors.length;
    var angles = Math.PI * 2 / numberOfColor;
    colors.forEach(function (color, i) {
        _this2.beginFill(color);
        _this2.lineStyle(0, 0xffffff);
        _this2.arc(0, 0, radius, angles * i, angles * (i + 1));
        _this2.endFill();
    });
};
function addDropShadow(displayObject) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var opts = {
        alpha: 0.5,
        blur: 2,
        color: 0x000000,
        distance: 5,
        quality: 4
    };
    for (var key in options) {
        opts[key] = options[key];
    }
    var bounds = displayObject.getBounds();
    var renderTexture = PIXI.RenderTexture.create(bounds.right, bounds.bottom);
    Config_1.default.app.renderer.render(displayObject, renderTexture);
    var dropShadow = new PIXI.Sprite(renderTexture);
    var blurFilter = new PIXI.filters.BlurFilter(opts.blur, opts.quality);
    dropShadow.x = opts.distance;
    dropShadow.y = opts.distance;
    dropShadow.alpha = opts.alpha;
    dropShadow.filters = [blurFilter];
    dropShadow.tint = opts.color;
    displayObject.addChildAt(dropShadow, 0);
    dropShadow.cacheAsBitmap = true;
}
exports.addDropShadow = addDropShadow;
PIXI.Graphics.prototype["drawDashedPolygon"] = function (polygons, x, y, rotation, dash, gap, offsetPercentage) {
    var i;
    var p1;
    var p2;
    var dashLeft = 0;
    var gapLeft = 0;
    if (offsetPercentage > 0) {
        var progressOffset = (dash + gap) * offsetPercentage;
        if (progressOffset < dash) dashLeft = dash - progressOffset;else gapLeft = gap - (progressOffset - dash);
    }
    var rotatedPolygons = [];
    for (i = 0; i < polygons.length; i++) {
        var p = { x: polygons[i].x, y: polygons[i].y };
        var cosAngle = Math.cos(rotation);
        var sinAngle = Math.sin(rotation);
        var dx = p.x;
        var dy = p.y;
        p.x = dx * cosAngle - dy * sinAngle;
        p.y = dx * sinAngle + dy * cosAngle;
        rotatedPolygons.push(p);
    }
    for (i = 0; i < rotatedPolygons.length; i++) {
        p1 = rotatedPolygons[i];
        if (i == rotatedPolygons.length - 1) p2 = rotatedPolygons[0];else p2 = rotatedPolygons[i + 1];
        var dx2 = p2.x - p1.x;
        var dy2 = p2.y - p1.y;
        var len = Math.sqrt(dx2 * dx2 + dy2 * dy2);
        var normal = { x: dx2 / len, y: dy2 / len };
        var progressOnLine = 0;
        this.moveTo(x + p1.x + gapLeft * normal.x, y + p1.y + gapLeft * normal.y);
        while (progressOnLine <= len) {
            progressOnLine += gapLeft;
            if (dashLeft > 0) progressOnLine += dashLeft;else progressOnLine += dash;
            if (progressOnLine > len) {
                dashLeft = progressOnLine - len;
                progressOnLine = len;
            } else {
                dashLeft = 0;
            }
            this.lineTo(x + p1.x + progressOnLine * normal.x, y + p1.y + progressOnLine * normal.y);
            progressOnLine += gap;
            if (progressOnLine > len && dashLeft == 0) {
                gapLeft = progressOnLine - len;
            } else {
                gapLeft = 0;
                this.moveTo(x + p1.x + progressOnLine * normal.x, y + p1.y + progressOnLine * normal.y);
            }
        }
    }
};
//# sourceMappingURL=Utils.js.map

/***/ }),

/***/ "o8yA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var SectionView_1 = __webpack_require__("x54R");
var InteractionManager_1 = __webpack_require__("dUAP");
var GeneralObject_1 = __webpack_require__("Gv70");
var bound_1 = __webpack_require__("USDo");

var SectionOverview = function () {
    function SectionOverview(sections, objects, actions, reservationMode) {
        var _this = this;

        _classCallCheck(this, SectionOverview);

        this.actions = actions;
        this.sectionsViews = sections.map(function (section) {
            return new SectionView_1.default(section, _this.actions, reservationMode);
        });
        this.objectViews = objects.map(function (object) {
            object.basicType = "object-sectionView";
            return new GeneralObject_1.default(object, _this.actions, reservationMode);
        });
        this.sectionViewContainer = new PIXI.Container();
        this.sectionsContainer = new PIXI.Container();
        this.objectsContainer = new PIXI.Container();
        this.interactionManager = InteractionManager_1.default.createInteractionManager();
        this.sectionViewContainer.visible = false;
        this.sectionsViews.forEach(function (sectionView) {
            return _this.sectionsContainer.addChild(sectionView.getContainer());
        });
        this.objectViews.forEach(function (objectView) {
            _this.objectsContainer.addChild(objectView.getContainer());
        });
        this.sectionViewContainer.addChild(this.sectionsContainer);
        this.sectionViewContainer.addChild(this.objectsContainer);
    }

    SectionOverview.createSectionOverviewView = function createSectionOverviewView(sections, objects, actions, reservationMode) {
        if (!SectionOverview.initialised) {
            SectionOverview.instance;
            SectionOverview.initialised = true;
            SectionOverview.instance = new SectionOverview(sections, objects, actions, reservationMode);
        }
        return SectionOverview.instance;
    };

    SectionOverview.getInstance = function getInstance() {
        return SectionOverview.instance;
    };

    SectionOverview.prototype.newSections = function newSections(sections) {
        var _this2 = this;

        this.sectionsViews = sections.map(function (section) {
            var currentSectionView = _this2.sectionsViews ? _this2.sectionsViews.find(function (sView) {
                return sView._id === section._id;
            }) : undefined;
            if (currentSectionView && currentSectionView.locked === true) {
                return currentSectionView;
            } else {
                return new SectionView_1.default(section, _this2.actions);
            }
        });
        this.sectionsContainer.removeChildren();
        this.sectionsViews.forEach(function (sectionView) {
            return _this2.sectionsContainer.addChild(sectionView.getContainer());
        });
    };

    SectionOverview.prototype.newObjects = function newObjects(objects) {
        var _this3 = this;

        this.objectViews = objects.map(function (object) {
            var currentObjectView = _this3.objectViews ? _this3.objectViews.find(function (oView) {
                return oView._id === object._id;
            }) : undefined;
            if (currentObjectView && currentObjectView.locked === true) {
                return currentObjectView;
            } else {
                object.basicType = "object-sectionView";
                return new GeneralObject_1.default(object, _this3.actions, true);
            }
        });
        this.objectsContainer.removeChildren();
        this.objectViews.forEach(function (objectView) {
            return _this3.objectsContainer.addChild(objectView.getContainer());
        });
    };

    SectionOverview.prototype.getDimensions = function getDimensions() {
        var sectionCorners = this.sectionsViews.map(function (section) {
            return section.getCorner();
        });
        var objectCorners = this.objectViews.map(function (object) {
            return object.getCorner();
        });
        var top = sectionCorners[0].top;
        var left = sectionCorners[0].left;
        var right = sectionCorners[0].right;
        var bottom = sectionCorners[0].bottom;
        sectionCorners.concat(objectCorners).forEach(function (corner) {
            if (top > corner.top) {
                top = corner.top;
            }
            if (left > corner.left) {
                left = corner.left;
            }
            if (bottom < corner.bottom) {
                bottom = corner.bottom;
            }
            if (right < corner.right) {
                right = corner.right;
            }
        });
        return {
            top: top,
            bottom: bottom,
            right: right,
            left: left
        };
    };

    SectionOverview.prototype.setSelectable = function setSelectable(applicableSections) {
        var _this4 = this;

        return applicableSections.map(function (_ref) {
            var _id = _ref._id,
                applicable = _ref.applicable;

            var section = _this4.sectionsViews.find(function (section) {
                return section._id === _id;
            });
            if (section && section.selectable(applicable)) {
                return _id;
            } else {
                return undefined;
            }
        }).filter(function (sectionId) {
            return sectionId !== undefined;
        });
    };

    SectionOverview.prototype.toJSON = function toJSON() {
        return {
            sections: this.sectionsViews.map(function (section) {
                return section.toJSON();
            }),
            objects: this.objectViews.map(function (object) {
                return object.toJSON();
            })
        };
    };

    SectionOverview.prototype.getContainer = function getContainer() {
        return this.sectionViewContainer;
    };

    SectionOverview.prototype.hide = function hide() {
        this.sectionViewContainer.visible = false;
    };

    SectionOverview.prototype.show = function show() {
        this.sectionViewContainer.visible = true;
    };

    SectionOverview.prototype.hasSections = function hasSections() {
        return this.sectionsViews.length > 0;
    };

    return SectionOverview;
}();

SectionOverview.initialised = false;
__decorate([bound_1.default], SectionOverview.prototype, "newSections", null);
__decorate([bound_1.default], SectionOverview.prototype, "newObjects", null);
__decorate([bound_1.default], SectionOverview.prototype, "getDimensions", null);
__decorate([bound_1.default], SectionOverview.prototype, "setSelectable", null);
__decorate([bound_1.default], SectionOverview.prototype, "toJSON", null);
__decorate([bound_1.default], SectionOverview.prototype, "getContainer", null);
__decorate([bound_1.default], SectionOverview.prototype, "hide", null);
__decorate([bound_1.default], SectionOverview.prototype, "show", null);
__decorate([bound_1.default], SectionOverview.prototype, "hasSections", null);
exports.default = SectionOverview;
//# sourceMappingURL=SectionOverview.js.map

/***/ }),

/***/ "oGbJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var ConstructionSprites_1 = __webpack_require__("U/Ks");
var ReservationSprites_1 = __webpack_require__("YB4n");
var loadFont = __webpack_require__("tq9m");
var Config_1 = __webpack_require__("gH/r");
function loadReservation(host, onConsole, callback) {
    var reservationSprites = ReservationSprites_1.default(host, onConsole);
    loadSprites(reservationSprites, host, callback);
}
exports.loadReservation = loadReservation;
function loadConstruction(host, callback) {
    var constructionSprites = ConstructionSprites_1.default(host);
    loadSprites(constructionSprites, host, callback);
}
exports.loadConstruction = loadConstruction;
function loadSprites(spriteObj, host, callback) {
    var loader = PIXI.loader;
    var loadingChain = loader;
    Object.keys(spriteObj).forEach(function (key) {
        if (!loader.resources[key]) {
            loadingChain = loadingChain.add(key, spriteObj[key]);
        }
    });
    loadingChain.load(function () {
        loadFont(host + "public/sprites/Lato-Regular-64.fnt", function (err, font) {
            Config_1.default.font = font;
            callback();
        });
    });
}
//# sourceMappingURL=SpriteLoader.js.map

/***/ }),

/***/ "oWLW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _math = __webpack_require__("e3iB");

var _utils = __webpack_require__("dDI1");

var _const = __webpack_require__("YEQi");

var _Texture = __webpack_require__("xUki");

var _Texture2 = _interopRequireDefault(_Texture);

var _Container2 = __webpack_require__("OzBO");

var _Container3 = _interopRequireDefault(_Container2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var tempPoint = new _math.Point();

/**
 * The Sprite object is the base for all textured objects that are rendered to the screen
 *
 * A sprite can be created directly from an image like this:
 *
 * ```js
 * let sprite = new PIXI.Sprite.fromImage('assets/image.png');
 * ```
 *
 * The more efficient way to create sprites is using a {@link PIXI.Spritesheet}:
 *
 * ```js
 * PIXI.loader.add("assets/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.loader.resources["assets/spritesheet.json"].spritesheet;
 *   let sprite = new PIXI.Sprite(sheet.textures["image.png"]);
 *   ...
 * }
 * ```
 *
 * @class
 * @extends PIXI.Container
 * @memberof PIXI
 */

var Sprite = function (_Container) {
    _inherits(Sprite, _Container);

    /**
     * @param {PIXI.Texture} texture - The texture for this sprite
     */
    function Sprite(texture) {
        _classCallCheck(this, Sprite);

        /**
         * The anchor sets the origin point of the texture.
         * The default is 0,0 or taken from the {@link PIXI.Texture#defaultAnchor|Texture}
         * passed to the constructor. A value of 0,0 means the texture's origin is the top left.
         * Setting the anchor to 0.5,0.5 means the texture's origin is centered.
         * Setting the anchor to 1,1 would mean the texture's origin point will be the bottom right corner.
         * Note: Updating the {@link PIXI.Texture#defaultAnchor} after a Texture is
         * created does _not_ update the Sprite's anchor values.
         *
         * @member {PIXI.ObservablePoint}
         * @private
         */
        var _this = _possibleConstructorReturn(this, _Container.call(this));

        _this._anchor = new _math.ObservablePoint(_this._onAnchorUpdate, _this, texture ? texture.defaultAnchor.x : 0, texture ? texture.defaultAnchor.y : 0);

        /**
         * The texture that the sprite is using
         *
         * @private
         * @member {PIXI.Texture}
         */
        _this._texture = null;

        /**
         * The width of the sprite (this is initially set by the texture)
         *
         * @private
         * @member {number}
         */
        _this._width = 0;

        /**
         * The height of the sprite (this is initially set by the texture)
         *
         * @private
         * @member {number}
         */
        _this._height = 0;

        /**
         * The tint applied to the sprite. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
         *
         * @private
         * @member {number}
         * @default 0xFFFFFF
         */
        _this._tint = null;
        _this._tintRGB = null;
        _this.tint = 0xFFFFFF;

        /**
         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL
         * @see PIXI.BLEND_MODES
         */
        _this.blendMode = _const.BLEND_MODES.NORMAL;

        /**
         * The shader that will be used to render the sprite. Set to null to remove a current shader.
         *
         * @member {PIXI.Filter|PIXI.Shader}
         */
        _this.shader = null;

        /**
         * An internal cached value of the tint.
         *
         * @private
         * @member {number}
         * @default 0xFFFFFF
         */
        _this.cachedTint = 0xFFFFFF;

        // call texture setter
        _this.texture = texture || _Texture2.default.EMPTY;

        /**
         * this is used to store the vertex data of the sprite (basically a quad)
         *
         * @private
         * @member {Float32Array}
         */
        _this.vertexData = new Float32Array(8);

        /**
         * This is used to calculate the bounds of the object IF it is a trimmed sprite
         *
         * @private
         * @member {Float32Array}
         */
        _this.vertexTrimmedData = null;

        _this._transformID = -1;
        _this._textureID = -1;

        _this._transformTrimmedID = -1;
        _this._textureTrimmedID = -1;

        /**
         * Plugin that is responsible for rendering this element.
         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
         *
         * @member {string}
         * @default 'sprite'
         */
        _this.pluginName = 'sprite';
        return _this;
    }

    /**
     * When the texture is updated, this event will fire to update the scale and frame
     *
     * @private
     */

    Sprite.prototype._onTextureUpdate = function _onTextureUpdate() {
        this._textureID = -1;
        this._textureTrimmedID = -1;
        this.cachedTint = 0xFFFFFF;

        // so if _width is 0 then width was not set..
        if (this._width) {
            this.scale.x = (0, _utils.sign)(this.scale.x) * this._width / this._texture.orig.width;
        }

        if (this._height) {
            this.scale.y = (0, _utils.sign)(this.scale.y) * this._height / this._texture.orig.height;
        }
    };

    /**
     * Called when the anchor position updates.
     *
     * @private
     */

    Sprite.prototype._onAnchorUpdate = function _onAnchorUpdate() {
        this._transformID = -1;
        this._transformTrimmedID = -1;
    };

    /**
     * calculates worldTransform * vertices, store it in vertexData
     */

    Sprite.prototype.calculateVertices = function calculateVertices() {
        if (this._transformID === this.transform._worldID && this._textureID === this._texture._updateID) {
            return;
        }

        this._transformID = this.transform._worldID;
        this._textureID = this._texture._updateID;

        // set the vertex data

        var texture = this._texture;
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;
        var vertexData = this.vertexData;
        var trim = texture.trim;
        var orig = texture.orig;
        var anchor = this._anchor;

        var w0 = 0;
        var w1 = 0;
        var h0 = 0;
        var h1 = 0;

        if (trim) {
            // if the sprite is trimmed and is not a tilingsprite then we need to add the extra
            // space before transforming the sprite coords.
            w1 = trim.x - anchor._x * orig.width;
            w0 = w1 + trim.width;

            h1 = trim.y - anchor._y * orig.height;
            h0 = h1 + trim.height;
        } else {
            w1 = -anchor._x * orig.width;
            w0 = w1 + orig.width;

            h1 = -anchor._y * orig.height;
            h0 = h1 + orig.height;
        }

        // xy
        vertexData[0] = a * w1 + c * h1 + tx;
        vertexData[1] = d * h1 + b * w1 + ty;

        // xy
        vertexData[2] = a * w0 + c * h1 + tx;
        vertexData[3] = d * h1 + b * w0 + ty;

        // xy
        vertexData[4] = a * w0 + c * h0 + tx;
        vertexData[5] = d * h0 + b * w0 + ty;

        // xy
        vertexData[6] = a * w1 + c * h0 + tx;
        vertexData[7] = d * h0 + b * w1 + ty;
    };

    /**
     * calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData
     * This is used to ensure that the true width and height of a trimmed texture is respected
     */

    Sprite.prototype.calculateTrimmedVertices = function calculateTrimmedVertices() {
        if (!this.vertexTrimmedData) {
            this.vertexTrimmedData = new Float32Array(8);
        } else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) {
            return;
        }

        this._transformTrimmedID = this.transform._worldID;
        this._textureTrimmedID = this._texture._updateID;

        // lets do some special trim code!
        var texture = this._texture;
        var vertexData = this.vertexTrimmedData;
        var orig = texture.orig;
        var anchor = this._anchor;

        // lets calculate the new untrimmed bounds..
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;

        var w1 = -anchor._x * orig.width;
        var w0 = w1 + orig.width;

        var h1 = -anchor._y * orig.height;
        var h0 = h1 + orig.height;

        // xy
        vertexData[0] = a * w1 + c * h1 + tx;
        vertexData[1] = d * h1 + b * w1 + ty;

        // xy
        vertexData[2] = a * w0 + c * h1 + tx;
        vertexData[3] = d * h1 + b * w0 + ty;

        // xy
        vertexData[4] = a * w0 + c * h0 + tx;
        vertexData[5] = d * h0 + b * w0 + ty;

        // xy
        vertexData[6] = a * w1 + c * h0 + tx;
        vertexData[7] = d * h0 + b * w1 + ty;
    };

    /**
    *
    * Renders the object using the WebGL renderer
    *
    * @private
    * @param {PIXI.WebGLRenderer} renderer - The webgl renderer to use.
    */

    Sprite.prototype._renderWebGL = function _renderWebGL(renderer) {
        this.calculateVertices();

        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    };

    /**
    * Renders the object using the Canvas renderer
    *
    * @private
    * @param {PIXI.CanvasRenderer} renderer - The renderer
    */

    Sprite.prototype._renderCanvas = function _renderCanvas(renderer) {
        renderer.plugins[this.pluginName].render(this);
    };

    /**
     * Updates the bounds of the sprite.
     *
     * @private
     */

    Sprite.prototype._calculateBounds = function _calculateBounds() {
        var trim = this._texture.trim;
        var orig = this._texture.orig;

        // First lets check to see if the current texture has a trim..
        if (!trim || trim.width === orig.width && trim.height === orig.height) {
            // no trim! lets use the usual calculations..
            this.calculateVertices();
            this._bounds.addQuad(this.vertexData);
        } else {
            // lets calculate a special trimmed bounds...
            this.calculateTrimmedVertices();
            this._bounds.addQuad(this.vertexTrimmedData);
        }
    };

    /**
     * Gets the local bounds of the sprite object.
     *
     * @param {PIXI.Rectangle} rect - The output rectangle.
     * @return {PIXI.Rectangle} The bounds.
     */

    Sprite.prototype.getLocalBounds = function getLocalBounds(rect) {
        // we can do a fast local bounds if the sprite has no children!
        if (this.children.length === 0) {
            this._bounds.minX = this._texture.orig.width * -this._anchor._x;
            this._bounds.minY = this._texture.orig.height * -this._anchor._y;
            this._bounds.maxX = this._texture.orig.width * (1 - this._anchor._x);
            this._bounds.maxY = this._texture.orig.height * (1 - this._anchor._y);

            if (!rect) {
                if (!this._localBoundsRect) {
                    this._localBoundsRect = new _math.Rectangle();
                }

                rect = this._localBoundsRect;
            }

            return this._bounds.getRectangle(rect);
        }

        return _Container.prototype.getLocalBounds.call(this, rect);
    };

    /**
     * Tests if a point is inside this sprite
     *
     * @param {PIXI.Point} point - the point to test
     * @return {boolean} the result of the test
     */

    Sprite.prototype.containsPoint = function containsPoint(point) {
        this.worldTransform.applyInverse(point, tempPoint);

        var width = this._texture.orig.width;
        var height = this._texture.orig.height;
        var x1 = -width * this.anchor.x;
        var y1 = 0;

        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
            y1 = -height * this.anchor.y;

            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
                return true;
            }
        }

        return false;
    };

    /**
     * Destroys this sprite and optionally its texture and children
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
     */

    Sprite.prototype.destroy = function destroy(options) {
        _Container.prototype.destroy.call(this, options);

        this._texture.off('update', this._onTextureUpdate, this);

        this._anchor = null;

        var destroyTexture = typeof options === 'boolean' ? options : options && options.texture;

        if (destroyTexture) {
            var destroyBaseTexture = typeof options === 'boolean' ? options : options && options.baseTexture;

            this._texture.destroy(!!destroyBaseTexture);
        }

        this._texture = null;
        this.shader = null;
    };

    // some helper functions..

    /**
     * Helper function that creates a new sprite based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @static
     * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source Source to create texture from
     * @return {PIXI.Sprite} The newly created sprite
     */

    Sprite.from = function from(source) {
        return new Sprite(_Texture2.default.from(source));
    };

    /**
     * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
     * The frame ids are created when a Texture packer file has been loaded
     *
     * @static
     * @param {string} frameId - The frame Id of the texture in the cache
     * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the frameId
     */

    Sprite.fromFrame = function fromFrame(frameId) {
        var texture = _utils.TextureCache[frameId];

        if (!texture) {
            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
        }

        return new Sprite(texture);
    };

    /**
     * Helper function that creates a sprite that will contain a texture based on an image url
     * If the image is not in the texture cache it will be loaded
     *
     * @static
     * @param {string} imageId - The image url of the texture
     * @param {boolean} [crossorigin=(auto)] - if you want to specify the cross-origin parameter
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
     *  see {@link PIXI.SCALE_MODES} for possible values
     * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the image id
     */

    Sprite.fromImage = function fromImage(imageId, crossorigin, scaleMode) {
        return new Sprite(_Texture2.default.fromImage(imageId, crossorigin, scaleMode));
    };

    /**
     * The width of the sprite, setting this will actually modify the scale to achieve the value set
     *
     * @member {number}
     */

    _createClass(Sprite, [{
        key: 'width',
        get: function get() {
            return Math.abs(this.scale.x) * this._texture.orig.width;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            var s = (0, _utils.sign)(this.scale.x) || 1;

            this.scale.x = s * value / this._texture.orig.width;
            this._width = value;
        }

        /**
         * The height of the sprite, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            return Math.abs(this.scale.y) * this._texture.orig.height;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            var s = (0, _utils.sign)(this.scale.y) || 1;

            this.scale.y = s * value / this._texture.orig.height;
            this._height = value;
        }

        /**
         * The anchor sets the origin point of the texture.
         * The default is 0,0 or taken from the {@link PIXI.Texture|Texture} passed to the constructor.
         * Setting the texture at a later point of time does not change the anchor.
         *
         * 0,0 means the texture's origin is the top left, 0.5,0.5 is the center, 1,1 the bottom right corner.
         *
         * @member {PIXI.ObservablePoint}
         */

    }, {
        key: 'anchor',
        get: function get() {
            return this._anchor;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._anchor.copy(value);
        }

        /**
         * The tint applied to the sprite. This is a hex value.
         * A value of 0xFFFFFF will remove any tint effect.
         *
         * @member {number}
         * @default 0xFFFFFF
         */

    }, {
        key: 'tint',
        get: function get() {
            return this._tint;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._tint = value;
            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
        }

        /**
         * The texture that the sprite is using
         *
         * @member {PIXI.Texture}
         */

    }, {
        key: 'texture',
        get: function get() {
            return this._texture;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._texture === value) {
                return;
            }

            this._texture = value || _Texture2.default.EMPTY;
            this.cachedTint = 0xFFFFFF;

            this._textureID = -1;
            this._textureTrimmedID = -1;

            if (value) {
                // wait for the texture to load
                if (value.baseTexture.hasLoaded) {
                    this._onTextureUpdate();
                } else {
                    value.once('update', this._onTextureUpdate, this);
                }
            }
        }
    }]);

    return Sprite;
}(_Container3.default);

exports.default = Sprite;
//# sourceMappingURL=Sprite.js.map

/***/ }),

/***/ "oXPp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLManager2 = __webpack_require__("ClQe");

var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Base for a common object renderer that can be used as a system renderer plugin.
 *
 * @class
 * @extends PIXI.WebGLManager
 * @memberof PIXI
 */
var ObjectRenderer = function (_WebGLManager) {
  _inherits(ObjectRenderer, _WebGLManager);

  function ObjectRenderer() {
    _classCallCheck(this, ObjectRenderer);

    return _possibleConstructorReturn(this, _WebGLManager.apply(this, arguments));
  }

  /**
   * Starts the renderer and sets the shader
   *
   */
  ObjectRenderer.prototype.start = function start() {}
  // set the shader..


  /**
   * Stops the renderer
   *
   */
  ;

  ObjectRenderer.prototype.stop = function stop() {
    this.flush();
  };

  /**
   * Stub method for rendering content and emptying the current batch.
   *
   */

  ObjectRenderer.prototype.flush = function flush() {}
  // flush!


  /**
   * Renders an object
   *
   * @param {PIXI.DisplayObject} object - The object to render.
   */
  ;

  ObjectRenderer.prototype.render = function render(object) // eslint-disable-line no-unused-vars
  {
    // render the object
  };

  return ObjectRenderer;
}(_WebGLManager3.default);

exports.default = ObjectRenderer;
//# sourceMappingURL=ObjectRenderer.js.map

/***/ }),

/***/ "ogP8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;

var _DateUtils = __webpack_require__("s8Q5");

var _Helpers = __webpack_require__("2M8e");

/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, _DateUtils.isSameDay)(day, mod);
    }
    if ((0, _Helpers.isRangeOfDates)(mod)) {
      return (0, _DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, _DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),

/***/ "p/oJ":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

/***/ }),

/***/ "p/wO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _const = __webpack_require__("YEQi");

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * The Rounded Rectangle object is an area that has nice rounded corners, as indicated by its
 * top-left corner point (x, y) and by its width and its height and its radius.
 *
 * @class
 * @memberof PIXI
 */
var RoundedRectangle = function () {
    /**
     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rounded rectangle
     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rounded rectangle
     * @param {number} [width=0] - The overall width of this rounded rectangle
     * @param {number} [height=0] - The overall height of this rounded rectangle
     * @param {number} [radius=20] - Controls the radius of the rounded corners
     */
    function RoundedRectangle() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var radius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 20;

        _classCallCheck(this, RoundedRectangle);

        /**
         * @member {number}
         * @default 0
         */
        this.x = x;

        /**
         * @member {number}
         * @default 0
         */
        this.y = y;

        /**
         * @member {number}
         * @default 0
         */
        this.width = width;

        /**
         * @member {number}
         * @default 0
         */
        this.height = height;

        /**
         * @member {number}
         * @default 20
         */
        this.radius = radius;

        /**
         * The type of the object, mainly used to avoid `instanceof` checks
         *
         * @member {number}
         * @readonly
         * @default PIXI.SHAPES.RREC
         * @see PIXI.SHAPES
         */
        this.type = _const.SHAPES.RREC;
    }

    /**
     * Creates a clone of this Rounded Rectangle
     *
     * @return {PIXI.RoundedRectangle} a copy of the rounded rectangle
     */

    RoundedRectangle.prototype.clone = function clone() {
        return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
    };

    /**
     * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
     *
     * @param {number} x - The X coordinate of the point to test
     * @param {number} y - The Y coordinate of the point to test
     * @return {boolean} Whether the x/y coordinates are within this Rounded Rectangle
     */

    RoundedRectangle.prototype.contains = function contains(x, y) {
        if (this.width <= 0 || this.height <= 0) {
            return false;
        }
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                if (y >= this.y + this.radius && y <= this.y + this.height - this.radius || x >= this.x + this.radius && x <= this.x + this.width - this.radius) {
                    return true;
                }
                var dx = x - (this.x + this.radius);
                var dy = y - (this.y + this.radius);
                var radius2 = this.radius * this.radius;

                if (dx * dx + dy * dy <= radius2) {
                    return true;
                }
                dx = x - (this.x + this.width - this.radius);
                if (dx * dx + dy * dy <= radius2) {
                    return true;
                }
                dy = y - (this.y + this.height - this.radius);
                if (dx * dx + dy * dy <= radius2) {
                    return true;
                }
                dx = x - (this.x + this.radius);
                if (dx * dx + dy * dy <= radius2) {
                    return true;
                }
            }
        }

        return false;
    };

    return RoundedRectangle;
}();

exports.default = RoundedRectangle;
//# sourceMappingURL=RoundedRectangle.js.map

/***/ }),

/***/ "p2oQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var bound_1 = __webpack_require__("USDo");
var GeneralObject_1 = __webpack_require__("Gv70");
var Config_1 = __webpack_require__("gH/r");
var BackButton_1 = __webpack_require__("ainW");
var Section_1 = __webpack_require__("TbMi");

var SeatingReservation = function () {
    function SeatingReservation(_ref, actions) {
        var _this = this;

        var sections = _ref.sections,
            _ref$objects = _ref.objects,
            objects = _ref$objects === undefined ? [] : _ref$objects;

        _classCallCheck(this, SeatingReservation);

        this.actions = actions;
        this.ticketMapping = {};
        this.actions.onTicketMapped = this.onTicketMapped;
        this.actions.onTicketUnmapped = this.onTicketUnmapped;
        this.sections = sections.map(function (section, i) {
            section.sectionId = i;
            return new Section_1.default(section, _this.actions);
        });
        this.objects = objects.map(function (object, i) {
            object.objectId = i;
            return new GeneralObject_1.default(object, _this.actions, true);
        });
        this.seatingReservationContainer = new PIXI.Container();
        this.mask = new PIXI.Graphics();
        this.mask.visible = true;
        this.sectionContainer = new PIXI.Container();
        this.sections.forEach(function (section) {
            return _this.sectionContainer.addChild(section.getSectionContainer());
        });
        this.sectionContainer.removeChildAt(this.sections.length - 1);
        this.sectionContainer.addChild(this.mask);
        this.sectionContainer.addChild(this.sections[this.sections.length - 1].getSectionContainer());
        this.objectContainer = new PIXI.Container();
        this.objects.forEach(function (object) {
            return _this.objectContainer.addChild(object.getContainer());
        });
        this.seatingReservationContainer.addChild(this.sectionContainer);
        this.seatingReservationContainer.addChild(this.objectContainer);
        var bounds = this.seatingReservationContainer.getBounds();
        this.mask.beginFill(0xFFFFFF, 0.7);
        this.mask.drawRect(bounds.x * 4, bounds.y * 4, bounds.width * 4, bounds.height * 4);
        this.mask.endFill();
        this.mask.visible = false;
        this.backButton = new BackButton_1.default();
    }

    SeatingReservation.createSeatingReservationView = function createSeatingReservationView(seatingMapData, actions) {
        SeatingReservation.instance = new SeatingReservation(seatingMapData, actions);
        return SeatingReservation.instance;
    };

    SeatingReservation.getInstance = function getInstance() {
        return SeatingReservation.instance;
    };

    SeatingReservation.prototype.listenOnzoom = function listenOnzoom() {
        var _this2 = this;

        var scale = Config_1.default.viewport.scale;

        var isShowingSeat = void 0,
            isShowingTable = void 0;
        if (scale._x >= 0.80) {
            isShowingSeat = true;
            this.sections.forEach(function (section) {
                return section.showTextSeat(true);
            });
        } else {
            isShowingSeat = false;
            this.sections.forEach(function (section) {
                return section.showTextSeat(false);
            });
        }
        Config_1.default.viewport.on("zoomed", function (_ref2) {
            var viewport = _ref2.viewport;
            var scale = viewport.scale;

            if (scale._x >= 0.80 && !isShowingSeat) {
                _this2.sections.forEach(function (section) {
                    return section.showTextSeat(true);
                });
                isShowingSeat = true;
            } else if (scale._x < 0.80 && isShowingSeat) {
                _this2.sections.forEach(function (section) {
                    return section.showTextSeat(false);
                });
                isShowingSeat = false;
            }
        });
    };

    SeatingReservation.prototype.getBackButtonContainer = function getBackButtonContainer() {
        return this.backButton.getContainer();
    };

    SeatingReservation.prototype.setTicketMapping = function setTicketMapping(ticketMapping) {
        this.ticketMapping = ticketMapping;
    };

    SeatingReservation.prototype.onTicketMapped = function onTicketMapped(ticketTypeId, currentTicketData, packageId, seatLoc) {
        if (!this.ticketMapping[ticketTypeId]) {
            this.ticketMapping[ticketTypeId] = [];
        }
        this.ticketMapping[ticketTypeId] = this.ticketMapping[ticketTypeId].concat(currentTicketData);
        this.actions.onTicketMapCompleted(packageId || currentTicketData[0].ticketId, seatLoc);
    };

    SeatingReservation.prototype.onTicketUnmapped = function onTicketUnmapped(ticketTypeId, ticketId, unmappedSeatIds) {
        this.ticketMapping[ticketTypeId] = this.ticketMapping[ticketTypeId].filter(function (m) {
            return !unmappedSeatIds.includes(m.seatId);
        });
        this.actions.onTicketMapDeselected(ticketId);
    };

    SeatingReservation.prototype.mapExistingTicket = function mapExistingTicket(ticketId, ticketTypeId, packageGroupId, packageId, sectionId, tableId, seatId) {
        this.sections.forEach(function (section) {
            return section.mapExistingTicket(ticketId, ticketTypeId, packageGroupId, packageId, sectionId, tableId, seatId);
        });
    };

    SeatingReservation.prototype.getTicketMapping = function getTicketMapping() {
        return this.ticketMapping;
    };

    SeatingReservation.prototype.ticketsSelected = function ticketsSelected(ticketData) {
        this.ticketData = ticketData;
        if (!this.ticketMapping[ticketData.ticketTypeId]) {
            this.ticketMapping[ticketData.ticketTypeId] = [];
        }
        this.sections.forEach(function (section) {
            return section.setTicketMapping(ticketData);
        });
        return this.sections.map(function (section) {
            return section.applicableTicketType(ticketData.ticketTypeId);
        });
    };

    SeatingReservation.prototype.deselectTicket = function deselectTicket(sectionId, tableId, seatId) {
        this.sections.find(function (section) {
            return section.id === sectionId;
        }).tables.find(function (table) {
            return table.id === tableId;
        }).unselectSeat(seatId);
    };

    SeatingReservation.prototype.disableSeat = function disableSeat(sectionId, tableId, seatId) {
        this.sections.find(function (section) {
            return section.id === sectionId;
        }).tables.find(function (table) {
            return table.id === tableId;
        }).disableSeat(seatId);
    };

    SeatingReservation.prototype.focusOnSection = function focusOnSection(sectionId) {
        var sectionBounds = void 0;
        this.sections.forEach(function (section) {
            var focused = section.determineFocus(sectionId);
            if (focused) {
                sectionBounds = section.getDimensions();
            }
        });
        return sectionBounds;
    };

    SeatingReservation.prototype.getDimensions = function getDimensions() {
        var dim = this.sections[0].getBounds();
        var top = dim.top;
        var bottom = dim.bottom;
        var left = dim.left;
        var right = dim.right;
        var objectDim = this.objects.map(function (object) {
            return object.getCorner();
        });
        var sectionDim = this.sections.map(function (section) {
            return section.getBounds();
        });
        objectDim.concat(sectionDim).forEach(function (dimension) {
            if (dimension.left < left) {
                left = dimension.left;
            }
            if (dimension.right > right) {
                right = dimension.right;
            }
            if (dimension.top < top) {
                top = dimension.top;
            }
            if (dimension.bottom > bottom) {
                bottom = dimension.bottom;
            }
        });
        return {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
    };

    SeatingReservation.prototype.getContainer = function getContainer() {
        return this.seatingReservationContainer;
    };

    SeatingReservation.prototype.hide = function hide() {
        this.seatingReservationContainer.visible = false;
        if (this.backButton) {
            this.backButton.hide();
        }
    };

    SeatingReservation.prototype.show = function show() {
        this.seatingReservationContainer.visible = true;
        if (this.backButton) {
            this.backButton.show();
        }
    };

    return SeatingReservation;
}();

SeatingReservation.initialised = false;
__decorate([bound_1.default], SeatingReservation.prototype, "listenOnzoom", null);
__decorate([bound_1.default], SeatingReservation.prototype, "getBackButtonContainer", null);
__decorate([bound_1.default], SeatingReservation.prototype, "setTicketMapping", null);
__decorate([bound_1.default], SeatingReservation.prototype, "onTicketMapped", null);
__decorate([bound_1.default], SeatingReservation.prototype, "onTicketUnmapped", null);
__decorate([bound_1.default], SeatingReservation.prototype, "mapExistingTicket", null);
__decorate([bound_1.default], SeatingReservation.prototype, "getTicketMapping", null);
__decorate([bound_1.default], SeatingReservation.prototype, "ticketsSelected", null);
__decorate([bound_1.default], SeatingReservation.prototype, "deselectTicket", null);
__decorate([bound_1.default], SeatingReservation.prototype, "disableSeat", null);
__decorate([bound_1.default], SeatingReservation.prototype, "focusOnSection", null);
__decorate([bound_1.default], SeatingReservation.prototype, "getDimensions", null);
__decorate([bound_1.default], SeatingReservation.prototype, "getContainer", null);
__decorate([bound_1.default], SeatingReservation.prototype, "hide", null);
__decorate([bound_1.default], SeatingReservation.prototype, "show", null);
exports.default = SeatingReservation;
//# sourceMappingURL=SeatingReservation.js.map

/***/ }),

/***/ "p35m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * TimeLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
 * number of milliseconds per frame.
 *
 * @class
 * @memberof PIXI
 */
var TimeLimiter = function () {
  /**
   * @param {number} maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame.
   */
  function TimeLimiter(maxMilliseconds) {
    _classCallCheck(this, TimeLimiter);

    /**
     * The maximum milliseconds that can be spent preparing items each frame.
     * @private
     */
    this.maxMilliseconds = maxMilliseconds;
    /**
     * The start time of the current frame.
     * @type {number}
     * @private
     */
    this.frameStart = 0;
  }

  /**
   * Resets any counting properties to start fresh on a new frame.
   */

  TimeLimiter.prototype.beginFrame = function beginFrame() {
    this.frameStart = Date.now();
  };

  /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @return {boolean} If the item is allowed to be uploaded.
   */

  TimeLimiter.prototype.allowedToUpload = function allowedToUpload() {
    return Date.now() - this.frameStart < this.maxMilliseconds;
  };

  return TimeLimiter;
}();

exports.default = TimeLimiter;
//# sourceMappingURL=TimeLimiter.js.map

/***/ }),

/***/ "p4CC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = mapWebGLDrawModesToPixi;

var _const = __webpack_require__("YEQi");

/**
 * Generic Mask Stack data structure.
 *
 * @memberof PIXI
 * @function mapWebGLDrawModesToPixi
 * @private
 * @param {WebGLRenderingContext} gl - The current WebGL drawing context
 * @param {object} [object={}] - The object to map into
 * @return {object} The mapped draw modes.
 */
function mapWebGLDrawModesToPixi(gl) {
  var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  object[_const.DRAW_MODES.POINTS] = gl.POINTS;
  object[_const.DRAW_MODES.LINES] = gl.LINES;
  object[_const.DRAW_MODES.LINE_LOOP] = gl.LINE_LOOP;
  object[_const.DRAW_MODES.LINE_STRIP] = gl.LINE_STRIP;
  object[_const.DRAW_MODES.TRIANGLES] = gl.TRIANGLES;
  object[_const.DRAW_MODES.TRIANGLE_STRIP] = gl.TRIANGLE_STRIP;
  object[_const.DRAW_MODES.TRIANGLE_FAN] = gl.TRIANGLE_FAN;

  return object;
}
//# sourceMappingURL=mapWebGLDrawModesToPixi.js.map

/***/ }),

/***/ "pKi2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var bound_1 = __webpack_require__("USDo");
var Seat_1 = __webpack_require__("qrdL");
var Utils_1 = __webpack_require__("o6Mn");

var Seat = function (_Seat_1$default) {
    _inherits(Seat, _Seat_1$default);

    function Seat(seatData, actions, disableInteraction) {
        _classCallCheck(this, Seat);

        var _this = _possibleConstructorReturn(this, _Seat_1$default.call(this, seatData, actions, disableInteraction, true));

        _this.isRow = seatData.isRow;
        _this.selectedGraphics = new PIXI.Graphics();
        _this.selectedGraphics.lineStyle(0);
        _this.selectedGraphics.beginFill(0xFFFFFF, 1);
        _this.selectedGraphics.drawCircle(0, 0, Utils_1.seatWidth / 4);
        _this.selectedGraphics.endFill();
        if (!_this.bookByTable && !_this.locked && !_this.reserved && !_this.disabled) {}
        return _this;
    }

    Seat.prototype.isUnavailable = function isUnavailable() {
        return this.reserved || this.locked || this.held || !this.valid;
    };

    Seat.prototype.mapTicket = function mapTicket(mappedTicketId, mappedTicketTypeId) {
        this.mappedTicketId = mappedTicketId;
        this.mappedTicketTypeId = String(mappedTicketTypeId);
        this.selected = true;
        this.reserved = false;
        this.setTexture();
        return {
            seatId: this._id,
            tableId: this.tableId,
            sectionId: this.sectionId,
            ticketId: this.mappedTicketId,
            name: this.name
        };
    };

    Seat.prototype.unmapTicket = function unmapTicket() {
        this.mappedTicketId = undefined;
        this.mappedTicketTypeId = undefined;
        this.selected = false;
        this.setTexture();
        return this._id;
    };

    Seat.prototype.removeMappedTicket = function removeMappedTicket() {
        this.mappedTicketId = undefined;
        this.selected = false;
    };

    Seat.prototype.deSelect = function deSelect() {
        this.selected = false;
        if (this.mappedTicketId === this.ticketData.ticketId) {
            this.ticketData.allocated = false;
        }
        var ticketId = String(this.mappedTicketId);
        var ticketTypeId = String(this.mappedTicketTypeId);
        var result = this.unmapTicket();
        this.actions.onTicketUnmapped(ticketTypeId, ticketId, [result]);
    };

    Seat.prototype.onClick = function onClick() {
        if (!this.bookByTable && !this.locked && !this.reserved && this.valid) {
            if (!this.mappedTicketId) {
                if (!this.ticketData.allocated) {
                    this.ticketData.allocated = true;
                    this.selected = true;
                    var result = this.mapTicket(this.ticketData.ticketId, this.ticketData.ticketTypeId);
                    console.log("this.name", this.name);
                    this.actions.onTicketMapped(this.ticketData.ticketTypeId, [result], null, { seatName: this.name, tableName: this.isRow ? "" : this.tableName, sectionName: this.sectionName, isRow: this.isRow });
                }
            } else {
                this.deSelect();
            }
        }
    };

    Seat.prototype.mapExistingTicket = function mapExistingTicket(ticketId, ticketTypeId, seatId) {
        if (seatId === this._id) {
            this.ticketData.allocated = true;
            this.selected = true;
            this.mappedTicketId = ticketId;
            this.mappedTicketTypeId = ticketTypeId;
            this.reserved = false;
            this.setTexture();
            this.setupInteraction();
            this.actions.onTicketMapped(ticketTypeId, [{ ticketId: ticketId }], null, { seatName: this.label, tableName: this.tableName, sectionName: this.sectionName });
        }
    };

    Seat.prototype.determineFocus = function determineFocus(focused) {
        this.focused = focused;
        this.setTexture();
    };

    Seat.prototype.setTicketMapping = function setTicketMapping(currentTicketData, dontLock) {
        this.ticketData = currentTicketData;
        this.setTexture();
        if (dontLock || this.ticketIds.includes(this.ticketData.ticketTypeId)) {
            this.valid = true;
        } else {
            this.valid = false;
        }
    };

    Seat.prototype.onTableSelected = function onTableSelected() {
        this.tableSelected = true;
        this.setTexture();
    };

    Seat.prototype.onTableDeselected = function onTableDeselected() {
        this.tableSelected = false;
        this.setTexture();
    };

    Seat.prototype.determineTextureType = function determineTextureType() {
        var textureName = void 0;
        if (this.reserved || this.locked || !(this.valid && this.focused)) {
            textureName = Utils_1.seatUnavailableTexture;
        } else {
            textureName = this.selected ? Utils_1.seatSelectedtexture : Utils_1.seatAvailableTexture;
        }
        this.seatTexture = PIXI.loader.resources[textureName].texture;
        this.seatTexture.baseTexture.mipmap = true;
    };

    Seat.prototype.createClickFor = function createClickFor(target) {
        target.interactive = true;
        target.on("mousedown", function (e) {});
    };

    return Seat;
}(Seat_1.default);

__decorate([bound_1.default], Seat.prototype, "isUnavailable", null);
__decorate([bound_1.default], Seat.prototype, "mapTicket", null);
__decorate([bound_1.default], Seat.prototype, "unmapTicket", null);
__decorate([bound_1.default], Seat.prototype, "removeMappedTicket", null);
__decorate([bound_1.default], Seat.prototype, "deSelect", null);
__decorate([bound_1.default], Seat.prototype, "onClick", null);
__decorate([bound_1.default], Seat.prototype, "mapExistingTicket", null);
__decorate([bound_1.default], Seat.prototype, "determineFocus", null);
__decorate([bound_1.default], Seat.prototype, "setTicketMapping", null);
__decorate([bound_1.default], Seat.prototype, "onTableSelected", null);
__decorate([bound_1.default], Seat.prototype, "onTableDeselected", null);
__decorate([bound_1.default], Seat.prototype, "determineTextureType", null);
__decorate([bound_1.default], Seat.prototype, "createClickFor", null);
exports.default = Seat;
//# sourceMappingURL=Seat.js.map

/***/ }),

/***/ "pWxZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};

/***/ }),

/***/ "pZ9z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = mapCanvasBlendModesToPixi;

var _const = __webpack_require__("YEQi");

var _canUseNewCanvasBlendModes = __webpack_require__("StZv");

var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Maps blend combinations to Canvas.
 *
 * @memberof PIXI
 * @function mapCanvasBlendModesToPixi
 * @private
 * @param {string[]} [array=[]] - The array to output into.
 * @return {string[]} Mapped modes.
 */
function mapCanvasBlendModesToPixi() {
    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if ((0, _canUseNewCanvasBlendModes2.default)()) {
        array[_const.BLEND_MODES.NORMAL] = 'source-over';
        array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
        array[_const.BLEND_MODES.MULTIPLY] = 'multiply';
        array[_const.BLEND_MODES.SCREEN] = 'screen';
        array[_const.BLEND_MODES.OVERLAY] = 'overlay';
        array[_const.BLEND_MODES.DARKEN] = 'darken';
        array[_const.BLEND_MODES.LIGHTEN] = 'lighten';
        array[_const.BLEND_MODES.COLOR_DODGE] = 'color-dodge';
        array[_const.BLEND_MODES.COLOR_BURN] = 'color-burn';
        array[_const.BLEND_MODES.HARD_LIGHT] = 'hard-light';
        array[_const.BLEND_MODES.SOFT_LIGHT] = 'soft-light';
        array[_const.BLEND_MODES.DIFFERENCE] = 'difference';
        array[_const.BLEND_MODES.EXCLUSION] = 'exclusion';
        array[_const.BLEND_MODES.HUE] = 'hue';
        array[_const.BLEND_MODES.SATURATION] = 'saturate';
        array[_const.BLEND_MODES.COLOR] = 'color';
        array[_const.BLEND_MODES.LUMINOSITY] = 'luminosity';
    } else {
        // this means that the browser does not support the cool new blend modes in canvas 'cough' ie 'cough'
        array[_const.BLEND_MODES.NORMAL] = 'source-over';
        array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
        array[_const.BLEND_MODES.MULTIPLY] = 'source-over';
        array[_const.BLEND_MODES.SCREEN] = 'source-over';
        array[_const.BLEND_MODES.OVERLAY] = 'source-over';
        array[_const.BLEND_MODES.DARKEN] = 'source-over';
        array[_const.BLEND_MODES.LIGHTEN] = 'source-over';
        array[_const.BLEND_MODES.COLOR_DODGE] = 'source-over';
        array[_const.BLEND_MODES.COLOR_BURN] = 'source-over';
        array[_const.BLEND_MODES.HARD_LIGHT] = 'source-over';
        array[_const.BLEND_MODES.SOFT_LIGHT] = 'source-over';
        array[_const.BLEND_MODES.DIFFERENCE] = 'source-over';
        array[_const.BLEND_MODES.EXCLUSION] = 'source-over';
        array[_const.BLEND_MODES.HUE] = 'source-over';
        array[_const.BLEND_MODES.SATURATION] = 'source-over';
        array[_const.BLEND_MODES.COLOR] = 'source-over';
        array[_const.BLEND_MODES.LUMINOSITY] = 'source-over';
    }
    // not-premultiplied, only for webgl
    array[_const.BLEND_MODES.NORMAL_NPM] = array[_const.BLEND_MODES.NORMAL];
    array[_const.BLEND_MODES.ADD_NPM] = array[_const.BLEND_MODES.ADD];
    array[_const.BLEND_MODES.SCREEN_NPM] = array[_const.BLEND_MODES.SCREEN];

    return array;
}
//# sourceMappingURL=mapCanvasBlendModesToPixi.js.map

/***/ }),

/***/ "pb6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__("dZBD");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./config.js
var config = __webpack_require__("aSYM");

// CONCATENATED MODULE: ./services/MerchandiseService.js



var MerchandiseService = {
  list: function list(id) {
    return new Promise(function (resolve, reject) {
      axios_default.a.get(Object(config["a" /* default */])("API_URL") + "merchandise/" + id + "/list").then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  create: function create(orderId, merchData) {
    return new Promise(function (resolve, reject) {
      axios_default.a.put(Object(config["a" /* default */])("API_URL") + "merchandise/" + orderId + "/create", merchData).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getMerch: function getMerch(orderId) {
    return new Promise(function (resolve, reject) {
      axios_default.a.get(Object(config["a" /* default */])("API_URL") + "merchandise/" + orderId).then(function (response) {
        resolve(response.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};
/* harmony default export */ var services_MerchandiseService = (MerchandiseService);
// EXTERNAL MODULE: ./utils/normaliseMerchandiseData.js
var normaliseMerchandiseData = __webpack_require__("awkt");

// CONCATENATED MODULE: ./state/actions/merchandiseActions.js
/* unused harmony export CLEAR_ORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_MERCHANDISE_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_MERCHANDISE_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_MERCHANDISE_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_MERCHANDISE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_MERCHANDISE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_MERCHANDISE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_MERCHANDISE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_MERCHANDISE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_MERCHANDISE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RESET_MERCHANDISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return resetMerchOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return merchandiseActions_listMerchandise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return merchandiseActions_createMerchandiseOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return merchandiseActions_getMerchandise; });



var CLEAR_ORDER = "CLEAR_ORDER";

var GET_MERCHANDISE_LIST_REQUEST = "GET_MERCHANDISE_LIST_REQUEST";
var GET_MERCHANDISE_LIST_SUCCESS = "GET_MERCHANDISE_LIST_SUCCESS";
var GET_MERCHANDISE_LIST_ERROR = "GET_MERCHANDISE_LIST_ERROR";

var CREATE_MERCHANDISE_REQUEST = "CREATE_MERCHANDISE_REQUEST";
var CREATE_MERCHANDISE_SUCCESS = "CREATE_MERCHANDISE_SUCCESS";
var CREATE_MERCHANDISE_ERROR = "CREATE_MERCHANDISE_ERROR";

var GET_MERCHANDISE_REQUEST = "GET_MERCHANDISE_REQUEST";
var GET_MERCHANDISE_SUCCESS = "GET_MERCHANDISE_SUCCESS";
var GET_MERCHANDISE_ERROR = "GET_MERCHANDISE_ERROR";

var RESET_MERCHANDISE = "RESET_MERCHANDISE";

var resetMerchOrder = function resetMerchOrder() {
  return function (dispatch) {
    dispatch({ type: RESET_MERCHANDISE });
  };
};

var merchandiseActions_listMerchandise = function listMerchandise(orderId) {
  return function (dispatch) {
    dispatch({ type: GET_MERCHANDISE_LIST_REQUEST });
    services_MerchandiseService.list(orderId).then(function (merchList) {
      dispatch({ type: GET_MERCHANDISE_LIST_SUCCESS, merchList: merchList });
    }).catch(function (err) {
      dispatch({ type: GET_MERCHANDISE_LIST_ERROR, error: err });
    });
  };
};

var merchandiseActions_createMerchandiseOrder = function createMerchandiseOrder(eventSlug, orderId, merchData) {
  var normalisedMerchData = Object(normaliseMerchandiseData["a" /* default */])(merchData);
  return function (dispatch) {
    dispatch({ type: CREATE_MERCHANDISE_REQUEST });
    services_MerchandiseService.create(orderId, normalisedMerchData).then(function (merch) {
      if (merch.soldOut) {
        preact_router_es["Router"].route("/" + eventSlug + "/add-ons/" + orderId);
        dispatch({
          type: GET_MERCHANDISE_LIST_SUCCESS,
          merchList: merch.merchList
        });
        dispatch({
          type: CREATE_MERCHANDISE_ERROR,
          error: "Some add-ons selected are now sold out"
        });
      } else {
        dispatch({
          type: CREATE_MERCHANDISE_SUCCESS,
          data: merch
        });
        preact_router_es["Router"].route("/" + eventSlug + "/details/" + orderId);
      }
    }).catch(function (err) {
      dispatch({ type: CREATE_MERCHANDISE_ERROR, error: err });
    });
  };
};

var merchandiseActions_getMerchandise = function getMerchandise(orderId) {
  return function (dispatch) {
    dispatch({ type: GET_MERCHANDISE_REQUEST });
    services_MerchandiseService.getMerch(orderId).then(function (_ref) {
      var merch = _ref.merch,
          offer = _ref.offer;

      dispatch({
        type: GET_MERCHANDISE_SUCCESS,
        data: merch,
        offer: offer
      });
    }).catch(function (err) {
      dispatch({ type: GET_MERCHANDISE_ERROR, error: err });
    });
  };
};

/***/ }),

/***/ "pc4T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _math = __webpack_require__("e3iB");

var _TransformBase2 = __webpack_require__("Pszr");

var _TransformBase3 = _interopRequireDefault(_TransformBase2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Transform that takes care about its versions
 *
 * @class
 * @extends PIXI.TransformBase
 * @memberof PIXI
 */
var TransformStatic = function (_TransformBase) {
    _inherits(TransformStatic, _TransformBase);

    /**
     *
     */
    function TransformStatic() {
        _classCallCheck(this, TransformStatic);

        /**
        * The coordinate of the object relative to the local coordinates of the parent.
        *
        * @member {PIXI.ObservablePoint}
        */
        var _this = _possibleConstructorReturn(this, _TransformBase.call(this));

        _this.position = new _math.ObservablePoint(_this.onChange, _this, 0, 0);

        /**
         * The scale factor of the object.
         *
         * @member {PIXI.ObservablePoint}
         */
        _this.scale = new _math.ObservablePoint(_this.onChange, _this, 1, 1);

        /**
         * The pivot point of the displayObject that it rotates around.
         *
         * @member {PIXI.ObservablePoint}
         */
        _this.pivot = new _math.ObservablePoint(_this.onChange, _this, 0, 0);

        /**
         * The skew amount, on the x and y axis.
         *
         * @member {PIXI.ObservablePoint}
         */
        _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);

        _this._rotation = 0;

        _this._cx = 1; // cos rotation + skewY;
        _this._sx = 0; // sin rotation + skewY;
        _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
        _this._sy = 1; // sin rotation + Math.PI/2 - skewX;

        _this._localID = 0;
        _this._currentLocalID = 0;
        return _this;
    }

    /**
     * Called when a value changes.
     *
     * @private
     */

    TransformStatic.prototype.onChange = function onChange() {
        this._localID++;
    };

    /**
     * Called when skew or rotation changes
     *
     * @private
     */

    TransformStatic.prototype.updateSkew = function updateSkew() {
        this._cx = Math.cos(this._rotation + this.skew._y);
        this._sx = Math.sin(this._rotation + this.skew._y);
        this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
        this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2

        this._localID++;
    };

    /**
     * Updates only local matrix
     */

    TransformStatic.prototype.updateLocalTransform = function updateLocalTransform() {
        var lt = this.localTransform;

        if (this._localID !== this._currentLocalID) {
            // get the matrix values of the displayobject based on its transform properties..
            lt.a = this._cx * this.scale._x;
            lt.b = this._sx * this.scale._x;
            lt.c = this._cy * this.scale._y;
            lt.d = this._sy * this.scale._y;

            lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
            lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
            this._currentLocalID = this._localID;

            // force an update..
            this._parentID = -1;
        }
    };

    /**
     * Updates the values of the object and applies the parent's transform.
     *
     * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
     */

    TransformStatic.prototype.updateTransform = function updateTransform(parentTransform) {
        var lt = this.localTransform;

        if (this._localID !== this._currentLocalID) {
            // get the matrix values of the displayobject based on its transform properties..
            lt.a = this._cx * this.scale._x;
            lt.b = this._sx * this.scale._x;
            lt.c = this._cy * this.scale._y;
            lt.d = this._sy * this.scale._y;

            lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
            lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
            this._currentLocalID = this._localID;

            // force an update..
            this._parentID = -1;
        }

        if (this._parentID !== parentTransform._worldID) {
            // concat the parent matrix with the objects transform.
            var pt = parentTransform.worldTransform;
            var wt = this.worldTransform;

            wt.a = lt.a * pt.a + lt.b * pt.c;
            wt.b = lt.a * pt.b + lt.b * pt.d;
            wt.c = lt.c * pt.a + lt.d * pt.c;
            wt.d = lt.c * pt.b + lt.d * pt.d;
            wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
            wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;

            this._parentID = parentTransform._worldID;

            // update the id of the transform..
            this._worldID++;
        }
    };

    /**
     * Decomposes a matrix and sets the transforms properties based on it.
     *
     * @param {PIXI.Matrix} matrix - The matrix to decompose
     */

    TransformStatic.prototype.setFromMatrix = function setFromMatrix(matrix) {
        matrix.decompose(this);
        this._localID++;
    };

    /**
     * The rotation of the object in radians.
     *
     * @member {number}
     */

    _createClass(TransformStatic, [{
        key: 'rotation',
        get: function get() {
            return this._rotation;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._rotation !== value) {
                this._rotation = value;
                this.updateSkew();
            }
        }
    }]);

    return TransformStatic;
}(_TransformBase3.default);

exports.default = TransformStatic;
//# sourceMappingURL=TransformStatic.js.map

/***/ }),

/***/ "pj9u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scrollToErrors; });
/* unused harmony export scrollTo */
var scrollToErrors = function scrollToErrors() {
  setTimeout(function () {
    try {
      var errors = document.getElementsByClassName("has-error");
      if (errors.length) {
        var firstEl = errors[0];
        scrollTo(findPos(firstEl), 200);
        focusFirstInput(firstEl);
      }
    } catch (e) {}
  }, 100);
};

var focusFirstInput = function focusFirstInput(element) {
  try {
    element.querySelector("input").focus();
  } catch (err) {}
};

function findPos(obj) {
  var top = 0;
  if (obj.offsetParent) {
    do {
      top += obj.offsetTop;
    } while (obj = obj.offsetParent);
    return [top];
  }
}

var scrollTo = function scrollTo(elementY, duration) {
  var startingY = window.pageYOffset;
  var diff = elementY - startingY;
  var start;

  if (!window.requestAnimationFrame) {
    window.scrollTo(0, elementY);
    return;
  }
  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    // Elapsed miliseconds since start of scrolling.
    var time = timestamp - start;
    // Get percent of completion in range [0, 1].
    var percent = Math.min(time / duration, 1);
    window.scrollTo(0, startingY + diff * percent);
    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
};

/***/ }),

/***/ "po5f":
/***/ (function(module, exports) {

function getSqDist(p1, p2) {
    var dx = p1[0] - p2[0],
        dy = p1[1] - p2[1];

    return dx * dx + dy * dy;
}

// basic distance-based simplification
module.exports = function simplifyRadialDist(points, tolerance) {
    if (points.length <= 1) return points;
    tolerance = typeof tolerance === 'number' ? tolerance : 1;
    var sqTolerance = tolerance * tolerance;

    var prevPoint = points[0],
        newPoints = [prevPoint],
        point;

    for (var i = 1, len = points.length; i < len; i++) {
        point = points[i];

        if (getSqDist(point, prevPoint) > sqTolerance) {
            newPoints.push(point);
            prevPoint = point;
        }
    }

    if (prevPoint !== point) newPoints.push(point);

    return newPoints;
};

/***/ }),

/***/ "pv+l":
/***/ (function(module, exports) {

module.exports = function (originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "q/Zl":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};

function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

/***/ }),

/***/ "q84K":
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;

/***/ }),

/***/ "q9uR":
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__("NwWY"),
    forEach = __webpack_require__("FXvN"),
    isArray = function isArray(arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
};

module.exports = function (headers) {
  if (!headers) return {};

  var result = {};

  forEach(trim(headers).split('\n'), function (row) {
    var index = row.indexOf(':'),
        key = trim(row.slice(0, index)).toLowerCase(),
        value = trim(row.slice(index + 1));

    if (typeof result[key] === 'undefined') {
      result[key] = value;
    } else if (isArray(result[key])) {
      result[key].push(value);
    } else {
      result[key] = [result[key], value];
    }
  });

  return result;
};

/***/ }),

/***/ "qALj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "af9b65f8a1cbd1093c3c565ab34cb39e.svg";

/***/ }),

/***/ "qM/P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _const = __webpack_require__("YEQi");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * TextureGarbageCollector. This class manages the GPU and ensures that it does not get clogged
 * up with textures that are no longer being used.
 *
 * @class
 * @memberof PIXI
 */
var TextureGarbageCollector = function () {
    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
     */
    function TextureGarbageCollector(renderer) {
        _classCallCheck(this, TextureGarbageCollector);

        this.renderer = renderer;

        this.count = 0;
        this.checkCount = 0;
        this.maxIdle = _settings2.default.GC_MAX_IDLE;
        this.checkCountMax = _settings2.default.GC_MAX_CHECK_COUNT;
        this.mode = _settings2.default.GC_MODE;
    }

    /**
     * Checks to see when the last time a texture was used
     * if the texture has not been used for a specified amount of time it will be removed from the GPU
     */

    TextureGarbageCollector.prototype.update = function update() {
        this.count++;

        if (this.mode === _const.GC_MODES.MANUAL) {
            return;
        }

        this.checkCount++;

        if (this.checkCount > this.checkCountMax) {
            this.checkCount = 0;

            this.run();
        }
    };

    /**
     * Checks to see when the last time a texture was used
     * if the texture has not been used for a specified amount of time it will be removed from the GPU
     */

    TextureGarbageCollector.prototype.run = function run() {
        var tm = this.renderer.textureManager;
        var managedTextures = tm._managedTextures;
        var wasRemoved = false;

        for (var i = 0; i < managedTextures.length; i++) {
            var texture = managedTextures[i];

            // only supports non generated textures at the moment!
            if (!texture._glRenderTargets && this.count - texture.touched > this.maxIdle) {
                tm.destroyTexture(texture, true);
                managedTextures[i] = null;
                wasRemoved = true;
            }
        }

        if (wasRemoved) {
            var j = 0;

            for (var _i = 0; _i < managedTextures.length; _i++) {
                if (managedTextures[_i] !== null) {
                    managedTextures[j++] = managedTextures[_i];
                }
            }

            managedTextures.length = j;
        }
    };

    /**
     * Removes all the textures within the specified displayObject and its children from the GPU
     *
     * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
     */

    TextureGarbageCollector.prototype.unload = function unload(displayObject) {
        var tm = this.renderer.textureManager;

        // only destroy non generated textures
        if (displayObject._texture && displayObject._texture._glRenderTargets) {
            tm.destroyTexture(displayObject._texture, true);
        }

        for (var i = displayObject.children.length - 1; i >= 0; i--) {
            this.unload(displayObject.children[i]);
        }
    };

    return TextureGarbageCollector;
}();

exports.default = TextureGarbageCollector;
//# sourceMappingURL=TextureGarbageCollector.js.map

/***/ }),

/***/ "qQO4":
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__("hVVj");
var v4 = __webpack_require__("hYHi");

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;

/***/ }),

/***/ "qSyn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d5d60d7f9b8334f4eae42beff31a1994.svg";

/***/ }),

/***/ "qWpA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a95182f44334f6d667801d48857da499.svg";

/***/ }),

/***/ "qjkZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// References:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger

if (!Number.isInteger) {
    Number.isInteger = function numberIsInteger(value) {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };
}
//# sourceMappingURL=Number.isInteger.js.map

/***/ }),

/***/ "qm7U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b97129340bc9769a0bc2dad68109deaa.svg";

/***/ }),

/***/ "qmQd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _path = __webpack_require__("UUq2");

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * @author Vico @vicocotea
 * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/noise.js
 */

/**
 * A Noise effect filter.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var NoiseFilter = function (_core$Filter) {
    _inherits(NoiseFilter, _core$Filter);

    /**
     * @param {number} noise - The noise intensity, should be a normalized value in the range [0, 1].
     * @param {number} seed - A random seed for the noise generation. Default is `Math.random()`.
     */
    function NoiseFilter() {
        var noise = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
        var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Math.random();

        _classCallCheck(this, NoiseFilter);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
        // fragment shader
        'precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) * uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    gl_FragColor = color;\n}\n'));

        _this.noise = noise;
        _this.seed = seed;
        return _this;
    }

    /**
     * The amount of noise to apply, this value should be in the range (0, 1].
     *
     * @member {number}
     * @default 0.5
     */

    _createClass(NoiseFilter, [{
        key: 'noise',
        get: function get() {
            return this.uniforms.uNoise;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.uNoise = value;
        }

        /**
         * A seed value to apply to the random noise generation. `Math.random()` is a good value to use.
         *
         * @member {number}
         */

    }, {
        key: 'seed',
        get: function get() {
            return this.uniforms.uSeed;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.uSeed = value;
        }
    }]);

    return NoiseFilter;
}(core.Filter);

exports.default = NoiseFilter;
//# sourceMappingURL=NoiseFilter.js.map

/***/ }),

/***/ "qowt":
/***/ (function(module, exports) {

function _cross(o, a, b) {
    return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]);
}

function _upperTangent(pointset) {
    var lower = [];
    for (var l = 0; l < pointset.length; l++) {
        while (lower.length >= 2 && _cross(lower[lower.length - 2], lower[lower.length - 1], pointset[l]) <= 0) {
            lower.pop();
        }
        lower.push(pointset[l]);
    }
    lower.pop();
    return lower;
}

function _lowerTangent(pointset) {
    var reversed = pointset.reverse(),
        upper = [];
    for (var u = 0; u < reversed.length; u++) {
        while (upper.length >= 2 && _cross(upper[upper.length - 2], upper[upper.length - 1], reversed[u]) <= 0) {
            upper.pop();
        }
        upper.push(reversed[u]);
    }
    upper.pop();
    return upper;
}

// pointset has to be sorted by X
function convex(pointset) {
    var upper = _upperTangent(pointset),
        lower = _lowerTangent(pointset);
    var convex = lower.concat(upper);
    convex.push(pointset[0]);
    return convex;
}

module.exports = convex;

/***/ }),

/***/ "qrAv":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "qrdL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var bound_1 = __webpack_require__("USDo");
var InteractionManager_1 = __webpack_require__("dUAP");
var SelectableObject_1 = __webpack_require__("5t/1");
var SelectionListener_1 = __webpack_require__("//Eg");
var Text_js_1 = __webpack_require__("h2Qz");
var Utils_1 = __webpack_require__("o6Mn");
var Config_1 = __webpack_require__("gH/r");

var NonConstructionSeat = function (_SelectableObject_1$d) {
    _inherits(NonConstructionSeat, _SelectableObject_1$d);

    function NonConstructionSeat(_ref, actions, disableInteraction, isTicketing) {
        var _id = _ref._id,
            ticketInfo = _ref.ticketInfo,
            sectionName = _ref.sectionName,
            tableName = _ref.tableName,
            pos = _ref.pos,
            disabled = _ref.disabled,
            reserved = _ref.reserved,
            seatId = _ref.seatId,
            tableId = _ref.tableId,
            sectionId = _ref.sectionId,
            held = _ref.held,
            locked = _ref.locked,
            ticketIds = _ref.ticketIds,
            seatLabelPattern = _ref.seatLabelPattern,
            seatlabelStartAt = _ref.seatlabelStartAt,
            bookByTable = _ref.bookByTable,
            labelOverride = _ref.labelOverride,
            label = _ref.label,
            name = _ref.name;

        _classCallCheck(this, NonConstructionSeat);

        var _this = _possibleConstructorReturn(this, _SelectableObject_1$d.call(this, _id, pos, reserved, held, locked, ticketIds, bookByTable));

        _this.actions = actions;
        _this.ticketInfo = ticketInfo;
        _this.sectionName = sectionName;
        _this.tableName = tableName;
        _this.tableId = tableId;
        _this.labelOverride = labelOverride;
        _this.sectionId = sectionId;
        _this.disabled = disabled;
        _this.seatId = seatId;
        _this.ticketIds = ticketIds || [];
        _this.held = held;
        _this.locked = locked;
        _this.valid = true;
        _this.moveSelected = false;
        _this.moveToSelected = false;
        _this.basicType = "seat";
        _this.name = name;
        _this.mappedTicketId;
        _this.selected = false;
        _this.focused = true;
        _this.seatLabelPattern = seatLabelPattern;
        _this.seatContainer = new PIXI.Container();
        _this.seatlabelStartAt = seatlabelStartAt || 1;
        _this.label = label;
        _this.setLabel();
        if (isTicketing) {
            _this.determineTicketingTextureType();
        } else {
            _this.determineTextureType();
        }
        _this.seatWidthScale = Utils_1.seatWidth / _this.seatTexture.orig.width;
        _this.seatHeightScale = Utils_1.seatHeight / _this.seatTexture.orig.height;
        _this.interactionManager = InteractionManager_1.default.createInteractionManager();
        _this.seat = new PIXI.Sprite(_this.seatTexture);
        _this.seat.anchor = new PIXI.ObservablePoint(function () {}, undefined, 0.5, 0.5);
        _this.seat.scale = new PIXI.Point(_this.seatWidthScale, _this.seatHeightScale);
        _this.tableSelected = false;
        _this.selected = false;
        _this.seatContainer.addChild(_this.seat);
        _this.seatContainer.addChild(_this.text);
        _this.seatContainer.position = pos;
        _this.seatCurrentlySelected = false;
        _this.disableClick = false;
        if (disableInteraction && !_this.disabled) {
            _this.setupInteraction();
        }
        if (_this.disabled) {
            _this.text.visible = false;
            _this.seat.visible = false;
        }
        return _this;
    }

    NonConstructionSeat.prototype.showText = function showText(show) {
        if (!this.disabled) {
            this.text.visible = show;
        }
    };

    NonConstructionSeat.prototype.setText = function setText() {
        if (!this.label) {
            if (this.labelOverride !== undefined) {
                this.text.text = String(this.labelOverride + this.seatlabelStartAt);
            } else {
                if (this.seatLabelPattern === "alphabet") {
                    this.text.text = String.fromCharCode(65 + this.seatId + this.seatlabelStartAt);
                } else {
                    this.text.text = String(this.seatId + this.seatlabelStartAt);
                }
            }
        }
    };

    NonConstructionSeat.prototype.setLabelOverride = function setLabelOverride(i) {
        this.labelOverride = i;
        this.setText();
    };

    NonConstructionSeat.prototype.setLabel = function setLabel() {
        var label = void 0;
        if (this.labelOverride !== undefined) {
            label = String(this.labelOverride + this.seatlabelStartAt);
        } else {
            if (this.seatLabelPattern === "alphabet") {
                label = String.fromCharCode(65 + this.seatId + this.seatlabelStartAt);
            } else {
                label = String(this.seatId + this.seatlabelStartAt);
            }
        }
        this.text = Text_js_1.TextWrapper.createText(this.label !== undefined ? this.label : label, Config_1.default.fontStyle);
        this.text.resolution = 2;
        this.text.anchor = new PIXI.ObservablePoint(function () {}, undefined, 0.5, 0.5);
    };

    NonConstructionSeat.prototype.getNames = function getNames(label) {
        return {
            seatName: label + " " + this.text.text,
            tableName: this.tableName,
            sectionName: this.sectionName
        };
    };

    NonConstructionSeat.prototype.highlight = function highlight(_highlight) {
        this.moveSelected = _highlight;
        this.setTexture();
    };

    NonConstructionSeat.prototype.enableClick = function enableClick(enable) {
        this.disableClick = !enable;
    };

    NonConstructionSeat.prototype.addTicketDataTo = function addTicketDataTo(ticketData) {
        this.ticketInfo = ticketData;
        this.reserved = true;
        this.moveToSelected = false;
        this.setTexture();
    };

    NonConstructionSeat.prototype.removeTicketDataFrom = function removeTicketDataFrom() {
        this.ticketInfo = undefined;
        this.reserved = false;
        this.moveSelected = false;
        this.setTexture();
    };

    NonConstructionSeat.prototype.unClickSeat = function unClickSeat() {
        this.moveSelected = false;
        this.moveToSelected = false;
        this.setTexture();
    };

    NonConstructionSeat.prototype.setupInteraction = function setupInteraction() {
        this.selectionListener = new SelectionListener_1.default(this.seatContainer, this, this.onClick);
    };

    NonConstructionSeat.prototype.deSelect = function deSelect() {
        this.selected = false;
    };

    NonConstructionSeat.prototype.disable = function disable() {
        this.reserved = true;
        this.setTexture();
        delete this.selectionListener;
    };

    NonConstructionSeat.prototype.onClick = function onClick() {
        var seatInfo = {
            seatId: this._id,
            seatNum: this.seatId + this.seatlabelStartAt,
            tableId: this.tableId,
            tableName: this.tableName,
            sectionId: this.sectionId,
            sectionName: this.sectionName
        };
        if (!this.disableClick) {
            if (this.seatCurrentlySelected && !this.ticketInfo) {
                this.actions.onSecondSeatClicked(seatInfo);
                this.moveToSelected = true;
                this.setTexture();
            } else if (!this.seatCurrentlySelected && this.ticketInfo) {
                this.actions.onSeatClicked(seatInfo, this.ticketInfo);
                this.moveSelected = true;
                this.setTexture();
            } else if (this.seatCurrentlySelected && this.ticketInfo) {
                this.actions.onSeatSwapClicked(seatInfo, this.ticketInfo);
                this.moveToSelected = true;
                this.setTexture();
            }
        }
    };

    NonConstructionSeat.prototype.changeSeat = function changeSeat() {
        var seatInfo = {
            seatId: this._id,
            seatNum: this.seatId + this.seatlabelStartAt,
            tableId: this.tableId,
            tableName: this.tableName,
            sectionId: this.sectionId,
            sectionName: this.sectionName
        };
        this.moveSelected = true;
        this.setTexture();
        return {
            seatInfo: seatInfo,
            ticketInfo: this.ticketInfo
        };
    };

    NonConstructionSeat.prototype.seatSelected = function seatSelected(seatCurrentlySelected) {
        this.seatCurrentlySelected = seatCurrentlySelected;
    };

    NonConstructionSeat.prototype.deselectSeat = function deselectSeat() {
        this.seatCurrentlySelected = false;
    };

    NonConstructionSeat.prototype.unAssignSeat = function unAssignSeat() {
        this.moveSelected = false;
        this.reserved = false;
        this.ticketInfo = undefined;
        this.setTexture();
    };

    NonConstructionSeat.prototype.setTexture = function setTexture() {
        this.determineTextureType();
        this.seat.texture = this.seatTexture;
    };

    NonConstructionSeat.prototype.determineTextureType = function determineTextureType() {
        var textureName = void 0;
        if (this.moveSelected) {
            this.text.fill = 0x000000;
            textureName = Utils_1.seatMovedTexture;
        } else if (this.moveToSelected) {
            this.text.fill = 0x000000;
            textureName = Utils_1.seatMovedToTexture;
        } else if (this.reserved) {
            this.text.fill = 0x000000;
            textureName = Utils_1.seatAssignedTexture;
        } else {
            this.text.fill = 0x000000;
            textureName = Utils_1.seatUnassignedTexture;
        }
        this.seatTexture = PIXI.loader.resources[textureName].texture;
        this.seatTexture.baseTexture.mipmap = true;
    };

    NonConstructionSeat.prototype.determineTicketingTextureType = function determineTicketingTextureType() {
        var textureName = void 0;
        if (this.reserved || this.locked || !(this.valid && this.focused)) {
            textureName = Utils_1.seatUnavailableTexture;
        } else {
            textureName = this.selected ? Utils_1.seatSelectedtexture : Utils_1.seatAvailableTexture;
        }
        this.seatTexture = PIXI.loader.resources[textureName].texture;
        this.seatTexture.baseTexture.mipmap = true;
    };

    NonConstructionSeat.prototype.setPos = function setPos(pos) {
        this.seatContainer.position = pos;
    };

    NonConstructionSeat.prototype.getSeat = function getSeat() {
        return this.seatContainer;
    };

    NonConstructionSeat.prototype.setActions = function setActions(actions) {
        this.actions = actions;
    };

    return NonConstructionSeat;
}(SelectableObject_1.default);

__decorate([bound_1.default], NonConstructionSeat.prototype, "showText", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "setText", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "setLabelOverride", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "setLabel", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "getNames", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "highlight", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "enableClick", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "addTicketDataTo", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "removeTicketDataFrom", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "unClickSeat", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "setupInteraction", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "disable", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "changeSeat", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "seatSelected", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "deselectSeat", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "unAssignSeat", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "setTexture", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "setPos", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "getSeat", null);
__decorate([bound_1.default], NonConstructionSeat.prototype, "setActions", null);
exports.default = NonConstructionSeat;
//# sourceMappingURL=Seat.js.map

/***/ }),

/***/ "qyFb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

var _ObservablePoint = __webpack_require__("aG0R");

var _ObservablePoint2 = _interopRequireDefault(_ObservablePoint);

var _utils = __webpack_require__("dDI1");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A BitmapText object will create a line or multiple lines of text using bitmap font. To
 * split a line you can use '\n', '\r' or '\r\n' in your string. You can generate the fnt files using:
 *
 * A BitmapText can only be created when the font is loaded
 *
 * ```js
 * // in this case the font is in a file called 'desyrel.fnt'
 * let bitmapText = new PIXI.extras.BitmapText("text using a fancy font!", {font: "35px Desyrel", align: "right"});
 * ```
 *
 * http://www.angelcode.com/products/bmfont/ for windows or
 * http://www.bmglyph.com/ for mac.
 *
 * @class
 * @extends PIXI.Container
 * @memberof PIXI.extras
 */
var BitmapText = function (_core$Container) {
    _inherits(BitmapText, _core$Container);

    /**
     * @param {string} text - The copy that you would like the text to display
     * @param {object} style - The style parameters
     * @param {string|object} style.font - The font descriptor for the object, can be passed as a string of form
     *      "24px FontName" or "FontName" or as an object with explicit name/size properties.
     * @param {string} [style.font.name] - The bitmap font id
     * @param {number} [style.font.size] - The size of the font in pixels, e.g. 24
     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'), does not affect
     *      single line text
     * @param {number} [style.tint=0xFFFFFF] - The tint color
     */
    function BitmapText(text) {
        var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, BitmapText);

        /**
         * Private tracker for the width of the overall text
         *
         * @member {number}
         * @private
         */
        var _this = _possibleConstructorReturn(this, _core$Container.call(this));

        _this._textWidth = 0;

        /**
         * Private tracker for the height of the overall text
         *
         * @member {number}
         * @private
         */
        _this._textHeight = 0;

        /**
         * Private tracker for the letter sprite pool.
         *
         * @member {PIXI.Sprite[]}
         * @private
         */
        _this._glyphs = [];

        /**
         * Private tracker for the current style.
         *
         * @member {object}
         * @private
         */
        _this._font = {
            tint: style.tint !== undefined ? style.tint : 0xFFFFFF,
            align: style.align || 'left',
            name: null,
            size: 0
        };

        /**
         * Private tracker for the current font.
         *
         * @member {object}
         * @private
         */
        _this.font = style.font; // run font setter

        /**
         * Private tracker for the current text.
         *
         * @member {string}
         * @private
         */
        _this._text = text;

        /**
         * The max width of this bitmap text in pixels. If the text provided is longer than the
         * value provided, line breaks will be automatically inserted in the last whitespace.
         * Disable by setting value to 0
         *
         * @member {number}
         * @private
         */
        _this._maxWidth = 0;

        /**
         * The max line height. This is useful when trying to use the total height of the Text,
         * ie: when trying to vertically align.
         *
         * @member {number}
         * @private
         */
        _this._maxLineHeight = 0;

        /**
         * Letter spacing. This is useful for setting the space between characters.
         * @member {number}
         * @private
         */
        _this._letterSpacing = 0;

        /**
         * Text anchor. read-only
         *
         * @member {PIXI.ObservablePoint}
         * @private
         */
        _this._anchor = new _ObservablePoint2.default(function () {
            _this.dirty = true;
        }, _this, 0, 0);

        /**
         * The dirty state of this object.
         *
         * @member {boolean}
         */
        _this.dirty = false;

        _this.updateText();
        return _this;
    }

    /**
     * Renders text and updates it when needed
     *
     * @private
     */

    BitmapText.prototype.updateText = function updateText() {
        var data = BitmapText.fonts[this._font.name];
        var scale = this._font.size / data.size;
        var pos = new core.Point();
        var chars = [];
        var lineWidths = [];
        var text = this.text.replace(/(?:\r\n|\r)/g, '\n');
        var textLength = text.length;
        var maxWidth = this._maxWidth * data.size / this._font.size;

        var prevCharCode = null;
        var lastLineWidth = 0;
        var maxLineWidth = 0;
        var line = 0;
        var lastBreakPos = -1;
        var lastBreakWidth = 0;
        var spacesRemoved = 0;
        var maxLineHeight = 0;

        for (var i = 0; i < textLength; i++) {
            var charCode = text.charCodeAt(i);
            var char = text.charAt(i);

            if (/(?:\s)/.test(char)) {
                lastBreakPos = i;
                lastBreakWidth = lastLineWidth;
            }

            if (char === '\r' || char === '\n') {
                lineWidths.push(lastLineWidth);
                maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
                ++line;
                ++spacesRemoved;

                pos.x = 0;
                pos.y += data.lineHeight;
                prevCharCode = null;
                continue;
            }

            var charData = data.chars[charCode];

            if (!charData) {
                continue;
            }

            if (prevCharCode && charData.kerning[prevCharCode]) {
                pos.x += charData.kerning[prevCharCode];
            }

            chars.push({
                texture: charData.texture,
                line: line,
                charCode: charCode,
                position: new core.Point(pos.x + charData.xOffset + this._letterSpacing / 2, pos.y + charData.yOffset)
            });
            pos.x += charData.xAdvance + this._letterSpacing;
            lastLineWidth = pos.x;
            maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height);
            prevCharCode = charCode;

            if (lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth) {
                ++spacesRemoved;
                core.utils.removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos);
                i = lastBreakPos;
                lastBreakPos = -1;

                lineWidths.push(lastBreakWidth);
                maxLineWidth = Math.max(maxLineWidth, lastBreakWidth);
                line++;

                pos.x = 0;
                pos.y += data.lineHeight;
                prevCharCode = null;
            }
        }

        var lastChar = text.charAt(text.length - 1);

        if (lastChar !== '\r' && lastChar !== '\n') {
            if (/(?:\s)/.test(lastChar)) {
                lastLineWidth = lastBreakWidth;
            }

            lineWidths.push(lastLineWidth);
            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
        }

        var lineAlignOffsets = [];

        for (var _i = 0; _i <= line; _i++) {
            var alignOffset = 0;

            if (this._font.align === 'right') {
                alignOffset = maxLineWidth - lineWidths[_i];
            } else if (this._font.align === 'center') {
                alignOffset = (maxLineWidth - lineWidths[_i]) / 2;
            }

            lineAlignOffsets.push(alignOffset);
        }

        var lenChars = chars.length;
        var tint = this.tint;

        for (var _i2 = 0; _i2 < lenChars; _i2++) {
            var c = this._glyphs[_i2]; // get the next glyph sprite

            if (c) {
                c.texture = chars[_i2].texture;
            } else {
                c = new core.Sprite(chars[_i2].texture);
                this._glyphs.push(c);
            }

            c.position.x = (chars[_i2].position.x + lineAlignOffsets[chars[_i2].line]) * scale;
            c.position.y = chars[_i2].position.y * scale;
            c.scale.x = c.scale.y = scale;
            c.tint = tint;

            if (!c.parent) {
                this.addChild(c);
            }
        }

        // remove unnecessary children.
        for (var _i3 = lenChars; _i3 < this._glyphs.length; ++_i3) {
            this.removeChild(this._glyphs[_i3]);
        }

        this._textWidth = maxLineWidth * scale;
        this._textHeight = (pos.y + data.lineHeight) * scale;

        // apply anchor
        if (this.anchor.x !== 0 || this.anchor.y !== 0) {
            for (var _i4 = 0; _i4 < lenChars; _i4++) {
                this._glyphs[_i4].x -= this._textWidth * this.anchor.x;
                this._glyphs[_i4].y -= this._textHeight * this.anchor.y;
            }
        }
        this._maxLineHeight = maxLineHeight * scale;
    };

    /**
     * Updates the transform of this object
     *
     * @private
     */

    BitmapText.prototype.updateTransform = function updateTransform() {
        this.validate();
        this.containerUpdateTransform();
    };

    /**
     * Validates text before calling parent's getLocalBounds
     *
     * @return {PIXI.Rectangle} The rectangular bounding area
     */

    BitmapText.prototype.getLocalBounds = function getLocalBounds() {
        this.validate();

        return _core$Container.prototype.getLocalBounds.call(this);
    };

    /**
     * Updates text when needed
     *
     * @private
     */

    BitmapText.prototype.validate = function validate() {
        if (this.dirty) {
            this.updateText();
            this.dirty = false;
        }
    };

    /**
     * The tint of the BitmapText object
     *
     * @member {number}
     */

    /**
     * Register a bitmap font with data and a texture.
     *
     * @static
     * @param {XMLDocument} xml - The XML document data.
     * @param {Object.<string, PIXI.Texture>|PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
     *  If providing an object, the key is the `<page>` element's `file` attribute in the FNT file.
     * @return {Object} Result font object with font, size, lineHeight and char fields.
     */
    BitmapText.registerFont = function registerFont(xml, textures) {
        var data = {};
        var info = xml.getElementsByTagName('info')[0];
        var common = xml.getElementsByTagName('common')[0];
        var pages = xml.getElementsByTagName('page');
        var res = (0, _utils.getResolutionOfUrl)(pages[0].getAttribute('file'), _settings2.default.RESOLUTION);
        var pagesTextures = {};

        data.font = info.getAttribute('face');
        data.size = parseInt(info.getAttribute('size'), 10);
        data.lineHeight = parseInt(common.getAttribute('lineHeight'), 10) / res;
        data.chars = {};

        // Single texture, convert to list
        if (textures instanceof core.Texture) {
            textures = [textures];
        }

        // Convert the input Texture, Textures or object
        // into a page Texture lookup by "id"
        for (var i = 0; i < pages.length; i++) {
            var id = pages[i].getAttribute('id');
            var file = pages[i].getAttribute('file');

            pagesTextures[id] = textures instanceof Array ? textures[i] : textures[file];
        }

        // parse letters
        var letters = xml.getElementsByTagName('char');

        for (var _i5 = 0; _i5 < letters.length; _i5++) {
            var letter = letters[_i5];
            var charCode = parseInt(letter.getAttribute('id'), 10);
            var page = letter.getAttribute('page') || 0;
            var textureRect = new core.Rectangle(parseInt(letter.getAttribute('x'), 10) / res + pagesTextures[page].frame.x / res, parseInt(letter.getAttribute('y'), 10) / res + pagesTextures[page].frame.y / res, parseInt(letter.getAttribute('width'), 10) / res, parseInt(letter.getAttribute('height'), 10) / res);

            data.chars[charCode] = {
                xOffset: parseInt(letter.getAttribute('xoffset'), 10) / res,
                yOffset: parseInt(letter.getAttribute('yoffset'), 10) / res,
                xAdvance: parseInt(letter.getAttribute('xadvance'), 10) / res,
                kerning: {},
                texture: new core.Texture(pagesTextures[page].baseTexture, textureRect),
                page: page
            };
        }

        // parse kernings
        var kernings = xml.getElementsByTagName('kerning');

        for (var _i6 = 0; _i6 < kernings.length; _i6++) {
            var kerning = kernings[_i6];
            var first = parseInt(kerning.getAttribute('first'), 10) / res;
            var second = parseInt(kerning.getAttribute('second'), 10) / res;
            var amount = parseInt(kerning.getAttribute('amount'), 10) / res;

            if (data.chars[second]) {
                data.chars[second].kerning[first] = amount;
            }
        }

        // I'm leaving this as a temporary fix so we can test the bitmap fonts in v3
        // but it's very likely to change
        BitmapText.fonts[data.font] = data;

        return data;
    };

    _createClass(BitmapText, [{
        key: 'tint',
        get: function get() {
            return this._font.tint;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._font.tint = typeof value === 'number' && value >= 0 ? value : 0xFFFFFF;

            this.dirty = true;
        }

        /**
         * The alignment of the BitmapText object
         *
         * @member {string}
         * @default 'left'
         */

    }, {
        key: 'align',
        get: function get() {
            return this._font.align;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._font.align = value || 'left';

            this.dirty = true;
        }

        /**
         * The anchor sets the origin point of the text.
         * The default is 0,0 this means the text's origin is the top left
         * Setting the anchor to 0.5,0.5 means the text's origin is centered
         * Setting the anchor to 1,1 would mean the text's origin point will be the bottom right corner
         *
         * @member {PIXI.Point | number}
         */

    }, {
        key: 'anchor',
        get: function get() {
            return this._anchor;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (typeof value === 'number') {
                this._anchor.set(value);
            } else {
                this._anchor.copy(value);
            }
        }

        /**
         * The font descriptor of the BitmapText object
         *
         * @member {string|object}
         */

    }, {
        key: 'font',
        get: function get() {
            return this._font;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (!value) {
                return;
            }

            if (typeof value === 'string') {
                value = value.split(' ');

                this._font.name = value.length === 1 ? value[0] : value.slice(1).join(' ');
                this._font.size = value.length >= 2 ? parseInt(value[0], 10) : BitmapText.fonts[this._font.name].size;
            } else {
                this._font.name = value.name;
                this._font.size = typeof value.size === 'number' ? value.size : parseInt(value.size, 10);
            }

            this.dirty = true;
        }

        /**
         * The text of the BitmapText object
         *
         * @member {string}
         */

    }, {
        key: 'text',
        get: function get() {
            return this._text;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            value = value.toString() || ' ';
            if (this._text === value) {
                return;
            }
            this._text = value;
            this.dirty = true;
        }

        /**
         * The max width of this bitmap text in pixels. If the text provided is longer than the
         * value provided, line breaks will be automatically inserted in the last whitespace.
         * Disable by setting value to 0
         *
         * @member {number}
         */

    }, {
        key: 'maxWidth',
        get: function get() {
            return this._maxWidth;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._maxWidth === value) {
                return;
            }
            this._maxWidth = value;
            this.dirty = true;
        }

        /**
         * The max line height. This is useful when trying to use the total height of the Text,
         * ie: when trying to vertically align.
         *
         * @member {number}
         * @readonly
         */

    }, {
        key: 'maxLineHeight',
        get: function get() {
            this.validate();

            return this._maxLineHeight;
        }

        /**
         * The width of the overall text, different from fontSize,
         * which is defined in the style object
         *
         * @member {number}
         * @readonly
         */

    }, {
        key: 'textWidth',
        get: function get() {
            this.validate();

            return this._textWidth;
        }

        /**
         * Additional space between characters.
         *
         * @member {number}
         */

    }, {
        key: 'letterSpacing',
        get: function get() {
            return this._letterSpacing;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._letterSpacing !== value) {
                this._letterSpacing = value;
                this.dirty = true;
            }
        }

        /**
         * The height of the overall text, different from fontSize,
         * which is defined in the style object
         *
         * @member {number}
         * @readonly
         */

    }, {
        key: 'textHeight',
        get: function get() {
            this.validate();

            return this._textHeight;
        }
    }]);

    return BitmapText;
}(core.Container);

exports.default = BitmapText;

BitmapText.fonts = {};
//# sourceMappingURL=BitmapText.js.map

/***/ }),

/***/ "rGF6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _eventemitter = __webpack_require__("wCSE");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _const = __webpack_require__("YEQi");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

var _TransformStatic = __webpack_require__("pc4T");

var _TransformStatic2 = _interopRequireDefault(_TransformStatic);

var _Transform = __webpack_require__("ThH+");

var _Transform2 = _interopRequireDefault(_Transform);

var _Bounds = __webpack_require__("Me0q");

var _Bounds2 = _interopRequireDefault(_Bounds);

var _math = __webpack_require__("e3iB");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// _tempDisplayObjectParent = new DisplayObject();

/**
 * The base class for all objects that are rendered on the screen.
 * This is an abstract class and should not be used on its own rather it should be extended.
 *
 * @class
 * @extends EventEmitter
 * @memberof PIXI
 */
var DisplayObject = function (_EventEmitter) {
    _inherits(DisplayObject, _EventEmitter);

    /**
     *
     */
    function DisplayObject() {
        _classCallCheck(this, DisplayObject);

        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        var TransformClass = _settings2.default.TRANSFORM_MODE === _const.TRANSFORM_MODE.STATIC ? _TransformStatic2.default : _Transform2.default;

        _this.tempDisplayObjectParent = null;

        // TODO: need to create Transform from factory
        /**
         * World transform and local transform of this object.
         * This will become read-only later, please do not assign anything there unless you know what are you doing
         *
         * @member {PIXI.TransformBase}
         */
        _this.transform = new TransformClass();

        /**
         * The opacity of the object.
         *
         * @member {number}
         */
        _this.alpha = 1;

        /**
         * The visibility of the object. If false the object will not be drawn, and
         * the updateTransform function will not be called.
         *
         * Only affects recursive calls from parent. You can ask for bounds or call updateTransform manually
         *
         * @member {boolean}
         */
        _this.visible = true;

        /**
         * Can this object be rendered, if false the object will not be drawn but the updateTransform
         * methods will still be called.
         *
         * Only affects recursive calls from parent. You can ask for bounds manually
         *
         * @member {boolean}
         */
        _this.renderable = true;

        /**
         * The display object container that contains this display object.
         *
         * @member {PIXI.Container}
         * @readonly
         */
        _this.parent = null;

        /**
         * The multiplied alpha of the displayObject
         *
         * @member {number}
         * @readonly
         */
        _this.worldAlpha = 1;

        /**
         * The area the filter is applied to. This is used as more of an optimisation
         * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle
         *
         * Also works as an interaction mask
         *
         * @member {PIXI.Rectangle}
         */
        _this.filterArea = null;

        _this._filters = null;
        _this._enabledFilters = null;

        /**
         * The bounds object, this is used to calculate and store the bounds of the displayObject
         *
         * @member {PIXI.Rectangle}
         * @private
         */
        _this._bounds = new _Bounds2.default();
        _this._boundsID = 0;
        _this._lastBoundsID = -1;
        _this._boundsRect = null;
        _this._localBoundsRect = null;

        /**
         * The original, cached mask of the object
         *
         * @member {PIXI.Graphics|PIXI.Sprite}
         * @private
         */
        _this._mask = null;

        /**
         * If the object has been destroyed via destroy(). If true, it should not be used.
         *
         * @member {boolean}
         * @private
         * @readonly
         */
        _this._destroyed = false;

        /**
         * Fired when this DisplayObject is added to a Container.
         *
         * @event PIXI.DisplayObject#added
         * @param {PIXI.Container} container - The container added to.
         */

        /**
         * Fired when this DisplayObject is removed from a Container.
         *
         * @event PIXI.DisplayObject#removed
         * @param {PIXI.Container} container - The container removed from.
         */
        return _this;
    }

    /**
     * @private
     * @member {PIXI.DisplayObject}
     */

    /**
     * Updates the object transform for rendering
     *
     * TODO - Optimization pass!
     */
    DisplayObject.prototype.updateTransform = function updateTransform() {
        this.transform.updateTransform(this.parent.transform);
        // multiply the alphas..
        this.worldAlpha = this.alpha * this.parent.worldAlpha;

        this._bounds.updateID++;
    };

    /**
     * recursively updates transform of all objects from the root to this one
     * internal function for toLocal()
     */

    DisplayObject.prototype._recursivePostUpdateTransform = function _recursivePostUpdateTransform() {
        if (this.parent) {
            this.parent._recursivePostUpdateTransform();
            this.transform.updateTransform(this.parent.transform);
        } else {
            this.transform.updateTransform(this._tempDisplayObjectParent.transform);
        }
    };

    /**
     * Retrieves the bounds of the displayObject as a rectangle object.
     *
     * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
     *  being updated. This means the calculation returned MAY be out of date BUT will give you a
     *  nice performance boost
     * @param {PIXI.Rectangle} rect - Optional rectangle to store the result of the bounds calculation
     * @return {PIXI.Rectangle} the rectangular bounding area
     */

    DisplayObject.prototype.getBounds = function getBounds(skipUpdate, rect) {
        if (!skipUpdate) {
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.updateTransform();
                this.parent = null;
            } else {
                this._recursivePostUpdateTransform();
                this.updateTransform();
            }
        }

        if (this._boundsID !== this._lastBoundsID) {
            this.calculateBounds();
        }

        if (!rect) {
            if (!this._boundsRect) {
                this._boundsRect = new _math.Rectangle();
            }

            rect = this._boundsRect;
        }

        return this._bounds.getRectangle(rect);
    };

    /**
     * Retrieves the local bounds of the displayObject as a rectangle object
     *
     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation
     * @return {PIXI.Rectangle} the rectangular bounding area
     */

    DisplayObject.prototype.getLocalBounds = function getLocalBounds(rect) {
        var transformRef = this.transform;
        var parentRef = this.parent;

        this.parent = null;
        this.transform = this._tempDisplayObjectParent.transform;

        if (!rect) {
            if (!this._localBoundsRect) {
                this._localBoundsRect = new _math.Rectangle();
            }

            rect = this._localBoundsRect;
        }

        var bounds = this.getBounds(false, rect);

        this.parent = parentRef;
        this.transform = transformRef;

        return bounds;
    };

    /**
     * Calculates the global position of the display object
     *
     * @param {PIXI.Point} position - The world origin to calculate from
     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
     *  (otherwise will create a new Point)
     * @param {boolean} [skipUpdate=false] - Should we skip the update transform.
     * @return {PIXI.Point} A point object representing the position of this object
     */

    DisplayObject.prototype.toGlobal = function toGlobal(position, point) {
        var skipUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (!skipUpdate) {
            this._recursivePostUpdateTransform();

            // this parent check is for just in case the item is a root object.
            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.displayObjectUpdateTransform();
                this.parent = null;
            } else {
                this.displayObjectUpdateTransform();
            }
        }

        // don't need to update the lot
        return this.worldTransform.apply(position, point);
    };

    /**
     * Calculates the local position of the display object relative to another point
     *
     * @param {PIXI.Point} position - The world origin to calculate from
     * @param {PIXI.DisplayObject} [from] - The DisplayObject to calculate the global position from
     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
     *  (otherwise will create a new Point)
     * @param {boolean} [skipUpdate=false] - Should we skip the update transform
     * @return {PIXI.Point} A point object representing the position of this object
     */

    DisplayObject.prototype.toLocal = function toLocal(position, from, point, skipUpdate) {
        if (from) {
            position = from.toGlobal(position, point, skipUpdate);
        }

        if (!skipUpdate) {
            this._recursivePostUpdateTransform();

            // this parent check is for just in case the item is a root object.
            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.displayObjectUpdateTransform();
                this.parent = null;
            } else {
                this.displayObjectUpdateTransform();
            }
        }

        // simply apply the matrix..
        return this.worldTransform.applyInverse(position, point);
    };

    /**
     * Renders the object using the WebGL renderer
     *
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */

    DisplayObject.prototype.renderWebGL = function renderWebGL(renderer) // eslint-disable-line no-unused-vars
    {}
    // OVERWRITE;


    /**
     * Renders the object using the Canvas renderer
     *
     * @param {PIXI.CanvasRenderer} renderer - The renderer
     */
    ;

    DisplayObject.prototype.renderCanvas = function renderCanvas(renderer) // eslint-disable-line no-unused-vars
    {}
    // OVERWRITE;


    /**
     * Set the parent Container of this DisplayObject
     *
     * @param {PIXI.Container} container - The Container to add this DisplayObject to
     * @return {PIXI.Container} The Container that this DisplayObject was added to
     */
    ;

    DisplayObject.prototype.setParent = function setParent(container) {
        if (!container || !container.addChild) {
            throw new Error('setParent: Argument must be a Container');
        }

        container.addChild(this);

        return container;
    };

    /**
     * Convenience function to set the position, scale, skew and pivot at once.
     *
     * @param {number} [x=0] - The X position
     * @param {number} [y=0] - The Y position
     * @param {number} [scaleX=1] - The X scale value
     * @param {number} [scaleY=1] - The Y scale value
     * @param {number} [rotation=0] - The rotation
     * @param {number} [skewX=0] - The X skew value
     * @param {number} [skewY=0] - The Y skew value
     * @param {number} [pivotX=0] - The X pivot value
     * @param {number} [pivotY=0] - The Y pivot value
     * @return {PIXI.DisplayObject} The DisplayObject instance
     */

    DisplayObject.prototype.setTransform = function setTransform() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var scaleX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var scaleY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var rotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var skewX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
        var skewY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
        var pivotX = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
        var pivotY = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;

        this.position.x = x;
        this.position.y = y;
        this.scale.x = !scaleX ? 1 : scaleX;
        this.scale.y = !scaleY ? 1 : scaleY;
        this.rotation = rotation;
        this.skew.x = skewX;
        this.skew.y = skewY;
        this.pivot.x = pivotX;
        this.pivot.y = pivotY;

        return this;
    };

    /**
     * Base destroy method for generic display objects. This will automatically
     * remove the display object from its parent Container as well as remove
     * all current event listeners and internal references. Do not use a DisplayObject
     * after calling `destroy`.
     *
     */

    DisplayObject.prototype.destroy = function destroy() {
        this.removeAllListeners();
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.transform = null;

        this.parent = null;

        this._bounds = null;
        this._currentBounds = null;
        this._mask = null;

        this.filterArea = null;

        this.interactive = false;
        this.interactiveChildren = false;

        this._destroyed = true;
    };

    /**
     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
     * An alias to position.x
     *
     * @member {number}
     */

    _createClass(DisplayObject, [{
        key: '_tempDisplayObjectParent',
        get: function get() {
            if (this.tempDisplayObjectParent === null) {
                this.tempDisplayObjectParent = new DisplayObject();
            }

            return this.tempDisplayObjectParent;
        }
    }, {
        key: 'x',
        get: function get() {
            return this.position.x;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.position.x = value;
        }

        /**
         * The position of the displayObject on the y axis relative to the local coordinates of the parent.
         * An alias to position.y
         *
         * @member {number}
         */

    }, {
        key: 'y',
        get: function get() {
            return this.position.y;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.position.y = value;
        }

        /**
         * Current transform of the object based on world (parent) factors
         *
         * @member {PIXI.Matrix}
         * @readonly
         */

    }, {
        key: 'worldTransform',
        get: function get() {
            return this.transform.worldTransform;
        }

        /**
         * Current transform of the object based on local factors: position, scale, other stuff
         *
         * @member {PIXI.Matrix}
         * @readonly
         */

    }, {
        key: 'localTransform',
        get: function get() {
            return this.transform.localTransform;
        }

        /**
         * The coordinate of the object relative to the local coordinates of the parent.
         * Assignment by value since pixi-v4.
         *
         * @member {PIXI.Point|PIXI.ObservablePoint}
         */

    }, {
        key: 'position',
        get: function get() {
            return this.transform.position;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.position.copy(value);
        }

        /**
         * The scale factor of the object.
         * Assignment by value since pixi-v4.
         *
         * @member {PIXI.Point|PIXI.ObservablePoint}
         */

    }, {
        key: 'scale',
        get: function get() {
            return this.transform.scale;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.scale.copy(value);
        }

        /**
         * The pivot point of the displayObject that it rotates around.
         * Assignment by value since pixi-v4.
         *
         * @member {PIXI.Point|PIXI.ObservablePoint}
         */

    }, {
        key: 'pivot',
        get: function get() {
            return this.transform.pivot;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.pivot.copy(value);
        }

        /**
         * The skew factor for the object in radians.
         * Assignment by value since pixi-v4.
         *
         * @member {PIXI.ObservablePoint}
         */

    }, {
        key: 'skew',
        get: function get() {
            return this.transform.skew;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.skew.copy(value);
        }

        /**
         * The rotation of the object in radians.
         *
         * @member {number}
         */

    }, {
        key: 'rotation',
        get: function get() {
            return this.transform.rotation;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.rotation = value;
        }

        /**
         * Indicates if the object is globally visible.
         *
         * @member {boolean}
         * @readonly
         */

    }, {
        key: 'worldVisible',
        get: function get() {
            var item = this;

            do {
                if (!item.visible) {
                    return false;
                }

                item = item.parent;
            } while (item);

            return true;
        }

        /**
         * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
         * object to the shape of the mask applied to it. In PIXI a regular mask must be a
         * PIXI.Graphics or a PIXI.Sprite object. This allows for much faster masking in canvas as it
         * utilises shape clipping. To remove a mask, set this property to null.
         *
         * @todo For the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
         *
         * @member {PIXI.Graphics|PIXI.Sprite}
         */

    }, {
        key: 'mask',
        get: function get() {
            return this._mask;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._mask) {
                this._mask.renderable = true;
                this._mask.isMask = false;
            }

            this._mask = value;

            if (this._mask) {
                this._mask.renderable = false;
                this._mask.isMask = true;
            }
        }

        /**
         * Sets the filters for the displayObject.
         * * IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
         * To remove filters simply set this property to 'null'
         *
         * @member {PIXI.Filter[]}
         */

    }, {
        key: 'filters',
        get: function get() {
            return this._filters && this._filters.slice();
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._filters = value && value.slice();
        }
    }]);

    return DisplayObject;
}(_eventemitter2.default);

// performance increase to avoid using call.. (10x faster)


exports.default = DisplayObject;
DisplayObject.prototype.displayObjectUpdateTransform = DisplayObject.prototype.updateTransform;
//# sourceMappingURL=DisplayObject.js.map

/***/ }),

/***/ "rWY2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 (c) 2014-2019, Andrii Heonia
 Hull.js, a JavaScript library for concave hull generation by set of points.
 https://github.com/AndriiHeonia/hull
*/



var intersect = __webpack_require__("k2Y9");
var grid = __webpack_require__("TSIo");
var formatUtil = __webpack_require__("YI+C");
var convexHull = __webpack_require__("qowt");

function _filterDuplicates(pointset) {
    var unique = [pointset[0]];
    var lastPoint = pointset[0];
    for (var i = 1; i < pointset.length; i++) {
        var currentPoint = pointset[i];
        if (lastPoint[0] !== currentPoint[0] || lastPoint[1] !== currentPoint[1]) {
            unique.push(currentPoint);
        }
        lastPoint = currentPoint;
    }
    return unique;
}

function _sortByX(pointset) {
    return pointset.sort(function (a, b) {
        return a[0] - b[0] || a[1] - b[1];
    });
}

function _sqLength(a, b) {
    return Math.pow(b[0] - a[0], 2) + Math.pow(b[1] - a[1], 2);
}

function _cos(o, a, b) {
    var aShifted = [a[0] - o[0], a[1] - o[1]],
        bShifted = [b[0] - o[0], b[1] - o[1]],
        sqALen = _sqLength(o, a),
        sqBLen = _sqLength(o, b),
        dot = aShifted[0] * bShifted[0] + aShifted[1] * bShifted[1];

    return dot / Math.sqrt(sqALen * sqBLen);
}

function _intersect(segment, pointset) {
    for (var i = 0; i < pointset.length - 1; i++) {
        var seg = [pointset[i], pointset[i + 1]];
        if (segment[0][0] === seg[0][0] && segment[0][1] === seg[0][1] || segment[0][0] === seg[1][0] && segment[0][1] === seg[1][1]) {
            continue;
        }
        if (intersect(segment, seg)) {
            return true;
        }
    }
    return false;
}

function _occupiedArea(pointset) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;

    for (var i = pointset.length - 1; i >= 0; i--) {
        if (pointset[i][0] < minX) {
            minX = pointset[i][0];
        }
        if (pointset[i][1] < minY) {
            minY = pointset[i][1];
        }
        if (pointset[i][0] > maxX) {
            maxX = pointset[i][0];
        }
        if (pointset[i][1] > maxY) {
            maxY = pointset[i][1];
        }
    }

    return [maxX - minX, // width
    maxY - minY // height
    ];
}

function _bBoxAround(edge) {
    return [Math.min(edge[0][0], edge[1][0]), // left
    Math.min(edge[0][1], edge[1][1]), // top
    Math.max(edge[0][0], edge[1][0]), // right
    Math.max(edge[0][1], edge[1][1]) // bottom
    ];
}

function _midPoint(edge, innerPoints, convex) {
    var point = null,
        angle1Cos = MAX_CONCAVE_ANGLE_COS,
        angle2Cos = MAX_CONCAVE_ANGLE_COS,
        a1Cos = void 0,
        a2Cos = void 0;

    for (var i = 0; i < innerPoints.length; i++) {
        a1Cos = _cos(edge[0], edge[1], innerPoints[i]);
        a2Cos = _cos(edge[1], edge[0], innerPoints[i]);

        if (a1Cos > angle1Cos && a2Cos > angle2Cos && !_intersect([edge[0], innerPoints[i]], convex) && !_intersect([edge[1], innerPoints[i]], convex)) {

            angle1Cos = a1Cos;
            angle2Cos = a2Cos;
            point = innerPoints[i];
        }
    }

    return point;
}

function _concave(convex, maxSqEdgeLen, maxSearchArea, grid, edgeSkipList) {
    var midPointInserted = false;

    for (var i = 0; i < convex.length - 1; i++) {
        var edge = [convex[i], convex[i + 1]];
        // generate a key in the format X0,Y0,X1,Y1
        var keyInSkipList = edge[0][0] + ',' + edge[0][1] + ',' + edge[1][0] + ',' + edge[1][1];

        if (_sqLength(edge[0], edge[1]) < maxSqEdgeLen || edgeSkipList.has(keyInSkipList)) {
            continue;
        }

        var scaleFactor = 0;
        var bBoxAround = _bBoxAround(edge);
        var bBoxWidth = void 0;
        var bBoxHeight = void 0;
        var midPoint = void 0;
        do {
            bBoxAround = grid.extendBbox(bBoxAround, scaleFactor);
            bBoxWidth = bBoxAround[2] - bBoxAround[0];
            bBoxHeight = bBoxAround[3] - bBoxAround[1];

            midPoint = _midPoint(edge, grid.rangePoints(bBoxAround), convex);
            scaleFactor++;
        } while (midPoint === null && (maxSearchArea[0] > bBoxWidth || maxSearchArea[1] > bBoxHeight));

        if (bBoxWidth >= maxSearchArea[0] && bBoxHeight >= maxSearchArea[1]) {
            edgeSkipList.add(keyInSkipList);
        }

        if (midPoint !== null) {
            convex.splice(i + 1, 0, midPoint);
            grid.removePoint(midPoint);
            midPointInserted = true;
        }
    }

    if (midPointInserted) {
        return _concave(convex, maxSqEdgeLen, maxSearchArea, grid, edgeSkipList);
    }

    return convex;
}

function hull(pointset, concavity, format) {
    var maxEdgeLen = concavity || 20;

    var points = _filterDuplicates(_sortByX(formatUtil.toXy(pointset, format)));

    if (points.length < 4) {
        return points.concat([points[0]]);
    }

    var occupiedArea = _occupiedArea(points);
    var maxSearchArea = [occupiedArea[0] * MAX_SEARCH_BBOX_SIZE_PERCENT, occupiedArea[1] * MAX_SEARCH_BBOX_SIZE_PERCENT];

    var convex = convexHull(points);
    var innerPoints = points.filter(function (pt) {
        return convex.indexOf(pt) < 0;
    });

    var cellSize = Math.ceil(1 / (points.length / (occupiedArea[0] * occupiedArea[1])));

    var concave = _concave(convex, Math.pow(maxEdgeLen, 2), maxSearchArea, grid(innerPoints, cellSize), new Set());

    if (format) {
        return formatUtil.fromXy(concave, format);
    } else {
        return concave;
    }
}

var MAX_CONCAVE_ANGLE_COS = Math.cos(90 / (180 / Math.PI)); // angle = 90 deg
var MAX_SEARCH_BBOX_SIZE_PERCENT = 0.6;

module.exports = hull;

/***/ }),

/***/ "raNh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = buildRectangle;

var _buildLine = __webpack_require__("MEjA");

var _buildLine2 = _interopRequireDefault(_buildLine);

var _utils = __webpack_require__("dDI1");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Builds a rectangle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
 */
function buildRectangle(graphicsData, webGLData, webGLDataNativeLines) {
    // --- //
    // need to convert points to a nice regular data
    //
    var rectData = graphicsData.shape;
    var x = rectData.x;
    var y = rectData.y;
    var width = rectData.width;
    var height = rectData.height;

    if (graphicsData.fill) {
        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
        var alpha = graphicsData.fillAlpha;

        var r = color[0] * alpha;
        var g = color[1] * alpha;
        var b = color[2] * alpha;

        var verts = webGLData.points;
        var indices = webGLData.indices;

        var vertPos = verts.length / 6;

        // start
        verts.push(x, y);
        verts.push(r, g, b, alpha);

        verts.push(x + width, y);
        verts.push(r, g, b, alpha);

        verts.push(x, y + height);
        verts.push(r, g, b, alpha);

        verts.push(x + width, y + height);
        verts.push(r, g, b, alpha);

        // insert 2 dead triangles..
        indices.push(vertPos, vertPos, vertPos + 1, vertPos + 2, vertPos + 3, vertPos + 3);
    }

    if (graphicsData.lineWidth) {
        var tempPoints = graphicsData.points;

        graphicsData.points = [x, y, x + width, y, x + width, y + height, x, y + height, x, y];

        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);

        graphicsData.points = tempPoints;
    }
}
//# sourceMappingURL=buildRectangle.js.map

/***/ }),

/***/ "rj2i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),

/***/ "rjpc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var TEMP_RECT = new core.Rectangle();
var BYTES_PER_PIXEL = 4;

/**
 * The extract manager provides functionality to export content from the renderers.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
 *
 * @class
 * @memberof PIXI.extract
 */

var WebGLExtract = function () {
    /**
     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
     */
    function WebGLExtract(renderer) {
        _classCallCheck(this, WebGLExtract);

        this.renderer = renderer;
        /**
         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
         *
         * @member {PIXI.extract.WebGLExtract} extract
         * @memberof PIXI.WebGLRenderer#
         * @see PIXI.extract.WebGLExtract
         */
        renderer.extract = this;
    }

    /**
     * Will return a HTML Image of the target
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {HTMLImageElement} HTML Image of the target
     */

    WebGLExtract.prototype.image = function image(target) {
        var image = new Image();

        image.src = this.base64(target);

        return image;
    };

    /**
     * Will return a a base64 encoded string of this target. It works by calling
     *  `WebGLExtract.getCanvas` and then running toDataURL on that.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {string} A base64 encoded string of the texture.
     */

    WebGLExtract.prototype.base64 = function base64(target) {
        return this.canvas(target).toDataURL();
    };

    /**
     * Creates a Canvas element, renders this target to it and then returns it.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
     */

    WebGLExtract.prototype.canvas = function canvas(target) {
        var renderer = this.renderer;
        var textureBuffer = void 0;
        var resolution = void 0;
        var frame = void 0;
        var flipY = false;
        var renderTexture = void 0;
        var generated = false;

        if (target) {
            if (target instanceof core.RenderTexture) {
                renderTexture = target;
            } else {
                renderTexture = this.renderer.generateTexture(target);
                generated = true;
            }
        }

        if (renderTexture) {
            textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
            resolution = textureBuffer.resolution;
            frame = renderTexture.frame;
            flipY = false;
        } else {
            textureBuffer = this.renderer.rootRenderTarget;
            resolution = textureBuffer.resolution;
            flipY = true;

            frame = TEMP_RECT;
            frame.width = textureBuffer.size.width;
            frame.height = textureBuffer.size.height;
        }

        var width = frame.width * resolution;
        var height = frame.height * resolution;

        var canvasBuffer = new core.CanvasRenderTarget(width, height, 1);

        if (textureBuffer) {
            // bind the buffer
            renderer.bindRenderTarget(textureBuffer);

            // set up an array of pixels
            var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);

            // read pixels to the array
            var gl = renderer.gl;

            gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);

            // add the pixels to the canvas
            var canvasData = canvasBuffer.context.getImageData(0, 0, width, height);

            canvasData.data.set(webglPixels);

            canvasBuffer.context.putImageData(canvasData, 0, 0);

            // pulling pixels
            if (flipY) {
                canvasBuffer.context.scale(1, -1);
                canvasBuffer.context.drawImage(canvasBuffer.canvas, 0, -height);
            }
        }

        if (generated) {
            renderTexture.destroy(true);
        }
        // send the canvas back..

        return canvasBuffer.canvas;
    };

    /**
     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
     * order, with integer values between 0 and 255 (included).
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
     */

    WebGLExtract.prototype.pixels = function pixels(target) {
        var renderer = this.renderer;
        var textureBuffer = void 0;
        var resolution = void 0;
        var frame = void 0;
        var renderTexture = void 0;
        var generated = false;

        if (target) {
            if (target instanceof core.RenderTexture) {
                renderTexture = target;
            } else {
                renderTexture = this.renderer.generateTexture(target);
                generated = true;
            }
        }

        if (renderTexture) {
            textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
            resolution = textureBuffer.resolution;
            frame = renderTexture.frame;
        } else {
            textureBuffer = this.renderer.rootRenderTarget;
            resolution = textureBuffer.resolution;

            frame = TEMP_RECT;
            frame.width = textureBuffer.size.width;
            frame.height = textureBuffer.size.height;
        }

        var width = frame.width * resolution;
        var height = frame.height * resolution;

        var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);

        if (textureBuffer) {
            // bind the buffer
            renderer.bindRenderTarget(textureBuffer);
            // read pixels to the array
            var gl = renderer.gl;

            gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
        }

        if (generated) {
            renderTexture.destroy(true);
        }

        return webglPixels;
    };

    /**
     * Destroys the extract
     *
     */

    WebGLExtract.prototype.destroy = function destroy() {
        this.renderer.extract = null;
        this.renderer = null;
    };

    return WebGLExtract;
}();

exports.default = WebGLExtract;

core.WebGLRenderer.registerPlugin('extract', WebGLExtract);
//# sourceMappingURL=WebGLExtract.js.map

/***/ }),

/***/ "rkyF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),

/***/ "rtye":
/***/ (function(module, exports, __webpack_require__) {


var Texture = __webpack_require__("l5aM");

/**
 * Helper class to create a webGL Framebuffer
 *
 * @class
 * @memberof PIXI.glCore
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param width {Number} the width of the drawing area of the frame buffer
 * @param height {Number} the height of the drawing area of the frame buffer
 */
var Framebuffer = function Framebuffer(gl, width, height) {
  /**
   * The current WebGL rendering context
   *
   * @member {WebGLRenderingContext}
   */
  this.gl = gl;

  /**
   * The frame buffer
   *
   * @member {WebGLFramebuffer}
   */
  this.framebuffer = gl.createFramebuffer();

  /**
   * The stencil buffer
   *
   * @member {WebGLRenderbuffer}
   */
  this.stencil = null;

  /**
   * The stencil buffer
   *
   * @member {PIXI.glCore.GLTexture}
   */
  this.texture = null;

  /**
   * The width of the drawing area of the buffer
   *
   * @member {Number}
   */
  this.width = width || 100;
  /**
   * The height of the drawing area of the buffer
   *
   * @member {Number}
   */
  this.height = height || 100;
};

/**
 * Adds a texture to the frame buffer
 * @param texture {PIXI.glCore.GLTexture}
 */
Framebuffer.prototype.enableTexture = function (texture) {
  var gl = this.gl;

  this.texture = texture || new Texture(gl);

  this.texture.bind();

  //gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,  this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);

  this.bind();

  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture.texture, 0);
};

/**
 * Initialises the stencil buffer
 */
Framebuffer.prototype.enableStencil = function () {
  if (this.stencil) return;

  var gl = this.gl;

  this.stencil = gl.createRenderbuffer();

  gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);

  // TODO.. this is depth AND stencil?
  gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, this.stencil);
  gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, this.width, this.height);
};

/**
 * Erases the drawing area and fills it with a colour
 * @param  r {Number} the red value of the clearing colour
 * @param  g {Number} the green value of the clearing colour
 * @param  b {Number} the blue value of the clearing colour
 * @param  a {Number} the alpha value of the clearing colour
 */
Framebuffer.prototype.clear = function (r, g, b, a) {
  this.bind();

  var gl = this.gl;

  gl.clearColor(r, g, b, a);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
};

/**
 * Binds the frame buffer to the WebGL context
 */
Framebuffer.prototype.bind = function () {
  var gl = this.gl;
  gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
};

/**
 * Unbinds the frame buffer to the WebGL context
 */
Framebuffer.prototype.unbind = function () {
  var gl = this.gl;
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
};
/**
 * Resizes the drawing area of the buffer to the given width and height
 * @param  width  {Number} the new width
 * @param  height {Number} the new height
 */
Framebuffer.prototype.resize = function (width, height) {
  var gl = this.gl;

  this.width = width;
  this.height = height;

  if (this.texture) {
    this.texture.uploadData(null, width, height);
  }

  if (this.stencil) {
    // update the stencil buffer width and height
    gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);
    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
  }
};

/**
 * Destroys this buffer
 */
Framebuffer.prototype.destroy = function () {
  var gl = this.gl;

  //TODO
  if (this.texture) {
    this.texture.destroy();
  }

  gl.deleteFramebuffer(this.framebuffer);

  this.gl = null;

  this.stencil = null;
  this.texture = null;
};

/**
 * Creates a frame buffer with a texture containing the given data
 * @static
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param width {Number} the width of the drawing area of the frame buffer
 * @param height {Number} the height of the drawing area of the frame buffer
 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
 */
Framebuffer.createRGBA = function (gl, width, height, data) {
  var texture = Texture.fromData(gl, null, width, height);
  texture.enableNearestScaling();
  texture.enableWrapClamp();

  //now create the framebuffer object and attach the texture to it.
  var fbo = new Framebuffer(gl, width, height);
  fbo.enableTexture(texture);
  //fbo.enableStencil(); // get this back on soon!

  //fbo.enableStencil(); // get this back on soon!

  fbo.unbind();

  return fbo;
};

/**
 * Creates a frame buffer with a texture containing the given data
 * @static
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param width {Number} the width of the drawing area of the frame buffer
 * @param height {Number} the height of the drawing area of the frame buffer
 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
 */
Framebuffer.createFloat32 = function (gl, width, height, data) {
  // create a new texture..
  var texture = new Texture.fromData(gl, data, width, height);
  texture.enableNearestScaling();
  texture.enableWrapClamp();

  //now create the framebuffer object and attach the texture to it.
  var fbo = new Framebuffer(gl, width, height);
  fbo.enableTexture(texture);

  fbo.unbind();

  return fbo;
};

module.exports = Framebuffer;

/***/ }),

/***/ "s0lT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;
exports.default = extractUniformsFromSrc;

var _pixiGlCore = __webpack_require__("PJsv");

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var defaultValue = _pixiGlCore2.default.shader.defaultValue;

function extractUniformsFromSrc(vertexSrc, fragmentSrc, mask) {
    var vertUniforms = extractUniformsFromString(vertexSrc, mask);
    var fragUniforms = extractUniformsFromString(fragmentSrc, mask);

    return _extends(vertUniforms, fragUniforms);
}

function extractUniformsFromString(string) {
    var maskRegex = new RegExp('^(projectionMatrix|uSampler|filterArea|filterClamp)$');

    var uniforms = {};
    var nameSplit = void 0;

    // clean the lines a little - remove extra spaces / tabs etc
    // then split along ';'
    var lines = string.replace(/\s+/g, ' ').split(/\s*;\s*/);

    // loop through..
    for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();

        if (line.indexOf('uniform') > -1) {
            var splitLine = line.split(' ');
            var type = splitLine[1];

            var name = splitLine[2];
            var size = 1;

            if (name.indexOf('[') > -1) {
                // array!
                nameSplit = name.split(/\[|]/);
                name = nameSplit[0];
                size *= Number(nameSplit[1]);
            }

            if (!name.match(maskRegex)) {
                uniforms[name] = {
                    value: defaultValue(type, size),
                    name: name,
                    type: type
                };
            }
        }
    }

    return uniforms;
}
//# sourceMappingURL=extractUniformsFromSrc.js.map

/***/ }),

/***/ "s8Q5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.isDate = isDate;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */
function isDate(value) {
  return value instanceof Date && !isNaN(value.valueOf());
}

/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {[type]} d
 * @param {[type]} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameMonth(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDate: isDate,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),

/***/ "sNCo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__("rkyF");

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var root; /* global window */

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac"), __webpack_require__("l262")(module)))

/***/ }),

/***/ "sUm+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _GroupD = __webpack_require__("PGIZ");

var _GroupD2 = _interopRequireDefault(_GroupD);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * A standard object to store the Uvs of a texture
 *
 * @class
 * @private
 * @memberof PIXI
 */
var TextureUvs = function () {
    /**
     *
     */
    function TextureUvs() {
        _classCallCheck(this, TextureUvs);

        this.x0 = 0;
        this.y0 = 0;

        this.x1 = 1;
        this.y1 = 0;

        this.x2 = 1;
        this.y2 = 1;

        this.x3 = 0;
        this.y3 = 1;

        this.uvsUint32 = new Uint32Array(4);
    }

    /**
     * Sets the texture Uvs based on the given frame information.
     *
     * @private
     * @param {PIXI.Rectangle} frame - The frame of the texture
     * @param {PIXI.Rectangle} baseFrame - The base frame of the texture
     * @param {number} rotate - Rotation of frame, see {@link PIXI.GroupD8}
     */

    TextureUvs.prototype.set = function set(frame, baseFrame, rotate) {
        var tw = baseFrame.width;
        var th = baseFrame.height;

        if (rotate) {
            // width and height div 2 div baseFrame size
            var w2 = frame.width / 2 / tw;
            var h2 = frame.height / 2 / th;

            // coordinates of center
            var cX = frame.x / tw + w2;
            var cY = frame.y / th + h2;

            rotate = _GroupD2.default.add(rotate, _GroupD2.default.NW); // NW is top-left corner
            this.x0 = cX + w2 * _GroupD2.default.uX(rotate);
            this.y0 = cY + h2 * _GroupD2.default.uY(rotate);

            rotate = _GroupD2.default.add(rotate, 2); // rotate 90 degrees clockwise
            this.x1 = cX + w2 * _GroupD2.default.uX(rotate);
            this.y1 = cY + h2 * _GroupD2.default.uY(rotate);

            rotate = _GroupD2.default.add(rotate, 2);
            this.x2 = cX + w2 * _GroupD2.default.uX(rotate);
            this.y2 = cY + h2 * _GroupD2.default.uY(rotate);

            rotate = _GroupD2.default.add(rotate, 2);
            this.x3 = cX + w2 * _GroupD2.default.uX(rotate);
            this.y3 = cY + h2 * _GroupD2.default.uY(rotate);
        } else {
            this.x0 = frame.x / tw;
            this.y0 = frame.y / th;

            this.x1 = (frame.x + frame.width) / tw;
            this.y1 = frame.y / th;

            this.x2 = (frame.x + frame.width) / tw;
            this.y2 = (frame.y + frame.height) / th;

            this.x3 = frame.x / tw;
            this.y3 = (frame.y + frame.height) / th;
        }

        this.uvsUint32[0] = (Math.round(this.y0 * 65535) & 0xFFFF) << 16 | Math.round(this.x0 * 65535) & 0xFFFF;
        this.uvsUint32[1] = (Math.round(this.y1 * 65535) & 0xFFFF) << 16 | Math.round(this.x1 * 65535) & 0xFFFF;
        this.uvsUint32[2] = (Math.round(this.y2 * 65535) & 0xFFFF) << 16 | Math.round(this.x2 * 65535) & 0xFFFF;
        this.uvsUint32[3] = (Math.round(this.y3 * 65535) & 0xFFFF) << 16 | Math.round(this.x3 * 65535) & 0xFFFF;
    };

    return TextureUvs;
}();

exports.default = TextureUvs;
//# sourceMappingURL=TextureUvs.js.map

/***/ }),

/***/ "sY57":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Mesh2 = __webpack_require__("esRn");

var _Mesh3 = _interopRequireDefault(_Mesh2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The Plane allows you to draw a texture across several points and them manipulate these points
 *
 *```js
 * for (let i = 0; i < 20; i++) {
 *     points.push(new PIXI.Point(i * 50, 0));
 * };
 * let Plane = new PIXI.Plane(PIXI.Texture.fromImage("snake.png"), points);
 *  ```
 *
 * @class
 * @extends PIXI.mesh.Mesh
 * @memberof PIXI.mesh
 *
 */
var Plane = function (_Mesh) {
    _inherits(Plane, _Mesh);

    /**
     * @param {PIXI.Texture} texture - The texture to use on the Plane.
     * @param {number} [verticesX=10] - The number of vertices in the x-axis
     * @param {number} [verticesY=10] - The number of vertices in the y-axis
     */
    function Plane(texture, verticesX, verticesY) {
        _classCallCheck(this, Plane);

        /**
         * Tracker for if the Plane is ready to be drawn. Needed because Mesh ctor can
         * call _onTextureUpdated which could call refresh too early.
         *
         * @member {boolean}
         * @private
         */
        var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));

        _this._ready = true;

        _this.verticesX = verticesX || 10;
        _this.verticesY = verticesY || 10;

        _this.drawMode = _Mesh3.default.DRAW_MODES.TRIANGLES;
        _this.refresh();
        return _this;
    }

    /**
     * Refreshes plane coordinates
     *
     */

    Plane.prototype._refresh = function _refresh() {
        var texture = this._texture;
        var total = this.verticesX * this.verticesY;
        var verts = [];
        var colors = [];
        var uvs = [];
        var indices = [];

        var segmentsX = this.verticesX - 1;
        var segmentsY = this.verticesY - 1;

        var sizeX = texture.width / segmentsX;
        var sizeY = texture.height / segmentsY;

        for (var i = 0; i < total; i++) {
            var x = i % this.verticesX;
            var y = i / this.verticesX | 0;

            verts.push(x * sizeX, y * sizeY);

            uvs.push(x / segmentsX, y / segmentsY);
        }

        //  cons

        var totalSub = segmentsX * segmentsY;

        for (var _i = 0; _i < totalSub; _i++) {
            var xpos = _i % segmentsX;
            var ypos = _i / segmentsX | 0;

            var value = ypos * this.verticesX + xpos;
            var value2 = ypos * this.verticesX + xpos + 1;
            var value3 = (ypos + 1) * this.verticesX + xpos;
            var value4 = (ypos + 1) * this.verticesX + xpos + 1;

            indices.push(value, value2, value3);
            indices.push(value2, value4, value3);
        }

        // console.log(indices)
        this.vertices = new Float32Array(verts);
        this.uvs = new Float32Array(uvs);
        this.colors = new Float32Array(colors);
        this.indices = new Uint16Array(indices);

        this.dirty++;
        this.indexDirty++;

        this.multiplyUvs();
    };

    /**
     * Clear texture UVs when new texture is set
     *
     * @private
     */

    Plane.prototype._onTextureUpdate = function _onTextureUpdate() {
        _Mesh3.default.prototype._onTextureUpdate.call(this);

        // wait for the Plane ctor to finish before calling refresh
        if (this._ready) {
            this.refresh();
        }
    };

    return Plane;
}(_Mesh3.default);

exports.default = Plane;
//# sourceMappingURL=Plane.js.map

/***/ }),

/***/ "sdh2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _Sprite2 = __webpack_require__("oWLW");

var _Sprite3 = _interopRequireDefault(_Sprite2);

var _Texture = __webpack_require__("xUki");

var _Texture2 = _interopRequireDefault(_Texture);

var _math = __webpack_require__("e3iB");

var _utils = __webpack_require__("dDI1");

var _const = __webpack_require__("YEQi");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

var _TextStyle = __webpack_require__("gZse");

var _TextStyle2 = _interopRequireDefault(_TextStyle);

var _TextMetrics = __webpack_require__("nMdc");

var _TextMetrics2 = _interopRequireDefault(_TextMetrics);

var _trimCanvas = __webpack_require__("dt3n");

var _trimCanvas2 = _interopRequireDefault(_trimCanvas);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint max-depth: [2, 8] */

var defaultDestroyOptions = {
    texture: true,
    children: false,
    baseTexture: true
};

/**
 * A Text Object will create a line or multiple lines of text. To split a line you can use '\n' in your text string,
 * or add a wordWrap property set to true and and wordWrapWidth property with a value in the style object.
 *
 * A Text can be created directly from a string and a style object,
 * which can be generated [here](https://pixijs.io/pixi-text-style).
 *
 * ```js
 * let text = new PIXI.Text('This is a PixiJS text',{fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'});
 * ```
 *
 * @class
 * @extends PIXI.Sprite
 * @memberof PIXI
 */

var Text = function (_Sprite) {
    _inherits(Text, _Sprite);

    /**
     * @param {string} text - The string that you would like the text to display
     * @param {object|PIXI.TextStyle} [style] - The style parameters
     * @param {HTMLCanvasElement} [canvas] - The canvas element for drawing text
     */
    function Text(text, style, canvas) {
        _classCallCheck(this, Text);

        canvas = canvas || document.createElement('canvas');

        canvas.width = 3;
        canvas.height = 3;

        var texture = _Texture2.default.fromCanvas(canvas, _settings2.default.SCALE_MODE, 'text');

        texture.orig = new _math.Rectangle();
        texture.trim = new _math.Rectangle();

        // base texture is already automatically added to the cache, now adding the actual texture
        var _this = _possibleConstructorReturn(this, _Sprite.call(this, texture));

        _Texture2.default.addToCache(_this._texture, _this._texture.baseTexture.textureCacheIds[0]);

        /**
         * The canvas element that everything is drawn to
         *
         * @member {HTMLCanvasElement}
         */
        _this.canvas = canvas;

        /**
         * The canvas 2d context that everything is drawn with
         * @member {CanvasRenderingContext2D}
         */
        _this.context = _this.canvas.getContext('2d');

        /**
         * The resolution / device pixel ratio of the canvas. This is set automatically by the renderer.
         * @member {number}
         * @default 1
         */
        _this.resolution = _settings2.default.RESOLUTION;

        /**
         * Private tracker for the current text.
         *
         * @member {string}
         * @private
         */
        _this._text = null;

        /**
         * Private tracker for the current style.
         *
         * @member {object}
         * @private
         */
        _this._style = null;
        /**
         * Private listener to track style changes.
         *
         * @member {Function}
         * @private
         */
        _this._styleListener = null;

        /**
         * Private tracker for the current font.
         *
         * @member {string}
         * @private
         */
        _this._font = '';

        _this.text = text;
        _this.style = style;

        _this.localStyleID = -1;
        return _this;
    }

    /**
     * Renders text and updates it when needed.
     *
     * @private
     * @param {boolean} respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
     */

    Text.prototype.updateText = function updateText(respectDirty) {
        var style = this._style;

        // check if style has changed..
        if (this.localStyleID !== style.styleID) {
            this.dirty = true;
            this.localStyleID = style.styleID;
        }

        if (!this.dirty && respectDirty) {
            return;
        }

        this._font = this._style.toFontString();

        var context = this.context;
        var measured = _TextMetrics2.default.measureText(this._text, this._style, this._style.wordWrap, this.canvas);
        var width = measured.width;
        var height = measured.height;
        var lines = measured.lines;
        var lineHeight = measured.lineHeight;
        var lineWidths = measured.lineWidths;
        var maxLineWidth = measured.maxLineWidth;
        var fontProperties = measured.fontProperties;

        this.canvas.width = Math.ceil((Math.max(1, width) + style.padding * 2) * this.resolution);
        this.canvas.height = Math.ceil((Math.max(1, height) + style.padding * 2) * this.resolution);

        context.scale(this.resolution, this.resolution);

        context.clearRect(0, 0, this.canvas.width, this.canvas.height);

        context.font = this._font;
        context.strokeStyle = style.stroke;
        context.lineWidth = style.strokeThickness;
        context.textBaseline = style.textBaseline;
        context.lineJoin = style.lineJoin;
        context.miterLimit = style.miterLimit;

        var linePositionX = void 0;
        var linePositionY = void 0;

        if (style.dropShadow) {
            context.fillStyle = style.dropShadowColor;
            context.globalAlpha = style.dropShadowAlpha;
            context.shadowBlur = style.dropShadowBlur;

            if (style.dropShadowBlur > 0) {
                context.shadowColor = style.dropShadowColor;
            }

            var xShadowOffset = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
            var yShadowOffset = Math.sin(style.dropShadowAngle) * style.dropShadowDistance;

            for (var i = 0; i < lines.length; i++) {
                linePositionX = style.strokeThickness / 2;
                linePositionY = style.strokeThickness / 2 + i * lineHeight + fontProperties.ascent;

                if (style.align === 'right') {
                    linePositionX += maxLineWidth - lineWidths[i];
                } else if (style.align === 'center') {
                    linePositionX += (maxLineWidth - lineWidths[i]) / 2;
                }

                if (style.fill) {
                    this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding);

                    if (style.stroke && style.strokeThickness) {
                        context.strokeStyle = style.dropShadowColor;
                        this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding, true);
                        context.strokeStyle = style.stroke;
                    }
                }
            }
        }

        // reset the shadow blur and alpha that was set by the drop shadow, for the regular text
        context.shadowBlur = 0;
        context.globalAlpha = 1;

        // set canvas text styles
        context.fillStyle = this._generateFillStyle(style, lines);

        // draw lines line by line
        for (var _i = 0; _i < lines.length; _i++) {
            linePositionX = style.strokeThickness / 2;
            linePositionY = style.strokeThickness / 2 + _i * lineHeight + fontProperties.ascent;

            if (style.align === 'right') {
                linePositionX += maxLineWidth - lineWidths[_i];
            } else if (style.align === 'center') {
                linePositionX += (maxLineWidth - lineWidths[_i]) / 2;
            }

            if (style.stroke && style.strokeThickness) {
                this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding, true);
            }

            if (style.fill) {
                this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding);
            }
        }

        this.updateTexture();
    };

    /**
     * Render the text with letter-spacing.
     * @param {string} text - The text to draw
     * @param {number} x - Horizontal position to draw the text
     * @param {number} y - Vertical position to draw the text
     * @param {boolean} [isStroke=false] - Is this drawing for the outside stroke of the
     *  text? If not, it's for the inside fill
     * @private
     */

    Text.prototype.drawLetterSpacing = function drawLetterSpacing(text, x, y) {
        var isStroke = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var style = this._style;

        // letterSpacing of 0 means normal
        var letterSpacing = style.letterSpacing;

        if (letterSpacing === 0) {
            if (isStroke) {
                this.context.strokeText(text, x, y);
            } else {
                this.context.fillText(text, x, y);
            }

            return;
        }

        var characters = String.prototype.split.call(text, '');
        var currentPosition = x;
        var index = 0;
        var current = '';

        while (index < text.length) {
            current = characters[index++];
            if (isStroke) {
                this.context.strokeText(current, currentPosition, y);
            } else {
                this.context.fillText(current, currentPosition, y);
            }
            currentPosition += this.context.measureText(current).width + letterSpacing;
        }
    };

    /**
     * Updates texture size based on canvas size
     *
     * @private
     */

    Text.prototype.updateTexture = function updateTexture() {
        var canvas = this.canvas;

        if (this._style.trim) {
            var trimmed = (0, _trimCanvas2.default)(canvas);

            if (trimmed.data) {
                canvas.width = trimmed.width;
                canvas.height = trimmed.height;
                this.context.putImageData(trimmed.data, 0, 0);
            }
        }

        var texture = this._texture;
        var style = this._style;
        var padding = style.trim ? 0 : style.padding;
        var baseTexture = texture.baseTexture;

        baseTexture.hasLoaded = true;
        baseTexture.resolution = this.resolution;

        baseTexture.realWidth = canvas.width;
        baseTexture.realHeight = canvas.height;
        baseTexture.width = canvas.width / this.resolution;
        baseTexture.height = canvas.height / this.resolution;

        texture.trim.width = texture._frame.width = canvas.width / this.resolution;
        texture.trim.height = texture._frame.height = canvas.height / this.resolution;
        texture.trim.x = -padding;
        texture.trim.y = -padding;

        texture.orig.width = texture._frame.width - padding * 2;
        texture.orig.height = texture._frame.height - padding * 2;

        // call sprite onTextureUpdate to update scale if _width or _height were set
        this._onTextureUpdate();

        baseTexture.emit('update', baseTexture);

        this.dirty = false;
    };

    /**
     * Renders the object using the WebGL renderer
     *
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */

    Text.prototype.renderWebGL = function renderWebGL(renderer) {
        if (this.resolution !== renderer.resolution) {
            this.resolution = renderer.resolution;
            this.dirty = true;
        }

        this.updateText(true);

        _Sprite.prototype.renderWebGL.call(this, renderer);
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The renderer
     */

    Text.prototype._renderCanvas = function _renderCanvas(renderer) {
        if (this.resolution !== renderer.resolution) {
            this.resolution = renderer.resolution;
            this.dirty = true;
        }

        this.updateText(true);

        _Sprite.prototype._renderCanvas.call(this, renderer);
    };

    /**
     * Gets the local bounds of the text object.
     *
     * @param {Rectangle} rect - The output rectangle.
     * @return {Rectangle} The bounds.
     */

    Text.prototype.getLocalBounds = function getLocalBounds(rect) {
        this.updateText(true);

        return _Sprite.prototype.getLocalBounds.call(this, rect);
    };

    /**
     * calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account.
     */

    Text.prototype._calculateBounds = function _calculateBounds() {
        this.updateText(true);
        this.calculateVertices();
        // if we have already done this on THIS frame.
        this._bounds.addQuad(this.vertexData);
    };

    /**
     * Method to be called upon a TextStyle change.
     * @private
     */

    Text.prototype._onStyleChange = function _onStyleChange() {
        this.dirty = true;
    };

    /**
     * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
     *
     * @private
     * @param {object} style - The style.
     * @param {string[]} lines - The lines of text.
     * @return {string|number|CanvasGradient} The fill style
     */

    Text.prototype._generateFillStyle = function _generateFillStyle(style, lines) {
        if (!Array.isArray(style.fill)) {
            return style.fill;
        }

        // cocoon on canvas+ cannot generate textures, so use the first colour instead
        if (navigator.isCocoonJS) {
            return style.fill[0];
        }

        // the gradient will be evenly spaced out according to how large the array is.
        // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
        var gradient = void 0;
        var totalIterations = void 0;
        var currentIteration = void 0;
        var stop = void 0;

        var width = this.canvas.width / this.resolution;
        var height = this.canvas.height / this.resolution;

        // make a copy of the style settings, so we can manipulate them later
        var fill = style.fill.slice();
        var fillGradientStops = style.fillGradientStops.slice();

        // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
        if (!fillGradientStops.length) {
            var lengthPlus1 = fill.length + 1;

            for (var i = 1; i < lengthPlus1; ++i) {
                fillGradientStops.push(i / lengthPlus1);
            }
        }

        // stop the bleeding of the last gradient on the line above to the top gradient of the this line
        // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
        fill.unshift(style.fill[0]);
        fillGradientStops.unshift(0);

        fill.push(style.fill[style.fill.length - 1]);
        fillGradientStops.push(1);

        if (style.fillGradientType === _const.TEXT_GRADIENT.LINEAR_VERTICAL) {
            // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
            gradient = this.context.createLinearGradient(width / 2, 0, width / 2, height);

            // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
            // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
            totalIterations = (fill.length + 1) * lines.length;
            currentIteration = 0;
            for (var _i2 = 0; _i2 < lines.length; _i2++) {
                currentIteration += 1;
                for (var j = 0; j < fill.length; j++) {
                    if (typeof fillGradientStops[j] === 'number') {
                        stop = fillGradientStops[j] / lines.length + _i2 / lines.length;
                    } else {
                        stop = currentIteration / totalIterations;
                    }
                    gradient.addColorStop(stop, fill[j]);
                    currentIteration++;
                }
            }
        } else {
            // start the gradient at the center left of the canvas, and end at the center right of the canvas
            gradient = this.context.createLinearGradient(0, height / 2, width, height / 2);

            // can just evenly space out the gradients in this case, as multiple lines makes no difference
            // to an even left to right gradient
            totalIterations = fill.length + 1;
            currentIteration = 1;

            for (var _i3 = 0; _i3 < fill.length; _i3++) {
                if (typeof fillGradientStops[_i3] === 'number') {
                    stop = fillGradientStops[_i3];
                } else {
                    stop = currentIteration / totalIterations;
                }
                gradient.addColorStop(stop, fill[_i3]);
                currentIteration++;
            }
        }

        return gradient;
    };

    /**
     * Destroys this text object.
     * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
     * the majority of the time the texture will not be shared with any other Sprites.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their
     *  destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
     */

    Text.prototype.destroy = function destroy(options) {
        if (typeof options === 'boolean') {
            options = { children: options };
        }

        options = _extends({}, defaultDestroyOptions, options);

        _Sprite.prototype.destroy.call(this, options);

        // make sure to reset the the context and canvas.. dont want this hanging around in memory!
        this.context = null;
        this.canvas = null;

        this._style = null;
    };

    /**
     * The width of the Text, setting this will actually modify the scale to achieve the value set
     *
     * @member {number}
     */

    _createClass(Text, [{
        key: 'width',
        get: function get() {
            this.updateText(true);

            return Math.abs(this.scale.x) * this._texture.orig.width;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.updateText(true);

            var s = (0, _utils.sign)(this.scale.x) || 1;

            this.scale.x = s * value / this._texture.orig.width;
            this._width = value;
        }

        /**
         * The height of the Text, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            this.updateText(true);

            return Math.abs(this.scale.y) * this._texture.orig.height;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.updateText(true);

            var s = (0, _utils.sign)(this.scale.y) || 1;

            this.scale.y = s * value / this._texture.orig.height;
            this._height = value;
        }

        /**
         * Set the style of the text. Set up an event listener to listen for changes on the style
         * object and mark the text as dirty.
         *
         * @member {object|PIXI.TextStyle}
         */

    }, {
        key: 'style',
        get: function get() {
            return this._style;
        },
        set: function set(style) // eslint-disable-line require-jsdoc
        {
            style = style || {};

            if (style instanceof _TextStyle2.default) {
                this._style = style;
            } else {
                this._style = new _TextStyle2.default(style);
            }

            this.localStyleID = -1;
            this.dirty = true;
        }

        /**
         * Set the copy for the text object. To split a line you can use '\n'.
         *
         * @member {string}
         */

    }, {
        key: 'text',
        get: function get() {
            return this._text;
        },
        set: function set(text) // eslint-disable-line require-jsdoc
        {
            text = String(text === '' || text === null || text === undefined ? ' ' : text);

            if (this._text === text) {
                return;
            }
            this._text = text;
            this.dirty = true;
        }
    }]);

    return Text;
}(_Sprite3.default);

exports.default = Text;
//# sourceMappingURL=Text.js.map

/***/ }),

/***/ "sh3Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

module.exports = function () {
    function Plugin(parent) {
        _classCallCheck(this, Plugin);

        this.parent = parent;
        this.paused = false;
    }

    /**
     * handler for pointerdown PIXI event
     * @param {PIXI.interaction.InteractionEvent} event
     */

    _createClass(Plugin, [{
        key: "down",
        value: function down(event) {}

        /**
         * handler for pointermove PIXI event
         * @param {PIXI.interaction.InteractionEvent} event
         */

    }, {
        key: "move",
        value: function move(event) {}

        /**
         * handler for pointerup PIXI event
         * @param {PIXI.interaction.InteractionEvent} event
         */

    }, {
        key: "up",
        value: function up(event) {}

        /**
         * handler for wheel event on div
         * @param {WheelEvent} event
         */

    }, {
        key: "wheel",
        value: function wheel(event) {}

        /**
         * called on each tick
         */

    }, {
        key: "update",
        value: function update() {}

        /**
         * called when the viewport is resized
         */

    }, {
        key: "resize",
        value: function resize() {}

        /**
         * called when the viewport is manually moved
         */

    }, {
        key: "reset",
        value: function reset() {}

        /**
         * called when viewport is paused
         */

    }, {
        key: "pause",
        value: function pause() {
            this.paused = true;
        }

        /**
         * called when viewport is resumed
         */

    }, {
        key: "resume",
        value: function resume() {
            this.paused = false;
        }
    }]);

    return Plugin;
}();

/***/ }),

/***/ "slyL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var defaultStyle = {
    align: 'left',
    fill: 0xffffff,
    fontSize: 26,
    fontWeight: 'normal',
    lineHeight: 0,
    wordWrap: false,
    anchor: new PIXI.Point(0, 0)
};

var TextStyle = function () {
    function TextStyle(style) {
        _classCallCheck(this, TextStyle);

        this.styleID = 0;
        _extends(this, defaultStyle, style);
    }

    TextStyle.prototype.getFlatCopy = function getFlatCopy() {
        return {
            align: this.align,
            fontSize: this.fontSize,
            fill: this.fill,
            fontWeight: this.fontWeight,
            width: this.wordWrapWidth,
            wordWrapWidth: this.wordWrapWidth,
            lineHeight: this.lineHeight
        };
    };

    _createClass(TextStyle, [{
        key: "center",
        get: function get() {
            return this._anchor;
        },
        set: function set(value) {
            this._anchor = value;
        }
    }, {
        key: "anchor",
        get: function get() {
            return this._anchor;
        },
        set: function set(anch) {
            this._anchor = anch;
        }
    }, {
        key: "align",
        get: function get() {
            return this._align;
        },
        set: function set(value) {
            this._align = value;
            this.styleID++;
        }
    }, {
        key: "weight",
        get: function get() {
            return this._weight;
        }
    }, {
        key: "fontWeight",
        get: function get() {
            return this._weight < 0.4 ? 'bold' : 'normal';
        },
        set: function set(value) {
            this._weight = value === 'bold' ? 0.3 : 0.7;
            this.styleID++;
        }
    }, {
        key: "fontSize",
        get: function get() {
            return this._fontSize;
        },
        set: function set(value) {
            this._fontSize = value;
            this.styleID++;
        }
    }, {
        key: "fill",
        get: function get() {
            return this._fill;
        },
        set: function set(value) {
            var outputColor = PIXI.utils.hex2rgb(value);
            if (this._fill !== outputColor) {
                this._fill = outputColor;
                this.styleID++;
            }
        }
    }]);

    return TextStyle;
}();

exports.default = TextStyle;
//# sourceMappingURL=text-style.js.map

/***/ }),

/***/ "sq5Z":
/***/ (function(module, exports, __webpack_require__) {

var mapType = __webpack_require__("3hrJ");
var defaultValue = __webpack_require__("7Hmw");

/**
 * Extracts the uniforms
 * @class
 * @memberof PIXI.glCore.shader
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param program {WebGLProgram} The shader program to get the uniforms from
 * @return uniforms {Object}
 */
var extractUniforms = function extractUniforms(gl, program) {
  var uniforms = {};

  var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);

  for (var i = 0; i < totalUniforms; i++) {
    var uniformData = gl.getActiveUniform(program, i);
    var name = uniformData.name.replace(/\[.*?\]/, "");
    var type = mapType(gl, uniformData.type);

    uniforms[name] = {
      type: type,
      size: uniformData.size,
      location: gl.getUniformLocation(program, name),
      value: defaultValue(type, uniformData.size)
    };
  }

  return uniforms;
};

module.exports = extractUniforms;

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "tALL":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined") {
    win = self;
} else {
    win = {};
}

module.exports = win;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "tLgl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bb4bd6045e9e0e997d535465804929e3.svg";

/***/ }),

/***/ "tMVT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _maxRecommendedTextures = __webpack_require__("4eqS");

var _maxRecommendedTextures2 = _interopRequireDefault(_maxRecommendedTextures);

var _canUploadSameBuffer = __webpack_require__("JVKT");

var _canUploadSameBuffer2 = _interopRequireDefault(_canUploadSameBuffer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * User's customizable globals for overriding the default PIXI settings, such
 * as a renderer's default resolution, framerate, float percision, etc.
 * @example
 * // Use the native window resolution as the default resolution
 * // will support high-density displays when rendering
 * PIXI.settings.RESOLUTION = window.devicePixelRatio.
 *
 * // Disable interpolation when scaling, will make texture be pixelated
 * PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
 * @namespace PIXI.settings
 */
exports.default = {

  /**
   * Target frames per millisecond.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 0.06
   */
  TARGET_FPMS: 0.06,

  /**
   * If set to true WebGL will attempt make textures mimpaped by default.
   * Mipmapping will only succeed if the base texture uploaded has power of two dimensions.
   *
   * @static
   * @memberof PIXI.settings
   * @type {boolean}
   * @default true
   */
  MIPMAP_TEXTURES: true,

  /**
   * Default resolution / device pixel ratio of the renderer.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */
  RESOLUTION: 1,

  /**
   * Default filter resolution.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */
  FILTER_RESOLUTION: 1,

  /**
   * The maximum textures that this device supports.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 32
   */
  SPRITE_MAX_TEXTURES: (0, _maxRecommendedTextures2.default)(32),

  // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
  // TODO: maybe add PARTICLE.BATCH_SIZE: 15000

  /**
   * The default sprite batch size.
   *
   * The default aims to balance desktop and mobile devices.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 4096
   */
  SPRITE_BATCH_SIZE: 4096,

  /**
   * The prefix that denotes a URL is for a retina asset.
   *
   * @static
   * @memberof PIXI.settings
   * @type {RegExp}
   * @example `@2x`
   * @default /@([0-9\.]+)x/
   */
  RETINA_PREFIX: /@([0-9\.]+)x/,

  /**
   * The default render options if none are supplied to {@link PIXI.WebGLRenderer}
   * or {@link PIXI.CanvasRenderer}.
   *
   * @static
   * @constant
   * @memberof PIXI.settings
   * @type {object}
   * @property {HTMLCanvasElement} view=null
   * @property {number} resolution=1
   * @property {boolean} antialias=false
   * @property {boolean} forceFXAA=false
   * @property {boolean} autoResize=false
   * @property {boolean} transparent=false
   * @property {number} backgroundColor=0x000000
   * @property {boolean} clearBeforeRender=true
   * @property {boolean} preserveDrawingBuffer=false
   * @property {boolean} roundPixels=false
   * @property {number} width=800
   * @property {number} height=600
   * @property {boolean} legacy=false
   */
  RENDER_OPTIONS: {
    view: null,
    antialias: false,
    forceFXAA: false,
    autoResize: false,
    transparent: false,
    backgroundColor: 0x000000,
    clearBeforeRender: true,
    preserveDrawingBuffer: false,
    roundPixels: false,
    width: 800,
    height: 600,
    legacy: false
  },

  /**
   * Default transform type.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.TRANSFORM_MODE}
   * @default PIXI.TRANSFORM_MODE.STATIC
   */
  TRANSFORM_MODE: 0,

  /**
   * Default Garbage Collection mode.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.GC_MODES}
   * @default PIXI.GC_MODES.AUTO
   */
  GC_MODE: 0,

  /**
   * Default Garbage Collection max idle.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 3600
   */
  GC_MAX_IDLE: 60 * 60,

  /**
   * Default Garbage Collection maximum check count.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 600
   */
  GC_MAX_CHECK_COUNT: 60 * 10,

  /**
   * Default wrap modes that are supported by pixi.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.WRAP_MODES}
   * @default PIXI.WRAP_MODES.CLAMP
   */
  WRAP_MODE: 0,

  /**
   * The scale modes that are supported by pixi.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.SCALE_MODES}
   * @default PIXI.SCALE_MODES.LINEAR
   */
  SCALE_MODE: 0,

  /**
   * Default specify float precision in vertex shader.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @default PIXI.PRECISION.HIGH
   */
  PRECISION_VERTEX: 'highp',

  /**
   * Default specify float precision in fragment shader.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @default PIXI.PRECISION.MEDIUM
   */
  PRECISION_FRAGMENT: 'mediump',

  /**
   * Can we upload the same buffer in a single frame?
   *
   * @static
   * @constant
   * @memberof PIXI.settings
   * @type {boolean}
   */
  CAN_UPLOAD_SAME_BUFFER: (0, _canUploadSameBuffer2.default)(),

  /**
   * Default Mesh `canvasPadding`.
   *
   * @see PIXI.mesh.Mesh#canvasPadding
   * @static
   * @constant
   * @memberof PIXI.settings
   * @type {number}
   */
  MESH_CANVAS_PADDING: 0
};
//# sourceMappingURL=settings.js.map

/***/ }),

/***/ "tXzk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__("dDI1");

var _const = __webpack_require__("YEQi");

var _ObjectRenderer2 = __webpack_require__("oXPp");

var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);

var _WebGLRenderer = __webpack_require__("i77b");

var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

var _WebGLGraphicsData = __webpack_require__("3MQf");

var _WebGLGraphicsData2 = _interopRequireDefault(_WebGLGraphicsData);

var _PrimitiveShader = __webpack_require__("udb+");

var _PrimitiveShader2 = _interopRequireDefault(_PrimitiveShader);

var _buildPoly = __webpack_require__("EYtC");

var _buildPoly2 = _interopRequireDefault(_buildPoly);

var _buildRectangle = __webpack_require__("raNh");

var _buildRectangle2 = _interopRequireDefault(_buildRectangle);

var _buildRoundedRectangle = __webpack_require__("BGVx");

var _buildRoundedRectangle2 = _interopRequireDefault(_buildRoundedRectangle);

var _buildCircle = __webpack_require__("gTSb");

var _buildCircle2 = _interopRequireDefault(_buildCircle);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Renders the graphics object.
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.ObjectRenderer
 */
var GraphicsRenderer = function (_ObjectRenderer) {
    _inherits(GraphicsRenderer, _ObjectRenderer);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this object renderer works for.
     */
    function GraphicsRenderer(renderer) {
        _classCallCheck(this, GraphicsRenderer);

        var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));

        _this.graphicsDataPool = [];

        _this.primitiveShader = null;

        _this.gl = renderer.gl;

        // easy access!
        _this.CONTEXT_UID = 0;
        return _this;
    }

    /**
     * Called when there is a WebGL context change
     *
     * @private
     *
     */

    GraphicsRenderer.prototype.onContextChange = function onContextChange() {
        this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        this.primitiveShader = new _PrimitiveShader2.default(this.gl);
    };

    /**
     * Destroys this renderer.
     *
     */

    GraphicsRenderer.prototype.destroy = function destroy() {
        _ObjectRenderer3.default.prototype.destroy.call(this);

        for (var i = 0; i < this.graphicsDataPool.length; ++i) {
            this.graphicsDataPool[i].destroy();
        }

        this.graphicsDataPool = null;
    };

    /**
     * Renders a graphics object.
     *
     * @param {PIXI.Graphics} graphics - The graphics object to render.
     */

    GraphicsRenderer.prototype.render = function render(graphics) {
        var renderer = this.renderer;
        var gl = renderer.gl;

        var webGLData = void 0;
        var webGL = graphics._webGL[this.CONTEXT_UID];

        if (!webGL || graphics.dirty !== webGL.dirty) {
            this.updateGraphics(graphics);

            webGL = graphics._webGL[this.CONTEXT_UID];
        }

        // This  could be speeded up for sure!
        var shader = this.primitiveShader;

        renderer.bindShader(shader);
        renderer.state.setBlendMode(graphics.blendMode);

        for (var i = 0, n = webGL.data.length; i < n; i++) {
            webGLData = webGL.data[i];
            var shaderTemp = webGLData.shader;

            renderer.bindShader(shaderTemp);
            shaderTemp.uniforms.translationMatrix = graphics.transform.worldTransform.toArray(true);
            shaderTemp.uniforms.tint = (0, _utils.hex2rgb)(graphics.tint);
            shaderTemp.uniforms.alpha = graphics.worldAlpha;

            renderer.bindVao(webGLData.vao);

            if (webGLData.nativeLines) {
                gl.drawArrays(gl.LINES, 0, webGLData.points.length / 6);
            } else {
                webGLData.vao.draw(gl.TRIANGLE_STRIP, webGLData.indices.length);
            }
        }
    };

    /**
     * Updates the graphics object
     *
     * @private
     * @param {PIXI.Graphics} graphics - The graphics object to update
     */

    GraphicsRenderer.prototype.updateGraphics = function updateGraphics(graphics) {
        var gl = this.renderer.gl;

        // get the contexts graphics object
        var webGL = graphics._webGL[this.CONTEXT_UID];

        // if the graphics object does not exist in the webGL context time to create it!
        if (!webGL) {
            webGL = graphics._webGL[this.CONTEXT_UID] = { lastIndex: 0, data: [], gl: gl, clearDirty: -1, dirty: -1 };
        }

        // flag the graphics as not dirty as we are about to update it...
        webGL.dirty = graphics.dirty;

        // if the user cleared the graphics object we will need to clear every object
        if (graphics.clearDirty !== webGL.clearDirty) {
            webGL.clearDirty = graphics.clearDirty;

            // loop through and return all the webGLDatas to the object pool so than can be reused later on
            for (var i = 0; i < webGL.data.length; i++) {
                this.graphicsDataPool.push(webGL.data[i]);
            }

            // clear the array and reset the index..
            webGL.data.length = 0;
            webGL.lastIndex = 0;
        }

        var webGLData = void 0;
        var webGLDataNativeLines = void 0;

        // loop through the graphics datas and construct each one..
        // if the object is a complex fill then the new stencil buffer technique will be used
        // other wise graphics objects will be pushed into a batch..
        for (var _i = webGL.lastIndex; _i < graphics.graphicsData.length; _i++) {
            var data = graphics.graphicsData[_i];

            // TODO - this can be simplified
            webGLData = this.getWebGLData(webGL, 0);

            if (data.nativeLines && data.lineWidth) {
                webGLDataNativeLines = this.getWebGLData(webGL, 0, true);
                webGL.lastIndex++;
            }

            if (data.type === _const.SHAPES.POLY) {
                (0, _buildPoly2.default)(data, webGLData, webGLDataNativeLines);
            }
            if (data.type === _const.SHAPES.RECT) {
                (0, _buildRectangle2.default)(data, webGLData, webGLDataNativeLines);
            } else if (data.type === _const.SHAPES.CIRC || data.type === _const.SHAPES.ELIP) {
                (0, _buildCircle2.default)(data, webGLData, webGLDataNativeLines);
            } else if (data.type === _const.SHAPES.RREC) {
                (0, _buildRoundedRectangle2.default)(data, webGLData, webGLDataNativeLines);
            }

            webGL.lastIndex++;
        }

        this.renderer.bindVao(null);

        // upload all the dirty data...
        for (var _i2 = 0; _i2 < webGL.data.length; _i2++) {
            webGLData = webGL.data[_i2];

            if (webGLData.dirty) {
                webGLData.upload();
            }
        }
    };

    /**
     *
     * @private
     * @param {WebGLRenderingContext} gl - the current WebGL drawing context
     * @param {number} type - TODO @Alvin
     * @param {number} nativeLines - indicate whether the webGLData use for nativeLines.
     * @return {*} TODO
     */

    GraphicsRenderer.prototype.getWebGLData = function getWebGLData(gl, type, nativeLines) {
        var webGLData = gl.data[gl.data.length - 1];

        if (!webGLData || webGLData.nativeLines !== nativeLines || webGLData.points.length > 320000) {
            webGLData = this.graphicsDataPool.pop() || new _WebGLGraphicsData2.default(this.renderer.gl, this.primitiveShader, this.renderer.state.attribsState);
            webGLData.nativeLines = nativeLines;
            webGLData.reset(type);
            gl.data.push(webGLData);
        }

        webGLData.dirty = true;

        return webGLData;
    };

    return GraphicsRenderer;
}(_ObjectRenderer3.default);

exports.default = GraphicsRenderer;

_WebGLRenderer2.default.registerPlugin('graphics', GraphicsRenderer);
//# sourceMappingURL=GraphicsRenderer.js.map

/***/ }),

/***/ "tkK7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ "tknA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pixiGlCore = __webpack_require__("PJsv");

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

var _createIndicesForQuads = __webpack_require__("DI0o");

var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 * Helper class to create a quad
 *
 * @class
 * @memberof PIXI
 */
var Quad = function () {
  /**
   * @param {WebGLRenderingContext} gl - The gl context for this quad to use.
   * @param {object} state - TODO: Description
   */
  function Quad(gl, state) {
    _classCallCheck(this, Quad);

    /**
     * the current WebGL drawing context
     *
     * @member {WebGLRenderingContext}
     */
    this.gl = gl;

    /**
     * An array of vertices
     *
     * @member {Float32Array}
     */
    this.vertices = new Float32Array([-1, -1, 1, -1, 1, 1, -1, 1]);

    /**
     * The Uvs of the quad
     *
     * @member {Float32Array}
     */
    this.uvs = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);

    this.interleaved = new Float32Array(8 * 2);

    for (var i = 0; i < 4; i++) {
      this.interleaved[i * 4] = this.vertices[i * 2];
      this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
      this.interleaved[i * 4 + 2] = this.uvs[i * 2];
      this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
    }

    /**
     * An array containing the indices of the vertices
     *
     * @member {Uint16Array}
     */
    this.indices = (0, _createIndicesForQuads2.default)(1);

    /**
     * The vertex buffer
     *
     * @member {glCore.GLBuffer}
     */
    this.vertexBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, this.interleaved, gl.STATIC_DRAW);

    /**
     * The index buffer
     *
     * @member {glCore.GLBuffer}
     */
    this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);

    /**
     * The vertex array object
     *
     * @member {glCore.VertexArrayObject}
     */
    this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, state);
  }

  /**
   * Initialises the vaos and uses the shader.
   *
   * @param {PIXI.Shader} shader - the shader to use
   */

  Quad.prototype.initVao = function initVao(shader) {
    this.vao.clear().addIndex(this.indexBuffer).addAttribute(this.vertexBuffer, shader.attributes.aVertexPosition, this.gl.FLOAT, false, 4 * 4, 0).addAttribute(this.vertexBuffer, shader.attributes.aTextureCoord, this.gl.FLOAT, false, 4 * 4, 2 * 4);
  };

  /**
   * Maps two Rectangle to the quad.
   *
   * @param {PIXI.Rectangle} targetTextureFrame - the first rectangle
   * @param {PIXI.Rectangle} destinationFrame - the second rectangle
   * @return {PIXI.Quad} Returns itself.
   */

  Quad.prototype.map = function map(targetTextureFrame, destinationFrame) {
    var x = 0; // destinationFrame.x / targetTextureFrame.width;
    var y = 0; // destinationFrame.y / targetTextureFrame.height;

    this.uvs[0] = x;
    this.uvs[1] = y;

    this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width;
    this.uvs[3] = y;

    this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width;
    this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height;

    this.uvs[6] = x;
    this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height;

    x = destinationFrame.x;
    y = destinationFrame.y;

    this.vertices[0] = x;
    this.vertices[1] = y;

    this.vertices[2] = x + destinationFrame.width;
    this.vertices[3] = y;

    this.vertices[4] = x + destinationFrame.width;
    this.vertices[5] = y + destinationFrame.height;

    this.vertices[6] = x;
    this.vertices[7] = y + destinationFrame.height;

    return this;
  };

  /**
   * Binds the buffer and uploads the data
   *
   * @return {PIXI.Quad} Returns itself.
   */

  Quad.prototype.upload = function upload() {
    for (var i = 0; i < 4; i++) {
      this.interleaved[i * 4] = this.vertices[i * 2];
      this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
      this.interleaved[i * 4 + 2] = this.uvs[i * 2];
      this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
    }

    this.vertexBuffer.upload(this.interleaved);

    return this;
  };

  /**
   * Removes this quad from WebGL
   */

  Quad.prototype.destroy = function destroy() {
    var gl = this.gl;

    gl.deleteBuffer(this.vertexBuffer);
    gl.deleteBuffer(this.indexBuffer);
  };

  return Quad;
}();

exports.default = Quad;
//# sourceMappingURL=Quad.js.map

/***/ }),

/***/ "to8j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("MC1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__("cSRp");



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("pv+l")(module)))

/***/ }),

/***/ "tq9m":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xhr = __webpack_require__("iMim");
var noop = function noop() {};
var parseASCII = __webpack_require__("FYdd");
var parseXML = __webpack_require__("u3a5");
var readBinary = __webpack_require__("B7+M");
var isBinaryFormat = __webpack_require__("2dnb");
var xtend = __webpack_require__("K5Tb");

var xml2 = function hasXML2() {
  return self.XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
}();

module.exports = function (opt, cb) {
  cb = typeof cb === 'function' ? cb : noop;

  if (typeof opt === 'string') opt = { uri: opt };else if (!opt) opt = {};

  var expectBinary = opt.binary;
  if (expectBinary) opt = getBinaryOpts(opt);

  xhr(opt, function (err, res, body) {
    if (err) return cb(err);
    if (!/^2/.test(res.statusCode)) return cb(new Error('http status code: ' + res.statusCode));
    if (!body) return cb(new Error('no body result'));

    var binary = false;

    //if the response type is an array buffer,
    //we need to convert it into a regular Buffer object
    if (isArrayBuffer(body)) {
      var array = new Uint8Array(body);
      body = new Buffer(array, 'binary');
    }

    //now check the string/Buffer response
    //and see if it has a binary BMF header
    if (isBinaryFormat(body)) {
      binary = true;
      //if we have a string, turn it into a Buffer
      if (typeof body === 'string') body = new Buffer(body, 'binary');
    }

    //we are not parsing a binary format, just ASCII/XML/etc
    if (!binary) {
      //might still be a buffer if responseType is 'arraybuffer'
      if (Buffer.isBuffer(body)) body = body.toString(opt.encoding);
      body = body.trim();
    }

    var result;
    try {
      var type = res.headers['content-type'];
      if (binary) result = readBinary(body);else if (/json/.test(type) || body.charAt(0) === '{') result = JSON.parse(body);else if (/xml/.test(type) || body.charAt(0) === '<') result = parseXML(body);else result = parseASCII(body);
    } catch (e) {
      cb(new Error('error parsing font ' + e.message));
      cb = noop;
    }
    cb(null, result);
  });
};

function isArrayBuffer(arr) {
  var str = Object.prototype.toString;
  return str.call(arr) === '[object ArrayBuffer]';
}

function getBinaryOpts(opt) {
  //IE10+ and other modern browsers support array buffers
  if (xml2) return xtend(opt, { responseType: 'arraybuffer' });

  if (typeof self.XMLHttpRequest === 'undefined') throw new Error('your browser does not support XHR loading');

  //IE9 and XML1 browsers could still use an override
  var req = new self.XMLHttpRequest();
  req.overrideMimeType('text/plain; charset=x-user-defined');
  return xtend({
    xhr: req
  }, opt);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("dskh").Buffer))

/***/ }),

/***/ "tsWd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("mI+K");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),

/***/ "tyHu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_TICKETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_TICKETS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_TICKETS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_TICKETS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHECK_ACCESS_CODE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHECK_ACCESS_CODE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHECK_ACCESS_CODE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_TICKET_QUANTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TICKET_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_DOTATION_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SELECT_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REMOVE_ACCESS_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SHOW_ACCESS_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SHOW_CUSTOM_DONATION_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return clearTickets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return showAccessCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return checkAccessCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return removeAccessCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return loadTickets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return addQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return addPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return updateDonationAmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return showCustomDonationField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return selectDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventsService__ = __webpack_require__("4Q11");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orderSummaryActions__ = __webpack_require__("E70C");


var CLEAR_TICKETS = "CLEAR_TICKETS";

var GET_TICKETS_REQUEST = "GET_TICKETS_REQUEST";
var GET_TICKETS_SUCCESS = "GET_TICKETS_SUCCESS";
var GET_TICKETS_ERROR = "GET_TICKETS_ERROR";

var CHECK_ACCESS_CODE_REQUEST = "CHECK_ACCESS_CODE_REQUEST";
var CHECK_ACCESS_CODE_SUCCESS = "CHECK_ACCESS_CODE_SUCCESS";
var CHECK_ACCESS_CODE_ERROR = "CHECK_ACCESS_CODE_ERROR";

var ADD_TICKET_QUANTITY = "ADD_TICKET_QUANTITY";
var ADD_TICKET_PRICE = "ADD_TICKET_PRICE";
var UPDATE_DOTATION_AMOUNT = "UPDATE_DOTATION_AMOUNT";
var SELECT_DATE = "SELECT_DATE";
var REMOVE_ACCESS_CODE = "REMOVE_ACCESS_CODE";
var SHOW_ACCESS_CODES = "SHOW_ACCESS_CODES";

var SHOW_CUSTOM_DONATION_FIELD = "SHOW_CUSTOM_DONATION_FIELD";



var clearTickets = function clearTickets() {
  return function (dispatch) {
    dispatch({ type: CLEAR_TICKETS });
  };
};

var showAccessCodes = function showAccessCodes() {
  return function (dispatch) {
    dispatch({ type: SHOW_ACCESS_CODES });
  };
};

var checkAccessCode = function checkAccessCode(eventId, accessCode) {
  var forceLoadTickets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return function (dispatch, getState) {
    dispatch({ type: CHECK_ACCESS_CODE_REQUEST, eventId: eventId, accessCode: accessCode });
    __WEBPACK_IMPORTED_MODULE_0__services_EventsService__["a" /* default */].checkAccessCode(eventId, accessCode).then(function () {
      var state = getState();
      dispatch({ type: CHECK_ACCESS_CODE_SUCCESS, accessCode: accessCode });
      if (forceLoadTickets) {
        dispatch(loadTickets(state.event.id, state.ticketSelection.selectedDateId, accessCode));
      }
    }).catch(function (err) {
      var message = err.response.status === 404 ? "Access password not valid" : "Error apply access password";
      dispatch({ type: CHECK_ACCESS_CODE_ERROR, error: message });
    });
  };
};

var removeAccessCode = function removeAccessCode() {
  return function (dispatch, getState) {
    dispatch({ type: REMOVE_ACCESS_CODE });
    var state = getState();
    dispatch(loadTickets(state.event.id, state.ticketSelection.selectedDateId, null));
  };
};

var loadTickets = function loadTickets(eventId, dateId, accessCode) {
  return function (dispatch) {
    dispatch({ type: GET_TICKETS_REQUEST, eventId: eventId, dateId: dateId });
    __WEBPACK_IMPORTED_MODULE_0__services_EventsService__["a" /* default */].getTickets(eventId, dateId, accessCode).then(function (tickets) {
      dispatch({ type: GET_TICKETS_SUCCESS, tickets: tickets });
    }).catch(function (err) {
      dispatch({ type: GET_TICKETS_ERROR, error: err });
    });
  };
};

var addQuantity = function addQuantity(ticketTypeId, quantity) {
  return function (dispatch, getState) {
    dispatch({ type: ADD_TICKET_QUANTITY, ticketTypeId: ticketTypeId, quantity: quantity });
    var state = getState();
    Object(__WEBPACK_IMPORTED_MODULE_1__orderSummaryActions__["d" /* loadSummary */])(state.event.id, state.ticketSelection.tickets, state.ticketSelection.clientDonation)(dispatch);
  };
};

var addPrice = function addPrice(ticketTypeId, price) {
  return function (dispatch, getState) {
    dispatch({ type: ADD_TICKET_PRICE, ticketTypeId: ticketTypeId, price: price });
    var state = getState();
    Object(__WEBPACK_IMPORTED_MODULE_1__orderSummaryActions__["d" /* loadSummary */])(state.event.id, state.ticketSelection.tickets, state.ticketSelection.clientDonation)(dispatch);
  };
};

var updateDonationAmount = function updateDonationAmount(amount) {
  return function (dispatch, getState) {
    dispatch({ type: UPDATE_DOTATION_AMOUNT, amount: amount });
    var state = getState();
    Object(__WEBPACK_IMPORTED_MODULE_1__orderSummaryActions__["d" /* loadSummary */])(state.event.id, state.ticketSelection.tickets, state.ticketSelection.clientDonation)(dispatch);
  };
};

var showCustomDonationField = function showCustomDonationField() {
  return function (dispatch) {
    dispatch({ type: SHOW_CUSTOM_DONATION_FIELD, donationOtherOption: true });
  };
};

var selectDate = function selectDate(dateId, dateDisplay, startDate) {
  return function (dispatch, getState) {
    dispatch({ type: SELECT_DATE, dateId: dateId, dateDisplay: dateDisplay, startDate: startDate });
    var state = getState();
    Object(__WEBPACK_IMPORTED_MODULE_1__orderSummaryActions__["d" /* loadSummary */])(state.event.id, state.ticketSelection.tickets, state.ticketSelection.clientDonation)(dispatch);
    loadTickets(state.event.id, dateId, state.ticketSelection.accessCode)(dispatch);
  };
};

/***/ }),

/***/ "u3a5":
/***/ (function(module, exports, __webpack_require__) {

var parseAttributes = __webpack_require__("HWKW");
var parseFromString = __webpack_require__("i99N");

//In some cases element.attribute.nodeName can return
//all lowercase values.. so we need to map them to the correct 
//case
var NAME_MAP = {
  scaleh: 'scaleH',
  scalew: 'scaleW',
  stretchh: 'stretchH',
  lineheight: 'lineHeight',
  alphachnl: 'alphaChnl',
  redchnl: 'redChnl',
  greenchnl: 'greenChnl',
  bluechnl: 'blueChnl'
};

module.exports = function parse(data) {
  data = data.toString();

  var xmlRoot = parseFromString(data);
  var output = {
    pages: [],
    chars: [],
    kernings: []

    //get config settings
  };['info', 'common'].forEach(function (key) {
    var element = xmlRoot.getElementsByTagName(key)[0];
    if (element) output[key] = parseAttributes(getAttribs(element));
  });

  //get page info
  var pageRoot = xmlRoot.getElementsByTagName('pages')[0];
  if (!pageRoot) throw new Error('malformed file -- no <pages> element');
  var pages = pageRoot.getElementsByTagName('page');
  for (var i = 0; i < pages.length; i++) {
    var p = pages[i];
    var id = parseInt(p.getAttribute('id'), 10);
    var file = p.getAttribute('file');
    if (isNaN(id)) throw new Error('malformed file -- page "id" attribute is NaN');
    if (!file) throw new Error('malformed file -- needs page "file" attribute');
    output.pages[parseInt(id, 10)] = file;
  }

  //get kernings / chars
  ;['chars', 'kernings'].forEach(function (key) {
    var element = xmlRoot.getElementsByTagName(key)[0];
    if (!element) return;
    var childTag = key.substring(0, key.length - 1);
    var children = element.getElementsByTagName(childTag);
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      output[key].push(parseAttributes(getAttribs(child)));
    }
  });
  return output;
};

function getAttribs(element) {
  var attribs = getAttribList(element);
  return attribs.reduce(function (dict, attrib) {
    var key = mapName(attrib.nodeName);
    dict[key] = attrib.nodeValue;
    return dict;
  }, {});
}

function getAttribList(element) {
  //IE8+ and modern browsers
  var attribs = [];
  for (var i = 0; i < element.attributes.length; i++) {
    attribs.push(element.attributes[i]);
  }return attribs;
}

function mapName(nodeName) {
  return NAME_MAP[nodeName.toLowerCase()] || nodeName;
}

/***/ }),

/***/ "uGyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uSo9":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__("kAhx");

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';
  return document.location.href;
}

function getLocationOrigin() {
  if (typeof document === 'undefined' || document.location == null) return '';

  // Oh dear IE10...
  if (!document.location.origin) {
    return document.location.protocol + '//' + document.location.hostname + (document.location.port ? ':' + document.location.port : '');
  }

  return document.location.origin;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = function reportModuleWrapper() {
  var handlers = [],
      lastArgs = null,
      lastException = null,
      lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
        _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function () {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
}();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if (parts = chrome.exec(lines[i])) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if (parts = winjs.exec(lines[i])) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if (parts = gecko.exec(lines[i])) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      if (element.url && element.url.substr(0, 5) === 'blob:') {
        // Special case for handling JavaScript loaded into a blob.
        // We use a synchronous AJAX request here as a blob is already in
        // memory - it's not making a network request.  This will generate a warning
        // in the browser console, but there has already been an error so that's not
        // that much of an issue.
        var xhr = new XMLHttpRequest();
        xhr.open('GET', element.url, false);
        xhr.send(null);

        // If we failed to download the source, skip this patch
        if (xhr.status === 200) {
          var source = xhr.responseText || '';

          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
          source = source.slice(-300);

          // Now we dig out the source map URL
          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);

          // If we don't find a source map comment or we find more than one, continue on to the next element.
          if (sourceMaps) {
            var sourceMapAddress = sourceMaps[1];

            // Now we check to see if it's a relative URL.
            // If it is, convert it to an absolute one.
            if (sourceMapAddress.charAt(0) === '~') {
              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
            }

            // Now we strip the '.map' off of the end of the URL and update the
            // element so that Sentry can match the map to the blob.
            element.url = sourceMapAddress.slice(0, -4);
          }
        }
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
        stack = [],
        funcs = {},
        recursion = false,
        parts,
        item,
        source;

    for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if (parts = functionName.exec(curr.toString())) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
}();

module.exports = TraceKit;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "uTLr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ea637931744acbdf4e69c533c133d062.svg";

/***/ }),

/***/ "uTT0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

/***/ }),

/***/ "udb+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Shader2 = __webpack_require__("wBQE");

var _Shader3 = _interopRequireDefault(_Shader2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * This shader is used to draw simple primitive shapes for {@link PIXI.Graphics}.
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.Shader
 */
var PrimitiveShader = function (_Shader) {
  _inherits(PrimitiveShader, _Shader);

  /**
   * @param {WebGLRenderingContext} gl - The webgl shader manager this shader works for.
   */
  function PrimitiveShader(gl) {
    _classCallCheck(this, PrimitiveShader);

    return _possibleConstructorReturn(this, _Shader.call(this, gl,
    // vertex shader
    ['attribute vec2 aVertexPosition;', 'attribute vec4 aColor;', 'uniform mat3 translationMatrix;', 'uniform mat3 projectionMatrix;', 'uniform float alpha;', 'uniform vec3 tint;', 'varying vec4 vColor;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vColor = aColor * vec4(tint * alpha, alpha);', '}'].join('\n'),
    // fragment shader
    ['varying vec4 vColor;', 'void main(void){', '   gl_FragColor = vColor;', '}'].join('\n')));
  }

  return PrimitiveShader;
}(_Shader3.default);

exports.default = PrimitiveShader;
//# sourceMappingURL=PrimitiveShader.js.map

/***/ }),

/***/ "uh8Y":
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function cycleReplacer(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function (key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null ? value instanceof Error ? stringifyError(value) : value : replacer.call(this, key, value);
  };
}

/***/ }),

/***/ "ulr3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("Ywoo");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement('div', { className: classNames.weekdays, role: 'rowgroup' }, _react2.default.createElement('div', { className: classNames.weekdaysRow, role: 'row' }, showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }), days));
    }
  }]);

  return Weekdays;
}(_react.Component);

exports.default = Weekdays;
Weekdays.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    weekday: _propTypes2.default.string.isRequired,
    weekdays: _propTypes2.default.string.isRequired,
    weekdaysRow: _propTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _propTypes2.default.number.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showWeekNumbers: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
} : {};
//# sourceMappingURL=Weekdays.js.map

/***/ }),

/***/ "uz6X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var transformData = __webpack_require__("woEt");
var isCancel = __webpack_require__("V3+0");
var defaults = __webpack_require__("BXyq");
var isAbsoluteURL = __webpack_require__("7/2Y");
var combineURLs = __webpack_require__("a2Uu");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),

/***/ "v4E7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__("mnG2");

var isCallable = __webpack_require__("b4C7");

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function DefaultValue(O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};

/***/ }),

/***/ "vKdq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

var MiniSignalBinding = function () {
  function MiniSignalBinding(fn, once, thisArg) {
    if (once === undefined) once = false;

    _classCallCheck(this, MiniSignalBinding);

    this._fn = fn;
    this._once = once;
    this._thisArg = thisArg;
    this._next = this._prev = this._owner = null;
  }

  _createClass(MiniSignalBinding, [{
    key: 'detach',
    value: function detach() {
      if (this._owner === null) return false;
      this._owner.detach(this);
      return true;
    }
  }]);

  return MiniSignalBinding;
}();

function _addMiniSignalBinding(self, node) {
  if (!self._head) {
    self._head = node;
    self._tail = node;
  } else {
    self._tail._next = node;
    node._prev = self._tail;
    self._tail = node;
  }

  node._owner = self;

  return node;
}

var MiniSignal = function () {
  function MiniSignal() {
    _classCallCheck(this, MiniSignal);

    this._head = this._tail = undefined;
  }

  _createClass(MiniSignal, [{
    key: 'handlers',
    value: function handlers() {
      var exists = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

      var node = this._head;

      if (exists) return !!node;

      var ee = [];

      while (node) {
        ee.push(node);
        node = node._next;
      }

      return ee;
    }
  }, {
    key: 'has',
    value: function has(node) {
      if (!(node instanceof MiniSignalBinding)) {
        throw new Error('MiniSignal#has(): First arg must be a MiniSignalBinding object.');
      }

      return node._owner === this;
    }
  }, {
    key: 'dispatch',
    value: function dispatch() {
      var node = this._head;

      if (!node) return false;

      while (node) {
        if (node._once) this.detach(node);
        node._fn.apply(node._thisArg, arguments);
        node = node._next;
      }

      return true;
    }
  }, {
    key: 'add',
    value: function add(fn) {
      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

      if (typeof fn !== 'function') {
        throw new Error('MiniSignal#add(): First arg must be a Function.');
      }
      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, false, thisArg));
    }
  }, {
    key: 'once',
    value: function once(fn) {
      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

      if (typeof fn !== 'function') {
        throw new Error('MiniSignal#once(): First arg must be a Function.');
      }
      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, true, thisArg));
    }
  }, {
    key: 'detach',
    value: function detach(node) {
      if (!(node instanceof MiniSignalBinding)) {
        throw new Error('MiniSignal#detach(): First arg must be a MiniSignalBinding object.');
      }
      if (node._owner !== this) return this;

      if (node._prev) node._prev._next = node._next;
      if (node._next) node._next._prev = node._prev;

      if (node === this._head) {
        this._head = node._next;
        if (node._next === null) {
          this._tail = null;
        }
      } else if (node === this._tail) {
        this._tail = node._prev;
        this._tail._next = null;
      }

      node._owner = null;
      return this;
    }
  }, {
    key: 'detachAll',
    value: function detachAll() {
      var node = this._head;
      if (!node) return this;

      this._head = this._tail = null;

      while (node) {
        node._owner = null;
        node = node._next;
      }
      return this;
    }
  }]);

  return MiniSignal;
}();

MiniSignal.MiniSignalBinding = MiniSignalBinding;

exports['default'] = MiniSignal;
module.exports = exports['default'];

/***/ }),

/***/ "vUdk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Mesh = PIXI.mesh.Mesh;
var loadFont = __webpack_require__("tq9m");
var createLayout = __webpack_require__("5Nhd");
var createIndices = __webpack_require__("Rtmq");
var vertices = __webpack_require__("1eZj");
var text_style_1 = __webpack_require__("slyL");
var Utils_1 = __webpack_require__("o6Mn");
var Config_1 = __webpack_require__("gH/r");

var Text = function (_PIXI$mesh$Mesh) {
    _inherits(Text, _PIXI$mesh$Mesh);

    function Text(text) {
        var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Text);

        var _this = _possibleConstructorReturn(this, _PIXI$mesh$Mesh.call(this, style.texture));

        _this.debug = false;
        _this.style = new text_style_1.default(style);
        _this._text = text;
        _this.pluginName = 'sdf';
        _this.loadAssets();
        _this.parentGroup = Config_1.default.textGroup;
        return _this;
    }

    Text.prototype.setKey = function setKey() {
        var text = this._text;
        var fill = this.style.fill;
        var fontSize = this.style.fontSize;
        var weight = this.style.weight;
        this.key = "" + text + fill.toString() + fontSize + weight;
    };

    Text.prototype.loadAssets = function loadAssets() {
        this._font = Config_1.default.font;
        this.font = this._font;
        this._texture = PIXI.loader.resources[Utils_1.lato].texture;
        this.updateText();
    };

    Text.prototype.updateText = function updateText() {
        this.setKey();
        var opt = _extends({ text: this._text, font: this._font }, this.style.getFlatCopy());
        this.layout = createLayout(opt);
        var flipY = opt.flipY !== false;
        var font = this._font;
        var texWidth = font.common.scaleW;
        var texHeight = font.common.scaleH;
        var glyphs = this.layout.glyphs.filter(function (glyph) {
            var bitmap = glyph.data;
            return bitmap.width * bitmap.height > 0;
        });
        this.visibleGlyphs = glyphs;
        var positions = vertices.positions(glyphs);
        var uvs = vertices.uvs(glyphs, texWidth, texHeight, false);
        this.indices = createIndices({
            clockwise: true,
            type: 'uint16',
            count: glyphs.length
        });
        this.vertices = new Float32Array(positions);
        this.uvs = new Float32Array(uvs);
        this.styleID = this.style.styleID;
        this.dirty++;
        this.indexDirty++;
        this.calculateVertices();
        this.calculateTextSize();
        var xPos = this.style.anchor.x * this.textWidth + 0.5;
        var yPos = this.style.anchor.y * this.textHeight;
        this.position = new PIXI.Point(-xPos, yPos);
    };

    Text.prototype.calculateTextSize = function calculateTextSize() {
        if (this.vertexData.length >= 2) {
            var minX = this.vertexData[0];
            var maxX = this.vertexData[0];
            var minY = this.vertexData[1];
            var maxY = this.vertexData[1];
            for (var i = 0; i < this.vertexData.length; i += 2) {
                var xIndex = i;
                var yIndex = i + 1;
                var x = this.vertexData[xIndex];
                var y = this.vertexData[yIndex];
                if (x > maxX) {
                    maxX = x;
                } else if (x < minX) {
                    minX = x;
                }
                if (y > maxY) {
                    maxY = y;
                } else if (y < minY) {
                    minY = y;
                }
            }
            this.textWidth = maxX - minX;
            this.textHeight = maxY - minY;
        }
    };

    Text.prototype.getTransform = function getTransform() {
        var transArray = this.transform.worldTransform.toArray(true);
        var res = new Float32Array(transArray.length);
        res.set(transArray);
        return res;
    };

    Text.prototype._calculateBounds = function _calculateBounds() {
        this.calculateVertices();
    };

    Text.prototype.calculateVertices = function calculateVertices() {
        var vertices = this.vertices;
        var n = vertices.length;
        if (!this.vertexData || this.vertexData.length !== n) {
            this.vertexData = new Float32Array(n);
        }
        var vertexData = this.vertexData;
        var fontSize = this.style.fontSize / this._font.info.size;
        var matrix = this.transform.worldTransform;
        var a = matrix.a;
        var b = matrix.b;
        var c = matrix.c;
        var d = matrix.d;
        var tx = matrix.tx;
        var ty = matrix.ty;
        for (var i = 0; i < n; i += 2) {
            var rawX = vertices[i] * fontSize;
            var rawY = vertices[i + 1] * fontSize;
            vertexData[i] = a * rawX + c * rawY + tx;
            vertexData[i + 1] = d * rawY + b * rawX + ty;
            this._bounds.addPoint(new PIXI.Point(vertexData[i], vertexData[i + 1]));
        }
    };

    _createClass(Text, [{
        key: "text",
        get: function get() {
            return this._text;
        },
        set: function set(value) {
            this._text = value;
            this.updateText();
        }
    }, {
        key: "fill",
        set: function set(value) {
            this.style.fill = value;
        }
    }]);

    return Text;
}(PIXI.mesh.Mesh);

exports.default = Text;
//# sourceMappingURL=text.js.map

/***/ }),

/***/ "vamC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Point = __webpack_require__("TceE");

var _Point2 = _interopRequireDefault(_Point);

var _const = __webpack_require__("YEQi");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * @class
 * @memberof PIXI
 */
var Polygon = function () {
    /**
     * @param {PIXI.Point[]|number[]} points - This can be an array of Points
     *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
     *  the arguments passed can be all the points of the polygon e.g.
     *  `new PIXI.Polygon(new PIXI.Point(), new PIXI.Point(), ...)`, or the arguments passed can be flat
     *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
     */
    function Polygon() {
        for (var _len = arguments.length, points = Array(_len), _key = 0; _key < _len; _key++) {
            points[_key] = arguments[_key];
        }

        _classCallCheck(this, Polygon);

        if (Array.isArray(points[0])) {
            points = points[0];
        }

        // if this is an array of points, convert it to a flat array of numbers
        if (points[0] instanceof _Point2.default) {
            var p = [];

            for (var i = 0, il = points.length; i < il; i++) {
                p.push(points[i].x, points[i].y);
            }

            points = p;
        }

        this.closed = true;

        /**
         * An array of the points of this polygon
         *
         * @member {number[]}
         */
        this.points = points;

        /**
         * The type of the object, mainly used to avoid `instanceof` checks
         *
         * @member {number}
         * @readOnly
         * @default PIXI.SHAPES.POLY
         * @see PIXI.SHAPES
         */
        this.type = _const.SHAPES.POLY;
    }

    /**
     * Creates a clone of this polygon
     *
     * @return {PIXI.Polygon} a copy of the polygon
     */

    Polygon.prototype.clone = function clone() {
        return new Polygon(this.points.slice());
    };

    /**
     * Closes the polygon, adding points if necessary.
     *
     */

    Polygon.prototype.close = function close() {
        var points = this.points;

        // close the poly if the value is true!
        if (points[0] !== points[points.length - 2] || points[1] !== points[points.length - 1]) {
            points.push(points[0], points[1]);
        }
    };

    /**
     * Checks whether the x and y coordinates passed to this function are contained within this polygon
     *
     * @param {number} x - The X coordinate of the point to test
     * @param {number} y - The Y coordinate of the point to test
     * @return {boolean} Whether the x/y coordinates are within this polygon
     */

    Polygon.prototype.contains = function contains(x, y) {
        var inside = false;

        // use some raycasting to test hits
        // https://github.com/substack/point-in-polygon/blob/master/index.js
        var length = this.points.length / 2;

        for (var i = 0, j = length - 1; i < length; j = i++) {
            var xi = this.points[i * 2];
            var yi = this.points[i * 2 + 1];
            var xj = this.points[j * 2];
            var yj = this.points[j * 2 + 1];
            var intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;

            if (intersect) {
                inside = !inside;
            }
        }

        return inside;
    };

    return Polygon;
}();

exports.default = Polygon;
//# sourceMappingURL=Polygon.js.map

/***/ }),

/***/ "vusc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _Matrix = __webpack_require__("dh7x");

var _Matrix2 = _interopRequireDefault(_Matrix);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var tempMat = new _Matrix2.default();

/**
 * Class controls uv transform and frame clamp for texture
 * Can be used in Texture "transform" field, or separately, you can use different clamp settings on the same texture.
 * If you want to add support for texture region of certain feature or filter, that's what you're looking for.
 *
 * @see PIXI.Texture
 * @see PIXI.mesh.Mesh
 * @see PIXI.extras.TilingSprite
 * @class
 * @memberof PIXI
 */

var TextureMatrix = function () {
    /**
     *
     * @param {PIXI.Texture} texture observed texture
     * @param {number} [clampMargin] Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
     * @constructor
     */
    function TextureMatrix(texture, clampMargin) {
        _classCallCheck(this, TextureMatrix);

        this._texture = texture;

        this.mapCoord = new _Matrix2.default();

        this.uClampFrame = new Float32Array(4);

        this.uClampOffset = new Float32Array(2);

        this._lastTextureID = -1;

        /**
         * Changes frame clamping
         * Works with TilingSprite and Mesh
         * Change to 1.5 if you texture has repeated right and bottom lines, that leads to smoother borders
         *
         * @default 0
         * @member {number}
         */
        this.clampOffset = 0;

        /**
         * Changes frame clamping
         * Works with TilingSprite and Mesh
         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
         *
         * @default 0.5
         * @member {number}
         */
        this.clampMargin = typeof clampMargin === 'undefined' ? 0.5 : clampMargin;
    }

    /**
     * texture property
     * @member {PIXI.Texture}
     */

    /**
     * Multiplies uvs array to transform
     * @param {Float32Array} uvs mesh uvs
     * @param {Float32Array} [out=uvs] output
     * @returns {Float32Array} output
     */
    TextureMatrix.prototype.multiplyUvs = function multiplyUvs(uvs, out) {
        if (out === undefined) {
            out = uvs;
        }

        var mat = this.mapCoord;

        for (var i = 0; i < uvs.length; i += 2) {
            var x = uvs[i];
            var y = uvs[i + 1];

            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }

        return out;
    };

    /**
     * updates matrices if texture was changed
     * @param {boolean} forceUpdate if true, matrices will be updated any case
     * @returns {boolean} whether or not it was updated
     */

    TextureMatrix.prototype.update = function update(forceUpdate) {
        var tex = this._texture;

        if (!tex || !tex.valid) {
            return false;
        }

        if (!forceUpdate && this._lastTextureID === tex._updateID) {
            return false;
        }

        this._lastTextureID = tex._updateID;

        var uvs = tex._uvs;

        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);

        var orig = tex.orig;
        var trim = tex.trim;

        if (trim) {
            tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append(tempMat);
        }

        var texBase = tex.baseTexture;
        var frame = this.uClampFrame;
        var margin = this.clampMargin / texBase.resolution;
        var offset = this.clampOffset;

        frame[0] = (tex._frame.x + margin + offset) / texBase.width;
        frame[1] = (tex._frame.y + margin + offset) / texBase.height;
        frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width;
        frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = offset / texBase.realWidth;
        this.uClampOffset[1] = offset / texBase.realHeight;

        return true;
    };

    _createClass(TextureMatrix, [{
        key: 'texture',
        get: function get() {
            return this._texture;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._texture = value;
            this._lastTextureID = -1;
        }
    }]);

    return TextureMatrix;
}();

exports.default = TextureMatrix;
//# sourceMappingURL=TextureMatrix.js.map

/***/ }),

/***/ "vwhv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = earcut;
module.exports.default = earcut;

function earcut(data, holeIndices, dim) {

    dim = dim || 2;

    var hasHoles = holeIndices && holeIndices.length,
        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
        outerNode = linkedList(data, 0, outerLen, dim, true),
        triangles = [];

    if (!outerNode || outerNode.next === outerNode.prev) return triangles;

    var minX, minY, maxX, maxY, x, y, invSize;

    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);

    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];

        for (var i = dim; i < outerLen; i += dim) {
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }

        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 1 / invSize : 0;
    }

    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);

    return triangles;
}

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    var i, last;

    if (clockwise === signedArea(data, start, end, dim) > 0) {
        for (i = start; i < end; i += dim) {
            last = insertNode(i, data[i], data[i + 1], last);
        }
    } else {
        for (i = end - dim; i >= start; i -= dim) {
            last = insertNode(i, data[i], data[i + 1], last);
        }
    }

    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }

    return last;
}

// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;

    var p = start,
        again;
    do {
        again = false;

        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else {
            p = p.next;
        }
    } while (again || p !== end);

    return end;
}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;

    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);

    var stop = ear,
        prev,
        next;

    // iterate through ears, slicing them one by one
    while (ear.prev !== ear.next) {
        prev = ear.prev;
        next = ear.next;

        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);

            removeNode(ear);

            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;

            continue;
        }

        ear = next;

        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) {
                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);

                // if this didn't work, try curing all small self-intersections locally
            } else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);

                // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) {
                splitEarcut(ear, triangles, dim, minX, minY, invSize);
            }

            break;
        }
    }
}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // now make sure we don't have other points inside the potential ear
    var p = ear.next.next;

    while (p !== ear.prev) {
        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }

    return true;
}

function isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // triangle bbox; min & max are calculated like this for speed
    var minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x,
        minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y,
        maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x,
        maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;

    // z-order range for the current triangle bbox;
    var minZ = zOrder(minTX, minTY, minX, minY, invSize),
        maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);

    var p = ear.prevZ,
        n = ear.nextZ;

    // look for points inside the triangle in both directions
    while (p && p.z >= minZ && n && n.z <= maxZ) {
        if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;

        if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    // look for remaining points in decreasing z-order
    while (p && p.z >= minZ) {
        if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }

    // look for remaining points in increasing z-order
    while (n && n.z <= maxZ) {
        if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    return true;
}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev,
            b = p.next.next;

        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);

            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);

            p = start = b;
        }
        p = p.next;
    } while (p !== start);

    return filterPoints(p);
}

// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while (b !== a.prev) {
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = splitPolygon(a, b);

                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);

                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize);
                earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    } while (a !== start);
}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [],
        i,
        len,
        start,
        end,
        list;

    for (i = 0, len = holeIndices.length; i < len; i++) {
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }

    queue.sort(compareX);

    // process holes from left to right
    for (i = 0; i < queue.length; i++) {
        eliminateHole(queue[i], outerNode);
        outerNode = filterPoints(outerNode, outerNode.next);
    }

    return outerNode;
}

function compareX(a, b) {
    return a.x - b.x;
}

// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    outerNode = findHoleBridge(hole, outerNode);
    if (outerNode) {
        var b = splitPolygon(outerNode, hole);
        filterPoints(b, b.next);
    }
}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    var p = outerNode,
        hx = hole.x,
        hy = hole.y,
        qx = -Infinity,
        m;

    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    } while (p !== outerNode);

    if (!m) return null;

    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint

    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point

    var stop = m,
        mx = m.x,
        my = m.y,
        tanMin = Infinity,
        tan;

    p = m;

    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

            if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }

        p = p.next;
    } while (p !== stop);

    return m;
}

// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}

// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    } while (p !== start);

    p.prevZ.nextZ = null;
    p.prevZ = null;

    sortLinked(p);
}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    var i,
        p,
        q,
        e,
        tail,
        numMerges,
        pSize,
        qSize,
        inSize = 1;

    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;

        while (p) {
            numMerges++;
            q = p;
            pSize = 0;
            for (i = 0; i < inSize; i++) {
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;

            while (pSize > 0 || qSize > 0 && q) {

                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }

                if (tail) tail.nextZ = e;else list = e;

                e.prevZ = tail;
                tail = e;
            }

            p = q;
        }

        tail.nextZ = null;
        inSize *= 2;
    } while (numMerges > 1);

    return list;
}

// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;

    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;

    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;

    return x | y << 1;
}

// find the leftmost node of a polygon ring
function getLeftmost(start) {
    var p = start,
        leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    } while (p !== start);

    return leftmost;
}

// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && ( // dones't intersect other edges
    locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && ( // locally visible
    area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
    equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}

// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}

// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}

// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    var o1 = sign(area(p1, q1, p2));
    var o2 = sign(area(p1, q1, q2));
    var o3 = sign(area(p2, q2, p1));
    var o4 = sign(area(p2, q2, q1));

    if (o1 !== o2 && o3 !== o4) return true; // general case

    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

    return false;
}

// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}

function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
        p = p.next;
    } while (p !== a);

    return false;
}

// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    var p = a,
        inside = false,
        px = (a.x + b.x) / 2,
        py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    } while (p !== a);

    return inside;
}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    var a2 = new Node(a.i, a.x, a.y),
        b2 = new Node(b.i, b.x, b.y),
        an = a.next,
        bp = b.prev;

    a.next = b;
    b.prev = a;

    a2.next = an;
    an.prev = a2;

    b2.next = a2;
    a2.prev = b2;

    bp.next = b2;
    b2.prev = bp;

    return b2;
}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    var p = new Node(i, x, y);

    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}

function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;

    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}

function Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;

    // vertex coordinates
    this.x = x;
    this.y = y;

    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;

    // z-order curve value
    this.z = null;

    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;

    // indicates whether this is a steiner point
    this.steiner = false;
}

// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
earcut.deviation = function (data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;

    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
    if (hasHoles) {
        for (var i = 0, len = holeIndices.length; i < len; i++) {
            var start = holeIndices[i] * dim;
            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
            polygonArea -= Math.abs(signedArea(data, start, end, dim));
        }
    }

    var trianglesArea = 0;
    for (i = 0; i < triangles.length; i += 3) {
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }

    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};

function signedArea(data, start, end, dim) {
    var sum = 0;
    for (var i = start, j = end - dim; i < end; i += dim) {
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}

// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
earcut.flatten = function (data) {
    var dim = data[0][0].length,
        result = { vertices: [], holes: [], dimensions: dim },
        holeIndex = 0;

    for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].length; j++) {
            for (var d = 0; d < dim; d++) {
                result.vertices.push(data[i][j][d]);
            }
        }
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};

/***/ }),

/***/ "wBQE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pixiGlCore = __webpack_require__("PJsv");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function checkPrecision(src, def) {
    if (src instanceof Array) {
        if (src[0].substring(0, 9) !== 'precision') {
            var copy = src.slice(0);

            copy.unshift('precision ' + def + ' float;');

            return copy;
        }
    } else if (src.trim().substring(0, 9) !== 'precision') {
        return 'precision ' + def + ' float;\n' + src;
    }

    return src;
}

/**
 * Wrapper class, webGL Shader for Pixi.
 * Adds precision string if vertexSrc or fragmentSrc have no mention of it.
 *
 * @class
 * @extends GLShader
 * @memberof PIXI
 */

var Shader = function (_GLShader) {
    _inherits(Shader, _GLShader);

    /**
     *
     * @param {WebGLRenderingContext} gl - The current WebGL rendering context
     * @param {string|string[]} vertexSrc - The vertex shader source as an array of strings.
     * @param {string|string[]} fragmentSrc - The fragment shader source as an array of strings.
     * @param {object} [attributeLocations] - A key value pair showing which location eact attribute should sit.
                       e.g. {position:0, uvs:1}.
     * @param {string} [precision] - The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
     */
    function Shader(gl, vertexSrc, fragmentSrc, attributeLocations, precision) {
        _classCallCheck(this, Shader);

        return _possibleConstructorReturn(this, _GLShader.call(this, gl, checkPrecision(vertexSrc, precision || _settings2.default.PRECISION_VERTEX), checkPrecision(fragmentSrc, precision || _settings2.default.PRECISION_FRAGMENT), undefined, attributeLocations));
    }

    return Shader;
}(_pixiGlCore.GLShader);

exports.default = Shader;
//# sourceMappingURL=Shader.js.map

/***/ }),

/***/ "wCSE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty,
    prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = [],
      events,
      name;

  if (this._eventsCount === 0) return names;

  for (name in events = this._events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event,
      available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1:
        return listeners.fn.call(listeners.context), true;
      case 2:
        return listeners.fn.call(listeners.context, a1), true;
      case 3:
        return listeners.fn.call(listeners.context, a1, a2), true;
      case 4:
        return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len - 1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length,
        j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1:
          listeners[i].fn.call(listeners[i].context);break;
        case 2:
          listeners[i].fn.call(listeners[i].context, a1);break;
        case 3:
          listeners[i].fn.call(listeners[i].context, a1, a2);break;
        case 4:
          listeners[i].fn.call(listeners[i].context, a1, a2, a3);break;
        default:
          if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this),
      evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true),
      evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
      if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}

/***/ }),

/***/ "wRU+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("UQex");
var invariant = __webpack_require__("wRU+");
var ReactPropTypesSecret = __webpack_require__("Asjh");

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "woEt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),

/***/ "wqtJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Config_1 = __webpack_require__("gH/r");

var KeyboardManager = function () {
    function KeyboardManager() {
        _classCallCheck(this, KeyboardManager);

        this.shift = keyboard(16);
        this.shiftPressed = false;
        this.shiftReleased = undefined;
        this.listenToShift = this.listenToShift.bind(this);
        this.listenToShift();
        listenUndo(Config_1.default.undoActions.undoCb);
        listenRedo(Config_1.default.undoActions.redoCb);
    }

    KeyboardManager.prototype.listenToShift = function listenToShift() {
        var _this = this;

        this.shift.press = function () {
            _this.shiftPressed = true;
            Config_1.default.viewport.pausePlugin("drag");
        };
        this.shift.release = function () {
            _this.shiftPressed = false;
            Config_1.default.viewport.resumePlugin("drag");
            if (_this.shiftReleased) {
                _this.shiftReleased();
            }
        };
    };

    KeyboardManager.prototype.onShiftReleased = function onShiftReleased(cb) {
        this.shiftReleased = cb;
    };

    return KeyboardManager;
}();

exports.default = KeyboardManager;
function listenUndo(cb) {
    var checkUndo = function checkUndo(event) {
        if (event.keyCode == 90 && (event.ctrlKey || event.metaKey) && !event.shiftKey) {
            cb();
        }
    };
    window.addEventListener("keydown", checkUndo, false);
}
function listenRedo(cb) {
    var checkRedo = function checkRedo(event) {
        if (event.keyCode == 90 && (event.ctrlKey || event.metaKey) && event.shiftKey) {
            cb();
        }
    };
    window.addEventListener("keydown", checkRedo, false);
}
function keyboard(keyCode) {
    var key = {};
    key.code = keyCode;
    key.isDown = false;
    key.isUp = true;
    key.press = undefined;
    key.release = undefined;
    key.downHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isUp && key.press) key.press();
            key.isDown = true;
            key.isUp = false;
        }
    };
    key.upHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isDown && key.release) key.release();
            key.isDown = false;
            key.isUp = true;
        }
    };
    window.addEventListener("keydown", key.downHandler.bind(key), false);
    window.addEventListener("keyup", key.upHandler.bind(key), false);
    return key;
}
//# sourceMappingURL=KeyboardManager.js.map

/***/ }),

/***/ "wzjF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var itemSize = 2;
var box = { min: [0, 0], max: [0, 0] };
function bounds(positions) {
    var count = positions.length / itemSize;
    box.min[0] = positions[0];
    box.min[1] = positions[1];
    box.max[0] = positions[0];
    box.max[1] = positions[1];
    for (var i = 0; i < count; i++) {
        var x = positions[i * itemSize + 0];
        var y = positions[i * itemSize + 1];
        box.min[0] = Math.min(x, box.min[0]);
        box.min[1] = Math.min(y, box.min[1]);
        box.max[0] = Math.max(x, box.max[0]);
        box.max[1] = Math.max(y, box.max[1]);
    }
}
exports.computeBox = function (positions, output) {
    bounds(positions);
    output.min.set(box.min[0], box.min[1], 0);
    output.max.set(box.max[0], box.max[1], 0);
};
exports.computeSphere = function (positions, output) {
    bounds(positions);
    var minX = box.min[0];
    var minY = box.min[1];
    var maxX = box.max[0];
    var maxY = box.max[1];
    var width = maxX - minX;
    var height = maxY - minY;
    var length = Math.sqrt(width * width + height * height);
    output.center.set(minX + width / 2, minY + height / 2, 0);
    output.radius = length / 2;
};
exports.nextPow2 = function (v) {
    v += +(v === 0);
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
};
exports.float32Concat = function (first, second) {
    var firstLength = first.length,
        result = new Float32Array(firstLength + second.length);
    result.set(first);
    result.set(second, firstLength);
    return result;
};
exports.UInt16Concat = function (first, second) {
    var firstLength = first.length,
        result = new Uint16Array(firstLength + second.length);
    result.set(first);
    result.set(second, firstLength);
    return result;
};
exports.Int32Concat = function (first, second) {
    var firstLength = first.length,
        result = new Int32Array(firstLength + second.length);
    result.set(first);
    result.set(second, firstLength);
    return result;
};
exports.getLog2 = function (v) {
    var r = void 0,
        shift = void 0;
    r = +(v > 0xFFFF) << 4;
    v >>>= r;
    shift = +(v > 0xFF) << 3;
    v >>>= shift;
    r |= shift;
    shift = +(v > 0xF) << 2;
    v >>>= shift;
    r |= shift;
    shift = +(v > 0x3) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
};
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "x48B":
/***/ (function(module, exports) {


/**
 * @class
 * @memberof PIXI.glCore.shader
 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
 * @param attributeLocations {Object} An attribute location map that lets you manually set the attribute locations
 * @return {WebGLProgram} the shader program
 */
var compileProgram = function compileProgram(gl, vertexSrc, fragmentSrc, attributeLocations) {
    var glVertShader = compileShader(gl, gl.VERTEX_SHADER, vertexSrc);
    var glFragShader = compileShader(gl, gl.FRAGMENT_SHADER, fragmentSrc);

    var program = gl.createProgram();

    gl.attachShader(program, glVertShader);
    gl.attachShader(program, glFragShader);

    // optionally, set the attributes manually for the program rather than letting WebGL decide..
    if (attributeLocations) {
        for (var i in attributeLocations) {
            gl.bindAttribLocation(program, attributeLocations[i], i);
        }
    }

    gl.linkProgram(program);

    // if linking fails, then log and cleanup
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        console.error('Pixi.js Error: Could not initialize shader.');
        console.error('gl.VALIDATE_STATUS', gl.getProgramParameter(program, gl.VALIDATE_STATUS));
        console.error('gl.getError()', gl.getError());

        // if there is a program info log, log it
        if (gl.getProgramInfoLog(program) !== '') {
            console.warn('Pixi.js Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(program));
        }

        gl.deleteProgram(program);
        program = null;
    }

    // clean up some shaders
    gl.deleteShader(glVertShader);
    gl.deleteShader(glFragShader);

    return program;
};

/**
 * @private
 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
 * @param type {Number} the type, can be either VERTEX_SHADER or FRAGMENT_SHADER
 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
 * @return {WebGLShader} the shader
 */
var compileShader = function compileShader(gl, type, src) {
    var shader = gl.createShader(type);

    gl.shaderSource(shader, src);
    gl.compileShader(shader);

    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        console.log(gl.getShaderInfoLog(shader));
        return null;
    }

    return shader;
};

module.exports = compileProgram;

/***/ }),

/***/ "x54R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PIXI = __webpack_require__("ix37");
var Selector_1 = __webpack_require__("8Y7Z");
var InteractionManager_1 = __webpack_require__("dUAP");
var Config_1 = __webpack_require__("gH/r");
var MoveableText_1 = __webpack_require__("Q5l6");
var SelectionListener_1 = __webpack_require__("//Eg");
var Selector_2 = __webpack_require__("8Y7Z");
var bound_1 = __webpack_require__("USDo");
var ActionTracker_1 = __webpack_require__("h0Oq");
var hull = __webpack_require__("rWY2");
var simplify = __webpack_require__("W6Cf");

var SectionView = function () {
    function SectionView(section, actions) {
        var reservationMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        _classCallCheck(this, SectionView);

        this.reservationMode = reservationMode;
        this.section = section;
        var sectionData = void 0;
        if (section.basicType === "section-sectionView") {
            sectionData = section;
        } else {
            sectionData = this.constructSectionData(section);
        }
        this.initialiseData(sectionData, actions);
        this.initialiseGraphics();
        this.drawSection();
    }

    SectionView.prototype.constructSectionData = function constructSectionData(section) {
        var boundingPoints = simplify(hull(section.points, 200), 10);
        var pos = section.moveableContainer.position;
        var outlinePoints = boundingPoints.map(function (point) {
            return [point[0] + pos.x, point[1] + pos.y];
        });
        var boundsColor = 0xffffff;
        var borderColor = 0x000000;
        var textColor = 0x000000;
        var alpha = 0.8;
        var name = section.name;
        var _id = section._id;
        var textPos = this.getPolygonCentroid(boundingPoints.map(function (point) {
            return { x: point[0], y: point[1] };
        }));
        var textData = {
            pos: textPos,
            color: textColor,
            fontSize: 16,
            textData: name
        };
        return {
            _id: _id,
            pos: pos,
            boundingPoints: boundingPoints,
            outlinePoints: outlinePoints,
            boundsColor: boundsColor,
            borderColor: borderColor,
            textData: textData,
            alpha: alpha,
            name: name,
            label: name,
            textPos: textPos,
            locked: false
        };
    };

    SectionView.prototype.initialiseData = function initialiseData(sectionData, actions) {
        this.basicType = "section-sectionView";
        this._id = sectionData._id;
        this.pos = new PIXI.Point(sectionData.pos.x, sectionData.pos.y);
        this.onElementClicked = actions.onElementClicked;
        this.actions = actions;
        this.boundingPoints = sectionData.boundingPoints.map(function (point) {
            return new PIXI.Point(point[0], point[1]);
        });
        this.outlinePoints = sectionData.outlinePoints.map(function (point) {
            return new PIXI.Point(point[0], point[1]);
        });
        this.boundsColor = sectionData.boundsColor;
        this.borderColor = sectionData.borderColor;
        this.textData = sectionData.textData || {};
        this.alpha = sectionData.alpha;
        this.name = sectionData.name;
        this.label = sectionData.name;
        this.locked = sectionData.locked;
    };

    SectionView.prototype.initialiseGraphics = function initialiseGraphics() {
        this.interactionManager = InteractionManager_1.default.createInteractionManager();
        this.moveableContainer = new PIXI.Container();
        this.moveableContainer.position = this.pos;
        if (!this.reservationMode) {
            this.selectionListener = new SelectionListener_1.default(this.moveableContainer, this, this.onClick);
        } else {
            this.enableReservationListener();
        }
        this.moveableText = new MoveableText_1.default(this.textData, this.reservationMode);
        this.graphics = new PIXI.Graphics();
        this.moveableContainer.addChild(this.graphics);
        this.moveableText.setContainerOffset(this.moveableContainer.position.x, this.moveableContainer.position.y);
        this.moveableContainer.addChild(this.moveableText.getContainer());
    };

    SectionView.prototype.selectable = function selectable(_selectable) {
        this.moveableContainer.interactive = _selectable;
        if (_selectable) {
            this.moveableText.changeColor(this.textData.color);
            this.drawSection();
            return true;
        } else {
            this.moveableText.changeColor(0x000000);
            this.drawDisabledSection();
            return false;
        }
    };

    SectionView.prototype.enableReservationListener = function enableReservationListener() {
        var _this = this;

        this.moveableContainer.interactive = true;
        this.moveableContainer.on("mouseover", function () {
            Selector_2.drawPolySelectionBox(_this.outlinePoints);
            _this.moveableContainer.once("mouseout", function () {
                Selector_2.clear();
            });
        });
        this.moveableContainer.on("click", function () {
            _this.actions.onSectionClicked(_this._id);
        });
        this.moveableContainer.on("tap", function () {
            _this.actions.onSectionClicked(_this._id);
        });
    };

    SectionView.prototype.toJSON = function toJSON() {
        return {
            _id: this._id,
            basicType: this.basicType,
            pos: { x: this.moveableContainer.position.x, y: this.moveableContainer.position.y },
            boundingPoints: this.boundingPoints.map(function (point) {
                return [point.x, point.y];
            }),
            outlinePoints: this.outlinePoints.map(function (point) {
                return [point.x, point.y];
            }),
            boundsColor: this.boundsColor,
            borderColor: this.borderColor,
            textData: this.moveableText.toJSON(),
            alpha: this.alpha,
            name: this.name,
            locked: this.locked
        };
    };

    SectionView.prototype.onAnySectionChange = function onAnySectionChange() {
        if (this.locked === false) {
            this.locked = true;
            if (this.cb) {
                this.cb();
            }
        }
    };

    SectionView.prototype.listenOnLock = function listenOnLock(cb) {
        this.cb = cb;
    };

    SectionView.prototype.lockChanged = function lockChanged(locked) {
        this.locked = locked;
    };

    SectionView.prototype.changeTextColor = function changeTextColor(hex) {
        var undoValue = ActionTracker_1.default.constructUndoValue("changeTextColor", this.changeTextColor, [this.textColor]);
        this.textColor = hex;
        this.moveableText.changeColor(hex);
        this.onAnySectionChange();
        this.onChange();
        return undoValue;
    };

    SectionView.prototype.changeBorderColor = function changeBorderColor(hex) {
        var undoValue = ActionTracker_1.default.constructUndoValue("changeBorderColor", this.changeBorderColor, [this.borderColor]);
        this.borderColor = hex;
        this.drawSection();
        this.onAnySectionChange();
        this.onChange();
        return undoValue;
    };

    SectionView.prototype.getTextColor = function getTextColor() {
        return this.moveableText.color;
    };

    SectionView.prototype.changeColor = function changeColor(hex, alpha) {
        var undoValue = ActionTracker_1.default.constructUndoValue("changeColor", this.changeColor, [this.boundsColor, this.alpha]);
        this.boundsColor = hex;
        this.alpha = alpha;
        this.drawSection();
        this.onAnySectionChange();
        this.onChange();
        return undoValue;
    };

    SectionView.prototype.setLabel = function setLabel(name) {
        var undoValue = ActionTracker_1.default.constructUndoValue("setLabel", this.setLabel, [this.name]);
        this.setName(name);
        return undoValue;
    };

    SectionView.prototype.setName = function setName(name) {
        this.name = name;
        this.label = this.name;
        this.rename();
    };

    SectionView.prototype.rename = function rename() {
        if (this.renameCb) {
            this.renameCb();
        }
        this.moveableText.changeText(this.name);
        this.onAnySectionChange();
    };

    SectionView.prototype.onRename = function onRename(cb) {
        this.renameCb = cb;
    };

    SectionView.prototype.getPolygonCentroid = function getPolygonCentroid(pts) {
        var first = pts[0],
            last = pts[pts.length - 1];
        if (first.x != last.x || first.y != last.y) pts.push(first);
        var twicearea = 0,
            x = 0,
            y = 0,
            nPts = pts.length,
            p1,
            p2,
            f;
        for (var i = 0, j = nPts - 1; i < nPts; j = i++) {
            p1 = pts[i];
            p2 = pts[j];
            f = p1.x * p2.y - p2.x * p1.y;
            twicearea += f;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
        }
        f = twicearea * 3;
        return { x: x / f, y: y / f };
    };

    SectionView.prototype.drawSection = function drawSection() {
        this.graphics.clear();
        this.graphics.lineStyle(3, this.borderColor, 1.0);
        this.graphics.beginFill(this.boundsColor, this.alpha);
        this.graphics.drawPolygon(this.boundingPoints);
        this.graphics.endFill();
    };

    SectionView.prototype.drawDisabledSection = function drawDisabledSection() {
        this.graphics.clear();
        this.graphics.lineStyle(3, this.borderColor, 1.0);
        this.graphics.beginFill(0xE8EDF5, this.alpha);
        this.graphics.drawPolygon(this.boundingPoints);
        this.graphics.endFill();
    };

    SectionView.prototype.getCorner = function getCorner() {
        var left = this.outlinePoints[0].x;
        var right = this.outlinePoints[0].x;
        var top = this.outlinePoints[0].y;
        var bottom = this.outlinePoints[0].y;
        this.outlinePoints.forEach(function (point) {
            if (point.x < left) {
                left = point.x;
            }
            if (point.x > right) {
                right = point.x;
            }
            if (point.y < top) {
                top = point.y;
            }
            if (point.y > bottom) {
                bottom = point.y;
            }
        });
        return {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
    };

    SectionView.prototype.onSelect = function onSelect() {};

    SectionView.prototype.onDeselect = function onDeselect() {};

    SectionView.prototype.onClick = function onClick() {
        this.interactionManager.itemSelected(this);
    };

    SectionView.prototype.move = function move(e) {
        var _this2 = this;

        var xInc = e.data.originalEvent.movementX / Config_1.default.viewport.transform.scale._x;
        var yInc = e.data.originalEvent.movementY / Config_1.default.viewport.transform.scale._y;
        this.moveableContainer.position.x += xInc;
        this.moveableContainer.position.y += yInc;
        this.outlinePoints = this.boundingPoints.map(function (point) {
            return new PIXI.Point(point.x + _this2.moveableContainer.position.x, point.y + _this2.moveableContainer.position.y);
        });
        this.moveableText.setContainerOffset(this.moveableContainer.position.x, this.moveableContainer.position.y);
        this.onAnySectionChange();
    };

    SectionView.prototype.drawSelectionBox = function drawSelectionBox() {
        Selector_1.drawEditablePolyBox(this.outlinePoints, this.onVertexMoved, this.onVertexAdded, this.onVertexRemoved);
    };

    SectionView.prototype.onVertexMoved = function onVertexMoved(i, e) {
        var xInc = e.data.originalEvent.movementX / Config_1.default.viewport.transform.scale._x;
        var yInc = e.data.originalEvent.movementY / Config_1.default.viewport.transform.scale._y;
        if (i === this.boundingPoints.length - 1 || i === 0) {
            var l = this.boundingPoints.length - 1;
            this.boundingPoints[0].x += xInc;
            this.boundingPoints[l].x += xInc;
            this.boundingPoints[0].y += yInc;
            this.boundingPoints[l].y += yInc;
            this.outlinePoints[0].x += xInc;
            this.outlinePoints[l].x += xInc;
            this.outlinePoints[0].y += yInc;
            this.outlinePoints[l].y += yInc;
        } else {
            this.boundingPoints[i].x += xInc;
            this.boundingPoints[i].y += yInc;
            this.outlinePoints[i].x += xInc;
            this.outlinePoints[i].y += yInc;
        }
        this.drawSection();
        this.drawSelectionBox();
        this.onAnySectionChange();
    };

    SectionView.prototype.onVertexAdded = function onVertexAdded(pid1, pid2, e) {
        var _this3 = this;

        var _e$data$global = e.data.global,
            x = _e$data$global.x,
            y = _e$data$global.y;
        var _Config_1$default$can = Config_1.default.canvasBounding,
            top = _Config_1$default$can.top,
            left = _Config_1$default$can.left;
        var _Config_1$default$vie = Config_1.default.viewport.transform,
            position = _Config_1$default$vie.position,
            scale = _Config_1$default$vie.scale;

        var oldBoundingPoints = [].concat(this.boundingPoints);
        this.boundingPoints.splice(pid2, 0, new PIXI.Point((x - position._x - left) / scale._x - this.moveableContainer.position.x, (y - position._y - top) / scale._y - this.moveableContainer.position.y));
        this.outlinePoints = this.boundingPoints.map(function (point) {
            return new PIXI.Point(point.x + _this3.moveableContainer.position.x, point.y + _this3.moveableContainer.position.y);
        });
        this.drawSection();
        this.drawSelectionBox();
        this.onAnySectionChange();
        var actionId = ActionTracker_1.default.generateActionId();
        ActionTracker_1.default.addUndoAction("onVertexRemoved", actionId, [this.undoBoundingPoints], [[oldBoundingPoints]]);
    };

    SectionView.prototype.onVertexRemoved = function onVertexRemoved(i) {
        var _this4 = this;

        var oldBoundingPoints = [].concat(this.boundingPoints);
        if (i === this.boundingPoints.length - 1 || i === 0) {
            this.boundingPoints.splice(this.boundingPoints.length - 1, 1);
            this.boundingPoints.splice(0, 1);
            var endPoint = this.boundingPoints[0];
            this.boundingPoints.push(new PIXI.Point(endPoint.x, endPoint.y));
        } else {
            this.boundingPoints.splice(i, 1);
        }
        this.outlinePoints = this.boundingPoints.map(function (point) {
            return new PIXI.Point(point.x + _this4.moveableContainer.position.x, point.y + _this4.moveableContainer.position.y);
        });
        this.drawSection();
        this.drawSelectionBox();
        this.onAnySectionChange();
        var actionId = ActionTracker_1.default.generateActionId();
        ActionTracker_1.default.addUndoAction("onVertexRemoved", actionId, [this.undoBoundingPoints], [[oldBoundingPoints]]);
    };

    SectionView.prototype.undoBoundingPoints = function undoBoundingPoints(boundingPoints) {
        var _this5 = this;

        var undoAction = ActionTracker_1.default.constructUndoValue("undoBoundingPoints", this.undoBoundingPoints, [this.boundingPoints]);
        this.boundingPoints = boundingPoints;
        this.outlinePoints = this.boundingPoints.map(function (point) {
            return new PIXI.Point(point.x + _this5.moveableContainer.position.x, point.y + _this5.moveableContainer.position.y);
        });
        this.drawSection();
        this.drawSelectionBox();
        this.onAnySectionChange();
        return undoAction;
    };

    SectionView.prototype.getContainer = function getContainer() {
        return this.moveableContainer;
    };

    SectionView.prototype.onChange = function onChange() {
        if (this._onChange) {
            this._onChange();
        }
    };

    SectionView.prototype.setOnChange = function setOnChange(cb) {
        this._onChange = cb;
    };

    return SectionView;
}();

__decorate([bound_1.default], SectionView.prototype, "constructSectionData", null);
__decorate([bound_1.default], SectionView.prototype, "initialiseData", null);
__decorate([bound_1.default], SectionView.prototype, "initialiseGraphics", null);
__decorate([bound_1.default], SectionView.prototype, "selectable", null);
__decorate([bound_1.default], SectionView.prototype, "enableReservationListener", null);
__decorate([bound_1.default], SectionView.prototype, "toJSON", null);
__decorate([bound_1.default], SectionView.prototype, "onAnySectionChange", null);
__decorate([bound_1.default], SectionView.prototype, "listenOnLock", null);
__decorate([bound_1.default], SectionView.prototype, "lockChanged", null);
__decorate([bound_1.default], SectionView.prototype, "changeTextColor", null);
__decorate([bound_1.default], SectionView.prototype, "changeBorderColor", null);
__decorate([bound_1.default], SectionView.prototype, "getTextColor", null);
__decorate([bound_1.default], SectionView.prototype, "changeColor", null);
__decorate([bound_1.default], SectionView.prototype, "setLabel", null);
__decorate([bound_1.default], SectionView.prototype, "setName", null);
__decorate([bound_1.default], SectionView.prototype, "rename", null);
__decorate([bound_1.default], SectionView.prototype, "onRename", null);
__decorate([bound_1.default], SectionView.prototype, "getPolygonCentroid", null);
__decorate([bound_1.default], SectionView.prototype, "drawSection", null);
__decorate([bound_1.default], SectionView.prototype, "drawDisabledSection", null);
__decorate([bound_1.default], SectionView.prototype, "getCorner", null);
__decorate([bound_1.default], SectionView.prototype, "onSelect", null);
__decorate([bound_1.default], SectionView.prototype, "onDeselect", null);
__decorate([bound_1.default], SectionView.prototype, "onClick", null);
__decorate([bound_1.default], SectionView.prototype, "move", null);
__decorate([bound_1.default], SectionView.prototype, "drawSelectionBox", null);
__decorate([bound_1.default], SectionView.prototype, "onVertexMoved", null);
__decorate([bound_1.default], SectionView.prototype, "onVertexAdded", null);
__decorate([bound_1.default], SectionView.prototype, "onVertexRemoved", null);
__decorate([bound_1.default], SectionView.prototype, "undoBoundingPoints", null);
__decorate([bound_1.default], SectionView.prototype, "getContainer", null);
__decorate([bound_1.default], SectionView.prototype, "onChange", null);
__decorate([bound_1.default], SectionView.prototype, "setOnChange", null);
exports.default = SectionView;
//# sourceMappingURL=SectionView.js.map

/***/ }),

/***/ "xIVz":
/***/ (function(module, exports) {

module.exports = isFunction;

var toString = Object.prototype.toString;

function isFunction(fn) {
  var string = toString.call(fn);
  return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && (
  // IE8 and below
  fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
};

/***/ }),

/***/ "xUki":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _BaseTexture = __webpack_require__("ce6K");

var _BaseTexture2 = _interopRequireDefault(_BaseTexture);

var _VideoBaseTexture = __webpack_require__("U1Rh");

var _VideoBaseTexture2 = _interopRequireDefault(_VideoBaseTexture);

var _TextureUvs = __webpack_require__("sUm+");

var _TextureUvs2 = _interopRequireDefault(_TextureUvs);

var _eventemitter = __webpack_require__("wCSE");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _math = __webpack_require__("e3iB");

var _utils = __webpack_require__("dDI1");

var _settings = __webpack_require__("tMVT");

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A texture stores the information that represents an image or part of an image. It cannot be added
 * to the display list directly. Instead use it as the texture for a Sprite. If no frame is provided
 * then the whole image is used.
 *
 * You can directly create a texture from an image and then reuse it multiple times like this :
 *
 * ```js
 * let texture = PIXI.Texture.fromImage('assets/image.png');
 * let sprite1 = new PIXI.Sprite(texture);
 * let sprite2 = new PIXI.Sprite(texture);
 * ```
 *
 * Textures made from SVGs, loaded or not, cannot be used before the file finishes processing.
 * You can check for this by checking the sprite's _textureID property.
 * ```js
 * var texture = PIXI.Texture.fromImage('assets/image.svg');
 * var sprite1 = new PIXI.Sprite(texture);
 * //sprite1._textureID should not be undefined if the texture has finished processing the SVG file
 * ```
 * You can use a ticker or rAF to ensure your sprites load the finished textures after processing. See issue #3068.
 *
 * @class
 * @extends EventEmitter
 * @memberof PIXI
 */
var Texture = function (_EventEmitter) {
    _inherits(Texture, _EventEmitter);

    /**
     * @param {PIXI.BaseTexture} baseTexture - The base texture source to create the texture from
     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
     * @param {PIXI.Rectangle} [orig] - The area of original texture
     * @param {PIXI.Rectangle} [trim] - Trimmed rectangle of original texture
     * @param {number} [rotate] - indicates how the texture was rotated by texture packer. See {@link PIXI.GroupD8}
     * @param {PIXI.Point} [anchor] - Default anchor point used for sprite placement / rotation
     */
    function Texture(baseTexture, frame, orig, trim, rotate, anchor) {
        _classCallCheck(this, Texture);

        /**
         * Does this Texture have any frame data assigned to it?
         *
         * @member {boolean}
         */
        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        _this.noFrame = false;

        if (!frame) {
            _this.noFrame = true;
            frame = new _math.Rectangle(0, 0, 1, 1);
        }

        if (baseTexture instanceof Texture) {
            baseTexture = baseTexture.baseTexture;
        }

        /**
         * The base texture that this texture uses.
         *
         * @member {PIXI.BaseTexture}
         */
        _this.baseTexture = baseTexture;

        /**
         * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
         * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
         *
         * @member {PIXI.Rectangle}
         */
        _this._frame = frame;

        /**
         * This is the trimmed area of original texture, before it was put in atlas
         * Please call `_updateUvs()` after you change coordinates of `trim` manually.
         *
         * @member {PIXI.Rectangle}
         */
        _this.trim = trim;

        /**
         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
         *
         * @member {boolean}
         */
        _this.valid = false;

        /**
         * This will let a renderer know that a texture has been updated (used mainly for webGL uv updates)
         *
         * @member {boolean}
         */
        _this.requiresUpdate = false;

        /**
         * The WebGL UV data cache.
         *
         * @member {PIXI.TextureUvs}
         * @private
         */
        _this._uvs = null;

        /**
         * This is the area of original texture, before it was put in atlas
         *
         * @member {PIXI.Rectangle}
         */
        _this.orig = orig || frame; // new Rectangle(0, 0, 1, 1);

        _this._rotate = Number(rotate || 0);

        if (rotate === true) {
            // this is old texturepacker legacy, some games/libraries are passing "true" for rotated textures
            _this._rotate = 2;
        } else if (_this._rotate % 2 !== 0) {
            throw new Error('attempt to use diamond-shaped UVs. If you are sure, set rotation manually');
        }

        if (baseTexture.hasLoaded) {
            if (_this.noFrame) {
                frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);

                // if there is no frame we should monitor for any base texture changes..
                baseTexture.on('update', _this.onBaseTextureUpdated, _this);
            }
            _this.frame = frame;
        } else {
            baseTexture.once('loaded', _this.onBaseTextureLoaded, _this);
        }

        /**
         * Anchor point that is used as default if sprite is created with this texture.
         * Changing the `defaultAnchor` at a later point of time will not update Sprite's anchor point.
         * @member {PIXI.Point}
         * @default {0,0}
         */
        _this.defaultAnchor = anchor ? new _math.Point(anchor.x, anchor.y) : new _math.Point(0, 0);

        /**
         * Fired when the texture is updated. This happens if the frame or the baseTexture is updated.
         *
         * @event PIXI.Texture#update
         * @protected
         * @param {PIXI.Texture} texture - Instance of texture being updated.
         */

        _this._updateID = 0;

        /**
         * Contains data for uvs. May contain clamp settings and some matrices.
         * Its a bit heavy, so by default that object is not created.
         * @member {PIXI.TextureMatrix}
         * @default null
         */
        _this.transform = null;

        /**
         * The ids under which this Texture has been added to the texture cache. This is
         * automatically set as long as Texture.addToCache is used, but may not be set if a
         * Texture is added directly to the TextureCache array.
         *
         * @member {string[]}
         */
        _this.textureCacheIds = [];
        return _this;
    }

    /**
     * Updates this texture on the gpu.
     *
     */

    Texture.prototype.update = function update() {
        this.baseTexture.update();
    };

    /**
     * Called when the base texture is loaded
     *
     * @private
     * @param {PIXI.BaseTexture} baseTexture - The base texture.
     */

    Texture.prototype.onBaseTextureLoaded = function onBaseTextureLoaded(baseTexture) {
        this._updateID++;

        // TODO this code looks confusing.. boo to abusing getters and setters!
        if (this.noFrame) {
            this.frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
        } else {
            this.frame = this._frame;
        }

        this.baseTexture.on('update', this.onBaseTextureUpdated, this);
        this.emit('update', this);
    };

    /**
     * Called when the base texture is updated
     *
     * @private
     * @param {PIXI.BaseTexture} baseTexture - The base texture.
     */

    Texture.prototype.onBaseTextureUpdated = function onBaseTextureUpdated(baseTexture) {
        this._updateID++;

        this._frame.width = baseTexture.width;
        this._frame.height = baseTexture.height;

        this.emit('update', this);
    };

    /**
     * Destroys this texture
     *
     * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
     */

    Texture.prototype.destroy = function destroy(destroyBase) {
        if (this.baseTexture) {
            if (destroyBase) {
                // delete the texture if it exists in the texture cache..
                // this only needs to be removed if the base texture is actually destroyed too..
                if (_utils.TextureCache[this.baseTexture.imageUrl]) {
                    Texture.removeFromCache(this.baseTexture.imageUrl);
                }

                this.baseTexture.destroy();
            }

            this.baseTexture.off('update', this.onBaseTextureUpdated, this);
            this.baseTexture.off('loaded', this.onBaseTextureLoaded, this);

            this.baseTexture = null;
        }

        this._frame = null;
        this._uvs = null;
        this.trim = null;
        this.orig = null;

        this.valid = false;

        Texture.removeFromCache(this);
        this.textureCacheIds = null;
    };

    /**
     * Creates a new texture object that acts the same as this one.
     *
     * @return {PIXI.Texture} The new texture
     */

    Texture.prototype.clone = function clone() {
        return new Texture(this.baseTexture, this.frame, this.orig, this.trim, this.rotate, this.defaultAnchor);
    };

    /**
     * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
     */

    Texture.prototype._updateUvs = function _updateUvs() {
        if (!this._uvs) {
            this._uvs = new _TextureUvs2.default();
        }

        this._uvs.set(this._frame, this.baseTexture, this.rotate);

        this._updateID++;
    };

    /**
     * Helper function that creates a Texture object from the given image url.
     * If the image is not in the texture cache it will be  created and loaded.
     *
     * @static
     * @param {string} imageUrl - The image url of the texture
     * @param {boolean} [crossorigin] - Whether requests should be treated as crossorigin
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with SVG images.
     * @return {PIXI.Texture} The newly created texture
     */

    Texture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
        var texture = _utils.TextureCache[imageUrl];

        if (!texture) {
            texture = new Texture(_BaseTexture2.default.fromImage(imageUrl, crossorigin, scaleMode, sourceScale));
            Texture.addToCache(texture, imageUrl);
        }

        return texture;
    };

    /**
     * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
     * The frame ids are created when a Texture packer file has been loaded
     *
     * @static
     * @param {string} frameId - The frame Id of the texture in the cache
     * @return {PIXI.Texture} The newly created texture
     */

    Texture.fromFrame = function fromFrame(frameId) {
        var texture = _utils.TextureCache[frameId];

        if (!texture) {
            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
        }

        return texture;
    };

    /**
     * Helper function that creates a new Texture based on the given canvas element.
     *
     * @static
     * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {string} [origin='canvas'] - A string origin of who created the base texture
     * @return {PIXI.Texture} The newly created texture
     */

    Texture.fromCanvas = function fromCanvas(canvas, scaleMode) {
        var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'canvas';

        return new Texture(_BaseTexture2.default.fromCanvas(canvas, scaleMode, origin));
    };

    /**
     * Helper function that creates a new Texture based on the given video element.
     *
     * @static
     * @param {HTMLVideoElement|string} video - The URL or actual element of the video
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
     * @param {boolean} [autoPlay=true] - Start playing video as soon as it is loaded
     * @return {PIXI.Texture} The newly created texture
     */

    Texture.fromVideo = function fromVideo(video, scaleMode, crossorigin, autoPlay) {
        if (typeof video === 'string') {
            return Texture.fromVideoUrl(video, scaleMode, crossorigin, autoPlay);
        }

        return new Texture(_VideoBaseTexture2.default.fromVideo(video, scaleMode, autoPlay));
    };

    /**
     * Helper function that creates a new Texture based on the video url.
     *
     * @static
     * @param {string} videoUrl - URL of the video
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
     * @param {boolean} [autoPlay=true] - Start playing video as soon as it is loaded
     * @return {PIXI.Texture} The newly created texture
     */

    Texture.fromVideoUrl = function fromVideoUrl(videoUrl, scaleMode, crossorigin, autoPlay) {
        return new Texture(_VideoBaseTexture2.default.fromUrl(videoUrl, scaleMode, crossorigin, autoPlay));
    };

    /**
     * Helper function that creates a new Texture based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @static
     * @param {number|string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|PIXI.BaseTexture}
     *        source - Source to create texture from
     * @return {PIXI.Texture} The newly created texture
     */

    Texture.from = function from(source) {
        // TODO auto detect cross origin..
        // TODO pass in scale mode?
        if (typeof source === 'string') {
            var texture = _utils.TextureCache[source];

            if (!texture) {
                // check if its a video..
                var isVideo = source.match(/\.(mp4|webm|ogg|h264|avi|mov)$/) !== null;

                if (isVideo) {
                    return Texture.fromVideoUrl(source);
                }

                return Texture.fromImage(source);
            }

            return texture;
        } else if (source instanceof HTMLImageElement) {
            return new Texture(_BaseTexture2.default.from(source));
        } else if (source instanceof HTMLCanvasElement) {
            return Texture.fromCanvas(source, _settings2.default.SCALE_MODE, 'HTMLCanvasElement');
        } else if (source instanceof HTMLVideoElement) {
            return Texture.fromVideo(source);
        } else if (source instanceof _BaseTexture2.default) {
            return new Texture(source);
        }

        // lets assume its a texture!
        return source;
    };

    /**
     * Create a texture from a source and add to the cache.
     *
     * @static
     * @param {HTMLImageElement|HTMLCanvasElement} source - The input source.
     * @param {String} imageUrl - File name of texture, for cache and resolving resolution.
     * @param {String} [name] - Human readible name for the texture cache. If no name is
     *        specified, only `imageUrl` will be used as the cache ID.
     * @return {PIXI.Texture} Output texture
     */

    Texture.fromLoader = function fromLoader(source, imageUrl, name) {
        var baseTexture = new _BaseTexture2.default(source, undefined, (0, _utils.getResolutionOfUrl)(imageUrl));
        var texture = new Texture(baseTexture);

        baseTexture.imageUrl = imageUrl;

        // No name, use imageUrl instead
        if (!name) {
            name = imageUrl;
        }

        // lets also add the frame to pixi's global cache for fromFrame and fromImage fucntions
        _BaseTexture2.default.addToCache(texture.baseTexture, name);
        Texture.addToCache(texture, name);

        // also add references by url if they are different.
        if (name !== imageUrl) {
            _BaseTexture2.default.addToCache(texture.baseTexture, imageUrl);
            Texture.addToCache(texture, imageUrl);
        }

        return texture;
    };

    /**
     * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
     *
     * @static
     * @param {PIXI.Texture} texture - The Texture to add to the cache.
     * @param {string} id - The id that the Texture will be stored against.
     */

    Texture.addToCache = function addToCache(texture, id) {
        if (id) {
            if (texture.textureCacheIds.indexOf(id) === -1) {
                texture.textureCacheIds.push(id);
            }

            // @if DEBUG
            /* eslint-disable no-console */
            if (_utils.TextureCache[id]) {
                console.warn('Texture added to the cache with an id [' + id + '] that already had an entry');
            }
            /* eslint-enable no-console */
            // @endif

            _utils.TextureCache[id] = texture;
        }
    };

    /**
     * Remove a Texture from the global TextureCache.
     *
     * @static
     * @param {string|PIXI.Texture} texture - id of a Texture to be removed, or a Texture instance itself
     * @return {PIXI.Texture|null} The Texture that was removed
     */

    Texture.removeFromCache = function removeFromCache(texture) {
        if (typeof texture === 'string') {
            var textureFromCache = _utils.TextureCache[texture];

            if (textureFromCache) {
                var index = textureFromCache.textureCacheIds.indexOf(texture);

                if (index > -1) {
                    textureFromCache.textureCacheIds.splice(index, 1);
                }

                delete _utils.TextureCache[texture];

                return textureFromCache;
            }
        } else if (texture && texture.textureCacheIds) {
            for (var i = 0; i < texture.textureCacheIds.length; ++i) {
                // Check that texture matches the one being passed in before deleting it from the cache.
                if (_utils.TextureCache[texture.textureCacheIds[i]] === texture) {
                    delete _utils.TextureCache[texture.textureCacheIds[i]];
                }
            }

            texture.textureCacheIds.length = 0;

            return texture;
        }

        return null;
    };

    /**
     * The frame specifies the region of the base texture that this texture uses.
     * Please call `_updateUvs()` after you change coordinates of `frame` manually.
     *
     * @member {PIXI.Rectangle}
     */

    _createClass(Texture, [{
        key: 'frame',
        get: function get() {
            return this._frame;
        },
        set: function set(frame) // eslint-disable-line require-jsdoc
        {
            this._frame = frame;

            this.noFrame = false;

            var x = frame.x,
                y = frame.y,
                width = frame.width,
                height = frame.height;

            var xNotFit = x + width > this.baseTexture.width;
            var yNotFit = y + height > this.baseTexture.height;

            if (xNotFit || yNotFit) {
                var relationship = xNotFit && yNotFit ? 'and' : 'or';
                var errorX = 'X: ' + x + ' + ' + width + ' = ' + (x + width) + ' > ' + this.baseTexture.width;
                var errorY = 'Y: ' + y + ' + ' + height + ' = ' + (y + height) + ' > ' + this.baseTexture.height;

                throw new Error('Texture Error: frame does not fit inside the base Texture dimensions: ' + (errorX + ' ' + relationship + ' ' + errorY));
            }

            // this.valid = width && height && this.baseTexture.source && this.baseTexture.hasLoaded;
            this.valid = width && height && this.baseTexture.hasLoaded;

            if (!this.trim && !this.rotate) {
                this.orig = frame;
            }

            if (this.valid) {
                this._updateUvs();
            }
        }

        /**
         * Indicates whether the texture is rotated inside the atlas
         * set to 2 to compensate for texture packer rotation
         * set to 6 to compensate for spine packer rotation
         * can be used to rotate or mirror sprites
         * See {@link PIXI.GroupD8} for explanation
         *
         * @member {number}
         */

    }, {
        key: 'rotate',
        get: function get() {
            return this._rotate;
        },
        set: function set(rotate) // eslint-disable-line require-jsdoc
        {
            this._rotate = rotate;
            if (this.valid) {
                this._updateUvs();
            }
        }

        /**
         * The width of the Texture in pixels.
         *
         * @member {number}
         */

    }, {
        key: 'width',
        get: function get() {
            return this.orig.width;
        }

        /**
         * The height of the Texture in pixels.
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            return this.orig.height;
        }
    }]);

    return Texture;
}(_eventemitter2.default);

exports.default = Texture;

function createWhiteTexture() {
    var canvas = document.createElement('canvas');

    canvas.width = 10;
    canvas.height = 10;

    var context = canvas.getContext('2d');

    context.fillStyle = 'white';
    context.fillRect(0, 0, 10, 10);

    return new Texture(new _BaseTexture2.default(canvas));
}

function removeAllHandlers(tex) {
    tex.destroy = function _emptyDestroy() {/* empty */};
    tex.on = function _emptyOn() {/* empty */};
    tex.once = function _emptyOnce() {/* empty */};
    tex.emit = function _emptyEmit() {/* empty */};
}

/**
 * An empty texture, used often to not have to create multiple empty textures.
 * Can not be destroyed.
 *
 * @static
 * @constant
 */
Texture.EMPTY = new Texture(new _BaseTexture2.default());
removeAllHandlers(Texture.EMPTY);
removeAllHandlers(Texture.EMPTY.baseTexture);

/**
 * A white texture of 10x10 size, used for graphics and other things
 * Can not be destroyed.
 *
 * @static
 * @constant
 */
Texture.WHITE = createWhiteTexture();
removeAllHandlers(Texture.WHITE);
removeAllHandlers(Texture.WHITE.baseTexture);
//# sourceMappingURL=Texture.js.map

/***/ }),

/***/ "xbqV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__("JUot");

var defaultMessage = 'Copy to clipboard: #{key}, Enter';

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
      message,
      reselectPrevious,
      range,
      selection,
      mark,
      success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement('span');
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = 'unset';
    // prevents scrolling to the end of the page
    mark.style.position = 'fixed';
    mark.style.top = 0;
    mark.style.clip = 'rect(0, 0, 0, 0)';
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = 'pre';
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = 'text';
    mark.style.MozUserSelect = 'text';
    mark.style.msUserSelect = 'text';
    mark.style.userSelect = 'text';

    document.body.appendChild(mark);

    range.selectNode(mark);
    selection.addRange(range);

    var successful = document.execCommand('copy');
    if (!successful) {
      throw new Error('copy command was unsuccessful');
    }
    success = true;
  } catch (err) {
    debug && console.error('unable to copy using execCommand: ', err);
    debug && console.warn('trying IE specific stuff');
    try {
      window.clipboardData.setData('text', text);
      success = true;
    } catch (err) {
      debug && console.error('unable to copy using clipboardData: ', err);
      debug && console.error('falling back to prompt');
      message = format('message' in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == 'function') {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;

/***/ }),

/***/ "xsdn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var SeatingConstruction_1 = __webpack_require__("EA1K");
exports.SeatingConstruction = SeatingConstruction_1.default;
var SectionOverview_1 = __webpack_require__("o8yA");
exports.SectionOverview = SectionOverview_1.default;
var SeatingReservation_1 = __webpack_require__("p2oQ");
exports.SeatingReservation = SeatingReservation_1.default;
var SeatingManagement_1 = __webpack_require__("ECnJ");
exports.SeatingManagement = SeatingManagement_1.default;
var SeatingMapping_1 = __webpack_require__("EtHY");
exports.SeatingMapping = SeatingMapping_1.default;
//# sourceMappingURL=Views.js.map

/***/ }),

/***/ "xwA8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__("dDI1");

var _canUseNewCanvasBlendModes = __webpack_require__("StZv");

var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Utility methods for Sprite/Texture tinting.
 *
 * @class
 * @memberof PIXI
 */
var CanvasTinter = {
    /**
     * Basically this method just needs a sprite and a color and tints the sprite with the given color.
     *
     * @memberof PIXI.CanvasTinter
     * @param {PIXI.Sprite} sprite - the sprite to tint
     * @param {number} color - the color to use to tint the sprite with
     * @return {HTMLCanvasElement} The tinted canvas
     */
    getTintedTexture: function getTintedTexture(sprite, color) {
        var texture = sprite._texture;

        color = CanvasTinter.roundColor(color);

        var stringColor = '#' + ('00000' + (color | 0).toString(16)).substr(-6);

        texture.tintCache = texture.tintCache || {};

        var cachedTexture = texture.tintCache[stringColor];

        var canvas = void 0;

        if (cachedTexture) {
            if (cachedTexture.tintId === texture._updateID) {
                return texture.tintCache[stringColor];
            }

            canvas = texture.tintCache[stringColor];
        } else {
            canvas = CanvasTinter.canvas || document.createElement('canvas');
        }

        CanvasTinter.tintMethod(texture, color, canvas);

        canvas.tintId = texture._updateID;

        if (CanvasTinter.convertTintToImage) {
            // is this better?
            var tintImage = new Image();

            tintImage.src = canvas.toDataURL();

            texture.tintCache[stringColor] = tintImage;
        } else {
            texture.tintCache[stringColor] = canvas;
            // if we are not converting the texture to an image then we need to lose the reference to the canvas
            CanvasTinter.canvas = null;
        }

        return canvas;
    },

    /**
     * Tint a texture using the 'multiply' operation.
     *
     * @memberof PIXI.CanvasTinter
     * @param {PIXI.Texture} texture - the texture to tint
     * @param {number} color - the color to use to tint the sprite with
     * @param {HTMLCanvasElement} canvas - the current canvas
     */
    tintWithMultiply: function tintWithMultiply(texture, color, canvas) {
        var context = canvas.getContext('2d');
        var crop = texture._frame.clone();
        var resolution = texture.baseTexture.resolution;

        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;

        canvas.width = Math.ceil(crop.width);
        canvas.height = Math.ceil(crop.height);

        context.save();
        context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);

        context.fillRect(0, 0, crop.width, crop.height);

        context.globalCompositeOperation = 'multiply';

        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);

        context.globalCompositeOperation = 'destination-atop';

        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.restore();
    },

    /**
     * Tint a texture using the 'overlay' operation.
     *
     * @memberof PIXI.CanvasTinter
     * @param {PIXI.Texture} texture - the texture to tint
     * @param {number} color - the color to use to tint the sprite with
     * @param {HTMLCanvasElement} canvas - the current canvas
     */
    tintWithOverlay: function tintWithOverlay(texture, color, canvas) {
        var context = canvas.getContext('2d');
        var crop = texture._frame.clone();
        var resolution = texture.baseTexture.resolution;

        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;

        canvas.width = Math.ceil(crop.width);
        canvas.height = Math.ceil(crop.height);

        context.save();
        context.globalCompositeOperation = 'copy';
        context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
        context.fillRect(0, 0, crop.width, crop.height);

        context.globalCompositeOperation = 'destination-atop';
        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);

        // context.globalCompositeOperation = 'copy';
        context.restore();
    },

    /**
     * Tint a texture pixel per pixel.
     *
     * @memberof PIXI.CanvasTinter
     * @param {PIXI.Texture} texture - the texture to tint
     * @param {number} color - the color to use to tint the sprite with
     * @param {HTMLCanvasElement} canvas - the current canvas
     */
    tintWithPerPixel: function tintWithPerPixel(texture, color, canvas) {
        var context = canvas.getContext('2d');
        var crop = texture._frame.clone();
        var resolution = texture.baseTexture.resolution;

        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;

        canvas.width = Math.ceil(crop.width);
        canvas.height = Math.ceil(crop.height);

        context.save();
        context.globalCompositeOperation = 'copy';
        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.restore();

        var rgbValues = (0, _utils.hex2rgb)(color);
        var r = rgbValues[0];
        var g = rgbValues[1];
        var b = rgbValues[2];

        var pixelData = context.getImageData(0, 0, crop.width, crop.height);

        var pixels = pixelData.data;

        for (var i = 0; i < pixels.length; i += 4) {
            pixels[i + 0] *= r;
            pixels[i + 1] *= g;
            pixels[i + 2] *= b;
        }

        context.putImageData(pixelData, 0, 0);
    },

    /**
     * Rounds the specified color according to the CanvasTinter.cacheStepsPerColorChannel.
     *
     * @memberof PIXI.CanvasTinter
     * @param {number} color - the color to round, should be a hex color
     * @return {number} The rounded color.
     */
    roundColor: function roundColor(color) {
        var step = CanvasTinter.cacheStepsPerColorChannel;

        var rgbValues = (0, _utils.hex2rgb)(color);

        rgbValues[0] = Math.min(255, rgbValues[0] / step * step);
        rgbValues[1] = Math.min(255, rgbValues[1] / step * step);
        rgbValues[2] = Math.min(255, rgbValues[2] / step * step);

        return (0, _utils.rgb2hex)(rgbValues);
    },

    /**
     * Number of steps which will be used as a cap when rounding colors.
     *
     * @memberof PIXI.CanvasTinter
     * @type {number}
     */
    cacheStepsPerColorChannel: 8,

    /**
     * Tint cache boolean flag.
     *
     * @memberof PIXI.CanvasTinter
     * @type {boolean}
     */
    convertTintToImage: false,

    /**
     * Whether or not the Canvas BlendModes are supported, consequently the ability to tint using the multiply method.
     *
     * @memberof PIXI.CanvasTinter
     * @type {boolean}
     */
    canUseMultiply: (0, _canUseNewCanvasBlendModes2.default)(),

    /**
     * The tinting method that will be used.
     *
     * @memberof PIXI.CanvasTinter
     * @type {tintMethodFunctionType}
     */
    tintMethod: 0
};

CanvasTinter.tintMethod = CanvasTinter.canUseMultiply ? CanvasTinter.tintWithMultiply : CanvasTinter.tintWithPerPixel;

/**
 * The tintMethod type.
 *
 * @memberof PIXI.CanvasTinter
 * @callback tintMethodFunctionType
 * @param texture {PIXI.Texture} the texture to tint
 * @param color {number} the color to use to tint the sprite with
 * @param canvas {HTMLCanvasElement} the current canvas
 */

exports.default = CanvasTinter;
//# sourceMappingURL=CanvasTinter.js.map

/***/ }),

/***/ "y78Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__("UHtZ"),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),

/***/ "yM7h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__("RjZD");

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

/**
 * The instance name of the object.
 *
 * @memberof PIXI.DisplayObject#
 * @member {string} name
 */
core.DisplayObject.prototype.name = null;

/**
 * Returns the display object in the container
 *
 * @method getChildByName
 * @memberof PIXI.Container#
 * @param {string} name - instance name
 * @return {PIXI.DisplayObject} The child with the specified name.
 */
core.Container.prototype.getChildByName = function getChildByName(name) {
    for (var i = 0; i < this.children.length; i++) {
        if (this.children[i].name === name) {
            return this.children[i];
        }
    }

    return null;
};
//# sourceMappingURL=getChildByName.js.map

/***/ }),

/***/ "ySUw":
/***/ (function(module, exports, __webpack_require__) {

var tabbable = __webpack_require__("TO+D");
var xtend = __webpack_require__("bI+R");

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];
        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },

    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

function focusTrap(element, userOptions) {
  var doc = document;
  var container = typeof element === 'string' ? doc.querySelector(element) : element;

  var config = xtend({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true
  }, userOptions);

  var state = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false
  };

  var trap = {
    activate: activate,
    deactivate: deactivate,
    pause: pause,
    unpause: unpause
  };

  return trap;

  function activate(activateOptions) {
    if (state.active) return;

    updateTabbableNodes();

    state.active = true;
    state.paused = false;
    state.nodeFocusedBeforeActivation = doc.activeElement;

    var onActivate = activateOptions && activateOptions.onActivate ? activateOptions.onActivate : config.onActivate;
    if (onActivate) {
      onActivate();
    }

    addListeners();
    return trap;
  }

  function deactivate(deactivateOptions) {
    if (!state.active) return;

    removeListeners();
    state.active = false;
    state.paused = false;

    activeFocusTraps.deactivateTrap(trap);

    var onDeactivate = deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate;
    if (onDeactivate) {
      onDeactivate();
    }

    var returnFocus = deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate;
    if (returnFocus) {
      delay(function () {
        tryFocus(state.nodeFocusedBeforeActivation);
      });
    }

    return trap;
  }

  function pause() {
    if (state.paused || !state.active) return;
    state.paused = true;
    removeListeners();
  }

  function unpause() {
    if (!state.paused || !state.active) return;
    state.paused = false;
    addListeners();
  }

  function addListeners() {
    if (!state.active) return;

    // There can be only one listening focus trap at a time
    activeFocusTraps.activateTrap(trap);

    updateTabbableNodes();

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    delay(function () {
      tryFocus(getInitialFocusNode());
    });
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, true);
    doc.addEventListener('touchstart', checkPointerDown, true);
    doc.addEventListener('click', checkClick, true);
    doc.addEventListener('keydown', checkKey, true);

    return trap;
  }

  function removeListeners() {
    if (!state.active) return;

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);

    return trap;
  }

  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error('`' + optionName + '` refers to no known node');
      }
    }
    if (typeof optionValue === 'function') {
      node = optionValue();
      if (!node) {
        throw new Error('`' + optionName + '` did not return a node');
      }
    }
    return node;
  }

  function getInitialFocusNode() {
    var node;
    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (container.contains(doc.activeElement)) {
      node = doc.activeElement;
    } else {
      node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error("You can't have a focus-trap without at least one focusable element");
    }

    return node;
  }

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  function checkPointerDown(e) {
    if (container.contains(e.target)) return;
    if (config.clickOutsideDeactivates) {
      deactivate({
        returnFocus: !tabbable.isFocusable(e.target)
      });
    } else {
      e.preventDefault();
    }
  }

  // In case focus escapes the trap for some strange reason, pull it back in.
  function checkFocusIn(e) {
    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (container.contains(e.target) || e.target instanceof Document) {
      return;
    }
    e.stopImmediatePropagation();
    tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
  }

  function checkKey(e) {
    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      e.preventDefault();
      deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  }

  // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  function checkTab(e) {
    updateTabbableNodes();
    if (e.shiftKey && e.target === state.firstTabbableNode) {
      e.preventDefault();
      tryFocus(state.lastTabbableNode);
      return;
    }
    if (!e.shiftKey && e.target === state.lastTabbableNode) {
      e.preventDefault();
      tryFocus(state.firstTabbableNode);
      return;
    }
  }

  function checkClick(e) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function updateTabbableNodes() {
    var tabbableNodes = tabbable(container);
    state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
    state.lastTabbableNode = tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
  }

  function tryFocus(node) {
    if (node === doc.activeElement) return;
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus();
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  }
}

function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
}

function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}

function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
}

function delay(fn) {
  return setTimeout(fn, 0);
}

module.exports = focusTrap;

/***/ }),

/***/ "yTo9":
/***/ (function(module, exports) {


/**
 * Helper class to create a webGL Context
 *
 * @class
 * @memberof PIXI.glCore
 * @param canvas {HTMLCanvasElement} the canvas element that we will get the context from
 * @param options {Object} An options object that gets passed in to the canvas element containing the context attributes,
 *                         see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext for the options available
 * @return {WebGLRenderingContext} the WebGL context
 */
var createContext = function createContext(canvas, options) {
    var gl = canvas.getContext('webgl', options) || canvas.getContext('experimental-webgl', options);

    if (!gl) {
        // fail, not able to get a context
        throw new Error('This browser does not support webGL. Try using the canvas renderer');
    }

    return gl;
};

module.exports = createContext;

/***/ }),

/***/ "yY49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ya0i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Default property values of interactive objects
 * Used by {@link PIXI.interaction.InteractionManager} to automatically give all DisplayObjects these properties
 *
 * @private
 * @name interactiveTarget
 * @memberof PIXI.interaction
 * @example
 *      function MyObject() {}
 *
 *      Object.assign(
 *          core.DisplayObject.prototype,
 *          PIXI.interaction.interactiveTarget
 *      );
 */
exports.default = {

  /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse
   * events will not be emitted unless `interactive` is set to `true`.
   *
   * @example
   * const sprite = new PIXI.Sprite(texture);
   * sprite.interactive = true;
   * sprite.on('tap', (event) => {
   *    //handle event
   * });
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  interactive: false,

  /**
   * Determines if the children to the displayObject can be clicked/touched
   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
   *
   * @member {boolean}
   * @memberof PIXI.Container#
   */
  interactiveChildren: true,

  /**
   * Interaction shape. Children will be hit first, then this shape will be checked.
   * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
   *
   * @example
   * const sprite = new PIXI.Sprite(texture);
   * sprite.interactive = true;
   * sprite.hitArea = new PIXI.Rectangle(0, 0, 100, 100);
   * @member {PIXI.Rectangle|PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.RoundedRectangle}
   * @memberof PIXI.DisplayObject#
   */
  hitArea: null,

  /**
   * If enabled, the mouse cursor use the pointer behavior when hovered over the displayObject if it is interactive
   * Setting this changes the 'cursor' property to `'pointer'`.
   *
   * @example
   * const sprite = new PIXI.Sprite(texture);
   * sprite.interactive = true;
   * sprite.buttonMode = true;
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  get buttonMode() {
    return this.cursor === 'pointer';
  },
  set buttonMode(value) {
    if (value) {
      this.cursor = 'pointer';
    } else if (this.cursor === 'pointer') {
      this.cursor = null;
    }
  },

  /**
   * This defines what cursor mode is used when the mouse cursor
   * is hovered over the displayObject.
   *
   * @example
   * const sprite = new PIXI.Sprite(texture);
   * sprite.interactive = true;
   * sprite.cursor = 'wait';
   * @see https://developer.mozilla.org/en/docs/Web/CSS/cursor
   *
   * @member {string}
   * @memberof PIXI.DisplayObject#
   */
  cursor: null,

  /**
   * Internal set of all active pointers, by identifier
   *
   * @member {Map<number, InteractionTrackingData>}
   * @memberof PIXI.DisplayObject#
   * @private
   */
  get trackedPointers() {
    if (this._trackedPointers === undefined) this._trackedPointers = {};

    return this._trackedPointers;
  },

  /**
   * Map of all tracked pointers, by identifier. Use trackedPointers to access.
   *
   * @private
   * @type {Map<number, InteractionTrackingData>}
   */
  _trackedPointers: undefined
};
//# sourceMappingURL=interactiveTarget.js.map

/***/ }),

/***/ "yfZu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "81c632195c41f49078616ac825c3e804.svg";

/***/ }),

/***/ "yh9p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function placeHoldersCount(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
}

function byteLength(b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64);
}

function toByteArray(b64) {
  var i, l, tmp, placeHolders, arr;
  var len = b64.length;
  placeHolders = placeHoldersCount(b64);

  arr = new Arr(len * 3 / 4 - placeHolders);

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len;

  var L = 0;

  for (i = 0; i < l; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[L++] = tmp >> 16 & 0xFF;
    arr[L++] = tmp >> 8 & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  if (placeHolders === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[L++] = tmp & 0xFF;
  } else if (placeHolders === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[L++] = tmp >> 8 & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  return arr;
}

function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}

function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}

function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var output = '';
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup[tmp >> 2];
    output += lookup[tmp << 4 & 0x3F];
    output += '==';
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    output += lookup[tmp >> 10];
    output += lookup[tmp >> 4 & 0x3F];
    output += lookup[tmp << 2 & 0x3F];
    output += '=';
  }

  parts.push(output);

  return parts.join('');
}

/***/ }),

/***/ "ywQn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim

var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__("uTT0");
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = function () {
	/* global window */
	if (typeof window === 'undefined') {
		return false;
	}
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}();
var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2);
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;

/***/ }),

/***/ "z7q+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = generateFragBlurSource;
var GAUSSIAN_VALUES = {
    5: [0.153388, 0.221461, 0.250301],
    7: [0.071303, 0.131514, 0.189879, 0.214607],
    9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
    11: [0.0093, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
    13: [0.002406, 0.009255, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
    15: [0.000489, 0.002403, 0.009246, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448]
};

var fragTemplate = ['varying vec2 vBlurTexCoords[%size%];', 'uniform sampler2D uSampler;', 'void main(void)', '{', '    gl_FragColor = vec4(0.0);', '    %blur%', '}'].join('\n');

function generateFragBlurSource(kernelSize) {
    var kernel = GAUSSIAN_VALUES[kernelSize];
    var halfLength = kernel.length;

    var fragSource = fragTemplate;

    var blurLoop = '';
    var template = 'gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;';
    var value = void 0;

    for (var i = 0; i < kernelSize; i++) {
        var blur = template.replace('%index%', i);

        value = i;

        if (i >= halfLength) {
            value = kernelSize - i - 1;
        }

        blur = blur.replace('%value%', kernel[value]);

        blurLoop += blur;
        blurLoop += '\n';
    }

    fragSource = fragSource.replace('%blur%', blurLoop);
    fragSource = fragSource.replace('%size%', kernelSize);

    return fragSource;
}
//# sourceMappingURL=generateBlurFragSource.js.map

/***/ }),

/***/ "zX5E":
/***/ (function(module, exports) {


module.exports = function load(src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0];
  var script = document.createElement('script');

  if (typeof opts === 'function') {
    cb = opts;
    opts = {};
  }

  opts = opts || {};
  cb = cb || function () {};

  script.type = opts.type || 'text/javascript';
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true;
  script.src = src;

  if (opts.attrs) {
    setAttributes(script, opts.attrs);
  }

  if (opts.text) {
    script.text = '' + opts.text;
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
  onend(script, cb);

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script);
};

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd(script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null;
    cb(null, script);
  };
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null;
    cb(new Error('Failed to load ' + this.src), script);
  };
}

function ieOnEnd(script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return;
    this.onreadystatechange = null;
    cb(null, script); // there is no way to catch loading errors in IE8
  };
}

/***/ }),

/***/ "zbw2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0dcda5d510bc7d164208cde92865dbc0.svg";

/***/ }),

/***/ "zjtw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Shader2 = __webpack_require__("wBQE");

var _Shader3 = _interopRequireDefault(_Shader2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * @class
 * @extends PIXI.Shader
 * @memberof PIXI
 */
var ParticleShader = function (_Shader) {
    _inherits(ParticleShader, _Shader);

    /**
     * @param {PIXI.Shader} gl - The webgl shader manager this shader works for.
     */
    function ParticleShader(gl) {
        _classCallCheck(this, ParticleShader);

        return _possibleConstructorReturn(this, _Shader.call(this, gl,
        // vertex shader
        ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'attribute vec4 aColor;', 'attribute vec2 aPositionCoord;', 'attribute float aRotation;', 'uniform mat3 projectionMatrix;', 'uniform vec4 uColor;', 'varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'void main(void){', '   float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);', '   float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);', '   vec2 v = vec2(x, y);', '   v = v + aPositionCoord;', '   gl_Position = vec4((projectionMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);', '   vTextureCoord = aTextureCoord;', '   vColor = aColor * uColor;', '}'].join('\n'),
        // hello
        ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'uniform sampler2D uSampler;', 'void main(void){', '  vec4 color = texture2D(uSampler, vTextureCoord) * vColor;', '  gl_FragColor = color;', '}'].join('\n')));
    }

    return ParticleShader;
}(_Shader3.default);

exports.default = ParticleShader;
//# sourceMappingURL=ParticleShader.js.map

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.55e09.js